var w$ = Object.defineProperty, x$ = Object.defineProperties;
var C$ = Object.getOwnPropertyDescriptors;
var Xf = Object.getOwnPropertySymbols;
var FC = Object.prototype.hasOwnProperty, zC = Object.prototype.propertyIsEnumerable;
var ro = Math.pow, wv = (e, t, n) => t in e ? w$(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, se = (e, t) => {
  for (var n in t || (t = {}))
    FC.call(t, n) && wv(e, n, t[n]);
  if (Xf)
    for (var n of Xf(t))
      zC.call(t, n) && wv(e, n, t[n]);
  return e;
}, ge = (e, t) => x$(e, C$(t));
var xl = (e, t) => {
  var n = {};
  for (var r in e)
    FC.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && Xf)
    for (var r of Xf(e))
      t.indexOf(r) < 0 && zC.call(e, r) && (n[r] = e[r]);
  return n;
};
var Ln = (e, t, n) => (wv(e, typeof t != "symbol" ? t + "" : t, n), n);
var Mo = (e, t, n) => new Promise((r, o) => {
  var i = (c) => {
    try {
      s(n.next(c));
    } catch (l) {
      o(l);
    }
  }, a = (c) => {
    try {
      s(n.throw(c));
    } catch (l) {
      o(l);
    }
  }, s = (c) => c.done ? r(c.value) : Promise.resolve(c.value).then(i, a);
  s((n = n.apply(e, t)).next());
});
import { jsx as z, jsxs as _e, Fragment as fo } from "react/jsx-runtime";
import * as B from "react";
import et, { useMemo as We, createElement as uh, forwardRef as nl, useContext as rl, createContext as ol, useState as Ge, useRef as it, useEffect as mt, Component as af, useLayoutEffect as Lc, Children as JP, isValidElement as sa, cloneElement as es, useImperativeHandle as S$, useCallback as bt, memo as T$, useReducer as E$ } from "react";
import { bi as k$, bj as Or, aW as Li, ba as QP, m as Ci, bk as ba, bl as $c, af as eO, bm as g_, bn as M$, a4 as R$, bo as xv, e as ya, T as vt, bp as sf, bq as xm, ag as Sd, Z as Bi, A as P$, br as O$, g as Go, bs as N$, bt as tO, am as is, b9 as Fc, k as as, bu as Mr, bv as Rr, bw as A$, bx as D$, by as $p, bz as I$, bA as nO, bB as L$, bC as ad, bD as $$, bE as hc, bF as BC, bG as F$, bH as rO, bI as lf, bJ as z$, bK as B$, bL as H$, bM as HC, O as Wr, bN as oO, bO as iO, y as aO, M as ci, z as dh, bP as v_, N as _a, bQ as j$, bR as W$, bS as zc, bT as ca, bU as V$, bV as Bc, R as Cm, bW as il, bX as Hc, bY as jc, bZ as U$, b_ as Cv, b$ as sO, c0 as q$, c1 as G$, c2 as Y$, ak as lO, c3 as Z$, c4 as cO, c5 as X$, c6 as uO, c7 as dO, a2 as fh, c8 as fO, c as Ua, c9 as Tb, ca as Sv, b8 as wr, cb as K$, cc as aa, cd as sd, ce as Sm, t as ua, a_ as pO, l as b_, cf as J$, cg as Fa, ch as Q$, ci as hO, cj as mO, ck as gO, cl as vO, cm as bO, Q as eF, f as y_, X as tF, Y as nF, cn as rF, co as oF, cp as yO, P as zn, cq as iF, bg as aF, cr as ld, cs as Eb, ct as sF, cu as _O, aa as ph, n as __, cv as ts, cw as lF, cx as cF, cy as uF, s as dF, r as wO, cz as fF, cA as pF, cB as hF, cC as mF, cD as Td, cE as gF, cF as xO, cG as vF, cH as bF, cI as yF, cJ as _F, a6 as wF, cK as xF, cL as CF, cM as CO, x as SO, aQ as TO, a5 as SF, cN as TF, cO as EF, D as jC, cP as kF, cQ as WC, F as MF, v as qa, B as EO, H as RF, G as PF, cR as VC, h as kO, cS as OF, cT as NF, cU as cd, cV as AF } from "./get-widget-options-DTIulxC2.js";
import * as MO from "react-dom";
import _r, { createPortal as DF } from "react-dom";
function ue() {
  return ue = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, ue.apply(this, arguments);
}
const IF = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: ue
}, Symbol.toStringTag, { value: "Module" }));
function LF(e) {
  let {
    i18n: t,
    defaultNS: n,
    children: r
  } = e;
  const o = We(() => ({
    i18n: t,
    defaultNS: n
  }), [t, n]);
  return uh(k$.Provider, {
    value: o
  }, r);
}
let Kf;
const $F = new Uint8Array(16);
function FF() {
  if (!Kf && (Kf = typeof crypto != "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto), !Kf))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return Kf($F);
}
const sr = [];
for (let e = 0; e < 256; ++e)
  sr.push((e + 256).toString(16).slice(1));
function zF(e, t = 0) {
  return sr[e[t + 0]] + sr[e[t + 1]] + sr[e[t + 2]] + sr[e[t + 3]] + "-" + sr[e[t + 4]] + sr[e[t + 5]] + "-" + sr[e[t + 6]] + sr[e[t + 7]] + "-" + sr[e[t + 8]] + sr[e[t + 9]] + "-" + sr[e[t + 10]] + sr[e[t + 11]] + sr[e[t + 12]] + sr[e[t + 13]] + sr[e[t + 14]] + sr[e[t + 15]];
}
const BF = typeof crypto != "undefined" && crypto.randomUUID && crypto.randomUUID.bind(crypto), UC = {
  randomUUID: BF
};
function RO(e, t, n) {
  if (UC.randomUUID && !t && !e)
    return UC.randomUUID();
  e = e || {};
  const r = e.random || (e.rng || FF)();
  return r[6] = r[6] & 15 | 64, r[8] = r[8] & 63 | 128, zF(r);
}
function ss(e) {
  return e === void 0 || typeof e == "string" || "title" in e && "type" in e;
}
function Tv(e) {
  return "attribute" in e;
}
function HF(e) {
  return "measure" in e;
}
const jF = {
  title: "Grand Total",
  rows: !1,
  columns: !1
}, Nr = {
  BOX_MIN_VALUE_NAME: "Box Min",
  BOX_MEDIAN_VALUE_NAME: "Box Median",
  BOX_MAX_VALUE_NAME: "Box Max",
  WHISKER_MIN_VALUE_NAME: "Whisker Min",
  WHISKER_MAX_VALUE_NAME: "Whisker Max",
  OUTLIER_COUNT_VALUE_NAME: "Outlier Count",
  OUTLIER_MIN_VALUE_NAME: "Outlier Min",
  OUTLIER_MAX_VALUE_NAME: "Outlier Max"
};
function w_(e) {
  return [
    Or(Nr.BOX_MIN_VALUE_NAME, "QUARTILE([Attr], 1)", {
      Attr: e
    }),
    Or(Nr.BOX_MEDIAN_VALUE_NAME, "MEDIAN([Attr])", {
      Attr: e
    }),
    Or(Nr.BOX_MAX_VALUE_NAME, "QUARTILE([Attr], 3)", {
      Attr: e
    })
  ];
}
function WF(e) {
  return [
    ...w_(e),
    Or(Nr.WHISKER_MIN_VALUE_NAME, "LOWERWHISKERMAX_IQR([Attr])", {
      Attr: e
    }),
    Or(Nr.WHISKER_MAX_VALUE_NAME, "UPPERWHISKERMIN_IQR([Attr])", {
      Attr: e
    }),
    Or(Nr.OUTLIER_COUNT_VALUE_NAME, "OUTLIERSCOUNT_IQR([Attr])", {
      Attr: e
    })
  ];
}
function VF(e) {
  return [
    ...w_(e),
    Or(Nr.WHISKER_MIN_VALUE_NAME, "MIN([Attr])", {
      Attr: e
    }),
    Or(Nr.WHISKER_MAX_VALUE_NAME, "MAX([Attr])", {
      Attr: e
    })
  ];
}
function UF(e) {
  return [
    ...w_(e),
    Or(Nr.WHISKER_MIN_VALUE_NAME, "LOWERWHISKERMAX_STDEVP([Attr])", {
      Attr: e
    }),
    Or(Nr.WHISKER_MAX_VALUE_NAME, "UPPERWHISKERMIN_STDEVP([Attr])", {
      Attr: e
    }),
    Or(Nr.OUTLIER_COUNT_VALUE_NAME, "OUTLIERSCOUNT_STDEVP([Attr])", {
      Attr: e
    })
  ];
}
const qF = (e) => {
  const t = Li(e), n = Or(Nr.OUTLIER_MAX_VALUE_NAME, "(UPPERWHISKERMIN_IQR([Attr]), all([Attr]))", {
    Attr: e
  }), r = Or(Nr.OUTLIER_MIN_VALUE_NAME, "(LOWERWHISKERMAX_IQR([Attr]), all([Attr]))", {
    Attr: e
  });
  return t.name = `${t.name} (Outliers)`, t.jaql = (o) => {
    const i = Object.assign(Object.assign({}, e.jaql(!0)), { filter: {
      or: [
        {
          fromNotEqual: n.jaql(!0)
        },
        {
          toNotEqual: r.jaql(!0)
        }
      ]
    } });
    return o ? i : { jaql: i };
  }, t;
}, GF = (e) => {
  const t = Li(e), n = Or(Nr.OUTLIER_MAX_VALUE_NAME, "(UPPERWHISKERMIN_STDEVP([Attr]), all([Attr]))", {
    Attr: e
  }), r = Or(Nr.OUTLIER_MIN_VALUE_NAME, "(LOWERWHISKERMAX_STDEVP([Attr]), all([Attr]))", {
    Attr: e
  });
  return t.jaql = (o) => {
    const i = Object.assign(Object.assign({}, e.jaql(!0)), { filter: {
      or: [
        {
          fromNotEqual: n.jaql(!0)
        },
        {
          toNotEqual: r.jaql(!0)
        }
      ]
    } });
    return o ? i : { jaql: i };
  }, t;
};
function YF(e, t) {
  const n = t == null ? void 0 : t.find((r) => PO(e) === r.attribute.id);
  return n && !n.disabled && (n.isScope && (n.isScope = !1), e.jaql.in = {
    selected: n.jaql()
  }), e;
}
function ZF(e, t) {
  const n = [], r = [];
  return t.forEach((o) => {
    e.some((a) => PO(a) === o.attribute.id) ? n.push(o) : r.push(o);
  }), [n, r];
}
function PO(e) {
  const { dim: t, level: n, dateTimeLevel: r, bucket: o } = e.jaql;
  let i = `${t}`;
  return (n || r) && (i += `_${n || r}`), o && (i += `_${o}`), i;
}
var XF = function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
function KF(e, t, n) {
  return {
    rowsCount: e.length,
    columnsCount: t.length,
    measuresCount: n.length
  };
}
function JF(e) {
  switch (e) {
    case "sortAsc":
      return "asc";
    case "sortDesc":
      return "desc";
    default:
      return "none";
  }
}
function QF(e, t, n) {
  const r = JF(e.direction), o = t === n.rowsCount - 1, i = {
    dir: r,
    initialized: !0,
    field: e.by && "valuesIndex" in e.by ? n.rowsCount + n.columnsCount + e.by.valuesIndex : t
  };
  return o && (i.sortingLastDimension = !0), e.by && (i.measurePath = (e.by.columnsMembersPath || []).reduce((a, s, c) => Object.assign(Object.assign({}, a), { [n.rowsCount + c]: s }), {})), {
    sort: r,
    sortDetails: i
  };
}
function ez(e, t) {
  const n = e[t.rowsCount - 1];
  if (n.jaql.sortDetails && n.jaql.sortDetails.field !== t.rowsCount - 1) {
    const o = e[n.jaql.sortDetails.field], i = n.jaql, { sortDetails: a, sort: s } = i, c = XF(i, ["sortDetails", "sort"]);
    o.jaql.sortDetails = a, o.jaql.sort = s, n.jaql = c;
  }
}
const Fp = "ComposeSDK";
function tz(e, t) {
  const { attributes: n, measures: r, filters: o, filterRelations: i, highlights: a, dataSource: s, count: c, offset: l, ungroup: d } = e, f = d && r.length === 0, p = Object.assign({ metadata: nz({ attributes: n, measures: r, filters: o, filterRelations: i, highlights: a }, t) }, rz(s, c, l, f));
  return i ? Object.assign(Object.assign({}, p), { filterRelations: i }) : p;
}
function OO(e, t, n, r, o) {
  const [i, a] = ZF(e, r);
  e.forEach((l) => YF(l, i));
  const s = (l) => {
    const d = l.jaql();
    return n ? Array.isArray(d) ? d.map((f) => Object.assign(Object.assign({}, f), { instanceid: l.guid })) : Object.assign(Object.assign({}, d), { instanceid: l.guid }) : d;
  }, c = (o ? t.flatMap((l) => s(l)) : [...t, ...a].flatMap((l) => s(l))).filter((l) => Object.keys(l.jaql.filter || {}).length !== 0);
  return o && a.length > 0 && console.warn(`The following highlight filters were not applied due to missing attributes: [${a.map((l) => l.attribute.name).join(", ")}].`), c;
}
function nz(e, t) {
  const { attributes: n, measures: r, filters: o, filterRelations: i, highlights: a } = e, s = n.map((d) => d.jaql()), c = r.map((d) => d.jaql()), l = OO(s, o, i, a, t);
  return [...s, ...c, ...l];
}
function rz(e, t, n, r) {
  return Object.assign(Object.assign(Object.assign({ datasource: QP(e), by: Fp, queryGuid: RO() }, r ? { ungroup: !0 } : {}), t ? { count: t } : {}), n ? { offset: n } : {});
}
function l$e(e, t) {
  const { rowsAttributes: n, columnsAttributes: r, measures: o, filters: i, filterRelations: a, grandTotals: s, highlights: c, dataSource: l, count: d, offset: f } = e, p = Object.assign({ metadata: iz({ rowsAttributes: n, columnsAttributes: r, measures: o, filters: i, highlights: c }, t) }, az(l, s, d, f));
  return a ? Object.assign(Object.assign({}, p), { filterRelations: a }) : p;
}
function qC(e, t, n, r) {
  const o = t === "rows" && Tv(e) && e.sort && e.sort.direction !== "sortNone", i = Object.assign(Object.assign({}, Tv(e) ? e.attribute.jaql(!0) : e.jaql(!0)), o && QF(e.sort, n, r));
  return Object.assign(Object.assign({ jaql: i }, Tv(e) && e.includeSubTotals ? { format: { subtotal: !0 } } : {}), { panel: t, field: { index: n, id: `${t}-${n}` } });
}
function oz(e, t, n) {
  return Object.assign(Object.assign({}, HF(e) ? Ci(e.measure.jaql(), {
    jaql: { subtotalAgg: e.totalsCalculation },
    format: { databars: e.dataBars || !1 }
  }) : e.jaql()), { panel: t, field: { index: n, id: `${t}-${n}` } });
}
function iz(e, t) {
  const { rowsAttributes: n, columnsAttributes: r, measures: o, filters: i, filterRelations: a, highlights: s } = e, c = KF(n, r, o);
  let l = 0;
  const d = n.map((b, x) => qC(b, "rows", x + l, c));
  l = l + n.length;
  const f = r.map((b, x) => qC(b, "columns", x + l, c));
  l = l + r.length;
  const p = [
    ...d,
    ...f
  ], m = o.map((b, x) => oz(b, "measures", x + l)), v = OO(p, i, a, s, t), g = [...p, ...m, ...v];
  return ez(g, c), g;
}
function az(e, t, n, r) {
  return Object.assign(Object.assign(Object.assign({ datasource: QP(e), by: Fp, queryGuid: RO(), dashboard: Fp, widget: Fp, format: "pivot" }, n ? { count: n } : {}), r ? { offset: r } : {}), { grandTotals: Object.assign(Object.assign({}, jF), t) });
}
function sz(e) {
  if (e.sheet)
    return e.sheet;
  for (var t = 0; t < document.styleSheets.length; t++)
    if (document.styleSheets[t].ownerNode === e)
      return document.styleSheets[t];
}
function lz(e) {
  var t = document.createElement("style");
  return t.setAttribute("data-emotion", e.key), e.nonce !== void 0 && t.setAttribute("nonce", e.nonce), t.appendChild(document.createTextNode("")), t.setAttribute("data-s", ""), t;
}
var cz = /* @__PURE__ */ function() {
  function e(n) {
    var r = this;
    this._insertTag = function(o) {
      var i;
      r.tags.length === 0 ? r.insertionPoint ? i = r.insertionPoint.nextSibling : r.prepend ? i = r.container.firstChild : i = r.before : i = r.tags[r.tags.length - 1].nextSibling, r.container.insertBefore(o, i), r.tags.push(o);
    }, this.isSpeedy = n.speedy === void 0 ? process.env.NODE_ENV === "production" : n.speedy, this.tags = [], this.ctr = 0, this.nonce = n.nonce, this.key = n.key, this.container = n.container, this.prepend = n.prepend, this.insertionPoint = n.insertionPoint, this.before = null;
  }
  var t = e.prototype;
  return t.hydrate = function(r) {
    r.forEach(this._insertTag);
  }, t.insert = function(r) {
    this.ctr % (this.isSpeedy ? 65e3 : 1) === 0 && this._insertTag(lz(this));
    var o = this.tags[this.tags.length - 1];
    if (process.env.NODE_ENV !== "production") {
      var i = r.charCodeAt(0) === 64 && r.charCodeAt(1) === 105;
      i && this._alreadyInsertedOrderInsensitiveRule && console.error(`You're attempting to insert the following rule:
` + r + "\n\n`@import` rules must be before all other types of rules in a stylesheet but other rules have already been inserted. Please ensure that `@import` rules are before all other rules."), this._alreadyInsertedOrderInsensitiveRule = this._alreadyInsertedOrderInsensitiveRule || !i;
    }
    if (this.isSpeedy) {
      var a = sz(o);
      try {
        a.insertRule(r, a.cssRules.length);
      } catch (s) {
        process.env.NODE_ENV !== "production" && !/:(-moz-placeholder|-moz-focus-inner|-moz-focusring|-ms-input-placeholder|-moz-read-write|-moz-read-only|-ms-clear|-ms-expand|-ms-reveal){/.test(r) && console.error('There was a problem inserting the following rule: "' + r + '"', s);
      }
    } else
      o.appendChild(document.createTextNode(r));
    this.ctr++;
  }, t.flush = function() {
    this.tags.forEach(function(r) {
      return r.parentNode && r.parentNode.removeChild(r);
    }), this.tags = [], this.ctr = 0, process.env.NODE_ENV !== "production" && (this._alreadyInsertedOrderInsensitiveRule = !1);
  }, e;
}(), br = "-ms-", hh = "-moz-", Mt = "-webkit-", x_ = "comm", C_ = "rule", S_ = "decl", uz = "@import", NO = "@keyframes", dz = "@layer", fz = Math.abs, Tm = String.fromCharCode, pz = Object.assign;
function hz(e, t) {
  return dr(e, 0) ^ 45 ? (((t << 2 ^ dr(e, 0)) << 2 ^ dr(e, 1)) << 2 ^ dr(e, 2)) << 2 ^ dr(e, 3) : 0;
}
function AO(e) {
  return e.trim();
}
function mz(e, t) {
  return (e = t.exec(e)) ? e[0] : e;
}
function Pt(e, t, n) {
  return e.replace(t, n);
}
function kb(e, t) {
  return e.indexOf(t);
}
function dr(e, t) {
  return e.charCodeAt(t) | 0;
}
function Ed(e, t, n) {
  return e.slice(t, n);
}
function wi(e) {
  return e.length;
}
function T_(e) {
  return e.length;
}
function Jf(e, t) {
  return t.push(e), e;
}
function gz(e, t) {
  return e.map(t).join("");
}
var Em = 1, mc = 1, DO = 0, Zr = 0, Bn = 0, Wc = "";
function km(e, t, n, r, o, i, a) {
  return { value: e, root: t, parent: n, type: r, props: o, children: i, line: Em, column: mc, length: a, return: "" };
}
function _u(e, t) {
  return pz(km("", null, null, "", null, null, 0), e, { length: -e.length }, t);
}
function vz() {
  return Bn;
}
function bz() {
  return Bn = Zr > 0 ? dr(Wc, --Zr) : 0, mc--, Bn === 10 && (mc = 1, Em--), Bn;
}
function lo() {
  return Bn = Zr < DO ? dr(Wc, Zr++) : 0, mc++, Bn === 10 && (mc = 1, Em++), Bn;
}
function Pi() {
  return dr(Wc, Zr);
}
function zp() {
  return Zr;
}
function cf(e, t) {
  return Ed(Wc, e, t);
}
function kd(e) {
  switch (e) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function IO(e) {
  return Em = mc = 1, DO = wi(Wc = e), Zr = 0, [];
}
function LO(e) {
  return Wc = "", e;
}
function Bp(e) {
  return AO(cf(Zr - 1, Mb(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function yz(e) {
  for (; (Bn = Pi()) && Bn < 33; )
    lo();
  return kd(e) > 2 || kd(Bn) > 3 ? "" : " ";
}
function _z(e, t) {
  for (; --t && lo() && !(Bn < 48 || Bn > 102 || Bn > 57 && Bn < 65 || Bn > 70 && Bn < 97); )
    ;
  return cf(e, zp() + (t < 6 && Pi() == 32 && lo() == 32));
}
function Mb(e) {
  for (; lo(); )
    switch (Bn) {
      case e:
        return Zr;
      case 34:
      case 39:
        e !== 34 && e !== 39 && Mb(Bn);
        break;
      case 40:
        e === 41 && Mb(e);
        break;
      case 92:
        lo();
        break;
    }
  return Zr;
}
function wz(e, t) {
  for (; lo() && e + Bn !== 57; )
    if (e + Bn === 84 && Pi() === 47)
      break;
  return "/*" + cf(t, Zr - 1) + "*" + Tm(e === 47 ? e : lo());
}
function xz(e) {
  for (; !kd(Pi()); )
    lo();
  return cf(e, Zr);
}
function Cz(e) {
  return LO(Hp("", null, null, null, [""], e = IO(e), 0, [0], e));
}
function Hp(e, t, n, r, o, i, a, s, c) {
  for (var l = 0, d = 0, f = a, p = 0, m = 0, v = 0, g = 1, b = 1, x = 1, T = 0, S = "", _ = o, w = i, k = r, E = S; b; )
    switch (v = T, T = lo()) {
      case 40:
        if (v != 108 && dr(E, f - 1) == 58) {
          kb(E += Pt(Bp(T), "&", "&\f"), "&\f") != -1 && (x = -1);
          break;
        }
      case 34:
      case 39:
      case 91:
        E += Bp(T);
        break;
      case 9:
      case 10:
      case 13:
      case 32:
        E += yz(v);
        break;
      case 92:
        E += _z(zp() - 1, 7);
        continue;
      case 47:
        switch (Pi()) {
          case 42:
          case 47:
            Jf(Sz(wz(lo(), zp()), t, n), c);
            break;
          default:
            E += "/";
        }
        break;
      case 123 * g:
        s[l++] = wi(E) * x;
      case 125 * g:
      case 59:
      case 0:
        switch (T) {
          case 0:
          case 125:
            b = 0;
          case 59 + d:
            x == -1 && (E = Pt(E, /\f/g, "")), m > 0 && wi(E) - f && Jf(m > 32 ? YC(E + ";", r, n, f - 1) : YC(Pt(E, " ", "") + ";", r, n, f - 2), c);
            break;
          case 59:
            E += ";";
          default:
            if (Jf(k = GC(E, t, n, l, d, o, s, S, _ = [], w = [], f), i), T === 123)
              if (d === 0)
                Hp(E, t, k, k, _, i, f, s, w);
              else
                switch (p === 99 && dr(E, 3) === 110 ? 100 : p) {
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    Hp(e, k, k, r && Jf(GC(e, k, k, 0, 0, o, s, S, o, _ = [], f), w), o, w, f, s, r ? _ : w);
                    break;
                  default:
                    Hp(E, k, k, k, [""], w, 0, s, w);
                }
        }
        l = d = m = 0, g = x = 1, S = E = "", f = a;
        break;
      case 58:
        f = 1 + wi(E), m = v;
      default:
        if (g < 1) {
          if (T == 123)
            --g;
          else if (T == 125 && g++ == 0 && bz() == 125)
            continue;
        }
        switch (E += Tm(T), T * g) {
          case 38:
            x = d > 0 ? 1 : (E += "\f", -1);
            break;
          case 44:
            s[l++] = (wi(E) - 1) * x, x = 1;
            break;
          case 64:
            Pi() === 45 && (E += Bp(lo())), p = Pi(), d = f = wi(S = E += xz(zp())), T++;
            break;
          case 45:
            v === 45 && wi(E) == 2 && (g = 0);
        }
    }
  return i;
}
function GC(e, t, n, r, o, i, a, s, c, l, d) {
  for (var f = o - 1, p = o === 0 ? i : [""], m = T_(p), v = 0, g = 0, b = 0; v < r; ++v)
    for (var x = 0, T = Ed(e, f + 1, f = fz(g = a[v])), S = e; x < m; ++x)
      (S = AO(g > 0 ? p[x] + " " + T : Pt(T, /&\f/g, p[x]))) && (c[b++] = S);
  return km(e, t, n, o === 0 ? C_ : s, c, l, d);
}
function Sz(e, t, n) {
  return km(e, t, n, x_, Tm(vz()), Ed(e, 2, -2), 0);
}
function YC(e, t, n, r) {
  return km(e, t, n, S_, Ed(e, 0, r), Ed(e, r + 1, -1), r);
}
function lc(e, t) {
  for (var n = "", r = T_(e), o = 0; o < r; o++)
    n += t(e[o], o, e, t) || "";
  return n;
}
function Tz(e, t, n, r) {
  switch (e.type) {
    case dz:
      if (e.children.length)
        break;
    case uz:
    case S_:
      return e.return = e.return || e.value;
    case x_:
      return "";
    case NO:
      return e.return = e.value + "{" + lc(e.children, r) + "}";
    case C_:
      e.value = e.props.join(",");
  }
  return wi(n = lc(e.children, r)) ? e.return = e.value + "{" + n + "}" : "";
}
function Ez(e) {
  var t = T_(e);
  return function(n, r, o, i) {
    for (var a = "", s = 0; s < t; s++)
      a += e[s](n, r, o, i) || "";
    return a;
  };
}
function kz(e) {
  return function(t) {
    t.root || (t = t.return) && e(t);
  };
}
function $O(e) {
  var t = /* @__PURE__ */ Object.create(null);
  return function(n) {
    return t[n] === void 0 && (t[n] = e(n)), t[n];
  };
}
var Mz = function(t, n, r) {
  for (var o = 0, i = 0; o = i, i = Pi(), o === 38 && i === 12 && (n[r] = 1), !kd(i); )
    lo();
  return cf(t, Zr);
}, Rz = function(t, n) {
  var r = -1, o = 44;
  do
    switch (kd(o)) {
      case 0:
        o === 38 && Pi() === 12 && (n[r] = 1), t[r] += Mz(Zr - 1, n, r);
        break;
      case 2:
        t[r] += Bp(o);
        break;
      case 4:
        if (o === 44) {
          t[++r] = Pi() === 58 ? "&\f" : "", n[r] = t[r].length;
          break;
        }
      default:
        t[r] += Tm(o);
    }
  while (o = lo());
  return t;
}, Pz = function(t, n) {
  return LO(Rz(IO(t), n));
}, ZC = /* @__PURE__ */ new WeakMap(), Oz = function(t) {
  if (!(t.type !== "rule" || !t.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  t.length < 1)) {
    for (var n = t.value, r = t.parent, o = t.column === r.column && t.line === r.line; r.type !== "rule"; )
      if (r = r.parent, !r)
        return;
    if (!(t.props.length === 1 && n.charCodeAt(0) !== 58 && !ZC.get(r)) && !o) {
      ZC.set(t, !0);
      for (var i = [], a = Pz(n, i), s = r.props, c = 0, l = 0; c < a.length; c++)
        for (var d = 0; d < s.length; d++, l++)
          t.props[l] = i[c] ? a[c].replace(/&\f/g, s[d]) : s[d] + " " + a[c];
    }
  }
}, Nz = function(t) {
  if (t.type === "decl") {
    var n = t.value;
    // charcode for l
    n.charCodeAt(0) === 108 && // charcode for b
    n.charCodeAt(2) === 98 && (t.return = "", t.value = "");
  }
}, Az = "emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason", Dz = function(t) {
  return t.type === "comm" && t.children.indexOf(Az) > -1;
}, Iz = function(t) {
  return function(n, r, o) {
    if (!(n.type !== "rule" || t.compat)) {
      var i = n.value.match(/(:first|:nth|:nth-last)-child/g);
      if (i) {
        for (var a = !!n.parent, s = a ? n.parent.children : (
          // global rule at the root level
          o
        ), c = s.length - 1; c >= 0; c--) {
          var l = s[c];
          if (l.line < n.line)
            break;
          if (l.column < n.column) {
            if (Dz(l))
              return;
            break;
          }
        }
        i.forEach(function(d) {
          console.error('The pseudo class "' + d + '" is potentially unsafe when doing server-side rendering. Try changing it to "' + d.split("-child")[0] + '-of-type".');
        });
      }
    }
  };
}, FO = function(t) {
  return t.type.charCodeAt(1) === 105 && t.type.charCodeAt(0) === 64;
}, Lz = function(t, n) {
  for (var r = t - 1; r >= 0; r--)
    if (!FO(n[r]))
      return !0;
  return !1;
}, XC = function(t) {
  t.type = "", t.value = "", t.return = "", t.children = "", t.props = "";
}, $z = function(t, n, r) {
  FO(t) && (t.parent ? (console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles."), XC(t)) : Lz(n, r) && (console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules."), XC(t)));
};
function zO(e, t) {
  switch (hz(e, t)) {
    case 5103:
      return Mt + "print-" + e + e;
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return Mt + e + e;
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return Mt + e + hh + e + br + e + e;
    case 6828:
    case 4268:
      return Mt + e + br + e + e;
    case 6165:
      return Mt + e + br + "flex-" + e + e;
    case 5187:
      return Mt + e + Pt(e, /(\w+).+(:[^]+)/, Mt + "box-$1$2" + br + "flex-$1$2") + e;
    case 5443:
      return Mt + e + br + "flex-item-" + Pt(e, /flex-|-self/, "") + e;
    case 4675:
      return Mt + e + br + "flex-line-pack" + Pt(e, /align-content|flex-|-self/, "") + e;
    case 5548:
      return Mt + e + br + Pt(e, "shrink", "negative") + e;
    case 5292:
      return Mt + e + br + Pt(e, "basis", "preferred-size") + e;
    case 6060:
      return Mt + "box-" + Pt(e, "-grow", "") + Mt + e + br + Pt(e, "grow", "positive") + e;
    case 4554:
      return Mt + Pt(e, /([^-])(transform)/g, "$1" + Mt + "$2") + e;
    case 6187:
      return Pt(Pt(Pt(e, /(zoom-|grab)/, Mt + "$1"), /(image-set)/, Mt + "$1"), e, "") + e;
    case 5495:
    case 3959:
      return Pt(e, /(image-set\([^]*)/, Mt + "$1$`$1");
    case 4968:
      return Pt(Pt(e, /(.+:)(flex-)?(.*)/, Mt + "box-pack:$3" + br + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + Mt + e + e;
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return Pt(e, /(.+)-inline(.+)/, Mt + "$1$2") + e;
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (wi(e) - 1 - t > 6)
        switch (dr(e, t + 1)) {
          case 109:
            if (dr(e, t + 4) !== 45)
              break;
          case 102:
            return Pt(e, /(.+:)(.+)-([^]+)/, "$1" + Mt + "$2-$3$1" + hh + (dr(e, t + 3) == 108 ? "$3" : "$2-$3")) + e;
          case 115:
            return ~kb(e, "stretch") ? zO(Pt(e, "stretch", "fill-available"), t) + e : e;
        }
      break;
    case 4949:
      if (dr(e, t + 1) !== 115)
        break;
    case 6444:
      switch (dr(e, wi(e) - 3 - (~kb(e, "!important") && 10))) {
        case 107:
          return Pt(e, ":", ":" + Mt) + e;
        case 101:
          return Pt(e, /(.+:)([^;!]+)(;|!.+)?/, "$1" + Mt + (dr(e, 14) === 45 ? "inline-" : "") + "box$3$1" + Mt + "$2$3$1" + br + "$2box$3") + e;
      }
      break;
    case 5936:
      switch (dr(e, t + 11)) {
        case 114:
          return Mt + e + br + Pt(e, /[svh]\w+-[tblr]{2}/, "tb") + e;
        case 108:
          return Mt + e + br + Pt(e, /[svh]\w+-[tblr]{2}/, "tb-rl") + e;
        case 45:
          return Mt + e + br + Pt(e, /[svh]\w+-[tblr]{2}/, "lr") + e;
      }
      return Mt + e + br + e + e;
  }
  return e;
}
var Fz = function(t, n, r, o) {
  if (t.length > -1 && !t.return)
    switch (t.type) {
      case S_:
        t.return = zO(t.value, t.length);
        break;
      case NO:
        return lc([_u(t, {
          value: Pt(t.value, "@", "@" + Mt)
        })], o);
      case C_:
        if (t.length)
          return gz(t.props, function(i) {
            switch (mz(i, /(::plac\w+|:read-\w+)/)) {
              case ":read-only":
              case ":read-write":
                return lc([_u(t, {
                  props: [Pt(i, /:(read-\w+)/, ":" + hh + "$1")]
                })], o);
              case "::placeholder":
                return lc([_u(t, {
                  props: [Pt(i, /:(plac\w+)/, ":" + Mt + "input-$1")]
                }), _u(t, {
                  props: [Pt(i, /:(plac\w+)/, ":" + hh + "$1")]
                }), _u(t, {
                  props: [Pt(i, /:(plac\w+)/, br + "input-$1")]
                })], o);
            }
            return "";
          });
    }
}, zz = [Fz], BO = function(t) {
  var n = t.key;
  if (process.env.NODE_ENV !== "production" && !n)
    throw new Error(`You have to configure \`key\` for your cache. Please make sure it's unique (and not equal to 'css') as it's used for linking styles to your cache.
If multiple caches share the same key they might "fight" for each other's style elements.`);
  if (n === "css") {
    var r = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(r, function(g) {
      var b = g.getAttribute("data-emotion");
      b.indexOf(" ") !== -1 && (document.head.appendChild(g), g.setAttribute("data-s", ""));
    });
  }
  var o = t.stylisPlugins || zz;
  if (process.env.NODE_ENV !== "production" && /[^a-z-]/.test(n))
    throw new Error('Emotion key must only contain lower case alphabetical characters and - but "' + n + '" was passed');
  var i = {}, a, s = [];
  a = t.container || document.head, Array.prototype.forEach.call(
    // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + n + ' "]'),
    function(g) {
      for (var b = g.getAttribute("data-emotion").split(" "), x = 1; x < b.length; x++)
        i[b[x]] = !0;
      s.push(g);
    }
  );
  var c, l = [Oz, Nz];
  process.env.NODE_ENV !== "production" && l.push(Iz({
    get compat() {
      return v.compat;
    }
  }), $z);
  {
    var d, f = [Tz, process.env.NODE_ENV !== "production" ? function(g) {
      g.root || (g.return ? d.insert(g.return) : g.value && g.type !== x_ && d.insert(g.value + "{}"));
    } : kz(function(g) {
      d.insert(g);
    })], p = Ez(l.concat(o, f)), m = function(b) {
      return lc(Cz(b), p);
    };
    c = function(b, x, T, S) {
      d = T, process.env.NODE_ENV !== "production" && x.map !== void 0 && (d = {
        insert: function(w) {
          T.insert(w + x.map);
        }
      }), m(b ? b + "{" + x.styles + "}" : x.styles), S && (v.inserted[x.name] = !0);
    };
  }
  var v = {
    key: n,
    sheet: new cz({
      key: n,
      container: a,
      nonce: t.nonce,
      speedy: t.speedy,
      prepend: t.prepend,
      insertionPoint: t.insertionPoint
    }),
    nonce: t.nonce,
    inserted: i,
    registered: {},
    insert: c
  };
  return v.sheet.hydrate(s), v;
}, Bz = !0;
function E_(e, t, n) {
  var r = "";
  return n.split(" ").forEach(function(o) {
    e[o] !== void 0 ? t.push(e[o] + ";") : r += o + " ";
  }), r;
}
var Mm = function(t, n, r) {
  var o = t.key + "-" + n.name;
  // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (r === !1 || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  Bz === !1) && t.registered[o] === void 0 && (t.registered[o] = n.styles);
}, Rm = function(t, n, r) {
  Mm(t, n, r);
  var o = t.key + "-" + n.name;
  if (t.inserted[n.name] === void 0) {
    var i = n;
    do
      t.insert(n === i ? "." + o : "", i, t.sheet, !0), i = i.next;
    while (i !== void 0);
  }
};
function Hz(e) {
  for (var t = 0, n, r = 0, o = e.length; o >= 4; ++r, o -= 4)
    n = e.charCodeAt(r) & 255 | (e.charCodeAt(++r) & 255) << 8 | (e.charCodeAt(++r) & 255) << 16 | (e.charCodeAt(++r) & 255) << 24, n = /* Math.imul(k, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16), n ^= /* k >>> r: */
    n >>> 24, t = /* Math.imul(k, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
  switch (o) {
    case 3:
      t ^= (e.charCodeAt(r + 2) & 255) << 16;
    case 2:
      t ^= (e.charCodeAt(r + 1) & 255) << 8;
    case 1:
      t ^= e.charCodeAt(r) & 255, t = /* Math.imul(h, m): */
      (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
  }
  return t ^= t >>> 13, t = /* Math.imul(h, m): */
  (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16), ((t ^ t >>> 15) >>> 0).toString(36);
}
var jz = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
}, KC = `You have illegal escape sequence in your template literal, most likely inside content's property value.
Because you write your CSS inside a JavaScript string you actually have to do double escaping, so for example "content: '\\00d7';" should become "content: '\\\\00d7';".
You can read more about this here:
https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences`, Wz = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).", Vz = /[A-Z]|^ms/g, HO = /_EMO_([^_]+?)_([^]*?)_EMO_/g, k_ = function(t) {
  return t.charCodeAt(1) === 45;
}, JC = function(t) {
  return t != null && typeof t != "boolean";
}, Ev = /* @__PURE__ */ $O(function(e) {
  return k_(e) ? e : e.replace(Vz, "-$&").toLowerCase();
}), mh = function(t, n) {
  switch (t) {
    case "animation":
    case "animationName":
      if (typeof n == "string")
        return n.replace(HO, function(r, o, i) {
          return ai = {
            name: o,
            styles: i,
            next: ai
          }, o;
        });
  }
  return jz[t] !== 1 && !k_(t) && typeof n == "number" && n !== 0 ? n + "px" : n;
};
if (process.env.NODE_ENV !== "production") {
  var Uz = /(var|attr|counters?|url|element|(((repeating-)?(linear|radial))|conic)-gradient)\(|(no-)?(open|close)-quote/, qz = ["normal", "none", "initial", "inherit", "unset"], Gz = mh, Yz = /^-ms-/, Zz = /-(.)/g, QC = {};
  mh = function(t, n) {
    if (t === "content" && (typeof n != "string" || qz.indexOf(n) === -1 && !Uz.test(n) && (n.charAt(0) !== n.charAt(n.length - 1) || n.charAt(0) !== '"' && n.charAt(0) !== "'")))
      throw new Error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + n + "\"'`");
    var r = Gz(t, n);
    return r !== "" && !k_(t) && t.indexOf("-") !== -1 && QC[t] === void 0 && (QC[t] = !0, console.error("Using kebab-case for css properties in objects is not supported. Did you mean " + t.replace(Yz, "ms-").replace(Zz, function(o, i) {
      return i.toUpperCase();
    }) + "?")), r;
  };
}
var jO = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function Md(e, t, n) {
  if (n == null)
    return "";
  if (n.__emotion_styles !== void 0) {
    if (process.env.NODE_ENV !== "production" && n.toString() === "NO_COMPONENT_SELECTOR")
      throw new Error(jO);
    return n;
  }
  switch (typeof n) {
    case "boolean":
      return "";
    case "object": {
      if (n.anim === 1)
        return ai = {
          name: n.name,
          styles: n.styles,
          next: ai
        }, n.name;
      if (n.styles !== void 0) {
        var r = n.next;
        if (r !== void 0)
          for (; r !== void 0; )
            ai = {
              name: r.name,
              styles: r.styles,
              next: ai
            }, r = r.next;
        var o = n.styles + ";";
        return process.env.NODE_ENV !== "production" && n.map !== void 0 && (o += n.map), o;
      }
      return Xz(e, t, n);
    }
    case "function": {
      if (e !== void 0) {
        var i = ai, a = n(e);
        return ai = i, Md(e, t, a);
      } else
        process.env.NODE_ENV !== "production" && console.error("Functions that are interpolated in css calls will be stringified.\nIf you want to have a css call based on props, create a function that returns a css call like this\nlet dynamicStyle = (props) => css`color: ${props.color}`\nIt can be called directly with props or interpolated in a styled call like this\nlet SomeComponent = styled('div')`${dynamicStyle}`");
      break;
    }
    case "string":
      if (process.env.NODE_ENV !== "production") {
        var s = [], c = n.replace(HO, function(d, f, p) {
          var m = "animation" + s.length;
          return s.push("const " + m + " = keyframes`" + p.replace(/^@keyframes animation-\w+/, "") + "`"), "${" + m + "}";
        });
        s.length && console.error("`keyframes` output got interpolated into plain string, please wrap it with `css`.\n\nInstead of doing this:\n\n" + [].concat(s, ["`" + c + "`"]).join(`
`) + `

You should wrap it with \`css\` like this:

` + ("css`" + c + "`"));
      }
      break;
  }
  if (t == null)
    return n;
  var l = t[n];
  return l !== void 0 ? l : n;
}
function Xz(e, t, n) {
  var r = "";
  if (Array.isArray(n))
    for (var o = 0; o < n.length; o++)
      r += Md(e, t, n[o]) + ";";
  else
    for (var i in n) {
      var a = n[i];
      if (typeof a != "object")
        t != null && t[a] !== void 0 ? r += i + "{" + t[a] + "}" : JC(a) && (r += Ev(i) + ":" + mh(i, a) + ";");
      else {
        if (i === "NO_COMPONENT_SELECTOR" && process.env.NODE_ENV !== "production")
          throw new Error(jO);
        if (Array.isArray(a) && typeof a[0] == "string" && (t == null || t[a[0]] === void 0))
          for (var s = 0; s < a.length; s++)
            JC(a[s]) && (r += Ev(i) + ":" + mh(i, a[s]) + ";");
        else {
          var c = Md(e, t, a);
          switch (i) {
            case "animation":
            case "animationName": {
              r += Ev(i) + ":" + c + ";";
              break;
            }
            default:
              process.env.NODE_ENV !== "production" && i === "undefined" && console.error(Wz), r += i + "{" + c + "}";
          }
        }
      }
    }
  return r;
}
var e2 = /label:\s*([^\s;\n{]+)\s*(;|$)/g, WO;
process.env.NODE_ENV !== "production" && (WO = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//g);
var ai, gc = function(t, n, r) {
  if (t.length === 1 && typeof t[0] == "object" && t[0] !== null && t[0].styles !== void 0)
    return t[0];
  var o = !0, i = "";
  ai = void 0;
  var a = t[0];
  a == null || a.raw === void 0 ? (o = !1, i += Md(r, n, a)) : (process.env.NODE_ENV !== "production" && a[0] === void 0 && console.error(KC), i += a[0]);
  for (var s = 1; s < t.length; s++)
    i += Md(r, n, t[s]), o && (process.env.NODE_ENV !== "production" && a[s] === void 0 && console.error(KC), i += a[s]);
  var c;
  process.env.NODE_ENV !== "production" && (i = i.replace(WO, function(p) {
    return c = p, "";
  })), e2.lastIndex = 0;
  for (var l = "", d; (d = e2.exec(i)) !== null; )
    l += "-" + // $FlowFixMe we know it's not null
    d[1];
  var f = Hz(i) + l;
  return process.env.NODE_ENV !== "production" ? {
    name: f,
    styles: i,
    map: c,
    next: ai,
    toString: function() {
      return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
  } : {
    name: f,
    styles: i,
    next: ai
  };
}, Kz = function(t) {
  return t();
}, VO = B[`useInsertionEffect${Math.random()}`.slice(0, 5)] ? B[`useInsertionEffect${Math.random()}`.slice(0, 5)] : !1, M_ = VO || Kz, t2 = VO || B.useLayoutEffect, Jz = {}.hasOwnProperty, R_ = /* @__PURE__ */ B.createContext(
  // we're doing this to avoid preconstruct's dead code elimination in this one case
  // because this module is primarily intended for the browser and node
  // but it's also required in react native and similar environments sometimes
  // and we could have a special build just for that
  // but this is much easier and the native packages
  // might use a different theme context in the future anyway
  typeof HTMLElement != "undefined" ? /* @__PURE__ */ BO({
    key: "css"
  }) : null
);
process.env.NODE_ENV !== "production" && (R_.displayName = "EmotionCacheContext");
var UO = R_.Provider, Pm = function(t) {
  return /* @__PURE__ */ nl(function(n, r) {
    var o = rl(R_);
    return t(n, o, r);
  });
}, Hi = /* @__PURE__ */ B.createContext({});
process.env.NODE_ENV !== "production" && (Hi.displayName = "EmotionThemeContext");
var n2 = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__", r2 = "__EMOTION_LABEL_PLEASE_DO_NOT_USE__", Qz = function(t) {
  var n = t.cache, r = t.serialized, o = t.isStringTag;
  return Mm(n, r, o), M_(function() {
    return Rm(n, r, o);
  }), null;
}, eB = /* @__PURE__ */ Pm(function(e, t, n) {
  var r = e.css;
  typeof r == "string" && t.registered[r] !== void 0 && (r = t.registered[r]);
  var o = e[n2], i = [r], a = "";
  typeof e.className == "string" ? a = E_(t.registered, i, e.className) : e.className != null && (a = e.className + " ");
  var s = gc(i, void 0, B.useContext(Hi));
  if (process.env.NODE_ENV !== "production" && s.name.indexOf("-") === -1) {
    var c = e[r2];
    c && (s = gc([s, "label:" + c + ";"]));
  }
  a += t.key + "-" + s.name;
  var l = {};
  for (var d in e)
    Jz.call(e, d) && d !== "css" && d !== n2 && (process.env.NODE_ENV === "production" || d !== r2) && (l[d] = e[d]);
  return l.ref = n, l.className = a, /* @__PURE__ */ B.createElement(B.Fragment, null, /* @__PURE__ */ B.createElement(Qz, {
    cache: t,
    serialized: s,
    isStringTag: typeof o == "string"
  }), /* @__PURE__ */ B.createElement(o, l));
});
process.env.NODE_ENV !== "production" && (eB.displayName = "EmotionCssPropInternal");
var tB = {
  name: "@emotion/react",
  version: "11.11.4",
  main: "dist/emotion-react.cjs.js",
  module: "dist/emotion-react.esm.js",
  browser: {
    "./dist/emotion-react.esm.js": "./dist/emotion-react.browser.esm.js"
  },
  exports: {
    ".": {
      module: {
        worker: "./dist/emotion-react.worker.esm.js",
        browser: "./dist/emotion-react.browser.esm.js",
        default: "./dist/emotion-react.esm.js"
      },
      import: "./dist/emotion-react.cjs.mjs",
      default: "./dist/emotion-react.cjs.js"
    },
    "./jsx-runtime": {
      module: {
        worker: "./jsx-runtime/dist/emotion-react-jsx-runtime.worker.esm.js",
        browser: "./jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js",
        default: "./jsx-runtime/dist/emotion-react-jsx-runtime.esm.js"
      },
      import: "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.mjs",
      default: "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.js"
    },
    "./_isolated-hnrs": {
      module: {
        worker: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.worker.esm.js",
        browser: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.esm.js",
        default: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.esm.js"
      },
      import: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.mjs",
      default: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.js"
    },
    "./jsx-dev-runtime": {
      module: {
        worker: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.worker.esm.js",
        browser: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.browser.esm.js",
        default: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.esm.js"
      },
      import: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.mjs",
      default: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.js"
    },
    "./package.json": "./package.json",
    "./types/css-prop": "./types/css-prop.d.ts",
    "./macro": {
      types: {
        import: "./macro.d.mts",
        default: "./macro.d.ts"
      },
      default: "./macro.js"
    }
  },
  types: "types/index.d.ts",
  files: [
    "src",
    "dist",
    "jsx-runtime",
    "jsx-dev-runtime",
    "_isolated-hnrs",
    "types/*.d.ts",
    "macro.*"
  ],
  sideEffects: !1,
  author: "Emotion Contributors",
  license: "MIT",
  scripts: {
    "test:typescript": "dtslint types"
  },
  dependencies: {
    "@babel/runtime": "^7.18.3",
    "@emotion/babel-plugin": "^11.11.0",
    "@emotion/cache": "^11.11.0",
    "@emotion/serialize": "^1.1.3",
    "@emotion/use-insertion-effect-with-fallbacks": "^1.0.1",
    "@emotion/utils": "^1.2.1",
    "@emotion/weak-memoize": "^0.3.1",
    "hoist-non-react-statics": "^3.3.1"
  },
  peerDependencies: {
    react: ">=16.8.0"
  },
  peerDependenciesMeta: {
    "@types/react": {
      optional: !0
    }
  },
  devDependencies: {
    "@definitelytyped/dtslint": "0.0.112",
    "@emotion/css": "11.11.2",
    "@emotion/css-prettifier": "1.1.3",
    "@emotion/server": "11.11.0",
    "@emotion/styled": "11.11.0",
    "html-tag-names": "^1.1.2",
    react: "16.14.0",
    "svg-tag-names": "^1.1.1",
    typescript: "^4.5.5"
  },
  repository: "https://github.com/emotion-js/emotion/tree/main/packages/react",
  publishConfig: {
    access: "public"
  },
  "umd:main": "dist/emotion-react.umd.min.js",
  preconstruct: {
    entrypoints: [
      "./index.js",
      "./jsx-runtime.js",
      "./jsx-dev-runtime.js",
      "./_isolated-hnrs.js"
    ],
    umdName: "emotionReact",
    exports: {
      envConditions: [
        "browser",
        "worker"
      ],
      extra: {
        "./types/css-prop": "./types/css-prop.d.ts",
        "./macro": {
          types: {
            import: "./macro.d.mts",
            default: "./macro.d.ts"
          },
          default: "./macro.js"
        }
      }
    }
  }
}, o2 = !1, P_ = /* @__PURE__ */ Pm(function(e, t) {
  process.env.NODE_ENV !== "production" && !o2 && // check for className as well since the user is
  // probably using the custom createElement which
  // means it will be turned into a className prop
  // $FlowFixMe I don't really want to add it to the type since it shouldn't be used
  (e.className || e.css) && (console.error("It looks like you're using the css prop on Global, did you mean to use the styles prop instead?"), o2 = !0);
  var n = e.styles, r = gc([n], void 0, B.useContext(Hi)), o = B.useRef();
  return t2(function() {
    var i = t.key + "-global", a = new t.sheet.constructor({
      key: i,
      nonce: t.sheet.nonce,
      container: t.sheet.container,
      speedy: t.sheet.isSpeedy
    }), s = !1, c = document.querySelector('style[data-emotion="' + i + " " + r.name + '"]');
    return t.sheet.tags.length && (a.before = t.sheet.tags[0]), c !== null && (s = !0, c.setAttribute("data-emotion", i), a.hydrate([c])), o.current = [a, s], function() {
      a.flush();
    };
  }, [t]), t2(function() {
    var i = o.current, a = i[0], s = i[1];
    if (s) {
      i[1] = !1;
      return;
    }
    if (r.next !== void 0 && Rm(t, r.next, !0), a.tags.length) {
      var c = a.tags[a.tags.length - 1].nextElementSibling;
      a.before = c, a.flush();
    }
    t.insert("", r, a, !1);
  }, [t, r.name]), null;
});
process.env.NODE_ENV !== "production" && (P_.displayName = "EmotionGlobal");
function ra() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return gc(t);
}
var us = function() {
  var t = ra.apply(void 0, arguments), n = "animation-" + t.name;
  return {
    name: n,
    styles: "@keyframes " + n + "{" + t.styles + "}",
    anim: 1,
    toString: function() {
      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
    }
  };
}, nB = function e(t) {
  for (var n = t.length, r = 0, o = ""; r < n; r++) {
    var i = t[r];
    if (i != null) {
      var a = void 0;
      switch (typeof i) {
        case "boolean":
          break;
        case "object": {
          if (Array.isArray(i))
            a = e(i);
          else {
            process.env.NODE_ENV !== "production" && i.styles !== void 0 && i.name !== void 0 && console.error("You have passed styles created with `css` from `@emotion/react` package to the `cx`.\n`cx` is meant to compose class names (strings) so you should convert those styles to a class name by passing them to the `css` received from <ClassNames/> component."), a = "";
            for (var s in i)
              i[s] && s && (a && (a += " "), a += s);
          }
          break;
        }
        default:
          a = i;
      }
      a && (o && (o += " "), o += a);
    }
  }
  return o;
};
function rB(e, t, n) {
  var r = [], o = E_(e, r, n);
  return r.length < 2 ? n : o + t(r);
}
var oB = function(t) {
  var n = t.cache, r = t.serializedArr;
  return M_(function() {
    for (var o = 0; o < r.length; o++)
      Rm(n, r[o], !1);
  }), null;
}, iB = /* @__PURE__ */ Pm(function(e, t) {
  var n = !1, r = [], o = function() {
    if (n && process.env.NODE_ENV !== "production")
      throw new Error("css can only be used during render");
    for (var l = arguments.length, d = new Array(l), f = 0; f < l; f++)
      d[f] = arguments[f];
    var p = gc(d, t.registered);
    return r.push(p), Mm(t, p, !1), t.key + "-" + p.name;
  }, i = function() {
    if (n && process.env.NODE_ENV !== "production")
      throw new Error("cx can only be used during render");
    for (var l = arguments.length, d = new Array(l), f = 0; f < l; f++)
      d[f] = arguments[f];
    return rB(t.registered, o, nB(d));
  }, a = {
    css: o,
    cx: i,
    theme: B.useContext(Hi)
  }, s = e.children(a);
  return n = !0, /* @__PURE__ */ B.createElement(B.Fragment, null, /* @__PURE__ */ B.createElement(oB, {
    cache: t,
    serializedArr: r
  }), s);
});
process.env.NODE_ENV !== "production" && (iB.displayName = "EmotionClassNames");
if (process.env.NODE_ENV !== "production") {
  var i2 = !0, aB = typeof jest != "undefined" || typeof vi != "undefined";
  if (i2 && !aB) {
    var a2 = (
      // $FlowIgnore
      typeof globalThis != "undefined" ? globalThis : i2 ? window : global
    ), s2 = "__EMOTION_REACT_" + tB.version.split(".")[0] + "__";
    a2[s2] && console.warn("You are loading @emotion/react when it is already loaded. Running multiple instances may cause problems. This can happen if multiple versions are used, or if multiple builds of the same version are used."), a2[s2] = !0;
  }
}
var sB = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/, lB = /* @__PURE__ */ $O(
  function(e) {
    return sB.test(e) || e.charCodeAt(0) === 111 && e.charCodeAt(1) === 110 && e.charCodeAt(2) < 91;
  }
  /* Z+1 */
), cB = lB, uB = function(t) {
  return t !== "theme";
}, l2 = function(t) {
  return typeof t == "string" && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  t.charCodeAt(0) > 96 ? cB : uB;
}, c2 = function(t, n, r) {
  var o;
  if (n) {
    var i = n.shouldForwardProp;
    o = t.__emotion_forwardProp && i ? function(a) {
      return t.__emotion_forwardProp(a) && i(a);
    } : i;
  }
  return typeof o != "function" && r && (o = t.__emotion_forwardProp), o;
}, u2 = `You have illegal escape sequence in your template literal, most likely inside content's property value.
Because you write your CSS inside a JavaScript string you actually have to do double escaping, so for example "content: '\\00d7';" should become "content: '\\\\00d7';".
You can read more about this here:
https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences`, dB = function(t) {
  var n = t.cache, r = t.serialized, o = t.isStringTag;
  return Mm(n, r, o), M_(function() {
    return Rm(n, r, o);
  }), null;
}, fB = function e(t, n) {
  if (process.env.NODE_ENV !== "production" && t === void 0)
    throw new Error(`You are trying to create a styled element with an undefined component.
You may have forgotten to import it.`);
  var r = t.__emotion_real === t, o = r && t.__emotion_base || t, i, a;
  n !== void 0 && (i = n.label, a = n.target);
  var s = c2(t, n, r), c = s || l2(o), l = !c("as");
  return function() {
    var d = arguments, f = r && t.__emotion_styles !== void 0 ? t.__emotion_styles.slice(0) : [];
    if (i !== void 0 && f.push("label:" + i + ";"), d[0] == null || d[0].raw === void 0)
      f.push.apply(f, d);
    else {
      process.env.NODE_ENV !== "production" && d[0][0] === void 0 && console.error(u2), f.push(d[0][0]);
      for (var p = d.length, m = 1; m < p; m++)
        process.env.NODE_ENV !== "production" && d[0][m] === void 0 && console.error(u2), f.push(d[m], d[0][m]);
    }
    var v = Pm(function(g, b, x) {
      var T = l && g.as || o, S = "", _ = [], w = g;
      if (g.theme == null) {
        w = {};
        for (var k in g)
          w[k] = g[k];
        w.theme = B.useContext(Hi);
      }
      typeof g.className == "string" ? S = E_(b.registered, _, g.className) : g.className != null && (S = g.className + " ");
      var E = gc(f.concat(_), b.registered, w);
      S += b.key + "-" + E.name, a !== void 0 && (S += " " + a);
      var R = l && s === void 0 ? l2(T) : c, P = {};
      for (var A in g)
        l && A === "as" || // $FlowFixMe
        R(A) && (P[A] = g[A]);
      return P.className = S, P.ref = x, /* @__PURE__ */ B.createElement(B.Fragment, null, /* @__PURE__ */ B.createElement(dB, {
        cache: b,
        serialized: E,
        isStringTag: typeof T == "string"
      }), /* @__PURE__ */ B.createElement(T, P));
    });
    return v.displayName = i !== void 0 ? i : "Styled(" + (typeof o == "string" ? o : o.displayName || o.name || "Component") + ")", v.defaultProps = t.defaultProps, v.__emotion_real = v, v.__emotion_base = o, v.__emotion_styles = f, v.__emotion_forwardProp = s, Object.defineProperty(v, "toString", {
      value: function() {
        return a === void 0 && process.env.NODE_ENV !== "production" ? "NO_COMPONENT_SELECTOR" : "." + a;
      }
    }), v.withComponent = function(g, b) {
      return e(g, ue({}, n, b, {
        shouldForwardProp: c2(v, b, !0)
      })).apply(void 0, f);
    }, v;
  };
}, pB = [
  "a",
  "abbr",
  "address",
  "area",
  "article",
  "aside",
  "audio",
  "b",
  "base",
  "bdi",
  "bdo",
  "big",
  "blockquote",
  "body",
  "br",
  "button",
  "canvas",
  "caption",
  "cite",
  "code",
  "col",
  "colgroup",
  "data",
  "datalist",
  "dd",
  "del",
  "details",
  "dfn",
  "dialog",
  "div",
  "dl",
  "dt",
  "em",
  "embed",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hgroup",
  "hr",
  "html",
  "i",
  "iframe",
  "img",
  "input",
  "ins",
  "kbd",
  "keygen",
  "label",
  "legend",
  "li",
  "link",
  "main",
  "map",
  "mark",
  "marquee",
  "menu",
  "menuitem",
  "meta",
  "meter",
  "nav",
  "noscript",
  "object",
  "ol",
  "optgroup",
  "option",
  "output",
  "p",
  "param",
  "picture",
  "pre",
  "progress",
  "q",
  "rp",
  "rt",
  "ruby",
  "s",
  "samp",
  "script",
  "section",
  "select",
  "small",
  "source",
  "span",
  "strong",
  "style",
  "sub",
  "summary",
  "sup",
  "table",
  "tbody",
  "td",
  "textarea",
  "tfoot",
  "th",
  "thead",
  "time",
  "title",
  "tr",
  "track",
  "u",
  "ul",
  "var",
  "video",
  "wbr",
  // SVG
  "circle",
  "clipPath",
  "defs",
  "ellipse",
  "foreignObject",
  "g",
  "image",
  "line",
  "linearGradient",
  "mask",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "radialGradient",
  "rect",
  "stop",
  "svg",
  "text",
  "tspan"
], Fo = fB.bind();
pB.forEach(function(e) {
  Fo[e] = Fo(e);
});
var hB = Object.defineProperty, mB = Object.defineProperties, gB = Object.getOwnPropertyDescriptors, gh = Object.getOwnPropertySymbols, qO = Object.prototype.hasOwnProperty, GO = Object.prototype.propertyIsEnumerable, li = Math.pow, Rb = (e, t, n) => t in e ? hB(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, pe = (e, t) => {
  for (var n in t || (t = {}))
    qO.call(t, n) && Rb(e, n, t[n]);
  if (gh)
    for (var n of gh(t))
      GO.call(t, n) && Rb(e, n, t[n]);
  return e;
}, $e = (e, t) => mB(e, gB(t)), Wn = (e, t) => {
  var n = {};
  for (var r in e)
    qO.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && gh)
    for (var r of gh(e))
      t.indexOf(r) < 0 && GO.call(e, r) && (n[r] = e[r]);
  return n;
}, Z = (e, t, n) => (Rb(e, typeof t != "symbol" ? t + "" : t, n), n), YO = (e, t, n) => new Promise((r, o) => {
  var i = (c) => {
    try {
      s(n.next(c));
    } catch (l) {
      o(l);
    }
  }, a = (c) => {
    try {
      s(n.throw(c));
    } catch (l) {
      o(l);
    }
  }, s = (c) => c.done ? r(c.value) : Promise.resolve(c.value).then(i, a);
  s((n = n.apply(e, t)).next());
}), O_ = typeof globalThis != "undefined" ? globalThis : typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
function ji(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function wa(e) {
  if (e.__esModule)
    return e;
  var t = e.default;
  if (typeof t == "function") {
    var n = function r() {
      if (this instanceof r) {
        var o = [null];
        o.push.apply(o, arguments);
        var i = Function.bind.apply(t, o);
        return new i();
      }
      return t.apply(this, arguments);
    };
    n.prototype = t.prototype;
  } else
    n = {};
  return Object.defineProperty(n, "__esModule", { value: !0 }), Object.keys(e).forEach(function(r) {
    var o = Object.getOwnPropertyDescriptor(e, r);
    Object.defineProperty(n, r, o.get ? o : {
      enumerable: !0,
      get: function() {
        return e[r];
      }
    });
  }), n;
}
var ud = {}, vB = {
  get exports() {
    return ud;
  },
  set exports(e) {
    ud = e;
  }
}, d2;
function bB() {
  if (d2)
    return ud;
  d2 = 1;
  var e = typeof Reflect == "object" ? Reflect : null, t = e && typeof e.apply == "function" ? e.apply : function(_, w, k) {
    return Function.prototype.apply.call(_, w, k);
  }, n;
  e && typeof e.ownKeys == "function" ? n = e.ownKeys : Object.getOwnPropertySymbols ? n = function(_) {
    return Object.getOwnPropertyNames(_).concat(Object.getOwnPropertySymbols(_));
  } : n = function(_) {
    return Object.getOwnPropertyNames(_);
  };
  function r(_) {
    console && console.warn && console.warn(_);
  }
  var o = Number.isNaN || function(_) {
    return _ !== _;
  };
  function i() {
    i.init.call(this);
  }
  vB.exports = i, ud.once = x, i.EventEmitter = i, i.prototype._events = void 0, i.prototype._eventsCount = 0, i.prototype._maxListeners = void 0;
  var a = 10;
  function s(_) {
    if (typeof _ != "function")
      throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof _);
  }
  Object.defineProperty(i, "defaultMaxListeners", {
    enumerable: !0,
    get: function() {
      return a;
    },
    set: function(_) {
      if (typeof _ != "number" || _ < 0 || o(_))
        throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + _ + ".");
      a = _;
    }
  }), i.init = function() {
    (this._events === void 0 || this._events === Object.getPrototypeOf(this)._events) && (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
  }, i.prototype.setMaxListeners = function(_) {
    if (typeof _ != "number" || _ < 0 || o(_))
      throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + _ + ".");
    return this._maxListeners = _, this;
  };
  function c(_) {
    return _._maxListeners === void 0 ? i.defaultMaxListeners : _._maxListeners;
  }
  i.prototype.getMaxListeners = function() {
    return c(this);
  }, i.prototype.emit = function(_) {
    for (var w = [], k = 1; k < arguments.length; k++)
      w.push(arguments[k]);
    var E = _ === "error", R = this._events;
    if (R !== void 0)
      E = E && R.error === void 0;
    else if (!E)
      return !1;
    if (E) {
      var P;
      if (w.length > 0 && (P = w[0]), P instanceof Error)
        throw P;
      var A = new Error("Unhandled error." + (P ? " (" + P.message + ")" : ""));
      throw A.context = P, A;
    }
    var D = R[_];
    if (D === void 0)
      return !1;
    if (typeof D == "function")
      t(D, this, w);
    else
      for (var N = D.length, F = v(D, N), k = 0; k < N; ++k)
        t(F[k], this, w);
    return !0;
  };
  function l(_, w, k, E) {
    var R, P, A;
    if (s(k), P = _._events, P === void 0 ? (P = _._events = /* @__PURE__ */ Object.create(null), _._eventsCount = 0) : (P.newListener !== void 0 && (_.emit(
      "newListener",
      w,
      k.listener ? k.listener : k
    ), P = _._events), A = P[w]), A === void 0)
      A = P[w] = k, ++_._eventsCount;
    else if (typeof A == "function" ? A = P[w] = E ? [k, A] : [A, k] : E ? A.unshift(k) : A.push(k), R = c(_), R > 0 && A.length > R && !A.warned) {
      A.warned = !0;
      var D = new Error("Possible EventEmitter memory leak detected. " + A.length + " " + String(w) + " listeners added. Use emitter.setMaxListeners() to increase limit");
      D.name = "MaxListenersExceededWarning", D.emitter = _, D.type = w, D.count = A.length, r(D);
    }
    return _;
  }
  i.prototype.addListener = function(_, w) {
    return l(this, _, w, !1);
  }, i.prototype.on = i.prototype.addListener, i.prototype.prependListener = function(_, w) {
    return l(this, _, w, !0);
  };
  function d() {
    if (!this.fired)
      return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, arguments.length === 0 ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
  }
  function f(_, w, k) {
    var E = { fired: !1, wrapFn: void 0, target: _, type: w, listener: k }, R = d.bind(E);
    return R.listener = k, E.wrapFn = R, R;
  }
  i.prototype.once = function(_, w) {
    return s(w), this.on(_, f(this, _, w)), this;
  }, i.prototype.prependOnceListener = function(_, w) {
    return s(w), this.prependListener(_, f(this, _, w)), this;
  }, i.prototype.removeListener = function(_, w) {
    var k, E, R, P, A;
    if (s(w), E = this._events, E === void 0)
      return this;
    if (k = E[_], k === void 0)
      return this;
    if (k === w || k.listener === w)
      --this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : (delete E[_], E.removeListener && this.emit("removeListener", _, k.listener || w));
    else if (typeof k != "function") {
      for (R = -1, P = k.length - 1; P >= 0; P--)
        if (k[P] === w || k[P].listener === w) {
          A = k[P].listener, R = P;
          break;
        }
      if (R < 0)
        return this;
      R === 0 ? k.shift() : g(k, R), k.length === 1 && (E[_] = k[0]), E.removeListener !== void 0 && this.emit("removeListener", _, A || w);
    }
    return this;
  }, i.prototype.off = i.prototype.removeListener, i.prototype.removeAllListeners = function(_) {
    var w, k, E;
    if (k = this._events, k === void 0)
      return this;
    if (k.removeListener === void 0)
      return arguments.length === 0 ? (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0) : k[_] !== void 0 && (--this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : delete k[_]), this;
    if (arguments.length === 0) {
      var R = Object.keys(k), P;
      for (E = 0; E < R.length; ++E)
        P = R[E], P !== "removeListener" && this.removeAllListeners(P);
      return this.removeAllListeners("removeListener"), this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0, this;
    }
    if (w = k[_], typeof w == "function")
      this.removeListener(_, w);
    else if (w !== void 0)
      for (E = w.length - 1; E >= 0; E--)
        this.removeListener(_, w[E]);
    return this;
  };
  function p(_, w, k) {
    var E = _._events;
    if (E === void 0)
      return [];
    var R = E[w];
    return R === void 0 ? [] : typeof R == "function" ? k ? [R.listener || R] : [R] : k ? b(R) : v(R, R.length);
  }
  i.prototype.listeners = function(_) {
    return p(this, _, !0);
  }, i.prototype.rawListeners = function(_) {
    return p(this, _, !1);
  }, i.listenerCount = function(_, w) {
    return typeof _.listenerCount == "function" ? _.listenerCount(w) : m.call(_, w);
  }, i.prototype.listenerCount = m;
  function m(_) {
    var w = this._events;
    if (w !== void 0) {
      var k = w[_];
      if (typeof k == "function")
        return 1;
      if (k !== void 0)
        return k.length;
    }
    return 0;
  }
  i.prototype.eventNames = function() {
    return this._eventsCount > 0 ? n(this._events) : [];
  };
  function v(_, w) {
    for (var k = new Array(w), E = 0; E < w; ++E)
      k[E] = _[E];
    return k;
  }
  function g(_, w) {
    for (; w + 1 < _.length; w++)
      _[w] = _[w + 1];
    _.pop();
  }
  function b(_) {
    for (var w = new Array(_.length), k = 0; k < w.length; ++k)
      w[k] = _[k].listener || _[k];
    return w;
  }
  function x(_, w) {
    return new Promise(function(k, E) {
      function R(A) {
        _.removeListener(w, P), E(A);
      }
      function P() {
        typeof _.removeListener == "function" && _.removeListener("error", R), k([].slice.call(arguments));
      }
      S(_, w, P, { once: !0 }), w !== "error" && T(_, R, { once: !0 });
    });
  }
  function T(_, w, k) {
    typeof _.on == "function" && S(_, "error", w, k);
  }
  function S(_, w, k, E) {
    if (typeof _.on == "function")
      E.once ? _.once(w, k) : _.on(w, k);
    else if (typeof _.addEventListener == "function")
      _.addEventListener(w, function R(P) {
        E.once && _.removeEventListener(w, R), k(P);
      });
    else
      throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof _);
  }
  return ud;
}
var yB = bB();
const uf = /* @__PURE__ */ ji(yB);
var Cl = {}, f2;
function _B() {
  if (f2)
    return Cl;
  f2 = 1;
  var e = _r;
  if (process.env.NODE_ENV === "production")
    Cl.createRoot = e.createRoot, Cl.hydrateRoot = e.hydrateRoot;
  else {
    var t = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    Cl.createRoot = function(n, r) {
      t.usingClientEntryPoint = !0;
      try {
        return e.createRoot(n, r);
      } finally {
        t.usingClientEntryPoint = !1;
      }
    }, Cl.hydrateRoot = function(n, r, o) {
      t.usingClientEntryPoint = !0;
      try {
        return e.hydrateRoot(n, r, o);
      } finally {
        t.usingClientEntryPoint = !1;
      }
    };
  }
  return Cl;
}
var wB = _B();
const xB = /* @__PURE__ */ ji(wB);
function CB() {
  this.__data__ = [], this.size = 0;
}
function ZO(e, t) {
  return e === t || e !== e && t !== t;
}
function Om(e, t) {
  for (var n = e.length; n--; )
    if (ZO(e[n][0], t))
      return n;
  return -1;
}
var SB = Array.prototype, TB = SB.splice;
function EB(e) {
  var t = this.__data__, n = Om(t, e);
  if (n < 0)
    return !1;
  var r = t.length - 1;
  return n == r ? t.pop() : TB.call(t, n, 1), --this.size, !0;
}
function kB(e) {
  var t = this.__data__, n = Om(t, e);
  return n < 0 ? void 0 : t[n][1];
}
function MB(e) {
  return Om(this.__data__, e) > -1;
}
function RB(e, t) {
  var n = this.__data__, r = Om(n, e);
  return r < 0 ? (++this.size, n.push([e, t])) : n[r][1] = t, this;
}
function xa(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var r = e[t];
    this.set(r[0], r[1]);
  }
}
xa.prototype.clear = CB;
xa.prototype.delete = EB;
xa.prototype.get = kB;
xa.prototype.has = MB;
xa.prototype.set = RB;
function PB() {
  this.__data__ = new xa(), this.size = 0;
}
function OB(e) {
  var t = this.__data__, n = t.delete(e);
  return this.size = t.size, n;
}
function NB(e) {
  return this.__data__.get(e);
}
function AB(e) {
  return this.__data__.has(e);
}
var DB = typeof global == "object" && global && global.Object === Object && global;
const XO = DB;
var IB = typeof self == "object" && self && self.Object === Object && self, LB = XO || IB || Function("return this")();
const Wi = LB;
var $B = Wi.Symbol;
const vc = $B;
var KO = Object.prototype, FB = KO.hasOwnProperty, zB = KO.toString, wu = vc ? vc.toStringTag : void 0;
function BB(e) {
  var t = FB.call(e, wu), n = e[wu];
  try {
    e[wu] = void 0;
    var r = !0;
  } catch (i) {
  }
  var o = zB.call(e);
  return r && (t ? e[wu] = n : delete e[wu]), o;
}
var HB = Object.prototype, jB = HB.toString;
function WB(e) {
  return jB.call(e);
}
var VB = "[object Null]", UB = "[object Undefined]", p2 = vc ? vc.toStringTag : void 0;
function Vc(e) {
  return e == null ? e === void 0 ? UB : VB : p2 && p2 in Object(e) ? BB(e) : WB(e);
}
function Rd(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
var qB = "[object AsyncFunction]", GB = "[object Function]", YB = "[object GeneratorFunction]", ZB = "[object Proxy]";
function JO(e) {
  if (!Rd(e))
    return !1;
  var t = Vc(e);
  return t == GB || t == YB || t == qB || t == ZB;
}
var XB = Wi["__core-js_shared__"];
const kv = XB;
var h2 = function() {
  var e = /[^.]+$/.exec(kv && kv.keys && kv.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}();
function KB(e) {
  return !!h2 && h2 in e;
}
var JB = Function.prototype, QB = JB.toString;
function al(e) {
  if (e != null) {
    try {
      return QB.call(e);
    } catch (t) {
    }
    try {
      return e + "";
    } catch (t) {
    }
  }
  return "";
}
var e8 = /[\\^$.*+?()[\]{}|]/g, t8 = /^\[object .+?Constructor\]$/, n8 = Function.prototype, r8 = Object.prototype, o8 = n8.toString, i8 = r8.hasOwnProperty, a8 = RegExp(
  "^" + o8.call(i8).replace(e8, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function s8(e) {
  if (!Rd(e) || KB(e))
    return !1;
  var t = JO(e) ? a8 : t8;
  return t.test(al(e));
}
function l8(e, t) {
  return e == null ? void 0 : e[t];
}
function Uc(e, t) {
  var n = l8(e, t);
  return s8(n) ? n : void 0;
}
var c8 = Uc(Wi, "Map");
const Pd = c8;
var u8 = Uc(Object, "create");
const Od = u8;
function d8() {
  this.__data__ = Od ? Od(null) : {}, this.size = 0;
}
function f8(e) {
  var t = this.has(e) && delete this.__data__[e];
  return this.size -= t ? 1 : 0, t;
}
var p8 = "__lodash_hash_undefined__", h8 = Object.prototype, m8 = h8.hasOwnProperty;
function g8(e) {
  var t = this.__data__;
  if (Od) {
    var n = t[e];
    return n === p8 ? void 0 : n;
  }
  return m8.call(t, e) ? t[e] : void 0;
}
var v8 = Object.prototype, b8 = v8.hasOwnProperty;
function y8(e) {
  var t = this.__data__;
  return Od ? t[e] !== void 0 : b8.call(t, e);
}
var _8 = "__lodash_hash_undefined__";
function w8(e, t) {
  var n = this.__data__;
  return this.size += this.has(e) ? 0 : 1, n[e] = Od && t === void 0 ? _8 : t, this;
}
function qs(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var r = e[t];
    this.set(r[0], r[1]);
  }
}
qs.prototype.clear = d8;
qs.prototype.delete = f8;
qs.prototype.get = g8;
qs.prototype.has = y8;
qs.prototype.set = w8;
function x8() {
  this.size = 0, this.__data__ = {
    hash: new qs(),
    map: new (Pd || xa)(),
    string: new qs()
  };
}
function C8(e) {
  var t = typeof e;
  return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
}
function Nm(e, t) {
  var n = e.__data__;
  return C8(t) ? n[typeof t == "string" ? "string" : "hash"] : n.map;
}
function S8(e) {
  var t = Nm(this, e).delete(e);
  return this.size -= t ? 1 : 0, t;
}
function T8(e) {
  return Nm(this, e).get(e);
}
function E8(e) {
  return Nm(this, e).has(e);
}
function k8(e, t) {
  var n = Nm(this, e), r = n.size;
  return n.set(e, t), this.size += n.size == r ? 0 : 1, this;
}
function sl(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var r = e[t];
    this.set(r[0], r[1]);
  }
}
sl.prototype.clear = x8;
sl.prototype.delete = S8;
sl.prototype.get = T8;
sl.prototype.has = E8;
sl.prototype.set = k8;
var M8 = 200;
function R8(e, t) {
  var n = this.__data__;
  if (n instanceof xa) {
    var r = n.__data__;
    if (!Pd || r.length < M8 - 1)
      return r.push([e, t]), this.size = ++n.size, this;
    n = this.__data__ = new sl(r);
  }
  return n.set(e, t), this.size = n.size, this;
}
function ns(e) {
  var t = this.__data__ = new xa(e);
  this.size = t.size;
}
ns.prototype.clear = PB;
ns.prototype.delete = OB;
ns.prototype.get = NB;
ns.prototype.has = AB;
ns.prototype.set = R8;
var P8 = "__lodash_hash_undefined__";
function O8(e) {
  return this.__data__.set(e, P8), this;
}
function N8(e) {
  return this.__data__.has(e);
}
function vh(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.__data__ = new sl(); ++t < n; )
    this.add(e[t]);
}
vh.prototype.add = vh.prototype.push = O8;
vh.prototype.has = N8;
function A8(e, t) {
  for (var n = -1, r = e == null ? 0 : e.length; ++n < r; )
    if (t(e[n], n, e))
      return !0;
  return !1;
}
function D8(e, t) {
  return e.has(t);
}
var I8 = 1, L8 = 2;
function QO(e, t, n, r, o, i) {
  var a = n & I8, s = e.length, c = t.length;
  if (s != c && !(a && c > s))
    return !1;
  var l = i.get(e), d = i.get(t);
  if (l && d)
    return l == t && d == e;
  var f = -1, p = !0, m = n & L8 ? new vh() : void 0;
  for (i.set(e, t), i.set(t, e); ++f < s; ) {
    var v = e[f], g = t[f];
    if (r)
      var b = a ? r(g, v, f, t, e, i) : r(v, g, f, e, t, i);
    if (b !== void 0) {
      if (b)
        continue;
      p = !1;
      break;
    }
    if (m) {
      if (!A8(t, function(x, T) {
        if (!D8(m, T) && (v === x || o(v, x, n, r, i)))
          return m.push(T);
      })) {
        p = !1;
        break;
      }
    } else if (!(v === g || o(v, g, n, r, i))) {
      p = !1;
      break;
    }
  }
  return i.delete(e), i.delete(t), p;
}
var $8 = Wi.Uint8Array;
const m2 = $8;
function F8(e) {
  var t = -1, n = Array(e.size);
  return e.forEach(function(r, o) {
    n[++t] = [o, r];
  }), n;
}
function z8(e) {
  var t = -1, n = Array(e.size);
  return e.forEach(function(r) {
    n[++t] = r;
  }), n;
}
var B8 = 1, H8 = 2, j8 = "[object Boolean]", W8 = "[object Date]", V8 = "[object Error]", U8 = "[object Map]", q8 = "[object Number]", G8 = "[object RegExp]", Y8 = "[object Set]", Z8 = "[object String]", X8 = "[object Symbol]", K8 = "[object ArrayBuffer]", J8 = "[object DataView]", g2 = vc ? vc.prototype : void 0, Mv = g2 ? g2.valueOf : void 0;
function Q8(e, t, n, r, o, i, a) {
  switch (n) {
    case J8:
      if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset)
        return !1;
      e = e.buffer, t = t.buffer;
    case K8:
      return !(e.byteLength != t.byteLength || !i(new m2(e), new m2(t)));
    case j8:
    case W8:
    case q8:
      return ZO(+e, +t);
    case V8:
      return e.name == t.name && e.message == t.message;
    case G8:
    case Z8:
      return e == t + "";
    case U8:
      var s = F8;
    case Y8:
      var c = r & B8;
      if (s || (s = z8), e.size != t.size && !c)
        return !1;
      var l = a.get(e);
      if (l)
        return l == t;
      r |= H8, a.set(e, t);
      var d = QO(s(e), s(t), r, o, i, a);
      return a.delete(e), d;
    case X8:
      if (Mv)
        return Mv.call(e) == Mv.call(t);
  }
  return !1;
}
function eH(e, t) {
  for (var n = -1, r = t.length, o = e.length; ++n < r; )
    e[o + n] = t[n];
  return e;
}
var tH = Array.isArray;
const bh = tH;
function nH(e, t, n) {
  var r = t(e);
  return bh(e) ? r : eH(r, n(e));
}
function rH(e, t) {
  for (var n = -1, r = e == null ? 0 : e.length, o = 0, i = []; ++n < r; ) {
    var a = e[n];
    t(a, n, e) && (i[o++] = a);
  }
  return i;
}
function oH() {
  return [];
}
var iH = Object.prototype, aH = iH.propertyIsEnumerable, v2 = Object.getOwnPropertySymbols, sH = v2 ? function(e) {
  return e == null ? [] : (e = Object(e), rH(v2(e), function(t) {
    return aH.call(e, t);
  }));
} : oH;
const lH = sH;
function cH(e, t) {
  for (var n = -1, r = Array(e); ++n < e; )
    r[n] = t(n);
  return r;
}
function bc(e) {
  return e != null && typeof e == "object";
}
var uH = "[object Arguments]";
function b2(e) {
  return bc(e) && Vc(e) == uH;
}
var e3 = Object.prototype, dH = e3.hasOwnProperty, fH = e3.propertyIsEnumerable, pH = b2(/* @__PURE__ */ function() {
  return arguments;
}()) ? b2 : function(e) {
  return bc(e) && dH.call(e, "callee") && !fH.call(e, "callee");
};
const hH = pH;
function mH() {
  return !1;
}
var t3 = typeof exports == "object" && exports && !exports.nodeType && exports, y2 = t3 && typeof module == "object" && module && !module.nodeType && module, gH = y2 && y2.exports === t3, _2 = gH ? Wi.Buffer : void 0, vH = _2 ? _2.isBuffer : void 0, bH = vH || mH;
const Pb = bH;
var yH = 9007199254740991, _H = /^(?:0|[1-9]\d*)$/;
function wH(e, t) {
  var n = typeof e;
  return t = t == null ? yH : t, !!t && (n == "number" || n != "symbol" && _H.test(e)) && e > -1 && e % 1 == 0 && e < t;
}
var xH = 9007199254740991;
function n3(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= xH;
}
var CH = "[object Arguments]", SH = "[object Array]", TH = "[object Boolean]", EH = "[object Date]", kH = "[object Error]", MH = "[object Function]", RH = "[object Map]", PH = "[object Number]", OH = "[object Object]", NH = "[object RegExp]", AH = "[object Set]", DH = "[object String]", IH = "[object WeakMap]", LH = "[object ArrayBuffer]", $H = "[object DataView]", FH = "[object Float32Array]", zH = "[object Float64Array]", BH = "[object Int8Array]", HH = "[object Int16Array]", jH = "[object Int32Array]", WH = "[object Uint8Array]", VH = "[object Uint8ClampedArray]", UH = "[object Uint16Array]", qH = "[object Uint32Array]", Jt = {};
Jt[FH] = Jt[zH] = Jt[BH] = Jt[HH] = Jt[jH] = Jt[WH] = Jt[VH] = Jt[UH] = Jt[qH] = !0;
Jt[CH] = Jt[SH] = Jt[LH] = Jt[TH] = Jt[$H] = Jt[EH] = Jt[kH] = Jt[MH] = Jt[RH] = Jt[PH] = Jt[OH] = Jt[NH] = Jt[AH] = Jt[DH] = Jt[IH] = !1;
function GH(e) {
  return bc(e) && n3(e.length) && !!Jt[Vc(e)];
}
function YH(e) {
  return function(t) {
    return e(t);
  };
}
var r3 = typeof exports == "object" && exports && !exports.nodeType && exports, dd = r3 && typeof module == "object" && module && !module.nodeType && module, ZH = dd && dd.exports === r3, Rv = ZH && XO.process, XH = function() {
  try {
    var e = dd && dd.require && dd.require("util").types;
    return e || Rv && Rv.binding && Rv.binding("util");
  } catch (t) {
  }
}();
const w2 = XH;
var x2 = w2 && w2.isTypedArray, KH = x2 ? YH(x2) : GH;
const o3 = KH;
var JH = Object.prototype, QH = JH.hasOwnProperty;
function ej(e, t) {
  var n = bh(e), r = !n && hH(e), o = !n && !r && Pb(e), i = !n && !r && !o && o3(e), a = n || r || o || i, s = a ? cH(e.length, String) : [], c = s.length;
  for (var l in e)
    QH.call(e, l) && !(a && // Safari 9 has enumerable `arguments.length` in strict mode.
    (l == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    o && (l == "offset" || l == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    i && (l == "buffer" || l == "byteLength" || l == "byteOffset") || // Skip index properties.
    wH(l, c))) && s.push(l);
  return s;
}
var tj = Object.prototype;
function nj(e) {
  var t = e && e.constructor, n = typeof t == "function" && t.prototype || tj;
  return e === n;
}
function rj(e, t) {
  return function(n) {
    return e(t(n));
  };
}
var oj = rj(Object.keys, Object);
const ij = oj;
var aj = Object.prototype, sj = aj.hasOwnProperty;
function lj(e) {
  if (!nj(e))
    return ij(e);
  var t = [];
  for (var n in Object(e))
    sj.call(e, n) && n != "constructor" && t.push(n);
  return t;
}
function cj(e) {
  return e != null && n3(e.length) && !JO(e);
}
function uj(e) {
  return cj(e) ? ej(e) : lj(e);
}
function C2(e) {
  return nH(e, uj, lH);
}
var dj = 1, fj = Object.prototype, pj = fj.hasOwnProperty;
function hj(e, t, n, r, o, i) {
  var a = n & dj, s = C2(e), c = s.length, l = C2(t), d = l.length;
  if (c != d && !a)
    return !1;
  for (var f = c; f--; ) {
    var p = s[f];
    if (!(a ? p in t : pj.call(t, p)))
      return !1;
  }
  var m = i.get(e), v = i.get(t);
  if (m && v)
    return m == t && v == e;
  var g = !0;
  i.set(e, t), i.set(t, e);
  for (var b = a; ++f < c; ) {
    p = s[f];
    var x = e[p], T = t[p];
    if (r)
      var S = a ? r(T, x, p, t, e, i) : r(x, T, p, e, t, i);
    if (!(S === void 0 ? x === T || o(x, T, n, r, i) : S)) {
      g = !1;
      break;
    }
    b || (b = p == "constructor");
  }
  if (g && !b) {
    var _ = e.constructor, w = t.constructor;
    _ != w && "constructor" in e && "constructor" in t && !(typeof _ == "function" && _ instanceof _ && typeof w == "function" && w instanceof w) && (g = !1);
  }
  return i.delete(e), i.delete(t), g;
}
var mj = Uc(Wi, "DataView");
const Ob = mj;
var gj = Uc(Wi, "Promise");
const Nb = gj;
var vj = Uc(Wi, "Set");
const Ab = vj;
var bj = Uc(Wi, "WeakMap");
const Db = bj;
var S2 = "[object Map]", yj = "[object Object]", T2 = "[object Promise]", E2 = "[object Set]", k2 = "[object WeakMap]", M2 = "[object DataView]", _j = al(Ob), wj = al(Pd), xj = al(Nb), Cj = al(Ab), Sj = al(Db), Ns = Vc;
(Ob && Ns(new Ob(new ArrayBuffer(1))) != M2 || Pd && Ns(new Pd()) != S2 || Nb && Ns(Nb.resolve()) != T2 || Ab && Ns(new Ab()) != E2 || Db && Ns(new Db()) != k2) && (Ns = function(e) {
  var t = Vc(e), n = t == yj ? e.constructor : void 0, r = n ? al(n) : "";
  if (r)
    switch (r) {
      case _j:
        return M2;
      case wj:
        return S2;
      case xj:
        return T2;
      case Cj:
        return E2;
      case Sj:
        return k2;
    }
  return t;
});
const R2 = Ns;
var Tj = 1, P2 = "[object Arguments]", O2 = "[object Array]", Qf = "[object Object]", Ej = Object.prototype, N2 = Ej.hasOwnProperty;
function kj(e, t, n, r, o, i) {
  var a = bh(e), s = bh(t), c = a ? O2 : R2(e), l = s ? O2 : R2(t);
  c = c == P2 ? Qf : c, l = l == P2 ? Qf : l;
  var d = c == Qf, f = l == Qf, p = c == l;
  if (p && Pb(e)) {
    if (!Pb(t))
      return !1;
    a = !0, d = !1;
  }
  if (p && !d)
    return i || (i = new ns()), a || o3(e) ? QO(e, t, n, r, o, i) : Q8(e, t, c, n, r, o, i);
  if (!(n & Tj)) {
    var m = d && N2.call(e, "__wrapped__"), v = f && N2.call(t, "__wrapped__");
    if (m || v) {
      var g = m ? e.value() : e, b = v ? t.value() : t;
      return i || (i = new ns()), o(g, b, n, r, i);
    }
  }
  return p ? (i || (i = new ns()), hj(e, t, n, r, o, i)) : !1;
}
function i3(e, t, n, r, o) {
  return e === t ? !0 : e == null || t == null || !bc(e) && !bc(t) ? e !== e && t !== t : kj(e, t, n, r, i3, o);
}
function Ib(e, t) {
  return i3(e, t);
}
const nt = {
  HEADERS: "headers",
  METADATA: "metadata",
  DATA: "data",
  GRAND: "grand",
  FINISH: "finish",
  ERROR: "error",
  TOTAL_ROWS: "totalRows",
  DATA_FINISH: "dataFinish",
  DATABARS: "dataBars",
  RANGE_MIN_MAX: "rangeMinMax"
}, Mj = [
  nt.ERROR,
  nt.HEADERS,
  nt.GRAND,
  nt.METADATA,
  nt.DATA,
  nt.DATA_FINISH,
  nt.TOTAL_ROWS,
  nt.DATABARS,
  nt.RANGE_MIN_MAX,
  nt.FINISH
], Ke = {
  ROWS: "rows",
  COLUMNS: "columns",
  MEASURES: "measures",
  SCOPE: "scope"
}, En = {
  ASC: "asc",
  DESC: "desc"
}, qt = {
  SUB_TOTAL: "subTotal",
  GRAND_TOTAL: "grandTotal",
  MEASURE_TOP: "measureTop",
  MEASURE_BOTTOM: "measureBottom",
  CORNER: "corner"
}, A2 = {
  COLOR: "color",
  CONDITION: "condition"
}, oa = {
  DATETIME: "datetime",
  TEXT: "text",
  NUMERIC: "numeric"
}, Sl = {
  MEMBER: "member",
  VALUE: "value",
  SUB_TOTAL: "subtotal",
  GRAND_TOTAL: "grandtotal"
}, Ga = {
  MEMBER: "member",
  INDEX: "index",
  TITLE: "title",
  NAME: "name",
  AGG: "agg",
  DIM: "dim"
};
class Rj {
  constructor(t, n, r, o) {
    Z(this, "rowIndex"), Z(this, "colIndex"), Z(this, "node"), Z(this, "parent"), Z(this, "childColCells", []), Z(this, "childRowCells", []), Z(this, "indexInParent", -1), Z(this, "siblingCount", 0), this.rowIndex = t, this.colIndex = n, this.node = r, this.parent = o;
  }
  /**
   * Defines if grid cell is child or main one
   *
   * @returns {boolean} - true - is children, false - main one
   */
  isChild() {
    return !this.node;
  }
  /**
   * Defines if node has child row or column nodes or not
   *
   * @returns {boolean} - true - has children, false - does not have
   */
  hasChildren() {
    return !!(this.childColCells.length || this.childRowCells.length);
  }
  /**
   * Defines if node has child column nodes or not
   *
   * @returns {boolean} - true - has column children, false - does not have
   */
  hasColCell() {
    return this.childColCells.length > 0;
  }
  /**
   * Adds column children cell
   *
   * @param {TreeCellMapI} cell - column children
   * @returns {void}
   */
  addColCell(t) {
    this.childColCells.push(t);
  }
  /**
   * Returns list of column children
   *
   * @returns {Array<TreeCellMapI>} - list of column children
   */
  getColCell() {
    return this.childColCells || [];
  }
  /**
   * Defines if node has child row nodes or not
   *
   * @returns {boolean} - true - has row children, false - does not have
   */
  hasRowCell() {
    return this.childRowCells.length > 0;
  }
  /**
   * Adds row children cell
   *
   * @param {TreeCellMapI} cell - row children
   * @returns {void}
   */
  addRowCell(t) {
    this.childRowCells.push(t);
  }
  /**
   * Returns list of row children
   *
   * @returns {Array<TreeCellMapI>} - list of row children
   */
  getRowCell() {
    return this.childRowCells || [];
  }
  /**
   * Returns row index of last merged cell
   *
   * @returns {number} - row index
   */
  getStopRowIndex() {
    return this.hasRowCell() ? this.rowIndex + this.getRowCell().length : this.rowIndex;
  }
  /**
   * Returns column index of last merged cell
   *
   * @returns {number} - column index
   */
  getStopColIndex() {
    return this.hasColCell() ? this.colIndex + this.getColCell().length : this.colIndex;
  }
  /**
   * Save index of node in parent child and total parent child count
   *
   * @param {number} indexInParent - index
   * @param {number} siblingCount - child count
   * @returns {void}
   */
  setIndexInParent(t, n) {
    this.indexInParent = t, this.siblingCount = n;
  }
  /**
   * Returns node index in parent and total parent child count
   *
   * @returns {{ indexInParent: number, siblingCount: number }} - index & count
   */
  getIndexInParent() {
    return {
      indexInParent: this.indexInParent,
      siblingCount: this.siblingCount
    };
  }
  getParenPosition() {
    if (!this.parent)
      return;
    const t = (this.parent || "").match(/\d+/g) || [];
    return [Number(t[0]), Number(t[1])];
  }
}
const yh = ["S&PManager", "Cache"], _h = ["null"];
let a3 = class Lb {
  constructor(t = "") {
    Z(this, "name"), Z(this, "log"), Z(this, "warn"), Z(this, "error"), Z(this, "console"), this.name = t, this.log = () => {
    }, this.warn = () => {
    }, this.error = () => {
    }, this.console = Lb.createMockConsole(), this.createLogFn();
  }
  setName(t) {
    this.name = t, this.createLogFn();
  }
  getName() {
    return this.name;
  }
  /**
   * Creates real or fake "log" function depending on include/exclude rules
   *
   * @returns {void}
   *
   * @private
   */
  createLogFn() {
    this.log = () => {
    }, this.warn = () => {
    }, this.error = () => {
    };
  }
  /**
   * Defines if logger is excluded from logging
   *
   * @returns {boolean} - true - excluded
   *
   * @private
   */
  isExcludedName() {
    return _h.length && !this.hasNamePartsInList(_h) ? !0 : yh.length ? this.hasNamePartsInList(yh) : !1;
  }
  /**
   * Determinates if included/excluded items contains part of the name
   *
   * @param {Array<string>} array - included/excluded items
   * @returns {boolean} - true - contains
   *
   * @private
   */
  hasNamePartsInList(t) {
    const n = this.name.toLowerCase();
    return t.some((r) => n.includes(r.toLowerCase()));
  }
  /**
   * Creates mock console instance for tests
   *
   * @returns {LoggerI} - logger instance
   */
  static createMockConsole() {
    return {
      log: () => {
      },
      warn: () => {
      },
      error: () => {
      }
    };
  }
  /**
   * Creates mock instance for tests
   *
   * @returns {LoggerI} - logger instance
   */
  static createMock() {
    const t = Lb.createMockConsole();
    return $e(pe({
      setName: () => {
      },
      getName: () => ""
    }, t), {
      console: t
    });
  }
};
const Pj = (e) => new a3(e), Oj = (e = "") => {
  yh.push(e.toLowerCase());
}, Nj = (e = "") => {
  _h.push(e.toLowerCase());
}, Aj = () => {
  yh.length = 0, _h.length = 0;
}, ds = {
  Logger: a3,
  create: Pj,
  excludeLogs: Oj,
  includeLogs: Nj,
  clearIncludeExclude: Aj
}, s3 = [Date, Error, RegExp, Promise];
function l3(e, t = s3) {
  return t.some((n) => e instanceof n);
}
function D2(e, t = []) {
  let n = !1;
  return t.forEach((r) => {
    e.includes(r) && (n = !0);
  }), n;
}
function c3(e = [], t, n) {
  const r = [];
  return n && e.forEach((o) => {
    r.push(`${o}.$`);
  }), e.length ? e.forEach((o) => {
    r.push(`${o}.${t}`);
  }) : r.push(t), r;
}
function fd(e) {
  return !(e === null || typeof e == "undefined" || typeof e != "object");
}
function Dj(e, t) {
  return fd(e) && e ? Array.isArray(e) ? !e.length : l3(e, t) ? !1 : !Object.keys(e).length : e == null;
}
function Ij(e = "") {
  const t = e.split(".");
  return t.length > 1 ? (t.pop(), t.join(".")) : t[0];
}
function I2(e, t, n) {
  return e.length ? D2(e, n) : t.length ? !D2(t, n) : !0;
}
function u3(e, t = [], n = [], r = [], o = {}, i = {}, a = [], s = []) {
  if (!fd(e))
    return {
      commonIncludeKeys: [],
      commonExcludeKeys: []
    };
  const c = a.indexOf(e);
  if (c !== -1)
    return s[c];
  a.push(e);
  const l = Object.keys(e), d = Array.isArray(e);
  let f = [], p = [];
  const m = [], v = [];
  if (l.forEach((g) => {
    const b = e[g], x = c3(r, g, d), T = r[0] || "&";
    o[T] = o[T] || [], i[T] = i[T] || [], x.forEach((S) => {
      (t || []).includes(S) && (o[T].push(S), f.push(S)), (t || []).forEach((_) => {
        const w = Ij(_);
        (`${w}.$` === T || w === T) && (o[T].includes(_) || o[T].push(_), f.includes(_) || f.push(_));
      }), (n || []).includes(S) && (i[T].push(S), p.push(S));
    }), fd(b) && u3(
      b,
      t,
      n,
      x,
      o,
      i,
      a,
      s
    );
  }), fd(e)) {
    let g = r[0] || "&";
    Array.isArray(e) && (g = `${g}.$`), o[g] = (o[g] || []).concat(
      m
    ), f = f.concat(m), i[g] = (i[g] || []).concat(
      v
    ), p = f.concat(v);
  }
  return s.push({
    commonIncludeKeys: f,
    commonExcludeKeys: p
  }), {
    commonIncludeKeys: f,
    commonExcludeKeys: p
  };
}
function d3(e, t, n = /* @__PURE__ */ new WeakMap()) {
  const {
    includeKeys: r,
    includeKeysObj: o,
    excludeKeys: i,
    excludeKeysObj: a,
    parentKeys: s = [],
    excludeEmpty: c,
    referenceClone: l
  } = t || {};
  if (!fd(e) || l3(e, l))
    return e;
  if (n.has(e))
    return n.get(e);
  const d = Object.keys(e), f = Array.isArray(e), p = f ? [] : {};
  n.set(e, p);
  const m = s[0] || "&", v = (o || {})[m] || [], g = (a || {})[m] || [];
  return d.forEach((b) => {
    const x = e[b];
    let T = [], S = !0;
    if (r || i ? S = I2(r || [], i || [], [b]) : (o || a) && (T = c3(s, b, f), S = I2(v, g, T)), S) {
      const _ = d3(
        x,
        $e(pe({}, t), {
          parentKeys: T
        }),
        n
      );
      (!c || !Dj(_, l)) && (f ? p.push(_) : p[b] = _);
    }
  }), p;
}
function Br(e, t) {
  const n = t || {}, { include: r, exclude: o } = n, i = Wn(n, ["include", "exclude"]);
  let a, s;
  (r || o) && (a = {}, s = {}, u3(e, r, o, [], a, s));
  const c = $e(pe({}, i), {
    includeKeysObj: a,
    excludeKeysObj: s
  });
  return d3(e, c);
}
Br.REFERENCE_CLONE_TYPES = s3;
const Pv = (e) => (t) => e.replace(/{{(\w+)}}/g, (n, r) => typeof t[r] != "undefined" ? t[r] : r), f3 = (e, t) => {
  let n, r, o = null;
  const i = (...a) => {
    n ? o = a : (e(...a), n = !0, o = null, r = setTimeout(() => {
      n = !1, o && (e(...o), o = null);
    }, t));
  };
  return i.cancel = () => {
    clearTimeout(r), n = !1;
  }, i;
}, p3 = (e, t) => {
  const n = {};
  return Object.keys(e).forEach((r) => {
    e[r] !== t[r] && (n[r] = t[r]);
  }), Object.keys(t).forEach((r) => {
    typeof n[r] == "undefined" && e[r] !== t[r] && (n[r] = t[r]);
  }), n;
};
function $b(e = !0) {
  let t = {}, n = null;
  return ({ callback: r, indices: o }) => {
    const i = Object.keys(o), a = !e || i.every((c) => {
      const l = o[c];
      return Array.isArray(l) ? l.length > 0 : l >= 0;
    }), s = i.length !== Object.keys(t).length || i.some((c) => {
      const l = t[c], d = o[c];
      return Array.isArray(d) ? l.join(",") !== d.join(",") : l !== d;
    });
    return t = o, a && s && (n = r(o)), n;
  };
}
function L2(e, t, n = 0) {
  for (let r = n; r < e.length; r += 1) {
    const o = e[r];
    if (t(o, r, e))
      return r;
  }
  return -1;
}
const Nd = "$*$root$*$";
function Lj(e, t, n, r) {
  const o = { value: e };
  return t && (o.children = t), n && (o.data = n), typeof r != "undefined" && (o.index = r), o;
}
function Am(e) {
  return !!(e && e.children && e.children.length);
}
function ui(e) {
  return e && e.children || [];
}
function Fb(e, t) {
  e && t && Array.isArray(t) && (e.children = t);
}
function $j(e, t) {
  e && (e.level = t);
}
function Fj(e) {
  return e && typeof e.level != "undefined" ? e.level || 0 : -1;
}
function Vl(e) {
  if (!e)
    return;
  if (e && !Array.isArray(e) && e.value === Nd)
    return e;
  const t = { value: Nd, children: [] };
  return Array.isArray(e) ? t.children = e : (t.children || [])[0] = e, t;
}
function h3(e, t, n = 0) {
  let r;
  if (!e || !t)
    return r;
  if (t(e, n) && (r = e), Am(e)) {
    const o = ui(e), i = o.length;
    for (let a = 0; a < i; a += 1) {
      const s = h3(o[a], t, n + 1);
      if (s) {
        r = s;
        break;
      }
    }
  }
  return r;
}
function zj(e, t) {
  if (!e && !t)
    return;
  if (!e && t)
    return Vl(t);
  if (e && !t)
    return Vl(e);
  const n = Vl(e), r = Vl(t), o = n && n.children || [], i = r && r.children || [], a = o.concat(i);
  return Vl(a);
}
const m3 = (e, t = 0) => {
  if (!e || !e.isPart)
    return;
  e.level = t;
  const n = ui(e), r = n[n.length - 1];
  return r && m3(r, t + 1) || e;
}, g3 = (e, t, n = 0) => {
  if (!e || !e.isPart)
    return;
  if (e.level = n, e && t && e.value === t.value && e.level === t.level)
    return e;
  const r = ui(e)[0];
  return r && g3(r, t, n + 1) || e;
};
function Bj(e, t) {
  let n = m3(e), r = g3(t, n);
  n && n.children && Array.isArray(n.children) && r && r.children && Array.isArray(r.children) && r.children.length > 0 && (n.children = n.children.concat(r.children), r.isHandled = !0);
  let o = !1;
  for (n = e, r = t; n && n.children && Array.isArray(n.children) && r && r.children && Array.isArray(r.children) && !r.isHandled; ) {
    const i = n.children;
    n = n.children[n.children.length - 1];
    let a = 0;
    for (r.children[0] && !o && (o = !ui(r.children[0]).some((s) => s.isPart), a = 1); a < r.children.length; )
      i.push(r.children[a]), a += 1;
    r = r.children[0];
  }
  return e;
}
function v3(e, t, n) {
  !e || !t || e.forEach((r) => {
    t(r, n), Am(r) && v3(ui(r), t, r);
  });
}
function b3(e, t = [], n = 0, r = { maxLevel: 0 }) {
  return e.forEach((o) => {
    r.maxLevel < n && (r.maxLevel = n), Am(o) ? b3(ui(o), t, n + 1, r) : t.push(o);
  }), t;
}
function Dm(e, t = {}) {
  if (t || (t = {}), typeof t.callCount != "number" ? t.callCount = 1 : t.callCount += 1, !e)
    return 0;
  let n = t.clearCache || !1;
  !Array.isArray(e) && e.value === Nd && (n = !0);
  let r = 1, o = [];
  return Array.isArray(e) ? (r = 0, o = e) : e.children && (o = ui(e)), o && o.length && (!n && !Array.isArray(e) && typeof e.childCount == "number" ? r = e.childCount : (r = 0, o.forEach((i) => {
    r += Dm(i, t);
  }), Array.isArray(e) || (e.childCount = r))), r;
}
function y3(e, t = {}) {
  if (t || (t = {}), typeof t.callCount != "number" ? t.callCount = 1 : t.callCount += 1, !e)
    return 0;
  let n = t.clearCache || !1;
  !Array.isArray(e) && e.value === Nd && (n = !0);
  let r = 0, o = [];
  if (e && !Array.isArray(e) && typeof e.value != "undefined" && (r = 1), Array.isArray(e) ? (r = 0, o = e) : e.children && (o = ui(e)), o && o.length)
    if (!n && !Array.isArray(e) && typeof e.childDeep == "number")
      r += e.childDeep;
    else {
      let i = 0;
      o.forEach((a) => {
        const s = y3(a, t);
        s > i && (i = s);
      }), r += i, Array.isArray(e) || (e.childDeep = i);
    }
  return r;
}
function _3(e = [], t = 0, n) {
  const r = [];
  let o = 0, i = -1, a = -1;
  const s = e.length;
  if (typeof t == "number" && typeof n == "number" && t > n)
    throw new Error('Wrong "getNodesByChildCount" diapason');
  if (typeof t == "number" && t < 0)
    throw new Error('Wrong "from" index for "getNodesByChildCount"');
  for (let c = 0; c < s; c += 1) {
    const l = e[c], d = Dm(l);
    if (o + d > t && (i < 0 && (i = o), r.push(l), typeof n == "number" && o + d >= n)) {
      a = o + d;
      break;
    }
    a = o + d, o += d;
  }
  return {
    nodes: r,
    start: i,
    stop: a
  };
}
function Hj(e) {
  e.isMapped !== void 0 && (e.isMapped = void 0), e.minLevel !== void 0 && (e.minLevel = void 0), e.childCount !== void 0 && (e.childCount = void 0), e.childDeep !== void 0 && (e.childDeep = void 0);
}
function zb(e = [], t = 0, n, r) {
  const { cloneFn: o = Br } = r || {}, i = [], { nodes: a, start: s, stop: c } = _3(e, t, n), l = a.length;
  let d, f, p = !0;
  if (s < t) {
    const m = a[0] || {}, v = t - s;
    let g;
    l === 1 && typeof n == "number" && (g = n - s, p = !1), d = o(m, !0);
    const b = zb(
      ui(m),
      v,
      g,
      r
    );
    Fb(d, b);
  }
  if (typeof n == "number" && c > n && p) {
    const m = a[l - 1] || {}, v = 0, g = Dm(m) - (c - n);
    f = o(m, !0);
    const b = zb(
      ui(m),
      v,
      g,
      r
    );
    Fb(f, b);
  }
  return a.forEach((m, v) => {
    if (d && v === 0)
      i.push(d);
    else if (f && v === l - 1)
      i.push(f);
    else {
      const g = o(m);
      i.push(g);
    }
  }), i;
}
const Re = {
  ROOT: Nd,
  create: Lj,
  hasChildren: Am,
  getChildren: ui,
  setChildren: Fb,
  setLevel: $j,
  getLevel: Fj,
  getLastLevelNodes: b3,
  iterateThroughTree: v3,
  wrapInRootNode: Vl,
  findNode: h3,
  merge: zj,
  deepMerge: Bj,
  getChildLength: Dm,
  getDeepLength: y3,
  getNodesByChildCount: _3,
  getCutNodesByChildCount: zb,
  clearNodeCache: Hj
}, ur = {
  FIRST: "first",
  LAST: "last",
  EVEN: "even",
  ODD: "odd"
}, Tl = (e, t) => `${e}-${t}`;
class jj {
  constructor(t, n = !1, r) {
    Z(this, "tree"), Z(this, "hasGrandTotals", !1), Z(this, "isVertical", !1), Z(this, "deep"), Z(this, "columns", []), Z(this, "lastLevel", []), Z(this, "map", {}), Z(this, "metadataCache", {}), Z(this, "valueNode"), Z(this, "grid"), this.isVertical = n, this.deep = r, t && (this.tree = t, this.columns = this.cacheLevels(Re.getChildren(this.tree)));
  }
  destroy() {
    this.tree = void 0, this.columns = [], this.lastLevel = [], this.map = {}, this.metadataCache = {}, this.valueNode = void 0, this.grid = void 0;
  }
  getMainCellWidth(t, n, r, o, i = { offsetTop: -1, columnsOffset: 0 }) {
    const { columnsOffset: a = 0 } = i, s = this.getItem(t, n), c = s && s.hasChildren() && s.hasColCell();
    let l = Number.NaN, d = !0;
    if (s && c) {
      const f = s.getColCell(), p = r({ index: n + a });
      l = f.reduce((m, v) => {
        const g = r({ index: v.colIndex + a });
        return g || (d = !1), m + g;
      }, p), l -= o, l = Math.ceil(l);
    }
    return d ? l : Number.NaN;
  }
  /**
   * Adds additional tree node to current state
   *
   * @param {TreeNode} tree - new treeNode
   * @returns {void}
   */
  extend(t) {
    t && (this.grid = void 0, this.tree = Re.merge(this.tree, t), this.columns = this.cacheLevels(Re.getChildren(t), this.columns));
  }
  /**
   * Returns grid (2d list) of tree structure
   *
   * @returns {Array<Array<TreeNode | string>>} - 2d list
   */
  getGrid() {
    if (this.grid)
      return this.grid;
    let t = this.getTreeDeepsLength(), n = this.getTreeChildLength();
    return this.isVertical ? ([t, n] = [n, t], this.map = this.fillMapVertical(Re.getChildren(this.tree), n, this.map)) : this.map = this.fillMap(Re.getChildren(this.tree), t, this.map), this.grid = Array.from(Array(t)).map(
      (r, o) => Array.from(Array(n)).map((i, a) => {
        const s = Tl(o, a), c = this.map[s];
        if (!c)
          throw new Error(`Key "${s}" does not found in TreeService`);
        return c.node ? c.node : c.parent;
      })
    ), this.grid;
  }
  /**
   * Returns part of current grid according to "from" - "to" position
   *
   * @param {number} from - start rows index for partial grid
   * @param {number} to - stop rows index for partial grid
   * @returns {Array<Array<TreeNode | string>>} - partial grid
   */
  getPartialGrid(t, n) {
    if (!this.isVertical)
      throw new Error('"getPartialGrid" can only be used for "vertical" tree');
    const r = this.getTreeDeepsLength(), o = Re.getChildren(this.tree), { nodes: i, start: a, stop: s } = Re.getNodesByChildCount(o, t, n);
    this.fillMapVertical(i, r, this.map, {
      parentRowIndex: a,
      parentColIndex: 0,
      prevChildren: 0,
      parentKey: ""
    });
    const c = Math.max(a, t), l = Math.min(s, n), d = Math.max(0, l - t);
    return Array.from(Array(d)).map(
      (f, p) => Array.from(Array(r)).map((m, v) => {
        const g = c + p, b = Tl(g, v), x = this.map[b];
        if (!x)
          throw new Error(`Key "${b}" does not found in TreeService`);
        return x.node ? x.node : x.parent || "";
      })
    );
  }
  /**
   * Returns part of current tree with possible cut nodes according to "from" - "to" position
   *
   * @param {number} from - start rows index for partial grid
   * @param {number} [to] - stop rows index for partial grid
   * @param {object} [options] - additional options
   * @param {Function} [options.cloneFn] - replace default clone function with specific one
   * @returns {Array<TreeNode>} - partial tree
   */
  getPartialTree(t, n, r) {
    const o = Re.getChildren(this.tree);
    return Re.getCutNodesByChildCount(o, t, n, r);
  }
  /**
   * Returns TreeNode item if exist for appropriate coordinates (rowIndex, columnIndex)
   *
   * @param {number} rowIndex - row index
   * @param {number} columnIndex - column index
   * @returns {TreeNode|undefined} - TreeNode item
   */
  getTreeNode(t, n) {
    const r = this.getItem(t, n);
    if (r && r.node)
      return r.node;
  }
  /**
   * Defines if cell with (rowIndex, columnIndex) coordinate is children cell or main one
   *
   * @param {number} rowIndex - row index of the cell
   * @param {number} columnIndex - column index of the cell
   * @returns {boolean} - true - if children, false if main one
   */
  isChildren(t, n) {
    const r = this.getItem(t, n);
    if (r)
      return r.isChild();
    if (typeof this.deep == "number" && (this.isVertical ? n : t) < this.deep)
      return !0;
    throw new Error(`Item "${t}-${n}" does not found in TreeService`);
  }
  /**
   * Defines if cell with (rowIndex, columnIndex) coordinate has children column/row cells or not
   *
   * @param {number} rowIndex - row index of the cell
   * @param {number} columnIndex - column index of the cell
   * @returns {boolean} - true - has children column/row cells, false - does not have
   */
  hasChildren(t, n) {
    const r = this.getItem(t, n);
    if (r)
      return r.hasChildren();
    throw new Error(`Item "${t}-${n}" does not found in TreeService`);
  }
  /**
   * Updates merge object for the cell if it has children cells
   *
   * @param {number} rowIndex - cell row index
   * @param {number} columnIndex - cell column index
   * @returns {object} - new merge object
   */
  getMainCellSpans(t, n) {
    const r = {}, o = this.getItem(t, n);
    return o && o.hasColCell() && (r.colSpan = o.getColCell().length + 1), o && o.hasRowCell() && (r.rowSpan = o.getRowCell().length + 1), r;
  }
  /**
   * Align start index in case of long merged cell
   *
   * @param {number} startIndex - initial start index
   * @param {boolean} isVertical - defines if it is vertical grid or not
   * @returns {number} - new start index
   */
  alignStartIndex(t, n = !1) {
    let r = 0, o = t;
    if (n && (r = t, o = 0), this.isVertical === n) {
      let i = this.getItem(r, o);
      if (i && i.isChild() && (i = this.getItemByKey(i.parent || "")), i)
        return n ? i.rowIndex : i.colIndex;
    }
    return t;
  }
  /**
   * Align stop index in case of long merged cell
   *
   * @param {number} stopIndex - initial stop index
   * @param {boolean} isVertical - defines if it is vertical grid or not
   * @returns {number} - new stop index
   */
  alignStopIndex(t, n = !1) {
    let r = 0, o = t;
    if (n && (r = t, o = 0), this.isVertical === n) {
      let i = this.getItem(r, o);
      if (i && i.isChild() && (i = this.getItemByKey(i.parent || "")), i)
        return n ? i.getStopRowIndex() : i.getStopColIndex();
    }
    return t;
  }
  /**
   * Returns number of last children for the tree
   *
   * @param {Array<TreeNode> | TreeNode} item - tree node or list of nodes
   * @param {{ callCount: number, clearCache: boolean }} options - options for state
   * @returns {number} - count of last children
   */
  getTreeChildLength(t = Re.getChildren(this.tree), n) {
    return Re.getChildLength(t, n);
  }
  /**
   * Returns deep level of the tree
   *
   * @param {Array<TreeNode> | TreeNode} item - tree node or list of nodes
   * @param {{ callCount: number, clearCache: boolean }} options - options for inner state
   * @returns {number} - count of last children
   */
  getTreeDeepsLength(t = Re.getChildren(this.tree), n) {
    return typeof this.deep != "undefined" && this.deep !== void 0 ? this.deep : Re.getDeepLength(t, n);
  }
  /**
   * Returns array of last tree nodes
   *
   * @returns {Array<TreeNode>} - list of tree nodes
   */
  getLastLevelNodes() {
    return this.lastLevel;
  }
  /**
   * Extract 2D array of data base on columnsTreeService
   *
   * @param {TreeServiceI} columnsTreeService - tree service according to which align the data
   * @returns {Array<Array<any>>} - 2D array of data
   */
  extractData(t) {
    if (!t)
      return [];
    const n = t.getLastLevelNodes().map((r) => r.index);
    return this.getLastLevelNodes().map((r) => typeof r.data == "undefined" ? [r.data] : n ? n.map((o) => {
      let i;
      return typeof o != "undefined" && r.data && (i = r.data[o]), i;
    }) : r.data);
  }
  /**
   * Returns cell meta information
   *
   * @param {number} rowIndex - cell row index
   * @param {number} columnIndex - cell column index
   * @param {{ to: number }} [options] - additional configuration options
   * @returns {{levels: Array<string>, siblings: Array<string>}} - meta information
   */
  // eslint-disable-next-line max-lines-per-function,sonarjs/cognitive-complexity
  getMetadata(t, n, r) {
    const o = this.getTreeDeepsLength();
    t === 1 / 0 && (t = o && o - 1), n === 1 / 0 && (n = o && o - 1);
    const i = `${t}-${n}`;
    if (this.metadataCache[i])
      return this.metadataCache[i];
    let a = this.getItemByKey(i);
    if (!a)
      throw new Error(`Can not find metadata info for ${i} cell`);
    let s = a ? a.node : void 0;
    if (s || (a = this.getItemByKey(a.parent || "")), !a)
      throw new Error(`Can not find metadata info for parent ${i} cell`);
    s = a ? a.node : void 0;
    const c = this.getItemByKey(`${t + 1}-${n}`), l = c ? c.node : void 0, d = s && s.level || 0, f = this.isVertical ? a.getStopColIndex() : a.getStopRowIndex();
    let { indexInParent: p, siblingCount: m } = a.getIndexInParent(), v = p;
    if (d === 0 && (m = this.getTreeChildLength(), p = this.isVertical ? a.rowIndex : a.colIndex, v = p + (this.isVertical ? a.getRowCell().length : a.getColCell().length)), r) {
      const T = r.to - r.from;
      m <= T && v > T - 1 && (v = T - 1);
    }
    const g = {
      levels: [],
      siblings: [],
      root: void 0,
      parent: void 0,
      valueNode: this.valueNode,
      nextNode: l
    }, { indexDivergence: b } = s || {};
    if (typeof b == "number") {
      const T = b === 0 ? ur.EVEN : ur.ODD;
      g.siblings.push(T);
    }
    if (d === 0 && g.levels.push(ur.FIRST), f === o - 1 && g.levels.push(ur.LAST), p === 0 && g.siblings.push(ur.FIRST), v === m - 1 && g.siblings.push(ur.LAST), s && d !== 0) {
      const T = this.isVertical ? t : 0, S = this.isVertical ? 0 : n;
      g.root = this.getMetadata(T, S, r);
    }
    const x = this.getItemByKey(a.parent || "");
    if (x && d !== 0 && (g.parent = this.getMetadata(x.rowIndex, x.colIndex, r)), r) {
      const T = this.isVertical ? a.rowIndex : a.colIndex, S = this.isVertical ? a.getStopRowIndex() : a.getStopColIndex();
      let _;
      x && (_ = this.isVertical ? x.getStopRowIndex() : x.getStopColIndex()), _ !== void 0 && _ >= r.to - r.from && S >= r.to - r.from - 1 && !g.siblings.includes(ur.LAST) && g.siblings.push(ur.LAST), T === 0 && !g.siblings.includes(ur.FIRST) && g.siblings.push(ur.FIRST);
    }
    return this.metadataCache[i] = g, g;
  }
  /**
   * Sets value node when it's single
   *
   * @param {TreeNode} valueNode - values measure node
   * @returns {void}
   */
  setValueNode(t) {
    typeof t == "object" && (this.valueNode = t);
  }
  /**
   * Fills cache object with nodes by appropriate deep level
   *
   * @param {Array<TreeNode>} list - list of nodes to cache
   * @param {Array<Array<TreeNode>>} cache - cache object
   * @param {{level: number }} options - internal recursive state
   * @returns {Array<Array<TreeNode>>} - cache object
   *
   * @private
   */
  cacheLevels(t, n = [], r = { level: 0 }) {
    const { level: o } = r;
    return t.forEach((i) => {
      if (n[o] || (n[o] = []), Re.setLevel(i, o), n[o].push(i), Re.hasChildren(i)) {
        const a = o + 1;
        this.cacheLevels(Re.getChildren(i), n, { level: a });
      } else
        this.lastLevel.push(i);
    }), n;
  }
  /**
   * Fill horizontal grid map according to tree structure
   *
   * @param {Array<TreeNode>} children - list of tree nodes
   * @param {number} rows - deep level rows
   * @param {object} map - map object to fill
   * @param {{parentColIndex: number, prevChildren: number}} initState - state object for
   * recursive calls
   * @returns {object} - map object
   *
   * @private
   */
  fillMap(t, n, r = {}, o) {
    const i = o || {
      parentRowIndex: 0,
      parentColIndex: 0,
      prevChildren: 0,
      parentKey: ""
    }, a = t.length;
    return t.forEach((s, c) => {
      const { parentRowIndex: l, parentColIndex: d, prevChildren: f, parentKey: p } = i, m = Re.getLevel(s) + l, v = c + d + f, g = Tl(m, v), b = this.createTreeCellMap({
        rowIndex: m,
        colIndex: v,
        node: s,
        parent: p
      });
      b.setIndexInParent(c, a), r[g] = b;
      let x = 0, T = 0;
      if (Re.hasChildren(s) ? (x = this.getTreeChildLength(s), typeof s.minLevel == "number" && (T = s.minLevel + 1 - m || 0)) : T = (n || 0) - (m || 0), (x > 1 || T > 1) && this.fillChildMap(r, g, m, v, T, x), Re.hasChildren(s)) {
        const S = $e(pe({}, i), {
          parentRowIndex: T > 1 ? T - 1 : 0,
          parentColIndex: c + d,
          parentKey: g
        });
        this.fillMap(Re.getChildren(s), n, r, S), x > 1 && (i.prevChildren += x - 1);
      }
    }), r;
  }
  /**
   * Fill vertical grid map according to tree structure
   *
   * @param {Array<TreeNode>} children - list of tree nodes
   * @param {number} cols - deep level columns
   * @param {TreeCellMapCache} map - map object to fill
   * @param {FillMapState} initState - state object for
   * recursive calls
   * @returns {object} - map object
   *
   * @private
   */
  fillMapVertical(t, n, r = {}, o) {
    const i = o || {
      parentRowIndex: 0,
      parentColIndex: 0,
      prevChildren: 0,
      parentKey: ""
    }, a = t.length;
    return t.forEach((s, c) => {
      if (s.isMapped) {
        i.parentRowIndex += Re.getChildLength(s) - 1;
        return;
      }
      s.isMapped = !0;
      const { parentRowIndex: l, prevChildren: d, parentKey: f } = i, p = Re.getLevel(s), m = c + l + d, v = Tl(m, p), g = this.createTreeCellMap({
        rowIndex: m,
        colIndex: p,
        node: s,
        parent: f
      });
      g.setIndexInParent(c, a), r[v] = g;
      let b = 0, x = 0;
      if (Re.hasChildren(s) ? x = this.getTreeChildLength(s) : b = (n || 0) - (p || 0), (b > 1 || x > 1) && this.fillChildMap(r, v, m, p, x, b), Re.hasChildren(s)) {
        const T = $e(pe({}, i), {
          parentRowIndex: c + l,
          parentKey: v
        });
        this.fillMapVertical(Re.getChildren(s), n, r, T), x > 1 && (i.prevChildren += x - 1);
      }
    }), r;
  }
  /**
   * Fill child items in map according to main cell merged row and col
   *
   * @param {object} map - map object to fill
   * @param {string} mainKey - main cell key in map
   * @param {number} rowStart - main cell row index
   * @param {number} colStart - main cell column index
   * @param {number} row - merged rows count
   * @param {number} col - merged columns count
   * @returns {void}
   *
   * @private
   */
  fillChildMap(t, n, r, o, i, a) {
    const s = t[n], c = Math.max(1, i), l = Math.max(1, a);
    Array.from(Array(c)).forEach((d, f) => {
      Array.from(Array(l)).forEach((p, m) => {
        if (f === 0 && m === 0)
          return;
        const v = r + f, g = o + m, b = Tl(v, g), x = this.createTreeCellMap({
          rowIndex: v,
          colIndex: g,
          parent: n
        });
        t[b] = x, !(f !== 0 && m !== 0) && (m === 0 && s.addRowCell(x), f === 0 && s.addColCell(x));
      });
    });
  }
  /**
   * Creates TreeCellMap instance
   *
   * @param {object} options - instance options
   * @param {number} options.rowIndex - row index of cell map instance
   * @param {number} options.colIndex - row index of cell map instance
   * @param {TreeNode} [options.node] - TreeNode for main cell
   * @param {string} [options.parent] - parent key for child item
   * @returns {TreeCellMap} - TreeCellMap instance
   *
   * @private
   */
  // eslint-disable-next-line class-methods-use-this
  createTreeCellMap({
    rowIndex: t,
    colIndex: n,
    node: r,
    parent: o
  }) {
    return new Rj(t, n, r, o);
  }
  /**
   * Returns TreeCellMapI item by key string
   *
   * @param {string} key - map key string
   * @returns {TreeCellMapI|undefined} - TreeCellMapI instance or undefined
   *
   * @private
   */
  getItemByKey(t) {
    return this.map[t];
  }
  /**
   * Returns TreeCellMapI item by (row, col) coordinate
   *
   * @param {number} row - cell row index
   * @param {number} col - cell column index
   * @returns {TreeCellMapI|undefined} - TreeCellMapI instance or undefined
   *
   * @private
   */
  getItem(t, n) {
    const r = Tl(t, n);
    return this.getItemByKey(r);
  }
}
class Ms extends jj {
}
class Jl extends Error {
  constructor(t = "Loading canceled") {
    super(t), this.name = "LoadingCanceledError";
    const n = new.target.prototype;
    Object.setPrototypeOf && Object.setPrototypeOf(this, n);
  }
}
class $2 {
  constructor(t = [], n) {
    Z(this, "divergence", 0);
    const r = n ? n.getDivergence() : 0, o = Re.getLastLevelNodes(t);
    this.divergence = (r + o.length) % 2;
    for (let i = 0; i < o.length; i += 1)
      o[i].indexDivergence = (i + r) % 2;
  }
  getDivergence() {
    return this.divergence;
  }
}
function Im(e = []) {
  const t = {};
  return e.forEach((n) => {
    const { index: r = 1 / 0 } = n.field || {}, o = `${r}`;
    t[o] = n.jaql.datatype || oa.TEXT;
  }), t;
}
function Bb(e, t) {
  if (e && t === oa.DATETIME)
    try {
      return new Date(e).toISOString();
    } catch (n) {
      return e;
    }
  return e;
}
function F2(e) {
  if (e !== null && !Ib(e, {}))
    return e;
}
function wh(e, t, n = {}) {
  const r = F2(e), o = F2(t);
  let i = !1;
  if (typeof r == "object" && r !== null && typeof o == "object" && o !== null) {
    i = !0;
    const a = Object.keys(r), s = Object.keys(o);
    a.length !== s.length ? i = !1 : a.forEach((c) => {
      const l = n[c] || "";
      let d = (r || {})[c], f = (o || {})[c];
      if (typeof d == "undefined" || typeof f == "undefined") {
        i = !1;
        return;
      }
      l === oa.DATETIME && (d = Bb(d, l), f = Bb(f, l)), d !== f && (i = !1);
    });
  } else
    i = r === o;
  return i;
}
function w3(e, t, n = Bb) {
  if (!e || typeof e != "object")
    return e;
  const r = {};
  return Object.keys(e).forEach((o) => {
    const i = t[o], a = (e || {})[o], s = n(a, i);
    r[o] = s;
  }), r;
}
const da = (e, t) => {
  let n = e && e.metadata || [];
  return t && (n = n.filter((r) => r.panel === t)), n.sort((r, o) => {
    const i = { index: 1 / 0 }, a = r.field || i, s = o.field || i;
    return a.index - s.index;
  }), n;
}, df = (e, t, n) => typeof t == "undefined" ? void 0 : da(e, n).filter((r) => (r.field || { index: 1 / 0 }).index === t)[0], Wj = (e, t) => {
  const n = e.field || { index: 1 / 0 };
  if (e.panel === Ke.MEASURES)
    return !0;
  if (e.panel === Ke.ROWS) {
    const r = da(t, Ke.ROWS), o = (r[r.length - 1] || {}).field || { index: 1 / 0 };
    if (r.length && o.index === n.index)
      return !0;
    r.length || console.error("Missing rows panel in jaql!");
  }
  return !1;
};
function Vj(e, t) {
  return !e || typeof e.field != "number" ? !1 : e.field !== t;
}
const Uj = (e, t = Ke.ROWS) => {
  const n = da(e, t).map((r, o) => {
    const i = Re.create(r.jaql.title, void 0, void 0, o), a = hr(i, t);
    switch (a.jaqlIndex = r.field ? r.field.index : void 0, t) {
      case Ke.ROWS: {
        a.measurePath = void 0;
        const s = Vj(
          r.jaql.sortDetails,
          a.jaqlIndex
        );
        r.jaql.sort && !s ? a.dir = r.jaql.sort : a.dir = null;
        break;
      }
      case Ke.MEASURES:
        a.databars = r.format ? r.format.databars : !1, a.measureJaqlIndex = a.jaqlIndex, da(e, Ke.COLUMNS).length || (a.measurePath = void 0, r.jaql.sortDetails && r.jaql.sortDetails.measurePath === null ? a.dir = r.jaql.sortDetails.dir : a.dir = null);
        break;
    }
    return a;
  });
  return Re.wrapInRootNode(n);
}, x3 = (e) => {
  (e && e.metadata ? e.metadata : []).forEach((t) => {
    t && t.jaql && t.jaql.sort && t.jaql.sortDetails && t.jaql.sortDetails.sortingLastDimension && (t.jaql.sort = null, delete t.jaql.sortDetails);
  });
}, C3 = (e) => {
  e && e.jaql && (e.jaql.sort = null, delete e.jaql.sortDetails);
}, S3 = (e) => {
  (e && e.metadata ? e.metadata : []).forEach((t) => C3(t));
}, qj = (e) => (e.metadata || []).reverse().find((t) => !!t.jaql.sortDetails), Gj = (e) => (e.metadata || []).find(
  (t) => !!(t.jaql.sortDetails && t.jaql.sortDetails.isLastApplied)
), Yj = (e) => {
  const t = Gj(e) || qj(e);
  if (!t)
    return;
  const n = t.field && t.field.index;
  (e.metadata || []).forEach((r) => {
    (r.field && r.field.index) !== n && C3(r);
  });
}, T3 = (e, t) => {
  e.metadata.forEach((n) => {
    const r = n.field && n.field.index;
    if (t.field === r) {
      n.jaql.sortDetails = n.jaql.sortDetails || t, n.jaql.sortDetails.isLastApplied = !0;
      return;
    }
    n.jaql.sortDetails && n.jaql.sortDetails && delete n.jaql.sortDetails.isLastApplied;
  });
}, Zj = (e, t, n) => {
  const { isSingleRowTree: r = !1, formatter: o } = n || {};
  if (!t) {
    console.warn("jaql is undefined or null!");
    return;
  }
  const i = df(t, e.field);
  if (i && i.panel === Ke.COLUMNS) {
    console.warn('Should not be sorted by "COLUMN" type panels!');
    return;
  }
  if (!i)
    return;
  const a = Wj(i, t);
  switch (r ? S3(t) : a && x3(t), e.dir) {
    case En.DESC:
    case null:
      i.jaql.sort = En.ASC;
      break;
    case En.ASC:
      i.jaql.sort = En.DESC;
      break;
    default:
      i.jaql.sort = void 0;
  }
  const s = i.field || { index: 1 / 0 };
  if (i.jaql.sort) {
    let { measurePath: c } = e;
    if (c) {
      const l = da(t), d = Im(l);
      c = w3(c, d, o);
    }
    i.jaql.sortDetails = {
      field: s.index,
      dir: i.jaql.sort,
      sortingLastDimension: a,
      measurePath: c,
      initialized: !0
    };
  } else
    i.jaql.sortDetails = void 0;
  t && t.metadata && s.index !== void 0 && (t.metadata[s.index] = i), T3(t, e);
}, Xj = (e, t, n) => {
  if (!e)
    return;
  const r = df(e, t);
  r && (r.format = r.format || {}, r.format.width = n);
}, Kj = (e) => {
  const t = {};
  return e && da(e).forEach((n) => {
    const r = n.field || { index: 1 / 0 };
    n.format && typeof n.format.width != "undefined" && typeof r.index != "undefined" && (t[r.index] = n.format.width);
  }), t;
}, Jj = (e, t) => {
  if (typeof t.measureJaqlIndex != "undefined") {
    const n = da(e), r = Im(n), o = n.filter((a) => a.panel === Ke.ROWS).find((a) => {
      const s = a.jaql.sortDetails;
      return !s || s.field !== t.measureJaqlIndex ? !1 : !!wh(t.measurePath, s.measurePath, r);
    });
    if (o) {
      t.dir = o.jaql.sort ? o.jaql.sort : null;
      return;
    }
    const i = df(e, t.measureJaqlIndex);
    if (i && i.jaql.sortDetails) {
      const a = i.jaql.sortDetails.measurePath, s = t.measurePath;
      if (wh(a, s, r)) {
        t.dir = i.jaql.sort || null;
        return;
      }
    }
  }
  t.dir = null;
};
function Qj(e, t, n, r) {
  const { isSingleRowTree: o, formatter: i } = r;
  o && S3(e), e.metadata.forEach((a) => {
    a.jaql.sortDetails && delete a.jaql.sortDetails.isLastApplied;
  }), t.forEach((a, s) => {
    let c;
    s === t.length - 1 ? (a.selected && x3(e), c = n.field) : c = a.indexInJaql;
    const l = df(e, c);
    if (!l) {
      console.warn(new Error("Panel not found"));
      return;
    }
    a.selected && !a.direction && console.warn(new Error("Direction should be defined and equal to 'asc' or 'desc'"));
    const d = da(e), f = Im(d);
    if (!a.direction || !a.selected) {
      const { sortDetails: p } = l.jaql;
      p && n.field === p.field && wh(
        n.measurePath,
        p.measurePath,
        f
      ) && (delete l.jaql.sort, delete l.jaql.sortDetails);
    }
    if (a.selected && a.direction) {
      l.jaql.sort = a.direction;
      let { measurePath: p } = n;
      p && (p = w3(p, f, i)), n.measurePath === void 0 && l.field && // for type checker
      l.panel === "rows" && n.field !== l.field.index && (p = {}), l.jaql.sortDetails = {
        field: n.field,
        dir: a.direction,
        sortingLastDimension: !1,
        // TODO: find out should it be true?
        measurePath: p,
        isLastApplied: !0,
        initialized: !0
      };
    }
  });
}
function eW(e, t, n, r) {
  return e.jaql.sortDetails ? !1 : n ? kn.isMeasurePathEqual(
    t.measurePath,
    n.measurePath,
    r
  ) : !1;
}
function Hb(e) {
  const t = e && e.dir;
  switch (t) {
    case "asc":
    case "desc":
      return t;
    default:
      return null;
  }
}
function tW(e, t) {
  var n, r;
  const o = e.metadata.filter((v) => v.panel === "rows"), i = kn.getMetadataPanelByIndex(
    e,
    t.field
  ), a = i.jaql.datatype, s = i.jaql.sortDetails, c = kn.getDataTypes(kn.getMetadataPanels(e)), l = [];
  for (let v = 0; v < o.length - 1; v += 1) {
    const g = o[v], b = !!(g.jaql.sortDetails && g.jaql.sortDetails.field === t.field && kn.isMeasurePathEqual(
      t.measurePath,
      g.jaql.sortDetails.measurePath,
      c
    )), x = Hb(g.jaql.sortDetails);
    l.push({
      title: g.jaql.title,
      // `datatype` should correspond to datatype of value column on which
      //   sorting settings was called
      datatype: a,
      selected: b,
      direction: x,
      indexInJaql: (n = g.field) == null ? void 0 : n.index
    });
  }
  const d = o[o.length - 1], f = eW(
    d,
    t,
    s,
    c
  ), p = Hb(s), m = {
    title: d.jaql.title,
    // `datatype` should correspond to datatype of value column on which
    //   sorting settings was called
    datatype: a,
    selected: f,
    direction: p,
    indexInJaql: (r = i.field) == null ? void 0 : r.index
  };
  return l.push(m), l;
}
function nW(e, t, n) {
  return e.filter((r) => r.field && t.field === r.field.index).map((r) => {
    const { sortDetails: o } = r.jaql, i = !!(o && kn.isMeasurePathEqual(
      t.measurePath,
      o.measurePath,
      n
    )), a = i ? Hb(o) : null;
    return {
      title: r.jaql.title,
      // TODO: remove `as` type assertion
      datatype: r.jaql.datatype,
      selected: i,
      direction: a
    };
  })[0];
}
const kn = {
  isMeasurePathEqual: wh,
  getDataTypes: Im,
  updatePanelsSortingMetadata: Zj,
  getMetadataTree: Uj,
  getMetadataPanels: da,
  getMetadataPanelByIndex: df,
  setResizeWidthToJaql: Xj,
  getResizeWidthFromJaql: Kj,
  markSortedNode: Jj,
  normalizeSingleBranchTreeSortDetails: Yj,
  updateLastAppliedSortingFlag: T3,
  handleComplexSortingSettingsUpdate: Qj,
  mapWidgetJaqlToSimpleSortingSettings: nW,
  mapWidgetJaqlToComplexSortingSettings: tW
};
function E3(e, t) {
  if (!Re.hasChildren(e))
    return !1;
  let n = !1;
  t === Ke.COLUMNS && e && e.isPart && (n = !0);
  const r = Re.getChildren(e);
  if (r.length > 1 || n)
    return !0;
  const [o] = r;
  return E3(o);
}
function rW(e) {
  return e == null;
}
const N_ = (e, t, n, r, o) => {
  const i = [];
  return e.forEach((a) => {
    if (i.push(a), Re.hasChildren(a)) {
      const s = Re.getChildren(a), c = N_(
        s,
        t,
        n,
        r,
        o
      );
      Re.setChildren(a, c);
      let l = !1;
      if ((o || E3(a, n)) && (n === Ke.COLUMNS ? typeof a.index != "undefined" && a.index > -1 && (l = !0) : n === Ke.ROWS && typeof a.data != "undefined" && (l = !0)), l) {
        const { value: d, index: f, data: p, jaqlIndex: m, measurePath: v } = a;
        let g;
        if (n === Ke.COLUMNS ? g = Re.create(d, void 0, void 0, f) : n === Ke.ROWS && (g = Re.create(d, void 0, p)), g) {
          const b = hr(g, n);
          b.userType = qt.SUB_TOTAL, b.jaqlIndex = m, b.measurePath = v, b.master = a, i.push(b);
        }
      }
    }
  }), i;
}, k3 = (e, t) => {
  e.userType === qt.SUB_TOTAL && e.master && (e.measurePath = e.master.measurePath);
}, M3 = (e, t, n, r) => {
  const o = e;
  if (n === Ke.COLUMNS && t) {
    const i = hr(t);
    if (typeof i.index == "number") {
      const a = kn.getMetadataTree(r, Ke.MEASURES);
      Re.getChildren(a).forEach((s, c) => {
        const l = $e(pe({}, s), {
          index: (i.index || 0) + c
        }), d = hr(l, n);
        d.userType = qt.GRAND_TOTAL, d.measureJaqlIndex = d.jaqlIndex, o.push(d);
      });
    }
  }
  return o;
}, R3 = (e, t) => {
  e.userType === qt.GRAND_TOTAL && (e.measurePath = void 0, e.metadataType === Ke.ROWS && (e.parent = void 0, e.jaqlIndex = 0));
}, P3 = (e, t, n, r) => {
  let o = e;
  if (n === Ke.COLUMNS) {
    const i = kn.getMetadataTree(r, Ke.MEASURES), a = Re.getChildLength(i), s = { maxLevel: 0 }, c = Re.getLastLevelNodes(o, [], 0, s);
    if (a > 1)
      c.forEach((l) => {
        if (l.userType === qt.GRAND_TOTAL)
          return;
        const d = Re.getChildren(i), f = [];
        for (let p = 0; p < d.length; p += 1) {
          if (typeof l.maxChilds == "number" && p >= l.maxChilds)
            continue;
          const m = $e(pe({}, d[p]), {
            index: (l.index || 0) + p,
            measurePath: l.measurePath
          }), v = hr(m, Ke.MEASURES);
          v.userType = qt.MEASURE_BOTTOM, v.measureJaqlIndex = v.jaqlIndex, f.push(v);
        }
        l.minLevel = s.maxLevel, Re.setChildren(l, f);
      });
    else if (a === 1) {
      const l = Re.getChildren(i)[0];
      if (l) {
        const d = pe({}, l), f = hr(d, Ke.MEASURES);
        f.userType = qt.MEASURE_TOP, Re.setChildren(f, o), o = [f], c.forEach((p) => {
          p.measureJaqlIndex = l.jaqlIndex;
        });
      }
    }
  }
  return o;
}, O3 = (e, t) => {
  !Re.hasChildren(e) && typeof e.measureJaqlIndex != "undefined" && kn.markSortedNode(t, e);
}, oW = (e, t, n, r) => {
  let o = {};
  if (t.userType === qt.SUB_TOTAL || t.userType === qt.GRAND_TOTAL || n.userType === qt.SUB_TOTAL || n.userType === qt.GRAND_TOTAL || n.parent && n.parent.userType === qt.SUB_TOTAL || n.parent && n.parent.userType === qt.GRAND_TOTAL)
    return;
  const i = r && r.format && r.format.color || null;
  if (!i)
    return;
  const { value: a, cf: s = -1 } = e;
  if (i.type === A2.COLOR && i.color && i.color !== "transparent" && (o.backgroundColor = i.color), i.type === A2.CONDITION && i.conditions && i.conditions.length)
    for (let c = 0, l = i.conditions.length; c < l && !rW(a); c += 1) {
      const d = i.conditions || [], { color: f } = d[c] || {};
      if (f && s === c) {
        o.backgroundColor = f;
        break;
      }
    }
  Object.keys(o).length > 0 && (e.style = e.style || {}, Object.assign(e.style, o)), o = void 0;
}, N3 = (e, t, n, r) => {
  const o = [], { level: i = 0, measurePath: a = {} } = r || {};
  let s;
  Array.isArray(e) ? s = e : s = Re.getChildren(e);
  const c = kn.getMetadataPanels(n, t)[i], l = c ? (c.field || { index: 1 / 0 }).index : void 0;
  return s.forEach((d) => {
    const f = hr(d, t);
    if (f.jaqlIndex = l, typeof l != "undefined" && (f.measurePath = $e(pe({}, a), {
      [l]: f.value
    })), o.push(f), Re.hasChildren(f)) {
      const p = Re.getChildren(f), m = {
        level: i + 1,
        measurePath: f.measurePath
      }, v = N3(p, t, n, m);
      Re.setChildren(f, v);
    }
  }), o;
}, A3 = (e, t, n) => {
  const { skipFormatEvent: r = !1, onlyFormatEvents: o = !1, iterateFn: i, emitFn: a } = n || {};
  e.forEach((s) => {
    if (i && i(s), (r || !o) && (k3(s), R3(s), O3(s, t)), a && (o || !r)) {
      const c = kn.getMetadataPanelByIndex(
        t,
        s.jaqlIndex,
        s.metadataType || ""
      );
      a(s, c, t);
    }
    if (Re.hasChildren(s)) {
      const c = Re.getChildren(s);
      A3(c, t, n);
    }
  });
}, iW = (e, t, n, r) => {
  const { originalData: o, applyIndexDivergence: i, subtotalsForSingleRow: a } = r || {};
  i && i(e);
  let s = N_(e, o, t, n, a);
  return s = M3(s, o, t, n), s = P3(s, o, t, n), Re.iterateThroughTree(s, (c, l) => {
    c.parent = l;
  }), s;
}, xu = {
  insertSubTotals: N_,
  postProcessSubTotal: k3,
  insertGrandTotals: M3,
  postProcessGrandTotal: R3,
  insertMeasureNodes: P3,
  postProcessMeasureNode: O3,
  applyColorFormatting: oW,
  preProcessTree: N3,
  modifyTree: iW,
  postProcessTree: A3
}, hr = (e, t) => {
  const n = e;
  return t && (n.metadataType = t), n;
};
function cc(e, t, n) {
  return !t || !t.length ? !1 : t.some((r) => {
    let o = !0;
    return n && n.fields && n.fields.length && n.fields.forEach((i) => {
      e[i] !== void 0 && r[i] === void 0 ? o = !1 : e[i] !== void 0 && r[i] !== void 0 && (Array.isArray(e[i]) ? o = o && e[i].indexOf(r[i]) !== -1 : o = o && e[i] === r[i]);
    }), o;
  });
}
const aW = (e, t = []) => {
  let n = !1;
  return !t || !t.length ? !1 : e.length === 0 ? !0 : (e.forEach((r) => {
    t.includes(r) && (n = !0);
  }), n);
}, z2 = (e, t) => {
  let n = !0;
  return !t || !t.length ? n = !1 : e.forEach((r) => {
    if (r.index) {
      const o = t[t.length - 1];
      n = n && cc(r, [o], { fields: [Ga.INDEX] });
    }
    if (r.dim && (r.name = r.dim, r.members && (r.member = r.members), n = n && cc(r, t, {
      fields: [Ga.NAME, Ga.MEMBER]
    })), r.title) {
      const o = t[t.length - 1];
      n = n && cc(r, [o], { fields: [Ga.TITLE] });
    }
  }), n;
}, sW = (e, t) => {
  let n = !0;
  return !t || !t.length ? n = !1 : e.forEach((r) => {
    r.index && (n = n && cc(r, t, { fields: [Ga.INDEX] })), r.dim && (r.name = r.dim, n = n && cc(r, t, {
      fields: [Ga.DIM, Ga.AGG]
    })), r.title && (n = n && cc(r, t, { fields: [Ga.TITLE] }));
  }), n;
}, lW = (e, t) => {
  let n = !0;
  if (e.type && n && (n = n && aW(e.type, t.type)), e.rows && e.rows.length && n) {
    const r = t.rows ? t.rows : [];
    n = n && z2(e.rows, r);
  }
  if (e.columns && n) {
    const r = t.columns ? t.columns : [];
    n = n && z2(e.columns, r);
  }
  if (e.values && n) {
    const r = t.measure ? [t.measure] : [];
    n = n && sW(e.values, r);
  }
  return n;
}, cW = (e, t) => e.metadata.find((n) => n.field && n.field.index === t), jp = (e, t, n = [], r = []) => {
  if (!t || !e || typeof e.jaqlIndex == "undefined")
    return { dimensionsMeta: n, type: r };
  const o = cW(t, e.jaqlIndex);
  if (o && o.jaql && e.metadataType !== Ke.MEASURES && n.unshift({
    title: o.jaql.title,
    name: o.jaql.dim,
    member: e.value,
    index: e.jaqlIndex
  }), e && e.userType && (e.userType === qt.SUB_TOTAL || e.userType === qt.GRAND_TOTAL)) {
    const i = e.userType.toLowerCase();
    r.push(i);
  }
  return e.parent && e.parent.metadataType !== Ke.MEASURES ? jp(e.parent, t, n, r) : { dimensionsMeta: n, type: r };
}, B2 = (e) => {
  let t = {};
  if (e) {
    const n = e.jaql;
    t = Wn(n, ["type", "datatype", "table", "column"]), e.field && (t.index = e.field.index);
  }
  return t;
}, fr = {
  CORNER: "corner",
  COLUMNS: "columns",
  ROWS: "rows",
  DATA: "data"
};
function Ov(e, t = "", n = "") {
  let r = "";
  return e && (e.levels.length && e.levels.forEach((o) => {
    r += ` ${t}--${n ? `${n}-` : ""}level-${o}`;
  }), e.siblings.length && e.siblings.forEach((o) => {
    r += ` ${t}--${n ? `${n}-` : ""}sibling-${o}`;
  }), e.root && e.root.siblings && e.root.siblings.length && e.root.siblings.forEach((o) => {
    r += ` ${t}--${n ? `${n}-root-` : "root-"}sibling-${o}`;
  }), e.parent && e.parent.siblings && e.parent.siblings.length && e.parent.siblings.forEach((o) => {
    r += ` ${t}--${n ? `${n}-parent-` : "parent-"}sibling-${o}`;
  })), r;
}
function uW(e, t) {
  const { metadata: n, rowMetadata: r, rowTreeNode: o, columnTreeNode: i, merge: a } = t || {}, s = {
    t: !0,
    r: !0,
    b: !0,
    l: !0
  };
  if (e === fr.CORNER || e === fr.COLUMNS)
    return s;
  if (e === fr.ROWS) {
    const c = a && a.colSpan, l = n && n.nextNode && n.nextNode.userType === qt.GRAND_TOTAL;
    n && n.levels.includes(ur.LAST) && !n.siblings.includes(ur.LAST) && !c && !l && (s.b = !1), n && n.levels.includes(ur.FIRST) && n.levels.includes(ur.LAST) && !n.siblings.includes(ur.LAST) && !c && !l && (s.b = !1);
  }
  if (e === fr.DATA) {
    const c = o && o.userType === qt.SUB_TOTAL, l = i && i.userType === qt.SUB_TOTAL, d = i && i.userType === qt.GRAND_TOTAL, f = r && r.nextNode && r.nextNode.userType === qt.GRAND_TOTAL;
    r && r.levels.includes(ur.LAST) && !r.siblings.includes(ur.LAST) && !c && !l && !d && !f && (s.b = !1);
  }
  return s;
}
function Nv(e, t = "", n = "") {
  let r = "";
  return e && e.userType && (r = `${t}--${n ? `${n}-` : ""}user-type-${e.userType}`), r;
}
function Av(e, t = "", n = "") {
  let r = "";
  return e && e.colSpan && (r = `${t}--${n ? `${n}-` : ""}merged-columns`), e && e.rowSpan && (r = ` ${t}--${n ? `${n}-` : ""}merged-rows`), r;
}
function Dv(e) {
  return e && e.colSpan ? e.colSpan - 1 : 0;
}
function H2(e, t) {
  if (e === void 0)
    return e;
  let n = typeof e == "number" ? e : parseInt(e, 10);
  return n -= t || 1, n;
}
function Cu(e) {
  const { isDataCell: t, dataNode: n, treeNode: r } = e, o = t ? n : r;
  return o && o.style || {};
}
const dW = (e) => {
  const t = {};
  return Object.keys(e).forEach((n) => {
    (!n.startsWith("border") || n === "borderColor") && (t[n] = e[n]);
  }), t;
}, fW = (e) => {
  const t = {};
  return Object.keys(e).forEach((n) => {
    (!n.startsWith("color") && !n.startsWith("padding") && !n.startsWith("border") && !n.startsWith("font") && !n.startsWith("lineHeight") && !n.startsWith("databarColor") || n === "borderColor") && (t[n] = e[n]);
  }), t;
}, pW = (e) => {
  const t = {};
  return Object.keys(e).forEach((n) => {
    (n.startsWith("color") || n.startsWith("padding") || n.startsWith("font") || n.startsWith("lineHeight")) && (t[n] = e[n]);
  }), t;
}, hW = (e) => {
  const t = {};
  return e.databarColor && (t.backgroundColor = e.databarColor), t;
}, mW = (e, t, n) => {
  if (!e || !t || !n || n.measureJaqlIndex === void 0)
    return;
  const [r, o] = e[n.measureJaqlIndex] || [];
  if (r == null)
    return;
  const i = t && t.store && t.store.compileRange, a = t && t.store && t.store.compileRangeContext, s = t && t.store && t.store.compileRangeArgs;
  if (!i || !s || !a || !t || !t.value)
    return;
  const c = $e(pe({}, s), {
    minvalue: r,
    midvalue: r + (o - r) / 2,
    maxvalue: o
  });
  let l, d;
  return c.min === void 0 && (c.maxvalue <= 0 && (d = !0), c.min = c.minDef), c.max === void 0 && (c.minvalue >= 0 && (l = !0), c.max = c.maxDef), d && (c.max = c.maxGray), l && (c.min = c.minGray), i.call(a, c)(t.value);
}, Su = "text";
class A_ {
  constructor(t, n, r) {
    Z(this, "plugins", []), Z(this, "globalStyles"), Z(this, "jaql"), Z(this, "indexHelper"), Z(this, "columnsMetadata", []), Z(this, "metadataCache", /* @__PURE__ */ new Map()), this.plugins = t, this.jaql = n, this.globalStyles = r, this.indexHelper = {
      measuresLevel: this.getMeasuresLevel(),
      columnStartFrom: 0,
      rowStartFrom: 0
    }, this.globalStyles && (this.globalStyles = dW(this.globalStyles));
  }
  /**
   * Get array of panels by type
   *
   * @param {ListOfPanelTypes} jaqlPanel - type of panels to return measures|columns|rows
   * @returns {Array<any>} row level of measures in column tree
   */
  getJaqlPanels(t) {
    if (!this.jaql)
      throw new Error("No Jaql in Plugin service!");
    return this.jaql.metadata.filter((n) => n.panel === t);
  }
  /**
   * Calculate level of measures in column tree
   *
   * @returns {number} row level of measures in column tree
   */
  getMeasuresLevel() {
    const t = this.getJaqlPanels(Ke.COLUMNS);
    return this.getJaqlPanels(Ke.MEASURES).length > 1 ? t.length : 0;
  }
  /**
   * Get count of row panels
   *
   * @returns {void}
   */
  getRowsColumnLength() {
    return this.getJaqlPanels(Ke.ROWS).length;
  }
  /**
   * Get count of row panels
   *
   * @param {Array<string>} types - array of types from current cell
   * @returns {void}
   */
  // eslint-disable-next-line class-methods-use-this
  getTotalTypes(t) {
    const n = t.filter(
      (r) => r === Sl.SUB_TOTAL || r === Sl.GRAND_TOTAL
    );
    return n && n.length ? n.filter((r, o, i) => i.indexOf(r) === o) : [];
  }
  /**
   * Calculate measure index and get panel metadata
   *
   * @param {number} index - measure index in row
   * @returns {MeasureMetadata} measure metadata
   */
  getMeasureMetaByIndex(t) {
    const n = this.getJaqlPanels(Ke.MEASURES);
    if (n.length === 1)
      return B2(n[0]);
    const r = t % n.length;
    return B2(n[r]);
  }
  resetRowStartFrom() {
    this.indexHelper.rowStartFrom = 1;
  }
  applyToColumns(t) {
    t.length !== 0 && (this.indexHelper.columnStartFrom === 0 && (this.indexHelper.columnStartFrom = this.getRowsColumnLength()), this._applyToColumns(t, { row: -1 }));
  }
  /**
   * Apply plugins to columns values and cache metadata for measure handler
   *
   * @param {Array<any>} columnTreeChildren - measure index in row
   * @param {object} indexes - measure index in row
   * @returns {void}
   */
  _applyToColumns(t, n) {
    t.forEach((r, o) => {
      const { dimensionsMeta: i, type: a } = jp(r, this.jaql);
      a.push(Sl.MEMBER);
      let s = n.row >= 0 ? n.row + 1 : 0;
      s >= this.indexHelper.rowStartFrom && (this.indexHelper.rowStartFrom = s + 1), r.metadataType === Ke.MEASURES && (s = this.indexHelper.measuresLevel);
      let c = o === 0 ? 0 : 1;
      c += this.indexHelper.columnStartFrom;
      const l = {
        type: a,
        rowIndex: s,
        colIndex: c,
        index: r.jaqlIndex,
        columns: i
      };
      r.metadataType === Ke.MEASURES && (l.measure = this.getMeasureMetaByIndex(r.index || 0));
      const d = {
        value: r.value || "",
        content: r.content || "",
        contentType: r.contentType || Su,
        style: r.style || {},
        store: r.store || {},
        state: r.state
      };
      if (this.applyGlobal(d), this.apply(l, d), this.addToMetadata(l, d, l.rowIndex, l.colIndex), Object.assign(r, d), this.indexHelper.columnStartFrom = c, r.children) {
        const f = {
          row: s,
          column: c
        };
        this._applyToColumns(r.children, f);
      } else
        this.columnsMetadata.push({ type: a, metadata: i });
      return !0;
    });
  }
  /**
   * Apply plugins to corner tree headers
   *
   * @param {any} cornerTree - measure index in row
   * @returns {void}
   */
  applyToHeaders(t) {
    !t || !t.children || t.children.length === 0 || t.children.forEach((n) => {
      const { dimensionsMeta: r } = jp(n, this.jaql), o = {
        type: [Sl.MEMBER],
        rowIndex: 0,
        colIndex: n.index || 0,
        index: n.jaqlIndex,
        rows: r
      }, i = {
        value: n.value,
        content: n.content || "",
        contentType: n.contentType || Su,
        style: n.style ? n.style : {},
        store: n.store || {},
        // eslint-disable-next-line max-lines
        state: n.state
      };
      this.applyGlobal(i), this.apply(o, i), this.addToMetadata(o, i, o.rowIndex, o.colIndex), Object.assign(n, i);
    });
  }
  applyToRows(t) {
    if (t.length === 0)
      return;
    const n = this.getJaqlPanels(Ke.ROWS), r = this.getJaqlPanels(Ke.MEASURES), o = this.getJaqlPanels(Ke.COLUMNS);
    this.indexHelper.rowStartFrom = A_.getRowStartFromForPage(
      n.length,
      r.length,
      o.length
    ), this._applyToRows(t);
  }
  static getRowStartFromForPage(t, n, r) {
    if (t === 0 && r === 0)
      return 0;
    const o = r + (n === 0 ? 0 : 1);
    return o === 0 ? 1 : o;
  }
  /**
   * Apply plugins to rows panels
   *
   * @param {Array<PivotTreeNode>} rowTreeChildren - measure index in row
   * @returns {void}
   */
  _applyToRows(t) {
    t.forEach((n, r) => {
      const { dimensionsMeta: o, type: i } = jp(n, this.jaql);
      i.push(Sl.MEMBER);
      const a = n.level ? n.level : 0, s = r === 0 ? this.indexHelper.rowStartFrom : this.indexHelper.rowStartFrom + 1, c = {
        type: i,
        rowIndex: s,
        colIndex: a,
        index: n.jaqlIndex,
        rows: o
      }, l = {
        value: n.value,
        content: n.content || "",
        contentType: n.contentType || Su,
        style: n.style || {},
        store: n.store || {},
        state: n.state
      };
      return this.applyGlobal(l), this.apply(c, l), this.addToMetadata(c, l, c.rowIndex, c.colIndex), this.indexHelper.rowStartFrom = s, n.children ? this._applyToRows(n.children) : n.data && n.data.length && this.applyToValues(
        n.data,
        { type: i, metadata: o },
        { rowIndex: s, colIndex: this.getRowsColumnLength() }
      ), Object.assign(n, l), !0;
    });
  }
  /**
   * Apply plugins to value panels
   *
   * @param {Array<any>} values - measure index in row
   * @param {object} rowData - row data
   * @param {Array<string>} rowData.type - row types
   * @param {Array<DimensionMetadata>} rowData.metadata - metadata of current row
   * @param {object} indexes - parent indexes in tree
   * @param {number} indexes.rowIndex - current row index
   * @param {number} indexes.colIndex - colIndex of last row cell to calculate value cell index
   * @returns {void}
   */
  // eslint-disable-next-line sonarjs/cognitive-complexity
  applyToValues(t, n, r) {
    t.length && t.forEach((o, i) => {
      const a = [Sl.VALUE], s = this.columnsMetadata[i];
      if (!s)
        return;
      const c = this.getTotalTypes([...n.type, ...s.type]), l = this.getMeasureMetaByIndex(i), d = {
        type: a.concat(c),
        rows: n.metadata,
        columns: s.metadata,
        measure: l,
        colIndex: i + r.colIndex,
        rowIndex: r.rowIndex,
        index: l && l.index ? l.index : 0
      };
      let f = {
        value: o,
        content: o,
        contentType: Su,
        style: {},
        store: o && o.store || {},
        state: o && o.state || void 0
      };
      o != null && typeof o == "object" && (f = {
        value: o.value ? o.value : null,
        content: o.content || "",
        contentType: o.contentType || Su,
        style: o.style || {},
        store: o.store || {},
        state: o.state
      }), this.applyGlobal(f), this.apply(d, f), this.addToMetadata(d, f, d.rowIndex, d.colIndex), t[i] = f;
    });
  }
  /**
   * Add cell metadata to map for click/hover APIs
   *
   * @param {Metadata} metadata - cell metadata
   * @param {CellItem} cellItem - cell content
   * @param {number} rowIndex - cell row index
   * @param {number} colIndex - cell column index
   * @returns {void}
   */
  addToMetadata(t, n, r, o) {
    const i = pe({
      cellData: {
        value: n.value,
        content: n.content
      }
    }, t);
    this.metadataCache.set(`${r}-${o}`, i);
  }
  /**
   * Apply global config to cells
   *
   * @param {CellItem} item - cell item to update by plugin
   * @returns {void}
   */
  applyGlobal(t) {
    const { globalStyles: n } = this;
    n && (t.style = pe(pe({}, t.style), n));
  }
  /**
   * Apply plugins to rows panels
   *
   * @param {Metadata} metadata - cell metadata
   * @param {CellItem} item - cell item to update by plugin
   * @returns {void}
   */
  apply(t, n) {
    this.plugins && this.plugins.length && this.plugins.forEach((r) => {
      if (lW(r.target, t)) {
        const o = r.handler;
        o(t, n);
      }
    });
  }
}
const Iv = (e, t) => {
  const n = e || { metadata: [], grandTotals: null };
  let { metadata: r } = n;
  return r = r.map((o) => {
    const i = o.field || {}, a = t.find(
      ({ field: c }) => c && c.index === i.index
    ), s = a ? a.format : null;
    return s ? $e(pe({}, o), { format: s }) : o;
  }), $e(pe({}, n), { metadata: r });
}, j2 = 100, gW = "dataLoad", jb = "dataChunkLoaded", vW = "dataBarChunkLoaded", bW = "rangeMinMaxChunkLoaded", Wb = "grandChunkLoaded", yW = "dataFinishChunkLoaded", _W = "finishChunkLoaded", Wp = "progressError", W2 = "headerCellFormat", wW = "dataCellFormat", Vb = "totalRowsCountLoaded", Ub = "totalColumnsCountLoaded", V2 = 1e3, xW = 0, CW = {
  throttle: f3,
  throttleTime: xW,
  PluginService: A_,
  skipInternalColorFormatting: !1,
  subtotalsForSingleRow: !1
};
class zr {
  // eslint-disable-next-line max-lines-per-function
  constructor(t, n, r, o) {
    Z(this, "logger"), Z(this, "events"), Z(this, "loadService"), Z(this, "options"), Z(this, "tempDataChunks", []), Z(this, "lastNotHandledChunkIndex", 0), Z(this, "lastReadyNotHandledChunkIndex", 0), Z(this, "rowsGrand"), Z(this, "rowsTreeService"), Z(this, "columnsTreeService"), Z(this, "cornerTreeService"), Z(this, "pageSize", j2), Z(this, "isPaginated", !1), Z(this, "loadedPagesCount", 0), Z(this, "isLoadInProgress", !1), Z(this, "loadPromiseResolve"), Z(this, "loadPromiseReject"), Z(this, "loadPromiseCache"), Z(this, "loadAllPromise"), Z(this, "loadAllPromiseResolve"), Z(this, "loadAllPromiseReject"), Z(this, "isWholeDataLoaded", !1), Z(this, "hasDataFinishEvent", !1), Z(this, "isDataHandlerThrottled", !1), Z(this, "onDataHandlerThrottle"), Z(this, "metadata", []), Z(this, "dataBars"), Z(this, "rangeMinMax"), Z(this, "divergenceComparator", new $2()), Z(this, "pluginService"), Z(this, "rawJaql"), Z(this, "triggeredEventsData", {}), Z(this, "callPlugins", []), Z(this, "globalStyles"), Z(this, "columnsCount"), Z(this, "totalColumnsCount"), Z(this, "rowsCount"), Z(this, "totalRowsCount"), Z(this, "totalRecordsCount"), Z(this, "limitReached"), Z(this, "onMetadataHandler", () => {
      const i = { metadata: this.getMetadata() };
      this.isSingleRowTree() && kn.normalizeSingleBranchTreeSortDetails(i);
    }), Z(this, "onHeadersHandler", (i) => {
      const a = this.getJaql.bind(this), s = this.getRawJaql.bind(this), c = this.applyIndexDivergence.bind(this), l = (m, v, g) => this.emit(W2, m, v, g, this.options), d = zr.createColumnsTreeServiceBuilder(
        {
          getJaql: a,
          getRawJaql: s,
          pluginService: this.pluginService,
          applyIndexDivergence: c
        },
        {
          emitHeaderCellFormatEvent: l
        }
      )(i);
      this.columnsTreeService = d.columnsTreeService, this.columnsCount = d.columnsCount, this.totalColumnsCount = d.totalColumnsCount, this.emit(Ub, {
        columnsCount: this.columnsCount || 0,
        totalColumnsCount: this.totalColumnsCount || 0
      });
      const f = zr.createCornerTreeServiceBuilder(
        {
          getJaql: a,
          getRawJaql: s,
          pluginService: this.pluginService,
          columnsTreeService: this.columnsTreeService
        },
        {
          emitHeaderCellFormatEvent: l
        }
      ), { cornerTreeService: p } = f();
      this.cornerTreeService = p;
    }), Z(this, "onDataHandler", (i) => {
      this.tempDataChunks = this.tempDataChunks || [], Array.isArray(i) ? (i || []).forEach((a) => {
        zr.fillDataChunks(this.tempDataChunks, a, this.pageSize);
      }) : zr.fillDataChunks(this.tempDataChunks, i, this.pageSize), this.tempDataChunks.length && (this.isDataHandlerThrottled = !0, this.onDataHandlerThrottle());
    }), Z(this, "onGrandHandler", (i) => {
      const a = this.preProcessTree([i], Ke.ROWS)[0], s = "Rows grand total", c = a ? a.data : [], l = Re.create(s, void 0, c), d = hr(l, Ke.ROWS);
      d.userType = qt.GRAND_TOTAL, this.postProcessTree([d]), this.postProcessData([d]), this.rowsGrand = d, this.emit(Wb, Re.wrapInRootNode(this.rowsGrand));
    }), Z(this, "onFinishHandler", () => {
      this.emit(_W, {
        totalRows: typeof this.totalRowsCount == "number" ? this.totalRowsCount : this.getTotalItemsCount(),
        // backward compatibility
        totalColumns: typeof this.totalColumnsCount == "number" ? this.totalColumnsCount : this.getLoadedColumnsCount()
        // backward compatibility
      });
    }), Z(this, "onTotalRowsHandler", (i) => {
      const { rowsCount: a, queryRowsCount: s, limitReached: c } = i || {};
      this.totalRowsCount = a, this.totalRecordsCount = s, this.limitReached = c, this.emit(Vb, i);
    }), Z(this, "onDataBarsHandler", (i) => {
      const { data: a = [] } = i;
      let s = 0;
      this.cornerTreeService && (s = this.cornerTreeService.getTreeChildLength()), this.dataBars = [...Array(s), ...a], this.emit(vW, this.dataBars);
    }), Z(this, "onRangeMinMaxHandler", (i) => {
      const { data: a = [] } = i, s = this.getJaql(), c = kn.getMetadataTree(s, Ke.MEASURES), l = Re.getChildren(c), d = [];
      l.forEach((f, p) => {
        d[f.measureJaqlIndex || 0] = a[p];
      }), this.rangeMinMax = d, this.emit(bW, this.rangeMinMax);
    }), Z(this, "onDataFinishHandler", ({ rowsCount: i } = {}) => {
      if (this.finishRequest(), this.rowsCount = i, this.tempDataChunks.length) {
        const a = this.tempDataChunks[this.tempDataChunks.length - 1];
        a.ready = !0;
      }
      this.onDataHandlerThrottle(), this.checkLoadPromise(), this.emit(yW, {
        limitedRows: this.rowsCount,
        limitedColumns: this.columnsCount
      });
    }), Z(this, "onErrorHandler", (i) => {
      process.env.NODE_ENV !== "production" && this.logger.console.warn(
        `${this.logger.getName()} data loading error "${JSON.stringify(i)}"`
      ), !this.isLoadInProgress && !this.isWholeDataLoaded && !(i instanceof Jl) && this.emit(Wp, i);
    }), this.loadService = t, this.events = n || new uf(), this.logger = o || ds.create("DataService"), this.options = pe(pe({}, CW), r), this.attachEvent(), this.onDataHandlerThrottle = this.options.throttle(() => {
      const i = L2(
        this.tempDataChunks,
        (f) => f.ready && !f.handled,
        this.lastReadyNotHandledChunkIndex
      );
      if (i === -1)
        return;
      this.lastReadyNotHandledChunkIndex = i;
      const a = this.tempDataChunks[i], s = this.preProcessTree(a.list, Ke.ROWS), c = this.modifyTree(s, Ke.ROWS);
      this.postProcessTree(c, { skipFormatEvent: !0 }), this.postProcessData(c, { skipFormatEvent: !0 });
      const l = Re.wrapInRootNode(c);
      this.rowsTreeService ? this.rowsTreeService.extend(l) : this.rowsTreeService = new Ms(l, !0), this.emit(jb, this.getLoadedElementsCount()), a.handled = !0;
      const d = L2(
        this.tempDataChunks,
        (f) => !f.handled,
        this.lastNotHandledChunkIndex
      );
      if (d !== -1 ? (this.lastNotHandledChunkIndex = d, this.onDataHandlerThrottle()) : this.isDataHandlerThrottled = !1, this.hasDataFinishEvent && this.tempDataChunks.length) {
        const f = this.tempDataChunks[this.tempDataChunks.length - 1];
        f.ready = !0;
      }
      this.hasDataFinishEvent && d === -1 ? (this.finishRequest(), this.checkLoadPromise()) : this.checkLoadPromise();
    }, this.options.throttleTime);
  }
  destroy() {
    this.detachEvent(), this.rowsGrand = void 0, this.rowsTreeService = void 0, this.columnsTreeService = void 0, this.cornerTreeService = void 0, this.tempDataChunks = [], this.lastNotHandledChunkIndex = 0, this.lastReadyNotHandledChunkIndex = 0, this.events.removeAllListeners();
  }
  /**
   * Subscribe to event notification
   *
   * @param {string} eventName - event name to subscribe
   * @param {Function} callback - event handler
   * @returns {void}
   */
  on(t, n) {
    this.events.on(t, n), this.triggeredEventsData[t] && (this.triggeredEventsData[t].forEach((r) => {
      this.events.emit(t, ...r);
    }), delete this.triggeredEventsData[t]);
  }
  /**
   * Emits event with payload
   *
   * @param {string} eventName - event name to emit
   * @param {Array<any>} payload - event payload
   * @returns {void}
   */
  emit(t, ...n) {
    this.events.listeners(t).length === 0 ? (this.triggeredEventsData[t] = this.triggeredEventsData[t] || [], this.triggeredEventsData[t].push(n)) : this.events.emit(t, ...n);
  }
  /**
   * Unsubscribe from event notification
   *
   * @param {string} eventName - event name to unsubscribe from
   * @param {Function} callback - event handler
   * @returns {void}
   */
  off(t, n) {
    this.events.removeListener(t, n), this.triggeredEventsData[t] && delete this.triggeredEventsData[t];
  }
  /**
   * Initialize start data loading
   *
   * @param {JaqlRequest} [jaql] - JAQL request object
   * @param {object} [options] - additional options
   * @param {number} [options.pageSize=100] - page size to wait
   * @param {boolean} [options.isPaginated=false] - defines which type of treeService to return,
   * partial or paginated
   * @param {Array<JaqlPanel>} [options.metadata] - jaql's metadata
   * @param {boolean} [options.cacheResult=false] - cache result for next call or not
   * @returns {Promise<any>} - promise with initial data to render
   */
  // eslint-disable-next-line max-lines-per-function,sonarjs/cognitive-complexity
  loadData(t, n) {
    const {
      pageSize: r = j2,
      isPaginated: o = !1,
      cacheResult: i = !1,
      metadata: a
    } = n || {}, s = this.pageSize === r;
    if (this.clearLoadAllPromise(), t && this.clearCache(), this.pageSize = r, this.isPaginated = o, this.emit(gW), this.loadPromiseCache && s) {
      const l = Promise.resolve(this.loadPromiseCache);
      return this.loadPromiseCache = void 0, l;
    }
    this.isLoadInProgress = !0, t && (this.metadata = a || [], this.rawJaql = Iv(t, this.metadata), this.initPluginService(this.rawJaql), this.loadService.load(t).then((l) => {
      if (l == null)
        return;
      const d = !("data" in l);
      if (l.dataFinish[0] && d)
        throw {
          error: {
            error: !0,
            details: "metadata undefined."
          }
        };
    }).catch((l) => {
      this.loadPromiseReject && this.loadPromiseReject(l.error);
    }));
    const c = new Promise((l, d) => {
      this.loadPromiseResolve = l, this.loadPromiseReject = d;
    }).then((l) => this.sendInitPage(l)).then((l) => (i && (this.loadPromiseCache = l), this.loadedPagesCount = 1, l)).catch((l) => {
      throw l instanceof Jl && this.clearLoadPromise(), l;
    });
    return this.checkLoadPromise(), c;
  }
  /**
   * Sets Promise that resolves after all data loaded
   *
   * @returns {Promise<{ loadedRowsCount: number, totalItemsCount: number }>} - promise with
   * loaded items count
   */
  loadAllData() {
    if (this.isWholeDataLoaded) {
      const t = {
        loadedRowsCount: this.getLoadedElementsCount(),
        totalItemsCount: typeof this.totalRowsCount == "number" ? this.totalRowsCount : this.getTotalItemsCount(),
        // backward compatibility
        totalRecordsCount: this.totalRecordsCount,
        limitReached: this.limitReached,
        dataBars: this.dataBars,
        rangeMinMax: this.rangeMinMax
      };
      return this.columnsCount !== 0 && this.totalColumnsCount !== 0 && (t.columnsCount = this.columnsCount, t.totalColumnsCount = this.totalColumnsCount), Promise.resolve(t);
    }
    return this.loadAllPromise || (this.loadAllPromise = new Promise((t, n) => {
      this.loadAllPromiseResolve = t, this.loadAllPromiseReject = n;
    }).then(() => ({
      loadedRowsCount: this.getLoadedElementsCount(),
      totalItemsCount: typeof this.totalRowsCount == "number" ? this.totalRowsCount : this.getTotalItemsCount(),
      // backward compatibility
      totalRecordsCount: this.totalRecordsCount,
      limitReached: this.limitReached,
      dataBars: this.dataBars,
      rangeMinMax: this.rangeMinMax
    })).catch((t) => {
      throw t instanceof Jl && this.clearLoadAllPromise(), t;
    })), this.loadAllPromise;
  }
  /**
   * public method for selecting page and setting new page size
   *
   * @param {number} selected - page number
   * @param {number} pageSize - set page size (optional)
   * @returns {Promise<{rowsTreeService, columnsTreeService, cornerTreeService, isLastPage}>}
   * - returns private method's call with panel's treeServices
   */
  getSelectedPageData(t, n) {
    return Promise.resolve(this.sendPaginatedPage(t, n));
  }
  /**
   * public method for selecting page by indexes
   *
   * @param {number} from - first row's index
   * @param {number} to - last row's index
   * @param {boolean} lastPage - append grandTotals
   * @returns {Promise<{rowsTreeService, columnsTreeService, cornerTreeService, isLastPage}>}
   * - returns private method's call with panel's treeServices
   */
  getIndexedPageData(t, n, r = !1) {
    return Promise.resolve(this.sendPartialPage(t, n, r));
  }
  /**
   * Returns current jaql request object
   *
   * @returns {JaqlRequest} - jaql request object
   */
  getJaql() {
    return this.loadService.getJaql() || {
      metadata: [],
      grandTotals: null
    };
  }
  /**
   * Defines data structure
   *
   * @returns {boolean} - true - single branch tree
   */
  isSingleRowTree() {
    return this.loadService.isSingleRowTree();
  }
  /**
   * Set cell process handlers
   *
   * @param {Array<PluginConfig>} handlers - object with target and handler
   * @returns {void}
   */
  setPluginHandlers(t) {
    this.callPlugins = t;
  }
  /**
   * Set global styles for all cells
   *
   * @param {GlobalStyles} [styles] - object with target and handler
   * @returns {void}
   */
  setGlobalStyles(t) {
    this.globalStyles = t;
  }
  /**
   * Returns current raw jaql request object
   *
   * @returns {JaqlRequest} - composition of required jaql fields
   * @private
   */
  getRawJaql() {
    return this.rawJaql || this.getJaql();
  }
  /**
   * Returns current jaql request metadata array
   *
   * @returns {Array<JaqlPanel>} - jaql request metadata
   * @private
   */
  getMetadata() {
    return this.metadata.length > 0 ? this.metadata : this.getJaql().metadata;
  }
  /**
   * Pre-process initial tree structure
   *
   * @param {Array<TreeNode>} items - items to normalize
   * @param {string} type - items types to normalize
   * @param {object} options - additional options
   * @param {number} [options.level=0] - tree level, for internal use only
   * @param {object} [options.measurePath={}] - items types to normalize
   * @returns {Array<PivotTreeNode>} - normalized list of items
   */
  preProcessTree(t, n, r) {
    return xu.preProcessTree(t, n, this.getJaql(), r);
  }
  /**
   * Post-process final tree structure with formatting event
   *
   * @param {PivotTreeNode} items - list of PivotTreeNode items
   * @param {object} [options] - additional options
   * @param {boolean} [options.skipFormatEvent] - process tree but skip format event trigger
   * @param {boolean} [options.onlyFormatEvents] - process tree with format event trigger only
   * @param {Function} [options.iterateFn] - iterate function to call for each tree node
   * @returns {void}
   */
  postProcessTree(t, n) {
    const r = (i, a, s) => this.emit(W2, i, a, s, this.options), o = $e(pe({}, n || {}), { emitFn: r });
    return xu.postProcessTree(t, this.getRawJaql(), o);
  }
  /**
   * Post-process data list with formatting event
   *
   * @param {PivotTreeNode} items - list of PivotTreeNode rows items
   * @param {object} [options] - additional options
   * @param {boolean} [options.skipFormatEvent] - process data list but skip format event trigger
   * @param {boolean} [options.onlyFormatEvents] - process data list with format event
   * trigger only
   * @returns {void}
   */
  // eslint-disable-next-line sonarjs/cognitive-complexity
  postProcessData(t, n) {
    const { skipFormatEvent: r = !1, onlyFormatEvents: o = !1 } = n || {}, i = this.columnsTreeService ? this.columnsTreeService.getLastLevelNodes() : [], a = Re.getLastLevelNodes(t), s = this.getRawJaql();
    r || a.forEach((c) => {
      const l = hr(c);
      i.forEach((d) => {
        const f = hr(d), p = kn.getMetadataPanelByIndex(
          s,
          f.measureJaqlIndex,
          Ke.MEASURES
        );
        if (typeof l.data != "undefined" && typeof f.index != "undefined") {
          const { data: m = [] } = l, { index: v } = f, g = m[v], b = typeof g == "object" && g !== null && g !== void 0 ? g : { value: g };
          if (m[v] = b, o || !r) {
            const { skipInternalColorFormatting: x = !1 } = this.options;
            x || xu.applyColorFormatting(b, l, f, p), this.emit(
              wW,
              b,
              l,
              f,
              p,
              s,
              this.options
            );
          }
        }
      });
    });
  }
  /**
   * Modify tree structure for subtotals and grand totals and some customization
   *
   * @param {Array<PivotTreeNode>} items - base items to modify
   * @param {string} type - items types to normalize
   * @param {TreeNode} originalData - initial data object
   * @returns {PivotTreeNode | Array<PivotTreeNode>} - normalized list of items
   */
  modifyTree(t, n, r) {
    const o = this.getJaql();
    return xu.modifyTree(t, n, o, {
      originalData: r,
      applyIndexDivergence: this.applyIndexDivergence.bind(this),
      subtotalsForSingleRow: this.options.subtotalsForSingleRow
    });
  }
  /**
   * method calculates divergence by prev indexes
   *
   * @param {Array<PivotTreeNode>} items - data to modify divergence and apply
   * @returns {void}
   * @private
   */
  applyIndexDivergence(t) {
    this.divergenceComparator = new $2(t, this.divergenceComparator);
  }
  /**
   * method creates plugin service instance for pivot
   *
   * @param {JaqlRequest} jaql - data to modify divergence and apply
   * @returns {void}
   * @private
   */
  initPluginService(t) {
    this.pluginService = new this.options.PluginService(this.callPlugins, t, this.globalStyles);
  }
  /**
   * Cancel current loading process
   *
   * @returns {void}
   */
  cancelLoading() {
    const t = new Jl();
    this.loadPromiseReject && typeof this.loadPromiseReject == "function" && this.loadPromiseReject(t), this.loadAllPromiseReject && typeof this.loadAllPromiseReject == "function" && this.loadAllPromiseReject(t), this.detachEvent();
  }
  /**
   * Returns final page size, excluding grand totals rows for example
   *
   * @returns {number} - page size
   * @private
   */
  getPageSize() {
    return this.pageSize;
  }
  /**
   *
   * Send result for "loadData" function after promise resolve
   *
   * @param {number} loadedCount - count of already loaded rows
   * @returns {{
   *     rowsTreeService: TreeServiceI,
   *     columnsTreeService: TreeServiceI,
   *     corner: TreeNode,
   *     values: TreeNode,
   *     cellsMetadata: Map<string, Metadata>
   * }} - object with initial data
   * @private
   */
  sendInitPage(t) {
    if (this.loadService.hasError() || !this.loadService.hasData())
      return zr.getEmptyPage();
    let n, r;
    const o = this.getPageSize();
    if (this.rowsTreeService) {
      const a = o > t ? t : o, s = zr.cloneTreeNode, c = this.rowsTreeService.getPartialTree(0, a, { cloneFn: s });
      this.rowsGrand && c.push(Br(this.rowsGrand)), this.postProcessTree(c, {
        onlyFormatEvents: !0,
        iterateFn: Re.clearNodeCache
      }), this.postProcessData(c, { onlyFormatEvents: !0 });
      const l = this.rowsTreeService ? this.rowsTreeService.getTreeDeepsLength() : 0, d = Re.wrapInRootNode(c);
      this.pluginService && d && d.children && (this.pluginService.applyToRows(d.children), r = this.pluginService.metadataCache), n = new Ms(d, !0, l), n.hasGrandTotals = !!this.rowsGrand;
    }
    const i = this.isWholeDataLoaded && o >= t;
    return {
      rowsTreeService: n,
      columnsTreeService: this.columnsTreeService,
      cornerTreeService: this.cornerTreeService,
      isLastPage: i,
      cellsMetadata: r
    };
  }
  /**
   * Sets Page Size and returns Tree Services
   *
   * @param {number} selected - page number -- STARTING FROM 0
   * @param {number} [newPageSize] - set new pageSize
   * @returns {{
   *     rowsTreeService: null,
   *     columnsTreeService: TreeServiceI,
   *     cornerTreeService: TreeServiceI,
   *     isLastPage: boolean
   * }} - returns panel's treeServices
   * @private
   */
  // eslint-disable-next-line sonarjs/cognitive-complexity
  sendPaginatedPage(t, n) {
    if (this.loadService.hasError() || !this.loadService.hasData())
      return zr.getEmptyPage();
    n && (this.pageSize = n);
    const r = this.getPageSize(), o = this.getLoadedElementsCount();
    if (t * r >= o)
      throw new Error("Selected page is out of elements range!");
    if (t < 0)
      throw new Error("Selected page must be >= 0");
    let i, a;
    if (this.rowsTreeService) {
      const s = t >= 0 ? t * r : 0, c = (t + 1) * r > o ? o : (t + 1) * r, l = zr.cloneTreeNode, d = this.rowsTreeService.getPartialTree(s, c, { cloneFn: l });
      this.rowsGrand && d.push(Br(this.rowsGrand)), this.postProcessTree(d, {
        onlyFormatEvents: !0,
        iterateFn: Re.clearNodeCache
      }), this.postProcessData(d, { onlyFormatEvents: !0 });
      const f = this.rowsTreeService ? this.rowsTreeService.getTreeDeepsLength() : 0, p = Re.wrapInRootNode(d);
      this.pluginService && p && p.children && (this.pluginService.applyToRows(p.children), a = this.pluginService.metadataCache), i = new Ms(p, !0, f), i.hasGrandTotals = !!this.rowsGrand;
    }
    return {
      rowsTreeService: i,
      columnsTreeService: this.columnsTreeService,
      cornerTreeService: this.cornerTreeService,
      isLastPage: !0,
      cellsMetadata: a
    };
  }
  /**
   * Returns partial tree by indexes
   *
   * @param {number} paramFrom - start index
   * @param {number} paramTo - stop index
   * @param {boolean} lastPage - append grandTotals
   * @returns {{
   *     rowsTreeService: TreeServiceI,
   *     columnsTreeService: TreeServiceI,
   *     cornerTreeService: TreeServiceI,
   *     isLastPage: boolean
   * }} - returns panel's treeServices
   * @private
   */
  sendPartialPage(t, n, r) {
    if (this.loadService.hasError() || !this.loadService.hasData())
      return zr.getEmptyPage();
    const o = this.getLoadedElementsCount();
    let [i, a] = [Math.min(t, n), Math.max(t, n)];
    i = i >= 0 ? i : 0, a = a >= 0 ? a : 0, a = a < o ? a : o;
    let s, c;
    if (i > o)
      s = void 0;
    else {
      let l;
      if (this.rowsTreeService) {
        const p = zr.cloneTreeNode;
        l = this.rowsTreeService.getPartialTree(i, a, { cloneFn: p }), r && this.rowsGrand && l.push(Br(this.rowsGrand)), this.postProcessTree(l, {
          onlyFormatEvents: !0,
          iterateFn: Re.clearNodeCache
        }), this.postProcessData(l, { onlyFormatEvents: !0 });
      }
      const d = this.rowsTreeService ? this.rowsTreeService.getTreeDeepsLength() : 0, f = Re.wrapInRootNode(l);
      this.pluginService && f && f.children && (this.pluginService.applyToRows(f.children), c = this.pluginService.metadataCache), s = new Ms(f, !0, d), s.hasGrandTotals = !!(r && this.rowsGrand);
    }
    return {
      rowsTreeService: s,
      columnsTreeService: this.columnsTreeService,
      cornerTreeService: this.cornerTreeService,
      isLastPage: !0,
      cellsMetadata: c
    };
  }
  /**
   *
   * Get current state of tree (not recommended to use before 'loadData')
   *
   * @returns {number} loadedCount - current loaded count of children
   * @private
   */
  getLoadedElementsCount() {
    return this.rowsTreeService ? this.rowsTreeService.getTreeChildLength() : 0;
  }
  /**
   * Returns total amount items count handled on back-end side
   *
   * @deprecated
   * @returns {number} - items count
   * @private
   */
  getTotalItemsCount() {
    return this.loadService.getTotalItemsCount();
  }
  /**
   * Getter for pivot table loaded columns number
   *
   * @deprecated
   * @returns {number} loadedCount - current loaded pivot table columns count
   * @private
   */
  getLoadedColumnsCount() {
    return this.columnsTreeService ? this.columnsTreeService.getTreeChildLength() : 0;
  }
  /**
   * Attach events to load service
   * This is a key function implementing the Observer pattern
   * DataService acts as Observer and subscribes its handlers to various
   * data loading events emitted by the load service.
   *
   *
   * @returns {void}
   * @private
   */
  attachEvent() {
    this.loadService.listenerCount(nt.HEADERS) && this.loadService.offAll(nt.HEADERS), this.loadService.on(nt.HEADERS, this.onHeadersHandler), this.loadService.on(nt.METADATA, this.onMetadataHandler), this.loadService.on(nt.DATA, this.onDataHandler), this.loadService.on(nt.GRAND, this.onGrandHandler), this.loadService.on(nt.DATA_FINISH, this.onDataFinishHandler), this.loadService.on(nt.TOTAL_ROWS, this.onTotalRowsHandler), this.loadService.on(nt.DATABARS, this.onDataBarsHandler), this.loadService.on(nt.RANGE_MIN_MAX, this.onRangeMinMaxHandler), this.loadService.on(nt.FINISH, this.onFinishHandler), this.loadService.on(nt.ERROR, this.onErrorHandler);
  }
  /**
   * Dettach events from load service
   *
   * @returns {void}
   * @private
   */
  detachEvent() {
    this.loadService.off(nt.HEADERS, this.onHeadersHandler), this.loadService.off(nt.METADATA, this.onMetadataHandler), this.loadService.off(nt.DATA, this.onDataHandler), this.loadService.off(nt.GRAND, this.onGrandHandler), this.loadService.off(nt.DATA_FINISH, this.onDataFinishHandler), this.loadService.off(nt.TOTAL_ROWS, this.onTotalRowsHandler), this.loadService.off(nt.DATABARS, this.onDataBarsHandler), this.loadService.off(nt.RANGE_MIN_MAX, this.onRangeMinMaxHandler), this.loadService.off(nt.FINISH, this.onFinishHandler), this.loadService.off(nt.ERROR, this.onErrorHandler);
  }
  /**
   * Check for enough data loaded and resolve promise of "loadData" function
   *
   * @returns {void}
   * @private
   */
  checkLoadPromise() {
    if (!this.isLoadInProgress)
      return;
    const t = this.getLoadedElementsCount();
    (t >= this.getPageSize() || this.isWholeDataLoaded) && (this.isLoadInProgress = !1, typeof this.loadPromiseResolve == "function" && (this.loadPromiseResolve(t), this.clearLoadPromise()));
  }
  /**
   * @returns {void}
   * @private
   */
  clearLoadAllPromise() {
    this.loadAllPromise = void 0, this.loadAllPromiseReject = void 0, this.loadAllPromiseResolve = void 0;
  }
  /**
   * @returns {void}
   * @private
   */
  clearLoadPromise() {
    this.loadPromiseReject = void 0, this.loadPromiseResolve = void 0;
  }
  /**
   * Mark finish request
   *
   * @returns {void}
   * @private
   */
  finishRequest() {
    this.logger.log("finishRequest"), this.hasDataFinishEvent = !0, !this.isDataHandlerThrottled && (this.isWholeDataLoaded = !0, this.loadAllPromiseResolve && typeof this.loadAllPromiseResolve == "function" && (this.loadAllPromiseResolve(), this.clearLoadAllPromise()));
  }
  /**
   * Clear internal cache in case new JAQL request send
   *
   * @returns {void}
   * @private
   */
  clearCache() {
    this.rowsGrand = void 0, this.rowsTreeService = void 0, this.columnsTreeService = void 0, this.loadedPagesCount = 0, this.hasDataFinishEvent = !1, this.isWholeDataLoaded = !1, this.isLoadInProgress = !1, this.tempDataChunks = [], this.lastNotHandledChunkIndex = 0, this.lastReadyNotHandledChunkIndex = 0, this.isDataHandlerThrottled = !1;
  }
  static getEmptyPage() {
    return {
      isLastPage: !0
    };
  }
  static fillDataChunks(t, n, r = V2, o = V2) {
    const i = t.length < 2 ? r : o;
    let a = t[Math.max(0, t.length - 1)], s, c = !a;
    if (!n || typeof n.children == "undefined" && typeof n.value == "undefined" && n.data && !n.data.length) {
      a && (a.ready = !0);
      return;
    }
    if (a) {
      const l = Math.max(0, a.list.length - 1);
      s = a.list[l];
      const d = a.size ? `${a.size}` : "0", f = parseInt(d, 10) + (n.size || 1);
      (a.handled || f > i && !(s.isPart && s.value === n.value)) && (c = !0);
    }
    n && n.isPart && s && (!s.isPart || s.value !== n.value) && (c = !0, s.value !== n.value && (s = void 0)), c && (a && (a.ready = !0), a = {
      list: [],
      size: 0,
      ready: !1,
      handled: !1
    }, t.push(a)), a && (s && s.isPart && n && n.isPart ? (Re.deepMerge(s, n), a.size += n.size || 1) : (a.list.push(n), a.size += n.size || 1));
  }
  static cloneTreeNode(t, n) {
    const r = t, {
      children: o,
      isMapped: i,
      minLevel: a,
      childCount: s,
      childDeep: c,
      parent: l,
      master: d,
      data: f,
      state: p,
      style: m,
      store: v
    } = r, g = Wn(r, [
      "children",
      "isMapped",
      // eslint-disable-line no-unused-vars
      "minLevel",
      // eslint-disable-line no-unused-vars
      "childCount",
      // eslint-disable-line no-unused-vars
      "childDeep",
      // eslint-disable-line no-unused-vars
      // @ts-ignore
      "parent",
      // @ts-ignore
      "master",
      // @ts-ignore
      "data",
      // @ts-ignore
      "state",
      // @ts-ignore
      "style",
      // @ts-ignore
      "store"
    ]), b = Br(g);
    return l && (b.parent = l), d && (b.master = d), f && (b.data = Br(f)), p && (b.state = Br(p)), m && (b.style = Br(m)), v && (b.store = Br(v)), !n && o && (b.children = o.map((x) => {
      const T = zr.cloneTreeNode(x);
      return T.parent = b, T;
    })), b;
  }
  /**
   * @typedef {Function} buildColumnsTreeService
   * @param {HeaderTreeNode} originalColumnsTree
   * @returns {BuildColumnsTreeServiceResult}
   */
  /**
   * @typedef {object} BuildColumnsTreeServiceResult
   * @property {TreeNode|undefined} columnsTree
   * @property {TreeService|undefined} columnsTreeService
   * @property {number} columnsCount
   * @property {number} totalColumnsCount
   */
  /**
   * Creates builder function for building columns tree service
   *
   * @param {object} handlers - build handlers
   * @param {Function} handlers.getJaql - jaql getter
   * @param {Function} [handlers.getRawJaql] - raw jaql getter
   * @param {PluginService} [handlers.pluginService] - plugin service
   * @param {Function} [handlers.applyIndexDivergence] - helper for calculation indexes divergence
   * @param {object} [events] - build event emitters
   * @param {Function} events.emitHeaderCellFormatEvent - emits EVENT_HEADER_CELL_FORMAT event
   * @returns {buildColumnsTreeService} - build function
   */
  static createColumnsTreeServiceBuilder(t, n) {
    return (r) => {
      const o = t.getJaql(), i = t.getRawJaql ? t.getRawJaql() : Iv(o, o.metadata || []), a = kn.getMetadataTree(o, Ke.MEASURES), s = Re.getChildren(a), { preProcessTree: c, modifyTree: l, postProcessTree: d } = xu;
      let f, p, m = 0, v = 0;
      if (Re.hasChildren(r)) {
        r.columnsCount && r.totalColumnsCount && (m = r.columnsCount, v = r.totalColumnsCount);
        const g = c(r, Ke.COLUMNS, o), b = l(g, Ke.COLUMNS, o, {
          originalData: r,
          applyIndexDivergence: t.applyIndexDivergence
        });
        d(b, i, {
          emitFn: n && n.emitHeaderCellFormatEvent
        });
        const x = Re.wrapInRootNode(b);
        t.pluginService && x && x.children && t.pluginService.applyToColumns(x.children), f = x, p = new Ms(x), s.length === 1 && p.setValueNode(s[0]);
      } else
        Re.hasChildren(a) ? (r.columnsCount && r.totalColumnsCount && (m = r.columnsCount, v = r.totalColumnsCount), typeof r.maxChilds == "number" && (m = r.maxChilds, a.children = Re.getChildren(a).filter((g, b) => b < r.maxChilds)), t.pluginService && a.children && t.pluginService.applyToColumns(a.children), d(Re.getChildren(a), i, {
          emitFn: n && n.emitHeaderCellFormatEvent
        }), f = a, p = new Ms(a)) : (t.pluginService && t.pluginService.resetRowStartFrom(), f = void 0, p = void 0, m = 0, v = 0);
      return {
        columnsTree: f,
        columnsTreeService: p,
        columnsCount: m,
        totalColumnsCount: v
      };
    };
  }
  /**
   * @typedef {Function} buildCornerTreeService
   * @param {HeaderTreeNode} originalColumnsTree
   * @returns {BuildCornerTreeServiceResult}
   */
  /**
   * @typedef {object} BuildCornerTreeServiceResult
   * @property {TreeNode|undefined} columnsTree
   * @property {TreeService|undefined} columnsTreeService
   * @property {number} columnsCount
   * @property {number} totalColumnsCount
   */
  /**
   * Creates builder function for building corners tree service
   *
   * @param {object} handlers - build handlers
   * @param {Function} handlers.getJaql - jaql getter
   * @param {Function} [handlers.getRawJaql] - raw jaql getter
   * @param {PluginService} [handlers.pluginService] - plugin service
   * @param {TreeServiceI} [handlers.columnsTreeService] - column tree service
   * @param {object} [events] - build event emitters
   * @param {Function} events.emitHeaderCellFormatEvent - emits EVENT_HEADER_CELL_FORMAT event
   * @returns {buildCornerTreeService} - build function
   */
  static createCornerTreeServiceBuilder(t, n) {
    return () => {
      const r = t.getJaql(), o = t.getRawJaql ? t.getRawJaql() : Iv(r, r.metadata || []), i = kn.getMetadataTree(r, Ke.ROWS);
      let a;
      if (Re.hasChildren(i)) {
        Re.iterateThroughTree(Re.getChildren(i), (c) => {
          c.userType = qt.CORNER;
          const l = kn.getMetadataPanelByIndex(
            o,
            c.jaqlIndex,
            c.metadataType || ""
          );
          n && n.emitHeaderCellFormatEvent && n.emitHeaderCellFormatEvent(c, l, o);
        });
        let s;
        t.columnsTreeService && (s = t.columnsTreeService.getTreeDeepsLength()), t.pluginService && t.pluginService.applyToHeaders(i), a = new Ms(i, !1, s);
      }
      return { cornerTree: i, cornerTreeService: a };
    };
  }
}
var qb = {}, SW = {
  get exports() {
    return qb;
  },
  set exports(e) {
    qb = e;
  }
};
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var U2;
function TW() {
  return U2 || (U2 = 1, function(e) {
    (function() {
      var t = {}.hasOwnProperty;
      function n() {
        for (var r = [], o = 0; o < arguments.length; o++) {
          var i = arguments[o];
          if (i) {
            var a = typeof i;
            if (a === "string" || a === "number")
              r.push(i);
            else if (Array.isArray(i)) {
              if (i.length) {
                var s = n.apply(null, i);
                s && r.push(s);
              }
            } else if (a === "object") {
              if (i.toString !== Object.prototype.toString && !i.toString.toString().includes("[native code]")) {
                r.push(i.toString());
                continue;
              }
              for (var c in i)
                t.call(i, c) && i[c] && r.push(c);
            }
          }
        }
        return r.join(" ");
      }
      e.exports ? (n.default = n, e.exports = n) : window.classNames = n;
    })();
  }(SW)), qb;
}
var EW = TW();
const Xe = /* @__PURE__ */ ji(EW);
var kW = function() {
  return Wi.Date.now();
};
const Lv = kW;
var MW = /\s/;
function RW(e) {
  for (var t = e.length; t-- && MW.test(e.charAt(t)); )
    ;
  return t;
}
var PW = /^\s+/;
function OW(e) {
  return e && e.slice(0, RW(e) + 1).replace(PW, "");
}
var NW = "[object Symbol]";
function AW(e) {
  return typeof e == "symbol" || bc(e) && Vc(e) == NW;
}
var q2 = NaN, DW = /^[-+]0x[0-9a-f]+$/i, IW = /^0b[01]+$/i, LW = /^0o[0-7]+$/i, $W = parseInt;
function G2(e) {
  if (typeof e == "number")
    return e;
  if (AW(e))
    return q2;
  if (Rd(e)) {
    var t = typeof e.valueOf == "function" ? e.valueOf() : e;
    e = Rd(t) ? t + "" : t;
  }
  if (typeof e != "string")
    return e === 0 ? e : +e;
  e = OW(e);
  var n = IW.test(e);
  return n || LW.test(e) ? $W(e.slice(2), n ? 2 : 8) : DW.test(e) ? q2 : +e;
}
var FW = "Expected a function", zW = Math.max, BW = Math.min;
function HW(e, t, n) {
  var r, o, i, a, s, c, l = 0, d = !1, f = !1, p = !0;
  if (typeof e != "function")
    throw new TypeError(FW);
  t = G2(t) || 0, Rd(n) && (d = !!n.leading, f = "maxWait" in n, i = f ? zW(G2(n.maxWait) || 0, t) : i, p = "trailing" in n ? !!n.trailing : p);
  function m(k) {
    var E = r, R = o;
    return r = o = void 0, l = k, a = e.apply(R, E), a;
  }
  function v(k) {
    return l = k, s = setTimeout(x, t), d ? m(k) : a;
  }
  function g(k) {
    var E = k - c, R = k - l, P = t - E;
    return f ? BW(P, i - R) : P;
  }
  function b(k) {
    var E = k - c, R = k - l;
    return c === void 0 || E >= t || E < 0 || f && R >= i;
  }
  function x() {
    var k = Lv();
    if (b(k))
      return T(k);
    s = setTimeout(x, g(k));
  }
  function T(k) {
    return s = void 0, p && r ? m(k) : (r = o = void 0, a);
  }
  function S() {
    s !== void 0 && clearTimeout(s), l = 0, r = c = o = s = void 0;
  }
  function _() {
    return s === void 0 ? a : T(Lv());
  }
  function w() {
    var k = Lv(), E = b(k);
    if (r = arguments, o = this, c = k, E) {
      if (s === void 0)
        return v(c);
      if (f)
        return clearTimeout(s), s = setTimeout(x, t), m(c);
    }
    return s === void 0 && (s = setTimeout(x, t)), a;
  }
  return w.cancel = S, w.flush = _, w;
}
const Yu = "getSize", Gb = "change", Zu = "dataBars", Xu = "rangeMinMax";
class jW {
  constructor(t, n) {
    Z(this, "events"), Z(this, "colsWidth", {}), Z(this, "rowsHeight", {}), Z(this, "initialFixedWidth", {}), Z(this, "dataBarsCols", []), Z(this, "dataBarsColsCache"), Z(this, "dataBarsMinMax"), Z(this, "rangeMinMax"), Z(this, "notifyChangeTimer", 0), Z(this, "notifySizeChangeTimer", 0), Z(this, "notifyDataBarsChangeTimer", 0), Z(this, "notifyRangeMinMaxChangeTimer", 0), Z(this, "logger"), Z(this, "columnWidth", ({ index: r }) => this.initialFixedWidth[r] !== void 0 ? this.initialFixedWidth[r] : this.colsWidth[r] || Number.NaN), Z(this, "rowHeight", ({ index: r }) => this.rowsHeight[r] || Number.NaN), this.events = new uf(), this.events.setMaxListeners(1 / 0), this.logger = ds.create("TableSize"), this.dataBarsMinMax = t, this.rangeMinMax = n;
  }
  updateDataBars(t, n, r) {
    this.dataBarsCols[t] = this.dataBarsCols[t] || [];
    const o = this.dataBarsCols[t];
    o[n] = r, this.dataBarsMinMax && this.notifyDataBarsChange();
  }
  updateDataBarsMinMax(t) {
    this.dataBarsMinMax = t, this.notifyDataBarsChange();
  }
  updateRangeMinMax(t) {
    this.rangeMinMax = t, this.notifyRangeMinMaxChange();
  }
  updateWidth(t, n) {
    this.logger.log("updateWidth", t, n), this.colsWidth[t] = n, this.notifySizesChange();
  }
  updateHeight(t, n) {
    this.logger.log("updateHeight", t, n), this.rowsHeight[t] = n, this.notifySizesChange();
  }
  notifyChange() {
    this.notifyChangeTimer && (clearTimeout(this.notifyChangeTimer), this.notifyChangeTimer = 0), this.notifyChangeTimer = window.setTimeout(() => {
      this.notifyChangeTimer = 0, this.events.emit(Yu);
    });
  }
  setFixedWidth(t, n) {
    this.logger.log("setFixedWidth", t, n), this.initialFixedWidth[t] = n, this.notifySizesChange();
  }
  /**
   * Set initial width to columns
   *
   * @param  {Array} predefinedColumnWidth - array with predefine with data for column
   * @returns {void}
   */
  setInitialFixedWidth(t) {
    this.logger.log("setInitialFixedWidth", t), Array.isArray(t) && t.forEach((n) => {
      const [r, o] = n;
      this.initialFixedWidth[r] = o;
    });
  }
  /**
   * Check for initial column width
   *
   * @param  {number} columnIndex - column index
   * @returns {boolean} - true - has initial width
   */
  hasInitialFixedWidth(t) {
    return typeof this.initialFixedWidth[t] != "undefined";
  }
  hasPendingChanges() {
    return !!(this.notifyChangeTimer || this.notifySizeChangeTimer);
  }
  fitWidths(t) {
    const n = [];
    Object.keys(this.colsWidth).forEach((i) => {
      const a = parseInt(i, 10);
      n.push([a, this.columnWidth({ index: a })]);
    });
    const r = n.reduce((i, [, a = 0] = []) => i + a, 0), o = n.map(([i, a]) => {
      const s = Math.floor(t * a / r);
      return [i, s];
    });
    this.setInitialFixedWidth(o), this.notifySizesChange();
  }
  /**
   * @returns {void}
   * @private
   */
  notifySizesChange() {
    this.notifySizeChangeTimer && (clearTimeout(this.notifySizeChangeTimer), this.notifySizeChangeTimer = 0), this.notifySizeChangeTimer = window.setTimeout(() => {
      this.notifySizeChangeTimer = 0;
      const t = {};
      Object.keys(this.colsWidth).forEach((n) => {
        const r = parseInt(n, 10);
        let o = this.colsWidth[r];
        const i = this.initialFixedWidth[r];
        typeof i == "number" && (o = i), t[r] = o;
      }), this.colsWidth = t, this.events.emit(Gb, this.colsWidth, this.rowsHeight);
    });
  }
  notifyDataBarsChange() {
    this.notifyDataBarsChangeTimer && (clearTimeout(this.notifyDataBarsChangeTimer), this.notifyDataBarsChangeTimer = 0), this.notifyDataBarsChangeTimer = window.setTimeout(() => {
      this.notifyDataBarsChangeTimer = 0, this.dataBarsColsCache = this.dataBarsCols.map(
        (t) => t.reduce((n, r) => n > r ? n : r, 0)
      ), this.events.emit(Zu, {
        colsWidth: this.dataBarsColsCache,
        minMaxs: this.dataBarsMinMax
      });
    });
  }
  notifyRangeMinMaxChange() {
    this.notifyRangeMinMaxChangeTimer && (clearTimeout(this.notifyRangeMinMaxChangeTimer), this.notifyRangeMinMaxChangeTimer = 0), this.notifyRangeMinMaxChangeTimer = window.setTimeout(() => {
      this.notifyRangeMinMaxChangeTimer = 0, this.events.emit(Xu, {
        // eslint-disable-next-line max-lines
        rangeMinMax: this.rangeMinMax
      });
    });
  }
  getDataBars() {
    if (!(!this.dataBarsMinMax || !this.dataBarsColsCache))
      return {
        colsWidth: this.dataBarsColsCache,
        minMaxs: this.dataBarsMinMax
      };
  }
  getRangeMinMax() {
    if (this.rangeMinMax)
      return {
        rangeMinMax: this.rangeMinMax
      };
  }
  on(t, n) {
    this.events.on(t, n);
  }
  off(t, n) {
    this.events.off(t, n);
  }
}
const Vp = class extends B.PureComponent {
  constructor(e) {
    super(e), Z(this, "height", 0), Z(this, "width", 0), Z(this, "content"), Z(this, "tdElement"), Z(this, "cellStyle"), Z(this, "contentStyle"), Z(this, "contentRef", (t) => {
      t && (this.content = t);
    }), Z(this, "tdRef", (t) => {
      t && (this.tdElement = t);
    }), Z(this, "onGetSize", () => {
      const { type: t, rowIndex: n, colIndex: r } = this.props, o = this.tdElement;
      if (!o)
        return;
      let i, a;
      if (t === Vp.type.COL) {
        if (!this.content)
          return;
        i = o.getBoundingClientRect().width, this.props.tableSize.updateWidth(r, i);
      } else
        a = o.getBoundingClientRect().height, this.props.tableSize.updateHeight(n, a);
    }), this.contentStyle = {}, this.cellStyle = {};
  }
  componentDidMount() {
    this.props.tableSize.on(Yu, this.onGetSize);
  }
  UNSAFE_componentWillReceiveProps(e) {
    e.tableSize !== this.props.tableSize && (this.props.tableSize.off(Yu, this.onGetSize), e.tableSize.on(Yu, this.onGetSize)), e.width !== this.props.width && (this.contentStyle = {}, this.props.type === Vp.type.COL && (this.contentStyle.height = 0)), e.height !== this.props.height && (this.cellStyle = {});
  }
  componentWillUnmount() {
    this.props.tableSize.off(Yu, this.onGetSize);
  }
  getIndex() {
    return this.props.type === Vp.type.COL ? this.props.colIndex : this.props.rowIndex;
  }
  render() {
    const { type: e } = this.props, t = this.getIndex(), n = `table-grid__cell-anchor
            table-grid__cell-anchor--${e}
            table-grid__cell-anchor--${e}-${t}
        `.trim();
    return /* @__PURE__ */ z("td", { className: n, style: this.cellStyle, ref: this.tdRef, children: /* @__PURE__ */ z(
      "div",
      {
        ref: this.contentRef,
        className: "table-grid__cell-anchor-content",
        style: this.contentStyle
      }
    ) }, `${e}-${t}`);
  }
};
let Ku = Vp;
Z(Ku, "type", {
  ROW: "row",
  COL: "col"
});
const WW = "multi-grid", VW = "multi-grid--new", Y2 = "multi-grid--no-rows", UW = "multi-grid--no-columns", Z2 = "multi-grid--no-corner", qW = "multi-grid--no-fixed-left", ep = "table-grid", GW = "table-grid--data", YW = "table-grid--rows", ZW = "table-grid--columns", XW = "table-grid--corner", X2 = "table-grid--top", K2 = "table-grid--right", J2 = "table-grid--bottom", Q2 = "table-grid--left", $v = "table-grid--fixed", KW = "table-grid__table table-grid--table-native", JW = "table-grid__colgroup", eS = "table-grid__column", QW = "table-grid__tbody", Fv = "table-grid__row", $r = "table-grid__cell", e7 = "table-grid__cell--selected", t7 = "table-grid__cell--drilled", n7 = "table-grid__cell--sorted", r7 = "table-grid__cell--sorted-inactive", o7 = "table-grid__cell--sorted--asc", i7 = "table-grid__cell--sorted--desc", a7 = "table-grid__cell--default-sorted--asc", s7 = "table-grid__cell--default-sorted--desc", l7 = "table-grid__cell--fixed-width", c7 = "table-grid__cell-corner", u7 = "table-grid__content", d7 = "table-grid__content__wrapper", tp = "table-grid__content__inner", f7 = "table-grid__sorting-settings-icon", p7 = "table-grid__cell--sort-icon-persistent";
class Ju extends B.PureComponent {
  constructor() {
    super(...arguments), Z(this, "tableStyles");
  }
  UNSAFE_componentWillReceiveProps(t) {
    t.borderColor !== this.props.borderColor && (this.tableStyles = void 0);
  }
  componentDidUpdate() {
    this.props.onGridUpdated && this.props.onGridUpdated();
  }
  getTableStyles() {
    return this.tableStyles === void 0 && (this.props.borderColor ? this.tableStyles = {
      borderColor: this.props.borderColor
    } : this.tableStyles = null), this.tableStyles;
  }
  // eslint-disable-next-line class-methods-use-this
  getColumns(t = 10) {
    return Array.from(Array(t + 1)).map((n, r) => /* @__PURE__ */ z("col", { className: `${eS} ${eS}-${r}` }, `col-${r}`));
  }
  getRows(t = 10, n = 10, r, o) {
    const { clone: i, borderWidth: a } = this.props;
    return /* @__PURE__ */ _e(fo, { children: [
      Array.from(Array(t)).map((s, c) => {
        const l = o[c];
        return this.getRow(n, c, l, r);
      }),
      i ? null : /* @__PURE__ */ z("tr", { className: Fv, style: { height: 0 }, children: Array.from(Array(n + 1)).map((s, c) => {
        const l = r[c];
        return /* @__PURE__ */ z(
          Ku,
          {
            type: Ku.type.COL,
            colIndex: c,
            tableSize: this.props.tableSize,
            width: l,
            borderWidth: a
          },
          `anchor-${c}`
        );
      }) }, "anchor")
    ] });
  }
  getRow(t = 10, n = 0, r, o) {
    const { clone: i, borderWidth: a } = this.props, s = i && typeof r == "number" ? r : "auto";
    return /* @__PURE__ */ _e("tr", { className: `${Fv} ${Fv}-${n}`, style: { height: s }, children: [
      Array.from(Array(t)).map((c, l) => {
        const d = o[l];
        return this.getCell({
          rowHeight: r,
          colWidth: d,
          rowIndex: n,
          colIndex: l
        });
      }),
      i ? null : /* @__PURE__ */ z(
        Ku,
        {
          type: Ku.type.ROW,
          rowIndex: n,
          tableSize: this.props.tableSize,
          height: r,
          borderWidth: a
        }
      )
    ] }, n);
  }
  getCell(t) {
    const { rowIndex: n, colIndex: r, rowHeight: o, colWidth: i } = t || {}, { clone: a, type: s, cellRenderer: c, borderWidth: l, isMobile: d } = this.props;
    return c({
      rowIndex: n,
      colIndex: r,
      rowHeight: o,
      colWidth: i,
      borderWidth: l,
      clone: a,
      type: s,
      isMobile: d
    });
  }
  render() {
    const { widths: t, heights: n, colsCount: r, rowsCount: o, className: i } = this.props, a = this.getTableStyles() || void 0;
    return /* @__PURE__ */ _e("table", { className: `${KW} ${i}`, style: a, children: [
      /* @__PURE__ */ z("colgroup", { className: JW, children: this.getColumns(r) }),
      /* @__PURE__ */ z("tbody", { className: QW, children: this.getRows(o, r, t, n) })
    ] });
  }
}
Z(Ju, "defaultProps", {
  clone: !1,
  borderWidth: 1,
  borderColor: ""
});
var Ql = {}, h7 = {
  get exports() {
    return Ql;
  },
  set exports(e) {
    Ql = e;
  }
}, Yb = {}, np = {
  get exports() {
    return Yb;
  },
  set exports(e) {
    Yb = e;
  }
}, tS;
function D3() {
  return tS || (tS = 1, function() {
    var e, t, n, r, o, i;
    typeof performance != "undefined" && performance !== null && performance.now ? np.exports = function() {
      return performance.now();
    } : typeof process != "undefined" && process !== null && process.hrtime ? (np.exports = function() {
      return (e() - o) / 1e6;
    }, t = process.hrtime, e = function() {
      var a;
      return a = t(), a[0] * 1e9 + a[1];
    }, r = e(), i = process.uptime() * 1e9, o = r - i) : Date.now ? (np.exports = function() {
      return Date.now() - n;
    }, n = Date.now()) : (np.exports = function() {
      return (/* @__PURE__ */ new Date()).getTime() - n;
    }, n = (/* @__PURE__ */ new Date()).getTime());
  }.call(O_)), Yb;
}
var nS;
function m7() {
  if (nS)
    return Ql;
  nS = 1;
  for (var e = D3(), t = typeof window == "undefined" ? O_ : window, n = ["moz", "webkit"], r = "AnimationFrame", o = t["request" + r], i = t["cancel" + r] || t["cancelRequest" + r], a = 0; !o && a < n.length; a++)
    o = t[n[a] + "Request" + r], i = t[n[a] + "Cancel" + r] || t[n[a] + "CancelRequest" + r];
  if (!o || !i) {
    var s = 0, c = 0, l = [], d = 1e3 / 60;
    o = function(f) {
      if (l.length === 0) {
        var p = e(), m = Math.max(0, d - (p - s));
        s = m + p, setTimeout(function() {
          var v = l.slice(0);
          l.length = 0;
          for (var g = 0; g < v.length; g++)
            if (!v[g].cancelled)
              try {
                v[g].callback(s);
              } catch (b) {
                setTimeout(function() {
                  throw b;
                }, 0);
              }
        }, Math.round(m));
      }
      return l.push({
        handle: ++c,
        callback: f,
        cancelled: !1
      }), c;
    }, i = function(f) {
      for (var p = 0; p < l.length; p++)
        l[p].handle === f && (l[p].cancelled = !0);
    };
  }
  return h7.exports = function(f) {
    return o.call(t, f);
  }, Ql.cancel = function() {
    i.apply(t, arguments);
  }, Ql.polyfill = function(f) {
    f || (f = t), f.requestAnimationFrame = o, f.cancelAnimationFrame = i;
  }, Ql;
}
var I3 = m7();
const rS = /* @__PURE__ */ ji(I3);
var ec = {}, g7 = {
  get exports() {
    return ec;
  },
  set exports(e) {
    ec = e;
  }
}, zv, oS;
function v7() {
  if (oS)
    return zv;
  oS = 1;
  var e = null, t = ["Webkit", "Moz", "O", "ms"];
  return zv = function(n) {
    e || (e = document.createElement("div"));
    var r = e.style;
    if (n in r)
      return n;
    for (var o = n.charAt(0).toUpperCase() + n.slice(1), i = t.length; i >= 0; i--) {
      var a = t[i] + o;
      if (a in r)
        return a;
    }
    return !1;
  }, zv;
}
var Bv, iS;
function b7() {
  if (iS)
    return Bv;
  iS = 1, Bv = r;
  var e = /\s/, t = /(_|-|\.|:)/, n = /([a-z][A-Z]|[A-Z][a-z])/;
  function r(c) {
    return e.test(c) ? c.toLowerCase() : t.test(c) ? (i(c) || c).toLowerCase() : n.test(c) ? s(c).toLowerCase() : c.toLowerCase();
  }
  var o = /[\W_]+(.|$)/g;
  function i(c) {
    return c.replace(o, function(l, d) {
      return d ? " " + d : "";
    });
  }
  var a = /(.)([A-Z]+)/g;
  function s(c) {
    return c.replace(a, function(l, d, f) {
      return d + " " + f.toLowerCase().split("").join(" ");
    });
  }
  return Bv;
}
var Hv, aS;
function y7() {
  if (aS)
    return Hv;
  aS = 1;
  var e = b7();
  Hv = t;
  function t(n) {
    return e(n).replace(/[\W_]+(.|$)/g, function(r, o) {
      return o ? " " + o : "";
    }).trim();
  }
  return Hv;
}
var jv, sS;
function _7() {
  if (sS)
    return jv;
  sS = 1;
  var e = y7();
  jv = t;
  function t(n) {
    return e(n).replace(/\s(\w)/g, function(r, o) {
      return o.toUpperCase();
    });
  }
  return jv;
}
var Wv, lS;
function w7() {
  if (lS)
    return Wv;
  lS = 1;
  var e = {
    animationIterationCount: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridRow: !0,
    gridColumn: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    // SVG-related properties
    fillOpacity: !0,
    stopOpacity: !0,
    strokeDashoffset: !0,
    strokeOpacity: !0,
    strokeWidth: !0
  };
  return Wv = function(t, n) {
    return typeof n == "number" && !e[t] ? n + "px" : n;
  }, Wv;
}
var cS;
function D_() {
  if (cS)
    return ec;
  cS = 1;
  var e = v7(), t = _7(), n = { float: "cssFloat" }, r = w7();
  function o(c, l, d) {
    var f = n[l];
    if (typeof f == "undefined" && (f = a(l)), f) {
      if (d === void 0)
        return c.style[f];
      c.style[f] = r(f, d);
    }
  }
  function i(c, l) {
    for (var d in l)
      l.hasOwnProperty(d) && o(c, d, l[d]);
  }
  function a(c) {
    var l = t(c), d = e(l);
    return n[l] = n[c] = n[d] = d, d;
  }
  function s() {
    arguments.length === 2 ? typeof arguments[1] == "string" ? arguments[0].style.cssText = arguments[1] : i(arguments[0], arguments[1]) : o(arguments[0], arguments[1], arguments[2]);
  }
  return g7.exports = s, ec.set = s, ec.get = function(c, l) {
    return Array.isArray(l) ? l.reduce(function(d, f) {
      return d[f] = o(c, f || ""), d;
    }, {}) : o(c, l || "");
  }, ec;
}
var x7 = D_();
const oi = /* @__PURE__ */ ji(x7);
function Vv(e) {
  const { clientHeight: t } = e, { paddingTop: n, paddingBottom: r } = getComputedStyle(e);
  return t - parseFloat(n || "") - parseFloat(r || "");
}
function Uv(e) {
  const { clientWidth: t } = e, { paddingLeft: n, paddingRight: r } = getComputedStyle(e);
  return t - parseFloat(n || "") - parseFloat(r || "");
}
let qv = !1;
function C7() {
  if (typeof document != "undefined") {
    const e = document.createElement("div");
    oi(e, {
      width: 100,
      height: 100,
      position: "absolute",
      top: -9999,
      overflow: "scroll",
      MsOverflowStyle: "scrollbar"
    });
    let t = document.querySelector(".pivot-container");
    t || (t = document.body), t.appendChild(e), qv = e.offsetWidth - e.clientWidth, t.removeChild(e);
  } else
    qv = 0;
  return qv || 0;
}
function uS(e) {
  return typeof e == "string";
}
const dS = {
  position: "relative",
  overflow: "hidden",
  width: "100%",
  height: "100%"
}, fS = {
  height: "auto"
}, S7 = {
  position: "absolute",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  overflow: "scroll",
  WebkitOverflowScrolling: "touch"
}, T7 = {
  position: "relative",
  top: void 0,
  left: void 0,
  right: void 0,
  bottom: void 0
}, E7 = {
  position: "absolute",
  height: 6
}, k7 = {
  position: "absolute",
  width: 6
}, M7 = {
  position: "relative",
  display: "block",
  height: "100%"
}, R7 = {
  position: "relative",
  display: "block",
  width: "100%"
}, P7 = {
  userSelect: "none"
}, O7 = {
  userSelect: "auto"
};
function N7(e) {
  const t = e || {}, { style: n, key: r } = t, o = Wn(t, ["style", "key"]), i = $e(pe({}, n), {
    right: 2,
    bottom: 2,
    left: 2,
    borderRadius: 3
  });
  return /* @__PURE__ */ z("div", pe({ style: i }, o), r);
}
function A7(e) {
  const t = e || {}, { style: n, key: r } = t, o = Wn(t, ["style", "key"]), i = $e(pe({}, n), {
    right: 2,
    bottom: 2,
    top: 2,
    borderRadius: 3
  });
  return /* @__PURE__ */ z("div", pe({ style: i }, o), r);
}
function D7(e) {
  const t = e || {}, { style: n, key: r } = t, o = Wn(t, ["style", "key"]), i = $e(pe({}, n), {
    cursor: "pointer",
    borderRadius: "inherit",
    backgroundColor: "rgba(0,0,0,.2)"
  });
  return /* @__PURE__ */ z("div", pe({ style: i }, o), r);
}
function I7(e) {
  const t = e || {}, { style: n, key: r } = t, o = Wn(t, ["style", "key"]), i = $e(pe({}, n), {
    cursor: "pointer",
    borderRadius: "inherit",
    backgroundColor: "rgba(0,0,0,.2)"
  });
  return /* @__PURE__ */ z("div", pe({ style: i }, o), r);
}
class I_ extends B.PureComponent {
  constructor() {
    super(...arguments), Z(this, "view", document.createElement("div")), Z(this, "trackHorizontal", document.createElement("div")), Z(this, "trackVertical", document.createElement("div")), Z(this, "thumbHorizontal", document.createElement("div")), Z(this, "thumbVertical", document.createElement("div")), Z(this, "requestFrame"), Z(this, "prevPageX", 0), Z(this, "prevPageY", 0), Z(this, "dragging", !1), Z(this, "hideTracksTimeout", null), Z(this, "detectScrollingInterval", null), Z(this, "trackMouseOver", !1), Z(this, "viewScrollTop", 0), Z(this, "lastViewScrollTop", 0), Z(this, "viewScrollLeft", 0), Z(this, "lastViewScrollLeft", 0), Z(this, "scrolling", !1), Z(this, "handleScroll", (t) => {
      const { onScroll: n } = this.props;
      n && n(t), this.update((r) => {
        const { scrollLeft: o, scrollTop: i } = r;
        this.viewScrollLeft = o, this.viewScrollTop = i;
      }), this.detectScrolling();
    }), Z(this, "handleWindowResize", () => {
      this.update();
    }), Z(this, "handleDrag", (t) => {
      if (this.prevPageX) {
        const { clientX: n } = t, { left: r } = this.trackHorizontal.getBoundingClientRect(), o = this.getThumbHorizontalWidth() - this.prevPageX, i = -r + n - o;
        this.view.scrollLeft = this.getScrollLeftForOffset(i);
      }
      if (this.prevPageY) {
        const { clientY: n } = t, { top: r } = this.trackVertical.getBoundingClientRect(), o = this.getThumbVerticalHeight() - this.prevPageY, i = -r + n - o;
        this.view.scrollTop = this.getScrollTopForOffset(i);
      }
      return !1;
    }), Z(this, "handleDragEnd", () => {
      this.dragging = !1, this.prevPageY = 0, this.prevPageX = 0, this.teardownDragging(), this.handleDragEndAutoHide();
    }), Z(this, "handleHorizontalTrackMouseDown", (t) => {
      t.preventDefault();
      const { target: n, clientX: r } = t;
      if (n instanceof HTMLElement) {
        const { left: o } = n.getBoundingClientRect(), i = this.getThumbHorizontalWidth(), a = Math.abs(o - r) - i / 2;
        this.view.scrollLeft = this.getScrollLeftForOffset(a);
      }
    }), Z(this, "handleVerticalTrackMouseDown", (t) => {
      t.preventDefault();
      const { target: n, clientY: r } = t;
      if (n instanceof HTMLElement) {
        const { top: o } = n.getBoundingClientRect(), i = this.getThumbVerticalHeight(), a = Math.abs(o - r) - i / 2;
        this.view.scrollTop = this.getScrollTopForOffset(a);
      }
    }), Z(this, "handleHorizontalThumbMouseDown", (t) => {
      t.preventDefault(), this.handleDragStart(t);
      const { target: n, clientX: r } = t;
      if (n instanceof HTMLElement) {
        const { offsetWidth: o } = n, { left: i } = n.getBoundingClientRect();
        this.prevPageX = o - (r - i);
      }
    }), Z(this, "handleVerticalThumbMouseDown", (t) => {
      t.preventDefault(), this.handleDragStart(t);
      const { target: n, clientY: r } = t;
      if (n instanceof HTMLElement) {
        const { offsetHeight: o } = n, { top: i } = n.getBoundingClientRect();
        this.prevPageY = o - (r - i);
      }
    }), Z(this, "handleTrackMouseEnter", () => {
      this.trackMouseOver = !0, this.handleTrackMouseEnterAutoHide();
    }), Z(this, "handleTrackMouseLeave", () => {
      this.trackMouseOver = !1, this.handleTrackMouseLeaveAutoHide();
    }), Z(this, "setTrackVerticalRef", (t) => {
      t && (this.trackVertical = t);
    }), Z(this, "setThumbVerticalRef", (t) => {
      t && (this.thumbVertical = t);
    }), Z(this, "setTrackHorizontalRef", (t) => {
      t && (this.trackHorizontal = t);
    }), Z(this, "setThumbHorizontalRef", (t) => {
      t && (this.thumbHorizontal = t);
    }), Z(this, "setViewRef", (t) => {
      t && (this.view = t);
    });
  }
  componentDidMount() {
    this.addListeners(), this.update();
  }
  componentDidUpdate() {
    this.update();
  }
  componentWillUnmount() {
    this.removeListeners(), I3.cancel(this.requestFrame), this.hideTracksTimeout && clearTimeout(this.hideTracksTimeout), this.detectScrollingInterval && clearInterval(this.detectScrollingInterval);
  }
  /**
   * returns all dimensions
   *
   * @returns {object} - CustomScroll scroll and size params
   * @private
   */
  getMeasurements() {
    const {
      scrollLeft: t = 0,
      scrollTop: n = 0,
      scrollWidth: r = 0,
      scrollHeight: o = 0,
      clientWidth: i = 0,
      clientHeight: a = 0
    } = this.view || {};
    return {
      left: t / (r - i) || 0,
      top: n / (o - a) || 0,
      scrollLeft: t,
      scrollTop: n,
      scrollWidth: r,
      scrollHeight: o,
      clientWidth: i,
      clientHeight: a
    };
  }
  /**
   * calculates horizontal thumb's width
   *
   * @returns {number} - horizontal thumb width
   * @private
   */
  getThumbHorizontalWidth() {
    const { scrollWidth: t, clientWidth: n } = this.view;
    return this.getThumbDimension(t, n, !1);
  }
  /**
   * calculates vertical thumb's height
   *
   * @returns {number} - vertical thumb height
   * @private
   */
  getThumbVerticalHeight() {
    const { scrollHeight: t, clientHeight: n } = this.view;
    return this.getThumbDimension(t, n, !0);
  }
  /**
   * calculates thumb's dimension
   *
   * @param {number} scrollDimension - scroll width | height
   * @param {number} clientDimension - client width | height
   * @param {boolean} isVertical - handle calculations for horizontal or vertical
   * @returns {number} -thumb dimension
   * @private
   */
  getThumbDimension(t, n, r) {
    const { thumbSize: o, thumbMinSize: i } = this.props, a = r ? Vv(this.trackVertical) : Uv(this.trackHorizontal), s = Math.ceil(n / t * a);
    return Math.abs(a - s) <= 2 ? 0 : o || Math.max(s, i);
  }
  /**
   * Calculates scrollLeft by offset arg
   *
   * @param {number} offset - offset to calulate by
   * @returns {number} - scrollLeft by offset
   * @private
   */
  getScrollLeftForOffset(t) {
    const { scrollWidth: n, clientWidth: r } = this.view, o = Uv(this.trackHorizontal), i = this.getThumbHorizontalWidth();
    return t / (o - i) * (n - r);
  }
  /**
   * Calculates scrollTop by offset arg
   *
   * @param {number} offset - offset to calulate by
   * @returns {number} - scrollTop by offset
   * @private
   */
  getScrollTopForOffset(t) {
    const { scrollHeight: n, clientHeight: r } = this.view, o = Vv(this.trackVertical), i = this.getThumbVerticalHeight();
    return t / (o - i) * (n - r);
  }
  /**
   * initial DOM components listeners attach
   *
   * @returns {void}
   * @private
   */
  addListeners() {
    if (typeof document == "undefined" || !this.view)
      return;
    const { view: t, trackHorizontal: n, trackVertical: r, thumbHorizontal: o, thumbVertical: i } = this;
    t.addEventListener("scroll", this.handleScroll), n.addEventListener("mouseenter", this.handleTrackMouseEnter), n.addEventListener("mouseleave", this.handleTrackMouseLeave), n.addEventListener("mousedown", this.handleHorizontalTrackMouseDown), r.addEventListener("mouseenter", this.handleTrackMouseEnter), r.addEventListener("mouseleave", this.handleTrackMouseLeave), r.addEventListener("mousedown", this.handleVerticalTrackMouseDown), o.addEventListener("mousedown", this.handleHorizontalThumbMouseDown), i.addEventListener("mousedown", this.handleVerticalThumbMouseDown), window.addEventListener("resize", this.handleWindowResize);
  }
  /**
   * initial DOM components listeners remove
   *
   * @returns {void}
   * @private
   */
  removeListeners() {
    if (typeof document == "undefined" || !this.view)
      return;
    const { view: t, trackHorizontal: n, trackVertical: r, thumbHorizontal: o, thumbVertical: i } = this;
    t.removeEventListener("scroll", this.handleScroll), n.removeEventListener("mouseenter", this.handleTrackMouseEnter), n.removeEventListener("mouseleave", this.handleTrackMouseLeave), n.removeEventListener("mousedown", this.handleHorizontalTrackMouseDown), r.removeEventListener("mouseenter", this.handleTrackMouseEnter), r.removeEventListener("mouseleave", this.handleTrackMouseLeave), r.removeEventListener("mousedown", this.handleVerticalTrackMouseDown), o.removeEventListener("mousedown", this.handleHorizontalThumbMouseDown), i.removeEventListener("mousedown", this.handleVerticalThumbMouseDown), window.removeEventListener("resize", this.handleWindowResize), this.teardownDragging();
  }
  /**
   * Tracks display during scroll handler
   *
   * @param {boolean} shouldStart - start status | stop status
   * @returns {void}
   * @private
   */
  handleScrollAutoHide(t = !0) {
    const { autoHide: n } = this.props;
    n && (t ? this.showTracks() : this.hideTracks());
  }
  /**
   * Sets listeners on dragging
   *
   * @returns {void}
   * @private
   */
  setupDragging() {
    oi(document.body, P7), document.addEventListener("mousemove", this.handleDrag), document.addEventListener("mouseup", this.handleDragEnd), document.onselectstart = () => !1;
  }
  /**
   * Removes listeners on dragging
   *
   * @returns {void}
   * @private
   */
  teardownDragging() {
    oi(document.body, O7), document.removeEventListener("mousemove", this.handleDrag), document.removeEventListener("mouseup", this.handleDragEnd), document.onselectstart = void 0;
  }
  /**
   * Sets status 'drag' and setups dragging
   *
   * @param {Event} event - standard drag event
   * @returns {void}
   * @private
   */
  handleDragStart(t) {
    this.dragging = !0, t.stopImmediatePropagation(), this.setupDragging();
  }
  /**
   * Tracks last scroll position
   *
   * @returns {void}
   * @private
   */
  handleDragEndAutoHide() {
    const { autoHide: t } = this.props;
    t && this.hideTracks();
  }
  /**
   * Tracks last scroll position
   *
   * @returns {void}
   * @private
   */
  handleTrackMouseEnterAutoHide() {
    const { autoHide: t } = this.props;
    t && this.showTracks();
  }
  /**
   * Tracks last scroll position
   *
   * @returns {void}
   * @private
   */
  handleTrackMouseLeaveAutoHide() {
    const { autoHide: t } = this.props;
    t && this.hideTracks();
  }
  /**
   * Tracks last scroll position
   *
   * @returns {void}
   * @private
   */
  showTracks() {
    clearTimeout(this.hideTracksTimeout), oi(this.trackHorizontal, { opacity: 1 }), oi(this.trackVertical, { opacity: 1 });
  }
  /**
   * Tracks last scroll position
   *
   * @returns {void}
   * @private
   */
  hideTracks() {
    if (this.dragging || this.trackMouseOver || this.scrolling)
      return;
    const { autoHideTimeout: t } = this.props;
    clearTimeout(this.hideTracksTimeout), this.hideTracksTimeout = setTimeout(() => {
      oi(this.trackHorizontal, { opacity: 0 }), oi(this.trackVertical, { opacity: 0 });
    }, t);
  }
  /**
   * Tracks last scroll position
   *
   * @returns {void}
   * @private
   */
  detectScrolling() {
    this.scrolling || (this.scrolling = !0, this.handleScrollAutoHide(!0), this.detectScrollingInterval = setInterval(() => {
      this.lastViewScrollLeft === this.viewScrollLeft && this.lastViewScrollTop === this.viewScrollTop && (clearInterval(this.detectScrollingInterval), this.scrolling = !1, this.handleScrollAutoHide(!1)), this.lastViewScrollLeft = this.viewScrollLeft, this.lastViewScrollTop = this.viewScrollTop;
    }, 100));
  }
  /**
   * raf manager for function
   *
   * @param {Function} callback - raf callback
   * @returns {void}
   * @private
   */
  raf(t) {
    this.requestFrame && rS.cancel(this.requestFrame), this.requestFrame = rS(() => {
      this.requestFrame = void 0, t();
    });
  }
  /**
   * CustomScroll recalculation and update
   *
   * @param {Function} callback - raf callback
   * @returns {void}
   * @private
   */
  handleUpdate(t) {
    const { hideTracksWhenNotNeeded: n } = this.props, r = this.getMeasurements(), { scrollLeft: o, clientWidth: i, scrollWidth: a } = r, s = Uv(this.trackHorizontal), c = this.getThumbHorizontalWidth(), l = o / (a - i) * (s - c), d = {
      width: c,
      transform: `translateX(${l}px)`
    }, { scrollTop: f, clientHeight: p, scrollHeight: m } = r, v = Vv(this.trackVertical), g = this.getThumbVerticalHeight(), b = f / (m - p) * (v - g), x = {
      height: g,
      transform: `translateY(${b}px)`
    };
    if (n) {
      const T = {
        visibility: a > i ? "visible" : "hidden"
      }, S = {
        visibility: m > p ? "visible" : "hidden"
      };
      oi(this.trackHorizontal, T), oi(this.trackVertical, S);
    }
    oi(this.thumbHorizontal, d), oi(this.thumbVertical, x), typeof t == "function" && t(r);
  }
  /**
   * CustomScroll recalculation and update with raf wrapper (public)
   *
   * @param {Function} callback - raf callback
   * @returns {void}
   */
  update(t) {
    this.raf(() => this.handleUpdate(t));
  }
  /**
   * Manually set scroll left
   *
   * @param {number} left - manual left
   * @returns {void}
   */
  scrollLeft(t = 0) {
    this.view && (this.view.scrollLeft = t);
  }
  /**
   * Manually set scroll top
   *
   * @param {number} top - manual top
   * @returns {void}
   */
  scrollTop(t = 0) {
    this.view && (this.view.scrollTop = t);
  }
  renderTracks() {
    const {
      renderThumbVertical: t,
      renderThumbHorizontal: n,
      renderTrackHorizontal: r,
      renderTrackVertical: o,
      autoHideDuration: i,
      autoHide: a
    } = this.props, s = {
      transition: `opacity ${i}ms`,
      opacity: 0
    }, c = pe(pe({}, E7), a && s), l = pe(pe({}, k7), a && s), d = t({
      style: R7,
      ref: this.setThumbVerticalRef
    }), f = o({
      key: "trackVertical",
      style: l,
      ref: this.setTrackVerticalRef,
      children: d,
      className: "scroll-elem__vertical-track"
    }), p = n({
      style: M7,
      ref: this.setThumbHorizontalRef
    });
    return [r({
      key: "trackHorizontal",
      style: c,
      ref: this.setTrackHorizontalRef,
      children: p,
      className: "scroll-elem__horizontal-track"
    }), f];
  }
  render() {
    const t = C7(), n = this.props, { autoHeight: r, autoHeightMin: o, autoHeightMax: i, style: a, children: s } = n, c = Wn(n, ["autoHeight", "autoHeightMin", "autoHeightMax", "style", "children"]), l = pe(pe(pe({}, dS), r && $e(pe({}, fS), {
      minHeight: o,
      maxHeight: i
    })), a), d = pe(pe(pe({}, dS), r && $e(pe({}, fS), {
      minHeight: o,
      maxHeight: i
    })), a);
    typeof d.height == "number" && (d.height -= c.scrollOffset || 0);
    const f = pe($e(pe({}, S7), {
      // Hide scrollbars by setting a negative margin
      marginRight: t ? -t : 0,
      marginBottom: t ? -t : 0
    }), r && $e(pe({}, T7), {
      // Add scrollbarWidth to autoHeight in order to compensate negative margins
      minHeight: uS(o) ? `calc(${o} + ${t}px)` : o + t,
      maxHeight: uS(i) ? `calc(${i} + ${t}px)` : i + t
    }));
    t || (f.scrollbarWidth = "none");
    const p = c.className || "pivot-scroller", m = `${p}__container`, v = `${p}__view`;
    return /* @__PURE__ */ _e("div", { className: p, style: l, children: [
      /* @__PURE__ */ z("div", { className: m, style: d, children: /* @__PURE__ */ z("div", { className: v, style: f, ref: this.setViewRef, children: s }) }),
      this.renderTracks()
    ] });
  }
}
Z(I_, "defaultProps", {
  renderTrackHorizontal: N7,
  renderTrackVertical: A7,
  renderThumbHorizontal: D7,
  renderThumbVertical: I7,
  thumbMinSize: 30,
  hideTracksWhenNotNeeded: !1,
  autoHide: !1,
  autoHideTimeout: 1e3,
  autoHideDuration: 200,
  autoHeight: !1,
  autoHeightMin: 0,
  autoHeightMax: 200,
  scrollOffset: 0
});
class L3 extends B.PureComponent {
  constructor() {
    super(...arguments), Z(this, "container"), Z(this, "containerRef", (t) => {
      this.container = t;
    }), Z(this, "onMouseWheel", (t) => {
      if (!this.props.activated)
        return;
      const n = Math.max(-1, Math.min(1, t.wheelDelta || -t.detail)), r = t.wheelDeltaX, o = t.wheelDeltaY;
      this.props.onMouseScroll && this.props.onMouseScroll(t, n, r, o);
    });
  }
  componentDidMount() {
    this.container && (this.container.addEventListener("mousewheel", this.onMouseWheel), this.container.addEventListener("DOMMouseScroll", this.onMouseWheel));
  }
  componentWillUnmount() {
    this.container && (this.container.removeEventListener("mousewheel", this.onMouseWheel), this.container.removeEventListener("DOMMouseScroll", this.onMouseWheel));
  }
  render() {
    const t = this.props, {
      children: n,
      activated: r,
      onMouseScroll: o
    } = t, i = Wn(t, [
      "children",
      "activated",
      // eslint-disable-line no-unused-vars
      "onMouseScroll"
    ]);
    return /* @__PURE__ */ z("div", $e(pe({}, i), { ref: this.containerRef, children: n }));
  }
}
Z(L3, "defaultProps", {
  activated: !0
});
function Gv(e) {
  if (!document)
    return e;
  const t = document.createElement("div");
  if (t.getBoundingClientRect) {
    t.style.width = "1px", t.style.height = "1px", t.style.boxSizing = "content-box", t.style.border = `solid ${e}px black`, document.body.appendChild(t);
    const n = t.getBoundingClientRect();
    return document.body.removeChild(t), (n.width - 1) / 2;
  }
  return e;
}
function pS(e) {
  let t = [], n = [];
  return e.cornerTreeService && (t = e.cornerTreeService.getLastLevelNodes()), e.columnsTreeService && (n = e.columnsTreeService.getLastLevelNodes()), [...t, ...n].map((r) => hr(r));
}
class $3 extends B.PureComponent {
  constructor(t) {
    super(t), Z(this, "logger"), Z(this, "data", []), Z(this, "cellsMetadata", /* @__PURE__ */ new Map()), Z(this, "cornerTable", []), Z(this, "columnsTable", []), Z(this, "rowsTable", []), Z(this, "dataBars", []), Z(this, "rangeMinMax", []), Z(this, "fixRowsCount", 0), Z(this, "fixColsCount", 0), Z(this, "rowsCount", 0), Z(this, "colsCount", 0), Z(this, "scrollContainer"), Z(this, "leftContainer"), Z(this, "topContainer"), Z(this, "rightContainer"), Z(this, "resetScroll"), Z(this, "isMainGridUpdateSkiped", !1), Z(this, "isFullWidthRefreshed", !1), Z(this, "isDomReadyTriggered", !1), Z(this, "domReadyTriggerTime", 0), Z(this, "measure"), Z(this, "styleObj"), Z(this, "cellDomReadyPromises"), Z(this, "addCellDomReadyPromise", (r) => {
      this.cellDomReadyPromises = this.cellDomReadyPromises || [], r && this.cellDomReadyPromises.push(r.promise);
    }), Z(this, "removeCellDomReadyPromise", (r) => {
      this.cellDomReadyPromises = this.cellDomReadyPromises || [], r && (this.cellDomReadyPromises = this.cellDomReadyPromises.filter((o) => o !== r.promise));
    }), Z(this, "onChange", (r, o) => {
      this.setState({
        widths: r,
        heights: o
      }), this.topContainer && this.topContainer.classList.add("active"), this.leftContainer && this.leftContainer.classList.add("active"), this.rightContainer && this.rightContainer.classList.add("active"), this.isMainGridUpdateSkiped && (this.isMainGridUpdateSkiped = !1, this.onMainGridUpdated());
    }), Z(this, "onResize", () => {
      const r = window.devicePixelRatio || 1;
      this.state.zoomRatio !== r && this.setState({
        zoomRatio: r,
        borderWidth: Gv(this.props.borderWidth || 1)
      });
    }), Z(this, "onScroll", (r) => {
      const o = r.target, i = o.scrollTop, a = o.scrollLeft;
      this.leftContainer && (this.leftContainer.scrollTop = i), this.topContainer && (this.topContainer.scrollLeft = a), this.scrollContainer && this.scrollContainer.view && (this.scrollContainer.view.scrollTop = i);
    }), Z(this, "onMouseScroll", (r, o) => {
      let i = 0, a = 0;
      if (this.scrollContainer && this.scrollContainer.view) {
        const { offsetHeight: s, scrollHeight: c } = this.scrollContainer.view;
        i = this.scrollContainer.view.scrollTop, a = i + -o * 40, o > 0 ? a > 0 && r.preventDefault() : a < c - s && r.preventDefault(), this.scrollContainer.view.scrollTop = a;
      }
    }), Z(this, "onMainGridUpdated", () => {
      if (this.state.tableSize.hasPendingChanges()) {
        this.isMainGridUpdateSkiped = !0;
        return;
      }
      if (this.isMainGridUpdateSkiped = !1, this.props.onGridUpdated && this.props.onGridUpdated(), this.props.onInitLoadingFinish && !this.isDomReadyTriggered && this.props.onInitLoadingFinish(), this.props.onTotalSizeChange && this.scrollContainer && this.scrollContainer.view) {
        const r = this.scrollContainer.view.children[0].scrollHeight + this.props.scrollBarsMargin;
        this.props.onTotalSizeChange(r);
      }
      if (this.props.isFullWidth && !this.isDomReadyTriggered && !this.isFullWidthRefreshed) {
        this.isFullWidthRefreshed = !0;
        const { width: r, scrollBarsMargin: o = 0 } = this.props, { tableSize: i } = this.state;
        i.fitWidths(r - o);
        return;
      }
      if (this.props.onDomReady && this.cellDomReadyPromises && !this.isDomReadyTriggered) {
        this.isDomReadyTriggered = !0;
        const { onDomReady: r } = this.props, o = (/* @__PURE__ */ new Date()).getTime();
        Promise.all(this.cellDomReadyPromises).catch((i) => {
          this.logger.warn(`Cell "domready" promise rejected with "${i.message}"`);
        }).then(() => {
          this.domReadyTriggerTime === o && r();
        }), this.domReadyTriggerTime = o;
      }
    }), Z(this, "cellRenderer", (r) => {
      const { type: o, clone: i, rowIndex: a, colIndex: s, isMobile: c, colWidth: l } = r, { borderWidth: d, tableSize: f } = this.state, { columnWidth: p } = f, m = this.props.addCellDomReadyPromise || this.addCellDomReadyPromise, v = this.props.removeCellDomReadyPromise || this.removeCellDomReadyPromise;
      let g = o, b, x = a, T = s, S, _, w, k, E, R, P, A, D, N = 0, F = 0, $, I;
      if (a >= this.fixRowsCount && s >= this.fixColsCount) {
        T -= this.fixColsCount, x -= this.fixRowsCount;
        try {
          _ = this.data[x][T];
        } catch (q) {
          throw new Error(`cellRenderer can't find data item for ${a}-${T}`);
        }
        if (I = `${x + this.fixRowsCount}-${T + this.fixColsCount}`, S = this.cellsMetadata.get(I), this.state.rowsTreeService) {
          k = this.state.rowsTreeService.getMetadata(x, 1 / 0);
          const q = this.state.rowsTreeService.getLastLevelNodes();
          w = hr(q[x]);
        }
        if (this.state.columnsTreeService) {
          R = this.state.columnsTreeService.getMetadata(1 / 0, T);
          const q = this.state.columnsTreeService.getLastLevelNodes();
          E = hr(q[T]), E && E.metadataType === Ke.MEASURES ? (P = E, E.parent && (E = hr(E.parent))) : R && R.valueNode && (P = hr(R.valueNode));
        }
      } else
        s >= this.fixColsCount ? (g = fr.COLUMNS, b = this.state.columnsTreeService, T -= this.fixColsCount, N = this.fixColsCount) : a >= this.fixRowsCount ? (g = fr.ROWS, b = this.state.rowsTreeService, x -= this.fixRowsCount, F = this.fixRowsCount) : (g = fr.CORNER, b = this.state.cornerTreeService);
      if (b) {
        const q = b.getTreeNode(x, T);
        A = q ? hr(q) : void 0, D = b.getMetadata(x, T), I = `${x}-${T}`, s >= this.fixColsCount ? I = `${x}-${T + this.fixColsCount}` : a >= this.fixRowsCount && (I = `${x + this.fixRowsCount}-${T}`), S = this.cellsMetadata.get(I), $ = b.getMainCellWidth(
          x,
          T,
          p,
          d,
          { columnsOffset: N, offsetTop: F }
        );
      }
      const j = (A || _ || {}).store || {};
      this.addCellDomReadyPromise(j.domReadyDefer || j.domReadyDeffer);
      let U = {}, G = !1, V = p({ index: s }), H = !1;
      return b && b.isChildren(x, T) ? G = !0 : b && b.hasChildren(x, T) && (U = b.getMainCellSpans(x, T), $ && (V = $)), (this.state.tableSize.hasInitialFixedWidth(s) || i) && (H = !0), H && isNaN(V) && l && (V = l), G ? null : /* @__PURE__ */ z(
        fD,
        $e(pe({
          isDataCell: !!_,
          tdComponent: "td",
          measure: this.measure,
          onSortingMetadataUpdate: this.props.onSortingMetadataUpdate,
          styleObj: this.styleObj,
          onSortingSettingsChanged: this.props.onSortingSettingsChanged,
          getSortingPopupContainer: this.props.getSortingPopupContainer,
          borderWidth: d,
          borderColor: this.props.borderColor,
          dataNode: _,
          cellMetadata: S,
          metadata: D,
          treeNode: A,
          rowIndex: a,
          columnIndex: s,
          tableType: g,
          rowTreeNode: w,
          rowMetadata: k,
          columnTreeNode: E,
          columnMetadata: R,
          measureTreeNode: P,
          parent: this,
          fixedWidth: H,
          tableSize: this.state.tableSize,
          isSelectedMode: this.props.isSelectedMode,
          allowHtml: this.props.allowHtml,
          onCellClick: this.props.onCellClick,
          onCellEnter: this.props.onCellEnter,
          onCellLeave: this.props.onCellLeave
        }, U), {
          colWidth: V,
          clone: i,
          zoomRatio: this.state.zoomRatio,
          rowHeight: this.props.rowHeight,
          imageColumns: this.props.imageColumns,
          fallbackImageUrl: this.props.fallbackImageUrl,
          addCellDomReadyPromise: m,
          removeCellDomReadyPromise: v,
          isMobile: c
        }),
        I
      );
    }), Z(this, "scrollContainerRef", (r) => {
      r && (this.scrollContainer = r, this.resetScroll && this.scrollContainer && this.scrollContainer.view && (this.resetScroll = !1, this.scrollContainer.view.scrollTop = 0, this.scrollContainer.view.scrollLeft = 0));
    }), Z(this, "leftContainerRef", (r) => {
      r && (this.leftContainer = r);
    }), Z(this, "topContainerRef", (r) => {
      r && (this.topContainer = r);
    }), Z(this, "rightContainerRef", (r) => {
      r && (this.rightContainer = r);
    }), this.logger = ds.create("PivotTable");
    const n = window.devicePixelRatio || 1;
    this.state = {
      tableSize: this.createTableSize(),
      widths: {},
      heights: {},
      borderWidth: Gv(t.borderWidth || 1),
      isResizeInProgress: !1,
      rowsTreeService: void 0,
      columnsTreeService: void 0,
      cornerTreeService: void 0,
      zoomRatio: n
    }, this.measure = () => {
    }, this.styleObj = {}, this.resetScroll = !1, t.dataBars && t.dataBars.length && this.notifyDataBars(t.dataBars), t.rangeMinMax && t.rangeMinMax.length && this.notifyRangeMinMax(t.rangeMinMax);
  }
  componentDidMount() {
    window.addEventListener("resize", this.onResize), this.props.onGetInitialData && this.props.onGetInitialData(), this.resetScroll && this.scrollContainer && this.scrollContainer.view && (this.resetScroll = !1, this.scrollContainer.view.scrollTop = 0, this.scrollContainer.view.scrollLeft = 0, this.topContainer && this.topContainer.classList.remove("active"), this.leftContainer && this.leftContainer.classList.remove("active"), this.rightContainer && this.rightContainer.classList.remove("active"));
  }
  UNSAFE_componentWillReceiveProps(t) {
    if (t.borderWidth !== this.props.borderWidth) {
      const n = window.devicePixelRatio || 1;
      this.setState({
        borderWidth: Gv(t.borderWidth || 1),
        zoomRatio: n
      });
    }
    t.dataBars !== this.props.dataBars && this.notifyDataBars(t.dataBars), t.rangeMinMax !== this.props.rangeMinMax && this.notifyRangeMinMax(t.rangeMinMax);
  }
  componentDidUpdate() {
    this.resetScroll && this.scrollContainer && this.scrollContainer.view && (this.resetScroll = !1, this.scrollContainer.view.scrollTop = 0, this.scrollContainer.view.scrollLeft = 0, this.topContainer && this.topContainer.classList.remove("active"), this.leftContainer && this.leftContainer.classList.remove("active"), this.rightContainer && this.rightContainer.classList.remove("active")), this.notifyDataBars(this.props.dataBars);
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this.onResize);
  }
  initialize(t, n, r, o) {
    const { cellsMetadata: i = /* @__PURE__ */ new Map() } = o || {};
    i !== null && (this.cellsMetadata = i), this.isDomReadyTriggered = !1, this.isFullWidthRefreshed = !1, this.resetScroll = !0;
    const a = {
      rowsTreeService: t,
      columnsTreeService: n,
      cornerTreeService: r
    };
    this.initTableSize(a);
    const s = this.createTableSize(), c = pS(a);
    if (this.props.onUpdatePredefinedColumnWidth) {
      const l = this.props.onUpdatePredefinedColumnWidth(
        c,
        void 0
      );
      s.setInitialFixedWidth(l);
    }
    this.cellDomReadyPromises = void 0, !t && !n && (this.cellDomReadyPromises = []), this.setState(pe({
      tableSize: s
    }, a));
  }
  addMore(t, n) {
    return this.initialize(
      t,
      this.state.columnsTreeService,
      this.state.cornerTreeService,
      {
        isLastPage: n,
        cellsMetadata: null
      }
    );
  }
  notifyDataBars(t) {
    this.dataBars = (t || []).map((n) => {
      if (!n)
        return n;
      const [r, o] = n;
      return [parseFloat(r), parseFloat(o)];
    }), this.state && this.state.tableSize && this.state.tableSize.updateDataBarsMinMax(this.dataBars);
  }
  notifyRangeMinMax(t) {
    this.rangeMinMax = (t || []).map((n) => {
      if (!n)
        return n;
      const [r, o] = n;
      return [parseFloat(r), parseFloat(o)];
    }), this.state && this.state.tableSize && this.state.tableSize.updateRangeMinMax(this.rangeMinMax);
  }
  createTableSize() {
    this.state && this.state.tableSize && this.state.tableSize.off(Gb, this.onChange);
    const t = new jW(this.dataBars, this.rangeMinMax);
    return t.on(Gb, this.onChange), t;
  }
  hasContent() {
    return !(this.rowsCount === 0 && this.colsCount === 0);
  }
  getDimensions() {
    const t = {
      getTreeChildLength: () => 0,
      getTreeDeepsLength: () => 0
    }, {
      columnsTreeService: n = t,
      cornerTreeService: r = t,
      rowsTreeService: o = t
    } = this.state;
    if (o) {
      let i = n === void 0 ? 0 : n.getTreeChildLength();
      r && (i += r.getTreeChildLength());
      const a = o.getTreeChildLength() + (n === void 0 ? 0 : n.getTreeDeepsLength());
      return {
        height: Array.from({ length: a }, (s, c) => [
          c,
          this.getRowHeight(c)
        ]),
        width: Array.from({ length: i }, (s, c) => [
          c,
          this.getColumnWidth(c)
        ])
      };
    }
    return { height: [], width: [] };
  }
  getColumnWidth(t) {
    return this.state.tableSize.columnWidth({ index: t });
  }
  /**
   * Returns row height from cellMeasurerCache
   *
   * @param {number} rowIndex - column index
   * @returns {number} - column width
   */
  getRowHeight(t) {
    return this.state.tableSize.rowHeight({ index: t });
  }
  initTableSize(t) {
    this.data = [], t.rowsTreeService && (this.data = t.rowsTreeService.extractData(t.columnsTreeService)), this.rowsCount = 0, this.colsCount = 0, this.fixRowsCount = 0, this.fixColsCount = 0, this.cornerTable = [], t.cornerTreeService && (this.cornerTable = t.cornerTreeService.getGrid(), this.fixRowsCount = this.cornerTable.length, this.rowsCount += this.fixRowsCount, this.cornerTable[0] && (this.fixColsCount = this.cornerTable[0].length, this.colsCount += this.fixColsCount)), this.columnsTable = [], t.columnsTreeService && (this.columnsTable = t.columnsTreeService.getGrid(), this.columnsTable[0] && (this.colsCount += this.columnsTable[0].length), t.cornerTreeService || (this.fixRowsCount = this.columnsTable.length, this.rowsCount += this.fixRowsCount)), this.rowsTable = [], t.rowsTreeService && (this.rowsTable = t.rowsTreeService.getGrid(), this.rowsCount += this.rowsTable.length);
  }
  resizeColumnStart() {
    this.setState({ isResizeInProgress: !0 });
  }
  resizeColumn(t, n, r) {
    const [o, i] = t[0];
    this.state.tableSize.setFixedWidth(o, i);
  }
  resizeColumnEnd(t, n) {
    this.setState({ isResizeInProgress: !1 });
    const r = [n, t], o = pS(this.state);
    if (this.props.onUpdatePredefinedColumnWidth) {
      const i = this.props.onUpdatePredefinedColumnWidth(
        o,
        r
      );
      this.state.tableSize.setInitialFixedWidth(i), this.state.tableSize.notifyChange();
    } else
      this.state.tableSize.setFixedWidth(n, t);
  }
  render() {
    const { widths: t, heights: n, borderWidth: r, rowsTreeService: o, columnsTreeService: i, cornerTreeService: a } = this.state, { width: s, height: c, borderColor: l, scrollBarsMargin: d, className: f, isFixedEnabled: p, isMobile: m } = this.props, { rowsCount: v, colsCount: g, fixRowsCount: b, fixColsCount: x } = this, T = { width: s, height: c }, S = T.height - d, _ = T.width - d;
    let w = 0, k = 0;
    t[0] && (w = Array.from(Array(x)).reduce(
      (P, A, D) => P + t[D],
      0
    ), w += r || 1, k = Array.from(Array(b)).reduce(
      (P, A, D) => P + n[D],
      0
    ), k += r || 1), w = Math.ceil(w), k = Math.ceil(k);
    const E = w / _ > 0.75 ? qW : "";
    let R = "";
    return b === 0 && x === 0 ? R += `${Y2} ${UW} ${Z2}` : x === 0 && (R += `${Y2} ${Z2}`), /* @__PURE__ */ _e(
      L3,
      {
        onMouseScroll: this.onMouseScroll,
        className: `${WW} ${VW} ${E} ${R} ${f}`,
        children: [
          /* @__PURE__ */ z(
            I_,
            {
              ref: this.scrollContainerRef,
              style: T,
              scrollOffset: d,
              onScroll: this.onScroll,
              children: /* @__PURE__ */ z("div", { className: `${ep} ${GW} ${J2} ${K2}`, children: /* @__PURE__ */ z(
                Ju,
                {
                  type: fr.DATA,
                  rowsCount: v,
                  colsCount: g,
                  widths: t,
                  heights: n,
                  rowsTreeService: o,
                  columnsTreeService: i,
                  cornerTreeService: a,
                  borderWidth: r,
                  borderColor: l,
                  tableSize: this.state.tableSize,
                  cellRenderer: this.cellRenderer,
                  zoomRatio: this.state.zoomRatio,
                  onGridUpdated: this.onMainGridUpdated,
                  isMobile: m
                }
              ) })
            }
          ),
          p ? /* @__PURE__ */ _e(fo, { children: [
            /* @__PURE__ */ z(
              "div",
              {
                ref: this.leftContainerRef,
                className: `${ep} ${$v} ${YW} ${J2} ${Q2}`,
                style: { width: w, height: S },
                children: /* @__PURE__ */ z(
                  Ju,
                  {
                    clone: !0,
                    type: fr.ROWS,
                    rowsCount: v,
                    colsCount: x,
                    widths: t,
                    heights: n,
                    rowsTreeService: o,
                    borderWidth: r,
                    borderColor: l,
                    tableSize: this.state.tableSize,
                    cellRenderer: this.cellRenderer,
                    zoomRatio: this.state.zoomRatio,
                    isMobile: m
                  }
                )
              }
            ),
            /* @__PURE__ */ z(
              "div",
              {
                ref: this.topContainerRef,
                className: `${ep} ${$v} ${ZW} ${X2} ${K2}`,
                style: { height: k, width: _ },
                children: /* @__PURE__ */ z(
                  Ju,
                  {
                    clone: !0,
                    type: fr.COLUMNS,
                    rowsCount: b,
                    colsCount: g,
                    widths: t,
                    heights: n,
                    columnsTreeService: i,
                    borderWidth: r,
                    borderColor: l,
                    tableSize: this.state.tableSize,
                    cellRenderer: this.cellRenderer,
                    zoomRatio: this.state.zoomRatio,
                    isMobile: m
                  }
                )
              }
            ),
            /* @__PURE__ */ z(
              "div",
              {
                ref: this.rightContainerRef,
                className: `${ep} ${$v} ${XW} ${X2} ${Q2}`,
                style: { width: w, height: k },
                children: /* @__PURE__ */ z(
                  Ju,
                  {
                    clone: !0,
                    type: fr.CORNER,
                    rowsCount: b,
                    colsCount: x,
                    widths: t,
                    heights: n,
                    cornerTreeService: a,
                    borderWidth: r,
                    borderColor: l,
                    tableSize: this.state.tableSize,
                    cellRenderer: this.cellRenderer,
                    zoomRatio: this.state.zoomRatio,
                    isMobile: m
                  }
                )
              }
            )
          ] }) : null
        ]
      }
    );
  }
}
Z($3, "defaultProps", {
  borderWidth: 1,
  borderColor: "",
  isFullWidth: !1,
  isFixedEnabled: !0
});
const L7 = "sisense-pivot__pagination-panel", $7 = "sisense-pivot__pagination-panel-wrapper", F7 = "sisense-pivot__pagination-panel--showed", z7 = "sisense-pivot__pagination-panel--hidden", B7 = "sisense-pivot__pagination-panel--desktop", H7 = "sisense-pivot__pagination-panel--limits-only", j7 = "sisense-pivot__pagination-panel--mobile", W7 = "sisense-pivot__pagination-panel--notification-only", V7 = "sisense-pivot__pagination-panel-list-wrapper", U7 = "sisense-pivot__pagination-panel-notification";
function He(e, t) {
  if (e == null)
    return {};
  var n = {};
  for (var r in e)
    if (Object.prototype.hasOwnProperty.call(e, r)) {
      if (t.indexOf(r) >= 0)
        continue;
      n[r] = e[r];
    }
  return n;
}
function re() {
  return re = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, re.apply(this, arguments);
}
var xh = {}, hS = {
  get exports() {
    return xh;
  },
  set exports(e) {
    xh = e;
  }
}, Zb = {}, q7 = {
  get exports() {
    return Zb;
  },
  set exports(e) {
    Zb = e;
  }
}, At = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var mS;
function G7() {
  if (mS)
    return At;
  mS = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, a = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, c = e ? Symbol.for("react.async_mode") : 60111, l = e ? Symbol.for("react.concurrent_mode") : 60111, d = e ? Symbol.for("react.forward_ref") : 60112, f = e ? Symbol.for("react.suspense") : 60113, p = e ? Symbol.for("react.suspense_list") : 60120, m = e ? Symbol.for("react.memo") : 60115, v = e ? Symbol.for("react.lazy") : 60116, g = e ? Symbol.for("react.block") : 60121, b = e ? Symbol.for("react.fundamental") : 60117, x = e ? Symbol.for("react.responder") : 60118, T = e ? Symbol.for("react.scope") : 60119;
  function S(w) {
    if (typeof w == "object" && w !== null) {
      var k = w.$$typeof;
      switch (k) {
        case t:
          switch (w = w.type, w) {
            case c:
            case l:
            case r:
            case i:
            case o:
            case f:
              return w;
            default:
              switch (w = w && w.$$typeof, w) {
                case s:
                case d:
                case v:
                case m:
                case a:
                  return w;
                default:
                  return k;
              }
          }
        case n:
          return k;
      }
    }
  }
  function _(w) {
    return S(w) === l;
  }
  return At.AsyncMode = c, At.ConcurrentMode = l, At.ContextConsumer = s, At.ContextProvider = a, At.Element = t, At.ForwardRef = d, At.Fragment = r, At.Lazy = v, At.Memo = m, At.Portal = n, At.Profiler = i, At.StrictMode = o, At.Suspense = f, At.isAsyncMode = function(w) {
    return _(w) || S(w) === c;
  }, At.isConcurrentMode = _, At.isContextConsumer = function(w) {
    return S(w) === s;
  }, At.isContextProvider = function(w) {
    return S(w) === a;
  }, At.isElement = function(w) {
    return typeof w == "object" && w !== null && w.$$typeof === t;
  }, At.isForwardRef = function(w) {
    return S(w) === d;
  }, At.isFragment = function(w) {
    return S(w) === r;
  }, At.isLazy = function(w) {
    return S(w) === v;
  }, At.isMemo = function(w) {
    return S(w) === m;
  }, At.isPortal = function(w) {
    return S(w) === n;
  }, At.isProfiler = function(w) {
    return S(w) === i;
  }, At.isStrictMode = function(w) {
    return S(w) === o;
  }, At.isSuspense = function(w) {
    return S(w) === f;
  }, At.isValidElementType = function(w) {
    return typeof w == "string" || typeof w == "function" || w === r || w === l || w === i || w === o || w === f || w === p || typeof w == "object" && w !== null && (w.$$typeof === v || w.$$typeof === m || w.$$typeof === a || w.$$typeof === s || w.$$typeof === d || w.$$typeof === b || w.$$typeof === x || w.$$typeof === T || w.$$typeof === g);
  }, At.typeOf = S, At;
}
var Ht = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var gS;
function Y7() {
  return gS || (gS = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, a = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, c = e ? Symbol.for("react.async_mode") : 60111, l = e ? Symbol.for("react.concurrent_mode") : 60111, d = e ? Symbol.for("react.forward_ref") : 60112, f = e ? Symbol.for("react.suspense") : 60113, p = e ? Symbol.for("react.suspense_list") : 60120, m = e ? Symbol.for("react.memo") : 60115, v = e ? Symbol.for("react.lazy") : 60116, g = e ? Symbol.for("react.block") : 60121, b = e ? Symbol.for("react.fundamental") : 60117, x = e ? Symbol.for("react.responder") : 60118, T = e ? Symbol.for("react.scope") : 60119;
    function S(ee) {
      return typeof ee == "string" || typeof ee == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      ee === r || ee === l || ee === i || ee === o || ee === f || ee === p || typeof ee == "object" && ee !== null && (ee.$$typeof === v || ee.$$typeof === m || ee.$$typeof === a || ee.$$typeof === s || ee.$$typeof === d || ee.$$typeof === b || ee.$$typeof === x || ee.$$typeof === T || ee.$$typeof === g);
    }
    function _(ee) {
      if (typeof ee == "object" && ee !== null) {
        var me = ee.$$typeof;
        switch (me) {
          case t:
            var oe = ee.type;
            switch (oe) {
              case c:
              case l:
              case r:
              case i:
              case o:
              case f:
                return oe;
              default:
                var ve = oe && oe.$$typeof;
                switch (ve) {
                  case s:
                  case d:
                  case v:
                  case m:
                  case a:
                    return ve;
                  default:
                    return me;
                }
            }
          case n:
            return me;
        }
      }
    }
    var w = c, k = l, E = s, R = a, P = t, A = d, D = r, N = v, F = m, $ = n, I = i, j = o, U = f, G = !1;
    function V(ee) {
      return G || (G = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), H(ee) || _(ee) === c;
    }
    function H(ee) {
      return _(ee) === l;
    }
    function q(ee) {
      return _(ee) === s;
    }
    function Q(ee) {
      return _(ee) === a;
    }
    function X(ee) {
      return typeof ee == "object" && ee !== null && ee.$$typeof === t;
    }
    function K(ee) {
      return _(ee) === d;
    }
    function J(ee) {
      return _(ee) === r;
    }
    function ne(ee) {
      return _(ee) === v;
    }
    function ae(ee) {
      return _(ee) === m;
    }
    function te(ee) {
      return _(ee) === n;
    }
    function le(ee) {
      return _(ee) === i;
    }
    function ce(ee) {
      return _(ee) === o;
    }
    function fe(ee) {
      return _(ee) === f;
    }
    Ht.AsyncMode = w, Ht.ConcurrentMode = k, Ht.ContextConsumer = E, Ht.ContextProvider = R, Ht.Element = P, Ht.ForwardRef = A, Ht.Fragment = D, Ht.Lazy = N, Ht.Memo = F, Ht.Portal = $, Ht.Profiler = I, Ht.StrictMode = j, Ht.Suspense = U, Ht.isAsyncMode = V, Ht.isConcurrentMode = H, Ht.isContextConsumer = q, Ht.isContextProvider = Q, Ht.isElement = X, Ht.isForwardRef = K, Ht.isFragment = J, Ht.isLazy = ne, Ht.isMemo = ae, Ht.isPortal = te, Ht.isProfiler = le, Ht.isStrictMode = ce, Ht.isSuspense = fe, Ht.isValidElementType = S, Ht.typeOf = _;
  }()), Ht;
}
var vS;
function F3() {
  return vS || (vS = 1, function(e) {
    process.env.NODE_ENV === "production" ? e.exports = G7() : e.exports = Y7();
  }(q7)), Zb;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var Yv, bS;
function Z7() {
  if (bS)
    return Yv;
  bS = 1;
  var e = Object.getOwnPropertySymbols, t = Object.prototype.hasOwnProperty, n = Object.prototype.propertyIsEnumerable;
  function r(i) {
    if (i == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(i);
  }
  function o() {
    try {
      if (!Object.assign)
        return !1;
      var i = new String("abc");
      if (i[5] = "de", Object.getOwnPropertyNames(i)[0] === "5")
        return !1;
      for (var a = {}, s = 0; s < 10; s++)
        a["_" + String.fromCharCode(s)] = s;
      var c = Object.getOwnPropertyNames(a).map(function(d) {
        return a[d];
      });
      if (c.join("") !== "0123456789")
        return !1;
      var l = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(d) {
        l[d] = d;
      }), Object.keys(Object.assign({}, l)).join("") === "abcdefghijklmnopqrst";
    } catch (d) {
      return !1;
    }
  }
  return Yv = o() ? Object.assign : function(i, a) {
    for (var s, c = r(i), l, d = 1; d < arguments.length; d++) {
      s = Object(arguments[d]);
      for (var f in s)
        t.call(s, f) && (c[f] = s[f]);
      if (e) {
        l = e(s);
        for (var p = 0; p < l.length; p++)
          n.call(s, l[p]) && (c[l[p]] = s[l[p]]);
      }
    }
    return c;
  }, Yv;
}
var Zv, yS;
function L_() {
  if (yS)
    return Zv;
  yS = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return Zv = e, Zv;
}
var _S, wS;
function z3() {
  return wS || (wS = 1, _S = Function.call.bind(Object.prototype.hasOwnProperty)), _S;
}
var Xv, xS;
function X7() {
  if (xS)
    return Xv;
  xS = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var t = L_(), n = {}, r = z3();
    e = function(i) {
      var a = "Warning: " + i;
      typeof console != "undefined" && console.error(a);
      try {
        throw new Error(a);
      } catch (s) {
      }
    };
  }
  function o(i, a, s, c, l) {
    if (process.env.NODE_ENV !== "production") {
      for (var d in i)
        if (r(i, d)) {
          var f;
          try {
            if (typeof i[d] != "function") {
              var p = Error(
                (c || "React class") + ": " + s + " type `" + d + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof i[d] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw p.name = "Invariant Violation", p;
            }
            f = i[d](a, d, c, s, null, t);
          } catch (v) {
            f = v;
          }
          if (f && !(f instanceof Error) && e(
            (c || "React class") + ": type specification of " + s + " `" + d + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof f + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), f instanceof Error && !(f.message in n)) {
            n[f.message] = !0;
            var m = l ? l() : "";
            e(
              "Failed " + s + " type: " + f.message + (m != null ? m : "")
            );
          }
        }
    }
  }
  return o.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (n = {});
  }, Xv = o, Xv;
}
var Kv, CS;
function K7() {
  if (CS)
    return Kv;
  CS = 1;
  var e = F3(), t = Z7(), n = L_(), r = z3(), o = X7(), i = function() {
  };
  process.env.NODE_ENV !== "production" && (i = function(s) {
    var c = "Warning: " + s;
    typeof console != "undefined" && console.error(c);
    try {
      throw new Error(c);
    } catch (l) {
    }
  });
  function a() {
    return null;
  }
  return Kv = function(s, c) {
    var l = typeof Symbol == "function" && Symbol.iterator, d = "@@iterator";
    function f(H) {
      var q = H && (l && H[l] || H[d]);
      if (typeof q == "function")
        return q;
    }
    var p = "<<anonymous>>", m = {
      array: x("array"),
      bigint: x("bigint"),
      bool: x("boolean"),
      func: x("function"),
      number: x("number"),
      object: x("object"),
      string: x("string"),
      symbol: x("symbol"),
      any: T(),
      arrayOf: S,
      element: _(),
      elementType: w(),
      instanceOf: k,
      node: A(),
      objectOf: R,
      oneOf: E,
      oneOfType: P,
      shape: N,
      exact: F
    };
    function v(H, q) {
      return H === q ? H !== 0 || 1 / H === 1 / q : H !== H && q !== q;
    }
    function g(H, q) {
      this.message = H, this.data = q && typeof q == "object" ? q : {}, this.stack = "";
    }
    g.prototype = Error.prototype;
    function b(H) {
      if (process.env.NODE_ENV !== "production")
        var q = {}, Q = 0;
      function X(J, ne, ae, te, le, ce, fe) {
        if (te = te || p, ce = ce || ae, fe !== n) {
          if (c) {
            var ee = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw ee.name = "Invariant Violation", ee;
          } else if (process.env.NODE_ENV !== "production" && typeof console != "undefined") {
            var me = te + ":" + ae;
            !q[me] && // Avoid spamming the console because they are often not actionable except for lib authors
            Q < 3 && (i(
              "You are manually calling a React.PropTypes validation function for the `" + ce + "` prop on `" + te + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), q[me] = !0, Q++);
          }
        }
        return ne[ae] == null ? J ? ne[ae] === null ? new g("The " + le + " `" + ce + "` is marked as required " + ("in `" + te + "`, but its value is `null`.")) : new g("The " + le + " `" + ce + "` is marked as required in " + ("`" + te + "`, but its value is `undefined`.")) : null : H(ne, ae, te, le, ce);
      }
      var K = X.bind(null, !1);
      return K.isRequired = X.bind(null, !0), K;
    }
    function x(H) {
      function q(Q, X, K, J, ne, ae) {
        var te = Q[X], le = j(te);
        if (le !== H) {
          var ce = U(te);
          return new g(
            "Invalid " + J + " `" + ne + "` of type " + ("`" + ce + "` supplied to `" + K + "`, expected ") + ("`" + H + "`."),
            { expectedType: H }
          );
        }
        return null;
      }
      return b(q);
    }
    function T() {
      return b(a);
    }
    function S(H) {
      function q(Q, X, K, J, ne) {
        if (typeof H != "function")
          return new g("Property `" + ne + "` of component `" + K + "` has invalid PropType notation inside arrayOf.");
        var ae = Q[X];
        if (!Array.isArray(ae)) {
          var te = j(ae);
          return new g("Invalid " + J + " `" + ne + "` of type " + ("`" + te + "` supplied to `" + K + "`, expected an array."));
        }
        for (var le = 0; le < ae.length; le++) {
          var ce = H(ae, le, K, J, ne + "[" + le + "]", n);
          if (ce instanceof Error)
            return ce;
        }
        return null;
      }
      return b(q);
    }
    function _() {
      function H(q, Q, X, K, J) {
        var ne = q[Q];
        if (!s(ne)) {
          var ae = j(ne);
          return new g("Invalid " + K + " `" + J + "` of type " + ("`" + ae + "` supplied to `" + X + "`, expected a single ReactElement."));
        }
        return null;
      }
      return b(H);
    }
    function w() {
      function H(q, Q, X, K, J) {
        var ne = q[Q];
        if (!e.isValidElementType(ne)) {
          var ae = j(ne);
          return new g("Invalid " + K + " `" + J + "` of type " + ("`" + ae + "` supplied to `" + X + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return b(H);
    }
    function k(H) {
      function q(Q, X, K, J, ne) {
        if (!(Q[X] instanceof H)) {
          var ae = H.name || p, te = V(Q[X]);
          return new g("Invalid " + J + " `" + ne + "` of type " + ("`" + te + "` supplied to `" + K + "`, expected ") + ("instance of `" + ae + "`."));
        }
        return null;
      }
      return b(q);
    }
    function E(H) {
      if (!Array.isArray(H))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? i(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : i("Invalid argument supplied to oneOf, expected an array.")), a;
      function q(Q, X, K, J, ne) {
        for (var ae = Q[X], te = 0; te < H.length; te++)
          if (v(ae, H[te]))
            return null;
        var le = JSON.stringify(H, function(ce, fe) {
          var ee = U(fe);
          return ee === "symbol" ? String(fe) : fe;
        });
        return new g("Invalid " + J + " `" + ne + "` of value `" + String(ae) + "` " + ("supplied to `" + K + "`, expected one of " + le + "."));
      }
      return b(q);
    }
    function R(H) {
      function q(Q, X, K, J, ne) {
        if (typeof H != "function")
          return new g("Property `" + ne + "` of component `" + K + "` has invalid PropType notation inside objectOf.");
        var ae = Q[X], te = j(ae);
        if (te !== "object")
          return new g("Invalid " + J + " `" + ne + "` of type " + ("`" + te + "` supplied to `" + K + "`, expected an object."));
        for (var le in ae)
          if (r(ae, le)) {
            var ce = H(ae, le, K, J, ne + "." + le, n);
            if (ce instanceof Error)
              return ce;
          }
        return null;
      }
      return b(q);
    }
    function P(H) {
      if (!Array.isArray(H))
        return process.env.NODE_ENV !== "production" && i("Invalid argument supplied to oneOfType, expected an instance of array."), a;
      for (var q = 0; q < H.length; q++) {
        var Q = H[q];
        if (typeof Q != "function")
          return i(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + G(Q) + " at index " + q + "."
          ), a;
      }
      function X(K, J, ne, ae, te) {
        for (var le = [], ce = 0; ce < H.length; ce++) {
          var fe = H[ce], ee = fe(K, J, ne, ae, te, n);
          if (ee == null)
            return null;
          ee.data && r(ee.data, "expectedType") && le.push(ee.data.expectedType);
        }
        var me = le.length > 0 ? ", expected one of type [" + le.join(", ") + "]" : "";
        return new g("Invalid " + ae + " `" + te + "` supplied to " + ("`" + ne + "`" + me + "."));
      }
      return b(X);
    }
    function A() {
      function H(q, Q, X, K, J) {
        return $(q[Q]) ? null : new g("Invalid " + K + " `" + J + "` supplied to " + ("`" + X + "`, expected a ReactNode."));
      }
      return b(H);
    }
    function D(H, q, Q, X, K) {
      return new g(
        (H || "React class") + ": " + q + " type `" + Q + "." + X + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + K + "`."
      );
    }
    function N(H) {
      function q(Q, X, K, J, ne) {
        var ae = Q[X], te = j(ae);
        if (te !== "object")
          return new g("Invalid " + J + " `" + ne + "` of type `" + te + "` " + ("supplied to `" + K + "`, expected `object`."));
        for (var le in H) {
          var ce = H[le];
          if (typeof ce != "function")
            return D(K, J, ne, le, U(ce));
          var fe = ce(ae, le, K, J, ne + "." + le, n);
          if (fe)
            return fe;
        }
        return null;
      }
      return b(q);
    }
    function F(H) {
      function q(Q, X, K, J, ne) {
        var ae = Q[X], te = j(ae);
        if (te !== "object")
          return new g("Invalid " + J + " `" + ne + "` of type `" + te + "` " + ("supplied to `" + K + "`, expected `object`."));
        var le = t({}, Q[X], H);
        for (var ce in le) {
          var fe = H[ce];
          if (r(H, ce) && typeof fe != "function")
            return D(K, J, ne, ce, U(fe));
          if (!fe)
            return new g(
              "Invalid " + J + " `" + ne + "` key `" + ce + "` supplied to `" + K + "`.\nBad object: " + JSON.stringify(Q[X], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(H), null, "  ")
            );
          var ee = fe(ae, ce, K, J, ne + "." + ce, n);
          if (ee)
            return ee;
        }
        return null;
      }
      return b(q);
    }
    function $(H) {
      switch (typeof H) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !H;
        case "object":
          if (Array.isArray(H))
            return H.every($);
          if (H === null || s(H))
            return !0;
          var q = f(H);
          if (q) {
            var Q = q.call(H), X;
            if (q !== H.entries) {
              for (; !(X = Q.next()).done; )
                if (!$(X.value))
                  return !1;
            } else
              for (; !(X = Q.next()).done; ) {
                var K = X.value;
                if (K && !$(K[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function I(H, q) {
      return H === "symbol" ? !0 : q ? q["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && q instanceof Symbol : !1;
    }
    function j(H) {
      var q = typeof H;
      return Array.isArray(H) ? "array" : H instanceof RegExp ? "object" : I(q, H) ? "symbol" : q;
    }
    function U(H) {
      if (typeof H == "undefined" || H === null)
        return "" + H;
      var q = j(H);
      if (q === "object") {
        if (H instanceof Date)
          return "date";
        if (H instanceof RegExp)
          return "regexp";
      }
      return q;
    }
    function G(H) {
      var q = U(H);
      switch (q) {
        case "array":
        case "object":
          return "an " + q;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + q;
        default:
          return q;
      }
    }
    function V(H) {
      return !H.constructor || !H.constructor.name ? p : H.constructor.name;
    }
    return m.checkPropTypes = o, m.resetWarningCache = o.resetWarningCache, m.PropTypes = m, m;
  }, Kv;
}
var Jv, SS;
function J7() {
  if (SS)
    return Jv;
  SS = 1;
  var e = L_();
  function t() {
  }
  function n() {
  }
  return n.resetWarningCache = t, Jv = function() {
    function r(a, s, c, l, d, f) {
      if (f !== e) {
        var p = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw p.name = "Invariant Violation", p;
      }
    }
    r.isRequired = r;
    function o() {
      return r;
    }
    var i = {
      array: r,
      bigint: r,
      bool: r,
      func: r,
      number: r,
      object: r,
      string: r,
      symbol: r,
      any: r,
      arrayOf: o,
      element: r,
      elementType: r,
      instanceOf: o,
      node: r,
      objectOf: o,
      oneOf: o,
      oneOfType: o,
      shape: o,
      exact: o,
      checkPropTypes: n,
      resetWarningCache: t
    };
    return i.PropTypes = i, i;
  }, Jv;
}
var TS;
function B3() {
  if (TS)
    return xh;
  if (TS = 1, process.env.NODE_ENV !== "production") {
    var e = F3(), t = !0;
    hS.exports = K7()(e.isElement, t);
  } else
    hS.exports = J7()();
  return xh;
}
var Q7 = B3();
const y = /* @__PURE__ */ ji(Q7);
function H3(e) {
  var t, n, r = "";
  if (typeof e == "string" || typeof e == "number")
    r += e;
  else if (typeof e == "object")
    if (Array.isArray(e)) {
      var o = e.length;
      for (t = 0; t < o; t++)
        e[t] && (n = H3(e[t])) && (r && (r += " "), r += n);
    } else
      for (n in e)
        e[n] && (r && (r += " "), r += n);
  return r;
}
function Qe() {
  for (var e, t, n = 0, r = "", o = arguments.length; n < o; n++)
    (e = arguments[n]) && (t = H3(e)) && (r && (r += " "), r += t);
  return r;
}
function e9(e) {
  const t = typeof e;
  switch (t) {
    case "number":
      return Number.isNaN(e) ? "NaN" : Number.isFinite(e) ? e !== Math.floor(e) ? "float" : "number" : "Infinity";
    case "object":
      return e === null ? "null" : e.constructor.name;
    default:
      return t;
  }
}
function t9(e) {
  return typeof e == "number" && isFinite(e) && Math.floor(e) === e;
}
const n9 = Number.isInteger || t9;
function j3(e, t, n, r) {
  const o = e[t];
  if (o == null || !n9(o)) {
    const i = e9(o);
    return new RangeError(`Invalid ${r} \`${t}\` of type \`${i}\` supplied to \`${n}\`, expected \`integer\`.`);
  }
  return null;
}
function W3(e, t, ...n) {
  return e[t] === void 0 ? null : j3(e, t, ...n);
}
function Xb() {
  return null;
}
W3.isRequired = j3;
Xb.isRequired = Xb;
const Si = process.env.NODE_ENV === "production" ? Xb : W3;
function fs(e, t) {
  return process.env.NODE_ENV === "production" ? () => null : function(...n) {
    return e(...n) || t(...n);
  };
}
function Ad(e) {
  return typeof e == "string";
}
function Qu(e, t, n) {
  return e === void 0 || Ad(e) ? t : re({}, t, {
    ownerState: re({}, t.ownerState, n)
  });
}
const r9 = {
  disableDefaultClasses: !1
}, V3 = /* @__PURE__ */ B.createContext(r9);
process.env.NODE_ENV !== "production" && (V3.displayName = "ClassNameConfiguratorContext");
function o9(e) {
  const {
    disableDefaultClasses: t
  } = B.useContext(V3);
  return (n) => t ? "" : e(n);
}
function U3(e, t = []) {
  if (e === void 0)
    return {};
  const n = {};
  return Object.keys(e).filter((r) => r.match(/^on[A-Z]/) && typeof e[r] == "function" && !t.includes(r)).forEach((r) => {
    n[r] = e[r];
  }), n;
}
function i9(e, t, n) {
  return typeof e == "function" ? e(t, n) : e;
}
function Wa(e) {
  if (typeof e != "object" || e === null)
    return !1;
  const t = Object.getPrototypeOf(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}
function q3(e) {
  if (!Wa(e))
    return e;
  const t = {};
  return Object.keys(e).forEach((n) => {
    t[n] = q3(e[n]);
  }), t;
}
function co(e, t, n = {
  clone: !0
}) {
  const r = n.clone ? re({}, e) : e;
  return Wa(e) && Wa(t) && Object.keys(t).forEach((o) => {
    o !== "__proto__" && (Wa(t[o]) && o in e && Wa(e[o]) ? r[o] = co(e[o], t[o], n) : n.clone ? r[o] = Wa(t[o]) ? q3(t[o]) : t[o] : r[o] = t[o]);
  }), r;
}
const a9 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: co,
  isPlainObject: Wa
}, Symbol.toStringTag, { value: "Module" }));
function s9(e) {
  const {
    prototype: t = {}
  } = e;
  return !!t.isReactComponent;
}
function G3(e, t, n, r, o) {
  const i = e[t], a = o || t;
  if (i == null || // When server-side rendering React doesn't warn either.
  // This is not an accurate check for SSR.
  // This is only in place for Emotion compat.
  // TODO: Revisit once https://github.com/facebook/react/issues/20047 is resolved.
  typeof window == "undefined")
    return null;
  let s;
  const c = i.type;
  return typeof c == "function" && !s9(c) && (s = "Did you accidentally use a plain function component for an element instead?"), s !== void 0 ? new Error(`Invalid ${r} \`${a}\` supplied to \`${n}\`. Expected an element that can hold a ref. ${s} For more information see https://mui.com/r/caveat-with-refs-guide`) : null;
}
const Y3 = fs(y.element, G3);
Y3.isRequired = fs(y.element.isRequired, G3);
const ff = Y3;
function l9(e) {
  const {
    prototype: t = {}
  } = e;
  return !!t.isReactComponent;
}
function c9(e, t, n, r, o) {
  const i = e[t], a = o || t;
  if (i == null || // When server-side rendering React doesn't warn either.
  // This is not an accurate check for SSR.
  // This is only in place for emotion compat.
  // TODO: Revisit once https://github.com/facebook/react/issues/20047 is resolved.
  typeof window == "undefined")
    return null;
  let s;
  return typeof i == "function" && !l9(i) && (s = "Did you accidentally provide a plain function component instead?"), s !== void 0 ? new Error(`Invalid ${r} \`${a}\` supplied to \`${n}\`. Expected an element type that can hold a ref. ${s} For more information see https://mui.com/r/caveat-with-refs-guide`) : null;
}
const $_ = fs(y.elementType, c9), u9 = "exact-prop: ​";
function Lm(e) {
  return process.env.NODE_ENV === "production" ? e : re({}, e, {
    [u9]: (t) => {
      const n = Object.keys(t).filter((r) => !e.hasOwnProperty(r));
      return n.length > 0 ? new Error(`The following props are not supported: ${n.map((r) => `\`${r}\``).join(", ")}. Please remove them.`) : null;
    }
  });
}
function Gs(e) {
  let t = "https://mui.com/production-error/?code=" + e;
  for (let n = 1; n < arguments.length; n += 1)
    t += "&args[]=" + encodeURIComponent(arguments[n]);
  return "Minified MUI error #" + e + "; visit " + t + " for the full message.";
}
const d9 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Gs
}, Symbol.toStringTag, { value: "Module" }));
var Kb = {}, f9 = {
  get exports() {
    return Kb;
  },
  set exports(e) {
    Kb = e;
  }
}, Dt = {};
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ES;
function p9() {
  if (ES)
    return Dt;
  ES = 1;
  var e = Symbol.for("react.element"), t = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), r = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), i = Symbol.for("react.provider"), a = Symbol.for("react.context"), s = Symbol.for("react.server_context"), c = Symbol.for("react.forward_ref"), l = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), p = Symbol.for("react.lazy"), m = Symbol.for("react.offscreen"), v;
  v = Symbol.for("react.module.reference");
  function g(b) {
    if (typeof b == "object" && b !== null) {
      var x = b.$$typeof;
      switch (x) {
        case e:
          switch (b = b.type, b) {
            case n:
            case o:
            case r:
            case l:
            case d:
              return b;
            default:
              switch (b = b && b.$$typeof, b) {
                case s:
                case a:
                case c:
                case p:
                case f:
                case i:
                  return b;
                default:
                  return x;
              }
          }
        case t:
          return x;
      }
    }
  }
  return Dt.ContextConsumer = a, Dt.ContextProvider = i, Dt.Element = e, Dt.ForwardRef = c, Dt.Fragment = n, Dt.Lazy = p, Dt.Memo = f, Dt.Portal = t, Dt.Profiler = o, Dt.StrictMode = r, Dt.Suspense = l, Dt.SuspenseList = d, Dt.isAsyncMode = function() {
    return !1;
  }, Dt.isConcurrentMode = function() {
    return !1;
  }, Dt.isContextConsumer = function(b) {
    return g(b) === a;
  }, Dt.isContextProvider = function(b) {
    return g(b) === i;
  }, Dt.isElement = function(b) {
    return typeof b == "object" && b !== null && b.$$typeof === e;
  }, Dt.isForwardRef = function(b) {
    return g(b) === c;
  }, Dt.isFragment = function(b) {
    return g(b) === n;
  }, Dt.isLazy = function(b) {
    return g(b) === p;
  }, Dt.isMemo = function(b) {
    return g(b) === f;
  }, Dt.isPortal = function(b) {
    return g(b) === t;
  }, Dt.isProfiler = function(b) {
    return g(b) === o;
  }, Dt.isStrictMode = function(b) {
    return g(b) === r;
  }, Dt.isSuspense = function(b) {
    return g(b) === l;
  }, Dt.isSuspenseList = function(b) {
    return g(b) === d;
  }, Dt.isValidElementType = function(b) {
    return typeof b == "string" || typeof b == "function" || b === n || b === o || b === r || b === l || b === d || b === m || typeof b == "object" && b !== null && (b.$$typeof === p || b.$$typeof === f || b.$$typeof === i || b.$$typeof === a || b.$$typeof === c || b.$$typeof === v || b.getModuleId !== void 0);
  }, Dt.typeOf = g, Dt;
}
var jt = {};
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var kS;
function h9() {
  return kS || (kS = 1, process.env.NODE_ENV !== "production" && function() {
    var e = Symbol.for("react.element"), t = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), r = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), i = Symbol.for("react.provider"), a = Symbol.for("react.context"), s = Symbol.for("react.server_context"), c = Symbol.for("react.forward_ref"), l = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), p = Symbol.for("react.lazy"), m = Symbol.for("react.offscreen"), v = !1, g = !1, b = !1, x = !1, T = !1, S;
    S = Symbol.for("react.module.reference");
    function _(oe) {
      return !!(typeof oe == "string" || typeof oe == "function" || oe === n || oe === o || T || oe === r || oe === l || oe === d || x || oe === m || v || g || b || typeof oe == "object" && oe !== null && (oe.$$typeof === p || oe.$$typeof === f || oe.$$typeof === i || oe.$$typeof === a || oe.$$typeof === c || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      oe.$$typeof === S || oe.getModuleId !== void 0));
    }
    function w(oe) {
      if (typeof oe == "object" && oe !== null) {
        var ve = oe.$$typeof;
        switch (ve) {
          case e:
            var we = oe.type;
            switch (we) {
              case n:
              case o:
              case r:
              case l:
              case d:
                return we;
              default:
                var ye = we && we.$$typeof;
                switch (ye) {
                  case s:
                  case a:
                  case c:
                  case p:
                  case f:
                  case i:
                    return ye;
                  default:
                    return ve;
                }
            }
          case t:
            return ve;
        }
      }
    }
    var k = a, E = i, R = e, P = c, A = n, D = p, N = f, F = t, $ = o, I = r, j = l, U = d, G = !1, V = !1;
    function H(oe) {
      return G || (G = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function q(oe) {
      return V || (V = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function Q(oe) {
      return w(oe) === a;
    }
    function X(oe) {
      return w(oe) === i;
    }
    function K(oe) {
      return typeof oe == "object" && oe !== null && oe.$$typeof === e;
    }
    function J(oe) {
      return w(oe) === c;
    }
    function ne(oe) {
      return w(oe) === n;
    }
    function ae(oe) {
      return w(oe) === p;
    }
    function te(oe) {
      return w(oe) === f;
    }
    function le(oe) {
      return w(oe) === t;
    }
    function ce(oe) {
      return w(oe) === o;
    }
    function fe(oe) {
      return w(oe) === r;
    }
    function ee(oe) {
      return w(oe) === l;
    }
    function me(oe) {
      return w(oe) === d;
    }
    jt.ContextConsumer = k, jt.ContextProvider = E, jt.Element = R, jt.ForwardRef = P, jt.Fragment = A, jt.Lazy = D, jt.Memo = N, jt.Portal = F, jt.Profiler = $, jt.StrictMode = I, jt.Suspense = j, jt.SuspenseList = U, jt.isAsyncMode = H, jt.isConcurrentMode = q, jt.isContextConsumer = Q, jt.isContextProvider = X, jt.isElement = K, jt.isForwardRef = J, jt.isFragment = ne, jt.isLazy = ae, jt.isMemo = te, jt.isPortal = le, jt.isProfiler = ce, jt.isStrictMode = fe, jt.isSuspense = ee, jt.isSuspenseList = me, jt.isValidElementType = _, jt.typeOf = w;
  }()), jt;
}
var MS;
function m9() {
  return MS || (MS = 1, function(e) {
    process.env.NODE_ENV === "production" ? e.exports = p9() : e.exports = h9();
  }(f9)), Kb;
}
var la = m9();
const g9 = /^\s*function(?:\s|\s*\/\*.*\*\/\s*)+([^(\s/]*)\s*/;
function Z3(e) {
  const t = `${e}`.match(g9);
  return t && t[1] || "";
}
function X3(e, t = "") {
  return e.displayName || e.name || Z3(e) || t;
}
function RS(e, t, n) {
  const r = X3(t);
  return e.displayName || (r !== "" ? `${n}(${r})` : n);
}
function v9(e) {
  if (e != null) {
    if (typeof e == "string")
      return e;
    if (typeof e == "function")
      return X3(e, "Component");
    if (typeof e == "object")
      switch (e.$$typeof) {
        case la.ForwardRef:
          return RS(e, e.render, "ForwardRef");
        case la.Memo:
          return RS(e, e.type, "memo");
        default:
          return;
      }
  }
}
const b9 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: v9,
  getFunctionName: Z3
}, Symbol.toStringTag, { value: "Module" }));
function fa(e, t, n, r, o) {
  if (process.env.NODE_ENV === "production")
    return null;
  const i = e[t], a = o || t;
  return i == null ? null : i && i.nodeType !== 1 ? new Error(`Invalid ${r} \`${a}\` supplied to \`${n}\`. Expected an HTMLElement.`) : null;
}
const y9 = y.oneOfType([y.func, y.object]), Yo = y9;
function at(e) {
  if (typeof e != "string")
    throw new Error(process.env.NODE_ENV !== "production" ? "MUI: `capitalize(string)` expects a string argument." : Gs(7));
  return e.charAt(0).toUpperCase() + e.slice(1);
}
const _9 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: at
}, Symbol.toStringTag, { value: "Module" }));
function PS(...e) {
  return e.reduce((t, n) => n == null ? t : function(...r) {
    t.apply(this, r), n.apply(this, r);
  }, () => {
  });
}
function K3(e, t = 166) {
  let n;
  function r(...o) {
    const i = () => {
      e.apply(this, o);
    };
    clearTimeout(n), n = setTimeout(i, t);
  }
  return r.clear = () => {
    clearTimeout(n);
  }, r;
}
function Ar(e) {
  return e && e.ownerDocument || document;
}
function Ys(e) {
  return Ar(e).defaultView || window;
}
function Jb(e, t) {
  typeof e == "function" ? e(t) : e && (e.current = t);
}
const w9 = typeof window != "undefined" ? B.useLayoutEffect : B.useEffect, $i = w9;
let OS = 0;
function x9(e) {
  const [t, n] = B.useState(e), r = e || t;
  return B.useEffect(() => {
    t == null && (OS += 1, n(`mui-${OS}`));
  }, [t]), r;
}
const NS = B[`useId${Math.random()}`.slice(0, 5)];
function Ch(e) {
  if (NS !== void 0) {
    const t = NS();
    return e != null ? e : t;
  }
  return x9(e);
}
function Dd({
  controlled: e,
  default: t,
  name: n,
  state: r = "value"
}) {
  const {
    current: o
  } = B.useRef(e !== void 0), [i, a] = B.useState(t), s = o ? e : i;
  if (process.env.NODE_ENV !== "production") {
    B.useEffect(() => {
      o !== (e !== void 0) && console.error([`MUI: A component is changing the ${o ? "" : "un"}controlled ${r} state of ${n} to be ${o ? "un" : ""}controlled.`, "Elements should not switch from uncontrolled to controlled (or vice versa).", `Decide between using a controlled or uncontrolled ${n} element for the lifetime of the component.`, "The nature of the state is determined during the first render. It's considered controlled if the value is not `undefined`.", "More info: https://fb.me/react-controlled-components"].join(`
`));
    }, [r, n, e]);
    const {
      current: l
    } = B.useRef(t);
    B.useEffect(() => {
      !o && l !== t && console.error([`MUI: A component is changing the default ${r} state of an uncontrolled ${n} after being initialized. To suppress this warning opt to use a controlled ${n}.`].join(`
`));
    }, [JSON.stringify(t)]);
  }
  const c = B.useCallback((l) => {
    o || a(l);
  }, []);
  return [s, c];
}
function Ya(e) {
  const t = B.useRef(e);
  return $i(() => {
    t.current = e;
  }), B.useRef((...n) => (
    // @ts-expect-error hide `this`
    (0, t.current)(...n)
  )).current;
}
function or(...e) {
  return B.useMemo(() => e.every((t) => t == null) ? null : (t) => {
    e.forEach((n) => {
      Jb(n, t);
    });
  }, e);
}
const AS = {};
function C9(e, t) {
  const n = B.useRef(AS);
  return n.current === AS && (n.current = e(t)), n;
}
const S9 = [];
function T9(e) {
  B.useEffect(e, S9);
}
class pf {
  constructor() {
    this.currentId = null, this.clear = () => {
      this.currentId !== null && (clearTimeout(this.currentId), this.currentId = null);
    }, this.disposeEffect = () => this.clear;
  }
  static create() {
    return new pf();
  }
  /**
   * Executes `fn` after `delay`, clearing any previously scheduled call.
   */
  start(t, n) {
    this.clear(), this.currentId = setTimeout(() => {
      this.currentId = null, n();
    }, t);
  }
}
function tc() {
  const e = C9(pf.create).current;
  return T9(e.disposeEffect), e;
}
let $m = !0, Qb = !1;
const E9 = new pf(), k9 = {
  text: !0,
  search: !0,
  url: !0,
  tel: !0,
  email: !0,
  password: !0,
  number: !0,
  date: !0,
  month: !0,
  week: !0,
  time: !0,
  datetime: !0,
  "datetime-local": !0
};
function M9(e) {
  const {
    type: t,
    tagName: n
  } = e;
  return !!(n === "INPUT" && k9[t] && !e.readOnly || n === "TEXTAREA" && !e.readOnly || e.isContentEditable);
}
function R9(e) {
  e.metaKey || e.altKey || e.ctrlKey || ($m = !0);
}
function Qv() {
  $m = !1;
}
function P9() {
  this.visibilityState === "hidden" && Qb && ($m = !0);
}
function O9(e) {
  e.addEventListener("keydown", R9, !0), e.addEventListener("mousedown", Qv, !0), e.addEventListener("pointerdown", Qv, !0), e.addEventListener("touchstart", Qv, !0), e.addEventListener("visibilitychange", P9, !0);
}
function N9(e) {
  const {
    target: t
  } = e;
  try {
    return t.matches(":focus-visible");
  } catch (n) {
  }
  return $m || M9(t);
}
function J3() {
  const e = B.useCallback((o) => {
    o != null && O9(o.ownerDocument);
  }, []), t = B.useRef(!1);
  function n() {
    return t.current ? (Qb = !0, E9.start(100, () => {
      Qb = !1;
    }), t.current = !1, !0) : !1;
  }
  function r(o) {
    return N9(o) ? (t.current = !0, !0) : !1;
  }
  return {
    isFocusVisibleRef: t,
    onFocus: r,
    onBlur: n,
    ref: e
  };
}
function Q3(e) {
  const t = e.documentElement.clientWidth;
  return Math.abs(window.innerWidth - t);
}
function eN(e, t) {
  const n = re({}, t);
  return Object.keys(e).forEach((r) => {
    if (r.toString().match(/^(components|slots)$/))
      n[r] = re({}, e[r], n[r]);
    else if (r.toString().match(/^(componentsProps|slotProps)$/)) {
      const o = e[r] || {}, i = t[r];
      n[r] = {}, !i || !Object.keys(i) ? n[r] = o : !o || !Object.keys(o) ? n[r] = i : (n[r] = re({}, i), Object.keys(o).forEach((a) => {
        n[r][a] = eN(o[a], i[a]);
      }));
    } else
      n[r] === void 0 && (n[r] = e[r]);
  }), n;
}
function Yt(e, t, n = void 0) {
  const r = {};
  return Object.keys(e).forEach(
    // `Object.keys(slots)` can't be wider than `T` because we infer `T` from `slots`.
    // @ts-expect-error https://github.com/microsoft/TypeScript/pull/12253#issuecomment-263132208
    (o) => {
      r[o] = e[o].reduce((i, a) => {
        if (a) {
          const s = t(a);
          s !== "" && i.push(s), n && n[a] && i.push(n[a]);
        }
        return i;
      }, []).join(" ");
    }
  ), r;
}
const DS = (e) => e, A9 = () => {
  let e = DS;
  return {
    configure(t) {
      e = t;
    },
    generate(t) {
      return e(t);
    },
    reset() {
      e = DS;
    }
  };
}, D9 = A9(), I9 = D9, tN = {
  active: "active",
  checked: "checked",
  completed: "completed",
  disabled: "disabled",
  error: "error",
  expanded: "expanded",
  focused: "focused",
  focusVisible: "focusVisible",
  open: "open",
  readOnly: "readOnly",
  required: "required",
  selected: "selected"
};
function Gt(e, t, n = "Mui") {
  const r = tN[t];
  return r ? `${n}-${r}` : `${I9.generate(e)}-${t}`;
}
function Wt(e, t, n = "Mui") {
  const r = {};
  return t.forEach((o) => {
    r[o] = Gt(e, o, n);
  }), r;
}
function L9(e, t = Number.MIN_SAFE_INTEGER, n = Number.MAX_SAFE_INTEGER) {
  return Math.max(t, Math.min(e, n));
}
const $9 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: L9
}, Symbol.toStringTag, { value: "Module" }));
function IS(e) {
  if (e === void 0)
    return {};
  const t = {};
  return Object.keys(e).filter((n) => !(n.match(/^on[A-Z]/) && typeof e[n] == "function")).forEach((n) => {
    t[n] = e[n];
  }), t;
}
function F9(e) {
  const {
    getSlotProps: t,
    additionalProps: n,
    externalSlotProps: r,
    externalForwardedProps: o,
    className: i
  } = e;
  if (!t) {
    const m = Qe(n == null ? void 0 : n.className, i, o == null ? void 0 : o.className, r == null ? void 0 : r.className), v = re({}, n == null ? void 0 : n.style, o == null ? void 0 : o.style, r == null ? void 0 : r.style), g = re({}, n, o, r);
    return m.length > 0 && (g.className = m), Object.keys(v).length > 0 && (g.style = v), {
      props: g,
      internalRef: void 0
    };
  }
  const a = U3(re({}, o, r)), s = IS(r), c = IS(o), l = t(a), d = Qe(l == null ? void 0 : l.className, n == null ? void 0 : n.className, i, o == null ? void 0 : o.className, r == null ? void 0 : r.className), f = re({}, l == null ? void 0 : l.style, n == null ? void 0 : n.style, o == null ? void 0 : o.style, r == null ? void 0 : r.style), p = re({}, l, n, c, s);
  return d.length > 0 && (p.className = d), Object.keys(f).length > 0 && (p.style = f), {
    props: p,
    internalRef: l.ref
  };
}
const z9 = ["elementType", "externalSlotProps", "ownerState", "skipResolvingSlotProps"];
function Zs(e) {
  var t;
  const {
    elementType: n,
    externalSlotProps: r,
    ownerState: o,
    skipResolvingSlotProps: i = !1
  } = e, a = He(e, z9), s = i ? {} : i9(r, o), {
    props: c,
    internalRef: l
  } = F9(re({}, a, {
    externalSlotProps: s
  })), d = or(l, s == null ? void 0 : s.ref, (t = e.additionalProps) == null ? void 0 : t.ref);
  return Qu(n, re({}, c, {
    ref: d
  }), o);
}
var Rs = {}, ey = {}, B9 = {
  get exports() {
    return ey;
  },
  set exports(e) {
    ey = e;
  }
}, LS;
function nN() {
  return LS || (LS = 1, function(e) {
    function t(n) {
      return n && n.__esModule ? n : {
        default: n
      };
    }
    e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(B9)), ey;
}
var ty = {}, H9 = {
  get exports() {
    return ty;
  },
  set exports(e) {
    ty = e;
  }
}, $S;
function j9() {
  return $S || ($S = 1, function(e) {
    function t() {
      return e.exports = t = Object.assign ? Object.assign.bind() : function(n) {
        for (var r = 1; r < arguments.length; r++) {
          var o = arguments[r];
          for (var i in o)
            Object.prototype.hasOwnProperty.call(o, i) && (n[i] = o[i]);
        }
        return n;
      }, e.exports.__esModule = !0, e.exports.default = e.exports, t.apply(this, arguments);
    }
    e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(H9)), ty;
}
var ny = {}, W9 = {
  get exports() {
    return ny;
  },
  set exports(e) {
    ny = e;
  }
}, FS;
function V9() {
  return FS || (FS = 1, function(e) {
    function t(n, r) {
      if (n == null)
        return {};
      var o = {};
      for (var i in n)
        if (Object.prototype.hasOwnProperty.call(n, i)) {
          if (r.indexOf(i) >= 0)
            continue;
          o[i] = n[i];
        }
      return o;
    }
    e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(W9)), ny;
}
function U9(e) {
  if (e.sheet)
    return e.sheet;
  for (var t = 0; t < document.styleSheets.length; t++)
    if (document.styleSheets[t].ownerNode === e)
      return document.styleSheets[t];
}
function q9(e) {
  var t = document.createElement("style");
  return t.setAttribute("data-emotion", e.key), e.nonce !== void 0 && t.setAttribute("nonce", e.nonce), t.appendChild(document.createTextNode("")), t.setAttribute("data-s", ""), t;
}
var G9 = /* @__PURE__ */ function() {
  function e(n) {
    var r = this;
    this._insertTag = function(o) {
      var i;
      r.tags.length === 0 ? r.insertionPoint ? i = r.insertionPoint.nextSibling : r.prepend ? i = r.container.firstChild : i = r.before : i = r.tags[r.tags.length - 1].nextSibling, r.container.insertBefore(o, i), r.tags.push(o);
    }, this.isSpeedy = n.speedy === void 0 ? process.env.NODE_ENV === "production" : n.speedy, this.tags = [], this.ctr = 0, this.nonce = n.nonce, this.key = n.key, this.container = n.container, this.prepend = n.prepend, this.insertionPoint = n.insertionPoint, this.before = null;
  }
  var t = e.prototype;
  return t.hydrate = function(n) {
    n.forEach(this._insertTag);
  }, t.insert = function(n) {
    this.ctr % (this.isSpeedy ? 65e3 : 1) === 0 && this._insertTag(q9(this));
    var r = this.tags[this.tags.length - 1];
    if (process.env.NODE_ENV !== "production") {
      var o = n.charCodeAt(0) === 64 && n.charCodeAt(1) === 105;
      o && this._alreadyInsertedOrderInsensitiveRule && console.error(`You're attempting to insert the following rule:
` + n + "\n\n`@import` rules must be before all other types of rules in a stylesheet but other rules have already been inserted. Please ensure that `@import` rules are before all other rules."), this._alreadyInsertedOrderInsensitiveRule = this._alreadyInsertedOrderInsensitiveRule || !o;
    }
    if (this.isSpeedy) {
      var i = U9(r);
      try {
        i.insertRule(n, i.cssRules.length);
      } catch (a) {
        process.env.NODE_ENV !== "production" && !/:(-moz-placeholder|-moz-focus-inner|-moz-focusring|-ms-input-placeholder|-moz-read-write|-moz-read-only|-ms-clear|-ms-expand|-ms-reveal){/.test(n) && console.error('There was a problem inserting the following rule: "' + n + '"', a);
      }
    } else
      r.appendChild(document.createTextNode(n));
    this.ctr++;
  }, t.flush = function() {
    this.tags.forEach(function(n) {
      return n.parentNode && n.parentNode.removeChild(n);
    }), this.tags = [], this.ctr = 0, process.env.NODE_ENV !== "production" && (this._alreadyInsertedOrderInsensitiveRule = !1);
  }, e;
}(), yr = "-ms-", Sh = "-moz-", Rt = "-webkit-", F_ = "comm", z_ = "rule", B_ = "decl", Y9 = "@import", rN = "@keyframes", Z9 = "@layer", X9 = Math.abs, Fm = String.fromCharCode, K9 = Object.assign;
function J9(e, t) {
  return pr(e, 0) ^ 45 ? (((t << 2 ^ pr(e, 0)) << 2 ^ pr(e, 1)) << 2 ^ pr(e, 2)) << 2 ^ pr(e, 3) : 0;
}
function oN(e) {
  return e.trim();
}
function Q9(e, t) {
  return (e = t.exec(e)) ? e[0] : e;
}
function Ot(e, t, n) {
  return e.replace(t, n);
}
function ry(e, t) {
  return e.indexOf(t);
}
function pr(e, t) {
  return e.charCodeAt(t) | 0;
}
function Id(e, t, n) {
  return e.slice(t, n);
}
function xi(e) {
  return e.length;
}
function H_(e) {
  return e.length;
}
function rp(e, t) {
  return t.push(e), e;
}
function eV(e, t) {
  return e.map(t).join("");
}
var zm = 1, yc = 1, iN = 0, Xr = 0, Hn = 0, qc = "";
function Bm(e, t, n, r, o, i, a) {
  return { value: e, root: t, parent: n, type: r, props: o, children: i, line: zm, column: yc, length: a, return: "" };
}
function Tu(e, t) {
  return K9(Bm("", null, null, "", null, null, 0), e, { length: -e.length }, t);
}
function tV() {
  return Hn;
}
function nV() {
  return Hn = Xr > 0 ? pr(qc, --Xr) : 0, yc--, Hn === 10 && (yc = 1, zm--), Hn;
}
function uo() {
  return Hn = Xr < iN ? pr(qc, Xr++) : 0, yc++, Hn === 10 && (yc = 1, zm++), Hn;
}
function Oi() {
  return pr(qc, Xr);
}
function Up() {
  return Xr;
}
function hf(e, t) {
  return Id(qc, e, t);
}
function Ld(e) {
  switch (e) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function aN(e) {
  return zm = yc = 1, iN = xi(qc = e), Xr = 0, [];
}
function sN(e) {
  return qc = "", e;
}
function qp(e) {
  return oN(hf(Xr - 1, oy(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function rV(e) {
  for (; (Hn = Oi()) && Hn < 33; )
    uo();
  return Ld(e) > 2 || Ld(Hn) > 3 ? "" : " ";
}
function oV(e, t) {
  for (; --t && uo() && !(Hn < 48 || Hn > 102 || Hn > 57 && Hn < 65 || Hn > 70 && Hn < 97); )
    ;
  return hf(e, Up() + (t < 6 && Oi() == 32 && uo() == 32));
}
function oy(e) {
  for (; uo(); )
    switch (Hn) {
      case e:
        return Xr;
      case 34:
      case 39:
        e !== 34 && e !== 39 && oy(Hn);
        break;
      case 40:
        e === 41 && oy(e);
        break;
      case 92:
        uo();
        break;
    }
  return Xr;
}
function iV(e, t) {
  for (; uo() && e + Hn !== 57 && !(e + Hn === 84 && Oi() === 47); )
    ;
  return "/*" + hf(t, Xr - 1) + "*" + Fm(e === 47 ? e : uo());
}
function aV(e) {
  for (; !Ld(Oi()); )
    uo();
  return hf(e, Xr);
}
function sV(e) {
  return sN(Gp("", null, null, null, [""], e = aN(e), 0, [0], e));
}
function Gp(e, t, n, r, o, i, a, s, c) {
  for (var l = 0, d = 0, f = a, p = 0, m = 0, v = 0, g = 1, b = 1, x = 1, T = 0, S = "", _ = o, w = i, k = r, E = S; b; )
    switch (v = T, T = uo()) {
      case 40:
        if (v != 108 && pr(E, f - 1) == 58) {
          ry(E += Ot(qp(T), "&", "&\f"), "&\f") != -1 && (x = -1);
          break;
        }
      case 34:
      case 39:
      case 91:
        E += qp(T);
        break;
      case 9:
      case 10:
      case 13:
      case 32:
        E += rV(v);
        break;
      case 92:
        E += oV(Up() - 1, 7);
        continue;
      case 47:
        switch (Oi()) {
          case 42:
          case 47:
            rp(lV(iV(uo(), Up()), t, n), c);
            break;
          default:
            E += "/";
        }
        break;
      case 123 * g:
        s[l++] = xi(E) * x;
      case 125 * g:
      case 59:
      case 0:
        switch (T) {
          case 0:
          case 125:
            b = 0;
          case 59 + d:
            x == -1 && (E = Ot(E, /\f/g, "")), m > 0 && xi(E) - f && rp(m > 32 ? BS(E + ";", r, n, f - 1) : BS(Ot(E, " ", "") + ";", r, n, f - 2), c);
            break;
          case 59:
            E += ";";
          default:
            if (rp(k = zS(E, t, n, l, d, o, s, S, _ = [], w = [], f), i), T === 123)
              if (d === 0)
                Gp(E, t, k, k, _, i, f, s, w);
              else
                switch (p === 99 && pr(E, 3) === 110 ? 100 : p) {
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    Gp(e, k, k, r && rp(zS(e, k, k, 0, 0, o, s, S, o, _ = [], f), w), o, w, f, s, r ? _ : w);
                    break;
                  default:
                    Gp(E, k, k, k, [""], w, 0, s, w);
                }
        }
        l = d = m = 0, g = x = 1, S = E = "", f = a;
        break;
      case 58:
        f = 1 + xi(E), m = v;
      default:
        if (g < 1) {
          if (T == 123)
            --g;
          else if (T == 125 && g++ == 0 && nV() == 125)
            continue;
        }
        switch (E += Fm(T), T * g) {
          case 38:
            x = d > 0 ? 1 : (E += "\f", -1);
            break;
          case 44:
            s[l++] = (xi(E) - 1) * x, x = 1;
            break;
          case 64:
            Oi() === 45 && (E += qp(uo())), p = Oi(), d = f = xi(S = E += aV(Up())), T++;
            break;
          case 45:
            v === 45 && xi(E) == 2 && (g = 0);
        }
    }
  return i;
}
function zS(e, t, n, r, o, i, a, s, c, l, d) {
  for (var f = o - 1, p = o === 0 ? i : [""], m = H_(p), v = 0, g = 0, b = 0; v < r; ++v)
    for (var x = 0, T = Id(e, f + 1, f = X9(g = a[v])), S = e; x < m; ++x)
      (S = oN(g > 0 ? p[x] + " " + T : Ot(T, /&\f/g, p[x]))) && (c[b++] = S);
  return Bm(e, t, n, o === 0 ? z_ : s, c, l, d);
}
function lV(e, t, n) {
  return Bm(e, t, n, F_, Fm(tV()), Id(e, 2, -2), 0);
}
function BS(e, t, n, r) {
  return Bm(e, t, n, B_, Id(e, 0, r), Id(e, r + 1, -1), r);
}
function uc(e, t) {
  for (var n = "", r = H_(e), o = 0; o < r; o++)
    n += t(e[o], o, e, t) || "";
  return n;
}
function cV(e, t, n, r) {
  switch (e.type) {
    case Z9:
      if (e.children.length)
        break;
    case Y9:
    case B_:
      return e.return = e.return || e.value;
    case F_:
      return "";
    case rN:
      return e.return = e.value + "{" + uc(e.children, r) + "}";
    case z_:
      e.value = e.props.join(",");
  }
  return xi(n = uc(e.children, r)) ? e.return = e.value + "{" + n + "}" : "";
}
function uV(e) {
  var t = H_(e);
  return function(n, r, o, i) {
    for (var a = "", s = 0; s < t; s++)
      a += e[s](n, r, o, i) || "";
    return a;
  };
}
function dV(e) {
  return function(t) {
    t.root || (t = t.return) && e(t);
  };
}
var fV = function(e, t, n) {
  for (var r = 0, o = 0; r = o, o = Oi(), r === 38 && o === 12 && (t[n] = 1), !Ld(o); )
    uo();
  return hf(e, Xr);
}, pV = function(e, t) {
  var n = -1, r = 44;
  do
    switch (Ld(r)) {
      case 0:
        r === 38 && Oi() === 12 && (t[n] = 1), e[n] += fV(Xr - 1, t, n);
        break;
      case 2:
        e[n] += qp(r);
        break;
      case 4:
        if (r === 44) {
          e[++n] = Oi() === 58 ? "&\f" : "", t[n] = e[n].length;
          break;
        }
      default:
        e[n] += Fm(r);
    }
  while (r = uo());
  return e;
}, hV = function(e, t) {
  return sN(pV(aN(e), t));
}, HS = /* @__PURE__ */ new WeakMap(), mV = function(e) {
  if (!(e.type !== "rule" || !e.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  e.length < 1)) {
    for (var t = e.value, n = e.parent, r = e.column === n.column && e.line === n.line; n.type !== "rule"; )
      if (n = n.parent, !n)
        return;
    if (!(e.props.length === 1 && t.charCodeAt(0) !== 58 && !HS.get(n)) && !r) {
      HS.set(e, !0);
      for (var o = [], i = hV(t, o), a = n.props, s = 0, c = 0; s < i.length; s++)
        for (var l = 0; l < a.length; l++, c++)
          e.props[c] = o[s] ? i[s].replace(/&\f/g, a[l]) : a[l] + " " + i[s];
    }
  }
}, gV = function(e) {
  if (e.type === "decl") {
    var t = e.value;
    t.charCodeAt(0) === 108 && // charcode for b
    t.charCodeAt(2) === 98 && (e.return = "", e.value = "");
  }
}, vV = "emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason", bV = function(e) {
  return e.type === "comm" && e.children.indexOf(vV) > -1;
}, yV = function(e) {
  return function(t, n, r) {
    if (!(t.type !== "rule" || e.compat)) {
      var o = t.value.match(/(:first|:nth|:nth-last)-child/g);
      if (o) {
        for (var i = !!t.parent, a = i ? t.parent.children : (
          // global rule at the root level
          r
        ), s = a.length - 1; s >= 0; s--) {
          var c = a[s];
          if (c.line < t.line)
            break;
          if (c.column < t.column) {
            if (bV(c))
              return;
            break;
          }
        }
        o.forEach(function(l) {
          console.error('The pseudo class "' + l + '" is potentially unsafe when doing server-side rendering. Try changing it to "' + l.split("-child")[0] + '-of-type".');
        });
      }
    }
  };
}, lN = function(e) {
  return e.type.charCodeAt(1) === 105 && e.type.charCodeAt(0) === 64;
}, _V = function(e, t) {
  for (var n = e - 1; n >= 0; n--)
    if (!lN(t[n]))
      return !0;
  return !1;
}, jS = function(e) {
  e.type = "", e.value = "", e.return = "", e.children = "", e.props = "";
}, wV = function(e, t, n) {
  lN(e) && (e.parent ? (console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles."), jS(e)) : _V(t, n) && (console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules."), jS(e)));
};
function cN(e, t) {
  switch (J9(e, t)) {
    case 5103:
      return Rt + "print-" + e + e;
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return Rt + e + e;
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return Rt + e + Sh + e + yr + e + e;
    case 6828:
    case 4268:
      return Rt + e + yr + e + e;
    case 6165:
      return Rt + e + yr + "flex-" + e + e;
    case 5187:
      return Rt + e + Ot(e, /(\w+).+(:[^]+)/, Rt + "box-$1$2" + yr + "flex-$1$2") + e;
    case 5443:
      return Rt + e + yr + "flex-item-" + Ot(e, /flex-|-self/, "") + e;
    case 4675:
      return Rt + e + yr + "flex-line-pack" + Ot(e, /align-content|flex-|-self/, "") + e;
    case 5548:
      return Rt + e + yr + Ot(e, "shrink", "negative") + e;
    case 5292:
      return Rt + e + yr + Ot(e, "basis", "preferred-size") + e;
    case 6060:
      return Rt + "box-" + Ot(e, "-grow", "") + Rt + e + yr + Ot(e, "grow", "positive") + e;
    case 4554:
      return Rt + Ot(e, /([^-])(transform)/g, "$1" + Rt + "$2") + e;
    case 6187:
      return Ot(Ot(Ot(e, /(zoom-|grab)/, Rt + "$1"), /(image-set)/, Rt + "$1"), e, "") + e;
    case 5495:
    case 3959:
      return Ot(e, /(image-set\([^]*)/, Rt + "$1$`$1");
    case 4968:
      return Ot(Ot(e, /(.+:)(flex-)?(.*)/, Rt + "box-pack:$3" + yr + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + Rt + e + e;
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return Ot(e, /(.+)-inline(.+)/, Rt + "$1$2") + e;
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (xi(e) - 1 - t > 6)
        switch (pr(e, t + 1)) {
          case 109:
            if (pr(e, t + 4) !== 45)
              break;
          case 102:
            return Ot(e, /(.+:)(.+)-([^]+)/, "$1" + Rt + "$2-$3$1" + Sh + (pr(e, t + 3) == 108 ? "$3" : "$2-$3")) + e;
          case 115:
            return ~ry(e, "stretch") ? cN(Ot(e, "stretch", "fill-available"), t) + e : e;
        }
      break;
    case 4949:
      if (pr(e, t + 1) !== 115)
        break;
    case 6444:
      switch (pr(e, xi(e) - 3 - (~ry(e, "!important") && 10))) {
        case 107:
          return Ot(e, ":", ":" + Rt) + e;
        case 101:
          return Ot(e, /(.+:)([^;!]+)(;|!.+)?/, "$1" + Rt + (pr(e, 14) === 45 ? "inline-" : "") + "box$3$1" + Rt + "$2$3$1" + yr + "$2box$3") + e;
      }
      break;
    case 5936:
      switch (pr(e, t + 11)) {
        case 114:
          return Rt + e + yr + Ot(e, /[svh]\w+-[tblr]{2}/, "tb") + e;
        case 108:
          return Rt + e + yr + Ot(e, /[svh]\w+-[tblr]{2}/, "tb-rl") + e;
        case 45:
          return Rt + e + yr + Ot(e, /[svh]\w+-[tblr]{2}/, "lr") + e;
      }
      return Rt + e + yr + e + e;
  }
  return e;
}
var xV = function(e, t, n, r) {
  if (e.length > -1 && !e.return)
    switch (e.type) {
      case B_:
        e.return = cN(e.value, e.length);
        break;
      case rN:
        return uc([Tu(e, {
          value: Ot(e.value, "@", "@" + Rt)
        })], r);
      case z_:
        if (e.length)
          return eV(e.props, function(o) {
            switch (Q9(o, /(::plac\w+|:read-\w+)/)) {
              case ":read-only":
              case ":read-write":
                return uc([Tu(e, {
                  props: [Ot(o, /:(read-\w+)/, ":" + Sh + "$1")]
                })], r);
              case "::placeholder":
                return uc([Tu(e, {
                  props: [Ot(o, /:(plac\w+)/, ":" + Rt + "input-$1")]
                }), Tu(e, {
                  props: [Ot(o, /:(plac\w+)/, ":" + Sh + "$1")]
                }), Tu(e, {
                  props: [Ot(o, /:(plac\w+)/, yr + "input-$1")]
                })], r);
            }
            return "";
          });
    }
}, CV = [xV], SV = function(e) {
  var t = e.key;
  if (process.env.NODE_ENV !== "production" && !t)
    throw new Error(`You have to configure \`key\` for your cache. Please make sure it's unique (and not equal to 'css') as it's used for linking styles to your cache.
If multiple caches share the same key they might "fight" for each other's style elements.`);
  if (t === "css") {
    var n = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(n, function(v) {
      var g = v.getAttribute("data-emotion");
      g.indexOf(" ") !== -1 && (document.head.appendChild(v), v.setAttribute("data-s", ""));
    });
  }
  var r = e.stylisPlugins || CV;
  if (process.env.NODE_ENV !== "production" && /[^a-z-]/.test(t))
    throw new Error('Emotion key must only contain lower case alphabetical characters and - but "' + t + '" was passed');
  var o = {}, i, a = [];
  i = e.container || document.head, Array.prototype.forEach.call(
    // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + t + ' "]'),
    function(v) {
      for (var g = v.getAttribute("data-emotion").split(" "), b = 1; b < g.length; b++)
        o[g[b]] = !0;
      a.push(v);
    }
  );
  var s, c = [mV, gV];
  process.env.NODE_ENV !== "production" && c.push(yV({
    get compat() {
      return m.compat;
    }
  }), wV);
  {
    var l, d = [cV, process.env.NODE_ENV !== "production" ? function(v) {
      v.root || (v.return ? l.insert(v.return) : v.value && v.type !== F_ && l.insert(v.value + "{}"));
    } : dV(function(v) {
      l.insert(v);
    })], f = uV(c.concat(r, d)), p = function(v) {
      return uc(sV(v), f);
    };
    s = function(v, g, b, x) {
      l = b, process.env.NODE_ENV !== "production" && g.map !== void 0 && (l = {
        insert: function(T) {
          b.insert(T + g.map);
        }
      }), p(v ? v + "{" + g.styles + "}" : g.styles), x && (m.inserted[g.name] = !0);
    };
  }
  var m = {
    key: t,
    sheet: new G9({
      key: t,
      container: i,
      nonce: e.nonce,
      speedy: e.speedy,
      prepend: e.prepend,
      insertionPoint: e.insertionPoint
    }),
    nonce: e.nonce,
    inserted: o,
    registered: {},
    insert: s
  };
  return m.sheet.hydrate(a), m;
};
let iy;
typeof document == "object" && (iy = SV({
  key: "css",
  prepend: !0
}));
function uN(e) {
  const {
    injectFirst: t,
    children: n
  } = e;
  return t && iy ? /* @__PURE__ */ z(UO, {
    value: iy,
    children: n
  }) : n;
}
process.env.NODE_ENV !== "production" && (uN.propTypes = {
  /**
   * Your component tree.
   */
  children: y.node,
  /**
   * By default, the styles are injected last in the <head> element of the page.
   * As a result, they gain more specificity than any other style sheet.
   * If you want to override MUI's styles, set this prop.
   */
  injectFirst: y.bool
});
function TV(e) {
  return e == null || Object.keys(e).length === 0;
}
function j_(e) {
  const {
    styles: t,
    defaultTheme: n = {}
  } = e;
  return /* @__PURE__ */ z(P_, {
    styles: typeof t == "function" ? (r) => t(TV(r) ? n : r) : t
  });
}
process.env.NODE_ENV !== "production" && (j_.propTypes = {
  defaultTheme: y.object,
  styles: y.oneOfType([y.array, y.string, y.object, y.func])
});
/**
 * @mui/styled-engine v5.15.14
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
function EV(e, t) {
  const n = Fo(e, t);
  return process.env.NODE_ENV !== "production" ? (...r) => {
    const o = typeof e == "string" ? `"${e}"` : "component";
    return r.length === 0 ? console.error([`MUI: Seems like you called \`styled(${o})()\` without a \`style\` argument.`, 'You must provide a `styles` argument: `styled("div")(styleYouForgotToPass)`.'].join(`
`)) : r.some((i) => i === void 0) && console.error(`MUI: the styled(${o})(...args) API requires all its args to be defined.`), n(...r);
  } : n;
}
const kV = (e, t) => {
  Array.isArray(e.__emotion_styles) && (e.__emotion_styles = t(e.__emotion_styles));
}, MV = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  GlobalStyles: j_,
  StyledEngineProvider: uN,
  ThemeContext: Hi,
  css: ra,
  default: EV,
  internal_processStyles: kV,
  keyframes: us
}, Symbol.toStringTag, { value: "Module" })), dN = /* @__PURE__ */ wa(MV), RV = /* @__PURE__ */ wa(a9), PV = /* @__PURE__ */ wa(_9), OV = /* @__PURE__ */ wa(b9), NV = ["values", "unit", "step"], AV = (e) => {
  const t = Object.keys(e).map((n) => ({
    key: n,
    val: e[n]
  })) || [];
  return t.sort((n, r) => n.val - r.val), t.reduce((n, r) => re({}, n, {
    [r.key]: r.val
  }), {});
};
function fN(e) {
  const {
    // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values: t = {
      xs: 0,
      // phone
      sm: 600,
      // tablet
      md: 900,
      // small laptop
      lg: 1200,
      // desktop
      xl: 1536
      // large screen
    },
    unit: n = "px",
    step: r = 5
  } = e, o = He(e, NV), i = AV(t), a = Object.keys(i);
  function s(p) {
    return `@media (min-width:${typeof t[p] == "number" ? t[p] : p}${n})`;
  }
  function c(p) {
    return `@media (max-width:${(typeof t[p] == "number" ? t[p] : p) - r / 100}${n})`;
  }
  function l(p, m) {
    const v = a.indexOf(m);
    return `@media (min-width:${typeof t[p] == "number" ? t[p] : p}${n}) and (max-width:${(v !== -1 && typeof t[a[v]] == "number" ? t[a[v]] : m) - r / 100}${n})`;
  }
  function d(p) {
    return a.indexOf(p) + 1 < a.length ? l(p, a[a.indexOf(p) + 1]) : s(p);
  }
  function f(p) {
    const m = a.indexOf(p);
    return m === 0 ? s(a[1]) : m === a.length - 1 ? c(a[m]) : l(p, a[a.indexOf(p) + 1]).replace("@media", "@media not all and");
  }
  return re({
    keys: a,
    values: i,
    up: s,
    down: c,
    between: l,
    only: d,
    not: f,
    unit: n
  }, o);
}
const DV = {
  borderRadius: 4
}, IV = DV, LV = process.env.NODE_ENV !== "production" ? y.oneOfType([y.number, y.string, y.object, y.array]) : {}, ps = LV;
function pd(e, t) {
  return t ? co(e, t, {
    clone: !1
    // No need to clone deep, it's way faster.
  }) : e;
}
const W_ = {
  xs: 0,
  // phone
  sm: 600,
  // tablet
  md: 900,
  // small laptop
  lg: 1200,
  // desktop
  xl: 1536
  // large screen
}, WS = {
  // Sorted ASC by size. That's important.
  // It can't be configured as it's used statically for propTypes.
  keys: ["xs", "sm", "md", "lg", "xl"],
  up: (e) => `@media (min-width:${W_[e]}px)`
};
function pa(e, t, n) {
  const r = e.theme || {};
  if (Array.isArray(t)) {
    const o = r.breakpoints || WS;
    return t.reduce((i, a, s) => (i[o.up(o.keys[s])] = n(t[s]), i), {});
  }
  if (typeof t == "object") {
    const o = r.breakpoints || WS;
    return Object.keys(t).reduce((i, a) => {
      if (Object.keys(o.values || W_).indexOf(a) !== -1) {
        const s = o.up(a);
        i[s] = n(t[a], a);
      } else {
        const s = a;
        i[s] = t[s];
      }
      return i;
    }, {});
  }
  return n(t);
}
function $V(e = {}) {
  var t;
  return ((t = e.keys) == null ? void 0 : t.reduce((n, r) => {
    const o = e.up(r);
    return n[o] = {}, n;
  }, {})) || {};
}
function FV(e, t) {
  return e.reduce((n, r) => {
    const o = n[r];
    return (!o || Object.keys(o).length === 0) && delete n[r], n;
  }, t);
}
function Hm(e, t, n = !0) {
  if (!t || typeof t != "string")
    return null;
  if (e && e.vars && n) {
    const r = `vars.${t}`.split(".").reduce((o, i) => o && o[i] ? o[i] : null, e);
    if (r != null)
      return r;
  }
  return t.split(".").reduce((r, o) => r && r[o] != null ? r[o] : null, e);
}
function Th(e, t, n, r = n) {
  let o;
  return typeof e == "function" ? o = e(n) : Array.isArray(e) ? o = e[n] || r : o = Hm(e, n) || r, t && (o = t(o, r, e)), o;
}
function Rn(e) {
  const {
    prop: t,
    cssProperty: n = e.prop,
    themeKey: r,
    transform: o
  } = e, i = (a) => {
    if (a[t] == null)
      return null;
    const s = a[t], c = a.theme, l = Hm(c, r) || {};
    return pa(a, s, (d) => {
      let f = Th(l, o, d);
      return d === f && typeof d == "string" && (f = Th(l, o, `${t}${d === "default" ? "" : at(d)}`, d)), n === !1 ? f : {
        [n]: f
      };
    });
  };
  return i.propTypes = process.env.NODE_ENV !== "production" ? {
    [t]: ps
  } : {}, i.filterProps = [t], i;
}
function zV(e) {
  const t = {};
  return (n) => (t[n] === void 0 && (t[n] = e(n)), t[n]);
}
const BV = {
  m: "margin",
  p: "padding"
}, HV = {
  t: "Top",
  r: "Right",
  b: "Bottom",
  l: "Left",
  x: ["Left", "Right"],
  y: ["Top", "Bottom"]
}, VS = {
  marginX: "mx",
  marginY: "my",
  paddingX: "px",
  paddingY: "py"
}, jV = zV((e) => {
  if (e.length > 2)
    if (VS[e])
      e = VS[e];
    else
      return [e];
  const [t, n] = e.split(""), r = BV[t], o = HV[n] || "";
  return Array.isArray(o) ? o.map((i) => r + i) : [r + o];
}), jm = ["m", "mt", "mr", "mb", "ml", "mx", "my", "margin", "marginTop", "marginRight", "marginBottom", "marginLeft", "marginX", "marginY", "marginInline", "marginInlineStart", "marginInlineEnd", "marginBlock", "marginBlockStart", "marginBlockEnd"], Wm = ["p", "pt", "pr", "pb", "pl", "px", "py", "padding", "paddingTop", "paddingRight", "paddingBottom", "paddingLeft", "paddingX", "paddingY", "paddingInline", "paddingInlineStart", "paddingInlineEnd", "paddingBlock", "paddingBlockStart", "paddingBlockEnd"], WV = [...jm, ...Wm];
function mf(e, t, n, r) {
  var o;
  const i = (o = Hm(e, t, !1)) != null ? o : n;
  return typeof i == "number" ? (a) => typeof a == "string" ? a : (process.env.NODE_ENV !== "production" && typeof a != "number" && console.error(`MUI: Expected ${r} argument to be a number or a string, got ${a}.`), i * a) : Array.isArray(i) ? (a) => typeof a == "string" ? a : (process.env.NODE_ENV !== "production" && (Number.isInteger(a) ? a > i.length - 1 && console.error([`MUI: The value provided (${a}) overflows.`, `The supported values are: ${JSON.stringify(i)}.`, `${a} > ${i.length - 1}, you need to add the missing values.`].join(`
`)) : console.error([`MUI: The \`theme.${t}\` array type cannot be combined with non integer values.You should either use an integer value that can be used as index, or define the \`theme.${t}\` as a number.`].join(`
`))), i[a]) : typeof i == "function" ? i : (process.env.NODE_ENV !== "production" && console.error([`MUI: The \`theme.${t}\` value (${i}) is invalid.`, "It should be a number, an array or a function."].join(`
`)), () => {
  });
}
function pN(e) {
  return mf(e, "spacing", 8, "spacing");
}
function gf(e, t) {
  if (typeof t == "string" || t == null)
    return t;
  const n = Math.abs(t), r = e(n);
  return t >= 0 ? r : typeof r == "number" ? -r : `-${r}`;
}
function VV(e, t) {
  return (n) => e.reduce((r, o) => (r[o] = gf(t, n), r), {});
}
function UV(e, t, n, r) {
  if (t.indexOf(n) === -1)
    return null;
  const o = jV(n), i = VV(o, r), a = e[n];
  return pa(e, a, i);
}
function hN(e, t) {
  const n = pN(e.theme);
  return Object.keys(e).map((r) => UV(e, t, r, n)).reduce(pd, {});
}
function bn(e) {
  return hN(e, jm);
}
bn.propTypes = process.env.NODE_ENV !== "production" ? jm.reduce((e, t) => (e[t] = ps, e), {}) : {};
bn.filterProps = jm;
function yn(e) {
  return hN(e, Wm);
}
yn.propTypes = process.env.NODE_ENV !== "production" ? Wm.reduce((e, t) => (e[t] = ps, e), {}) : {};
yn.filterProps = Wm;
process.env.NODE_ENV !== "production" && WV.reduce((e, t) => (e[t] = ps, e), {});
function qV(e = 8) {
  if (e.mui)
    return e;
  const t = pN({
    spacing: e
  }), n = (...r) => (process.env.NODE_ENV !== "production" && (r.length <= 4 || console.error(`MUI: Too many arguments provided, expected between 0 and 4, got ${r.length}`)), (r.length === 0 ? [1] : r).map((o) => {
    const i = t(o);
    return typeof i == "number" ? `${i}px` : i;
  }).join(" "));
  return n.mui = !0, n;
}
function Vm(...e) {
  const t = e.reduce((r, o) => (o.filterProps.forEach((i) => {
    r[i] = o;
  }), r), {}), n = (r) => Object.keys(r).reduce((o, i) => t[i] ? pd(o, t[i](r)) : o, {});
  return n.propTypes = process.env.NODE_ENV !== "production" ? e.reduce((r, o) => Object.assign(r, o.propTypes), {}) : {}, n.filterProps = e.reduce((r, o) => r.concat(o.filterProps), []), n;
}
function Lo(e) {
  return typeof e != "number" ? e : `${e}px solid`;
}
function Zo(e, t) {
  return Rn({
    prop: e,
    themeKey: "borders",
    transform: t
  });
}
const GV = Zo("border", Lo), YV = Zo("borderTop", Lo), ZV = Zo("borderRight", Lo), XV = Zo("borderBottom", Lo), KV = Zo("borderLeft", Lo), JV = Zo("borderColor"), QV = Zo("borderTopColor"), eU = Zo("borderRightColor"), tU = Zo("borderBottomColor"), nU = Zo("borderLeftColor"), rU = Zo("outline", Lo), oU = Zo("outlineColor"), Um = (e) => {
  if (e.borderRadius !== void 0 && e.borderRadius !== null) {
    const t = mf(e.theme, "shape.borderRadius", 4, "borderRadius"), n = (r) => ({
      borderRadius: gf(t, r)
    });
    return pa(e, e.borderRadius, n);
  }
  return null;
};
Um.propTypes = process.env.NODE_ENV !== "production" ? {
  borderRadius: ps
} : {};
Um.filterProps = ["borderRadius"];
Vm(GV, YV, ZV, XV, KV, JV, QV, eU, tU, nU, Um, rU, oU);
const qm = (e) => {
  if (e.gap !== void 0 && e.gap !== null) {
    const t = mf(e.theme, "spacing", 8, "gap"), n = (r) => ({
      gap: gf(t, r)
    });
    return pa(e, e.gap, n);
  }
  return null;
};
qm.propTypes = process.env.NODE_ENV !== "production" ? {
  gap: ps
} : {};
qm.filterProps = ["gap"];
const Gm = (e) => {
  if (e.columnGap !== void 0 && e.columnGap !== null) {
    const t = mf(e.theme, "spacing", 8, "columnGap"), n = (r) => ({
      columnGap: gf(t, r)
    });
    return pa(e, e.columnGap, n);
  }
  return null;
};
Gm.propTypes = process.env.NODE_ENV !== "production" ? {
  columnGap: ps
} : {};
Gm.filterProps = ["columnGap"];
const Ym = (e) => {
  if (e.rowGap !== void 0 && e.rowGap !== null) {
    const t = mf(e.theme, "spacing", 8, "rowGap"), n = (r) => ({
      rowGap: gf(t, r)
    });
    return pa(e, e.rowGap, n);
  }
  return null;
};
Ym.propTypes = process.env.NODE_ENV !== "production" ? {
  rowGap: ps
} : {};
Ym.filterProps = ["rowGap"];
const iU = Rn({
  prop: "gridColumn"
}), aU = Rn({
  prop: "gridRow"
}), sU = Rn({
  prop: "gridAutoFlow"
}), lU = Rn({
  prop: "gridAutoColumns"
}), cU = Rn({
  prop: "gridAutoRows"
}), uU = Rn({
  prop: "gridTemplateColumns"
}), dU = Rn({
  prop: "gridTemplateRows"
}), fU = Rn({
  prop: "gridTemplateAreas"
}), pU = Rn({
  prop: "gridArea"
});
Vm(qm, Gm, Ym, iU, aU, sU, lU, cU, uU, dU, fU, pU);
function dc(e, t) {
  return t === "grey" ? t : e;
}
const hU = Rn({
  prop: "color",
  themeKey: "palette",
  transform: dc
}), mU = Rn({
  prop: "bgcolor",
  cssProperty: "backgroundColor",
  themeKey: "palette",
  transform: dc
}), gU = Rn({
  prop: "backgroundColor",
  themeKey: "palette",
  transform: dc
});
Vm(hU, mU, gU);
function ao(e) {
  return e <= 1 && e !== 0 ? `${e * 100}%` : e;
}
const vU = Rn({
  prop: "width",
  transform: ao
}), V_ = (e) => {
  if (e.maxWidth !== void 0 && e.maxWidth !== null) {
    const t = (n) => {
      var r, o;
      const i = ((r = e.theme) == null || (r = r.breakpoints) == null || (r = r.values) == null ? void 0 : r[n]) || W_[n];
      return i ? ((o = e.theme) == null || (o = o.breakpoints) == null ? void 0 : o.unit) !== "px" ? {
        maxWidth: `${i}${e.theme.breakpoints.unit}`
      } : {
        maxWidth: i
      } : {
        maxWidth: ao(n)
      };
    };
    return pa(e, e.maxWidth, t);
  }
  return null;
};
V_.filterProps = ["maxWidth"];
const bU = Rn({
  prop: "minWidth",
  transform: ao
}), yU = Rn({
  prop: "height",
  transform: ao
}), _U = Rn({
  prop: "maxHeight",
  transform: ao
}), wU = Rn({
  prop: "minHeight",
  transform: ao
});
Rn({
  prop: "size",
  cssProperty: "width",
  transform: ao
});
Rn({
  prop: "size",
  cssProperty: "height",
  transform: ao
});
const xU = Rn({
  prop: "boxSizing"
});
Vm(vU, V_, bU, yU, _U, wU, xU);
const CU = {
  // borders
  border: {
    themeKey: "borders",
    transform: Lo
  },
  borderTop: {
    themeKey: "borders",
    transform: Lo
  },
  borderRight: {
    themeKey: "borders",
    transform: Lo
  },
  borderBottom: {
    themeKey: "borders",
    transform: Lo
  },
  borderLeft: {
    themeKey: "borders",
    transform: Lo
  },
  borderColor: {
    themeKey: "palette"
  },
  borderTopColor: {
    themeKey: "palette"
  },
  borderRightColor: {
    themeKey: "palette"
  },
  borderBottomColor: {
    themeKey: "palette"
  },
  borderLeftColor: {
    themeKey: "palette"
  },
  outline: {
    themeKey: "borders",
    transform: Lo
  },
  outlineColor: {
    themeKey: "palette"
  },
  borderRadius: {
    themeKey: "shape.borderRadius",
    style: Um
  },
  // palette
  color: {
    themeKey: "palette",
    transform: dc
  },
  bgcolor: {
    themeKey: "palette",
    cssProperty: "backgroundColor",
    transform: dc
  },
  backgroundColor: {
    themeKey: "palette",
    transform: dc
  },
  // spacing
  p: {
    style: yn
  },
  pt: {
    style: yn
  },
  pr: {
    style: yn
  },
  pb: {
    style: yn
  },
  pl: {
    style: yn
  },
  px: {
    style: yn
  },
  py: {
    style: yn
  },
  padding: {
    style: yn
  },
  paddingTop: {
    style: yn
  },
  paddingRight: {
    style: yn
  },
  paddingBottom: {
    style: yn
  },
  paddingLeft: {
    style: yn
  },
  paddingX: {
    style: yn
  },
  paddingY: {
    style: yn
  },
  paddingInline: {
    style: yn
  },
  paddingInlineStart: {
    style: yn
  },
  paddingInlineEnd: {
    style: yn
  },
  paddingBlock: {
    style: yn
  },
  paddingBlockStart: {
    style: yn
  },
  paddingBlockEnd: {
    style: yn
  },
  m: {
    style: bn
  },
  mt: {
    style: bn
  },
  mr: {
    style: bn
  },
  mb: {
    style: bn
  },
  ml: {
    style: bn
  },
  mx: {
    style: bn
  },
  my: {
    style: bn
  },
  margin: {
    style: bn
  },
  marginTop: {
    style: bn
  },
  marginRight: {
    style: bn
  },
  marginBottom: {
    style: bn
  },
  marginLeft: {
    style: bn
  },
  marginX: {
    style: bn
  },
  marginY: {
    style: bn
  },
  marginInline: {
    style: bn
  },
  marginInlineStart: {
    style: bn
  },
  marginInlineEnd: {
    style: bn
  },
  marginBlock: {
    style: bn
  },
  marginBlockStart: {
    style: bn
  },
  marginBlockEnd: {
    style: bn
  },
  // display
  displayPrint: {
    cssProperty: !1,
    transform: (e) => ({
      "@media print": {
        display: e
      }
    })
  },
  display: {},
  overflow: {},
  textOverflow: {},
  visibility: {},
  whiteSpace: {},
  // flexbox
  flexBasis: {},
  flexDirection: {},
  flexWrap: {},
  justifyContent: {},
  alignItems: {},
  alignContent: {},
  order: {},
  flex: {},
  flexGrow: {},
  flexShrink: {},
  alignSelf: {},
  justifyItems: {},
  justifySelf: {},
  // grid
  gap: {
    style: qm
  },
  rowGap: {
    style: Ym
  },
  columnGap: {
    style: Gm
  },
  gridColumn: {},
  gridRow: {},
  gridAutoFlow: {},
  gridAutoColumns: {},
  gridAutoRows: {},
  gridTemplateColumns: {},
  gridTemplateRows: {},
  gridTemplateAreas: {},
  gridArea: {},
  // positions
  position: {},
  zIndex: {
    themeKey: "zIndex"
  },
  top: {},
  right: {},
  bottom: {},
  left: {},
  // shadows
  boxShadow: {
    themeKey: "shadows"
  },
  // sizing
  width: {
    transform: ao
  },
  maxWidth: {
    style: V_
  },
  minWidth: {
    transform: ao
  },
  height: {
    transform: ao
  },
  maxHeight: {
    transform: ao
  },
  minHeight: {
    transform: ao
  },
  boxSizing: {},
  // typography
  fontFamily: {
    themeKey: "typography"
  },
  fontSize: {
    themeKey: "typography"
  },
  fontStyle: {
    themeKey: "typography"
  },
  fontWeight: {
    themeKey: "typography"
  },
  letterSpacing: {},
  textTransform: {},
  lineHeight: {},
  textAlign: {},
  typography: {
    cssProperty: !1,
    themeKey: "typography"
  }
}, vf = CU;
function SU(...e) {
  const t = e.reduce((r, o) => r.concat(Object.keys(o)), []), n = new Set(t);
  return e.every((r) => n.size === Object.keys(r).length);
}
function TU(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function mN() {
  function e(n, r, o, i) {
    const a = {
      [n]: r,
      theme: o
    }, s = i[n];
    if (!s)
      return {
        [n]: r
      };
    const {
      cssProperty: c = n,
      themeKey: l,
      transform: d,
      style: f
    } = s;
    if (r == null)
      return null;
    if (l === "typography" && r === "inherit")
      return {
        [n]: r
      };
    const p = Hm(o, l) || {};
    return f ? f(a) : pa(a, r, (m) => {
      let v = Th(p, d, m);
      return m === v && typeof m == "string" && (v = Th(p, d, `${n}${m === "default" ? "" : at(m)}`, m)), c === !1 ? v : {
        [c]: v
      };
    });
  }
  function t(n) {
    var r;
    const {
      sx: o,
      theme: i = {}
    } = n || {};
    if (!o)
      return null;
    const a = (r = i.unstable_sxConfig) != null ? r : vf;
    function s(c) {
      let l = c;
      if (typeof c == "function")
        l = c(i);
      else if (typeof c != "object")
        return c;
      if (!l)
        return null;
      const d = $V(i.breakpoints), f = Object.keys(d);
      let p = d;
      return Object.keys(l).forEach((m) => {
        const v = TU(l[m], i);
        if (v != null)
          if (typeof v == "object")
            if (a[m])
              p = pd(p, e(m, v, i, a));
            else {
              const g = pa({
                theme: i
              }, v, (b) => ({
                [m]: b
              }));
              SU(g, v) ? p[m] = t({
                sx: v,
                theme: i
              }) : p = pd(p, g);
            }
          else
            p = pd(p, e(m, v, i, a));
      }), FV(f, p);
    }
    return Array.isArray(o) ? o.map(s) : s(o);
  }
  return t;
}
const gN = mN();
gN.filterProps = ["sx"];
const U_ = gN;
function vN(e, t) {
  const n = this;
  return n.vars && typeof n.getColorSchemeSelector == "function" ? {
    [n.getColorSchemeSelector(e).replace(/(\[[^\]]+\])/, "*:where($1)")]: t
  } : n.palette.mode === e ? t : {};
}
const EU = ["breakpoints", "palette", "spacing", "shape"];
function q_(e = {}, ...t) {
  const {
    breakpoints: n = {},
    palette: r = {},
    spacing: o,
    shape: i = {}
  } = e, a = He(e, EU), s = fN(n), c = qV(o);
  let l = co({
    breakpoints: s,
    direction: "ltr",
    components: {},
    // Inject component definitions.
    palette: re({
      mode: "light"
    }, r),
    spacing: c,
    shape: re({}, IV, i)
  }, a);
  return l.applyStyles = vN, l = t.reduce((d, f) => co(d, f), l), l.unstable_sxConfig = re({}, vf, a == null ? void 0 : a.unstable_sxConfig), l.unstable_sx = function(d) {
    return U_({
      sx: d,
      theme: this
    });
  }, l;
}
const kU = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: q_,
  private_createBreakpoints: fN,
  unstable_applyStyles: vN
}, Symbol.toStringTag, { value: "Module" })), MU = /* @__PURE__ */ wa(kU), RU = ["sx"], PU = (e) => {
  var t, n;
  const r = {
    systemProps: {},
    otherProps: {}
  }, o = (t = e == null || (n = e.theme) == null ? void 0 : n.unstable_sxConfig) != null ? t : vf;
  return Object.keys(e).forEach((i) => {
    o[i] ? r.systemProps[i] = e[i] : r.otherProps[i] = e[i];
  }), r;
};
function bN(e) {
  const {
    sx: t
  } = e, n = He(e, RU), {
    systemProps: r,
    otherProps: o
  } = PU(n);
  let i;
  return Array.isArray(t) ? i = [r, ...t] : typeof t == "function" ? i = (...a) => {
    const s = t(...a);
    return Wa(s) ? re({}, r, s) : r;
  } : i = re({}, r, t), re({}, o, {
    sx: i
  });
}
const OU = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: U_,
  extendSxProp: bN,
  unstable_createStyleFunctionSx: mN,
  unstable_defaultSxConfig: vf
}, Symbol.toStringTag, { value: "Module" })), NU = /* @__PURE__ */ wa(OU);
var US;
function AU() {
  if (US)
    return Rs;
  US = 1;
  var e = nN();
  Object.defineProperty(Rs, "__esModule", {
    value: !0
  }), Rs.default = k, Rs.shouldForwardProp = b, Rs.systemDefaultTheme = void 0;
  var t = e(j9()), n = e(V9()), r = m(dN), o = RV, i = e(PV), a = e(OV), s = e(MU), c = e(NU);
  const l = ["ownerState"], d = ["variants"], f = ["name", "slot", "skipVariantsResolver", "skipSx", "overridesResolver"];
  function p(E) {
    if (typeof WeakMap != "function")
      return null;
    var R = /* @__PURE__ */ new WeakMap(), P = /* @__PURE__ */ new WeakMap();
    return (p = function(A) {
      return A ? P : R;
    })(E);
  }
  function m(E, R) {
    if (E && E.__esModule)
      return E;
    if (E === null || typeof E != "object" && typeof E != "function")
      return { default: E };
    var P = p(R);
    if (P && P.has(E))
      return P.get(E);
    var A = { __proto__: null }, D = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var N in E)
      if (N !== "default" && Object.prototype.hasOwnProperty.call(E, N)) {
        var F = D ? Object.getOwnPropertyDescriptor(E, N) : null;
        F && (F.get || F.set) ? Object.defineProperty(A, N, F) : A[N] = E[N];
      }
    return A.default = E, P && P.set(E, A), A;
  }
  function v(E) {
    return Object.keys(E).length === 0;
  }
  function g(E) {
    return typeof E == "string" && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    E.charCodeAt(0) > 96;
  }
  function b(E) {
    return E !== "ownerState" && E !== "theme" && E !== "sx" && E !== "as";
  }
  const x = Rs.systemDefaultTheme = (0, s.default)(), T = (E) => E && E.charAt(0).toLowerCase() + E.slice(1);
  function S({
    defaultTheme: E,
    theme: R,
    themeId: P
  }) {
    return v(R) ? E : R[P] || R;
  }
  function _(E) {
    return E ? (R, P) => P[E] : null;
  }
  function w(E, R) {
    let {
      ownerState: P
    } = R, A = (0, n.default)(R, l);
    const D = typeof E == "function" ? E((0, t.default)({
      ownerState: P
    }, A)) : E;
    if (Array.isArray(D))
      return D.flatMap((N) => w(N, (0, t.default)({
        ownerState: P
      }, A)));
    if (D && typeof D == "object" && Array.isArray(D.variants)) {
      const {
        variants: N = []
      } = D;
      let F = (0, n.default)(D, d);
      return N.forEach(($) => {
        let I = !0;
        typeof $.props == "function" ? I = $.props((0, t.default)({
          ownerState: P
        }, A, P)) : Object.keys($.props).forEach((j) => {
          (P == null ? void 0 : P[j]) !== $.props[j] && A[j] !== $.props[j] && (I = !1);
        }), I && (Array.isArray(F) || (F = [F]), F.push(typeof $.style == "function" ? $.style((0, t.default)({
          ownerState: P
        }, A, P)) : $.style));
      }), F;
    }
    return D;
  }
  function k(E = {}) {
    const {
      themeId: R,
      defaultTheme: P = x,
      rootShouldForwardProp: A = b,
      slotShouldForwardProp: D = b
    } = E, N = (F) => (0, c.default)((0, t.default)({}, F, {
      theme: S((0, t.default)({}, F, {
        defaultTheme: P,
        themeId: R
      }))
    }));
    return N.__mui_systemSx = !0, (F, $ = {}) => {
      (0, r.internal_processStyles)(F, (te) => te.filter((le) => !(le != null && le.__mui_systemSx)));
      const {
        name: I,
        slot: j,
        skipVariantsResolver: U,
        skipSx: G,
        // TODO v6: remove `lowercaseFirstLetter()` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        overridesResolver: V = _(T(j))
      } = $, H = (0, n.default)($, f), q = U !== void 0 ? U : (
        // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        j && j !== "Root" && j !== "root" || !1
      ), Q = G || !1;
      let X;
      process.env.NODE_ENV !== "production" && I && (X = `${I}-${T(j || "Root")}`);
      let K = b;
      j === "Root" || j === "root" ? K = A : j ? K = D : g(F) && (K = void 0);
      const J = (0, r.default)(F, (0, t.default)({
        shouldForwardProp: K,
        label: X
      }, H)), ne = (te) => typeof te == "function" && te.__emotion_real !== te || (0, o.isPlainObject)(te) ? (le) => w(te, (0, t.default)({}, le, {
        theme: S({
          theme: le.theme,
          defaultTheme: P,
          themeId: R
        })
      })) : te, ae = (te, ...le) => {
        let ce = ne(te);
        const fe = le ? le.map(ne) : [];
        I && V && fe.push((oe) => {
          const ve = S((0, t.default)({}, oe, {
            defaultTheme: P,
            themeId: R
          }));
          if (!ve.components || !ve.components[I] || !ve.components[I].styleOverrides)
            return null;
          const we = ve.components[I].styleOverrides, ye = {};
          return Object.entries(we).forEach(([Ce, Se]) => {
            ye[Ce] = w(Se, (0, t.default)({}, oe, {
              theme: ve
            }));
          }), V(oe, ye);
        }), I && !q && fe.push((oe) => {
          var ve;
          const we = S((0, t.default)({}, oe, {
            defaultTheme: P,
            themeId: R
          })), ye = we == null || (ve = we.components) == null || (ve = ve[I]) == null ? void 0 : ve.variants;
          return w({
            variants: ye
          }, (0, t.default)({}, oe, {
            theme: we
          }));
        }), Q || fe.push(N);
        const ee = fe.length - le.length;
        if (Array.isArray(te) && ee > 0) {
          const oe = new Array(ee).fill("");
          ce = [...te, ...oe], ce.raw = [...te.raw, ...oe];
        }
        const me = J(ce, ...fe);
        if (process.env.NODE_ENV !== "production") {
          let oe;
          I && (oe = `${I}${(0, i.default)(j || "")}`), oe === void 0 && (oe = `Styled(${(0, a.default)(F)})`), me.displayName = oe;
        }
        return F.muiName && (me.muiName = F.muiName), me;
      };
      return J.withConfig && (ae.withConfig = J.withConfig), ae;
    };
  }
  return Rs;
}
var DU = AU();
const IU = /* @__PURE__ */ ji(DU);
function LU(e, t) {
  return re({
    toolbar: {
      minHeight: 56,
      [e.up("xs")]: {
        "@media (orientation: landscape)": {
          minHeight: 48
        }
      },
      [e.up("sm")]: {
        minHeight: 64
      }
    }
  }, t);
}
var fn = {};
const $U = /* @__PURE__ */ wa(d9), FU = /* @__PURE__ */ wa($9);
var qS;
function zU() {
  if (qS)
    return fn;
  qS = 1;
  var e = nN();
  Object.defineProperty(fn, "__esModule", {
    value: !0
  }), fn.alpha = v, fn.blend = k, fn.colorChannel = void 0, fn.darken = b, fn.decomposeColor = a, fn.emphasize = _, fn.getContrastRatio = m, fn.getLuminance = p, fn.hexToRgb = o, fn.hslToRgb = f, fn.lighten = T, fn.private_safeAlpha = g, fn.private_safeColorChannel = void 0, fn.private_safeDarken = x, fn.private_safeEmphasize = w, fn.private_safeLighten = S, fn.recomposeColor = l, fn.rgbToHex = d;
  var t = e($U), n = e(FU);
  function r(E, R = 0, P = 1) {
    return process.env.NODE_ENV !== "production" && (E < R || E > P) && console.error(`MUI: The value provided ${E} is out of range [${R}, ${P}].`), (0, n.default)(E, R, P);
  }
  function o(E) {
    E = E.slice(1);
    const R = new RegExp(`.{1,${E.length >= 6 ? 2 : 1}}`, "g");
    let P = E.match(R);
    return P && P[0].length === 1 && (P = P.map((A) => A + A)), P ? `rgb${P.length === 4 ? "a" : ""}(${P.map((A, D) => D < 3 ? parseInt(A, 16) : Math.round(parseInt(A, 16) / 255 * 1e3) / 1e3).join(", ")})` : "";
  }
  function i(E) {
    const R = E.toString(16);
    return R.length === 1 ? `0${R}` : R;
  }
  function a(E) {
    if (E.type)
      return E;
    if (E.charAt(0) === "#")
      return a(o(E));
    const R = E.indexOf("("), P = E.substring(0, R);
    if (["rgb", "rgba", "hsl", "hsla", "color"].indexOf(P) === -1)
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: Unsupported \`${E}\` color.
The following formats are supported: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color().` : (0, t.default)(9, E));
    let A = E.substring(R + 1, E.length - 1), D;
    if (P === "color") {
      if (A = A.split(" "), D = A.shift(), A.length === 4 && A[3].charAt(0) === "/" && (A[3] = A[3].slice(1)), ["srgb", "display-p3", "a98-rgb", "prophoto-rgb", "rec-2020"].indexOf(D) === -1)
        throw new Error(process.env.NODE_ENV !== "production" ? `MUI: unsupported \`${D}\` color space.
The following color spaces are supported: srgb, display-p3, a98-rgb, prophoto-rgb, rec-2020.` : (0, t.default)(10, D));
    } else
      A = A.split(",");
    return A = A.map((N) => parseFloat(N)), {
      type: P,
      values: A,
      colorSpace: D
    };
  }
  const s = (E) => {
    const R = a(E);
    return R.values.slice(0, 3).map((P, A) => R.type.indexOf("hsl") !== -1 && A !== 0 ? `${P}%` : P).join(" ");
  };
  fn.colorChannel = s;
  const c = (E, R) => {
    try {
      return s(E);
    } catch (P) {
      return R && process.env.NODE_ENV !== "production" && console.warn(R), E;
    }
  };
  fn.private_safeColorChannel = c;
  function l(E) {
    const {
      type: R,
      colorSpace: P
    } = E;
    let {
      values: A
    } = E;
    return R.indexOf("rgb") !== -1 ? A = A.map((D, N) => N < 3 ? parseInt(D, 10) : D) : R.indexOf("hsl") !== -1 && (A[1] = `${A[1]}%`, A[2] = `${A[2]}%`), R.indexOf("color") !== -1 ? A = `${P} ${A.join(" ")}` : A = `${A.join(", ")}`, `${R}(${A})`;
  }
  function d(E) {
    if (E.indexOf("#") === 0)
      return E;
    const {
      values: R
    } = a(E);
    return `#${R.map((P, A) => i(A === 3 ? Math.round(255 * P) : P)).join("")}`;
  }
  function f(E) {
    E = a(E);
    const {
      values: R
    } = E, P = R[0], A = R[1] / 100, D = R[2] / 100, N = A * Math.min(D, 1 - D), F = (j, U = (j + P / 30) % 12) => D - N * Math.max(Math.min(U - 3, 9 - U, 1), -1);
    let $ = "rgb";
    const I = [Math.round(F(0) * 255), Math.round(F(8) * 255), Math.round(F(4) * 255)];
    return E.type === "hsla" && ($ += "a", I.push(R[3])), l({
      type: $,
      values: I
    });
  }
  function p(E) {
    E = a(E);
    let R = E.type === "hsl" || E.type === "hsla" ? a(f(E)).values : E.values;
    return R = R.map((P) => (E.type !== "color" && (P /= 255), P <= 0.03928 ? P / 12.92 : li((P + 0.055) / 1.055, 2.4))), Number((0.2126 * R[0] + 0.7152 * R[1] + 0.0722 * R[2]).toFixed(3));
  }
  function m(E, R) {
    const P = p(E), A = p(R);
    return (Math.max(P, A) + 0.05) / (Math.min(P, A) + 0.05);
  }
  function v(E, R) {
    return E = a(E), R = r(R), (E.type === "rgb" || E.type === "hsl") && (E.type += "a"), E.type === "color" ? E.values[3] = `/${R}` : E.values[3] = R, l(E);
  }
  function g(E, R, P) {
    try {
      return v(E, R);
    } catch (A) {
      return P && process.env.NODE_ENV !== "production" && console.warn(P), E;
    }
  }
  function b(E, R) {
    if (E = a(E), R = r(R), E.type.indexOf("hsl") !== -1)
      E.values[2] *= 1 - R;
    else if (E.type.indexOf("rgb") !== -1 || E.type.indexOf("color") !== -1)
      for (let P = 0; P < 3; P += 1)
        E.values[P] *= 1 - R;
    return l(E);
  }
  function x(E, R, P) {
    try {
      return b(E, R);
    } catch (A) {
      return P && process.env.NODE_ENV !== "production" && console.warn(P), E;
    }
  }
  function T(E, R) {
    if (E = a(E), R = r(R), E.type.indexOf("hsl") !== -1)
      E.values[2] += (100 - E.values[2]) * R;
    else if (E.type.indexOf("rgb") !== -1)
      for (let P = 0; P < 3; P += 1)
        E.values[P] += (255 - E.values[P]) * R;
    else if (E.type.indexOf("color") !== -1)
      for (let P = 0; P < 3; P += 1)
        E.values[P] += (1 - E.values[P]) * R;
    return l(E);
  }
  function S(E, R, P) {
    try {
      return T(E, R);
    } catch (A) {
      return P && process.env.NODE_ENV !== "production" && console.warn(P), E;
    }
  }
  function _(E, R = 0.15) {
    return p(E) > 0.5 ? b(E, R) : T(E, R);
  }
  function w(E, R, P) {
    try {
      return _(E, R);
    } catch (A) {
      return P && process.env.NODE_ENV !== "production" && console.warn(P), E;
    }
  }
  function k(E, R, P, A = 1) {
    const D = (I, j) => Math.round(li(li(I, 1 / A) * (1 - P) + li(j, 1 / A) * P, A)), N = a(E), F = a(R), $ = [D(N.values[0], F.values[0]), D(N.values[1], F.values[1]), D(N.values[2], F.values[2])];
    return l({
      type: "rgb",
      values: $
    });
  }
  return fn;
}
var tn = zU();
const BU = {
  black: "#000",
  white: "#fff"
}, $d = BU, HU = {
  50: "#fafafa",
  100: "#f5f5f5",
  200: "#eeeeee",
  300: "#e0e0e0",
  400: "#bdbdbd",
  500: "#9e9e9e",
  600: "#757575",
  700: "#616161",
  800: "#424242",
  900: "#212121",
  A100: "#f5f5f5",
  A200: "#eeeeee",
  A400: "#bdbdbd",
  A700: "#616161"
}, jU = HU, WU = {
  50: "#f3e5f5",
  100: "#e1bee7",
  200: "#ce93d8",
  300: "#ba68c8",
  400: "#ab47bc",
  500: "#9c27b0",
  600: "#8e24aa",
  700: "#7b1fa2",
  800: "#6a1b9a",
  900: "#4a148c",
  A100: "#ea80fc",
  A200: "#e040fb",
  A400: "#d500f9",
  A700: "#aa00ff"
}, El = WU, VU = {
  50: "#ffebee",
  100: "#ffcdd2",
  200: "#ef9a9a",
  300: "#e57373",
  400: "#ef5350",
  500: "#f44336",
  600: "#e53935",
  700: "#d32f2f",
  800: "#c62828",
  900: "#b71c1c",
  A100: "#ff8a80",
  A200: "#ff5252",
  A400: "#ff1744",
  A700: "#d50000"
}, kl = VU, UU = {
  50: "#fff3e0",
  100: "#ffe0b2",
  200: "#ffcc80",
  300: "#ffb74d",
  400: "#ffa726",
  500: "#ff9800",
  600: "#fb8c00",
  700: "#f57c00",
  800: "#ef6c00",
  900: "#e65100",
  A100: "#ffd180",
  A200: "#ffab40",
  A400: "#ff9100",
  A700: "#ff6d00"
}, Eu = UU, qU = {
  50: "#e3f2fd",
  100: "#bbdefb",
  200: "#90caf9",
  300: "#64b5f6",
  400: "#42a5f5",
  500: "#2196f3",
  600: "#1e88e5",
  700: "#1976d2",
  800: "#1565c0",
  900: "#0d47a1",
  A100: "#82b1ff",
  A200: "#448aff",
  A400: "#2979ff",
  A700: "#2962ff"
}, Ml = qU, GU = {
  50: "#e1f5fe",
  100: "#b3e5fc",
  200: "#81d4fa",
  300: "#4fc3f7",
  400: "#29b6f6",
  500: "#03a9f4",
  600: "#039be5",
  700: "#0288d1",
  800: "#0277bd",
  900: "#01579b",
  A100: "#80d8ff",
  A200: "#40c4ff",
  A400: "#00b0ff",
  A700: "#0091ea"
}, Rl = GU, YU = {
  50: "#e8f5e9",
  100: "#c8e6c9",
  200: "#a5d6a7",
  300: "#81c784",
  400: "#66bb6a",
  500: "#4caf50",
  600: "#43a047",
  700: "#388e3c",
  800: "#2e7d32",
  900: "#1b5e20",
  A100: "#b9f6ca",
  A200: "#69f0ae",
  A400: "#00e676",
  A700: "#00c853"
}, Pl = YU, ZU = ["mode", "contrastThreshold", "tonalOffset"], GS = {
  // The colors used to style the text.
  text: {
    // The most important text.
    primary: "rgba(0, 0, 0, 0.87)",
    // Secondary text.
    secondary: "rgba(0, 0, 0, 0.6)",
    // Disabled text have even lower visual prominence.
    disabled: "rgba(0, 0, 0, 0.38)"
  },
  // The color used to divide different elements.
  divider: "rgba(0, 0, 0, 0.12)",
  // The background colors used to style the surfaces.
  // Consistency between these values is important.
  background: {
    paper: $d.white,
    default: $d.white
  },
  // The colors used to style the action elements.
  action: {
    // The color of an active action like an icon button.
    active: "rgba(0, 0, 0, 0.54)",
    // The color of an hovered action.
    hover: "rgba(0, 0, 0, 0.04)",
    hoverOpacity: 0.04,
    // The color of a selected action.
    selected: "rgba(0, 0, 0, 0.08)",
    selectedOpacity: 0.08,
    // The color of a disabled action.
    disabled: "rgba(0, 0, 0, 0.26)",
    // The background color of a disabled action.
    disabledBackground: "rgba(0, 0, 0, 0.12)",
    disabledOpacity: 0.38,
    focus: "rgba(0, 0, 0, 0.12)",
    focusOpacity: 0.12,
    activatedOpacity: 0.12
  }
}, e0 = {
  text: {
    primary: $d.white,
    secondary: "rgba(255, 255, 255, 0.7)",
    disabled: "rgba(255, 255, 255, 0.5)",
    icon: "rgba(255, 255, 255, 0.5)"
  },
  divider: "rgba(255, 255, 255, 0.12)",
  background: {
    paper: "#121212",
    default: "#121212"
  },
  action: {
    active: $d.white,
    hover: "rgba(255, 255, 255, 0.08)",
    hoverOpacity: 0.08,
    selected: "rgba(255, 255, 255, 0.16)",
    selectedOpacity: 0.16,
    disabled: "rgba(255, 255, 255, 0.3)",
    disabledBackground: "rgba(255, 255, 255, 0.12)",
    disabledOpacity: 0.38,
    focus: "rgba(255, 255, 255, 0.12)",
    focusOpacity: 0.12,
    activatedOpacity: 0.24
  }
};
function YS(e, t, n, r) {
  const o = r.light || r, i = r.dark || r * 1.5;
  e[t] || (e.hasOwnProperty(n) ? e[t] = e[n] : t === "light" ? e.light = tn.lighten(e.main, o) : t === "dark" && (e.dark = tn.darken(e.main, i)));
}
function XU(e = "light") {
  return e === "dark" ? {
    main: Ml[200],
    light: Ml[50],
    dark: Ml[400]
  } : {
    main: Ml[700],
    light: Ml[400],
    dark: Ml[800]
  };
}
function KU(e = "light") {
  return e === "dark" ? {
    main: El[200],
    light: El[50],
    dark: El[400]
  } : {
    main: El[500],
    light: El[300],
    dark: El[700]
  };
}
function JU(e = "light") {
  return e === "dark" ? {
    main: kl[500],
    light: kl[300],
    dark: kl[700]
  } : {
    main: kl[700],
    light: kl[400],
    dark: kl[800]
  };
}
function QU(e = "light") {
  return e === "dark" ? {
    main: Rl[400],
    light: Rl[300],
    dark: Rl[700]
  } : {
    main: Rl[700],
    light: Rl[500],
    dark: Rl[900]
  };
}
function eq(e = "light") {
  return e === "dark" ? {
    main: Pl[400],
    light: Pl[300],
    dark: Pl[700]
  } : {
    main: Pl[800],
    light: Pl[500],
    dark: Pl[900]
  };
}
function tq(e = "light") {
  return e === "dark" ? {
    main: Eu[400],
    light: Eu[300],
    dark: Eu[700]
  } : {
    main: "#ed6c02",
    // closest to orange[800] that pass 3:1.
    light: Eu[500],
    dark: Eu[900]
  };
}
function nq(e) {
  const {
    mode: t = "light",
    contrastThreshold: n = 3,
    tonalOffset: r = 0.2
  } = e, o = He(e, ZU), i = e.primary || XU(t), a = e.secondary || KU(t), s = e.error || JU(t), c = e.info || QU(t), l = e.success || eq(t), d = e.warning || tq(t);
  function f(v) {
    const g = tn.getContrastRatio(v, e0.text.primary) >= n ? e0.text.primary : GS.text.primary;
    if (process.env.NODE_ENV !== "production") {
      const b = tn.getContrastRatio(v, g);
      b < 3 && console.error([`MUI: The contrast ratio of ${b}:1 for ${g} on ${v}`, "falls below the WCAG recommended absolute minimum contrast ratio of 3:1.", "https://www.w3.org/TR/2008/REC-WCAG20-20081211/#visual-audio-contrast-contrast"].join(`
`));
    }
    return g;
  }
  const p = ({
    color: v,
    name: g,
    mainShade: b = 500,
    lightShade: x = 300,
    darkShade: T = 700
  }) => {
    if (v = re({}, v), !v.main && v[b] && (v.main = v[b]), !v.hasOwnProperty("main"))
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: The color${g ? ` (${g})` : ""} provided to augmentColor(color) is invalid.
The color object needs to have a \`main\` property or a \`${b}\` property.` : Gs(11, g ? ` (${g})` : "", b));
    if (typeof v.main != "string")
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: The color${g ? ` (${g})` : ""} provided to augmentColor(color) is invalid.
\`color.main\` should be a string, but \`${JSON.stringify(v.main)}\` was provided instead.

Did you intend to use one of the following approaches?

import { green } from "@mui/material/colors";

const theme1 = createTheme({ palette: {
  primary: green,
} });

const theme2 = createTheme({ palette: {
  primary: { main: green[500] },
} });` : Gs(12, g ? ` (${g})` : "", JSON.stringify(v.main)));
    return YS(v, "light", x, r), YS(v, "dark", T, r), v.contrastText || (v.contrastText = f(v.main)), v;
  }, m = {
    dark: e0,
    light: GS
  };
  return process.env.NODE_ENV !== "production" && (m[t] || console.error(`MUI: The palette mode \`${t}\` is not supported.`)), co(re({
    // A collection of common colors.
    common: re({}, $d),
    // prevent mutable object.
    // The palette mode, can be light or dark.
    mode: t,
    // The colors used to represent primary interface elements for a user.
    primary: p({
      color: i,
      name: "primary"
    }),
    // The colors used to represent secondary interface elements for a user.
    secondary: p({
      color: a,
      name: "secondary",
      mainShade: "A400",
      lightShade: "A200",
      darkShade: "A700"
    }),
    // The colors used to represent interface elements that the user should be made aware of.
    error: p({
      color: s,
      name: "error"
    }),
    // The colors used to represent potentially dangerous actions or important messages.
    warning: p({
      color: d,
      name: "warning"
    }),
    // The colors used to present information to the user that is neutral and not necessarily important.
    info: p({
      color: c,
      name: "info"
    }),
    // The colors used to indicate the successful completion of an action that user triggered.
    success: p({
      color: l,
      name: "success"
    }),
    // The grey colors.
    grey: jU,
    // Used by `getContrastText()` to maximize the contrast between
    // the background and the text.
    contrastThreshold: n,
    // Takes a background color and returns the text color that maximizes the contrast.
    getContrastText: f,
    // Generate a rich color object.
    augmentColor: p,
    // Used by the functions below to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    tonalOffset: r
  }, m[t]), o);
}
const rq = ["fontFamily", "fontSize", "fontWeightLight", "fontWeightRegular", "fontWeightMedium", "fontWeightBold", "htmlFontSize", "allVariants", "pxToRem"];
function oq(e) {
  return Math.round(e * 1e5) / 1e5;
}
const ZS = {
  textTransform: "uppercase"
}, XS = '"Roboto", "Helvetica", "Arial", sans-serif';
function iq(e, t) {
  const n = typeof t == "function" ? t(e) : t, {
    fontFamily: r = XS,
    // The default font size of the Material Specification.
    fontSize: o = 14,
    // px
    fontWeightLight: i = 300,
    fontWeightRegular: a = 400,
    fontWeightMedium: s = 500,
    fontWeightBold: c = 700,
    // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize: l = 16,
    // Apply the CSS properties to all the variants.
    allVariants: d,
    pxToRem: f
  } = n, p = He(n, rq);
  process.env.NODE_ENV !== "production" && (typeof o != "number" && console.error("MUI: `fontSize` is required to be a number."), typeof l != "number" && console.error("MUI: `htmlFontSize` is required to be a number."));
  const m = o / 14, v = f || ((x) => `${x / l * m}rem`), g = (x, T, S, _, w) => re({
    fontFamily: r,
    fontWeight: x,
    fontSize: v(T),
    // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
    lineHeight: S
  }, r === XS ? {
    letterSpacing: `${oq(_ / T)}em`
  } : {}, w, d), b = {
    h1: g(i, 96, 1.167, -1.5),
    h2: g(i, 60, 1.2, -0.5),
    h3: g(a, 48, 1.167, 0),
    h4: g(a, 34, 1.235, 0.25),
    h5: g(a, 24, 1.334, 0),
    h6: g(s, 20, 1.6, 0.15),
    subtitle1: g(a, 16, 1.75, 0.15),
    subtitle2: g(s, 14, 1.57, 0.1),
    body1: g(a, 16, 1.5, 0.15),
    body2: g(a, 14, 1.43, 0.15),
    button: g(s, 14, 1.75, 0.4, ZS),
    caption: g(a, 12, 1.66, 0.4),
    overline: g(a, 12, 2.66, 1, ZS),
    // TODO v6: Remove handling of 'inherit' variant from the theme as it is already handled in Material UI's Typography component. Also, remember to remove the associated types.
    inherit: {
      fontFamily: "inherit",
      fontWeight: "inherit",
      fontSize: "inherit",
      lineHeight: "inherit",
      letterSpacing: "inherit"
    }
  };
  return co(re({
    htmlFontSize: l,
    pxToRem: v,
    fontFamily: r,
    fontSize: o,
    fontWeightLight: i,
    fontWeightRegular: a,
    fontWeightMedium: s,
    fontWeightBold: c
  }, b), p, {
    clone: !1
    // No need to clone deep
  });
}
const aq = 0.2, sq = 0.14, lq = 0.12;
function ln(...e) {
  return [`${e[0]}px ${e[1]}px ${e[2]}px ${e[3]}px rgba(0,0,0,${aq})`, `${e[4]}px ${e[5]}px ${e[6]}px ${e[7]}px rgba(0,0,0,${sq})`, `${e[8]}px ${e[9]}px ${e[10]}px ${e[11]}px rgba(0,0,0,${lq})`].join(",");
}
const cq = ["none", ln(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0), ln(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0), ln(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0), ln(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0), ln(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0), ln(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0), ln(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1), ln(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2), ln(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2), ln(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3), ln(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3), ln(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4), ln(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4), ln(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4), ln(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5), ln(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5), ln(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5), ln(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6), ln(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6), ln(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7), ln(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7), ln(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7), ln(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8), ln(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)], uq = cq, dq = ["duration", "easing", "delay"], fq = {
  // This is the most common easing curve.
  easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
  // Objects enter the screen at full velocity from off-screen and
  // slowly decelerate to a resting point.
  easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
  // Objects leave the screen at full velocity. They do not decelerate when off-screen.
  easeIn: "cubic-bezier(0.4, 0, 1, 1)",
  // The sharp curve is used by objects that may return to the screen at any time.
  sharp: "cubic-bezier(0.4, 0, 0.6, 1)"
}, pq = {
  shortest: 150,
  shorter: 200,
  short: 250,
  // most basic recommended timing
  standard: 300,
  // this is to be used in complex animations
  complex: 375,
  // recommended when something is entering screen
  enteringScreen: 225,
  // recommended when something is leaving screen
  leavingScreen: 195
};
function KS(e) {
  return `${Math.round(e)}ms`;
}
function hq(e) {
  if (!e)
    return 0;
  const t = e / 36;
  return Math.round((4 + 15 * li(t, 0.25) + t / 5) * 10);
}
function mq(e) {
  const t = re({}, fq, e.easing), n = re({}, pq, e.duration);
  return re({
    getAutoHeightDuration: hq,
    create: (r = ["all"], o = {}) => {
      const {
        duration: i = n.standard,
        easing: a = t.easeInOut,
        delay: s = 0
      } = o, c = He(o, dq);
      if (process.env.NODE_ENV !== "production") {
        const l = (f) => typeof f == "string", d = (f) => !isNaN(parseFloat(f));
        !l(r) && !Array.isArray(r) && console.error('MUI: Argument "props" must be a string or Array.'), !d(i) && !l(i) && console.error(`MUI: Argument "duration" must be a number or a string but found ${i}.`), l(a) || console.error('MUI: Argument "easing" must be a string.'), !d(s) && !l(s) && console.error('MUI: Argument "delay" must be a number or a string.'), typeof o != "object" && console.error(["MUI: Secong argument of transition.create must be an object.", "Arguments should be either `create('prop1', options)` or `create(['prop1', 'prop2'], options)`"].join(`
`)), Object.keys(c).length !== 0 && console.error(`MUI: Unrecognized argument(s) [${Object.keys(c).join(",")}].`);
      }
      return (Array.isArray(r) ? r : [r]).map((l) => `${l} ${typeof i == "string" ? i : KS(i)} ${a} ${typeof s == "string" ? s : KS(s)}`).join(",");
    }
  }, e, {
    easing: t,
    duration: n
  });
}
const gq = {
  mobileStepper: 1e3,
  fab: 1050,
  speedDial: 1050,
  appBar: 1100,
  drawer: 1200,
  modal: 1300,
  snackbar: 1400,
  tooltip: 1500
}, vq = gq, bq = ["breakpoints", "mixins", "spacing", "palette", "transitions", "typography", "shape"];
function hs(e = {}, ...t) {
  const {
    mixins: n = {},
    palette: r = {},
    transitions: o = {},
    typography: i = {}
  } = e, a = He(e, bq);
  if (e.vars)
    throw new Error(process.env.NODE_ENV !== "production" ? "MUI: `vars` is a private field used for CSS variables support.\nPlease use another name." : Gs(18));
  const s = nq(r), c = q_(e);
  let l = co(c, {
    mixins: LU(c.breakpoints, n),
    palette: s,
    // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
    shadows: uq.slice(),
    typography: iq(s, i),
    transitions: mq(o),
    zIndex: re({}, vq)
  });
  if (l = co(l, a), l = t.reduce((d, f) => co(d, f), l), process.env.NODE_ENV !== "production") {
    const d = ["active", "checked", "completed", "disabled", "error", "expanded", "focused", "focusVisible", "required", "selected"], f = (p, m) => {
      let v;
      for (v in p) {
        const g = p[v];
        if (d.indexOf(v) !== -1 && Object.keys(g).length > 0) {
          if (process.env.NODE_ENV !== "production") {
            const b = Gt("", v);
            console.error([`MUI: The \`${m}\` component increases the CSS specificity of the \`${v}\` internal state.`, "You can not override it like this: ", JSON.stringify(p, null, 2), "", `Instead, you need to use the '&.${b}' syntax:`, JSON.stringify({
              root: {
                [`&.${b}`]: g
              }
            }, null, 2), "", "https://mui.com/r/state-classes-guide"].join(`
`));
          }
          p[v] = {};
        }
      }
    };
    Object.keys(l.components).forEach((p) => {
      const m = l.components[p].styleOverrides;
      m && p.indexOf("Mui") === 0 && f(m, p);
    });
  }
  return l.unstable_sxConfig = re({}, vf, a == null ? void 0 : a.unstable_sxConfig), l.unstable_sx = function(d) {
    return U_({
      sx: d,
      theme: this
    });
  }, l;
}
const yq = hs(), Zm = yq, _c = "$$material";
function yN(e) {
  return e !== "ownerState" && e !== "theme" && e !== "sx" && e !== "as";
}
const _q = (e) => yN(e) && e !== "classes", Xo = _q, wq = IU({
  themeId: _c,
  defaultTheme: Zm,
  rootShouldForwardProp: Xo
}), Fe = wq;
function xq(e) {
  const {
    theme: t,
    name: n,
    props: r
  } = e;
  return !t || !t.components || !t.components[n] || !t.components[n].defaultProps ? r : eN(t.components[n].defaultProps, r);
}
function Cq(e) {
  return Object.keys(e).length === 0;
}
function _N(e = null) {
  const t = B.useContext(Hi);
  return !t || Cq(t) ? e : t;
}
const Sq = q_();
function G_(e = Sq) {
  return _N(e);
}
function Tq({
  props: e,
  name: t,
  defaultTheme: n,
  themeId: r
}) {
  let o = G_(n);
  return r && (o = o[r] || o), xq({
    theme: o,
    name: t,
    props: e
  });
}
function rn({
  props: e,
  name: t
}) {
  return Tq({
    props: e,
    name: t,
    defaultTheme: Zm,
    themeId: _c
  });
}
const wN = "base";
function Eq(e) {
  return `${wN}--${e}`;
}
function kq(e, t) {
  return `${wN}-${e}-${t}`;
}
function xN(e, t) {
  const n = tN[t];
  return n ? Eq(n) : kq(e, t);
}
function Mq(e, t) {
  const n = {};
  return t.forEach((r) => {
    n[r] = xN(e, r);
  }), n;
}
const Rq = ["input", "select", "textarea", "a[href]", "button", "[tabindex]", "audio[controls]", "video[controls]", '[contenteditable]:not([contenteditable="false"])'].join(",");
function Pq(e) {
  const t = parseInt(e.getAttribute("tabindex") || "", 10);
  return Number.isNaN(t) ? e.contentEditable === "true" || (e.nodeName === "AUDIO" || e.nodeName === "VIDEO" || e.nodeName === "DETAILS") && e.getAttribute("tabindex") === null ? 0 : e.tabIndex : t;
}
function Oq(e) {
  if (e.tagName !== "INPUT" || e.type !== "radio" || !e.name)
    return !1;
  const t = (r) => e.ownerDocument.querySelector(`input[type="radio"]${r}`);
  let n = t(`[name="${e.name}"]:checked`);
  return n || (n = t(`[name="${e.name}"]`)), n !== e;
}
function Nq(e) {
  return !(e.disabled || e.tagName === "INPUT" && e.type === "hidden" || Oq(e));
}
function Aq(e) {
  const t = [], n = [];
  return Array.from(e.querySelectorAll(Rq)).forEach((r, o) => {
    const i = Pq(r);
    i === -1 || !Nq(r) || (i === 0 ? t.push(r) : n.push({
      documentOrder: o,
      tabIndex: i,
      node: r
    }));
  }), n.sort((r, o) => r.tabIndex === o.tabIndex ? r.documentOrder - o.documentOrder : r.tabIndex - o.tabIndex).map((r) => r.node).concat(t);
}
function Dq() {
  return !0;
}
function Eh(e) {
  const {
    children: t,
    disableAutoFocus: n = !1,
    disableEnforceFocus: r = !1,
    disableRestoreFocus: o = !1,
    getTabbable: i = Aq,
    isEnabled: a = Dq,
    open: s
  } = e, c = B.useRef(!1), l = B.useRef(null), d = B.useRef(null), f = B.useRef(null), p = B.useRef(null), m = B.useRef(!1), v = B.useRef(null), g = or(t.ref, v), b = B.useRef(null);
  B.useEffect(() => {
    !s || !v.current || (m.current = !n);
  }, [n, s]), B.useEffect(() => {
    if (!s || !v.current)
      return;
    const S = Ar(v.current);
    return v.current.contains(S.activeElement) || (v.current.hasAttribute("tabIndex") || (process.env.NODE_ENV !== "production" && console.error(["MUI: The modal content node does not accept focus.", 'For the benefit of assistive technologies, the tabIndex of the node is being set to "-1".'].join(`
`)), v.current.setAttribute("tabIndex", "-1")), m.current && v.current.focus()), () => {
      o || (f.current && f.current.focus && (c.current = !0, f.current.focus()), f.current = null);
    };
  }, [s]), B.useEffect(() => {
    if (!s || !v.current)
      return;
    const S = Ar(v.current), _ = (E) => {
      b.current = E, !(r || !a() || E.key !== "Tab") && S.activeElement === v.current && E.shiftKey && (c.current = !0, d.current && d.current.focus());
    }, w = () => {
      const E = v.current;
      if (E === null)
        return;
      if (!S.hasFocus() || !a() || c.current) {
        c.current = !1;
        return;
      }
      if (E.contains(S.activeElement) || r && S.activeElement !== l.current && S.activeElement !== d.current)
        return;
      if (S.activeElement !== p.current)
        p.current = null;
      else if (p.current !== null)
        return;
      if (!m.current)
        return;
      let R = [];
      if ((S.activeElement === l.current || S.activeElement === d.current) && (R = i(v.current)), R.length > 0) {
        var P, A;
        const D = !!((P = b.current) != null && P.shiftKey && ((A = b.current) == null ? void 0 : A.key) === "Tab"), N = R[0], F = R[R.length - 1];
        typeof N != "string" && typeof F != "string" && (D ? F.focus() : N.focus());
      } else
        E.focus();
    };
    S.addEventListener("focusin", w), S.addEventListener("keydown", _, !0);
    const k = setInterval(() => {
      S.activeElement && S.activeElement.tagName === "BODY" && w();
    }, 50);
    return () => {
      clearInterval(k), S.removeEventListener("focusin", w), S.removeEventListener("keydown", _, !0);
    };
  }, [n, r, o, a, s, i]);
  const x = (S) => {
    f.current === null && (f.current = S.relatedTarget), m.current = !0, p.current = S.target;
    const _ = t.props.onFocus;
    _ && _(S);
  }, T = (S) => {
    f.current === null && (f.current = S.relatedTarget), m.current = !0;
  };
  return /* @__PURE__ */ _e(B.Fragment, {
    children: [/* @__PURE__ */ z("div", {
      tabIndex: s ? 0 : -1,
      onFocus: T,
      ref: l,
      "data-testid": "sentinelStart"
    }), /* @__PURE__ */ B.cloneElement(t, {
      ref: g,
      onFocus: x
    }), /* @__PURE__ */ z("div", {
      tabIndex: s ? 0 : -1,
      onFocus: T,
      ref: d,
      "data-testid": "sentinelEnd"
    })]
  });
}
process.env.NODE_ENV !== "production" && (Eh.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A single child content element.
   */
  children: ff,
  /**
   * If `true`, the focus trap will not automatically shift focus to itself when it opens, and
   * replace it to the last focused element when it closes.
   * This also works correctly with any focus trap children that have the `disableAutoFocus` prop.
   *
   * Generally this should never be set to `true` as it makes the focus trap less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableAutoFocus: y.bool,
  /**
   * If `true`, the focus trap will not prevent focus from leaving the focus trap while open.
   *
   * Generally this should never be set to `true` as it makes the focus trap less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableEnforceFocus: y.bool,
  /**
   * If `true`, the focus trap will not restore focus to previously focused element once
   * focus trap is hidden or unmounted.
   * @default false
   */
  disableRestoreFocus: y.bool,
  /**
   * Returns an array of ordered tabbable nodes (i.e. in tab order) within the root.
   * For instance, you can provide the "tabbable" npm dependency.
   * @param {HTMLElement} root
   */
  getTabbable: y.func,
  /**
   * This prop extends the `open` prop.
   * It allows to toggle the open state without having to wait for a rerender when changing the `open` prop.
   * This prop should be memoized.
   * It can be used to support multiple focus trap mounted at the same time.
   * @default function defaultIsEnabled(): boolean {
   *   return true;
   * }
   */
  isEnabled: y.func,
  /**
   * If `true`, focus is locked.
   */
  open: y.bool.isRequired
});
process.env.NODE_ENV !== "production" && (Eh.propTypes = Lm(Eh.propTypes));
function Iq(e) {
  return typeof e == "function" ? e() : e;
}
const Fd = /* @__PURE__ */ B.forwardRef(function(e, t) {
  const {
    children: n,
    container: r,
    disablePortal: o = !1
  } = e, [i, a] = B.useState(null), s = or(/* @__PURE__ */ B.isValidElement(n) ? n.ref : null, t);
  if ($i(() => {
    o || a(Iq(r) || document.body);
  }, [r, o]), $i(() => {
    if (i && !o)
      return Jb(t, i), () => {
        Jb(t, null);
      };
  }, [t, i, o]), o) {
    if (/* @__PURE__ */ B.isValidElement(n)) {
      const c = {
        ref: s
      };
      return /* @__PURE__ */ B.cloneElement(n, c);
    }
    return /* @__PURE__ */ z(B.Fragment, {
      children: n
    });
  }
  return /* @__PURE__ */ z(B.Fragment, {
    children: i && /* @__PURE__ */ MO.createPortal(n, i)
  });
});
process.env.NODE_ENV !== "production" && (Fd.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The children to render into the `container`.
   */
  children: y.node,
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * You can also provide a callback, which is called in a React layout effect.
   * This lets you set the container from a ref, and also makes server-side rendering possible.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: y.oneOfType([fa, y.func]),
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: y.bool
});
process.env.NODE_ENV !== "production" && (Fd.propTypes = Lm(Fd.propTypes));
function Lq(e) {
  const t = Ar(e);
  return t.body === e ? Ys(e).innerWidth > t.documentElement.clientWidth : e.scrollHeight > e.clientHeight;
}
function hd(e, t) {
  t ? e.setAttribute("aria-hidden", "true") : e.removeAttribute("aria-hidden");
}
function JS(e) {
  return parseInt(Ys(e).getComputedStyle(e).paddingRight, 10) || 0;
}
function $q(e) {
  const t = ["TEMPLATE", "SCRIPT", "STYLE", "LINK", "MAP", "META", "NOSCRIPT", "PICTURE", "COL", "COLGROUP", "PARAM", "SLOT", "SOURCE", "TRACK"].indexOf(e.tagName) !== -1, n = e.tagName === "INPUT" && e.getAttribute("type") === "hidden";
  return t || n;
}
function QS(e, t, n, r, o) {
  const i = [t, n, ...r];
  [].forEach.call(e.children, (a) => {
    const s = i.indexOf(a) === -1, c = !$q(a);
    s && c && hd(a, o);
  });
}
function t0(e, t) {
  let n = -1;
  return e.some((r, o) => t(r) ? (n = o, !0) : !1), n;
}
function Fq(e, t) {
  const n = [], r = e.container;
  if (!t.disableScrollLock) {
    if (Lq(r)) {
      const i = Q3(Ar(r));
      n.push({
        value: r.style.paddingRight,
        property: "padding-right",
        el: r
      }), r.style.paddingRight = `${JS(r) + i}px`;
      const a = Ar(r).querySelectorAll(".mui-fixed");
      [].forEach.call(a, (s) => {
        n.push({
          value: s.style.paddingRight,
          property: "padding-right",
          el: s
        }), s.style.paddingRight = `${JS(s) + i}px`;
      });
    }
    let o;
    if (r.parentNode instanceof DocumentFragment)
      o = Ar(r).body;
    else {
      const i = r.parentElement, a = Ys(r);
      o = (i == null ? void 0 : i.nodeName) === "HTML" && a.getComputedStyle(i).overflowY === "scroll" ? i : r;
    }
    n.push({
      value: o.style.overflow,
      property: "overflow",
      el: o
    }, {
      value: o.style.overflowX,
      property: "overflow-x",
      el: o
    }, {
      value: o.style.overflowY,
      property: "overflow-y",
      el: o
    }), o.style.overflow = "hidden";
  }
  return () => {
    n.forEach(({
      value: o,
      el: i,
      property: a
    }) => {
      o ? i.style.setProperty(a, o) : i.style.removeProperty(a);
    });
  };
}
function zq(e) {
  const t = [];
  return [].forEach.call(e.children, (n) => {
    n.getAttribute("aria-hidden") === "true" && t.push(n);
  }), t;
}
class Bq {
  constructor() {
    this.containers = void 0, this.modals = void 0, this.modals = [], this.containers = [];
  }
  add(t, n) {
    let r = this.modals.indexOf(t);
    if (r !== -1)
      return r;
    r = this.modals.length, this.modals.push(t), t.modalRef && hd(t.modalRef, !1);
    const o = zq(n);
    QS(n, t.mount, t.modalRef, o, !0);
    const i = t0(this.containers, (a) => a.container === n);
    return i !== -1 ? (this.containers[i].modals.push(t), r) : (this.containers.push({
      modals: [t],
      container: n,
      restore: null,
      hiddenSiblings: o
    }), r);
  }
  mount(t, n) {
    const r = t0(this.containers, (i) => i.modals.indexOf(t) !== -1), o = this.containers[r];
    o.restore || (o.restore = Fq(o, n));
  }
  remove(t, n = !0) {
    const r = this.modals.indexOf(t);
    if (r === -1)
      return r;
    const o = t0(this.containers, (a) => a.modals.indexOf(t) !== -1), i = this.containers[o];
    if (i.modals.splice(i.modals.indexOf(t), 1), this.modals.splice(r, 1), i.modals.length === 0)
      i.restore && i.restore(), t.modalRef && hd(t.modalRef, n), QS(i.container, t.mount, t.modalRef, i.hiddenSiblings, !1), this.containers.splice(o, 1);
    else {
      const a = i.modals[i.modals.length - 1];
      a.modalRef && hd(a.modalRef, !1);
    }
    return r;
  }
  isTopModal(t) {
    return this.modals.length > 0 && this.modals[this.modals.length - 1] === t;
  }
}
function Hq(e) {
  return typeof e == "function" ? e() : e;
}
function jq(e) {
  return e ? e.props.hasOwnProperty("in") : !1;
}
const Wq = new Bq();
function Vq(e) {
  const {
    container: t,
    disableEscapeKeyDown: n = !1,
    disableScrollLock: r = !1,
    // @ts-ignore internal logic - Base UI supports the manager as a prop too
    manager: o = Wq,
    closeAfterTransition: i = !1,
    onTransitionEnter: a,
    onTransitionExited: s,
    children: c,
    onClose: l,
    open: d,
    rootRef: f
  } = e, p = B.useRef({}), m = B.useRef(null), v = B.useRef(null), g = or(v, f), [b, x] = B.useState(!d), T = jq(c);
  let S = !0;
  (e["aria-hidden"] === "false" || e["aria-hidden"] === !1) && (S = !1);
  const _ = () => Ar(m.current), w = () => (p.current.modalRef = v.current, p.current.mount = m.current, p.current), k = () => {
    o.mount(w(), {
      disableScrollLock: r
    }), v.current && (v.current.scrollTop = 0);
  }, E = Ya(() => {
    const F = Hq(t) || _().body;
    o.add(w(), F), v.current && k();
  }), R = B.useCallback(() => o.isTopModal(w()), [o]), P = Ya((F) => {
    m.current = F, F && (d && R() ? k() : v.current && hd(v.current, S));
  }), A = B.useCallback(() => {
    o.remove(w(), S);
  }, [S, o]);
  B.useEffect(() => () => {
    A();
  }, [A]), B.useEffect(() => {
    d ? E() : (!T || !i) && A();
  }, [d, A, T, i, E]);
  const D = (F) => ($) => {
    var I;
    (I = F.onKeyDown) == null || I.call(F, $), !($.key !== "Escape" || $.which === 229 || // Wait until IME is settled.
    !R()) && (n || ($.stopPropagation(), l && l($, "escapeKeyDown")));
  }, N = (F) => ($) => {
    var I;
    (I = F.onClick) == null || I.call(F, $), $.target === $.currentTarget && l && l($, "backdropClick");
  };
  return {
    getRootProps: (F = {}) => {
      const $ = U3(e);
      delete $.onTransitionEnter, delete $.onTransitionExited;
      const I = re({}, $, F);
      return re({
        role: "presentation"
      }, I, {
        onKeyDown: D(I),
        ref: g
      });
    },
    getBackdropProps: (F = {}) => {
      const $ = F;
      return re({
        "aria-hidden": !0
      }, $, {
        onClick: N($),
        open: d
      });
    },
    getTransitionProps: () => {
      const F = () => {
        x(!1), a && a();
      }, $ = () => {
        x(!0), s && s(), i && A();
      };
      return {
        onEnter: PS(F, c == null ? void 0 : c.props.onEnter),
        onExited: PS($, c == null ? void 0 : c.props.onExited)
      };
    },
    rootRef: g,
    portalRef: P,
    isTopModal: R,
    exited: b,
    hasTransition: T
  };
}
var Vr = "top", Ho = "bottom", jo = "right", Ur = "left", Y_ = "auto", bf = [Vr, Ho, jo, Ur], wc = "start", zd = "end", Uq = "clippingParents", CN = "viewport", ku = "popper", qq = "reference", eT = /* @__PURE__ */ bf.reduce(function(e, t) {
  return e.concat([t + "-" + wc, t + "-" + zd]);
}, []), SN = /* @__PURE__ */ [].concat(bf, [Y_]).reduce(function(e, t) {
  return e.concat([t, t + "-" + wc, t + "-" + zd]);
}, []), Gq = "beforeRead", Yq = "read", Zq = "afterRead", Xq = "beforeMain", Kq = "main", Jq = "afterMain", Qq = "beforeWrite", eG = "write", tG = "afterWrite", nG = [Gq, Yq, Zq, Xq, Kq, Jq, Qq, eG, tG];
function Fi(e) {
  return e ? (e.nodeName || "").toLowerCase() : null;
}
function po(e) {
  if (e == null)
    return window;
  if (e.toString() !== "[object Window]") {
    var t = e.ownerDocument;
    return t && t.defaultView || window;
  }
  return e;
}
function Xs(e) {
  var t = po(e).Element;
  return e instanceof t || e instanceof Element;
}
function zo(e) {
  var t = po(e).HTMLElement;
  return e instanceof t || e instanceof HTMLElement;
}
function Z_(e) {
  if (typeof ShadowRoot == "undefined")
    return !1;
  var t = po(e).ShadowRoot;
  return e instanceof t || e instanceof ShadowRoot;
}
function rG(e) {
  var t = e.state;
  Object.keys(t.elements).forEach(function(n) {
    var r = t.styles[n] || {}, o = t.attributes[n] || {}, i = t.elements[n];
    !zo(i) || !Fi(i) || (Object.assign(i.style, r), Object.keys(o).forEach(function(a) {
      var s = o[a];
      s === !1 ? i.removeAttribute(a) : i.setAttribute(a, s === !0 ? "" : s);
    }));
  });
}
function oG(e) {
  var t = e.state, n = {
    popper: {
      position: t.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(t.elements.popper.style, n.popper), t.styles = n, t.elements.arrow && Object.assign(t.elements.arrow.style, n.arrow), function() {
    Object.keys(t.elements).forEach(function(r) {
      var o = t.elements[r], i = t.attributes[r] || {}, a = Object.keys(t.styles.hasOwnProperty(r) ? t.styles[r] : n[r]), s = a.reduce(function(c, l) {
        return c[l] = "", c;
      }, {});
      !zo(o) || !Fi(o) || (Object.assign(o.style, s), Object.keys(i).forEach(function(c) {
        o.removeAttribute(c);
      }));
    });
  };
}
const iG = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: rG,
  effect: oG,
  requires: ["computeStyles"]
};
function Ni(e) {
  return e.split("-")[0];
}
var Vs = Math.max, kh = Math.min, xc = Math.round;
function ay() {
  var e = navigator.userAgentData;
  return e != null && e.brands && Array.isArray(e.brands) ? e.brands.map(function(t) {
    return t.brand + "/" + t.version;
  }).join(" ") : navigator.userAgent;
}
function TN() {
  return !/^((?!chrome|android).)*safari/i.test(ay());
}
function Cc(e, t, n) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  var r = e.getBoundingClientRect(), o = 1, i = 1;
  t && zo(e) && (o = e.offsetWidth > 0 && xc(r.width) / e.offsetWidth || 1, i = e.offsetHeight > 0 && xc(r.height) / e.offsetHeight || 1);
  var a = Xs(e) ? po(e) : window, s = a.visualViewport, c = !TN() && n, l = (r.left + (c && s ? s.offsetLeft : 0)) / o, d = (r.top + (c && s ? s.offsetTop : 0)) / i, f = r.width / o, p = r.height / i;
  return {
    width: f,
    height: p,
    top: d,
    right: l + f,
    bottom: d + p,
    left: l,
    x: l,
    y: d
  };
}
function X_(e) {
  var t = Cc(e), n = e.offsetWidth, r = e.offsetHeight;
  return Math.abs(t.width - n) <= 1 && (n = t.width), Math.abs(t.height - r) <= 1 && (r = t.height), {
    x: e.offsetLeft,
    y: e.offsetTop,
    width: n,
    height: r
  };
}
function EN(e, t) {
  var n = t.getRootNode && t.getRootNode();
  if (e.contains(t))
    return !0;
  if (n && Z_(n)) {
    var r = t;
    do {
      if (r && e.isSameNode(r))
        return !0;
      r = r.parentNode || r.host;
    } while (r);
  }
  return !1;
}
function ha(e) {
  return po(e).getComputedStyle(e);
}
function aG(e) {
  return ["table", "td", "th"].indexOf(Fi(e)) >= 0;
}
function ms(e) {
  return ((Xs(e) ? e.ownerDocument : (
    // $FlowFixMe[prop-missing]
    e.document
  )) || window.document).documentElement;
}
function Xm(e) {
  return Fi(e) === "html" ? e : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    e.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    e.parentNode || // DOM Element detected
    (Z_(e) ? e.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    ms(e)
  );
}
function tT(e) {
  return !zo(e) || // https://github.com/popperjs/popper-core/issues/837
  ha(e).position === "fixed" ? null : e.offsetParent;
}
function sG(e) {
  var t = /firefox/i.test(ay()), n = /Trident/i.test(ay());
  if (n && zo(e)) {
    var r = ha(e);
    if (r.position === "fixed")
      return null;
  }
  var o = Xm(e);
  for (Z_(o) && (o = o.host); zo(o) && ["html", "body"].indexOf(Fi(o)) < 0; ) {
    var i = ha(o);
    if (i.transform !== "none" || i.perspective !== "none" || i.contain === "paint" || ["transform", "perspective"].indexOf(i.willChange) !== -1 || t && i.willChange === "filter" || t && i.filter && i.filter !== "none")
      return o;
    o = o.parentNode;
  }
  return null;
}
function yf(e) {
  for (var t = po(e), n = tT(e); n && aG(n) && ha(n).position === "static"; )
    n = tT(n);
  return n && (Fi(n) === "html" || Fi(n) === "body" && ha(n).position === "static") ? t : n || sG(e) || t;
}
function K_(e) {
  return ["top", "bottom"].indexOf(e) >= 0 ? "x" : "y";
}
function md(e, t, n) {
  return Vs(e, kh(t, n));
}
function lG(e, t, n) {
  var r = md(e, t, n);
  return r > n ? n : r;
}
function kN() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function MN(e) {
  return Object.assign({}, kN(), e);
}
function RN(e, t) {
  return t.reduce(function(n, r) {
    return n[r] = e, n;
  }, {});
}
var cG = function(e, t) {
  return e = typeof e == "function" ? e(Object.assign({}, t.rects, {
    placement: t.placement
  })) : e, MN(typeof e != "number" ? e : RN(e, bf));
};
function uG(e) {
  var t, n = e.state, r = e.name, o = e.options, i = n.elements.arrow, a = n.modifiersData.popperOffsets, s = Ni(n.placement), c = K_(s), l = [Ur, jo].indexOf(s) >= 0, d = l ? "height" : "width";
  if (!(!i || !a)) {
    var f = cG(o.padding, n), p = X_(i), m = c === "y" ? Vr : Ur, v = c === "y" ? Ho : jo, g = n.rects.reference[d] + n.rects.reference[c] - a[c] - n.rects.popper[d], b = a[c] - n.rects.reference[c], x = yf(i), T = x ? c === "y" ? x.clientHeight || 0 : x.clientWidth || 0 : 0, S = g / 2 - b / 2, _ = f[m], w = T - p[d] - f[v], k = T / 2 - p[d] / 2 + S, E = md(_, k, w), R = c;
    n.modifiersData[r] = (t = {}, t[R] = E, t.centerOffset = E - k, t);
  }
}
function dG(e) {
  var t = e.state, n = e.options, r = n.element, o = r === void 0 ? "[data-popper-arrow]" : r;
  o != null && (typeof o == "string" && (o = t.elements.popper.querySelector(o), !o) || EN(t.elements.popper, o) && (t.elements.arrow = o));
}
const fG = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: uG,
  effect: dG,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function Sc(e) {
  return e.split("-")[1];
}
var pG = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function hG(e, t) {
  var n = e.x, r = e.y, o = t.devicePixelRatio || 1;
  return {
    x: xc(n * o) / o || 0,
    y: xc(r * o) / o || 0
  };
}
function nT(e) {
  var t, n = e.popper, r = e.popperRect, o = e.placement, i = e.variation, a = e.offsets, s = e.position, c = e.gpuAcceleration, l = e.adaptive, d = e.roundOffsets, f = e.isFixed, p = a.x, m = p === void 0 ? 0 : p, v = a.y, g = v === void 0 ? 0 : v, b = typeof d == "function" ? d({
    x: m,
    y: g
  }) : {
    x: m,
    y: g
  };
  m = b.x, g = b.y;
  var x = a.hasOwnProperty("x"), T = a.hasOwnProperty("y"), S = Ur, _ = Vr, w = window;
  if (l) {
    var k = yf(n), E = "clientHeight", R = "clientWidth";
    if (k === po(n) && (k = ms(n), ha(k).position !== "static" && s === "absolute" && (E = "scrollHeight", R = "scrollWidth")), k = k, o === Vr || (o === Ur || o === jo) && i === zd) {
      _ = Ho;
      var P = f && k === w && w.visualViewport ? w.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        k[E]
      );
      g -= P - r.height, g *= c ? 1 : -1;
    }
    if (o === Ur || (o === Vr || o === Ho) && i === zd) {
      S = jo;
      var A = f && k === w && w.visualViewport ? w.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        k[R]
      );
      m -= A - r.width, m *= c ? 1 : -1;
    }
  }
  var D = Object.assign({
    position: s
  }, l && pG), N = d === !0 ? hG({
    x: m,
    y: g
  }, po(n)) : {
    x: m,
    y: g
  };
  if (m = N.x, g = N.y, c) {
    var F;
    return Object.assign({}, D, (F = {}, F[_] = T ? "0" : "", F[S] = x ? "0" : "", F.transform = (w.devicePixelRatio || 1) <= 1 ? "translate(" + m + "px, " + g + "px)" : "translate3d(" + m + "px, " + g + "px, 0)", F));
  }
  return Object.assign({}, D, (t = {}, t[_] = T ? g + "px" : "", t[S] = x ? m + "px" : "", t.transform = "", t));
}
function mG(e) {
  var t = e.state, n = e.options, r = n.gpuAcceleration, o = r === void 0 ? !0 : r, i = n.adaptive, a = i === void 0 ? !0 : i, s = n.roundOffsets, c = s === void 0 ? !0 : s, l = {
    placement: Ni(t.placement),
    variation: Sc(t.placement),
    popper: t.elements.popper,
    popperRect: t.rects.popper,
    gpuAcceleration: o,
    isFixed: t.options.strategy === "fixed"
  };
  t.modifiersData.popperOffsets != null && (t.styles.popper = Object.assign({}, t.styles.popper, nT(Object.assign({}, l, {
    offsets: t.modifiersData.popperOffsets,
    position: t.options.strategy,
    adaptive: a,
    roundOffsets: c
  })))), t.modifiersData.arrow != null && (t.styles.arrow = Object.assign({}, t.styles.arrow, nT(Object.assign({}, l, {
    offsets: t.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: c
  })))), t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-placement": t.placement
  });
}
const gG = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: mG,
  data: {}
};
var op = {
  passive: !0
};
function vG(e) {
  var t = e.state, n = e.instance, r = e.options, o = r.scroll, i = o === void 0 ? !0 : o, a = r.resize, s = a === void 0 ? !0 : a, c = po(t.elements.popper), l = [].concat(t.scrollParents.reference, t.scrollParents.popper);
  return i && l.forEach(function(d) {
    d.addEventListener("scroll", n.update, op);
  }), s && c.addEventListener("resize", n.update, op), function() {
    i && l.forEach(function(d) {
      d.removeEventListener("scroll", n.update, op);
    }), s && c.removeEventListener("resize", n.update, op);
  };
}
const bG = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: vG,
  data: {}
};
var yG = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function Yp(e) {
  return e.replace(/left|right|bottom|top/g, function(t) {
    return yG[t];
  });
}
var _G = {
  start: "end",
  end: "start"
};
function rT(e) {
  return e.replace(/start|end/g, function(t) {
    return _G[t];
  });
}
function J_(e) {
  var t = po(e), n = t.pageXOffset, r = t.pageYOffset;
  return {
    scrollLeft: n,
    scrollTop: r
  };
}
function Q_(e) {
  return Cc(ms(e)).left + J_(e).scrollLeft;
}
function wG(e, t) {
  var n = po(e), r = ms(e), o = n.visualViewport, i = r.clientWidth, a = r.clientHeight, s = 0, c = 0;
  if (o) {
    i = o.width, a = o.height;
    var l = TN();
    (l || !l && t === "fixed") && (s = o.offsetLeft, c = o.offsetTop);
  }
  return {
    width: i,
    height: a,
    x: s + Q_(e),
    y: c
  };
}
function xG(e) {
  var t, n = ms(e), r = J_(e), o = (t = e.ownerDocument) == null ? void 0 : t.body, i = Vs(n.scrollWidth, n.clientWidth, o ? o.scrollWidth : 0, o ? o.clientWidth : 0), a = Vs(n.scrollHeight, n.clientHeight, o ? o.scrollHeight : 0, o ? o.clientHeight : 0), s = -r.scrollLeft + Q_(e), c = -r.scrollTop;
  return ha(o || n).direction === "rtl" && (s += Vs(n.clientWidth, o ? o.clientWidth : 0) - i), {
    width: i,
    height: a,
    x: s,
    y: c
  };
}
function ew(e) {
  var t = ha(e), n = t.overflow, r = t.overflowX, o = t.overflowY;
  return /auto|scroll|overlay|hidden/.test(n + o + r);
}
function PN(e) {
  return ["html", "body", "#document"].indexOf(Fi(e)) >= 0 ? e.ownerDocument.body : zo(e) && ew(e) ? e : PN(Xm(e));
}
function gd(e, t) {
  var n;
  t === void 0 && (t = []);
  var r = PN(e), o = r === ((n = e.ownerDocument) == null ? void 0 : n.body), i = po(r), a = o ? [i].concat(i.visualViewport || [], ew(r) ? r : []) : r, s = t.concat(a);
  return o ? s : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    s.concat(gd(Xm(a)))
  );
}
function sy(e) {
  return Object.assign({}, e, {
    left: e.x,
    top: e.y,
    right: e.x + e.width,
    bottom: e.y + e.height
  });
}
function CG(e, t) {
  var n = Cc(e, !1, t === "fixed");
  return n.top = n.top + e.clientTop, n.left = n.left + e.clientLeft, n.bottom = n.top + e.clientHeight, n.right = n.left + e.clientWidth, n.width = e.clientWidth, n.height = e.clientHeight, n.x = n.left, n.y = n.top, n;
}
function oT(e, t, n) {
  return t === CN ? sy(wG(e, n)) : Xs(t) ? CG(t, n) : sy(xG(ms(e)));
}
function SG(e) {
  var t = gd(Xm(e)), n = ["absolute", "fixed"].indexOf(ha(e).position) >= 0, r = n && zo(e) ? yf(e) : e;
  return Xs(r) ? t.filter(function(o) {
    return Xs(o) && EN(o, r) && Fi(o) !== "body";
  }) : [];
}
function TG(e, t, n, r) {
  var o = t === "clippingParents" ? SG(e) : [].concat(t), i = [].concat(o, [n]), a = i[0], s = i.reduce(function(c, l) {
    var d = oT(e, l, r);
    return c.top = Vs(d.top, c.top), c.right = kh(d.right, c.right), c.bottom = kh(d.bottom, c.bottom), c.left = Vs(d.left, c.left), c;
  }, oT(e, a, r));
  return s.width = s.right - s.left, s.height = s.bottom - s.top, s.x = s.left, s.y = s.top, s;
}
function ON(e) {
  var t = e.reference, n = e.element, r = e.placement, o = r ? Ni(r) : null, i = r ? Sc(r) : null, a = t.x + t.width / 2 - n.width / 2, s = t.y + t.height / 2 - n.height / 2, c;
  switch (o) {
    case Vr:
      c = {
        x: a,
        y: t.y - n.height
      };
      break;
    case Ho:
      c = {
        x: a,
        y: t.y + t.height
      };
      break;
    case jo:
      c = {
        x: t.x + t.width,
        y: s
      };
      break;
    case Ur:
      c = {
        x: t.x - n.width,
        y: s
      };
      break;
    default:
      c = {
        x: t.x,
        y: t.y
      };
  }
  var l = o ? K_(o) : null;
  if (l != null) {
    var d = l === "y" ? "height" : "width";
    switch (i) {
      case wc:
        c[l] = c[l] - (t[d] / 2 - n[d] / 2);
        break;
      case zd:
        c[l] = c[l] + (t[d] / 2 - n[d] / 2);
        break;
    }
  }
  return c;
}
function Bd(e, t) {
  t === void 0 && (t = {});
  var n = t, r = n.placement, o = r === void 0 ? e.placement : r, i = n.strategy, a = i === void 0 ? e.strategy : i, s = n.boundary, c = s === void 0 ? Uq : s, l = n.rootBoundary, d = l === void 0 ? CN : l, f = n.elementContext, p = f === void 0 ? ku : f, m = n.altBoundary, v = m === void 0 ? !1 : m, g = n.padding, b = g === void 0 ? 0 : g, x = MN(typeof b != "number" ? b : RN(b, bf)), T = p === ku ? qq : ku, S = e.rects.popper, _ = e.elements[v ? T : p], w = TG(Xs(_) ? _ : _.contextElement || ms(e.elements.popper), c, d, a), k = Cc(e.elements.reference), E = ON({
    reference: k,
    element: S,
    strategy: "absolute",
    placement: o
  }), R = sy(Object.assign({}, S, E)), P = p === ku ? R : k, A = {
    top: w.top - P.top + x.top,
    bottom: P.bottom - w.bottom + x.bottom,
    left: w.left - P.left + x.left,
    right: P.right - w.right + x.right
  }, D = e.modifiersData.offset;
  if (p === ku && D) {
    var N = D[o];
    Object.keys(A).forEach(function(F) {
      var $ = [jo, Ho].indexOf(F) >= 0 ? 1 : -1, I = [Vr, Ho].indexOf(F) >= 0 ? "y" : "x";
      A[F] += N[I] * $;
    });
  }
  return A;
}
function EG(e, t) {
  t === void 0 && (t = {});
  var n = t, r = n.placement, o = n.boundary, i = n.rootBoundary, a = n.padding, s = n.flipVariations, c = n.allowedAutoPlacements, l = c === void 0 ? SN : c, d = Sc(r), f = d ? s ? eT : eT.filter(function(v) {
    return Sc(v) === d;
  }) : bf, p = f.filter(function(v) {
    return l.indexOf(v) >= 0;
  });
  p.length === 0 && (p = f);
  var m = p.reduce(function(v, g) {
    return v[g] = Bd(e, {
      placement: g,
      boundary: o,
      rootBoundary: i,
      padding: a
    })[Ni(g)], v;
  }, {});
  return Object.keys(m).sort(function(v, g) {
    return m[v] - m[g];
  });
}
function kG(e) {
  if (Ni(e) === Y_)
    return [];
  var t = Yp(e);
  return [rT(e), t, rT(t)];
}
function MG(e) {
  var t = e.state, n = e.options, r = e.name;
  if (!t.modifiersData[r]._skip) {
    for (var o = n.mainAxis, i = o === void 0 ? !0 : o, a = n.altAxis, s = a === void 0 ? !0 : a, c = n.fallbackPlacements, l = n.padding, d = n.boundary, f = n.rootBoundary, p = n.altBoundary, m = n.flipVariations, v = m === void 0 ? !0 : m, g = n.allowedAutoPlacements, b = t.options.placement, x = Ni(b), T = x === b, S = c || (T || !v ? [Yp(b)] : kG(b)), _ = [b].concat(S).reduce(function(K, J) {
      return K.concat(Ni(J) === Y_ ? EG(t, {
        placement: J,
        boundary: d,
        rootBoundary: f,
        padding: l,
        flipVariations: v,
        allowedAutoPlacements: g
      }) : J);
    }, []), w = t.rects.reference, k = t.rects.popper, E = /* @__PURE__ */ new Map(), R = !0, P = _[0], A = 0; A < _.length; A++) {
      var D = _[A], N = Ni(D), F = Sc(D) === wc, $ = [Vr, Ho].indexOf(N) >= 0, I = $ ? "width" : "height", j = Bd(t, {
        placement: D,
        boundary: d,
        rootBoundary: f,
        altBoundary: p,
        padding: l
      }), U = $ ? F ? jo : Ur : F ? Ho : Vr;
      w[I] > k[I] && (U = Yp(U));
      var G = Yp(U), V = [];
      if (i && V.push(j[N] <= 0), s && V.push(j[U] <= 0, j[G] <= 0), V.every(function(K) {
        return K;
      })) {
        P = D, R = !1;
        break;
      }
      E.set(D, V);
    }
    if (R)
      for (var H = v ? 3 : 1, q = function(K) {
        var J = _.find(function(ne) {
          var ae = E.get(ne);
          if (ae)
            return ae.slice(0, K).every(function(te) {
              return te;
            });
        });
        if (J)
          return P = J, "break";
      }, Q = H; Q > 0; Q--) {
        var X = q(Q);
        if (X === "break")
          break;
      }
    t.placement !== P && (t.modifiersData[r]._skip = !0, t.placement = P, t.reset = !0);
  }
}
const RG = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: MG,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function iT(e, t, n) {
  return n === void 0 && (n = {
    x: 0,
    y: 0
  }), {
    top: e.top - t.height - n.y,
    right: e.right - t.width + n.x,
    bottom: e.bottom - t.height + n.y,
    left: e.left - t.width - n.x
  };
}
function aT(e) {
  return [Vr, jo, Ho, Ur].some(function(t) {
    return e[t] >= 0;
  });
}
function PG(e) {
  var t = e.state, n = e.name, r = t.rects.reference, o = t.rects.popper, i = t.modifiersData.preventOverflow, a = Bd(t, {
    elementContext: "reference"
  }), s = Bd(t, {
    altBoundary: !0
  }), c = iT(a, r), l = iT(s, o, i), d = aT(c), f = aT(l);
  t.modifiersData[n] = {
    referenceClippingOffsets: c,
    popperEscapeOffsets: l,
    isReferenceHidden: d,
    hasPopperEscaped: f
  }, t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-reference-hidden": d,
    "data-popper-escaped": f
  });
}
const OG = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: PG
};
function NG(e, t, n) {
  var r = Ni(e), o = [Ur, Vr].indexOf(r) >= 0 ? -1 : 1, i = typeof n == "function" ? n(Object.assign({}, t, {
    placement: e
  })) : n, a = i[0], s = i[1];
  return a = a || 0, s = (s || 0) * o, [Ur, jo].indexOf(r) >= 0 ? {
    x: s,
    y: a
  } : {
    x: a,
    y: s
  };
}
function AG(e) {
  var t = e.state, n = e.options, r = e.name, o = n.offset, i = o === void 0 ? [0, 0] : o, a = SN.reduce(function(d, f) {
    return d[f] = NG(f, t.rects, i), d;
  }, {}), s = a[t.placement], c = s.x, l = s.y;
  t.modifiersData.popperOffsets != null && (t.modifiersData.popperOffsets.x += c, t.modifiersData.popperOffsets.y += l), t.modifiersData[r] = a;
}
const DG = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: AG
};
function IG(e) {
  var t = e.state, n = e.name;
  t.modifiersData[n] = ON({
    reference: t.rects.reference,
    element: t.rects.popper,
    strategy: "absolute",
    placement: t.placement
  });
}
const LG = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: IG,
  data: {}
};
function $G(e) {
  return e === "x" ? "y" : "x";
}
function FG(e) {
  var t = e.state, n = e.options, r = e.name, o = n.mainAxis, i = o === void 0 ? !0 : o, a = n.altAxis, s = a === void 0 ? !1 : a, c = n.boundary, l = n.rootBoundary, d = n.altBoundary, f = n.padding, p = n.tether, m = p === void 0 ? !0 : p, v = n.tetherOffset, g = v === void 0 ? 0 : v, b = Bd(t, {
    boundary: c,
    rootBoundary: l,
    padding: f,
    altBoundary: d
  }), x = Ni(t.placement), T = Sc(t.placement), S = !T, _ = K_(x), w = $G(_), k = t.modifiersData.popperOffsets, E = t.rects.reference, R = t.rects.popper, P = typeof g == "function" ? g(Object.assign({}, t.rects, {
    placement: t.placement
  })) : g, A = typeof P == "number" ? {
    mainAxis: P,
    altAxis: P
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, P), D = t.modifiersData.offset ? t.modifiersData.offset[t.placement] : null, N = {
    x: 0,
    y: 0
  };
  if (k) {
    if (i) {
      var F, $ = _ === "y" ? Vr : Ur, I = _ === "y" ? Ho : jo, j = _ === "y" ? "height" : "width", U = k[_], G = U + b[$], V = U - b[I], H = m ? -R[j] / 2 : 0, q = T === wc ? E[j] : R[j], Q = T === wc ? -R[j] : -E[j], X = t.elements.arrow, K = m && X ? X_(X) : {
        width: 0,
        height: 0
      }, J = t.modifiersData["arrow#persistent"] ? t.modifiersData["arrow#persistent"].padding : kN(), ne = J[$], ae = J[I], te = md(0, E[j], K[j]), le = S ? E[j] / 2 - H - te - ne - A.mainAxis : q - te - ne - A.mainAxis, ce = S ? -E[j] / 2 + H + te + ae + A.mainAxis : Q + te + ae + A.mainAxis, fe = t.elements.arrow && yf(t.elements.arrow), ee = fe ? _ === "y" ? fe.clientTop || 0 : fe.clientLeft || 0 : 0, me = (F = D == null ? void 0 : D[_]) != null ? F : 0, oe = U + le - me - ee, ve = U + ce - me, we = md(m ? kh(G, oe) : G, U, m ? Vs(V, ve) : V);
      k[_] = we, N[_] = we - U;
    }
    if (s) {
      var ye, Ce = _ === "x" ? Vr : Ur, Se = _ === "x" ? Ho : jo, Te = k[w], Ae = w === "y" ? "height" : "width", je = Te + b[Ce], Me = Te - b[Se], ze = [Vr, Ur].indexOf(x) !== -1, ft = (ye = D == null ? void 0 : D[w]) != null ? ye : 0, Ue = ze ? je : Te - E[Ae] - R[Ae] - ft + A.altAxis, Be = ze ? Te + E[Ae] + R[Ae] - ft - A.altAxis : Me, Pe = m && ze ? lG(Ue, Te, Be) : md(m ? Ue : je, Te, m ? Be : Me);
      k[w] = Pe, N[w] = Pe - Te;
    }
    t.modifiersData[r] = N;
  }
}
const zG = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: FG,
  requiresIfExists: ["offset"]
};
function BG(e) {
  return {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  };
}
function HG(e) {
  return e === po(e) || !zo(e) ? J_(e) : BG(e);
}
function jG(e) {
  var t = e.getBoundingClientRect(), n = xc(t.width) / e.offsetWidth || 1, r = xc(t.height) / e.offsetHeight || 1;
  return n !== 1 || r !== 1;
}
function WG(e, t, n) {
  n === void 0 && (n = !1);
  var r = zo(t), o = zo(t) && jG(t), i = ms(t), a = Cc(e, o, n), s = {
    scrollLeft: 0,
    scrollTop: 0
  }, c = {
    x: 0,
    y: 0
  };
  return (r || !r && !n) && ((Fi(t) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  ew(i)) && (s = HG(t)), zo(t) ? (c = Cc(t, !0), c.x += t.clientLeft, c.y += t.clientTop) : i && (c.x = Q_(i))), {
    x: a.left + s.scrollLeft - c.x,
    y: a.top + s.scrollTop - c.y,
    width: a.width,
    height: a.height
  };
}
function VG(e) {
  var t = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Set(), r = [];
  e.forEach(function(i) {
    t.set(i.name, i);
  });
  function o(i) {
    n.add(i.name);
    var a = [].concat(i.requires || [], i.requiresIfExists || []);
    a.forEach(function(s) {
      if (!n.has(s)) {
        var c = t.get(s);
        c && o(c);
      }
    }), r.push(i);
  }
  return e.forEach(function(i) {
    n.has(i.name) || o(i);
  }), r;
}
function UG(e) {
  var t = VG(e);
  return nG.reduce(function(n, r) {
    return n.concat(t.filter(function(o) {
      return o.phase === r;
    }));
  }, []);
}
function qG(e) {
  var t;
  return function() {
    return t || (t = new Promise(function(n) {
      Promise.resolve().then(function() {
        t = void 0, n(e());
      });
    })), t;
  };
}
function GG(e) {
  var t = e.reduce(function(n, r) {
    var o = n[r.name];
    return n[r.name] = o ? Object.assign({}, o, r, {
      options: Object.assign({}, o.options, r.options),
      data: Object.assign({}, o.data, r.data)
    }) : r, n;
  }, {});
  return Object.keys(t).map(function(n) {
    return t[n];
  });
}
var sT = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function lT() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return !t.some(function(r) {
    return !(r && typeof r.getBoundingClientRect == "function");
  });
}
function YG(e) {
  e === void 0 && (e = {});
  var t = e, n = t.defaultModifiers, r = n === void 0 ? [] : n, o = t.defaultOptions, i = o === void 0 ? sT : o;
  return function(a, s, c) {
    c === void 0 && (c = i);
    var l = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, sT, i),
      modifiersData: {},
      elements: {
        reference: a,
        popper: s
      },
      attributes: {},
      styles: {}
    }, d = [], f = !1, p = {
      state: l,
      setOptions: function(g) {
        var b = typeof g == "function" ? g(l.options) : g;
        v(), l.options = Object.assign({}, i, l.options, b), l.scrollParents = {
          reference: Xs(a) ? gd(a) : a.contextElement ? gd(a.contextElement) : [],
          popper: gd(s)
        };
        var x = UG(GG([].concat(r, l.options.modifiers)));
        return l.orderedModifiers = x.filter(function(T) {
          return T.enabled;
        }), m(), p.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!f) {
          var g = l.elements, b = g.reference, x = g.popper;
          if (lT(b, x)) {
            l.rects = {
              reference: WG(b, yf(x), l.options.strategy === "fixed"),
              popper: X_(x)
            }, l.reset = !1, l.placement = l.options.placement, l.orderedModifiers.forEach(function(R) {
              return l.modifiersData[R.name] = Object.assign({}, R.data);
            });
            for (var T = 0; T < l.orderedModifiers.length; T++) {
              if (l.reset === !0) {
                l.reset = !1, T = -1;
                continue;
              }
              var S = l.orderedModifiers[T], _ = S.fn, w = S.options, k = w === void 0 ? {} : w, E = S.name;
              typeof _ == "function" && (l = _({
                state: l,
                options: k,
                name: E,
                instance: p
              }) || l);
            }
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: qG(function() {
        return new Promise(function(g) {
          p.forceUpdate(), g(l);
        });
      }),
      destroy: function() {
        v(), f = !0;
      }
    };
    if (!lT(a, s))
      return p;
    p.setOptions(c).then(function(g) {
      !f && c.onFirstUpdate && c.onFirstUpdate(g);
    });
    function m() {
      l.orderedModifiers.forEach(function(g) {
        var b = g.name, x = g.options, T = x === void 0 ? {} : x, S = g.effect;
        if (typeof S == "function") {
          var _ = S({
            state: l,
            name: b,
            instance: p,
            options: T
          }), w = function() {
          };
          d.push(_ || w);
        }
      });
    }
    function v() {
      d.forEach(function(g) {
        return g();
      }), d = [];
    }
    return p;
  };
}
var ZG = [bG, LG, gG, iG, DG, RG, zG, fG, OG], XG = /* @__PURE__ */ YG({
  defaultModifiers: ZG
});
const NN = "Popper";
function KG(e) {
  return xN(NN, e);
}
Mq(NN, ["root"]);
const JG = ["anchorEl", "children", "direction", "disablePortal", "modifiers", "open", "placement", "popperOptions", "popperRef", "slotProps", "slots", "TransitionProps", "ownerState"], QG = ["anchorEl", "children", "container", "direction", "disablePortal", "keepMounted", "modifiers", "open", "placement", "popperOptions", "popperRef", "style", "transition", "slotProps", "slots"];
function eY(e, t) {
  if (t === "ltr")
    return e;
  switch (e) {
    case "bottom-end":
      return "bottom-start";
    case "bottom-start":
      return "bottom-end";
    case "top-end":
      return "top-start";
    case "top-start":
      return "top-end";
    default:
      return e;
  }
}
function Mh(e) {
  return typeof e == "function" ? e() : e;
}
function Km(e) {
  return e.nodeType !== void 0;
}
function tY(e) {
  return !Km(e);
}
const nY = () => Yt({
  root: ["root"]
}, o9(KG)), rY = {}, oY = /* @__PURE__ */ B.forwardRef(function(e, t) {
  var n;
  const {
    anchorEl: r,
    children: o,
    direction: i,
    disablePortal: a,
    modifiers: s,
    open: c,
    placement: l,
    popperOptions: d,
    popperRef: f,
    slotProps: p = {},
    slots: m = {},
    TransitionProps: v
    // @ts-ignore internal logic
    // prevent from spreading to DOM, it can come from the parent component e.g. Select.
  } = e, g = He(e, JG), b = B.useRef(null), x = or(b, t), T = B.useRef(null), S = or(T, f), _ = B.useRef(S);
  $i(() => {
    _.current = S;
  }, [S]), B.useImperativeHandle(f, () => T.current, []);
  const w = eY(l, i), [k, E] = B.useState(w), [R, P] = B.useState(Mh(r));
  B.useEffect(() => {
    T.current && T.current.forceUpdate();
  }), B.useEffect(() => {
    r && P(Mh(r));
  }, [r]), $i(() => {
    if (!R || !c)
      return;
    const $ = (U) => {
      E(U.placement);
    };
    if (process.env.NODE_ENV !== "production" && R && Km(R) && R.nodeType === 1) {
      const U = R.getBoundingClientRect();
      process.env.NODE_ENV !== "test" && U.top === 0 && U.left === 0 && U.right === 0 && U.bottom === 0 && console.warn(["MUI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
    }
    let I = [{
      name: "preventOverflow",
      options: {
        altBoundary: a
      }
    }, {
      name: "flip",
      options: {
        altBoundary: a
      }
    }, {
      name: "onUpdate",
      enabled: !0,
      phase: "afterWrite",
      fn: ({
        state: U
      }) => {
        $(U);
      }
    }];
    s != null && (I = I.concat(s)), d && d.modifiers != null && (I = I.concat(d.modifiers));
    const j = XG(R, b.current, re({
      placement: w
    }, d, {
      modifiers: I
    }));
    return _.current(j), () => {
      j.destroy(), _.current(null);
    };
  }, [R, a, s, c, d, w]);
  const A = {
    placement: k
  };
  v !== null && (A.TransitionProps = v);
  const D = nY(), N = (n = m.root) != null ? n : "div", F = Zs({
    elementType: N,
    externalSlotProps: p.root,
    externalForwardedProps: g,
    additionalProps: {
      role: "tooltip",
      ref: x
    },
    ownerState: e,
    className: D.root
  });
  return /* @__PURE__ */ z(N, re({}, F, {
    children: typeof o == "function" ? o(A) : o
  }));
}), AN = /* @__PURE__ */ B.forwardRef(function(e, t) {
  const {
    anchorEl: n,
    children: r,
    container: o,
    direction: i = "ltr",
    disablePortal: a = !1,
    keepMounted: s = !1,
    modifiers: c,
    open: l,
    placement: d = "bottom",
    popperOptions: f = rY,
    popperRef: p,
    style: m,
    transition: v = !1,
    slotProps: g = {},
    slots: b = {}
  } = e, x = He(e, QG), [T, S] = B.useState(!0), _ = () => {
    S(!1);
  }, w = () => {
    S(!0);
  };
  if (!s && !l && (!v || T))
    return null;
  let k;
  if (o)
    k = o;
  else if (n) {
    const P = Mh(n);
    k = P && Km(P) ? Ar(P).body : Ar(null).body;
  }
  const E = !l && s && (!v || T) ? "none" : void 0, R = v ? {
    in: l,
    onEnter: _,
    onExited: w
  } : void 0;
  return /* @__PURE__ */ z(Fd, {
    disablePortal: a,
    container: k,
    children: /* @__PURE__ */ z(oY, re({
      anchorEl: n,
      direction: i,
      disablePortal: a,
      modifiers: c,
      ref: t,
      open: v ? !T : l,
      placement: d,
      popperOptions: f,
      popperRef: p,
      slotProps: g,
      slots: b
    }, x, {
      style: re({
        // Prevents scroll issue, waiting for Popper.js to add this style once initiated.
        position: "fixed",
        // Fix Popper.js display issue
        top: 0,
        left: 0,
        display: E
      }, m),
      TransitionProps: R,
      children: r
    }))
  });
});
process.env.NODE_ENV !== "production" && (AN.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * An HTML element, [virtualElement](https://popper.js.org/docs/v2/virtual-elements/),
   * or a function that returns either.
   * It's used to set the position of the popper.
   * The return value will passed as the reference object of the Popper instance.
   */
  anchorEl: fs(y.oneOfType([fa, y.object, y.func]), (e) => {
    if (e.open) {
      const t = Mh(e.anchorEl);
      if (t && Km(t) && t.nodeType === 1) {
        const n = t.getBoundingClientRect();
        if (process.env.NODE_ENV !== "test" && n.top === 0 && n.left === 0 && n.right === 0 && n.bottom === 0)
          return new Error(["MUI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
      } else if (!t || typeof t.getBoundingClientRect != "function" || tY(t) && t.contextElement != null && t.contextElement.nodeType !== 1)
        return new Error(["MUI: The `anchorEl` prop provided to the component is invalid.", "It should be an HTML element instance or a virtualElement ", "(https://popper.js.org/docs/v2/virtual-elements/)."].join(`
`));
    }
    return null;
  }),
  /**
   * Popper render function or node.
   */
  children: y.oneOfType([y.node, y.func]),
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * You can also provide a callback, which is called in a React layout effect.
   * This lets you set the container from a ref, and also makes server-side rendering possible.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: y.oneOfType([fa, y.func]),
  /**
   * Direction of the text.
   * @default 'ltr'
   */
  direction: y.oneOf(["ltr", "rtl"]),
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: y.bool,
  /**
   * Always keep the children in the DOM.
   * This prop can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Popper.
   * @default false
   */
  keepMounted: y.bool,
  /**
   * Popper.js is based on a "plugin-like" architecture,
   * most of its features are fully encapsulated "modifiers".
   *
   * A modifier is a function that is called each time Popper.js needs to
   * compute the position of the popper.
   * For this reason, modifiers should be very performant to avoid bottlenecks.
   * To learn how to create a modifier, [read the modifiers documentation](https://popper.js.org/docs/v2/modifiers/).
   */
  modifiers: y.arrayOf(y.shape({
    data: y.object,
    effect: y.func,
    enabled: y.bool,
    fn: y.func,
    name: y.any,
    options: y.object,
    phase: y.oneOf(["afterMain", "afterRead", "afterWrite", "beforeMain", "beforeRead", "beforeWrite", "main", "read", "write"]),
    requires: y.arrayOf(y.string),
    requiresIfExists: y.arrayOf(y.string)
  })),
  /**
   * If `true`, the component is shown.
   */
  open: y.bool.isRequired,
  /**
   * Popper placement.
   * @default 'bottom'
   */
  placement: y.oneOf(["auto-end", "auto-start", "auto", "bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
  /**
   * Options provided to the [`Popper.js`](https://popper.js.org/docs/v2/constructors/#options) instance.
   * @default {}
   */
  popperOptions: y.shape({
    modifiers: y.array,
    onFirstUpdate: y.func,
    placement: y.oneOf(["auto-end", "auto-start", "auto", "bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
    strategy: y.oneOf(["absolute", "fixed"])
  }),
  /**
   * A ref that points to the used popper instance.
   */
  popperRef: Yo,
  /**
   * The props used for each slot inside the Popper.
   * @default {}
   */
  slotProps: y.shape({
    root: y.oneOfType([y.func, y.object])
  }),
  /**
   * The components used for each slot inside the Popper.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: y.shape({
    root: y.elementType
  }),
  /**
   * Help supporting a react-transition-group/Transition component.
   * @default false
   */
  transition: y.bool
});
const iY = ["onChange", "maxRows", "minRows", "style", "value"];
function ip(e) {
  return parseInt(e, 10) || 0;
}
const aY = {
  shadow: {
    // Visibility needed to hide the extra text area on iPads
    visibility: "hidden",
    // Remove from the content flow
    position: "absolute",
    // Ignore the scrollbar width
    overflow: "hidden",
    height: 0,
    top: 0,
    left: 0,
    // Create a new layer, increase the isolation of the computed values
    transform: "translateZ(0)"
  }
};
function sY(e) {
  return e == null || Object.keys(e).length === 0 || e.outerHeightStyle === 0 && !e.overflowing;
}
const DN = /* @__PURE__ */ B.forwardRef(function(e, t) {
  const {
    onChange: n,
    maxRows: r,
    minRows: o = 1,
    style: i,
    value: a
  } = e, s = He(e, iY), {
    current: c
  } = B.useRef(a != null), l = B.useRef(null), d = or(t, l), f = B.useRef(null), p = B.useCallback(() => {
    const g = l.current, b = Ys(g).getComputedStyle(g);
    if (b.width === "0px")
      return {
        outerHeightStyle: 0,
        overflowing: !1
      };
    const x = f.current;
    x.style.width = b.width, x.value = g.value || e.placeholder || "x", x.value.slice(-1) === `
` && (x.value += " ");
    const T = b.boxSizing, S = ip(b.paddingBottom) + ip(b.paddingTop), _ = ip(b.borderBottomWidth) + ip(b.borderTopWidth), w = x.scrollHeight;
    x.value = "x";
    const k = x.scrollHeight;
    let E = w;
    o && (E = Math.max(Number(o) * k, E)), r && (E = Math.min(Number(r) * k, E)), E = Math.max(E, k);
    const R = E + (T === "border-box" ? S + _ : 0), P = Math.abs(E - w) <= 1;
    return {
      outerHeightStyle: R,
      overflowing: P
    };
  }, [r, o, e.placeholder]), m = B.useCallback(() => {
    const g = p();
    if (sY(g))
      return;
    const b = l.current;
    b.style.height = `${g.outerHeightStyle}px`, b.style.overflow = g.overflowing ? "hidden" : "";
  }, [p]);
  $i(() => {
    const g = () => {
      m();
    };
    let b;
    const x = () => {
      cancelAnimationFrame(b), b = requestAnimationFrame(() => {
        g();
      });
    }, T = K3(g), S = l.current, _ = Ys(S);
    _.addEventListener("resize", T);
    let w;
    return typeof ResizeObserver != "undefined" && (w = new ResizeObserver(process.env.NODE_ENV === "test" ? x : g), w.observe(S)), () => {
      T.clear(), cancelAnimationFrame(b), _.removeEventListener("resize", T), w && w.disconnect();
    };
  }, [p, m]), $i(() => {
    m();
  });
  const v = (g) => {
    c || m(), n && n(g);
  };
  return /* @__PURE__ */ _e(B.Fragment, {
    children: [/* @__PURE__ */ z("textarea", re({
      value: a,
      onChange: v,
      ref: d,
      rows: o,
      style: i
    }, s)), /* @__PURE__ */ z("textarea", {
      "aria-hidden": !0,
      className: e.className,
      readOnly: !0,
      ref: f,
      tabIndex: -1,
      style: re({}, aY.shadow, i, {
        paddingTop: 0,
        paddingBottom: 0
      })
    })]
  });
});
process.env.NODE_ENV !== "production" && (DN.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  className: y.string,
  /**
   * Maximum number of rows to display.
   */
  maxRows: y.oneOfType([y.number, y.string]),
  /**
   * Minimum number of rows to display.
   * @default 1
   */
  minRows: y.oneOfType([y.number, y.string]),
  /**
   * @ignore
   */
  onChange: y.func,
  /**
   * @ignore
   */
  placeholder: y.string,
  /**
   * @ignore
   */
  style: y.object,
  /**
   * @ignore
   */
  value: y.oneOfType([y.arrayOf(y.string), y.number, y.string])
});
function tw({
  props: e,
  states: t,
  muiFormControl: n
}) {
  return t.reduce((r, o) => (r[o] = e[o], n && typeof e[o] == "undefined" && (r[o] = n[o]), r), {});
}
const IN = /* @__PURE__ */ B.createContext(void 0);
process.env.NODE_ENV !== "production" && (IN.displayName = "FormControlContext");
const LN = IN;
function Jm() {
  return B.useContext(LN);
}
function $N({
  styles: e,
  themeId: t,
  defaultTheme: n = {}
}) {
  const r = G_(n), o = typeof e == "function" ? e(t && r[t] || r) : e;
  return /* @__PURE__ */ z(j_, {
    styles: o
  });
}
process.env.NODE_ENV !== "production" && ($N.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  defaultTheme: y.object,
  /**
   * @ignore
   */
  styles: y.oneOfType([y.array, y.func, y.number, y.object, y.string, y.bool]),
  /**
   * @ignore
   */
  themeId: y.string
});
const FN = /* @__PURE__ */ B.createContext(null);
process.env.NODE_ENV !== "production" && (FN.displayName = "ThemeContext");
const zN = FN;
function BN() {
  const e = B.useContext(zN);
  return process.env.NODE_ENV !== "production" && B.useDebugValue(e), e;
}
const lY = typeof Symbol == "function" && Symbol.for, cY = lY ? Symbol.for("mui.nested") : "__THEME_NESTED__";
function uY(e, t) {
  if (typeof t == "function") {
    const n = t(e);
    return process.env.NODE_ENV !== "production" && (n || console.error(["MUI: You should return an object from your theme function, i.e.", "<ThemeProvider theme={() => ({})} />"].join(`
`))), n;
  }
  return re({}, e, t);
}
function Rh(e) {
  const {
    children: t,
    theme: n
  } = e, r = BN();
  process.env.NODE_ENV !== "production" && r === null && typeof n == "function" && console.error(["MUI: You are providing a theme function prop to the ThemeProvider component:", "<ThemeProvider theme={outerTheme => outerTheme} />", "", "However, no outer theme is present.", "Make sure a theme is already injected higher in the React tree or provide a theme object."].join(`
`));
  const o = B.useMemo(() => {
    const i = r === null ? n : uY(r, n);
    return i != null && (i[cY] = r !== null), i;
  }, [n, r]);
  return /* @__PURE__ */ z(zN.Provider, {
    value: o,
    children: t
  });
}
process.env.NODE_ENV !== "production" && (Rh.propTypes = {
  /**
   * Your component tree.
   */
  children: y.node,
  /**
   * A theme object. You can provide a function to extend the outer theme.
   */
  theme: y.oneOfType([y.object, y.func]).isRequired
});
process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "production" && (Rh.propTypes = Lm(Rh.propTypes));
const dY = ["value"], HN = /* @__PURE__ */ B.createContext();
function jN(e) {
  let {
    value: t
  } = e, n = He(e, dY);
  return /* @__PURE__ */ z(HN.Provider, re({
    value: t != null ? t : !0
  }, n));
}
process.env.NODE_ENV !== "production" && (jN.propTypes = {
  children: y.node,
  value: y.bool
});
const Qm = () => {
  const e = B.useContext(HN);
  return e != null ? e : !1;
}, cT = {};
function uT(e, t, n, r = !1) {
  return B.useMemo(() => {
    const o = e && t[e] || t;
    if (typeof n == "function") {
      const i = n(o), a = e ? re({}, t, {
        [e]: i
      }) : i;
      return r ? () => a : a;
    }
    return e ? re({}, t, {
      [e]: n
    }) : re({}, t, n);
  }, [e, t, n, r]);
}
function Ph(e) {
  const {
    children: t,
    theme: n,
    themeId: r
  } = e, o = _N(cT), i = BN() || cT;
  process.env.NODE_ENV !== "production" && (o === null && typeof n == "function" || r && o && !o[r] && typeof n == "function") && console.error(["MUI: You are providing a theme function prop to the ThemeProvider component:", "<ThemeProvider theme={outerTheme => outerTheme} />", "", "However, no outer theme is present.", "Make sure a theme is already injected higher in the React tree or provide a theme object."].join(`
`));
  const a = uT(r, o, n), s = uT(r, i, n, !0), c = a.direction === "rtl";
  return /* @__PURE__ */ z(Rh, {
    theme: s,
    children: /* @__PURE__ */ z(Hi.Provider, {
      value: a,
      children: /* @__PURE__ */ z(jN, {
        value: c,
        children: t
      })
    })
  });
}
process.env.NODE_ENV !== "production" && (Ph.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Your component tree.
   */
  children: y.node,
  /**
   * A theme object. You can provide a function to extend the outer theme.
   */
  theme: y.oneOfType([y.func, y.object]).isRequired,
  /**
   * The design system's unique id for getting the corresponded theme when there are multiple design systems.
   */
  themeId: y.string
});
process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "production" && (Ph.propTypes = Lm(Ph.propTypes));
function Wo(e) {
  return Wo = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Wo(e);
}
function fY(e, t) {
  if (Wo(e) != "object" || !e)
    return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (Wo(r) != "object")
      return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function WN(e) {
  var t = fY(e, "string");
  return Wo(t) == "symbol" ? t : t + "";
}
function VN(e) {
  return /* @__PURE__ */ z($N, re({}, e, {
    defaultTheme: Zm,
    themeId: _c
  }));
}
process.env.NODE_ENV !== "production" && (VN.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The styles you want to apply globally.
   */
  styles: y.oneOfType([y.array, y.func, y.number, y.object, y.string, y.bool])
});
function dT(e) {
  return e != null && !(Array.isArray(e) && e.length === 0);
}
function UN(e, t = !1) {
  return e && (dT(e.value) && e.value !== "" || t && dT(e.defaultValue) && e.defaultValue !== "");
}
function pY(e) {
  return Gt("MuiInputBase", e);
}
const hY = Wt("MuiInputBase", ["root", "formControl", "focused", "disabled", "adornedStart", "adornedEnd", "error", "sizeSmall", "multiline", "colorSecondary", "fullWidth", "hiddenLabel", "readOnly", "input", "inputSizeSmall", "inputMultiline", "inputTypeSearch", "inputAdornedStart", "inputAdornedEnd", "inputHiddenLabel"]), Tc = hY, mY = ["aria-describedby", "autoComplete", "autoFocus", "className", "color", "components", "componentsProps", "defaultValue", "disabled", "disableInjectingGlobalStyles", "endAdornment", "error", "fullWidth", "id", "inputComponent", "inputProps", "inputRef", "margin", "maxRows", "minRows", "multiline", "name", "onBlur", "onChange", "onClick", "onFocus", "onKeyDown", "onKeyUp", "placeholder", "readOnly", "renderSuffix", "rows", "size", "slotProps", "slots", "startAdornment", "type", "value"], eg = (e, t) => {
  const {
    ownerState: n
  } = e;
  return [t.root, n.formControl && t.formControl, n.startAdornment && t.adornedStart, n.endAdornment && t.adornedEnd, n.error && t.error, n.size === "small" && t.sizeSmall, n.multiline && t.multiline, n.color && t[`color${at(n.color)}`], n.fullWidth && t.fullWidth, n.hiddenLabel && t.hiddenLabel];
}, tg = (e, t) => {
  const {
    ownerState: n
  } = e;
  return [t.input, n.size === "small" && t.inputSizeSmall, n.multiline && t.inputMultiline, n.type === "search" && t.inputTypeSearch, n.startAdornment && t.inputAdornedStart, n.endAdornment && t.inputAdornedEnd, n.hiddenLabel && t.inputHiddenLabel];
}, gY = (e) => {
  const {
    classes: t,
    color: n,
    disabled: r,
    error: o,
    endAdornment: i,
    focused: a,
    formControl: s,
    fullWidth: c,
    hiddenLabel: l,
    multiline: d,
    readOnly: f,
    size: p,
    startAdornment: m,
    type: v
  } = e, g = {
    root: ["root", `color${at(n)}`, r && "disabled", o && "error", c && "fullWidth", a && "focused", s && "formControl", p && p !== "medium" && `size${at(p)}`, d && "multiline", m && "adornedStart", i && "adornedEnd", l && "hiddenLabel", f && "readOnly"],
    input: ["input", r && "disabled", v === "search" && "inputTypeSearch", d && "inputMultiline", p === "small" && "inputSizeSmall", l && "inputHiddenLabel", m && "inputAdornedStart", i && "inputAdornedEnd", f && "readOnly"]
  };
  return Yt(g, pY, t);
}, ng = Fe("div", {
  name: "MuiInputBase",
  slot: "Root",
  overridesResolver: eg
})(({
  theme: e,
  ownerState: t
}) => re({}, e.typography.body1, {
  color: (e.vars || e).palette.text.primary,
  lineHeight: "1.4375em",
  // 23px
  boxSizing: "border-box",
  // Prevent padding issue with fullWidth.
  position: "relative",
  cursor: "text",
  display: "inline-flex",
  alignItems: "center",
  [`&.${Tc.disabled}`]: {
    color: (e.vars || e).palette.text.disabled,
    cursor: "default"
  }
}, t.multiline && re({
  padding: "4px 0 5px"
}, t.size === "small" && {
  paddingTop: 1
}), t.fullWidth && {
  width: "100%"
})), rg = Fe("input", {
  name: "MuiInputBase",
  slot: "Input",
  overridesResolver: tg
})(({
  theme: e,
  ownerState: t
}) => {
  const n = e.palette.mode === "light", r = re({
    color: "currentColor"
  }, e.vars ? {
    opacity: e.vars.opacity.inputPlaceholder
  } : {
    opacity: n ? 0.42 : 0.5
  }, {
    transition: e.transitions.create("opacity", {
      duration: e.transitions.duration.shorter
    })
  }), o = {
    opacity: "0 !important"
  }, i = e.vars ? {
    opacity: e.vars.opacity.inputPlaceholder
  } : {
    opacity: n ? 0.42 : 0.5
  };
  return re({
    font: "inherit",
    letterSpacing: "inherit",
    color: "currentColor",
    padding: "4px 0 5px",
    border: 0,
    boxSizing: "content-box",
    background: "none",
    height: "1.4375em",
    // Reset 23pxthe native input line-height
    margin: 0,
    // Reset for Safari
    WebkitTapHighlightColor: "transparent",
    display: "block",
    // Make the flex item shrink with Firefox
    minWidth: 0,
    width: "100%",
    // Fix IE11 width issue
    animationName: "mui-auto-fill-cancel",
    animationDuration: "10ms",
    "&::-webkit-input-placeholder": r,
    "&::-moz-placeholder": r,
    // Firefox 19+
    "&:-ms-input-placeholder": r,
    // IE11
    "&::-ms-input-placeholder": r,
    // Edge
    "&:focus": {
      outline: 0
    },
    // Reset Firefox invalid required input style
    "&:invalid": {
      boxShadow: "none"
    },
    "&::-webkit-search-decoration": {
      // Remove the padding when type=search.
      WebkitAppearance: "none"
    },
    // Show and hide the placeholder logic
    [`label[data-shrink=false] + .${Tc.formControl} &`]: {
      "&::-webkit-input-placeholder": o,
      "&::-moz-placeholder": o,
      // Firefox 19+
      "&:-ms-input-placeholder": o,
      // IE11
      "&::-ms-input-placeholder": o,
      // Edge
      "&:focus::-webkit-input-placeholder": i,
      "&:focus::-moz-placeholder": i,
      // Firefox 19+
      "&:focus:-ms-input-placeholder": i,
      // IE11
      "&:focus::-ms-input-placeholder": i
      // Edge
    },
    [`&.${Tc.disabled}`]: {
      opacity: 1,
      // Reset iOS opacity
      WebkitTextFillColor: (e.vars || e).palette.text.disabled
      // Fix opacity Safari bug
    },
    "&:-webkit-autofill": {
      animationDuration: "5000s",
      animationName: "mui-auto-fill"
    }
  }, t.size === "small" && {
    paddingTop: 1
  }, t.multiline && {
    height: "auto",
    resize: "none",
    padding: 0,
    paddingTop: 0
  }, t.type === "search" && {
    // Improve type search style.
    MozAppearance: "textfield"
  });
}), vY = /* @__PURE__ */ z(VN, {
  styles: {
    "@keyframes mui-auto-fill": {
      from: {
        display: "block"
      }
    },
    "@keyframes mui-auto-fill-cancel": {
      from: {
        display: "block"
      }
    }
  }
}), qN = /* @__PURE__ */ B.forwardRef(function(e, t) {
  var n;
  const r = rn({
    props: e,
    name: "MuiInputBase"
  }), {
    "aria-describedby": o,
    autoComplete: i,
    autoFocus: a,
    className: s,
    components: c = {},
    componentsProps: l = {},
    defaultValue: d,
    disabled: f,
    disableInjectingGlobalStyles: p,
    endAdornment: m,
    fullWidth: v = !1,
    id: g,
    inputComponent: b = "input",
    inputProps: x = {},
    inputRef: T,
    maxRows: S,
    minRows: _,
    multiline: w = !1,
    name: k,
    onBlur: E,
    onChange: R,
    onClick: P,
    onFocus: A,
    onKeyDown: D,
    onKeyUp: N,
    placeholder: F,
    readOnly: $,
    renderSuffix: I,
    rows: j,
    slotProps: U = {},
    slots: G = {},
    startAdornment: V,
    type: H = "text",
    value: q
  } = r, Q = He(r, mY), X = x.value != null ? x.value : q, {
    current: K
  } = B.useRef(X != null), J = B.useRef(), ne = B.useCallback((Be) => {
    process.env.NODE_ENV !== "production" && Be && Be.nodeName !== "INPUT" && !Be.focus && console.error(["MUI: You have provided a `inputComponent` to the input component", "that does not correctly handle the `ref` prop.", "Make sure the `ref` prop is called with a HTMLInputElement."].join(`
`));
  }, []), ae = or(J, T, x.ref, ne), [te, le] = B.useState(!1), ce = Jm();
  process.env.NODE_ENV !== "production" && B.useEffect(() => {
    if (ce)
      return ce.registerEffect();
  }, [ce]);
  const fe = tw({
    props: r,
    muiFormControl: ce,
    states: ["color", "disabled", "error", "hiddenLabel", "size", "required", "filled"]
  });
  fe.focused = ce ? ce.focused : te, B.useEffect(() => {
    !ce && f && te && (le(!1), E && E());
  }, [ce, f, te, E]);
  const ee = ce && ce.onFilled, me = ce && ce.onEmpty, oe = B.useCallback((Be) => {
    UN(Be) ? ee && ee() : me && me();
  }, [ee, me]);
  $i(() => {
    K && oe({
      value: X
    });
  }, [X, oe, K]);
  const ve = (Be) => {
    if (fe.disabled) {
      Be.stopPropagation();
      return;
    }
    A && A(Be), x.onFocus && x.onFocus(Be), ce && ce.onFocus ? ce.onFocus(Be) : le(!0);
  }, we = (Be) => {
    E && E(Be), x.onBlur && x.onBlur(Be), ce && ce.onBlur ? ce.onBlur(Be) : le(!1);
  }, ye = (Be, ...Pe) => {
    if (!K) {
      const Ee = Be.target || J.current;
      if (Ee == null)
        throw new Error(process.env.NODE_ENV !== "production" ? "MUI: Expected valid input target. Did you use a custom `inputComponent` and forget to forward refs? See https://mui.com/r/input-component-ref-interface for more info." : Gs(1));
      oe({
        value: Ee.value
      });
    }
    x.onChange && x.onChange(Be, ...Pe), R && R(Be, ...Pe);
  };
  B.useEffect(() => {
    oe(J.current);
  }, []);
  const Ce = (Be) => {
    J.current && Be.currentTarget === Be.target && J.current.focus(), P && P(Be);
  };
  let Se = b, Te = x;
  w && Se === "input" && (j ? (process.env.NODE_ENV !== "production" && (_ || S) && console.warn("MUI: You can not use the `minRows` or `maxRows` props when the input `rows` prop is set."), Te = re({
    type: void 0,
    minRows: j,
    maxRows: j
  }, Te)) : Te = re({
    type: void 0,
    maxRows: S,
    minRows: _
  }, Te), Se = DN);
  const Ae = (Be) => {
    oe(Be.animationName === "mui-auto-fill-cancel" ? J.current : {
      value: "x"
    });
  };
  B.useEffect(() => {
    ce && ce.setAdornedStart(!!V);
  }, [ce, V]);
  const je = re({}, r, {
    color: fe.color || "primary",
    disabled: fe.disabled,
    endAdornment: m,
    error: fe.error,
    focused: fe.focused,
    formControl: ce,
    fullWidth: v,
    hiddenLabel: fe.hiddenLabel,
    multiline: w,
    size: fe.size,
    startAdornment: V,
    type: H
  }), Me = gY(je), ze = G.root || c.Root || ng, ft = U.root || l.root || {}, Ue = G.input || c.Input || rg;
  return Te = re({}, Te, (n = U.input) != null ? n : l.input), /* @__PURE__ */ _e(B.Fragment, {
    children: [!p && vY, /* @__PURE__ */ _e(ze, re({}, ft, !Ad(ze) && {
      ownerState: re({}, je, ft.ownerState)
    }, {
      ref: t,
      onClick: Ce
    }, Q, {
      className: Qe(Me.root, ft.className, s, $ && "MuiInputBase-readOnly"),
      children: [V, /* @__PURE__ */ z(LN.Provider, {
        value: null,
        children: /* @__PURE__ */ z(Ue, re({
          ownerState: je,
          "aria-invalid": fe.error,
          "aria-describedby": o,
          autoComplete: i,
          autoFocus: a,
          defaultValue: d,
          disabled: fe.disabled,
          id: g,
          onAnimationStart: Ae,
          name: k,
          placeholder: F,
          readOnly: $,
          required: fe.required,
          rows: j,
          value: X,
          onKeyDown: D,
          onKeyUp: N,
          type: H
        }, Te, !Ad(Ue) && {
          as: Se,
          ownerState: re({}, je, Te.ownerState)
        }, {
          ref: ae,
          className: Qe(Me.input, Te.className, $ && "MuiInputBase-readOnly"),
          onBlur: we,
          onChange: ye,
          onFocus: ve
        }))
      }), m, I ? I(re({}, fe, {
        startAdornment: V
      })) : null]
    }))]
  });
});
process.env.NODE_ENV !== "production" && (qN.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  "aria-describedby": y.string,
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: y.string,
  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: y.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: y.object,
  /**
   * @ignore
   */
  className: y.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * The prop defaults to the value (`'primary'`) inherited from the parent FormControl component.
   */
  color: y.oneOfType([y.oneOf(["primary", "secondary", "error", "info", "success", "warning"]), y.string]),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */
  components: y.shape({
    Input: y.elementType,
    Root: y.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `slotProps` prop.
   * It's recommended to use the `slotProps` prop instead, as `componentsProps` will be deprecated in the future.
   *
   * @default {}
   */
  componentsProps: y.shape({
    input: y.object,
    root: y.object
  }),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: y.any,
  /**
   * If `true`, the component is disabled.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  disabled: y.bool,
  /**
   * If `true`, GlobalStyles for the auto-fill keyframes will not be injected/removed on mount/unmount. Make sure to inject them at the top of your application.
   * This option is intended to help with boosting the initial rendering performance if you are loading a big amount of Input components at once.
   * @default false
   */
  disableInjectingGlobalStyles: y.bool,
  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: y.node,
  /**
   * If `true`, the `input` will indicate an error.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  error: y.bool,
  /**
   * If `true`, the `input` will take up the full width of its container.
   * @default false
   */
  fullWidth: y.bool,
  /**
   * The id of the `input` element.
   */
  id: y.string,
  /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   * @default 'input'
   */
  inputComponent: $_,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * @default {}
   */
  inputProps: y.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: Yo,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   * The prop defaults to the value (`'none'`) inherited from the parent FormControl component.
   */
  margin: y.oneOf(["dense", "none"]),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: y.oneOfType([y.number, y.string]),
  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: y.oneOfType([y.number, y.string]),
  /**
   * If `true`, a [TextareaAutosize](/material-ui/react-textarea-autosize/) element is rendered.
   * @default false
   */
  multiline: y.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: y.string,
  /**
   * Callback fired when the `input` is blurred.
   *
   * Notice that the first argument (event) might be undefined.
   */
  onBlur: y.func,
  /**
   * Callback fired when the value is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: y.func,
  /**
   * @ignore
   */
  onClick: y.func,
  /**
   * @ignore
   */
  onFocus: y.func,
  /**
   * Callback fired when the `input` doesn't satisfy its constraints.
   */
  onInvalid: y.func,
  /**
   * @ignore
   */
  onKeyDown: y.func,
  /**
   * @ignore
   */
  onKeyUp: y.func,
  /**
   * The short hint displayed in the `input` before the user enters a value.
   */
  placeholder: y.string,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: y.bool,
  /**
   * @ignore
   */
  renderSuffix: y.func,
  /**
   * If `true`, the `input` element is required.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  required: y.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: y.oneOfType([y.number, y.string]),
  /**
   * The size of the component.
   */
  size: y.oneOfType([y.oneOf(["medium", "small"]), y.string]),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slotProps: y.shape({
    input: y.object,
    root: y.object
  }),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: y.shape({
    input: y.elementType,
    root: y.elementType
  }),
  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: y.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: y.oneOfType([y.arrayOf(y.oneOfType([y.func, y.object, y.bool])), y.func, y.object]),
  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   * @default 'text'
   */
  type: y.string,
  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: y.any
});
const og = qN, GN = /* @__PURE__ */ B.createContext({});
process.env.NODE_ENV !== "production" && (GN.displayName = "ListContext");
const ly = GN;
function Oh(e, t) {
  return Oh = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, r) {
    return n.__proto__ = r, n;
  }, Oh(e, t);
}
function YN(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, Oh(e, t);
}
const fT = {
  disabled: !1
};
var bY = process.env.NODE_ENV !== "production" ? y.oneOfType([y.number, y.shape({
  enter: y.number,
  exit: y.number,
  appear: y.number
}).isRequired]) : null;
process.env.NODE_ENV !== "production" && y.oneOfType([y.string, y.shape({
  enter: y.string,
  exit: y.string,
  active: y.string
}), y.shape({
  enter: y.string,
  enterDone: y.string,
  enterActive: y.string,
  exit: y.string,
  exitDone: y.string,
  exitActive: y.string
})]);
const Nh = et.createContext(null);
var ed = "unmounted", As = "exited", Ds = "entering", Ul = "entered", cy = "exiting", Ca = /* @__PURE__ */ function(e) {
  YN(t, e);
  function t(r, o) {
    var i;
    i = e.call(this, r, o) || this;
    var a = o, s = a && !a.isMounting ? r.enter : r.appear, c;
    return i.appearStatus = null, r.in ? s ? (c = As, i.appearStatus = Ds) : c = Ul : r.unmountOnExit || r.mountOnEnter ? c = ed : c = As, i.state = {
      status: c
    }, i.nextCallback = null, i;
  }
  t.getDerivedStateFromProps = function(r, o) {
    var i = r.in;
    return i && o.status === ed ? {
      status: As
    } : null;
  };
  var n = t.prototype;
  return n.componentDidMount = function() {
    this.updateStatus(!0, this.appearStatus);
  }, n.componentDidUpdate = function(r) {
    var o = null;
    if (r !== this.props) {
      var i = this.state.status;
      this.props.in ? i !== Ds && i !== Ul && (o = Ds) : (i === Ds || i === Ul) && (o = cy);
    }
    this.updateStatus(!1, o);
  }, n.componentWillUnmount = function() {
    this.cancelNextCallback();
  }, n.getTimeouts = function() {
    var r = this.props.timeout, o, i, a;
    return o = i = a = r, r != null && typeof r != "number" && (o = r.exit, i = r.enter, a = r.appear !== void 0 ? r.appear : i), {
      exit: o,
      enter: i,
      appear: a
    };
  }, n.updateStatus = function(r, o) {
    r === void 0 && (r = !1), o !== null ? (this.cancelNextCallback(), o === Ds ? ((this.props.unmountOnExit || this.props.mountOnEnter) && (this.props.nodeRef ? this.props.nodeRef.current : _r.findDOMNode(this)), this.performEnter(r)) : this.performExit()) : this.props.unmountOnExit && this.state.status === As && this.setState({
      status: ed
    });
  }, n.performEnter = function(r) {
    var o = this, i = this.props.enter, a = this.context ? this.context.isMounting : r, s = this.props.nodeRef ? [a] : [_r.findDOMNode(this), a], c = s[0], l = s[1], d = this.getTimeouts(), f = a ? d.appear : d.enter;
    if (!r && !i || fT.disabled) {
      this.safeSetState({
        status: Ul
      }, function() {
        o.props.onEntered(c);
      });
      return;
    }
    this.props.onEnter(c, l), this.safeSetState({
      status: Ds
    }, function() {
      o.props.onEntering(c, l), o.onTransitionEnd(f, function() {
        o.safeSetState({
          status: Ul
        }, function() {
          o.props.onEntered(c, l);
        });
      });
    });
  }, n.performExit = function() {
    var r = this, o = this.props.exit, i = this.getTimeouts(), a = this.props.nodeRef ? void 0 : _r.findDOMNode(this);
    if (!o || fT.disabled) {
      this.safeSetState({
        status: As
      }, function() {
        r.props.onExited(a);
      });
      return;
    }
    this.props.onExit(a), this.safeSetState({
      status: cy
    }, function() {
      r.props.onExiting(a), r.onTransitionEnd(i.exit, function() {
        r.safeSetState({
          status: As
        }, function() {
          r.props.onExited(a);
        });
      });
    });
  }, n.cancelNextCallback = function() {
    this.nextCallback !== null && (this.nextCallback.cancel(), this.nextCallback = null);
  }, n.safeSetState = function(r, o) {
    o = this.setNextCallback(o), this.setState(r, o);
  }, n.setNextCallback = function(r) {
    var o = this, i = !0;
    return this.nextCallback = function(a) {
      i && (i = !1, o.nextCallback = null, r(a));
    }, this.nextCallback.cancel = function() {
      i = !1;
    }, this.nextCallback;
  }, n.onTransitionEnd = function(r, o) {
    this.setNextCallback(o);
    var i = this.props.nodeRef ? this.props.nodeRef.current : _r.findDOMNode(this), a = r == null && !this.props.addEndListener;
    if (!i || a) {
      setTimeout(this.nextCallback, 0);
      return;
    }
    if (this.props.addEndListener) {
      var s = this.props.nodeRef ? [this.nextCallback] : [i, this.nextCallback], c = s[0], l = s[1];
      this.props.addEndListener(c, l);
    }
    r != null && setTimeout(this.nextCallback, r);
  }, n.render = function() {
    var r = this.state.status;
    if (r === ed)
      return null;
    var o = this.props, i = o.children, a = He(o, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);
    return (
      // allows for nested Transitions
      /* @__PURE__ */ et.createElement(Nh.Provider, {
        value: null
      }, typeof i == "function" ? i(r, a) : et.cloneElement(et.Children.only(i), a))
    );
  }, t;
}(et.Component);
Ca.contextType = Nh;
Ca.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * A React reference to DOM element that need to transition:
   * https://stackoverflow.com/a/51127130/4671932
   *
   *   - When `nodeRef` prop is used, `node` is not passed to callback functions
   *      (e.g. `onEnter`) because user already has direct access to the node.
   *   - When changing `key` prop of `Transition` in a `TransitionGroup` a new
   *     `nodeRef` need to be provided to `Transition` with changed `key` prop
   *     (see
   *     [test/CSSTransition-test.js](https://github.com/reactjs/react-transition-group/blob/13435f897b3ab71f6e19d724f145596f5910581c/test/CSSTransition-test.js#L362-L437)).
   */
  nodeRef: y.shape({
    current: typeof Element == "undefined" ? y.any : function(e, t, n, r, o, i) {
      var a = e[t];
      return y.instanceOf(a && "ownerDocument" in a ? a.ownerDocument.defaultView.Element : Element)(e, t, n, r, o, i);
    }
  }),
  /**
   * A `function` child can be used instead of a React element. This function is
   * called with the current transition status (`'entering'`, `'entered'`,
   * `'exiting'`, `'exited'`), which can be used to apply context
   * specific props to a component.
   *
   * ```jsx
   * <Transition in={this.state.in} timeout={150}>
   *   {state => (
   *     <MyComponent className={`fade fade-${state}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: y.oneOfType([y.func.isRequired, y.element.isRequired]).isRequired,
  /**
   * Show the component; triggers the enter or exit states
   */
  in: y.bool,
  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: y.bool,
  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: y.bool,
  /**
   * By default the child component does not perform the enter transition when
   * it first mounts, regardless of the value of `in`. If you want this
   * behavior, set both `appear` and `in` to `true`.
   *
   * > **Note**: there are no special appear states like `appearing`/`appeared`, this prop
   * > only adds an additional enter transition. However, in the
   * > `<CSSTransition>` component that first enter transition does result in
   * > additional `.appear-*` classes, that way you can choose to style it
   * > differently.
   */
  appear: y.bool,
  /**
   * Enable or disable enter transitions.
   */
  enter: y.bool,
  /**
   * Enable or disable exit transitions.
   */
  exit: y.bool,
  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided.
   *
   * You may specify a single timeout for all transitions:
   *
   * ```jsx
   * timeout={500}
   * ```
   *
   * or individually:
   *
   * ```jsx
   * timeout={{
   *  appear: 500,
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * - `appear` defaults to the value of `enter`
   * - `enter` defaults to `0`
   * - `exit` defaults to `0`
   *
   * @type {number | { enter?: number, exit?: number, appear?: number }}
   */
  timeout: function(e) {
    var t = bY;
    e.addEndListener || (t = t.isRequired);
    for (var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), o = 1; o < n; o++)
      r[o - 1] = arguments[o];
    return t.apply(void 0, [e].concat(r));
  },
  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. Timeouts are still used as a fallback if provided.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: y.func,
  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: y.func,
  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: y.func,
  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: y.func,
  /**
   * Callback fired before the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: y.func,
  /**
   * Callback fired after the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: y.func,
  /**
   * Callback fired after the "exited" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: y.func
} : {};
function Ol() {
}
Ca.defaultProps = {
  in: !1,
  mountOnEnter: !1,
  unmountOnExit: !1,
  appear: !1,
  enter: !0,
  exit: !0,
  onEnter: Ol,
  onEntering: Ol,
  onEntered: Ol,
  onExit: Ol,
  onExiting: Ol,
  onExited: Ol
};
Ca.UNMOUNTED = ed;
Ca.EXITED = As;
Ca.ENTERING = Ds;
Ca.ENTERED = Ul;
Ca.EXITING = cy;
const ZN = Ca;
function Ah(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function nw(e, t) {
  var n = function(o) {
    return t && sa(o) ? t(o) : o;
  }, r = /* @__PURE__ */ Object.create(null);
  return e && JP.map(e, function(o) {
    return o;
  }).forEach(function(o) {
    r[o.key] = n(o);
  }), r;
}
function yY(e, t) {
  e = e || {}, t = t || {};
  function n(d) {
    return d in t ? t[d] : e[d];
  }
  var r = /* @__PURE__ */ Object.create(null), o = [];
  for (var i in e)
    i in t ? o.length && (r[i] = o, o = []) : o.push(i);
  var a, s = {};
  for (var c in t) {
    if (r[c])
      for (a = 0; a < r[c].length; a++) {
        var l = r[c][a];
        s[r[c][a]] = n(l);
      }
    s[c] = n(c);
  }
  for (a = 0; a < o.length; a++)
    s[o[a]] = n(o[a]);
  return s;
}
function zs(e, t, n) {
  return n[t] != null ? n[t] : e.props[t];
}
function _Y(e, t) {
  return nw(e.children, function(n) {
    return es(n, {
      onExited: t.bind(null, n),
      in: !0,
      appear: zs(n, "appear", e),
      enter: zs(n, "enter", e),
      exit: zs(n, "exit", e)
    });
  });
}
function wY(e, t, n) {
  var r = nw(e.children), o = yY(t, r);
  return Object.keys(o).forEach(function(i) {
    var a = o[i];
    if (sa(a)) {
      var s = i in t, c = i in r, l = t[i], d = sa(l) && !l.props.in;
      c && (!s || d) ? o[i] = es(a, {
        onExited: n.bind(null, a),
        in: !0,
        exit: zs(a, "exit", e),
        enter: zs(a, "enter", e)
      }) : !c && s && !d ? o[i] = es(a, {
        in: !1
      }) : c && s && sa(l) && (o[i] = es(a, {
        onExited: n.bind(null, a),
        in: l.props.in,
        exit: zs(a, "exit", e),
        enter: zs(a, "enter", e)
      }));
    }
  }), o;
}
var xY = Object.values || function(e) {
  return Object.keys(e).map(function(t) {
    return e[t];
  });
}, CY = {
  component: "div",
  childFactory: function(e) {
    return e;
  }
}, rw = /* @__PURE__ */ function(e) {
  YN(t, e);
  function t(r, o) {
    var i;
    i = e.call(this, r, o) || this;
    var a = i.handleExited.bind(Ah(i));
    return i.state = {
      contextValue: {
        isMounting: !0
      },
      handleExited: a,
      firstRender: !0
    }, i;
  }
  var n = t.prototype;
  return n.componentDidMount = function() {
    this.mounted = !0, this.setState({
      contextValue: {
        isMounting: !1
      }
    });
  }, n.componentWillUnmount = function() {
    this.mounted = !1;
  }, t.getDerivedStateFromProps = function(r, o) {
    var i = o.children, a = o.handleExited, s = o.firstRender;
    return {
      children: s ? _Y(r, a) : wY(r, i, a),
      firstRender: !1
    };
  }, n.handleExited = function(r, o) {
    var i = nw(this.props.children);
    r.key in i || (r.props.onExited && r.props.onExited(o), this.mounted && this.setState(function(a) {
      var s = re({}, a.children);
      return delete s[r.key], {
        children: s
      };
    }));
  }, n.render = function() {
    var r = this.props, o = r.component, i = r.childFactory, a = He(r, ["component", "childFactory"]), s = this.state.contextValue, c = xY(this.state.children).map(i);
    return delete a.appear, delete a.enter, delete a.exit, o === null ? /* @__PURE__ */ et.createElement(Nh.Provider, {
      value: s
    }, c) : /* @__PURE__ */ et.createElement(Nh.Provider, {
      value: s
    }, /* @__PURE__ */ et.createElement(o, a, c));
  }, t;
}(et.Component);
rw.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * `<TransitionGroup>` renders a `<div>` by default. You can change this
   * behavior by providing a `component` prop.
   * If you use React v16+ and would like to avoid a wrapping `<div>` element
   * you can pass in `component={null}`. This is useful if the wrapping div
   * borks your css styles.
   */
  component: y.any,
  /**
   * A set of `<Transition>` components, that are toggled `in` and out as they
   * leave. the `<TransitionGroup>` will inject specific transition props, so
   * remember to spread them through if you are wrapping the `<Transition>` as
   * with our `<Fade>` example.
   *
   * While this component is meant for multiple `Transition` or `CSSTransition`
   * children, sometimes you may want to have a single transition child with
   * content that you want to be transitioned out and in when you change it
   * (e.g. routes, images etc.) In that case you can change the `key` prop of
   * the transition child as you change its content, this will cause
   * `TransitionGroup` to transition the child out and back in.
   */
  children: y.node,
  /**
   * A convenience prop that enables or disables appear animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  appear: y.bool,
  /**
   * A convenience prop that enables or disables enter animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  enter: y.bool,
  /**
   * A convenience prop that enables or disables exit animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  exit: y.bool,
  /**
   * You may need to apply reactive updates to a child as it is exiting.
   * This is generally done by using `cloneElement` however in the case of an exiting
   * child the element has already been removed and not accessible to the consumer.
   *
   * If you do need to update a child as it leaves you can provide a `childFactory`
   * to wrap every child, even the ones that are leaving.
   *
   * @type Function(child: ReactElement) -> ReactElement
   */
  childFactory: y.func
} : {};
rw.defaultProps = CY;
const SY = rw;
function XN(e) {
  const {
    className: t,
    classes: n,
    pulsate: r = !1,
    rippleX: o,
    rippleY: i,
    rippleSize: a,
    in: s,
    onExited: c,
    timeout: l
  } = e, [d, f] = B.useState(!1), p = Qe(t, n.ripple, n.rippleVisible, r && n.ripplePulsate), m = {
    width: a,
    height: a,
    top: -(a / 2) + i,
    left: -(a / 2) + o
  }, v = Qe(n.child, d && n.childLeaving, r && n.childPulsate);
  return !s && !d && f(!0), B.useEffect(() => {
    if (!s && c != null) {
      const g = setTimeout(c, l);
      return () => {
        clearTimeout(g);
      };
    }
  }, [c, s, l]), /* @__PURE__ */ z("span", {
    className: p,
    style: m,
    children: /* @__PURE__ */ z("span", {
      className: v
    })
  });
}
process.env.NODE_ENV !== "production" && (XN.propTypes = {
  /**
   * Override or extend the styles applied to the component.
   */
  classes: y.object.isRequired,
  className: y.string,
  /**
   * @ignore - injected from TransitionGroup
   */
  in: y.bool,
  /**
   * @ignore - injected from TransitionGroup
   */
  onExited: y.func,
  /**
   * If `true`, the ripple pulsates, typically indicating the keyboard focus state of an element.
   */
  pulsate: y.bool,
  /**
   * Diameter of the ripple.
   */
  rippleSize: y.number,
  /**
   * Horizontal position of the ripple center.
   */
  rippleX: y.number,
  /**
   * Vertical position of the ripple center.
   */
  rippleY: y.number,
  /**
   * exit delay
   */
  timeout: y.number.isRequired
});
const TY = Wt("MuiTouchRipple", ["root", "ripple", "rippleVisible", "ripplePulsate", "child", "childLeaving", "childPulsate"]), Do = TY, EY = ["center", "classes", "className"];
let ig = (e) => e, pT, hT, mT, gT;
const uy = 550, kY = 80, MY = us(pT || (pT = ig`
  0% {
    transform: scale(0);
    opacity: 0.1;
  }

  100% {
    transform: scale(1);
    opacity: 0.3;
  }
`)), RY = us(hT || (hT = ig`
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`)), PY = us(mT || (mT = ig`
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.92);
  }

  100% {
    transform: scale(1);
  }
`)), OY = Fe("span", {
  name: "MuiTouchRipple",
  slot: "Root"
})({
  overflow: "hidden",
  pointerEvents: "none",
  position: "absolute",
  zIndex: 0,
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  borderRadius: "inherit"
}), NY = Fe(XN, {
  name: "MuiTouchRipple",
  slot: "Ripple"
})(gT || (gT = ig`
  opacity: 0;
  position: absolute;

  &.${0} {
    opacity: 0.3;
    transform: scale(1);
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  &.${0} {
    animation-duration: ${0}ms;
  }

  & .${0} {
    opacity: 1;
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: currentColor;
  }

  & .${0} {
    opacity: 0;
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  & .${0} {
    position: absolute;
    /* @noflip */
    left: 0px;
    top: 0;
    animation-name: ${0};
    animation-duration: 2500ms;
    animation-timing-function: ${0};
    animation-iteration-count: infinite;
    animation-delay: 200ms;
  }
`), Do.rippleVisible, MY, uy, ({
  theme: e
}) => e.transitions.easing.easeInOut, Do.ripplePulsate, ({
  theme: e
}) => e.transitions.duration.shorter, Do.child, Do.childLeaving, RY, uy, ({
  theme: e
}) => e.transitions.easing.easeInOut, Do.childPulsate, PY, ({
  theme: e
}) => e.transitions.easing.easeInOut), KN = /* @__PURE__ */ B.forwardRef(function(e, t) {
  const n = rn({
    props: e,
    name: "MuiTouchRipple"
  }), {
    center: r = !1,
    classes: o = {},
    className: i
  } = n, a = He(n, EY), [s, c] = B.useState([]), l = B.useRef(0), d = B.useRef(null);
  B.useEffect(() => {
    d.current && (d.current(), d.current = null);
  }, [s]);
  const f = B.useRef(!1), p = tc(), m = B.useRef(null), v = B.useRef(null), g = B.useCallback((S) => {
    const {
      pulsate: _,
      rippleX: w,
      rippleY: k,
      rippleSize: E,
      cb: R
    } = S;
    c((P) => [...P, /* @__PURE__ */ z(NY, {
      classes: {
        ripple: Qe(o.ripple, Do.ripple),
        rippleVisible: Qe(o.rippleVisible, Do.rippleVisible),
        ripplePulsate: Qe(o.ripplePulsate, Do.ripplePulsate),
        child: Qe(o.child, Do.child),
        childLeaving: Qe(o.childLeaving, Do.childLeaving),
        childPulsate: Qe(o.childPulsate, Do.childPulsate)
      },
      timeout: uy,
      pulsate: _,
      rippleX: w,
      rippleY: k,
      rippleSize: E
    }, l.current)]), l.current += 1, d.current = R;
  }, [o]), b = B.useCallback((S = {}, _ = {}, w = () => {
  }) => {
    const {
      pulsate: k = !1,
      center: E = r || _.pulsate,
      fakeElement: R = !1
      // For test purposes
    } = _;
    if ((S == null ? void 0 : S.type) === "mousedown" && f.current) {
      f.current = !1;
      return;
    }
    (S == null ? void 0 : S.type) === "touchstart" && (f.current = !0);
    const P = R ? null : v.current, A = P ? P.getBoundingClientRect() : {
      width: 0,
      height: 0,
      left: 0,
      top: 0
    };
    let D, N, F;
    if (E || S === void 0 || S.clientX === 0 && S.clientY === 0 || !S.clientX && !S.touches)
      D = Math.round(A.width / 2), N = Math.round(A.height / 2);
    else {
      const {
        clientX: $,
        clientY: I
      } = S.touches && S.touches.length > 0 ? S.touches[0] : S;
      D = Math.round($ - A.left), N = Math.round(I - A.top);
    }
    if (E)
      F = Math.sqrt((2 * li(A.width, 2) + li(A.height, 2)) / 3), F % 2 === 0 && (F += 1);
    else {
      const $ = Math.max(Math.abs((P ? P.clientWidth : 0) - D), D) * 2 + 2, I = Math.max(Math.abs((P ? P.clientHeight : 0) - N), N) * 2 + 2;
      F = Math.sqrt(li($, 2) + li(I, 2));
    }
    S != null && S.touches ? m.current === null && (m.current = () => {
      g({
        pulsate: k,
        rippleX: D,
        rippleY: N,
        rippleSize: F,
        cb: w
      });
    }, p.start(kY, () => {
      m.current && (m.current(), m.current = null);
    })) : g({
      pulsate: k,
      rippleX: D,
      rippleY: N,
      rippleSize: F,
      cb: w
    });
  }, [r, g, p]), x = B.useCallback(() => {
    b({}, {
      pulsate: !0
    });
  }, [b]), T = B.useCallback((S, _) => {
    if (p.clear(), (S == null ? void 0 : S.type) === "touchend" && m.current) {
      m.current(), m.current = null, p.start(0, () => {
        T(S, _);
      });
      return;
    }
    m.current = null, c((w) => w.length > 0 ? w.slice(1) : w), d.current = _;
  }, [p]);
  return B.useImperativeHandle(t, () => ({
    pulsate: x,
    start: b,
    stop: T
  }), [x, b, T]), /* @__PURE__ */ z(OY, re({
    className: Qe(Do.root, o.root, i),
    ref: v
  }, a, {
    children: /* @__PURE__ */ z(SY, {
      component: null,
      exit: !0,
      children: s
    })
  }));
});
process.env.NODE_ENV !== "production" && (KN.propTypes = {
  /**
   * If `true`, the ripple starts at the center of the component
   * rather than at the point of interaction.
   */
  center: y.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: y.object,
  /**
   * @ignore
   */
  className: y.string
});
const AY = KN;
function DY(e) {
  return Gt("MuiButtonBase", e);
}
const IY = Wt("MuiButtonBase", ["root", "disabled", "focusVisible"]), LY = IY, $Y = ["action", "centerRipple", "children", "className", "component", "disabled", "disableRipple", "disableTouchRipple", "focusRipple", "focusVisibleClassName", "LinkComponent", "onBlur", "onClick", "onContextMenu", "onDragLeave", "onFocus", "onFocusVisible", "onKeyDown", "onKeyUp", "onMouseDown", "onMouseLeave", "onMouseUp", "onTouchEnd", "onTouchMove", "onTouchStart", "tabIndex", "TouchRippleProps", "touchRippleRef", "type"], FY = (e) => {
  const {
    disabled: t,
    focusVisible: n,
    focusVisibleClassName: r,
    classes: o
  } = e, i = Yt({
    root: ["root", t && "disabled", n && "focusVisible"]
  }, DY, o);
  return n && r && (i.root += ` ${r}`), i;
}, zY = Fe("button", {
  name: "MuiButtonBase",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  position: "relative",
  boxSizing: "border-box",
  WebkitTapHighlightColor: "transparent",
  backgroundColor: "transparent",
  // Reset default value
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0,
  border: 0,
  margin: 0,
  // Remove the margin in Safari
  borderRadius: 0,
  padding: 0,
  // Remove the padding in Firefox
  cursor: "pointer",
  userSelect: "none",
  verticalAlign: "middle",
  MozAppearance: "none",
  // Reset
  WebkitAppearance: "none",
  // Reset
  textDecoration: "none",
  // So we take precedent over the style of a native <a /> element.
  color: "inherit",
  "&::-moz-focus-inner": {
    borderStyle: "none"
    // Remove Firefox dotted outline.
  },
  [`&.${LY.disabled}`]: {
    pointerEvents: "none",
    // Disable link interactions
    cursor: "default"
  },
  "@media print": {
    colorAdjust: "exact"
  }
}), JN = /* @__PURE__ */ B.forwardRef(function(e, t) {
  const n = rn({
    props: e,
    name: "MuiButtonBase"
  }), {
    action: r,
    centerRipple: o = !1,
    children: i,
    className: a,
    component: s = "button",
    disabled: c = !1,
    disableRipple: l = !1,
    disableTouchRipple: d = !1,
    focusRipple: f = !1,
    LinkComponent: p = "a",
    onBlur: m,
    onClick: v,
    onContextMenu: g,
    onDragLeave: b,
    onFocus: x,
    onFocusVisible: T,
    onKeyDown: S,
    onKeyUp: _,
    onMouseDown: w,
    onMouseLeave: k,
    onMouseUp: E,
    onTouchEnd: R,
    onTouchMove: P,
    onTouchStart: A,
    tabIndex: D = 0,
    TouchRippleProps: N,
    touchRippleRef: F,
    type: $
  } = n, I = He(n, $Y), j = B.useRef(null), U = B.useRef(null), G = or(U, F), {
    isFocusVisibleRef: V,
    onFocus: H,
    onBlur: q,
    ref: Q
  } = J3(), [X, K] = B.useState(!1);
  c && X && K(!1), B.useImperativeHandle(r, () => ({
    focusVisible: () => {
      K(!0), j.current.focus();
    }
  }), []);
  const [J, ne] = B.useState(!1);
  B.useEffect(() => {
    ne(!0);
  }, []);
  const ae = J && !l && !c;
  B.useEffect(() => {
    X && f && !l && J && U.current.pulsate();
  }, [l, f, X, J]);
  function te(Pe, Ee, st = d) {
    return Ya((Vt) => (Ee && Ee(Vt), !st && U.current && U.current[Pe](Vt), !0));
  }
  const le = te("start", w), ce = te("stop", g), fe = te("stop", b), ee = te("stop", E), me = te("stop", (Pe) => {
    X && Pe.preventDefault(), k && k(Pe);
  }), oe = te("start", A), ve = te("stop", R), we = te("stop", P), ye = te("stop", (Pe) => {
    q(Pe), V.current === !1 && K(!1), m && m(Pe);
  }, !1), Ce = Ya((Pe) => {
    j.current || (j.current = Pe.currentTarget), H(Pe), V.current === !0 && (K(!0), T && T(Pe)), x && x(Pe);
  }), Se = () => {
    const Pe = j.current;
    return s && s !== "button" && !(Pe.tagName === "A" && Pe.href);
  }, Te = B.useRef(!1), Ae = Ya((Pe) => {
    f && !Te.current && X && U.current && Pe.key === " " && (Te.current = !0, U.current.stop(Pe, () => {
      U.current.start(Pe);
    })), Pe.target === Pe.currentTarget && Se() && Pe.key === " " && Pe.preventDefault(), S && S(Pe), Pe.target === Pe.currentTarget && Se() && Pe.key === "Enter" && !c && (Pe.preventDefault(), v && v(Pe));
  }), je = Ya((Pe) => {
    f && Pe.key === " " && U.current && X && !Pe.defaultPrevented && (Te.current = !1, U.current.stop(Pe, () => {
      U.current.pulsate(Pe);
    })), _ && _(Pe), v && Pe.target === Pe.currentTarget && Se() && Pe.key === " " && !Pe.defaultPrevented && v(Pe);
  });
  let Me = s;
  Me === "button" && (I.href || I.to) && (Me = p);
  const ze = {};
  Me === "button" ? (ze.type = $ === void 0 ? "button" : $, ze.disabled = c) : (!I.href && !I.to && (ze.role = "button"), c && (ze["aria-disabled"] = c));
  const ft = or(t, Q, j);
  process.env.NODE_ENV !== "production" && B.useEffect(() => {
    ae && !U.current && console.error(["MUI: The `component` prop provided to ButtonBase is invalid.", "Please make sure the children prop is rendered in this custom component."].join(`
`));
  }, [ae]);
  const Ue = re({}, n, {
    centerRipple: o,
    component: s,
    disabled: c,
    disableRipple: l,
    disableTouchRipple: d,
    focusRipple: f,
    tabIndex: D,
    focusVisible: X
  }), Be = FY(Ue);
  return /* @__PURE__ */ _e(zY, re({
    as: Me,
    className: Qe(Be.root, a),
    ownerState: Ue,
    onBlur: ye,
    onClick: v,
    onContextMenu: ce,
    onFocus: Ce,
    onKeyDown: Ae,
    onKeyUp: je,
    onMouseDown: le,
    onMouseLeave: me,
    onMouseUp: ee,
    onDragLeave: fe,
    onTouchEnd: ve,
    onTouchMove: we,
    onTouchStart: oe,
    ref: ft,
    tabIndex: c ? -1 : D,
    type: $
  }, ze, I, {
    children: [i, ae ? (
      /* TouchRipple is only needed client-side, x2 boost on the server. */
      /* @__PURE__ */ z(AY, re({
        ref: G,
        center: o
      }, N))
    ) : null]
  }));
});
process.env.NODE_ENV !== "production" && (JN.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A ref for imperative actions.
   * It currently only supports `focusVisible()` action.
   */
  action: Yo,
  /**
   * If `true`, the ripples are centered.
   * They won't start at the cursor interaction position.
   * @default false
   */
  centerRipple: y.bool,
  /**
   * The content of the component.
   */
  children: y.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: y.object,
  /**
   * @ignore
   */
  className: y.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: $_,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: y.bool,
  /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */
  disableRipple: y.bool,
  /**
   * If `true`, the touch ripple effect is disabled.
   * @default false
   */
  disableTouchRipple: y.bool,
  /**
   * If `true`, the base button will have a keyboard focus ripple.
   * @default false
   */
  focusRipple: y.bool,
  /**
   * This prop can help identify which element has keyboard focus.
   * The class name will be applied when the element gains the focus through keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/HEAD/explainer.md).
   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
   * if needed.
   */
  focusVisibleClassName: y.string,
  /**
   * @ignore
   */
  href: y.any,
  /**
   * The component used to render a link when the `href` prop is provided.
   * @default 'a'
   */
  LinkComponent: y.elementType,
  /**
   * @ignore
   */
  onBlur: y.func,
  /**
   * @ignore
   */
  onClick: y.func,
  /**
   * @ignore
   */
  onContextMenu: y.func,
  /**
   * @ignore
   */
  onDragLeave: y.func,
  /**
   * @ignore
   */
  onFocus: y.func,
  /**
   * Callback fired when the component is focused with a keyboard.
   * We trigger a `onFocus` callback too.
   */
  onFocusVisible: y.func,
  /**
   * @ignore
   */
  onKeyDown: y.func,
  /**
   * @ignore
   */
  onKeyUp: y.func,
  /**
   * @ignore
   */
  onMouseDown: y.func,
  /**
   * @ignore
   */
  onMouseLeave: y.func,
  /**
   * @ignore
   */
  onMouseUp: y.func,
  /**
   * @ignore
   */
  onTouchEnd: y.func,
  /**
   * @ignore
   */
  onTouchMove: y.func,
  /**
   * @ignore
   */
  onTouchStart: y.func,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: y.oneOfType([y.arrayOf(y.oneOfType([y.func, y.object, y.bool])), y.func, y.object]),
  /**
   * @default 0
   */
  tabIndex: y.number,
  /**
   * Props applied to the `TouchRipple` element.
   */
  TouchRippleProps: y.object,
  /**
   * A ref that points to the `TouchRipple` element.
   */
  touchRippleRef: y.oneOfType([y.func, y.shape({
    current: y.shape({
      pulsate: y.func.isRequired,
      start: y.func.isRequired,
      stop: y.func.isRequired
    })
  })]),
  /**
   * @ignore
   */
  type: y.oneOfType([y.oneOf(["button", "reset", "submit"]), y.string])
});
const ag = JN, BY = Wt("MuiDivider", ["root", "absolute", "fullWidth", "inset", "middle", "flexItem", "light", "vertical", "withChildren", "withChildrenVertical", "textAlignRight", "textAlignLeft", "wrapper", "wrapperVertical"]), vT = BY, HY = Wt("MuiListItemIcon", ["root", "alignItemsFlexStart"]), bT = HY;
function jY(e) {
  return Gt("MuiTypography", e);
}
Wt("MuiTypography", ["root", "h1", "h2", "h3", "h4", "h5", "h6", "subtitle1", "subtitle2", "body1", "body2", "inherit", "button", "caption", "overline", "alignLeft", "alignRight", "alignCenter", "alignJustify", "noWrap", "gutterBottom", "paragraph"]);
const WY = ["align", "className", "component", "gutterBottom", "noWrap", "paragraph", "variant", "variantMapping"], VY = (e) => {
  const {
    align: t,
    gutterBottom: n,
    noWrap: r,
    paragraph: o,
    variant: i,
    classes: a
  } = e, s = {
    root: ["root", i, e.align !== "inherit" && `align${at(t)}`, n && "gutterBottom", r && "noWrap", o && "paragraph"]
  };
  return Yt(s, jY, a);
}, UY = Fe("span", {
  name: "MuiTypography",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.variant && t[n.variant], n.align !== "inherit" && t[`align${at(n.align)}`], n.noWrap && t.noWrap, n.gutterBottom && t.gutterBottom, n.paragraph && t.paragraph];
  }
})(({
  theme: e,
  ownerState: t
}) => re({
  margin: 0
}, t.variant === "inherit" && {
  // Some elements, like <button> on Chrome have default font that doesn't inherit, reset this.
  font: "inherit"
}, t.variant !== "inherit" && e.typography[t.variant], t.align !== "inherit" && {
  textAlign: t.align
}, t.noWrap && {
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap"
}, t.gutterBottom && {
  marginBottom: "0.35em"
}, t.paragraph && {
  marginBottom: 16
})), yT = {
  h1: "h1",
  h2: "h2",
  h3: "h3",
  h4: "h4",
  h5: "h5",
  h6: "h6",
  subtitle1: "h6",
  subtitle2: "h6",
  body1: "p",
  body2: "p",
  inherit: "p"
}, qY = {
  primary: "primary.main",
  textPrimary: "text.primary",
  secondary: "secondary.main",
  textSecondary: "text.secondary",
  error: "error.main"
}, GY = (e) => qY[e] || e, QN = /* @__PURE__ */ B.forwardRef(function(e, t) {
  const n = rn({
    props: e,
    name: "MuiTypography"
  }), r = GY(n.color), o = bN(re({}, n, {
    color: r
  })), {
    align: i = "inherit",
    className: a,
    component: s,
    gutterBottom: c = !1,
    noWrap: l = !1,
    paragraph: d = !1,
    variant: f = "body1",
    variantMapping: p = yT
  } = o, m = He(o, WY), v = re({}, o, {
    align: i,
    color: r,
    className: a,
    component: s,
    gutterBottom: c,
    noWrap: l,
    paragraph: d,
    variant: f,
    variantMapping: p
  }), g = s || (d ? "p" : p[f] || yT[f]) || "span", b = VY(v);
  return /* @__PURE__ */ z(UY, re({
    as: g,
    ref: t,
    ownerState: v,
    className: Qe(b.root, a)
  }, m));
});
process.env.NODE_ENV !== "production" && (QN.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Set the text-align on the component.
   * @default 'inherit'
   */
  align: y.oneOf(["center", "inherit", "justify", "left", "right"]),
  /**
   * The content of the component.
   */
  children: y.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: y.object,
  /**
   * @ignore
   */
  className: y.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: y.elementType,
  /**
   * If `true`, the text will have a bottom margin.
   * @default false
   */
  gutterBottom: y.bool,
  /**
   * If `true`, the text will not wrap, but instead will truncate with a text overflow ellipsis.
   *
   * Note that text overflow can only happen with block or inline-block level elements
   * (the element needs to have a width in order to overflow).
   * @default false
   */
  noWrap: y.bool,
  /**
   * If `true`, the element will be a paragraph element.
   * @default false
   */
  paragraph: y.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: y.oneOfType([y.arrayOf(y.oneOfType([y.func, y.object, y.bool])), y.func, y.object]),
  /**
   * Applies the theme typography styles.
   * @default 'body1'
   */
  variant: y.oneOfType([y.oneOf(["body1", "body2", "button", "caption", "h1", "h2", "h3", "h4", "h5", "h6", "inherit", "overline", "subtitle1", "subtitle2"]), y.string]),
  /**
   * The component maps the variant prop to a range of different HTML element types.
   * For instance, subtitle1 to `<h6>`.
   * If you wish to change that mapping, you can provide your own.
   * Alternatively, you can use the `component` prop.
   * @default {
   *   h1: 'h1',
   *   h2: 'h2',
   *   h3: 'h3',
   *   h4: 'h4',
   *   h5: 'h5',
   *   h6: 'h6',
   *   subtitle1: 'h6',
   *   subtitle2: 'h6',
   *   body1: 'p',
   *   body2: 'p',
   *   inherit: 'p',
   * }
   */
  variantMapping: y.object
});
const YY = QN, ZY = Wt("MuiListItemText", ["root", "multiline", "dense", "inset", "primary", "secondary"]), _T = ZY;
function XY(e) {
  return Gt("MuiMenuItem", e);
}
const KY = Wt("MuiMenuItem", ["root", "focusVisible", "dense", "disabled", "divider", "gutters", "selected"]), Mu = KY, JY = ["autoFocus", "component", "dense", "divider", "disableGutters", "focusVisibleClassName", "role", "tabIndex", "className"], QY = (e, t) => {
  const {
    ownerState: n
  } = e;
  return [t.root, n.dense && t.dense, n.divider && t.divider, !n.disableGutters && t.gutters];
}, eZ = (e) => {
  const {
    disabled: t,
    dense: n,
    divider: r,
    disableGutters: o,
    selected: i,
    classes: a
  } = e, s = Yt({
    root: ["root", n && "dense", t && "disabled", !o && "gutters", r && "divider", i && "selected"]
  }, XY, a);
  return re({}, a, s);
}, tZ = Fe(ag, {
  shouldForwardProp: (e) => Xo(e) || e === "classes",
  name: "MuiMenuItem",
  slot: "Root",
  overridesResolver: QY
})(({
  theme: e,
  ownerState: t
}) => re({}, e.typography.body1, {
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "center",
  position: "relative",
  textDecoration: "none",
  minHeight: 48,
  paddingTop: 6,
  paddingBottom: 6,
  boxSizing: "border-box",
  whiteSpace: "nowrap"
}, !t.disableGutters && {
  paddingLeft: 16,
  paddingRight: 16
}, t.divider && {
  borderBottom: `1px solid ${(e.vars || e).palette.divider}`,
  backgroundClip: "padding-box"
}, {
  "&:hover": {
    textDecoration: "none",
    backgroundColor: (e.vars || e).palette.action.hover,
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: "transparent"
    }
  },
  [`&.${Mu.selected}`]: {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.selectedOpacity})` : tn.alpha(e.palette.primary.main, e.palette.action.selectedOpacity),
    [`&.${Mu.focusVisible}`]: {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.focusOpacity}))` : tn.alpha(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.focusOpacity)
    }
  },
  [`&.${Mu.selected}:hover`]: {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.hoverOpacity}))` : tn.alpha(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.selectedOpacity})` : tn.alpha(e.palette.primary.main, e.palette.action.selectedOpacity)
    }
  },
  [`&.${Mu.focusVisible}`]: {
    backgroundColor: (e.vars || e).palette.action.focus
  },
  [`&.${Mu.disabled}`]: {
    opacity: (e.vars || e).palette.action.disabledOpacity
  },
  [`& + .${vT.root}`]: {
    marginTop: e.spacing(1),
    marginBottom: e.spacing(1)
  },
  [`& + .${vT.inset}`]: {
    marginLeft: 52
  },
  [`& .${_T.root}`]: {
    marginTop: 0,
    marginBottom: 0
  },
  [`& .${_T.inset}`]: {
    paddingLeft: 36
  },
  [`& .${bT.root}`]: {
    minWidth: 36
  }
}, !t.dense && {
  [e.breakpoints.up("sm")]: {
    minHeight: "auto"
  }
}, t.dense && re({
  minHeight: 32,
  // https://m2.material.io/components/menus#specs > Dense
  paddingTop: 4,
  paddingBottom: 4
}, e.typography.body2, {
  [`& .${bT.root} svg`]: {
    fontSize: "1.25rem"
  }
}))), eA = /* @__PURE__ */ B.forwardRef(function(e, t) {
  const n = rn({
    props: e,
    name: "MuiMenuItem"
  }), {
    autoFocus: r = !1,
    component: o = "li",
    dense: i = !1,
    divider: a = !1,
    disableGutters: s = !1,
    focusVisibleClassName: c,
    role: l = "menuitem",
    tabIndex: d,
    className: f
  } = n, p = He(n, JY), m = B.useContext(ly), v = B.useMemo(() => ({
    dense: i || m.dense || !1,
    disableGutters: s
  }), [m.dense, i, s]), g = B.useRef(null);
  $i(() => {
    r && (g.current ? g.current.focus() : process.env.NODE_ENV !== "production" && console.error("MUI: Unable to set focus to a MenuItem whose component has not been rendered."));
  }, [r]);
  const b = re({}, n, {
    dense: v.dense,
    divider: a,
    disableGutters: s
  }), x = eZ(n), T = or(g, t);
  let S;
  return n.disabled || (S = d !== void 0 ? d : -1), /* @__PURE__ */ z(ly.Provider, {
    value: v,
    children: /* @__PURE__ */ z(tZ, re({
      ref: T,
      role: l,
      tabIndex: S,
      component: o,
      focusVisibleClassName: Qe(x.focusVisible, c),
      className: Qe(x.root, f)
    }, p, {
      ownerState: b,
      classes: x
    }))
  });
});
process.env.NODE_ENV !== "production" && (eA.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, the list item is focused during the first mount.
   * Focus will also be triggered if the value changes from false to true.
   * @default false
   */
  autoFocus: y.bool,
  /**
   * The content of the component.
   */
  children: y.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: y.object,
  /**
   * @ignore
   */
  className: y.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: y.elementType,
  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input is used.
   * The prop defaults to the value inherited from the parent Menu component.
   * @default false
   */
  dense: y.bool,
  /**
   * @ignore
   */
  disabled: y.bool,
  /**
   * If `true`, the left and right padding is removed.
   * @default false
   */
  disableGutters: y.bool,
  /**
   * If `true`, a 1px light border is added to the bottom of the menu item.
   * @default false
   */
  divider: y.bool,
  /**
   * This prop can help identify which element has keyboard focus.
   * The class name will be applied when the element gains the focus through keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/HEAD/explainer.md).
   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
   * if needed.
   */
  focusVisibleClassName: y.string,
  /**
   * @ignore
   */
  role: y.string,
  /**
   * If `true`, the component is selected.
   * @default false
   */
  selected: y.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: y.oneOfType([y.arrayOf(y.oneOfType([y.func, y.object, y.bool])), y.func, y.object]),
  /**
   * @default 0
   */
  tabIndex: y.number
});
const nZ = eA;
function rZ(e) {
  return Gt("MuiList", e);
}
Wt("MuiList", ["root", "padding", "dense", "subheader"]);
const oZ = ["children", "className", "component", "dense", "disablePadding", "subheader"], iZ = (e) => {
  const {
    classes: t,
    disablePadding: n,
    dense: r,
    subheader: o
  } = e;
  return Yt({
    root: ["root", !n && "padding", r && "dense", o && "subheader"]
  }, rZ, t);
}, aZ = Fe("ul", {
  name: "MuiList",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, !n.disablePadding && t.padding, n.dense && t.dense, n.subheader && t.subheader];
  }
})(({
  ownerState: e
}) => re({
  listStyle: "none",
  margin: 0,
  padding: 0,
  position: "relative"
}, !e.disablePadding && {
  paddingTop: 8,
  paddingBottom: 8
}, e.subheader && {
  paddingTop: 0
})), tA = /* @__PURE__ */ B.forwardRef(function(e, t) {
  const n = rn({
    props: e,
    name: "MuiList"
  }), {
    children: r,
    className: o,
    component: i = "ul",
    dense: a = !1,
    disablePadding: s = !1,
    subheader: c
  } = n, l = He(n, oZ), d = B.useMemo(() => ({
    dense: a
  }), [a]), f = re({}, n, {
    component: i,
    dense: a,
    disablePadding: s
  }), p = iZ(f);
  return /* @__PURE__ */ z(ly.Provider, {
    value: d,
    children: /* @__PURE__ */ _e(aZ, re({
      as: i,
      className: Qe(p.root, o),
      ref: t,
      ownerState: f
    }, l, {
      children: [c, r]
    }))
  });
});
process.env.NODE_ENV !== "production" && (tA.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: y.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: y.object,
  /**
   * @ignore
   */
  className: y.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: y.elementType,
  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input is used for
   * the list and list items.
   * The prop is available to descendant components as the `dense` context.
   * @default false
   */
  dense: y.bool,
  /**
   * If `true`, vertical padding is removed from the list.
   * @default false
   */
  disablePadding: y.bool,
  /**
   * The content of the subheader, normally `ListSubheader`.
   */
  subheader: y.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: y.oneOfType([y.arrayOf(y.oneOfType([y.func, y.object, y.bool])), y.func, y.object])
});
const sZ = tA, lZ = ["actions", "autoFocus", "autoFocusItem", "children", "className", "disabledItemsFocusable", "disableListWrap", "onKeyDown", "variant"];
function n0(e, t, n) {
  return e === t ? e.firstChild : t && t.nextElementSibling ? t.nextElementSibling : n ? null : e.firstChild;
}
function wT(e, t, n) {
  return e === t ? n ? e.firstChild : e.lastChild : t && t.previousElementSibling ? t.previousElementSibling : n ? null : e.lastChild;
}
function nA(e, t) {
  if (t === void 0)
    return !0;
  let n = e.innerText;
  return n === void 0 && (n = e.textContent), n = n.trim().toLowerCase(), n.length === 0 ? !1 : t.repeating ? n[0] === t.keys[0] : n.indexOf(t.keys.join("")) === 0;
}
function Ru(e, t, n, r, o, i) {
  let a = !1, s = o(e, t, t ? n : !1);
  for (; s; ) {
    if (s === e.firstChild) {
      if (a)
        return !1;
      a = !0;
    }
    const c = r ? !1 : s.disabled || s.getAttribute("aria-disabled") === "true";
    if (!s.hasAttribute("tabindex") || !nA(s, i) || c)
      s = o(e, s, n);
    else
      return s.focus(), !0;
  }
  return !1;
}
const rA = /* @__PURE__ */ B.forwardRef(function(e, t) {
  const {
    // private
    // eslint-disable-next-line react/prop-types
    actions: n,
    autoFocus: r = !1,
    autoFocusItem: o = !1,
    children: i,
    className: a,
    disabledItemsFocusable: s = !1,
    disableListWrap: c = !1,
    onKeyDown: l,
    variant: d = "selectedMenu"
  } = e, f = He(e, lZ), p = B.useRef(null), m = B.useRef({
    keys: [],
    repeating: !0,
    previousKeyMatched: !0,
    lastTime: null
  });
  $i(() => {
    r && p.current.focus();
  }, [r]), B.useImperativeHandle(n, () => ({
    adjustStyleForScrollbar: (T, {
      direction: S
    }) => {
      const _ = !p.current.style.width;
      if (T.clientHeight < p.current.clientHeight && _) {
        const w = `${Q3(Ar(T))}px`;
        p.current.style[S === "rtl" ? "paddingLeft" : "paddingRight"] = w, p.current.style.width = `calc(100% + ${w})`;
      }
      return p.current;
    }
  }), []);
  const v = (T) => {
    const S = p.current, _ = T.key, w = Ar(S).activeElement;
    if (_ === "ArrowDown")
      T.preventDefault(), Ru(S, w, c, s, n0);
    else if (_ === "ArrowUp")
      T.preventDefault(), Ru(S, w, c, s, wT);
    else if (_ === "Home")
      T.preventDefault(), Ru(S, null, c, s, n0);
    else if (_ === "End")
      T.preventDefault(), Ru(S, null, c, s, wT);
    else if (_.length === 1) {
      const k = m.current, E = _.toLowerCase(), R = performance.now();
      k.keys.length > 0 && (R - k.lastTime > 500 ? (k.keys = [], k.repeating = !0, k.previousKeyMatched = !0) : k.repeating && E !== k.keys[0] && (k.repeating = !1)), k.lastTime = R, k.keys.push(E);
      const P = w && !k.repeating && nA(w, k);
      k.previousKeyMatched && (P || Ru(S, w, !1, s, n0, k)) ? T.preventDefault() : k.previousKeyMatched = !1;
    }
    l && l(T);
  }, g = or(p, t);
  let b = -1;
  B.Children.forEach(i, (T, S) => {
    if (!/* @__PURE__ */ B.isValidElement(T)) {
      b === S && (b += 1, b >= i.length && (b = -1));
      return;
    }
    process.env.NODE_ENV !== "production" && la.isFragment(T) && console.error(["MUI: The Menu component doesn't accept a Fragment as a child.", "Consider providing an array instead."].join(`
`)), T.props.disabled || (d === "selectedMenu" && T.props.selected || b === -1) && (b = S), b === S && (T.props.disabled || T.props.muiSkipListHighlight || T.type.muiSkipListHighlight) && (b += 1, b >= i.length && (b = -1));
  });
  const x = B.Children.map(i, (T, S) => {
    if (S === b) {
      const _ = {};
      return o && (_.autoFocus = !0), T.props.tabIndex === void 0 && d === "selectedMenu" && (_.tabIndex = 0), /* @__PURE__ */ B.cloneElement(T, _);
    }
    return T;
  });
  return /* @__PURE__ */ z(sZ, re({
    role: "menu",
    ref: g,
    className: a,
    onKeyDown: v,
    tabIndex: r ? 0 : -1
  }, f, {
    children: x
  }));
});
process.env.NODE_ENV !== "production" && (rA.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, will focus the `[role="menu"]` container and move into tab order.
   * @default false
   */
  autoFocus: y.bool,
  /**
   * If `true`, will focus the first menuitem if `variant="menu"` or selected item
   * if `variant="selectedMenu"`.
   * @default false
   */
  autoFocusItem: y.bool,
  /**
   * MenuList contents, normally `MenuItem`s.
   */
  children: y.node,
  /**
   * @ignore
   */
  className: y.string,
  /**
   * If `true`, will allow focus on disabled items.
   * @default false
   */
  disabledItemsFocusable: y.bool,
  /**
   * If `true`, the menu items will not wrap focus.
   * @default false
   */
  disableListWrap: y.bool,
  /**
   * @ignore
   */
  onKeyDown: y.func,
  /**
   * The variant to use. Use `menu` to prevent selected items from impacting the initial focus
   * and the vertical alignment relative to the anchor element.
   * @default 'selectedMenu'
   */
  variant: y.oneOf(["menu", "selectedMenu"])
});
const cZ = rA;
function sg() {
  const e = G_(Zm);
  return process.env.NODE_ENV !== "production" && B.useDebugValue(e), e[_c] || e;
}
function Dh(e, t) {
  var n, r;
  const {
    timeout: o,
    easing: i,
    style: a = {}
  } = e;
  return {
    duration: (n = a.transitionDuration) != null ? n : typeof o == "number" ? o : o[t.mode] || 0,
    easing: (r = a.transitionTimingFunction) != null ? r : typeof i == "object" ? i[t.mode] : i,
    delay: a.transitionDelay
  };
}
const uZ = ["addEndListener", "appear", "children", "easing", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "style", "timeout", "TransitionComponent"];
function dy(e) {
  return `scale(${e}, ${li(e, 2)})`;
}
const dZ = {
  entering: {
    opacity: 1,
    transform: dy(1)
  },
  entered: {
    opacity: 1,
    transform: "none"
  }
}, r0 = typeof navigator != "undefined" && /^((?!chrome|android).)*(safari|mobile)/i.test(navigator.userAgent) && /(os |version\/)15(.|_)4/i.test(navigator.userAgent), ow = /* @__PURE__ */ B.forwardRef(function(e, t) {
  const {
    addEndListener: n,
    appear: r = !0,
    children: o,
    easing: i,
    in: a,
    onEnter: s,
    onEntered: c,
    onEntering: l,
    onExit: d,
    onExited: f,
    onExiting: p,
    style: m,
    timeout: v = "auto",
    // eslint-disable-next-line react/prop-types
    TransitionComponent: g = ZN
  } = e, b = He(e, uZ), x = tc(), T = B.useRef(), S = sg(), _ = B.useRef(null), w = or(_, o.ref, t), k = (F) => ($) => {
    if (F) {
      const I = _.current;
      $ === void 0 ? F(I) : F(I, $);
    }
  }, E = k(l), R = k((F, $) => {
    const {
      duration: I,
      delay: j,
      easing: U
    } = Dh({
      style: m,
      timeout: v,
      easing: i
    }, {
      mode: "enter"
    });
    let G;
    v === "auto" ? (G = S.transitions.getAutoHeightDuration(F.clientHeight), T.current = G) : G = I, F.style.transition = [S.transitions.create("opacity", {
      duration: G,
      delay: j
    }), S.transitions.create("transform", {
      duration: r0 ? G : G * 0.666,
      delay: j,
      easing: U
    })].join(","), s && s(F, $);
  }), P = k(c), A = k(p), D = k((F) => {
    const {
      duration: $,
      delay: I,
      easing: j
    } = Dh({
      style: m,
      timeout: v,
      easing: i
    }, {
      mode: "exit"
    });
    let U;
    v === "auto" ? (U = S.transitions.getAutoHeightDuration(F.clientHeight), T.current = U) : U = $, F.style.transition = [S.transitions.create("opacity", {
      duration: U,
      delay: I
    }), S.transitions.create("transform", {
      duration: r0 ? U : U * 0.666,
      delay: r0 ? I : I || U * 0.333,
      easing: j
    })].join(","), F.style.opacity = 0, F.style.transform = dy(0.75), d && d(F);
  }), N = k(f);
  return /* @__PURE__ */ z(g, re({
    appear: r,
    in: a,
    nodeRef: _,
    onEnter: R,
    onEntered: P,
    onEntering: E,
    onExit: D,
    onExited: N,
    onExiting: A,
    addEndListener: (F) => {
      v === "auto" && x.start(T.current || 0, F), n && n(_.current, F);
    },
    timeout: v === "auto" ? null : v
  }, b, {
    children: (F, $) => /* @__PURE__ */ B.cloneElement(o, re({
      style: re({
        opacity: 0,
        transform: dy(0.75),
        visibility: F === "exited" && !a ? "hidden" : void 0
      }, dZ[F], m, o.props.style),
      ref: w
    }, $))
  }));
});
process.env.NODE_ENV !== "production" && (ow.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Add a custom transition end trigger. Called with the transitioning DOM
   * node and a done callback. Allows for more fine grained transition end
   * logic. Note: Timeouts are still used as a fallback if provided.
   */
  addEndListener: y.func,
  /**
   * Perform the enter transition when it first mounts if `in` is also `true`.
   * Set this to `false` to disable this behavior.
   * @default true
   */
  appear: y.bool,
  /**
   * A single child content element.
   */
  children: ff.isRequired,
  /**
   * The transition timing function.
   * You may specify a single easing or a object containing enter and exit values.
   */
  easing: y.oneOfType([y.shape({
    enter: y.string,
    exit: y.string
  }), y.string]),
  /**
   * If `true`, the component will transition in.
   */
  in: y.bool,
  /**
   * @ignore
   */
  onEnter: y.func,
  /**
   * @ignore
   */
  onEntered: y.func,
  /**
   * @ignore
   */
  onEntering: y.func,
  /**
   * @ignore
   */
  onExit: y.func,
  /**
   * @ignore
   */
  onExited: y.func,
  /**
   * @ignore
   */
  onExiting: y.func,
  /**
   * @ignore
   */
  style: y.object,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   *
   * Set to 'auto' to automatically calculate transition time based on height.
   * @default 'auto'
   */
  timeout: y.oneOfType([y.oneOf(["auto"]), y.number, y.shape({
    appear: y.number,
    enter: y.number,
    exit: y.number
  })])
});
ow.muiSupportAuto = !0;
const fy = ow, fZ = ["addEndListener", "appear", "children", "easing", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "style", "timeout", "TransitionComponent"], pZ = {
  entering: {
    opacity: 1
  },
  entered: {
    opacity: 1
  }
}, oA = /* @__PURE__ */ B.forwardRef(function(e, t) {
  const n = sg(), r = {
    enter: n.transitions.duration.enteringScreen,
    exit: n.transitions.duration.leavingScreen
  }, {
    addEndListener: o,
    appear: i = !0,
    children: a,
    easing: s,
    in: c,
    onEnter: l,
    onEntered: d,
    onEntering: f,
    onExit: p,
    onExited: m,
    onExiting: v,
    style: g,
    timeout: b = r,
    // eslint-disable-next-line react/prop-types
    TransitionComponent: x = ZN
  } = e, T = He(e, fZ), S = B.useRef(null), _ = or(S, a.ref, t), w = (N) => (F) => {
    if (N) {
      const $ = S.current;
      F === void 0 ? N($) : N($, F);
    }
  }, k = w(f), E = w((N, F) => {
    const $ = Dh({
      style: g,
      timeout: b,
      easing: s
    }, {
      mode: "enter"
    });
    N.style.webkitTransition = n.transitions.create("opacity", $), N.style.transition = n.transitions.create("opacity", $), l && l(N, F);
  }), R = w(d), P = w(v), A = w((N) => {
    const F = Dh({
      style: g,
      timeout: b,
      easing: s
    }, {
      mode: "exit"
    });
    N.style.webkitTransition = n.transitions.create("opacity", F), N.style.transition = n.transitions.create("opacity", F), p && p(N);
  }), D = w(m);
  return /* @__PURE__ */ z(x, re({
    appear: i,
    in: c,
    nodeRef: S,
    onEnter: E,
    onEntered: R,
    onEntering: k,
    onExit: A,
    onExited: D,
    onExiting: P,
    addEndListener: (N) => {
      o && o(S.current, N);
    },
    timeout: b
  }, T, {
    children: (N, F) => /* @__PURE__ */ B.cloneElement(a, re({
      style: re({
        opacity: 0,
        visibility: N === "exited" && !c ? "hidden" : void 0
      }, pZ[N], g, a.props.style),
      ref: _
    }, F))
  }));
});
process.env.NODE_ENV !== "production" && (oA.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Add a custom transition end trigger. Called with the transitioning DOM
   * node and a done callback. Allows for more fine grained transition end
   * logic. Note: Timeouts are still used as a fallback if provided.
   */
  addEndListener: y.func,
  /**
   * Perform the enter transition when it first mounts if `in` is also `true`.
   * Set this to `false` to disable this behavior.
   * @default true
   */
  appear: y.bool,
  /**
   * A single child content element.
   */
  children: ff.isRequired,
  /**
   * The transition timing function.
   * You may specify a single easing or a object containing enter and exit values.
   */
  easing: y.oneOfType([y.shape({
    enter: y.string,
    exit: y.string
  }), y.string]),
  /**
   * If `true`, the component will transition in.
   */
  in: y.bool,
  /**
   * @ignore
   */
  onEnter: y.func,
  /**
   * @ignore
   */
  onEntered: y.func,
  /**
   * @ignore
   */
  onEntering: y.func,
  /**
   * @ignore
   */
  onExit: y.func,
  /**
   * @ignore
   */
  onExited: y.func,
  /**
   * @ignore
   */
  onExiting: y.func,
  /**
   * @ignore
   */
  style: y.object,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   * @default {
   *   enter: theme.transitions.duration.enteringScreen,
   *   exit: theme.transitions.duration.leavingScreen,
   * }
   */
  timeout: y.oneOfType([y.number, y.shape({
    appear: y.number,
    enter: y.number,
    exit: y.number
  })])
});
const hZ = oA;
function mZ(e) {
  return Gt("MuiBackdrop", e);
}
Wt("MuiBackdrop", ["root", "invisible"]);
const gZ = ["children", "className", "component", "components", "componentsProps", "invisible", "open", "slotProps", "slots", "TransitionComponent", "transitionDuration"], vZ = (e) => {
  const {
    classes: t,
    invisible: n
  } = e;
  return Yt({
    root: ["root", n && "invisible"]
  }, mZ, t);
}, bZ = Fe("div", {
  name: "MuiBackdrop",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.invisible && t.invisible];
  }
})(({
  ownerState: e
}) => re({
  position: "fixed",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  right: 0,
  bottom: 0,
  top: 0,
  left: 0,
  backgroundColor: "rgba(0, 0, 0, 0.5)",
  WebkitTapHighlightColor: "transparent"
}, e.invisible && {
  backgroundColor: "transparent"
})), iA = /* @__PURE__ */ B.forwardRef(function(e, t) {
  var n, r, o;
  const i = rn({
    props: e,
    name: "MuiBackdrop"
  }), {
    children: a,
    className: s,
    component: c = "div",
    components: l = {},
    componentsProps: d = {},
    invisible: f = !1,
    open: p,
    slotProps: m = {},
    slots: v = {},
    TransitionComponent: g = hZ,
    transitionDuration: b
  } = i, x = He(i, gZ), T = re({}, i, {
    component: c,
    invisible: f
  }), S = vZ(T), _ = (n = m.root) != null ? n : d.root;
  return /* @__PURE__ */ z(g, re({
    in: p,
    timeout: b
  }, x, {
    children: /* @__PURE__ */ z(bZ, re({
      "aria-hidden": !0
    }, _, {
      as: (r = (o = v.root) != null ? o : l.Root) != null ? r : c,
      className: Qe(S.root, s, _ == null ? void 0 : _.className),
      ownerState: re({}, T, _ == null ? void 0 : _.ownerState),
      classes: S,
      ref: t,
      children: a
    }))
  }));
});
process.env.NODE_ENV !== "production" && (iA.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: y.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: y.object,
  /**
   * @ignore
   */
  className: y.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: y.elementType,
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */
  components: y.shape({
    Root: y.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `slotProps` prop.
   * It's recommended to use the `slotProps` prop instead, as `componentsProps` will be deprecated in the future.
   *
   * @default {}
   */
  componentsProps: y.shape({
    root: y.object
  }),
  /**
   * If `true`, the backdrop is invisible.
   * It can be used when rendering a popover or a custom select component.
   * @default false
   */
  invisible: y.bool,
  /**
   * If `true`, the component is shown.
   */
  open: y.bool.isRequired,
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slotProps: y.shape({
    root: y.object
  }),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: y.shape({
    root: y.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: y.oneOfType([y.arrayOf(y.oneOfType([y.func, y.object, y.bool])), y.func, y.object]),
  /**
   * The component used for the transition.
   * [Follow this guide](/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @default Fade
   */
  TransitionComponent: y.elementType,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */
  transitionDuration: y.oneOfType([y.number, y.shape({
    appear: y.number,
    enter: y.number,
    exit: y.number
  })])
});
const yZ = iA;
function _Z(e) {
  return Gt("MuiModal", e);
}
Wt("MuiModal", ["root", "hidden", "backdrop"]);
const wZ = ["BackdropComponent", "BackdropProps", "classes", "className", "closeAfterTransition", "children", "container", "component", "components", "componentsProps", "disableAutoFocus", "disableEnforceFocus", "disableEscapeKeyDown", "disablePortal", "disableRestoreFocus", "disableScrollLock", "hideBackdrop", "keepMounted", "onBackdropClick", "onClose", "onTransitionEnter", "onTransitionExited", "open", "slotProps", "slots", "theme"], xZ = (e) => {
  const {
    open: t,
    exited: n,
    classes: r
  } = e;
  return Yt({
    root: ["root", !t && n && "hidden"],
    backdrop: ["backdrop"]
  }, _Z, r);
}, CZ = Fe("div", {
  name: "MuiModal",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, !n.open && n.exited && t.hidden];
  }
})(({
  theme: e,
  ownerState: t
}) => re({
  position: "fixed",
  zIndex: (e.vars || e).zIndex.modal,
  right: 0,
  bottom: 0,
  top: 0,
  left: 0
}, !t.open && t.exited && {
  visibility: "hidden"
})), SZ = Fe(yZ, {
  name: "MuiModal",
  slot: "Backdrop",
  overridesResolver: (e, t) => t.backdrop
})({
  zIndex: -1
}), aA = /* @__PURE__ */ B.forwardRef(function(e, t) {
  var n, r, o, i, a, s;
  const c = rn({
    name: "MuiModal",
    props: e
  }), {
    BackdropComponent: l = SZ,
    BackdropProps: d,
    className: f,
    closeAfterTransition: p = !1,
    children: m,
    container: v,
    component: g,
    components: b = {},
    componentsProps: x = {},
    disableAutoFocus: T = !1,
    disableEnforceFocus: S = !1,
    disableEscapeKeyDown: _ = !1,
    disablePortal: w = !1,
    disableRestoreFocus: k = !1,
    disableScrollLock: E = !1,
    hideBackdrop: R = !1,
    keepMounted: P = !1,
    onBackdropClick: A,
    open: D,
    slotProps: N,
    slots: F
    // eslint-disable-next-line react/prop-types
  } = c, $ = He(c, wZ), I = re({}, c, {
    closeAfterTransition: p,
    disableAutoFocus: T,
    disableEnforceFocus: S,
    disableEscapeKeyDown: _,
    disablePortal: w,
    disableRestoreFocus: k,
    disableScrollLock: E,
    hideBackdrop: R,
    keepMounted: P
  }), {
    getRootProps: j,
    getBackdropProps: U,
    getTransitionProps: G,
    portalRef: V,
    isTopModal: H,
    exited: q,
    hasTransition: Q
  } = Vq(re({}, I, {
    rootRef: t
  })), X = re({}, I, {
    exited: q
  }), K = xZ(X), J = {};
  if (m.props.tabIndex === void 0 && (J.tabIndex = "-1"), Q) {
    const {
      onEnter: ee,
      onExited: me
    } = G();
    J.onEnter = ee, J.onExited = me;
  }
  const ne = (n = (r = F == null ? void 0 : F.root) != null ? r : b.Root) != null ? n : CZ, ae = (o = (i = F == null ? void 0 : F.backdrop) != null ? i : b.Backdrop) != null ? o : l, te = (a = N == null ? void 0 : N.root) != null ? a : x.root, le = (s = N == null ? void 0 : N.backdrop) != null ? s : x.backdrop, ce = Zs({
    elementType: ne,
    externalSlotProps: te,
    externalForwardedProps: $,
    getSlotProps: j,
    additionalProps: {
      ref: t,
      as: g
    },
    ownerState: X,
    className: Qe(f, te == null ? void 0 : te.className, K == null ? void 0 : K.root, !X.open && X.exited && (K == null ? void 0 : K.hidden))
  }), fe = Zs({
    elementType: ae,
    externalSlotProps: le,
    additionalProps: d,
    getSlotProps: (ee) => U(re({}, ee, {
      onClick: (me) => {
        A && A(me), ee != null && ee.onClick && ee.onClick(me);
      }
    })),
    className: Qe(le == null ? void 0 : le.className, d == null ? void 0 : d.className, K == null ? void 0 : K.backdrop),
    ownerState: X
  });
  return !P && !D && (!Q || q) ? null : /* @__PURE__ */ z(Fd, {
    ref: V,
    container: v,
    disablePortal: w,
    children: /* @__PURE__ */ _e(ne, re({}, ce, {
      children: [!R && l ? /* @__PURE__ */ z(ae, re({}, fe)) : null, /* @__PURE__ */ z(Eh, {
        disableEnforceFocus: S,
        disableAutoFocus: T,
        disableRestoreFocus: k,
        isEnabled: H,
        open: D,
        children: /* @__PURE__ */ B.cloneElement(m, J)
      })]
    }))
  });
});
process.env.NODE_ENV !== "production" && (aA.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A backdrop component. This prop enables custom backdrop rendering.
   * @deprecated Use `slots.backdrop` instead. While this prop currently works, it will be removed in the next major version.
   * Use the `slots.backdrop` prop to make your application ready for the next version of Material UI.
   * @default styled(Backdrop, {
   *   name: 'MuiModal',
   *   slot: 'Backdrop',
   *   overridesResolver: (props, styles) => {
   *     return styles.backdrop;
   *   },
   * })({
   *   zIndex: -1,
   * })
   */
  BackdropComponent: y.elementType,
  /**
   * Props applied to the [`Backdrop`](/material-ui/api/backdrop/) element.
   * @deprecated Use `slotProps.backdrop` instead.
   */
  BackdropProps: y.object,
  /**
   * A single child content element.
   */
  children: ff.isRequired,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: y.object,
  /**
   * @ignore
   */
  className: y.string,
  /**
   * When set to true the Modal waits until a nested Transition is completed before closing.
   * @default false
   */
  closeAfterTransition: y.bool,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: y.elementType,
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */
  components: y.shape({
    Backdrop: y.elementType,
    Root: y.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `slotProps` prop.
   * It's recommended to use the `slotProps` prop instead, as `componentsProps` will be deprecated in the future.
   *
   * @default {}
   */
  componentsProps: y.shape({
    backdrop: y.oneOfType([y.func, y.object]),
    root: y.oneOfType([y.func, y.object])
  }),
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * You can also provide a callback, which is called in a React layout effect.
   * This lets you set the container from a ref, and also makes server-side rendering possible.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: y.oneOfType([fa, y.func]),
  /**
   * If `true`, the modal will not automatically shift focus to itself when it opens, and
   * replace it to the last focused element when it closes.
   * This also works correctly with any modal children that have the `disableAutoFocus` prop.
   *
   * Generally this should never be set to `true` as it makes the modal less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableAutoFocus: y.bool,
  /**
   * If `true`, the modal will not prevent focus from leaving the modal while open.
   *
   * Generally this should never be set to `true` as it makes the modal less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableEnforceFocus: y.bool,
  /**
   * If `true`, hitting escape will not fire the `onClose` callback.
   * @default false
   */
  disableEscapeKeyDown: y.bool,
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: y.bool,
  /**
   * If `true`, the modal will not restore focus to previously focused element once
   * modal is hidden or unmounted.
   * @default false
   */
  disableRestoreFocus: y.bool,
  /**
   * Disable the scroll lock behavior.
   * @default false
   */
  disableScrollLock: y.bool,
  /**
   * If `true`, the backdrop is not rendered.
   * @default false
   */
  hideBackdrop: y.bool,
  /**
   * Always keep the children in the DOM.
   * This prop can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Modal.
   * @default false
   */
  keepMounted: y.bool,
  /**
   * Callback fired when the backdrop is clicked.
   * @deprecated Use the `onClose` prop with the `reason` argument to handle the `backdropClick` events.
   */
  onBackdropClick: y.func,
  /**
   * Callback fired when the component requests to be closed.
   * The `reason` parameter can optionally be used to control the response to `onClose`.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`.
   */
  onClose: y.func,
  /**
   * A function called when a transition enters.
   */
  onTransitionEnter: y.func,
  /**
   * A function called when a transition has exited.
   */
  onTransitionExited: y.func,
  /**
   * If `true`, the component is shown.
   */
  open: y.bool.isRequired,
  /**
   * The props used for each slot inside the Modal.
   * @default {}
   */
  slotProps: y.shape({
    backdrop: y.oneOfType([y.func, y.object]),
    root: y.oneOfType([y.func, y.object])
  }),
  /**
   * The components used for each slot inside the Modal.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: y.shape({
    backdrop: y.elementType,
    root: y.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: y.oneOfType([y.arrayOf(y.oneOfType([y.func, y.object, y.bool])), y.func, y.object])
});
const TZ = aA, EZ = (e) => {
  let t;
  return e < 1 ? t = 5.11916 * li(e, 2) : t = 4.5 * Math.log(e + 1) + 2, (t / 100).toFixed(2);
}, xT = EZ;
function kZ(e) {
  return Gt("MuiPaper", e);
}
Wt("MuiPaper", ["root", "rounded", "outlined", "elevation", "elevation0", "elevation1", "elevation2", "elevation3", "elevation4", "elevation5", "elevation6", "elevation7", "elevation8", "elevation9", "elevation10", "elevation11", "elevation12", "elevation13", "elevation14", "elevation15", "elevation16", "elevation17", "elevation18", "elevation19", "elevation20", "elevation21", "elevation22", "elevation23", "elevation24"]);
const MZ = ["className", "component", "elevation", "square", "variant"], RZ = (e) => {
  const {
    square: t,
    elevation: n,
    variant: r,
    classes: o
  } = e, i = {
    root: ["root", r, !t && "rounded", r === "elevation" && `elevation${n}`]
  };
  return Yt(i, kZ, o);
}, PZ = Fe("div", {
  name: "MuiPaper",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, t[n.variant], !n.square && t.rounded, n.variant === "elevation" && t[`elevation${n.elevation}`]];
  }
})(({
  theme: e,
  ownerState: t
}) => {
  var n;
  return re({
    backgroundColor: (e.vars || e).palette.background.paper,
    color: (e.vars || e).palette.text.primary,
    transition: e.transitions.create("box-shadow")
  }, !t.square && {
    borderRadius: e.shape.borderRadius
  }, t.variant === "outlined" && {
    border: `1px solid ${(e.vars || e).palette.divider}`
  }, t.variant === "elevation" && re({
    boxShadow: (e.vars || e).shadows[t.elevation]
  }, !e.vars && e.palette.mode === "dark" && {
    backgroundImage: `linear-gradient(${tn.alpha("#fff", xT(t.elevation))}, ${tn.alpha("#fff", xT(t.elevation))})`
  }, e.vars && {
    backgroundImage: (n = e.vars.overlays) == null ? void 0 : n[t.elevation]
  }));
}), sA = /* @__PURE__ */ B.forwardRef(function(e, t) {
  const n = rn({
    props: e,
    name: "MuiPaper"
  }), {
    className: r,
    component: o = "div",
    elevation: i = 1,
    square: a = !1,
    variant: s = "elevation"
  } = n, c = He(n, MZ), l = re({}, n, {
    component: o,
    elevation: i,
    square: a,
    variant: s
  }), d = RZ(l);
  return process.env.NODE_ENV !== "production" && sg().shadows[i] === void 0 && console.error([`MUI: The elevation provided <Paper elevation={${i}}> is not available in the theme.`, `Please make sure that \`theme.shadows[${i}]\` is defined.`].join(`
`)), /* @__PURE__ */ z(PZ, re({
    as: o,
    ownerState: l,
    className: Qe(d.root, r),
    ref: t
  }, c));
});
process.env.NODE_ENV !== "production" && (sA.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: y.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: y.object,
  /**
   * @ignore
   */
  className: y.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: y.elementType,
  /**
   * Shadow depth, corresponds to `dp` in the spec.
   * It accepts values between 0 and 24 inclusive.
   * @default 1
   */
  elevation: fs(Si, (e) => {
    const {
      elevation: t,
      variant: n
    } = e;
    return t > 0 && n === "outlined" ? new Error(`MUI: Combining \`elevation={${t}}\` with \`variant="${n}"\` has no effect. Either use \`elevation={0}\` or use a different \`variant\`.`) : null;
  }),
  /**
   * If `true`, rounded corners are disabled.
   * @default false
   */
  square: y.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: y.oneOfType([y.arrayOf(y.oneOfType([y.func, y.object, y.bool])), y.func, y.object]),
  /**
   * The variant to use.
   * @default 'elevation'
   */
  variant: y.oneOfType([y.oneOf(["elevation", "outlined"]), y.string])
});
const OZ = sA;
function NZ(e) {
  return Gt("MuiPopover", e);
}
Wt("MuiPopover", ["root", "paper"]);
const AZ = ["onEntering"], DZ = ["action", "anchorEl", "anchorOrigin", "anchorPosition", "anchorReference", "children", "className", "container", "elevation", "marginThreshold", "open", "PaperProps", "slots", "slotProps", "transformOrigin", "TransitionComponent", "transitionDuration", "TransitionProps", "disableScrollLock"], IZ = ["slotProps"];
function CT(e, t) {
  let n = 0;
  return typeof t == "number" ? n = t : t === "center" ? n = e.height / 2 : t === "bottom" && (n = e.height), n;
}
function ST(e, t) {
  let n = 0;
  return typeof t == "number" ? n = t : t === "center" ? n = e.width / 2 : t === "right" && (n = e.width), n;
}
function TT(e) {
  return [e.horizontal, e.vertical].map((t) => typeof t == "number" ? `${t}px` : t).join(" ");
}
function Zp(e) {
  return typeof e == "function" ? e() : e;
}
const LZ = (e) => {
  const {
    classes: t
  } = e;
  return Yt({
    root: ["root"],
    paper: ["paper"]
  }, NZ, t);
}, $Z = Fe(TZ, {
  name: "MuiPopover",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({}), lA = Fe(OZ, {
  name: "MuiPopover",
  slot: "Paper",
  overridesResolver: (e, t) => t.paper
})({
  position: "absolute",
  overflowY: "auto",
  overflowX: "hidden",
  // So we see the popover when it's empty.
  // It's most likely on issue on userland.
  minWidth: 16,
  minHeight: 16,
  maxWidth: "calc(100% - 32px)",
  maxHeight: "calc(100% - 32px)",
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0
}), cA = /* @__PURE__ */ B.forwardRef(function(e, t) {
  var n, r, o;
  const i = rn({
    props: e,
    name: "MuiPopover"
  }), {
    action: a,
    anchorEl: s,
    anchorOrigin: c = {
      vertical: "top",
      horizontal: "left"
    },
    anchorPosition: l,
    anchorReference: d = "anchorEl",
    children: f,
    className: p,
    container: m,
    elevation: v = 8,
    marginThreshold: g = 16,
    open: b,
    PaperProps: x = {},
    slots: T,
    slotProps: S,
    transformOrigin: _ = {
      vertical: "top",
      horizontal: "left"
    },
    TransitionComponent: w = fy,
    transitionDuration: k = "auto",
    TransitionProps: {
      onEntering: E
    } = {},
    disableScrollLock: R = !1
  } = i, P = He(i.TransitionProps, AZ), A = He(i, DZ), D = (n = S == null ? void 0 : S.paper) != null ? n : x, N = B.useRef(), F = or(N, D.ref), $ = re({}, i, {
    anchorOrigin: c,
    anchorReference: d,
    elevation: v,
    marginThreshold: g,
    externalPaperSlotProps: D,
    transformOrigin: _,
    TransitionComponent: w,
    transitionDuration: k,
    TransitionProps: P
  }), I = LZ($), j = B.useCallback(() => {
    if (d === "anchorPosition")
      return process.env.NODE_ENV !== "production" && (l || console.error('MUI: You need to provide a `anchorPosition` prop when using <Popover anchorReference="anchorPosition" />.')), l;
    const ee = Zp(s), me = ee && ee.nodeType === 1 ? ee : Ar(N.current).body, oe = me.getBoundingClientRect();
    if (process.env.NODE_ENV !== "production") {
      const ve = me.getBoundingClientRect();
      process.env.NODE_ENV !== "test" && ve.top === 0 && ve.left === 0 && ve.right === 0 && ve.bottom === 0 && console.warn(["MUI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
    }
    return {
      top: oe.top + CT(oe, c.vertical),
      left: oe.left + ST(oe, c.horizontal)
    };
  }, [s, c.horizontal, c.vertical, l, d]), U = B.useCallback((ee) => ({
    vertical: CT(ee, _.vertical),
    horizontal: ST(ee, _.horizontal)
  }), [_.horizontal, _.vertical]), G = B.useCallback((ee) => {
    const me = {
      width: ee.offsetWidth,
      height: ee.offsetHeight
    }, oe = U(me);
    if (d === "none")
      return {
        top: null,
        left: null,
        transformOrigin: TT(oe)
      };
    const ve = j();
    let we = ve.top - oe.vertical, ye = ve.left - oe.horizontal;
    const Ce = we + me.height, Se = ye + me.width, Te = Ys(Zp(s)), Ae = Te.innerHeight - g, je = Te.innerWidth - g;
    if (g !== null && we < g) {
      const Me = we - g;
      we -= Me, oe.vertical += Me;
    } else if (g !== null && Ce > Ae) {
      const Me = Ce - Ae;
      we -= Me, oe.vertical += Me;
    }
    if (process.env.NODE_ENV !== "production" && me.height > Ae && me.height && Ae && console.error(["MUI: The popover component is too tall.", `Some part of it can not be seen on the screen (${me.height - Ae}px).`, "Please consider adding a `max-height` to improve the user-experience."].join(`
`)), g !== null && ye < g) {
      const Me = ye - g;
      ye -= Me, oe.horizontal += Me;
    } else if (Se > je) {
      const Me = Se - je;
      ye -= Me, oe.horizontal += Me;
    }
    return {
      top: `${Math.round(we)}px`,
      left: `${Math.round(ye)}px`,
      transformOrigin: TT(oe)
    };
  }, [s, d, j, U, g]), [V, H] = B.useState(b), q = B.useCallback(() => {
    const ee = N.current;
    if (!ee)
      return;
    const me = G(ee);
    me.top !== null && (ee.style.top = me.top), me.left !== null && (ee.style.left = me.left), ee.style.transformOrigin = me.transformOrigin, H(!0);
  }, [G]);
  B.useEffect(() => (R && window.addEventListener("scroll", q), () => window.removeEventListener("scroll", q)), [s, R, q]);
  const Q = (ee, me) => {
    E && E(ee, me), q();
  }, X = () => {
    H(!1);
  };
  B.useEffect(() => {
    b && q();
  }), B.useImperativeHandle(a, () => b ? {
    updatePosition: () => {
      q();
    }
  } : null, [b, q]), B.useEffect(() => {
    if (!b)
      return;
    const ee = K3(() => {
      q();
    }), me = Ys(s);
    return me.addEventListener("resize", ee), () => {
      ee.clear(), me.removeEventListener("resize", ee);
    };
  }, [s, b, q]);
  let K = k;
  k === "auto" && !w.muiSupportAuto && (K = void 0);
  const J = m || (s ? Ar(Zp(s)).body : void 0), ne = (r = T == null ? void 0 : T.root) != null ? r : $Z, ae = (o = T == null ? void 0 : T.paper) != null ? o : lA, te = Zs({
    elementType: ae,
    externalSlotProps: re({}, D, {
      style: V ? D.style : re({}, D.style, {
        opacity: 0
      })
    }),
    additionalProps: {
      elevation: v,
      ref: F
    },
    ownerState: $,
    className: Qe(I.paper, D == null ? void 0 : D.className)
  }), le = Zs({
    elementType: ne,
    externalSlotProps: (S == null ? void 0 : S.root) || {},
    externalForwardedProps: A,
    additionalProps: {
      ref: t,
      slotProps: {
        backdrop: {
          invisible: !0
        }
      },
      container: J,
      open: b
    },
    ownerState: $,
    className: Qe(I.root, p)
  }), {
    slotProps: ce
  } = le, fe = He(le, IZ);
  return /* @__PURE__ */ z(ne, re({}, fe, !Ad(ne) && {
    slotProps: ce,
    disableScrollLock: R
  }, {
    children: /* @__PURE__ */ z(w, re({
      appear: !0,
      in: b,
      onEntering: Q,
      onExited: X,
      timeout: K
    }, P, {
      children: /* @__PURE__ */ z(ae, re({}, te, {
        children: f
      }))
    }))
  }));
});
process.env.NODE_ENV !== "production" && (cA.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A ref for imperative actions.
   * It currently only supports updatePosition() action.
   */
  action: Yo,
  /**
   * An HTML element, [PopoverVirtualElement](/material-ui/react-popover/#virtual-element),
   * or a function that returns either.
   * It's used to set the position of the popover.
   */
  anchorEl: fs(y.oneOfType([fa, y.func]), (e) => {
    if (e.open && (!e.anchorReference || e.anchorReference === "anchorEl")) {
      const t = Zp(e.anchorEl);
      if (t && t.nodeType === 1) {
        const n = t.getBoundingClientRect();
        if (process.env.NODE_ENV !== "test" && n.top === 0 && n.left === 0 && n.right === 0 && n.bottom === 0)
          return new Error(["MUI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
      } else
        return new Error(["MUI: The `anchorEl` prop provided to the component is invalid.", `It should be an Element or PopoverVirtualElement instance but it's \`${t}\` instead.`].join(`
`));
    }
    return null;
  }),
  /**
   * This is the point on the anchor where the popover's
   * `anchorEl` will attach to. This is not used when the
   * anchorReference is 'anchorPosition'.
   *
   * Options:
   * vertical: [top, center, bottom];
   * horizontal: [left, center, right].
   * @default {
   *   vertical: 'top',
   *   horizontal: 'left',
   * }
   */
  anchorOrigin: y.shape({
    horizontal: y.oneOfType([y.oneOf(["center", "left", "right"]), y.number]).isRequired,
    vertical: y.oneOfType([y.oneOf(["bottom", "center", "top"]), y.number]).isRequired
  }),
  /**
   * This is the position that may be used to set the position of the popover.
   * The coordinates are relative to the application's client area.
   */
  anchorPosition: y.shape({
    left: y.number.isRequired,
    top: y.number.isRequired
  }),
  /**
   * This determines which anchor prop to refer to when setting
   * the position of the popover.
   * @default 'anchorEl'
   */
  anchorReference: y.oneOf(["anchorEl", "anchorPosition", "none"]),
  /**
   * The content of the component.
   */
  children: y.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: y.object,
  /**
   * @ignore
   */
  className: y.string,
  /**
   * An HTML element, component instance, or function that returns either.
   * The `container` will passed to the Modal component.
   *
   * By default, it uses the body of the anchorEl's top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: y.oneOfType([fa, y.func]),
  /**
   * Disable the scroll lock behavior.
   * @default false
   */
  disableScrollLock: y.bool,
  /**
   * The elevation of the popover.
   * @default 8
   */
  elevation: Si,
  /**
   * Specifies how close to the edge of the window the popover can appear.
   * If null, the popover will not be constrained by the window.
   * @default 16
   */
  marginThreshold: y.number,
  /**
   * Callback fired when the component requests to be closed.
   * The `reason` parameter can optionally be used to control the response to `onClose`.
   */
  onClose: y.func,
  /**
   * If `true`, the component is shown.
   */
  open: y.bool.isRequired,
  /**
   * Props applied to the [`Paper`](/material-ui/api/paper/) element.
   *
   * This prop is an alias for `slotProps.paper` and will be overriden by it if both are used.
   * @deprecated Use `slotProps.paper` instead.
   *
   * @default {}
   */
  PaperProps: y.shape({
    component: $_
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @default {}
   */
  slotProps: y.shape({
    paper: y.oneOfType([y.func, y.object]),
    root: y.oneOfType([y.func, y.object])
  }),
  /**
   * The components used for each slot inside.
   *
   * @default {}
   */
  slots: y.shape({
    paper: y.elementType,
    root: y.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: y.oneOfType([y.arrayOf(y.oneOfType([y.func, y.object, y.bool])), y.func, y.object]),
  /**
   * This is the point on the popover which
   * will attach to the anchor's origin.
   *
   * Options:
   * vertical: [top, center, bottom, x(px)];
   * horizontal: [left, center, right, x(px)].
   * @default {
   *   vertical: 'top',
   *   horizontal: 'left',
   * }
   */
  transformOrigin: y.shape({
    horizontal: y.oneOfType([y.oneOf(["center", "left", "right"]), y.number]).isRequired,
    vertical: y.oneOfType([y.oneOf(["bottom", "center", "top"]), y.number]).isRequired
  }),
  /**
   * The component used for the transition.
   * [Follow this guide](/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @default Grow
   */
  TransitionComponent: y.elementType,
  /**
   * Set to 'auto' to automatically calculate transition time based on height.
   * @default 'auto'
   */
  transitionDuration: y.oneOfType([y.oneOf(["auto"]), y.number, y.shape({
    appear: y.number,
    enter: y.number,
    exit: y.number
  })]),
  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](https://reactcommunity.org/react-transition-group/transition/) component.
   * @default {}
   */
  TransitionProps: y.object
});
const FZ = cA;
function zZ(e) {
  return Gt("MuiMenu", e);
}
Wt("MuiMenu", ["root", "paper", "list"]);
const BZ = ["onEntering"], HZ = ["autoFocus", "children", "className", "disableAutoFocusItem", "MenuListProps", "onClose", "open", "PaperProps", "PopoverClasses", "transitionDuration", "TransitionProps", "variant", "slots", "slotProps"], jZ = {
  vertical: "top",
  horizontal: "right"
}, WZ = {
  vertical: "top",
  horizontal: "left"
}, VZ = (e) => {
  const {
    classes: t
  } = e;
  return Yt({
    root: ["root"],
    paper: ["paper"],
    list: ["list"]
  }, zZ, t);
}, UZ = Fe(FZ, {
  shouldForwardProp: (e) => Xo(e) || e === "classes",
  name: "MuiMenu",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({}), qZ = Fe(lA, {
  name: "MuiMenu",
  slot: "Paper",
  overridesResolver: (e, t) => t.paper
})({
  // specZ: The maximum height of a simple menu should be one or more rows less than the view
  // height. This ensures a tappable area outside of the simple menu with which to dismiss
  // the menu.
  maxHeight: "calc(100% - 96px)",
  // Add iOS momentum scrolling for iOS < 13.0
  WebkitOverflowScrolling: "touch"
}), GZ = Fe(cZ, {
  name: "MuiMenu",
  slot: "List",
  overridesResolver: (e, t) => t.list
})({
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0
}), uA = /* @__PURE__ */ B.forwardRef(function(e, t) {
  var n, r;
  const o = rn({
    props: e,
    name: "MuiMenu"
  }), {
    autoFocus: i = !0,
    children: a,
    className: s,
    disableAutoFocusItem: c = !1,
    MenuListProps: l = {},
    onClose: d,
    open: f,
    PaperProps: p = {},
    PopoverClasses: m,
    transitionDuration: v = "auto",
    TransitionProps: {
      onEntering: g
    } = {},
    variant: b = "selectedMenu",
    slots: x = {},
    slotProps: T = {}
  } = o, S = He(o.TransitionProps, BZ), _ = He(o, HZ), w = Qm(), k = re({}, o, {
    autoFocus: i,
    disableAutoFocusItem: c,
    MenuListProps: l,
    onEntering: g,
    PaperProps: p,
    transitionDuration: v,
    TransitionProps: S,
    variant: b
  }), E = VZ(k), R = i && !c && f, P = B.useRef(null), A = (U, G) => {
    P.current && P.current.adjustStyleForScrollbar(U, {
      direction: w ? "rtl" : "ltr"
    }), g && g(U, G);
  }, D = (U) => {
    U.key === "Tab" && (U.preventDefault(), d && d(U, "tabKeyDown"));
  };
  let N = -1;
  B.Children.map(a, (U, G) => {
    /* @__PURE__ */ B.isValidElement(U) && (process.env.NODE_ENV !== "production" && la.isFragment(U) && console.error(["MUI: The Menu component doesn't accept a Fragment as a child.", "Consider providing an array instead."].join(`
`)), U.props.disabled || (b === "selectedMenu" && U.props.selected || N === -1) && (N = G));
  });
  const F = (n = x.paper) != null ? n : qZ, $ = (r = T.paper) != null ? r : p, I = Zs({
    elementType: x.root,
    externalSlotProps: T.root,
    ownerState: k,
    className: [E.root, s]
  }), j = Zs({
    elementType: F,
    externalSlotProps: $,
    ownerState: k,
    className: E.paper
  });
  return /* @__PURE__ */ z(UZ, re({
    onClose: d,
    anchorOrigin: {
      vertical: "bottom",
      horizontal: w ? "right" : "left"
    },
    transformOrigin: w ? jZ : WZ,
    slots: {
      paper: F,
      root: x.root
    },
    slotProps: {
      root: I,
      paper: j
    },
    open: f,
    ref: t,
    transitionDuration: v,
    TransitionProps: re({
      onEntering: A
    }, S),
    ownerState: k
  }, _, {
    classes: m,
    children: /* @__PURE__ */ z(GZ, re({
      onKeyDown: D,
      actions: P,
      autoFocus: i && (N === -1 || c),
      autoFocusItem: R,
      variant: b
    }, l, {
      className: Qe(E.list, l.className),
      children: a
    }))
  }));
});
process.env.NODE_ENV !== "production" && (uA.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * An HTML element, or a function that returns one.
   * It's used to set the position of the menu.
   */
  anchorEl: y.oneOfType([fa, y.func]),
  /**
   * If `true` (Default) will focus the `[role="menu"]` if no focusable child is found. Disabled
   * children are not focusable. If you set this prop to `false` focus will be placed
   * on the parent modal container. This has severe accessibility implications
   * and should only be considered if you manage focus otherwise.
   * @default true
   */
  autoFocus: y.bool,
  /**
   * Menu contents, normally `MenuItem`s.
   */
  children: y.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: y.object,
  /**
   * @ignore
   */
  className: y.string,
  /**
   * When opening the menu will not focus the active item but the `[role="menu"]`
   * unless `autoFocus` is also set to `false`. Not using the default means not
   * following WAI-ARIA authoring practices. Please be considerate about possible
   * accessibility implications.
   * @default false
   */
  disableAutoFocusItem: y.bool,
  /**
   * Props applied to the [`MenuList`](/material-ui/api/menu-list/) element.
   * @default {}
   */
  MenuListProps: y.object,
  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`, `"tabKeyDown"`.
   */
  onClose: y.func,
  /**
   * If `true`, the component is shown.
   */
  open: y.bool.isRequired,
  /**
   * @ignore
   */
  PaperProps: y.object,
  /**
   * `classes` prop applied to the [`Popover`](/material-ui/api/popover/) element.
   */
  PopoverClasses: y.object,
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @default {}
   */
  slotProps: y.shape({
    paper: y.oneOfType([y.func, y.object]),
    root: y.oneOfType([y.func, y.object])
  }),
  /**
   * The components used for each slot inside.
   *
   * @default {}
   */
  slots: y.shape({
    paper: y.elementType,
    root: y.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: y.oneOfType([y.arrayOf(y.oneOfType([y.func, y.object, y.bool])), y.func, y.object]),
  /**
   * The length of the transition in `ms`, or 'auto'
   * @default 'auto'
   */
  transitionDuration: y.oneOfType([y.oneOf(["auto"]), y.number, y.shape({
    appear: y.number,
    enter: y.number,
    exit: y.number
  })]),
  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](https://reactcommunity.org/react-transition-group/transition/) component.
   * @default {}
   */
  TransitionProps: y.object,
  /**
   * The variant to use. Use `menu` to prevent selected items from impacting the initial focus.
   * @default 'selectedMenu'
   */
  variant: y.oneOf(["menu", "selectedMenu"])
});
const YZ = uA;
function ZZ(e) {
  return Gt("MuiNativeSelect", e);
}
const XZ = Wt("MuiNativeSelect", ["root", "select", "multiple", "filled", "outlined", "standard", "disabled", "icon", "iconOpen", "iconFilled", "iconOutlined", "iconStandard", "nativeInput", "error"]), iw = XZ, KZ = ["className", "disabled", "error", "IconComponent", "inputRef", "variant"], JZ = (e) => {
  const {
    classes: t,
    variant: n,
    disabled: r,
    multiple: o,
    open: i,
    error: a
  } = e, s = {
    select: ["select", n, r && "disabled", o && "multiple", a && "error"],
    icon: ["icon", `icon${at(n)}`, i && "iconOpen", r && "disabled"]
  };
  return Yt(s, ZZ, t);
}, dA = ({
  ownerState: e,
  theme: t
}) => re({
  MozAppearance: "none",
  // Reset
  WebkitAppearance: "none",
  // Reset
  // When interacting quickly, the text can end up selected.
  // Native select can't be selected either.
  userSelect: "none",
  borderRadius: 0,
  // Reset
  cursor: "pointer",
  "&:focus": re({}, t.vars ? {
    backgroundColor: `rgba(${t.vars.palette.common.onBackgroundChannel} / 0.05)`
  } : {
    backgroundColor: t.palette.mode === "light" ? "rgba(0, 0, 0, 0.05)" : "rgba(255, 255, 255, 0.05)"
  }, {
    borderRadius: 0
    // Reset Chrome style
  }),
  // Remove IE11 arrow
  "&::-ms-expand": {
    display: "none"
  },
  [`&.${iw.disabled}`]: {
    cursor: "default"
  },
  "&[multiple]": {
    height: "auto"
  },
  "&:not([multiple]) option, &:not([multiple]) optgroup": {
    backgroundColor: (t.vars || t).palette.background.paper
  },
  // Bump specificity to allow extending custom inputs
  "&&&": {
    paddingRight: 24,
    minWidth: 16
    // So it doesn't collapse.
  }
}, e.variant === "filled" && {
  "&&&": {
    paddingRight: 32
  }
}, e.variant === "outlined" && {
  borderRadius: (t.vars || t).shape.borderRadius,
  "&:focus": {
    borderRadius: (t.vars || t).shape.borderRadius
    // Reset the reset for Chrome style
  },
  "&&&": {
    paddingRight: 32
  }
}), QZ = Fe("select", {
  name: "MuiNativeSelect",
  slot: "Select",
  shouldForwardProp: Xo,
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.select, t[n.variant], n.error && t.error, {
      [`&.${iw.multiple}`]: t.multiple
    }];
  }
})(dA), fA = ({
  ownerState: e,
  theme: t
}) => re({
  // We use a position absolute over a flexbox in order to forward the pointer events
  // to the input and to support wrapping tags..
  position: "absolute",
  right: 0,
  top: "calc(50% - .5em)",
  // Center vertically, height is 1em
  pointerEvents: "none",
  // Don't block pointer events on the select under the icon.
  color: (t.vars || t).palette.action.active,
  [`&.${iw.disabled}`]: {
    color: (t.vars || t).palette.action.disabled
  }
}, e.open && {
  transform: "rotate(180deg)"
}, e.variant === "filled" && {
  right: 7
}, e.variant === "outlined" && {
  right: 7
}), eX = Fe("svg", {
  name: "MuiNativeSelect",
  slot: "Icon",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.icon, n.variant && t[`icon${at(n.variant)}`], n.open && t.iconOpen];
  }
})(fA), pA = /* @__PURE__ */ B.forwardRef(function(e, t) {
  const {
    className: n,
    disabled: r,
    error: o,
    IconComponent: i,
    inputRef: a,
    variant: s = "standard"
  } = e, c = He(e, KZ), l = re({}, e, {
    disabled: r,
    variant: s,
    error: o
  }), d = JZ(l);
  return /* @__PURE__ */ _e(B.Fragment, {
    children: [/* @__PURE__ */ z(QZ, re({
      ownerState: l,
      className: Qe(d.select, n),
      disabled: r,
      ref: a || t
    }, c)), e.multiple ? null : /* @__PURE__ */ z(eX, {
      as: i,
      ownerState: l,
      className: d.icon
    })]
  });
});
process.env.NODE_ENV !== "production" && (pA.propTypes = {
  /**
   * The option elements to populate the select with.
   * Can be some `<option>` elements.
   */
  children: y.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: y.object,
  /**
   * The CSS class name of the select element.
   */
  className: y.string,
  /**
   * If `true`, the select is disabled.
   */
  disabled: y.bool,
  /**
   * If `true`, the `select input` will indicate an error.
   */
  error: y.bool,
  /**
   * The icon that displays the arrow.
   */
  IconComponent: y.elementType.isRequired,
  /**
   * Use that prop to pass a ref to the native select element.
   * @deprecated
   */
  inputRef: Yo,
  /**
   * @ignore
   */
  multiple: y.bool,
  /**
   * Name attribute of the `select` or hidden `input` element.
   */
  name: y.string,
  /**
   * Callback fired when a menu item is selected.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: y.func,
  /**
   * The input value.
   */
  value: y.any,
  /**
   * The variant to use.
   */
  variant: y.oneOf(["standard", "outlined", "filled"])
});
const tX = pA;
function nX(e) {
  return Gt("MuiSelect", e);
}
const rX = Wt("MuiSelect", ["root", "select", "multiple", "filled", "outlined", "standard", "disabled", "focused", "icon", "iconOpen", "iconFilled", "iconOutlined", "iconStandard", "nativeInput", "error"]), Pu = rX;
var ET;
const oX = ["aria-describedby", "aria-label", "autoFocus", "autoWidth", "children", "className", "defaultOpen", "defaultValue", "disabled", "displayEmpty", "error", "IconComponent", "inputRef", "labelId", "MenuProps", "multiple", "name", "onBlur", "onChange", "onClose", "onFocus", "onOpen", "open", "readOnly", "renderValue", "SelectDisplayProps", "tabIndex", "type", "value", "variant"], iX = Fe("div", {
  name: "MuiSelect",
  slot: "Select",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [
      // Win specificity over the input base
      {
        [`&.${Pu.select}`]: t.select
      },
      {
        [`&.${Pu.select}`]: t[n.variant]
      },
      {
        [`&.${Pu.error}`]: t.error
      },
      {
        [`&.${Pu.multiple}`]: t.multiple
      }
    ];
  }
})(dA, {
  // Win specificity over the input base
  [`&.${Pu.select}`]: {
    height: "auto",
    // Resets for multiple select with chips
    minHeight: "1.4375em",
    // Required for select\text-field height consistency
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    overflow: "hidden"
  }
}), aX = Fe("svg", {
  name: "MuiSelect",
  slot: "Icon",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.icon, n.variant && t[`icon${at(n.variant)}`], n.open && t.iconOpen];
  }
})(fA), sX = Fe("input", {
  shouldForwardProp: (e) => yN(e) && e !== "classes",
  name: "MuiSelect",
  slot: "NativeInput",
  overridesResolver: (e, t) => t.nativeInput
})({
  bottom: 0,
  left: 0,
  position: "absolute",
  opacity: 0,
  pointerEvents: "none",
  width: "100%",
  boxSizing: "border-box"
});
function kT(e, t) {
  return typeof t == "object" && t !== null ? e === t : String(e) === String(t);
}
function lX(e) {
  return e == null || typeof e == "string" && !e.trim();
}
const cX = (e) => {
  const {
    classes: t,
    variant: n,
    disabled: r,
    multiple: o,
    open: i,
    error: a
  } = e, s = {
    select: ["select", n, r && "disabled", o && "multiple", a && "error"],
    icon: ["icon", `icon${at(n)}`, i && "iconOpen", r && "disabled"],
    nativeInput: ["nativeInput"]
  };
  return Yt(s, nX, t);
}, hA = /* @__PURE__ */ B.forwardRef(function(e, t) {
  var n;
  const {
    "aria-describedby": r,
    "aria-label": o,
    autoFocus: i,
    autoWidth: a,
    children: s,
    className: c,
    defaultOpen: l,
    defaultValue: d,
    disabled: f,
    displayEmpty: p,
    error: m = !1,
    IconComponent: v,
    inputRef: g,
    labelId: b,
    MenuProps: x = {},
    multiple: T,
    name: S,
    onBlur: _,
    onChange: w,
    onClose: k,
    onFocus: E,
    onOpen: R,
    open: P,
    readOnly: A,
    renderValue: D,
    SelectDisplayProps: N = {},
    tabIndex: F,
    value: $,
    variant: I = "standard"
  } = e, j = He(e, oX), [U, G] = Dd({
    controlled: $,
    default: d,
    name: "Select"
  }), [V, H] = Dd({
    controlled: P,
    default: l,
    name: "Select"
  }), q = B.useRef(null), Q = B.useRef(null), [X, K] = B.useState(null), {
    current: J
  } = B.useRef(P != null), [ne, ae] = B.useState(), te = or(t, g), le = B.useCallback((Ne) => {
    Q.current = Ne, Ne && K(Ne);
  }, []), ce = X == null ? void 0 : X.parentNode;
  B.useImperativeHandle(te, () => ({
    focus: () => {
      Q.current.focus();
    },
    node: q.current,
    value: U
  }), [U]), B.useEffect(() => {
    l && V && X && !J && (ae(a ? null : ce.clientWidth), Q.current.focus());
  }, [X, a]), B.useEffect(() => {
    i && Q.current.focus();
  }, [i]), B.useEffect(() => {
    if (!b)
      return;
    const Ne = Ar(Q.current).getElementById(b);
    if (Ne) {
      const Ve = () => {
        getSelection().isCollapsed && Q.current.focus();
      };
      return Ne.addEventListener("click", Ve), () => {
        Ne.removeEventListener("click", Ve);
      };
    }
  }, [b]);
  const fe = (Ne, Ve) => {
    Ne ? R && R(Ve) : k && k(Ve), J || (ae(a ? null : ce.clientWidth), H(Ne));
  }, ee = (Ne) => {
    Ne.button === 0 && (Ne.preventDefault(), Q.current.focus(), fe(!0, Ne));
  }, me = (Ne) => {
    fe(!1, Ne);
  }, oe = B.Children.toArray(s), ve = (Ne) => {
    const Ve = oe.find((ut) => ut.props.value === Ne.target.value);
    Ve !== void 0 && (G(Ve.props.value), w && w(Ne, Ve));
  }, we = (Ne) => (Ve) => {
    let ut;
    if (Ve.currentTarget.hasAttribute("tabindex")) {
      if (T) {
        ut = Array.isArray(U) ? U.slice() : [];
        const Ut = U.indexOf(Ne.props.value);
        Ut === -1 ? ut.push(Ne.props.value) : ut.splice(Ut, 1);
      } else
        ut = Ne.props.value;
      if (Ne.props.onClick && Ne.props.onClick(Ve), U !== ut && (G(ut), w)) {
        const Ut = Ve.nativeEvent || Ve, St = new Ut.constructor(Ut.type, Ut);
        Object.defineProperty(St, "target", {
          writable: !0,
          value: {
            value: ut,
            name: S
          }
        }), w(St, Ne);
      }
      T || fe(!1, Ve);
    }
  }, ye = (Ne) => {
    A || [
      " ",
      "ArrowUp",
      "ArrowDown",
      // The native select doesn't respond to enter on macOS, but it's recommended by
      // https://www.w3.org/WAI/ARIA/apg/patterns/combobox/examples/combobox-select-only/
      "Enter"
    ].indexOf(Ne.key) !== -1 && (Ne.preventDefault(), fe(!0, Ne));
  }, Ce = X !== null && V, Se = (Ne) => {
    !Ce && _ && (Object.defineProperty(Ne, "target", {
      writable: !0,
      value: {
        value: U,
        name: S
      }
    }), _(Ne));
  };
  delete j["aria-invalid"];
  let Te, Ae;
  const je = [];
  let Me = !1, ze = !1;
  (UN({
    value: U
  }) || p) && (D ? Te = D(U) : Me = !0);
  const ft = oe.map((Ne) => {
    if (!/* @__PURE__ */ B.isValidElement(Ne))
      return null;
    process.env.NODE_ENV !== "production" && la.isFragment(Ne) && console.error(["MUI: The Select component doesn't accept a Fragment as a child.", "Consider providing an array instead."].join(`
`));
    let Ve;
    if (T) {
      if (!Array.isArray(U))
        throw new Error(process.env.NODE_ENV !== "production" ? "MUI: The `value` prop must be an array when using the `Select` component with `multiple`." : Gs(2));
      Ve = U.some((ut) => kT(ut, Ne.props.value)), Ve && Me && je.push(Ne.props.children);
    } else
      Ve = kT(U, Ne.props.value), Ve && Me && (Ae = Ne.props.children);
    return Ve && (ze = !0), /* @__PURE__ */ B.cloneElement(Ne, {
      "aria-selected": Ve ? "true" : "false",
      onClick: we(Ne),
      onKeyUp: (ut) => {
        ut.key === " " && ut.preventDefault(), Ne.props.onKeyUp && Ne.props.onKeyUp(ut);
      },
      role: "option",
      selected: Ve,
      value: void 0,
      // The value is most likely not a valid HTML attribute.
      "data-value": Ne.props.value
      // Instead, we provide it as a data attribute.
    });
  });
  process.env.NODE_ENV !== "production" && B.useEffect(() => {
    if (!ze && !T && U !== "") {
      const Ne = oe.map((Ve) => Ve.props.value);
      console.warn([`MUI: You have provided an out-of-range value \`${U}\` for the select ${S ? `(name="${S}") ` : ""}component.`, "Consider providing a value that matches one of the available options or ''.", `The available values are ${Ne.filter((Ve) => Ve != null).map((Ve) => `\`${Ve}\``).join(", ") || '""'}.`].join(`
`));
    }
  }, [ze, oe, T, S, U]), Me && (T ? je.length === 0 ? Te = null : Te = je.reduce((Ne, Ve, ut) => (Ne.push(Ve), ut < je.length - 1 && Ne.push(", "), Ne), []) : Te = Ae);
  let Ue = ne;
  !a && J && X && (Ue = ce.clientWidth);
  let Be;
  typeof F != "undefined" ? Be = F : Be = f ? null : 0;
  const Pe = N.id || (S ? `mui-component-select-${S}` : void 0), Ee = re({}, e, {
    variant: I,
    value: U,
    open: Ce,
    error: m
  }), st = cX(Ee), Vt = re({}, x.PaperProps, (n = x.slotProps) == null ? void 0 : n.paper), Ct = Ch();
  return /* @__PURE__ */ _e(B.Fragment, {
    children: [/* @__PURE__ */ z(iX, re({
      ref: le,
      tabIndex: Be,
      role: "combobox",
      "aria-controls": Ct,
      "aria-disabled": f ? "true" : void 0,
      "aria-expanded": Ce ? "true" : "false",
      "aria-haspopup": "listbox",
      "aria-label": o,
      "aria-labelledby": [b, Pe].filter(Boolean).join(" ") || void 0,
      "aria-describedby": r,
      onKeyDown: ye,
      onMouseDown: f || A ? null : ee,
      onBlur: Se,
      onFocus: E
    }, N, {
      ownerState: Ee,
      className: Qe(N.className, st.select, c),
      id: Pe,
      children: lX(Te) ? (
        // notranslate needed while Google Translate will not fix zero-width space issue
        ET || (ET = /* @__PURE__ */ z("span", {
          className: "notranslate",
          children: "​"
        }))
      ) : Te
    })), /* @__PURE__ */ z(sX, re({
      "aria-invalid": m,
      value: Array.isArray(U) ? U.join(",") : U,
      name: S,
      ref: q,
      "aria-hidden": !0,
      onChange: ve,
      tabIndex: -1,
      disabled: f,
      className: st.nativeInput,
      autoFocus: i,
      ownerState: Ee
    }, j)), /* @__PURE__ */ z(aX, {
      as: v,
      className: st.icon,
      ownerState: Ee
    }), /* @__PURE__ */ z(YZ, re({
      id: `menu-${S || ""}`,
      anchorEl: ce,
      open: Ce,
      onClose: me,
      anchorOrigin: {
        vertical: "bottom",
        horizontal: "center"
      },
      transformOrigin: {
        vertical: "top",
        horizontal: "center"
      }
    }, x, {
      MenuListProps: re({
        "aria-labelledby": b,
        role: "listbox",
        "aria-multiselectable": T ? "true" : void 0,
        disableListWrap: !0,
        id: Ct
      }, x.MenuListProps),
      slotProps: re({}, x.slotProps, {
        paper: re({}, Vt, {
          style: re({
            minWidth: Ue
          }, Vt != null ? Vt.style : null)
        })
      }),
      children: ft
    }))]
  });
});
process.env.NODE_ENV !== "production" && (hA.propTypes = {
  /**
   * @ignore
   */
  "aria-describedby": y.string,
  /**
   * @ignore
   */
  "aria-label": y.string,
  /**
   * @ignore
   */
  autoFocus: y.bool,
  /**
   * If `true`, the width of the popover will automatically be set according to the items inside the
   * menu, otherwise it will be at least the width of the select input.
   */
  autoWidth: y.bool,
  /**
   * The option elements to populate the select with.
   * Can be some `<MenuItem>` elements.
   */
  children: y.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: y.object,
  /**
   * The CSS class name of the select element.
   */
  className: y.string,
  /**
   * If `true`, the component is toggled on mount. Use when the component open state is not controlled.
   * You can only use it when the `native` prop is `false` (default).
   */
  defaultOpen: y.bool,
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: y.any,
  /**
   * If `true`, the select is disabled.
   */
  disabled: y.bool,
  /**
   * If `true`, the selected item is displayed even if its value is empty.
   */
  displayEmpty: y.bool,
  /**
   * If `true`, the `select input` will indicate an error.
   */
  error: y.bool,
  /**
   * The icon that displays the arrow.
   */
  IconComponent: y.elementType.isRequired,
  /**
   * Imperative handle implementing `{ value: T, node: HTMLElement, focus(): void }`
   * Equivalent to `ref`
   */
  inputRef: Yo,
  /**
   * The ID of an element that acts as an additional label. The Select will
   * be labelled by the additional label and the selected value.
   */
  labelId: y.string,
  /**
   * Props applied to the [`Menu`](/material-ui/api/menu/) element.
   */
  MenuProps: y.object,
  /**
   * If `true`, `value` must be an array and the menu will support multiple selections.
   */
  multiple: y.bool,
  /**
   * Name attribute of the `select` or hidden `input` element.
   */
  name: y.string,
  /**
   * @ignore
   */
  onBlur: y.func,
  /**
   * Callback fired when a menu item is selected.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (any).
   * @param {object} [child] The react element that was selected.
   */
  onChange: y.func,
  /**
   * Callback fired when the component requests to be closed.
   * Use in controlled mode (see open).
   *
   * @param {object} event The event source of the callback.
   */
  onClose: y.func,
  /**
   * @ignore
   */
  onFocus: y.func,
  /**
   * Callback fired when the component requests to be opened.
   * Use in controlled mode (see open).
   *
   * @param {object} event The event source of the callback.
   */
  onOpen: y.func,
  /**
   * If `true`, the component is shown.
   */
  open: y.bool,
  /**
   * @ignore
   */
  readOnly: y.bool,
  /**
   * Render the selected value.
   *
   * @param {any} value The `value` provided to the component.
   * @returns {ReactNode}
   */
  renderValue: y.func,
  /**
   * Props applied to the clickable div element.
   */
  SelectDisplayProps: y.object,
  /**
   * @ignore
   */
  tabIndex: y.oneOfType([y.number, y.string]),
  /**
   * @ignore
   */
  type: y.any,
  /**
   * The input value.
   */
  value: y.any,
  /**
   * The variant to use.
   */
  variant: y.oneOf(["standard", "outlined", "filled"])
});
const uX = hA;
function dX(e) {
  return Gt("MuiSvgIcon", e);
}
Wt("MuiSvgIcon", ["root", "colorPrimary", "colorSecondary", "colorAction", "colorError", "colorDisabled", "fontSizeInherit", "fontSizeSmall", "fontSizeMedium", "fontSizeLarge"]);
const fX = ["children", "className", "color", "component", "fontSize", "htmlColor", "inheritViewBox", "titleAccess", "viewBox"], pX = (e) => {
  const {
    color: t,
    fontSize: n,
    classes: r
  } = e, o = {
    root: ["root", t !== "inherit" && `color${at(t)}`, `fontSize${at(n)}`]
  };
  return Yt(o, dX, r);
}, hX = Fe("svg", {
  name: "MuiSvgIcon",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.color !== "inherit" && t[`color${at(n.color)}`], t[`fontSize${at(n.fontSize)}`]];
  }
})(({
  theme: e,
  ownerState: t
}) => {
  var n, r, o, i, a, s, c, l, d, f, p, m, v;
  return {
    userSelect: "none",
    width: "1em",
    height: "1em",
    display: "inline-block",
    // the <svg> will define the property that has `currentColor`
    // for example heroicons uses fill="none" and stroke="currentColor"
    fill: t.hasSvgAsChild ? void 0 : "currentColor",
    flexShrink: 0,
    transition: (n = e.transitions) == null || (r = n.create) == null ? void 0 : r.call(n, "fill", {
      duration: (o = e.transitions) == null || (o = o.duration) == null ? void 0 : o.shorter
    }),
    fontSize: {
      inherit: "inherit",
      small: ((i = e.typography) == null || (a = i.pxToRem) == null ? void 0 : a.call(i, 20)) || "1.25rem",
      medium: ((s = e.typography) == null || (c = s.pxToRem) == null ? void 0 : c.call(s, 24)) || "1.5rem",
      large: ((l = e.typography) == null || (d = l.pxToRem) == null ? void 0 : d.call(l, 35)) || "2.1875rem"
    }[t.fontSize],
    // TODO v5 deprecate, v6 remove for sx
    color: (f = (p = (e.vars || e).palette) == null || (p = p[t.color]) == null ? void 0 : p.main) != null ? f : {
      action: (m = (e.vars || e).palette) == null || (m = m.action) == null ? void 0 : m.active,
      disabled: (v = (e.vars || e).palette) == null || (v = v.action) == null ? void 0 : v.disabled,
      inherit: void 0
    }[t.color]
  };
}), aw = /* @__PURE__ */ B.forwardRef(function(e, t) {
  const n = rn({
    props: e,
    name: "MuiSvgIcon"
  }), {
    children: r,
    className: o,
    color: i = "inherit",
    component: a = "svg",
    fontSize: s = "medium",
    htmlColor: c,
    inheritViewBox: l = !1,
    titleAccess: d,
    viewBox: f = "0 0 24 24"
  } = n, p = He(n, fX), m = /* @__PURE__ */ B.isValidElement(r) && r.type === "svg", v = re({}, n, {
    color: i,
    component: a,
    fontSize: s,
    instanceFontSize: e.fontSize,
    inheritViewBox: l,
    viewBox: f,
    hasSvgAsChild: m
  }), g = {};
  l || (g.viewBox = f);
  const b = pX(v);
  return /* @__PURE__ */ _e(hX, re({
    as: a,
    className: Qe(b.root, o),
    focusable: "false",
    color: c,
    "aria-hidden": d ? void 0 : !0,
    role: d ? "img" : void 0,
    ref: t
  }, g, p, m && r.props, {
    ownerState: v,
    children: [m ? r.props.children : r, d ? /* @__PURE__ */ z("title", {
      children: d
    }) : null]
  }));
});
process.env.NODE_ENV !== "production" && (aw.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Node passed into the SVG element.
   */
  children: y.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: y.object,
  /**
   * @ignore
   */
  className: y.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * You can use the `htmlColor` prop to apply a color attribute to the SVG element.
   * @default 'inherit'
   */
  color: y.oneOfType([y.oneOf(["inherit", "action", "disabled", "primary", "secondary", "error", "info", "success", "warning"]), y.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: y.elementType,
  /**
   * The fontSize applied to the icon. Defaults to 24px, but can be configure to inherit font size.
   * @default 'medium'
   */
  fontSize: y.oneOfType([y.oneOf(["inherit", "large", "medium", "small"]), y.string]),
  /**
   * Applies a color attribute to the SVG element.
   */
  htmlColor: y.string,
  /**
   * If `true`, the root node will inherit the custom `component`'s viewBox and the `viewBox`
   * prop will be ignored.
   * Useful when you want to reference a custom `component` and have `SvgIcon` pass that
   * `component`'s viewBox to the root node.
   * @default false
   */
  inheritViewBox: y.bool,
  /**
   * The shape-rendering attribute. The behavior of the different options is described on the
   * [MDN Web Docs](https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/shape-rendering).
   * If you are having issues with blurry icons you should investigate this prop.
   */
  shapeRendering: y.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: y.oneOfType([y.arrayOf(y.oneOfType([y.func, y.object, y.bool])), y.func, y.object]),
  /**
   * Provides a human-readable title for the element that contains it.
   * https://www.w3.org/TR/SVG-access/#Equivalent
   */
  titleAccess: y.string,
  /**
   * Allows you to redefine what the coordinates without units mean inside an SVG element.
   * For example, if the SVG element is 500 (width) by 200 (height),
   * and you pass viewBox="0 0 50 20",
   * this means that the coordinates inside the SVG will go from the top left corner (0,0)
   * to bottom right (50,20) and each unit will be worth 10px.
   * @default '0 0 24 24'
   */
  viewBox: y.string
});
aw.muiName = "SvgIcon";
const py = aw;
function Vi(e, t) {
  function n(r, o) {
    return /* @__PURE__ */ z(py, re({
      "data-testid": `${t}Icon`,
      ref: o
    }, r, {
      children: e
    }));
  }
  return process.env.NODE_ENV !== "production" && (n.displayName = `${t}Icon`), n.muiName = py.muiName, /* @__PURE__ */ B.memo(/* @__PURE__ */ B.forwardRef(n));
}
const mX = Vi(/* @__PURE__ */ z("path", {
  d: "M7 10l5 5 5-5z"
}), "ArrowDropDown");
function gX(e) {
  return Gt("MuiInput", e);
}
const vX = re({}, Tc, Wt("MuiInput", ["root", "underline", "input"])), Ou = vX, bX = ["disableUnderline", "components", "componentsProps", "fullWidth", "inputComponent", "multiline", "slotProps", "slots", "type"], yX = (e) => {
  const {
    classes: t,
    disableUnderline: n
  } = e, r = Yt({
    root: ["root", !n && "underline"],
    input: ["input"]
  }, gX, t);
  return re({}, t, r);
}, _X = Fe(ng, {
  shouldForwardProp: (e) => Xo(e) || e === "classes",
  name: "MuiInput",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [...eg(e, t), !n.disableUnderline && t.underline];
  }
})(({
  theme: e,
  ownerState: t
}) => {
  let n = e.palette.mode === "light" ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)";
  return e.vars && (n = `rgba(${e.vars.palette.common.onBackgroundChannel} / ${e.vars.opacity.inputUnderline})`), re({
    position: "relative"
  }, t.formControl && {
    "label + &": {
      marginTop: 16
    }
  }, !t.disableUnderline && {
    "&::after": {
      borderBottom: `2px solid ${(e.vars || e).palette[t.color].main}`,
      left: 0,
      bottom: 0,
      // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
      content: '""',
      position: "absolute",
      right: 0,
      transform: "scaleX(0)",
      transition: e.transitions.create("transform", {
        duration: e.transitions.duration.shorter,
        easing: e.transitions.easing.easeOut
      }),
      pointerEvents: "none"
      // Transparent to the hover style.
    },
    [`&.${Ou.focused}:after`]: {
      // translateX(0) is a workaround for Safari transform scale bug
      // See https://github.com/mui/material-ui/issues/31766
      transform: "scaleX(1) translateX(0)"
    },
    [`&.${Ou.error}`]: {
      "&::before, &::after": {
        borderBottomColor: (e.vars || e).palette.error.main
      }
    },
    "&::before": {
      borderBottom: `1px solid ${n}`,
      left: 0,
      bottom: 0,
      // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
      content: '"\\00a0"',
      position: "absolute",
      right: 0,
      transition: e.transitions.create("border-bottom-color", {
        duration: e.transitions.duration.shorter
      }),
      pointerEvents: "none"
      // Transparent to the hover style.
    },
    [`&:hover:not(.${Ou.disabled}, .${Ou.error}):before`]: {
      borderBottom: `2px solid ${(e.vars || e).palette.text.primary}`,
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        borderBottom: `1px solid ${n}`
      }
    },
    [`&.${Ou.disabled}:before`]: {
      borderBottomStyle: "dotted"
    }
  });
}), wX = Fe(rg, {
  name: "MuiInput",
  slot: "Input",
  overridesResolver: tg
})({}), sw = /* @__PURE__ */ B.forwardRef(function(e, t) {
  var n, r, o, i;
  const a = rn({
    props: e,
    name: "MuiInput"
  }), {
    disableUnderline: s,
    components: c = {},
    componentsProps: l,
    fullWidth: d = !1,
    inputComponent: f = "input",
    multiline: p = !1,
    slotProps: m,
    slots: v = {},
    type: g = "text"
  } = a, b = He(a, bX), x = yX(a), T = {
    root: {
      ownerState: {
        disableUnderline: s
      }
    }
  }, S = (m != null ? m : l) ? co(m != null ? m : l, T) : T, _ = (n = (r = v.root) != null ? r : c.Root) != null ? n : _X, w = (o = (i = v.input) != null ? i : c.Input) != null ? o : wX;
  return /* @__PURE__ */ z(og, re({
    slots: {
      root: _,
      input: w
    },
    slotProps: S,
    fullWidth: d,
    inputComponent: f,
    multiline: p,
    ref: t,
    type: g
  }, b, {
    classes: x
  }));
});
process.env.NODE_ENV !== "production" && (sw.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: y.string,
  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: y.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: y.object,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * The prop defaults to the value (`'primary'`) inherited from the parent FormControl component.
   */
  color: y.oneOfType([y.oneOf(["primary", "secondary"]), y.string]),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */
  components: y.shape({
    Input: y.elementType,
    Root: y.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `slotProps` prop.
   * It's recommended to use the `slotProps` prop instead, as `componentsProps` will be deprecated in the future.
   *
   * @default {}
   */
  componentsProps: y.shape({
    input: y.object,
    root: y.object
  }),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: y.any,
  /**
   * If `true`, the component is disabled.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  disabled: y.bool,
  /**
   * If `true`, the `input` will not have an underline.
   */
  disableUnderline: y.bool,
  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: y.node,
  /**
   * If `true`, the `input` will indicate an error.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  error: y.bool,
  /**
   * If `true`, the `input` will take up the full width of its container.
   * @default false
   */
  fullWidth: y.bool,
  /**
   * The id of the `input` element.
   */
  id: y.string,
  /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   * @default 'input'
   */
  inputComponent: y.elementType,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * @default {}
   */
  inputProps: y.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: Yo,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   * The prop defaults to the value (`'none'`) inherited from the parent FormControl component.
   */
  margin: y.oneOf(["dense", "none"]),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: y.oneOfType([y.number, y.string]),
  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: y.oneOfType([y.number, y.string]),
  /**
   * If `true`, a [TextareaAutosize](/material-ui/react-textarea-autosize/) element is rendered.
   * @default false
   */
  multiline: y.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: y.string,
  /**
   * Callback fired when the value is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: y.func,
  /**
   * The short hint displayed in the `input` before the user enters a value.
   */
  placeholder: y.string,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: y.bool,
  /**
   * If `true`, the `input` element is required.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  required: y.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: y.oneOfType([y.number, y.string]),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slotProps: y.shape({
    input: y.object,
    root: y.object
  }),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: y.shape({
    input: y.elementType,
    root: y.elementType
  }),
  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: y.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: y.oneOfType([y.arrayOf(y.oneOfType([y.func, y.object, y.bool])), y.func, y.object]),
  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   * @default 'text'
   */
  type: y.string,
  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: y.any
});
sw.muiName = "Input";
const xX = sw;
function CX(e) {
  return Gt("MuiFilledInput", e);
}
const SX = re({}, Tc, Wt("MuiFilledInput", ["root", "underline", "input"])), Ps = SX, TX = ["disableUnderline", "components", "componentsProps", "fullWidth", "hiddenLabel", "inputComponent", "multiline", "slotProps", "slots", "type"], EX = (e) => {
  const {
    classes: t,
    disableUnderline: n
  } = e, r = Yt({
    root: ["root", !n && "underline"],
    input: ["input"]
  }, CX, t);
  return re({}, t, r);
}, kX = Fe(ng, {
  shouldForwardProp: (e) => Xo(e) || e === "classes",
  name: "MuiFilledInput",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [...eg(e, t), !n.disableUnderline && t.underline];
  }
})(({
  theme: e,
  ownerState: t
}) => {
  var n;
  const r = e.palette.mode === "light", o = r ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)", i = r ? "rgba(0, 0, 0, 0.06)" : "rgba(255, 255, 255, 0.09)", a = r ? "rgba(0, 0, 0, 0.09)" : "rgba(255, 255, 255, 0.13)", s = r ? "rgba(0, 0, 0, 0.12)" : "rgba(255, 255, 255, 0.12)";
  return re({
    position: "relative",
    backgroundColor: e.vars ? e.vars.palette.FilledInput.bg : i,
    borderTopLeftRadius: (e.vars || e).shape.borderRadius,
    borderTopRightRadius: (e.vars || e).shape.borderRadius,
    transition: e.transitions.create("background-color", {
      duration: e.transitions.duration.shorter,
      easing: e.transitions.easing.easeOut
    }),
    "&:hover": {
      backgroundColor: e.vars ? e.vars.palette.FilledInput.hoverBg : a,
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: e.vars ? e.vars.palette.FilledInput.bg : i
      }
    },
    [`&.${Ps.focused}`]: {
      backgroundColor: e.vars ? e.vars.palette.FilledInput.bg : i
    },
    [`&.${Ps.disabled}`]: {
      backgroundColor: e.vars ? e.vars.palette.FilledInput.disabledBg : s
    }
  }, !t.disableUnderline && {
    "&::after": {
      borderBottom: `2px solid ${(n = (e.vars || e).palette[t.color || "primary"]) == null ? void 0 : n.main}`,
      left: 0,
      bottom: 0,
      // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
      content: '""',
      position: "absolute",
      right: 0,
      transform: "scaleX(0)",
      transition: e.transitions.create("transform", {
        duration: e.transitions.duration.shorter,
        easing: e.transitions.easing.easeOut
      }),
      pointerEvents: "none"
      // Transparent to the hover style.
    },
    [`&.${Ps.focused}:after`]: {
      // translateX(0) is a workaround for Safari transform scale bug
      // See https://github.com/mui/material-ui/issues/31766
      transform: "scaleX(1) translateX(0)"
    },
    [`&.${Ps.error}`]: {
      "&::before, &::after": {
        borderBottomColor: (e.vars || e).palette.error.main
      }
    },
    "&::before": {
      borderBottom: `1px solid ${e.vars ? `rgba(${e.vars.palette.common.onBackgroundChannel} / ${e.vars.opacity.inputUnderline})` : o}`,
      left: 0,
      bottom: 0,
      // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
      content: '"\\00a0"',
      position: "absolute",
      right: 0,
      transition: e.transitions.create("border-bottom-color", {
        duration: e.transitions.duration.shorter
      }),
      pointerEvents: "none"
      // Transparent to the hover style.
    },
    [`&:hover:not(.${Ps.disabled}, .${Ps.error}):before`]: {
      borderBottom: `1px solid ${(e.vars || e).palette.text.primary}`
    },
    [`&.${Ps.disabled}:before`]: {
      borderBottomStyle: "dotted"
    }
  }, t.startAdornment && {
    paddingLeft: 12
  }, t.endAdornment && {
    paddingRight: 12
  }, t.multiline && re({
    padding: "25px 12px 8px"
  }, t.size === "small" && {
    paddingTop: 21,
    paddingBottom: 4
  }, t.hiddenLabel && {
    paddingTop: 16,
    paddingBottom: 17
  }, t.hiddenLabel && t.size === "small" && {
    paddingTop: 8,
    paddingBottom: 9
  }));
}), MX = Fe(rg, {
  name: "MuiFilledInput",
  slot: "Input",
  overridesResolver: tg
})(({
  theme: e,
  ownerState: t
}) => re({
  paddingTop: 25,
  paddingRight: 12,
  paddingBottom: 8,
  paddingLeft: 12
}, !e.vars && {
  "&:-webkit-autofill": {
    WebkitBoxShadow: e.palette.mode === "light" ? null : "0 0 0 100px #266798 inset",
    WebkitTextFillColor: e.palette.mode === "light" ? null : "#fff",
    caretColor: e.palette.mode === "light" ? null : "#fff",
    borderTopLeftRadius: "inherit",
    borderTopRightRadius: "inherit"
  }
}, e.vars && {
  "&:-webkit-autofill": {
    borderTopLeftRadius: "inherit",
    borderTopRightRadius: "inherit"
  },
  [e.getColorSchemeSelector("dark")]: {
    "&:-webkit-autofill": {
      WebkitBoxShadow: "0 0 0 100px #266798 inset",
      WebkitTextFillColor: "#fff",
      caretColor: "#fff"
    }
  }
}, t.size === "small" && {
  paddingTop: 21,
  paddingBottom: 4
}, t.hiddenLabel && {
  paddingTop: 16,
  paddingBottom: 17
}, t.startAdornment && {
  paddingLeft: 0
}, t.endAdornment && {
  paddingRight: 0
}, t.hiddenLabel && t.size === "small" && {
  paddingTop: 8,
  paddingBottom: 9
}, t.multiline && {
  paddingTop: 0,
  paddingBottom: 0,
  paddingLeft: 0,
  paddingRight: 0
})), lw = /* @__PURE__ */ B.forwardRef(function(e, t) {
  var n, r, o, i;
  const a = rn({
    props: e,
    name: "MuiFilledInput"
  }), {
    components: s = {},
    componentsProps: c,
    fullWidth: l = !1,
    // declare here to prevent spreading to DOM
    inputComponent: d = "input",
    multiline: f = !1,
    slotProps: p,
    slots: m = {},
    type: v = "text"
  } = a, g = He(a, TX), b = re({}, a, {
    fullWidth: l,
    inputComponent: d,
    multiline: f,
    type: v
  }), x = EX(a), T = {
    root: {
      ownerState: b
    },
    input: {
      ownerState: b
    }
  }, S = (p != null ? p : c) ? co(T, p != null ? p : c) : T, _ = (n = (r = m.root) != null ? r : s.Root) != null ? n : kX, w = (o = (i = m.input) != null ? i : s.Input) != null ? o : MX;
  return /* @__PURE__ */ z(og, re({
    slots: {
      root: _,
      input: w
    },
    componentsProps: S,
    fullWidth: l,
    inputComponent: d,
    multiline: f,
    ref: t,
    type: v
  }, g, {
    classes: x
  }));
});
process.env.NODE_ENV !== "production" && (lw.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: y.string,
  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: y.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: y.object,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * The prop defaults to the value (`'primary'`) inherited from the parent FormControl component.
   */
  color: y.oneOfType([y.oneOf(["primary", "secondary"]), y.string]),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */
  components: y.shape({
    Input: y.elementType,
    Root: y.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `slotProps` prop.
   * It's recommended to use the `slotProps` prop instead, as `componentsProps` will be deprecated in the future.
   *
   * @default {}
   */
  componentsProps: y.shape({
    input: y.object,
    root: y.object
  }),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: y.any,
  /**
   * If `true`, the component is disabled.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  disabled: y.bool,
  /**
   * If `true`, the input will not have an underline.
   */
  disableUnderline: y.bool,
  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: y.node,
  /**
   * If `true`, the `input` will indicate an error.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  error: y.bool,
  /**
   * If `true`, the `input` will take up the full width of its container.
   * @default false
   */
  fullWidth: y.bool,
  /**
   * If `true`, the label is hidden.
   * This is used to increase density for a `FilledInput`.
   * Be sure to add `aria-label` to the `input` element.
   * @default false
   */
  hiddenLabel: y.bool,
  /**
   * The id of the `input` element.
   */
  id: y.string,
  /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   * @default 'input'
   */
  inputComponent: y.elementType,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * @default {}
   */
  inputProps: y.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: Yo,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   * The prop defaults to the value (`'none'`) inherited from the parent FormControl component.
   */
  margin: y.oneOf(["dense", "none"]),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: y.oneOfType([y.number, y.string]),
  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: y.oneOfType([y.number, y.string]),
  /**
   * If `true`, a [TextareaAutosize](/material-ui/react-textarea-autosize/) element is rendered.
   * @default false
   */
  multiline: y.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: y.string,
  /**
   * Callback fired when the value is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: y.func,
  /**
   * The short hint displayed in the `input` before the user enters a value.
   */
  placeholder: y.string,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: y.bool,
  /**
   * If `true`, the `input` element is required.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  required: y.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: y.oneOfType([y.number, y.string]),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slotProps: y.shape({
    input: y.object,
    root: y.object
  }),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: y.shape({
    input: y.elementType,
    root: y.elementType
  }),
  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: y.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: y.oneOfType([y.arrayOf(y.oneOfType([y.func, y.object, y.bool])), y.func, y.object]),
  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   * @default 'text'
   */
  type: y.string,
  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: y.any
});
lw.muiName = "Input";
const RX = lw;
var MT;
const PX = ["children", "classes", "className", "label", "notched"], OX = Fe("fieldset", {
  shouldForwardProp: Xo
})({
  textAlign: "left",
  position: "absolute",
  bottom: 0,
  right: 0,
  top: -5,
  left: 0,
  margin: 0,
  padding: "0 8px",
  pointerEvents: "none",
  borderRadius: "inherit",
  borderStyle: "solid",
  borderWidth: 1,
  overflow: "hidden",
  minWidth: "0%"
}), NX = Fe("legend", {
  shouldForwardProp: Xo
})(({
  ownerState: e,
  theme: t
}) => re({
  float: "unset",
  // Fix conflict with bootstrap
  width: "auto",
  // Fix conflict with bootstrap
  overflow: "hidden"
}, !e.withLabel && {
  padding: 0,
  lineHeight: "11px",
  // sync with `height` in `legend` styles
  transition: t.transitions.create("width", {
    duration: 150,
    easing: t.transitions.easing.easeOut
  })
}, e.withLabel && re({
  display: "block",
  // Fix conflict with normalize.css and sanitize.css
  padding: 0,
  height: 11,
  // sync with `lineHeight` in `legend` styles
  fontSize: "0.75em",
  visibility: "hidden",
  maxWidth: 0.01,
  transition: t.transitions.create("max-width", {
    duration: 50,
    easing: t.transitions.easing.easeOut
  }),
  whiteSpace: "nowrap",
  "& > span": {
    paddingLeft: 5,
    paddingRight: 5,
    display: "inline-block",
    opacity: 0,
    visibility: "visible"
  }
}, e.notched && {
  maxWidth: "100%",
  transition: t.transitions.create("max-width", {
    duration: 100,
    easing: t.transitions.easing.easeOut,
    delay: 50
  })
})));
function mA(e) {
  const {
    className: t,
    label: n,
    notched: r
  } = e, o = He(e, PX), i = n != null && n !== "", a = re({}, e, {
    notched: r,
    withLabel: i
  });
  return /* @__PURE__ */ z(OX, re({
    "aria-hidden": !0,
    className: t,
    ownerState: a
  }, o, {
    children: /* @__PURE__ */ z(NX, {
      ownerState: a,
      children: i ? /* @__PURE__ */ z("span", {
        children: n
      }) : (
        // notranslate needed while Google Translate will not fix zero-width space issue
        MT || (MT = /* @__PURE__ */ z("span", {
          className: "notranslate",
          children: "​"
        }))
      )
    })
  }));
}
process.env.NODE_ENV !== "production" && (mA.propTypes = {
  /**
   * The content of the component.
   */
  children: y.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: y.object,
  /**
   * @ignore
   */
  className: y.string,
  /**
   * The label.
   */
  label: y.node,
  /**
   * If `true`, the outline is notched to accommodate the label.
   */
  notched: y.bool.isRequired,
  /**
   * @ignore
   */
  style: y.object
});
function AX(e) {
  return Gt("MuiOutlinedInput", e);
}
const DX = re({}, Tc, Wt("MuiOutlinedInput", ["root", "notchedOutline", "input"])), Na = DX, IX = ["components", "fullWidth", "inputComponent", "label", "multiline", "notched", "slots", "type"], LX = (e) => {
  const {
    classes: t
  } = e, n = Yt({
    root: ["root"],
    notchedOutline: ["notchedOutline"],
    input: ["input"]
  }, AX, t);
  return re({}, t, n);
}, $X = Fe(ng, {
  shouldForwardProp: (e) => Xo(e) || e === "classes",
  name: "MuiOutlinedInput",
  slot: "Root",
  overridesResolver: eg
})(({
  theme: e,
  ownerState: t
}) => {
  const n = e.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)";
  return re({
    position: "relative",
    borderRadius: (e.vars || e).shape.borderRadius,
    [`&:hover .${Na.notchedOutline}`]: {
      borderColor: (e.vars || e).palette.text.primary
    },
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      [`&:hover .${Na.notchedOutline}`]: {
        borderColor: e.vars ? `rgba(${e.vars.palette.common.onBackgroundChannel} / 0.23)` : n
      }
    },
    [`&.${Na.focused} .${Na.notchedOutline}`]: {
      borderColor: (e.vars || e).palette[t.color].main,
      borderWidth: 2
    },
    [`&.${Na.error} .${Na.notchedOutline}`]: {
      borderColor: (e.vars || e).palette.error.main
    },
    [`&.${Na.disabled} .${Na.notchedOutline}`]: {
      borderColor: (e.vars || e).palette.action.disabled
    }
  }, t.startAdornment && {
    paddingLeft: 14
  }, t.endAdornment && {
    paddingRight: 14
  }, t.multiline && re({
    padding: "16.5px 14px"
  }, t.size === "small" && {
    padding: "8.5px 14px"
  }));
}), FX = Fe(mA, {
  name: "MuiOutlinedInput",
  slot: "NotchedOutline",
  overridesResolver: (e, t) => t.notchedOutline
})(({
  theme: e
}) => {
  const t = e.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)";
  return {
    borderColor: e.vars ? `rgba(${e.vars.palette.common.onBackgroundChannel} / 0.23)` : t
  };
}), zX = Fe(rg, {
  name: "MuiOutlinedInput",
  slot: "Input",
  overridesResolver: tg
})(({
  theme: e,
  ownerState: t
}) => re({
  padding: "16.5px 14px"
}, !e.vars && {
  "&:-webkit-autofill": {
    WebkitBoxShadow: e.palette.mode === "light" ? null : "0 0 0 100px #266798 inset",
    WebkitTextFillColor: e.palette.mode === "light" ? null : "#fff",
    caretColor: e.palette.mode === "light" ? null : "#fff",
    borderRadius: "inherit"
  }
}, e.vars && {
  "&:-webkit-autofill": {
    borderRadius: "inherit"
  },
  [e.getColorSchemeSelector("dark")]: {
    "&:-webkit-autofill": {
      WebkitBoxShadow: "0 0 0 100px #266798 inset",
      WebkitTextFillColor: "#fff",
      caretColor: "#fff"
    }
  }
}, t.size === "small" && {
  padding: "8.5px 14px"
}, t.multiline && {
  padding: 0
}, t.startAdornment && {
  paddingLeft: 0
}, t.endAdornment && {
  paddingRight: 0
})), cw = /* @__PURE__ */ B.forwardRef(function(e, t) {
  var n, r, o, i, a;
  const s = rn({
    props: e,
    name: "MuiOutlinedInput"
  }), {
    components: c = {},
    fullWidth: l = !1,
    inputComponent: d = "input",
    label: f,
    multiline: p = !1,
    notched: m,
    slots: v = {},
    type: g = "text"
  } = s, b = He(s, IX), x = LX(s), T = Jm(), S = tw({
    props: s,
    muiFormControl: T,
    states: ["color", "disabled", "error", "focused", "hiddenLabel", "size", "required"]
  }), _ = re({}, s, {
    color: S.color || "primary",
    disabled: S.disabled,
    error: S.error,
    focused: S.focused,
    formControl: T,
    fullWidth: l,
    hiddenLabel: S.hiddenLabel,
    multiline: p,
    size: S.size,
    type: g
  }), w = (n = (r = v.root) != null ? r : c.Root) != null ? n : $X, k = (o = (i = v.input) != null ? i : c.Input) != null ? o : zX;
  return /* @__PURE__ */ z(og, re({
    slots: {
      root: w,
      input: k
    },
    renderSuffix: (E) => /* @__PURE__ */ z(FX, {
      ownerState: _,
      className: x.notchedOutline,
      label: f != null && f !== "" && S.required ? a || (a = /* @__PURE__ */ _e(B.Fragment, {
        children: [f, " ", "*"]
      })) : f,
      notched: typeof m != "undefined" ? m : !!(E.startAdornment || E.filled || E.focused)
    }),
    fullWidth: l,
    inputComponent: d,
    multiline: p,
    ref: t,
    type: g
  }, b, {
    classes: re({}, x, {
      notchedOutline: null
    })
  }));
});
process.env.NODE_ENV !== "production" && (cw.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: y.string,
  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: y.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: y.object,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * The prop defaults to the value (`'primary'`) inherited from the parent FormControl component.
   */
  color: y.oneOfType([y.oneOf(["primary", "secondary"]), y.string]),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */
  components: y.shape({
    Input: y.elementType,
    Root: y.elementType
  }),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: y.any,
  /**
   * If `true`, the component is disabled.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  disabled: y.bool,
  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: y.node,
  /**
   * If `true`, the `input` will indicate an error.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  error: y.bool,
  /**
   * If `true`, the `input` will take up the full width of its container.
   * @default false
   */
  fullWidth: y.bool,
  /**
   * The id of the `input` element.
   */
  id: y.string,
  /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   * @default 'input'
   */
  inputComponent: y.elementType,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * @default {}
   */
  inputProps: y.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: Yo,
  /**
   * The label of the `input`. It is only used for layout. The actual labelling
   * is handled by `InputLabel`.
   */
  label: y.node,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   * The prop defaults to the value (`'none'`) inherited from the parent FormControl component.
   */
  margin: y.oneOf(["dense", "none"]),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: y.oneOfType([y.number, y.string]),
  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: y.oneOfType([y.number, y.string]),
  /**
   * If `true`, a [TextareaAutosize](/material-ui/react-textarea-autosize/) element is rendered.
   * @default false
   */
  multiline: y.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: y.string,
  /**
   * If `true`, the outline is notched to accommodate the label.
   */
  notched: y.bool,
  /**
   * Callback fired when the value is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: y.func,
  /**
   * The short hint displayed in the `input` before the user enters a value.
   */
  placeholder: y.string,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: y.bool,
  /**
   * If `true`, the `input` element is required.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  required: y.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: y.oneOfType([y.number, y.string]),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: y.shape({
    input: y.elementType,
    root: y.elementType
  }),
  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: y.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: y.oneOfType([y.arrayOf(y.oneOfType([y.func, y.object, y.bool])), y.func, y.object]),
  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   * @default 'text'
   */
  type: y.string,
  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: y.any
});
cw.muiName = "Input";
const BX = cw, HX = ["autoWidth", "children", "classes", "className", "defaultOpen", "displayEmpty", "IconComponent", "id", "input", "inputProps", "label", "labelId", "MenuProps", "multiple", "native", "onClose", "onOpen", "open", "renderValue", "SelectDisplayProps", "variant"], jX = ["root"], WX = (e) => {
  const {
    classes: t
  } = e;
  return t;
}, uw = {
  name: "MuiSelect",
  overridesResolver: (e, t) => t.root,
  shouldForwardProp: (e) => Xo(e) && e !== "variant",
  slot: "Root"
}, VX = Fe(xX, uw)(""), UX = Fe(BX, uw)(""), qX = Fe(RX, uw)(""), dw = /* @__PURE__ */ B.forwardRef(function(e, t) {
  const n = rn({
    name: "MuiSelect",
    props: e
  }), {
    autoWidth: r = !1,
    children: o,
    classes: i = {},
    className: a,
    defaultOpen: s = !1,
    displayEmpty: c = !1,
    IconComponent: l = mX,
    id: d,
    input: f,
    inputProps: p,
    label: m,
    labelId: v,
    MenuProps: g,
    multiple: b = !1,
    native: x = !1,
    onClose: T,
    onOpen: S,
    open: _,
    renderValue: w,
    SelectDisplayProps: k,
    variant: E = "outlined"
  } = n, R = He(n, HX), P = x ? tX : uX, A = Jm(), D = tw({
    props: n,
    muiFormControl: A,
    states: ["variant", "error"]
  }), N = D.variant || E, F = re({}, n, {
    variant: N,
    classes: i
  }), $ = WX(F), I = He($, jX), j = f || {
    standard: /* @__PURE__ */ z(VX, {
      ownerState: F
    }),
    outlined: /* @__PURE__ */ z(UX, {
      label: m,
      ownerState: F
    }),
    filled: /* @__PURE__ */ z(qX, {
      ownerState: F
    })
  }[N], U = or(t, j.ref);
  return /* @__PURE__ */ z(B.Fragment, {
    children: /* @__PURE__ */ B.cloneElement(j, re({
      // Most of the logic is implemented in `SelectInput`.
      // The `Select` component is a simple API wrapper to expose something better to play with.
      inputComponent: P,
      inputProps: re({
        children: o,
        error: D.error,
        IconComponent: l,
        variant: N,
        type: void 0,
        // We render a select. We can ignore the type provided by the `Input`.
        multiple: b
      }, x ? {
        id: d
      } : {
        autoWidth: r,
        defaultOpen: s,
        displayEmpty: c,
        labelId: v,
        MenuProps: g,
        onClose: T,
        onOpen: S,
        open: _,
        renderValue: w,
        SelectDisplayProps: re({
          id: d
        }, k)
      }, p, {
        classes: p ? co(I, p.classes) : I
      }, f ? f.props.inputProps : {})
    }, (b && x || c) && N === "outlined" ? {
      notched: !0
    } : {}, {
      ref: U,
      className: Qe(j.props.className, a, $.root)
    }, !f && {
      variant: N
    }, R))
  });
});
process.env.NODE_ENV !== "production" && (dw.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, the width of the popover will automatically be set according to the items inside the
   * menu, otherwise it will be at least the width of the select input.
   * @default false
   */
  autoWidth: y.bool,
  /**
   * The option elements to populate the select with.
   * Can be some `MenuItem` when `native` is false and `option` when `native` is true.
   *
   * ⚠️The `MenuItem` elements **must** be direct descendants when `native` is false.
   */
  children: y.node,
  /**
   * Override or extend the styles applied to the component.
   * @default {}
   */
  classes: y.object,
  /**
   * @ignore
   */
  className: y.string,
  /**
   * If `true`, the component is initially open. Use when the component open state is not controlled (i.e. the `open` prop is not defined).
   * You can only use it when the `native` prop is `false` (default).
   * @default false
   */
  defaultOpen: y.bool,
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: y.any,
  /**
   * If `true`, a value is displayed even if no items are selected.
   *
   * In order to display a meaningful value, a function can be passed to the `renderValue` prop which
   * returns the value to be displayed when no items are selected.
   *
   * ⚠️ When using this prop, make sure the label doesn't overlap with the empty displayed value.
   * The label should either be hidden or forced to a shrunk state.
   * @default false
   */
  displayEmpty: y.bool,
  /**
   * The icon that displays the arrow.
   * @default ArrowDropDownIcon
   */
  IconComponent: y.elementType,
  /**
   * The `id` of the wrapper element or the `select` element when `native`.
   */
  id: y.string,
  /**
   * An `Input` element; does not have to be a material-ui specific `Input`.
   */
  input: y.element,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * When `native` is `true`, the attributes are applied on the `select` element.
   */
  inputProps: y.object,
  /**
   * See [OutlinedInput#label](/material-ui/api/outlined-input/#props)
   */
  label: y.node,
  /**
   * The ID of an element that acts as an additional label. The Select will
   * be labelled by the additional label and the selected value.
   */
  labelId: y.string,
  /**
   * Props applied to the [`Menu`](/material-ui/api/menu/) element.
   */
  MenuProps: y.object,
  /**
   * If `true`, `value` must be an array and the menu will support multiple selections.
   * @default false
   */
  multiple: y.bool,
  /**
   * If `true`, the component uses a native `select` element.
   * @default false
   */
  native: y.bool,
  /**
   * Callback fired when a menu item is selected.
   *
   * @param {SelectChangeEvent<Value>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (any).
   * **Warning**: This is a generic event, not a change event, unless the change event is caused by browser autofill.
   * @param {object} [child] The react element that was selected when `native` is `false` (default).
   */
  onChange: y.func,
  /**
   * Callback fired when the component requests to be closed.
   * Use it in either controlled (see the `open` prop), or uncontrolled mode (to detect when the Select collapses).
   *
   * @param {object} event The event source of the callback.
   */
  onClose: y.func,
  /**
   * Callback fired when the component requests to be opened.
   * Use it in either controlled (see the `open` prop), or uncontrolled mode (to detect when the Select expands).
   *
   * @param {object} event The event source of the callback.
   */
  onOpen: y.func,
  /**
   * If `true`, the component is shown.
   * You can only use it when the `native` prop is `false` (default).
   */
  open: y.bool,
  /**
   * Render the selected value.
   * You can only use it when the `native` prop is `false` (default).
   *
   * @param {any} value The `value` provided to the component.
   * @returns {ReactNode}
   */
  renderValue: y.func,
  /**
   * Props applied to the clickable div element.
   */
  SelectDisplayProps: y.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: y.oneOfType([y.arrayOf(y.oneOfType([y.func, y.object, y.bool])), y.func, y.object]),
  /**
   * The `input` value. Providing an empty string will select no options.
   * Set to an empty string `''` if you don't want any of the available options to be selected.
   *
   * If the value is an object it must have reference equality with the option in order to be selected.
   * If the value is not an object, the string representation must match with the string representation of the option in order to be selected.
   */
  value: y.oneOfType([y.oneOf([""]), y.any]),
  /**
   * The variant to use.
   * @default 'outlined'
   */
  variant: y.oneOf(["filled", "outlined", "standard"])
});
dw.muiName = "Select";
const GX = dw, gA = /* @__PURE__ */ B.createContext();
process.env.NODE_ENV !== "production" && (gA.displayName = "TableContext");
const YX = gA, vA = /* @__PURE__ */ B.createContext();
process.env.NODE_ENV !== "production" && (vA.displayName = "Tablelvl2Context");
const ZX = vA;
function XX(e) {
  return Gt("MuiTableCell", e);
}
const KX = Wt("MuiTableCell", ["root", "head", "body", "footer", "sizeSmall", "sizeMedium", "paddingCheckbox", "paddingNone", "alignLeft", "alignCenter", "alignRight", "alignJustify", "stickyHeader"]), JX = KX, QX = ["align", "className", "component", "padding", "scope", "size", "sortDirection", "variant"], eK = (e) => {
  const {
    classes: t,
    variant: n,
    align: r,
    padding: o,
    size: i,
    stickyHeader: a
  } = e, s = {
    root: ["root", n, a && "stickyHeader", r !== "inherit" && `align${at(r)}`, o !== "normal" && `padding${at(o)}`, `size${at(i)}`]
  };
  return Yt(s, XX, t);
}, tK = Fe("td", {
  name: "MuiTableCell",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, t[n.variant], t[`size${at(n.size)}`], n.padding !== "normal" && t[`padding${at(n.padding)}`], n.align !== "inherit" && t[`align${at(n.align)}`], n.stickyHeader && t.stickyHeader];
  }
})(({
  theme: e,
  ownerState: t
}) => re({}, e.typography.body2, {
  display: "table-cell",
  verticalAlign: "inherit",
  // Workaround for a rendering bug with spanned columns in Chrome 62.0.
  // Removes the alpha (sets it to 1), and lightens or darkens the theme color.
  borderBottom: e.vars ? `1px solid ${e.vars.palette.TableCell.border}` : `1px solid
    ${e.palette.mode === "light" ? tn.lighten(tn.alpha(e.palette.divider, 1), 0.88) : tn.darken(tn.alpha(e.palette.divider, 1), 0.68)}`,
  textAlign: "left",
  padding: 16
}, t.variant === "head" && {
  color: (e.vars || e).palette.text.primary,
  lineHeight: e.typography.pxToRem(24),
  fontWeight: e.typography.fontWeightMedium
}, t.variant === "body" && {
  color: (e.vars || e).palette.text.primary
}, t.variant === "footer" && {
  color: (e.vars || e).palette.text.secondary,
  lineHeight: e.typography.pxToRem(21),
  fontSize: e.typography.pxToRem(12)
}, t.size === "small" && {
  padding: "6px 16px",
  [`&.${JX.paddingCheckbox}`]: {
    width: 24,
    // prevent the checkbox column from growing
    padding: "0 12px 0 16px",
    "& > *": {
      padding: 0
    }
  }
}, t.padding === "checkbox" && {
  width: 48,
  // prevent the checkbox column from growing
  padding: "0 0 0 4px"
}, t.padding === "none" && {
  padding: 0
}, t.align === "left" && {
  textAlign: "left"
}, t.align === "center" && {
  textAlign: "center"
}, t.align === "right" && {
  textAlign: "right",
  flexDirection: "row-reverse"
}, t.align === "justify" && {
  textAlign: "justify"
}, t.stickyHeader && {
  position: "sticky",
  top: 0,
  zIndex: 2,
  backgroundColor: (e.vars || e).palette.background.default
})), bA = /* @__PURE__ */ B.forwardRef(function(e, t) {
  const n = rn({
    props: e,
    name: "MuiTableCell"
  }), {
    align: r = "inherit",
    className: o,
    component: i,
    padding: a,
    scope: s,
    size: c,
    sortDirection: l,
    variant: d
  } = n, f = He(n, QX), p = B.useContext(YX), m = B.useContext(ZX), v = m && m.variant === "head";
  let g;
  i ? g = i : g = v ? "th" : "td";
  let b = s;
  g === "td" ? b = void 0 : !b && v && (b = "col");
  const x = d || m && m.variant, T = re({}, n, {
    align: r,
    component: g,
    padding: a || (p && p.padding ? p.padding : "normal"),
    size: c || (p && p.size ? p.size : "medium"),
    sortDirection: l,
    stickyHeader: x === "head" && p && p.stickyHeader,
    variant: x
  }), S = eK(T);
  let _ = null;
  return l && (_ = l === "asc" ? "ascending" : "descending"), /* @__PURE__ */ z(tK, re({
    as: g,
    ref: t,
    className: Qe(S.root, o),
    "aria-sort": _,
    scope: b,
    ownerState: T
  }, f));
});
process.env.NODE_ENV !== "production" && (bA.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Set the text-align on the table cell content.
   *
   * Monetary or generally number fields **should be right aligned** as that allows
   * you to add them up quickly in your head without having to worry about decimals.
   * @default 'inherit'
   */
  align: y.oneOf(["center", "inherit", "justify", "left", "right"]),
  /**
   * The content of the component.
   */
  children: y.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: y.object,
  /**
   * @ignore
   */
  className: y.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: y.elementType,
  /**
   * Sets the padding applied to the cell.
   * The prop defaults to the value (`'default'`) inherited from the parent Table component.
   */
  padding: y.oneOf(["checkbox", "none", "normal"]),
  /**
   * Set scope attribute.
   */
  scope: y.string,
  /**
   * Specify the size of the cell.
   * The prop defaults to the value (`'medium'`) inherited from the parent Table component.
   */
  size: y.oneOfType([y.oneOf(["medium", "small"]), y.string]),
  /**
   * Set aria-sort direction.
   */
  sortDirection: y.oneOf(["asc", "desc", !1]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: y.oneOfType([y.arrayOf(y.oneOfType([y.func, y.object, y.bool])), y.func, y.object]),
  /**
   * Specify the cell type.
   * The prop defaults to the value inherited from the parent TableHead, TableBody, or TableFooter components.
   */
  variant: y.oneOfType([y.oneOf(["body", "footer", "head"]), y.string])
});
const hy = bA;
function nK(e) {
  return Gt("MuiToolbar", e);
}
Wt("MuiToolbar", ["root", "gutters", "regular", "dense"]);
const rK = ["className", "component", "disableGutters", "variant"], oK = (e) => {
  const {
    classes: t,
    disableGutters: n,
    variant: r
  } = e;
  return Yt({
    root: ["root", !n && "gutters", r]
  }, nK, t);
}, iK = Fe("div", {
  name: "MuiToolbar",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, !n.disableGutters && t.gutters, t[n.variant]];
  }
})(({
  theme: e,
  ownerState: t
}) => re({
  position: "relative",
  display: "flex",
  alignItems: "center"
}, !t.disableGutters && {
  paddingLeft: e.spacing(2),
  paddingRight: e.spacing(2),
  [e.breakpoints.up("sm")]: {
    paddingLeft: e.spacing(3),
    paddingRight: e.spacing(3)
  }
}, t.variant === "dense" && {
  minHeight: 48
}), ({
  theme: e,
  ownerState: t
}) => t.variant === "regular" && e.mixins.toolbar), yA = /* @__PURE__ */ B.forwardRef(function(e, t) {
  const n = rn({
    props: e,
    name: "MuiToolbar"
  }), {
    className: r,
    component: o = "div",
    disableGutters: i = !1,
    variant: a = "regular"
  } = n, s = He(n, rK), c = re({}, n, {
    component: o,
    disableGutters: i,
    variant: a
  }), l = oK(c);
  return /* @__PURE__ */ z(iK, re({
    as: o,
    className: Qe(l.root, r),
    ref: t,
    ownerState: c
  }, s));
});
process.env.NODE_ENV !== "production" && (yA.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The Toolbar children, usually a mixture of `IconButton`, `Button` and `Typography`.
   * The Toolbar is a flex container, allowing flex item properties to be used to lay out the children.
   */
  children: y.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: y.object,
  /**
   * @ignore
   */
  className: y.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: y.elementType,
  /**
   * If `true`, disables gutter padding.
   * @default false
   */
  disableGutters: y.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: y.oneOfType([y.arrayOf(y.oneOfType([y.func, y.object, y.bool])), y.func, y.object]),
  /**
   * The variant to use.
   * @default 'regular'
   */
  variant: y.oneOfType([y.oneOf(["dense", "regular"]), y.string])
});
const aK = yA, sK = Vi(/* @__PURE__ */ z("path", {
  d: "M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z"
}), "KeyboardArrowLeft"), lK = Vi(/* @__PURE__ */ z("path", {
  d: "M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"
}), "KeyboardArrowRight");
function cK(e) {
  return Gt("MuiIconButton", e);
}
const uK = Wt("MuiIconButton", ["root", "disabled", "colorInherit", "colorPrimary", "colorSecondary", "colorError", "colorInfo", "colorSuccess", "colorWarning", "edgeStart", "edgeEnd", "sizeSmall", "sizeMedium", "sizeLarge"]), dK = uK, fK = ["edge", "children", "className", "color", "disabled", "disableFocusRipple", "size"], pK = (e) => {
  const {
    classes: t,
    disabled: n,
    color: r,
    edge: o,
    size: i
  } = e, a = {
    root: ["root", n && "disabled", r !== "default" && `color${at(r)}`, o && `edge${at(o)}`, `size${at(i)}`]
  };
  return Yt(a, cK, t);
}, hK = Fe(ag, {
  name: "MuiIconButton",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.color !== "default" && t[`color${at(n.color)}`], n.edge && t[`edge${at(n.edge)}`], t[`size${at(n.size)}`]];
  }
})(({
  theme: e,
  ownerState: t
}) => re({
  textAlign: "center",
  flex: "0 0 auto",
  fontSize: e.typography.pxToRem(24),
  padding: 8,
  borderRadius: "50%",
  overflow: "visible",
  // Explicitly set the default value to solve a bug on IE11.
  color: (e.vars || e).palette.action.active,
  transition: e.transitions.create("background-color", {
    duration: e.transitions.duration.shortest
  })
}, !t.disableRipple && {
  "&:hover": {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.action.activeChannel} / ${e.vars.palette.action.hoverOpacity})` : tn.alpha(e.palette.action.active, e.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: "transparent"
    }
  }
}, t.edge === "start" && {
  marginLeft: t.size === "small" ? -3 : -12
}, t.edge === "end" && {
  marginRight: t.size === "small" ? -3 : -12
}), ({
  theme: e,
  ownerState: t
}) => {
  var n;
  const r = (n = (e.vars || e).palette) == null ? void 0 : n[t.color];
  return re({}, t.color === "inherit" && {
    color: "inherit"
  }, t.color !== "inherit" && t.color !== "default" && re({
    color: r == null ? void 0 : r.main
  }, !t.disableRipple && {
    "&:hover": re({}, r && {
      backgroundColor: e.vars ? `rgba(${r.mainChannel} / ${e.vars.palette.action.hoverOpacity})` : tn.alpha(r.main, e.palette.action.hoverOpacity)
    }, {
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: "transparent"
      }
    })
  }), t.size === "small" && {
    padding: 5,
    fontSize: e.typography.pxToRem(18)
  }, t.size === "large" && {
    padding: 12,
    fontSize: e.typography.pxToRem(28)
  }, {
    [`&.${dK.disabled}`]: {
      backgroundColor: "transparent",
      color: (e.vars || e).palette.action.disabled
    }
  });
}), _A = /* @__PURE__ */ B.forwardRef(function(e, t) {
  const n = rn({
    props: e,
    name: "MuiIconButton"
  }), {
    edge: r = !1,
    children: o,
    className: i,
    color: a = "default",
    disabled: s = !1,
    disableFocusRipple: c = !1,
    size: l = "medium"
  } = n, d = He(n, fK), f = re({}, n, {
    edge: r,
    color: a,
    disabled: s,
    disableFocusRipple: c,
    size: l
  }), p = pK(f);
  return /* @__PURE__ */ z(hK, re({
    className: Qe(p.root, i),
    centerRipple: !0,
    focusRipple: !c,
    disabled: s,
    ref: t
  }, d, {
    ownerState: f,
    children: o
  }));
});
process.env.NODE_ENV !== "production" && (_A.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The icon to display.
   */
  children: fs(y.node, (e) => B.Children.toArray(e.children).some((t) => /* @__PURE__ */ B.isValidElement(t) && t.props.onClick) ? new Error(["MUI: You are providing an onClick event listener to a child of a button element.", "Prefer applying it to the IconButton directly.", "This guarantees that the whole <button> will be responsive to click events."].join(`
`)) : null),
  /**
   * Override or extend the styles applied to the component.
   */
  classes: y.object,
  /**
   * @ignore
   */
  className: y.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'default'
   */
  color: y.oneOfType([y.oneOf(["inherit", "default", "primary", "secondary", "error", "info", "success", "warning"]), y.string]),
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: y.bool,
  /**
   * If `true`, the  keyboard focus ripple is disabled.
   * @default false
   */
  disableFocusRipple: y.bool,
  /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */
  disableRipple: y.bool,
  /**
   * If given, uses a negative margin to counteract the padding on one
   * side (this is often helpful for aligning the left or right
   * side of the icon with content above or below, without ruining the border
   * size and shape).
   * @default false
   */
  edge: y.oneOf(["end", "start", !1]),
  /**
   * The size of the component.
   * `small` is equivalent to the dense button styling.
   * @default 'medium'
   */
  size: y.oneOfType([y.oneOf(["small", "medium", "large"]), y.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: y.oneOfType([y.arrayOf(y.oneOfType([y.func, y.object, y.bool])), y.func, y.object])
});
const ap = _A, my = Vi(/* @__PURE__ */ z("path", {
  d: "M5.59 7.41L10.18 12l-4.59 4.59L7 18l6-6-6-6zM16 6h2v12h-2z"
}), "LastPage"), gy = Vi(/* @__PURE__ */ z("path", {
  d: "M18.41 16.59L13.82 12l4.59-4.59L17 6l-6 6 6 6zM6 6h2v12H6z"
}), "FirstPage"), mK = ["backIconButtonProps", "count", "disabled", "getItemAriaLabel", "nextIconButtonProps", "onPageChange", "page", "rowsPerPage", "showFirstButton", "showLastButton", "slots", "slotProps"], wA = /* @__PURE__ */ B.forwardRef(function(e, t) {
  var n, r, o, i, a, s, c, l;
  const {
    backIconButtonProps: d,
    count: f,
    disabled: p = !1,
    getItemAriaLabel: m,
    nextIconButtonProps: v,
    onPageChange: g,
    page: b,
    rowsPerPage: x,
    showFirstButton: T,
    showLastButton: S,
    slots: _ = {},
    slotProps: w = {}
  } = e, k = He(e, mK), E = Qm(), R = (te) => {
    g(te, 0);
  }, P = (te) => {
    g(te, b - 1);
  }, A = (te) => {
    g(te, b + 1);
  }, D = (te) => {
    g(te, Math.max(0, Math.ceil(f / x) - 1));
  }, N = (n = _.firstButton) != null ? n : ap, F = (r = _.lastButton) != null ? r : ap, $ = (o = _.nextButton) != null ? o : ap, I = (i = _.previousButton) != null ? i : ap, j = (a = _.firstButtonIcon) != null ? a : gy, U = (s = _.lastButtonIcon) != null ? s : my, G = (c = _.nextButtonIcon) != null ? c : lK, V = (l = _.previousButtonIcon) != null ? l : sK, H = E ? F : N, q = E ? $ : I, Q = E ? I : $, X = E ? N : F, K = E ? w.lastButton : w.firstButton, J = E ? w.nextButton : w.previousButton, ne = E ? w.previousButton : w.nextButton, ae = E ? w.firstButton : w.lastButton;
  return /* @__PURE__ */ _e("div", re({
    ref: t
  }, k, {
    children: [T && /* @__PURE__ */ z(H, re({
      onClick: R,
      disabled: p || b === 0,
      "aria-label": m("first", b),
      title: m("first", b)
    }, K, {
      children: E ? /* @__PURE__ */ z(U, re({}, w.lastButtonIcon)) : /* @__PURE__ */ z(j, re({}, w.firstButtonIcon))
    })), /* @__PURE__ */ z(q, re({
      onClick: P,
      disabled: p || b === 0,
      color: "inherit",
      "aria-label": m("previous", b),
      title: m("previous", b)
    }, J != null ? J : d, {
      children: E ? /* @__PURE__ */ z(G, re({}, w.nextButtonIcon)) : /* @__PURE__ */ z(V, re({}, w.previousButtonIcon))
    })), /* @__PURE__ */ z(Q, re({
      onClick: A,
      disabled: p || (f !== -1 ? b >= Math.ceil(f / x) - 1 : !1),
      color: "inherit",
      "aria-label": m("next", b),
      title: m("next", b)
    }, ne != null ? ne : v, {
      children: E ? /* @__PURE__ */ z(V, re({}, w.previousButtonIcon)) : /* @__PURE__ */ z(G, re({}, w.nextButtonIcon))
    })), S && /* @__PURE__ */ z(X, re({
      onClick: D,
      disabled: p || b >= Math.ceil(f / x) - 1,
      "aria-label": m("last", b),
      title: m("last", b)
    }, ae, {
      children: E ? /* @__PURE__ */ z(j, re({}, w.firstButtonIcon)) : /* @__PURE__ */ z(U, re({}, w.lastButtonIcon))
    }))]
  }));
});
process.env.NODE_ENV !== "production" && (wA.propTypes = {
  /**
   * Props applied to the back arrow [`IconButton`](/material-ui/api/icon-button/) element.
   */
  backIconButtonProps: y.object,
  /**
   * The total number of rows.
   */
  count: y.number.isRequired,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: y.bool,
  /**
   * Accepts a function which returns a string value that provides a user-friendly name for the current page.
   *
   * For localization purposes, you can use the provided [translations](/material-ui/guides/localization/).
   *
   * @param {string} type The link or button type to format ('page' | 'first' | 'last' | 'next' | 'previous'). Defaults to 'page'.
   * @param {number} page The page number to format.
   * @returns {string}
   */
  getItemAriaLabel: y.func.isRequired,
  /**
   * Props applied to the next arrow [`IconButton`](/material-ui/api/icon-button/) element.
   */
  nextIconButtonProps: y.object,
  /**
   * Callback fired when the page is changed.
   *
   * @param {object} event The event source of the callback.
   * @param {number} page The page selected.
   */
  onPageChange: y.func.isRequired,
  /**
   * The zero-based index of the current page.
   */
  page: y.number.isRequired,
  /**
   * The number of rows per page.
   */
  rowsPerPage: y.number.isRequired,
  /**
   * If `true`, show the first-page button.
   */
  showFirstButton: y.bool.isRequired,
  /**
   * If `true`, show the last-page button.
   */
  showLastButton: y.bool.isRequired,
  /**
   * The props used for each slot inside the TablePaginationActions.
   * @default {}
   */
  slotProps: y.shape({
    firstButton: y.object,
    firstButtonIcon: y.object,
    lastButton: y.object,
    lastButtonIcon: y.object,
    nextButton: y.object,
    nextButtonIcon: y.object,
    previousButton: y.object,
    previousButtonIcon: y.object
  }),
  /**
   * The components used for each slot inside the TablePaginationActions.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: y.shape({
    firstButton: y.elementType,
    firstButtonIcon: y.elementType,
    lastButton: y.elementType,
    lastButtonIcon: y.elementType,
    nextButton: y.elementType,
    nextButtonIcon: y.elementType,
    previousButton: y.elementType,
    previousButtonIcon: y.elementType
  })
});
const gK = wA;
function vK(e) {
  return Gt("MuiTablePagination", e);
}
const bK = Wt("MuiTablePagination", ["root", "toolbar", "spacer", "selectLabel", "selectRoot", "select", "selectIcon", "input", "menuItem", "displayedRows", "actions"]), vd = bK;
var RT;
const yK = ["ActionsComponent", "backIconButtonProps", "className", "colSpan", "component", "count", "disabled", "getItemAriaLabel", "labelDisplayedRows", "labelRowsPerPage", "nextIconButtonProps", "onPageChange", "onRowsPerPageChange", "page", "rowsPerPage", "rowsPerPageOptions", "SelectProps", "showFirstButton", "showLastButton", "slotProps", "slots"], _K = Fe(hy, {
  name: "MuiTablePagination",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(({
  theme: e
}) => ({
  overflow: "auto",
  color: (e.vars || e).palette.text.primary,
  fontSize: e.typography.pxToRem(14),
  // Increase the specificity to override TableCell.
  "&:last-child": {
    padding: 0
  }
})), wK = Fe(aK, {
  name: "MuiTablePagination",
  slot: "Toolbar",
  overridesResolver: (e, t) => re({
    [`& .${vd.actions}`]: t.actions
  }, t.toolbar)
})(({
  theme: e
}) => ({
  minHeight: 52,
  paddingRight: 2,
  [`${e.breakpoints.up("xs")} and (orientation: landscape)`]: {
    minHeight: 52
  },
  [e.breakpoints.up("sm")]: {
    minHeight: 52,
    paddingRight: 2
  },
  [`& .${vd.actions}`]: {
    flexShrink: 0,
    marginLeft: 20
  }
})), xK = Fe("div", {
  name: "MuiTablePagination",
  slot: "Spacer",
  overridesResolver: (e, t) => t.spacer
})({
  flex: "1 1 100%"
}), CK = Fe("p", {
  name: "MuiTablePagination",
  slot: "SelectLabel",
  overridesResolver: (e, t) => t.selectLabel
})(({
  theme: e
}) => re({}, e.typography.body2, {
  flexShrink: 0
})), SK = Fe(GX, {
  name: "MuiTablePagination",
  slot: "Select",
  overridesResolver: (e, t) => re({
    [`& .${vd.selectIcon}`]: t.selectIcon,
    [`& .${vd.select}`]: t.select
  }, t.input, t.selectRoot)
})({
  color: "inherit",
  fontSize: "inherit",
  flexShrink: 0,
  marginRight: 32,
  marginLeft: 8,
  [`& .${vd.select}`]: {
    paddingLeft: 8,
    paddingRight: 24,
    textAlign: "right",
    textAlignLast: "right"
    // Align <select> on Chrome.
  }
}), TK = Fe(nZ, {
  name: "MuiTablePagination",
  slot: "MenuItem",
  overridesResolver: (e, t) => t.menuItem
})({}), EK = Fe("p", {
  name: "MuiTablePagination",
  slot: "DisplayedRows",
  overridesResolver: (e, t) => t.displayedRows
})(({
  theme: e
}) => re({}, e.typography.body2, {
  flexShrink: 0
}));
function kK({
  from: e,
  to: t,
  count: n
}) {
  return `${e}–${t} of ${n !== -1 ? n : `more than ${t}`}`;
}
function MK(e) {
  return `Go to ${e} page`;
}
const RK = (e) => {
  const {
    classes: t
  } = e;
  return Yt({
    root: ["root"],
    toolbar: ["toolbar"],
    spacer: ["spacer"],
    selectLabel: ["selectLabel"],
    select: ["select"],
    input: ["input"],
    selectIcon: ["selectIcon"],
    menuItem: ["menuItem"],
    displayedRows: ["displayedRows"],
    actions: ["actions"]
  }, vK, t);
}, xA = /* @__PURE__ */ B.forwardRef(function(e, t) {
  var n;
  const r = rn({
    props: e,
    name: "MuiTablePagination"
  }), {
    ActionsComponent: o = gK,
    backIconButtonProps: i,
    className: a,
    colSpan: s,
    component: c = hy,
    count: l,
    disabled: d = !1,
    getItemAriaLabel: f = MK,
    labelDisplayedRows: p = kK,
    labelRowsPerPage: m = "Rows per page:",
    nextIconButtonProps: v,
    onPageChange: g,
    onRowsPerPageChange: b,
    page: x,
    rowsPerPage: T,
    rowsPerPageOptions: S = [10, 25, 50, 100],
    SelectProps: _ = {},
    showFirstButton: w = !1,
    showLastButton: k = !1,
    slotProps: E = {},
    slots: R = {}
  } = r, P = He(r, yK), A = r, D = RK(A), N = (n = E == null ? void 0 : E.select) != null ? n : _, F = N.native ? "option" : TK;
  let $;
  (c === hy || c === "td") && ($ = s || 1e3);
  const I = Ch(N.id), j = Ch(N.labelId), U = () => l === -1 ? (x + 1) * T : T === -1 ? l : Math.min(l, (x + 1) * T);
  return /* @__PURE__ */ z(_K, re({
    colSpan: $,
    ref: t,
    as: c,
    ownerState: A,
    className: Qe(D.root, a)
  }, P, {
    children: /* @__PURE__ */ _e(wK, {
      className: D.toolbar,
      children: [/* @__PURE__ */ z(xK, {
        className: D.spacer
      }), S.length > 1 && /* @__PURE__ */ z(CK, {
        className: D.selectLabel,
        id: j,
        children: m
      }), S.length > 1 && /* @__PURE__ */ z(SK, re({
        variant: "standard"
      }, !N.variant && {
        input: RT || (RT = /* @__PURE__ */ z(og, {}))
      }, {
        value: T,
        onChange: b,
        id: I,
        labelId: j
      }, N, {
        classes: re({}, N.classes, {
          // TODO v5 remove `classes.input`
          root: Qe(D.input, D.selectRoot, (N.classes || {}).root),
          select: Qe(D.select, (N.classes || {}).select),
          // TODO v5 remove `selectIcon`
          icon: Qe(D.selectIcon, (N.classes || {}).icon)
        }),
        disabled: d,
        children: S.map((G) => /* @__PURE__ */ uh(F, re({}, !Ad(F) && {
          ownerState: A
        }, {
          className: D.menuItem,
          key: G.label ? G.label : G,
          value: G.value ? G.value : G
        }), G.label ? G.label : G))
      })), /* @__PURE__ */ z(EK, {
        className: D.displayedRows,
        children: p({
          from: l === 0 ? 0 : x * T + 1,
          to: U(),
          count: l === -1 ? -1 : l,
          page: x
        })
      }), /* @__PURE__ */ z(o, {
        className: D.actions,
        backIconButtonProps: i,
        count: l,
        nextIconButtonProps: v,
        onPageChange: g,
        page: x,
        rowsPerPage: T,
        showFirstButton: w,
        showLastButton: k,
        slotProps: E.actions,
        slots: R.actions,
        getItemAriaLabel: f,
        disabled: d
      })]
    })
  }));
});
process.env.NODE_ENV !== "production" && (xA.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The component used for displaying the actions.
   * Either a string to use a HTML element or a component.
   * @default TablePaginationActions
   */
  ActionsComponent: y.elementType,
  /**
   * Props applied to the back arrow [`IconButton`](/material-ui/api/icon-button/) component.
   *
   * This prop is an alias for `slotProps.actions.previousButton` and will be overriden by it if both are used.
   * @deprecated Use `slotProps.actions.previousButton` instead.
   */
  backIconButtonProps: y.object,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: y.object,
  /**
   * @ignore
   */
  className: y.string,
  /**
   * @ignore
   */
  colSpan: y.number,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: y.elementType,
  /**
   * The total number of rows.
   *
   * To enable server side pagination for an unknown number of items, provide -1.
   */
  count: Si.isRequired,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: y.bool,
  /**
   * Accepts a function which returns a string value that provides a user-friendly name for the current page.
   * This is important for screen reader users.
   *
   * For localization purposes, you can use the provided [translations](/material-ui/guides/localization/).
   * @param {string} type The link or button type to format ('first' | 'last' | 'next' | 'previous').
   * @returns {string}
   * @default function defaultGetAriaLabel(type) {
   *   return `Go to ${type} page`;
   * }
   */
  getItemAriaLabel: y.func,
  /**
   * Customize the displayed rows label. Invoked with a `{ from, to, count, page }`
   * object.
   *
   * For localization purposes, you can use the provided [translations](/material-ui/guides/localization/).
   * @default function defaultLabelDisplayedRows({ from, to, count }) {
   *   return `${from}–${to} of ${count !== -1 ? count : `more than ${to}`}`;
   * }
   */
  labelDisplayedRows: y.func,
  /**
   * Customize the rows per page label.
   *
   * For localization purposes, you can use the provided [translations](/material-ui/guides/localization/).
   * @default 'Rows per page:'
   */
  labelRowsPerPage: y.node,
  /**
   * Props applied to the next arrow [`IconButton`](/material-ui/api/icon-button/) element.
   *
   * This prop is an alias for `slotProps.actions.nextButton` and will be overriden by it if both are used.
   * @deprecated Use `slotProps.actions.nextButton` instead.
   */
  nextIconButtonProps: y.object,
  /**
   * Callback fired when the page is changed.
   *
   * @param {React.MouseEvent<HTMLButtonElement> | null} event The event source of the callback.
   * @param {number} page The page selected.
   */
  onPageChange: y.func.isRequired,
  /**
   * Callback fired when the number of rows per page is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   */
  onRowsPerPageChange: y.func,
  /**
   * The zero-based index of the current page.
   */
  page: fs(Si.isRequired, (e) => {
    const {
      count: t,
      page: n,
      rowsPerPage: r
    } = e;
    if (t === -1)
      return null;
    const o = Math.max(0, Math.ceil(t / r) - 1);
    return n < 0 || n > o ? new Error(`MUI: The page prop of a TablePagination is out of range (0 to ${o}, but page is ${n}).`) : null;
  }),
  /**
   * The number of rows per page.
   *
   * Set -1 to display all the rows.
   */
  rowsPerPage: Si.isRequired,
  /**
   * Customizes the options of the rows per page select field. If less than two options are
   * available, no select field will be displayed.
   * Use -1 for the value with a custom label to show all the rows.
   * @default [10, 25, 50, 100]
   */
  rowsPerPageOptions: y.arrayOf(y.oneOfType([y.number, y.shape({
    label: y.string.isRequired,
    value: y.number.isRequired
  })]).isRequired),
  /**
   * Props applied to the rows per page [`Select`](/material-ui/api/select/) element.
   *
   * This prop is an alias for `slotProps.select` and will be overriden by it if both are used.
   * @deprecated Use `slotProps.select` instead.
   *
   * @default {}
   */
  SelectProps: y.object,
  /**
   * If `true`, show the first-page button.
   * @default false
   */
  showFirstButton: y.bool,
  /**
   * If `true`, show the last-page button.
   * @default false
   */
  showLastButton: y.bool,
  /**
   * The props used for each slot inside the TablePagination.
   * @default {}
   */
  slotProps: y.shape({
    actions: y.shape({
      firstButton: y.object,
      firstButtonIcon: y.object,
      lastButton: y.object,
      lastButtonIcon: y.object,
      nextButton: y.object,
      nextButtonIcon: y.object,
      previousButton: y.object,
      previousButtonIcon: y.object
    }),
    select: y.object
  }),
  /**
   * The components used for each slot inside the TablePagination.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: y.shape({
    actions: y.shape({
      firstButton: y.elementType,
      firstButtonIcon: y.elementType,
      lastButton: y.elementType,
      lastButtonIcon: y.elementType,
      nextButton: y.elementType,
      nextButtonIcon: y.elementType,
      previousButton: y.elementType,
      previousButtonIcon: y.elementType
    })
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: y.oneOfType([y.arrayOf(y.oneOfType([y.func, y.object, y.bool])), y.func, y.object])
});
const PK = xA, OK = ["theme"];
function ll(e) {
  let {
    theme: t
  } = e, n = He(e, OK);
  const r = t[_c];
  return /* @__PURE__ */ z(Ph, re({}, n, {
    themeId: r ? _c : void 0,
    theme: r || t
  }));
}
process.env.NODE_ENV !== "production" && (ll.propTypes = {
  /**
   * Your component tree.
   */
  children: y.node,
  /**
   * A theme object. You can provide a function to extend the outer theme.
   */
  theme: y.oneOfType([y.object, y.func]).isRequired
});
var NK = function() {
}, CA = typeof window != "undefined", AK = CA ? Lc : mt;
const DK = AK;
var SA = {
  x: 0,
  y: 0,
  width: 0,
  height: 0,
  top: 0,
  left: 0,
  bottom: 0,
  right: 0
};
function IK() {
  var e = Ge(null), t = e[0], n = e[1], r = Ge(SA), o = r[0], i = r[1], a = We(function() {
    return new window.ResizeObserver(function(s) {
      if (s[0]) {
        var c = s[0].contentRect, l = c.x, d = c.y, f = c.width, p = c.height, m = c.top, v = c.left, g = c.bottom, b = c.right;
        i({ x: l, y: d, width: f, height: p, top: m, left: v, bottom: g, right: b });
      }
    });
  }, []);
  return DK(function() {
    if (t)
      return a.observe(t), function() {
        a.disconnect();
      };
  }, [t]), [n, o];
}
const LK = CA && typeof window.ResizeObserver != "undefined" ? IK : function() {
  return [NK, SA];
}, TA = ol({}), $K = "responsive-table-pagination", yi = {
  xs: 0,
  sm: 200,
  md: 439,
  lg: 600,
  xl: 1536
}, FK = (e) => sp(yi.xs, yi.sm, e) ? "xs" : sp(yi.sm, yi.md, e) ? "sm" : sp(yi.md, yi.lg, e) ? "md" : sp(yi.lg, yi.xl, e) ? "lg" : "xl", sp = (e, t, n) => n >= e && n < t;
function zK(e) {
  return Gt("MuiPagination", e);
}
Wt("MuiPagination", ["root", "ul", "outlined", "text"]);
const BK = ["boundaryCount", "componentName", "count", "defaultPage", "disabled", "hideNextButton", "hidePrevButton", "onChange", "page", "showFirstButton", "showLastButton", "siblingCount"];
function HK(e = {}) {
  const {
    boundaryCount: t = 1,
    componentName: n = "usePagination",
    count: r = 1,
    defaultPage: o = 1,
    disabled: i = !1,
    hideNextButton: a = !1,
    hidePrevButton: s = !1,
    onChange: c,
    page: l,
    showFirstButton: d = !1,
    showLastButton: f = !1,
    siblingCount: p = 1
  } = e, m = He(e, BK), [v, g] = Dd({
    controlled: l,
    default: o,
    name: n,
    state: "page"
  }), b = (P, A) => {
    l || g(A), c && c(P, A);
  }, x = (P, A) => {
    const D = A - P + 1;
    return Array.from({
      length: D
    }, (N, F) => P + F);
  }, T = x(1, Math.min(t, r)), S = x(Math.max(r - t + 1, t + 1), r), _ = Math.max(
    Math.min(
      // Natural start
      v - p,
      // Lower boundary when page is high
      r - t - p * 2 - 1
    ),
    // Greater than startPages
    t + 2
  ), w = Math.min(
    Math.max(
      // Natural end
      v + p,
      // Upper boundary when page is low
      t + p * 2 + 2
    ),
    // Less than endPages
    S.length > 0 ? S[0] - 2 : r - 1
  ), k = [
    ...d ? ["first"] : [],
    ...s ? [] : ["previous"],
    ...T,
    // Start ellipsis
    // eslint-disable-next-line no-nested-ternary
    ..._ > t + 2 ? ["start-ellipsis"] : t + 1 < r - t ? [t + 1] : [],
    // Sibling pages
    ...x(_, w),
    // End ellipsis
    // eslint-disable-next-line no-nested-ternary
    ...w < r - t - 1 ? ["end-ellipsis"] : r - t > t ? [r - t] : [],
    ...S,
    ...a ? [] : ["next"],
    ...f ? ["last"] : []
  ], E = (P) => {
    switch (P) {
      case "first":
        return 1;
      case "previous":
        return v - 1;
      case "next":
        return v + 1;
      case "last":
        return r;
      default:
        return null;
    }
  }, R = k.map((P) => typeof P == "number" ? {
    onClick: (A) => {
      b(A, P);
    },
    type: "page",
    page: P,
    selected: P === v,
    disabled: i,
    "aria-current": P === v ? "true" : void 0
  } : {
    onClick: (A) => {
      b(A, E(P));
    },
    type: P,
    page: E(P),
    selected: !1,
    disabled: i || P.indexOf("ellipsis") === -1 && (P === "next" || P === "last" ? v >= r : v <= 1)
  });
  return re({
    items: R
  }, m);
}
function jK(e) {
  return Gt("MuiPaginationItem", e);
}
const WK = Wt("MuiPaginationItem", ["root", "page", "sizeSmall", "sizeLarge", "text", "textPrimary", "textSecondary", "outlined", "outlinedPrimary", "outlinedSecondary", "rounded", "ellipsis", "firstLast", "previousNext", "focusVisible", "disabled", "selected", "icon", "colorPrimary", "colorSecondary"]), Po = WK, PT = Vi(/* @__PURE__ */ z("path", {
  d: "M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"
}), "NavigateBefore"), OT = Vi(/* @__PURE__ */ z("path", {
  d: "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
}), "NavigateNext"), VK = ["className", "color", "component", "components", "disabled", "page", "selected", "shape", "size", "slots", "type", "variant"], EA = (e, t) => {
  const {
    ownerState: n
  } = e;
  return [t.root, t[n.variant], t[`size${at(n.size)}`], n.variant === "text" && t[`text${at(n.color)}`], n.variant === "outlined" && t[`outlined${at(n.color)}`], n.shape === "rounded" && t.rounded, n.type === "page" && t.page, (n.type === "start-ellipsis" || n.type === "end-ellipsis") && t.ellipsis, (n.type === "previous" || n.type === "next") && t.previousNext, (n.type === "first" || n.type === "last") && t.firstLast];
}, UK = (e) => {
  const {
    classes: t,
    color: n,
    disabled: r,
    selected: o,
    size: i,
    shape: a,
    type: s,
    variant: c
  } = e, l = {
    root: ["root", `size${at(i)}`, c, a, n !== "standard" && `color${at(n)}`, n !== "standard" && `${c}${at(n)}`, r && "disabled", o && "selected", {
      page: "page",
      first: "firstLast",
      last: "firstLast",
      "start-ellipsis": "ellipsis",
      "end-ellipsis": "ellipsis",
      previous: "previousNext",
      next: "previousNext"
    }[s]],
    icon: ["icon"]
  };
  return Yt(l, jK, t);
}, qK = Fe("div", {
  name: "MuiPaginationItem",
  slot: "Root",
  overridesResolver: EA
})(({
  theme: e,
  ownerState: t
}) => re({}, e.typography.body2, {
  borderRadius: 32 / 2,
  textAlign: "center",
  boxSizing: "border-box",
  minWidth: 32,
  padding: "0 6px",
  margin: "0 3px",
  color: (e.vars || e).palette.text.primary,
  height: "auto",
  [`&.${Po.disabled}`]: {
    opacity: (e.vars || e).palette.action.disabledOpacity
  }
}, t.size === "small" && {
  minWidth: 26,
  borderRadius: 26 / 2,
  margin: "0 1px",
  padding: "0 4px"
}, t.size === "large" && {
  minWidth: 40,
  borderRadius: 40 / 2,
  padding: "0 10px",
  fontSize: e.typography.pxToRem(15)
})), GK = Fe(ag, {
  name: "MuiPaginationItem",
  slot: "Root",
  overridesResolver: EA
})(({
  theme: e,
  ownerState: t
}) => re({}, e.typography.body2, {
  borderRadius: 32 / 2,
  textAlign: "center",
  boxSizing: "border-box",
  minWidth: 32,
  height: 32,
  padding: "0 6px",
  margin: "0 3px",
  color: (e.vars || e).palette.text.primary,
  [`&.${Po.focusVisible}`]: {
    backgroundColor: (e.vars || e).palette.action.focus
  },
  [`&.${Po.disabled}`]: {
    opacity: (e.vars || e).palette.action.disabledOpacity
  },
  transition: e.transitions.create(["color", "background-color"], {
    duration: e.transitions.duration.short
  }),
  "&:hover": {
    backgroundColor: (e.vars || e).palette.action.hover,
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: "transparent"
    }
  },
  [`&.${Po.selected}`]: {
    backgroundColor: (e.vars || e).palette.action.selected,
    "&:hover": {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.action.selectedChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.hoverOpacity}))` : tn.alpha(e.palette.action.selected, e.palette.action.selectedOpacity + e.palette.action.hoverOpacity),
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: (e.vars || e).palette.action.selected
      }
    },
    [`&.${Po.focusVisible}`]: {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.action.selectedChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.focusOpacity}))` : tn.alpha(e.palette.action.selected, e.palette.action.selectedOpacity + e.palette.action.focusOpacity)
    },
    [`&.${Po.disabled}`]: {
      opacity: 1,
      color: (e.vars || e).palette.action.disabled,
      backgroundColor: (e.vars || e).palette.action.selected
    }
  }
}, t.size === "small" && {
  minWidth: 26,
  height: 26,
  borderRadius: 26 / 2,
  margin: "0 1px",
  padding: "0 4px"
}, t.size === "large" && {
  minWidth: 40,
  height: 40,
  borderRadius: 40 / 2,
  padding: "0 10px",
  fontSize: e.typography.pxToRem(15)
}, t.shape === "rounded" && {
  borderRadius: (e.vars || e).shape.borderRadius
}), ({
  theme: e,
  ownerState: t
}) => re({}, t.variant === "text" && {
  [`&.${Po.selected}`]: re({}, t.color !== "standard" && {
    color: (e.vars || e).palette[t.color].contrastText,
    backgroundColor: (e.vars || e).palette[t.color].main,
    "&:hover": {
      backgroundColor: (e.vars || e).palette[t.color].dark,
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: (e.vars || e).palette[t.color].main
      }
    },
    [`&.${Po.focusVisible}`]: {
      backgroundColor: (e.vars || e).palette[t.color].dark
    }
  }, {
    [`&.${Po.disabled}`]: {
      color: (e.vars || e).palette.action.disabled
    }
  })
}, t.variant === "outlined" && {
  border: e.vars ? `1px solid rgba(${e.vars.palette.common.onBackgroundChannel} / 0.23)` : `1px solid ${e.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)"}`,
  [`&.${Po.selected}`]: re({}, t.color !== "standard" && {
    color: (e.vars || e).palette[t.color].main,
    border: `1px solid ${e.vars ? `rgba(${e.vars.palette[t.color].mainChannel} / 0.5)` : tn.alpha(e.palette[t.color].main, 0.5)}`,
    backgroundColor: e.vars ? `rgba(${e.vars.palette[t.color].mainChannel} / ${e.vars.palette.action.activatedOpacity})` : tn.alpha(e.palette[t.color].main, e.palette.action.activatedOpacity),
    "&:hover": {
      backgroundColor: e.vars ? `rgba(${e.vars.palette[t.color].mainChannel} / calc(${e.vars.palette.action.activatedOpacity} + ${e.vars.palette.action.focusOpacity}))` : tn.alpha(e.palette[t.color].main, e.palette.action.activatedOpacity + e.palette.action.focusOpacity),
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: "transparent"
      }
    },
    [`&.${Po.focusVisible}`]: {
      backgroundColor: e.vars ? `rgba(${e.vars.palette[t.color].mainChannel} / calc(${e.vars.palette.action.activatedOpacity} + ${e.vars.palette.action.focusOpacity}))` : tn.alpha(e.palette[t.color].main, e.palette.action.activatedOpacity + e.palette.action.focusOpacity)
    }
  }, {
    [`&.${Po.disabled}`]: {
      borderColor: (e.vars || e).palette.action.disabledBackground,
      color: (e.vars || e).palette.action.disabled
    }
  })
})), YK = Fe("div", {
  name: "MuiPaginationItem",
  slot: "Icon",
  overridesResolver: (e, t) => t.icon
})(({
  theme: e,
  ownerState: t
}) => re({
  fontSize: e.typography.pxToRem(20),
  margin: "0 -8px"
}, t.size === "small" && {
  fontSize: e.typography.pxToRem(18)
}, t.size === "large" && {
  fontSize: e.typography.pxToRem(22)
})), kA = /* @__PURE__ */ B.forwardRef(function(e, t) {
  const n = rn({
    props: e,
    name: "MuiPaginationItem"
  }), {
    className: r,
    color: o = "standard",
    component: i,
    components: a = {},
    disabled: s = !1,
    page: c,
    selected: l = !1,
    shape: d = "circular",
    size: f = "medium",
    slots: p = {},
    type: m = "page",
    variant: v = "text"
  } = n, g = He(n, VK), b = re({}, n, {
    color: o,
    disabled: s,
    selected: l,
    shape: d,
    size: f,
    type: m,
    variant: v
  }), x = Qm(), T = UK(b), S = (x ? {
    previous: p.next || a.next || OT,
    next: p.previous || a.previous || PT,
    last: p.first || a.first || gy,
    first: p.last || a.last || my
  } : {
    previous: p.previous || a.previous || PT,
    next: p.next || a.next || OT,
    first: p.first || a.first || gy,
    last: p.last || a.last || my
  })[m];
  return m === "start-ellipsis" || m === "end-ellipsis" ? /* @__PURE__ */ z(qK, {
    ref: t,
    ownerState: b,
    className: Qe(T.root, r),
    children: "…"
  }) : /* @__PURE__ */ _e(GK, re({
    ref: t,
    ownerState: b,
    component: i,
    disabled: s,
    className: Qe(T.root, r)
  }, g, {
    children: [m === "page" && c, S ? /* @__PURE__ */ z(YK, {
      as: S,
      ownerState: b,
      className: T.icon
    }) : null]
  }));
});
process.env.NODE_ENV !== "production" && (kA.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  children: y.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: y.object,
  /**
   * @ignore
   */
  className: y.string,
  /**
   * The active color.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'standard'
   */
  color: y.oneOfType([y.oneOf(["primary", "secondary", "standard"]), y.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: y.elementType,
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */
  components: y.shape({
    first: y.elementType,
    last: y.elementType,
    next: y.elementType,
    previous: y.elementType
  }),
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: y.bool,
  /**
   * The current page number.
   */
  page: y.node,
  /**
   * If `true` the pagination item is selected.
   * @default false
   */
  selected: y.bool,
  /**
   * The shape of the pagination item.
   * @default 'circular'
   */
  shape: y.oneOf(["circular", "rounded"]),
  /**
   * The size of the component.
   * @default 'medium'
   */
  size: y.oneOfType([y.oneOf(["small", "medium", "large"]), y.string]),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: y.shape({
    first: y.elementType,
    last: y.elementType,
    next: y.elementType,
    previous: y.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: y.oneOfType([y.arrayOf(y.oneOfType([y.func, y.object, y.bool])), y.func, y.object]),
  /**
   * The type of pagination item.
   * @default 'page'
   */
  type: y.oneOf(["end-ellipsis", "first", "last", "next", "page", "previous", "start-ellipsis"]),
  /**
   * The variant to use.
   * @default 'text'
   */
  variant: y.oneOfType([y.oneOf(["outlined", "text"]), y.string])
});
const MA = kA, ZK = ["boundaryCount", "className", "color", "count", "defaultPage", "disabled", "getItemAriaLabel", "hideNextButton", "hidePrevButton", "onChange", "page", "renderItem", "shape", "showFirstButton", "showLastButton", "siblingCount", "size", "variant"], XK = (e) => {
  const {
    classes: t,
    variant: n
  } = e;
  return Yt({
    root: ["root", n],
    ul: ["ul"]
  }, zK, t);
}, KK = Fe("nav", {
  name: "MuiPagination",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, t[n.variant]];
  }
})({}), JK = Fe("ul", {
  name: "MuiPagination",
  slot: "Ul",
  overridesResolver: (e, t) => t.ul
})({
  display: "flex",
  flexWrap: "wrap",
  alignItems: "center",
  padding: 0,
  margin: 0,
  listStyle: "none"
});
function QK(e, t, n) {
  return e === "page" ? `${n ? "" : "Go to "}page ${t}` : `Go to ${e} page`;
}
const RA = /* @__PURE__ */ B.forwardRef(function(e, t) {
  const n = rn({
    props: e,
    name: "MuiPagination"
  }), {
    boundaryCount: r = 1,
    className: o,
    color: i = "standard",
    count: a = 1,
    defaultPage: s = 1,
    disabled: c = !1,
    getItemAriaLabel: l = QK,
    hideNextButton: d = !1,
    hidePrevButton: f = !1,
    renderItem: p = (E) => /* @__PURE__ */ z(MA, re({}, E)),
    shape: m = "circular",
    showFirstButton: v = !1,
    showLastButton: g = !1,
    siblingCount: b = 1,
    size: x = "medium",
    variant: T = "text"
  } = n, S = He(n, ZK), {
    items: _
  } = HK(re({}, n, {
    componentName: "Pagination"
  })), w = re({}, n, {
    boundaryCount: r,
    color: i,
    count: a,
    defaultPage: s,
    disabled: c,
    getItemAriaLabel: l,
    hideNextButton: d,
    hidePrevButton: f,
    renderItem: p,
    shape: m,
    showFirstButton: v,
    showLastButton: g,
    siblingCount: b,
    size: x,
    variant: T
  }), k = XK(w);
  return /* @__PURE__ */ z(KK, re({
    "aria-label": "pagination navigation",
    className: Qe(k.root, o),
    ownerState: w,
    ref: t
  }, S, {
    children: /* @__PURE__ */ z(JK, {
      className: k.ul,
      ownerState: w,
      children: _.map((E, R) => /* @__PURE__ */ z("li", {
        children: p(re({}, E, {
          color: i,
          "aria-label": l(E.type, E.page, E.selected),
          shape: m,
          size: x,
          variant: T
        }))
      }, R))
    })
  }));
});
process.env.NODE_ENV !== "production" && (RA.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Number of always visible pages at the beginning and end.
   * @default 1
   */
  boundaryCount: Si,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: y.object,
  /**
   * @ignore
   */
  className: y.string,
  /**
   * The active color.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'standard'
   */
  color: y.oneOfType([y.oneOf(["primary", "secondary", "standard"]), y.string]),
  /**
   * The total number of pages.
   * @default 1
   */
  count: Si,
  /**
   * The page selected by default when the component is uncontrolled.
   * @default 1
   */
  defaultPage: Si,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: y.bool,
  /**
   * Accepts a function which returns a string value that provides a user-friendly name for the current page.
   * This is important for screen reader users.
   *
   * For localization purposes, you can use the provided [translations](/material-ui/guides/localization/).
   * @param {string} type The link or button type to format ('page' | 'first' | 'last' | 'next' | 'previous' | 'start-ellipsis' | 'end-ellipsis'). Defaults to 'page'.
   * @param {number} page The page number to format.
   * @param {bool} selected If true, the current page is selected.
   * @returns {string}
   */
  getItemAriaLabel: y.func,
  /**
   * If `true`, hide the next-page button.
   * @default false
   */
  hideNextButton: y.bool,
  /**
   * If `true`, hide the previous-page button.
   * @default false
   */
  hidePrevButton: y.bool,
  /**
   * Callback fired when the page is changed.
   *
   * @param {React.ChangeEvent<unknown>} event The event source of the callback.
   * @param {number} page The page selected.
   */
  onChange: y.func,
  /**
   * The current page.
   */
  page: Si,
  /**
   * Render the item.
   * @param {PaginationRenderItemParams} params The props to spread on a PaginationItem.
   * @returns {ReactNode}
   * @default (item) => <PaginationItem {...item} />
   */
  renderItem: y.func,
  /**
   * The shape of the pagination items.
   * @default 'circular'
   */
  shape: y.oneOf(["circular", "rounded"]),
  /**
   * If `true`, show the first-page button.
   * @default false
   */
  showFirstButton: y.bool,
  /**
   * If `true`, show the last-page button.
   * @default false
   */
  showLastButton: y.bool,
  /**
   * Number of always visible pages before and after the current page.
   * @default 1
   */
  siblingCount: Si,
  /**
   * The size of the component.
   * @default 'medium'
   */
  size: y.oneOfType([y.oneOf(["small", "medium", "large"]), y.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: y.oneOfType([y.arrayOf(y.oneOfType([y.func, y.object, y.bool])), y.func, y.object]),
  /**
   * The variant to use.
   * @default 'text'
   */
  variant: y.oneOfType([y.oneOf(["outlined", "text"]), y.string])
});
const eJ = RA, lp = {
  $ABBEY: " #45464a",
  $ALABASTER: " #f7f7f7",
  $ALTO: " #d3d3d3",
  $ALTO2: " #dadada",
  $ALUMINIUM: " #a4a8b0",
  $ATHENS_GRAY_DARK: " #edeef1",
  $ATHENS_GRAY_DARK2: " #e3e5ea",
  $ATHENS_GRAY_LIGHT: " #f9f9fb",
  $ATHENS_GRAY: " #f4f4f8",
  $BLACK: " #000000",
  $BRIGHT_GRAY: " #373c48",
  $CARNATION: " #fa5556",
  $CHARADE: " #272a34",
  $DODGER_BLUE: " #1faff3",
  $EMPEROR: " #4f4f4f",
  $EBONY: " #080e18",
  $EBONY_CLAY: " #272d39",
  $FRENCH_GRAY: " #bdc1c7",
  $GALLERY_DARK: " #ebebeb",
  $GALLERY: " #efefef",
  $GHOST2: " #c6c9ce",
  $GRAY_CHATEAU: " #9ea2ab",
  $HALF_AND_HALF: " #ffffde",
  $MAKO: " #444a55",
  $MERCURY: " #e5e5e5",
  $MISCHKA: " #d1d1d7",
  $NEVADA: " #686a6c",
  $NOBEL: " #b6b6b6",
  $OSLO_GRAY: " #888c92",
  $OXFORD_BLUE: " #3a4356",
  $PALE_CANERY: " #ffff9c",
  $PALE_SKY: " #6e7785",
  $PORCELAIN: "rgba(165, 168, 173, 0.25)",
  $PROCELAIN_GRAY: " #e7e8ea",
  $POWDER_BLUE: " #b1e4d7",
  $REGENT_GREY: " #7f899c",
  $SEASHELL: " #f1f1f1",
  $SELECTIVE_YELLOW: " #fbbc04",
  $SELECTIVE_YELLOW2: " #f2b900",
  $SHARK: " #23252d",
  $SHUTTLE_GRAY_DARK: " #5b6372",
  $SHUTTLE_GRAY: " #5c6372",
  $SILVER: " #bbbbbb",
  $SILVER2: " #c5c5c5",
  $SILVER_CHALICE: " #acacac",
  $SUPERNOVA_YELLOW: " #ffcb05",
  $TURQUOISE: " #35d7be",
  $TROPICAL_BLUE: " #c1e1f6",
  $TROUT: " #515866",
  $WILD_SAND: " #f5f5f5",
  $WISTFUL: " #a4a4d5",
  $WHITE: " #ffffff",
  $GHOST: " #c7c9d5",
  $SCIENCE_BLUE: " #0065e3",
  $ALABASTER_DARK: "#f7f7f7",
  $EASTERN_BLUE: "#22ab9f",
  $HONEY_FLOWER: "#53206b",
  $MANATEE: "#9898a4",
  $MIRAGE: "#131326",
  $RUM: "#735482",
  $STORM_GRAY: "#6a6a7c",
  $TUNA: "#363649",
  $MORTAR: "#463a4c",
  $SPARTAN_GRAY: "#e0e1eb",
  $LIGHT_WISTERIA: "#bface1",
  $EAST_SIDE: "#a087cd",
  $MOON_RAKER: "#cbb7ef",
  $DULL_LAVENDAR: "#b297e3"
}, _t = {
  StTextColors: {
    active: "rgba(38, 46, 61, 1)",
    content: "rgba(38, 46, 61, 0.8)",
    secondary: "rgba(38, 46, 61, 0.55)",
    link: "rgba(54, 163, 217, 1)",
    accented: "rgba(12, 14, 18, 1)",
    disabled: "rgba(38, 46, 61, 0.3)"
  },
  StTextColorsDark: {
    active: "rgba(235, 239, 247, 1)",
    content: "rgba(235, 239, 247, 0.8)",
    secondary: "rgba(235, 239, 247, 0.55)",
    disabled: "rgba(235, 239, 247, 0.3)",
    accented: "rgba(255, 255, 255, 1)"
  },
  StUiColors: {
    default: "rgba(38, 46, 61, 0.67)",
    additional: "rgba(38, 46, 61, 0.4)",
    guiding: "rgba(38, 46, 61, 0.1)"
  },
  StUiColorsDark: {
    default: "rgba(235, 239, 247, 0.67)",
    additional: "rgba(235, 239, 247, 0.35)",
    guiding: "rgba(235, 239, 247, 0.17)"
  },
  StBackgroundColors: {
    workspace: "#FFFFFF",
    supporting: "#F9F9FB",
    priority: "#F4F4F8",
    themeAgnostic: "rgba(174, 174, 180, 0.3)"
  },
  StBackgroundColorsDark: {
    workspace: "rgba(20, 21, 23, 1)",
    supporting: "rgba(10, 10, 11, 1)",
    priority: "rgba(9, 9, 10, 1)"
  },
  StPrimaryColors: {
    primary: "#FFC805"
  },
  StInteractionColors: {
    defaultHover: "rgba(12, 14, 18, 0.07)",
    guidingHover: "rgba(38, 46, 61, 0.17)",
    linkHovered: "rgba(50, 147, 197, 1)",
    primaryHovered: "rgba(242, 185, 0, 1)"
  },
  StInteractionColorsDark: {
    defaultHover: "rgba(255, 255, 255, 0.15)",
    guidingHover: "rgba(235, 239, 247, 0.17)",
    linkHovered: "rgba(54, 163, 217, 1)"
  },
  StSemanticColors: {
    info: "rgba(52, 150, 200, 1)",
    success: "rgba(34, 195, 195, 1)",
    warning: "rgba(242, 185, 0, 1)",
    error: "rgba(231, 71, 39, 1)",
    infoBG: "rgba(52, 150, 200, 0.1)",
    successBG: "rgba(34, 195, 195, 0.1)",
    warningBG: "rgba(242, 185, 0, 0.1)",
    errorBG: "rgba(231, 71, 39, 0.1)"
  }
}, tJ = {
  Shadows: {
    level1: "0px 1px 2px rgba(9, 9, 10, 0.1), 0px 2px 4px rgba(9, 9, 10, 0.1)",
    level2: "drop-shadow(0px 1px 4px rgba(9, 9, 10, 0.1)) drop-shadow(0px 1px 8px rgba(9, 9, 10, 0.15))"
  }
}, PA = hs({
  components: {
    MuiButton: {
      variants: [
        {
          props: { variant: "gray" },
          style: {
            backgroundColor: _t.StUiColors.guiding,
            color: _t.StInteractionColors.linkHovered,
            "&:hover": {
              backgroundColor: _t.StInteractionColors.guidingHover
            },
            "&:disabled": {
              backgroundColor: "#EDEEF2"
            }
          }
        },
        {
          props: { variant: "contained" },
          style: {
            "&:disabled": {
              backgroundColor: _t.StPrimaryColors.primary
            }
          }
        },
        {
          props: { variant: "outlined" },
          style: {
            backgroundColor: _t.StBackgroundColors.workspace,
            color: _t.StInteractionColors.linkHovered,
            border: `1px solid ${lp.$SHUTTLE_GRAY_DARK}`,
            "&:hover": {
              backgroundColor: _t.StBackgroundColors.workspace,
              border: `1px solid ${lp.$SHUTTLE_GRAY_DARK}`
            },
            "&:disabled": {
              backgroundColor: _t.StBackgroundColors.workspace
            }
          }
        },
        {
          props: { variant: "text" },
          style: {
            color: _t.StTextColors.link,
            "&:hover": {
              backgroundColor: _t.StInteractionColors.guidingHover
            },
            "&:disabled": {
              backgroundColor: _t.StBackgroundColors.workspace
            }
          }
        }
      ],
      styleOverrides: {
        root: {
          borderRadius: "4px",
          height: "28px",
          lineHeight: "24px",
          minHeight: 0,
          textTransform: "none",
          color: _t.StTextColors.active,
          boxShadow: "none",
          "&:hover": {
            backgroundColor: _t.StInteractionColors.primaryHovered,
            boxShadow: "none"
          },
          "&:disabled": {
            color: lp.$SHUTTLE_GRAY_DARK,
            opacity: ".3"
          }
        }
      }
    },
    MuiLink: {
      styleOverrides: {
        root: {
          color: "#1FAFF3",
          "&:hover": {
            color: "#0065e3",
            textDecoration: "none"
          }
        }
      }
    },
    MuiTypography: {
      defaultProps: {
        color: lp.$SHUTTLE_GRAY_DARK
      }
    }
  },
  typography: {
    fontFamily: "Open Sans",
    fontSize: 13
  },
  palette: {
    primary: {
      light: "#757ce8",
      main: _t.StPrimaryColors.primary,
      dark: _t.StPrimaryColors.primary,
      contrastText: _t.StBackgroundColors.workspace
    },
    secondary: {
      light: "#ff7961",
      main: "#f44336",
      dark: "#ba000d",
      contrastText: "#000"
    },
    success: {
      light: "#5BE584",
      main: "#00AB55",
      dark: "#007B55"
    }
  }
});
PA.shadows[1] = "0px 0px 5px rgba(58, 67, 86, 0.2)";
PA.shadows[2] = "0 1px 3px 1px rgba(58, 67, 86, 0.3)";
const nJ = hs({
  components: {
    MuiIcon: {
      styleOverrides: {
        root: {
          color: `${_t.StPrimaryColors.primary}`,
          top: 0
        }
      }
    },
    MuiSvgIcon: {
      // styleOverrides: {
      //     root: {
      //         fill: utils.makeASlightlyDifferentColor(
      //             themeService.getDesignSettings().typography.primaryTextColor,
      //             0.9,
      //         ),
      //     },
      // },
    }
  }
}), rJ = (e) => {
  const { name: t, sx: n } = e, r = Xe("app-icon__svg");
  return /* @__PURE__ */ _e(py, { classes: { root: r }, sx: n, inheritViewBox: !0, children: [
    /* @__PURE__ */ z("use", { xlinkHref: `#${t}` }),
    /* @__PURE__ */ z("symbol", { id: "general-arrow-big-down", viewBox: "0 0 24 24", children: /* @__PURE__ */ z(
      "path",
      {
        fill: "currentColor",
        d: "M7.589 10L7 10.777 11.99 15 17 10.777 16.413 10l-4.422 3.727z"
      }
    ) }),
    /* @__PURE__ */ z("symbol", { id: "general-arrow-left", viewBox: "0 0 24 24", children: /* @__PURE__ */ z(
      "path",
      {
        fill: "currentColor",
        d: "M13.878 9.325a.5.5 0 1 0-.76-.65l-2.998 3.5a.5.5 0 0 0 0 .65l2.999 3.5a.5.5 0 1 0 .76-.65l-2.72-3.175 2.72-3.175z"
      }
    ) }),
    /* @__PURE__ */ z("symbol", { id: "general-arrow-long-right", viewBox: "0 0 29 8", children: /* @__PURE__ */ z(
      "path",
      {
        d: "M28.354 4.354a.5.5 0 0 0 0-.708L25.172.464a.5.5 0 1 0-.707.708L27.293 4l-2.828 2.828a.5.5 0 1 0 .707.708l3.182-3.182zM0 4.5h28v-1H0v1z",
        fill: "#3A4356"
      }
    ) }),
    /* @__PURE__ */ z("symbol", { id: "general-arrow-right", viewBox: "0 0 24 24", children: /* @__PURE__ */ z(
      "path",
      {
        fill: "currentColor",
        d: "M13.34 12.5l-2.72-3.175a.5.5 0 1 1 .76-.65l2.998 3.5a.5.5 0 0 1 0 .65l-2.998 3.5a.5.5 0 1 1-.76-.65l2.72-3.175z"
      }
    ) }),
    /* @__PURE__ */ z("symbol", { id: "general-arrow-up", viewBox: "0 0 24 24", children: /* @__PURE__ */ z(
      "path",
      {
        fill: "currentColor",
        d: "M12 10.16l-3.174 2.719a.5.5 0 0 1-.65-.76l3.5-2.998a.5.5 0 0 1 .65 0l3.5 2.998a.5.5 0 1 1-.65.76L12 10.159z"
      }
    ) }),
    /* @__PURE__ */ z("symbol", { id: "general-arrow-up-down", viewBox: "0 0 24 24", children: /* @__PURE__ */ z(
      "path",
      {
        fill: "currentColor",
        d: "M15.646 14.646a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L12 18.293l3.646-3.647zm0-5.292L12 5.707 8.354 9.354a.5.5 0 1 1-.708-.708l4-4a.5.5 0 0 1 .708 0l4 4a.5.5 0 0 1-.708.708z"
      }
    ) }),
    /* @__PURE__ */ z("symbol", { id: "general-double-arrow-back", viewBox: "0 0 24 24", children: /* @__PURE__ */ z(
      "path",
      {
        fill: "currentColor",
        d: "M9.658 12.5l2.72 3.175a.5.5 0 1 1-.76.65l-2.998-3.5a.5.5 0 0 1 0-.65l2.999-3.5a.5.5 0 1 1 .76.65L9.658 12.5zm5.719-3.175l-2.72 3.175 2.72 3.175a.5.5 0 1 1-.76.65l-2.998-3.5a.5.5 0 0 1 0-.65l2.998-3.5a.5.5 0 1 1 .76.65z"
      }
    ) }),
    /* @__PURE__ */ z("symbol", { id: "general-double-arrow-front", viewBox: "0 0 24 24", children: /* @__PURE__ */ z(
      "path",
      {
        fill: "currentColor",
        d: "M11.34 12.5L8.62 9.325a.5.5 0 0 1 .76-.65l2.998 3.5a.5.5 0 0 1 0 .65l-2.998 3.5a.5.5 0 1 1-.76-.65l2.72-3.175zm.279-3.175a.5.5 0 0 1 .76-.65l2.998 3.5a.5.5 0 0 1 0 .65l-2.999 3.5a.5.5 0 1 1-.76-.65l2.72-3.175-2.72-3.175z"
      }
    ) }),
    /* @__PURE__ */ z("symbol", { id: "general-double-big-arrow-back", viewBox: "0 0 31 31", children: /* @__PURE__ */ _e("g", { fill: "currentColor", children: [
      /* @__PURE__ */ z("path", { d: "M16 11.825l-3.842 4.297 3.662 4.087a.5.5 0 1 1-.76.65l-3.94-4.412a.5.5 0 0 1 0-.65l4.12-4.622a.5.5 0 1 1 .76.65zm5 0l-3.842 4.297 3.662 4.087a.5.5 0 1 1-.76.65l-3.94-4.412a.5.5 0 0 1 0-.65l4.12-4.622a.5.5 0 1 1 .76.65z" }),
      /* @__PURE__ */ z("path", { d: "M10 11.5a.5.5 0 0 1 1 0v9a.5.5 0 0 1-1 0v-9z" })
    ] }) }),
    /* @__PURE__ */ z("symbol", { id: "general-double-big-arrow-front", viewBox: "0 0 31 31", children: /* @__PURE__ */ _e("g", { fill: "currentColor", children: [
      /* @__PURE__ */ z("path", { d: "M15 20.175l3.842-4.297-3.662-4.087a.5.5 0 1 1 .76-.65l3.94 4.412a.5.5 0 0 1 0 .65l-4.12 4.622a.5.5 0 1 1-.76-.65zm-5 0l3.842-4.297-3.662-4.087a.5.5 0 1 1 .76-.65l3.94 4.412a.5.5 0 0 1 0 .65l-4.12 4.622a.5.5 0 1 1-.76-.65z" }),
      /* @__PURE__ */ z("path", { d: "M21 20.5a.5.5 0 0 1-1 0v-9a.5.5 0 0 1 1 0v9z" })
    ] }) }),
    /* @__PURE__ */ z("symbol", { id: "general-x", viewBox: "0 0 24 24", children: /* @__PURE__ */ z(
      "path",
      {
        fill: "currentColor",
        d: "M12 12.293L6.854 7.146a.5.5 0 1 0-.708.708L11.293 13l-5.147 5.146a.5.5 0 0 0 .708.708L12 13.707l5.146 5.147a.5.5 0 0 0 .708-.708L12.707 13l5.147-5.146a.5.5 0 0 0-.708-.708L12 12.293z"
      }
    ) })
  ] });
}, nc = nl((e, t) => {
  const { dataTestId: n, name: r, className: o } = e, i = /* @__PURE__ */ z(rJ, pe({}, e)), a = Xe("app-icon", `app-icon--${r}`, o);
  return /* @__PURE__ */ z(ll, { theme: nJ, children: /* @__PURE__ */ z("span", $e(pe({ "data-testid": n }, e), { ref: t, className: a, children: i })) });
}), NT = "24px", oJ = "24px", iJ = hs({
  components: {
    MuiPagination: {
      styleOverrides: {
        root: {
          display: "flex",
          justifyContent: "space-around",
          flexGrow: 1,
          ".MuiPagination-ul": {
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
            height: NT
          }
        }
      }
    },
    MuiPaginationItem: {
      styleOverrides: {
        root: {
          height: NT,
          minWidth: oJ,
          margin: "0 2px",
          "&.Mui-selected": {
            border: `1px solid ${_t.StUiColors.default}`,
            borderRadius: "12px",
            backgroundColor: "transparent",
            "&:hover": {
              backgroundColor: _t.StBackgroundColors.themeAgnostic
              // color: themeService.getDesignSettings().typography.primaryTextColor,
            }
          },
          "&:hover": {
            backgroundColor: _t.StBackgroundColors.themeAgnostic
            // color: themeService.getDesignSettings().typography.primaryTextColor,
          },
          "&.MuiPaginationItem-ellipsis": {
            background: "transparent",
            fontFamily: "Open Sans",
            fontWeight: "400",
            fontSize: "13px",
            lineHeight: "18px",
            paddingTop: "4px"
          },
          "&.MuiPaginationItem-firstLast": {
            display: "none"
          },
          "&.MuiPaginationItem-previousNext": {
            width: "40px"
          }
        }
      }
    }
  }
}), aJ = hs({
  components: {
    MuiTypography: {
      variants: [
        {
          props: { variant: "titleHero" },
          style: {
            fontWeight: 600,
            fontSize: 30,
            lineHeight: "36px",
            letterSpacing: -0.5
          }
        },
        {
          props: { variant: "titleBig" },
          style: {
            fontWeight: 400,
            fontSize: 21,
            lineHeight: "24px",
            letterSpacing: -0.2
          }
        },
        {
          props: { variant: "titleMedium" },
          style: {
            fontWeight: 600,
            fontSize: "18px",
            lineHeight: "24px"
          }
        },
        {
          props: { variant: "titleSmall" },
          style: {
            fontWeight: 600,
            fontSize: "15px",
            lineHeight: "20px"
          }
        },
        {
          props: { variant: "subTitle" },
          style: {
            fontWeight: 700,
            fontSize: "13px",
            lineHeight: "16px",
            letterSpacing: "0.2px"
          }
        },
        {
          props: { variant: "bodyLabel" },
          style: {
            fontWeight: 400,
            fontSize: "13px",
            lineHeight: "16px",
            letterSpacing: "0.1px"
          }
        },
        {
          props: { variant: "laccent" },
          style: {
            fontWeight: 600,
            fontSize: "13px",
            lineHeight: "16px",
            letterSpacing: "0.1px"
          }
        },
        {
          props: { variant: "bodyParagraph" },
          style: {
            fontWeight: 400,
            fontSize: "13px",
            lineHeight: "18px"
          }
        },
        {
          props: { variant: "paccent" },
          style: {
            fontWeight: 600,
            fontSize: "13px",
            lineHeight: "18px"
          }
        },
        {
          props: { variant: "bodyUI" },
          style: {
            fontWeight: 400,
            fontSize: "13px",
            lineHeight: "20px",
            letterSpacing: "0.3px"
          }
        },
        {
          props: { variant: "overline" },
          style: {
            fontWeight: 400,
            fontSize: "11px",
            lineHeight: "16px",
            letterSpacing: "1.5px"
          }
        },
        {
          props: { variant: "caption" },
          style: {
            fontWeight: 700,
            fontSize: "11px",
            lineHeight: "14px",
            letterSpacing: "0.5px"
          }
        },
        {
          props: { variant: "annotation" },
          style: {
            fontWeight: 400,
            fontSize: "11px",
            lineHeight: "16px",
            letterSpacing: "0.3px"
          }
        },
        {
          props: { variant: "code" },
          style: {
            fontFamily: "Hack",
            fontWeight: 400,
            fontSize: "13px",
            lineHeight: "20px"
          }
        }
      ],
      styleOverrides: {
        root: {
          display: "inline-block",
          fontFamily: "Open Sans",
          color: _t.StTextColors.content,
          "::first-letter": {
            textTransform: "capitalize"
          }
        }
      }
    }
  }
}), Xp = et.forwardRef(
  (e, t) => {
    var n = e, { children: r, theme: o = aJ, dataTestId: i } = n, a = Wn(n, ["children", "theme", "dataTestId"]);
    return /* @__PURE__ */ z(ll, { theme: o, children: /* @__PURE__ */ z(YY, $e(pe({ ref: t }, a), { "data-testid": i, children: r })) });
  }
), AT = 1, sJ = et.forwardRef(
  ({ onPageChange: e, count: t, rowsPerPage: n, page: r }, o) => {
    const i = rl(TA), a = (s, c) => e(null, c);
    return /* @__PURE__ */ z(ll, { theme: iJ, children: /* @__PURE__ */ z(
      eJ,
      {
        ref: o,
        count: Math.ceil(t / n),
        page: r + AT,
        siblingCount: i.siblingCount,
        onChange: a,
        showFirstButton: !0,
        showLastButton: !0,
        size: "small",
        boundaryCount: AT,
        renderItem: (s) => /* @__PURE__ */ z(
          MA,
          $e(pe({
            components: {
              first: () => /* @__PURE__ */ z(
                nc,
                {
                  sx: { color: _t.StUiColors.additional },
                  name: "general-double-arrow-back"
                }
              ),
              last: () => /* @__PURE__ */ z(
                nc,
                {
                  sx: { color: _t.StUiColors.additional },
                  name: "general-double-arrow-front"
                }
              ),
              next: () => /* @__PURE__ */ z(
                nc,
                {
                  sx: { color: _t.StUiColors.additional },
                  name: "general-arrow-right"
                }
              ),
              previous: () => /* @__PURE__ */ z(
                nc,
                {
                  sx: { color: _t.StUiColors.additional },
                  name: "general-arrow-left"
                }
              )
            }
          }, s), {
            page: /* @__PURE__ */ z(Xp, { variant: "bodyLabel", dataTestId: `PaginationPage-${s.page}`, children: s.page })
          })
        ),
        "data-testid": "PaginationActionsComponent"
      }
    ) });
  }
), lJ = hs({
  breakpoints: {
    values: yi
  },
  components: {
    MuiTablePagination: {
      styleOverrides: {
        root: {
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
          width: "100%"
        },
        toolbar: {
          "&.MuiTablePagination-toolbar": {
            display: "flex",
            flexDirection: "row",
            padding: "0px 20px 0 20px",
            alignItems: "center",
            height: "30px",
            width: "100%"
          },
          ".Mui-selected": {
            margin: 0
          }
        },
        spacer: {
          display: "none"
        },
        displayedRows: {
          whiteSpace: "nowrap"
        },
        selectLabel: {
          order: 4,
          paddingLeft: "20px"
        },
        input: {
          order: 5,
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          borderRadius: "4px",
          marginRight: "0"
        },
        select: {
          "&.MuiTablePagination-select": {
            background: "transparent"
          }
        },
        selectIcon: {
          position: "absolute",
          top: "8%"
        },
        menuItem: {
          paddingLeft: "10px",
          "&.MuiTablePagination-menuItem.Mui-selected": {
            position: "relative",
            background: "transparent",
            // '&:hover': {
            //     backgroundColor:
            //         themeService.getDesignSettings().typography.primaryTextColor,
            //     color: themeService.getDesignSettings().typography.primaryTextColor,
            // },
            "&:after": {
              marginLeft: "15px",
              content: '""',
              display: "block",
              position: "absolute",
              width: "24px",
              height: "24px",
              top: "3px",
              backgroundImage: `url("data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M16.2604 8.58124L10.9174 16.0615L7 12.1442L7.70711 11.4371L10.7898 14.5197L15.4467 8L16.2604 8.58124Z' fill='%235B6372'/%3E%3C/svg%3E%0A")`
            }
          },
          "&.MuiTablePagination-menuItem": {
            fontFamily: "inherit",
            fontWeight: "400",
            fontSize: "13px",
            lineHeight: "18px",
            color: _t.StTextColors.content
          },
          "&:hover": {
            backgroundColor: _t.StBackgroundColors.priority
          }
        },
        actions: {
          marginLeft: 0
        }
      }
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          padding: "4px 0px",
          gap: "4px",
          marginTop: "4px",
          background: _t.StBackgroundColors.workspace,
          boxShadow: tJ.Shadows.level1,
          borderRadius: "4px"
        }
      }
    },
    MuiList: {
      styleOverrides: {
        root: {
          padding: 0,
          width: "100%"
        }
      }
    }
  }
}), cJ = 1, uJ = et.forwardRef(
  // eslint-disable-next-line max-lines-per-function
  (e, t) => {
    var n = e, {
      count: r,
      page: o,
      rowsPerPage: i,
      onRowsPerPageChange: a,
      displayedLabelRows: s,
      onPageChange: c,
      labelRowsPerPage: l,
      labelRowsPerPageShort: d = "Rows",
      rowsPerPageOptions: f = [10, 25, 50, 75],
      theme: p = lJ,
      dataTestId: m,
      style: v
    } = n;
    Wn(n, [
      "count",
      "page",
      "rowsPerPage",
      "onRowsPerPageChange",
      "displayedLabelRows",
      "onPageChange",
      "labelRowsPerPage",
      "labelRowsPerPageShort",
      "rowsPerPageOptions",
      "theme",
      "dataTestId",
      "style"
    ]);
    const [g, { width: b }] = LK(), x = b < yi.lg, T = ({
      from: E,
      to: R,
      count: P
    }) => {
      const A = x ? `${E}-${R} / ${P}` : `${E}-${R} ${s.conjunction} ${P} ${s.result}`;
      return /* @__PURE__ */ z(Xp, { variant: "bodyParagraph", sx: { color: _t.StTextColors.secondary }, children: A });
    }, S = (E, R) => c(R), _ = (E) => a(Number(E.target.value)), w = FK(b), k = {
      siblingCount: x ? 0 : 1
    };
    return /* @__PURE__ */ z(ll, { theme: p, children: /* @__PURE__ */ z(TA.Provider, { value: k, children: /* @__PURE__ */ z("div", { className: `${$K} ${w}`, ref: g, children: /* @__PURE__ */ z(
      PK,
      {
        ref: t,
        component: "div",
        count: r,
        page: o - cJ,
        ActionsComponent: sJ,
        onPageChange: S,
        onRowsPerPageChange: _,
        rowsPerPage: i,
        rowsPerPageOptions: f,
        labelDisplayedRows: T,
        slotProps: {
          select: {
            SelectDisplayProps: {
              "data-testid": "TablePaginationSelect"
            },
            IconComponent: (E) => /* @__PURE__ */ z(nc, $e(pe({}, E), { name: "general-arrow-big-down" })),
            renderValue: (E) => /* @__PURE__ */ z(Xp, { variant: "bodyParagraph", children: String(E) }),
            MenuProps: {
              sx: {
                ".MuiPaper-root": {
                  fontFamily: v == null ? void 0 : v.fontFamily
                }
              }
            }
          }
        },
        labelRowsPerPage: /* @__PURE__ */ z(Xp, { variant: "bodyParagraph", children: x ? d : l }),
        "data-testid": m
      }
    ) }) }) });
  }
), vy = {
  isMobile: !1,
  conjunctionLabel: "of",
  resultLabel: "Results",
  rowsPerPageLabel: "Results per page",
  rowsPerPageLabelShort: "Rows",
  notifyRowsLimitLabel: "The Pivot table is limited to {{recordsCount}} records",
  notifyColumnsLimitLabel: "The Pivot table is limited to {{columnsCount}} columns",
  notifyRowsAndColumnsLimitLabel: "The Pivot table is limited to {{recordsCount}} records and {{columnsCount}} columns",
  alertIcon: "<div>!</div>",
  numberFormatter: null,
  onNotificationMoreClick: null
};
class OA extends B.PureComponent {
  constructor(t) {
    super(t), Z(this, "logger"), Z(this, "panel"), Z(this, "listFirst"), Z(this, "listLast"), Z(this, "listNumbers"), Z(this, "rowsEl"), Z(this, "totalEl"), Z(this, "notificationEl"), Z(this, "oldSize"), Z(this, "notificationStr"), Z(this, "notificationFallback"), Z(this, "onHeightChangeMemoizer", $b(!1)), Z(this, "handlePageSelected", (c) => {
      const l = c === 0 ? c : c - 1;
      this.props.activePage !== l && this.notifyOnPageChange(l);
    }), Z(this, "onRowsPerPageChange", (c) => {
      const { onItemsPerPageChange: l } = this.props;
      typeof l != "undefined" && typeof l == "function" && l(c);
    }), Z(this, "onNotificationMoreClick", (c) => {
      const { columnsCount: l, itemsCount: d, limitCount: f } = this.props;
      if (this.props.options) {
        const { onNotificationMoreClick: p } = this.props.options;
        p && p(c, {
          columnsCount: l,
          columnsLimitReached: this.isColumnsLimitReached(this.props),
          rowsCount: d,
          rowsLimitReached: this.isRowsLimitReached(this.props),
          recordsCount: f
        });
      }
    }), Z(this, "panelRef", (c) => {
      c && (this.panel = c);
    });
    const { itemsCount: n, itemsPerPage: r, options: o, style: i } = this.props;
    this.logger = ds.create("PaginationPanel");
    const a = Math.ceil(n / r) || 0, s = $e(pe(pe({}, vy), o), { style: i });
    this.state = {
      pagesCount: a,
      options: s
    };
  }
  componentDidMount() {
    const { activePage: t, disableInitialCallback: n } = this.props;
    this.provideHeightUpdate(), n || this.notifyOnPageChange(t);
  }
  UNSAFE_componentWillReceiveProps(t) {
    let n = null;
    if (t.itemsCount !== this.props.itemsCount || t.itemsPerPage !== this.props.itemsPerPage) {
      n = n || {};
      const i = Math.ceil(t.itemsCount / t.itemsPerPage) || 0;
      n.pagesCount = i;
    }
    if ((t.itemsCount !== this.props.itemsCount || t.itemsPerPage !== this.props.itemsPerPage || t.activePage !== this.props.activePage || t.totalItemsCount !== this.props.totalItemsCount || t.columnsCount !== this.props.columnsCount || t.totalColumnsCount !== this.props.totalColumnsCount || t.limitReached !== this.props.limitReached || t.limitCount !== this.props.limitCount) && (this.notificationStr = void 0), t.options !== this.props.options) {
      n = n || {};
      const i = pe(pe({}, vy), t.options);
      n.options = i;
    }
    const r = t.options || {}, o = this.props.options || {};
    (t.width !== this.props.width || t.itemsCount !== this.props.itemsCount || t.totalItemsCount !== this.props.totalItemsCount || t.columnsCount !== this.props.columnsCount || t.totalColumnsCount !== this.props.totalColumnsCount || t.limitReached !== this.props.limitReached || t.limitCount !== this.props.limitCount || t.itemsPerPage !== this.props.itemsPerPage || t.activePage !== this.props.activePage || r.isMobile !== o.isMobile) && (this.oldSize = void 0), n && this.setState(n);
  }
  componentDidUpdate() {
    this.provideHeightUpdate();
  }
  getHeight() {
    return this.panel && this.panel.offsetHeight || 0;
  }
  getNotificationStr() {
    const { itemsCount: t, itemsPerPage: n, activePage: r, totalColumnsCount: o, columnsCount: i, limitCount: a } = this.props, { options: s } = this.state, { notifyRowsLimitLabel: c, notifyColumnsLimitLabel: l, notifyRowsAndColumnsLimitLabel: d } = s || {}, f = this.isRowsLimitReached(this.props), p = this.isColumnsLimitReached(this.props);
    let m = () => "";
    f && p ? m = Pv(d || "") : f ? m = Pv(c || "") : p && (m = Pv(l || ""));
    let v = t, g = a;
    if (this.props.options) {
      const b = {
        type: "number",
        separated: !0,
        abbreviations: { k: !0, m: !0 }
      }, { numberFormatter: x } = this.props.options;
      x && (v = x(v, b), g = x(g, b));
    }
    return this.notificationStr = m({
      columnsCount: i,
      totalColumnsCount: o,
      rowsCount: v,
      recordsCount: g
    }), this.notificationFallback = /* @__PURE__ */ z("div", {}), o === 0 && i === 0 && (this.notificationFallback = null), {
      notificationStr: this.notificationStr,
      notificationFallback: this.notificationFallback
    };
  }
  isRowsLimitReached(t = this.props) {
    return t.limitReached;
  }
  isColumnsLimitReached(t = this.props) {
    return t.totalColumnsCount > t.columnsCount;
  }
  /**
   * Notify about paginator container height change
   *
   * @returns {void}
   * @private
   */
  provideHeightUpdate() {
    const { onHeightChange: t } = this.props;
    t && this.panel && this.onHeightChangeMemoizer({
      callback: ({ offsetHeight: n }) => {
        t(n);
      },
      indices: {
        offsetHeight: this.getHeight()
      }
    });
  }
  /**
   *  Callback for Parent Components
   *
   * @param {number} selectedItem - selected page number
   * @returns {void}
   * @private
   */
  notifyOnPageChange(t) {
    const { onPageChange: n } = this.props;
    typeof n != "undefined" && typeof n == "function" && n({ selected: t });
  }
  render() {
    const { className: t, activePage: n, itemsPerPage: r, itemsCount: o, totalItemsCount: i } = this.props, { pagesCount: a, options: s } = this.state, {
      isMobile: c,
      alertIcon: l,
      conjunctionLabel: d,
      resultLabel: f,
      rowsPerPageLabel: p,
      rowsPerPageLabelShort: m
    } = s, v = i > o && a === 1, g = n > -1 && a > 1, b = this.isRowsLimitReached(this.props) || this.isColumnsLimitReached(this.props), x = Xe(
      t,
      L7,
      !g && !v && !b ? z7 : "",
      g ? F7 : "",
      c ? j7 : B7,
      v ? H7 : "",
      b ? W7 : ""
    ), { notificationStr: T, notificationFallback: S } = this.getNotificationStr(), _ = { width: "100%", height: "" };
    return /* @__PURE__ */ z("div", { className: "sis-scope", children: /* @__PURE__ */ z("div", { className: x, "data-html2canvas-ignore": "true", ref: this.panelRef, children: /* @__PURE__ */ z(I_, { style: _, autoHeight: !0, children: /* @__PURE__ */ _e("div", { className: $7, children: [
      T ? /* @__PURE__ */ z("div", { className: U7, title: T, children: /* @__PURE__ */ z(
        "div",
        {
          role: "button",
          tabIndex: 0,
          onClick: this.onNotificationMoreClick,
          onKeyPress: this.onNotificationMoreClick,
          dangerouslySetInnerHTML: {
            __html: l
          },
          "aria-label": "alert"
        }
      ) }) : S,
      /* @__PURE__ */ z("div", { className: V7, children: /* @__PURE__ */ z(
        uJ,
        {
          count: o,
          page: n + 1,
          rowsPerPage: r,
          displayedLabelRows: {
            conjunction: d,
            result: f
          },
          rowsPerPageOptions: [10, 25, 50, 75],
          labelRowsPerPage: p,
          labelRowsPerPageShort: m,
          dataTestId: "TablePagination",
          onPageChange: this.handlePageSelected,
          onRowsPerPageChange: this.onRowsPerPageChange,
          style: this.props.style
        }
      ) })
    ] }) }) }) });
  }
}
Z(OA, "defaultProps", {
  isAllDataLoaded: !1,
  activePage: 0,
  disableInitialCallback: !0,
  className: "",
  options: pe({}, vy),
  onHeightChange: null,
  onPageChange: null
});
const fw = (e) => {
  switch (e.metadataType) {
    case Ke.MEASURES:
      return En.ASC;
    default:
      return En.DESC;
  }
}, DT = "sisense-pivot", dJ = "sisense-pivot__multi-grid", fJ = "sisense-pivot__overlay", $n = "#5B6372", ri = "rgba(244, 244, 244, 1)", Aa = "rgba(239, 239, 239, 1)", pJ = Fo.div`
  &,
  .table-grid {
    background-color: ${(e) => e.backgroundColor};
    font-family: ${(e) => e.fontFamily};
  }

  .table-grid__row > .table-grid__cell {
    color: ${(e) => e.textColor || $n};
  }

  ${(e) => {
  var t;
  return ((t = e.fillOptions) == null ? void 0 : t.alternatingRows) && ra`
      .table-grid__cell--data.table-grid__cell--row-level-last.table-grid__cell--row-sibling-odd:not(
          .table-grid__cell--row-user-type-subTotal
        ):not(.table-grid__cell--row-user-type-grandTotal):not(.table-grid__cell--drilled):not(
          .table-grid__cell--selected
        ) {
        background-color: ${e.fillColor || ri};
        color: ${e.textColor || $n};
      }
      .table-grid__cell--rows.table-grid__cell--level-last.table-grid__cell--sibling-odd:not(
          .table-grid__cell--user-type-subTotal
        ):not(.table-grid__cell--user-type-grandTotal):not(.table-grid__cell--drilled):not(
          .table-grid__cell--selected
        ) {
        background-color: ${e.fillColor || ri};
        color: ${e.textColor || $n};
      }
      .table-grid--bottom.table-grid--right
        .table-grid__cell--row-level-last.table-grid__cell--row-sibling-odd:not(
          .table-grid__cell--row-user-type-subTotal
        ):not(.table-grid__cell--row-user-type-grandTotal):not(.table-grid__cell--drilled):not(
          .table-grid__cell--selected
        ) {
        background-color: ${e.fillColor || ri};
        color: ${e.textColor || $n};
      }
      .table-grid--bottom.table-grid--left
        .table-grid__cell--level-last.table-grid__cell--sibling-odd:not(
          .table-grid__cell--user-type-subTotal
        ):not(.table-grid__cell--user-type-grandTotal):not(.table-grid__cell--drilled):not(
          .table-grid__cell--selected
        ) {
        background-color: ${e.fillColor || ri};
        color: ${e.textColor || $n};
      }
    `;
}}

  ${(e) => {
  var t;
  return ((t = e.fillOptions) == null ? void 0 : t.alternatingColumns) && ra`
      .table-grid--bottom.table-grid--left .table-grid__column:nth-of-type(even),
      .table-grid--bottom.table-grid--right .table-grid__column:nth-of-type(even) {
        background-color: ${e.fillColor || ri};
        color: ${e.textColor || $n};
      }
    `;
}}

  ${(e) => {
  var t;
  return ((t = e.fillOptions) == null ? void 0 : t.columnsHeaders) && ra`
      .table-grid--top.table-grid--left
        .table-grid__cell:not(.table-grid__cell--drilled):not(.table-grid__cell--selected),
      .table-grid--top.table-grid--right
        .table-grid__cell:not(.table-grid__cell--drilled):not(.table-grid__cell--selected) {
        background-color: ${e.fillColor || ri};
        color: ${e.textColor || $n};
      }
      .table-grid__cell--corner.table-grid__cell:not(.table-grid__cell--drilled):not(
          .table-grid__cell--selected
        ),
      .table-grid__cell--columns.table-grid__cell:not(.table-grid__cell--drilled):not(
          .table-grid__cell--selected
        ) {
        background-color: ${e.fillColor || ri};
        color: ${e.textColor || $n};
      }
    `;
}}

  ${(e) => {
  var t;
  return ((t = e.fillOptions) == null ? void 0 : t.rowMembers) && ra`
      .table-grid--bottom.table-grid--left
        .table-grid__cell:not(.table-grid__cell--drilled):not(.table-grid__cell--selected):not(
          .table-grid__cell--user-type-subTotal
        ):not(.table-grid__cell--user-type-grandTotal) {
        background-color: ${e.fillColor || ri};
        color: ${e.textColor || $n};
      }
      .table-grid__cell--rows.table-grid__cell:not(.table-grid__cell--drilled):not(
          .table-grid__cell--selected
        ):not(.table-grid__cell--user-type-subTotal):not(.table-grid__cell--user-type-grandTotal) {
        background-color: ${e.fillColor || ri};
        color: ${e.textColor || $n};
      }
    `;
}}

  ${(e) => {
  var t;
  return ((t = e.fillOptions) == null ? void 0 : t.rowMembers) && ra`
      .table-grid--bottom.table-grid--left
        .table-grid__cell:not(.table-grid__cell--drilled):not(.table-grid__cell--selected):not(
          .table-grid__cell--user-type-subTotal
        ):not(.table-grid__cell--user-type-grandTotal) {
        background-color: ${e.fillColor || ri};
        color: ${e.textColor || $n};
      }
      .table-grid__cell--rows.table-grid__cell:not(.table-grid__cell--drilled):not(
          .table-grid__cell--selected
        ):not(.table-grid__cell--user-type-subTotal):not(.table-grid__cell--user-type-grandTotal) {
        background-color: ${e.fillColor || ri};
        color: ${e.textColor || $n};
      }
    `;
}}

  ${(e) => {
  var t;
  return ((t = e.fillOptions) == null ? void 0 : t.totals) && ra`
      .table-grid--bottom.table-grid--left .table-grid__cell--user-type-subTotal,
      .table-grid--bottom.table-grid--left .table-grid__cell--user-type-grandTotal {
        background-color: ${e.additionalFillColor || Aa};
        color: ${e.textColor || $n};
      }
      .table-grid--bottom.table-grid--right {
        .table-grid__cell--row-user-type-subTotal,
        .table-grid__cell--row-user-type-grandTotal,
        .table-grid__cell--col-user-type-subTotal,
        .table-grid__cell--col-user-type-grandTotal {
          background-color: ${e.additionalFillColor || Aa};
          color: ${e.textColor || $n};
        }
        .table-grid__cell--row-user-type-subTotal.table-grid__cell.table-grid__cell--row-level-last.table-grid__cell--row-sibling-odd,
        .table-grid__cell--row-user-type-subTotal.table-grid__cell.table-grid__cell--row-level-last.table-grid__cell--row-sibling-even,
        .table-grid__cell--row-user-type-grandTotal.table-grid__cell.table-grid__cell--row-level-last.table-grid__cell--row-sibling-odd,
        .table-grid__cell--row-user-type-grandTotal.table-grid__cell.table-grid__cell--row-level-last.table-grid__cell--row-sibling-even,
        .table-grid__cell--col-user-type-subTotal.table-grid__cell.table-grid__cell--row-level-last.table-grid__cell--row-sibling-odd,
        .table-grid__cell--col-user-type-subTotal.table-grid__cell.table-grid__cell--row-level-last.table-grid__cell--row-sibling-even,
        .table-grid__cell--col-user-type-grandTotal.table-grid__cell.table-grid__cell--row-level-last.table-grid__cell--row-sibling-odd,
        .table-grid__cell--col-user-type-grandTotal.table-grid__cell.table-grid__cell--row-level-last.table-grid__cell--row-sibling-even {
          background-color: ${e.additionalFillColor || Aa};
          color: ${e.textColor || $n};
        }
        .table-grid__cell--row-user-type-subTotal.table-grid__cell--col-user-type-subTotal,
        .table-grid__cell--row-user-type-subTotal.table-grid__cell--col-user-type-grandTotal,
        .table-grid__cell--row-user-type-grandTotal.table-grid__cell--col-user-type-subTotal,
        .table-grid__cell--row-user-type-grandTotal.table-grid__cell--col-user-type-grandTotal {
          background-color: ${e.additionalFillColor || Aa};
          color: ${e.textColor || $n};
        }
      }
      .table-grid__cell--rows.table-grid__cell--user-type-subTotal,
      .table-grid__cell--rows.table-grid__cell--user-type-grandTotal {
        background-color: ${e.additionalFillColor || Aa};
        color: ${e.textColor || $n};
      }
      .table-grid__cell--data.table-grid__cell--row-user-type-subTotal,
      .table-grid__cell--data.table-grid__cell--row-user-type-grandTotal,
      .table-grid__cell--data.table-grid__cell--col-user-type-subTotal,
      .table-grid__cell--data.table-grid__cell--col-user-type-grandTotal {
        background-color: ${e.additionalFillColor || Aa};
        color: ${e.textColor || $n};
        &.table-grid__cell {
          &.table-grid__cell--row-level-last.table-grid__cell--row-sibling-odd,
          &.table-grid__cell--row-level-last.table-grid__cell--row-sibling-even {
            background-color: ${e.additionalFillColor || Aa};
            color: ${e.textColor || $n};
          }
        }
      }
      .table-grid__cell--data.table-grid__cell--row-user-type-subTotal.table-grid__cell--col-user-type-subTotal,
      .table-grid__cell--data.table-grid__cell--row-user-type-subTotal.table-grid__cell--col-user-type-grandTotal,
      .table-grid__cell--data.table-grid__cell--row-user-type-grandTotal.table-grid__cell--col-user-type-subTotal,
      .table-grid__cell--data.table-grid__cell--row-user-type-grandTotal.table-grid__cell--col-user-type-grandTotal {
        background-color: ${e.additionalFillColor || Aa};
        color: ${e.textColor || $n};
      }
    `;
}}

  .MuiTablePagination-root {
    .MuiTypography-root,
    .MuiPaginationItem-root {
      font-family: ${(e) => e.fontFamily};
      color: ${(e) => e.navigationPrimaryColor};
    }
    .Mui-selected {
      border-color: ${(e) => e.navigationSecondaryColor};
    }
    .MuiSvgIcon-root {
      color: ${(e) => e.navigationSecondaryColor};
    }
  }
  .table-grid__cell--selected {
    background-color: ${(e) => e.selectionColor};
  }
`;
class by extends B.PureComponent {
  constructor(t) {
    super(t), Z(this, "logger"), Z(this, "pivotTable"), Z(this, "paginationPanel"), Z(this, "forceNotifyAboutHeightChange", !1), Z(this, "onEmptyChangeMemoizer", $b()), Z(this, "onTotalHeightChangeMemoizer", $b()), Z(this, "pivotContainer"), Z(this, "childrenReadyStateInitial", {
      pivotDomReady: !1,
      paginationDomReady: !1,
      isDebouncing: !1
    }), Z(this, "childrenReadyState", this.childrenReadyStateInitial), Z(this, "domReadyEvent", HW(() => this.onDomReadyEvent(), 500)), Z(this, "onPivotDomReady", () => {
      this.childrenReadyState = $e(pe({}, this.childrenReadyState), {
        pivotDomReady: !0,
        isDebouncing: !0
      }), this.domReadyEvent();
    }), Z(this, "pivotTableRef", (n) => {
      n && (this.pivotTable = n);
    }), Z(this, "paginationPanelRef", (n) => {
      n && (this.paginationPanel = n);
    }), Z(this, "onPaginationHeightChange", (n) => {
      this.setState({
        paginationPanelHeight: n,
        pivotHeight: this.calculatePivotHeight({ paginationPanelHeight: n })
      });
    }), Z(this, "onTableTotalSizeChange", (n) => {
      this.setState({
        pivotTableHeight: n,
        pivotHeight: this.calculatePivotHeight({ pivotTableHeight: n })
      });
    }), Z(this, "onSortingMetadataUpdate", (n, r) => {
      const { measurePath: o, dir: i } = n, a = {
        measurePath: o,
        dir: i || fw(n),
        field: r ? r.jaqlIndex : n.jaqlIndex
      };
      this.props.onSortingMetadataUpdate && this.props.onSortingMetadataUpdate(a);
    }), Z(this, "setPivotContainerRef", (n) => {
      n && this.pivotContainer !== n && (this.pivotContainer = n, this.forceUpdate());
    }), this.logger = ds.create("Pivot"), this.state = {
      pivotHeight: t.height
    };
  }
  componentDidMount() {
    const { onEmptyChange: t } = this.props;
    t && this.onEmptyChangeMemoizer({
      callback: ({ isEmpty: n }) => {
        t(n);
      },
      indices: {
        isEmpty: !(this.pivotTable && this.pivotTable.hasContent())
      }
    });
  }
  UNSAFE_componentWillReceiveProps(t) {
    const n = p3(this.props, t);
    (typeof n.width != "undefined" || typeof n.height != "undefined" || typeof n.isAutoHeight != "undefined" || typeof n.isPaginated != "undefined" || typeof n.itemsCount != "undefined" || typeof n.itemsPerPage != "undefined") && (this.forceNotifyAboutHeightChange = !0, this.setState({
      pivotHeight: this.calculatePivotHeight({
        isAutoHeight: t.isAutoHeight,
        holderHeight: t.height
      })
    }));
  }
  componentDidUpdate() {
    const { onEmptyChange: t, onTotalHeightChange: n, scrollBarsMargin: r = 0 } = this.props;
    if (t && this.onEmptyChangeMemoizer({
      callback: ({ isEmpty: o }) => {
        t(o);
      },
      indices: {
        isEmpty: !(this.pivotTable && this.pivotTable.hasContent())
        // eslint-disable-next-line max-lines
      }
    }), n && this.isPaginationReady()) {
      const { pivotTableHeight: o, paginationPanelHeight: i } = this.state;
      if (this.forceNotifyAboutHeightChange) {
        if (this.forceNotifyAboutHeightChange = !1, typeof o != "undefined" && typeof i != "undefined") {
          const a = o + i + r;
          n(a);
        }
      } else
        this.onTotalHeightChangeMemoizer({
          callback: ({
            tableHeight: a,
            paginationHeight: s
          } = { tableHeight: 0, paginationHeight: 0 }) => {
            const c = a + s + r;
            n(c);
          },
          indices: {
            tableHeight: o,
            paginationHeight: i
          }
        });
    }
  }
  componentWillUnmount() {
    this.pivotTable = void 0, this.paginationPanel = void 0;
  }
  initialize(t, n, r, o) {
    this.pivotTable && this.pivotTable.initialize(
      t,
      n,
      r,
      o
    );
  }
  addMore(t, n = !1) {
    this.pivotTable && t && this.pivotTable.addMore(t, n);
  }
  getDimensions() {
    return this.pivotTable ? this.pivotTable.getDimensions() : { width: [], height: [] };
  }
  /**
   * Defines if pagination panel is already rendered and we know his size
   *
   * @returns {boolean} - true - ready, rendered
   */
  isPaginationReady() {
    const { paginationPanelHeight: t } = this.state, n = typeof t == "number" && t >= 0, r = this.props.isPaginated ? n : !0;
    return this.childrenReadyState = $e(pe({}, this.childrenReadyState), {
      paginationDomReady: r,
      isDebouncing: !0
    }), this.domReadyEvent(), r;
  }
  /**
   * Calculates PivotTable height according to isAutoHeight and isPaginated rules and so on
   *
   * @param {boolean} options - partial props and state
   * @param {boolean} options.isAutoHeight - isAutoHeight condition
   * @param {number} options.holderHeight - holder height
   * @param {number|null} options.pivotTableHeight - real pivot height
   * @param {number|null} options.paginationPanelHeight - pivot navigator height
   * @returns {number} - final height
   * @private
   */
  calculatePivotHeight({
    isAutoHeight: t = this.props.isAutoHeight,
    holderHeight: n = this.props.height,
    pivotTableHeight: r = this.state.pivotTableHeight || 0,
    paginationPanelHeight: o = this.state.paginationPanelHeight || 0
  }) {
    const { scrollBarsMargin: i = 0 } = this.props, a = n - o, s = a ? a - i : 1;
    return t ? r || s : a;
  }
  /**
   * Triggers onDomReady event when Pivot and Pagination are both rendered
   *
   * @returns {void}
   */
  onDomReadyEvent() {
    if (this.childrenReadyState.pivotDomReady && this.childrenReadyState.paginationDomReady && this.childrenReadyState.isDebouncing) {
      this.domReadyEvent.cancel(), this.childrenReadyState = pe({}, this.childrenReadyStateInitial);
      const { onDomReady: t } = this.props;
      t && t();
    }
  }
  render() {
    const t = this.props, {
      className: n,
      fontFamily: r,
      textColor: o,
      backgroundColor: i,
      fillColor: a,
      additionalFillColor: s,
      fillOptions: c,
      navigationPrimaryColor: l,
      navigationSecondaryColor: d,
      selectionColor: f,
      isPaginated: p,
      overlay: m,
      itemsCount: v,
      itemsPerPage: g,
      paginationOptions: b,
      totalItemsCount: x,
      totalRecordsCount: T,
      limitReached: S,
      totalColumnsCount: _,
      columnsCount: w,
      scrollBarsMargin: k = 0,
      rowHeight: E,
      imageColumns: R,
      fallbackImageUrl: P,
      dataBars: A,
      rangeMinMax: D,
      isMobile: N,
      addCellDomReadyPromise: F,
      removeCellDomReadyPromise: $
    } = t, I = Wn(t, [
      "className",
      "fontFamily",
      "textColor",
      "backgroundColor",
      "fillColor",
      "additionalFillColor",
      "fillOptions",
      "navigationPrimaryColor",
      "navigationSecondaryColor",
      "selectionColor",
      "isPaginated",
      "overlay",
      "itemsCount",
      "itemsPerPage",
      "paginationOptions",
      "totalItemsCount",
      "totalRecordsCount",
      "limitReached",
      "totalColumnsCount",
      "columnsCount",
      "scrollBarsMargin",
      "rowHeight",
      "imageColumns",
      "fallbackImageUrl",
      "dataBars",
      "rangeMinMax",
      "isMobile",
      "addCellDomReadyPromise",
      "removeCellDomReadyPromise"
    ]), { pivotHeight: j } = this.state;
    return /* @__PURE__ */ z(
      pJ,
      {
        fontFamily: r,
        textColor: o,
        backgroundColor: i,
        fillColor: a,
        additionalFillColor: s,
        fillOptions: c,
        navigationPrimaryColor: l,
        navigationSecondaryColor: d,
        selectionColor: f,
        children: /* @__PURE__ */ _e("div", { className: Xe(DT, `${DT}--new`, n), ref: this.setPivotContainerRef, children: [
          this.pivotContainer && /* @__PURE__ */ z(
            $3,
            $e(pe({}, I), {
              className: dJ,
              rowHeight: E,
              imageColumns: R,
              fallbackImageUrl: P,
              addCellDomReadyPromise: F,
              removeCellDomReadyPromise: $,
              onSortingMetadataUpdate: this.onSortingMetadataUpdate,
              onSortingSettingsChanged: this.props.onSortingSettingsChanged,
              ref: this.pivotTableRef,
              height: j,
              onTotalSizeChange: this.onTableTotalSizeChange,
              scrollBarsMargin: k,
              dataBars: A,
              rangeMinMax: D,
              isMobile: N,
              onDomReady: this.onPivotDomReady
            })
          ),
          p ? /* @__PURE__ */ z(
            OA,
            $e(pe({}, I), {
              ref: this.paginationPanelRef,
              itemsCount: v,
              itemsPerPage: g,
              options: b,
              totalItemsCount: x,
              limitReached: S,
              limitCount: T,
              totalColumnsCount: _,
              columnsCount: w,
              onHeightChange: this.onPaginationHeightChange,
              style: {
                fontFamily: r
              }
            })
          ) : null,
          m ? /* @__PURE__ */ z("div", { className: fJ }) : null
        ] })
      }
    );
  }
}
Z(by, "defaultProps", {
  isAutoHeight: !1,
  isFullWidth: !1,
  isFixedEnabled: !0,
  isPaginated: !1,
  overlay: !1,
  itemsCount: 0,
  totalItemsCount: 0,
  totalRecordsCount: 0,
  limitReached: !1,
  totalColumnsCount: 0,
  columnsCount: 0,
  itemsPerPage: 0,
  borderWidth: 1,
  scrollBarsMargin: 9
});
const hJ = "sisense-pivot__resize-control", mJ = (e) => typeof e == "undefined" ? !0 : !!e;
class gJ extends B.Component {
  constructor() {
    super(...arguments), Z(this, "resizeControlPosition", 0), Z(this, "widthAfterResize", 0), Z(this, "currentElementWidth", 0), Z(this, "onMouseDown", (t) => {
      t.preventDefault(), this.currentElementWidth = this.props.onResizeStart(), this.resizeControlPosition = t.clientX, window.addEventListener("mouseup", this.onHandleUp), window.addEventListener("mousemove", this.onHandleResize);
    }), Z(this, "onClick", (t) => {
      t.stopPropagation();
    }), Z(this, "onHandleUp", (t) => {
      const { clientX: n } = t;
      if (!this.widthAfterResize) {
        const r = n, o = this.resizeControlPosition - this.currentElementWidth;
        this.widthAfterResize = r - o;
      }
      this.props.onResizeEnd(this.widthAfterResize), window.removeEventListener("mousemove", this.onHandleResize, !1), window.removeEventListener("mouseup", this.onHandleUp, !1);
    }), Z(this, "onHandleResize", (t) => {
      this.resizeElement(t);
    });
  }
  shouldComponentUpdate() {
    return !1;
  }
  /**
   * Handler for resize element
   *
   * @param {any} event - event for resize
   * @returns {void} - return nothing
   * @private
   */
  resizeElement(t) {
    const { onResize: n } = this.props, { movementX: r, clientX: o } = t;
    if (mJ(r)) {
      const i = o, a = this.resizeControlPosition - this.currentElementWidth;
      this.widthAfterResize = i - a, n(this.widthAfterResize);
    }
  }
  render() {
    return /* @__PURE__ */ z(
      "div",
      {
        className: hJ,
        onMouseDownCapture: this.onMouseDown,
        onClick: this.onClick,
        role: "button",
        "aria-label": "Resize control",
        tabIndex: 0,
        onKeyPress: this.onClick
      }
    );
  }
}
const vJ = "sisense-pivot__data-bar", IT = "sisense-pivot__data-bar--show", LT = "sisense-pivot__data-bar--show-active", bJ = "sisense-pivot__data-bar-inner", yJ = "sisense-pivot__data-bar-bar", _J = (e, t, n) => {
  if (typeof e == "undefined" || e === null || e === "0" || typeof t == "undefined" || t === null || typeof n == "undefined" || n === null)
    return [];
  const r = parseFloat(e);
  let o = 0, i = 0;
  if (t === n)
    return [];
  const a = (r - t) / (n - t) * 100;
  if (t >= 0 && n >= 0)
    o = 0, i = a;
  else if (t < 0 && n < 0)
    o = 100, i = (100 - a) * -1;
  else {
    const s = t * -1 / (n - t) * 100;
    o = s, i = a - s;
  }
  return [o, i, r < 0 ? -1 : 1];
};
class wJ extends B.Component {
  constructor(t) {
    super(t), Z(this, "root"), Z(this, "style"), Z(this, "innerStyle"), Z(this, "timerShow"), Z(this, "timerShowInner"), Z(this, "onWidthChange", (n) => {
      const { columnIndex: r, dataNode: o } = this.props, { colsWidth: i, minMaxs: a } = n;
      let s = i[r];
      s += 8;
      const [c, l] = a[r] || [], d = o ? o.value : void 0, [f, p, m] = _J(d, c, l);
      this.style = void 0, this.innerStyle = void 0, this.setState({
        width: s,
        left: f,
        size: p,
        sign: m
      }), !(typeof f == "undefined" && typeof p == "undefined") && (this.root && this.root.classList.add(IT), this.timerShow && cancelAnimationFrame(this.timerShow), this.timerShow = requestAnimationFrame(() => {
        this.timerShowInner && cancelAnimationFrame(this.timerShowInner), this.timerShowInner = requestAnimationFrame(() => {
          this.root && this.root.classList.add(LT);
        });
      }));
    }), Z(this, "rootRef", (n) => {
      n && (this.root = n);
    }), this.state = {
      width: 0,
      left: 0,
      size: 0
    };
  }
  componentDidMount() {
    if (this.props.tableSize) {
      this.props.tableSize.on(Zu, this.onWidthChange);
      const t = this.props.tableSize.getDataBars();
      t && this.onWidthChange(t);
    }
  }
  UNSAFE_componentWillReceiveProps(t) {
    if ((t.tableSize !== this.props.tableSize || t.columnIndex !== this.props.columnIndex || t.dataNode !== this.props.dataNode || t.style !== this.props.style) && (this.style = void 0, this.innerStyle = void 0, this.root && (this.root.classList.remove(IT), this.root.classList.remove(LT))), t.tableSize !== this.props.tableSize && (this.props.tableSize && this.props.tableSize.off(Zu, this.onWidthChange), t.tableSize)) {
      t.tableSize.on(Zu, this.onWidthChange);
      const n = t.tableSize.getDataBars();
      n && this.onWidthChange(n);
    }
  }
  componentWillUnmount() {
    this.root = void 0, this.props.tableSize && this.props.tableSize.off(Zu, this.onWidthChange), this.timerShow && cancelAnimationFrame(this.timerShow), this.timerShowInner && cancelAnimationFrame(this.timerShowInner);
  }
  getStyle() {
    if (!this.style) {
      const { width: t } = this.state;
      if (typeof t == "undefined")
        return this.style = {}, this.style;
      this.style = {
        width: `calc(100% - ${t}px)`
      };
    }
    return this.style;
  }
  getInnerStyle() {
    if (!this.innerStyle) {
      const { style: t } = this.props, { left: n, size: r, sign: o } = this.state;
      if (typeof n == "undefined" || typeof r == "undefined")
        return this.innerStyle = {}, this.innerStyle;
      o === 1 ? this.innerStyle = $e(pe({}, t), {
        left: `${n}%`,
        width: `${r}%`
      }) : this.innerStyle = $e(pe({}, t), {
        right: `${100 - n}%`,
        width: `${-1 * r}%`
      });
    }
    return this.innerStyle;
  }
  render() {
    const { dataNode: t } = this.props;
    if (!t || t.value === null)
      return null;
    const n = this.getStyle(), r = this.getInnerStyle();
    return /* @__PURE__ */ z("div", { className: vJ, style: n, ref: this.rootRef, children: /* @__PURE__ */ z("div", { className: bJ, children: /* @__PURE__ */ z("div", { className: yJ, style: r }) }) });
  }
}
class NA extends B.PureComponent {
  constructor(t) {
    super(t), Z(this, "cellPadding"), Z(this, "ratio"), Z(this, "defaultHeight"), Z(this, "style", {}), Z(this, "domReadyDefer"), Z(this, "setDefer", () => {
      const n = {
        promise: Promise.resolve(),
        resolve() {
          return !0;
        },
        reject() {
          return !1;
        }
      }, r = new Promise((o, i) => {
        n.resolve = o, n.reject = i;
      });
      this.domReadyDefer = $e(pe({}, n), {
        promise: r
      }), this.props.addCellDomReadyPromise && this.props.addCellDomReadyPromise(this.domReadyDefer);
    }), Z(this, "onLoad", (n) => {
      const r = n.currentTarget.naturalWidth, o = n.currentTarget.naturalHeight;
      this.ratio = r / o, this.setImageStyle(), setTimeout(() => {
        this.domReadyDefer && this.domReadyDefer.resolve();
      }, 0);
    }), Z(this, "onError", (n) => {
      const r = (this.props.defaultHeight || this.defaultHeight) - this.cellPadding;
      this.setState({
        imageUrl: this.props.fallbackImageUrl || "",
        imageStyle: {
          position: "absolute",
          top: "0",
          left: "0",
          display: "block",
          width: r,
          height: r
        }
      }), setTimeout(() => {
        this.domReadyDefer && this.domReadyDefer.resolve(n);
      }, 0);
    }), this.cellPadding = 7, this.ratio = 0, this.defaultHeight = 60, this.setStyle(), this.state = {
      imageUrl: t.imageUrl,
      imageStyle: {
        position: "absolute",
        top: "0",
        left: "0",
        display: "block",
        width: this.getHeight() * this.ratio,
        height: "100%"
      }
    }, this.setDefer();
  }
  UNSAFE_componentWillReceiveProps(t) {
    this.props.rowHeight !== t.rowHeight && (this.setStyle(t), this.setImageStyle(t)), this.props.imageUrl !== t.imageUrl && this.setState({
      imageUrl: t.imageUrl
    });
  }
  componentWillUnmount() {
    this.props.removeCellDomReadyPromise && this.props.removeCellDomReadyPromise(this.domReadyDefer);
  }
  getHeight(t) {
    return ((t ? t.rowHeight : this.props.rowHeight) || this.defaultHeight) - this.cellPadding;
  }
  setStyle(t) {
    this.style = {
      position: "relative",
      display: "block",
      width: "100%",
      height: this.getHeight(t),
      fontSize: 0,
      lineHeight: 0
    };
  }
  setImageStyle(t) {
    const n = this.ratio * this.getHeight(t);
    this.setState({
      imageStyle: {
        position: "absolute",
        top: "0",
        left: "0",
        display: "block",
        width: n,
        height: "100%"
      }
    });
  }
  render() {
    return /* @__PURE__ */ z("div", { style: this.style, children: /* @__PURE__ */ z(
      "img",
      {
        src: this.state.imageUrl,
        alt: "",
        style: this.state.imageStyle,
        onLoad: this.onLoad,
        onError: this.onError
      }
    ) });
  }
}
Z(NA, "defaultProps", {
  rowHeight: 60,
  fallbackImageUrl: ""
});
var yy = {}, xJ = {
  get exports() {
    return yy;
  },
  set exports(e) {
    yy = e;
  }
};
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var $T;
function CJ() {
  return $T || ($T = 1, function(e) {
    (function() {
      var t = {}.hasOwnProperty;
      function n() {
        for (var i = "", a = 0; a < arguments.length; a++) {
          var s = arguments[a];
          s && (i = o(i, r(s)));
        }
        return i;
      }
      function r(i) {
        if (typeof i == "string" || typeof i == "number")
          return i;
        if (typeof i != "object")
          return "";
        if (Array.isArray(i))
          return n.apply(null, i);
        if (i.toString !== Object.prototype.toString && !i.toString.toString().includes("[native code]"))
          return i.toString();
        var a = "";
        for (var s in i)
          t.call(i, s) && i[s] && (a = o(a, s));
        return a;
      }
      function o(i, a) {
        return a ? i ? i + " " + a : i + a : i;
      }
      e.exports ? (n.default = n, e.exports = n) : window.classNames = n;
    })();
  }(xJ)), yy;
}
var SJ = CJ();
const rs = /* @__PURE__ */ ji(SJ);
function TJ(e) {
  var t = e.children, n = e.prefixCls, r = e.id, o = e.overlayInnerStyle, i = e.className, a = e.style;
  return /* @__PURE__ */ B.createElement("div", {
    className: rs("".concat(n, "-content"), i),
    style: a
  }, /* @__PURE__ */ B.createElement("div", {
    className: "".concat(n, "-inner"),
    id: r,
    role: "tooltip",
    style: o
  }, typeof t == "function" ? t() : t));
}
function kr(e, t, n) {
  return t = WN(t), t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function FT(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Je(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? FT(Object(n), !0).forEach(function(r) {
      kr(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : FT(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function Ih(e, t) {
  if (e == null)
    return {};
  var n = He(e, t), r, o;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (o = 0; o < i.length; o++)
      r = i[o], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function EJ(e) {
  if (Array.isArray(e))
    return e;
}
function kJ(e, t) {
  var n = e == null ? null : typeof Symbol != "undefined" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r, o, i, a, s = [], c = !0, l = !1;
    try {
      if (i = (n = n.call(e)).next, t === 0) {
        if (Object(n) !== n)
          return;
        c = !1;
      } else
        for (; !(c = (r = i.call(n)).done) && (s.push(r.value), s.length !== t); c = !0)
          ;
    } catch (d) {
      l = !0, o = d;
    } finally {
      try {
        if (!c && n.return != null && (a = n.return(), Object(a) !== a))
          return;
      } finally {
        if (l)
          throw o;
      }
    }
    return s;
  }
}
function _y(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function AA(e, t) {
  if (e) {
    if (typeof e == "string")
      return _y(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set")
      return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return _y(e, t);
  }
}
function MJ() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function wt(e, t) {
  return EJ(e) || kJ(e, t) || AA(e, t) || MJ();
}
function Ai() {
  return !!(typeof window != "undefined" && window.document && window.document.createElement);
}
var wy = {}, pw = [], RJ = function(e) {
  pw.push(e);
};
function Lh(e, t) {
  if (process.env.NODE_ENV !== "production" && !e && console !== void 0) {
    var n = pw.reduce(function(r, o) {
      return o(r != null ? r : "", "warning");
    }, t);
    n && console.error("Warning: ".concat(n));
  }
}
function PJ(e, t) {
  if (process.env.NODE_ENV !== "production" && !e && console !== void 0) {
    var n = pw.reduce(function(r, o) {
      return o(r != null ? r : "", "note");
    }, t);
    n && console.warn("Note: ".concat(n));
  }
}
function OJ() {
  wy = {};
}
function DA(e, t, n) {
  !t && !wy[n] && (e(!1, n), wy[n] = !0);
}
function lg(e, t) {
  DA(Lh, e, t);
}
function NJ(e, t) {
  DA(PJ, e, t);
}
lg.preMessage = RJ;
lg.resetWarned = OJ;
lg.noteOnce = NJ;
function AJ(e, t, n) {
  var r = B.useRef({});
  return (!("value" in r.current) || n(r.current.condition, t)) && (r.current.value = e(), r.current.condition = t), r.current.value;
}
var hw = function(e, t) {
  typeof e == "function" ? e(t) : Wo(e) === "object" && e && "current" in e && (e.current = t);
}, IA = function() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  var r = t.filter(Boolean);
  return r.length <= 1 ? r[0] : function(o) {
    t.forEach(function(i) {
      hw(i, o);
    });
  };
}, mw = function() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return AJ(function() {
    return IA.apply(void 0, t);
  }, t, function(r, o) {
    return r.length !== o.length || r.every(function(i, a) {
      return i !== o[a];
    });
  });
}, cg = function(e) {
  var t, n, r = la.isMemo(e) ? e.type.type : e.type;
  return !(typeof r == "function" && !((t = r.prototype) !== null && t !== void 0 && t.render) && r.$$typeof !== la.ForwardRef || typeof e == "function" && !((n = e.prototype) !== null && n !== void 0 && n.render) && e.$$typeof !== la.ForwardRef);
}, LA = /* @__PURE__ */ B.createContext(null);
function DJ(e) {
  if (Array.isArray(e))
    return _y(e);
}
function IJ(e) {
  if (typeof Symbol != "undefined" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function LJ() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function xy(e) {
  return DJ(e) || IJ(e) || AA(e) || LJ();
}
var zT = process.env.NODE_ENV !== "test" && Ai() ? B.useLayoutEffect : B.useEffect, io = function(e, t) {
  var n = B.useRef(!0);
  zT(function() {
    return e(n.current);
  }, t), zT(function() {
    return n.current = !1, function() {
      n.current = !0;
    };
  }, []);
}, BT = [];
function $J(e, t) {
  var n = B.useState(function() {
    if (!Ai())
      return null;
    var v = document.createElement("div");
    return process.env.NODE_ENV !== "production" && t && v.setAttribute("data-debug", t), v;
  }), r = wt(n, 1), o = r[0], i = B.useRef(!1), a = B.useContext(LA), s = B.useState(BT), c = wt(s, 2), l = c[0], d = c[1], f = a || (i.current ? void 0 : function(v) {
    d(function(g) {
      var b = [v].concat(xy(g));
      return b;
    });
  });
  function p() {
    o.parentElement || document.body.appendChild(o), i.current = !0;
  }
  function m() {
    var v;
    (v = o.parentElement) === null || v === void 0 || v.removeChild(o), i.current = !1;
  }
  return io(function() {
    return e ? a ? a(p) : p() : m(), m;
  }, [e]), io(function() {
    l.length && (l.forEach(function(v) {
      return v();
    }), d(BT));
  }, [l]), [o, f];
}
function FJ(e, t) {
  if (!e)
    return !1;
  if (e.contains)
    return e.contains(t);
  for (var n = t; n; ) {
    if (n === e)
      return !0;
    n = n.parentNode;
  }
  return !1;
}
var HT = "data-rc-order", jT = "data-rc-priority", zJ = "rc-util-key", Cy = /* @__PURE__ */ new Map();
function $A() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = e.mark;
  return t ? t.startsWith("data-") ? t : "data-".concat(t) : zJ;
}
function ug(e) {
  if (e.attachTo)
    return e.attachTo;
  var t = document.querySelector("head");
  return t || document.body;
}
function BJ(e) {
  return e === "queue" ? "prependQueue" : e ? "prepend" : "append";
}
function gw(e) {
  return Array.from((Cy.get(e) || e).children).filter(function(t) {
    return t.tagName === "STYLE";
  });
}
function FA(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  if (!Ai())
    return null;
  var n = t.csp, r = t.prepend, o = t.priority, i = o === void 0 ? 0 : o, a = BJ(r), s = a === "prependQueue", c = document.createElement("style");
  c.setAttribute(HT, a), s && i && c.setAttribute(jT, "".concat(i)), n != null && n.nonce && (c.nonce = n == null ? void 0 : n.nonce), c.innerHTML = e;
  var l = ug(t), d = l.firstChild;
  if (r) {
    if (s) {
      var f = (t.styles || gw(l)).filter(function(p) {
        if (!["prepend", "prependQueue"].includes(p.getAttribute(HT)))
          return !1;
        var m = Number(p.getAttribute(jT) || 0);
        return i >= m;
      });
      if (f.length)
        return l.insertBefore(c, f[f.length - 1].nextSibling), c;
    }
    l.insertBefore(c, d);
  } else
    l.appendChild(c);
  return c;
}
function zA(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = ug(t);
  return (t.styles || gw(n)).find(function(r) {
    return r.getAttribute($A(t)) === e;
  });
}
function Sy(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = zA(e, t);
  if (n) {
    var r = ug(t);
    r.removeChild(n);
  }
}
function HJ(e, t) {
  var n = Cy.get(e);
  if (!n || !FJ(document, n)) {
    var r = FA("", t), o = r.parentNode;
    Cy.set(e, o), e.removeChild(r);
  }
}
function BA(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, r = ug(n), o = gw(r), i = Je(Je({}, n), {}, {
    styles: o
  });
  HJ(r, i);
  var a = zA(t, i);
  if (a) {
    var s, c;
    if ((s = i.csp) !== null && s !== void 0 && s.nonce && a.nonce !== ((c = i.csp) === null || c === void 0 ? void 0 : c.nonce)) {
      var l;
      a.nonce = (l = i.csp) === null || l === void 0 ? void 0 : l.nonce;
    }
    return a.innerHTML !== e && (a.innerHTML = e), a;
  }
  var d = FA(e, i);
  return d.setAttribute($A(i), t), d;
}
function jJ(e) {
  var t = "rc-scrollbar-measure-".concat(Math.random().toString(36).substring(7)), n = document.createElement("div");
  n.id = t;
  var r = n.style;
  r.position = "absolute", r.left = "0", r.top = "0", r.width = "100px", r.height = "100px", r.overflow = "scroll";
  var o, i;
  if (e) {
    var a = getComputedStyle(e);
    r.scrollbarColor = a.scrollbarColor, r.scrollbarWidth = a.scrollbarWidth;
    var s = getComputedStyle(e, "::-webkit-scrollbar"), c = parseInt(s.width, 10), l = parseInt(s.height, 10);
    try {
      var d = c ? "width: ".concat(s.width, ";") : "", f = l ? "height: ".concat(s.height, ";") : "";
      BA(`
#`.concat(t, `::-webkit-scrollbar {
`).concat(d, `
`).concat(f, `
}`), t);
    } catch (v) {
      console.error(v), o = c, i = l;
    }
  }
  document.body.appendChild(n);
  var p = e && o && !isNaN(o) ? o : n.offsetWidth - n.clientWidth, m = e && i && !isNaN(i) ? i : n.offsetHeight - n.clientHeight;
  return document.body.removeChild(n), Sy(t), {
    width: p,
    height: m
  };
}
function WJ(e) {
  return typeof document == "undefined" || !e || !(e instanceof Element) ? {
    width: 0,
    height: 0
  } : jJ(e);
}
function VJ() {
  return document.body.scrollHeight > (window.innerHeight || document.documentElement.clientHeight) && window.innerWidth > document.body.offsetWidth;
}
var UJ = "rc-util-locker-".concat(Date.now()), WT = 0;
function qJ(e) {
  var t = !!e, n = B.useState(function() {
    return WT += 1, "".concat(UJ, "_").concat(WT);
  }), r = wt(n, 1), o = r[0];
  io(function() {
    if (t) {
      var i = WJ(document.body).width, a = VJ();
      BA(`
html body {
  overflow-y: hidden;
  `.concat(a ? "width: calc(100% - ".concat(i, "px);") : "", `
}`), o);
    } else
      Sy(o);
    return function() {
      Sy(o);
    };
  }, [t, o]);
}
var GJ = !1;
function YJ(e) {
  return GJ;
}
var VT = function(e) {
  return e === !1 ? !1 : !Ai() || !e ? null : typeof e == "string" ? document.querySelector(e) : typeof e == "function" ? e() : e;
}, vw = /* @__PURE__ */ B.forwardRef(function(e, t) {
  var n = e.open, r = e.autoLock, o = e.getContainer, i = e.debug, a = e.autoDestroy, s = a === void 0 ? !0 : a, c = e.children, l = B.useState(n), d = wt(l, 2), f = d[0], p = d[1], m = f || n;
  process.env.NODE_ENV !== "production" && lg(Ai() || !n, "Portal only work in client side. Please call 'useEffect' to show Portal instead default render in SSR."), B.useEffect(function() {
    (s || n) && p(n);
  }, [n, s]);
  var v = B.useState(function() {
    return VT(o);
  }), g = wt(v, 2), b = g[0], x = g[1];
  B.useEffect(function() {
    var N = VT(o);
    x(N != null ? N : null);
  });
  var T = $J(m && !b, i), S = wt(T, 2), _ = S[0], w = S[1], k = b != null ? b : _;
  qJ(r && n && Ai() && (k === _ || k === document.body));
  var E = null;
  if (c && cg(c) && t) {
    var R = c;
    E = R.ref;
  }
  var P = mw(E, t);
  if (!m || !Ai() || b === void 0)
    return null;
  var A = k === !1 || YJ(), D = c;
  return t && (D = /* @__PURE__ */ B.cloneElement(c, {
    ref: P
  })), /* @__PURE__ */ B.createElement(LA.Provider, {
    value: w
  }, A ? D : /* @__PURE__ */ DF(D, k));
});
process.env.NODE_ENV !== "production" && (vw.displayName = "Portal");
function Ty(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = [];
  return et.Children.forEach(e, function(r) {
    r == null && !t.keepEmpty || (Array.isArray(r) ? n = n.concat(Ty(r)) : la.isFragment(r) && r.props ? n = n.concat(Ty(r.props.children, t)) : n.push(r));
  }), n;
}
function Hd(e) {
  return e instanceof HTMLElement || e instanceof SVGElement;
}
function ZJ(e) {
  return e && Wo(e) === "object" && Hd(e.nativeElement) ? e.nativeElement : Hd(e) ? e : null;
}
function Kp(e) {
  var t = ZJ(e);
  if (t)
    return t;
  if (e instanceof et.Component) {
    var n;
    return (n = _r.findDOMNode) === null || n === void 0 ? void 0 : n.call(_r, e);
  }
  return null;
}
var Ey = /* @__PURE__ */ B.createContext(null);
function XJ(e) {
  var t = e.children, n = e.onBatchResize, r = B.useRef(0), o = B.useRef([]), i = B.useContext(Ey), a = B.useCallback(function(s, c, l) {
    r.current += 1;
    var d = r.current;
    o.current.push({
      size: s,
      element: c,
      data: l
    }), Promise.resolve().then(function() {
      d === r.current && (n == null || n(o.current), o.current = []);
    }), i == null || i(s, c, l);
  }, [n, i]);
  return /* @__PURE__ */ B.createElement(Ey.Provider, {
    value: a
  }, t);
}
var HA = function() {
  if (typeof Map != "undefined")
    return Map;
  function e(t, n) {
    var r = -1;
    return t.some(function(o, i) {
      return o[0] === n ? (r = i, !0) : !1;
    }), r;
  }
  return (
    /** @class */
    function() {
      function t() {
        this.__entries__ = [];
      }
      return Object.defineProperty(t.prototype, "size", {
        /**
         * @returns {boolean}
         */
        get: function() {
          return this.__entries__.length;
        },
        enumerable: !0,
        configurable: !0
      }), t.prototype.get = function(n) {
        var r = e(this.__entries__, n), o = this.__entries__[r];
        return o && o[1];
      }, t.prototype.set = function(n, r) {
        var o = e(this.__entries__, n);
        ~o ? this.__entries__[o][1] = r : this.__entries__.push([n, r]);
      }, t.prototype.delete = function(n) {
        var r = this.__entries__, o = e(r, n);
        ~o && r.splice(o, 1);
      }, t.prototype.has = function(n) {
        return !!~e(this.__entries__, n);
      }, t.prototype.clear = function() {
        this.__entries__.splice(0);
      }, t.prototype.forEach = function(n, r) {
        r === void 0 && (r = null);
        for (var o = 0, i = this.__entries__; o < i.length; o++) {
          var a = i[o];
          n.call(r, a[1], a[0]);
        }
      }, t;
    }()
  );
}(), ky = typeof window != "undefined" && typeof document != "undefined" && window.document === document, $h = function() {
  return typeof global != "undefined" && global.Math === Math ? global : typeof self != "undefined" && self.Math === Math ? self : typeof window != "undefined" && window.Math === Math ? window : Function("return this")();
}(), KJ = function() {
  return typeof requestAnimationFrame == "function" ? requestAnimationFrame.bind($h) : function(e) {
    return setTimeout(function() {
      return e(Date.now());
    }, 1e3 / 60);
  };
}(), JJ = 2;
function QJ(e, t) {
  var n = !1, r = !1, o = 0;
  function i() {
    n && (n = !1, e()), r && s();
  }
  function a() {
    KJ(i);
  }
  function s() {
    var c = Date.now();
    if (n) {
      if (c - o < JJ)
        return;
      r = !0;
    } else
      n = !0, r = !1, setTimeout(a, t);
    o = c;
  }
  return s;
}
var eQ = 20, tQ = ["top", "right", "bottom", "left", "width", "height", "size", "weight"], nQ = typeof MutationObserver != "undefined", rQ = (
  /** @class */
  function() {
    function e() {
      this.connected_ = !1, this.mutationEventsAdded_ = !1, this.mutationsObserver_ = null, this.observers_ = [], this.onTransitionEnd_ = this.onTransitionEnd_.bind(this), this.refresh = QJ(this.refresh.bind(this), eQ);
    }
    return e.prototype.addObserver = function(t) {
      ~this.observers_.indexOf(t) || this.observers_.push(t), this.connected_ || this.connect_();
    }, e.prototype.removeObserver = function(t) {
      var n = this.observers_, r = n.indexOf(t);
      ~r && n.splice(r, 1), !n.length && this.connected_ && this.disconnect_();
    }, e.prototype.refresh = function() {
      var t = this.updateObservers_();
      t && this.refresh();
    }, e.prototype.updateObservers_ = function() {
      var t = this.observers_.filter(function(n) {
        return n.gatherActive(), n.hasActive();
      });
      return t.forEach(function(n) {
        return n.broadcastActive();
      }), t.length > 0;
    }, e.prototype.connect_ = function() {
      !ky || this.connected_ || (document.addEventListener("transitionend", this.onTransitionEnd_), window.addEventListener("resize", this.refresh), nQ ? (this.mutationsObserver_ = new MutationObserver(this.refresh), this.mutationsObserver_.observe(document, {
        attributes: !0,
        childList: !0,
        characterData: !0,
        subtree: !0
      })) : (document.addEventListener("DOMSubtreeModified", this.refresh), this.mutationEventsAdded_ = !0), this.connected_ = !0);
    }, e.prototype.disconnect_ = function() {
      !ky || !this.connected_ || (document.removeEventListener("transitionend", this.onTransitionEnd_), window.removeEventListener("resize", this.refresh), this.mutationsObserver_ && this.mutationsObserver_.disconnect(), this.mutationEventsAdded_ && document.removeEventListener("DOMSubtreeModified", this.refresh), this.mutationsObserver_ = null, this.mutationEventsAdded_ = !1, this.connected_ = !1);
    }, e.prototype.onTransitionEnd_ = function(t) {
      var n = t.propertyName, r = n === void 0 ? "" : n, o = tQ.some(function(i) {
        return !!~r.indexOf(i);
      });
      o && this.refresh();
    }, e.getInstance = function() {
      return this.instance_ || (this.instance_ = new e()), this.instance_;
    }, e.instance_ = null, e;
  }()
), jA = function(e, t) {
  for (var n = 0, r = Object.keys(t); n < r.length; n++) {
    var o = r[n];
    Object.defineProperty(e, o, {
      value: t[o],
      enumerable: !1,
      writable: !1,
      configurable: !0
    });
  }
  return e;
}, Ec = function(e) {
  var t = e && e.ownerDocument && e.ownerDocument.defaultView;
  return t || $h;
}, WA = dg(0, 0, 0, 0);
function Fh(e) {
  return parseFloat(e) || 0;
}
function UT(e) {
  for (var t = [], n = 1; n < arguments.length; n++)
    t[n - 1] = arguments[n];
  return t.reduce(function(r, o) {
    var i = e["border-" + o + "-width"];
    return r + Fh(i);
  }, 0);
}
function oQ(e) {
  for (var t = ["top", "right", "bottom", "left"], n = {}, r = 0, o = t; r < o.length; r++) {
    var i = o[r], a = e["padding-" + i];
    n[i] = Fh(a);
  }
  return n;
}
function iQ(e) {
  var t = e.getBBox();
  return dg(0, 0, t.width, t.height);
}
function aQ(e) {
  var t = e.clientWidth, n = e.clientHeight;
  if (!t && !n)
    return WA;
  var r = Ec(e).getComputedStyle(e), o = oQ(r), i = o.left + o.right, a = o.top + o.bottom, s = Fh(r.width), c = Fh(r.height);
  if (r.boxSizing === "border-box" && (Math.round(s + i) !== t && (s -= UT(r, "left", "right") + i), Math.round(c + a) !== n && (c -= UT(r, "top", "bottom") + a)), !lQ(e)) {
    var l = Math.round(s + i) - t, d = Math.round(c + a) - n;
    Math.abs(l) !== 1 && (s -= l), Math.abs(d) !== 1 && (c -= d);
  }
  return dg(o.left, o.top, s, c);
}
var sQ = /* @__PURE__ */ function() {
  return typeof SVGGraphicsElement != "undefined" ? function(e) {
    return e instanceof Ec(e).SVGGraphicsElement;
  } : function(e) {
    return e instanceof Ec(e).SVGElement && typeof e.getBBox == "function";
  };
}();
function lQ(e) {
  return e === Ec(e).document.documentElement;
}
function cQ(e) {
  return ky ? sQ(e) ? iQ(e) : aQ(e) : WA;
}
function uQ(e) {
  var t = e.x, n = e.y, r = e.width, o = e.height, i = typeof DOMRectReadOnly != "undefined" ? DOMRectReadOnly : Object, a = Object.create(i.prototype);
  return jA(a, {
    x: t,
    y: n,
    width: r,
    height: o,
    top: n,
    right: t + r,
    bottom: o + n,
    left: t
  }), a;
}
function dg(e, t, n, r) {
  return { x: e, y: t, width: n, height: r };
}
var dQ = (
  /** @class */
  function() {
    function e(t) {
      this.broadcastWidth = 0, this.broadcastHeight = 0, this.contentRect_ = dg(0, 0, 0, 0), this.target = t;
    }
    return e.prototype.isActive = function() {
      var t = cQ(this.target);
      return this.contentRect_ = t, t.width !== this.broadcastWidth || t.height !== this.broadcastHeight;
    }, e.prototype.broadcastRect = function() {
      var t = this.contentRect_;
      return this.broadcastWidth = t.width, this.broadcastHeight = t.height, t;
    }, e;
  }()
), fQ = (
  /** @class */
  /* @__PURE__ */ function() {
    function e(t, n) {
      var r = uQ(n);
      jA(this, { target: t, contentRect: r });
    }
    return e;
  }()
), pQ = (
  /** @class */
  function() {
    function e(t, n, r) {
      if (this.activeObservations_ = [], this.observations_ = new HA(), typeof t != "function")
        throw new TypeError("The callback provided as parameter 1 is not a function.");
      this.callback_ = t, this.controller_ = n, this.callbackCtx_ = r;
    }
    return e.prototype.observe = function(t) {
      if (!arguments.length)
        throw new TypeError("1 argument required, but only 0 present.");
      if (!(typeof Element == "undefined" || !(Element instanceof Object))) {
        if (!(t instanceof Ec(t).Element))
          throw new TypeError('parameter 1 is not of type "Element".');
        var n = this.observations_;
        n.has(t) || (n.set(t, new dQ(t)), this.controller_.addObserver(this), this.controller_.refresh());
      }
    }, e.prototype.unobserve = function(t) {
      if (!arguments.length)
        throw new TypeError("1 argument required, but only 0 present.");
      if (!(typeof Element == "undefined" || !(Element instanceof Object))) {
        if (!(t instanceof Ec(t).Element))
          throw new TypeError('parameter 1 is not of type "Element".');
        var n = this.observations_;
        n.has(t) && (n.delete(t), n.size || this.controller_.removeObserver(this));
      }
    }, e.prototype.disconnect = function() {
      this.clearActive(), this.observations_.clear(), this.controller_.removeObserver(this);
    }, e.prototype.gatherActive = function() {
      var t = this;
      this.clearActive(), this.observations_.forEach(function(n) {
        n.isActive() && t.activeObservations_.push(n);
      });
    }, e.prototype.broadcastActive = function() {
      if (this.hasActive()) {
        var t = this.callbackCtx_, n = this.activeObservations_.map(function(r) {
          return new fQ(r.target, r.broadcastRect());
        });
        this.callback_.call(t, n, t), this.clearActive();
      }
    }, e.prototype.clearActive = function() {
      this.activeObservations_.splice(0);
    }, e.prototype.hasActive = function() {
      return this.activeObservations_.length > 0;
    }, e;
  }()
), VA = typeof WeakMap != "undefined" ? /* @__PURE__ */ new WeakMap() : new HA(), UA = (
  /** @class */
  /* @__PURE__ */ function() {
    function e(t) {
      if (!(this instanceof e))
        throw new TypeError("Cannot call a class as a function.");
      if (!arguments.length)
        throw new TypeError("1 argument required, but only 0 present.");
      var n = rQ.getInstance(), r = new pQ(t, n, this);
      VA.set(this, r);
    }
    return e;
  }()
);
[
  "observe",
  "unobserve",
  "disconnect"
].forEach(function(e) {
  UA.prototype[e] = function() {
    var t;
    return (t = VA.get(this))[e].apply(t, arguments);
  };
});
var hQ = function() {
  return typeof $h.ResizeObserver != "undefined" ? $h.ResizeObserver : UA;
}(), Za = /* @__PURE__ */ new Map();
function mQ(e) {
  e.forEach(function(t) {
    var n, r = t.target;
    (n = Za.get(r)) === null || n === void 0 || n.forEach(function(o) {
      return o(r);
    });
  });
}
var qA = new hQ(mQ);
function gQ(e, t) {
  Za.has(e) || (Za.set(e, /* @__PURE__ */ new Set()), qA.observe(e)), Za.get(e).add(t);
}
function vQ(e, t) {
  Za.has(e) && (Za.get(e).delete(t), Za.get(e).size || (qA.unobserve(e), Za.delete(e)));
}
function bw(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function qT(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, WN(r.key), r);
  }
}
function yw(e, t, n) {
  return t && qT(e.prototype, t), n && qT(e, n), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _w(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(e, "prototype", {
    writable: !1
  }), t && Oh(e, t);
}
function zh(e) {
  return zh = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, zh(e);
}
function GA() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t) {
  }
  return (GA = function() {
    return !!e;
  })();
}
function bQ(e, t) {
  if (t && (Wo(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return Ah(e);
}
function ww(e) {
  var t = GA();
  return function() {
    var n = zh(e), r;
    if (t) {
      var o = zh(this).constructor;
      r = Reflect.construct(n, arguments, o);
    } else
      r = n.apply(this, arguments);
    return bQ(this, r);
  };
}
var yQ = /* @__PURE__ */ function(e) {
  _w(n, e);
  var t = ww(n);
  function n() {
    return bw(this, n), t.apply(this, arguments);
  }
  return yw(n, [{
    key: "render",
    value: function() {
      return this.props.children;
    }
  }]), n;
}(B.Component);
function _Q(e, t) {
  var n = e.children, r = e.disabled, o = B.useRef(null), i = B.useRef(null), a = B.useContext(Ey), s = typeof n == "function", c = s ? n(o) : n, l = B.useRef({
    width: -1,
    height: -1,
    offsetWidth: -1,
    offsetHeight: -1
  }), d = !s && /* @__PURE__ */ B.isValidElement(c) && cg(c), f = d ? c.ref : null, p = mw(f, o), m = function() {
    var b;
    return Kp(o.current) || // Support `nativeElement` format
    (o.current && Wo(o.current) === "object" ? Kp((b = o.current) === null || b === void 0 ? void 0 : b.nativeElement) : null) || Kp(i.current);
  };
  B.useImperativeHandle(t, function() {
    return m();
  });
  var v = B.useRef(e);
  v.current = e;
  var g = B.useCallback(function(b) {
    var x = v.current, T = x.onResize, S = x.data, _ = b.getBoundingClientRect(), w = _.width, k = _.height, E = b.offsetWidth, R = b.offsetHeight, P = Math.floor(w), A = Math.floor(k);
    if (l.current.width !== P || l.current.height !== A || l.current.offsetWidth !== E || l.current.offsetHeight !== R) {
      var D = {
        width: P,
        height: A,
        offsetWidth: E,
        offsetHeight: R
      };
      l.current = D;
      var N = E === Math.round(w) ? w : E, F = R === Math.round(k) ? k : R, $ = Je(Je({}, D), {}, {
        offsetWidth: N,
        offsetHeight: F
      });
      a == null || a($, b, S), T && Promise.resolve().then(function() {
        T($, b);
      });
    }
  }, []);
  return B.useEffect(function() {
    var b = m();
    return b && !r && gQ(b, g), function() {
      return vQ(b, g);
    };
  }, [o.current, r]), /* @__PURE__ */ B.createElement(yQ, {
    ref: i
  }, d ? /* @__PURE__ */ B.cloneElement(c, {
    ref: p
  }) : c);
}
var YA = /* @__PURE__ */ B.forwardRef(_Q);
process.env.NODE_ENV !== "production" && (YA.displayName = "SingleObserver");
var wQ = "rc-observer-key";
function xQ(e, t) {
  var n = e.children, r = typeof n == "function" ? [n] : Ty(n);
  return process.env.NODE_ENV !== "production" && (r.length > 1 ? Lh(!1, "Find more than one child node with `children` in ResizeObserver. Please use ResizeObserver.Collection instead.") : r.length === 0 && Lh(!1, "`children` of ResizeObserver is empty. Nothing is in observe.")), r.map(function(o, i) {
    var a = (o == null ? void 0 : o.key) || "".concat(wQ, "-").concat(i);
    return /* @__PURE__ */ B.createElement(YA, re({}, e, {
      key: a,
      ref: i === 0 ? t : void 0
    }), o);
  });
}
var fg = /* @__PURE__ */ B.forwardRef(xQ);
process.env.NODE_ENV !== "production" && (fg.displayName = "ResizeObserver");
fg.Collection = XJ;
function ZA(e) {
  var t;
  return e == null || (t = e.getRootNode) === null || t === void 0 ? void 0 : t.call(e);
}
function CQ(e) {
  return ZA(e) instanceof ShadowRoot;
}
function My(e) {
  return CQ(e) ? ZA(e) : null;
}
function Ba(e) {
  var t = B.useRef();
  t.current = e;
  var n = B.useCallback(function() {
    for (var r, o = arguments.length, i = new Array(o), a = 0; a < o; a++)
      i[a] = arguments[a];
    return (r = t.current) === null || r === void 0 ? void 0 : r.call.apply(r, [t].concat(i));
  }, []);
  return n;
}
function SQ() {
  var e = Je({}, B);
  return e.useId;
}
var GT = 0, YT = SQ();
const TQ = YT ? (
  // Use React `useId`
  function(e) {
    var t = YT();
    return e || (process.env.NODE_ENV === "test" ? "test-id" : t);
  }
) : (
  // Use compatible of `useId`
  function(e) {
    var t = B.useState("ssr-id"), n = wt(t, 2), r = n[0], o = n[1];
    return B.useEffect(function() {
      var i = GT;
      GT += 1, o("rc_unique_".concat(i));
    }, []), e || (process.env.NODE_ENV === "test" ? "test-id" : r);
  }
), EQ = function() {
  if (typeof navigator == "undefined" || typeof window == "undefined")
    return !1;
  var e = navigator.userAgent || navigator.vendor || window.opera;
  return /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(e) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(e == null ? void 0 : e.substr(0, 4));
};
var kQ = /* @__PURE__ */ B.createContext({}), MQ = /* @__PURE__ */ function(e) {
  _w(n, e);
  var t = ww(n);
  function n() {
    return bw(this, n), t.apply(this, arguments);
  }
  return yw(n, [{
    key: "render",
    value: function() {
      return this.props.children;
    }
  }]), n;
}(B.Component);
function Jp(e) {
  var t = B.useRef(!1), n = B.useState(e), r = wt(n, 2), o = r[0], i = r[1];
  B.useEffect(function() {
    return t.current = !1, function() {
      t.current = !0;
    };
  }, []);
  function a(s, c) {
    c && t.current || i(s);
  }
  return [o, a];
}
var za = "none", cp = "appear", up = "enter", dp = "leave", ZT = "none", ii = "prepare", rc = "start", oc = "active", xw = "end", XA = "prepared";
function XT(e, t) {
  var n = {};
  return n[e.toLowerCase()] = t.toLowerCase(), n["Webkit".concat(e)] = "webkit".concat(t), n["Moz".concat(e)] = "moz".concat(t), n["ms".concat(e)] = "MS".concat(t), n["O".concat(e)] = "o".concat(t.toLowerCase()), n;
}
function RQ(e, t) {
  var n = {
    animationend: XT("Animation", "AnimationEnd"),
    transitionend: XT("Transition", "TransitionEnd")
  };
  return e && ("AnimationEvent" in t || delete n.animationend.animation, "TransitionEvent" in t || delete n.transitionend.transition), n;
}
var PQ = RQ(Ai(), typeof window != "undefined" ? window : {}), KA = {};
if (Ai()) {
  var OQ = document.createElement("div");
  KA = OQ.style;
}
var fp = {};
function JA(e) {
  if (fp[e])
    return fp[e];
  var t = PQ[e];
  if (t)
    for (var n = Object.keys(t), r = n.length, o = 0; o < r; o += 1) {
      var i = n[o];
      if (Object.prototype.hasOwnProperty.call(t, i) && i in KA)
        return fp[e] = t[i], fp[e];
    }
  return "";
}
var QA = JA("animationend"), eD = JA("transitionend"), tD = !!(QA && eD), KT = QA || "animationend", JT = eD || "transitionend";
function QT(e, t) {
  if (!e)
    return null;
  if (Wo(e) === "object") {
    var n = t.replace(/-\w/g, function(r) {
      return r[1].toUpperCase();
    });
    return e[n];
  }
  return "".concat(e, "-").concat(t);
}
const NQ = function(e) {
  var t = it();
  function n(o) {
    o && (o.removeEventListener(JT, e), o.removeEventListener(KT, e));
  }
  function r(o) {
    t.current && t.current !== o && n(t.current), o && o !== t.current && (o.addEventListener(JT, e), o.addEventListener(KT, e), t.current = o);
  }
  return B.useEffect(function() {
    return function() {
      n(t.current);
    };
  }, []), [r, n];
};
var nD = Ai() ? Lc : mt, rD = function(e) {
  return +setTimeout(e, 16);
}, oD = function(e) {
  return clearTimeout(e);
};
typeof window != "undefined" && "requestAnimationFrame" in window && (rD = function(e) {
  return window.requestAnimationFrame(e);
}, oD = function(e) {
  return window.cancelAnimationFrame(e);
});
var eE = 0, pg = /* @__PURE__ */ new Map();
function iD(e) {
  pg.delete(e);
}
var Bh = function(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
  eE += 1;
  var n = eE;
  function r(o) {
    if (o === 0)
      iD(n), e();
    else {
      var i = rD(function() {
        r(o - 1);
      });
      pg.set(n, i);
    }
  }
  return r(t), n;
};
Bh.cancel = function(e) {
  var t = pg.get(e);
  return iD(e), oD(t);
};
process.env.NODE_ENV !== "production" && (Bh.ids = function() {
  return pg;
});
const AQ = function() {
  var e = B.useRef(null);
  function t() {
    Bh.cancel(e.current);
  }
  function n(r) {
    var o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2;
    t();
    var i = Bh(function() {
      o <= 1 ? r({
        isCanceled: function() {
          return i !== e.current;
        }
      }) : n(r, o - 1);
    });
    e.current = i;
  }
  return B.useEffect(function() {
    return function() {
      t();
    };
  }, []), [n, t];
};
var DQ = [ii, rc, oc, xw], IQ = [ii, XA], aD = !1, LQ = !0;
function sD(e) {
  return e === oc || e === xw;
}
const $Q = function(e, t, n) {
  var r = Jp(ZT), o = wt(r, 2), i = o[0], a = o[1], s = AQ(), c = wt(s, 2), l = c[0], d = c[1];
  function f() {
    a(ii, !0);
  }
  var p = t ? IQ : DQ;
  return nD(function() {
    if (i !== ZT && i !== xw) {
      var m = p.indexOf(i), v = p[m + 1], g = n(i);
      g === aD ? a(v, !0) : v && l(function(b) {
        function x() {
          b.isCanceled() || a(v, !0);
        }
        g === !0 ? x() : Promise.resolve(g).then(x);
      });
    }
  }, [e, i]), B.useEffect(function() {
    return function() {
      d();
    };
  }, []), [f, i];
};
function FQ(e, t, n, r) {
  var o = r.motionEnter, i = o === void 0 ? !0 : o, a = r.motionAppear, s = a === void 0 ? !0 : a, c = r.motionLeave, l = c === void 0 ? !0 : c, d = r.motionDeadline, f = r.motionLeaveImmediately, p = r.onAppearPrepare, m = r.onEnterPrepare, v = r.onLeavePrepare, g = r.onAppearStart, b = r.onEnterStart, x = r.onLeaveStart, T = r.onAppearActive, S = r.onEnterActive, _ = r.onLeaveActive, w = r.onAppearEnd, k = r.onEnterEnd, E = r.onLeaveEnd, R = r.onVisibleChanged, P = Jp(), A = wt(P, 2), D = A[0], N = A[1], F = Jp(za), $ = wt(F, 2), I = $[0], j = $[1], U = Jp(null), G = wt(U, 2), V = G[0], H = G[1], q = it(!1), Q = it(null);
  function X() {
    return n();
  }
  var K = it(!1);
  function J() {
    j(za, !0), H(null, !0);
  }
  var ne = Ba(function(Se) {
    if (I !== za) {
      var Te = X();
      if (!(Se && !Se.deadline && Se.target !== Te)) {
        var Ae = K.current, je;
        I === cp && Ae ? je = w == null ? void 0 : w(Te, Se) : I === up && Ae ? je = k == null ? void 0 : k(Te, Se) : I === dp && Ae && (je = E == null ? void 0 : E(Te, Se)), Ae && je !== !1 && J();
      }
    }
  }), ae = NQ(ne), te = wt(ae, 1), le = te[0], ce = function(Se) {
    switch (Se) {
      case cp:
        return kr(kr(kr({}, ii, p), rc, g), oc, T);
      case up:
        return kr(kr(kr({}, ii, m), rc, b), oc, S);
      case dp:
        return kr(kr(kr({}, ii, v), rc, x), oc, _);
      default:
        return {};
    }
  }, fe = B.useMemo(function() {
    return ce(I);
  }, [I]), ee = $Q(I, !e, function(Se) {
    if (Se === ii) {
      var Te = fe[ii];
      return Te ? Te(X()) : aD;
    }
    if (ve in fe) {
      var Ae;
      H(((Ae = fe[ve]) === null || Ae === void 0 ? void 0 : Ae.call(fe, X(), null)) || null);
    }
    return ve === oc && I !== za && (le(X()), d > 0 && (clearTimeout(Q.current), Q.current = setTimeout(function() {
      ne({
        deadline: !0
      });
    }, d))), ve === XA && J(), LQ;
  }), me = wt(ee, 2), oe = me[0], ve = me[1], we = sD(ve);
  K.current = we, nD(function() {
    N(t);
    var Se = q.current;
    q.current = !0;
    var Te;
    !Se && t && s && (Te = cp), Se && t && i && (Te = up), (Se && !t && l || !Se && f && !t && l) && (Te = dp);
    var Ae = ce(Te);
    Te && (e || Ae[ii]) ? (j(Te), oe()) : j(za);
  }, [t]), mt(function() {
    (I === cp && !s || // Cancel enter
    I === up && !i || // Cancel leave
    I === dp && !l) && j(za);
  }, [s, i, l]), mt(function() {
    return function() {
      q.current = !1, clearTimeout(Q.current);
    };
  }, []);
  var ye = B.useRef(!1);
  mt(function() {
    D && (ye.current = !0), D !== void 0 && I === za && ((ye.current || D) && (R == null || R(D)), ye.current = !0);
  }, [D, I]);
  var Ce = V;
  return fe[ii] && ve === rc && (Ce = Je({
    transition: "none"
  }, Ce)), [I, ve, Ce, D != null ? D : t];
}
function zQ(e) {
  var t = e;
  Wo(e) === "object" && (t = e.transitionSupport);
  function n(o, i) {
    return !!(o.motionName && t && i !== !1);
  }
  var r = /* @__PURE__ */ B.forwardRef(function(o, i) {
    var a = o.visible, s = a === void 0 ? !0 : a, c = o.removeOnLeave, l = c === void 0 ? !0 : c, d = o.forceRender, f = o.children, p = o.motionName, m = o.leavedClassName, v = o.eventProps, g = B.useContext(kQ), b = g.motion, x = n(o, b), T = it(), S = it();
    function _() {
      try {
        return T.current instanceof HTMLElement ? T.current : Kp(S.current);
      } catch (V) {
        return null;
      }
    }
    var w = FQ(x, s, _, o), k = wt(w, 4), E = k[0], R = k[1], P = k[2], A = k[3], D = B.useRef(A);
    A && (D.current = !0);
    var N = B.useCallback(function(V) {
      T.current = V, hw(i, V);
    }, [i]), F, $ = Je(Je({}, v), {}, {
      visible: s
    });
    if (!f)
      F = null;
    else if (E === za)
      A ? F = f(Je({}, $), N) : !l && D.current && m ? F = f(Je(Je({}, $), {}, {
        className: m
      }), N) : d || !l && !m ? F = f(Je(Je({}, $), {}, {
        style: {
          display: "none"
        }
      }), N) : F = null;
    else {
      var I;
      R === ii ? I = "prepare" : sD(R) ? I = "active" : R === rc && (I = "start");
      var j = QT(p, "".concat(E, "-").concat(I));
      F = f(Je(Je({}, $), {}, {
        className: rs(QT(p, E), kr(kr({}, j, j && I), p, typeof p == "string")),
        style: P
      }), N);
    }
    if (/* @__PURE__ */ B.isValidElement(F) && cg(F)) {
      var U = F, G = U.ref;
      G || (F = /* @__PURE__ */ B.cloneElement(F, {
        ref: N
      }));
    }
    return /* @__PURE__ */ B.createElement(MQ, {
      ref: S
    }, F);
  });
  return r.displayName = "CSSMotion", r;
}
const Cw = zQ(tD);
var Ry = "add", Py = "keep", Oy = "remove", o0 = "removed";
function BQ(e) {
  var t;
  return e && Wo(e) === "object" && "key" in e ? t = e : t = {
    key: e
  }, Je(Je({}, t), {}, {
    key: String(t.key)
  });
}
function Ny() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
  return e.map(BQ);
}
function HQ() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], n = [], r = 0, o = t.length, i = Ny(e), a = Ny(t);
  i.forEach(function(l) {
    for (var d = !1, f = r; f < o; f += 1) {
      var p = a[f];
      if (p.key === l.key) {
        r < f && (n = n.concat(a.slice(r, f).map(function(m) {
          return Je(Je({}, m), {}, {
            status: Ry
          });
        })), r = f), n.push(Je(Je({}, p), {}, {
          status: Py
        })), r += 1, d = !0;
        break;
      }
    }
    d || n.push(Je(Je({}, l), {}, {
      status: Oy
    }));
  }), r < o && (n = n.concat(a.slice(r).map(function(l) {
    return Je(Je({}, l), {}, {
      status: Ry
    });
  })));
  var s = {};
  n.forEach(function(l) {
    var d = l.key;
    s[d] = (s[d] || 0) + 1;
  });
  var c = Object.keys(s).filter(function(l) {
    return s[l] > 1;
  });
  return c.forEach(function(l) {
    n = n.filter(function(d) {
      var f = d.key, p = d.status;
      return f !== l || p !== Oy;
    }), n.forEach(function(d) {
      d.key === l && (d.status = Py);
    });
  }), n;
}
var jQ = ["component", "children", "onVisibleChanged", "onAllRemoved"], WQ = ["status"], VQ = ["eventProps", "visible", "children", "motionName", "motionAppear", "motionEnter", "motionLeave", "motionLeaveImmediately", "motionDeadline", "removeOnLeave", "leavedClassName", "onAppearPrepare", "onAppearStart", "onAppearActive", "onAppearEnd", "onEnterStart", "onEnterActive", "onEnterEnd", "onLeaveStart", "onLeaveActive", "onLeaveEnd"];
function UQ(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Cw, n = /* @__PURE__ */ function(r) {
    _w(i, r);
    var o = ww(i);
    function i() {
      var a;
      bw(this, i);
      for (var s = arguments.length, c = new Array(s), l = 0; l < s; l++)
        c[l] = arguments[l];
      return a = o.call.apply(o, [this].concat(c)), kr(Ah(a), "state", {
        keyEntities: []
      }), kr(Ah(a), "removeKey", function(d) {
        var f = a.state.keyEntities, p = f.map(function(m) {
          return m.key !== d ? m : Je(Je({}, m), {}, {
            status: o0
          });
        });
        return a.setState({
          keyEntities: p
        }), p.filter(function(m) {
          var v = m.status;
          return v !== o0;
        }).length;
      }), a;
    }
    return yw(i, [{
      key: "render",
      value: function() {
        var a = this, s = this.state.keyEntities, c = this.props, l = c.component, d = c.children, f = c.onVisibleChanged, p = c.onAllRemoved, m = Ih(c, jQ), v = l || B.Fragment, g = {};
        return VQ.forEach(function(b) {
          g[b] = m[b], delete m[b];
        }), delete m.keys, /* @__PURE__ */ B.createElement(v, m, s.map(function(b, x) {
          var T = b.status, S = Ih(b, WQ), _ = T === Ry || T === Py;
          return /* @__PURE__ */ B.createElement(t, re({}, g, {
            key: S.key,
            visible: _,
            eventProps: S,
            onVisibleChanged: function(w) {
              if (f == null || f(w, {
                key: S.key
              }), !w) {
                var k = a.removeKey(S.key);
                k === 0 && p && p();
              }
            }
          }), function(w, k) {
            return d(Je(Je({}, w), {}, {
              index: x
            }), k);
          });
        }));
      }
    }], [{
      key: "getDerivedStateFromProps",
      value: function(a, s) {
        var c = a.keys, l = s.keyEntities, d = Ny(c), f = HQ(l, d);
        return {
          keyEntities: f.filter(function(p) {
            var m = l.find(function(v) {
              var g = v.key;
              return p.key === g;
            });
            return !(m && m.status === o0 && p.status === Oy);
          })
        };
      }
    }]), i;
  }(B.Component);
  return kr(n, "defaultProps", {
    component: "div"
  }), n;
}
UQ(tD);
function qQ(e) {
  var t = e.prefixCls, n = e.align, r = e.arrow, o = e.arrowPos, i = r || {}, a = i.className, s = i.content, c = o.x, l = c === void 0 ? 0 : c, d = o.y, f = d === void 0 ? 0 : d, p = B.useRef();
  if (!n || !n.points)
    return null;
  var m = {
    position: "absolute"
  };
  if (n.autoArrow !== !1) {
    var v = n.points[0], g = n.points[1], b = v[0], x = v[1], T = g[0], S = g[1];
    b === T || !["t", "b"].includes(b) ? m.top = f : b === "t" ? m.top = 0 : m.bottom = 0, x === S || !["l", "r"].includes(x) ? m.left = l : x === "l" ? m.left = 0 : m.right = 0;
  }
  return /* @__PURE__ */ B.createElement("div", {
    ref: p,
    className: rs("".concat(t, "-arrow"), a),
    style: m
  }, s);
}
function GQ(e) {
  var t = e.prefixCls, n = e.open, r = e.zIndex, o = e.mask, i = e.motion;
  return o ? /* @__PURE__ */ B.createElement(Cw, re({}, i, {
    motionAppear: !0,
    visible: n,
    removeOnLeave: !0
  }), function(a) {
    var s = a.className;
    return /* @__PURE__ */ B.createElement("div", {
      style: {
        zIndex: r
      },
      className: rs("".concat(t, "-mask"), s)
    });
  }) : null;
}
var lD = /* @__PURE__ */ B.memo(function(e) {
  var t = e.children;
  return t;
}, function(e, t) {
  return t.cache;
});
process.env.NODE_ENV !== "production" && (lD.displayName = "PopupContent");
var cD = /* @__PURE__ */ B.forwardRef(function(e, t) {
  var n = e.popup, r = e.className, o = e.prefixCls, i = e.style, a = e.target, s = e.onVisibleChanged, c = e.open, l = e.keepDom, d = e.fresh, f = e.onClick, p = e.mask, m = e.arrow, v = e.arrowPos, g = e.align, b = e.motion, x = e.maskMotion, T = e.forceRender, S = e.getPopupContainer, _ = e.autoDestroy, w = e.portal, k = e.zIndex, E = e.onMouseEnter, R = e.onMouseLeave, P = e.onPointerEnter, A = e.ready, D = e.offsetX, N = e.offsetY, F = e.offsetR, $ = e.offsetB, I = e.onAlign, j = e.onPrepare, U = e.stretch, G = e.targetWidth, V = e.targetHeight, H = typeof n == "function" ? n() : n, q = c || l, Q = (S == null ? void 0 : S.length) > 0, X = B.useState(!S || !Q), K = wt(X, 2), J = K[0], ne = K[1];
  if (io(function() {
    !J && Q && a && ne(!0);
  }, [J, Q, a]), !J)
    return null;
  var ae = "auto", te = {
    left: "-1000vw",
    top: "-1000vh",
    right: ae,
    bottom: ae
  };
  if (A || !c) {
    var le, ce = g.points, fe = g.dynamicInset || ((le = g._experimental) === null || le === void 0 ? void 0 : le.dynamicInset), ee = fe && ce[0][1] === "r", me = fe && ce[0][0] === "b";
    ee ? (te.right = F, te.left = ae) : (te.left = D, te.right = ae), me ? (te.bottom = $, te.top = ae) : (te.top = N, te.bottom = ae);
  }
  var oe = {};
  return U && (U.includes("height") && V ? oe.height = V : U.includes("minHeight") && V && (oe.minHeight = V), U.includes("width") && G ? oe.width = G : U.includes("minWidth") && G && (oe.minWidth = G)), c || (oe.pointerEvents = "none"), /* @__PURE__ */ B.createElement(w, {
    open: T || q,
    getContainer: S && function() {
      return S(a);
    },
    autoDestroy: _
  }, /* @__PURE__ */ B.createElement(GQ, {
    prefixCls: o,
    open: c,
    zIndex: k,
    mask: p,
    motion: x
  }), /* @__PURE__ */ B.createElement(fg, {
    onResize: I,
    disabled: !c
  }, function(ve) {
    return /* @__PURE__ */ B.createElement(Cw, re({
      motionAppear: !0,
      motionEnter: !0,
      motionLeave: !0,
      removeOnLeave: !1,
      forceRender: T,
      leavedClassName: "".concat(o, "-hidden")
    }, b, {
      onAppearPrepare: j,
      onEnterPrepare: j,
      visible: c,
      onVisibleChanged: function(we) {
        var ye;
        b == null || (ye = b.onVisibleChanged) === null || ye === void 0 || ye.call(b, we), s(we);
      }
    }), function(we, ye) {
      var Ce = we.className, Se = we.style, Te = rs(o, Ce, r);
      return /* @__PURE__ */ B.createElement("div", {
        ref: IA(ve, t, ye),
        className: Te,
        style: Je(Je(Je(Je({
          "--arrow-x": "".concat(v.x || 0, "px"),
          "--arrow-y": "".concat(v.y || 0, "px")
        }, te), oe), Se), {}, {
          boxSizing: "border-box",
          zIndex: k
        }, i),
        onMouseEnter: E,
        onMouseLeave: R,
        onPointerEnter: P,
        onClick: f
      }, m && /* @__PURE__ */ B.createElement(qQ, {
        prefixCls: o,
        arrow: m,
        arrowPos: v,
        align: g
      }), /* @__PURE__ */ B.createElement(lD, {
        cache: !c && !d
      }, H));
    });
  }));
});
process.env.NODE_ENV !== "production" && (cD.displayName = "Popup");
var uD = /* @__PURE__ */ B.forwardRef(function(e, t) {
  var n = e.children, r = e.getTriggerDOMNode, o = cg(n), i = B.useCallback(function(s) {
    hw(t, r ? r(s) : s);
  }, [r]), a = mw(i, n.ref);
  return o ? /* @__PURE__ */ B.cloneElement(n, {
    ref: a
  }) : n;
});
process.env.NODE_ENV !== "production" && (uD.displayName = "TriggerWrapper");
var tE = /* @__PURE__ */ B.createContext(null);
function nE(e) {
  return e ? Array.isArray(e) ? e : [e] : [];
}
function YQ(e, t, n, r) {
  return B.useMemo(function() {
    var o = nE(n != null ? n : t), i = nE(r != null ? r : t), a = new Set(o), s = new Set(i);
    return e && (a.has("hover") && (a.delete("hover"), a.add("click")), s.has("hover") && (s.delete("hover"), s.add("click"))), [a, s];
  }, [e, t, n, r]);
}
const ZQ = function(e) {
  if (!e)
    return !1;
  if (e instanceof Element) {
    if (e.offsetParent)
      return !0;
    if (e.getBBox) {
      var t = e.getBBox(), n = t.width, r = t.height;
      if (n || r)
        return !0;
    }
    if (e.getBoundingClientRect) {
      var o = e.getBoundingClientRect(), i = o.width, a = o.height;
      if (i || a)
        return !0;
    }
  }
  return !1;
};
function XQ() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], n = arguments.length > 2 ? arguments[2] : void 0;
  return n ? e[0] === t[0] : e[0] === t[0] && e[1] === t[1];
}
function KQ(e, t, n, r) {
  for (var o = n.points, i = Object.keys(e), a = 0; a < i.length; a += 1) {
    var s, c = i[a];
    if (XQ((s = e[c]) === null || s === void 0 ? void 0 : s.points, o, r))
      return "".concat(t, "-placement-").concat(c);
  }
  return "";
}
function rE(e, t, n, r) {
  return t || (n ? {
    motionName: "".concat(e, "-").concat(n)
  } : r ? {
    motionName: r
  } : null);
}
function _f(e) {
  return e.ownerDocument.defaultView;
}
function Ay(e) {
  for (var t = [], n = e == null ? void 0 : e.parentElement, r = ["hidden", "scroll", "clip", "auto"]; n; ) {
    var o = _f(n).getComputedStyle(n), i = o.overflowX, a = o.overflowY, s = o.overflow;
    [i, a, s].some(function(c) {
      return r.includes(c);
    }) && t.push(n), n = n.parentElement;
  }
  return t;
}
function jd(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
  return Number.isNaN(e) ? t : e;
}
function Nu(e) {
  return jd(parseFloat(e), 0);
}
function oE(e, t) {
  var n = Je({}, e);
  return (t || []).forEach(function(r) {
    if (!(r instanceof HTMLBodyElement || r instanceof HTMLHtmlElement)) {
      var o = _f(r).getComputedStyle(r), i = o.overflow, a = o.overflowClipMargin, s = o.borderTopWidth, c = o.borderBottomWidth, l = o.borderLeftWidth, d = o.borderRightWidth, f = r.getBoundingClientRect(), p = r.offsetHeight, m = r.clientHeight, v = r.offsetWidth, g = r.clientWidth, b = Nu(s), x = Nu(c), T = Nu(l), S = Nu(d), _ = jd(Math.round(f.width / v * 1e3) / 1e3), w = jd(Math.round(f.height / p * 1e3) / 1e3), k = (v - g - T - S) * _, E = (p - m - b - x) * w, R = b * w, P = x * w, A = T * _, D = S * _, N = 0, F = 0;
      if (i === "clip") {
        var $ = Nu(a);
        N = $ * _, F = $ * w;
      }
      var I = f.x + A - N, j = f.y + R - F, U = I + f.width + 2 * N - A - D - k, G = j + f.height + 2 * F - R - P - E;
      n.left = Math.max(n.left, I), n.top = Math.max(n.top, j), n.right = Math.min(n.right, U), n.bottom = Math.min(n.bottom, G);
    }
  }), n;
}
function iE(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, n = "".concat(t), r = n.match(/^(.*)\%$/);
  return r ? e * (parseFloat(r[1]) / 100) : parseFloat(n);
}
function aE(e, t) {
  var n = t || [], r = wt(n, 2), o = r[0], i = r[1];
  return [iE(e.width, o), iE(e.height, i)];
}
function sE() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
  return [e[0], e[1]];
}
function Nl(e, t) {
  var n = t[0], r = t[1], o, i;
  return n === "t" ? i = e.y : n === "b" ? i = e.y + e.height : i = e.y + e.height / 2, r === "l" ? o = e.x : r === "r" ? o = e.x + e.width : o = e.x + e.width / 2, {
    x: o,
    y: i
  };
}
function Da(e, t) {
  var n = {
    t: "b",
    b: "t",
    l: "r",
    r: "l"
  };
  return e.map(function(r, o) {
    return o === t ? n[r] || "c" : r;
  }).join("");
}
function JQ(e, t, n, r, o, i, a) {
  var s = B.useState({
    ready: !1,
    offsetX: 0,
    offsetY: 0,
    offsetR: 0,
    offsetB: 0,
    arrowX: 0,
    arrowY: 0,
    scaleX: 1,
    scaleY: 1,
    align: o[r] || {}
  }), c = wt(s, 2), l = c[0], d = c[1], f = B.useRef(0), p = B.useMemo(function() {
    return t ? Ay(t) : [];
  }, [t]), m = B.useRef({}), v = function() {
    m.current = {};
  };
  e || v();
  var g = Ba(function() {
    if (t && n && e) {
      let tr = function(no, Co) {
        var fi = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Te, Ji = H.x + no, pi = H.y + Co, Ma = Ji + le, hi = pi + te, Cs = Math.max(Ji, fi.left), Ss = Math.max(pi, fi.top), pu = Math.min(Ma, fi.right), Ze = Math.min(hi, fi.bottom);
        return Math.max(0, (pu - Cs) * (Ze - Ss));
      }, ka = function() {
        Jn = H.y + Tt, qn = Jn + te, Sn = H.x + kt, Qn = Sn + le;
      };
      var T, S, _ = t, w = _.ownerDocument, k = _f(_), E = k.getComputedStyle(_), R = E.width, P = E.height, A = E.position, D = _.style.left, N = _.style.top, F = _.style.right, $ = _.style.bottom, I = _.style.overflow, j = Je(Je({}, o[r]), i), U = w.createElement("div");
      (T = _.parentElement) === null || T === void 0 || T.appendChild(U), U.style.left = "".concat(_.offsetLeft, "px"), U.style.top = "".concat(_.offsetTop, "px"), U.style.position = A, U.style.height = "".concat(_.offsetHeight, "px"), U.style.width = "".concat(_.offsetWidth, "px"), _.style.left = "0", _.style.top = "0", _.style.right = "auto", _.style.bottom = "auto", _.style.overflow = "hidden";
      var G;
      if (Array.isArray(n))
        G = {
          x: n[0],
          y: n[1],
          width: 0,
          height: 0
        };
      else {
        var V = n.getBoundingClientRect();
        G = {
          x: V.x,
          y: V.y,
          width: V.width,
          height: V.height
        };
      }
      var H = _.getBoundingClientRect(), q = w.documentElement, Q = q.clientWidth, X = q.clientHeight, K = q.scrollWidth, J = q.scrollHeight, ne = q.scrollTop, ae = q.scrollLeft, te = H.height, le = H.width, ce = G.height, fe = G.width, ee = {
        left: 0,
        top: 0,
        right: Q,
        bottom: X
      }, me = {
        left: -ae,
        top: -ne,
        right: K - ae,
        bottom: J - ne
      }, oe = j.htmlRegion, ve = "visible", we = "visibleFirst";
      oe !== "scroll" && oe !== we && (oe = ve);
      var ye = oe === we, Ce = oE(me, p), Se = oE(ee, p), Te = oe === ve ? Se : Ce, Ae = ye ? Se : Te;
      _.style.left = "auto", _.style.top = "auto", _.style.right = "0", _.style.bottom = "0";
      var je = _.getBoundingClientRect();
      _.style.left = D, _.style.top = N, _.style.right = F, _.style.bottom = $, _.style.overflow = I, (S = _.parentElement) === null || S === void 0 || S.removeChild(U);
      var Me = jd(Math.round(le / parseFloat(R) * 1e3) / 1e3), ze = jd(Math.round(te / parseFloat(P) * 1e3) / 1e3);
      if (Me === 0 || ze === 0 || Hd(n) && !ZQ(n))
        return;
      var ft = j.offset, Ue = j.targetOffset, Be = aE(H, ft), Pe = wt(Be, 2), Ee = Pe[0], st = Pe[1], Vt = aE(G, Ue), Ct = wt(Vt, 2), Ne = Ct[0], Ve = Ct[1];
      G.x -= Ne, G.y -= Ve;
      var ut = j.points || [], Ut = wt(ut, 2), St = Ut[0], Zn = Ut[1], Cn = sE(Zn), an = sE(St), xr = Nl(G, Cn), Vn = Nl(H, an), An = Je({}, j), kt = xr.x - Vn.x + Ee, Tt = xr.y - Vn.y + st, Nt = tr(kt, Tt), Cr = tr(kt, Tt, Se), Xn = Nl(G, ["t", "l"]), mn = Nl(H, ["t", "l"]), Kn = Nl(G, ["b", "r"]), Un = Nl(H, ["b", "r"]), Bt = j.overflow || {}, gt = Bt.adjustX, Zt = Bt.adjustY, ke = Bt.shiftX, gn = Bt.shiftY, ir = function(no) {
        return typeof no == "boolean" ? no : no >= 0;
      }, Jn, qn, Sn, Qn;
      ka();
      var er = ir(Zt), mr = an[0] === Cn[0];
      if (er && an[0] === "t" && (qn > Ae.bottom || m.current.bt)) {
        var Ir = Tt;
        mr ? Ir -= te - ce : Ir = Xn.y - Un.y - st;
        var Ye = tr(kt, Ir), Le = tr(kt, Ir, Se);
        Ye > Nt || Ye === Nt && (!ye || // Choose recommend one
        Le >= Cr) ? (m.current.bt = !0, Tt = Ir, st = -st, An.points = [Da(an, 0), Da(Cn, 0)]) : m.current.bt = !1;
      }
      if (er && an[0] === "b" && (Jn < Ae.top || m.current.tb)) {
        var dn = Tt;
        mr ? dn += te - ce : dn = Kn.y - mn.y - st;
        var ar = tr(kt, dn), uu = tr(kt, dn, Se);
        ar > Nt || ar === Nt && (!ye || // Choose recommend one
        uu >= Cr) ? (m.current.tb = !0, Tt = dn, st = -st, An.points = [Da(an, 0), Da(Cn, 0)]) : m.current.tb = !1;
      }
      var Gi = ir(gt), hl = an[1] === Cn[1];
      if (Gi && an[1] === "l" && (Qn > Ae.right || m.current.rl)) {
        var Yi = kt;
        hl ? Yi -= le - fe : Yi = Xn.x - Un.x - Ee;
        var ml = tr(Yi, Tt), du = tr(Yi, Tt, Se);
        ml > Nt || ml === Nt && (!ye || // Choose recommend one
        du >= Cr) ? (m.current.rl = !0, kt = Yi, Ee = -Ee, An.points = [Da(an, 1), Da(Cn, 1)]) : m.current.rl = !1;
      }
      if (Gi && an[1] === "r" && (Sn < Ae.left || m.current.lr)) {
        var Zi = kt;
        hl ? Zi += le - fe : Zi = Kn.x - mn.x - Ee;
        var Ta = tr(Zi, Tt), Xi = tr(Zi, Tt, Se);
        Ta > Nt || Ta === Nt && (!ye || // Choose recommend one
        Xi >= Cr) ? (m.current.lr = !0, kt = Zi, Ee = -Ee, An.points = [Da(an, 1), Da(Cn, 1)]) : m.current.lr = !1;
      }
      ka();
      var Qr = ke === !0 ? 0 : ke;
      typeof Qr == "number" && (Sn < Se.left && (kt -= Sn - Se.left - Ee, G.x + fe < Se.left + Qr && (kt += G.x - Se.left + fe - Qr)), Qn > Se.right && (kt -= Qn - Se.right - Ee, G.x > Se.right - Qr && (kt += G.x - Se.right + Qr)));
      var yo = gn === !0 ? 0 : gn;
      typeof yo == "number" && (Jn < Se.top && (Tt -= Jn - Se.top - st, G.y + ce < Se.top + yo && (Tt += G.y - Se.top + ce - yo)), qn > Se.bottom && (Tt -= qn - Se.bottom - st, G.y > Se.bottom - yo && (Tt += G.y - Se.bottom + yo)));
      var Qo = H.x + kt, pt = Qo + le, Et = H.y + Tt, _o = Et + te, wo = G.x, eo = wo + fe, to = G.y, tt = to + ce, Xt = Math.max(Qo, wo), xs = Math.min(pt, eo), Ki = (Xt + xs) / 2, gr = Ki - Qo, fu = Math.max(Et, to), Ea = Math.min(_o, tt), xo = (fu + Ea) / 2, sn = xo - Et;
      a == null || a(t, An);
      var ei = je.right - H.x - (kt + H.width), di = je.bottom - H.y - (Tt + H.height);
      d({
        ready: !0,
        offsetX: kt / Me,
        offsetY: Tt / ze,
        offsetR: ei / Me,
        offsetB: di / ze,
        arrowX: gr / Me,
        arrowY: sn / ze,
        scaleX: Me,
        scaleY: ze,
        align: An
      });
    }
  }), b = function() {
    f.current += 1;
    var T = f.current;
    Promise.resolve().then(function() {
      f.current === T && g();
    });
  }, x = function() {
    d(function(T) {
      return Je(Je({}, T), {}, {
        ready: !1
      });
    });
  };
  return io(x, [r]), io(function() {
    e || x();
  }, [e]), [l.ready, l.offsetX, l.offsetY, l.offsetR, l.offsetB, l.arrowX, l.arrowY, l.scaleX, l.scaleY, l.align, b];
}
function QQ(e, t, n, r, o) {
  io(function() {
    if (e && t && n) {
      let f = function() {
        r(), o();
      };
      var i = t, a = n, s = Ay(i), c = Ay(a), l = _f(a), d = new Set([l].concat(xy(s), xy(c)));
      return d.forEach(function(p) {
        p.addEventListener("scroll", f, {
          passive: !0
        });
      }), l.addEventListener("resize", f, {
        passive: !0
      }), r(), function() {
        d.forEach(function(p) {
          p.removeEventListener("scroll", f), l.removeEventListener("resize", f);
        });
      };
    }
  }, [e, t, n]);
}
function eee(e, t, n, r, o, i, a, s) {
  var c = B.useRef(e);
  c.current = e, B.useEffect(function() {
    if (t && r && (!o || i)) {
      var l = function(b) {
        var x = b.target;
        c.current && !a(x) && s(!1);
      }, d = _f(r);
      d.addEventListener("mousedown", l, !0), d.addEventListener("contextmenu", l, !0);
      var f = My(n);
      if (f && (f.addEventListener("mousedown", l, !0), f.addEventListener("contextmenu", l, !0)), process.env.NODE_ENV !== "production") {
        var p, m, v = n == null || (p = n.getRootNode) === null || p === void 0 ? void 0 : p.call(n), g = (m = r.getRootNode) === null || m === void 0 ? void 0 : m.call(r);
        Lh(v === g, "trigger element and popup element should in same shadow root.");
      }
      return function() {
        d.removeEventListener("mousedown", l, !0), d.removeEventListener("contextmenu", l, !0), f && (f.removeEventListener("mousedown", l, !0), f.removeEventListener("contextmenu", l, !0));
      };
    }
  }, [t, n, r, o, i]);
}
var tee = ["prefixCls", "children", "action", "showAction", "hideAction", "popupVisible", "defaultPopupVisible", "onPopupVisibleChange", "afterPopupVisibleChange", "mouseEnterDelay", "mouseLeaveDelay", "focusDelay", "blurDelay", "mask", "maskClosable", "getPopupContainer", "forceRender", "autoDestroy", "destroyPopupOnHide", "popup", "popupClassName", "popupStyle", "popupPlacement", "builtinPlacements", "popupAlign", "zIndex", "stretch", "getPopupClassNameFromAlign", "fresh", "alignPoint", "onPopupClick", "onPopupAlign", "arrow", "popupMotion", "maskMotion", "popupTransitionName", "popupAnimation", "maskTransitionName", "maskAnimation", "className", "getTriggerDOMNode"];
function nee() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : vw, t = /* @__PURE__ */ B.forwardRef(function(n, r) {
    var o = n.prefixCls, i = o === void 0 ? "rc-trigger-popup" : o, a = n.children, s = n.action, c = s === void 0 ? "hover" : s, l = n.showAction, d = n.hideAction, f = n.popupVisible, p = n.defaultPopupVisible, m = n.onPopupVisibleChange, v = n.afterPopupVisibleChange, g = n.mouseEnterDelay, b = n.mouseLeaveDelay, x = b === void 0 ? 0.1 : b, T = n.focusDelay, S = n.blurDelay, _ = n.mask, w = n.maskClosable, k = w === void 0 ? !0 : w, E = n.getPopupContainer, R = n.forceRender, P = n.autoDestroy, A = n.destroyPopupOnHide, D = n.popup, N = n.popupClassName, F = n.popupStyle, $ = n.popupPlacement, I = n.builtinPlacements, j = I === void 0 ? {} : I, U = n.popupAlign, G = n.zIndex, V = n.stretch, H = n.getPopupClassNameFromAlign, q = n.fresh, Q = n.alignPoint, X = n.onPopupClick, K = n.onPopupAlign, J = n.arrow, ne = n.popupMotion, ae = n.maskMotion, te = n.popupTransitionName, le = n.popupAnimation, ce = n.maskTransitionName, fe = n.maskAnimation, ee = n.className, me = n.getTriggerDOMNode, oe = Ih(n, tee), ve = P || A || !1, we = B.useState(!1), ye = wt(we, 2), Ce = ye[0], Se = ye[1];
    io(function() {
      Se(EQ());
    }, []);
    var Te = B.useRef({}), Ae = B.useContext(tE), je = B.useMemo(function() {
      return {
        registerSubPopup: function(xe, ht) {
          Te.current[xe] = ht, Ae == null || Ae.registerSubPopup(xe, ht);
        }
      };
    }, [Ae]), Me = TQ(), ze = B.useState(null), ft = wt(ze, 2), Ue = ft[0], Be = ft[1], Pe = B.useRef(null), Ee = Ba(function(xe) {
      Pe.current = xe, Hd(xe) && Ue !== xe && Be(xe), Ae == null || Ae.registerSubPopup(Me, xe);
    }), st = B.useState(null), Vt = wt(st, 2), Ct = Vt[0], Ne = Vt[1], Ve = B.useRef(null), ut = Ba(function(xe) {
      Hd(xe) && Ct !== xe && (Ne(xe), Ve.current = xe);
    }), Ut = B.Children.only(a), St = (Ut == null ? void 0 : Ut.props) || {}, Zn = {}, Cn = Ba(function(xe) {
      var ht, Dn, Tn = Ct;
      return (Tn == null ? void 0 : Tn.contains(xe)) || ((ht = My(Tn)) === null || ht === void 0 ? void 0 : ht.host) === xe || xe === Tn || (Ue == null ? void 0 : Ue.contains(xe)) || ((Dn = My(Ue)) === null || Dn === void 0 ? void 0 : Dn.host) === xe || xe === Ue || Object.values(Te.current).some(function(Kt) {
        return (Kt == null ? void 0 : Kt.contains(xe)) || xe === Kt;
      });
    }), an = rE(i, ne, le, te), xr = rE(i, ae, fe, ce), Vn = B.useState(p || !1), An = wt(Vn, 2), kt = An[0], Tt = An[1], Nt = f != null ? f : kt, Cr = Ba(function(xe) {
      f === void 0 && Tt(xe);
    });
    io(function() {
      Tt(f || !1);
    }, [f]);
    var Xn = B.useRef(Nt);
    Xn.current = Nt;
    var mn = B.useRef([]);
    mn.current = [];
    var Kn = Ba(function(xe) {
      var ht;
      Cr(xe), ((ht = mn.current[mn.current.length - 1]) !== null && ht !== void 0 ? ht : Nt) !== xe && (mn.current.push(xe), m == null || m(xe));
    }), Un = B.useRef(), Bt = function() {
      clearTimeout(Un.current);
    }, gt = function(xe) {
      var ht = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
      Bt(), ht === 0 ? Kn(xe) : Un.current = setTimeout(function() {
        Kn(xe);
      }, ht * 1e3);
    };
    B.useEffect(function() {
      return Bt;
    }, []);
    var Zt = B.useState(!1), ke = wt(Zt, 2), gn = ke[0], ir = ke[1];
    io(function(xe) {
      (!xe || Nt) && ir(!0);
    }, [Nt]);
    var Jn = B.useState(null), qn = wt(Jn, 2), Sn = qn[0], Qn = qn[1], er = B.useState([0, 0]), mr = wt(er, 2), Ir = mr[0], Ye = mr[1], Le = function(xe) {
      Ye([xe.clientX, xe.clientY]);
    }, dn = JQ(Nt, Ue, Q ? Ir : Ct, $, j, U, K), ar = wt(dn, 11), uu = ar[0], Gi = ar[1], hl = ar[2], Yi = ar[3], ml = ar[4], du = ar[5], Zi = ar[6], Ta = ar[7], Xi = ar[8], Qr = ar[9], yo = ar[10], Qo = YQ(Ce, c, l, d), pt = wt(Qo, 2), Et = pt[0], _o = pt[1], wo = Et.has("click"), eo = _o.has("click") || _o.has("contextMenu"), to = Ba(function() {
      gn || yo();
    }), tt = function() {
      Xn.current && Q && eo && gt(!1);
    };
    QQ(Nt, Ct, Ue, to, tt), io(function() {
      to();
    }, [Ir, $]), io(function() {
      Nt && !(j != null && j[$]) && to();
    }, [JSON.stringify(U)]);
    var Xt = B.useMemo(function() {
      var xe = KQ(j, i, Qr, Q);
      return rs(xe, H == null ? void 0 : H(Qr));
    }, [Qr, H, j, i, Q]);
    B.useImperativeHandle(r, function() {
      return {
        nativeElement: Ve.current,
        popupElement: Pe.current,
        forceAlign: to
      };
    });
    var xs = B.useState(0), Ki = wt(xs, 2), gr = Ki[0], fu = Ki[1], Ea = B.useState(0), xo = wt(Ea, 2), sn = xo[0], ei = xo[1], di = function() {
      if (V && Ct) {
        var xe = Ct.getBoundingClientRect();
        fu(xe.width), ei(xe.height);
      }
    }, tr = function() {
      di(), to();
    }, ka = function(xe) {
      ir(!1), yo(), v == null || v(xe);
    }, no = function() {
      return new Promise(function(xe) {
        di(), Qn(function() {
          return xe;
        });
      });
    };
    io(function() {
      Sn && (yo(), Sn(), Qn(null));
    }, [Sn]);
    function Co(xe, ht, Dn, Tn) {
      Zn[xe] = function(Kt) {
        var To;
        Tn == null || Tn(Kt), gt(ht, Dn);
        for (var Ts = arguments.length, Ra = new Array(Ts > 1 ? Ts - 1 : 0), vn = 1; vn < Ts; vn++)
          Ra[vn - 1] = arguments[vn];
        (To = St[xe]) === null || To === void 0 || To.call.apply(To, [St, Kt].concat(Ra));
      };
    }
    (wo || eo) && (Zn.onClick = function(xe) {
      var ht;
      Xn.current && eo ? gt(!1) : !Xn.current && wo && (Le(xe), gt(!0));
      for (var Dn = arguments.length, Tn = new Array(Dn > 1 ? Dn - 1 : 0), Kt = 1; Kt < Dn; Kt++)
        Tn[Kt - 1] = arguments[Kt];
      (ht = St.onClick) === null || ht === void 0 || ht.call.apply(ht, [St, xe].concat(Tn));
    }), eee(Nt, eo, Ct, Ue, _, k, Cn, gt);
    var fi = Et.has("hover"), Ji = _o.has("hover"), pi, Ma;
    fi && (Co("onMouseEnter", !0, g, function(xe) {
      Le(xe);
    }), Co("onPointerEnter", !0, g, function(xe) {
      Le(xe);
    }), pi = function(xe) {
      (Nt || gn) && Ue !== null && Ue !== void 0 && Ue.contains(xe.target) && gt(!0, g);
    }, Q && (Zn.onMouseMove = function(xe) {
      var ht;
      (ht = St.onMouseMove) === null || ht === void 0 || ht.call(St, xe);
    })), Ji && (Co("onMouseLeave", !1, x), Co("onPointerLeave", !1, x), Ma = function() {
      gt(!1, x);
    }), Et.has("focus") && Co("onFocus", !0, T), _o.has("focus") && Co("onBlur", !1, S), Et.has("contextMenu") && (Zn.onContextMenu = function(xe) {
      var ht;
      Xn.current && _o.has("contextMenu") ? gt(!1) : (Le(xe), gt(!0)), xe.preventDefault();
      for (var Dn = arguments.length, Tn = new Array(Dn > 1 ? Dn - 1 : 0), Kt = 1; Kt < Dn; Kt++)
        Tn[Kt - 1] = arguments[Kt];
      (ht = St.onContextMenu) === null || ht === void 0 || ht.call.apply(ht, [St, xe].concat(Tn));
    }), ee && (Zn.className = rs(St.className, ee));
    var hi = Je(Je({}, St), Zn), Cs = {}, Ss = ["onContextMenu", "onClick", "onMouseDown", "onTouchStart", "onMouseEnter", "onMouseLeave", "onFocus", "onBlur"];
    Ss.forEach(function(xe) {
      oe[xe] && (Cs[xe] = function() {
        for (var ht, Dn = arguments.length, Tn = new Array(Dn), Kt = 0; Kt < Dn; Kt++)
          Tn[Kt] = arguments[Kt];
        (ht = hi[xe]) === null || ht === void 0 || ht.call.apply(ht, [hi].concat(Tn)), oe[xe].apply(oe, Tn);
      });
    });
    var pu = /* @__PURE__ */ B.cloneElement(Ut, Je(Je({}, hi), Cs)), Ze = {
      x: du,
      y: Zi
    }, So = J ? Je({}, J !== !0 ? J : {}) : null;
    return /* @__PURE__ */ B.createElement(B.Fragment, null, /* @__PURE__ */ B.createElement(fg, {
      disabled: !Nt,
      ref: ut,
      onResize: tr
    }, /* @__PURE__ */ B.createElement(uD, {
      getTriggerDOMNode: me
    }, pu)), /* @__PURE__ */ B.createElement(tE.Provider, {
      value: je
    }, /* @__PURE__ */ B.createElement(cD, {
      portal: e,
      ref: Ee,
      prefixCls: i,
      popup: D,
      className: rs(N, Xt),
      style: F,
      target: Ct,
      onMouseEnter: pi,
      onMouseLeave: Ma,
      onPointerEnter: pi,
      zIndex: G,
      open: Nt,
      keepDom: gn,
      fresh: q,
      onClick: X,
      mask: _,
      motion: an,
      maskMotion: xr,
      onVisibleChanged: ka,
      onPrepare: no,
      forceRender: R,
      autoDestroy: ve,
      getPopupContainer: E,
      align: Qr,
      arrow: So,
      arrowPos: Ze,
      ready: uu,
      offsetX: Gi,
      offsetY: hl,
      offsetR: Yi,
      offsetB: ml,
      onAlign: to,
      stretch: V,
      targetWidth: gr / Ta,
      targetHeight: sn / Xi
    })));
  });
  return process.env.NODE_ENV !== "production" && (t.displayName = "Trigger"), t;
}
const ree = nee(vw);
var Al = {
  shiftX: 64,
  adjustY: 1
}, Dl = {
  adjustX: 1,
  shiftY: !0
}, Ro = [0, 0], oee = {
  left: {
    points: ["cr", "cl"],
    overflow: Dl,
    offset: [-4, 0],
    targetOffset: Ro
  },
  right: {
    points: ["cl", "cr"],
    overflow: Dl,
    offset: [4, 0],
    targetOffset: Ro
  },
  top: {
    points: ["bc", "tc"],
    overflow: Al,
    offset: [0, -4],
    targetOffset: Ro
  },
  bottom: {
    points: ["tc", "bc"],
    overflow: Al,
    offset: [0, 4],
    targetOffset: Ro
  },
  topLeft: {
    points: ["bl", "tl"],
    overflow: Al,
    offset: [0, -4],
    targetOffset: Ro
  },
  leftTop: {
    points: ["tr", "tl"],
    overflow: Dl,
    offset: [-4, 0],
    targetOffset: Ro
  },
  topRight: {
    points: ["br", "tr"],
    overflow: Al,
    offset: [0, -4],
    targetOffset: Ro
  },
  rightTop: {
    points: ["tl", "tr"],
    overflow: Dl,
    offset: [4, 0],
    targetOffset: Ro
  },
  bottomRight: {
    points: ["tr", "br"],
    overflow: Al,
    offset: [0, 4],
    targetOffset: Ro
  },
  rightBottom: {
    points: ["bl", "br"],
    overflow: Dl,
    offset: [4, 0],
    targetOffset: Ro
  },
  bottomLeft: {
    points: ["tl", "bl"],
    overflow: Al,
    offset: [0, 4],
    targetOffset: Ro
  },
  leftBottom: {
    points: ["br", "bl"],
    overflow: Dl,
    offset: [-4, 0],
    targetOffset: Ro
  }
}, iee = ["overlayClassName", "trigger", "mouseEnterDelay", "mouseLeaveDelay", "overlayStyle", "prefixCls", "children", "onVisibleChange", "afterVisibleChange", "transitionName", "animation", "motion", "placement", "align", "destroyTooltipOnHide", "defaultVisible", "getTooltipContainer", "overlayInnerStyle", "arrowContent", "overlay", "id", "showArrow"], aee = function(e, t) {
  var n = e.overlayClassName, r = e.trigger, o = r === void 0 ? ["hover"] : r, i = e.mouseEnterDelay, a = i === void 0 ? 0 : i, s = e.mouseLeaveDelay, c = s === void 0 ? 0.1 : s, l = e.overlayStyle, d = e.prefixCls, f = d === void 0 ? "rc-tooltip" : d, p = e.children, m = e.onVisibleChange, v = e.afterVisibleChange, g = e.transitionName, b = e.animation, x = e.motion, T = e.placement, S = T === void 0 ? "right" : T, _ = e.align, w = _ === void 0 ? {} : _, k = e.destroyTooltipOnHide, E = k === void 0 ? !1 : k, R = e.defaultVisible, P = e.getTooltipContainer, A = e.overlayInnerStyle, D = e.overlay, N = e.id, F = e.showArrow, $ = F === void 0 ? !0 : F, I = Ih(e, iee), j = it(null);
  S$(t, function() {
    return j.current;
  });
  var U = Je({}, I);
  "visible" in e && (U.popupVisible = e.visible);
  var G = function() {
    return /* @__PURE__ */ B.createElement(TJ, {
      key: "content",
      prefixCls: f,
      id: N,
      overlayInnerStyle: A
    }, D);
  };
  return /* @__PURE__ */ B.createElement(ree, re({
    popupClassName: n,
    prefixCls: f,
    popup: G,
    action: o,
    builtinPlacements: oee,
    popupPlacement: S,
    ref: j,
    popupAlign: w,
    getPopupContainer: P,
    onPopupVisibleChange: m,
    afterPopupVisibleChange: v,
    popupTransitionName: g,
    popupAnimation: b,
    popupMotion: x,
    defaultPopupVisible: R,
    autoDestroy: E,
    mouseLeaveDelay: c,
    popupStyle: l,
    mouseEnterDelay: a,
    arrow: $
  }, U), p);
};
const see = /* @__PURE__ */ nl(aee), lee = "_breakLongWord_1947o_272", cee = "_rcToolTipZoomIn_1947o_1", uee = "_rcToolTipZoomOut_1947o_1", i0 = {
  breakLongWord: lee,
  rcToolTipZoomIn: cee,
  rcToolTipZoomOut: uee
}, Xa = Object.freeze({
  SISENSE_NAMESPACE: "sis-scope",
  TEXT_PRIMARY: "slf-text-primary",
  TEXT_SECONDARY: "slf-text-secondary",
  TEXT_SECONDARY_HOVER: "slf-text-secondary-hov",
  TEXT_HREF: "slf-text-href",
  TEXT_HREF_HOVER: "slf-text-href-hov"
}), dD = (e) => {
  const t = e, {
    breakingLongWord: n,
    hideArrow: r = !1,
    overlayClassName: o,
    overlay: i,
    imgOverlay: a = !1,
    semanticText: s
  } = t, c = Wn(t, [
    "breakingLongWord",
    "hideArrow",
    "overlayClassName",
    "overlay",
    "imgOverlay",
    "semanticText"
  ]), l = Xe(
    o,
    "slf-default",
    Xa.SISENSE_NAMESPACE,
    {
      "hide-arrow": r,
      [i0.breakLongWord]: n,
      [i0.semanticText]: s,
      [i0.semanticText]: s
    }
  );
  return /* @__PURE__ */ z(
    see,
    $e(pe({
      destroyTooltipOnHide: !0,
      overlay: typeof i == "string" ? a ? /* @__PURE__ */ z("img", { src: i }) : /* @__PURE__ */ z("div", { dangerouslySetInnerHTML: { __html: i } }) : i
    }, c), {
      overlayClassName: l
    })
  );
}, dee = "_popover_wakdx_1", fee = "_popoverMask_wakdx_6", lE = {
  popover: dee,
  popoverMask: fee
}, pee = () => {
}, hee = 1069, bd = (e) => {
  const {
    bubbleMouseEvents: t = !1,
    level: n = 0,
    mask: r = !0,
    onRequestClose: o = pee,
    visible: i = !1,
    zIndex: a = hee,
    maskClassName: s,
    getTooltipContainer: c
  } = e, l = () => {
    let f = document.body;
    return c && (f = c()), f;
  }, d = (f) => {
    t || (f.preventDefault(), f.stopPropagation());
  };
  return /* @__PURE__ */ _e(fo, { children: [
    i && r && /* @__PURE__ */ z(mee, { portalRootEl: l(), children: /* @__PURE__ */ z(
      "div",
      {
        className: Xe(lE.popoverMask, s),
        style: { zIndex: (a + n).toString() },
        onClick: (f) => o == null ? void 0 : o(f.nativeEvent)
      }
    ) }),
    /* @__PURE__ */ z(
      dD,
      $e(pe({}, e), {
        overlayClassName: lE.popover,
        hideArrow: !0,
        onClick: d,
        zIndex: a + n + 1,
        align: e.align
      })
    )
  ] });
}, mee = (e) => _r.createPortal(e.children, e.portalRootEl);
var Dy = /* @__PURE__ */ ((e) => (e.topLeft = "tl", e.topCenter = "tc", e.topRight = "tr", e.centerLeft = "cl", e.centerCenter = "cc", e.centerRight = "cr", e.bottomLeft = "bl", e.bottomCenter = "bc", e.bottomRight = "br", e))(Dy || {});
const gee = (e) => {
  const { onRequestClose: t, onClick: n, onKeyPress: r, sortingPopup: o, className: i, getTooltipContainer: a } = e;
  return /* @__PURE__ */ z(
    bd,
    {
      bubbleMouseEvents: !0,
      level: 0,
      mask: !0,
      placement: "bottom",
      onVisibleChange: (s) => {
      },
      trigger: ["click"],
      overlay: () => o,
      onRequestClose: t,
      getTooltipContainer: a,
      visible: o !== null,
      align: {
        points: [Dy.topLeft, Dy.bottomRight]
      },
      children: /* @__PURE__ */ z(
        "span",
        {
          role: "button",
          "aria-label": "Show sorting settings pop-up",
          tabIndex: 0,
          onClick: n,
          onKeyPress: r,
          className: i
        }
      )
    }
  );
}, cE = 50, vee = new RegExp(`<\\/?[\\w\\s="/.':;#-\\/\\?]+>`), a0 = {
  TEXT: "text",
  HTML: "html",
  COMPONENT: "component"
};
class fD extends B.PureComponent {
  constructor(t) {
    super(t), Z(this, "cellEl"), Z(this, "metadataClassName"), Z(this, "virtualBorderStyle"), Z(this, "cellStyle"), Z(this, "cellContentStyle"), Z(this, "databarStyle"), Z(this, "cachedHtml"), Z(this, "timeoutId"), Z(this, "isMouseInCell"), Z(this, "onCellClick", (n) => {
      const {
        isDataCell: r,
        dataNode: o,
        treeNode: i,
        columnTreeNode: a,
        rowTreeNode: s,
        measureTreeNode: c,
        cellMetadata: l,
        onCellClick: d
      } = this.props;
      let f;
      a ? f = o : i && (f = i), d && d({
        event: n,
        isDataCell: r,
        dataNode: f,
        rowTreeNode: s,
        columnTreeNode: a,
        measureTreeNode: c,
        cellMetadata: l,
        cell: this
      });
    }), Z(this, "onCellEnter", (n) => {
      const { onCellEnter: r, cellMetadata: o } = this.props, i = {
        domEvent: n,
        metadata: o,
        cell: o ? o.cellData : void 0
      };
      this.isMouseInCell || (this.timeoutId && (clearTimeout(this.timeoutId), this.timeoutId = void 0), n.persist(), this.timeoutId = setTimeout(() => {
        r && r(i), this.timeoutId = void 0, this.isMouseInCell = !0;
      }, 100));
    }), Z(this, "onCellLeave", (n) => {
      const { onCellLeave: r, cellMetadata: o } = this.props, i = {
        domEvent: n,
        metadata: o,
        cell: o ? o.cellData : void 0
      };
      this.timeoutId && (clearTimeout(this.timeoutId), this.timeoutId = void 0), n.persist(), r && this.isMouseInCell && (r(i), this.isMouseInCell = !1);
    }), Z(this, "onResizeStartHandler", () => {
      const { parent: n } = this.props, { merge: r } = this.state;
      n && n.resizeColumnStart && n.resizeColumnStart();
      const o = this.props.columnIndex + Dv(r);
      let i = 0;
      return n && n.getColumnWidth && (i = n.getColumnWidth(o)), i;
    }), Z(this, "onResizeHandler", (n) => {
      const { parent: r, columnIndex: o } = this.props, { merge: i } = this.state;
      if (r && r.resizeColumn) {
        const a = o + Dv(i), s = Math.max(cE, n), c = [[a, s]], l = { columnIndex: a }, d = { width: !0 };
        r.resizeColumn(c, l, d);
      }
    }), Z(this, "onResizeEndHandler", (n) => {
      const { parent: r, columnIndex: o } = this.props, { merge: i } = this.state;
      if (r && r.resizeColumnEnd) {
        const a = o + Dv(i), s = Math.max(cE, n);
        r.resizeColumnEnd(s, a);
      }
    }), Z(this, "onRangeMinMaxChange", (n, r = this.props) => {
      const { dataNode: o, measureTreeNode: i } = r, a = mW(n.rangeMinMax, o, i);
      a && (this.cellStyle = void 0, this.setState({ backgroundColor: a }));
    }), Z(this, "setSortingPopup", (n) => {
      const r = n !== null;
      this.setState((o) => $e(pe({}, o), {
        sortIconShouldBeVisible: r,
        sortingPopup: n
      }));
    }), Z(this, "handleSortingIconClick", (n) => {
      n.preventDefault(), n.stopPropagation(), this.props.onSortingSettingsChanged(this.props.treeNode, this.props.metadata, this);
    }), Z(this, "createMarkup", (n) => ((!this.cachedHtml || n !== this.cachedHtml.data) && (this.cachedHtml = {
      data: n,
      html: { __html: n }
    }), this.cachedHtml.html)), Z(this, "onCellRef", (n) => {
      n && (this.cellEl = n);
    }), this.state = {
      isDrilled: !1,
      isSelected: this.getSelectStatus(),
      sortIconShouldBeVisible: !1,
      sortingPopup: null,
      merge: t.merge ? t.merge : { colSpan: t.colSpan, rowSpan: t.rowSpan },
      isEmbedImage: this.getIsEmbedImageStatus(t)
    };
  }
  componentDidMount() {
    if (this.props.tableSize) {
      this.props.tableSize.notifyChange(), this.props.tableSize.on(Xu, this.onRangeMinMaxChange);
      const t = this.props.tableSize.getRangeMinMax();
      t && this.onRangeMinMaxChange(t);
    }
    this.dataBarsCheck();
  }
  UNSAFE_componentWillReceiveProps(t) {
    if ((this.props.metadata !== t.metadata || this.props.rowMetadata !== t.rowMetadata || this.props.columnMetadata !== t.columnMetadata || this.props.rowIndex !== t.rowIndex || this.props.columnIndex !== t.columnIndex || this.props.fixedWidth !== t.fixedWidth) && (this.metadataClassName = void 0), (this.props.borderWidth !== t.borderWidth || this.props.borderColor !== t.borderColor || this.props.colWidth !== t.colWidth) && (this.virtualBorderStyle = void 0, this.cellStyle = void 0, this.cellContentStyle = void 0, this.databarStyle = void 0), (this.props.isDataCell !== t.isDataCell || this.props.treeNode !== t.treeNode || this.props.dataNode !== t.dataNode || Cu(this.props) !== Cu(t)) && (this.cellStyle = void 0, this.cellContentStyle = void 0, this.databarStyle = void 0, this.setState({
      isSelected: !1,
      backgroundColor: void 0
    })), this.props.tableSize !== t.tableSize && (this.props.tableSize && this.props.tableSize.off(Xu, this.onRangeMinMaxChange), t.tableSize)) {
      t.tableSize.on(Xu, this.onRangeMinMaxChange);
      const r = t.tableSize.getRangeMinMax();
      r && this.onRangeMinMaxChange(r, t);
    }
    (this.props.merge !== t.merge || this.props.colSpan !== t.colSpan || this.props.rowSpan !== t.rowSpan) && (this.cellStyle = void 0, this.cellContentStyle = void 0, this.databarStyle = void 0, this.setState({
      merge: t.merge ? t.merge : { colSpan: t.colSpan, rowSpan: t.rowSpan }
    }));
    const n = t.isDataCell ? t.dataNode : t.treeNode;
    this.props.isSelectedMode && n && n.state && // @ts-ignore
    !n.state.sliced && this.select("isSelected"), (this.props.imageColumns !== t.imageColumns || this.props.treeNode !== t.treeNode) && this.setState({
      isEmbedImage: this.getIsEmbedImageStatus(t)
    });
  }
  componentDidUpdate() {
    this.props.tableSize && this.props.tableSize.notifyChange(), this.dataBarsCheck();
  }
  componentWillUnmount() {
    this.metadataClassName = void 0, this.virtualBorderStyle = void 0, this.cellStyle = void 0, this.cellContentStyle = void 0, this.databarStyle = void 0, this.props.tableSize && this.props.tableSize.off(Xu, this.onRangeMinMaxChange);
  }
  dataBarsCheck() {
    const { tableSize: t, columnIndex: n, rowIndex: r } = this.props;
    if (this.hasDataBars() && this.cellEl && t) {
      let o = 0;
      const i = this.cellEl.querySelector(`.${tp}`);
      i && (o = i.offsetWidth), t.updateDataBars(n, r, o);
    }
  }
  getSelectStatus() {
    let t;
    return this.props.columnTreeNode ? t = this.props.dataNode : this.props.treeNode && (t = this.props.treeNode), !!(this.props.isSelectedMode && t && t.state && // @ts-ignore
    t.state.selected);
  }
  getIsEmbedImageStatus(t) {
    const { isDataCell: n, tableType: r, imageColumns: o } = t, { columnIndex: i } = this.props;
    return n ? !1 : !!(r === fr.ROWS && o && o.includes(i));
  }
  /**
   * Mark cell as selected
   *
   * @param {string} key - key of state object
   *
   * @returns {void}
   */
  select(t) {
    const n = {
      [t]: !0
    };
    this.setState((r) => pe(pe({}, r), n));
  }
  /**
   * Mark cell as unselected
   *
   * @param {string} key - key of state object
   *
   * @returns {void}
   */
  unselect(t) {
    const n = {
      [t]: !1
    };
    this.setState((r) => pe(pe({}, r), n));
  }
  /**
   * Get cell select status
   *
   * @returns {boolean} - return isSelected value
   */
  isDrilled() {
    return this.state.isDrilled;
  }
  hasDataBars() {
    const { tableType: t, rowTreeNode: n, columnTreeNode: r, measureTreeNode: o } = this.props;
    return !(t !== fr.DATA || !o || !o.databars || n && (n.userType === qt.SUB_TOTAL || n.userType === qt.GRAND_TOTAL) || r && (r.userType === qt.SUB_TOTAL || r.userType === qt.GRAND_TOTAL));
  }
  /**
   * Calculates new className string for cell or use cached one
   *
   * @returns {string} - class names
   * @private
   */
  getClassName() {
    const {
      isDataCell: t,
      rowIndex: n,
      columnIndex: r,
      metadata: o,
      rowMetadata: i,
      columnMetadata: a,
      treeNode: s,
      rowTreeNode: c,
      columnTreeNode: l,
      fixedWidth: d,
      tableType: f = ""
    } = this.props, { merge: p } = this.state;
    if (this.metadataClassName === void 0) {
      const m = `${$r}--row-${n}`, v = `${$r}--col-${r}`;
      let g = "", b = "", x = "";
      t ? (b = `
                    ${Ov(i, $r, "row")}
                    ${Ov(a, $r, "col")}
                `.trim(), x = `
                    ${Nv(c, $r, "row")}
                    ${Nv(l, $r, "col")}
                `.trim(), g = `
                    ${Av(p, $r, "row")}
                    ${Av(p, $r, "col")}
                `.trim()) : (b = Ov(o, $r), x = Nv(s, $r), g = Av(p, $r)), this.metadataClassName = Xe(
        $r,
        `${$r}--new`,
        `${$r}--${f}`,
        m,
        v,
        b,
        x,
        g,
        d ? l7 : ""
      );
    }
    return this.metadataClassName;
  }
  /**
   * Calculates new cell style object or use cached one
   *
   * @returns {object | undefined} - style object
   * @private
   */
  getCellStyle() {
    if (this.cellStyle === void 0) {
      const {
        treeNode: t,
        rowTreeNode: n,
        columnTreeNode: r,
        metadata: o,
        rowMetadata: i,
        columnMetadata: a,
        tableType: s = ""
      } = this.props, { merge: c, backgroundColor: l } = this.state, d = uW(s, {
        metadata: o,
        rowMetadata: i,
        columnMetadata: a,
        treeNode: t,
        rowTreeNode: n,
        columnTreeNode: r,
        merge: c
      }), f = Cu(this.props);
      this.cellStyle = fW(f), this.cellStyle.borderWidth = this.props.borderWidth, this.cellStyle.borderColor === void 0 && delete this.cellStyle.borderColor, d.b || (this.cellStyle.borderColor && (this.cellStyle.borderTopColor = this.cellStyle.borderColor, this.cellStyle.borderLeftColor = this.cellStyle.borderColor, this.cellStyle.borderRightColor = this.cellStyle.borderColor, delete this.cellStyle.borderColor), this.cellStyle.borderBottomColor = "transparent"), l && !this.cellStyle.backgroundColor && (this.cellStyle.backgroundColor = l);
    }
    return this.cellStyle;
  }
  /**
   * Calculates new cell conent style object or use cached one
   *
   * @returns {object} - style object
   * @private
   */
  // eslint-disable-next-line sonarjs/cognitive-complexity
  getCellContentStyle() {
    if (this.cellContentStyle === void 0) {
      const { fixedWidth: t, styleObj: n, colWidth: r, rowHeight: o, tableType: i } = this.props, a = Cu(this.props);
      this.cellContentStyle = pW(a), (t || this.state.isEmbedImage) && (n.width !== void 0 || r) && (this.cellContentStyle = this.cellContentStyle || {}, this.cellContentStyle.width = H2(
        n.width || r,
        this.props.borderWidth
      )), o && (i === fr.ROWS || i === fr.DATA) && (this.cellContentStyle = this.cellContentStyle || {}, this.cellContentStyle.height = o), !o && this.state.isEmbedImage && (this.cellContentStyle = this.cellContentStyle || {}, this.cellContentStyle.lineHeight = 0), this.state.isEmbedImage && (this.cellContentStyle.borderRight = `solid ${this.props.borderWidth || 1}px transparent`);
    }
    return this.cellContentStyle;
  }
  /**
   * Calculates new cell content style object or use cached one
   *
   * @returns {object} - style object
   * @private
   */
  getDatabarsStyle() {
    if (this.databarStyle === void 0) {
      const t = Cu(this.props);
      this.databarStyle = hW(t);
    }
    return this.databarStyle;
  }
  getContentNode() {
    const { colWidth: t, styleObj: n, isDataCell: r, dataNode: o, treeNode: i, borderWidth: a } = this.props, s = r ? o : i, c = s ? s.content || s.value : "", l = (s || {}).store || {}, d = (s || {}).contentType || a0.TEXT;
    if (typeof c == "string" && (d === a0.HTML || this.props.allowHtml && vee.test(c)))
      return /* @__PURE__ */ z("div", { className: tp, dangerouslySetInnerHTML: this.createMarkup(c) });
    if (this.state.isEmbedImage) {
      const { rowHeight: f, fallbackImageUrl: p } = this.props;
      return /* @__PURE__ */ z(
        NA,
        {
          imageUrl: c,
          fallbackImageUrl: p,
          rowHeight: f,
          addCellDomReadyPromise: this.props.addCellDomReadyPromise,
          removeCellDomReadyPromise: this.props.removeCellDomReadyPromise
        }
      );
    }
    if (d === a0.COMPONENT) {
      const f = l, { domReadyDefer: p } = f, m = Wn(f, ["domReadyDefer"]);
      return /* @__PURE__ */ z("div", { className: tp, children: /* @__PURE__ */ z(
        c,
        $e(pe({}, m), {
          width: H2(n.width || t, a),
          domReadyDefer: p
        })
      ) });
    }
    return /* @__PURE__ */ z("div", { className: tp, children: c });
  }
  // eslint-disable-next-line max-lines-per-function,sonarjs/cognitive-complexity
  render() {
    const { isDataCell: t, treeNode: n, tableType: r, tdComponent: o, isMobile: i } = this.props, { merge: a } = this.state, s = this.getCellStyle(), c = this.getCellContentStyle(), l = this.getDatabarsStyle();
    let d = this.getClassName() || "", f = !1;
    if (n) {
      f = typeof n.dir != "undefined", d = f ? `${d} ${n7}` : d, i && (d = `${d} ${r7}`);
      let T = "";
      n.dir ? T = n.dir === En.ASC ? o7 : i7 : f && !n.dir && (T = fw(n) === En.ASC ? a7 : s7), d = `${d} ${T}`;
      const { sortIconShouldBeVisible: S } = this.state;
      S && (d = `${d} ${p7}`);
    }
    const p = r === fr.CORNER || r === fr.COLUMNS, m = this.hasDataBars(), v = this.state.isSelected && !t ? e7 : "", g = this.state.isDrilled ? t7 : "", b = this.getContentNode();
    let x = null;
    return f && (x = /* @__PURE__ */ z(
      gee,
      {
        onRequestClose: () => this.setSortingPopup(null),
        onClick: this.handleSortingIconClick,
        onKeyPress: this.handleSortingIconClick,
        sortingPopup: this.state.sortingPopup,
        className: f7,
        getTooltipContainer: this.props.getSortingPopupContainer
      }
    )), B.createElement(
      o,
      {
        ref: this.onCellRef,
        onClick: this.onCellClick,
        onContextMenu: this.onCellClick,
        onMouseEnter: this.onCellEnter,
        onMouseLeave: this.onCellLeave,
        className: Xe(d, g, v),
        style: s,
        colSpan: a ? a.colSpan : void 0,
        rowSpan: a ? a.rowSpan : void 0
      },
      [
        /* @__PURE__ */ _e("div", { className: c7, children: [
          x,
          p && /* @__PURE__ */ z(
            gJ,
            {
              onResizeStart: this.onResizeStartHandler,
              onResize: this.onResizeHandler,
              onResizeEnd: this.onResizeEndHandler
            }
          ),
          m && /* @__PURE__ */ z(
            wJ,
            {
              columnIndex: this.props.columnIndex,
              tableSize: this.props.tableSize,
              dataNode: this.props.dataNode,
              style: l
            }
          )
        ] }, "corner"),
        /* @__PURE__ */ z("div", { className: u7, style: c, children: /* @__PURE__ */ z("div", { className: d7, children: b }) }, "content")
      ]
    );
  }
}
Z(fD, "defaultProps", {
  isDataCell: !1,
  fixedWidth: !1,
  borderWidth: 1,
  onSortingMetadataUpdate: () => {
  }
});
var pD = Symbol.for("immer-nothing"), uE = Symbol.for("immer-draftable"), ho = Symbol.for("immer-state"), bee = process.env.NODE_ENV !== "production" ? [
  // All error codes, starting by 0:
  function(e) {
    return `The plugin for '${e}' has not been loaded into Immer. To enable the plugin, import and call \`enable${e}()\` when initializing your application.`;
  },
  function(e) {
    return `produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '${e}'`;
  },
  "This object has been frozen and should not be mutated",
  function(e) {
    return "Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + e;
  },
  "An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.",
  "Immer forbids circular references",
  "The first or second argument to `produce` must be a function",
  "The third argument to `produce` must be a function or undefined",
  "First argument to `createDraft` must be a plain object, an array, or an immerable object",
  "First argument to `finishDraft` must be a draft returned by `createDraft`",
  function(e) {
    return `'current' expects a draft, got: ${e}`;
  },
  "Object.defineProperty() cannot be used on an Immer draft",
  "Object.setPrototypeOf() cannot be used on an Immer draft",
  "Immer only supports deleting array indices",
  "Immer only supports setting array indices and the 'length' property",
  function(e) {
    return `'original' expects a draft, got: ${e}`;
  }
  // Note: if more errors are added, the errorOffset in Patches.ts should be increased
  // See Patches.ts for additional errors
] : [];
function Hr(e, ...t) {
  if (process.env.NODE_ENV !== "production") {
    const n = bee[e], r = typeof n == "function" ? n.apply(null, t) : n;
    throw new Error(`[Immer] ${r}`);
  }
  throw new Error(
    `[Immer] minified error nr: ${e}. Full error at: https://bit.ly/3cXEKWf`
  );
}
var kc = Object.getPrototypeOf;
function Mc(e) {
  return !!e && !!e[ho];
}
function Ks(e) {
  var t;
  return e ? hD(e) || Array.isArray(e) || !!e[uE] || !!((t = e.constructor) != null && t[uE]) || mg(e) || gg(e) : !1;
}
var yee = Object.prototype.constructor.toString();
function hD(e) {
  if (!e || typeof e != "object")
    return !1;
  const t = kc(e);
  if (t === null)
    return !0;
  const n = Object.hasOwnProperty.call(t, "constructor") && t.constructor;
  return n === Object ? !0 : typeof n == "function" && Function.toString.call(n) === yee;
}
function Hh(e, t) {
  hg(e) === 0 ? Reflect.ownKeys(e).forEach((n) => {
    t(n, e[n], e);
  }) : e.forEach((n, r) => t(r, n, e));
}
function hg(e) {
  const t = e[ho];
  return t ? t.type_ : Array.isArray(e) ? 1 : mg(e) ? 2 : gg(e) ? 3 : 0;
}
function Iy(e, t) {
  return hg(e) === 2 ? e.has(t) : Object.prototype.hasOwnProperty.call(e, t);
}
function mD(e, t, n) {
  const r = hg(e);
  r === 2 ? e.set(t, n) : r === 3 ? e.add(n) : e[t] = n;
}
function _ee(e, t) {
  return e === t ? e !== 0 || 1 / e === 1 / t : e !== e && t !== t;
}
function mg(e) {
  return e instanceof Map;
}
function gg(e) {
  return e instanceof Set;
}
function Is(e) {
  return e.copy_ || e.base_;
}
function Ly(e, t) {
  if (mg(e))
    return new Map(e);
  if (gg(e))
    return new Set(e);
  if (Array.isArray(e))
    return Array.prototype.slice.call(e);
  const n = hD(e);
  if (t === !0 || t === "class_only" && !n) {
    const r = Object.getOwnPropertyDescriptors(e);
    delete r[ho];
    let o = Reflect.ownKeys(r);
    for (let i = 0; i < o.length; i++) {
      const a = o[i], s = r[a];
      s.writable === !1 && (s.writable = !0, s.configurable = !0), (s.get || s.set) && (r[a] = {
        configurable: !0,
        writable: !0,
        // could live with !!desc.set as well here...
        enumerable: s.enumerable,
        value: e[a]
      });
    }
    return Object.create(kc(e), r);
  } else {
    const r = kc(e);
    if (r !== null && n)
      return pe({}, e);
    const o = Object.create(r);
    return Object.assign(o, e);
  }
}
function Sw(e, t = !1) {
  return vg(e) || Mc(e) || !Ks(e) || (hg(e) > 1 && (e.set = e.add = e.clear = e.delete = wee), Object.freeze(e), t && Object.entries(e).forEach(([n, r]) => Sw(r, !0))), e;
}
function wee() {
  Hr(2);
}
function vg(e) {
  return Object.isFrozen(e);
}
var xee = {};
function Js(e) {
  const t = xee[e];
  return t || Hr(0, e), t;
}
var Wd;
function gD() {
  return Wd;
}
function Cee(e, t) {
  return {
    drafts_: [],
    parent_: e,
    immer_: t,
    // Whenever the modified draft contains a draft from another scope, we
    // need to prevent auto-freezing so the unowned draft can be finalized.
    canAutoFreeze_: !0,
    unfinalizedDrafts_: 0
  };
}
function dE(e, t) {
  t && (Js("Patches"), e.patches_ = [], e.inversePatches_ = [], e.patchListener_ = t);
}
function $y(e) {
  Fy(e), e.drafts_.forEach(See), e.drafts_ = null;
}
function Fy(e) {
  e === Wd && (Wd = e.parent_);
}
function fE(e) {
  return Wd = Cee(Wd, e);
}
function See(e) {
  const t = e[ho];
  t.type_ === 0 || t.type_ === 1 ? t.revoke_() : t.revoked_ = !0;
}
function pE(e, t) {
  t.unfinalizedDrafts_ = t.drafts_.length;
  const n = t.drafts_[0];
  return e !== void 0 && e !== n ? (n[ho].modified_ && ($y(t), Hr(4)), Ks(e) && (e = jh(t, e), t.parent_ || Wh(t, e)), t.patches_ && Js("Patches").generateReplacementPatches_(
    n[ho].base_,
    e,
    t.patches_,
    t.inversePatches_
  )) : e = jh(t, n, []), $y(t), t.patches_ && t.patchListener_(t.patches_, t.inversePatches_), e !== pD ? e : void 0;
}
function jh(e, t, n) {
  if (vg(t))
    return t;
  const r = t[ho];
  if (!r)
    return Hh(
      t,
      (o, i) => hE(e, r, t, o, i, n)
    ), t;
  if (r.scope_ !== e)
    return t;
  if (!r.modified_)
    return Wh(e, r.base_, !0), r.base_;
  if (!r.finalized_) {
    r.finalized_ = !0, r.scope_.unfinalizedDrafts_--;
    const o = r.copy_;
    let i = o, a = !1;
    r.type_ === 3 && (i = new Set(o), o.clear(), a = !0), Hh(
      i,
      (s, c) => hE(e, r, o, s, c, n, a)
    ), Wh(e, o, !1), n && e.patches_ && Js("Patches").generatePatches_(
      r,
      n,
      e.patches_,
      e.inversePatches_
    );
  }
  return r.copy_;
}
function hE(e, t, n, r, o, i, a) {
  if (process.env.NODE_ENV !== "production" && o === n && Hr(5), Mc(o)) {
    const s = i && t && t.type_ !== 3 && // Set objects are atomic since they have no keys.
    !Iy(t.assigned_, r) ? i.concat(r) : void 0, c = jh(e, o, s);
    if (mD(n, r, c), Mc(c))
      e.canAutoFreeze_ = !1;
    else
      return;
  } else
    a && n.add(o);
  if (Ks(o) && !vg(o)) {
    if (!e.immer_.autoFreeze_ && e.unfinalizedDrafts_ < 1)
      return;
    jh(e, o), (!t || !t.scope_.parent_) && typeof r != "symbol" && Object.prototype.propertyIsEnumerable.call(n, r) && Wh(e, o);
  }
}
function Wh(e, t, n = !1) {
  !e.parent_ && e.immer_.autoFreeze_ && e.canAutoFreeze_ && Sw(t, n);
}
function Tee(e, t) {
  const n = Array.isArray(e), r = {
    type_: n ? 1 : 0,
    // Track which produce call this is associated with.
    scope_: t ? t.scope_ : gD(),
    // True for both shallow and deep changes.
    modified_: !1,
    // Used during finalization.
    finalized_: !1,
    // Track which properties have been assigned (true) or deleted (false).
    assigned_: {},
    // The parent draft state.
    parent_: t,
    // The base state.
    base_: e,
    // The base proxy.
    draft_: null,
    // set below
    // The base copy with any updated values.
    copy_: null,
    // Called by the `produce` function.
    revoke_: null,
    isManual_: !1
  };
  let o = r, i = Tw;
  n && (o = [r], i = Vd);
  const { revoke: a, proxy: s } = Proxy.revocable(o, i);
  return r.draft_ = s, r.revoke_ = a, s;
}
var Tw = {
  get(e, t) {
    if (t === ho)
      return e;
    const n = Is(e);
    if (!Iy(n, t))
      return Eee(e, n, t);
    const r = n[t];
    return e.finalized_ || !Ks(r) ? r : r === s0(e.base_, t) ? (l0(e), e.copy_[t] = By(r, e)) : r;
  },
  has(e, t) {
    return t in Is(e);
  },
  ownKeys(e) {
    return Reflect.ownKeys(Is(e));
  },
  set(e, t, n) {
    const r = vD(Is(e), t);
    if (r != null && r.set)
      return r.set.call(e.draft_, n), !0;
    if (!e.modified_) {
      const o = s0(Is(e), t), i = o == null ? void 0 : o[ho];
      if (i && i.base_ === n)
        return e.copy_[t] = n, e.assigned_[t] = !1, !0;
      if (_ee(n, o) && (n !== void 0 || Iy(e.base_, t)))
        return !0;
      l0(e), zy(e);
    }
    return e.copy_[t] === n && // special case: handle new props with value 'undefined'
    (n !== void 0 || t in e.copy_) || // special case: NaN
    Number.isNaN(n) && Number.isNaN(e.copy_[t]) || (e.copy_[t] = n, e.assigned_[t] = !0), !0;
  },
  deleteProperty(e, t) {
    return s0(e.base_, t) !== void 0 || t in e.base_ ? (e.assigned_[t] = !1, l0(e), zy(e)) : delete e.assigned_[t], e.copy_ && delete e.copy_[t], !0;
  },
  // Note: We never coerce `desc.value` into an Immer draft, because we can't make
  // the same guarantee in ES5 mode.
  getOwnPropertyDescriptor(e, t) {
    const n = Is(e), r = Reflect.getOwnPropertyDescriptor(n, t);
    return r && {
      writable: !0,
      configurable: e.type_ !== 1 || t !== "length",
      enumerable: r.enumerable,
      value: n[t]
    };
  },
  defineProperty() {
    Hr(11);
  },
  getPrototypeOf(e) {
    return kc(e.base_);
  },
  setPrototypeOf() {
    Hr(12);
  }
}, Vd = {};
Hh(Tw, (e, t) => {
  Vd[e] = function() {
    return arguments[0] = arguments[0][0], t.apply(this, arguments);
  };
});
Vd.deleteProperty = function(e, t) {
  return process.env.NODE_ENV !== "production" && isNaN(parseInt(t)) && Hr(13), Vd.set.call(this, e, t, void 0);
};
Vd.set = function(e, t, n) {
  return process.env.NODE_ENV !== "production" && t !== "length" && isNaN(parseInt(t)) && Hr(14), Tw.set.call(this, e[0], t, n, e[0]);
};
function s0(e, t) {
  const n = e[ho];
  return (n ? Is(n) : e)[t];
}
function Eee(e, t, n) {
  var r;
  const o = vD(t, n);
  return o ? "value" in o ? o.value : (
    // This is a very special case, if the prop is a getter defined by the
    // prototype, we should invoke it with the draft as context!
    (r = o.get) == null ? void 0 : r.call(e.draft_)
  ) : void 0;
}
function vD(e, t) {
  if (!(t in e))
    return;
  let n = kc(e);
  for (; n; ) {
    const r = Object.getOwnPropertyDescriptor(n, t);
    if (r)
      return r;
    n = kc(n);
  }
}
function zy(e) {
  e.modified_ || (e.modified_ = !0, e.parent_ && zy(e.parent_));
}
function l0(e) {
  e.copy_ || (e.copy_ = Ly(
    e.base_,
    e.scope_.immer_.useStrictShallowCopy_
  ));
}
var kee = class {
  constructor(e) {
    this.autoFreeze_ = !0, this.useStrictShallowCopy_ = !1, this.produce = (t, n, r) => {
      if (typeof t == "function" && typeof n != "function") {
        const i = n;
        n = t;
        const a = this;
        return function(s = i, ...c) {
          return a.produce(s, (l) => n.call(this, l, ...c));
        };
      }
      typeof n != "function" && Hr(6), r !== void 0 && typeof r != "function" && Hr(7);
      let o;
      if (Ks(t)) {
        const i = fE(this), a = By(t, void 0);
        let s = !0;
        try {
          o = n(a), s = !1;
        } finally {
          s ? $y(i) : Fy(i);
        }
        return dE(i, r), pE(o, i);
      } else if (!t || typeof t != "object") {
        if (o = n(t), o === void 0 && (o = t), o === pD && (o = void 0), this.autoFreeze_ && Sw(o, !0), r) {
          const i = [], a = [];
          Js("Patches").generateReplacementPatches_(t, o, i, a), r(i, a);
        }
        return o;
      } else
        Hr(1, t);
    }, this.produceWithPatches = (t, n) => {
      if (typeof t == "function")
        return (i, ...a) => this.produceWithPatches(i, (s) => t(s, ...a));
      let r, o;
      return [this.produce(t, n, (i, a) => {
        r = i, o = a;
      }), r, o];
    }, typeof (e == null ? void 0 : e.autoFreeze) == "boolean" && this.setAutoFreeze(e.autoFreeze), typeof (e == null ? void 0 : e.useStrictShallowCopy) == "boolean" && this.setUseStrictShallowCopy(e.useStrictShallowCopy);
  }
  createDraft(e) {
    Ks(e) || Hr(8), Mc(e) && (e = Mee(e));
    const t = fE(this), n = By(e, void 0);
    return n[ho].isManual_ = !0, Fy(t), n;
  }
  finishDraft(e, t) {
    const n = e && e[ho];
    (!n || !n.isManual_) && Hr(9);
    const { scope_: r } = n;
    return dE(r, t), pE(void 0, r);
  }
  /**
   * Pass true to automatically freeze all copies created by Immer.
   *
   * By default, auto-freezing is enabled.
   */
  setAutoFreeze(e) {
    this.autoFreeze_ = e;
  }
  /**
   * Pass true to enable strict shallow copy.
   *
   * By default, immer does not copy the object descriptors such as getter, setter and non-enumrable properties.
   */
  setUseStrictShallowCopy(e) {
    this.useStrictShallowCopy_ = e;
  }
  applyPatches(e, t) {
    let n;
    for (n = t.length - 1; n >= 0; n--) {
      const o = t[n];
      if (o.path.length === 0 && o.op === "replace") {
        e = o.value;
        break;
      }
    }
    n > -1 && (t = t.slice(n + 1));
    const r = Js("Patches").applyPatches_;
    return Mc(e) ? r(e, t) : this.produce(
      e,
      (o) => r(o, t)
    );
  }
};
function By(e, t) {
  const n = mg(e) ? Js("MapSet").proxyMap_(e, t) : gg(e) ? Js("MapSet").proxySet_(e, t) : Tee(e, t);
  return (t ? t.scope_ : gD()).drafts_.push(n), n;
}
function Mee(e) {
  return Mc(e) || Hr(10, e), bD(e);
}
function bD(e) {
  if (!Ks(e) || vg(e))
    return e;
  const t = e[ho];
  let n;
  if (t) {
    if (!t.modified_)
      return t.base_;
    t.finalized_ = !0, n = Ly(e, t.scope_.immer_.useStrictShallowCopy_);
  } else
    n = Ly(e, !0);
  return Hh(n, (r, o) => {
    mD(n, r, bD(o));
  }), t && (t.finalized_ = !1), n;
}
var mo = new kee(), Hy = mo.produce;
mo.produceWithPatches.bind(
  mo
);
mo.setAutoFreeze.bind(mo);
mo.setUseStrictShallowCopy.bind(mo);
mo.applyPatches.bind(mo);
mo.createDraft.bind(mo);
mo.finishDraft.bind(mo);
var Au = {}, mE;
function Ree() {
  if (mE)
    return Au;
  mE = 1, Object.defineProperty(Au, "__esModule", {
    value: !0
  }), Au.default = void 0;
  var e = r(et), t = dN;
  function n(a) {
    if (typeof WeakMap != "function")
      return null;
    var s = /* @__PURE__ */ new WeakMap(), c = /* @__PURE__ */ new WeakMap();
    return (n = function(l) {
      return l ? c : s;
    })(a);
  }
  function r(a, s) {
    if (a && a.__esModule)
      return a;
    if (a === null || typeof a != "object" && typeof a != "function")
      return { default: a };
    var c = n(s);
    if (c && c.has(a))
      return c.get(a);
    var l = { __proto__: null }, d = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var f in a)
      if (f !== "default" && Object.prototype.hasOwnProperty.call(a, f)) {
        var p = d ? Object.getOwnPropertyDescriptor(a, f) : null;
        p && (p.get || p.set) ? Object.defineProperty(l, f, p) : l[f] = a[f];
      }
    return l.default = a, c && c.set(a, l), l;
  }
  function o(a) {
    return Object.keys(a).length === 0;
  }
  function i(a = null) {
    const s = e.useContext(t.ThemeContext);
    return !s || o(s) ? a : s;
  }
  return Au.default = i, Au;
}
var Pee = Ree();
const Oee = /* @__PURE__ */ ji(Pee), Nee = ["anchorEl", "component", "components", "componentsProps", "container", "disablePortal", "keepMounted", "modifiers", "open", "placement", "popperOptions", "popperRef", "transition", "slots", "slotProps"], Aee = Fe(AN, {
  name: "MuiPopper",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({}), yD = /* @__PURE__ */ B.forwardRef(function(e, t) {
  var n;
  const r = Oee(), o = rn({
    props: e,
    name: "MuiPopper"
  }), {
    anchorEl: i,
    component: a,
    components: s,
    componentsProps: c,
    container: l,
    disablePortal: d,
    keepMounted: f,
    modifiers: p,
    open: m,
    placement: v,
    popperOptions: g,
    popperRef: b,
    transition: x,
    slots: T,
    slotProps: S
  } = o, _ = He(o, Nee), w = (n = T == null ? void 0 : T.root) != null ? n : s == null ? void 0 : s.Root, k = re({
    anchorEl: i,
    container: l,
    disablePortal: d,
    keepMounted: f,
    modifiers: p,
    open: m,
    placement: v,
    popperOptions: g,
    popperRef: b,
    transition: x
  }, _);
  return /* @__PURE__ */ z(Aee, re({
    as: a,
    direction: r == null ? void 0 : r.direction,
    slots: {
      root: w
    },
    slotProps: S != null ? S : c
  }, k, {
    ref: t
  }));
});
process.env.NODE_ENV !== "production" && (yD.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * An HTML element, [virtualElement](https://popper.js.org/docs/v2/virtual-elements/),
   * or a function that returns either.
   * It's used to set the position of the popper.
   * The return value will passed as the reference object of the Popper instance.
   */
  anchorEl: y.oneOfType([fa, y.object, y.func]),
  /**
   * Popper render function or node.
   */
  children: y.oneOfType([y.node, y.func]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: y.elementType,
  /**
   * The components used for each slot inside the Popper.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  components: y.shape({
    Root: y.elementType
  }),
  /**
   * The props used for each slot inside the Popper.
   * @default {}
   */
  componentsProps: y.shape({
    root: y.oneOfType([y.func, y.object])
  }),
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * You can also provide a callback, which is called in a React layout effect.
   * This lets you set the container from a ref, and also makes server-side rendering possible.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: y.oneOfType([fa, y.func]),
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: y.bool,
  /**
   * Always keep the children in the DOM.
   * This prop can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Popper.
   * @default false
   */
  keepMounted: y.bool,
  /**
   * Popper.js is based on a "plugin-like" architecture,
   * most of its features are fully encapsulated "modifiers".
   *
   * A modifier is a function that is called each time Popper.js needs to
   * compute the position of the popper.
   * For this reason, modifiers should be very performant to avoid bottlenecks.
   * To learn how to create a modifier, [read the modifiers documentation](https://popper.js.org/docs/v2/modifiers/).
   */
  modifiers: y.arrayOf(y.shape({
    data: y.object,
    effect: y.func,
    enabled: y.bool,
    fn: y.func,
    name: y.any,
    options: y.object,
    phase: y.oneOf(["afterMain", "afterRead", "afterWrite", "beforeMain", "beforeRead", "beforeWrite", "main", "read", "write"]),
    requires: y.arrayOf(y.string),
    requiresIfExists: y.arrayOf(y.string)
  })),
  /**
   * If `true`, the component is shown.
   */
  open: y.bool.isRequired,
  /**
   * Popper placement.
   * @default 'bottom'
   */
  placement: y.oneOf(["auto-end", "auto-start", "auto", "bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
  /**
   * Options provided to the [`Popper.js`](https://popper.js.org/docs/v2/constructors/#options) instance.
   * @default {}
   */
  popperOptions: y.shape({
    modifiers: y.array,
    onFirstUpdate: y.func,
    placement: y.oneOf(["auto-end", "auto-start", "auto", "bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
    strategy: y.oneOf(["absolute", "fixed"])
  }),
  /**
   * A ref that points to the used popper instance.
   */
  popperRef: Yo,
  /**
   * The props used for each slot inside the Popper.
   * @default {}
   */
  slotProps: y.shape({
    root: y.oneOfType([y.func, y.object])
  }),
  /**
   * The components used for each slot inside the Popper.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: y.shape({
    root: y.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: y.oneOfType([y.arrayOf(y.oneOfType([y.func, y.object, y.bool])), y.func, y.object]),
  /**
   * Help supporting a react-transition-group/Transition component.
   * @default false
   */
  transition: y.bool
});
const _D = yD;
function Dee(e) {
  return Gt("MuiTooltip", e);
}
const Iee = Wt("MuiTooltip", ["popper", "popperInteractive", "popperArrow", "popperClose", "tooltip", "tooltipArrow", "touch", "tooltipPlacementLeft", "tooltipPlacementRight", "tooltipPlacementTop", "tooltipPlacementBottom", "arrow"]), Ka = Iee, Lee = ["arrow", "children", "classes", "components", "componentsProps", "describeChild", "disableFocusListener", "disableHoverListener", "disableInteractive", "disableTouchListener", "enterDelay", "enterNextDelay", "enterTouchDelay", "followCursor", "id", "leaveDelay", "leaveTouchDelay", "onClose", "onOpen", "open", "placement", "PopperComponent", "PopperProps", "slotProps", "slots", "title", "TransitionComponent", "TransitionProps"];
function $ee(e) {
  return Math.round(e * 1e5) / 1e5;
}
const Fee = (e) => {
  const {
    classes: t,
    disableInteractive: n,
    arrow: r,
    touch: o,
    placement: i
  } = e, a = {
    popper: ["popper", !n && "popperInteractive", r && "popperArrow"],
    tooltip: ["tooltip", r && "tooltipArrow", o && "touch", `tooltipPlacement${at(i.split("-")[0])}`],
    arrow: ["arrow"]
  };
  return Yt(a, Dee, t);
}, zee = Fe(_D, {
  name: "MuiTooltip",
  slot: "Popper",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.popper, !n.disableInteractive && t.popperInteractive, n.arrow && t.popperArrow, !n.open && t.popperClose];
  }
})(({
  theme: e,
  ownerState: t,
  open: n
}) => re({
  zIndex: (e.vars || e).zIndex.tooltip,
  pointerEvents: "none"
}, !t.disableInteractive && {
  pointerEvents: "auto"
}, !n && {
  pointerEvents: "none"
}, t.arrow && {
  [`&[data-popper-placement*="bottom"] .${Ka.arrow}`]: {
    top: 0,
    marginTop: "-0.71em",
    "&::before": {
      transformOrigin: "0 100%"
    }
  },
  [`&[data-popper-placement*="top"] .${Ka.arrow}`]: {
    bottom: 0,
    marginBottom: "-0.71em",
    "&::before": {
      transformOrigin: "100% 0"
    }
  },
  [`&[data-popper-placement*="right"] .${Ka.arrow}`]: re({}, t.isRtl ? {
    right: 0,
    marginRight: "-0.71em"
  } : {
    left: 0,
    marginLeft: "-0.71em"
  }, {
    height: "1em",
    width: "0.71em",
    "&::before": {
      transformOrigin: "100% 100%"
    }
  }),
  [`&[data-popper-placement*="left"] .${Ka.arrow}`]: re({}, t.isRtl ? {
    left: 0,
    marginLeft: "-0.71em"
  } : {
    right: 0,
    marginRight: "-0.71em"
  }, {
    height: "1em",
    width: "0.71em",
    "&::before": {
      transformOrigin: "0 0"
    }
  })
})), Bee = Fe("div", {
  name: "MuiTooltip",
  slot: "Tooltip",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.tooltip, n.touch && t.touch, n.arrow && t.tooltipArrow, t[`tooltipPlacement${at(n.placement.split("-")[0])}`]];
  }
})(({
  theme: e,
  ownerState: t
}) => re({
  backgroundColor: e.vars ? e.vars.palette.Tooltip.bg : tn.alpha(e.palette.grey[700], 0.92),
  borderRadius: (e.vars || e).shape.borderRadius,
  color: (e.vars || e).palette.common.white,
  fontFamily: e.typography.fontFamily,
  padding: "4px 8px",
  fontSize: e.typography.pxToRem(11),
  maxWidth: 300,
  margin: 2,
  wordWrap: "break-word",
  fontWeight: e.typography.fontWeightMedium
}, t.arrow && {
  position: "relative",
  margin: 0
}, t.touch && {
  padding: "8px 16px",
  fontSize: e.typography.pxToRem(14),
  lineHeight: `${$ee(16 / 14)}em`,
  fontWeight: e.typography.fontWeightRegular
}, {
  [`.${Ka.popper}[data-popper-placement*="left"] &`]: re({
    transformOrigin: "right center"
  }, t.isRtl ? re({
    marginLeft: "14px"
  }, t.touch && {
    marginLeft: "24px"
  }) : re({
    marginRight: "14px"
  }, t.touch && {
    marginRight: "24px"
  })),
  [`.${Ka.popper}[data-popper-placement*="right"] &`]: re({
    transformOrigin: "left center"
  }, t.isRtl ? re({
    marginRight: "14px"
  }, t.touch && {
    marginRight: "24px"
  }) : re({
    marginLeft: "14px"
  }, t.touch && {
    marginLeft: "24px"
  })),
  [`.${Ka.popper}[data-popper-placement*="top"] &`]: re({
    transformOrigin: "center bottom",
    marginBottom: "14px"
  }, t.touch && {
    marginBottom: "24px"
  }),
  [`.${Ka.popper}[data-popper-placement*="bottom"] &`]: re({
    transformOrigin: "center top",
    marginTop: "14px"
  }, t.touch && {
    marginTop: "24px"
  })
})), Hee = Fe("span", {
  name: "MuiTooltip",
  slot: "Arrow",
  overridesResolver: (e, t) => t.arrow
})(({
  theme: e
}) => ({
  overflow: "hidden",
  position: "absolute",
  width: "1em",
  height: "0.71em",
  boxSizing: "border-box",
  color: e.vars ? e.vars.palette.Tooltip.bg : tn.alpha(e.palette.grey[700], 0.9),
  "&::before": {
    content: '""',
    margin: "auto",
    display: "block",
    width: "100%",
    height: "100%",
    backgroundColor: "currentColor",
    transform: "rotate(45deg)"
  }
}));
let pp = !1;
const gE = new pf();
let Du = {
  x: 0,
  y: 0
};
function hp(e, t) {
  return (n, ...r) => {
    t && t(n, ...r), e(n, ...r);
  };
}
const wD = /* @__PURE__ */ B.forwardRef(function(e, t) {
  var n, r, o, i, a, s, c, l, d, f, p, m, v, g, b, x, T, S, _;
  const w = rn({
    props: e,
    name: "MuiTooltip"
  }), {
    arrow: k = !1,
    children: E,
    components: R = {},
    componentsProps: P = {},
    describeChild: A = !1,
    disableFocusListener: D = !1,
    disableHoverListener: N = !1,
    disableInteractive: F = !1,
    disableTouchListener: $ = !1,
    enterDelay: I = 100,
    enterNextDelay: j = 0,
    enterTouchDelay: U = 700,
    followCursor: G = !1,
    id: V,
    leaveDelay: H = 0,
    leaveTouchDelay: q = 1500,
    onClose: Q,
    onOpen: X,
    open: K,
    placement: J = "bottom",
    PopperComponent: ne,
    PopperProps: ae = {},
    slotProps: te = {},
    slots: le = {},
    title: ce,
    TransitionComponent: fe = fy,
    TransitionProps: ee
  } = w, me = He(w, Lee), oe = /* @__PURE__ */ B.isValidElement(E) ? E : /* @__PURE__ */ z("span", {
    children: E
  }), ve = sg(), we = Qm(), [ye, Ce] = B.useState(), [Se, Te] = B.useState(null), Ae = B.useRef(!1), je = F || G, Me = tc(), ze = tc(), ft = tc(), Ue = tc(), [Be, Pe] = Dd({
    controlled: K,
    default: !1,
    name: "Tooltip",
    state: "open"
  });
  let Ee = Be;
  if (process.env.NODE_ENV !== "production") {
    const {
      current: Ye
    } = B.useRef(K !== void 0);
    B.useEffect(() => {
      ye && ye.disabled && !Ye && ce !== "" && ye.tagName.toLowerCase() === "button" && console.error(["MUI: You are providing a disabled `button` child to the Tooltip component.", "A disabled element does not fire events.", "Tooltip needs to listen to the child element's events to display the title.", "", "Add a simple wrapper element, such as a `span`."].join(`
`));
    }, [ce, ye, Ye]);
  }
  const st = Ch(V), Vt = B.useRef(), Ct = Ya(() => {
    Vt.current !== void 0 && (document.body.style.WebkitUserSelect = Vt.current, Vt.current = void 0), Ue.clear();
  });
  B.useEffect(() => Ct, [Ct]);
  const Ne = (Ye) => {
    gE.clear(), pp = !0, Pe(!0), X && !Ee && X(Ye);
  }, Ve = Ya(
    /**
     * @param {React.SyntheticEvent | Event} event
     */
    (Ye) => {
      gE.start(800 + H, () => {
        pp = !1;
      }), Pe(!1), Q && Ee && Q(Ye), Me.start(ve.transitions.duration.shortest, () => {
        Ae.current = !1;
      });
    }
  ), ut = (Ye) => {
    Ae.current && Ye.type !== "touchstart" || (ye && ye.removeAttribute("title"), ze.clear(), ft.clear(), I || pp && j ? ze.start(pp ? j : I, () => {
      Ne(Ye);
    }) : Ne(Ye));
  }, Ut = (Ye) => {
    ze.clear(), ft.start(H, () => {
      Ve(Ye);
    });
  }, {
    isFocusVisibleRef: St,
    onBlur: Zn,
    onFocus: Cn,
    ref: an
  } = J3(), [, xr] = B.useState(!1), Vn = (Ye) => {
    Zn(Ye), St.current === !1 && (xr(!1), Ut(Ye));
  }, An = (Ye) => {
    ye || Ce(Ye.currentTarget), Cn(Ye), St.current === !0 && (xr(!0), ut(Ye));
  }, kt = (Ye) => {
    Ae.current = !0;
    const Le = oe.props;
    Le.onTouchStart && Le.onTouchStart(Ye);
  }, Tt = (Ye) => {
    kt(Ye), ft.clear(), Me.clear(), Ct(), Vt.current = document.body.style.WebkitUserSelect, document.body.style.WebkitUserSelect = "none", Ue.start(U, () => {
      document.body.style.WebkitUserSelect = Vt.current, ut(Ye);
    });
  }, Nt = (Ye) => {
    oe.props.onTouchEnd && oe.props.onTouchEnd(Ye), Ct(), ft.start(q, () => {
      Ve(Ye);
    });
  };
  B.useEffect(() => {
    if (!Ee)
      return;
    function Ye(Le) {
      (Le.key === "Escape" || Le.key === "Esc") && Ve(Le);
    }
    return document.addEventListener("keydown", Ye), () => {
      document.removeEventListener("keydown", Ye);
    };
  }, [Ve, Ee]);
  const Cr = or(oe.ref, an, Ce, t);
  !ce && ce !== 0 && (Ee = !1);
  const Xn = B.useRef(), mn = (Ye) => {
    const Le = oe.props;
    Le.onMouseMove && Le.onMouseMove(Ye), Du = {
      x: Ye.clientX,
      y: Ye.clientY
    }, Xn.current && Xn.current.update();
  }, Kn = {}, Un = typeof ce == "string";
  A ? (Kn.title = !Ee && Un && !N ? ce : null, Kn["aria-describedby"] = Ee ? st : null) : (Kn["aria-label"] = Un ? ce : null, Kn["aria-labelledby"] = Ee && !Un ? st : null);
  const Bt = re({}, Kn, me, oe.props, {
    className: Qe(me.className, oe.props.className),
    onTouchStart: kt,
    ref: Cr
  }, G ? {
    onMouseMove: mn
  } : {});
  process.env.NODE_ENV !== "production" && (Bt["data-mui-internal-clone-element"] = !0, B.useEffect(() => {
    ye && !ye.getAttribute("data-mui-internal-clone-element") && console.error(["MUI: The `children` component of the Tooltip is not forwarding its props correctly.", "Please make sure that props are spread on the same element that the ref is applied to."].join(`
`));
  }, [ye]));
  const gt = {};
  $ || (Bt.onTouchStart = Tt, Bt.onTouchEnd = Nt), N || (Bt.onMouseOver = hp(ut, Bt.onMouseOver), Bt.onMouseLeave = hp(Ut, Bt.onMouseLeave), je || (gt.onMouseOver = ut, gt.onMouseLeave = Ut)), D || (Bt.onFocus = hp(An, Bt.onFocus), Bt.onBlur = hp(Vn, Bt.onBlur), je || (gt.onFocus = An, gt.onBlur = Vn)), process.env.NODE_ENV !== "production" && oe.props.title && console.error(["MUI: You have provided a `title` prop to the child of <Tooltip />.", `Remove this title prop \`${oe.props.title}\` or the Tooltip component.`].join(`
`));
  const Zt = B.useMemo(() => {
    var Ye;
    let Le = [{
      name: "arrow",
      enabled: !!Se,
      options: {
        element: Se,
        padding: 4
      }
    }];
    return (Ye = ae.popperOptions) != null && Ye.modifiers && (Le = Le.concat(ae.popperOptions.modifiers)), re({}, ae.popperOptions, {
      modifiers: Le
    });
  }, [Se, ae]), ke = re({}, w, {
    isRtl: we,
    arrow: k,
    disableInteractive: je,
    placement: J,
    PopperComponentProp: ne,
    touch: Ae.current
  }), gn = Fee(ke), ir = (n = (r = le.popper) != null ? r : R.Popper) != null ? n : zee, Jn = (o = (i = (a = le.transition) != null ? a : R.Transition) != null ? i : fe) != null ? o : fy, qn = (s = (c = le.tooltip) != null ? c : R.Tooltip) != null ? s : Bee, Sn = (l = (d = le.arrow) != null ? d : R.Arrow) != null ? l : Hee, Qn = Qu(ir, re({}, ae, (f = te.popper) != null ? f : P.popper, {
    className: Qe(gn.popper, ae == null ? void 0 : ae.className, (p = (m = te.popper) != null ? m : P.popper) == null ? void 0 : p.className)
  }), ke), er = Qu(Jn, re({}, ee, (v = te.transition) != null ? v : P.transition), ke), mr = Qu(qn, re({}, (g = te.tooltip) != null ? g : P.tooltip, {
    className: Qe(gn.tooltip, (b = (x = te.tooltip) != null ? x : P.tooltip) == null ? void 0 : b.className)
  }), ke), Ir = Qu(Sn, re({}, (T = te.arrow) != null ? T : P.arrow, {
    className: Qe(gn.arrow, (S = (_ = te.arrow) != null ? _ : P.arrow) == null ? void 0 : S.className)
  }), ke);
  return /* @__PURE__ */ _e(B.Fragment, {
    children: [/* @__PURE__ */ B.cloneElement(oe, Bt), /* @__PURE__ */ z(ir, re({
      as: ne != null ? ne : _D,
      placement: J,
      anchorEl: G ? {
        getBoundingClientRect: () => ({
          top: Du.y,
          left: Du.x,
          right: Du.x,
          bottom: Du.y,
          width: 0,
          height: 0
        })
      } : ye,
      popperRef: Xn,
      open: ye ? Ee : !1,
      id: st,
      transition: !0
    }, gt, Qn, {
      popperOptions: Zt,
      children: ({
        TransitionProps: Ye
      }) => /* @__PURE__ */ z(Jn, re({
        timeout: ve.transitions.duration.shorter
      }, Ye, er, {
        children: /* @__PURE__ */ _e(qn, re({}, mr, {
          children: [ce, k ? /* @__PURE__ */ z(Sn, re({}, Ir, {
            ref: Te
          })) : null]
        }))
      }))
    }))]
  });
});
process.env.NODE_ENV !== "production" && (wD.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, adds an arrow to the tooltip.
   * @default false
   */
  arrow: y.bool,
  /**
   * Tooltip reference element.
   */
  children: ff.isRequired,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: y.object,
  /**
   * @ignore
   */
  className: y.string,
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */
  components: y.shape({
    Arrow: y.elementType,
    Popper: y.elementType,
    Tooltip: y.elementType,
    Transition: y.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `slotProps` prop.
   * It's recommended to use the `slotProps` prop instead, as `componentsProps` will be deprecated in the future.
   *
   * @default {}
   */
  componentsProps: y.shape({
    arrow: y.object,
    popper: y.object,
    tooltip: y.object,
    transition: y.object
  }),
  /**
   * Set to `true` if the `title` acts as an accessible description.
   * By default the `title` acts as an accessible label for the child.
   * @default false
   */
  describeChild: y.bool,
  /**
   * Do not respond to focus-visible events.
   * @default false
   */
  disableFocusListener: y.bool,
  /**
   * Do not respond to hover events.
   * @default false
   */
  disableHoverListener: y.bool,
  /**
   * Makes a tooltip not interactive, i.e. it will close when the user
   * hovers over the tooltip before the `leaveDelay` is expired.
   * @default false
   */
  disableInteractive: y.bool,
  /**
   * Do not respond to long press touch events.
   * @default false
   */
  disableTouchListener: y.bool,
  /**
   * The number of milliseconds to wait before showing the tooltip.
   * This prop won't impact the enter touch delay (`enterTouchDelay`).
   * @default 100
   */
  enterDelay: y.number,
  /**
   * The number of milliseconds to wait before showing the tooltip when one was already recently opened.
   * @default 0
   */
  enterNextDelay: y.number,
  /**
   * The number of milliseconds a user must touch the element before showing the tooltip.
   * @default 700
   */
  enterTouchDelay: y.number,
  /**
   * If `true`, the tooltip follow the cursor over the wrapped element.
   * @default false
   */
  followCursor: y.bool,
  /**
   * This prop is used to help implement the accessibility logic.
   * If you don't provide this prop. It falls back to a randomly generated id.
   */
  id: y.string,
  /**
   * The number of milliseconds to wait before hiding the tooltip.
   * This prop won't impact the leave touch delay (`leaveTouchDelay`).
   * @default 0
   */
  leaveDelay: y.number,
  /**
   * The number of milliseconds after the user stops touching an element before hiding the tooltip.
   * @default 1500
   */
  leaveTouchDelay: y.number,
  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   */
  onClose: y.func,
  /**
   * Callback fired when the component requests to be open.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   */
  onOpen: y.func,
  /**
   * If `true`, the component is shown.
   */
  open: y.bool,
  /**
   * Tooltip placement.
   * @default 'bottom'
   */
  placement: y.oneOf(["bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
  /**
   * The component used for the popper.
   * @default Popper
   */
  PopperComponent: y.elementType,
  /**
   * Props applied to the [`Popper`](/material-ui/api/popper/) element.
   * @default {}
   */
  PopperProps: y.object,
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slotProps: y.shape({
    arrow: y.object,
    popper: y.object,
    tooltip: y.object,
    transition: y.object
  }),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: y.shape({
    arrow: y.elementType,
    popper: y.elementType,
    tooltip: y.elementType,
    transition: y.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: y.oneOfType([y.arrayOf(y.oneOfType([y.func, y.object, y.bool])), y.func, y.object]),
  /**
   * Tooltip title. Zero-length titles string, undefined, null and false are never displayed.
   */
  title: y.node,
  /**
   * The component used for the transition.
   * [Follow this guide](/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @default Grow
   */
  TransitionComponent: y.elementType,
  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](https://reactcommunity.org/react-transition-group/transition/) component.
   */
  TransitionProps: y.object
});
const jee = wD, Wee = hs({
  components: {
    MuiTooltip: {
      styleOverrides: {
        arrow: {
          color: _t.StBackgroundColors.workspace
        },
        tooltip: {
          color: _t.StTextColors.content,
          maxWidth: "432px",
          borderRadius: "4px",
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          alignItems: "center",
          padding: "12px 16px",
          gap: "10px",
          backgroundColor: _t.StBackgroundColors.workspace,
          filter: "drop-shadow(0px 1px 4px rgba(9, 9, 10, 0.1)) drop-shadow(0px 4px 12px rgba(9, 9, 10, 0.2));"
        }
      }
    }
  }
}), Vee = "#2c3342", Uee = "#f4f4f8", qee = "#dee1e7", Gee = "#fff", Yee = "_breakLongWord_1dxah_307", Zee = "_semanticText_1dxah_311", Xee = "_tooltip_1dxah_315", Kee = "_rcToolTipZoomIn_1dxah_1", Jee = "_rcToolTipZoomOut_1dxah_1", Qee = {
  loginDarkColor: Vee,
  darkBtnHoverColor: Uee,
  greyHoverColor: qee,
  defaultBackgroundColor: Gee,
  breakLongWord: Yee,
  semanticText: Zee,
  tooltip: Xee,
  rcToolTipZoomIn: Kee,
  rcToolTipZoomOut: Jee
}, xD = nl(
  (e, t) => {
    var n = e, { title: r, children: o, arrow: i, theme: a = Wee } = n, s = Wn(n, ["title", "children", "arrow", "theme"]);
    const { classes: c = {} } = s, l = $e(pe({}, c), {
      tooltip: Xe(
        Qee.tooltip,
        c.tooltip,
        Xa.SISENSE_NAMESPACE
      )
    });
    return /* @__PURE__ */ z(ll, { theme: a, children: /* @__PURE__ */ z(jee, $e(pe({}, s), { title: r, arrow: i, ref: t, classes: l, children: o })) });
  }
);
function vE(e) {
  return `‘${e}’`;
}
function ete(e) {
  return e[e.length - 1];
}
const tte = (e) => {
  const { hierarchy: t, prependedText: n } = e, r = it(null), o = it(null), i = t.map(vE).join(" → "), [a, s] = Ge(i);
  return Lc(() => {
    if (r.current && o.current) {
      const c = r.current.offsetWidth;
      if (o.current.offsetWidth > c) {
        const l = vE(ete(t));
        s(l);
      }
    }
  }, [t]), /* @__PURE__ */ _e("div", { className: "header-text", children: [
    /* @__PURE__ */ z("span", { className: "header-text__sort-by", children: n }),
    /* @__PURE__ */ z(xD, { placement: "top", title: a, arrow: !0, children: /* @__PURE__ */ z("span", { ref: r, className: "header-text__hierarchy-container", children: /* @__PURE__ */ z("span", { ref: o, children: a }) }) })
  ] });
}, CD = (e) => {
  const { onCrossIconClick: t, className: n, prependedText: r, hierarchy: o } = e;
  return /* @__PURE__ */ _e("div", { className: n, children: [
    /* @__PURE__ */ z(tte, { hierarchy: o, prependedText: r }),
    !!t && /* @__PURE__ */ z(nc, { onClick: t, name: "general-x", className: "cross-icon" })
  ] });
};
var bE = {}, yE = {}, ic = {}, nte = {
  get exports() {
    return ic;
  },
  set exports(e) {
    ic = e;
  }
}, _E;
function rte() {
  if (_E)
    return ic;
  _E = 1;
  for (var e = D3(), t = typeof window == "undefined" ? O_ : window, n = ["moz", "webkit"], r = "AnimationFrame", o = t["request" + r], i = t["cancel" + r] || t["cancelRequest" + r], a = 0; !o && a < n.length; a++)
    o = t[n[a] + "Request" + r], i = t[n[a] + "Cancel" + r] || t[n[a] + "CancelRequest" + r];
  if (!o || !i) {
    var s = 0, c = 0, l = [], d = 1e3 / 60;
    o = function(f) {
      if (l.length === 0) {
        var p = e(), m = Math.max(0, d - (p - s));
        s = m + p, setTimeout(function() {
          var v = l.slice(0);
          l.length = 0;
          for (var g = 0; g < v.length; g++)
            if (!v[g].cancelled)
              try {
                v[g].callback(s);
              } catch (b) {
                setTimeout(function() {
                  throw b;
                }, 0);
              }
        }, Math.round(m));
      }
      return l.push({
        handle: ++c,
        callback: f,
        cancelled: !1
      }), c;
    }, i = function(f) {
      for (var p = 0; p < l.length; p++)
        l[p].handle === f && (l[p].cancelled = !0);
    };
  }
  return nte.exports = function(f) {
    return o.call(t, f);
  }, ic.cancel = function() {
    i.apply(t, arguments);
  }, ic.polyfill = function(f) {
    f || (f = t), f.requestAnimationFrame = o, f.cancelAnimationFrame = i;
  }, ic;
}
var wE = {}, xE;
function ote() {
  return xE || (xE = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = t;
    function t(n) {
      return typeof n == "string";
    }
  }(wE)), wE;
}
var CE = {}, SE;
function ite() {
  return SE || (SE = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = i;
    var t = D_(), n = r(t);
    function r(a) {
      return a && a.__esModule ? a : { default: a };
    }
    var o = !1;
    function i() {
      if (o !== !1)
        return o;
      if (typeof document != "undefined") {
        var a = document.createElement("div");
        (0, n.default)(a, {
          width: 100,
          height: 100,
          position: "absolute",
          top: -9999,
          overflow: "scroll",
          MsOverflowStyle: "scrollbar"
        }), document.body.appendChild(a), o = a.offsetWidth - a.clientWidth, document.body.removeChild(a);
      } else
        o = 0;
      return o || 0;
    }
  }(CE)), CE;
}
var TE = {}, EE;
function ate() {
  return EE || (EE = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = t;
    function t() {
      return !1;
    }
  }(TE)), TE;
}
var kE = {}, ME;
function ste() {
  return ME || (ME = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = t;
    function t(n) {
      var r = n.clientWidth, o = getComputedStyle(n), i = o.paddingLeft, a = o.paddingRight;
      return r - parseFloat(i) - parseFloat(a);
    }
  }(kE)), kE;
}
var RE = {}, PE;
function lte() {
  return PE || (PE = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = t;
    function t(n) {
      var r = n.clientHeight, o = getComputedStyle(n), i = o.paddingTop, a = o.paddingBottom;
      return r - parseFloat(i) - parseFloat(a);
    }
  }(RE)), RE;
}
var oo = {}, OE;
function cte() {
  return OE || (OE = 1, Object.defineProperty(oo, "__esModule", {
    value: !0
  }), oo.containerStyleDefault = {
    position: "relative",
    overflow: "hidden",
    width: "100%",
    height: "100%"
  }, oo.containerStyleAutoHeight = {
    height: "auto"
  }, oo.viewStyleDefault = {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    overflow: "scroll",
    WebkitOverflowScrolling: "touch"
  }, oo.viewStyleAutoHeight = {
    position: "relative",
    top: void 0,
    left: void 0,
    right: void 0,
    bottom: void 0
  }, oo.viewStyleUniversalInitial = {
    overflow: "hidden",
    marginRight: 0,
    marginBottom: 0
  }, oo.trackHorizontalStyleDefault = {
    position: "absolute",
    height: 6
  }, oo.trackVerticalStyleDefault = {
    position: "absolute",
    width: 6
  }, oo.thumbHorizontalStyleDefault = {
    position: "relative",
    display: "block",
    height: "100%"
  }, oo.thumbVerticalStyleDefault = {
    position: "relative",
    display: "block",
    width: "100%"
  }, oo.disableSelectStyle = {
    userSelect: "none"
  }, oo.disableSelectStyleReset = {
    userSelect: ""
  }), oo;
}
var Ia = {}, NE;
function ute() {
  if (NE)
    return Ia;
  NE = 1, Object.defineProperty(Ia, "__esModule", {
    value: !0
  });
  var e = Object.assign || function(d) {
    for (var f = 1; f < arguments.length; f++) {
      var p = arguments[f];
      for (var m in p)
        Object.prototype.hasOwnProperty.call(p, m) && (d[m] = p[m]);
    }
    return d;
  };
  Ia.renderViewDefault = i, Ia.renderTrackHorizontalDefault = a, Ia.renderTrackVerticalDefault = s, Ia.renderThumbHorizontalDefault = c, Ia.renderThumbVerticalDefault = l;
  var t = et, n = r(t);
  function r(d) {
    return d && d.__esModule ? d : { default: d };
  }
  function o(d, f) {
    var p = {};
    for (var m in d)
      f.indexOf(m) >= 0 || Object.prototype.hasOwnProperty.call(d, m) && (p[m] = d[m]);
    return p;
  }
  function i(d) {
    return n.default.createElement("div", d);
  }
  function a(d) {
    var f = d.style, p = o(d, ["style"]), m = e({}, f, {
      right: 2,
      bottom: 2,
      left: 2,
      borderRadius: 3
    });
    return n.default.createElement("div", e({ style: m }, p));
  }
  function s(d) {
    var f = d.style, p = o(d, ["style"]), m = e({}, f, {
      right: 2,
      bottom: 2,
      top: 2,
      borderRadius: 3
    });
    return n.default.createElement("div", e({ style: m }, p));
  }
  function c(d) {
    var f = d.style, p = o(d, ["style"]), m = e({}, f, {
      cursor: "pointer",
      borderRadius: "inherit",
      backgroundColor: "rgba(0,0,0,.2)"
    });
    return n.default.createElement("div", e({ style: m }, p));
  }
  function l(d) {
    var f = d.style, p = o(d, ["style"]), m = e({}, f, {
      cursor: "pointer",
      borderRadius: "inherit",
      backgroundColor: "rgba(0,0,0,.2)"
    });
    return n.default.createElement("div", e({ style: m }, p));
  }
  return Ia;
}
var AE;
function dte() {
  return AE || (AE = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var t = Object.assign || function(N) {
      for (var F = 1; F < arguments.length; F++) {
        var $ = arguments[F];
        for (var I in $)
          Object.prototype.hasOwnProperty.call($, I) && (N[I] = $[I]);
      }
      return N;
    }, n = /* @__PURE__ */ function() {
      function N(F, $) {
        for (var I = 0; I < $.length; I++) {
          var j = $[I];
          j.enumerable = j.enumerable || !1, j.configurable = !0, "value" in j && (j.writable = !0), Object.defineProperty(F, j.key, j);
        }
      }
      return function(F, $, I) {
        return $ && N(F.prototype, $), I && N(F, I), F;
      };
    }(), r = rte(), o = k(r), i = D_(), a = k(i), s = et, c = B3(), l = k(c), d = ote(), f = k(d), p = ite(), m = k(p), v = ate(), g = k(v), b = ste(), x = k(b), T = lte(), S = k(T), _ = cte(), w = ute();
    function k(N) {
      return N && N.__esModule ? N : { default: N };
    }
    function E(N, F) {
      var $ = {};
      for (var I in N)
        F.indexOf(I) >= 0 || Object.prototype.hasOwnProperty.call(N, I) && ($[I] = N[I]);
      return $;
    }
    function R(N, F) {
      if (!(N instanceof F))
        throw new TypeError("Cannot call a class as a function");
    }
    function P(N, F) {
      if (!N)
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return F && (typeof F == "object" || typeof F == "function") ? F : N;
    }
    function A(N, F) {
      if (typeof F != "function" && F !== null)
        throw new TypeError("Super expression must either be null or a function, not " + typeof F);
      N.prototype = Object.create(F && F.prototype, { constructor: { value: N, enumerable: !1, writable: !0, configurable: !0 } }), F && (Object.setPrototypeOf ? Object.setPrototypeOf(N, F) : N.__proto__ = F);
    }
    var D = function(N) {
      A(F, N);
      function F($) {
        var I;
        R(this, F);
        for (var j = arguments.length, U = Array(j > 1 ? j - 1 : 0), G = 1; G < j; G++)
          U[G - 1] = arguments[G];
        var V = P(this, (I = F.__proto__ || Object.getPrototypeOf(F)).call.apply(I, [this, $].concat(U)));
        return V.getScrollLeft = V.getScrollLeft.bind(V), V.getScrollTop = V.getScrollTop.bind(V), V.getScrollWidth = V.getScrollWidth.bind(V), V.getScrollHeight = V.getScrollHeight.bind(V), V.getClientWidth = V.getClientWidth.bind(V), V.getClientHeight = V.getClientHeight.bind(V), V.getValues = V.getValues.bind(V), V.getThumbHorizontalWidth = V.getThumbHorizontalWidth.bind(V), V.getThumbVerticalHeight = V.getThumbVerticalHeight.bind(V), V.getScrollLeftForOffset = V.getScrollLeftForOffset.bind(V), V.getScrollTopForOffset = V.getScrollTopForOffset.bind(V), V.scrollLeft = V.scrollLeft.bind(V), V.scrollTop = V.scrollTop.bind(V), V.scrollToLeft = V.scrollToLeft.bind(V), V.scrollToTop = V.scrollToTop.bind(V), V.scrollToRight = V.scrollToRight.bind(V), V.scrollToBottom = V.scrollToBottom.bind(V), V.handleTrackMouseEnter = V.handleTrackMouseEnter.bind(V), V.handleTrackMouseLeave = V.handleTrackMouseLeave.bind(V), V.handleHorizontalTrackMouseDown = V.handleHorizontalTrackMouseDown.bind(V), V.handleVerticalTrackMouseDown = V.handleVerticalTrackMouseDown.bind(V), V.handleHorizontalThumbMouseDown = V.handleHorizontalThumbMouseDown.bind(V), V.handleVerticalThumbMouseDown = V.handleVerticalThumbMouseDown.bind(V), V.handleWindowResize = V.handleWindowResize.bind(V), V.handleScroll = V.handleScroll.bind(V), V.handleDrag = V.handleDrag.bind(V), V.handleDragEnd = V.handleDragEnd.bind(V), V.state = {
          didMountUniversal: !1
        }, V;
      }
      return n(F, [{
        key: "componentDidMount",
        value: function() {
          this.addListeners(), this.update(), this.componentDidMountUniversal();
        }
      }, {
        key: "componentDidMountUniversal",
        value: function() {
          var $ = this.props.universal;
          $ && this.setState({ didMountUniversal: !0 });
        }
      }, {
        key: "componentDidUpdate",
        value: function() {
          this.update();
        }
      }, {
        key: "componentWillUnmount",
        value: function() {
          this.removeListeners(), (0, r.cancel)(this.requestFrame), clearTimeout(this.hideTracksTimeout), clearInterval(this.detectScrollingInterval);
        }
      }, {
        key: "getScrollLeft",
        value: function() {
          return this.view ? this.view.scrollLeft : 0;
        }
      }, {
        key: "getScrollTop",
        value: function() {
          return this.view ? this.view.scrollTop : 0;
        }
      }, {
        key: "getScrollWidth",
        value: function() {
          return this.view ? this.view.scrollWidth : 0;
        }
      }, {
        key: "getScrollHeight",
        value: function() {
          return this.view ? this.view.scrollHeight : 0;
        }
      }, {
        key: "getClientWidth",
        value: function() {
          return this.view ? this.view.clientWidth : 0;
        }
      }, {
        key: "getClientHeight",
        value: function() {
          return this.view ? this.view.clientHeight : 0;
        }
      }, {
        key: "getValues",
        value: function() {
          var $ = this.view || {}, I = $.scrollLeft, j = I === void 0 ? 0 : I, U = $.scrollTop, G = U === void 0 ? 0 : U, V = $.scrollWidth, H = V === void 0 ? 0 : V, q = $.scrollHeight, Q = q === void 0 ? 0 : q, X = $.clientWidth, K = X === void 0 ? 0 : X, J = $.clientHeight, ne = J === void 0 ? 0 : J;
          return {
            left: j / (H - K) || 0,
            top: G / (Q - ne) || 0,
            scrollLeft: j,
            scrollTop: G,
            scrollWidth: H,
            scrollHeight: Q,
            clientWidth: K,
            clientHeight: ne
          };
        }
      }, {
        key: "getThumbHorizontalWidth",
        value: function() {
          var $ = this.props, I = $.thumbSize, j = $.thumbMinSize, U = this.view, G = U.scrollWidth, V = U.clientWidth, H = (0, x.default)(this.trackHorizontal), q = Math.ceil(V / G * H);
          return H === q ? 0 : I || Math.max(q, j);
        }
      }, {
        key: "getThumbVerticalHeight",
        value: function() {
          var $ = this.props, I = $.thumbSize, j = $.thumbMinSize, U = this.view, G = U.scrollHeight, V = U.clientHeight, H = (0, S.default)(this.trackVertical), q = Math.ceil(V / G * H);
          return H === q ? 0 : I || Math.max(q, j);
        }
      }, {
        key: "getScrollLeftForOffset",
        value: function($) {
          var I = this.view, j = I.scrollWidth, U = I.clientWidth, G = (0, x.default)(this.trackHorizontal), V = this.getThumbHorizontalWidth();
          return $ / (G - V) * (j - U);
        }
      }, {
        key: "getScrollTopForOffset",
        value: function($) {
          var I = this.view, j = I.scrollHeight, U = I.clientHeight, G = (0, S.default)(this.trackVertical), V = this.getThumbVerticalHeight();
          return $ / (G - V) * (j - U);
        }
      }, {
        key: "scrollLeft",
        value: function() {
          var $ = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
          this.view && (this.view.scrollLeft = $);
        }
      }, {
        key: "scrollTop",
        value: function() {
          var $ = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
          this.view && (this.view.scrollTop = $);
        }
      }, {
        key: "scrollToLeft",
        value: function() {
          this.view && (this.view.scrollLeft = 0);
        }
      }, {
        key: "scrollToTop",
        value: function() {
          this.view && (this.view.scrollTop = 0);
        }
      }, {
        key: "scrollToRight",
        value: function() {
          this.view && (this.view.scrollLeft = this.view.scrollWidth);
        }
      }, {
        key: "scrollToBottom",
        value: function() {
          this.view && (this.view.scrollTop = this.view.scrollHeight);
        }
      }, {
        key: "addListeners",
        value: function() {
          if (!(typeof document == "undefined" || !this.view)) {
            var $ = this.view, I = this.trackHorizontal, j = this.trackVertical, U = this.thumbHorizontal, G = this.thumbVertical;
            $.addEventListener("scroll", this.handleScroll), (0, m.default)() && (I.addEventListener("mouseenter", this.handleTrackMouseEnter), I.addEventListener("mouseleave", this.handleTrackMouseLeave), I.addEventListener("mousedown", this.handleHorizontalTrackMouseDown), j.addEventListener("mouseenter", this.handleTrackMouseEnter), j.addEventListener("mouseleave", this.handleTrackMouseLeave), j.addEventListener("mousedown", this.handleVerticalTrackMouseDown), U.addEventListener("mousedown", this.handleHorizontalThumbMouseDown), G.addEventListener("mousedown", this.handleVerticalThumbMouseDown), window.addEventListener("resize", this.handleWindowResize));
          }
        }
      }, {
        key: "removeListeners",
        value: function() {
          if (!(typeof document == "undefined" || !this.view)) {
            var $ = this.view, I = this.trackHorizontal, j = this.trackVertical, U = this.thumbHorizontal, G = this.thumbVertical;
            $.removeEventListener("scroll", this.handleScroll), (0, m.default)() && (I.removeEventListener("mouseenter", this.handleTrackMouseEnter), I.removeEventListener("mouseleave", this.handleTrackMouseLeave), I.removeEventListener("mousedown", this.handleHorizontalTrackMouseDown), j.removeEventListener("mouseenter", this.handleTrackMouseEnter), j.removeEventListener("mouseleave", this.handleTrackMouseLeave), j.removeEventListener("mousedown", this.handleVerticalTrackMouseDown), U.removeEventListener("mousedown", this.handleHorizontalThumbMouseDown), G.removeEventListener("mousedown", this.handleVerticalThumbMouseDown), window.removeEventListener("resize", this.handleWindowResize), this.teardownDragging());
          }
        }
      }, {
        key: "handleScroll",
        value: function($) {
          var I = this, j = this.props, U = j.onScroll, G = j.onScrollFrame;
          U && U($), this.update(function(V) {
            var H = V.scrollLeft, q = V.scrollTop;
            I.viewScrollLeft = H, I.viewScrollTop = q, G && G(V);
          }), this.detectScrolling();
        }
      }, {
        key: "handleScrollStart",
        value: function() {
          var $ = this.props.onScrollStart;
          $ && $(), this.handleScrollStartAutoHide();
        }
      }, {
        key: "handleScrollStartAutoHide",
        value: function() {
          var $ = this.props.autoHide;
          $ && this.showTracks();
        }
      }, {
        key: "handleScrollStop",
        value: function() {
          var $ = this.props.onScrollStop;
          $ && $(), this.handleScrollStopAutoHide();
        }
      }, {
        key: "handleScrollStopAutoHide",
        value: function() {
          var $ = this.props.autoHide;
          $ && this.hideTracks();
        }
      }, {
        key: "handleWindowResize",
        value: function() {
          this.update();
        }
      }, {
        key: "handleHorizontalTrackMouseDown",
        value: function($) {
          $.preventDefault();
          var I = $.target, j = $.clientX, U = I.getBoundingClientRect(), G = U.left, V = this.getThumbHorizontalWidth(), H = Math.abs(G - j) - V / 2;
          this.view.scrollLeft = this.getScrollLeftForOffset(H);
        }
      }, {
        key: "handleVerticalTrackMouseDown",
        value: function($) {
          $.preventDefault();
          var I = $.target, j = $.clientY, U = I.getBoundingClientRect(), G = U.top, V = this.getThumbVerticalHeight(), H = Math.abs(G - j) - V / 2;
          this.view.scrollTop = this.getScrollTopForOffset(H);
        }
      }, {
        key: "handleHorizontalThumbMouseDown",
        value: function($) {
          $.preventDefault(), this.handleDragStart($);
          var I = $.target, j = $.clientX, U = I.offsetWidth, G = I.getBoundingClientRect(), V = G.left;
          this.prevPageX = U - (j - V);
        }
      }, {
        key: "handleVerticalThumbMouseDown",
        value: function($) {
          $.preventDefault(), this.handleDragStart($);
          var I = $.target, j = $.clientY, U = I.offsetHeight, G = I.getBoundingClientRect(), V = G.top;
          this.prevPageY = U - (j - V);
        }
      }, {
        key: "setupDragging",
        value: function() {
          (0, a.default)(document.body, _.disableSelectStyle), document.addEventListener("mousemove", this.handleDrag), document.addEventListener("mouseup", this.handleDragEnd), document.onselectstart = g.default;
        }
      }, {
        key: "teardownDragging",
        value: function() {
          (0, a.default)(document.body, _.disableSelectStyleReset), document.removeEventListener("mousemove", this.handleDrag), document.removeEventListener("mouseup", this.handleDragEnd), document.onselectstart = void 0;
        }
      }, {
        key: "handleDragStart",
        value: function($) {
          this.dragging = !0, $.stopImmediatePropagation(), this.setupDragging();
        }
      }, {
        key: "handleDrag",
        value: function($) {
          if (this.prevPageX) {
            var I = $.clientX, j = this.trackHorizontal.getBoundingClientRect(), U = j.left, G = this.getThumbHorizontalWidth(), V = G - this.prevPageX, H = -U + I - V;
            this.view.scrollLeft = this.getScrollLeftForOffset(H);
          }
          if (this.prevPageY) {
            var q = $.clientY, Q = this.trackVertical.getBoundingClientRect(), X = Q.top, K = this.getThumbVerticalHeight(), J = K - this.prevPageY, ne = -X + q - J;
            this.view.scrollTop = this.getScrollTopForOffset(ne);
          }
          return !1;
        }
      }, {
        key: "handleDragEnd",
        value: function() {
          this.dragging = !1, this.prevPageX = this.prevPageY = 0, this.teardownDragging(), this.handleDragEndAutoHide();
        }
      }, {
        key: "handleDragEndAutoHide",
        value: function() {
          var $ = this.props.autoHide;
          $ && this.hideTracks();
        }
      }, {
        key: "handleTrackMouseEnter",
        value: function() {
          this.trackMouseOver = !0, this.handleTrackMouseEnterAutoHide();
        }
      }, {
        key: "handleTrackMouseEnterAutoHide",
        value: function() {
          var $ = this.props.autoHide;
          $ && this.showTracks();
        }
      }, {
        key: "handleTrackMouseLeave",
        value: function() {
          this.trackMouseOver = !1, this.handleTrackMouseLeaveAutoHide();
        }
      }, {
        key: "handleTrackMouseLeaveAutoHide",
        value: function() {
          var $ = this.props.autoHide;
          $ && this.hideTracks();
        }
      }, {
        key: "showTracks",
        value: function() {
          clearTimeout(this.hideTracksTimeout), (0, a.default)(this.trackHorizontal, { opacity: 1 }), (0, a.default)(this.trackVertical, { opacity: 1 });
        }
      }, {
        key: "hideTracks",
        value: function() {
          var $ = this;
          if (!this.dragging && !this.scrolling && !this.trackMouseOver) {
            var I = this.props.autoHideTimeout;
            clearTimeout(this.hideTracksTimeout), this.hideTracksTimeout = setTimeout(function() {
              (0, a.default)($.trackHorizontal, { opacity: 0 }), (0, a.default)($.trackVertical, { opacity: 0 });
            }, I);
          }
        }
      }, {
        key: "detectScrolling",
        value: function() {
          var $ = this;
          this.scrolling || (this.scrolling = !0, this.handleScrollStart(), this.detectScrollingInterval = setInterval(function() {
            $.lastViewScrollLeft === $.viewScrollLeft && $.lastViewScrollTop === $.viewScrollTop && (clearInterval($.detectScrollingInterval), $.scrolling = !1, $.handleScrollStop()), $.lastViewScrollLeft = $.viewScrollLeft, $.lastViewScrollTop = $.viewScrollTop;
          }, 100));
        }
      }, {
        key: "raf",
        value: function($) {
          var I = this;
          this.requestFrame && o.default.cancel(this.requestFrame), this.requestFrame = (0, o.default)(function() {
            I.requestFrame = void 0, $();
          });
        }
      }, {
        key: "update",
        value: function($) {
          var I = this;
          this.raf(function() {
            return I._update($);
          });
        }
      }, {
        key: "_update",
        value: function($) {
          var I = this.props, j = I.onUpdate, U = I.hideTracksWhenNotNeeded, G = this.getValues();
          if ((0, m.default)()) {
            var V = G.scrollLeft, H = G.clientWidth, q = G.scrollWidth, Q = (0, x.default)(this.trackHorizontal), X = this.getThumbHorizontalWidth(), K = V / (q - H) * (Q - X), J = {
              width: X,
              transform: "translateX(" + K + "px)"
            }, ne = G.scrollTop, ae = G.clientHeight, te = G.scrollHeight, le = (0, S.default)(this.trackVertical), ce = this.getThumbVerticalHeight(), fe = ne / (te - ae) * (le - ce), ee = {
              height: ce,
              transform: "translateY(" + fe + "px)"
            };
            if (U) {
              var me = {
                visibility: q > H ? "visible" : "hidden"
              }, oe = {
                visibility: te > ae ? "visible" : "hidden"
              };
              (0, a.default)(this.trackHorizontal, me), (0, a.default)(this.trackVertical, oe);
            }
            (0, a.default)(this.thumbHorizontal, J), (0, a.default)(this.thumbVertical, ee);
          }
          j && j(G), typeof $ == "function" && $(G);
        }
      }, {
        key: "render",
        value: function() {
          var $ = this, I = (0, m.default)(), j = this.props, U = j.renderView, G = j.renderTrackHorizontal, V = j.renderTrackVertical, H = j.renderThumbHorizontal, q = j.renderThumbVertical, Q = j.tagName, X = j.autoHide, K = j.autoHideDuration, J = j.universal, ne = j.autoHeight, ae = j.autoHeightMin, te = j.autoHeightMax, le = j.style, ce = j.children, fe = E(j, ["onScroll", "onScrollFrame", "onScrollStart", "onScrollStop", "onUpdate", "renderView", "renderTrackHorizontal", "renderTrackVertical", "renderThumbHorizontal", "renderThumbVertical", "tagName", "hideTracksWhenNotNeeded", "autoHide", "autoHideTimeout", "autoHideDuration", "thumbSize", "thumbMinSize", "universal", "autoHeight", "autoHeightMin", "autoHeightMax", "style", "children"]), ee = this.state.didMountUniversal, me = t({}, _.containerStyleDefault, ne && t({}, _.containerStyleAutoHeight, {
            minHeight: ae,
            maxHeight: te
          }), le), oe = t({}, _.viewStyleDefault, {
            // Hide scrollbars by setting a negative margin
            marginRight: I ? -I : 0,
            marginBottom: I ? -I : 0
          }, ne && t({}, _.viewStyleAutoHeight, {
            // Add scrollbarWidth to autoHeight in order to compensate negative margins
            minHeight: (0, f.default)(ae) ? "calc(" + ae + " + " + I + "px)" : ae + I,
            maxHeight: (0, f.default)(te) ? "calc(" + te + " + " + I + "px)" : te + I
          }), ne && J && !ee && {
            minHeight: ae,
            maxHeight: te
          }, J && !ee && _.viewStyleUniversalInitial), ve = {
            transition: "opacity " + K + "ms",
            opacity: 0
          }, we = t({}, _.trackHorizontalStyleDefault, X && ve, (!I || J && !ee) && {
            display: "none"
          }), ye = t({}, _.trackVerticalStyleDefault, X && ve, (!I || J && !ee) && {
            display: "none"
          });
          return (0, s.createElement)(Q, t({}, fe, { style: me, ref: function(Ce) {
            $.container = Ce;
          } }), [(0, s.cloneElement)(U({ style: oe }), { key: "view", ref: function(Ce) {
            $.view = Ce;
          } }, ce), (0, s.cloneElement)(G({ style: we }), { key: "trackHorizontal", ref: function(Ce) {
            $.trackHorizontal = Ce;
          } }, (0, s.cloneElement)(H({ style: _.thumbHorizontalStyleDefault }), { ref: function(Ce) {
            $.thumbHorizontal = Ce;
          } })), (0, s.cloneElement)(V({ style: ye }), { key: "trackVertical", ref: function(Ce) {
            $.trackVertical = Ce;
          } }, (0, s.cloneElement)(q({ style: _.thumbVerticalStyleDefault }), { ref: function(Ce) {
            $.thumbVertical = Ce;
          } }))]);
        }
      }]), F;
    }(s.Component);
    e.default = D, D.propTypes = {
      onScroll: l.default.func,
      onScrollFrame: l.default.func,
      onScrollStart: l.default.func,
      onScrollStop: l.default.func,
      onUpdate: l.default.func,
      renderView: l.default.func,
      renderTrackHorizontal: l.default.func,
      renderTrackVertical: l.default.func,
      renderThumbHorizontal: l.default.func,
      renderThumbVertical: l.default.func,
      tagName: l.default.string,
      thumbSize: l.default.number,
      thumbMinSize: l.default.number,
      hideTracksWhenNotNeeded: l.default.bool,
      autoHide: l.default.bool,
      autoHideTimeout: l.default.number,
      autoHideDuration: l.default.number,
      autoHeight: l.default.bool,
      autoHeightMin: l.default.oneOfType([l.default.number, l.default.string]),
      autoHeightMax: l.default.oneOfType([l.default.number, l.default.string]),
      universal: l.default.bool,
      style: l.default.object,
      children: l.default.node
    }, D.defaultProps = {
      renderView: w.renderViewDefault,
      renderTrackHorizontal: w.renderTrackHorizontalDefault,
      renderTrackVertical: w.renderTrackVerticalDefault,
      renderThumbHorizontal: w.renderThumbHorizontalDefault,
      renderThumbVertical: w.renderThumbVerticalDefault,
      tagName: "div",
      thumbMinSize: 30,
      hideTracksWhenNotNeeded: !1,
      autoHide: !1,
      autoHideTimeout: 1e3,
      autoHideDuration: 200,
      autoHeight: !1,
      autoHeightMin: 0,
      autoHeightMax: 200,
      universal: !1
    };
  }(yE)), yE;
}
var DE;
function fte() {
  return DE || (DE = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.Scrollbars = void 0;
    var t = dte(), n = r(t);
    function r(o) {
      return o && o.__esModule ? o : { default: o };
    }
    e.default = n.default, e.Scrollbars = n.default;
  }(bE)), bE;
}
var pte = fte();
const hte = "_loader_1uppi_1", mte = "_caption_1uppi_7", Iu = {
  loader: hte,
  caption: mte
}, gte = (e) => {
  const { className: t = "", caption: n = "", isLoading: r = !1 } = e, o = Xe(
    Iu["loader-two-dots"],
    {
      [Iu["loader-two-dots--inactive"]]: !r
    },
    t
  ), i = Xe(Iu.loader, Iu["loader-two-dots-indicator"]), a = Xe(Iu.caption);
  return /* @__PURE__ */ z("div", { className: o, children: r && /* @__PURE__ */ z("div", { "data-testid": "loader-component", className: i, children: n && /* @__PURE__ */ z("div", { className: a, children: /* @__PURE__ */ z("span", { children: n }) }) }) });
}, vte = "_clickable_19yrx_1", bte = "_disabled_19yrx_5", IE = {
  clickable: vte,
  disabled: bte
}, mp = () => {
}, jr = (e) => {
  const [t, n] = Ge(!1), {
    className: r = "",
    disabled: o = !1,
    name: i,
    hoverSuffix: a = "",
    onClick: s = mp,
    onMouseEnter: c = mp,
    onMouseLeave: l = mp,
    title: d = ""
  } = e, f = (k) => {
    t || n(!0), c(k);
  }, p = (k) => {
    t && n(!1), l(k);
  }, m = { top: "auto" }, v = !o && t && a ? `${i}${a}` : i, g = Xe("app-icon", `app-icon--${v}`), b = Xe("app-icon__svg"), x = Xe(g, r, {
    [IE.clickable]: s !== mp,
    [IE.disabled]: o
  }), T = e, { dataTestId: S } = T, _ = Wn(T, ["dataTestId"]), w = pe({ disabled: o, onClick: s }, _);
  return d && !o && (w.title = d), delete w.hoverSuffix, /* @__PURE__ */ z(
    "span",
    $e(pe({}, w), {
      className: x,
      onMouseEnter: f,
      onMouseLeave: p,
      "data-testid": S,
      children: /* @__PURE__ */ _e("svg", { className: b, style: m, children: [
        /* @__PURE__ */ z("use", { xlinkHref: `#${v}` }),
        /* @__PURE__ */ z("symbol", { id: "general-arrow-down", viewBox: "0 0 24 24", children: /* @__PURE__ */ z(
          "path",
          {
            fill: "currentColor",
            d: "M12 13.84l3.174-2.719a.5.5 0 0 1 .65.76l-3.5 2.998a.5.5 0 0 1-.65 0l-3.5-2.998a.5.5 0 1 1 .65-.76L12 13.841z"
          }
        ) }),
        /* @__PURE__ */ z("symbol", { id: "general-vi-small-white", viewBox: "0 0 24 24", children: /* @__PURE__ */ z(
          "path",
          {
            fill: "currentColor",
            d: "M8.354 11.646l-.708.708 3.418 3.417 5.343-7.48-.814-.582-4.657 6.52z"
          }
        ) })
      ] })
    })
  );
}, yte = "_sharedComponentsInputRadioButton_195lt_1", _te = "_disabled_195lt_15", LE = {
  sharedComponentsInputRadioButton: yte,
  disabled: _te
}, wte = ({
  checked: e,
  text: t,
  disabled: n = !1,
  inline: r = !1,
  title: o = "",
  name: i = "",
  value: a,
  onChange: s,
  preventClick: c,
  inputRadioButtonClassName: l,
  className: d,
  textClassName: f,
  dataTestId: p = void 0
}) => {
  const m = pe({
    disabled: n,
    name: i,
    value: a
  }, o && !n && { title: o }), v = (b) => {
    if (c) {
      b.preventDefault(), b.stopPropagation();
      return;
    }
    s(b);
  }, g = Xe(
    "custom-radiobtn",
    {
      "custom-radiobtn--inline": r,
      [LE.disabled]: n
    },
    d
  );
  return /* @__PURE__ */ z("div", { className: g, children: /* @__PURE__ */ _e("label", { className: "custom-radiobtn__label", children: [
    /* @__PURE__ */ _e(
      "div",
      {
        className: Xe(
          LE.sharedComponentsInputRadioButton,
          l,
          {}
        ),
        children: [
          /* @__PURE__ */ z(
            "input",
            pe({
              className: "custom-radiobtn__input",
              type: "radio",
              onChange: v,
              checked: e,
              "data-testid": p
            }, m)
          ),
          /* @__PURE__ */ z("span", { className: "custom-radiobtn__icon" })
        ]
      }
    ),
    /* @__PURE__ */ z("span", { className: Xe("custom-radiobtn__text", f), children: t })
  ] }) });
}, xte = ({
  checked: e,
  onChange: t,
  className: n = "",
  disabled: r = !1,
  inline: o = !1,
  text: i = ""
}) => {
  const a = {
    checked: e,
    disabled: r,
    onChange: t
  }, s = "custom-togglebtn", c = Xe(
    s,
    {
      [`${s}--inline`]: o
    },
    n
  ), l = `${s}__icon`;
  return /* @__PURE__ */ z("div", { className: c, children: /* @__PURE__ */ _e("label", { className: `${s}__label`, children: [
    /* @__PURE__ */ z("input", pe({ type: "checkbox", className: `${s}__input` }, a)),
    /* @__PURE__ */ z("span", { className: l }),
    i && /* @__PURE__ */ z("span", { className: `${s}__text`, children: i })
  ] }) });
}, Cte = "_transparent_i81lr_1", Ste = "_icon_i81lr_12", Tte = "_disabled_i81lr_17", Ete = "_sharedComponentsInputCheckbox_i81lr_27", gp = {
  transparent: Cte,
  icon: Ste,
  disabled: Tte,
  sharedComponentsInputCheckbox: Ete
}, kte = (e) => {
  const t = e, {
    className: n,
    disabled: r,
    inline: o,
    text: i,
    textClassName: a,
    title: s,
    transparent: c,
    dataTestId: l,
    iconName: d,
    onDescriptionClick: f,
    inputCheckboxClassName: p
  } = t, m = Wn(t, [
    "className",
    "disabled",
    "inline",
    "text",
    "textClassName",
    "title",
    "transparent",
    "dataTestId",
    "iconName",
    "onDescriptionClick",
    "inputCheckboxClassName"
  ]), v = pe({ disabled: r }, m);
  s && !r && (v.title = s);
  const g = "custom-checkbox", b = Xe(
    g,
    {
      "custom-checkbox--inline": o,
      [gp.disabled]: r
    },
    n
  ), x = Xe(`${g}__icon`, "app-icon app-icon--form-checkbox-mark", {
    [gp.transparent]: c
  }), T = Xe(`${g}__text`, a), S = f ? (_) => {
    f(), _.preventDefault();
  } : void 0;
  return /* @__PURE__ */ z("div", { className: b, children: /* @__PURE__ */ _e("label", { className: `${g}__label`, children: [
    /* @__PURE__ */ _e("div", { className: Xe(gp.sharedComponentsInputCheckbox, p), children: [
      /* @__PURE__ */ z(
        "input",
        pe({
          type: "checkbox",
          className: `${g}__input`,
          "data-testid": l
        }, v)
      ),
      /* @__PURE__ */ z("span", { className: x, children: /* @__PURE__ */ z("svg", { className: "app-icon__svg", children: /* @__PURE__ */ z("use", { xlinkHref: "#form-checkbox-mark" }) }) })
    ] }),
    d && /* @__PURE__ */ z(
      jr,
      {
        name: d,
        className: gp.icon,
        onClick: S
      }
    ),
    /* @__PURE__ */ z("span", { className: T, onClick: S, children: i })
  ] }) });
}, Mte = "_container_v8yrt_7", Rte = "_disabled_v8yrt_27", Pte = "_groupHeader_v8yrt_31", Ote = "_isDrill_v8yrt_36", Nte = "_separator_v8yrt_45", Ate = "_noIcon_v8yrt_48", Dte = "_item_v8yrt_52", Ite = "_checked_v8yrt_52", Lte = "_radio_v8yrt_62", $te = "_checkbox_v8yrt_68", Fte = "_icon_v8yrt_74", zte = "_itemType_v8yrt_77", Bte = "_nestedType_v8yrt_86", Hte = "_nestedIcon_v8yrt_90", jte = "_menuItemText_v8yrt_93", Wte = "_separateGroup_v8yrt_99", Vte = "_itemCheckBox_v8yrt_103", Ute = "_itemRadioButton_v8yrt_108", qte = "_scrollbar_v8yrt_113", Gte = "_itemContainer_v8yrt_120", Yte = "_inlineConfirmation_v8yrt_125", Zte = "_menuItemTooltip_v8yrt_129", Xte = "_toggleButtonMenu_v8yrt_138", Kte = "_loader_v8yrt_146", Fn = {
  container: Mte,
  disabled: Rte,
  groupHeader: Pte,
  isDrill: Ote,
  separator: Nte,
  noIcon: Ate,
  item: Dte,
  checked: Ite,
  radio: Lte,
  checkbox: $te,
  icon: Fte,
  itemType: zte,
  nestedType: Bte,
  nestedIcon: Hte,
  menuItemText: jte,
  separateGroup: Wte,
  itemCheckBox: Vte,
  itemRadioButton: Ute,
  scrollbar: qte,
  itemContainer: Gte,
  inlineConfirmation: Yte,
  menuItemTooltip: Zte,
  toggleButtonMenu: Xte,
  loader: Kte
}, td = Object.freeze({
  ITEM: "item",
  RADIO: "radio",
  CHECKBOX: "checkbox",
  TOGGLE: "toggle",
  NESTED: "nested"
});
class SD extends af {
  constructor(t) {
    super(t), Z(this, "renderRegularMenuItem", () => {
      const { dataTestId: n, iconName: r, iconClass: o, isDrill: i } = this.props;
      return /* @__PURE__ */ _e("span", { className: Fn.itemContainer, children: [
        r && /* @__PURE__ */ z(jr, { name: r, className: o }),
        /* @__PURE__ */ z(
          "span",
          {
            "data-testid": n,
            className: Xe(Fn.menuItemText, Xa.TEXT_PRIMARY),
            children: this.getContent()
          }
        ),
        i && /* @__PURE__ */ z(jr, { name: "general-arrow-right" })
      ] });
    }), Z(this, "renderMenuItem", () => {
      const { tooltip: n, classNameTooltip: r, level: o } = this.props, i = this.renderRegularMenuItem();
      return n ? /* @__PURE__ */ z(
        dD,
        {
          overlay: /* @__PURE__ */ z("div", { children: n }),
          placement: "right",
          overlayClassName: Xe(r, Fn.menuItemTooltip),
          mouseLeaveDelay: 0,
          align: { offset: [o ? 5 : 10, 0] },
          children: i
        }
      ) : i;
    }), this.state = { inInlineConfirmation: !1 };
  }
  getContent() {
    const { type: t, caption: n, subCaption: r, checked: o, selected: i } = this.props;
    switch (t) {
      case td.RADIO:
        return /* @__PURE__ */ z(
          wte,
          {
            text: n,
            name: n,
            onChange: () => null,
            value: n,
            checked: !!o,
            preventClick: !0
          }
        );
      case td.CHECKBOX:
        return /* @__PURE__ */ z(
          kte,
          {
            title: n,
            text: n,
            onChange: () => null,
            checked: !!o,
            className: Fn.itemCheckBox
          }
        );
      case td.TOGGLE:
        return /* @__PURE__ */ _e("div", { children: [
          /* @__PURE__ */ z("span", { children: n }),
          /* @__PURE__ */ z(
            xte,
            {
              onChange: () => null,
              className: Fn.toggleButtonMenu,
              checked: !!o
            }
          )
        ] });
      case td.NESTED:
        return /* @__PURE__ */ _e("div", { className: Fn.nestedType, children: [
          /* @__PURE__ */ z("div", { children: n }),
          /* @__PURE__ */ z(jr, { className: Fn.nestedIcon, name: "general-double-arrow-front" }),
          /* @__PURE__ */ z("div", { children: r })
        ] });
      default:
        return /* @__PURE__ */ _e("div", { className: Fn.itemType, children: [
          n,
          i && /* @__PURE__ */ z(jr, { name: "general-vi-small-white" })
        ] });
    }
  }
  handleClick(t) {
    t.stopPropagation();
    const { handleClick: n, disabled: r } = this.props;
    r || n();
  }
  render() {
    const { checked: t, className: n, iconName: r, handleOver: o, handleOut: i, disabled: a } = this.props, s = !1, c = Xe(n, {
      [Fn.checked]: t,
      [Fn.noIcon]: !r || s,
      [Fn.disabled]: a,
      [Xa.TEXT_PRIMARY]: t,
      [Xa.TEXT_SECONDARY_HOVER]: !t && !a,
      [Xa.TEXT_SECONDARY]: a
    });
    return /* @__PURE__ */ z(
      "li",
      {
        "data-menu-item": !0,
        className: c,
        onClick: this.handleClick.bind(this),
        onMouseOver: o,
        onMouseOut: i,
        children: this.renderMenuItem()
      }
    );
  }
}
Z(SD, "defaultProps", {
  className: ""
});
const Jte = "_container_v9uof_1", Qte = "_message_v9uof_9", ene = "_buttons_v9uof_16", tne = "_button_v9uof_16", nne = "_confirm_v9uof_34", rne = "_cancel_v9uof_39", La = {
  container: Jte,
  message: Qte,
  buttons: ene,
  button: tne,
  confirm: nne,
  cancel: rne
}, one = ({
  message: e,
  title: t,
  onCancel: n,
  onConfirm: r
}) => {
  const o = Xe(La.button, La.confirm), i = Xe(La.button, La.cancel);
  return /* @__PURE__ */ _e("div", { className: La.container, children: [
    /* @__PURE__ */ z("div", { className: La.title, children: t }),
    /* @__PURE__ */ z("div", { className: Xe(La.message, Xa.TEXT_SECONDARY), children: e }),
    /* @__PURE__ */ _e("div", { className: La.buttons, children: [
      /* @__PURE__ */ z("button", { className: o, onClick: r, children: "Yes" }),
      /* @__PURE__ */ z("button", { className: i, onClick: n, children: "No" })
    ] })
  ] });
};
function ine(e, t) {
  const n = {};
  return e.reduce(function(r, o) {
    const i = t(o);
    return r[i] || (r[i] = []), r[i].push(o), r;
  }, n);
}
const $E = () => {
}, TD = class extends af {
  constructor(e) {
    super(e), Z(this, "timeoutIn"), Z(this, "handleClick", (t) => {
      if (t.subItems || t.actionableComponent) {
        this.clearTimeout(), this.state.activeSubMenu === t.id ? this.closeSubMenu() : this.setState({ activeSubMenu: t.id });
        return;
      } else if (t.confirmation && !t.confirmation.inline) {
        this.clearTimeout(), this.setState({ activeSubMenu: t.id });
        return;
      }
      const { onItemSelected: n } = this.props;
      n(t, t.value);
    }), Z(this, "handleOver", (t) => {
      this.clearTimeout(), this.setState({ isHoverSubMenu: !1 });
      const n = t.subItems || t.actionableComponent ? t.id : null;
      this.timeoutIn = window.setTimeout(() => {
        this.setState({
          activeSubMenu: n
        });
      }, 900);
    }), Z(this, "handleOut", (t) => {
      (t.subItems || t.actionableComponent) && this.state.activeSubMenu && this.clearTimeout();
    }), Z(this, "onSubMenuMouseEnter", () => {
      this.clearTimeout(), this.setState({ isHoverSubMenu: !0 });
    }), Z(this, "onSubMenuMouseLeave", () => {
      this.setState({ isHoverSubMenu: !1 });
    }), Z(this, "closeSubMenu", () => {
      this.setState({ activeSubMenu: null });
    }), Z(this, "onConfirm", (t) => {
      const { onItemSelected: n } = this.props;
      this.closeSubMenu(), n(t);
    }), Z(this, "renderMenuItem", (t) => {
      const { onItemSelected: n, onRequestClose: r, level: o, classNameTooltip: i, zIndex: a, className: s } = this.props;
      let c = Xe(Fn[t.type], {
        [Fn.isDrill]: t.subItems,
        [Fn.separator]: t.separator,
        fakeHover: t.checked,
        [Fn.groupHeader]: t.groupTitle
      });
      const l = (f) => {
        const p = Xe(t.iconClass, Fn.icon);
        return /* @__PURE__ */ z(
          SD,
          {
            className: f,
            checked: t.checked,
            dataTestId: t.dataTestId,
            disabled: t.disabled,
            type: t.type,
            caption: t.caption,
            subCaption: t.subCaption,
            tooltip: t.tooltip,
            classNameTooltip: i,
            iconName: t.iconName,
            iconClass: p,
            isDrill: !!t.subItems || !!t.actionableComponent,
            level: o,
            selected: t.selected,
            handleClick: () => this.handleClick(t),
            handleOver: () => this.handleOver(t),
            handleOut: () => this.handleOut(t)
          },
          t.id
        );
      };
      let d = t.subItems;
      if (d) {
        const f = this.state.activeSubMenu === t.id;
        let p = this.handleClick;
        return c = Xe(c, {
          fakeHover: f && this.state.isHoverSubMenu
        }), t.value !== void 0 && (d = d.map(function(m) {
          return $e(pe({}, m), {
            checked: m.value === t.value
          });
        }), p = (m) => n(t, m.value)), /* @__PURE__ */ z(
          bd,
          {
            visible: f,
            level: 1,
            mask: !1,
            trigger: [],
            placement: "rightTop",
            align: { offset: [0, 0] },
            overlay: () => /* @__PURE__ */ z(
              TD,
              {
                items: d || [],
                className: s,
                onItemSelected: p,
                onMouseEnter: this.onSubMenuMouseEnter,
                scrollbarProps: {
                  className: t.subItemScrollbarClassName
                },
                level: (o || 0) + 1,
                zIndex: (a || 1) + 1
              }
            ),
            onRequestClose: r,
            zIndex: (a || 1) + 1,
            children: l(c)
          },
          t.id
        );
      } else if (t.actionableComponent) {
        const { componentProps: f } = t.actionableComponent, p = t.actionableComponent.component, m = this.state.activeSubMenu === t.id;
        return /* @__PURE__ */ z(
          bd,
          {
            visible: m,
            level: 1,
            mask: !1,
            trigger: [],
            placement: "rightTop",
            align: { offset: [10, 0] },
            overlay: () => /* @__PURE__ */ z(p, $e(pe({}, f), { onRequestClose: r })),
            onRequestClose: r,
            children: l(c)
          },
          t.id
        );
      } else if (t.confirmation && !t.confirmation.inline) {
        const f = t.confirmation, p = this.state.activeSubMenu === t.id;
        return /* @__PURE__ */ z(
          bd,
          {
            visible: p,
            level: 1,
            mask: !0,
            trigger: [],
            placement: "rightBottom",
            align: { offset: [10, 0] },
            overlay: () => /* @__PURE__ */ z(
              one,
              {
                title: f.title,
                message: f.message,
                onCancel: this.closeSubMenu,
                onConfirm: () => this.onConfirm(t)
              }
            ),
            onRequestClose: this.closeSubMenu,
            children: l(c)
          },
          t.id
        );
      }
      return l(c);
    }), this.state = {
      activeSubMenu: null,
      isHoverSubMenu: !1
    }, this.timeoutIn = null;
  }
  componentWillUnmount() {
    this.clearTimeout();
  }
  clearTimeout() {
    this.timeoutIn && (clearTimeout(this.timeoutIn), this.timeoutIn = null);
  }
  getSeparateGroups(e) {
    const t = ine(e, (r) => r.groupId || ""), n = Object.values(t);
    return n.slice(1).forEach((r) => r[0].separator = !0), n;
  }
  render() {
    const e = this.props, {
      items: t,
      className: n,
      onMouseEnter: r,
      scrollbarProps: o
    } = e, i = o, { className: a } = i, s = Wn(i, ["className"]), {
      width: c,
      isLoading: l
    } = e;
    let d = t.filter((g) => !g.hidden);
    d = d.map((g, b) => (g.separator && !d[b - 1] && (g.separator = !1), g));
    const f = Xe(Fn.container, n), p = Xe(Fn.scrollbar, a), m = c ? { width: `${c}px`, minWidth: "inherit" } : {}, v = l ? Fn.loader : "";
    return /* @__PURE__ */ z("div", { className: f, onMouseEnter: r, style: m, children: /* @__PURE__ */ _e(pte.Scrollbars, $e(pe({ className: p }, s), { hideTracksWhenNotNeeded: !0, children: [
      this.getSeparateGroups(d).map((g, b) => /* @__PURE__ */ z("div", { className: Fn.separateGroup, children: g.map(this.renderMenuItem) }, b)),
      /* @__PURE__ */ z("div", { className: v, children: /* @__PURE__ */ z(gte, { isLoading: l }) })
    ] })) });
  }
};
let ED = TD;
Z(ED, "defaultProps", {
  onMouseEnter: $E,
  onRequestClose: $E,
  scrollbarProps: {},
  level: 0,
  isLoading: !1,
  zIndex: 1
});
const ane = "#2c3342", sne = "#f4f4f8", lne = "#dee1e7", cne = "#fff", une = "_component_lx560_8", dne = "_searchIcon_lx560_13", fne = "_large_lx560_19", pne = "_clearIcon_lx560_22", hne = "_clearIconHidden_lx560_34", mne = "_passwordVisibilityIcon_lx560_43", gne = "_customIcon_lx560_54", vne = "_isLeft_lx560_59", bne = "_input_lx560_66", yne = "_withLeftIcon_lx560_76", Fr = {
  loginDarkColor: ane,
  darkBtnHoverColor: sne,
  greyHoverColor: lne,
  defaultBackgroundColor: cne,
  component: une,
  searchIcon: dne,
  large: fne,
  clearIcon: pne,
  clearIconHidden: hne,
  passwordVisibilityIcon: mne,
  customIcon: gne,
  isLeft: vne,
  input: bne,
  withLeftIcon: yne
}, _ne = (e) => {
  const {
    className: t,
    inputClassName: n,
    onChange: r,
    onClicked: o,
    onBlur: i = () => {
    },
    placeholder: a,
    search: s,
    dataTestId: c,
    defaultValue: l,
    value: d,
    autoFocus: f,
    clearable: p,
    password: m,
    disabled: v = !1,
    size: g,
    icon: b,
    trimInput: x,
    ariaLabel: T = "input"
  } = e, [S, _] = Ge(l || d || ""), [w, k] = Ge(!1), E = it(null), { name: R = "", placement: P } = b || {};
  return mt(() => {
    _(d || "");
  }, [d]), /* @__PURE__ */ _e("div", { className: Xe(Fr.component, t), children: [
    s && /* @__PURE__ */ z(
      jr,
      {
        className: Xe(Fr.searchIcon, {
          [Fr.large]: g === "large"
        }),
        name: "general-search-small"
      }
    ),
    /* @__PURE__ */ z(
      "input",
      {
        className: Xe(Fr.input, n, {
          [Fr.withLeftIcon]: s || b && P === "left",
          [Fr.large]: g === "large"
        }),
        placeholder: a,
        disabled: v,
        onChange: (A) => {
          r(x ? A.target.value.trim() : A.target.value), _(A.target.value);
        },
        onClick: o,
        onBlur: i,
        "data-testid": c,
        defaultValue: l,
        value: d != null ? d : S,
        autoFocus: f,
        type: m && !w ? "password" : "text",
        ref: E,
        "aria-label": T
      }
    ),
    p && !m && !b && /* @__PURE__ */ z(
      jr,
      {
        className: Xe(Fr.clearIcon, {
          [Fr.clearIconHidden]: S === "",
          [Fr.large]: g === "large"
        }),
        name: "general-x",
        onClick: () => {
          _(""), r("");
        },
        onMouseDown: (A) => A.preventDefault()
      }
    ),
    m && /* @__PURE__ */ z(
      jr,
      {
        className: Xe(Fr.passwordVisibilityIcon, {
          [Fr.large]: g === "large"
        }),
        name: w ? "general-unhide" : "general-show",
        onClick: () => {
          k(!w);
        },
        onMouseDown: (A) => A.preventDefault()
      }
    ),
    b && !p && !m && /* @__PURE__ */ z(
      jr,
      {
        className: Xe(Fr.customIcon, {
          [Fr.large]: g === "large",
          [Fr.isLeft]: P === "left"
        }),
        name: R
      }
    )
  ] });
}, wne = 136, xne = "_searchInputWrapper_otzmq_1", Cne = {
  searchInputWrapper: xne
}, FE = () => {
}, Sne = nl(
  ({
    width: e = wne,
    onClick: t = FE,
    inputProps: n = { onChange: FE },
    className: r = ""
  }, o) => {
    const i = Xe(r || Cne.searchInputWrapper);
    return /* @__PURE__ */ z(
      "div",
      {
        ref: o,
        style: { width: e },
        className: i,
        "data-testid": "search_input_container",
        children: /* @__PURE__ */ z(_ne, pe({ onClicked: t }, n))
      }
    );
  }
), Tne = "#2c3342", Ene = "#f4f4f8", kne = "#dee1e7", Mne = "#fff", Rne = "_dropdownButton_xulrt_21", Pne = "_inlineVariant_xulrt_30", One = "_open_xulrt_37", Nne = "_disabled_xulrt_43", Ane = "_selectedIcon_xulrt_48", Dne = "_chosenTitle_xulrt_51", Ine = "_clickIcon_xulrt_58", Bs = {
  loginDarkColor: Tne,
  darkBtnHoverColor: Ene,
  greyHoverColor: kne,
  defaultBackgroundColor: Mne,
  dropdownButton: Rne,
  inlineVariant: Pne,
  open: One,
  disabled: Nne,
  selectedIcon: Ane,
  chosenTitle: Dne,
  clickIcon: Ine
}, Lne = ({
  selectedItem: e,
  width: t,
  dropDownButtonClasses: n,
  selectedShowIcon: r = !0,
  placeholder: o = ""
}) => {
  const { caption: i, iconName: a } = e || {};
  return /* @__PURE__ */ _e("div", { className: n, title: i, style: t ? { width: t, minWidth: "inherit" } : {}, children: [
    r && a && /* @__PURE__ */ z(jr, { className: Bs.selectedIcon, name: a }),
    /* @__PURE__ */ z("div", { className: Bs.chosenTitle, children: i || o }),
    /* @__PURE__ */ z("div", { className: Bs.clickIcon, children: /* @__PURE__ */ z(jr, { name: "general-arrow-down" }) })
  ] });
}, $ne = (e, t, n, r) => {
  const [o, i] = Ge($e(pe({}, n), {
    value: t == null ? void 0 : t.caption
  })), a = (l) => {
    l.stopPropagation();
  }, s = (l) => {
    n == null || n.onChange(l), i($e(pe({}, n), { value: l }));
  }, c = () => {
    var l;
    const d = (l = r == null ? void 0 : r.current) == null ? void 0 : l.getElementsByTagName("input")[0];
    d == null || d.select();
  };
  return mt(() => {
    e ? (i($e(pe({}, n), { value: t == null ? void 0 : t.caption })), c()) : n == null || n.onChange("");
  }, [e]), mt(() => {
    e && o.value !== (n == null ? void 0 : n.value) && c();
  }, [o.value]), { handlers: {
    handleOnSearchInputClick: a,
    handleOnSearchInputChange: s
  }, inputProps: o };
}, Fne = ({
  items: e = [],
  selectedShowIcon: t = !0,
  placeholder: n = "",
  disabled: r,
  selectedItemId: o,
  width: i,
  inlineVariant: a,
  classNameDropdown: s,
  classNameButton: c,
  classNameSearch: l,
  searchInputProps: d,
  isOpen: f = !1
}) => {
  const p = e.find((T) => T.id === o), m = it(null), {
    inputProps: v,
    handlers: { handleOnSearchInputClick: g, handleOnSearchInputChange: b }
  } = $ne(f, p, d, m), x = Xe(
    c,
    Bs.dropdownButton,
    {
      [Bs.disabled]: r,
      [Bs.open]: f,
      [Bs.inlineVariant]: a
    },
    s
  );
  return /* @__PURE__ */ z(fo, { children: d && f && !r ? /* @__PURE__ */ z(
    Sne,
    {
      ref: m,
      width: i,
      onClick: g,
      inputProps: $e(pe({}, v), { onChange: b }),
      className: l
    }
  ) : /* @__PURE__ */ z(
    Lne,
    {
      selectedItem: p,
      width: i,
      placeholder: n,
      selectedShowIcon: t,
      dropDownButtonClasses: x
    }
  ) });
}, zne = (e, t, n) => {
  const [r, o] = Ge(t), i = () => {
    n || o(!r);
  };
  return { handlers: {
    handleOnSelectItem: (a) => {
      e(a), i();
    },
    handleDropdownClick: i
  }, isOpen: r };
}, Bne = "_menu_1lxhu_1", Hne = {
  menu: Bne
}, jne = () => {
}, Wne = nl(
  ({
    bubblePopoverMouseEvents: e = !1,
    items: t = [],
    onSelectItem: n = jne,
    popoverOverlayLevel: r = 0,
    selectedShowIcon: o = !0,
    mask: i = !0,
    placeholder: a = "",
    placement: s = "bottomLeft",
    disabled: c = !1,
    selectedItemId: l,
    width: d,
    scrollbarProps: f,
    classNameMenu: p,
    inlineVariant: m,
    classNameDropdown: v,
    classNameButton: g,
    classNameSearch: b,
    classNameTooltip: x,
    zIndex: T,
    searchInputProps: S,
    open: _ = !1,
    isLoading: w = !1
  }, k) => {
    const E = m ? 12 : 0, R = t.map((N) => ({
      id: N.id,
      caption: N.caption || N.id,
      type: td.ITEM,
      iconName: N.iconName,
      iconClass: N.iconClass,
      selected: N.id === l,
      tooltip: N.tooltip,
      disabled: N.disabled
    })), {
      isOpen: P,
      handlers: { handleOnSelectItem: A, handleDropdownClick: D }
    } = zne(n, _, c);
    return /* @__PURE__ */ z("div", { ref: k, "data-testid": "popover_container", children: /* @__PURE__ */ z(
      bd,
      {
        zIndex: T,
        bubbleMouseEvents: e,
        trigger: ["click"],
        visible: P,
        placement: s,
        overlay: () => {
          const N = Xe(
            Hne.menu,
            // SLF.BACK,
            // SLF.TEXT_PRIMARY,
            Xa.SISENSE_NAMESPACE,
            p
          );
          return /* @__PURE__ */ z(
            ED,
            {
              items: R,
              onItemSelected: A,
              className: N,
              width: d,
              scrollbarProps: f,
              isLoading: w,
              classNameTooltip: x
            }
          );
        },
        level: r,
        onVisibleChange: D,
        onRequestClose: D,
        align: { offset: [0, E] },
        mask: i,
        children: /* @__PURE__ */ z("div", { children: /* @__PURE__ */ z(
          Fne,
          {
            isOpen: P,
            items: t,
            selectedShowIcon: o,
            placeholder: a,
            width: d,
            disabled: c,
            classNameButton: g,
            classNameDropdown: v,
            classNameSearch: b,
            inlineVariant: m,
            searchInputProps: S,
            selectedItemId: l
          }
        ) })
      }
    ) });
  }
), Vne = (e) => {
  const { direction: t, items: n, onChange: r } = e;
  return /* @__PURE__ */ z(
    Wne,
    {
      classNameDropdown: "direction-selector",
      classNameMenu: "sis-scope direction-selector__menu",
      items: n,
      selectedItemId: t,
      onSelectItem: (o) => {
        r(o.id);
      },
      mask: !1,
      scrollbarProps: {
        // Custom style to remove bottom padding below the last item
        style: {
          marginBottom: "-8px"
        }
      }
    }
  );
};
function Une(e) {
  return Gt("PrivateSwitchBase", e);
}
Wt("PrivateSwitchBase", ["root", "checked", "disabled", "input", "edgeStart", "edgeEnd"]);
const qne = ["autoFocus", "checked", "checkedIcon", "className", "defaultChecked", "disabled", "disableFocusRipple", "edge", "icon", "id", "inputProps", "inputRef", "name", "onBlur", "onChange", "onFocus", "readOnly", "required", "tabIndex", "type", "value"], Gne = (e) => {
  const {
    classes: t,
    checked: n,
    disabled: r,
    edge: o
  } = e, i = {
    root: ["root", n && "checked", r && "disabled", o && `edge${at(o)}`],
    input: ["input"]
  };
  return Yt(i, Une, t);
}, Yne = Fe(ag)(({
  ownerState: e
}) => re({
  padding: 9,
  borderRadius: "50%"
}, e.edge === "start" && {
  marginLeft: e.size === "small" ? -3 : -12
}, e.edge === "end" && {
  marginRight: e.size === "small" ? -3 : -12
})), Zne = Fe("input", {
  shouldForwardProp: Xo
})({
  cursor: "inherit",
  position: "absolute",
  opacity: 0,
  width: "100%",
  height: "100%",
  top: 0,
  left: 0,
  margin: 0,
  padding: 0,
  zIndex: 1
}), kD = /* @__PURE__ */ B.forwardRef(function(e, t) {
  const {
    autoFocus: n,
    checked: r,
    checkedIcon: o,
    className: i,
    defaultChecked: a,
    disabled: s,
    disableFocusRipple: c = !1,
    edge: l = !1,
    icon: d,
    id: f,
    inputProps: p,
    inputRef: m,
    name: v,
    onBlur: g,
    onChange: b,
    onFocus: x,
    readOnly: T,
    required: S = !1,
    tabIndex: _,
    type: w,
    value: k
  } = e, E = He(e, qne), [R, P] = Dd({
    controlled: r,
    default: !!a,
    name: "SwitchBase",
    state: "checked"
  }), A = Jm(), D = (G) => {
    x && x(G), A && A.onFocus && A.onFocus(G);
  }, N = (G) => {
    g && g(G), A && A.onBlur && A.onBlur(G);
  }, F = (G) => {
    if (G.nativeEvent.defaultPrevented)
      return;
    const V = G.target.checked;
    P(V), b && b(G, V);
  };
  let $ = s;
  A && typeof $ == "undefined" && ($ = A.disabled);
  const I = w === "checkbox" || w === "radio", j = re({}, e, {
    checked: R,
    disabled: $,
    disableFocusRipple: c,
    edge: l
  }), U = Gne(j);
  return /* @__PURE__ */ _e(Yne, re({
    component: "span",
    className: Qe(U.root, i),
    centerRipple: !0,
    focusRipple: !c,
    disabled: $,
    tabIndex: null,
    role: void 0,
    onFocus: D,
    onBlur: N,
    ownerState: j,
    ref: t
  }, E, {
    children: [/* @__PURE__ */ z(Zne, re({
      autoFocus: n,
      checked: r,
      defaultChecked: a,
      className: U.input,
      disabled: $,
      id: I ? f : void 0,
      name: v,
      onChange: F,
      readOnly: T,
      ref: m,
      required: S,
      ownerState: j,
      tabIndex: _,
      type: w
    }, w === "checkbox" && k === void 0 ? {} : {
      value: k
    }, p)), R ? o : d]
  }));
});
process.env.NODE_ENV !== "production" && (kD.propTypes = {
  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: y.bool,
  /**
   * If `true`, the component is checked.
   */
  checked: y.bool,
  /**
   * The icon to display when the component is checked.
   */
  checkedIcon: y.node.isRequired,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: y.object,
  /**
   * @ignore
   */
  className: y.string,
  /**
   * @ignore
   */
  defaultChecked: y.bool,
  /**
   * If `true`, the component is disabled.
   */
  disabled: y.bool,
  /**
   * If `true`, the  keyboard focus ripple is disabled.
   * @default false
   */
  disableFocusRipple: y.bool,
  /**
   * If given, uses a negative margin to counteract the padding on one
   * side (this is often helpful for aligning the left or right
   * side of the icon with content above or below, without ruining the border
   * size and shape).
   * @default false
   */
  edge: y.oneOf(["end", "start", !1]),
  /**
   * The icon to display when the component is unchecked.
   */
  icon: y.node.isRequired,
  /**
   * The id of the `input` element.
   */
  id: y.string,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: y.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: Yo,
  /*
   * @ignore
   */
  name: y.string,
  /**
   * @ignore
   */
  onBlur: y.func,
  /**
   * Callback fired when the state is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */
  onChange: y.func,
  /**
   * @ignore
   */
  onFocus: y.func,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: y.bool,
  /**
   * If `true`, the `input` element is required.
   */
  required: y.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: y.object,
  /**
   * @ignore
   */
  tabIndex: y.oneOfType([y.number, y.string]),
  /**
   * The input component prop `type`.
   */
  type: y.string.isRequired,
  /**
   * The value of the component.
   */
  value: y.any
});
const Xne = kD, Kne = Vi(/* @__PURE__ */ z("path", {
  d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
}), "CheckBoxOutlineBlank"), Jne = Vi(/* @__PURE__ */ z("path", {
  d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
}), "CheckBox"), Qne = Vi(/* @__PURE__ */ z("path", {
  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z"
}), "IndeterminateCheckBox");
function ere(e) {
  return Gt("MuiCheckbox", e);
}
const tre = Wt("MuiCheckbox", ["root", "checked", "disabled", "indeterminate", "colorPrimary", "colorSecondary", "sizeSmall", "sizeMedium"]), c0 = tre, nre = ["checkedIcon", "color", "icon", "indeterminate", "indeterminateIcon", "inputProps", "size", "className"], rre = (e) => {
  const {
    classes: t,
    indeterminate: n,
    color: r,
    size: o
  } = e, i = {
    root: ["root", n && "indeterminate", `color${at(r)}`, `size${at(o)}`]
  }, a = Yt(i, ere, t);
  return re({}, t, a);
}, ore = Fe(Xne, {
  shouldForwardProp: (e) => Xo(e) || e === "classes",
  name: "MuiCheckbox",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.indeterminate && t.indeterminate, t[`size${at(n.size)}`], n.color !== "default" && t[`color${at(n.color)}`]];
  }
})(({
  theme: e,
  ownerState: t
}) => re({
  color: (e.vars || e).palette.text.secondary
}, !t.disableRipple && {
  "&:hover": {
    backgroundColor: e.vars ? `rgba(${t.color === "default" ? e.vars.palette.action.activeChannel : e.vars.palette[t.color].mainChannel} / ${e.vars.palette.action.hoverOpacity})` : tn.alpha(t.color === "default" ? e.palette.action.active : e.palette[t.color].main, e.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: "transparent"
    }
  }
}, t.color !== "default" && {
  [`&.${c0.checked}, &.${c0.indeterminate}`]: {
    color: (e.vars || e).palette[t.color].main
  },
  [`&.${c0.disabled}`]: {
    color: (e.vars || e).palette.action.disabled
  }
})), ire = /* @__PURE__ */ z(Jne, {}), are = /* @__PURE__ */ z(Kne, {}), sre = /* @__PURE__ */ z(Qne, {}), MD = /* @__PURE__ */ B.forwardRef(function(e, t) {
  var n, r;
  const o = rn({
    props: e,
    name: "MuiCheckbox"
  }), {
    checkedIcon: i = ire,
    color: a = "primary",
    icon: s = are,
    indeterminate: c = !1,
    indeterminateIcon: l = sre,
    inputProps: d,
    size: f = "medium",
    className: p
  } = o, m = He(o, nre), v = c ? l : s, g = c ? l : i, b = re({}, o, {
    color: a,
    indeterminate: c,
    size: f
  }), x = rre(b);
  return /* @__PURE__ */ z(ore, re({
    type: "checkbox",
    inputProps: re({
      "data-indeterminate": c
    }, d),
    icon: /* @__PURE__ */ B.cloneElement(v, {
      fontSize: (n = v.props.fontSize) != null ? n : f
    }),
    checkedIcon: /* @__PURE__ */ B.cloneElement(g, {
      fontSize: (r = g.props.fontSize) != null ? r : f
    }),
    ownerState: b,
    ref: t,
    className: Qe(x.root, p)
  }, m, {
    classes: x
  }));
});
process.env.NODE_ENV !== "production" && (MD.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, the component is checked.
   */
  checked: y.bool,
  /**
   * The icon to display when the component is checked.
   * @default <CheckBoxIcon />
   */
  checkedIcon: y.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: y.object,
  /**
   * @ignore
   */
  className: y.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: y.oneOfType([y.oneOf(["default", "primary", "secondary", "error", "info", "success", "warning"]), y.string]),
  /**
   * The default checked state. Use when the component is not controlled.
   */
  defaultChecked: y.bool,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: y.bool,
  /**
   * If `true`, the ripple effect is disabled.
   * @default false
   */
  disableRipple: y.bool,
  /**
   * The icon to display when the component is unchecked.
   * @default <CheckBoxOutlineBlankIcon />
   */
  icon: y.node,
  /**
   * The id of the `input` element.
   */
  id: y.string,
  /**
   * If `true`, the component appears indeterminate.
   * This does not set the native input element to indeterminate due
   * to inconsistent behavior across browsers.
   * However, we set a `data-indeterminate` attribute on the `input`.
   * @default false
   */
  indeterminate: y.bool,
  /**
   * The icon to display when the component is indeterminate.
   * @default <IndeterminateCheckBoxIcon />
   */
  indeterminateIcon: y.node,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: y.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: Yo,
  /**
   * Callback fired when the state is changed.
   *
   * @param {React.ChangeEvent<HTMLInputElement>} event The event source of the callback.
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */
  onChange: y.func,
  /**
   * If `true`, the `input` element is required.
   * @default false
   */
  required: y.bool,
  /**
   * The size of the component.
   * `small` is equivalent to the dense checkbox styling.
   * @default 'medium'
   */
  size: y.oneOfType([y.oneOf(["medium", "small"]), y.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: y.oneOfType([y.arrayOf(y.oneOfType([y.func, y.object, y.bool])), y.func, y.object]),
  /**
   * The value of the component. The DOM API casts this to a string.
   * The browser uses "on" as the default value.
   */
  value: y.any
});
const lre = MD, cre = hs({
  components: {
    MuiCheckbox: {
      styleOverrides: {
        root: {
          width: "28px",
          height: "28px",
          "&.Mui-disabled": {
            opacity: 0.5
          },
          "&:hover": {
            backgroundColor: _t.StInteractionColors.defaultHover
          },
          "& .MuiSvgIcon-root": {
            fontSize: 14,
            fill: _t.StUiColors.default
          }
        }
      }
    }
  }
}), ure = nl(
  (e, t) => {
    var n = e, { theme: r = cre, dataTestId: o } = n, i = Wn(n, ["theme", "dataTestId"]);
    return /* @__PURE__ */ z(ll, { theme: r, children: /* @__PURE__ */ z(lre, pe({ "data-testid": o, ref: t }, i)) });
  }
), dre = (e) => {
  const { title: t, fieldTypes: n, selected: r, onSettingsItemStateChange: o, subtotalsCaption: i } = e, [a, s] = Ge(r), c = e.direction || En.ASC, l = () => {
    s(!a), o({
      title: t,
      selected: !a,
      direction: c
    });
  }, d = a === !1 ? null : /* @__PURE__ */ z(
    Vne,
    {
      direction: c,
      items: n,
      onChange: (_) => {
        o({
          title: t,
          selected: a,
          direction: _
        });
      }
    }
  ), f = it(null), p = it(null), [m, v] = Ge(!1), g = () => {
    const _ = f.current, w = p.current;
    _ === null || w === null || _.offsetWidth < w.offsetWidth && v(!0);
  }, b = () => {
    const _ = f.current, w = p.current;
    _ === null || w === null || _.offsetWidth < w.offsetWidth && v(!1);
  }, x = () => {
    s(!a), o({
      title: t,
      selected: !a,
      direction: c
    });
  }, [T, S] = Ge(!1);
  return /* @__PURE__ */ _e("div", { className: "settings-item", children: [
    /* @__PURE__ */ _e("div", { className: "checkbox-input", children: [
      /* @__PURE__ */ z(
        ure,
        {
          checked: a,
          onChange: l
        }
      ),
      /* @__PURE__ */ _e(
        "div",
        {
          className: "checkbox-input__label",
          tabIndex: 0,
          role: "button",
          "aria-pressed": "false",
          onClick: x,
          onKeyUp: x,
          onMouseEnter: () => S(!0),
          onMouseLeave: () => S(!1),
          children: [
            /* @__PURE__ */ z(xD, { placement: "top", title: t, children: /* @__PURE__ */ z(
              "div",
              {
                ref: f,
                className: "checkbox-input__text-wrapper",
                onMouseEnter: g,
                onMouseLeave: b,
                children: /* @__PURE__ */ z("span", { ref: p, children: t })
              }
            ) }),
            i
          ]
        }
      )
    ] }),
    d
  ] }, t);
};
function RD(e) {
  const t = {
    [En.ASC]: {
      [oa.TEXT]: e.ascAZ,
      [oa.NUMERIC]: e.asc19,
      [oa.DATETIME]: e.asc19
    },
    [En.DESC]: {
      [oa.TEXT]: e.descZA,
      [oa.NUMERIC]: e.desc91,
      [oa.DATETIME]: e.desc91
    }
  };
  return function(n, r) {
    return t[r][n];
  };
}
const vr = (e) => e.getBoundingClientRect(), zE = (e, t) => ({
  get collidedTop() {
    return vr(e).top < vr(t).top;
  },
  get collidedBottom() {
    return vr(e).bottom > vr(t).bottom;
  },
  get collidedLeft() {
    return vr(e).left < vr(t).left;
  },
  get collidedRight() {
    return vr(e).right > vr(t).right;
  },
  get overflowTop() {
    return vr(t).top - vr(e).top;
  },
  get overflowBottom() {
    return vr(e).bottom - vr(t).bottom;
  },
  get overflowLeft() {
    return vr(t).left - vr(e).left;
  },
  get overflowRight() {
    return vr(e).right - vr(t).right;
  }
}), fre = "_sharedComponentsButton_t1p0l_31", pre = "_sharedComponentsButtonText_t1p0l_34", hre = "_btnSecondary_t1p0l_37", u0 = {
  sharedComponentsButton: fre,
  sharedComponentsButtonText: pre,
  btnSecondary: hre
}, mre = " ", Vh = (e) => {
  const t = e, {
    allowDisabledTitle: n,
    className: r,
    disabled: o,
    hoverSuffix: i,
    iconClassName: a,
    iconName: s,
    transparent: c,
    text: l,
    trailingIconName: d,
    title: f,
    dark: p,
    gray: m,
    secondary: v,
    dataTestId: g,
    ariaLabel: b = "button"
  } = t, x = Wn(t, [
    "allowDisabledTitle",
    "className",
    "disabled",
    "hoverSuffix",
    "iconClassName",
    "iconName",
    "transparent",
    "text",
    "trailingIconName",
    "title",
    "dark",
    "gray",
    "secondary",
    "dataTestId",
    "ariaLabel"
  ]), T = Xe(
    "btn",
    {
      "btn--disabled": o,
      "btn--transp": c,
      "btn--dark": p,
      "btn--icon": !l,
      "btn--gray": m,
      [u0.btnSecondary]: v
    },
    u0.sharedComponentsButton,
    r
  ), S = Xe("btn__icon", a), _ = s && /* @__PURE__ */ z(
    jr,
    {
      className: S,
      name: s,
      disabled: o,
      hoverSuffix: i
    }
  ), w = Xe("btn__text", u0.sharedComponentsButtonText), k = l && /* @__PURE__ */ z("span", { className: w, children: l }), E = _ && k && mre, R = d && /* @__PURE__ */ z(
    jr,
    {
      className: S,
      name: d,
      disabled: o,
      hoverSuffix: i
    }
  ), P = pe({
    disabled: o,
    title: f && (!o || n) ? f : void 0
  }, x);
  return /* @__PURE__ */ _e("button", $e(pe({}, P), { className: T, "data-testid": g, "aria-label": b, children: [
    _,
    E,
    k,
    R
  ] }));
};
Vh.propTypes = {
  allowDisabledTitle: y.bool,
  className: y.string,
  disabled: y.bool,
  hoverSuffix: y.string,
  iconClassName: y.string,
  iconName: y.string,
  onClick: y.func.isRequired,
  text: y.string,
  title: y.string,
  trailingIconName: y.string,
  transparent: y.bool,
  dark: y.bool,
  gray: y.bool
};
Vh.defaultProps = {
  allowDisabledTitle: !1
};
const gre = (e) => {
  const {
    titleOfPopUp: t,
    currentSortingSettings: n,
    onSortingSettingsUpdate: r,
    onCrossIconClick: o,
    messages: i
  } = e, a = RD(i), [s, c] = Ge(n), l = () => r(s), d = () => {
    const S = Hy(s, (_) => {
      _.forEach((w) => {
        w.direction = null, w.selected = !1;
      });
    });
    r(S);
  }, f = (S) => {
    const _ = Hy(s, (w) => {
      const k = w.findIndex(({ title: E }) => S.title === E);
      k !== -1 && (w[k].selected = S.selected, w[k].direction = S.direction, S.selected || (w[k].direction = null));
    });
    c(_);
  }, p = s.map((S, _) => {
    const { datatype: w, selected: k, direction: E } = S, { title: R } = S, P = _ === s.length - 1 ? null : /* @__PURE__ */ z("span", { className: "subtotals-caption", children: i.subtotals }), A = [
      {
        caption: a(w, En.ASC),
        id: En.ASC
      },
      {
        caption: a(w, En.DESC),
        id: En.DESC
      }
    ];
    return /* @__PURE__ */ z(
      dre,
      {
        title: R,
        fieldTypes: A,
        selected: k,
        direction: E,
        onSettingsItemStateChange: f,
        subtotalsCaption: P
      },
      R
    );
  }), m = n.some((S) => S.selected) ? /* @__PURE__ */ z(Vh, { text: i.clearSorting, gray: !0, onClick: d }) : null, v = it(null), g = it(null), b = it(null), [x, T] = Ge({});
  return Lc(
    () => {
      const S = v.current;
      if (S === null)
        return;
      const _ = g.current;
      if (_ === null)
        return;
      const w = b.current;
      if (w === null)
        return;
      const k = zE(_, S), E = zE(w, S);
      E.collidedBottom || k.collidedTop || E.collidedTop || k.collidedBottom ? T({
        borderTop: "1px #E7E8EA solid",
        paddingTop: "16px"
      }) : T({});
    },
    s.map(({ selected: S }) => S)
  ), /* @__PURE__ */ z("div", { className: "sis-scope", children: /* @__PURE__ */ _e("div", { className: "complex-sorting-settings", children: [
    /* @__PURE__ */ z(
      CD,
      {
        className: "sorting-settings-header",
        prependedText: i.sortBy,
        hierarchy: t,
        onCrossIconClick: o
      }
    ),
    /* @__PURE__ */ _e("div", { ref: v, className: "complex-sorting-settings__body", children: [
      /* @__PURE__ */ z("span", { ref: g, style: { fontWeight: 600 }, children: i.selectToSort }),
      /* @__PURE__ */ z("ul", { ref: b, className: "settings-checkboxes", children: p })
    ] }),
    /* @__PURE__ */ z("div", { className: "complex-sorting-settings__actions", style: x, children: /* @__PURE__ */ _e("div", { className: "sp-buttons", children: [
      /* @__PURE__ */ z(Vh, { onClick: l, text: i.apply }),
      m
    ] }) })
  ] }) });
}, vre = "_item_fvqjc_1", bre = "_icon_fvqjc_10", d0 = {
  item: vre,
  icon: bre
}, yre = ({ items: e, className: t, onChange: n }) => /* @__PURE__ */ z("div", { className: t, children: e.map((r) => /* @__PURE__ */ _e(
  "div",
  {
    className: d0.item,
    onClick: () => n(r.value),
    "data-testid": r.dataTestId,
    children: [
      /* @__PURE__ */ z("span", { className: d0.name, children: r.name }),
      r.checked && /* @__PURE__ */ z(jr, { className: d0.icon, name: "general-vi-small-white" })
    ]
  },
  r.value
)) }), _re = (e) => {
  const {
    titleOfPopUp: t,
    currentSortingSettings: n,
    onSortingSettingsUpdate: r,
    messages: o
  } = e, i = RD(o), { datatype: a, direction: s } = n, c = (l) => {
    const d = Hy(n, (f) => {
      f.selected = !0, f.direction = l;
    });
    r(d);
  };
  return /* @__PURE__ */ z("div", { className: "sis-scope", children: /* @__PURE__ */ _e("div", { className: "simple-sorting-settings", children: [
    /* @__PURE__ */ z(
      CD,
      {
        className: "sorting-settings-header",
        prependedText: `${o.sort} - `,
        hierarchy: t
      }
    ),
    /* @__PURE__ */ z("div", { className: "simple-sorting-settings__actions", children: /* @__PURE__ */ z(
      yre,
      {
        styles: {
          margin: "16px"
        },
        onChange: c,
        items: [
          {
            name: `${o.sort} ${i(a, En.ASC)}`,
            value: En.ASC,
            checked: s === En.ASC,
            dataTestId: "sort-ascending"
          },
          {
            name: `${o.sort} ${i(a, En.DESC)}`,
            value: En.DESC,
            checked: s === En.DESC,
            dataTestId: "sort-descending"
          }
        ]
      }
    ) })
  ] }) });
};
function wre(e) {
  let t = e;
  const n = [];
  for (; t.content && typeof t.content != typeof B.Component ? n.push(t.content) : n.push(t.value), t.parent; )
    t = t.parent;
  return n.reverse();
}
const BE = "queryStart", HE = "queryEnd", xre = "loadingStart", Cre = "loadingFinish", Sre = "sortUpdate", jE = "sortingSettingsChanged", Tre = "pageChange", Ere = "emptyChange", kre = "totalHeightChange", Mre = "domReady", Rre = "firstPageRendered", Pre = "totalWidgetRendered", vp = 0, WE = {
  isFirstPageRendered: !1,
  isGrandTotalRowRendered: !1,
  isTotalRowsCountRendered: !1,
  isReceivedRowsCountCalculated: !1
};
class Ore {
  /**
   * @param {DataServiceI} dataService - data service instance
   * @param {object} [defaultProps] - default options
   * @param {EventEmitter} [events] - EventEmitter instance
   */
  constructor(t, n, r = new uf()) {
    Z(this, "events"), Z(this, "domElem"), Z(this, "pivot"), Z(this, "dataService"), Z(this, "currentRowsTreeService"), Z(this, "isLoadPageInProgress", !1), Z(this, "isFirstPageRenderInProgress", !1), Z(this, "onDataChunkReceivedThrottle"), Z(this, "loadedItemsCount"), Z(this, "totalItemsCount", 0), Z(this, "totalRecordsCount", 0), Z(this, "totalColumnsCount", 0), Z(this, "columnsCount", 0), Z(this, "limitReached", !1), Z(this, "appearanceState", pe({}, WE)), Z(this, "props"), Z(this, "rootDom"), Z(this, "onDataChunkReceived", (o) => {
      this.onDataChunkReceivedThrottle(o);
    }), Z(this, "onGrandChunkReceived", (o) => {
      const { isPaginated: i } = this.props;
      i && this.currentRowsTreeService && !this.currentRowsTreeService.hasGrandTotals && (this.currentRowsTreeService.extend(o), this.currentRowsTreeService.hasGrandTotals = !0, this.pivot && this.pivot.addMore(this.currentRowsTreeService, !0)), this.setAppearanceState({ isGrandTotalRowRendered: !0 });
    }), Z(this, "onTotalRowsChunkReceived", (o) => {
      const { rowsCount: i, queryRowsCount: a, limitReached: s = !1 } = o;
      this.updateProps({
        totalItemsCount: i,
        totalRecordsCount: a,
        limitReached: s
      }), this.setAppearanceState({ isTotalRowsCountRendered: !0 });
    }), Z(this, "onTotalColumnsChunkReceived", (o) => {
      const { columnsCount: i, totalColumnsCount: a } = o;
      this.columnsCount = i, this.totalColumnsCount = a, this.updateProps({ columnsCount: i, totalColumnsCount: a });
    }), Z(this, "onProgressError", (o) => {
      this.emit(Wp, o);
    }), Z(this, "onSortingMetadataUpdate", (o) => {
      const i = this.dataService ? this.dataService.isSingleRowTree() : !1;
      this.emit(Sre, o, { isSingleRowTree: i });
    }), Z(this, "handleSortingSettingsChanged", (o, i, a) => {
      if (!o || o.dir === void 0)
        return;
      const s = i && i.valueNode ? hr(i.valueNode) : void 0, c = {
        measurePath: o.measurePath,
        dir: o.dir || fw(o),
        field: s ? s.jaqlIndex : o.jaqlIndex
      }, l = o.metadataType === "rows" && o.jaqlIndex === c.field, d = this.dataService ? this.dataService.isSingleRowTree() : !1, f = l || d, p = wre(o);
      f ? this.showSimpleSortingPopup(c, a, d, p) : this.showComplexSortingPopup(c, a, d, p);
    }), Z(this, "onMoreLoadingFinish", () => {
      this.hideLoading();
    }), Z(this, "onPageChange", (o) => {
      this.emit(Tre), this.loadPageData(o.selected);
    }), Z(this, "onItemsPerPageChange", (o) => {
      this.updateProps({
        activePage: vp,
        itemsPerPage: o
      });
    }), Z(this, "onEmptyChange", (o) => {
      this.emit(Ere, o);
    }), Z(this, "onTotalHeightChange", (o) => {
      this.emit(kre, o);
    }), Z(this, "onDomReady", () => {
      this.emit(Mre);
    }), Z(this, "onGridUpdated", () => {
      this.isFirstPageRenderInProgress && (this.isFirstPageRenderInProgress = !1, this.setAppearanceState({ isFirstPageRendered: !0 })), this.hideLoading();
    }), this.events = r, t && (this.registerDataServiceListeners(t), this.dataService = t), this.props = pe({
      className: "",
      width: 800,
      height: 400,
      isPaginated: !0,
      isAutoHeight: !1,
      itemsCount: 0,
      loadedItemsCount: 0,
      totalItemsCount: 0,
      totalRecordsCount: 0,
      limitReached: !1,
      totalColumnsCount: 0,
      columnsCount: 0,
      itemsPerPage: 25,
      activePage: vp,
      isFullWidth: !1,
      isFixedEnabled: !0,
      isAllDataLoaded: !1,
      getSortingPopupMessages: () => ({
        // default captions
        clearSorting: "Clear sorting",
        selectToSort: "Select column (level) to sort:",
        sortBy: "Sort by",
        sort: "Sort",
        subtotals: "(Subtotals)",
        apply: "Apply",
        cancel: "Cancel",
        ascAZ: "Ascending (A-Z)",
        descZA: "Descending (Z-A)",
        asc19: "Ascending (1-9)",
        desc91: "Descending (9-1)"
      }),
      paginationOptions: void 0,
      onGetInitialData: () => {
      },
      onMoreLoadingFinish: this.onMoreLoadingFinish,
      onPageChange: this.onPageChange,
      onItemsPerPageChange: this.onItemsPerPageChange,
      onSortingSettingsChanged: this.handleSortingSettingsChanged,
      onSortingMetadataUpdate: this.onSortingMetadataUpdate,
      onEmptyChange: this.onEmptyChange,
      onTotalHeightChange: this.onTotalHeightChange,
      onGridUpdated: this.onGridUpdated,
      onDomReady: this.onDomReady
    }, n), this.onDataChunkReceivedThrottle = f3((o) => {
      const { activePage: i } = this.props;
      let a = o;
      this.loadedItemsCount && this.loadedItemsCount > o && (a = this.loadedItemsCount), this.updateProps({
        itemsCount: a,
        activePage: i > -1 ? i : 0
      });
    }, 500);
  }
  destroy() {
    if (this.onDataChunkReceivedThrottle.cancel(), this.dataService) {
      const t = this.dataService;
      this.destroyDataServiceListeners(t);
    }
    if (this.domElem)
      try {
        this.rootDom.unmount();
      } catch (t) {
        _r.unmountComponentAtNode(this.domElem);
      }
    this.currentRowsTreeService && (this.currentRowsTreeService.destroy(), this.currentRowsTreeService = void 0), this.pivot = void 0;
  }
  on(t, n) {
    this.events.on(t, n);
  }
  off(t, n) {
    this.events.removeListener(t, n);
  }
  emit(t, ...n) {
    const r = [t, ...n];
    this.events.emit(...r);
  }
  /**
   * Render Pivot component into DOM element
   *
   * @param {Element} domElem - DOM element to render
   * @param {object} newProps - Pivot 2 props
   * @returns {void}
   */
  render(t, n) {
    this.domElem = t;
    const r = $e(pe(pe({}, this.props), n), {
      // reference: https://stackoverflow.com/a/55823466/2425556
      ref: (i) => this.pivot = i
    }), o = B.createElement(by, r, null);
    try {
      this.rootDom || (this.rootDom = xB.createRoot(this.domElem)), this.rootDom.render(o);
    } catch (i) {
      _r.render(o, this.domElem);
    }
    this.props = r;
  }
  /**
   * Update data service instance
   *
   * @param {DataServiceI} dataService - new data service instance
   * @returns {void}
   */
  updateDataService(t) {
    if (this.dataService) {
      const n = this.dataService;
      this.destroyDataServiceListeners(n);
    }
    if (this.dataService = t, this.onDataChunkReceivedThrottle.cancel(), this.dataService) {
      const n = this.dataService;
      this.resetAppearanceState(), this.registerDataServiceListeners(n);
    }
  }
  /**
   * Registers data service events handlers
   *
   * @param {DataService} dataService - data service instance
   * @returns {void}
   */
  registerDataServiceListeners(t) {
    t.on(jb, this.onDataChunkReceived), t.on(Wb, this.onGrandChunkReceived), t.on(Vb, this.onTotalRowsChunkReceived), t.on(Ub, this.onTotalColumnsChunkReceived), t.on(Wp, this.onProgressError);
  }
  /**
   * Destroys data service events handlers
   *
   * @param {DataService} dataService - data service instance
   * @returns {void}
   */
  destroyDataServiceListeners(t) {
    t.off(jb, this.onDataChunkReceived), t.off(Wb, this.onGrandChunkReceived), t.off(Vb, this.onTotalRowsChunkReceived), t.off(Ub, this.onTotalColumnsChunkReceived), t.off(Wp, this.onProgressError);
  }
  /**
   * returns pivot's configuration
   *
   * @returns {Props} - current props with callbacks and configurations
   */
  getCurrentState() {
    return pe({}, this.props);
  }
  /**
   * Start JAQL loading
   *
   * @param {JaqlRequest} jaql - JAQL request to load
   * @returns {void}
   */
  updateJaql(t) {
    this.totalItemsCount = 0, this.totalColumnsCount = 0, this.totalRecordsCount = 0, this.columnsCount = 0, this.limitReached = !1, this.loadedItemsCount = void 0, this.updateProps({
      totalItemsCount: this.totalItemsCount,
      totalColumnsCount: this.totalColumnsCount,
      totalRecordsCount: this.totalRecordsCount,
      columnsCount: this.columnsCount,
      limitReached: this.limitReached
    }), this.loadInitData(t);
  }
  /**
   * Update component width/height
   *
   * @param {object} newProps - component changed properties
   * @returns {void}
   */
  updateProps(t) {
    if (!this.domElem)
      return;
    const n = $e(pe(pe({}, this.props), t), {
      // reference: https://stackoverflow.com/a/55823466/2425556
      ref: (i) => this.pivot = i
    }), r = p3(this.props, n);
    (typeof r.isPaginated != "undefined" || typeof r.itemsPerPage != "undefined") && (this.totalItemsCount = 0, this.totalRecordsCount = 0, this.loadedItemsCount = void 0, this.loadInitData(void 0, n));
    const o = B.createElement(by, n, null);
    try {
      this.rootDom.render(o);
    } catch (i) {
      _r.render(o, this.domElem);
    }
    this.props = n;
  }
  /**
   * Loading initial page
   *
   * @param {JaqlRequest} [jaql] - JAQL to load, or 'null' if use cached data
   * @param {Props} [props] - Pivot props
   * @returns {void}
   * @private
   */
  loadInitData(t, n = this.props) {
    var r, o;
    if (((o = (r = this.dataService) == null ? void 0 : r.getJaql()) == null ? void 0 : o.queryGuid) === (t == null ? void 0 : t.queryGuid))
      return;
    const { dataService: i } = this, { isPaginated: a, itemsPerPage: s } = n, c = a ? s : void 0;
    if (this.onDataChunkReceivedThrottle.cancel(), !i) {
      this.pivot && this.pivot.initialize(), this.currentRowsTreeService && (this.currentRowsTreeService.destroy(), this.currentRowsTreeService = void 0);
      return;
    }
    this.updateProps({
      itemsCount: 0,
      totalItemsCount: 0,
      totalColumnsCount: 0,
      totalRecordsCount: 0,
      columnsCount: 0,
      activePage: vp,
      isAllDataLoaded: !1,
      limitReached: !1
    }), this.currentRowsTreeService = void 0, this.isLoadPageInProgress = !1, this.isFirstPageRenderInProgress = !1, this.showLoading(), this.events.emit(BE), i.loadData(t, { pageSize: c, isPaginated: a }).then(
      ({ rowsTreeService: l, columnsTreeService: d, cornerTreeService: f, isLastPage: p, cellsMetadata: m }) => {
        this.events.emit(HE, { cellsMetadata: m }), this.loadedItemsCount !== null && this.updateProps({
          itemsCount: this.loadedItemsCount,
          totalItemsCount: this.totalItemsCount,
          totalRecordsCount: this.totalRecordsCount,
          limitReached: this.limitReached,
          activePage: vp,
          isAllDataLoaded: !0
        }), this.pivot && (this.isFirstPageRenderInProgress = !0, this.pivot.initialize(l, d, f, {
          isLastPage: p,
          cellsMetadata: m
        }), this.currentRowsTreeService = l);
      }
    ).catch((l) => {
      if (!(l instanceof Jl))
        throw l;
    }), i.loadAllData().then((l) => {
      this.totalItemsCount = l.totalItemsCount, this.loadedItemsCount = l.loadedRowsCount, this.totalRecordsCount = l.totalRecordsCount, this.limitReached = l.limitReached, l.columnsCount && l.totalColumnsCount && (this.columnsCount = l.columnsCount, this.totalColumnsCount = l.totalColumnsCount);
      const d = pe({ isAllDataLoaded: !0 }, l);
      this.updateProps(d), this.setAppearanceState({ isReceivedRowsCountCalculated: !0 });
    }).catch((l) => {
      if (!(l instanceof Jl))
        throw l;
    });
  }
  /**
   * Load appropriate page in case of paging
   *
   * @param {number} page - page to load
   * @returns {void}
   * @private
   */
  loadPageData(t) {
    if (this.isLoadPageInProgress || !this.props.isPaginated)
      return;
    const { dataService: n } = this;
    if (!n) {
      console.warn("DataService instance not defined");
      return;
    }
    this.isLoadPageInProgress = !0, this.showLoading(), this.events.emit(BE), n.getSelectedPageData(t, this.props.itemsPerPage).then((r) => {
      const {
        rowsTreeService: o,
        columnsTreeService: i,
        cornerTreeService: a,
        isLastPage: s,
        cellsMetadata: c
      } = r;
      this.events.emit(HE, r), this.isLoadPageInProgress = !1, this.pivot && (this.pivot.initialize(o, i, a, {
        isLastPage: s,
        cellsMetadata: c
      }), this.currentRowsTreeService = o), this.updateProps({
        activePage: t
      });
    });
  }
  /**
   * Show loading indication
   *
   * @returns {void}
   * @private
   */
  showLoading() {
    this.emit(xre);
  }
  /**
   * Hide loading indication
   *
   * @returns {void}
   * @private
   */
  hideLoading() {
    this.emit(Cre);
  }
  showSimpleSortingPopup(t, n, r, o) {
    const i = this.dataService && this.dataService.getJaql();
    if (!i)
      return;
    const a = kn.getMetadataPanels(i), s = kn.getDataTypes(a), c = kn.mapWidgetJaqlToSimpleSortingSettings(
      a,
      t,
      s
    );
    if (c === void 0)
      return;
    const l = (f) => {
      n.setSortingPopup(null), !Ib(c, f) && this.emit(jE, {
        type: "simple",
        settings: [f],
        sortDetails: t,
        isSingleRowTree: r
      });
    }, d = B.createElement(_re, {
      titleOfPopUp: o,
      currentSortingSettings: c,
      onSortingSettingsUpdate: l,
      messages: this.props.getSortingPopupMessages()
    });
    n.setSortingPopup(d);
  }
  showComplexSortingPopup(t, n, r, o) {
    const i = this.dataService && this.dataService.getJaql();
    if (!i)
      return;
    const a = kn.mapWidgetJaqlToComplexSortingSettings(
      i,
      t
    ), s = (l) => {
      n.setSortingPopup(null), !Ib(a, l) && this.emit(jE, {
        type: "complex",
        settings: l,
        sortDetails: t,
        isSingleRowTree: r
      });
    }, c = B.createElement(gre, {
      titleOfPopUp: o,
      currentSortingSettings: a,
      onSortingSettingsUpdate: s,
      onCrossIconClick: () => n.setSortingPopup(null),
      messages: this.props.getSortingPopupMessages()
    });
    n.setSortingPopup(c);
  }
  /**
   * Handles appearance state updating
   *
   * @param {AppearanceState} prevState - prev appearance state
   * @param {AppearanceState} nextState - next appearance state
   * @returns {void}
   */
  onAppearanceStateUpdated(t, n) {
    !t.isFirstPageRendered && n.isFirstPageRendered && this.emit(Rre), !this.isTotallyRendered(t) && this.isTotallyRendered(n) && this.emit(Pre);
  }
  /**
   * Setter for pivot builder appearance state
   *
   * @param {AppearanceState} appearanceState - appearance state properties to update
   * @returns {void}
   */
  setAppearanceState(t = {}) {
    const n = Object.freeze(pe({}, this.appearanceState)), r = Object.freeze(pe(pe({}, this.appearanceState), t));
    this.onAppearanceStateUpdated(n, r), this.appearanceState = r;
  }
  /**
   * Resets pivot builder appearance state
   *
   * @returns {void}
   */
  resetAppearanceState() {
    const t = Object.freeze(pe({}, this.appearanceState)), n = Object.freeze(pe({}, WE));
    this.onAppearanceStateUpdated(t, n), this.appearanceState = n;
  }
  /**
   * Checks if pivot widget totally rendered
   *
   * @param {AppearanceState} [state] - appearance state
   * @returns {boolean} - is totally rendered flag
   */
  isTotallyRendered(t = this.appearanceState) {
    const n = this.dataService && this.dataService.getJaql() || {
      grandTotals: { rows: void 0 }
    }, r = !!(n.grandTotals && n.grandTotals.rows);
    return t.isFirstPageRendered && t.isTotalRowsCountRendered && t.isReceivedRowsCountCalculated && (!r || t.isGrandTotalRowRendered);
  }
}
var Uh = {}, Nre = {
  get exports() {
    return Uh;
  },
  set exports(e) {
    Uh = e;
  }
}, f0, VE;
function PD() {
  if (VE)
    return f0;
  VE = 1;
  var e = /^(?:(?![^:@]+:[^:@\/]*@)(http|https|ws|wss):\/\/)?((?:(([^:@]*)(?::([^:@]*))?)?@)?((?:[a-f0-9]{0,4}:){2,7}[a-f0-9]{0,4}|[^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/, t = [
    "source",
    "protocol",
    "authority",
    "userInfo",
    "user",
    "password",
    "host",
    "port",
    "relative",
    "path",
    "directory",
    "file",
    "query",
    "anchor"
  ];
  f0 = function(o) {
    var i = o, a = o.indexOf("["), s = o.indexOf("]");
    a != -1 && s != -1 && (o = o.substring(0, a) + o.substring(a, s).replace(/:/g, ";") + o.substring(s, o.length));
    for (var c = e.exec(o || ""), l = {}, d = 14; d--; )
      l[t[d]] = c[d] || "";
    return a != -1 && s != -1 && (l.source = i, l.host = l.host.substring(1, l.host.length - 1).replace(/;/g, ":"), l.authority = l.authority.replace("[", "").replace("]", "").replace(/;/g, ":"), l.ipv6uri = !0), l.pathNames = n(l, l.path), l.queryKey = r(l, l.query), l;
  };
  function n(o, i) {
    var a = /\/{2,9}/g, s = i.replace(a, "/").split("/");
    return (i.substr(0, 1) == "/" || i.length === 0) && s.splice(0, 1), i.substr(i.length - 1, 1) == "/" && s.splice(s.length - 1, 1), s;
  }
  function r(o, i) {
    var a = {};
    return i.replace(/(?:^|&)([^&=]*)=?([^&]*)/g, function(s, c, l) {
      c && (a[c] = l);
    }), a;
  }
  return f0;
}
var qh = {}, Are = {
  get exports() {
    return qh;
  },
  set exports(e) {
    qh = e;
  }
}, Gh = {}, Dre = {
  get exports() {
    return Gh;
  },
  set exports(e) {
    Gh = e;
  }
}, p0, UE;
function Ire() {
  if (UE)
    return p0;
  UE = 1;
  var e = 1e3, t = e * 60, n = t * 60, r = n * 24, o = r * 365.25;
  p0 = function(l, d) {
    d = d || {};
    var f = typeof l;
    if (f === "string" && l.length > 0)
      return i(l);
    if (f === "number" && isNaN(l) === !1)
      return d.long ? s(l) : a(l);
    throw new Error(
      "val is not a non-empty string or a valid number. val=" + JSON.stringify(l)
    );
  };
  function i(l) {
    if (l = String(l), !(l.length > 100)) {
      var d = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(
        l
      );
      if (d) {
        var f = parseFloat(d[1]), p = (d[2] || "ms").toLowerCase();
        switch (p) {
          case "years":
          case "year":
          case "yrs":
          case "yr":
          case "y":
            return f * o;
          case "days":
          case "day":
          case "d":
            return f * r;
          case "hours":
          case "hour":
          case "hrs":
          case "hr":
          case "h":
            return f * n;
          case "minutes":
          case "minute":
          case "mins":
          case "min":
          case "m":
            return f * t;
          case "seconds":
          case "second":
          case "secs":
          case "sec":
          case "s":
            return f * e;
          case "milliseconds":
          case "millisecond":
          case "msecs":
          case "msec":
          case "ms":
            return f;
          default:
            return;
        }
      }
    }
  }
  function a(l) {
    return l >= r ? Math.round(l / r) + "d" : l >= n ? Math.round(l / n) + "h" : l >= t ? Math.round(l / t) + "m" : l >= e ? Math.round(l / e) + "s" : l + "ms";
  }
  function s(l) {
    return c(l, r, "day") || c(l, n, "hour") || c(l, t, "minute") || c(l, e, "second") || l + " ms";
  }
  function c(l, d, f) {
    if (!(l < d))
      return l < d * 1.5 ? Math.floor(l / d) + " " + f : Math.ceil(l / d) + " " + f + "s";
  }
  return p0;
}
var qE;
function Lre() {
  return qE || (qE = 1, function(e, t) {
    t = e.exports = r.debug = r.default = r, t.coerce = c, t.disable = a, t.enable = i, t.enabled = s, t.humanize = Ire(), t.instances = [], t.names = [], t.skips = [], t.formatters = {};
    function n(l) {
      var d = 0, f;
      for (f in l)
        d = (d << 5) - d + l.charCodeAt(f), d |= 0;
      return t.colors[Math.abs(d) % t.colors.length];
    }
    function r(l) {
      var d;
      function f() {
        if (f.enabled) {
          var p = f, m = +/* @__PURE__ */ new Date(), v = m - (d || m);
          p.diff = v, p.prev = d, p.curr = m, d = m;
          for (var g = new Array(arguments.length), b = 0; b < g.length; b++)
            g[b] = arguments[b];
          g[0] = t.coerce(g[0]), typeof g[0] != "string" && g.unshift("%O");
          var x = 0;
          g[0] = g[0].replace(/%([a-zA-Z%])/g, function(S, _) {
            if (S === "%%")
              return S;
            x++;
            var w = t.formatters[_];
            if (typeof w == "function") {
              var k = g[x];
              S = w.call(p, k), g.splice(x, 1), x--;
            }
            return S;
          }), t.formatArgs.call(p, g);
          var T = f.log || t.log || console.log.bind(console);
          T.apply(p, g);
        }
      }
      return f.namespace = l, f.enabled = t.enabled(l), f.useColors = t.useColors(), f.color = n(l), f.destroy = o, typeof t.init == "function" && t.init(f), t.instances.push(f), f;
    }
    function o() {
      var l = t.instances.indexOf(this);
      return l !== -1 ? (t.instances.splice(l, 1), !0) : !1;
    }
    function i(l) {
      t.save(l), t.names = [], t.skips = [];
      var d, f = (typeof l == "string" ? l : "").split(/[\s,]+/), p = f.length;
      for (d = 0; d < p; d++)
        f[d] && (l = f[d].replace(/\*/g, ".*?"), l[0] === "-" ? t.skips.push(new RegExp("^" + l.substr(1) + "$")) : t.names.push(new RegExp("^" + l + "$")));
      for (d = 0; d < t.instances.length; d++) {
        var m = t.instances[d];
        m.enabled = t.enabled(m.namespace);
      }
    }
    function a() {
      t.enable("");
    }
    function s(l) {
      if (l[l.length - 1] === "*")
        return !0;
      var d, f;
      for (d = 0, f = t.skips.length; d < f; d++)
        if (t.skips[d].test(l))
          return !1;
      for (d = 0, f = t.names.length; d < f; d++)
        if (t.names[d].test(l))
          return !0;
      return !1;
    }
    function c(l) {
      return l instanceof Error ? l.stack || l.message : l;
    }
  }(Dre, Gh)), Gh;
}
var GE;
function bg() {
  return GE || (GE = 1, function(e, t) {
    t = e.exports = Lre(), t.log = o, t.formatArgs = r, t.save = i, t.load = a, t.useColors = n, t.storage = typeof chrome != "undefined" && typeof chrome.storage != "undefined" ? chrome.storage.local : s(), t.colors = [
      "#0000CC",
      "#0000FF",
      "#0033CC",
      "#0033FF",
      "#0066CC",
      "#0066FF",
      "#0099CC",
      "#0099FF",
      "#00CC00",
      "#00CC33",
      "#00CC66",
      "#00CC99",
      "#00CCCC",
      "#00CCFF",
      "#3300CC",
      "#3300FF",
      "#3333CC",
      "#3333FF",
      "#3366CC",
      "#3366FF",
      "#3399CC",
      "#3399FF",
      "#33CC00",
      "#33CC33",
      "#33CC66",
      "#33CC99",
      "#33CCCC",
      "#33CCFF",
      "#6600CC",
      "#6600FF",
      "#6633CC",
      "#6633FF",
      "#66CC00",
      "#66CC33",
      "#9900CC",
      "#9900FF",
      "#9933CC",
      "#9933FF",
      "#99CC00",
      "#99CC33",
      "#CC0000",
      "#CC0033",
      "#CC0066",
      "#CC0099",
      "#CC00CC",
      "#CC00FF",
      "#CC3300",
      "#CC3333",
      "#CC3366",
      "#CC3399",
      "#CC33CC",
      "#CC33FF",
      "#CC6600",
      "#CC6633",
      "#CC9900",
      "#CC9933",
      "#CCCC00",
      "#CCCC33",
      "#FF0000",
      "#FF0033",
      "#FF0066",
      "#FF0099",
      "#FF00CC",
      "#FF00FF",
      "#FF3300",
      "#FF3333",
      "#FF3366",
      "#FF3399",
      "#FF33CC",
      "#FF33FF",
      "#FF6600",
      "#FF6633",
      "#FF9900",
      "#FF9933",
      "#FFCC00",
      "#FFCC33"
    ];
    function n() {
      return typeof window != "undefined" && window.process && window.process.type === "renderer" ? !0 : typeof navigator != "undefined" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/) ? !1 : typeof document != "undefined" && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance || // is firebug? http://stackoverflow.com/a/398120/376773
      typeof window != "undefined" && window.console && (window.console.firebug || window.console.exception && window.console.table) || // is firefox >= v31?
      // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
      typeof navigator != "undefined" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31 || // double check webkit in userAgent just in case we are in a worker
      typeof navigator != "undefined" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
    }
    t.formatters.j = function(c) {
      try {
        return JSON.stringify(c);
      } catch (l) {
        return "[UnexpectedJSONParseError]: " + l.message;
      }
    };
    function r(c) {
      var l = this.useColors;
      if (c[0] = (l ? "%c" : "") + this.namespace + (l ? " %c" : " ") + c[0] + (l ? "%c " : " ") + "+" + t.humanize(this.diff), !!l) {
        var d = "color: " + this.color;
        c.splice(1, 0, d, "color: inherit");
        var f = 0, p = 0;
        c[0].replace(/%[a-zA-Z%]/g, function(m) {
          m !== "%%" && (f++, m === "%c" && (p = f));
        }), c.splice(p, 0, d);
      }
    }
    function o() {
      return typeof console == "object" && console.log && Function.prototype.apply.call(console.log, console, arguments);
    }
    function i(c) {
      try {
        c == null ? t.storage.removeItem("debug") : t.storage.debug = c;
      } catch (l) {
      }
    }
    function a() {
      var c;
      try {
        c = t.storage.debug;
      } catch (l) {
      }
      return !c && typeof process != "undefined" && "env" in process && (c = process.env.DEBUG), c;
    }
    t.enable(a());
    function s() {
      try {
        return window.localStorage;
      } catch (c) {
      }
    }
  }(Are, qh)), qh;
}
var h0, YE;
function $re() {
  if (YE)
    return h0;
  YE = 1;
  var e = PD(), t = bg()("socket.io-client:url");
  h0 = n;
  function n(r, o) {
    var i = r;
    o = o || typeof location != "undefined" && location, r == null && (r = o.protocol + "//" + o.host), typeof r == "string" && (r.charAt(0) === "/" && (r.charAt(1) === "/" ? r = o.protocol + r : r = o.host + r), /^(https?|wss?):\/\//.test(r) || (t("protocol-less url %s", r), typeof o != "undefined" ? r = o.protocol + "//" + r : r = "https://" + r), t("parse %s", r), i = e(r)), i.port || (/^(http|ws)$/.test(i.protocol) ? i.port = "80" : /^(http|ws)s$/.test(i.protocol) && (i.port = "443")), i.path = i.path || "/";
    var a = i.host.indexOf(":") !== -1, s = a ? "[" + i.host + "]" : i.host;
    return i.id = i.protocol + "://" + s + ":" + i.port, i.href = i.protocol + "://" + s + (o && o.port === i.port ? "" : ":" + i.port), i;
  }
  return h0;
}
var ZE = {}, Yh = {}, Fre = {
  get exports() {
    return Yh;
  },
  set exports(e) {
    Yh = e;
  }
}, Zh = {}, zre = {
  get exports() {
    return Zh;
  },
  set exports(e) {
    Zh = e;
  }
}, m0, XE;
function Bre() {
  if (XE)
    return m0;
  XE = 1;
  var e = 1e3, t = e * 60, n = t * 60, r = n * 24, o = r * 365.25;
  m0 = function(l, d) {
    d = d || {};
    var f = typeof l;
    if (f === "string" && l.length > 0)
      return i(l);
    if (f === "number" && isNaN(l) === !1)
      return d.long ? s(l) : a(l);
    throw new Error(
      "val is not a non-empty string or a valid number. val=" + JSON.stringify(l)
    );
  };
  function i(l) {
    if (l = String(l), !(l.length > 100)) {
      var d = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(
        l
      );
      if (d) {
        var f = parseFloat(d[1]), p = (d[2] || "ms").toLowerCase();
        switch (p) {
          case "years":
          case "year":
          case "yrs":
          case "yr":
          case "y":
            return f * o;
          case "days":
          case "day":
          case "d":
            return f * r;
          case "hours":
          case "hour":
          case "hrs":
          case "hr":
          case "h":
            return f * n;
          case "minutes":
          case "minute":
          case "mins":
          case "min":
          case "m":
            return f * t;
          case "seconds":
          case "second":
          case "secs":
          case "sec":
          case "s":
            return f * e;
          case "milliseconds":
          case "millisecond":
          case "msecs":
          case "msec":
          case "ms":
            return f;
          default:
            return;
        }
      }
    }
  }
  function a(l) {
    return l >= r ? Math.round(l / r) + "d" : l >= n ? Math.round(l / n) + "h" : l >= t ? Math.round(l / t) + "m" : l >= e ? Math.round(l / e) + "s" : l + "ms";
  }
  function s(l) {
    return c(l, r, "day") || c(l, n, "hour") || c(l, t, "minute") || c(l, e, "second") || l + " ms";
  }
  function c(l, d, f) {
    if (!(l < d))
      return l < d * 1.5 ? Math.floor(l / d) + " " + f : Math.ceil(l / d) + " " + f + "s";
  }
  return m0;
}
var KE;
function Hre() {
  return KE || (KE = 1, function(e, t) {
    t = e.exports = r.debug = r.default = r, t.coerce = c, t.disable = a, t.enable = i, t.enabled = s, t.humanize = Bre(), t.instances = [], t.names = [], t.skips = [], t.formatters = {};
    function n(l) {
      var d = 0, f;
      for (f in l)
        d = (d << 5) - d + l.charCodeAt(f), d |= 0;
      return t.colors[Math.abs(d) % t.colors.length];
    }
    function r(l) {
      var d;
      function f() {
        if (f.enabled) {
          var p = f, m = +/* @__PURE__ */ new Date(), v = m - (d || m);
          p.diff = v, p.prev = d, p.curr = m, d = m;
          for (var g = new Array(arguments.length), b = 0; b < g.length; b++)
            g[b] = arguments[b];
          g[0] = t.coerce(g[0]), typeof g[0] != "string" && g.unshift("%O");
          var x = 0;
          g[0] = g[0].replace(/%([a-zA-Z%])/g, function(S, _) {
            if (S === "%%")
              return S;
            x++;
            var w = t.formatters[_];
            if (typeof w == "function") {
              var k = g[x];
              S = w.call(p, k), g.splice(x, 1), x--;
            }
            return S;
          }), t.formatArgs.call(p, g);
          var T = f.log || t.log || console.log.bind(console);
          T.apply(p, g);
        }
      }
      return f.namespace = l, f.enabled = t.enabled(l), f.useColors = t.useColors(), f.color = n(l), f.destroy = o, typeof t.init == "function" && t.init(f), t.instances.push(f), f;
    }
    function o() {
      var l = t.instances.indexOf(this);
      return l !== -1 ? (t.instances.splice(l, 1), !0) : !1;
    }
    function i(l) {
      t.save(l), t.names = [], t.skips = [];
      var d, f = (typeof l == "string" ? l : "").split(/[\s,]+/), p = f.length;
      for (d = 0; d < p; d++)
        f[d] && (l = f[d].replace(/\*/g, ".*?"), l[0] === "-" ? t.skips.push(new RegExp("^" + l.substr(1) + "$")) : t.names.push(new RegExp("^" + l + "$")));
      for (d = 0; d < t.instances.length; d++) {
        var m = t.instances[d];
        m.enabled = t.enabled(m.namespace);
      }
    }
    function a() {
      t.enable("");
    }
    function s(l) {
      if (l[l.length - 1] === "*")
        return !0;
      var d, f;
      for (d = 0, f = t.skips.length; d < f; d++)
        if (t.skips[d].test(l))
          return !1;
      for (d = 0, f = t.names.length; d < f; d++)
        if (t.names[d].test(l))
          return !0;
      return !1;
    }
    function c(l) {
      return l instanceof Error ? l.stack || l.message : l;
    }
  }(zre, Zh)), Zh;
}
var JE;
function jre() {
  return JE || (JE = 1, function(e, t) {
    t = e.exports = Hre(), t.log = o, t.formatArgs = r, t.save = i, t.load = a, t.useColors = n, t.storage = typeof chrome != "undefined" && typeof chrome.storage != "undefined" ? chrome.storage.local : s(), t.colors = [
      "#0000CC",
      "#0000FF",
      "#0033CC",
      "#0033FF",
      "#0066CC",
      "#0066FF",
      "#0099CC",
      "#0099FF",
      "#00CC00",
      "#00CC33",
      "#00CC66",
      "#00CC99",
      "#00CCCC",
      "#00CCFF",
      "#3300CC",
      "#3300FF",
      "#3333CC",
      "#3333FF",
      "#3366CC",
      "#3366FF",
      "#3399CC",
      "#3399FF",
      "#33CC00",
      "#33CC33",
      "#33CC66",
      "#33CC99",
      "#33CCCC",
      "#33CCFF",
      "#6600CC",
      "#6600FF",
      "#6633CC",
      "#6633FF",
      "#66CC00",
      "#66CC33",
      "#9900CC",
      "#9900FF",
      "#9933CC",
      "#9933FF",
      "#99CC00",
      "#99CC33",
      "#CC0000",
      "#CC0033",
      "#CC0066",
      "#CC0099",
      "#CC00CC",
      "#CC00FF",
      "#CC3300",
      "#CC3333",
      "#CC3366",
      "#CC3399",
      "#CC33CC",
      "#CC33FF",
      "#CC6600",
      "#CC6633",
      "#CC9900",
      "#CC9933",
      "#CCCC00",
      "#CCCC33",
      "#FF0000",
      "#FF0033",
      "#FF0066",
      "#FF0099",
      "#FF00CC",
      "#FF00FF",
      "#FF3300",
      "#FF3333",
      "#FF3366",
      "#FF3399",
      "#FF33CC",
      "#FF33FF",
      "#FF6600",
      "#FF6633",
      "#FF9900",
      "#FF9933",
      "#FFCC00",
      "#FFCC33"
    ];
    function n() {
      return typeof window != "undefined" && window.process && window.process.type === "renderer" ? !0 : typeof navigator != "undefined" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/) ? !1 : typeof document != "undefined" && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance || // is firebug? http://stackoverflow.com/a/398120/376773
      typeof window != "undefined" && window.console && (window.console.firebug || window.console.exception && window.console.table) || // is firefox >= v31?
      // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
      typeof navigator != "undefined" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31 || // double check webkit in userAgent just in case we are in a worker
      typeof navigator != "undefined" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
    }
    t.formatters.j = function(c) {
      try {
        return JSON.stringify(c);
      } catch (l) {
        return "[UnexpectedJSONParseError]: " + l.message;
      }
    };
    function r(c) {
      var l = this.useColors;
      if (c[0] = (l ? "%c" : "") + this.namespace + (l ? " %c" : " ") + c[0] + (l ? "%c " : " ") + "+" + t.humanize(this.diff), !!l) {
        var d = "color: " + this.color;
        c.splice(1, 0, d, "color: inherit");
        var f = 0, p = 0;
        c[0].replace(/%[a-zA-Z%]/g, function(m) {
          m !== "%%" && (f++, m === "%c" && (p = f));
        }), c.splice(p, 0, d);
      }
    }
    function o() {
      return typeof console == "object" && console.log && Function.prototype.apply.call(console.log, console, arguments);
    }
    function i(c) {
      try {
        c == null ? t.storage.removeItem("debug") : t.storage.debug = c;
      } catch (l) {
      }
    }
    function a() {
      var c;
      try {
        c = t.storage.debug;
      } catch (l) {
      }
      return !c && typeof process != "undefined" && "env" in process && (c = process.env.DEBUG), c;
    }
    t.enable(a());
    function s() {
      try {
        return window.localStorage;
      } catch (c) {
      }
    }
  }(Fre, Yh)), Yh;
}
var jy = {}, Wre = {
  get exports() {
    return jy;
  },
  set exports(e) {
    jy = e;
  }
}, QE;
function Gc() {
  return QE || (QE = 1, function(e) {
    e.exports = t;
    function t(r) {
      if (r)
        return n(r);
    }
    function n(r) {
      for (var o in t.prototype)
        r[o] = t.prototype[o];
      return r;
    }
    t.prototype.on = t.prototype.addEventListener = function(r, o) {
      return this._callbacks = this._callbacks || {}, (this._callbacks["$" + r] = this._callbacks["$" + r] || []).push(o), this;
    }, t.prototype.once = function(r, o) {
      function i() {
        this.off(r, i), o.apply(this, arguments);
      }
      return i.fn = o, this.on(r, i), this;
    }, t.prototype.off = t.prototype.removeListener = t.prototype.removeAllListeners = t.prototype.removeEventListener = function(r, o) {
      if (this._callbacks = this._callbacks || {}, arguments.length == 0)
        return this._callbacks = {}, this;
      var i = this._callbacks["$" + r];
      if (!i)
        return this;
      if (arguments.length == 1)
        return delete this._callbacks["$" + r], this;
      for (var a, s = 0; s < i.length; s++)
        if (a = i[s], a === o || a.fn === o) {
          i.splice(s, 1);
          break;
        }
      return i.length === 0 && delete this._callbacks["$" + r], this;
    }, t.prototype.emit = function(r) {
      this._callbacks = this._callbacks || {};
      for (var o = new Array(arguments.length - 1), i = this._callbacks["$" + r], a = 1; a < arguments.length; a++)
        o[a - 1] = arguments[a];
      if (i) {
        i = i.slice(0);
        for (var a = 0, s = i.length; a < s; ++a)
          i[a].apply(this, o);
      }
      return this;
    }, t.prototype.listeners = function(r) {
      return this._callbacks = this._callbacks || {}, this._callbacks["$" + r] || [];
    }, t.prototype.hasListeners = function(r) {
      return !!this.listeners(r).length;
    };
  }(Wre)), jy;
}
var Lu = {}, g0, ek;
function OD() {
  if (ek)
    return g0;
  ek = 1;
  var e = {}.toString;
  return g0 = Array.isArray || function(t) {
    return e.call(t) == "[object Array]";
  }, g0;
}
var v0, tk;
function ND() {
  if (tk)
    return v0;
  tk = 1, v0 = r;
  var e = typeof Buffer == "function" && typeof Buffer.isBuffer == "function", t = typeof ArrayBuffer == "function", n = function(o) {
    return typeof ArrayBuffer.isView == "function" ? ArrayBuffer.isView(o) : o.buffer instanceof ArrayBuffer;
  };
  function r(o) {
    return e && Buffer.isBuffer(o) || t && (o instanceof ArrayBuffer || n(o));
  }
  return v0;
}
var nk;
function Vre() {
  if (nk)
    return Lu;
  nk = 1;
  var e = OD(), t = ND(), n = Object.prototype.toString, r = typeof Blob == "function" || typeof Blob != "undefined" && n.call(Blob) === "[object BlobConstructor]", o = typeof File == "function" || typeof File != "undefined" && n.call(File) === "[object FileConstructor]";
  Lu.deconstructPacket = function(s) {
    var c = [], l = s.data, d = s;
    return d.data = i(l, c), d.attachments = c.length, { packet: d, buffers: c };
  };
  function i(s, c) {
    if (!s)
      return s;
    if (t(s)) {
      var l = { _placeholder: !0, num: c.length };
      return c.push(s), l;
    } else if (e(s)) {
      for (var d = new Array(s.length), f = 0; f < s.length; f++)
        d[f] = i(s[f], c);
      return d;
    } else if (typeof s == "object" && !(s instanceof Date)) {
      var d = {};
      for (var p in s)
        d[p] = i(s[p], c);
      return d;
    }
    return s;
  }
  Lu.reconstructPacket = function(s, c) {
    return s.data = a(s.data, c), s.attachments = void 0, s;
  };
  function a(s, c) {
    if (!s)
      return s;
    if (s && s._placeholder === !0) {
      var l = typeof s.num == "number" && s.num >= 0 && s.num < c.length;
      if (l)
        return c[s.num];
      throw new Error("illegal attachments");
    } else if (e(s))
      for (var d = 0; d < s.length; d++)
        s[d] = a(s[d], c);
    else if (typeof s == "object")
      for (var f in s)
        s[f] = a(s[f], c);
    return s;
  }
  return Lu.removeBlobs = function(s, c) {
    function l(p, m, v) {
      if (!p)
        return p;
      if (r && p instanceof Blob || o && p instanceof File) {
        d++;
        var g = new FileReader();
        g.onload = function() {
          v ? v[m] = this.result : f = this.result, --d || c(f);
        }, g.readAsArrayBuffer(p);
      } else if (e(p))
        for (var b = 0; b < p.length; b++)
          l(p[b], b, p);
      else if (typeof p == "object" && !t(p))
        for (var x in p)
          l(p[x], x, p);
    }
    var d = 0, f = s;
    l(f), d || c(f);
  }, Lu;
}
var rk;
function Ew() {
  return rk || (rk = 1, function(e) {
    var t = jre()("socket.io-parser"), n = Gc(), r = Vre(), o = OD(), i = ND();
    e.protocol = 4, e.types = [
      "CONNECT",
      "DISCONNECT",
      "EVENT",
      "ACK",
      "ERROR",
      "BINARY_EVENT",
      "BINARY_ACK"
    ], e.CONNECT = 0, e.DISCONNECT = 1, e.EVENT = 2, e.ACK = 3, e.ERROR = 4, e.BINARY_EVENT = 5, e.BINARY_ACK = 6, e.Encoder = a, e.Decoder = f;
    function a() {
    }
    var s = e.ERROR + '"encode error"';
    a.prototype.encode = function(b, x) {
      if (t("encoding packet %j", b), e.BINARY_EVENT === b.type || e.BINARY_ACK === b.type)
        d(b, x);
      else {
        var T = c(b);
        x([T]);
      }
    };
    function c(b) {
      var x = "" + b.type;
      if ((e.BINARY_EVENT === b.type || e.BINARY_ACK === b.type) && (x += b.attachments + "-"), b.nsp && b.nsp !== "/" && (x += b.nsp + ","), b.id != null && (x += b.id), b.data != null) {
        var T = l(b.data);
        if (T !== !1)
          x += T;
        else
          return s;
      }
      return t("encoded %j as %s", b, x), x;
    }
    function l(b) {
      try {
        return JSON.stringify(b);
      } catch (x) {
        return !1;
      }
    }
    function d(b, x) {
      function T(S) {
        var _ = r.deconstructPacket(S), w = c(_.packet), k = _.buffers;
        k.unshift(w), x(k);
      }
      r.removeBlobs(b, T);
    }
    function f() {
      this.reconstructor = null;
    }
    n(f.prototype), f.prototype.add = function(b) {
      var x;
      if (typeof b == "string") {
        if (this.reconstructor)
          throw new Error("got plaintext data when reconstructing a packet");
        x = p(b), e.BINARY_EVENT === x.type || e.BINARY_ACK === x.type ? (this.reconstructor = new v(x), this.reconstructor.reconPack.attachments === 0 && this.emit("decoded", x)) : this.emit("decoded", x);
      } else if (i(b) || b.base64)
        if (this.reconstructor)
          x = this.reconstructor.takeBinaryData(b), x && (this.reconstructor = null, this.emit("decoded", x));
        else
          throw new Error("got binary data when not reconstructing a packet");
      else
        throw new Error("Unknown type: " + b);
    };
    function p(b) {
      var x = 0, T = {
        type: Number(b.charAt(0))
      };
      if (e.types[T.type] == null)
        return g("unknown packet type " + T.type);
      if (e.BINARY_EVENT === T.type || e.BINARY_ACK === T.type) {
        for (var S = x + 1; b.charAt(++x) !== "-" && x != b.length; )
          ;
        var _ = b.substring(S, x);
        if (_ != Number(_) || b.charAt(x) !== "-")
          throw new Error("Illegal attachments");
        T.attachments = Number(_);
      }
      if (b.charAt(x + 1) === "/") {
        for (var S = x + 1; ++x; ) {
          var w = b.charAt(x);
          if (w === "," || x === b.length)
            break;
        }
        T.nsp = b.substring(S, x);
      } else
        T.nsp = "/";
      var k = b.charAt(x + 1);
      if (k !== "" && Number(k) == k) {
        for (var S = x + 1; ++x; ) {
          var w = b.charAt(x);
          if (w == null || Number(w) != w) {
            --x;
            break;
          }
          if (x === b.length)
            break;
        }
        T.id = Number(b.substring(S, x + 1));
      }
      if (b.charAt(++x)) {
        var E = m(b.substr(x)), R = E !== !1 && (T.type === e.ERROR || o(E));
        if (R)
          T.data = E;
        else
          return g("invalid payload");
      }
      return t("decoded %s as %j", b, T), T;
    }
    function m(b) {
      try {
        return JSON.parse(b);
      } catch (x) {
        return !1;
      }
    }
    f.prototype.destroy = function() {
      this.reconstructor && this.reconstructor.finishedReconstruction();
    };
    function v(b) {
      this.reconPack = b, this.buffers = [];
    }
    v.prototype.takeBinaryData = function(b) {
      if (this.buffers.push(b), this.buffers.length === this.reconPack.attachments) {
        var x = r.reconstructPacket(this.reconPack, this.buffers);
        return this.finishedReconstruction(), x;
      }
      return null;
    }, v.prototype.finishedReconstruction = function() {
      this.reconPack = null, this.buffers = [];
    };
    function g(b) {
      return {
        type: e.ERROR,
        data: "parser error: " + b
      };
    }
  }(ZE)), ZE;
}
var Wy = {}, Ure = {
  get exports() {
    return Wy;
  },
  set exports(e) {
    Wy = e;
  }
}, bp = {}, Xh = {}, ok = {
  get exports() {
    return Xh;
  },
  set exports(e) {
    Xh = e;
  }
}, ik;
function qre() {
  if (ik)
    return Xh;
  ik = 1;
  try {
    ok.exports = typeof XMLHttpRequest != "undefined" && "withCredentials" in new XMLHttpRequest();
  } catch (e) {
    ok.exports = !1;
  }
  return Xh;
}
var ak, sk;
function kw() {
  return sk || (sk = 1, ak = function() {
    return typeof self != "undefined" ? self : typeof window != "undefined" ? window : Function("return this")();
  }()), ak;
}
var b0, lk;
function Mw() {
  if (lk)
    return b0;
  lk = 1;
  var e = qre(), t = kw();
  return b0 = function(n) {
    var r = n.xdomain, o = n.xscheme, i = n.enablesXDR;
    try {
      if (typeof XMLHttpRequest != "undefined" && (!r || e))
        return new XMLHttpRequest();
    } catch (a) {
    }
    try {
      if (typeof XDomainRequest != "undefined" && !o && i)
        return new XDomainRequest();
    } catch (a) {
    }
    if (!r)
      try {
        return new t[["Active"].concat("Object").join("X")]("Microsoft.XMLHTTP");
      } catch (a) {
      }
  }, b0;
}
var yd = {}, Gre = {
  get exports() {
    return yd;
  },
  set exports(e) {
    yd = e;
  }
}, ck = {}, uk, dk;
function Yre() {
  return dk || (dk = 1, uk = Object.keys || function(e) {
    var t = [], n = Object.prototype.hasOwnProperty;
    for (var r in e)
      n.call(e, r) && t.push(r);
    return t;
  }), uk;
}
var y0, fk;
function Zre() {
  if (fk)
    return y0;
  fk = 1;
  var e = {}.toString;
  return y0 = Array.isArray || function(t) {
    return e.call(t) == "[object Array]";
  }, y0;
}
var _0, pk;
function AD() {
  if (pk)
    return _0;
  pk = 1;
  var e = Zre(), t = Object.prototype.toString, n = typeof Blob == "function" || typeof Blob != "undefined" && t.call(Blob) === "[object BlobConstructor]", r = typeof File == "function" || typeof File != "undefined" && t.call(File) === "[object FileConstructor]";
  _0 = o;
  function o(i) {
    if (!i || typeof i != "object")
      return !1;
    if (e(i)) {
      for (var a = 0, s = i.length; a < s; a++)
        if (o(i[a]))
          return !0;
      return !1;
    }
    if (typeof Buffer == "function" && Buffer.isBuffer && Buffer.isBuffer(i) || typeof ArrayBuffer == "function" && i instanceof ArrayBuffer || n && i instanceof Blob || r && i instanceof File)
      return !0;
    if (i.toJSON && typeof i.toJSON == "function" && arguments.length === 1)
      return o(i.toJSON(), !0);
    for (var c in i)
      if (Object.prototype.hasOwnProperty.call(i, c) && o(i[c]))
        return !0;
    return !1;
  }
  return _0;
}
var hk, mk;
function Xre() {
  return mk || (mk = 1, hk = function(e, t, n) {
    var r = e.byteLength;
    if (t = t || 0, n = n || r, e.slice)
      return e.slice(t, n);
    if (t < 0 && (t += r), n < 0 && (n += r), n > r && (n = r), t >= r || t >= n || r === 0)
      return new ArrayBuffer(0);
    for (var o = new Uint8Array(e), i = new Uint8Array(n - t), a = t, s = 0; a < n; a++, s++)
      i[s] = o[a];
    return i.buffer;
  }), hk;
}
var w0, gk;
function Kre() {
  if (gk)
    return w0;
  gk = 1, w0 = e;
  function e(n, r, o) {
    var i = !1;
    return o = o || t, a.count = n, n === 0 ? r() : a;
    function a(s, c) {
      if (a.count <= 0)
        throw new Error("after called too many times");
      --a.count, s ? (i = !0, r(s), r = o) : a.count === 0 && !i && r(null, c);
    }
  }
  function t() {
  }
  return w0;
}
/*! https://mths.be/utf8js v2.1.2 by @mathias */
var x0, vk;
function Jre() {
  if (vk)
    return x0;
  vk = 1;
  var e = String.fromCharCode;
  function t(m) {
    for (var v = [], g = 0, b = m.length, x, T; g < b; )
      x = m.charCodeAt(g++), x >= 55296 && x <= 56319 && g < b ? (T = m.charCodeAt(g++), (T & 64512) == 56320 ? v.push(((x & 1023) << 10) + (T & 1023) + 65536) : (v.push(x), g--)) : v.push(x);
    return v;
  }
  function n(m) {
    for (var v = m.length, g = -1, b, x = ""; ++g < v; )
      b = m[g], b > 65535 && (b -= 65536, x += e(b >>> 10 & 1023 | 55296), b = 56320 | b & 1023), x += e(b);
    return x;
  }
  function r(m, v) {
    if (m >= 55296 && m <= 57343) {
      if (v)
        throw Error(
          "Lone surrogate U+" + m.toString(16).toUpperCase() + " is not a scalar value"
        );
      return !1;
    }
    return !0;
  }
  function o(m, v) {
    return e(m >> v & 63 | 128);
  }
  function i(m, v) {
    if (!(m & 4294967168))
      return e(m);
    var g = "";
    return m & 4294965248 ? m & 4294901760 ? m & 4292870144 || (g = e(m >> 18 & 7 | 240), g += o(m, 12), g += o(m, 6)) : (r(m, v) || (m = 65533), g = e(m >> 12 & 15 | 224), g += o(m, 6)) : g = e(m >> 6 & 31 | 192), g += e(m & 63 | 128), g;
  }
  function a(m, v) {
    v = v || {};
    for (var g = v.strict !== !1, b = t(m), x = b.length, T = -1, S, _ = ""; ++T < x; )
      S = b[T], _ += i(S, g);
    return _;
  }
  function s() {
    if (f >= d)
      throw Error("Invalid byte index");
    var m = l[f] & 255;
    if (f++, (m & 192) == 128)
      return m & 63;
    throw Error("Invalid continuation byte");
  }
  function c(m) {
    var v, g, b, x, T;
    if (f > d)
      throw Error("Invalid byte index");
    if (f == d)
      return !1;
    if (v = l[f] & 255, f++, !(v & 128))
      return v;
    if ((v & 224) == 192) {
      if (g = s(), T = (v & 31) << 6 | g, T >= 128)
        return T;
      throw Error("Invalid continuation byte");
    }
    if ((v & 240) == 224) {
      if (g = s(), b = s(), T = (v & 15) << 12 | g << 6 | b, T >= 2048)
        return r(T, m) ? T : 65533;
      throw Error("Invalid continuation byte");
    }
    if ((v & 248) == 240 && (g = s(), b = s(), x = s(), T = (v & 7) << 18 | g << 12 | b << 6 | x, T >= 65536 && T <= 1114111))
      return T;
    throw Error("Invalid UTF-8 detected");
  }
  var l, d, f;
  function p(m, v) {
    v = v || {};
    var g = v.strict !== !1;
    l = t(m), d = l.length, f = 0;
    for (var b = [], x; (x = c(g)) !== !1; )
      b.push(x);
    return n(b);
  }
  return x0 = {
    version: "2.1.2",
    encode: a,
    decode: p
  }, x0;
}
var C0 = {}, bk;
function Qre() {
  return bk || (bk = 1, function(e) {
    C0.encode = function(t) {
      var n = new Uint8Array(t), r, o = n.length, i = "";
      for (r = 0; r < o; r += 3)
        i += e[n[r] >> 2], i += e[(n[r] & 3) << 4 | n[r + 1] >> 4], i += e[(n[r + 1] & 15) << 2 | n[r + 2] >> 6], i += e[n[r + 2] & 63];
      return o % 3 === 2 ? i = i.substring(0, i.length - 1) + "=" : o % 3 === 1 && (i = i.substring(0, i.length - 2) + "=="), i;
    }, C0.decode = function(t) {
      var n = t.length * 0.75, r = t.length, o, i = 0, a, s, c, l;
      t[t.length - 1] === "=" && (n--, t[t.length - 2] === "=" && n--);
      var d = new ArrayBuffer(n), f = new Uint8Array(d);
      for (o = 0; o < r; o += 4)
        a = e.indexOf(t[o]), s = e.indexOf(t[o + 1]), c = e.indexOf(t[o + 2]), l = e.indexOf(t[o + 3]), f[i++] = a << 2 | s >> 4, f[i++] = (s & 15) << 4 | c >> 2, f[i++] = (c & 3) << 6 | l & 63;
      return d;
    };
  }("ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/")), C0;
}
var S0, yk;
function eoe() {
  if (yk)
    return S0;
  yk = 1;
  var e = typeof e != "undefined" ? e : typeof WebKitBlobBuilder != "undefined" ? WebKitBlobBuilder : typeof MSBlobBuilder != "undefined" ? MSBlobBuilder : typeof MozBlobBuilder != "undefined" ? MozBlobBuilder : !1, t = function() {
    try {
      var s = new Blob(["hi"]);
      return s.size === 2;
    } catch (c) {
      return !1;
    }
  }(), n = t && function() {
    try {
      var s = new Blob([new Uint8Array([1, 2])]);
      return s.size === 2;
    } catch (c) {
      return !1;
    }
  }(), r = e && e.prototype.append && e.prototype.getBlob;
  function o(s) {
    return s.map(function(c) {
      if (c.buffer instanceof ArrayBuffer) {
        var l = c.buffer;
        if (c.byteLength !== l.byteLength) {
          var d = new Uint8Array(c.byteLength);
          d.set(new Uint8Array(l, c.byteOffset, c.byteLength)), l = d.buffer;
        }
        return l;
      }
      return c;
    });
  }
  function i(s, c) {
    c = c || {};
    var l = new e();
    return o(s).forEach(function(d) {
      l.append(d);
    }), c.type ? l.getBlob(c.type) : l.getBlob();
  }
  function a(s, c) {
    return new Blob(o(s), c || {});
  }
  return typeof Blob != "undefined" && (i.prototype = Blob.prototype, a.prototype = Blob.prototype), S0 = /* @__PURE__ */ function() {
    return t ? n ? Blob : a : r ? i : void 0;
  }(), S0;
}
var _k;
function Rc() {
  return _k || (_k = 1, function(e) {
    var t = Yre(), n = AD(), r = Xre(), o = Kre(), i = Jre(), a;
    typeof ArrayBuffer != "undefined" && (a = Qre());
    var s = typeof navigator != "undefined" && /Android/i.test(navigator.userAgent), c = typeof navigator != "undefined" && /PhantomJS/i.test(navigator.userAgent), l = s || c;
    e.protocol = 3;
    var d = e.packets = {
      open: 0,
      close: 1,
      ping: 2,
      pong: 3,
      message: 4,
      upgrade: 5,
      noop: 6
    }, f = t(d), p = { type: "error", data: "parser error" }, m = eoe();
    e.encodePacket = function(_, w, k, E) {
      typeof w == "function" && (E = w, w = !1), typeof k == "function" && (E = k, k = null);
      var R = _.data === void 0 ? void 0 : _.data.buffer || _.data;
      if (typeof ArrayBuffer != "undefined" && R instanceof ArrayBuffer)
        return g(_, w, E);
      if (typeof m != "undefined" && R instanceof m)
        return x(_, w, E);
      if (R && R.base64)
        return v(_, E);
      var P = d[_.type];
      return _.data !== void 0 && (P += k ? i.encode(String(_.data), { strict: !1 }) : String(_.data)), E("" + P);
    };
    function v(_, w) {
      var k = "b" + e.packets[_.type] + _.data.data;
      return w(k);
    }
    function g(_, w, k) {
      if (!w)
        return e.encodeBase64Packet(_, k);
      var E = _.data, R = new Uint8Array(E), P = new Uint8Array(1 + E.byteLength);
      P[0] = d[_.type];
      for (var A = 0; A < R.length; A++)
        P[A + 1] = R[A];
      return k(P.buffer);
    }
    function b(_, w, k) {
      if (!w)
        return e.encodeBase64Packet(_, k);
      var E = new FileReader();
      return E.onload = function() {
        e.encodePacket({ type: _.type, data: E.result }, w, !0, k);
      }, E.readAsArrayBuffer(_.data);
    }
    function x(_, w, k) {
      if (!w)
        return e.encodeBase64Packet(_, k);
      if (l)
        return b(_, w, k);
      var E = new Uint8Array(1);
      E[0] = d[_.type];
      var R = new m([E.buffer, _.data]);
      return k(R);
    }
    e.encodeBase64Packet = function(_, w) {
      var k = "b" + e.packets[_.type];
      if (typeof m != "undefined" && _.data instanceof m) {
        var E = new FileReader();
        return E.onload = function() {
          var N = E.result.split(",")[1];
          w(k + N);
        }, E.readAsDataURL(_.data);
      }
      var R;
      try {
        R = String.fromCharCode.apply(null, new Uint8Array(_.data));
      } catch (N) {
        for (var P = new Uint8Array(_.data), A = new Array(P.length), D = 0; D < P.length; D++)
          A[D] = P[D];
        R = String.fromCharCode.apply(null, A);
      }
      return k += btoa(R), w(k);
    }, e.decodePacket = function(_, w, k) {
      if (_ === void 0)
        return p;
      if (typeof _ == "string") {
        if (_.charAt(0) === "b")
          return e.decodeBase64Packet(_.substr(1), w);
        if (k && (_ = T(_), _ === !1))
          return p;
        var R = _.charAt(0);
        return Number(R) != R || !f[R] ? p : _.length > 1 ? { type: f[R], data: _.substring(1) } : { type: f[R] };
      }
      var E = new Uint8Array(_), R = E[0], P = r(_, 1);
      return m && w === "blob" && (P = new m([P])), { type: f[R], data: P };
    };
    function T(_) {
      try {
        _ = i.decode(_, { strict: !1 });
      } catch (w) {
        return !1;
      }
      return _;
    }
    e.decodeBase64Packet = function(_, w) {
      var k = f[_.charAt(0)];
      if (!a)
        return { type: k, data: { base64: !0, data: _.substr(1) } };
      var E = a.decode(_.substr(1));
      return w === "blob" && m && (E = new m([E])), { type: k, data: E };
    }, e.encodePayload = function(_, w, k) {
      typeof w == "function" && (k = w, w = null);
      var E = n(_);
      if (w && E)
        return m && !l ? e.encodePayloadAsBlob(_, k) : e.encodePayloadAsArrayBuffer(_, k);
      if (!_.length)
        return k("0:");
      function R(A) {
        return A.length + ":" + A;
      }
      function P(A, D) {
        e.encodePacket(A, E ? w : !1, !1, function(N) {
          D(null, R(N));
        });
      }
      S(_, P, function(A, D) {
        return k(D.join(""));
      });
    };
    function S(_, w, k) {
      for (var E = new Array(_.length), R = o(_.length, k), P = function(D, N, F) {
        w(N, function($, I) {
          E[D] = I, F($, E);
        });
      }, A = 0; A < _.length; A++)
        P(A, _[A], R);
    }
    e.decodePayload = function(_, w, k) {
      if (typeof _ != "string")
        return e.decodePayloadAsBinary(_, w, k);
      typeof w == "function" && (k = w, w = null);
      var E;
      if (_ === "")
        return k(p, 0, 1);
      for (var R = "", P, A, D = 0, N = _.length; D < N; D++) {
        var F = _.charAt(D);
        if (F !== ":") {
          R += F;
          continue;
        }
        if (R === "" || R != (P = Number(R)) || (A = _.substr(D + 1, P), R != A.length))
          return k(p, 0, 1);
        if (A.length) {
          if (E = e.decodePacket(A, w, !1), p.type === E.type && p.data === E.data)
            return k(p, 0, 1);
          var $ = k(E, D + P, N);
          if ($ === !1)
            return;
        }
        D += P, R = "";
      }
      if (R !== "")
        return k(p, 0, 1);
    }, e.encodePayloadAsArrayBuffer = function(_, w) {
      if (!_.length)
        return w(new ArrayBuffer(0));
      function k(E, R) {
        e.encodePacket(E, !0, !0, function(P) {
          return R(null, P);
        });
      }
      S(_, k, function(E, R) {
        var P = R.reduce(function(N, F) {
          var $;
          return typeof F == "string" ? $ = F.length : $ = F.byteLength, N + $.toString().length + $ + 2;
        }, 0), A = new Uint8Array(P), D = 0;
        return R.forEach(function(N) {
          var F = typeof N == "string", $ = N;
          if (F) {
            for (var I = new Uint8Array(N.length), j = 0; j < N.length; j++)
              I[j] = N.charCodeAt(j);
            $ = I.buffer;
          }
          F ? A[D++] = 0 : A[D++] = 1;
          for (var U = $.byteLength.toString(), j = 0; j < U.length; j++)
            A[D++] = parseInt(U[j]);
          A[D++] = 255;
          for (var I = new Uint8Array($), j = 0; j < I.length; j++)
            A[D++] = I[j];
        }), w(A.buffer);
      });
    }, e.encodePayloadAsBlob = function(_, w) {
      function k(E, R) {
        e.encodePacket(E, !0, !0, function(P) {
          var A = new Uint8Array(1);
          if (A[0] = 1, typeof P == "string") {
            for (var D = new Uint8Array(P.length), N = 0; N < P.length; N++)
              D[N] = P.charCodeAt(N);
            P = D.buffer, A[0] = 0;
          }
          for (var F = P instanceof ArrayBuffer ? P.byteLength : P.size, $ = F.toString(), I = new Uint8Array($.length + 1), N = 0; N < $.length; N++)
            I[N] = parseInt($[N]);
          if (I[$.length] = 255, m) {
            var j = new m([A.buffer, I.buffer, P]);
            R(null, j);
          }
        });
      }
      S(_, k, function(E, R) {
        return w(new m(R));
      });
    }, e.decodePayloadAsBinary = function(_, w, k) {
      typeof w == "function" && (k = w, w = null);
      for (var E = _, R = []; E.byteLength > 0; ) {
        for (var P = new Uint8Array(E), A = P[0] === 0, D = "", N = 1; P[N] !== 255; N++) {
          if (D.length > 310)
            return k(p, 0, 1);
          D += P[N];
        }
        E = r(E, 2 + D.length), D = parseInt(D);
        var F = r(E, 0, D);
        if (A)
          try {
            F = String.fromCharCode.apply(null, new Uint8Array(F));
          } catch (j) {
            var $ = new Uint8Array(F);
            F = "";
            for (var N = 0; N < $.length; N++)
              F += String.fromCharCode($[N]);
          }
        R.push(F), E = r(E, D);
      }
      var I = R.length;
      R.forEach(function(j, U) {
        k(e.decodePacket(j, w, !0), U, I);
      });
    };
  }(ck)), ck;
}
var T0, wk;
function Rw() {
  if (wk)
    return T0;
  wk = 1;
  var e = Rc(), t = Gc();
  T0 = n;
  function n(r) {
    this.path = r.path, this.hostname = r.hostname, this.port = r.port, this.secure = r.secure, this.query = r.query, this.timestampParam = r.timestampParam, this.timestampRequests = r.timestampRequests, this.readyState = "", this.agent = r.agent || !1, this.socket = r.socket, this.enablesXDR = r.enablesXDR, this.withCredentials = r.withCredentials, this.pfx = r.pfx, this.key = r.key, this.passphrase = r.passphrase, this.cert = r.cert, this.ca = r.ca, this.ciphers = r.ciphers, this.rejectUnauthorized = r.rejectUnauthorized, this.forceNode = r.forceNode, this.isReactNative = r.isReactNative, this.extraHeaders = r.extraHeaders, this.localAddress = r.localAddress;
  }
  return t(n.prototype), n.prototype.onError = function(r, o) {
    var i = new Error(r);
    return i.type = "TransportError", i.description = o, this.emit("error", i), this;
  }, n.prototype.open = function() {
    return (this.readyState === "closed" || this.readyState === "") && (this.readyState = "opening", this.doOpen()), this;
  }, n.prototype.close = function() {
    return (this.readyState === "opening" || this.readyState === "open") && (this.doClose(), this.onClose()), this;
  }, n.prototype.send = function(r) {
    if (this.readyState === "open")
      this.write(r);
    else
      throw new Error("Transport not open");
  }, n.prototype.onOpen = function() {
    this.readyState = "open", this.writable = !0, this.emit("open");
  }, n.prototype.onData = function(r) {
    var o = e.decodePacket(r, this.socket.binaryType);
    this.onPacket(o);
  }, n.prototype.onPacket = function(r) {
    this.emit("packet", r);
  }, n.prototype.onClose = function() {
    this.readyState = "closed", this.emit("close");
  }, T0;
}
var E0 = {}, xk;
function yg() {
  return xk || (xk = 1, E0.encode = function(e) {
    var t = "";
    for (var n in e)
      e.hasOwnProperty(n) && (t.length && (t += "&"), t += encodeURIComponent(n) + "=" + encodeURIComponent(e[n]));
    return t;
  }, E0.decode = function(e) {
    for (var t = {}, n = e.split("&"), r = 0, o = n.length; r < o; r++) {
      var i = n[r].split("=");
      t[decodeURIComponent(i[0])] = decodeURIComponent(i[1]);
    }
    return t;
  }), E0;
}
var Ck, Sk;
function _g() {
  return Sk || (Sk = 1, Ck = function(e, t) {
    var n = function() {
    };
    n.prototype = t.prototype, e.prototype = new n(), e.prototype.constructor = e;
  }), Ck;
}
var k0, Tk;
function DD() {
  if (Tk)
    return k0;
  Tk = 1;
  var e = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz-_".split(""), t = 64, n = {}, r = 0, o = 0, i;
  function a(l) {
    var d = "";
    do
      d = e[l % t] + d, l = Math.floor(l / t);
    while (l > 0);
    return d;
  }
  function s(l) {
    var d = 0;
    for (o = 0; o < l.length; o++)
      d = d * t + n[l.charAt(o)];
    return d;
  }
  function c() {
    var l = a(+/* @__PURE__ */ new Date());
    return l !== i ? (r = 0, i = l) : l + "." + a(r++);
  }
  for (; o < t; o++)
    n[e[o]] = o;
  return c.encode = a, c.decode = s, k0 = c, k0;
}
var Kh = {}, toe = {
  get exports() {
    return Kh;
  },
  set exports(e) {
    Kh = e;
  }
}, Jh = {}, noe = {
  get exports() {
    return Jh;
  },
  set exports(e) {
    Jh = e;
  }
}, M0, Ek;
function roe() {
  if (Ek)
    return M0;
  Ek = 1;
  var e = 1e3, t = e * 60, n = t * 60, r = n * 24, o = r * 365.25;
  M0 = function(l, d) {
    d = d || {};
    var f = typeof l;
    if (f === "string" && l.length > 0)
      return i(l);
    if (f === "number" && isNaN(l) === !1)
      return d.long ? s(l) : a(l);
    throw new Error(
      "val is not a non-empty string or a valid number. val=" + JSON.stringify(l)
    );
  };
  function i(l) {
    if (l = String(l), !(l.length > 100)) {
      var d = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(
        l
      );
      if (d) {
        var f = parseFloat(d[1]), p = (d[2] || "ms").toLowerCase();
        switch (p) {
          case "years":
          case "year":
          case "yrs":
          case "yr":
          case "y":
            return f * o;
          case "days":
          case "day":
          case "d":
            return f * r;
          case "hours":
          case "hour":
          case "hrs":
          case "hr":
          case "h":
            return f * n;
          case "minutes":
          case "minute":
          case "mins":
          case "min":
          case "m":
            return f * t;
          case "seconds":
          case "second":
          case "secs":
          case "sec":
          case "s":
            return f * e;
          case "milliseconds":
          case "millisecond":
          case "msecs":
          case "msec":
          case "ms":
            return f;
          default:
            return;
        }
      }
    }
  }
  function a(l) {
    return l >= r ? Math.round(l / r) + "d" : l >= n ? Math.round(l / n) + "h" : l >= t ? Math.round(l / t) + "m" : l >= e ? Math.round(l / e) + "s" : l + "ms";
  }
  function s(l) {
    return c(l, r, "day") || c(l, n, "hour") || c(l, t, "minute") || c(l, e, "second") || l + " ms";
  }
  function c(l, d, f) {
    if (!(l < d))
      return l < d * 1.5 ? Math.floor(l / d) + " " + f : Math.ceil(l / d) + " " + f + "s";
  }
  return M0;
}
var kk;
function ooe() {
  return kk || (kk = 1, function(e, t) {
    t = e.exports = r.debug = r.default = r, t.coerce = c, t.disable = a, t.enable = i, t.enabled = s, t.humanize = roe(), t.instances = [], t.names = [], t.skips = [], t.formatters = {};
    function n(l) {
      var d = 0, f;
      for (f in l)
        d = (d << 5) - d + l.charCodeAt(f), d |= 0;
      return t.colors[Math.abs(d) % t.colors.length];
    }
    function r(l) {
      var d;
      function f() {
        if (f.enabled) {
          var p = f, m = +/* @__PURE__ */ new Date(), v = m - (d || m);
          p.diff = v, p.prev = d, p.curr = m, d = m;
          for (var g = new Array(arguments.length), b = 0; b < g.length; b++)
            g[b] = arguments[b];
          g[0] = t.coerce(g[0]), typeof g[0] != "string" && g.unshift("%O");
          var x = 0;
          g[0] = g[0].replace(/%([a-zA-Z%])/g, function(S, _) {
            if (S === "%%")
              return S;
            x++;
            var w = t.formatters[_];
            if (typeof w == "function") {
              var k = g[x];
              S = w.call(p, k), g.splice(x, 1), x--;
            }
            return S;
          }), t.formatArgs.call(p, g);
          var T = f.log || t.log || console.log.bind(console);
          T.apply(p, g);
        }
      }
      return f.namespace = l, f.enabled = t.enabled(l), f.useColors = t.useColors(), f.color = n(l), f.destroy = o, typeof t.init == "function" && t.init(f), t.instances.push(f), f;
    }
    function o() {
      var l = t.instances.indexOf(this);
      return l !== -1 ? (t.instances.splice(l, 1), !0) : !1;
    }
    function i(l) {
      t.save(l), t.names = [], t.skips = [];
      var d, f = (typeof l == "string" ? l : "").split(/[\s,]+/), p = f.length;
      for (d = 0; d < p; d++)
        f[d] && (l = f[d].replace(/\*/g, ".*?"), l[0] === "-" ? t.skips.push(new RegExp("^" + l.substr(1) + "$")) : t.names.push(new RegExp("^" + l + "$")));
      for (d = 0; d < t.instances.length; d++) {
        var m = t.instances[d];
        m.enabled = t.enabled(m.namespace);
      }
    }
    function a() {
      t.enable("");
    }
    function s(l) {
      if (l[l.length - 1] === "*")
        return !0;
      var d, f;
      for (d = 0, f = t.skips.length; d < f; d++)
        if (t.skips[d].test(l))
          return !1;
      for (d = 0, f = t.names.length; d < f; d++)
        if (t.names[d].test(l))
          return !0;
      return !1;
    }
    function c(l) {
      return l instanceof Error ? l.stack || l.message : l;
    }
  }(noe, Jh)), Jh;
}
var Mk;
function wg() {
  return Mk || (Mk = 1, function(e, t) {
    t = e.exports = ooe(), t.log = o, t.formatArgs = r, t.save = i, t.load = a, t.useColors = n, t.storage = typeof chrome != "undefined" && typeof chrome.storage != "undefined" ? chrome.storage.local : s(), t.colors = [
      "#0000CC",
      "#0000FF",
      "#0033CC",
      "#0033FF",
      "#0066CC",
      "#0066FF",
      "#0099CC",
      "#0099FF",
      "#00CC00",
      "#00CC33",
      "#00CC66",
      "#00CC99",
      "#00CCCC",
      "#00CCFF",
      "#3300CC",
      "#3300FF",
      "#3333CC",
      "#3333FF",
      "#3366CC",
      "#3366FF",
      "#3399CC",
      "#3399FF",
      "#33CC00",
      "#33CC33",
      "#33CC66",
      "#33CC99",
      "#33CCCC",
      "#33CCFF",
      "#6600CC",
      "#6600FF",
      "#6633CC",
      "#6633FF",
      "#66CC00",
      "#66CC33",
      "#9900CC",
      "#9900FF",
      "#9933CC",
      "#9933FF",
      "#99CC00",
      "#99CC33",
      "#CC0000",
      "#CC0033",
      "#CC0066",
      "#CC0099",
      "#CC00CC",
      "#CC00FF",
      "#CC3300",
      "#CC3333",
      "#CC3366",
      "#CC3399",
      "#CC33CC",
      "#CC33FF",
      "#CC6600",
      "#CC6633",
      "#CC9900",
      "#CC9933",
      "#CCCC00",
      "#CCCC33",
      "#FF0000",
      "#FF0033",
      "#FF0066",
      "#FF0099",
      "#FF00CC",
      "#FF00FF",
      "#FF3300",
      "#FF3333",
      "#FF3366",
      "#FF3399",
      "#FF33CC",
      "#FF33FF",
      "#FF6600",
      "#FF6633",
      "#FF9900",
      "#FF9933",
      "#FFCC00",
      "#FFCC33"
    ];
    function n() {
      return typeof window != "undefined" && window.process && window.process.type === "renderer" ? !0 : typeof navigator != "undefined" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/) ? !1 : typeof document != "undefined" && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance || // is firebug? http://stackoverflow.com/a/398120/376773
      typeof window != "undefined" && window.console && (window.console.firebug || window.console.exception && window.console.table) || // is firefox >= v31?
      // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
      typeof navigator != "undefined" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31 || // double check webkit in userAgent just in case we are in a worker
      typeof navigator != "undefined" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
    }
    t.formatters.j = function(c) {
      try {
        return JSON.stringify(c);
      } catch (l) {
        return "[UnexpectedJSONParseError]: " + l.message;
      }
    };
    function r(c) {
      var l = this.useColors;
      if (c[0] = (l ? "%c" : "") + this.namespace + (l ? " %c" : " ") + c[0] + (l ? "%c " : " ") + "+" + t.humanize(this.diff), !!l) {
        var d = "color: " + this.color;
        c.splice(1, 0, d, "color: inherit");
        var f = 0, p = 0;
        c[0].replace(/%[a-zA-Z%]/g, function(m) {
          m !== "%%" && (f++, m === "%c" && (p = f));
        }), c.splice(p, 0, d);
      }
    }
    function o() {
      return typeof console == "object" && console.log && Function.prototype.apply.call(console.log, console, arguments);
    }
    function i(c) {
      try {
        c == null ? t.storage.removeItem("debug") : t.storage.debug = c;
      } catch (l) {
      }
    }
    function a() {
      var c;
      try {
        c = t.storage.debug;
      } catch (l) {
      }
      return !c && typeof process != "undefined" && "env" in process && (c = process.env.DEBUG), c;
    }
    t.enable(a());
    function s() {
      try {
        return window.localStorage;
      } catch (c) {
      }
    }
  }(toe, Kh)), Kh;
}
var R0, Rk;
function ID() {
  if (Rk)
    return R0;
  Rk = 1;
  var e = Rw(), t = yg(), n = Rc(), r = _g(), o = DD(), i = wg()("engine.io-client:polling");
  R0 = s;
  var a = function() {
    var c = Mw(), l = new c({ xdomain: !1 });
    return l.responseType != null;
  }();
  function s(c) {
    var l = c && c.forceBase64;
    (!a || l) && (this.supportsBinary = !1), e.call(this, c);
  }
  return r(s, e), s.prototype.name = "polling", s.prototype.doOpen = function() {
    this.poll();
  }, s.prototype.pause = function(c) {
    var l = this;
    this.readyState = "pausing";
    function d() {
      i("paused"), l.readyState = "paused", c();
    }
    if (this.polling || !this.writable) {
      var f = 0;
      this.polling && (i("we are currently polling - waiting to pause"), f++, this.once("pollComplete", function() {
        i("pre-pause polling complete"), --f || d();
      })), this.writable || (i("we are currently writing - waiting to pause"), f++, this.once("drain", function() {
        i("pre-pause writing complete"), --f || d();
      }));
    } else
      d();
  }, s.prototype.poll = function() {
    i("polling"), this.polling = !0, this.doPoll(), this.emit("poll");
  }, s.prototype.onData = function(c) {
    var l = this;
    i("polling got data %s", c);
    var d = function(f, p, m) {
      if (l.readyState === "opening" && f.type === "open" && l.onOpen(), f.type === "close")
        return l.onClose(), !1;
      l.onPacket(f);
    };
    n.decodePayload(c, this.socket.binaryType, d), this.readyState !== "closed" && (this.polling = !1, this.emit("pollComplete"), this.readyState === "open" ? this.poll() : i('ignoring poll - transport state "%s"', this.readyState));
  }, s.prototype.doClose = function() {
    var c = this;
    function l() {
      i("writing close packet"), c.write([{ type: "close" }]);
    }
    this.readyState === "open" ? (i("transport open - closing"), l()) : (i("transport not open - deferring close"), this.once("open", l));
  }, s.prototype.write = function(c) {
    var l = this;
    this.writable = !1;
    var d = function() {
      l.writable = !0, l.emit("drain");
    };
    n.encodePayload(c, this.supportsBinary, function(f) {
      l.doWrite(f, d);
    });
  }, s.prototype.uri = function() {
    var c = this.query || {}, l = this.secure ? "https" : "http", d = "";
    this.timestampRequests !== !1 && (c[this.timestampParam] = o()), !this.supportsBinary && !c.sid && (c.b64 = 1), c = t.encode(c), this.port && (l === "https" && Number(this.port) !== 443 || l === "http" && Number(this.port) !== 80) && (d = ":" + this.port), c.length && (c = "?" + c);
    var f = this.hostname.indexOf(":") !== -1;
    return l + "://" + (f ? "[" + this.hostname + "]" : this.hostname) + d + this.path + c;
  }, R0;
}
var Pk;
function ioe() {
  if (Pk)
    return yd;
  Pk = 1;
  var e = Mw(), t = ID(), n = Gc(), r = _g(), o = wg()("engine.io-client:polling-xhr"), i = kw();
  Gre.exports = s, yd.Request = c;
  function a() {
  }
  function s(f) {
    if (t.call(this, f), this.requestTimeout = f.requestTimeout, this.extraHeaders = f.extraHeaders, typeof location != "undefined") {
      var p = location.protocol === "https:", m = location.port;
      m || (m = p ? 443 : 80), this.xd = typeof location != "undefined" && f.hostname !== location.hostname || m !== f.port, this.xs = f.secure !== p;
    }
  }
  r(s, t), s.prototype.supportsBinary = !0, s.prototype.request = function(f) {
    return f = f || {}, f.uri = this.uri(), f.xd = this.xd, f.xs = this.xs, f.agent = this.agent || !1, f.supportsBinary = this.supportsBinary, f.enablesXDR = this.enablesXDR, f.withCredentials = this.withCredentials, f.pfx = this.pfx, f.key = this.key, f.passphrase = this.passphrase, f.cert = this.cert, f.ca = this.ca, f.ciphers = this.ciphers, f.rejectUnauthorized = this.rejectUnauthorized, f.requestTimeout = this.requestTimeout, f.extraHeaders = this.extraHeaders, new c(f);
  }, s.prototype.doWrite = function(f, p) {
    var m = typeof f != "string" && f !== void 0, v = this.request({ method: "POST", data: f, isBinary: m }), g = this;
    v.on("success", p), v.on("error", function(b) {
      g.onError("xhr post error", b);
    }), this.sendXhr = v;
  }, s.prototype.doPoll = function() {
    o("xhr poll");
    var f = this.request(), p = this;
    f.on("data", function(m) {
      p.onData(m);
    }), f.on("error", function(m) {
      p.onError("xhr poll error", m);
    }), this.pollXhr = f;
  };
  function c(f) {
    this.method = f.method || "GET", this.uri = f.uri, this.xd = !!f.xd, this.xs = !!f.xs, this.async = f.async !== !1, this.data = f.data !== void 0 ? f.data : null, this.agent = f.agent, this.isBinary = f.isBinary, this.supportsBinary = f.supportsBinary, this.enablesXDR = f.enablesXDR, this.withCredentials = f.withCredentials, this.requestTimeout = f.requestTimeout, this.pfx = f.pfx, this.key = f.key, this.passphrase = f.passphrase, this.cert = f.cert, this.ca = f.ca, this.ciphers = f.ciphers, this.rejectUnauthorized = f.rejectUnauthorized, this.extraHeaders = f.extraHeaders, this.create();
  }
  if (n(c.prototype), c.prototype.create = function() {
    var f = { agent: this.agent, xdomain: this.xd, xscheme: this.xs, enablesXDR: this.enablesXDR };
    f.pfx = this.pfx, f.key = this.key, f.passphrase = this.passphrase, f.cert = this.cert, f.ca = this.ca, f.ciphers = this.ciphers, f.rejectUnauthorized = this.rejectUnauthorized;
    var p = this.xhr = new e(f), m = this;
    try {
      o("xhr open %s: %s", this.method, this.uri), p.open(this.method, this.uri, this.async);
      try {
        if (this.extraHeaders) {
          p.setDisableHeaderCheck && p.setDisableHeaderCheck(!0);
          for (var v in this.extraHeaders)
            this.extraHeaders.hasOwnProperty(v) && p.setRequestHeader(v, this.extraHeaders[v]);
        }
      } catch (g) {
      }
      if (this.method === "POST")
        try {
          this.isBinary ? p.setRequestHeader("Content-type", "application/octet-stream") : p.setRequestHeader("Content-type", "text/plain;charset=UTF-8");
        } catch (g) {
        }
      try {
        p.setRequestHeader("Accept", "*/*");
      } catch (g) {
      }
      "withCredentials" in p && (p.withCredentials = this.withCredentials), this.requestTimeout && (p.timeout = this.requestTimeout), this.hasXDR() ? (p.onload = function() {
        m.onLoad();
      }, p.onerror = function() {
        m.onError(p.responseText);
      }) : p.onreadystatechange = function() {
        if (p.readyState === 2)
          try {
            var g = p.getResponseHeader("Content-Type");
            (m.supportsBinary && g === "application/octet-stream" || g === "application/octet-stream; charset=UTF-8") && (p.responseType = "arraybuffer");
          } catch (b) {
          }
        p.readyState === 4 && (p.status === 200 || p.status === 1223 ? m.onLoad() : setTimeout(function() {
          m.onError(typeof p.status == "number" ? p.status : 0);
        }, 0));
      }, o("xhr data %s", this.data), p.send(this.data);
    } catch (g) {
      setTimeout(function() {
        m.onError(g);
      }, 0);
      return;
    }
    typeof document != "undefined" && (this.index = c.requestsCount++, c.requests[this.index] = this);
  }, c.prototype.onSuccess = function() {
    this.emit("success"), this.cleanup();
  }, c.prototype.onData = function(f) {
    this.emit("data", f), this.onSuccess();
  }, c.prototype.onError = function(f) {
    this.emit("error", f), this.cleanup(!0);
  }, c.prototype.cleanup = function(f) {
    if (!(typeof this.xhr == "undefined" || this.xhr === null)) {
      if (this.hasXDR() ? this.xhr.onload = this.xhr.onerror = a : this.xhr.onreadystatechange = a, f)
        try {
          this.xhr.abort();
        } catch (p) {
        }
      typeof document != "undefined" && delete c.requests[this.index], this.xhr = null;
    }
  }, c.prototype.onLoad = function() {
    var f;
    try {
      var p;
      try {
        p = this.xhr.getResponseHeader("Content-Type");
      } catch (m) {
      }
      p === "application/octet-stream" || p === "application/octet-stream; charset=UTF-8" ? f = this.xhr.response || this.xhr.responseText : f = this.xhr.responseText;
    } catch (m) {
      this.onError(m);
    }
    f != null && this.onData(f);
  }, c.prototype.hasXDR = function() {
    return typeof XDomainRequest != "undefined" && !this.xs && this.enablesXDR;
  }, c.prototype.abort = function() {
    this.cleanup();
  }, c.requestsCount = 0, c.requests = {}, typeof document != "undefined") {
    if (typeof attachEvent == "function")
      attachEvent("onunload", d);
    else if (typeof addEventListener == "function") {
      var l = "onpagehide" in i ? "pagehide" : "unload";
      addEventListener(l, d, !1);
    }
  }
  function d() {
    for (var f in c.requests)
      c.requests.hasOwnProperty(f) && c.requests[f].abort();
  }
  return yd;
}
var P0, Ok;
function aoe() {
  if (Ok)
    return P0;
  Ok = 1;
  var e = ID(), t = _g(), n = kw();
  P0 = s;
  var r = /\n/g, o = /\\n/g, i;
  function a() {
  }
  function s(c) {
    e.call(this, c), this.query = this.query || {}, i || (i = n.___eio = n.___eio || []), this.index = i.length;
    var l = this;
    i.push(function(d) {
      l.onData(d);
    }), this.query.j = this.index, typeof addEventListener == "function" && addEventListener("beforeunload", function() {
      l.script && (l.script.onerror = a);
    }, !1);
  }
  return t(s, e), s.prototype.supportsBinary = !1, s.prototype.doClose = function() {
    this.script && (this.script.parentNode.removeChild(this.script), this.script = null), this.form && (this.form.parentNode.removeChild(this.form), this.form = null, this.iframe = null), e.prototype.doClose.call(this);
  }, s.prototype.doPoll = function() {
    var c = this, l = document.createElement("script");
    this.script && (this.script.parentNode.removeChild(this.script), this.script = null), l.async = !0, l.src = this.uri(), l.onerror = function(p) {
      c.onError("jsonp poll error", p);
    };
    var d = document.getElementsByTagName("script")[0];
    d ? d.parentNode.insertBefore(l, d) : (document.head || document.body).appendChild(l), this.script = l;
    var f = typeof navigator != "undefined" && /gecko/i.test(navigator.userAgent);
    f && setTimeout(function() {
      var p = document.createElement("iframe");
      document.body.appendChild(p), document.body.removeChild(p);
    }, 100);
  }, s.prototype.doWrite = function(c, l) {
    var d = this;
    if (!this.form) {
      var f = document.createElement("form"), p = document.createElement("textarea"), m = this.iframeId = "eio_iframe_" + this.index, v;
      f.className = "socketio", f.style.position = "absolute", f.style.top = "-1000px", f.style.left = "-1000px", f.target = m, f.method = "POST", f.setAttribute("accept-charset", "utf-8"), p.name = "d", f.appendChild(p), document.body.appendChild(f), this.form = f, this.area = p;
    }
    this.form.action = this.uri();
    function g() {
      b(), l();
    }
    function b() {
      if (d.iframe)
        try {
          d.form.removeChild(d.iframe);
        } catch (T) {
          d.onError("jsonp polling iframe removal error", T);
        }
      try {
        var x = '<iframe src="javascript:0" name="' + d.iframeId + '">';
        v = document.createElement(x);
      } catch (T) {
        v = document.createElement("iframe"), v.name = d.iframeId, v.src = "javascript:0";
      }
      v.id = d.iframeId, d.form.appendChild(v), d.iframe = v;
    }
    b(), c = c.replace(o, `\\
`), this.area.value = c.replace(r, "\\n");
    try {
      this.form.submit();
    } catch (x) {
    }
    this.iframe.attachEvent ? this.iframe.onreadystatechange = function() {
      d.iframe.readyState === "complete" && g();
    } : this.iframe.onload = g;
  }, P0;
}
const soe = {}, loe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: soe
}, Symbol.toStringTag, { value: "Module" })), coe = /* @__PURE__ */ wa(loe);
var O0, Nk;
function uoe() {
  if (Nk)
    return O0;
  Nk = 1;
  var e = Rw(), t = Rc(), n = yg(), r = _g(), o = DD(), i = wg()("engine.io-client:websocket"), a, s;
  if (typeof WebSocket != "undefined" ? a = WebSocket : typeof self != "undefined" && (a = self.WebSocket || self.MozWebSocket), typeof window == "undefined")
    try {
      s = coe;
    } catch (d) {
    }
  var c = a || s;
  O0 = l;
  function l(d) {
    var f = d && d.forceBase64;
    f && (this.supportsBinary = !1), this.perMessageDeflate = d.perMessageDeflate, this.usingBrowserWebSocket = a && !d.forceNode, this.protocols = d.protocols, this.usingBrowserWebSocket || (c = s), e.call(this, d);
  }
  return r(l, e), l.prototype.name = "websocket", l.prototype.supportsBinary = !0, l.prototype.doOpen = function() {
    if (this.check()) {
      var d = this.uri(), f = this.protocols, p = {};
      this.isReactNative || (p.agent = this.agent, p.perMessageDeflate = this.perMessageDeflate, p.pfx = this.pfx, p.key = this.key, p.passphrase = this.passphrase, p.cert = this.cert, p.ca = this.ca, p.ciphers = this.ciphers, p.rejectUnauthorized = this.rejectUnauthorized), this.extraHeaders && (p.headers = this.extraHeaders), this.localAddress && (p.localAddress = this.localAddress);
      try {
        this.ws = this.usingBrowserWebSocket && !this.isReactNative ? f ? new c(d, f) : new c(d) : new c(d, f, p);
      } catch (m) {
        return this.emit("error", m);
      }
      this.ws.binaryType === void 0 && (this.supportsBinary = !1), this.ws.supports && this.ws.supports.binary ? (this.supportsBinary = !0, this.ws.binaryType = "nodebuffer") : this.ws.binaryType = "arraybuffer", this.addEventListeners();
    }
  }, l.prototype.addEventListeners = function() {
    var d = this;
    this.ws.onopen = function() {
      d.onOpen();
    }, this.ws.onclose = function() {
      d.onClose();
    }, this.ws.onmessage = function(f) {
      d.onData(f.data);
    }, this.ws.onerror = function(f) {
      d.onError("websocket error", f);
    };
  }, l.prototype.write = function(d) {
    var f = this;
    this.writable = !1;
    for (var p = d.length, m = 0, v = p; m < v; m++)
      (function(b) {
        t.encodePacket(b, f.supportsBinary, function(x) {
          if (!f.usingBrowserWebSocket) {
            var T = {};
            if (b.options && (T.compress = b.options.compress), f.perMessageDeflate) {
              var S = typeof x == "string" ? Buffer.byteLength(x) : x.length;
              S < f.perMessageDeflate.threshold && (T.compress = !1);
            }
          }
          try {
            f.usingBrowserWebSocket ? f.ws.send(x) : f.ws.send(x, T);
          } catch (_) {
            i("websocket closed before onclose event");
          }
          --p || g();
        });
      })(d[m]);
    function g() {
      f.emit("flush"), setTimeout(function() {
        f.writable = !0, f.emit("drain");
      }, 0);
    }
  }, l.prototype.onClose = function() {
    e.prototype.onClose.call(this);
  }, l.prototype.doClose = function() {
    typeof this.ws != "undefined" && this.ws.close();
  }, l.prototype.uri = function() {
    var d = this.query || {}, f = this.secure ? "wss" : "ws", p = "";
    this.port && (f === "wss" && Number(this.port) !== 443 || f === "ws" && Number(this.port) !== 80) && (p = ":" + this.port), this.timestampRequests && (d[this.timestampParam] = o()), this.supportsBinary || (d.b64 = 1), d = n.encode(d), d.length && (d = "?" + d);
    var m = this.hostname.indexOf(":") !== -1;
    return f + "://" + (m ? "[" + this.hostname + "]" : this.hostname) + p + this.path + d;
  }, l.prototype.check = function() {
    return !!c && !("__initialize" in c && this.name === l.prototype.name);
  }, O0;
}
var Ak;
function Dk() {
  if (Ak)
    return bp;
  Ak = 1;
  var e = Mw(), t = ioe(), n = aoe(), r = uoe();
  bp.polling = o, bp.websocket = r;
  function o(i) {
    var a, s = !1, c = !1, l = i.jsonp !== !1;
    if (typeof location != "undefined") {
      var d = location.protocol === "https:", f = location.port;
      f || (f = d ? 443 : 80), s = i.hostname !== location.hostname || f !== i.port, c = i.secure !== d;
    }
    if (i.xdomain = s, i.xscheme = c, a = new e(i), "open" in a && !i.forceJSONP)
      return new t(i);
    if (!l)
      throw new Error("JSONP disabled");
    return new n(i);
  }
  return bp;
}
var N0, Ik;
function LD() {
  if (Ik)
    return N0;
  Ik = 1;
  var e = [].indexOf;
  return N0 = function(t, n) {
    if (e)
      return t.indexOf(n);
    for (var r = 0; r < t.length; ++r)
      if (t[r] === n)
        return r;
    return -1;
  }, N0;
}
var A0, Lk;
function doe() {
  if (Lk)
    return A0;
  Lk = 1;
  var e = Dk(), t = Gc(), n = wg()("engine.io-client:socket"), r = LD(), o = Rc(), i = PD(), a = yg();
  A0 = s;
  function s(l, d) {
    if (!(this instanceof s))
      return new s(l, d);
    d = d || {}, l && typeof l == "object" && (d = l, l = null), l ? (l = i(l), d.hostname = l.host, d.secure = l.protocol === "https" || l.protocol === "wss", d.port = l.port, l.query && (d.query = l.query)) : d.host && (d.hostname = i(d.host).host), this.secure = d.secure != null ? d.secure : typeof location != "undefined" && location.protocol === "https:", d.hostname && !d.port && (d.port = this.secure ? "443" : "80"), this.agent = d.agent || !1, this.hostname = d.hostname || (typeof location != "undefined" ? location.hostname : "localhost"), this.port = d.port || (typeof location != "undefined" && location.port ? location.port : this.secure ? 443 : 80), this.query = d.query || {}, typeof this.query == "string" && (this.query = a.decode(this.query)), this.upgrade = d.upgrade !== !1, this.path = (d.path || "/engine.io").replace(/\/$/, "") + "/", this.forceJSONP = !!d.forceJSONP, this.jsonp = d.jsonp !== !1, this.forceBase64 = !!d.forceBase64, this.enablesXDR = !!d.enablesXDR, this.withCredentials = d.withCredentials !== !1, this.timestampParam = d.timestampParam || "t", this.timestampRequests = d.timestampRequests, this.transports = d.transports || ["polling", "websocket"], this.transportOptions = d.transportOptions || {}, this.readyState = "", this.writeBuffer = [], this.prevBufferLen = 0, this.policyPort = d.policyPort || 843, this.rememberUpgrade = d.rememberUpgrade || !1, this.binaryType = null, this.onlyBinaryUpgrades = d.onlyBinaryUpgrades, this.perMessageDeflate = d.perMessageDeflate !== !1 ? d.perMessageDeflate || {} : !1, this.perMessageDeflate === !0 && (this.perMessageDeflate = {}), this.perMessageDeflate && this.perMessageDeflate.threshold == null && (this.perMessageDeflate.threshold = 1024), this.pfx = d.pfx || void 0, this.key = d.key || void 0, this.passphrase = d.passphrase || void 0, this.cert = d.cert || void 0, this.ca = d.ca || void 0, this.ciphers = d.ciphers || void 0, this.rejectUnauthorized = d.rejectUnauthorized === void 0 ? !0 : d.rejectUnauthorized, this.forceNode = !!d.forceNode, this.isReactNative = typeof navigator != "undefined" && typeof navigator.product == "string" && navigator.product.toLowerCase() === "reactnative", (typeof self == "undefined" || this.isReactNative) && (d.extraHeaders && Object.keys(d.extraHeaders).length > 0 && (this.extraHeaders = d.extraHeaders), d.localAddress && (this.localAddress = d.localAddress)), this.id = null, this.upgrades = null, this.pingInterval = null, this.pingTimeout = null, this.pingIntervalTimer = null, this.pingTimeoutTimer = null, this.open();
  }
  s.priorWebsocketSuccess = !1, t(s.prototype), s.protocol = o.protocol, s.Socket = s, s.Transport = Rw(), s.transports = Dk(), s.parser = Rc(), s.prototype.createTransport = function(l) {
    n('creating transport "%s"', l);
    var d = c(this.query);
    d.EIO = o.protocol, d.transport = l;
    var f = this.transportOptions[l] || {};
    this.id && (d.sid = this.id);
    var p = new e[l]({
      query: d,
      socket: this,
      agent: f.agent || this.agent,
      hostname: f.hostname || this.hostname,
      port: f.port || this.port,
      secure: f.secure || this.secure,
      path: f.path || this.path,
      forceJSONP: f.forceJSONP || this.forceJSONP,
      jsonp: f.jsonp || this.jsonp,
      forceBase64: f.forceBase64 || this.forceBase64,
      enablesXDR: f.enablesXDR || this.enablesXDR,
      withCredentials: f.withCredentials || this.withCredentials,
      timestampRequests: f.timestampRequests || this.timestampRequests,
      timestampParam: f.timestampParam || this.timestampParam,
      policyPort: f.policyPort || this.policyPort,
      pfx: f.pfx || this.pfx,
      key: f.key || this.key,
      passphrase: f.passphrase || this.passphrase,
      cert: f.cert || this.cert,
      ca: f.ca || this.ca,
      ciphers: f.ciphers || this.ciphers,
      rejectUnauthorized: f.rejectUnauthorized || this.rejectUnauthorized,
      perMessageDeflate: f.perMessageDeflate || this.perMessageDeflate,
      extraHeaders: f.extraHeaders || this.extraHeaders,
      forceNode: f.forceNode || this.forceNode,
      localAddress: f.localAddress || this.localAddress,
      requestTimeout: f.requestTimeout || this.requestTimeout,
      protocols: f.protocols || void 0,
      isReactNative: this.isReactNative
    });
    return p;
  };
  function c(l) {
    var d = {};
    for (var f in l)
      l.hasOwnProperty(f) && (d[f] = l[f]);
    return d;
  }
  return s.prototype.open = function() {
    var l;
    if (this.rememberUpgrade && s.priorWebsocketSuccess && this.transports.indexOf("websocket") !== -1)
      l = "websocket";
    else if (this.transports.length === 0) {
      var d = this;
      setTimeout(function() {
        d.emit("error", "No transports available");
      }, 0);
      return;
    } else
      l = this.transports[0];
    this.readyState = "opening";
    try {
      l = this.createTransport(l);
    } catch (f) {
      this.transports.shift(), this.open();
      return;
    }
    l.open(), this.setTransport(l);
  }, s.prototype.setTransport = function(l) {
    n("setting transport %s", l.name);
    var d = this;
    this.transport && (n("clearing existing transport %s", this.transport.name), this.transport.removeAllListeners()), this.transport = l, l.on("drain", function() {
      d.onDrain();
    }).on("packet", function(f) {
      d.onPacket(f);
    }).on("error", function(f) {
      d.onError(f);
    }).on("close", function() {
      d.onClose("transport close");
    });
  }, s.prototype.probe = function(l) {
    n('probing transport "%s"', l);
    var d = this.createTransport(l, { probe: 1 }), f = !1, p = this;
    s.priorWebsocketSuccess = !1;
    function m() {
      if (p.onlyBinaryUpgrades) {
        var _ = !this.supportsBinary && p.transport.supportsBinary;
        f = f || _;
      }
      f || (n('probe transport "%s" opened', l), d.send([{ type: "ping", data: "probe" }]), d.once("packet", function(w) {
        if (!f)
          if (w.type === "pong" && w.data === "probe") {
            if (n('probe transport "%s" pong', l), p.upgrading = !0, p.emit("upgrading", d), !d)
              return;
            s.priorWebsocketSuccess = d.name === "websocket", n('pausing current transport "%s"', p.transport.name), p.transport.pause(function() {
              f || p.readyState !== "closed" && (n("changing transport and sending upgrade packet"), S(), p.setTransport(d), d.send([{ type: "upgrade" }]), p.emit("upgrade", d), d = null, p.upgrading = !1, p.flush());
            });
          } else {
            n('probe transport "%s" failed', l);
            var k = new Error("probe error");
            k.transport = d.name, p.emit("upgradeError", k);
          }
      }));
    }
    function v() {
      f || (f = !0, S(), d.close(), d = null);
    }
    function g(_) {
      var w = new Error("probe error: " + _);
      w.transport = d.name, v(), n('probe transport "%s" failed because of error: %s', l, _), p.emit("upgradeError", w);
    }
    function b() {
      g("transport closed");
    }
    function x() {
      g("socket closed");
    }
    function T(_) {
      d && _.name !== d.name && (n('"%s" works - aborting "%s"', _.name, d.name), v());
    }
    function S() {
      d.removeListener("open", m), d.removeListener("error", g), d.removeListener("close", b), p.removeListener("close", x), p.removeListener("upgrading", T);
    }
    d.once("open", m), d.once("error", g), d.once("close", b), this.once("close", x), this.once("upgrading", T), d.open();
  }, s.prototype.onOpen = function() {
    if (n("socket open"), this.readyState = "open", s.priorWebsocketSuccess = this.transport.name === "websocket", this.emit("open"), this.flush(), this.readyState === "open" && this.upgrade && this.transport.pause) {
      n("starting upgrade probes");
      for (var l = 0, d = this.upgrades.length; l < d; l++)
        this.probe(this.upgrades[l]);
    }
  }, s.prototype.onPacket = function(l) {
    if (this.readyState === "opening" || this.readyState === "open" || this.readyState === "closing")
      switch (n('socket receive: type "%s", data "%s"', l.type, l.data), this.emit("packet", l), this.emit("heartbeat"), l.type) {
        case "open":
          this.onHandshake(JSON.parse(l.data));
          break;
        case "pong":
          this.setPing(), this.emit("pong");
          break;
        case "error":
          var d = new Error("server error");
          d.code = l.data, this.onError(d);
          break;
        case "message":
          this.emit("data", l.data), this.emit("message", l.data);
          break;
      }
    else
      n('packet received with socket readyState "%s"', this.readyState);
  }, s.prototype.onHandshake = function(l) {
    this.emit("handshake", l), this.id = l.sid, this.transport.query.sid = l.sid, this.upgrades = this.filterUpgrades(l.upgrades), this.pingInterval = l.pingInterval, this.pingTimeout = l.pingTimeout, this.onOpen(), this.readyState !== "closed" && (this.setPing(), this.removeListener("heartbeat", this.onHeartbeat), this.on("heartbeat", this.onHeartbeat));
  }, s.prototype.onHeartbeat = function(l) {
    clearTimeout(this.pingTimeoutTimer);
    var d = this;
    d.pingTimeoutTimer = setTimeout(function() {
      d.readyState !== "closed" && d.onClose("ping timeout");
    }, l || d.pingInterval + d.pingTimeout);
  }, s.prototype.setPing = function() {
    var l = this;
    clearTimeout(l.pingIntervalTimer), l.pingIntervalTimer = setTimeout(function() {
      n("writing ping packet - expecting pong within %sms", l.pingTimeout), l.ping(), l.onHeartbeat(l.pingTimeout);
    }, l.pingInterval);
  }, s.prototype.ping = function() {
    var l = this;
    this.sendPacket("ping", function() {
      l.emit("ping");
    });
  }, s.prototype.onDrain = function() {
    this.writeBuffer.splice(0, this.prevBufferLen), this.prevBufferLen = 0, this.writeBuffer.length === 0 ? this.emit("drain") : this.flush();
  }, s.prototype.flush = function() {
    this.readyState !== "closed" && this.transport.writable && !this.upgrading && this.writeBuffer.length && (n("flushing %d packets in socket", this.writeBuffer.length), this.transport.send(this.writeBuffer), this.prevBufferLen = this.writeBuffer.length, this.emit("flush"));
  }, s.prototype.write = s.prototype.send = function(l, d, f) {
    return this.sendPacket("message", l, d, f), this;
  }, s.prototype.sendPacket = function(l, d, f, p) {
    if (typeof d == "function" && (p = d, d = void 0), typeof f == "function" && (p = f, f = null), !(this.readyState === "closing" || this.readyState === "closed")) {
      f = f || {}, f.compress = f.compress !== !1;
      var m = {
        type: l,
        data: d,
        options: f
      };
      this.emit("packetCreate", m), this.writeBuffer.push(m), p && this.once("flush", p), this.flush();
    }
  }, s.prototype.close = function() {
    if (this.readyState === "opening" || this.readyState === "open") {
      this.readyState = "closing";
      var l = this;
      this.writeBuffer.length ? this.once("drain", function() {
        this.upgrading ? p() : d();
      }) : this.upgrading ? p() : d();
    }
    function d() {
      l.onClose("forced close"), n("socket closing - telling transport to close"), l.transport.close();
    }
    function f() {
      l.removeListener("upgrade", f), l.removeListener("upgradeError", f), d();
    }
    function p() {
      l.once("upgrade", f), l.once("upgradeError", f);
    }
    return this;
  }, s.prototype.onError = function(l) {
    n("socket error %j", l), s.priorWebsocketSuccess = !1, this.emit("error", l), this.onClose("transport error", l);
  }, s.prototype.onClose = function(l, d) {
    if (this.readyState === "opening" || this.readyState === "open" || this.readyState === "closing") {
      n('socket close with reason: "%s"', l);
      var f = this;
      clearTimeout(this.pingIntervalTimer), clearTimeout(this.pingTimeoutTimer), this.transport.removeAllListeners("close"), this.transport.close(), this.transport.removeAllListeners(), this.readyState = "closed", this.id = null, this.emit("close", l, d), f.writeBuffer = [], f.prevBufferLen = 0;
    }
  }, s.prototype.filterUpgrades = function(l) {
    for (var d = [], f = 0, p = l.length; f < p; f++)
      ~r(this.transports, l[f]) && d.push(l[f]);
    return d;
  }, A0;
}
var $k;
function foe() {
  return $k || ($k = 1, function(e) {
    e.exports = doe(), e.exports.parser = Rc();
  }(Ure)), Wy;
}
var Vy = {}, poe = {
  get exports() {
    return Vy;
  },
  set exports(e) {
    Vy = e;
  }
}, D0, Fk;
function hoe() {
  if (Fk)
    return D0;
  Fk = 1, D0 = e;
  function e(t, n) {
    var r = [];
    n = n || 0;
    for (var o = n || 0; o < t.length; o++)
      r[o - n] = t[o];
    return r;
  }
  return D0;
}
var I0, zk;
function $D() {
  if (zk)
    return I0;
  zk = 1, I0 = e;
  function e(t, n, r) {
    return t.on(n, r), {
      destroy: function() {
        t.removeListener(n, r);
      }
    };
  }
  return I0;
}
var L0, Bk;
function FD() {
  if (Bk)
    return L0;
  Bk = 1;
  var e = [].slice;
  return L0 = function(t, n) {
    if (typeof n == "string" && (n = t[n]), typeof n != "function")
      throw new Error("bind() requires a function");
    var r = e.call(arguments, 2);
    return function() {
      return n.apply(t, r.concat(e.call(arguments)));
    };
  }, L0;
}
var Hk;
function zD() {
  return Hk || (Hk = 1, function(e, t) {
    var n = Ew(), r = Gc(), o = hoe(), i = $D(), a = FD(), s = bg()("socket.io-client:socket"), c = yg(), l = AD();
    e.exports = p;
    var d = {
      connect: 1,
      connect_error: 1,
      connect_timeout: 1,
      connecting: 1,
      disconnect: 1,
      error: 1,
      reconnect: 1,
      reconnect_attempt: 1,
      reconnect_failed: 1,
      reconnect_error: 1,
      reconnecting: 1,
      ping: 1,
      pong: 1
    }, f = r.prototype.emit;
    function p(m, v, g) {
      this.io = m, this.nsp = v, this.json = this, this.ids = 0, this.acks = {}, this.receiveBuffer = [], this.sendBuffer = [], this.connected = !1, this.disconnected = !0, this.flags = {}, g && g.query && (this.query = g.query), this.io.autoConnect && this.open();
    }
    r(p.prototype), p.prototype.subEvents = function() {
      if (!this.subs) {
        var m = this.io;
        this.subs = [
          i(m, "open", a(this, "onopen")),
          i(m, "packet", a(this, "onpacket")),
          i(m, "close", a(this, "onclose"))
        ];
      }
    }, p.prototype.open = p.prototype.connect = function() {
      return this.connected ? this : (this.subEvents(), this.io.reconnecting || this.io.open(), this.io.readyState === "open" && this.onopen(), this.emit("connecting"), this);
    }, p.prototype.send = function() {
      var m = o(arguments);
      return m.unshift("message"), this.emit.apply(this, m), this;
    }, p.prototype.emit = function(m) {
      if (d.hasOwnProperty(m))
        return f.apply(this, arguments), this;
      var v = o(arguments), g = {
        type: (this.flags.binary !== void 0 ? this.flags.binary : l(v)) ? n.BINARY_EVENT : n.EVENT,
        data: v
      };
      return g.options = {}, g.options.compress = !this.flags || this.flags.compress !== !1, typeof v[v.length - 1] == "function" && (s("emitting packet with ack id %d", this.ids), this.acks[this.ids] = v.pop(), g.id = this.ids++), this.connected ? this.packet(g) : this.sendBuffer.push(g), this.flags = {}, this;
    }, p.prototype.packet = function(m) {
      m.nsp = this.nsp, this.io.packet(m);
    }, p.prototype.onopen = function() {
      if (s("transport is open - connecting"), this.nsp !== "/")
        if (this.query) {
          var m = typeof this.query == "object" ? c.encode(this.query) : this.query;
          s("sending connect packet with query %s", m), this.packet({ type: n.CONNECT, query: m });
        } else
          this.packet({ type: n.CONNECT });
    }, p.prototype.onclose = function(m) {
      s("close (%s)", m), this.connected = !1, this.disconnected = !0, delete this.id, this.emit("disconnect", m);
    }, p.prototype.onpacket = function(m) {
      var v = m.nsp === this.nsp, g = m.type === n.ERROR && m.nsp === "/";
      if (!(!v && !g))
        switch (m.type) {
          case n.CONNECT:
            this.onconnect();
            break;
          case n.EVENT:
            this.onevent(m);
            break;
          case n.BINARY_EVENT:
            this.onevent(m);
            break;
          case n.ACK:
            this.onack(m);
            break;
          case n.BINARY_ACK:
            this.onack(m);
            break;
          case n.DISCONNECT:
            this.ondisconnect();
            break;
          case n.ERROR:
            this.emit("error", m.data);
            break;
        }
    }, p.prototype.onevent = function(m) {
      var v = m.data || [];
      s("emitting event %j", v), m.id != null && (s("attaching ack callback to event"), v.push(this.ack(m.id))), this.connected ? f.apply(this, v) : this.receiveBuffer.push(v);
    }, p.prototype.ack = function(m) {
      var v = this, g = !1;
      return function() {
        if (!g) {
          g = !0;
          var b = o(arguments);
          s("sending ack %j", b), v.packet({
            type: l(b) ? n.BINARY_ACK : n.ACK,
            id: m,
            data: b
          });
        }
      };
    }, p.prototype.onack = function(m) {
      var v = this.acks[m.id];
      typeof v == "function" ? (s("calling ack %s with %j", m.id, m.data), v.apply(this, m.data), delete this.acks[m.id]) : s("bad ack %s", m.id);
    }, p.prototype.onconnect = function() {
      this.connected = !0, this.disconnected = !1, this.emitBuffered(), this.emit("connect");
    }, p.prototype.emitBuffered = function() {
      var m;
      for (m = 0; m < this.receiveBuffer.length; m++)
        f.apply(this, this.receiveBuffer[m]);
      for (this.receiveBuffer = [], m = 0; m < this.sendBuffer.length; m++)
        this.packet(this.sendBuffer[m]);
      this.sendBuffer = [];
    }, p.prototype.ondisconnect = function() {
      s("server disconnect (%s)", this.nsp), this.destroy(), this.onclose("io server disconnect");
    }, p.prototype.destroy = function() {
      if (this.subs) {
        for (var m = 0; m < this.subs.length; m++)
          this.subs[m].destroy();
        this.subs = null;
      }
      this.io.destroy(this);
    }, p.prototype.close = p.prototype.disconnect = function() {
      return this.connected && (s("performing disconnect (%s)", this.nsp), this.packet({ type: n.DISCONNECT })), this.destroy(), this.connected && this.onclose("io client disconnect"), this;
    }, p.prototype.compress = function(m) {
      return this.flags.compress = m, this;
    }, p.prototype.binary = function(m) {
      return this.flags.binary = m, this;
    };
  }(poe)), Vy;
}
var $0, jk;
function moe() {
  if (jk)
    return $0;
  jk = 1, $0 = e;
  function e(t) {
    t = t || {}, this.ms = t.min || 100, this.max = t.max || 1e4, this.factor = t.factor || 2, this.jitter = t.jitter > 0 && t.jitter <= 1 ? t.jitter : 0, this.attempts = 0;
  }
  return e.prototype.duration = function() {
    var t = this.ms * Math.pow(this.factor, this.attempts++);
    if (this.jitter) {
      var n = Math.random(), r = Math.floor(n * this.jitter * t);
      t = Math.floor(n * 10) & 1 ? t + r : t - r;
    }
    return Math.min(t, this.max) | 0;
  }, e.prototype.reset = function() {
    this.attempts = 0;
  }, e.prototype.setMin = function(t) {
    this.ms = t;
  }, e.prototype.setMax = function(t) {
    this.max = t;
  }, e.prototype.setJitter = function(t) {
    this.jitter = t;
  }, $0;
}
var F0, Wk;
function Vk() {
  if (Wk)
    return F0;
  Wk = 1;
  var e = foe(), t = zD(), n = Gc(), r = Ew(), o = $D(), i = FD(), a = bg()("socket.io-client:manager"), s = LD(), c = moe(), l = Object.prototype.hasOwnProperty;
  F0 = d;
  function d(f, p) {
    if (!(this instanceof d))
      return new d(f, p);
    f && typeof f == "object" && (p = f, f = void 0), p = p || {}, p.path = p.path || "/socket.io", this.nsps = {}, this.subs = [], this.opts = p, this.reconnection(p.reconnection !== !1), this.reconnectionAttempts(p.reconnectionAttempts || 1 / 0), this.reconnectionDelay(p.reconnectionDelay || 1e3), this.reconnectionDelayMax(p.reconnectionDelayMax || 5e3), this.randomizationFactor(p.randomizationFactor || 0.5), this.backoff = new c({
      min: this.reconnectionDelay(),
      max: this.reconnectionDelayMax(),
      jitter: this.randomizationFactor()
    }), this.timeout(p.timeout == null ? 2e4 : p.timeout), this.readyState = "closed", this.uri = f, this.connecting = [], this.lastPing = null, this.encoding = !1, this.packetBuffer = [];
    var m = p.parser || r;
    this.encoder = new m.Encoder(), this.decoder = new m.Decoder(), this.autoConnect = p.autoConnect !== !1, this.autoConnect && this.open();
  }
  return d.prototype.emitAll = function() {
    this.emit.apply(this, arguments);
    for (var f in this.nsps)
      l.call(this.nsps, f) && this.nsps[f].emit.apply(this.nsps[f], arguments);
  }, d.prototype.updateSocketIds = function() {
    for (var f in this.nsps)
      l.call(this.nsps, f) && (this.nsps[f].id = this.generateId(f));
  }, d.prototype.generateId = function(f) {
    return (f === "/" ? "" : f + "#") + this.engine.id;
  }, n(d.prototype), d.prototype.reconnection = function(f) {
    return arguments.length ? (this._reconnection = !!f, this) : this._reconnection;
  }, d.prototype.reconnectionAttempts = function(f) {
    return arguments.length ? (this._reconnectionAttempts = f, this) : this._reconnectionAttempts;
  }, d.prototype.reconnectionDelay = function(f) {
    return arguments.length ? (this._reconnectionDelay = f, this.backoff && this.backoff.setMin(f), this) : this._reconnectionDelay;
  }, d.prototype.randomizationFactor = function(f) {
    return arguments.length ? (this._randomizationFactor = f, this.backoff && this.backoff.setJitter(f), this) : this._randomizationFactor;
  }, d.prototype.reconnectionDelayMax = function(f) {
    return arguments.length ? (this._reconnectionDelayMax = f, this.backoff && this.backoff.setMax(f), this) : this._reconnectionDelayMax;
  }, d.prototype.timeout = function(f) {
    return arguments.length ? (this._timeout = f, this) : this._timeout;
  }, d.prototype.maybeReconnectOnOpen = function() {
    !this.reconnecting && this._reconnection && this.backoff.attempts === 0 && this.reconnect();
  }, d.prototype.open = d.prototype.connect = function(f, p) {
    if (a("readyState %s", this.readyState), ~this.readyState.indexOf("open"))
      return this;
    a("opening %s", this.uri), this.engine = e(this.uri, this.opts);
    var m = this.engine, v = this;
    this.readyState = "opening", this.skipReconnect = !1;
    var g = o(m, "open", function() {
      v.onopen(), f && f();
    }), b = o(m, "error", function(S) {
      if (a("connect_error"), v.cleanup(), v.readyState = "closed", v.emitAll("connect_error", S), f) {
        var _ = new Error("Connection error");
        _.data = S, f(_);
      } else
        v.maybeReconnectOnOpen();
    });
    if (this._timeout !== !1) {
      var x = this._timeout;
      a("connect attempt will timeout after %d", x), x === 0 && g.destroy();
      var T = setTimeout(function() {
        a("connect attempt timed out after %d", x), g.destroy(), m.close(), m.emit("error", "timeout"), v.emitAll("connect_timeout", x);
      }, x);
      this.subs.push({
        destroy: function() {
          clearTimeout(T);
        }
      });
    }
    return this.subs.push(g), this.subs.push(b), this;
  }, d.prototype.onopen = function() {
    a("open"), this.cleanup(), this.readyState = "open", this.emit("open");
    var f = this.engine;
    this.subs.push(o(f, "data", i(this, "ondata"))), this.subs.push(o(f, "ping", i(this, "onping"))), this.subs.push(o(f, "pong", i(this, "onpong"))), this.subs.push(o(f, "error", i(this, "onerror"))), this.subs.push(o(f, "close", i(this, "onclose"))), this.subs.push(o(this.decoder, "decoded", i(this, "ondecoded")));
  }, d.prototype.onping = function() {
    this.lastPing = /* @__PURE__ */ new Date(), this.emitAll("ping");
  }, d.prototype.onpong = function() {
    this.emitAll("pong", /* @__PURE__ */ new Date() - this.lastPing);
  }, d.prototype.ondata = function(f) {
    this.decoder.add(f);
  }, d.prototype.ondecoded = function(f) {
    this.emit("packet", f);
  }, d.prototype.onerror = function(f) {
    a("error", f), this.emitAll("error", f);
  }, d.prototype.socket = function(f, p) {
    var m = this.nsps[f];
    if (!m) {
      m = new t(this, f, p), this.nsps[f] = m;
      var v = this;
      m.on("connecting", g), m.on("connect", function() {
        m.id = v.generateId(f);
      }), this.autoConnect && g();
    }
    function g() {
      ~s(v.connecting, m) || v.connecting.push(m);
    }
    return m;
  }, d.prototype.destroy = function(f) {
    var p = s(this.connecting, f);
    ~p && this.connecting.splice(p, 1), !this.connecting.length && this.close();
  }, d.prototype.packet = function(f) {
    a("writing packet %j", f);
    var p = this;
    f.query && f.type === 0 && (f.nsp += "?" + f.query), p.encoding ? p.packetBuffer.push(f) : (p.encoding = !0, this.encoder.encode(f, function(m) {
      for (var v = 0; v < m.length; v++)
        p.engine.write(m[v], f.options);
      p.encoding = !1, p.processPacketQueue();
    }));
  }, d.prototype.processPacketQueue = function() {
    if (this.packetBuffer.length > 0 && !this.encoding) {
      var f = this.packetBuffer.shift();
      this.packet(f);
    }
  }, d.prototype.cleanup = function() {
    a("cleanup");
    for (var f = this.subs.length, p = 0; p < f; p++) {
      var m = this.subs.shift();
      m.destroy();
    }
    this.packetBuffer = [], this.encoding = !1, this.lastPing = null, this.decoder.destroy();
  }, d.prototype.close = d.prototype.disconnect = function() {
    a("disconnect"), this.skipReconnect = !0, this.reconnecting = !1, this.readyState === "opening" && this.cleanup(), this.backoff.reset(), this.readyState = "closed", this.engine && this.engine.close();
  }, d.prototype.onclose = function(f) {
    a("onclose"), this.cleanup(), this.backoff.reset(), this.readyState = "closed", this.emit("close", f), this._reconnection && !this.skipReconnect && this.reconnect();
  }, d.prototype.reconnect = function() {
    if (this.reconnecting || this.skipReconnect)
      return this;
    var f = this;
    if (this.backoff.attempts >= this._reconnectionAttempts)
      a("reconnect failed"), this.backoff.reset(), this.emitAll("reconnect_failed"), this.reconnecting = !1;
    else {
      var p = this.backoff.duration();
      a("will wait %dms before reconnect attempt", p), this.reconnecting = !0;
      var m = setTimeout(function() {
        f.skipReconnect || (a("attempting reconnect"), f.emitAll("reconnect_attempt", f.backoff.attempts), f.emitAll("reconnecting", f.backoff.attempts), !f.skipReconnect && f.open(function(v) {
          v ? (a("reconnect attempt error"), f.reconnecting = !1, f.reconnect(), f.emitAll("reconnect_error", v.data)) : (a("reconnect success"), f.onreconnect());
        }));
      }, p);
      this.subs.push({
        destroy: function() {
          clearTimeout(m);
        }
      });
    }
  }, d.prototype.onreconnect = function() {
    var f = this.backoff.attempts;
    this.reconnecting = !1, this.backoff.reset(), this.updateSocketIds(), this.emitAll("reconnect", f);
  }, F0;
}
var Uk;
function goe() {
  return Uk || (Uk = 1, function(e, t) {
    var n = $re(), r = Ew(), o = Vk(), i = bg()("socket.io-client");
    e.exports = t = s;
    var a = t.managers = {};
    function s(c, l) {
      typeof c == "object" && (l = c, c = void 0), l = l || {};
      var d = n(c), f = d.source, p = d.id, m = d.path, v = a[p] && m in a[p].nsps, g = l.forceNew || l["force new connection"] || l.multiplex === !1 || v, b;
      return g ? (i("ignoring socket cache for %s", f), b = o(f, l)) : (a[p] || (i("new io instance for %s", f), a[p] = o(f, l)), b = a[p]), d.query && !l.query && (l.query = d.query), b.socket(d.path, l);
    }
    t.protocol = r.protocol, t.connect = s, t.Manager = Vk(), t.Socket = zD();
  }(Nre, Uh)), Uh;
}
var voe = goe();
const boe = /* @__PURE__ */ ji(voe);
class Pw {
  constructor(t, n) {
    Z(this, "socket"), Z(this, "isRegistered", !1), Z(this, "isListening", !1), Z(this, "onMessageCallback"), typeof t == "string" ? (this.socket = Pw.createNewSocket(t, n), this.subcribeOnSocketReadiness()) : this.socket = t;
  }
  /**
   * Subscribes on socket readiness events
   */
  subcribeOnSocketReadiness() {
    this.socket.on("register", () => {
      this.isRegistered = !0;
    }), this.socket.on("listen", () => {
      this.isListening = !0;
    });
  }
  /**
   * Checks if socket is ready for sending messages or not
   *
   * @returns {boolean} - true - ready
   */
  isReady() {
    return this.isRegistered && this.isListening;
  }
  /**
   * Attach event handler
   *
   * @param {string} event - event name
   * @param {Function} cb - handler function
   * @returns {void}
   */
  on(t, n) {
    this.socket.on(t, n);
  }
  /**
   * Detach event handler
   *
   * @param {string} event - event name
   * @param {Function} cb - handler function
   * @returns {void}
   */
  off(t, n) {
    this.socket.off(t, n);
  }
  /**
   * Send message via socket
   *
   * @param {string} event - message name
   * @param {Array<any>} args - arguments
   * @param {Array<any>} args.0 - message data
   * @returns {void}
   */
  send(t, ...n) {
    const r = n[0];
    this.socket.emit(t, JSON.stringify(r));
  }
  /**
   * Specific message handler
   *
   * @param {string} type - message type
   * @param {string} subType - message subtype (query ID)
   * @param {Function} callback - handler function
   * @returns {Function} - unsubscribe function
   */
  onMessage(t, n, r) {
    this.onMessageCallback = r;
    const o = t || "", i = n || "", a = i ? `${o}-${i}` : o, s = (c) => {
      let l = null;
      try {
        l = JSON.parse(c);
      } catch (d) {
        throw new Error("Error parsing response message");
      }
      r(o, l);
    };
    return this.on(a, s), () => {
      this.off(a, s);
    };
  }
  /**
   * Emulate receiving message from socket
   *
   * @param {string} event - message type
   * @param {any} data - message data
   * @returns {void}
   */
  trigger(t, n) {
    this.onMessageCallback && this.onMessageCallback(t, n);
  }
  static createNewSocket(t, n) {
    const r = boe.connect(t, {
      path: "/gateway",
      transports: ["websocket"],
      reconnection: !0,
      query: n
    });
    return r.on("connect_error", (o) => {
      console.log(`connect_error due to ${o.message}`);
    }), r.on("connect", () => {
      r.emit("register", {});
    }), r.on("register", () => {
      r.emit('{"eventName": "_registerEvent", "data": "pivot2"}');
    }), r.on("error", (o) => {
      console.warn(`"SisenseSocket" socket error "${o}"`);
    }), r;
  }
}
const yp = {
  INCLUDE: [
    "metadata.$.jaql",
    "metadata.$.field",
    "metadata.$.panel",
    "metadata.$.hierarchies",
    "metadata.$.format",
    "metadata.$.disabled",
    "metadata.$.distinctTotals"
  ],
  EXCLUDE: [
    "metadata.$.jaql.title",
    "metadata.$.format.mask",
    "metadata.$.format.width",
    "queryGuid",
    "widget",
    "dashboard",
    "grandTotals.title"
  ]
};
class yoe {
  constructor(t) {
    Z(this, "logger"), Z(this, "events"), Z(this, "jaql"), Z(this, "data"), Z(this, "isLoadInProgress", !1), Z(this, "loadPromiseResolve"), Z(this, "loadPromiseReject"), Z(this, "loadFromCacheState"), Z(this, "loadFromCacheInitialTimer"), Z(this, "loadFromCacheTimer"), Z(this, "isSingleBranchTree", !1), Z(this, "loadedItemsCount", 0), Z(this, "totalItemsCount", 0), Z(this, "isLimited", !1), Z(this, "isFinishEventReceived", !1), this.events = t || new uf(), this.logger = ds.create("AbstractDataLoadService");
  }
  /**
   * Destroys data load service
   *
   * @returns {void}
   */
  destroy() {
    this.data = void 0, this.events.removeAllListeners();
  }
  /**
   * Return copy of load service
   *
   * @returns {DataLoadService} - cloned instance
   */
  clone() {
    const t = this.logger.getName();
    throw new Error(`"${t}.clone" should be overridden in subclass`);
  }
  /**
   * Start data loading according to JAQL request
   *
   * @param {JaqlRequest} jaql - JAQL request
   * @returns {Promise<any>} - whole data loading promise
   */
  load(t) {
    if (!t)
      throw new Error(`${this.logger.getName()} "jaql" is not defined for "load" method`);
    const n = !!this.data, r = this.jaql;
    this.jaql = t, n && r && (this.jaql.queryGuid = r.queryGuid), this.isLoadInProgress = !0;
    const o = new Promise((i, a) => {
      this.loadPromiseResolve = i, this.loadPromiseReject = a;
    });
    this.loadFromCacheInitialTimer && clearTimeout(this.loadFromCacheInitialTimer);
    try {
      n ? this.loadFromCache() : this.loadFromServer();
    } catch (i) {
      this.notifyAboutDataError(i);
    }
    return o;
  }
  /**
   * Clear data cache
   *
   * @returns {void}
   */
  clear() {
    this.data = void 0;
  }
  /**
   * Returns current jaql request object
   *
   * @returns {JaqlRequest} - jaql request object
   */
  getJaql() {
    return this.jaql;
  }
  /**
   * Defines data structure
   *
   * @returns {boolean} - true - single branch tree
   */
  isSingleRowTree() {
    return this.isSingleBranchTree;
  }
  /**
   * Returns total amount items count handled on back-end side
   *
   * @returns {number} - items count
   */
  getTotalItemsCount() {
    return this.totalItemsCount;
  }
  /**
   * Defines if new jaql has only formatting changes or it requires new data loading from server
   *
   * @param {JaqlRequest} jaql - jaql request object
   * @returns {boolean} - true - only formatting changes, can use cached data
   */
  isFormattingChanges(t) {
    const n = Br(this.jaql, {
      include: yp.INCLUDE,
      exclude: yp.EXCLUDE,
      excludeEmpty: !0
    }), r = Br(t, {
      include: yp.INCLUDE,
      exclude: yp.EXCLUDE,
      excludeEmpty: !0
    });
    return [...(n == null ? void 0 : n.metadata) || [], ...(r == null ? void 0 : r.metadata) || []].forEach(
      (o) => {
        o && o.panel === Ke.SCOPE && delete o.field;
      }
    ), JSON.stringify(n) === JSON.stringify(r);
  }
  /**
   * Defines if service have some data
   *
   * @returns {boolean} - true - has some data
   */
  hasData() {
    return !!(this.data && this.data[nt.DATA]);
  }
  /**
   * Defines if service have some error
   *
   * @returns {boolean} - true - has some error
   */
  hasError() {
    return this.data ? !!this.data[nt.ERROR] : !1;
  }
  /**
   * Start data loading from the server
   *
   * @returns {void}
   * @private
   */
  loadFromServer() {
    const t = this.logger.getName();
    throw new Error(`"${t}.loadFromServer" should be overridden in subclass`);
  }
  /**
   * Method for canceling the processing of query already sent
   *
   * @returns {Promise<void>} - waiting promise
   */
  cancelQuery() {
    const t = this.logger.getName(), n = new Error(`"${t}.cancelQuery" should be overridden in subclass.`);
    return Promise.reject(n);
  }
  /**
   * Method for detection if cancel query is still needed
   *
   * @returns {boolean} - is cancel query needed
   */
  isCancelQueryNeeded() {
    return !this.isFinishEventReceived;
  }
  /**
   * Start data loading from the cache
   *
   * @returns {Promise<void>} - waiting promise
   * @private
   */
  loadFromCache() {
    return Promise.resolve().then(() => (this.loadFromCacheInitialTimer && clearTimeout(this.loadFromCacheInitialTimer), new Promise((t) => {
      this.loadFromCacheInitialTimer = setTimeout(t);
    }))).then(
      () => new Promise((t) => {
        this.loadFromCacheTimer && clearImmediate(this.loadFromCacheTimer), this.loadFromCacheState = void 0, this.loadMessageFromCache(() => {
          this.loadFromCacheState = void 0, this.loadFromCacheTimer && clearImmediate(this.loadFromCacheTimer), t();
        });
      })
    );
  }
  /**
   * Starts loading data from cache queue
   *
   * @param {Function} onFinish - on finish callback
   * @returns {void}
   * @private
   */
  loadMessageFromCache(t) {
    this.loadFromCacheState = this.loadFromCacheState || {};
    const n = this.loadFromCacheState;
    let r = "", o = 0;
    if (Mj.forEach((i) => {
      r || (n[i] = n[i] || 0, n[i] < ((this.data || {})[i] || []).length && (r = i, o = n[i]));
    }), r) {
      const i = ((this.data || {})[r] || [])[o];
      this.notifyAboutDataChunk(r || "", i, !0), n[r] = o + 1, this.loadMessageFromCache(t);
    } else
      t && t();
  }
  /**
   * Cache appropriate message
   *
   * @param {string} type - message type
   * @param {any} data - message payload
   * @returns {void}
   * @private
   */
  cacheData(t, n) {
    this.data = this.data || {};
    const r = this.data;
    r && (r[t] = r[t] || [], r[t].push(n || !0));
  }
  /*
   *
   * @private
   */
  /**
   * Notify outside about data chunk with saving to inner cache, applying chunk formatting with
   * saving initial messages queue
   *
   * @param {string} type - data chunk type
   * @param {any} chunk - data chunk data
   * @param {boolean} isFromCache - mark data which already was cached
   * @returns {void}
   * @private
   */
  // eslint-disable-next-line sonarjs/cognitive-complexity
  notifyAboutDataChunk(t, n, r = !1) {
    this.logger.log("notifyAboutDataChunk", t, n, r);
    const o = n && n.data && t === nt.DATA ? n.data : n;
    if (r || this.cacheData(t, n), !r && this.loadFromCacheState)
      return;
    t === nt.METADATA && (this.isSingleBranchTree = !!(o && o.isSingleBranchTree)), t === nt.ERROR && this.notifyAboutDataError(o), t === nt.DATA_FINISH && (this.loadedItemsCount = o ? o.rowsCount : 0, this.notifyAboutDataLoaded(this.data)), t === nt.TOTAL_ROWS && (this.totalItemsCount = o ? o.rowsCount : 0, this.totalItemsCount !== this.loadedItemsCount && (this.isLimited = !0)), t === nt.FINISH && (this.isFinishEventReceived = !0);
    const i = Br(o);
    this.events.emit(t, i);
  }
  /**
   * Resolve "load" method with appropriate data information
   *
   * @param {any} data - data to resolve with
   * @returns {void}
   * @private
   */
  notifyAboutDataLoaded(t) {
    this.isLoadInProgress && (this.isLoadInProgress = !1, typeof this.loadPromiseResolve == "function" && (this.loadPromiseResolve(t), this.logger.log("notifyAboutDataLoaded")), this.loadPromiseReject = void 0, this.loadPromiseResolve = void 0);
  }
  /**
   * Reject "load" method with appropriate data information
   *
   * @param {any} data - data to reject with
   * @returns {void}
   * @private
   */
  notifyAboutDataError(t) {
    this.isLoadInProgress && (this.isLoadInProgress = !1, typeof this.loadPromiseReject == "function" && (this.loadPromiseReject(t), this.logger.log("notifyAboutDataError")), this.loadPromiseReject = void 0, this.loadPromiseResolve = void 0);
  }
  /**
   * Subscribe to event notification
   *
   * @param {string} eventName - event name to subscribe
   * @param {Function} callback - event handler
   * @returns {void}
   */
  on(t, n) {
    this.events.on(t, n);
  }
  /**
   * Unsubscribe from event notification
   *
   * @param {string} eventName - event name to unsubscribe
   * @param {Function} callback - event handler
   * @returns {void}
   */
  off(t, n) {
    this.events.removeListener(t, n);
  }
  /**
   * Unsubscribe from all event notifications
   *
   * @param {string} eventName - event name to unsubscribe
   * @returns {void}
   */
  offAll(t) {
    this.events.removeAllListeners(t);
  }
  listenerCount(t) {
    return this.events.listenerCount(t);
  }
  /**
   * Trigger event notification
   *
   * @param {string} eventName - event name to subscribe
   * @param {Array<any>} rest - arguments will be passed to event handler
   * @returns {void}
   */
  emit(t, ...n) {
    this.events.emit(t, ...n);
  }
}
class Ow extends yoe {
  constructor(t, n, r) {
    if (super(n), Z(this, "socket"), Z(this, "initPromise"), Z(this, "isInitInProgress", !1), Z(this, "onMessageCancel"), Z(this, "onSocketError", (o) => {
      this.emit("error", {
        error: !0,
        type: 500,
        details: `Socket error: ${o.message}`
      });
    }), Z(this, "onSocketDisconnect", () => {
      this.emit("error", {
        error: !0,
        type: 500,
        details: "Socket disconnected"
      });
    }), this.logger = r || ds.create("DataLoadService"), !t)
      throw new Error(`${this.logger.getName()} "socket" not defined.`);
    this.socket = t, this.socket.on("error", this.onSocketError), this.socket.on("disconnect", this.onSocketDisconnect), this.on(nt.ERROR, (o) => {
      const i = JSON.stringify(o, null, 4);
      process.env.NODE_ENV !== "production" && this.logger.console.warn(`${this.logger.getName()} error message: 
${i}`);
    });
  }
  destroy() {
    super.destroy(), this.onMessageCancel && (this.onMessageCancel(), this.onMessageCancel = void 0), this.socket.off("error", this.onSocketError), this.socket.off("disconnect", this.onSocketDisconnect);
  }
  /**
   * Return copy of load service
   *
   * @returns {DataLoadService} - cloned instance
   */
  clone() {
    const t = Br(this.data);
    t[nt.HEADERS] || (t[nt.HEADERS] = [{}]);
    const n = new Ow(this.socket);
    return n.data = t, n.jaql = this.jaql, n.isFinishEventReceived = this.isFinishEventReceived, n.isSingleBranchTree = this.isSingleBranchTree, n.loadedItemsCount = this.loadedItemsCount, n.totalItemsCount = this.totalItemsCount, n.isLimited = this.isLimited, n;
  }
  /**
   * Start data loading from the server
   *
   * @returns {void}
   * @private
   */
  loadFromServer() {
    this.waitForSocketReady().then(() => {
      this.onMessageCancel && this.onMessageCancel(), this.onMessageCancel = this.socket.onMessage(void 0, void 0, (t, n) => {
        this.logger.log("handleMessage", t, n), this.notifyAboutDataChunk(t, n);
      }), this.socket.send("pivot", this.jaql);
    });
  }
  /**
   * Method for canceling the processing of query already sent
   *
   * @returns {Promise<void>} - waiting promise
   */
  cancelQuery() {
    return this.isCancelQueryNeeded() ? this.waitForSocketReady().then(() => {
      this.socket.send("pivot/cancel-query", {
        // eslint-disable-next-line promise/always-return
        queryGuid: this.jaql && this.jaql.queryGuid
      });
    }) : Promise.resolve();
  }
  /**
   *  Wait for socket connection
   *
   * @returns {Promise<void>} - wait promise
   * @private
   */
  waitForSocketReady() {
    return this.socket.isReady() ? Promise.resolve() : this.isInitInProgress && this.initPromise ? this.initPromise : (this.isInitInProgress = !0, this.initPromise = new Promise((t, n) => {
      this.socket.on("open", () => {
        this.socket && this.socket.isReady() ? t() : n(new Error("Can not open WebSocket connection"));
      });
    }), this.initPromise);
  }
}
let _p;
const _oe = new Uint8Array(16);
function woe() {
  if (!_p && (_p = typeof crypto != "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto), !_p))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return _p(_oe);
}
const lr = [];
for (let e = 0; e < 256; ++e)
  lr.push((e + 256).toString(16).slice(1));
function xoe(e, t = 0) {
  return lr[e[t + 0]] + lr[e[t + 1]] + lr[e[t + 2]] + lr[e[t + 3]] + "-" + lr[e[t + 4]] + lr[e[t + 5]] + "-" + lr[e[t + 6]] + lr[e[t + 7]] + "-" + lr[e[t + 8]] + lr[e[t + 9]] + "-" + lr[e[t + 10]] + lr[e[t + 11]] + lr[e[t + 12]] + lr[e[t + 13]] + lr[e[t + 14]] + lr[e[t + 15]];
}
const Coe = typeof crypto != "undefined" && crypto.randomUUID && crypto.randomUUID.bind(crypto), qk = {
  randomUUID: Coe
};
function Soe(e, t, n) {
  if (qk.randomUUID && !t && !e)
    return qk.randomUUID();
  e = e || {};
  const r = e.random || (e.rng || woe)();
  return r[6] = r[6] & 15 | 64, r[8] = r[8] & 63 | 128, xoe(r);
}
class BD extends Ow {
  constructor(t, n, r = {}) {
    super(t, n), Z(this, "options"), Z(this, "registrationWaitTimer"), Z(this, "onMessageCancels", []), this.options = r, this.logger = ds.create("SisenseDataLoadService");
  }
  destroy() {
    super.destroy(), this.onMessageCancels.length && (this.onMessageCancels.forEach((t) => {
      t && t();
    }), this.onMessageCancels.length = 0);
  }
  /**
   * Start data loading from the server
   *
   * @returns {void}
   * @private
   */
  loadFromServer() {
    this.waitForSocketReady().then(() => {
      const t = pe({
        queryGuid: Soe()
      }, this.jaql), { queryGuid: n } = t;
      this.onMessageCancels.length && (this.onMessageCancels.forEach((r) => {
        r && r();
      }), this.onMessageCancels.length = 0), Object.values(nt).forEach((r) => {
        const o = this.socket.onMessage(r, n, (i, a) => {
          this.logger.log("handleMessage", i, a), this.notifyAboutDataChunk(i, a);
        });
        this.onMessageCancels.push(o);
      }), this.socket.send("pivot", t);
    });
  }
  /**
   * Wait for socket connection and registration
   *
   * @returns {Promise<*>} - wait promise
   * @private
   */
  waitForSocketReady() {
    return this.socket.isReady() ? Promise.resolve() : new Promise((t) => {
      const { socketRegisterCheckInterval: n = 100 } = this.options;
      this.registrationWaitTimer && clearInterval(this.registrationWaitTimer);
      const r = () => {
        this.socket.isReady() && (clearInterval(this.registrationWaitTimer), t());
      };
      this.registrationWaitTimer = setInterval(r, n);
    });
  }
}
const Toe = {
  type: "logger",
  log(e) {
    this.output("log", e);
  },
  warn(e) {
    this.output("warn", e);
  },
  error(e) {
    this.output("error", e);
  },
  output(e, t) {
    console && console[e] && console[e].apply(console, t);
  }
};
class Qh {
  constructor(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.init(t, n);
  }
  init(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.prefix = n.prefix || "i18next:", this.logger = t || Toe, this.options = n, this.debug = n.debug;
  }
  log() {
    for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
      n[r] = arguments[r];
    return this.forward(n, "log", "", !0);
  }
  warn() {
    for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
      n[r] = arguments[r];
    return this.forward(n, "warn", "", !0);
  }
  error() {
    for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
      n[r] = arguments[r];
    return this.forward(n, "error", "");
  }
  deprecate() {
    for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
      n[r] = arguments[r];
    return this.forward(n, "warn", "WARNING DEPRECATED: ", !0);
  }
  forward(t, n, r, o) {
    return o && !this.debug ? null : (typeof t[0] == "string" && (t[0] = `${r}${this.prefix} ${t[0]}`), this.logger[n](t));
  }
  create(t) {
    return new Qh(this.logger, pe({
      prefix: `${this.prefix}:${t}:`
    }, this.options));
  }
  clone(t) {
    return t = t || this.options, t.prefix = t.prefix || this.prefix, new Qh(this.logger, t);
  }
}
var Ei = new Qh();
class xg {
  constructor() {
    this.observers = {};
  }
  on(t, n) {
    return t.split(" ").forEach((r) => {
      this.observers[r] = this.observers[r] || [], this.observers[r].push(n);
    }), this;
  }
  off(t, n) {
    if (this.observers[t]) {
      if (!n) {
        delete this.observers[t];
        return;
      }
      this.observers[t] = this.observers[t].filter((r) => r !== n);
    }
  }
  emit(t) {
    for (var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), o = 1; o < n; o++)
      r[o - 1] = arguments[o];
    this.observers[t] && [].concat(this.observers[t]).forEach((i) => {
      i(...r);
    }), this.observers["*"] && [].concat(this.observers["*"]).forEach((i) => {
      i.apply(i, [t, ...r]);
    });
  }
}
function $u() {
  let e, t;
  const n = new Promise((r, o) => {
    e = r, t = o;
  });
  return n.resolve = e, n.reject = t, n;
}
function Gk(e) {
  return e == null ? "" : "" + e;
}
function Eoe(e, t, n) {
  e.forEach((r) => {
    t[r] && (n[r] = t[r]);
  });
}
function Nw(e, t, n) {
  function r(a) {
    return a && a.indexOf("###") > -1 ? a.replace(/###/g, ".") : a;
  }
  function o() {
    return !e || typeof e == "string";
  }
  const i = typeof t != "string" ? [].concat(t) : t.split(".");
  for (; i.length > 1; ) {
    if (o())
      return {};
    const a = r(i.shift());
    !e[a] && n && (e[a] = new n()), Object.prototype.hasOwnProperty.call(e, a) ? e = e[a] : e = {};
  }
  return o() ? {} : {
    obj: e,
    k: r(i.shift())
  };
}
function Yk(e, t, n) {
  const {
    obj: r,
    k: o
  } = Nw(e, t, Object);
  r[o] = n;
}
function koe(e, t, n, r) {
  const {
    obj: o,
    k: i
  } = Nw(e, t, Object);
  o[i] = o[i] || [], o[i].push(n);
}
function em(e, t) {
  const {
    obj: n,
    k: r
  } = Nw(e, t);
  if (n)
    return n[r];
}
function Moe(e, t, n) {
  const r = em(e, n);
  return r !== void 0 ? r : em(t, n);
}
function HD(e, t, n) {
  for (const r in t)
    r !== "__proto__" && r !== "constructor" && (r in e ? typeof e[r] == "string" || e[r] instanceof String || typeof t[r] == "string" || t[r] instanceof String ? n && (e[r] = t[r]) : HD(e[r], t[r], n) : e[r] = t[r]);
  return e;
}
function Il(e) {
  return e.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
}
var Roe = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;",
  "/": "&#x2F;"
};
function Poe(e) {
  return typeof e == "string" ? e.replace(/[&<>"'\/]/g, (t) => Roe[t]) : e;
}
const Ooe = [" ", ",", "?", "!", ";"];
function Noe(e, t, n) {
  t = t || "", n = n || "";
  const r = Ooe.filter((a) => t.indexOf(a) < 0 && n.indexOf(a) < 0);
  if (r.length === 0)
    return !0;
  const o = new RegExp(`(${r.map((a) => a === "?" ? "\\?" : a).join("|")})`);
  let i = !o.test(e);
  if (!i) {
    const a = e.indexOf(n);
    a > 0 && !o.test(e.substring(0, a)) && (i = !0);
  }
  return i;
}
function tm(e, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ".";
  if (!e)
    return;
  if (e[t])
    return e[t];
  const r = t.split(n);
  let o = e;
  for (let i = 0; i < r.length; ++i) {
    if (!o || typeof o[r[i]] == "string" && i + 1 < r.length)
      return;
    if (o[r[i]] === void 0) {
      let a = 2, s = r.slice(i, i + a).join(n), c = o[s];
      for (; c === void 0 && r.length > i + a; )
        a++, s = r.slice(i, i + a).join(n), c = o[s];
      if (c === void 0)
        return;
      if (c === null)
        return null;
      if (t.endsWith(s)) {
        if (typeof c == "string")
          return c;
        if (s && typeof c[s] == "string")
          return c[s];
      }
      const l = r.slice(i + a).join(n);
      return l ? tm(c, l, n) : void 0;
    }
    o = o[r[i]];
  }
  return o;
}
function nm(e) {
  return e && e.indexOf("_") > 0 ? e.replace("_", "-") : e;
}
class Zk extends xg {
  constructor(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      ns: ["translation"],
      defaultNS: "translation"
    };
    super(), this.data = t || {}, this.options = n, this.options.keySeparator === void 0 && (this.options.keySeparator = "."), this.options.ignoreJSONStructure === void 0 && (this.options.ignoreJSONStructure = !0);
  }
  addNamespaces(t) {
    this.options.ns.indexOf(t) < 0 && this.options.ns.push(t);
  }
  removeNamespaces(t) {
    const n = this.options.ns.indexOf(t);
    n > -1 && this.options.ns.splice(n, 1);
  }
  getResource(t, n, r) {
    let o = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    const i = o.keySeparator !== void 0 ? o.keySeparator : this.options.keySeparator, a = o.ignoreJSONStructure !== void 0 ? o.ignoreJSONStructure : this.options.ignoreJSONStructure;
    let s = [t, n];
    r && typeof r != "string" && (s = s.concat(r)), r && typeof r == "string" && (s = s.concat(i ? r.split(i) : r)), t.indexOf(".") > -1 && (s = t.split("."));
    const c = em(this.data, s);
    return c || !a || typeof r != "string" ? c : tm(this.data && this.data[t] && this.data[t][n], r, i);
  }
  addResource(t, n, r, o) {
    let i = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {
      silent: !1
    };
    const a = i.keySeparator !== void 0 ? i.keySeparator : this.options.keySeparator;
    let s = [t, n];
    r && (s = s.concat(a ? r.split(a) : r)), t.indexOf(".") > -1 && (s = t.split("."), o = n, n = s[1]), this.addNamespaces(n), Yk(this.data, s, o), i.silent || this.emit("added", t, n, r, o);
  }
  addResources(t, n, r) {
    let o = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {
      silent: !1
    };
    for (const i in r)
      (typeof r[i] == "string" || Object.prototype.toString.apply(r[i]) === "[object Array]") && this.addResource(t, n, i, r[i], {
        silent: !0
      });
    o.silent || this.emit("added", t, n, r);
  }
  addResourceBundle(t, n, r, o, i) {
    let a = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {
      silent: !1
    }, s = [t, n];
    t.indexOf(".") > -1 && (s = t.split("."), o = r, r = n, n = s[1]), this.addNamespaces(n);
    let c = em(this.data, s) || {};
    o ? HD(c, r, i) : c = pe(pe({}, c), r), Yk(this.data, s, c), a.silent || this.emit("added", t, n, r);
  }
  removeResourceBundle(t, n) {
    this.hasResourceBundle(t, n) && delete this.data[t][n], this.removeNamespaces(n), this.emit("removed", t, n);
  }
  hasResourceBundle(t, n) {
    return this.getResource(t, n) !== void 0;
  }
  getResourceBundle(t, n) {
    return n || (n = this.options.defaultNS), this.options.compatibilityAPI === "v1" ? pe({}, this.getResource(t, n)) : this.getResource(t, n);
  }
  getDataByLanguage(t) {
    return this.data[t];
  }
  hasLanguageSomeTranslations(t) {
    const n = this.getDataByLanguage(t);
    return !!(n && Object.keys(n) || []).find((r) => n[r] && Object.keys(n[r]).length > 0);
  }
  toJSON() {
    return this.data;
  }
}
var jD = {
  processors: {},
  addPostProcessor(e) {
    this.processors[e.name] = e;
  },
  handle(e, t, n, r, o) {
    return e.forEach((i) => {
      this.processors[i] && (t = this.processors[i].process(t, n, r, o));
    }), t;
  }
};
const Xk = {};
class rm extends xg {
  constructor(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    super(), Eoe(["resourceStore", "languageUtils", "pluralResolver", "interpolator", "backendConnector", "i18nFormat", "utils"], t, this), this.options = n, this.options.keySeparator === void 0 && (this.options.keySeparator = "."), this.logger = Ei.create("translator");
  }
  changeLanguage(t) {
    t && (this.language = t);
  }
  exists(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      interpolation: {}
    };
    if (t == null)
      return !1;
    const r = this.resolve(t, n);
    return r && r.res !== void 0;
  }
  extractFromKey(t, n) {
    let r = n.nsSeparator !== void 0 ? n.nsSeparator : this.options.nsSeparator;
    r === void 0 && (r = ":");
    const o = n.keySeparator !== void 0 ? n.keySeparator : this.options.keySeparator;
    let i = n.ns || this.options.defaultNS || [];
    const a = r && t.indexOf(r) > -1, s = !this.options.userDefinedKeySeparator && !n.keySeparator && !this.options.userDefinedNsSeparator && !n.nsSeparator && !Noe(t, r, o);
    if (a && !s) {
      const c = t.match(this.interpolator.nestingRegexp);
      if (c && c.length > 0)
        return {
          key: t,
          namespaces: i
        };
      const l = t.split(r);
      (r !== o || r === o && this.options.ns.indexOf(l[0]) > -1) && (i = l.shift()), t = l.join(o);
    }
    return typeof i == "string" && (i = [i]), {
      key: t,
      namespaces: i
    };
  }
  translate(t, n, r) {
    if (typeof n != "object" && this.options.overloadTranslationOptionHandler && (n = this.options.overloadTranslationOptionHandler(arguments)), typeof n == "object" && (n = pe({}, n)), n || (n = {}), t == null)
      return "";
    Array.isArray(t) || (t = [String(t)]);
    const o = n.returnDetails !== void 0 ? n.returnDetails : this.options.returnDetails, i = n.keySeparator !== void 0 ? n.keySeparator : this.options.keySeparator, {
      key: a,
      namespaces: s
    } = this.extractFromKey(t[t.length - 1], n), c = s[s.length - 1], l = n.lng || this.language, d = n.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
    if (l && l.toLowerCase() === "cimode") {
      if (d) {
        const S = n.nsSeparator || this.options.nsSeparator;
        return o ? {
          res: `${c}${S}${a}`,
          usedKey: a,
          exactUsedKey: a,
          usedLng: l,
          usedNS: c
        } : `${c}${S}${a}`;
      }
      return o ? {
        res: a,
        usedKey: a,
        exactUsedKey: a,
        usedLng: l,
        usedNS: c
      } : a;
    }
    const f = this.resolve(t, n);
    let p = f && f.res;
    const m = f && f.usedKey || a, v = f && f.exactUsedKey || a, g = Object.prototype.toString.apply(p), b = ["[object Number]", "[object Function]", "[object RegExp]"], x = n.joinArrays !== void 0 ? n.joinArrays : this.options.joinArrays, T = !this.i18nFormat || this.i18nFormat.handleAsObject;
    if (T && p && typeof p != "string" && typeof p != "boolean" && typeof p != "number" && b.indexOf(g) < 0 && !(typeof x == "string" && g === "[object Array]")) {
      if (!n.returnObjects && !this.options.returnObjects) {
        this.options.returnedObjectHandler || this.logger.warn("accessing an object - but returnObjects options is not enabled!");
        const S = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(m, p, $e(pe({}, n), {
          ns: s
        })) : `key '${a} (${this.language})' returned an object instead of string.`;
        return o ? (f.res = S, f) : S;
      }
      if (i) {
        const S = g === "[object Array]", _ = S ? [] : {}, w = S ? v : m;
        for (const k in p)
          if (Object.prototype.hasOwnProperty.call(p, k)) {
            const E = `${w}${i}${k}`;
            _[k] = this.translate(E, $e(pe({}, n), {
              joinArrays: !1,
              ns: s
            })), _[k] === E && (_[k] = p[k]);
          }
        p = _;
      }
    } else if (T && typeof x == "string" && g === "[object Array]")
      p = p.join(x), p && (p = this.extendTranslation(p, t, n, r));
    else {
      let S = !1, _ = !1;
      const w = n.count !== void 0 && typeof n.count != "string", k = rm.hasDefaultValue(n), E = w ? this.pluralResolver.getSuffix(l, n.count, n) : "", R = n.ordinal && w ? this.pluralResolver.getSuffix(l, n.count, {
        ordinal: !1
      }) : "", P = n[`defaultValue${E}`] || n[`defaultValue${R}`] || n.defaultValue;
      !this.isValidLookup(p) && k && (S = !0, p = P), this.isValidLookup(p) || (_ = !0, p = a);
      const A = (n.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey) && _ ? void 0 : p, D = k && P !== p && this.options.updateMissing;
      if (_ || S || D) {
        if (this.logger.log(D ? "updateKey" : "missingKey", l, c, a, D ? P : p), i) {
          const I = this.resolve(a, $e(pe({}, n), {
            keySeparator: !1
          }));
          I && I.res && this.logger.warn("Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.");
        }
        let N = [];
        const F = this.languageUtils.getFallbackCodes(this.options.fallbackLng, n.lng || this.language);
        if (this.options.saveMissingTo === "fallback" && F && F[0])
          for (let I = 0; I < F.length; I++)
            N.push(F[I]);
        else
          this.options.saveMissingTo === "all" ? N = this.languageUtils.toResolveHierarchy(n.lng || this.language) : N.push(n.lng || this.language);
        const $ = (I, j, U) => {
          const G = k && U !== p ? U : A;
          this.options.missingKeyHandler ? this.options.missingKeyHandler(I, c, j, G, D, n) : this.backendConnector && this.backendConnector.saveMissing && this.backendConnector.saveMissing(I, c, j, G, D, n), this.emit("missingKey", I, c, j, p);
        };
        this.options.saveMissing && (this.options.saveMissingPlurals && w ? N.forEach((I) => {
          this.pluralResolver.getSuffixes(I, n).forEach((j) => {
            $([I], a + j, n[`defaultValue${j}`] || P);
          });
        }) : $(N, a, P));
      }
      p = this.extendTranslation(p, t, n, f, r), _ && p === a && this.options.appendNamespaceToMissingKey && (p = `${c}:${a}`), (_ || S) && this.options.parseMissingKeyHandler && (this.options.compatibilityAPI !== "v1" ? p = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? `${c}:${a}` : a, S ? p : void 0) : p = this.options.parseMissingKeyHandler(p));
    }
    return o ? (f.res = p, f) : p;
  }
  extendTranslation(t, n, r, o, i) {
    var a = this;
    if (this.i18nFormat && this.i18nFormat.parse)
      t = this.i18nFormat.parse(t, pe(pe({}, this.options.interpolation.defaultVariables), r), o.usedLng, o.usedNS, o.usedKey, {
        resolved: o
      });
    else if (!r.skipInterpolation) {
      r.interpolation && this.interpolator.init($e(pe({}, r), {
        interpolation: pe(pe({}, this.options.interpolation), r.interpolation)
      }));
      const l = typeof t == "string" && (r && r.interpolation && r.interpolation.skipOnVariables !== void 0 ? r.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
      let d;
      if (l) {
        const p = t.match(this.interpolator.nestingRegexp);
        d = p && p.length;
      }
      let f = r.replace && typeof r.replace != "string" ? r.replace : r;
      if (this.options.interpolation.defaultVariables && (f = pe(pe({}, this.options.interpolation.defaultVariables), f)), t = this.interpolator.interpolate(t, f, r.lng || this.language, r), l) {
        const p = t.match(this.interpolator.nestingRegexp), m = p && p.length;
        d < m && (r.nest = !1);
      }
      !r.lng && this.options.compatibilityAPI !== "v1" && o && o.res && (r.lng = o.usedLng), r.nest !== !1 && (t = this.interpolator.nest(t, function() {
        for (var p = arguments.length, m = new Array(p), v = 0; v < p; v++)
          m[v] = arguments[v];
        return i && i[0] === m[0] && !r.context ? (a.logger.warn(`It seems you are nesting recursively key: ${m[0]} in key: ${n[0]}`), null) : a.translate(...m, n);
      }, r)), r.interpolation && this.interpolator.reset();
    }
    const s = r.postProcess || this.options.postProcess, c = typeof s == "string" ? [s] : s;
    return t != null && c && c.length && r.applyPostProcessor !== !1 && (t = jD.handle(c, t, n, this.options && this.options.postProcessPassResolved ? pe({
      i18nResolved: o
    }, r) : r, this)), t;
  }
  resolve(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r, o, i, a, s;
    return typeof t == "string" && (t = [t]), t.forEach((c) => {
      if (this.isValidLookup(r))
        return;
      const l = this.extractFromKey(c, n), d = l.key;
      o = d;
      let f = l.namespaces;
      this.options.fallbackNS && (f = f.concat(this.options.fallbackNS));
      const p = n.count !== void 0 && typeof n.count != "string", m = p && !n.ordinal && n.count === 0 && this.pluralResolver.shouldUseIntlApi(), v = n.context !== void 0 && (typeof n.context == "string" || typeof n.context == "number") && n.context !== "", g = n.lngs ? n.lngs : this.languageUtils.toResolveHierarchy(n.lng || this.language, n.fallbackLng);
      f.forEach((b) => {
        this.isValidLookup(r) || (s = b, !Xk[`${g[0]}-${b}`] && this.utils && this.utils.hasLoadedNamespace && !this.utils.hasLoadedNamespace(s) && (Xk[`${g[0]}-${b}`] = !0, this.logger.warn(`key "${o}" for languages "${g.join(", ")}" won't get resolved as namespace "${s}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!")), g.forEach((x) => {
          if (this.isValidLookup(r))
            return;
          a = x;
          const T = [d];
          if (this.i18nFormat && this.i18nFormat.addLookupKeys)
            this.i18nFormat.addLookupKeys(T, d, x, b, n);
          else {
            let _;
            p && (_ = this.pluralResolver.getSuffix(x, n.count, n));
            const w = `${this.options.pluralSeparator}zero`, k = `${this.options.pluralSeparator}ordinal${this.options.pluralSeparator}`;
            if (p && (T.push(d + _), n.ordinal && _.indexOf(k) === 0 && T.push(d + _.replace(k, this.options.pluralSeparator)), m && T.push(d + w)), v) {
              const E = `${d}${this.options.contextSeparator}${n.context}`;
              T.push(E), p && (T.push(E + _), n.ordinal && _.indexOf(k) === 0 && T.push(E + _.replace(k, this.options.pluralSeparator)), m && T.push(E + w));
            }
          }
          let S;
          for (; S = T.pop(); )
            this.isValidLookup(r) || (i = S, r = this.getResource(x, b, S, n));
        }));
      });
    }), {
      res: r,
      usedKey: o,
      exactUsedKey: i,
      usedLng: a,
      usedNS: s
    };
  }
  isValidLookup(t) {
    return t !== void 0 && !(!this.options.returnNull && t === null) && !(!this.options.returnEmptyString && t === "");
  }
  getResource(t, n, r) {
    let o = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    return this.i18nFormat && this.i18nFormat.getResource ? this.i18nFormat.getResource(t, n, r, o) : this.resourceStore.getResource(t, n, r, o);
  }
  static hasDefaultValue(t) {
    const n = "defaultValue";
    for (const r in t)
      if (Object.prototype.hasOwnProperty.call(t, r) && n === r.substring(0, n.length) && t[r] !== void 0)
        return !0;
    return !1;
  }
}
function z0(e) {
  return e.charAt(0).toUpperCase() + e.slice(1);
}
class Kk {
  constructor(t) {
    this.options = t, this.supportedLngs = this.options.supportedLngs || !1, this.logger = Ei.create("languageUtils");
  }
  getScriptPartFromCode(t) {
    if (t = nm(t), !t || t.indexOf("-") < 0)
      return null;
    const n = t.split("-");
    return n.length === 2 || (n.pop(), n[n.length - 1].toLowerCase() === "x") ? null : this.formatLanguageCode(n.join("-"));
  }
  getLanguagePartFromCode(t) {
    if (t = nm(t), !t || t.indexOf("-") < 0)
      return t;
    const n = t.split("-");
    return this.formatLanguageCode(n[0]);
  }
  formatLanguageCode(t) {
    if (typeof t == "string" && t.indexOf("-") > -1) {
      const n = ["hans", "hant", "latn", "cyrl", "cans", "mong", "arab"];
      let r = t.split("-");
      return this.options.lowerCaseLng ? r = r.map((o) => o.toLowerCase()) : r.length === 2 ? (r[0] = r[0].toLowerCase(), r[1] = r[1].toUpperCase(), n.indexOf(r[1].toLowerCase()) > -1 && (r[1] = z0(r[1].toLowerCase()))) : r.length === 3 && (r[0] = r[0].toLowerCase(), r[1].length === 2 && (r[1] = r[1].toUpperCase()), r[0] !== "sgn" && r[2].length === 2 && (r[2] = r[2].toUpperCase()), n.indexOf(r[1].toLowerCase()) > -1 && (r[1] = z0(r[1].toLowerCase())), n.indexOf(r[2].toLowerCase()) > -1 && (r[2] = z0(r[2].toLowerCase()))), r.join("-");
    }
    return this.options.cleanCode || this.options.lowerCaseLng ? t.toLowerCase() : t;
  }
  isSupportedCode(t) {
    return (this.options.load === "languageOnly" || this.options.nonExplicitSupportedLngs) && (t = this.getLanguagePartFromCode(t)), !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(t) > -1;
  }
  getBestMatchFromCodes(t) {
    if (!t)
      return null;
    let n;
    return t.forEach((r) => {
      if (n)
        return;
      const o = this.formatLanguageCode(r);
      (!this.options.supportedLngs || this.isSupportedCode(o)) && (n = o);
    }), !n && this.options.supportedLngs && t.forEach((r) => {
      if (n)
        return;
      const o = this.getLanguagePartFromCode(r);
      if (this.isSupportedCode(o))
        return n = o;
      n = this.options.supportedLngs.find((i) => {
        if (i === o || !(i.indexOf("-") < 0 && o.indexOf("-") < 0) && i.indexOf(o) === 0)
          return i;
      });
    }), n || (n = this.getFallbackCodes(this.options.fallbackLng)[0]), n;
  }
  getFallbackCodes(t, n) {
    if (!t)
      return [];
    if (typeof t == "function" && (t = t(n)), typeof t == "string" && (t = [t]), Object.prototype.toString.apply(t) === "[object Array]")
      return t;
    if (!n)
      return t.default || [];
    let r = t[n];
    return r || (r = t[this.getScriptPartFromCode(n)]), r || (r = t[this.formatLanguageCode(n)]), r || (r = t[this.getLanguagePartFromCode(n)]), r || (r = t.default), r || [];
  }
  toResolveHierarchy(t, n) {
    const r = this.getFallbackCodes(n || this.options.fallbackLng || [], t), o = [], i = (a) => {
      a && (this.isSupportedCode(a) ? o.push(a) : this.logger.warn(`rejecting language code not found in supportedLngs: ${a}`));
    };
    return typeof t == "string" && (t.indexOf("-") > -1 || t.indexOf("_") > -1) ? (this.options.load !== "languageOnly" && i(this.formatLanguageCode(t)), this.options.load !== "languageOnly" && this.options.load !== "currentOnly" && i(this.getScriptPartFromCode(t)), this.options.load !== "currentOnly" && i(this.getLanguagePartFromCode(t))) : typeof t == "string" && i(this.formatLanguageCode(t)), r.forEach((a) => {
      o.indexOf(a) < 0 && i(this.formatLanguageCode(a));
    }), o;
  }
}
let Aoe = [{
  lngs: ["ach", "ak", "am", "arn", "br", "fil", "gun", "ln", "mfe", "mg", "mi", "oc", "pt", "pt-BR", "tg", "tl", "ti", "tr", "uz", "wa"],
  nr: [1, 2],
  fc: 1
}, {
  lngs: ["af", "an", "ast", "az", "bg", "bn", "ca", "da", "de", "dev", "el", "en", "eo", "es", "et", "eu", "fi", "fo", "fur", "fy", "gl", "gu", "ha", "hi", "hu", "hy", "ia", "it", "kk", "kn", "ku", "lb", "mai", "ml", "mn", "mr", "nah", "nap", "nb", "ne", "nl", "nn", "no", "nso", "pa", "pap", "pms", "ps", "pt-PT", "rm", "sco", "se", "si", "so", "son", "sq", "sv", "sw", "ta", "te", "tk", "ur", "yo"],
  nr: [1, 2],
  fc: 2
}, {
  lngs: ["ay", "bo", "cgg", "fa", "ht", "id", "ja", "jbo", "ka", "km", "ko", "ky", "lo", "ms", "sah", "su", "th", "tt", "ug", "vi", "wo", "zh"],
  nr: [1],
  fc: 3
}, {
  lngs: ["be", "bs", "cnr", "dz", "hr", "ru", "sr", "uk"],
  nr: [1, 2, 5],
  fc: 4
}, {
  lngs: ["ar"],
  nr: [0, 1, 2, 3, 11, 100],
  fc: 5
}, {
  lngs: ["cs", "sk"],
  nr: [1, 2, 5],
  fc: 6
}, {
  lngs: ["csb", "pl"],
  nr: [1, 2, 5],
  fc: 7
}, {
  lngs: ["cy"],
  nr: [1, 2, 3, 8],
  fc: 8
}, {
  lngs: ["fr"],
  nr: [1, 2],
  fc: 9
}, {
  lngs: ["ga"],
  nr: [1, 2, 3, 7, 11],
  fc: 10
}, {
  lngs: ["gd"],
  nr: [1, 2, 3, 20],
  fc: 11
}, {
  lngs: ["is"],
  nr: [1, 2],
  fc: 12
}, {
  lngs: ["jv"],
  nr: [0, 1],
  fc: 13
}, {
  lngs: ["kw"],
  nr: [1, 2, 3, 4],
  fc: 14
}, {
  lngs: ["lt"],
  nr: [1, 2, 10],
  fc: 15
}, {
  lngs: ["lv"],
  nr: [1, 2, 0],
  fc: 16
}, {
  lngs: ["mk"],
  nr: [1, 2],
  fc: 17
}, {
  lngs: ["mnk"],
  nr: [0, 1, 2],
  fc: 18
}, {
  lngs: ["mt"],
  nr: [1, 2, 11, 20],
  fc: 19
}, {
  lngs: ["or"],
  nr: [2, 1],
  fc: 2
}, {
  lngs: ["ro"],
  nr: [1, 2, 20],
  fc: 20
}, {
  lngs: ["sl"],
  nr: [5, 1, 2, 3],
  fc: 21
}, {
  lngs: ["he", "iw"],
  nr: [1, 2, 20, 21],
  fc: 22
}], Doe = {
  1: function(e) {
    return +(e > 1);
  },
  2: function(e) {
    return +(e != 1);
  },
  3: function(e) {
    return 0;
  },
  4: function(e) {
    return e % 10 == 1 && e % 100 != 11 ? 0 : e % 10 >= 2 && e % 10 <= 4 && (e % 100 < 10 || e % 100 >= 20) ? 1 : 2;
  },
  5: function(e) {
    return e == 0 ? 0 : e == 1 ? 1 : e == 2 ? 2 : e % 100 >= 3 && e % 100 <= 10 ? 3 : e % 100 >= 11 ? 4 : 5;
  },
  6: function(e) {
    return e == 1 ? 0 : e >= 2 && e <= 4 ? 1 : 2;
  },
  7: function(e) {
    return e == 1 ? 0 : e % 10 >= 2 && e % 10 <= 4 && (e % 100 < 10 || e % 100 >= 20) ? 1 : 2;
  },
  8: function(e) {
    return e == 1 ? 0 : e == 2 ? 1 : e != 8 && e != 11 ? 2 : 3;
  },
  9: function(e) {
    return +(e >= 2);
  },
  10: function(e) {
    return e == 1 ? 0 : e == 2 ? 1 : e < 7 ? 2 : e < 11 ? 3 : 4;
  },
  11: function(e) {
    return e == 1 || e == 11 ? 0 : e == 2 || e == 12 ? 1 : e > 2 && e < 20 ? 2 : 3;
  },
  12: function(e) {
    return +(e % 10 != 1 || e % 100 == 11);
  },
  13: function(e) {
    return +(e !== 0);
  },
  14: function(e) {
    return e == 1 ? 0 : e == 2 ? 1 : e == 3 ? 2 : 3;
  },
  15: function(e) {
    return e % 10 == 1 && e % 100 != 11 ? 0 : e % 10 >= 2 && (e % 100 < 10 || e % 100 >= 20) ? 1 : 2;
  },
  16: function(e) {
    return e % 10 == 1 && e % 100 != 11 ? 0 : e !== 0 ? 1 : 2;
  },
  17: function(e) {
    return e == 1 || e % 10 == 1 && e % 100 != 11 ? 0 : 1;
  },
  18: function(e) {
    return e == 0 ? 0 : e == 1 ? 1 : 2;
  },
  19: function(e) {
    return e == 1 ? 0 : e == 0 || e % 100 > 1 && e % 100 < 11 ? 1 : e % 100 > 10 && e % 100 < 20 ? 2 : 3;
  },
  20: function(e) {
    return e == 1 ? 0 : e == 0 || e % 100 > 0 && e % 100 < 20 ? 1 : 2;
  },
  21: function(e) {
    return e % 100 == 1 ? 1 : e % 100 == 2 ? 2 : e % 100 == 3 || e % 100 == 4 ? 3 : 0;
  },
  22: function(e) {
    return e == 1 ? 0 : e == 2 ? 1 : (e < 0 || e > 10) && e % 10 == 0 ? 2 : 3;
  }
};
const Ioe = ["v1", "v2", "v3"], Loe = ["v4"], Jk = {
  zero: 0,
  one: 1,
  two: 2,
  few: 3,
  many: 4,
  other: 5
};
function $oe() {
  const e = {};
  return Aoe.forEach((t) => {
    t.lngs.forEach((n) => {
      e[n] = {
        numbers: t.nr,
        plurals: Doe[t.fc]
      };
    });
  }), e;
}
class Foe {
  constructor(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.languageUtils = t, this.options = n, this.logger = Ei.create("pluralResolver"), (!this.options.compatibilityJSON || Loe.includes(this.options.compatibilityJSON)) && (typeof Intl == "undefined" || !Intl.PluralRules) && (this.options.compatibilityJSON = "v3", this.logger.error("Your environment seems not to be Intl API compatible, use an Intl.PluralRules polyfill. Will fallback to the compatibilityJSON v3 format handling.")), this.rules = $oe();
  }
  addRule(t, n) {
    this.rules[t] = n;
  }
  getRule(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (this.shouldUseIntlApi())
      try {
        return new Intl.PluralRules(nm(t), {
          type: n.ordinal ? "ordinal" : "cardinal"
        });
      } catch (r) {
        return;
      }
    return this.rules[t] || this.rules[this.languageUtils.getLanguagePartFromCode(t)];
  }
  needsPlural(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const r = this.getRule(t, n);
    return this.shouldUseIntlApi() ? r && r.resolvedOptions().pluralCategories.length > 1 : r && r.numbers.length > 1;
  }
  getPluralFormsOfKey(t, n) {
    let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return this.getSuffixes(t, r).map((o) => `${n}${o}`);
  }
  getSuffixes(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const r = this.getRule(t, n);
    return r ? this.shouldUseIntlApi() ? r.resolvedOptions().pluralCategories.sort((o, i) => Jk[o] - Jk[i]).map((o) => `${this.options.prepend}${n.ordinal ? `ordinal${this.options.prepend}` : ""}${o}`) : r.numbers.map((o) => this.getSuffix(t, o, n)) : [];
  }
  getSuffix(t, n) {
    let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    const o = this.getRule(t, r);
    return o ? this.shouldUseIntlApi() ? `${this.options.prepend}${r.ordinal ? `ordinal${this.options.prepend}` : ""}${o.select(n)}` : this.getSuffixRetroCompatible(o, n) : (this.logger.warn(`no plural rule found for: ${t}`), "");
  }
  getSuffixRetroCompatible(t, n) {
    const r = t.noAbs ? t.plurals(n) : t.plurals(Math.abs(n));
    let o = t.numbers[r];
    this.options.simplifyPluralSuffix && t.numbers.length === 2 && t.numbers[0] === 1 && (o === 2 ? o = "plural" : o === 1 && (o = ""));
    const i = () => this.options.prepend && o.toString() ? this.options.prepend + o.toString() : o.toString();
    return this.options.compatibilityJSON === "v1" ? o === 1 ? "" : typeof o == "number" ? `_plural_${o.toString()}` : i() : this.options.compatibilityJSON === "v2" || this.options.simplifyPluralSuffix && t.numbers.length === 2 && t.numbers[0] === 1 ? i() : this.options.prepend && r.toString() ? this.options.prepend + r.toString() : r.toString();
  }
  shouldUseIntlApi() {
    return !Ioe.includes(this.options.compatibilityJSON);
  }
}
function Qk(e, t, n) {
  let r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : ".", o = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !0, i = Moe(e, t, n);
  return !i && o && typeof n == "string" && (i = tm(e, n, r), i === void 0 && (i = tm(t, n, r))), i;
}
class zoe {
  constructor() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    this.logger = Ei.create("interpolator"), this.options = t, this.format = t.interpolation && t.interpolation.format || ((n) => n), this.init(t);
  }
  init() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    t.interpolation || (t.interpolation = {
      escapeValue: !0
    });
    const n = t.interpolation;
    this.escape = n.escape !== void 0 ? n.escape : Poe, this.escapeValue = n.escapeValue !== void 0 ? n.escapeValue : !0, this.useRawValueToEscape = n.useRawValueToEscape !== void 0 ? n.useRawValueToEscape : !1, this.prefix = n.prefix ? Il(n.prefix) : n.prefixEscaped || "{{", this.suffix = n.suffix ? Il(n.suffix) : n.suffixEscaped || "}}", this.formatSeparator = n.formatSeparator ? n.formatSeparator : n.formatSeparator || ",", this.unescapePrefix = n.unescapeSuffix ? "" : n.unescapePrefix || "-", this.unescapeSuffix = this.unescapePrefix ? "" : n.unescapeSuffix || "", this.nestingPrefix = n.nestingPrefix ? Il(n.nestingPrefix) : n.nestingPrefixEscaped || Il("$t("), this.nestingSuffix = n.nestingSuffix ? Il(n.nestingSuffix) : n.nestingSuffixEscaped || Il(")"), this.nestingOptionsSeparator = n.nestingOptionsSeparator ? n.nestingOptionsSeparator : n.nestingOptionsSeparator || ",", this.maxReplaces = n.maxReplaces ? n.maxReplaces : 1e3, this.alwaysFormat = n.alwaysFormat !== void 0 ? n.alwaysFormat : !1, this.resetRegExp();
  }
  reset() {
    this.options && this.init(this.options);
  }
  resetRegExp() {
    const t = `${this.prefix}(.+?)${this.suffix}`;
    this.regexp = new RegExp(t, "g");
    const n = `${this.prefix}${this.unescapePrefix}(.+?)${this.unescapeSuffix}${this.suffix}`;
    this.regexpUnescape = new RegExp(n, "g");
    const r = `${this.nestingPrefix}(.+?)${this.nestingSuffix}`;
    this.nestingRegexp = new RegExp(r, "g");
  }
  interpolate(t, n, r, o) {
    let i, a, s;
    const c = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};
    function l(m) {
      return m.replace(/\$/g, "$$$$");
    }
    const d = (m) => {
      if (m.indexOf(this.formatSeparator) < 0) {
        const x = Qk(n, c, m, this.options.keySeparator, this.options.ignoreJSONStructure);
        return this.alwaysFormat ? this.format(x, void 0, r, $e(pe(pe({}, o), n), {
          interpolationkey: m
        })) : x;
      }
      const v = m.split(this.formatSeparator), g = v.shift().trim(), b = v.join(this.formatSeparator).trim();
      return this.format(Qk(n, c, g, this.options.keySeparator, this.options.ignoreJSONStructure), b, r, $e(pe(pe({}, o), n), {
        interpolationkey: g
      }));
    };
    this.resetRegExp();
    const f = o && o.missingInterpolationHandler || this.options.missingInterpolationHandler, p = o && o.interpolation && o.interpolation.skipOnVariables !== void 0 ? o.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
    return [{
      regex: this.regexpUnescape,
      safeValue: (m) => l(m)
    }, {
      regex: this.regexp,
      safeValue: (m) => this.escapeValue ? l(this.escape(m)) : l(m)
    }].forEach((m) => {
      for (s = 0; i = m.regex.exec(t); ) {
        const v = i[1].trim();
        if (a = d(v), a === void 0)
          if (typeof f == "function") {
            const b = f(t, i, o);
            a = typeof b == "string" ? b : "";
          } else if (o && Object.prototype.hasOwnProperty.call(o, v))
            a = "";
          else if (p) {
            a = i[0];
            continue;
          } else
            this.logger.warn(`missed to pass in variable ${v} for interpolating ${t}`), a = "";
        else
          typeof a != "string" && !this.useRawValueToEscape && (a = Gk(a));
        const g = m.safeValue(a);
        if (t = t.replace(i[0], g), p ? (m.regex.lastIndex += a.length, m.regex.lastIndex -= i[0].length) : m.regex.lastIndex = 0, s++, s >= this.maxReplaces)
          break;
      }
    }), t;
  }
  nest(t, n) {
    let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, o, i, a;
    function s(c, l) {
      const d = this.nestingOptionsSeparator;
      if (c.indexOf(d) < 0)
        return c;
      const f = c.split(new RegExp(`${d}[ ]*{`));
      let p = `{${f[1]}`;
      c = f[0], p = this.interpolate(p, a);
      const m = p.match(/'/g), v = p.match(/"/g);
      (m && m.length % 2 === 0 && !v || v.length % 2 !== 0) && (p = p.replace(/'/g, '"'));
      try {
        a = JSON.parse(p), l && (a = pe(pe({}, l), a));
      } catch (g) {
        return this.logger.warn(`failed parsing options string in nesting for key ${c}`, g), `${c}${d}${p}`;
      }
      return delete a.defaultValue, c;
    }
    for (; o = this.nestingRegexp.exec(t); ) {
      let c = [];
      a = pe({}, r), a = a.replace && typeof a.replace != "string" ? a.replace : a, a.applyPostProcessor = !1, delete a.defaultValue;
      let l = !1;
      if (o[0].indexOf(this.formatSeparator) !== -1 && !/{.*}/.test(o[1])) {
        const d = o[1].split(this.formatSeparator).map((f) => f.trim());
        o[1] = d.shift(), c = d, l = !0;
      }
      if (i = n(s.call(this, o[1].trim(), a), a), i && o[0] === t && typeof i != "string")
        return i;
      typeof i != "string" && (i = Gk(i)), i || (this.logger.warn(`missed to resolve ${o[1]} for nesting ${t}`), i = ""), l && (i = c.reduce((d, f) => this.format(d, f, r.lng, $e(pe({}, r), {
        interpolationkey: o[1].trim()
      })), i.trim())), t = t.replace(o[0], i), this.regexp.lastIndex = 0;
    }
    return t;
  }
}
function Boe(e) {
  let t = e.toLowerCase().trim();
  const n = {};
  if (e.indexOf("(") > -1) {
    const r = e.split("(");
    t = r[0].toLowerCase().trim();
    const o = r[1].substring(0, r[1].length - 1);
    t === "currency" && o.indexOf(":") < 0 ? n.currency || (n.currency = o.trim()) : t === "relativetime" && o.indexOf(":") < 0 ? n.range || (n.range = o.trim()) : o.split(";").forEach((i) => {
      if (!i)
        return;
      const [a, ...s] = i.split(":"), c = s.join(":").trim().replace(/^'+|'+$/g, "");
      n[a.trim()] || (n[a.trim()] = c), c === "false" && (n[a.trim()] = !1), c === "true" && (n[a.trim()] = !0), isNaN(c) || (n[a.trim()] = parseInt(c, 10));
    });
  }
  return {
    formatName: t,
    formatOptions: n
  };
}
function Ll(e) {
  const t = {};
  return function(n, r, o) {
    const i = r + JSON.stringify(o);
    let a = t[i];
    return a || (a = e(nm(r), o), t[i] = a), a(n);
  };
}
class Hoe {
  constructor() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    this.logger = Ei.create("formatter"), this.options = t, this.formats = {
      number: Ll((n, r) => {
        const o = new Intl.NumberFormat(n, pe({}, r));
        return (i) => o.format(i);
      }),
      currency: Ll((n, r) => {
        const o = new Intl.NumberFormat(n, $e(pe({}, r), {
          style: "currency"
        }));
        return (i) => o.format(i);
      }),
      datetime: Ll((n, r) => {
        const o = new Intl.DateTimeFormat(n, pe({}, r));
        return (i) => o.format(i);
      }),
      relativetime: Ll((n, r) => {
        const o = new Intl.RelativeTimeFormat(n, pe({}, r));
        return (i) => o.format(i, r.range || "day");
      }),
      list: Ll((n, r) => {
        const o = new Intl.ListFormat(n, pe({}, r));
        return (i) => o.format(i);
      })
    }, this.init(t);
  }
  init(t) {
    const n = (arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      interpolation: {}
    }).interpolation;
    this.formatSeparator = n.formatSeparator ? n.formatSeparator : n.formatSeparator || ",";
  }
  add(t, n) {
    this.formats[t.toLowerCase().trim()] = n;
  }
  addCached(t, n) {
    this.formats[t.toLowerCase().trim()] = Ll(n);
  }
  format(t, n, r) {
    let o = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    return n.split(this.formatSeparator).reduce((i, a) => {
      const {
        formatName: s,
        formatOptions: c
      } = Boe(a);
      if (this.formats[s]) {
        let l = i;
        try {
          const d = o && o.formatParams && o.formatParams[o.interpolationkey] || {}, f = d.locale || d.lng || o.locale || o.lng || r;
          l = this.formats[s](i, f, pe(pe(pe({}, c), o), d));
        } catch (d) {
          this.logger.warn(d);
        }
        return l;
      } else
        this.logger.warn(`there was no format function for ${s}`);
      return i;
    }, t);
  }
}
function joe(e, t) {
  e.pending[t] !== void 0 && (delete e.pending[t], e.pendingCount--);
}
class Woe extends xg {
  constructor(t, n, r) {
    let o = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    super(), this.backend = t, this.store = n, this.services = r, this.languageUtils = r.languageUtils, this.options = o, this.logger = Ei.create("backendConnector"), this.waitingReads = [], this.maxParallelReads = o.maxParallelReads || 10, this.readingCalls = 0, this.maxRetries = o.maxRetries >= 0 ? o.maxRetries : 5, this.retryTimeout = o.retryTimeout >= 1 ? o.retryTimeout : 350, this.state = {}, this.queue = [], this.backend && this.backend.init && this.backend.init(r, o.backend, o);
  }
  queueLoad(t, n, r, o) {
    const i = {}, a = {}, s = {}, c = {};
    return t.forEach((l) => {
      let d = !0;
      n.forEach((f) => {
        const p = `${l}|${f}`;
        !r.reload && this.store.hasResourceBundle(l, f) ? this.state[p] = 2 : this.state[p] < 0 || (this.state[p] === 1 ? a[p] === void 0 && (a[p] = !0) : (this.state[p] = 1, d = !1, a[p] === void 0 && (a[p] = !0), i[p] === void 0 && (i[p] = !0), c[f] === void 0 && (c[f] = !0)));
      }), d || (s[l] = !0);
    }), (Object.keys(i).length || Object.keys(a).length) && this.queue.push({
      pending: a,
      pendingCount: Object.keys(a).length,
      loaded: {},
      errors: [],
      callback: o
    }), {
      toLoad: Object.keys(i),
      pending: Object.keys(a),
      toLoadLanguages: Object.keys(s),
      toLoadNamespaces: Object.keys(c)
    };
  }
  loaded(t, n, r) {
    const o = t.split("|"), i = o[0], a = o[1];
    n && this.emit("failedLoading", i, a, n), r && this.store.addResourceBundle(i, a, r), this.state[t] = n ? -1 : 2;
    const s = {};
    this.queue.forEach((c) => {
      koe(c.loaded, [i], a), joe(c, t), n && c.errors.push(n), c.pendingCount === 0 && !c.done && (Object.keys(c.loaded).forEach((l) => {
        s[l] || (s[l] = {});
        const d = c.loaded[l];
        d.length && d.forEach((f) => {
          s[l][f] === void 0 && (s[l][f] = !0);
        });
      }), c.done = !0, c.errors.length ? c.callback(c.errors) : c.callback());
    }), this.emit("loaded", s), this.queue = this.queue.filter((c) => !c.done);
  }
  read(t, n, r) {
    let o = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0, i = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : this.retryTimeout, a = arguments.length > 5 ? arguments[5] : void 0;
    if (!t.length)
      return a(null, {});
    if (this.readingCalls >= this.maxParallelReads) {
      this.waitingReads.push({
        lng: t,
        ns: n,
        fcName: r,
        tried: o,
        wait: i,
        callback: a
      });
      return;
    }
    this.readingCalls++;
    const s = (l, d) => {
      if (this.readingCalls--, this.waitingReads.length > 0) {
        const f = this.waitingReads.shift();
        this.read(f.lng, f.ns, f.fcName, f.tried, f.wait, f.callback);
      }
      if (l && d && o < this.maxRetries) {
        setTimeout(() => {
          this.read.call(this, t, n, r, o + 1, i * 2, a);
        }, i);
        return;
      }
      a(l, d);
    }, c = this.backend[r].bind(this.backend);
    if (c.length === 2) {
      try {
        const l = c(t, n);
        l && typeof l.then == "function" ? l.then((d) => s(null, d)).catch(s) : s(null, l);
      } catch (l) {
        s(l);
      }
      return;
    }
    return c(t, n, s);
  }
  prepareLoading(t, n) {
    let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, o = arguments.length > 3 ? arguments[3] : void 0;
    if (!this.backend)
      return this.logger.warn("No backend was added via i18next.use. Will not load resources."), o && o();
    typeof t == "string" && (t = this.languageUtils.toResolveHierarchy(t)), typeof n == "string" && (n = [n]);
    const i = this.queueLoad(t, n, r, o);
    if (!i.toLoad.length)
      return i.pending.length || o(), null;
    i.toLoad.forEach((a) => {
      this.loadOne(a);
    });
  }
  load(t, n, r) {
    this.prepareLoading(t, n, {}, r);
  }
  reload(t, n, r) {
    this.prepareLoading(t, n, {
      reload: !0
    }, r);
  }
  loadOne(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    const r = t.split("|"), o = r[0], i = r[1];
    this.read(o, i, "read", void 0, void 0, (a, s) => {
      a && this.logger.warn(`${n}loading namespace ${i} for language ${o} failed`, a), !a && s && this.logger.log(`${n}loaded namespace ${i} for language ${o}`, s), this.loaded(t, a, s);
    });
  }
  saveMissing(t, n, r, o, i) {
    let a = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {}, s = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : () => {
    };
    if (this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(n)) {
      this.logger.warn(`did not save key "${r}" as the namespace "${n}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
      return;
    }
    if (!(r == null || r === "")) {
      if (this.backend && this.backend.create) {
        const c = $e(pe({}, a), {
          isUpdate: i
        }), l = this.backend.create.bind(this.backend);
        if (l.length < 6)
          try {
            let d;
            l.length === 5 ? d = l(t, n, r, o, c) : d = l(t, n, r, o), d && typeof d.then == "function" ? d.then((f) => s(null, f)).catch(s) : s(null, d);
          } catch (d) {
            s(d);
          }
        else
          l(t, n, r, o, s, c);
      }
      !t || !t[0] || this.store.addResource(t[0], n, r, o);
    }
  }
}
function eM() {
  return {
    debug: !1,
    initImmediate: !0,
    ns: ["translation"],
    defaultNS: ["translation"],
    fallbackLng: ["dev"],
    fallbackNS: !1,
    supportedLngs: !1,
    nonExplicitSupportedLngs: !1,
    load: "all",
    preload: !1,
    simplifyPluralSuffix: !0,
    keySeparator: ".",
    nsSeparator: ":",
    pluralSeparator: "_",
    contextSeparator: "_",
    partialBundledLanguages: !1,
    saveMissing: !1,
    updateMissing: !1,
    saveMissingTo: "fallback",
    saveMissingPlurals: !0,
    missingKeyHandler: !1,
    missingInterpolationHandler: !1,
    postProcess: !1,
    postProcessPassResolved: !1,
    returnNull: !1,
    returnEmptyString: !0,
    returnObjects: !1,
    joinArrays: !1,
    returnedObjectHandler: !1,
    parseMissingKeyHandler: !1,
    appendNamespaceToMissingKey: !1,
    appendNamespaceToCIMode: !1,
    overloadTranslationOptionHandler: function(e) {
      let t = {};
      if (typeof e[1] == "object" && (t = e[1]), typeof e[1] == "string" && (t.defaultValue = e[1]), typeof e[2] == "string" && (t.tDescription = e[2]), typeof e[2] == "object" || typeof e[3] == "object") {
        const n = e[3] || e[2];
        Object.keys(n).forEach((r) => {
          t[r] = n[r];
        });
      }
      return t;
    },
    interpolation: {
      escapeValue: !0,
      format: (e, t, n, r) => e,
      prefix: "{{",
      suffix: "}}",
      formatSeparator: ",",
      unescapePrefix: "-",
      nestingPrefix: "$t(",
      nestingSuffix: ")",
      nestingOptionsSeparator: ",",
      maxReplaces: 1e3,
      skipOnVariables: !0
    }
  };
}
function tM(e) {
  return typeof e.ns == "string" && (e.ns = [e.ns]), typeof e.fallbackLng == "string" && (e.fallbackLng = [e.fallbackLng]), typeof e.fallbackNS == "string" && (e.fallbackNS = [e.fallbackNS]), e.supportedLngs && e.supportedLngs.indexOf("cimode") < 0 && (e.supportedLngs = e.supportedLngs.concat(["cimode"])), e;
}
function wp() {
}
function Voe(e) {
  Object.getOwnPropertyNames(Object.getPrototypeOf(e)).forEach((t) => {
    typeof e[t] == "function" && (e[t] = e[t].bind(e));
  });
}
class Ud extends xg {
  constructor() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = arguments.length > 1 ? arguments[1] : void 0;
    if (super(), this.options = tM(t), this.services = {}, this.logger = Ei, this.modules = {
      external: []
    }, Voe(this), n && !this.isInitialized && !t.isClone) {
      if (!this.options.initImmediate)
        return this.init(t, n), this;
      setTimeout(() => {
        this.init(t, n);
      }, 0);
    }
  }
  init() {
    var t = this;
    let n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = arguments.length > 1 ? arguments[1] : void 0;
    typeof n == "function" && (r = n, n = {}), !n.defaultNS && n.defaultNS !== !1 && n.ns && (typeof n.ns == "string" ? n.defaultNS = n.ns : n.ns.indexOf("translation") < 0 && (n.defaultNS = n.ns[0]));
    const o = eM();
    this.options = pe(pe(pe({}, o), this.options), tM(n)), this.options.compatibilityAPI !== "v1" && (this.options.interpolation = pe(pe({}, o.interpolation), this.options.interpolation)), n.keySeparator !== void 0 && (this.options.userDefinedKeySeparator = n.keySeparator), n.nsSeparator !== void 0 && (this.options.userDefinedNsSeparator = n.nsSeparator);
    function i(c) {
      return c ? typeof c == "function" ? new c() : c : null;
    }
    if (!this.options.isClone) {
      this.modules.logger ? Ei.init(i(this.modules.logger), this.options) : Ei.init(null, this.options);
      let c;
      this.modules.formatter ? c = this.modules.formatter : typeof Intl != "undefined" && (c = Hoe);
      const l = new Kk(this.options);
      this.store = new Zk(this.options.resources, this.options);
      const d = this.services;
      d.logger = Ei, d.resourceStore = this.store, d.languageUtils = l, d.pluralResolver = new Foe(l, {
        prepend: this.options.pluralSeparator,
        compatibilityJSON: this.options.compatibilityJSON,
        simplifyPluralSuffix: this.options.simplifyPluralSuffix
      }), c && (!this.options.interpolation.format || this.options.interpolation.format === o.interpolation.format) && (d.formatter = i(c), d.formatter.init(d, this.options), this.options.interpolation.format = d.formatter.format.bind(d.formatter)), d.interpolator = new zoe(this.options), d.utils = {
        hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
      }, d.backendConnector = new Woe(i(this.modules.backend), d.resourceStore, d, this.options), d.backendConnector.on("*", function(f) {
        for (var p = arguments.length, m = new Array(p > 1 ? p - 1 : 0), v = 1; v < p; v++)
          m[v - 1] = arguments[v];
        t.emit(f, ...m);
      }), this.modules.languageDetector && (d.languageDetector = i(this.modules.languageDetector), d.languageDetector.init && d.languageDetector.init(d, this.options.detection, this.options)), this.modules.i18nFormat && (d.i18nFormat = i(this.modules.i18nFormat), d.i18nFormat.init && d.i18nFormat.init(this)), this.translator = new rm(this.services, this.options), this.translator.on("*", function(f) {
        for (var p = arguments.length, m = new Array(p > 1 ? p - 1 : 0), v = 1; v < p; v++)
          m[v - 1] = arguments[v];
        t.emit(f, ...m);
      }), this.modules.external.forEach((f) => {
        f.init && f.init(this);
      });
    }
    if (this.format = this.options.interpolation.format, r || (r = wp), this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
      const c = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
      c.length > 0 && c[0] !== "dev" && (this.options.lng = c[0]);
    }
    !this.services.languageDetector && !this.options.lng && this.logger.warn("init: no languageDetector is used and no lng is defined"), ["getResource", "hasResourceBundle", "getResourceBundle", "getDataByLanguage"].forEach((c) => {
      this[c] = function() {
        return t.store[c](...arguments);
      };
    }), ["addResource", "addResources", "addResourceBundle", "removeResourceBundle"].forEach((c) => {
      this[c] = function() {
        return t.store[c](...arguments), t;
      };
    });
    const a = $u(), s = () => {
      const c = (l, d) => {
        this.isInitialized && !this.initializedStoreOnce && this.logger.warn("init: i18next is already initialized. You should call init just once!"), this.isInitialized = !0, this.options.isClone || this.logger.log("initialized", this.options), this.emit("initialized", this.options), a.resolve(d), r(l, d);
      };
      if (this.languages && this.options.compatibilityAPI !== "v1" && !this.isInitialized)
        return c(null, this.t.bind(this));
      this.changeLanguage(this.options.lng, c);
    };
    return this.options.resources || !this.options.initImmediate ? s() : setTimeout(s, 0), a;
  }
  loadResources(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : wp;
    const r = typeof t == "string" ? t : this.language;
    if (typeof t == "function" && (n = t), !this.options.resources || this.options.partialBundledLanguages) {
      if (r && r.toLowerCase() === "cimode")
        return n();
      const o = [], i = (a) => {
        a && this.services.languageUtils.toResolveHierarchy(a).forEach((s) => {
          o.indexOf(s) < 0 && o.push(s);
        });
      };
      r ? i(r) : this.services.languageUtils.getFallbackCodes(this.options.fallbackLng).forEach((a) => i(a)), this.options.preload && this.options.preload.forEach((a) => i(a)), this.services.backendConnector.load(o, this.options.ns, (a) => {
        !a && !this.resolvedLanguage && this.language && this.setResolvedLanguage(this.language), n(a);
      });
    } else
      n(null);
  }
  reloadResources(t, n, r) {
    const o = $u();
    return t || (t = this.languages), n || (n = this.options.ns), r || (r = wp), this.services.backendConnector.reload(t, n, (i) => {
      o.resolve(), r(i);
    }), o;
  }
  use(t) {
    if (!t)
      throw new Error("You are passing an undefined module! Please check the object you are passing to i18next.use()");
    if (!t.type)
      throw new Error("You are passing a wrong module! Please check the object you are passing to i18next.use()");
    return t.type === "backend" && (this.modules.backend = t), (t.type === "logger" || t.log && t.warn && t.error) && (this.modules.logger = t), t.type === "languageDetector" && (this.modules.languageDetector = t), t.type === "i18nFormat" && (this.modules.i18nFormat = t), t.type === "postProcessor" && jD.addPostProcessor(t), t.type === "formatter" && (this.modules.formatter = t), t.type === "3rdParty" && this.modules.external.push(t), this;
  }
  setResolvedLanguage(t) {
    if (!(!t || !this.languages) && !(["cimode", "dev"].indexOf(t) > -1))
      for (let n = 0; n < this.languages.length; n++) {
        const r = this.languages[n];
        if (!(["cimode", "dev"].indexOf(r) > -1) && this.store.hasLanguageSomeTranslations(r)) {
          this.resolvedLanguage = r;
          break;
        }
      }
  }
  changeLanguage(t, n) {
    var r = this;
    this.isLanguageChangingTo = t;
    const o = $u();
    this.emit("languageChanging", t);
    const i = (c) => {
      this.language = c, this.languages = this.services.languageUtils.toResolveHierarchy(c), this.resolvedLanguage = void 0, this.setResolvedLanguage(c);
    }, a = (c, l) => {
      l ? (i(l), this.translator.changeLanguage(l), this.isLanguageChangingTo = void 0, this.emit("languageChanged", l), this.logger.log("languageChanged", l)) : this.isLanguageChangingTo = void 0, o.resolve(function() {
        return r.t(...arguments);
      }), n && n(c, function() {
        return r.t(...arguments);
      });
    }, s = (c) => {
      !t && !c && this.services.languageDetector && (c = []);
      const l = typeof c == "string" ? c : this.services.languageUtils.getBestMatchFromCodes(c);
      l && (this.language || i(l), this.translator.language || this.translator.changeLanguage(l), this.services.languageDetector && this.services.languageDetector.cacheUserLanguage && this.services.languageDetector.cacheUserLanguage(l)), this.loadResources(l, (d) => {
        a(d, l);
      });
    };
    return !t && this.services.languageDetector && !this.services.languageDetector.async ? s(this.services.languageDetector.detect()) : !t && this.services.languageDetector && this.services.languageDetector.async ? this.services.languageDetector.detect.length === 0 ? this.services.languageDetector.detect().then(s) : this.services.languageDetector.detect(s) : s(t), o;
  }
  getFixedT(t, n, r) {
    var o = this;
    const i = function(a, s) {
      let c;
      if (typeof s != "object") {
        for (var l = arguments.length, d = new Array(l > 2 ? l - 2 : 0), f = 2; f < l; f++)
          d[f - 2] = arguments[f];
        c = o.options.overloadTranslationOptionHandler([a, s].concat(d));
      } else
        c = pe({}, s);
      c.lng = c.lng || i.lng, c.lngs = c.lngs || i.lngs, c.ns = c.ns || i.ns, c.keyPrefix = c.keyPrefix || r || i.keyPrefix;
      const p = o.options.keySeparator || ".";
      let m;
      return c.keyPrefix && Array.isArray(a) ? m = a.map((v) => `${c.keyPrefix}${p}${v}`) : m = c.keyPrefix ? `${c.keyPrefix}${p}${a}` : a, o.t(m, c);
    };
    return typeof t == "string" ? i.lng = t : i.lngs = t, i.ns = n, i.keyPrefix = r, i;
  }
  t() {
    return this.translator && this.translator.translate(...arguments);
  }
  exists() {
    return this.translator && this.translator.exists(...arguments);
  }
  setDefaultNamespace(t) {
    this.options.defaultNS = t;
  }
  hasLoadedNamespace(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (!this.isInitialized)
      return this.logger.warn("hasLoadedNamespace: i18next was not initialized", this.languages), !1;
    if (!this.languages || !this.languages.length)
      return this.logger.warn("hasLoadedNamespace: i18n.languages were undefined or empty", this.languages), !1;
    const r = n.lng || this.resolvedLanguage || this.languages[0], o = this.options ? this.options.fallbackLng : !1, i = this.languages[this.languages.length - 1];
    if (r.toLowerCase() === "cimode")
      return !0;
    const a = (s, c) => {
      const l = this.services.backendConnector.state[`${s}|${c}`];
      return l === -1 || l === 2;
    };
    if (n.precheck) {
      const s = n.precheck(this, a);
      if (s !== void 0)
        return s;
    }
    return !!(this.hasResourceBundle(r, t) || !this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages || a(r, t) && (!o || a(i, t)));
  }
  loadNamespaces(t, n) {
    const r = $u();
    return this.options.ns ? (typeof t == "string" && (t = [t]), t.forEach((o) => {
      this.options.ns.indexOf(o) < 0 && this.options.ns.push(o);
    }), this.loadResources((o) => {
      r.resolve(), n && n(o);
    }), r) : (n && n(), Promise.resolve());
  }
  loadLanguages(t, n) {
    const r = $u();
    typeof t == "string" && (t = [t]);
    const o = this.options.preload || [], i = t.filter((a) => o.indexOf(a) < 0);
    return i.length ? (this.options.preload = o.concat(i), this.loadResources((a) => {
      r.resolve(), n && n(a);
    }), r) : (n && n(), Promise.resolve());
  }
  dir(t) {
    if (t || (t = this.resolvedLanguage || (this.languages && this.languages.length > 0 ? this.languages[0] : this.language)), !t)
      return "rtl";
    const n = ["ar", "shu", "sqr", "ssh", "xaa", "yhd", "yud", "aao", "abh", "abv", "acm", "acq", "acw", "acx", "acy", "adf", "ads", "aeb", "aec", "afb", "ajp", "apc", "apd", "arb", "arq", "ars", "ary", "arz", "auz", "avl", "ayh", "ayl", "ayn", "ayp", "bbz", "pga", "he", "iw", "ps", "pbt", "pbu", "pst", "prp", "prd", "ug", "ur", "ydd", "yds", "yih", "ji", "yi", "hbo", "men", "xmn", "fa", "jpr", "peo", "pes", "prs", "dv", "sam", "ckb"], r = this.services && this.services.languageUtils || new Kk(eM());
    return n.indexOf(r.getLanguagePartFromCode(t)) > -1 || t.toLowerCase().indexOf("-arab") > 1 ? "rtl" : "ltr";
  }
  static createInstance() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = arguments.length > 1 ? arguments[1] : void 0;
    return new Ud(t, n);
  }
  cloneInstance() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : wp;
    const r = t.forkResourceStore;
    r && delete t.forkResourceStore;
    const o = $e(pe(pe({}, this.options), t), {
      isClone: !0
    }), i = new Ud(o);
    return (t.debug !== void 0 || t.prefix !== void 0) && (i.logger = i.logger.clone(t)), ["store", "services", "language"].forEach((a) => {
      i[a] = this[a];
    }), i.services = pe({}, this.services), i.services.utils = {
      hasLoadedNamespace: i.hasLoadedNamespace.bind(i)
    }, r && (i.store = new Zk(this.store.data, o), i.services.resourceStore = i.store), i.translator = new rm(i.services, o), i.translator.on("*", function(a) {
      for (var s = arguments.length, c = new Array(s > 1 ? s - 1 : 0), l = 1; l < s; l++)
        c[l - 1] = arguments[l];
      i.emit(a, ...c);
    }), i.init(o, n), i.translator.options = o, i.translator.backendConnector.services.utils = {
      hasLoadedNamespace: i.hasLoadedNamespace.bind(i)
    }, i;
  }
  toJSON() {
    return {
      options: this.options,
      store: this.store,
      language: this.language,
      languages: this.languages,
      resolvedLanguage: this.resolvedLanguage
    };
  }
}
const WD = Ud.createInstance();
WD.createInstance = Ud.createInstance;
const Uoe = {
  error: "Error"
}, qoe = {
  error: "Помилка"
}, nM = "common", Goe = {
  en: Uoe,
  uk: qoe
}, _i = WD.createInstance({
  defaultNS: nM,
  resources: Yoe(Goe, nM),
  lng: "en",
  fallbackLng: "en"
}), VD = {
  i18nextInstance: _i,
  initPromise: _i.init().then(() => _i)
}, Qp = /* @__PURE__ */ new Map();
Qp.set("common", VD);
const UD = (e) => {
  if (Qp.has(e.namespace))
    return Qp.get(e.namespace);
  if (e.plugins)
    for (const i of e.plugins)
      _i.use(i);
  Object.keys(e.resource).forEach((i) => {
    _i.addResourceBundle(i, e.namespace, e.resource[i]);
  });
  const t = _i.cloneInstance({
    defaultNS: e.namespace
  });
  let n = VD.initPromise.then(() => t);
  t.on("languageChanged", (i) => {
    _i.language !== i && _i.changeLanguage(i);
  }), _i.on("languageChanged", (i) => {
    t.language !== i && t.changeLanguage(i);
  });
  const r = e.language || "en";
  _i.language !== r && (n = n.then(() => t.changeLanguage(r)).then(() => t));
  const o = { initPromise: n, i18nextInstance: t };
  return Qp.set(e.namespace, o), o;
};
function Yoe(e, t) {
  return Object.keys(e).reduce((n, r) => (n[r] = {
    [t]: e[r]
  }, n), {});
}
const Zoe = {
  errors: {
    measure: {
      unsupportedType: "Unsupported measure type",
      dimensionalCalculatedMeasure: {
        noContext: "DimensionalCalculatedMeasure must have 'context' property"
      },
      dimensionalBaseMeasure: {
        noAttributeDimExpression: "DimensionalBaseMeasure must have 'attribute'/'dim'/'expression' property",
        noAggAggregation: "DimensionalBaseMeasure must have 'agg' or 'aggregation' property"
      },
      notAFormula: "Jaql is not a formula"
    },
    dataModelConfig: {
      noName: "'name' must be specified in config for DataModel",
      noMetadata: "'metadata' must be specified in config for DataModel"
    },
    filter: {
      unsupportedType: "Unsupported filter type: {{filterType}}",
      unsupportedDatetimeLevel: 'Filters do not support the next "datetime" levels: Hours, MinutesRoundTo30, MinutesRoundTo15, Minutes, Seconds',
      membersFilterNullMember: "MembersFilter of {{attributeId}} - member cannot be null",
      unsupportedConditionFilter: "Jaql contains unsupported condition filter: {{filter}}",
      formulaFiltersNotSupported: "Formula-based filter not supported yet: {{filter}}"
    },
    unsupportedDimensionalElement: "Unsupported dimensional element type"
  }
}, Xoe = {
  errors: {
    measure: {
      unsupportedType: "Непідтримуваний тип measure",
      dimensionalCalculatedMeasure: {
        noContext: "DimensionalCalculatedMeasure має мати властивість 'context'"
      },
      dimensionalBaseMeasure: {
        noAttributeDimExpression: "DimensionalBaseMeasure має мати властивість 'attribute'/'dim'/'expression'",
        noAggAggregation: "DimensionalBaseMeasure має мати властивість 'agg' або 'aggregation'"
      },
      notAFormula: "Jaql не формула"
    },
    dataModelConfig: {
      noName: "'name' має бути вказано в конфігурації для DataModel",
      noMetadata: "'metadata' має бути вказано в конфігурації для DataModel"
    },
    filter: {
      unsupportedType: "Непідтримуваний тип фільтра: {{filterType}}",
      unsupportedDatetimeLevel: 'Фільтри не підтримують наступні рівні "datetime": Hours, MinutesRoundTo30, MinutesRoundTo15, Minutes, Seconds',
      membersFilterNullMember: "MembersFilter у {{attributeId}} - member не може бути нульовим",
      unsupportedConditionFilter: "Jaql містить непідтримуваний condition фільтр: {{filter}}",
      formulaFiltersNotSupported: "Фільтри, що містять формули наразі не підтримуються: {{filter}}"
    },
    unsupportedDimensionalElement: "Непідтримуваний тип елемента"
  }
}, Koe = "sdkData", Joe = {
  en: Zoe,
  uk: Xoe
};
function Qoe() {
  return UD({
    resource: Joe,
    language: "en",
    namespace: Koe
  });
}
Qoe();
const rM = {
  table: { columns: [], rows: [] }
};
var B0;
(function(e) {
  e[e.None = 0] = "None", e[e.Ascending = 1] = "Ascending", e[e.Descending = 2] = "Descending";
})(B0 = B0 || (B0 = {}));
var H0;
(function(e) {
  e.TEXT = "text", e.NUMERIC = "numeric", e.DATETIME = "datetime";
})(H0 = H0 || (H0 = {}));
var j0;
(function(e) {
  e.ASC = "asc", e.DESC = "desc";
})(j0 = j0 || (j0 = {}));
var eh;
(function(e) {
  e.INCLUDE_ALL = "INCLUDE_ALL", e.ADVANCED = "ADVANCED", e.INVALID = "INVALID", e.CONDITION = "CONDITION", e.SPECIFIC_ITEMS = "SPECIFIC_ITEMS";
})(eh = eh || (eh = {}));
var th;
(function(e) {
  e.PERIOD = "PERIOD", e.DATE_RANGE = "DATE_RANGE";
})(th = th || (th = {}));
var nh;
(function(e) {
  e.NUMERIC_RANGE = "NUMERIC_RANGE";
})(nh = nh || (nh = {}));
var W0;
(function(e) {
  e.YEARS = "years", e.QUARTERS = "quarters", e.MONTHS = "months", e.WEEKS = "weeks", e.DAYS = "days", e.HOURS = "hours", e.MINUTES = "minutes";
})(W0 = W0 || (W0 = {}));
var V0;
(function(e) {
  e.DATE_TIME = "datetime", e.NUMERIC = "numeric", e.TEXT = "text";
})(V0 = V0 || (V0 = {}));
Object.assign(Object.assign(Object.assign({}, eh), th), nh);
var U0;
(function(e) {
  e.IS = "members", e.IS_NOT = "exclude", e.IS_WITHIN = "isWithin", e.TOP = "top", e.BOTTOM = "bottom", e.AFTER = "after", e.BEFORE = "before", e.STARTS_WITH = "startsWith", e.DOESNT_START_WITH = "doesntStartWith", e.ENDS_WITH = "endsWith", e.DOESNT_END_WITH = "doesntEndWith", e.CONTAINS = "contains", e.DOESNT_CONTAIN = "doesntContain", e.EQUALS = "equals", e.DOESNT_EQUAL = "doesntEqual", e.IS_EMPTY = "isEmpty", e.IS_NOT_EMPTY = "isNotEmpty", e.GREATER_THAN = "fromNotEqual", e.GREATER_THAN_OR_EQUAL = "from", e.LESS_THAN = "toNotEqual", e.LESS_THAN_OR_EQUAL = "to", e.BETWEEN = "between", e.IS_NOT_BETWEEN = "isNotBetween", e.MULTIPLE_CONDITION = "multipleCondition", e.NONE = "none";
})(U0 = U0 || (U0 = {}));
const Hs = (e) => {
  if (Array.isArray(e)) {
    const [t, ...n] = e;
    return n.length === 0 ? Hs(t) : {
      operator: "AND",
      left: Hs(t),
      right: Hs(n)
    };
  }
  return e;
};
var q0;
(function(e) {
  e.and = (t, n) => ({
    operator: "AND",
    left: Hs(t),
    right: Hs(n)
  }), e.or = (t, n) => ({
    operator: "OR",
    left: Hs(t),
    right: Hs(n)
  });
})(q0 = q0 || (q0 = {}));
class eie {
  /**
   * @param socket - socket instance
   */
  constructor(t) {
    Z(this, "dataLoadService"), Z(this, "socket"), this.socket = t;
  }
  destroy() {
  }
  prepareRequest(t) {
    return Promise.resolve(t);
  }
  prepareLoadService(t, n = !1) {
    return this.dataLoadService && (n || this.dataLoadService.isFormattingChanges(t)) ? this.dataLoadService : new BD(this.socket);
  }
  prepareDataService(t) {
    const n = new zr(t);
    return {
      loadData: (r, o, i) => {
        if (!n)
          throw new Error('No DataService defined during "prepareDataService"');
        return n.loadData(r, { pageSize: o, isPaginated: i });
      }
    };
  }
  loadInitData(t, n = !0, r = 100, o = !1) {
    return YO(this, null, function* () {
      const i = n ? r : void 0;
      try {
        const a = yield this.prepareRequest(t);
        this.dataLoadService = this.prepareLoadService(a, o);
        const { loadData: s } = this.prepareDataService(this.dataLoadService), { rowsTreeService: c, columnsTreeService: l, cornerTreeService: d, isLastPage: f } = yield s(
          o ? void 0 : a,
          i,
          n
        );
        return this.transformTreeStructuresToResultData({
          rowsTreeService: c,
          columnsTreeService: l,
          cornerTreeService: d,
          isLastPage: f
        });
      } catch (a) {
        console.error('Error during loading initial page"', a);
      }
      return rM;
    });
  }
  buildColumnsHelper(t, n, r, o) {
    var i;
    const a = `${r}${r === "" ? "" : " | "}${(i = o.value) == null ? void 0 : i.toString()}`;
    o.children ? o.children.forEach((s) => {
      this.buildColumnsHelper(t, n, a, s);
    }) : n.push({ name: a, type: t });
  }
  /**
   * Transforms Pivot Grid to Columns of Table structure
   *
   * @param columnType - type of column
   * @param grid - pivot grid
   * @returns An array of columns
   */
  transformGridToColumns(t, n) {
    const r = [];
    return n == null || n[0].forEach((o) => {
      typeof o != "string" && this.buildColumnsHelper(t, r, "", o);
    }), r || [];
  }
  // eslint-disable-next-line sonarjs/cognitive-complexity,max-lines-per-function
  transformTreeStructuresToResultData(t) {
    const { rowsTreeService: n, columnsTreeService: r, cornerTreeService: o } = t;
    if (!n || !r || !o)
      return rM;
    let i = [];
    i = o.getGrid();
    let a = [];
    a = r.getGrid();
    let s = [];
    s = n.getGrid();
    const c = this.transformGridToColumns("string", i), l = this.transformGridToColumns("number", a), d = [...c, ...l];
    let f = [];
    f = n.extractData(r);
    const p = f.length, m = d.length, v = [];
    let g = 0, b = 0;
    return Array.from(Array(p)).map((x, T) => {
      const S = [];
      Array.from(Array(m)).map((_, w) => {
        var k, E;
        let R;
        if (w < c.length) {
          g = T, b = w;
          try {
            R = s[g][b];
          } catch (A) {
            throw new Error(`Can't find data item for ${g}-${b}`);
          }
        } else {
          g = T, b = w - c.length;
          try {
            R = f[g][b];
          } catch (A) {
            throw new Error(`Can't find data item for ${g}-${b}`);
          }
        }
        let P;
        if (typeof R == "string") {
          const A = R.split("-");
          if (A.length === 2) {
            const D = Number(A[0]), N = Number(A[1]);
            R = s[D][N], P = ((k = R.value) == null ? void 0 : k.toString()) || "";
          } else
            P = "";
        } else
          P = ((E = R.value) == null ? void 0 : E.toString()) || "";
        S.push({ data: P, text: P });
      }), v.push(S);
    }), {
      table: {
        columns: d,
        rows: v
      },
      grids: {
        corner: i,
        rows: s,
        columns: a,
        values: f
      }
    };
  }
}
const tie = {
  errorPrefix: "[request-error]",
  errors: {
    networkError: "Network error. Probably you forgot to add your domain to 'CORS Allowed Origins' in Sisense Admin Panel -> Security Settings.",
    ssoNotEnabled: "SSO is not enabled on target instance, please choose another authentication method.",
    ssoNoLoginUrl: "Can not fetch login URL on target instance. Check SSO settings.",
    passwordAuthFailed: "$t(errorPrefix) Username and password authentication was not successful. Check credentials.",
    tokenAuthFailed: "$t(errorPrefix) Token authentication was not successful. Check credentials.",
    responseError_onlyStatus: "$t(errorPrefix) Status: {{status}}",
    responseError_withStatusText: "$t(errorPrefix) Status: {{status}} - {{statusText}}"
  }
}, nie = {
  errorPrefix: "[request-error]",
  errors: {
    networkError: "Помилка мережі. Можливо ви забули додати свій домен до «CORS Allowed Origins» в панелі адміністратора Sisense -> Security Settings.",
    ssoNotEnabled: "SSO не ввімкнено на цьому сервері, будь ласка, виберіть інший метод аутентифікації",
    ssoNoLoginUrl: "Неможливо отримати loginUrl з сервера. Перевірте налаштування SSO.",
    passwordAuthFailed: "$t(errorPrefix) Помилка автентифікації за допомогою імені користувача та пароля. Перевірте дані для входу.",
    tokenAuthFailed: "$t(errorPrefix) Помилка автентифікації за допомогою токена. Перевірте дані для входу.",
    responseError_onlyStatus: "$t(errorPrefix) Статус: {{status}}",
    responseError_withStatusText: "$t(errorPrefix) Статус: {{status}} - {{statusText}}"
  }
}, rie = "sdkRestClient", oie = {
  en: tie,
  uk: nie
};
function iie() {
  return UD({
    resource: oie,
    language: "en",
    namespace: rie
  });
}
iie();
function aie(e) {
  return e.type === "bearer";
}
function sie(e) {
  return e.type === "wat";
}
function lie(e) {
  return e.type === "sso";
}
class cie {
  constructor() {
    Z(this, "events"), Z(this, "ready", !0), Z(this, "onMessageCallback"), this.events = new uf(), this.ready = !0;
  }
  /**
   * Checks if socket is ready for sending messages or not
   *
   * @returns {boolean} - true - ready
   */
  isReady() {
    return this.ready;
  }
  /**
   * Attach event handler
   *
   * @param {string} event - event name
   * @param {Function} cb - handler function
   * @returns {void}
   */
  on(t, n) {
    this.events.on(t, n);
  }
  /**
   * Detach event handler
   *
   * @param {string} event - event name
   * @param {Function} cb - handler function
   * @returns {void}
   */
  off(t, n) {
    this.events.removeListener(t, n);
  }
  /**
   * Send message via socket
   *
   * @param {string} event - message name
   * @param {Array<any>} args - arguments
   * @param {Array<any>} args.0 - message data
   * @returns {void}
   */
  send(t, ...n) {
    const r = t || n;
    this.ready = !!r || !0;
  }
  /**
   * Specific message handler
   *
   * @param {string} type - message type
   * @param {string} subType - message subtype (query ID)
   * @param {Function} callback - handler function
   * @returns {Function} - unsubscribe function
   */
  onMessage(t, n, r) {
    this.onMessageCallback = r;
    const o = () => {
    };
    return this.on("message", o), () => {
      this.off("message", o);
    };
  }
  /**
   * Emulate receiving message from socket
   *
   * @param {string} event - message type
   * @param {any} data - message data
   * @returns {Promise} - waiting promise
   */
  trigger(t, n) {
    return new Promise((r) => {
      setTimeout(() => {
        this.onMessageCallback && this.onMessageCallback(t, n), r();
      }, 10);
    });
  }
}
const uie = "pivot2";
class die {
  constructor(t, n, r = !1) {
    Z(this, "_socket"), Z(this, "_url"), Z(this, "_auth"), Z(this, "_mockSocket"), this._url = t, this._auth = n, this._mockSocket = r;
  }
  getQueryOptionsSso(t) {
    return {};
  }
  getQueryOptionsBearer(t) {
    const n = t.bearer;
    if (!n)
      throw new Error("Missing bearer token");
    return {
      token: n
    };
  }
  getQueryOptionsWat(t) {
    const n = new Headers();
    t.applyHeader(n);
    const r = n.get("Authorization"), o = n.get("Initialiser");
    if (!r || !o)
      throw new Error("Missing auth header");
    return {
      authorization: r,
      initialiser: o
    };
  }
  get socket() {
    if (!this._socket) {
      if (this._mockSocket)
        return this._socket = new cie(), this._socket;
      const t = this._auth, n = this._url;
      let r = {};
      aie(t) ? r = this.getQueryOptionsBearer(t) : sie(t) ? r = this.getQueryOptionsWat(t) : lie(t) && (r = this.getQueryOptionsSso(t)), this._socket = new Pw(n + uie, r);
    }
    return this._socket;
  }
}
class c$e {
  constructor(t, n, r = !1) {
    Z(this, "socketBuilder"), this.socketBuilder = new die(t, n, r);
  }
  queryData(t, n, r, o) {
    return YO(this, null, function* () {
      return new eie(this.socketBuilder.socket).loadInitData(t, n, r, o);
    });
  }
  prepareDataService() {
    const t = new BD(this.socketBuilder.socket);
    return new zr(t);
  }
  preparePivotBuilder() {
    const t = this.prepareDataService();
    return new Ore(t);
  }
}
(function() {
  try {
    if (typeof document != "undefined") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode('.multi-grid{position:relative;display:block;overflow:hidden}.table-grid{position:relative;direction:ltr;will-change:transform;-webkit-overflow-scrolling:touch;background:#fff;user-select:text;-webkit-touch-callout:text;overflow-x:hidden;overflow-y:hidden}.table-grid,.table-grid *{box-sizing:border-box}.table-grid--top.table-grid--left,.table-grid--top.table-grid--right,.table-grid--bottom.table-grid--left,.table-grid--bottom.table-grid--right{position:absolute}.table-grid--top.table-grid--left,.table-grid--top.table-grid--right,.table-grid--bottom.table-grid--left{overflow-x:hidden;overflow-y:hidden}.table-grid__table{position:relative;display:table;table-layout:fixed;border-spacing:0;border-collapse:collapse}.table-grid__tbody{border-style:inherit;border-color:inherit;border-width:inherit;display:table-row-group}.table-grid__colgroup{display:table-column-group}.table-grid__column{display:table-column}.table-grid__row{border-style:inherit;border-color:inherit;border-width:inherit;display:table-row}.table-grid__cell{position:static!important;display:table-cell;vertical-align:top;box-sizing:border-box;white-space:nowrap;font-size:0;line-height:0;max-width:100%;margin:0;padding:0;border:solid 0 black;border-color:inherit;border-top-color:transparent;border-left-color:transparent}.table-grid__cell--row-0{border-top-color:inherit}.table-grid__cell--col-0,.table-grid__cell--columns{border-left-color:inherit}.table-grid__cell--fixed-width{white-space:normal}.table-grid__cell--fixed-width .table-grid__content{text-overflow:ellipsis}.table-grid__cell--fixed-width .table-grid__content__inner{display:inline;margin-right:0}.table-grid__cell-corner{border-style:inherit;border-color:inherit;border-width:inherit;position:relative;top:0;left:0;border-width:0}.table-grid__content{display:inline-block;font-size:15px;line-height:16px;position:relative;z-index:1}.table-grid__content__wrapper{display:inline;position:relative;z-index:1}.table-grid__content__inner{display:inline;position:relative;margin-right:1px;z-index:1}.table-grid__cell-corner{position:relative}.table-grid__cell-anchor{border-width:0;line-height:0;font-size:0;margin:0;padding:0}.table-grid__cell-anchor-content{width:0;height:0;line-height:0;font-size:0;overflow:hidden}.table-grid__cell--sorted .table-grid__content__inner{margin-right:16px}.table-grid__cell--sorted.table-grid__cell--fixed-width .table-grid__content__inner{margin-right:15px}.table-grid__cell--sorted .table-grid__icon--sorted,.table-grid__cell--sorted .table-grid__sorting-settings-icon{z-index:2;top:4px;right:3px;outline:none;display:inline-block;position:absolute;width:16px;height:12px}.table-grid__cell--sorted .table-grid__icon--sorted:after,.table-grid__cell--sorted .table-grid__sorting-settings-icon:after{display:inline-block;position:absolute;left:20%;top:25%;font-size:15px}.table-grid__cell--sorted .table-grid__icon--sorted:hover,.table-grid__cell--sorted .table-grid__sorting-settings-icon:hover{cursor:pointer}.table-grid--data{left:0!important;overflow-x:visible!important;overflow-y:visible!important}.multi-grid--no-fixed-left .table-grid--fixed.table-grid--rows,.multi-grid--no-fixed-left .table-grid--fixed.table-grid--corner,.multi-grid--no-rows .table-grid--fixed.table-grid--rows,.multi-grid--no-columns .table-grid--fixed.table-grid--columns,.multi-grid--no-corner .table-grid--fixed.table-grid--corner{opacity:0;visibility:hidden}.table-grid--fixed{position:absolute;display:block;opacity:0;transition:opacity 0s ease;background:#fff;overflow:hidden;z-index:10}.table-grid--fixed.active{opacity:1}.table-grid--fixed.table-grid--rows{top:0;left:0;bottom:0}.table-grid--fixed.table-grid--columns{top:0;left:0;right:0}.table-grid--fixed.table-grid--corner{top:0;left:0}.sis-scope .sisense-pivot__pagination-panel .MuiTablePagination-root{background-color:initial;overflow:initial}.sis-scope .sisense-pivot__pagination-panel .MuiTablePagination-root .MuiTablePagination-select{background-color:initial}.sis-scope .sisense-pivot__pagination-panel .MuiTablePagination-root .MuiTablePagination-toolbar{min-height:0}.sis-scope .sisense-pivot__pagination-panel{display:block;transition:opacity .3s ease}.sis-scope .sisense-pivot__pagination-panel--hidden{display:none}.sis-scope .sisense-pivot__pagination-panel .sisense-pivot__pagination-panel-list-wrapper,.sis-scope .sisense-pivot__pagination-panel .sisense-pivot__pagination-panel-total-wrapper,.sis-scope .sisense-pivot__pagination-panel .sisense-pivot__pagination-panel-notification{visibility:hidden;opacity:0}.sis-scope .sisense-pivot__pagination-panel-wrapper{display:flex;justify-content:space-between;align-items:center}.sis-scope .sisense-pivot__pagination-panel-list-wrapper{flex:1}.sis-scope .sisense-pivot__pagination-panel-list{display:flex;align-items:center;margin:0;padding:0;list-style:none}.sis-scope .sisense-pivot__pagination-panel-notification{display:flex;align-items:center;overflow:hidden;white-space:nowrap;cursor:pointer}.sis-scope .sisense-pivot__pagination-panel-notification-more{outline:none;margin-left:5px;margin-right:5px}.sis-scope .sisense-pivot__pagination-panel-total-wrapper{display:flex;overflow:hidden;white-space:nowrap;justify-content:flex-end}.sis-scope .sisense-pivot__pagination-panel-rows-count{padding-left:10px;margin-right:10px;border-left:1px solid #d8d8d8;pointer-events:none;overflow:hidden;text-overflow:ellipsis}.sis-scope .sisense-pivot__pagination-panel--showed .sisense-pivot__pagination-panel-list-wrapper,.sis-scope .sisense-pivot__pagination-panel--showed .sisense-pivot__pagination-panel-total-wrapper,.sis-scope .sisense-pivot__pagination-panel--notification-only .sisense-pivot__pagination-panel-notification,.sis-scope .sisense-pivot__pagination-panel--limits-only .sisense-pivot__pagination-panel-total-wrapper{visibility:visible;opacity:1}.sis-scope .sisense-pivot__pagination-panel--limits-only .sisense-pivot__pagination-panel-rows-count{border-left:none}.sis-scope .pivot-scroller,.sis-scope .pivot-scroller__container{height:40px}.sisense-pivot__resize-control{position:absolute;top:0;right:0;width:4px;height:50px;margin-left:-4px;cursor:col-resize;z-index:4}.sisense-pivot__data-bar{position:absolute;top:8px;left:0;width:50%;height:10px;padding:0 8px;opacity:0}.sisense-pivot__data-bar--show{opacity:0;transition:opacity .3s ease}.sisense-pivot__data-bar--show-active{opacity:1}.sisense-pivot__data-bar-inner{position:relative;height:100%;overflow:hidden}.sisense-pivot__data-bar-bar{position:absolute;top:0;height:100%;min-width:8px;background:green}.sisense-pivot{position:relative;height:100%;-webkit-text-size-adjust:none}.sisense-pivot .table-grid__content{overflow:hidden;max-width:100%}.sisense-pivot>.scroll-elem__horizontal-track,.sisense-pivot>.scroll-elem__vertical-track{z-index:5;opacity:0;transition:opacity .3s ease}.sisense-pivot ::-webkit-scrollbar{display:none}.sisense-pivot .scroll-elem__horizontal-track,.sisense-pivot .scroll-elem__vertical-track{opacity:0;transition:opacity .3s ease}.sisense-pivot:hover .scroll-elem__horizontal-track,.sisense-pivot:hover .scroll-elem__vertical-track{opacity:1}.sisense-pivot--merged-last-level-rows .table-grid--bottom.table-grid--left .table-grid__border-bottom{display:block}.sisense-pivot--merged-last-level-rows .table-grid--bottom.table-grid--left .table-grid__cell--level-last:not(.table-grid__cell--sibling-last):not(.table-grid__cell--merged-columns){border-bottom-color:transparent}.sisense-pivot--merged-last-level-rows .table-grid--bottom.table-grid--left .table-grid__cell--level-first.table-grid__cell--level-last:not(.table-grid__cell--merged-columns):not(.table-grid__cell--sibling-last){border-bottom-color:transparent}.sisense-pivot--merged-last-level-rows .table-grid--bottom.table-grid--left .table-grid__cell--level-first.table-grid__cell--level-last.table-grid__cell--user-type-grandTotal{border-bottom-color:transparent}.sisense-pivot--merged-last-level-rows .table-grid--bottom.table-grid--left .table-grid__cell--level-first.table-grid__cell--level-last.table-grid__cell--user-type-grandTotal .table-grid__cell-virtual-border{position:absolute;bottom:100%;left:0;display:block;width:2000px;height:1px;border-style:inherit;border-bottom-color:inherit;border-width:0}.sisense-pivot--merged-last-level-rows .table-grid--bottom.table-grid--right .table-grid__border-bottom{display:block}.sisense-pivot--merged-last-level-rows .table-grid--bottom.table-grid--right .table-grid__cell--row-level-last:not(.table-grid__cell--row-sibling-last):not(.table-grid__cell--row-user-type-subTotal):not(.table-grid__cell--col-user-type-subTotal):not(.table-grid__cell--col-user-type-grandTotal){border-bottom-color:transparent}.sisense-pivot--merged-last-level-rows .table-grid--bottom.table-grid--right .table-grid__cell--row-user-type-grandTotal{border-bottom-color:transparent}.sisense-pivot--merged-last-level-rows .table-grid--bottom.table-grid--right .table-grid__cell--row-user-type-grandTotal .table-grid__cell-virtual-border{position:absolute;bottom:100%;left:0;display:block;width:2000px;height:1px;border-style:inherit;border-bottom-color:inherit;border-width:0}.sisense-pivot__multi-grid--resize-in-progress{cursor:col-resize}.sisense-pivot__overlay{position:absolute;inset:0;z-index:1000000}@media print{div#root{margin:0!important;padding:0!important}.print-preview div.print-layout{margin:0!important;padding:0!important;background:none}.print-preview.print-layout div.print-layout__page{margin:0!important;padding:0!important;box-shadow:none;page-break-inside:avoid;page-break-after:always}}.print-preview.print-layout.print-layout__with-footer .page-footer{visibility:visible}.print-preview.print-layout .print-layout__page{display:flex;flex-flow:column;padding:0}.print-preview.print-layout .page-footer{flex-shrink:0;display:flex;flex-flow:column;justify-content:center;visibility:hidden;height:16px;clear:both;box-sizing:border-box;padding-top:10px;text-align:center}.print-preview.print-layout .page-footer>span,.print-preview.print-layout .page-footer div{flex-shrink:0;font-size:10px}.print-preview [contenteditable]:empty:before{content:attr(placeholder);display:block}.print-preview .title::-ms-clear{display:none}.print-preview .page-header{overflow:initial;height:40px;flex-shrink:0}.print-preview .page-header.page-header__content--show .page-header__title-container,.print-preview .page-header.page-header__content--show .page-header__header-divider,.print-preview .page-header.page-header__content--show .page-header__title{display:block}.print-preview .page-header .page-header__content,.print-preview .page-header .page-header__title-container,.print-preview .page-header .page-header__header-divider,.print-preview .page-header .page-header__title{display:none}.print-preview .page-header .page-header__content{height:34px;display:flex;flex-flow:row wrap;position:relative;z-index:3}.print-preview .page-header .page-header__content .page-header__title{text-overflow:ellipsis;overflow:hidden;word-wrap:normal;word-break:keep-all;white-space:nowrap;flex-grow:0;flex-shrink:0;order:1;background:rgba(0,0,0,0);border:none;outline:0;cursor:text;margin-right:10px;padding-left:5px;-webkit-user-select:text;user-select:text}.print-preview .page-header .page-header__content.page-header__title-container--focused .page-header__rename-controls{display:block}.print-preview .page-header .page-header__content.page-header__title-container--focused .page-header__editors{display:flex;align-items:center}.print-preview .page-header .page-header__content.page-header__title-container--focused .page-header__title{text-overflow:ellipsis;overflow:hidden;word-wrap:normal;word-break:keep-all;white-space:nowrap;flex-grow:0;flex-shrink:0;order:1;background:rgba(0,0,0,0);border:none;outline:0;cursor:text;margin-right:10px;padding-left:5px;-webkit-user-select:text;user-select:text}.print-preview .page-header .page-header__content .page-header__title-container,.print-preview .page-header .page-header__content .page-header__rename-controls{float:left}.print-preview .page-header .page-header__content .page-header__title-container{text-overflow:ellipsis;overflow:hidden;word-wrap:normal;word-break:keep-all;white-space:nowrap;font-size:16px;height:26px;width:100%;display:flex;flex-flow:row;justify-content:flex-start}.print-preview .page-header .page-header__content .page-header__rename-controls{display:none;flex-basis:32px;flex-grow:0;flex-shrink:0;order:1}.print-preview .page-header .page-header__content .page-header__rename-controls .page-header__rename-controls__action{float:left;cursor:pointer;vertical-align:middle;width:16px;height:16px}.print-preview .page-header .page-header__content .page-header__rename-controls .page-header__rename-controls__action--ok:after{content:"V";color:#adff2f}.print-preview .page-header .page-header__content .page-header__rename-controls .page-header__rename-controls__action--ok:hover:after{content:"V";color:green}.print-preview .page-header .page-header__content .page-header__rename-controls .page-header__rename-controls__action--cancel:after{content:"X";color:orchid}.print-preview .page-header .page-header__content .page-header__rename-controls .page-header__rename-controls__action--cancel:hover:after{content:"X";color:red}.print-preview .page-header .page-header__content .page-header__header-divider{margin-top:6px;bottom:5px;border:1px solid #e5e5e5;position:relative;width:100%}.print-preview .page-header .page-header__content .page-header__editors{padding-left:10px;padding-right:10px;display:none;position:relative;width:275px;height:34px;background-color:#fff;border:solid 1px #e5e5e5}.print-preview .page-header .page-header__content .page-header__editors .page-header__vertical-line{margin-left:10px;border-left:1px solid #e5e5e5;height:16px}.print-preview .page-header .page-header__content .page-header__editors div{background:none;border:none;margin-left:15px}.print-preview .page-header .page-header__content .page-header__editors .page-header__editors__left-text,.print-preview .page-header .page-header__content .page-header__editors .page-header__editors__center-text,.print-preview .page-header .page-header__content .page-header__editors .page-header__editors__end-text{width:17px;height:16px}.print-preview .page-header .page-header__content .page-header__editors .page-header__editors__left-text:after{content:"L"}.print-preview .page-header .page-header__content .page-header__editors .page-header__editors__center-text:after{content:"C"}.print-preview .page-header .page-header__content .page-header__editors .page-header__editors__end-text:after{content:"R"}.sis-scope .sorting-settings-header{flex-shrink:0;background-color:#f4f4f8;width:100%;height:42px;padding:10px 10px 10px 16px;border-top-left-radius:4px;border-top-right-radius:4px;display:flex;flex-direction:row;justify-content:space-between;font-size:15px}.sis-scope .header-text{display:flex;flex-flow:row nowrap;width:calc(100% - 24px)}.sis-scope .header-text__sort-by{font-weight:700;flex-shrink:0}.sis-scope .header-text__hierarchy-container{flex-grow:1;text-overflow:ellipsis;padding:0 .5em;display:inline-block;overflow:hidden;white-space:nowrap;vertical-align:top}.sis-scope .cross-icon{position:relative;top:-2px;color:#5b6372;border-radius:50%;min-width:24px}.sis-scope .cross-icon:hover{cursor:pointer;background-color:#d1d1d7}.sis-scope .direction-selector{margin-top:.2em;margin-left:2.4em;font-weight:400;min-width:152px;width:152px}.sis-scope.direction-selector__menu{background-color:#fff!important}.sis-scope .settings-item+.settings-item{margin-top:.9em}.sis-scope .checkbox-input{display:flex;align-items:center;padding-right:8px}.sis-scope .checkbox-input .wrapper-of-input-highlighted{background-color:#5b63721a;border-radius:50%}.sis-scope .checkbox-input .subtotals-caption{margin-left:.2em}.sis-scope .checkbox-input .custom-checkbox{width:28px;height:28px}.sis-scope .checkbox-input .custom-checkbox__label{cursor:pointer}.sis-scope .checkbox-input .checkbox-input__text-wrapper{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.sis-scope .checkbox-input .checkbox-input__label{display:flex;align-items:center;height:28px;cursor:pointer;max-width:calc(100% - 28px)}.sis-scope .simple-sorting-settings{width:200px;box-shadow:0 0 5px #3a435633;border-radius:4px;display:flex;flex-direction:column;background-color:#fff}.sis-scope .simple-sorting-settings .header-text{width:100%}.sis-scope .simple-sorting-settings__actions{padding:10px 0;display:flex;flex-direction:column;align-items:flex-start}.sis-scope .simple-sorting-settings__actions>div{width:100%}.sis-scope .simple-sorting-settings__actions>div>div{width:100%;border-radius:0;padding:5px 16px;margin:0;height:auto;cursor:pointer}.sis-scope .simple-sorting-settings__actions>div>div:hover{background:rgba(91,99,114,.1)}.sis-scope .complex-sorting-settings{box-shadow:0 0 5px #3a435633;border-radius:4px;width:320px;height:100%;display:flex;justify-content:space-between;flex-direction:column;max-height:386px;background-color:#fff}.sis-scope .complex-sorting-settings__body{overflow:auto;flex-grow:1;padding:17px 17px 14px}.sis-scope .complex-sorting-settings__actions{flex-shrink:0;display:flex;align-items:center;justify-content:space-between;padding:8px 16px 14px}.sis-scope .complex-sorting-settings__actions .sp-buttons{margin:0 0 0 auto}.sis-scope .complex-sorting-settings__actions .sp-buttons button{min-width:74px}.sis-scope .complex-sorting-settings__actions .sp-buttons>button:first-child+button{margin-left:10px}.sis-scope .complex-sorting-settings .settings-checkboxes{margin-left:-3px;margin-top:15px}body .prism-widget-preview .sisense-pivot__pagination-panel-wrapper,div#idk .prism-widget-preview .sisense-pivot__pagination-panel-wrapper{padding-bottom:0}body .sisense-pivot__pagination-panel-list-wrapper,body .sisense-pivot__pagination-panel-rows-count,div#idk .sisense-pivot__pagination-panel-list-wrapper,div#idk .sisense-pivot__pagination-panel-rows-count{color:#acacac}body .sisense-pivot__pagination-panel-notification-more,div#idk .sisense-pivot__pagination-panel-notification-more{color:#1faff3}body .sisense-pivot__pagination-panel-notification-more:hover,div#idk .sisense-pivot__pagination-panel-notification-more:hover{cursor:pointer;text-decoration:underline}body .sisense-pivot__pagination-panel-page,div#idk .sisense-pivot__pagination-panel-page{margin:0}body .sisense-pivot__pagination-panel-page:hover,div#idk .sisense-pivot__pagination-panel-page:hover{text-decoration:none}body .sisense-pivot__pagination-panel-list--number .sisense-pivot__pagination-panel-page,div#idk .sisense-pivot__pagination-panel-list--number .sisense-pivot__pagination-panel-page{margin-right:6px}body .sisense-pivot__pagination-panel-list--number .sisense-pivot__pagination-panel-page:first-child,div#idk .sisense-pivot__pagination-panel-list--number .sisense-pivot__pagination-panel-page:first-child{margin-left:6px}body .sisense-pivot__pagination-panel-list--number .sisense-pivot__pagination-panel-page:not(.sisense-pivot__pagination-panel-page--disabled):hover,div#idk .sisense-pivot__pagination-panel-list--number .sisense-pivot__pagination-panel-page:not(.sisense-pivot__pagination-panel-page--disabled):hover{color:#272a34;text-decoration:underline}body .sisense-pivot__pagination-panel-page--active,div#idk .sisense-pivot__pagination-panel-page--active{font-weight:400;color:#272a34}body .sisense-pivot__pagination-panel-page--first.sisense-pivot__pagination-panel-page--disabled,body .sisense-pivot__pagination-panel-page--last.sisense-pivot__pagination-panel-page--disabled,body .sisense-pivot__pagination-panel-page--previous.sisense-pivot__pagination-panel-page--disabled,body .sisense-pivot__pagination-panel-page--next.sisense-pivot__pagination-panel-page--disabled,div#idk .sisense-pivot__pagination-panel-page--first.sisense-pivot__pagination-panel-page--disabled,div#idk .sisense-pivot__pagination-panel-page--last.sisense-pivot__pagination-panel-page--disabled,div#idk .sisense-pivot__pagination-panel-page--previous.sisense-pivot__pagination-panel-page--disabled,div#idk .sisense-pivot__pagination-panel-page--next.sisense-pivot__pagination-panel-page--disabled{opacity:.5}body .sisense-pivot__pagination-panel-page--first .sisense-pivot__pagination-panel-button,body .sisense-pivot__pagination-panel-page--last .sisense-pivot__pagination-panel-button,body .sisense-pivot__pagination-panel-page--previous .sisense-pivot__pagination-panel-button,body .sisense-pivot__pagination-panel-page--next .sisense-pivot__pagination-panel-button,div#idk .sisense-pivot__pagination-panel-page--first .sisense-pivot__pagination-panel-button,div#idk .sisense-pivot__pagination-panel-page--last .sisense-pivot__pagination-panel-button,div#idk .sisense-pivot__pagination-panel-page--previous .sisense-pivot__pagination-panel-button,div#idk .sisense-pivot__pagination-panel-page--next .sisense-pivot__pagination-panel-button{display:block;width:16px;height:16px;text-indent:20px;overflow:hidden;background-repeat:no-repeat}body .sisense-pivot__pagination-panel-page--first .sisense-pivot__pagination-panel-button,div#idk .sisense-pivot__pagination-panel-page--first .sisense-pivot__pagination-panel-button{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAABACAYAAAATffeWAAABSUlEQVR42u2VsYrCQBCGc1pZiYVwYuBAbJLKPQvL7D1EHiRNQgJJwMrOUhBbGzux8Bm0tfVhblZWCMNOdptEjPkgxQfzj0ncXy3rE7B75U7z5TK+cZl3JNwg/Mvv4+nCVnh1YcuZ8XVxGLt+AeM7+MTrYDLvq9yELryovcv+LjKEvfYl/EC42ZIfZz4q8Zbm9f8BHJQznP8V5VpE60T7niHsr1jiLVWu5XvKhvD8N2fmbVVuFBbtEwXCXl1Y/gaeisPYtci+dyhveUuCIOiVeem/dJ7nmyzLjoQbhe9hGNoKry5sweC6OIzdZMEOrmsURX2Va/F9vwu3vIfrIkLY618Ct39QufGSJElGlLc0sv8P4LCc4bCsKNciWifa9wxhr39JmqZLlWuJ43gIz3+D0FblRmHRPlEg7NWF5dd2Kg5j1yL73qG8gfwDYL8rrp3YiQAAAAAASUVORK5CYII=);background-position:0 -32px}body .sisense-pivot__pagination-panel-page--first:not(.sisense-pivot__pagination-panel-page--disabled):hover .sisense-pivot__pagination-panel-button,div#idk .sisense-pivot__pagination-panel-page--first:not(.sisense-pivot__pagination-panel-page--disabled):hover .sisense-pivot__pagination-panel-button{background-position:0 0}body .sisense-pivot__pagination-panel-page--last .sisense-pivot__pagination-panel-button,div#idk .sisense-pivot__pagination-panel-page--last .sisense-pivot__pagination-panel-button{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAABACAYAAAATffeWAAABSUlEQVR42u2VsYrCQBCGc1pZiYVwYuBAbJLKPQvL7D1EHiRNQgJJwMrOUhBbGzux8Bm0tfVhblZWCMNOdptEjPkgxQfzj0ncXy3rE7B75U7z5TK+cZl3JNwg/Mvv4+nCVnh1YcuZ8XVxGLt+AeM7+MTrYDLvq9yELryovcv+LjKEvfYl/EC42ZIfZz4q8Zbm9f8BHJQznP8V5VpE60T7niHsr1jiLVWu5XvKhvD8N2fmbVVuFBbtEwXCXl1Y/gaeisPYtci+dyhveUuCIOiVeem/dJ7nmyzLjoQbhe9hGNoKry5sweC6OIzdZMEOrmsURX2Va/F9vwu3vIfrIkLY618Ct39QufGSJElGlLc0sv8P4LCc4bCsKNciWifa9wxhr39JmqZLlWuJ43gIz3+D0FblRmHRPlEg7NWF5dd2Kg5j1yL73qG8gfwDYL8rrp3YiQAAAAAASUVORK5CYII=);background-position:0 -48px}body .sisense-pivot__pagination-panel-page--last:not(.sisense-pivot__pagination-panel-page--disabled):hover .sisense-pivot__pagination-panel-button,div#idk .sisense-pivot__pagination-panel-page--last:not(.sisense-pivot__pagination-panel-page--disabled):hover .sisense-pivot__pagination-panel-button{background-position:0 -16px}body .sisense-pivot__pagination-panel-page--previous .sisense-pivot__pagination-panel-button,div#idk .sisense-pivot__pagination-panel-page--previous .sisense-pivot__pagination-panel-button{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAABACAYAAAATffeWAAABBklEQVR42mNgGAXEAC4tQ7u94up6iqRrFVTi1zS0P65p4DCBZL28kmoiGgaOJ9UNHTrIcTajpoH9ZTU920py/U2xARR7gfJApE40joKRDpiAqe+JjIalLtkmaBpYeYMMUdCyMCfbEHUtKydNI/vnSvrmNmQboqJrZgkyRFraTJj+BlDkBUoDkfJoHAWjABn4+Phw1dbW7i0pKSG9YklLS+Ovq6s7XlNTM4EczSJAm08CNZPXPgDafBmomfz2AaUGUOwFygORKtE4CkbbB8DE86S8vJz8iqWqqsobZEhFRQX57QOgZidgXngOdAn57YPKykpLkCHZ2dnC9DeAIi9QGoiUR+MIAgDRRntRFUnDLQAAAABJRU5ErkJggg==);background-position:0 -32px}body .sisense-pivot__pagination-panel-page--previous:not(.sisense-pivot__pagination-panel-page--disabled):hover .sisense-pivot__pagination-panel-button,div#idk .sisense-pivot__pagination-panel-page--previous:not(.sisense-pivot__pagination-panel-page--disabled):hover .sisense-pivot__pagination-panel-button{background-position:0 0}body .sisense-pivot__pagination-panel-page--next .sisense-pivot__pagination-panel-button,div#idk .sisense-pivot__pagination-panel-page--next .sisense-pivot__pagination-panel-button{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAABACAYAAAATffeWAAABBklEQVR42mNgGAXEAC4tQ7u94up6iqRrFVTi1zS0P65p4DCBZL28kmoiGgaOJ9UNHTrIcTajpoH9ZTU920py/U2xARR7gfJApE40joKRDpiAqe+JjIalLtkmaBpYeYMMUdCyMCfbEHUtKydNI/vnSvrmNmQboqJrZgkyRFraTJj+BlDkBUoDkfJoHAWjABn4+Phw1dbW7i0pKSG9YklLS+Ovq6s7XlNTM4EczSJAm08CNZPXPgDafBmomfz2AaUGUOwFygORKtE4CkbbB8DE86S8vJz8iqWqqsobZEhFRQX57QOgZidgXngOdAn57YPKykpLkCHZ2dnC9DeAIi9QGoiUR+MIAgDRRntRFUnDLQAAAABJRU5ErkJggg==);background-position:0 -48px}body .sisense-pivot__pagination-panel-page--next:not(.sisense-pivot__pagination-panel-page--disabled):hover .sisense-pivot__pagination-panel-button,div#idk .sisense-pivot__pagination-panel-page--next:not(.sisense-pivot__pagination-panel-page--disabled):hover .sisense-pivot__pagination-panel-button{background-position:0 -16px}body .sisense-pivot__pagination-panel--mobile .sisense-pivot__pagination-panel-wrapper,div#idk .sisense-pivot__pagination-panel--mobile .sisense-pivot__pagination-panel-wrapper{padding:8px 0}body .sisense-pivot__pagination-panel--mobile .sisense-pivot__pagination-panel-list-wrapper:last-child .sisense-pivot__pagination-panel-page,div#idk .sisense-pivot__pagination-panel--mobile .sisense-pivot__pagination-panel-list-wrapper:last-child .sisense-pivot__pagination-panel-page{margin-left:10px}body .sisense-pivot__pagination-panel--mobile .sisense-pivot__pagination-panel-list-wrapper:first-child .sisense-pivot__pagination-panel-page,div#idk .sisense-pivot__pagination-panel--mobile .sisense-pivot__pagination-panel-list-wrapper:first-child .sisense-pivot__pagination-panel-page{margin-right:10px}body .sisense-pivot__pagination-panel--mobile .sisense-pivot__pagination-panel-page--first.sisense-pivot__pagination-panel-page--disabled,body .sisense-pivot__pagination-panel--mobile .sisense-pivot__pagination-panel-page--last.sisense-pivot__pagination-panel-page--disabled,body .sisense-pivot__pagination-panel--mobile .sisense-pivot__pagination-panel-page--previous.sisense-pivot__pagination-panel-page--disabled,body .sisense-pivot__pagination-panel--mobile .sisense-pivot__pagination-panel-page--next.sisense-pivot__pagination-panel-page--disabled,div#idk .sisense-pivot__pagination-panel--mobile .sisense-pivot__pagination-panel-page--first.sisense-pivot__pagination-panel-page--disabled,div#idk .sisense-pivot__pagination-panel--mobile .sisense-pivot__pagination-panel-page--last.sisense-pivot__pagination-panel-page--disabled,div#idk .sisense-pivot__pagination-panel--mobile .sisense-pivot__pagination-panel-page--previous.sisense-pivot__pagination-panel-page--disabled,div#idk .sisense-pivot__pagination-panel--mobile .sisense-pivot__pagination-panel-page--next.sisense-pivot__pagination-panel-page--disabled{opacity:.2}body .sisense-pivot__pagination-panel--mobile .sisense-pivot__pagination-panel-page--first .sisense-pivot__pagination-panel-button,body .sisense-pivot__pagination-panel--mobile .sisense-pivot__pagination-panel-page--last .sisense-pivot__pagination-panel-button,body .sisense-pivot__pagination-panel--mobile .sisense-pivot__pagination-panel-page--previous .sisense-pivot__pagination-panel-button,body .sisense-pivot__pagination-panel--mobile .sisense-pivot__pagination-panel-page--next .sisense-pivot__pagination-panel-button,div#idk .sisense-pivot__pagination-panel--mobile .sisense-pivot__pagination-panel-page--first .sisense-pivot__pagination-panel-button,div#idk .sisense-pivot__pagination-panel--mobile .sisense-pivot__pagination-panel-page--last .sisense-pivot__pagination-panel-button,div#idk .sisense-pivot__pagination-panel--mobile .sisense-pivot__pagination-panel-page--previous .sisense-pivot__pagination-panel-button,div#idk .sisense-pivot__pagination-panel--mobile .sisense-pivot__pagination-panel-page--next .sisense-pivot__pagination-panel-button{text-indent:30px;width:24px;height:24px}body .sisense-pivot__pagination-panel--mobile .sisense-pivot__pagination-panel-page--first .sisense-pivot__pagination-panel-button,body .sisense-pivot__pagination-panel--mobile .sisense-pivot__pagination-panel-page--first:hover .sisense-pivot__pagination-panel-button,div#idk .sisense-pivot__pagination-panel--mobile .sisense-pivot__pagination-panel-page--first .sisense-pivot__pagination-panel-button,div#idk .sisense-pivot__pagination-panel--mobile .sisense-pivot__pagination-panel-page--first:hover .sisense-pivot__pagination-panel-button{background-image:url(data:image/png;base64,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);background-position:0 0}body .sisense-pivot__pagination-panel--mobile .sisense-pivot__pagination-panel-page--last .sisense-pivot__pagination-panel-button,body .sisense-pivot__pagination-panel--mobile .sisense-pivot__pagination-panel-page--last:hover .sisense-pivot__pagination-panel-button,div#idk .sisense-pivot__pagination-panel--mobile .sisense-pivot__pagination-panel-page--last .sisense-pivot__pagination-panel-button,div#idk .sisense-pivot__pagination-panel--mobile .sisense-pivot__pagination-panel-page--last:hover .sisense-pivot__pagination-panel-button{background-image:url(data:image/png;base64,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);background-position:0 -24px}body .sisense-pivot__pagination-panel--mobile .sisense-pivot__pagination-panel-page--previous .sisense-pivot__pagination-panel-button,body .sisense-pivot__pagination-panel--mobile .sisense-pivot__pagination-panel-page--previous:hover .sisense-pivot__pagination-panel-button,div#idk .sisense-pivot__pagination-panel--mobile .sisense-pivot__pagination-panel-page--previous .sisense-pivot__pagination-panel-button,div#idk .sisense-pivot__pagination-panel--mobile .sisense-pivot__pagination-panel-page--previous:hover .sisense-pivot__pagination-panel-button{background-image:url(data:image/png;base64,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);background-position:0 0}body .sisense-pivot__pagination-panel--mobile .sisense-pivot__pagination-panel-page--next .sisense-pivot__pagination-panel-button,body .sisense-pivot__pagination-panel--mobile .sisense-pivot__pagination-panel-page--next:hover .sisense-pivot__pagination-panel-button,div#idk .sisense-pivot__pagination-panel--mobile .sisense-pivot__pagination-panel-page--next .sisense-pivot__pagination-panel-button,div#idk .sisense-pivot__pagination-panel--mobile .sisense-pivot__pagination-panel-page--next:hover .sisense-pivot__pagination-panel-button{background-image:url(data:image/png;base64,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);background-position:0 -24px}@media only screen and (-webkit-min-device-pixel-ratio: 1.5),only screen and (min--moz-device-pixel-ratio: 1.5),only screen and (min-device-pixel-ratio: 1.5){body .sisense-pivot__pagination-panel--mobile .sisense-pivot__pagination-panel-page--first .sisense-pivot__pagination-panel-button,body .sisense-pivot__pagination-panel--mobile .sisense-pivot__pagination-panel-page--last .sisense-pivot__pagination-panel-button,body .sisense-pivot__pagination-panel--mobile .sisense-pivot__pagination-panel-page--previous .sisense-pivot__pagination-panel-button,body .sisense-pivot__pagination-panel--mobile .sisense-pivot__pagination-panel-page--next .sisense-pivot__pagination-panel-button,div#idk .sisense-pivot__pagination-panel--mobile .sisense-pivot__pagination-panel-page--first .sisense-pivot__pagination-panel-button,div#idk .sisense-pivot__pagination-panel--mobile .sisense-pivot__pagination-panel-page--last .sisense-pivot__pagination-panel-button,div#idk .sisense-pivot__pagination-panel--mobile .sisense-pivot__pagination-panel-page--previous .sisense-pivot__pagination-panel-button,div#idk .sisense-pivot__pagination-panel--mobile .sisense-pivot__pagination-panel-page--next .sisense-pivot__pagination-panel-button{background-size:24px 96px}body .sisense-pivot__pagination-panel--mobile .sisense-pivot__pagination-panel-page--first .sisense-pivot__pagination-panel-button,body .sisense-pivot__pagination-panel--mobile .sisense-pivot__pagination-panel-page--first:hover .sisense-pivot__pagination-panel-button,body .sisense-pivot__pagination-panel--mobile .sisense-pivot__pagination-panel-page--last .sisense-pivot__pagination-panel-button,body .sisense-pivot__pagination-panel--mobile .sisense-pivot__pagination-panel-page--last:hover .sisense-pivot__pagination-panel-button,div#idk .sisense-pivot__pagination-panel--mobile .sisense-pivot__pagination-panel-page--first .sisense-pivot__pagination-panel-button,div#idk .sisense-pivot__pagination-panel--mobile .sisense-pivot__pagination-panel-page--first:hover .sisense-pivot__pagination-panel-button,div#idk .sisense-pivot__pagination-panel--mobile .sisense-pivot__pagination-panel-page--last .sisense-pivot__pagination-panel-button,div#idk .sisense-pivot__pagination-panel--mobile .sisense-pivot__pagination-panel-page--last:hover .sisense-pivot__pagination-panel-button{background-image:url(data:image/png;base64,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)}body .sisense-pivot__pagination-panel--mobile .sisense-pivot__pagination-panel-page--previous .sisense-pivot__pagination-panel-button,body .sisense-pivot__pagination-panel--mobile .sisense-pivot__pagination-panel-page--previous:hover .sisense-pivot__pagination-panel-button,body .sisense-pivot__pagination-panel--mobile .sisense-pivot__pagination-panel-page--next .sisense-pivot__pagination-panel-button,body .sisense-pivot__pagination-panel--mobile .sisense-pivot__pagination-panel-page--next:hover .sisense-pivot__pagination-panel-button,div#idk .sisense-pivot__pagination-panel--mobile .sisense-pivot__pagination-panel-page--previous .sisense-pivot__pagination-panel-button,div#idk .sisense-pivot__pagination-panel--mobile .sisense-pivot__pagination-panel-page--previous:hover .sisense-pivot__pagination-panel-button,div#idk .sisense-pivot__pagination-panel--mobile .sisense-pivot__pagination-panel-page--next .sisense-pivot__pagination-panel-button,div#idk .sisense-pivot__pagination-panel--mobile .sisense-pivot__pagination-panel-page--next:hover .sisense-pivot__pagination-panel-button{background-image:url(data:image/png;base64,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)}}body .narration-tooltip--pivot2-notification.narration-tooltip.bottom.show-add,div#idk .narration-tooltip--pivot2-notification.narration-tooltip.bottom.show-add{opacity:0;transform:translateY(5px);transition:opacity .3s,transform .3s}body .narration-tooltip--pivot2-notification.narration-tooltip.bottom.show-add-active,div#idk .narration-tooltip--pivot2-notification.narration-tooltip.bottom.show-add-active{opacity:1;transform:translate(0)}body .narration-tooltip--pivot2-notification.narration-tooltip.top.show-add,div#idk .narration-tooltip--pivot2-notification.narration-tooltip.top.show-add{opacity:0;transform:translateY(-5px);transition:opacity .3s,transform .3s}body .narration-tooltip--pivot2-notification.narration-tooltip.top.show-add-active,div#idk .narration-tooltip--pivot2-notification.narration-tooltip.top.show-add-active{opacity:1;transform:translate(0)}body .narration-tooltip--pivot2-notification.narration-tooltip.show-remove,div#idk .narration-tooltip--pivot2-notification.narration-tooltip.show-remove{visibility:visible;opacity:1;transition:opacity .3s}body .narration-tooltip--pivot2-notification.narration-tooltip.show-remove-active,div#idk .narration-tooltip--pivot2-notification.narration-tooltip.show-remove-active{opacity:0}body .narration-tooltip--pivot2-notification .narration-tooltip-host,div#idk .narration-tooltip--pivot2-notification .narration-tooltip-host{width:450px}body .narration-tooltip--pivot2-notification .narration-text,div#idk .narration-tooltip--pivot2-notification .narration-text{padding:7px 13px}body .new-widget-modal .sisense-pivot__multi-grid .table-grid__cell--sorted .table-grid__icon--sorted,body .new-widget-modal .sisense-pivot__multi-grid .table-grid__cell--sorted .table-grid__sorting-settings-icon,div#idk .new-widget-modal .sisense-pivot__multi-grid .table-grid__cell--sorted .table-grid__icon--sorted,div#idk .new-widget-modal .sisense-pivot__multi-grid .table-grid__cell--sorted .table-grid__sorting-settings-icon{display:none}body .pivot-container,div#idk .pivot-container{position:relative;height:100%;border-style:solid;border-width:8px;border-bottom-width:3px;z-index:1}body .sisense-pivot .table-grid--top.table-grid--left .table-grid__cell--level-first,body .sisense-pivot .table-grid--top.table-grid--right .table-grid__cell--level-first,body .sisense-pivot .table-grid--bottom.table-grid--left .table-grid__cell--level-first,div#idk .sisense-pivot .table-grid--top.table-grid--left .table-grid__cell--level-first,div#idk .sisense-pivot .table-grid--top.table-grid--right .table-grid__cell--level-first,div#idk .sisense-pivot .table-grid--bottom.table-grid--left .table-grid__cell--level-first,body .sisense-pivot .table-grid__cell--corner.table-grid__cell--level-first,body .sisense-pivot .table-grid__cell--columns.table-grid__cell--level-first,body .sisense-pivot .table-grid__cell--rows.table-grid__cell--level-first,div#idk .sisense-pivot .table-grid__cell--corner.table-grid__cell--level-first,div#idk .sisense-pivot .table-grid__cell--columns.table-grid__cell--level-first,div#idk .sisense-pivot .table-grid__cell--rows.table-grid__cell--level-first{font-weight:600}body .sisense-pivot .scroll-elem__horizontal-track,div#idk .sisense-pivot .scroll-elem__horizontal-track{margin-top:2px}body .sisense-pivot .scroll-elem__vertical-track,div#idk .sisense-pivot .scroll-elem__vertical-track{margin-left:2px;z-index:10000}body .sisense-pivot__multi-grid .table-grid,div#idk .sisense-pivot__multi-grid .table-grid{z-index:1}body .sisense-pivot__multi-grid .table-grid__cell,div#idk .sisense-pivot__multi-grid .table-grid__cell{text-align:left;transition:background-color ease .3s;font-weight:400}body .sisense-pivot__multi-grid .table-grid__cell.table-grid__cell--data,div#idk .sisense-pivot__multi-grid .table-grid__cell.table-grid__cell--data{text-align:right}body .sisense-pivot__multi-grid .table-grid__content,div#idk .sisense-pivot__multi-grid .table-grid__content{font-size:13px;line-height:normal;padding:3px 8px 4px}body .sisense-pivot__multi-grid .table-grid__cell--sorted .table-grid__content,div#idk .sisense-pivot__multi-grid .table-grid__cell--sorted .table-grid__content{padding-right:25px}body .sisense-pivot__multi-grid .table-grid__cell--sorted .table-grid__icon--sorted,body .sisense-pivot__multi-grid .table-grid__cell--sorted .table-grid__sorting-settings-icon,div#idk .sisense-pivot__multi-grid .table-grid__cell--sorted .table-grid__icon--sorted,div#idk .sisense-pivot__multi-grid .table-grid__cell--sorted .table-grid__sorting-settings-icon{display:block}body .sisense-pivot__multi-grid .table-grid__cell--sorted .table-grid__icon--sorted:after,body .sisense-pivot__multi-grid .table-grid__cell--sorted .table-grid__sorting-settings-icon:after,div#idk .sisense-pivot__multi-grid .table-grid__cell--sorted .table-grid__icon--sorted:after,div#idk .sisense-pivot__multi-grid .table-grid__cell--sorted .table-grid__sorting-settings-icon:after{display:block;top:0;left:0;background-repeat:no-repeat;background-position:center}body .sisense-pivot__multi-grid .table-grid__cell--sorted .table-grid__icon--sorted,div#idk .sisense-pivot__multi-grid .table-grid__cell--sorted .table-grid__icon--sorted{top:4px;right:7px;width:16px;height:16px}body .sisense-pivot__multi-grid .table-grid__cell--sorted .table-grid__icon--sorted:after,div#idk .sisense-pivot__multi-grid .table-grid__cell--sorted .table-grid__icon--sorted:after{width:16px;height:16px}body .sisense-pivot__multi-grid .table-grid__cell--sorted .table-grid__sorting-settings-icon,div#idk .sisense-pivot__multi-grid .table-grid__cell--sorted .table-grid__sorting-settings-icon{top:1px;right:1px;width:22px;height:22px}body .sisense-pivot__multi-grid .table-grid__cell--sorted .table-grid__sorting-settings-icon:hover,div#idk .sisense-pivot__multi-grid .table-grid__cell--sorted .table-grid__sorting-settings-icon:hover{background-color:#f2f2f2;border-radius:50%}body .sisense-pivot__multi-grid .table-grid__cell--sorted .table-grid__sorting-settings-icon:after,div#idk .sisense-pivot__multi-grid .table-grid__cell--sorted .table-grid__sorting-settings-icon:after{width:20px;height:20px;top:1px;left:1px}body .sisense-pivot__multi-grid .table-grid__cell--sorted.table-grid__cell--sort-icon-persistent .table-grid__sorting-settings-icon,div#idk .sisense-pivot__multi-grid .table-grid__cell--sorted.table-grid__cell--sort-icon-persistent .table-grid__sorting-settings-icon{background-color:#f2f2f2;border-radius:50%}body .sisense-pivot__multi-grid .table-grid__cell--sorted.table-grid__cell--sort-icon-persistent.table-grid__cell--default-sorted--asc .table-grid__sorting-settings-icon:after,body .sisense-pivot__multi-grid .table-grid__cell--sorted.table-grid__cell--sort-icon-persistent.table-grid__cell--default-sorted--desc .table-grid__sorting-settings-icon:after,div#idk .sisense-pivot__multi-grid .table-grid__cell--sorted.table-grid__cell--sort-icon-persistent.table-grid__cell--default-sorted--asc .table-grid__sorting-settings-icon:after,div#idk .sisense-pivot__multi-grid .table-grid__cell--sorted.table-grid__cell--sort-icon-persistent.table-grid__cell--default-sorted--desc .table-grid__sorting-settings-icon:after{content:"";background-image:url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE5IDdINVY4SDE5VjdaIiBmaWxsPSIjNUI2MzcyIi8+CjxwYXRoIGQ9Ik0xNyAxMEg3VjExSDE3VjEwWiIgZmlsbD0iIzVCNjM3MiIvPgo8cGF0aCBkPSJNOSAxM0gxNVYxNEg5VjEzWiIgZmlsbD0iIzVCNjM3MiIvPgo8cGF0aCBkPSJNMTMgMTZIMTFWMTdIMTNWMTZaIiBmaWxsPSIjNUI2MzcyIi8+Cjwvc3ZnPgo=)}body .sisense-pivot__multi-grid .table-grid__cell--sorted.table-grid__cell--sort-icon-persistent.table-grid__cell--sorted--asc .table-grid__sorting-settings-icon:after,div#idk .sisense-pivot__multi-grid .table-grid__cell--sorted.table-grid__cell--sort-icon-persistent.table-grid__cell--sorted--asc .table-grid__sorting-settings-icon:after{content:"";background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYBAMAAAASWSDLAAAAIVBMVEUAAABVVVVgYHVaY3NYYHBbYnFbZHJcZHJbY3JbY3L///8+n+SvAAAACXRSTlMAAxgfIEZrwN7K99ocAAAAAWJLR0QKaND0VgAAADFJREFUGNNjYKApmAkBhJSZO3DCVTF3tiAkNDIzFOAcUU5WAYRZnMgGoHNmYpehHgAAbUUKxkfTjB4AAAAASUVORK5CYII=)}body .sisense-pivot__multi-grid .table-grid__cell--sorted.table-grid__cell--sort-icon-persistent.table-grid__cell--sorted--desc .table-grid__sorting-settings-icon:after,div#idk .sisense-pivot__multi-grid .table-grid__cell--sorted.table-grid__cell--sort-icon-persistent.table-grid__cell--sorted--desc .table-grid__sorting-settings-icon:after{content:"";background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYBAMAAAASWSDLAAAAJFBMVEUAAABVVVVgYHVYYHBbYnFbY3FbZHJcZHJbY3JbY3JbY3L///8jVOI/AAAACnRSTlMAAxggRmprwN7fVBJwpAAAAAFiS0dECx/XxMAAAAAySURBVBjTY2CgKVgFAYSUcTEgqeJClUHlwFWJcLEIwCU0siIV4BzmrskMCBvNDWjiMQDhxAw5ye8LaQAAAABJRU5ErkJggg==)}body .sisense-pivot__multi-grid .table-grid__cell--sorted.table-grid__cell--default-sorted--asc:hover .table-grid__sorting-settings-icon:after,body .sisense-pivot__multi-grid .table-grid__cell--sorted.table-grid__cell--default-sorted--desc:hover .table-grid__sorting-settings-icon:after,div#idk .sisense-pivot__multi-grid .table-grid__cell--sorted.table-grid__cell--default-sorted--asc:hover .table-grid__sorting-settings-icon:after,div#idk .sisense-pivot__multi-grid .table-grid__cell--sorted.table-grid__cell--default-sorted--desc:hover .table-grid__sorting-settings-icon:after{content:"";background-image:url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE5IDdINVY4SDE5VjdaIiBmaWxsPSIjNUI2MzcyIi8+CjxwYXRoIGQ9Ik0xNyAxMEg3VjExSDE3VjEwWiIgZmlsbD0iIzVCNjM3MiIvPgo8cGF0aCBkPSJNOSAxM0gxNVYxNEg5VjEzWiIgZmlsbD0iIzVCNjM3MiIvPgo8cGF0aCBkPSJNMTMgMTZIMTFWMTdIMTNWMTZaIiBmaWxsPSIjNUI2MzcyIi8+Cjwvc3ZnPgo=)}body .sisense-pivot__multi-grid .table-grid__cell--sorted.table-grid__cell--sorted--asc .table-grid__sorting-settings-icon:after,div#idk .sisense-pivot__multi-grid .table-grid__cell--sorted.table-grid__cell--sorted--asc .table-grid__sorting-settings-icon:after{content:"";background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYBAMAAAASWSDLAAAAIVBMVEUAAABVVVVgYHVaY3NYYHBbYnFbZHJcZHJbY3JbY3L///8+n+SvAAAACXRSTlMAAxgfIEZrwN7K99ocAAAAAWJLR0QKaND0VgAAADFJREFUGNNjYKApmAkBhJSZO3DCVTF3tiAkNDIzFOAcUU5WAYRZnMgGoHNmYpehHgAAbUUKxkfTjB4AAAAASUVORK5CYII=)}body .sisense-pivot__multi-grid .table-grid__cell--sorted.table-grid__cell--sorted--desc .table-grid__sorting-settings-icon:after,div#idk .sisense-pivot__multi-grid .table-grid__cell--sorted.table-grid__cell--sorted--desc .table-grid__sorting-settings-icon:after{content:"";background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYBAMAAAASWSDLAAAAJFBMVEUAAABVVVVgYHVYYHBbYnFbY3FbZHJcZHJbY3JbY3JbY3L///8jVOI/AAAACnRSTlMAAxggRmprwN7fVBJwpAAAAAFiS0dECx/XxMAAAAAySURBVBjTY2CgKVgFAYSUcTEgqeJClUHlwFWJcLEIwCU0siIV4BzmrskMCBvNDWjiMQDhxAw5ye8LaQAAAABJRU5ErkJggg==)}body .sisense-pivot__multi-grid .table-grid__cell--sorted.table-grid__cell--default-sorted--asc.table-grid__cell--sorted-inactive .table-grid__icon--sorted,body .sisense-pivot__multi-grid .table-grid__cell--sorted.table-grid__cell--default-sorted--asc.table-grid__cell--sorted-inactive .table-grid__sorting-settings-icon,body .sisense-pivot__multi-grid .table-grid__cell--sorted.table-grid__cell--default-sorted--desc.table-grid__cell--sorted-inactive .table-grid__icon--sorted,body .sisense-pivot__multi-grid .table-grid__cell--sorted.table-grid__cell--default-sorted--desc.table-grid__cell--sorted-inactive .table-grid__sorting-settings-icon,div#idk .sisense-pivot__multi-grid .table-grid__cell--sorted.table-grid__cell--default-sorted--asc.table-grid__cell--sorted-inactive .table-grid__icon--sorted,div#idk .sisense-pivot__multi-grid .table-grid__cell--sorted.table-grid__cell--default-sorted--asc.table-grid__cell--sorted-inactive .table-grid__sorting-settings-icon,div#idk .sisense-pivot__multi-grid .table-grid__cell--sorted.table-grid__cell--default-sorted--desc.table-grid__cell--sorted-inactive .table-grid__icon--sorted,div#idk .sisense-pivot__multi-grid .table-grid__cell--sorted.table-grid__cell--default-sorted--desc.table-grid__cell--sorted-inactive .table-grid__sorting-settings-icon{display:none}body .sisense-pivot__multi-grid .table-grid__cell--sorted.table-grid__cell--sorted--asc.table-grid__cell--sorted-inactive .table-grid__icon--sorted:hover,body .sisense-pivot__multi-grid .table-grid__cell--sorted.table-grid__cell--sorted--asc.table-grid__cell--sorted-inactive .table-grid__sorting-settings-icon:hover,body .sisense-pivot__multi-grid .table-grid__cell--sorted.table-grid__cell--sorted--desc.table-grid__cell--sorted-inactive .table-grid__icon--sorted:hover,body .sisense-pivot__multi-grid .table-grid__cell--sorted.table-grid__cell--sorted--desc.table-grid__cell--sorted-inactive .table-grid__sorting-settings-icon:hover,div#idk .sisense-pivot__multi-grid .table-grid__cell--sorted.table-grid__cell--sorted--asc.table-grid__cell--sorted-inactive .table-grid__icon--sorted:hover,div#idk .sisense-pivot__multi-grid .table-grid__cell--sorted.table-grid__cell--sorted--asc.table-grid__cell--sorted-inactive .table-grid__sorting-settings-icon:hover,div#idk .sisense-pivot__multi-grid .table-grid__cell--sorted.table-grid__cell--sorted--desc.table-grid__cell--sorted-inactive .table-grid__icon--sorted:hover,div#idk .sisense-pivot__multi-grid .table-grid__cell--sorted.table-grid__cell--sorted--desc.table-grid__cell--sorted-inactive .table-grid__sorting-settings-icon:hover{background-color:inherit;border-radius:inherit;pointer-events:none}body .sisense-pivot__multi-grid .table-grid__cell--user-type-measureTop,div#idk .sisense-pivot__multi-grid .table-grid__cell--user-type-measureTop{text-align:center}@supports (-ms-ime-align: auto){body .sisense-pivot__multi-grid .scroll-elem>div:first-child,div#idk .sisense-pivot__multi-grid .scroll-elem>div:first-child{overflow:auto!important}}body .sisense-pivot__multi-grid .sisense-pivot__data-bar,div#idk .sisense-pivot__multi-grid .sisense-pivot__data-bar{padding:0 8px}body .sisense-pivot__multi-grid .sisense-pivot__data-bar-bar,div#idk .sisense-pivot__multi-grid .sisense-pivot__data-bar-bar{background:#34cee6}body .sisense-css-module .pivot-container,div#idk .sisense-css-module .pivot-container{overflow:hidden}body .sisense-css-module .pivot-container ::-webkit-scrollbar,div#idk .sisense-css-module .pivot-container ::-webkit-scrollbar{width:initial;height:initial}body .print-layout .table-grid__cell--sorted .table-grid__cell-corner,div#idk .print-layout .table-grid__cell--sorted .table-grid__cell-corner{display:none}body .print-layout .sisense-pivot--sorting-by-subtotals .table-grid__cell--sorted .table-grid__cell-corner,div#idk .print-layout .sisense-pivot--sorting-by-subtotals .table-grid__cell--sorted .table-grid__cell-corner{display:block}body .print-layout .table-grid__cell--sorted .table-grid__content,div#idk .print-layout .table-grid__cell--sorted .table-grid__content{padding:2px 8px 3px}body .print-layout .table-grid__content__wrapper,div#idk .print-layout .table-grid__content__wrapper{overflow:hidden;width:100%;text-overflow:ellipsis;position:relative;display:block;min-width:8px}body .widget-to-image .scroll-elem__horizontal-track,body .widget-to-image .scroll-elem__vertical-track,div#idk .widget-to-image .scroll-elem__horizontal-track,div#idk .widget-to-image .scroll-elem__vertical-track{display:none}body .widget-to-image .table-grid__content__wrapper,div#idk .widget-to-image .table-grid__content__wrapper{text-overflow:ellipsis;display:-webkit-box;-webkit-box-orient:vertical}.subtotals-menu__host{width:254px;height:346px;background-color:#fff;border-radius:4px;box-shadow:0 0 5px #3a435633}.subtotals-menu__host .menu-item-host .menu-content{width:100%;max-width:100%;min-width:100%;border:none;box-shadow:none}.subtotals-menu__host .menu-item-host .menu-content .menu-item{width:100%;max-width:100%;min-width:100%;margin:1px 0;height:auto;min-height:29px}.subtotals-menu__host .menu-item-host .menu-content .menu-item .mi-icon{margin-left:12px}.subtotals-menu__host .menu-item-host .menu-content .menu-item .mi-caption__auto{margin-left:16px}.subtotals-menu__host .menu-item-host .menu-content .menu-item .menu-item-container{flex-flow:row wrap}.subtotals-menu__host .menu-item-host .menu-content .menu-item .break{flex-basis:100%;width:0px;height:0px;overflow:hidden}.subtotals-menu__host .menu-item-host .menu-content .menu-item.mi-separator{min-height:1px;margin:6px 0}.subtotals-menu__host .menu-item-host .menu-content .menu-item .mi-checker{margin:0 15px 0 0}.subtotals-menu__host .subtotals-menu__item-distinct{display:flex;justify-content:space-between;margin:7px 15px 7px 21px}.subtotals-menu__header{display:flex;flex-direction:row;justify-content:space-between;align-items:center;height:42px;background-color:#f4f4f8;border-radius:4px 4px 0 0;font-size:13px;font-weight:600;padding:12px 13px 12px 16px;line-height:18px;margin-bottom:7px}.subtotals-menu__header-tooltip .info{margin-left:0}.subtotals-menu__header-tooltip .info:hover{background-color:#dee1e7;border-radius:50%}.subtotals-menu__actions{margin-top:6px;padding:16px;display:flex;justify-content:flex-end;border-top:1px solid #edeef1}.subtotals-menu__actions button.btn{margin-left:8px}.totals-tooltip-host{width:433px;height:200px}.totals-tooltip__container{font-size:13px;margin:4px 8px;line-height:19px}:export{loginDarkColor:#2c3342;darkBtnHoverColor:#f4f4f8;greyHoverColor:#dee1e7;defaultBackgroundColor:#fff}:where(.sis-scope) html,:where(.sis-scope) body,:where(.sis-scope) applet,:where(.sis-scope) object,:where(.sis-scope) iframe,:where(.sis-scope) h1,:where(.sis-scope) h2,:where(.sis-scope) h3,:where(.sis-scope) h4,:where(.sis-scope) h5,:where(.sis-scope) h6,:where(.sis-scope) p,:where(.sis-scope) blockquote,:where(.sis-scope) pre,:where(.sis-scope) a,:where(.sis-scope) abbr,:where(.sis-scope) acronym,:where(.sis-scope) address,:where(.sis-scope) big,:where(.sis-scope) cite,:where(.sis-scope) code,:where(.sis-scope) del,:where(.sis-scope) dfn,:where(.sis-scope) em,:where(.sis-scope) img,:where(.sis-scope) ins,:where(.sis-scope) kbd,:where(.sis-scope) q,:where(.sis-scope) s,:where(.sis-scope) samp,:where(.sis-scope) small,:where(.sis-scope) strike,:where(.sis-scope) strong,:where(.sis-scope) sub,:where(.sis-scope) sup,:where(.sis-scope) tt,:where(.sis-scope) var,:where(.sis-scope) b,:where(.sis-scope) u,:where(.sis-scope) i,:where(.sis-scope) center,:where(.sis-scope) dl,:where(.sis-scope) dt,:where(.sis-scope) dd,:where(.sis-scope) ol,:where(.sis-scope) ul,:where(.sis-scope) li,:where(.sis-scope) fieldset,:where(.sis-scope) form,:where(.sis-scope) label,:where(.sis-scope) legend,:where(.sis-scope) table,:where(.sis-scope) caption,:where(.sis-scope) article,:where(.sis-scope) aside,:where(.sis-scope) canvas,:where(.sis-scope) details,:where(.sis-scope) embed,:where(.sis-scope) figure,:where(.sis-scope) figcaption,:where(.sis-scope) footer,:where(.sis-scope) header,:where(.sis-scope) hgroup,:where(.sis-scope) menu,:where(.sis-scope) nav,:where(.sis-scope) output,:where(.sis-scope) ruby,:where(.sis-scope) section,:where(.sis-scope) summary,:where(.sis-scope) time,:where(.sis-scope) mark,:where(.sis-scope) audio,:where(.sis-scope) video{margin:0;padding:0;vertical-align:baseline;border:0;outline:none}:where(.sis-scope) article,:where(.sis-scope) aside,:where(.sis-scope) details,:where(.sis-scope) figcaption,:where(.sis-scope) figure,:where(.sis-scope) footer,:where(.sis-scope) header,:where(.sis-scope) hgroup,:where(.sis-scope) menu,:where(.sis-scope) nav,:where(.sis-scope) section{display:block}:where(.sis-scope) body{margin:0}:where(.sis-scope) ol,:where(.sis-scope) ul{list-style:none}:where(.sis-scope) blockquote,:where(.sis-scope) q{quotes:none}:where(.sis-scope) blockquote:before,:where(.sis-scope) blockquote:after{content:none}:where(.sis-scope) q:before,:where(.sis-scope) q:after{content:none}:where(.sis-scope) table{border-spacing:0;border-collapse:collapse}:where(.sis-scope) textarea,:where(.sis-scope) select{outline:none}.sis-scope{font-size:13px;line-height:normal;cursor:default;padding:0;margin:0;background:inherit;font-family:Open Sans;color:#5b6372}.sis-scope .btn{background-color:#ffcb05;color:#3a4356}.sis-scope *,.sis-scope *:before,.sis-scope *:after{box-sizing:border-box}.sis-scope ::-webkit-input-placeholder{opacity:1}.sis-scope ::-moz-placeholder{opacity:1}.sis-scope ::-ms-placeholder{opacity:1}.sis-scope ::placeholder{opacity:1}.sis-scope .app-icon{position:relative;display:inline-block;vertical-align:middle;width:24px;height:24px;box-sizing:content-box;text-align:left}.sis-scope .app-icon:after{content:"";position:absolute;top:0;left:0;display:block;width:100%;height:100%}.sis-scope .app-icon__svg{position:relative;display:block;width:100%;height:100%}.sis-scope .app-icon--build-failed .app-icon__svg,.sis-scope .app-icon--build-stopped .app-icon__svg,.sis-scope .app-icon--build-exlamation-mark-error-cancel .app-icon__svg,.sis-scope .app-icon--general-relationship-error .app-icon__svg,.sis-scope .app-icon--placeholder-mark-x .app-icon__svg{fill:#fa5656}.sis-scope .app-icon--placeholder-mark-info .app-icon__svg,.sis-scope .app-icon--build-vi-apply-aprrove .app-icon__svg,.sis-scope .app-icon--general-status-running .app-icon__svg{fill:#35d7be}.sis-scope .app-icon--general-x-sign .app-icon__svg,.sis-scope .app-icon--general-vi-sign .app-icon__svg{fill:transparent}.sis-scope .app-icon--general-status-pending,.sis-scope .app-icon--general-status-running{color:#d1d1d7}.sis-scope .app-icon--general-relationship-tool-tip{width:36px}.sis-scope .app-icon--header-pulse{width:28px}.sis-scope .app-icon--general-update,.sis-scope .app-icon--popup-interval-selected,.sis-scope .app-icon--popup-week-selected,.sis-scope .app-icon--popup-disable-selected{width:50px;height:50px}.sis-scope .app-icon--general-yellow-round-add{width:27px;height:27px}.sis-scope .app-icon--general-sampling-sample-big,.sis-scope .app-icon--general-sampling-top-big,.sis-scope .app-icon--general-sampling-bottom-big{width:35px;height:35px}.sis-scope .app-icon--general-drag-edit-relation,.sis-scope .app-icon--general-drag-new-relation,.sis-scope .app-icon--general-drag{width:36px;height:36px}.sis-scope .app-icon--popup-public-selected{width:49px;height:42px}.sis-scope .app-icon--header-git,.sis-scope .app-icon--general-git-add-branch,.sis-scope .app-icon--header-git .app-icon__svg,.sis-scope .app-icon--general-git-add-branch .app-icon__svg{fill:none}.sis-scope .app-icon--header-git,.sis-scope .app-icon--header-alarm,.sis-scope .app-icon--header-user,.sis-scope .app-icon--header-user-filled{width:30px;height:30px}.sis-scope .app-icon--general-git-add-branch{width:18px;height:18px}.sis-scope .app-icon--popup-lshare-selected,.sis-scope .app-icon--popup-lock-selected,.sis-scope .app-icon--hint-question-mark,.sis-scope .app-icon--hint-x{width:42px;height:42px}.sis-scope .app-icon--resource-guide,.sis-scope .app-icon--resource-help,.sis-scope .app-icon--resource-learn{width:26px;height:37px}.sis-scope .app-icon--schema-arrow-close-left,.sis-scope .app-icon--schema-arrow-close-right,.sis-scope .app-icon--schema-version-history,.sis-scope .app-icon--schema-compass{width:26px;height:26px}.sis-scope .app-icon--wizard-add-folder,.sis-scope .app-icon--wizard-connect,.sis-scope .app-icon--wizard-database,.sis-scope .app-icon--wizard-files,.sis-scope .app-icon--wizard-new-page,.sis-scope .app-icon--wizard-recent,.sis-scope .app-icon--wizard-recent-circle,.sis-scope .app-icon--wizard-rest,.sis-scope .app-icon--wizard-view,.sis-scope .app-icon--wizard-web,.sis-scope .app-icon--wizard-certified{width:35px;height:35px}.sis-scope .app-icon--nodes-delete,.sis-scope .app-icon--nodes-rename,.sis-scope .app-icon--nodes-edit,.sis-scope .app-icon--nodes-more,.sis-scope .app-icon--nodes-preview,.sis-scope .app-icon--nodes-ignored,.sis-scope .app-icon--nodes-accumulated,.sis-scope .app-icon--nodes-accumulated-2{width:37px;height:37px}.sis-scope .app-icon--placeholder-database,.sis-scope .app-icon--placeholder-database-x,.sis-scope .app-icon--placeholder-connection,.sis-scope .app-icon--placeholder-git-graph,.sis-scope .app-icon--placeholder-parameters,.sis-scope .app-icon--placeholder-search-x,.sis-scope .app-icon--placeholder-search,.sis-scope .app-icon--placeholder-table,.sis-scope .app-icon--placeholder-table-x,.sis-scope .app-icon--placeholder-table-init,.sis-scope .app-icon--placeholder-tools,.sis-scope .app-icon--placeholder-preview,.sis-scope .app-icon--placeholder-database-plus-black-white,.sis-scope .app-icon--placeholder-preview-inspect-black-white,.sis-scope .app-icon--placeholder-preview-plus-black-white,.sis-scope .app-icon--placeholder-generate-token,.sis-scope .app-icon--placeholder-key,.sis-scope .app-icon--placeholder-presentation{width:110px;height:110px}.sis-scope .app-icon--placeholder-filter{width:110px;height:130px}.sis-scope .app-icon--placeholder-sheet{width:89px;height:93px}.sis-scope .app-icon--placeholder-mark-info,.sis-scope .app-icon--placeholder-mark-exclamation,.sis-scope .app-icon--placeholder-mark-vi,.sis-scope .app-icon--placeholder-mark-x{width:66px;height:66px}.sis-scope .app-icon--placeholder-place-file,.sis-scope .app-icon--placeholder-place-text-add{width:120px;height:70px}.sis-scope .app-icon--illustration-build-succeeded,.sis-scope .app-icon--illustration-build-failed{width:225px;height:210px}.sis-scope .app-icon--homepages-video,.sis-scope .app-icon--homepages-tutorials,.sis-scope .app-icon--homepages-documentation,.sis-scope .app-icon--homepages-sample{width:65px;height:56px}.sis-scope .app-icon--homepages-play{width:61px;height:61px}.sis-scope .app-icon--widget-area-chart,.sis-scope .app-icon--widget-area-map,.sis-scope .app-icon--widget-bar-chart,.sis-scope .app-icon--widget-box-whisker-plot,.sis-scope .app-icon--widget-calendar-heatmap,.sis-scope .app-icon--widget-column-char,.sis-scope .app-icon--widget-indicator,.sis-scope .app-icon--widget-line-chart,.sis-scope .app-icon--widget-pie-chart,.sis-scope .app-icon--widget-pivot,.sis-scope .app-icon--widget-polar-chart,.sis-scope .app-icon--widget-scatter-chart,.sis-scope .app-icon--widget-scatter-map,.sis-scope .app-icon--widget-sunburst,.sis-scope .app-icon--widget-table,.sis-scope .app-icon--widget-treemap,.sis-scope .app-icon--widget-no-sort{width:26px;height:26px}.sis-scope .app-icon--buildpanel-replace-all,.sis-scope .app-icon--buildpanel-by-table,.sis-scope .app-icon--buildpanel-changes-only{width:64px;height:64px}.sis-scope .app-icon--ai-group-similar-big{width:88px;height:83px}.sis-scope :export{loginDarkColor:#2c3342;darkBtnHoverColor:#f4f4f8;greyHoverColor:#dee1e7;defaultBackgroundColor:#fff}.sis-scope .btn{opacity:1;font-family:inherit;font-style:normal;font-size:13px;line-height:24px;display:inline-block;box-sizing:border-box;margin:0;padding:0;cursor:pointer;transition:all .3s ease;vertical-align:middle;text-decoration:none;border:0;border-radius:4px;outline:none;white-space:nowrap;appearance:none}.sis-scope .btn .btn__icon{display:inline-block;padding-left:9px}.sis-scope .btn .btn__icon+.btn__text{vertical-align:middle;margin-left:-3px;padding-left:0;padding-right:13px;max-width:calc(100% - 24px)}.sis-scope .btn:hover{text-decoration:none;opacity:1}.sis-scope .btn:focus{outline:none}.sis-scope .btn::-moz-focus-inner{border:0}.sis-scope .btn.btn--disabled,.sis-scope .btn[disabled=disabled]{cursor:default;opacity:.4}.sis-scope .btn__text{position:relative;display:inline-block;vertical-align:top;padding:2px 20px;max-width:100%}.sis-scope .btn__icon{display:inline-block;padding:0}.sis-scope .btn--warning,.sis-scope .btn--warning:hover{opacity:1}.sis-scope .btn--warning.btn--disabled,.sis-scope .btn--warning[disabled=disabled]{opacity:.4}.sis-scope .btn--danger{background:#edeef1;opacity:1}.sis-scope .btn--danger:hover{color:#fff;background:#fa5656;opacity:1}.sis-scope .btn--danger.btn--disabled,.sis-scope .btn--danger[disabled=disabled]{color:#5b6372;background:#edeef1;opacity:.6}.sis-scope .btn--transp{color:#9ea2ab;background:none;opacity:1;line-height:1}.sis-scope .btn--transp:hover{background:none;opacity:1}.sis-scope .btn--transp.btn--disabled,.sis-scope .btn--transp[disabled=disabled]{background:none;opacity:.4}.sis-scope .btn--transp .btn__icon{padding-left:0}.sis-scope .btn--transp .btn__text,.sis-scope .btn--transp .btn__icon+.btn__text{padding-left:0;padding-right:0}.sis-scope .btn--gray,.sis-scope .btn--smart,.sis-scope .btn--gray:hover,.sis-scope .btn--smart:hover{opacity:1}.sis-scope .btn--gray.btn--disabled,.sis-scope .btn--gray[disabled=disabled],.sis-scope .btn--smart.btn--disabled,.sis-scope .btn--smart[disabled=disabled]{opacity:.6}.sis-scope .btn--white{background:#fff;opacity:1}.sis-scope .btn--white:hover{background:#f2b900;opacity:1}.sis-scope .btn--white.btn--disabled,.sis-scope .btn--white[disabled=disabled]{background:#fff;opacity:.6}.sis-scope .btn--icon .btn__text{display:none}.sis-scope .btn--icon .btn__icon{padding-left:5px;padding-right:5px}.sis-scope .btn--icon.btn--transp .btn__icon,.sis-scope .btn--icon.btn--dark .btn__icon{padding-left:0;padding-right:0}.sis-scope .btn--limited .btn__text{white-space:normal}.sis-scope .btns-holder{display:flex;align-items:center}.sis-scope .btns-holder>*{margin:0 5px}.sis-scope .btns-holder>*:first-child{margin-left:0}.sis-scope .btns-holder>*:last-child{margin-right:0}.sis-scope .btns-holder .btn--offset-ml{margin-left:15px}.sis-scope .btns-holder .btn:not(.btn--transp)+.btn--transp{margin-left:15px}.sis-scope .btns-holder .btn--transp+.btn:not(.btn--transp){margin-left:15px}.sis-scope .btn-icon-link{display:inline-block;vertical-align:middle;margin:0;padding:0;background:none;border:none;outline:none;font-family:inherit;font-size:inherit;font-weight:inherit;font-style:inherit;color:inherit;cursor:pointer}.sis-scope .btn-icon-link:hover .btn-icon-link__icon.btn,.sis-scope .btn-icon-link:hover .btn-icon-link__icon.btn--warning{opacity:1}.sis-scope .btn-icon-link:hover .btn-icon-link__icon.btn--danger{color:#fff;background:#fa5656;opacity:1}.sis-scope .btn-icon-link:hover .btn-icon-link__icon.btn--transp{background:none;opacity:1}.sis-scope .btn-icon-link:hover .btn-icon-link__icon.btn--gray,.sis-scope .btn-icon-link:hover .btn-icon-link__icon.btn--smart{opacity:1}.sis-scope .btn-icon-link:hover .btn-icon-link__icon.btn--white{background:#f2b900;opacity:1}.sis-scope .btn-icon-link:hover .btn-icon-link__icon.confirm-btn{opacity:1}.sis-scope .btn-icon-link:hover .btn-icon-link__icon.confirm-btn.confirm-btn--apply{color:#fff;background:#35d7be;border-color:#35d7be}.sis-scope .btn-icon-link:hover .btn-icon-link__icon.confirm-btn.confirm-btn--cancel{color:#fff;background:#fa5656;border-color:#fa5656}.sis-scope .btn-icon-link.btn-icon-link--disabled,.sis-scope .btn-icon-link[disabled=disabled],.sis-scope .btn-icon-link.btn-icon-link--disabled .btn-icon-link__icon,.sis-scope .btn-icon-link[disabled=disabled] .btn-icon-link__icon{cursor:default}.sis-scope .btn-icon-link.btn-icon-link--disabled .btn-icon-link__icon.btn,.sis-scope .btn-icon-link[disabled=disabled] .btn-icon-link__icon.btn,.sis-scope .btn-icon-link.btn-icon-link--disabled .btn-icon-link__icon.btn--warning,.sis-scope .btn-icon-link[disabled=disabled] .btn-icon-link__icon.btn--warning{opacity:.4}.sis-scope .btn-icon-link.btn-icon-link--disabled .btn-icon-link__icon.btn--danger,.sis-scope .btn-icon-link[disabled=disabled] .btn-icon-link__icon.btn--danger{color:#5b6372;background:#edeef1;opacity:.6}.sis-scope .btn-icon-link.btn-icon-link--disabled .btn-icon-link__icon.btn--transp,.sis-scope .btn-icon-link[disabled=disabled] .btn-icon-link__icon.btn--transp{background:none;opacity:.4}.sis-scope .btn-icon-link.btn-icon-link--disabled .btn-icon-link__icon.btn--gray,.sis-scope .btn-icon-link.btn-icon-link--disabled .btn-icon-link__icon.btn--smart,.sis-scope .btn-icon-link[disabled=disabled] .btn-icon-link__icon.btn--gray,.sis-scope .btn-icon-link[disabled=disabled] .btn-icon-link__icon.btn--smart{opacity:.6}.sis-scope .btn-icon-link.btn-icon-link--disabled .btn-icon-link__icon.btn--white,.sis-scope .btn-icon-link[disabled=disabled] .btn-icon-link__icon.btn--white{background:#fff;opacity:.6}.sis-scope .btn-icon-link.btn-icon-link--disabled .btn-icon-link__icon.confirm-btn,.sis-scope .btn-icon-link[disabled=disabled] .btn-icon-link__icon.confirm-btn{opacity:.4}.sis-scope .btn-icon-link.btn-icon-link--disabled .btn-icon-link__icon.confirm-btn.confirm-btn--apply,.sis-scope .btn-icon-link[disabled=disabled] .btn-icon-link__icon.confirm-btn.confirm-btn--apply{color:#35d7be;background:rgba(53,215,190,0);border-color:#35d7be}.sis-scope .btn-icon-link.btn-icon-link--disabled .btn-icon-link__icon.confirm-btn.confirm-btn--cancel,.sis-scope .btn-icon-link[disabled=disabled] .btn-icon-link__icon.confirm-btn.confirm-btn--cancel{color:#fa5656;background:rgba(250,86,86,0);border-color:#fa5656}.sis-scope .btn-icon-link__icon{width:28px;margin-right:5px;border-radius:50%}.sis-scope .btn-icon-link__icon .btn__icon{vertical-align:top;padding:1px 0}.sis-scope .btn-icon-link__icon .btn__icon.app-icon--general-plus{padding-left:2px}.sis-scope .btn-icon-link__text{display:inline-block;vertical-align:middle}.sis-scope .btn--more:hover .btn__text{margin-left:-9px}.sis-scope .btn--more:hover .btn__icon{width:10px}.sis-scope .btn--more.btn--danger:hover .btn__icon,.sis-scope .btn--more.btn--danger:hover .btn__icon:before{border-color:#fff}.sis-scope .btn--more.btn--more-open .btn__text{margin-left:-9px}.sis-scope .btn--more.btn--more-open .btn__icon{width:10px}.sis-scope .btn--more .btn__text{position:relative;margin-left:0;padding-right:5px;transition:margin-left .3s linear}.sis-scope .btn--more .btn__icon{position:relative;top:2px;width:1px;height:9px;margin:0 10px 0 0;padding:0;border:solid 1px #3a4356;border-width:1px 0 1px 0;transition:width .3s linear,border-color .3s}.sis-scope .btn--more .btn__icon:before{content:"";position:absolute;left:0;top:3px;width:100%;height:1px;border-bottom:solid 1px #3a4356;transition:border-color .3s}.sis-scope .confirm-btns{display:flex;font-size:0}.sis-scope .confirm-btns .confirm-btn{opacity:1;padding:0;width:17px;height:17px;margin:0 4px;font-size:0;line-height:15px;text-align:center;border:solid 1px transparent;border-radius:50%}.sis-scope .confirm-btns .confirm-btn.confirm-btn--apply{color:#35d7be;background:rgba(53,215,190,0);border-color:#35d7be}.sis-scope .confirm-btns .confirm-btn.confirm-btn--cancel{color:#fa5656;background:rgba(250,86,86,0);border-color:#fa5656}.sis-scope .confirm-btns .confirm-btn:hover{opacity:1}.sis-scope .confirm-btns .confirm-btn:hover.confirm-btn--apply{color:#fff;background:#35d7be;border-color:#35d7be}.sis-scope .confirm-btns .confirm-btn:hover.confirm-btn--cancel{color:#fff;background:#fa5656;border-color:#fa5656}.sis-scope .confirm-btns .confirm-btn.btn--disabled,.sis-scope .confirm-btns .confirm-btn[disabled=disabled]{cursor:default;opacity:.4}.sis-scope .confirm-btns .confirm-btn.btn--disabled.confirm-btn--apply,.sis-scope .confirm-btns .confirm-btn[disabled=disabled].confirm-btn--apply{color:#35d7be;background:rgba(53,215,190,0);border-color:#35d7be}.sis-scope .confirm-btns .confirm-btn.btn--disabled.confirm-btn--cancel,.sis-scope .confirm-btns .confirm-btn[disabled=disabled].confirm-btn--cancel{color:#fa5656;background:rgba(250,86,86,0);border-color:#fa5656}.sis-scope .confirm-btns .confirm-btn .btn__icon{width:9px;height:9px;margin:3px;padding:0}.sis-scope .btn--dark{background:none;color:#5b6372;border-radius:4px;padding:0;transition:unset;line-height:1}.sis-scope .btn--dark .btn__text{padding:0}.sis-scope .btn--dark.btn--icon{display:flex;align-items:center;justify-content:center;height:28px;width:28px;padding:0;border-radius:50%}.sis-scope .btn--dark.btn--icon.btn--small{height:24px;width:24px}.sis-scope .btn--dark:hover{background-color:#f4f4f8;color:inherit}.sis-scope .btn--dark:hover.btn--on-grey{background-color:#dee1e7}.sis-scope .btn--dark:hover.btn--no-hover{background:none}.sis-scope .btn--dark.btn--disabled,.sis-scope .btn--dark[disabled=disabled]{cursor:default;background:none;opacity:.4}@keyframes _rcToolTipZoomIn_1947o_1{0%{opacity:0;transform-origin:50% 50%;transform:scale(0)}to{opacity:1;transform-origin:50% 50%;transform:scale(1)}}@keyframes _rcToolTipZoomOut_1947o_1{0%{opacity:1;transform-origin:50% 50%;transform:scale(1)}to{opacity:0;transform-origin:50% 50%;transform:scale(0)}}.rc-tooltip-inner{padding:6px 12px;min-height:0;border:0;border-radius:4px;pointer-events:none;color:red;font-size:14px}.rc-tooltip-arrow{border-width:0!important;width:8px;height:8px;background-color:#000;z-index:-1;transform:rotate(45deg)}.rc-tooltip-content:before{content:"";position:absolute;width:8px;height:8px;background-color:#000;transform:rotate(45deg)}._breakLongWord_1947o_272{word-break:break-all}._popover_wakdx_1 .rc-tooltip-inner{pointer-events:auto;overflow:hidden}._popoverMask_wakdx_6{position:absolute;width:100%;top:0;bottom:0}.rc-tooltip.rc-tooltip-zoom-appear,.rc-tooltip.rc-tooltip-zoom-enter{opacity:0}.rc-tooltip.rc-tooltip-zoom-enter,.rc-tooltip.rc-tooltip-zoom-leave{display:block}.rc-tooltip-zoom-enter,.rc-tooltip-zoom-appear{opacity:0;animation-duration:.3s;animation-fill-mode:both;animation-timing-function:cubic-bezier(.18,.89,.32,1.28);animation-play-state:paused}.rc-tooltip-zoom-leave{animation-duration:.3s;animation-fill-mode:both;animation-timing-function:cubic-bezier(.6,-.3,.74,.05);animation-play-state:paused}.rc-tooltip-zoom-enter.rc-tooltip-zoom-enter-active,.rc-tooltip-zoom-appear.rc-tooltip-zoom-appear-active{animation-name:rcToolTipZoomIn;animation-play-state:running}.rc-tooltip-zoom-leave.rc-tooltip-zoom-leave-active{animation-name:rcToolTipZoomOut;animation-play-state:running}@keyframes _rcToolTipZoomIn_1dxah_1{0%{opacity:0;transform-origin:50% 50%;transform:scale(0)}to{opacity:1;transform-origin:50% 50%;transform:scale(1)}}@keyframes _rcToolTipZoomOut_1dxah_1{0%{opacity:1;transform-origin:50% 50%;transform:scale(1)}to{opacity:0;transform-origin:50% 50%;transform:scale(0)}}.rc-tooltip{position:absolute;z-index:1070;display:block;visibility:visible;line-height:1.5;font-size:12px;background-color:#0000000d;padding:1px;opacity:.9}.rc-tooltip-hidden{display:none}.rc-tooltip-inner{padding:8px 10px;color:#333;text-align:left;text-decoration:none;background-color:#fff;border-radius:3px;min-height:34px;border:1px solid #b1b1b1}.rc-tooltip-arrow,.rc-tooltip-arrow-inner{position:absolute;width:0;height:0;border-color:transparent;border-style:solid}.rc-tooltip-placement-top .rc-tooltip-arrow,.rc-tooltip-placement-topLeft .rc-tooltip-arrow,.rc-tooltip-placement-topRight .rc-tooltip-arrow{transform:translate(-50%,5px);margin-left:-6px;border-width:6px 6px 0;border-top-color:#b1b1b1}.rc-tooltip-placement-top .rc-tooltip-arrow-inner,.rc-tooltip-placement-topLeft .rc-tooltip-arrow-inner,.rc-tooltip-placement-topRight .rc-tooltip-arrow-inner{bottom:1px;margin-left:-6px;border-width:6px 6px 0;border-top-color:#fff}.rc-tooltip-placement-top .rc-tooltip-arrow{left:50%}.rc-tooltip-placement-topLeft .rc-tooltip-arrow{left:15%}.rc-tooltip-placement-topRight .rc-tooltip-arrow{right:15%}.rc-tooltip-placement-right .rc-tooltip-arrow,.rc-tooltip-placement-rightTop .rc-tooltip-arrow,.rc-tooltip-placement-rightBottom .rc-tooltip-arrow{left:-5px;margin-top:-6px;border-width:6px 6px 6px 0;border-right-color:#b1b1b1;transform:translate(calc(-100% + 1px))}.rc-tooltip-placement-right .rc-tooltip-arrow-inner,.rc-tooltip-placement-rightTop .rc-tooltip-arrow-inner,.rc-tooltip-placement-rightBottom .rc-tooltip-arrow-inner{left:1px;margin-top:-6px;border-width:6px 6px 6px 0;border-right-color:#fff}.rc-tooltip-placement-right .rc-tooltip-arrow{top:50%}.rc-tooltip-placement-rightTop .rc-tooltip-arrow{top:15%;margin-top:0}.rc-tooltip-placement-rightBottom .rc-tooltip-arrow{bottom:15%}.rc-tooltip-placement-left .rc-tooltip-arrow,.rc-tooltip-placement-leftTop .rc-tooltip-arrow,.rc-tooltip-placement-leftBottom .rc-tooltip-arrow{right:-5px;margin-top:-6px;border-width:6px 0 6px 6px;border-left-color:#b1b1b1;transform:translate(calc(100% - 1px))}.rc-tooltip-placement-left .rc-tooltip-arrow-inner,.rc-tooltip-placement-leftTop .rc-tooltip-arrow-inner,.rc-tooltip-placement-leftBottom .rc-tooltip-arrow-inner{right:1px;margin-top:-6px;border-width:6px 0 6px 6px;border-left-color:#fff}.rc-tooltip-placement-left .rc-tooltip-arrow{top:50%}.rc-tooltip-placement-leftTop .rc-tooltip-arrow{top:15%;margin-top:0}.rc-tooltip-placement-leftBottom .rc-tooltip-arrow{bottom:15%}.rc-tooltip-placement-bottom .rc-tooltip-arrow,.rc-tooltip-placement-bottomLeft .rc-tooltip-arrow,.rc-tooltip-placement-bottomRight .rc-tooltip-arrow{transform:translate(-50%,-5px);margin-left:-6px;border-width:0 6px 6px;border-bottom-color:#b1b1b1}.rc-tooltip-placement-bottom .rc-tooltip-arrow-inner,.rc-tooltip-placement-bottomLeft .rc-tooltip-arrow-inner,.rc-tooltip-placement-bottomRight .rc-tooltip-arrow-inner{top:1px;margin-left:-6px;border-width:0 6px 6px;border-bottom-color:#fff}.rc-tooltip-placement-bottom .rc-tooltip-arrow{left:50%}.rc-tooltip-placement-bottomLeft .rc-tooltip-arrow{left:15%}.rc-tooltip-placement-bottomRight .rc-tooltip-arrow{right:15%}.rc-tooltip{padding:0;background-color:transparent;opacity:1}.rc-tooltip.hide-arrow .rc-tooltip-arrow,.rc-tooltip.hide-arrow .rc-tooltip-content:before{display:none}.rc-tooltip.hide-arrow.rc-tooltip-placement-top,.rc-tooltip.hide-arrow.rc-tooltip-placement-bottom,.rc-tooltip.hide-arrow.rc-tooltip-placement-left,.rc-tooltip.hide-arrow.rc-tooltip-placement-right,.rc-tooltip.hide-arrow .rc-tooltip-inner{padding:0}.rc-tooltip-content{position:relative}.rc-tooltip-inner{padding:6px 12px;min-height:0;border:0;border-radius:4px;box-shadow:0 -1px 5px 1px #3a435633;pointer-events:none;color:#7f899c;font-size:13px}.rc-tooltip-arrow{border-width:0!important;width:8px;height:8px;background-color:#fff;box-shadow:0 -1px 5px 1px #3a435633;z-index:-1;transform:rotate(45deg)}.rc-tooltip-content:before{content:"";position:absolute;width:8px;height:8px;background-color:#fff;transform:rotate(45deg)}.rc-tooltip-placement-top{padding-bottom:6px}.rc-tooltip-placement-top .rc-tooltip-arrow,.rc-tooltip-placement-top .rc-tooltip-content:before{left:50%;margin-left:-4px;bottom:-4px}.rc-tooltip-placement-bottom{padding-top:6px}.rc-tooltip-placement-bottom .rc-tooltip-arrow,.rc-tooltip-placement-bottom .rc-tooltip-content:before{left:50%;margin-left:-4px;top:-4px}.rc-tooltip-placement-right{padding-left:6px}.rc-tooltip-placement-right .rc-tooltip-arrow,.rc-tooltip-placement-right .rc-tooltip-content:before{top:50%;margin-top:-4px;left:-4px}.rc-tooltip-placement-left{padding-right:6px}.rc-tooltip-placement-left .rc-tooltip-arrow,.rc-tooltip-placement-left .rc-tooltip-content:before{top:50%;margin-top:-4px;right:-4px}._breakLongWord_1dxah_307{word-break:break-all}._semanticText_1dxah_311{max-width:432px}.sis-scope._tooltip_1dxah_315{padding:12px 16px}._loader_1uppi_1{display:flex;align-content:center;justify-content:center;align-items:center}._loader_1uppi_1 ._caption_1uppi_7{margin-top:50%;word-break:break-word;text-align:center}._loader_1uppi_1 ._caption_1uppi_7 span{position:unset}._clickable_19yrx_1{cursor:pointer}._disabled_19yrx_5{pointer-events:none}._sharedComponentsInputRadioButton_195lt_1{width:28px;height:28px;padding:8px}._sharedComponentsInputRadioButton_195lt_1:hover{background-color:#5b63721a;border-radius:50%}.sis-scope .custom-radiobtn__text{padding-left:4px}._disabled_195lt_15{pointer-events:none}._disabled_195lt_15 .custom-radiobtn__text{color:#5b637266}.sis-scope .custom-checkbox__icon.app-icon._transparent_i81lr_1{background:transparent!important;color:transparent}.sis-scope .custom-checkbox__input:checked+.custom-checkbox__icon._transparent_i81lr_1{color:#3a4356}.sis-scope .custom-checkbox__text{padding-left:4px}._icon_i81lr_12{margin:0 -5px 0 0;cursor:pointer}._disabled_i81lr_17{pointer-events:none}._disabled_i81lr_17 .custom-checkbox__text{color:#5b637266}._disabled_i81lr_17 .app-icon{opacity:.4}._sharedComponentsInputCheckbox_i81lr_27{width:28px;height:28px;padding:8px}._sharedComponentsInputCheckbox_i81lr_27:hover{background-color:#5b63721a;border-radius:50%}._container_v8yrt_7{min-width:128px;position:absolute;cursor:pointer;padding:0;background:#fff;box-shadow:0 0 5px #3a435633;border-radius:4px}._container_v8yrt_7 li{list-style-type:none;line-height:22px;display:flex;justify-content:flex-start;align-items:center;padding:4px 5px;position:relative;transition:background-color .3s eaSe;cursor:pointer}._container_v8yrt_7 li._disabled_v8yrt_27{opacity:.5;cursor:default}._container_v8yrt_7 li._groupHeader_v8yrt_31{pointer-events:none;font-style:italic;font-weight:600}._container_v8yrt_7 li._isDrill_v8yrt_36:hover,._container_v8yrt_7 li._isDrill_v8yrt_36.fakeHover{background-color:#f4f4f8}._container_v8yrt_7 li:hover:not(._disabled_v8yrt_27){background-color:#f4f4f8}._container_v8yrt_7 li:hover:not(._disabled_v8yrt_27):after{opacity:1}._container_v8yrt_7 li._separator_v8yrt_45{border-top:1px solid #e1e1e1}._container_v8yrt_7 li._noIcon_v8yrt_48{padding-left:16px;padding-right:16px}._container_v8yrt_7 li._item_v8yrt_52._checked_v8yrt_52:after{content:"";display:block;position:absolute;top:0;left:0;height:100%;width:2px;background-color:#3a4356}._container_v8yrt_7 li._radio_v8yrt_62{padding-left:8px;padding-right:0;line-height:22px;align-items:stretch}._container_v8yrt_7 li._checkbox_v8yrt_68{padding-left:0;padding-right:0;line-height:22px;align-items:stretch}._container_v8yrt_7 li ._icon_v8yrt_74{margin:0 10px 0 7px}._container_v8yrt_7 li ._itemType_v8yrt_77{display:flex;width:100%;margin-right:1px;white-space:nowrap}._container_v8yrt_7 li ._itemType_v8yrt_77 :last-child{margin-left:auto}._container_v8yrt_7 li ._nestedType_v8yrt_86{display:flex;width:100%}._container_v8yrt_7 li ._nestedType_v8yrt_86 ._nestedIcon_v8yrt_90{position:static!important}._container_v8yrt_7 li ._menuItemText_v8yrt_93{flex-grow:1;display:flex;align-items:center}._separateGroup_v8yrt_99{min-width:fit-content}._itemCheckBox_v8yrt_103{padding:0 5px 0 16px;width:100%}._itemRadioButton_v8yrt_108{padding:0 5px 0 8px;width:100%}._scrollbar_v8yrt_113{cursor:default}._scrollbar_v8yrt_113>div:first-child{position:relative!important}._itemContainer_v8yrt_120{display:flex;flex-grow:1}._inlineConfirmation_v8yrt_125{font-weight:600}._menuItemTooltip_v8yrt_129{max-width:180px;overflow-wrap:break-word}._menuItemTooltip_v8yrt_129.rc-tooltip-placement-left{max-width:195px;padding-right:15px}._toggleButtonMenu_v8yrt_138{pointer-events:none;position:absolute;top:50%;transform:translateY(-50%);right:10px}._loader_v8yrt_146{height:25px;position:relative;margin:0 auto;width:90%}._container_v9uof_1{min-width:245px;max-width:350px;padding:12px 18px;font-size:13px;user-select:none}._message_v9uof_9{margin-top:10px;overflow:hidden;white-space:pre-line;text-overflow:ellipsis}._buttons_v9uof_16{margin-top:19px;width:100%;text-align:right}._button_v9uof_16{height:25px;width:auto;background:transparent;outline:none;cursor:pointer;border:none}._button_v9uof_16:hover{opacity:.7}._confirm_v9uof_34{color:green;margin-right:20px}._cancel_v9uof_39{color:red}._component_lx560_8{position:relative;display:flex;align-items:center}._component_lx560_8 ._searchIcon_lx560_13._searchIcon_lx560_13{position:absolute;left:8px;z-index:1;opacity:40%}._component_lx560_8 ._searchIcon_lx560_13._searchIcon_lx560_13._large_lx560_19{top:4px}._component_lx560_8 ._clearIcon_lx560_22._clearIcon_lx560_22{width:15px;height:15px;position:absolute;top:3px;right:4px;border-radius:20px;padding:4px}._component_lx560_8 ._clearIcon_lx560_22._clearIcon_lx560_22:hover{background-color:#d1d1d7}._component_lx560_8 ._clearIcon_lx560_22._clearIcon_lx560_22._clearIconHidden_lx560_34{display:none}._component_lx560_8 ._clearIcon_lx560_22._clearIcon_lx560_22._large_lx560_19{width:15px;height:15px;top:4px;padding:5px}._component_lx560_8 ._passwordVisibilityIcon_lx560_43._passwordVisibilityIcon_lx560_43{width:24px;height:24px;position:absolute;right:8px}._component_lx560_8 ._passwordVisibilityIcon_lx560_43._passwordVisibilityIcon_lx560_43._large_lx560_19{width:24px;height:24px;top:5px}._component_lx560_8 ._customIcon_lx560_54{position:absolute;top:3px;right:4px}._component_lx560_8 ._customIcon_lx560_54._isLeft_lx560_59{right:0;left:8px}._component_lx560_8 ._customIcon_lx560_54._large_lx560_19{top:5px}._component_lx560_8 ._input_lx560_66{border-radius:4px;outline:none;background:#f4f4f8;line-height:28px;height:28px;border:none;text-indent:8px;width:100%}._component_lx560_8 ._input_lx560_66._withLeftIcon_lx560_76{text-indent:32px}._component_lx560_8 ._input_lx560_66::placeholder{color:#b0b5bf}._component_lx560_8 ._input_lx560_66:focus{border:1px solid #5b6372}._component_lx560_8 ._input_lx560_66._large_lx560_19{height:34px;line-height:34px}._component_lx560_8 ._input_lx560_66::-ms-reveal{display:none}.sis-scope ._component_lx560_8{position:relative;display:flex;align-items:center}.sis-scope ._component_lx560_8 ._searchIcon_lx560_13._searchIcon_lx560_13{position:absolute;left:8px;z-index:1;opacity:40%}.sis-scope ._component_lx560_8 ._searchIcon_lx560_13._searchIcon_lx560_13._large_lx560_19{top:4px}.sis-scope ._component_lx560_8 ._clearIcon_lx560_22._clearIcon_lx560_22{width:15px;height:15px;position:absolute;top:3px;right:4px;border-radius:20px;padding:4px}.sis-scope ._component_lx560_8 ._clearIcon_lx560_22._clearIcon_lx560_22:hover{background-color:#d1d1d7}.sis-scope ._component_lx560_8 ._clearIcon_lx560_22._clearIcon_lx560_22._clearIconHidden_lx560_34{display:none}.sis-scope ._component_lx560_8 ._clearIcon_lx560_22._clearIcon_lx560_22._large_lx560_19{width:15px;height:15px;top:4px;padding:5px}.sis-scope ._component_lx560_8 ._passwordVisibilityIcon_lx560_43._passwordVisibilityIcon_lx560_43{width:24px;height:24px;position:absolute;right:8px}.sis-scope ._component_lx560_8 ._passwordVisibilityIcon_lx560_43._passwordVisibilityIcon_lx560_43._large_lx560_19{width:24px;height:24px;top:5px}.sis-scope ._component_lx560_8 ._customIcon_lx560_54{position:absolute;top:3px;right:4px}.sis-scope ._component_lx560_8 ._customIcon_lx560_54._isLeft_lx560_59{right:0;left:8px}.sis-scope ._component_lx560_8 ._customIcon_lx560_54._large_lx560_19{top:5px}.sis-scope ._component_lx560_8 ._input_lx560_66{border-radius:4px;outline:none;background:#f4f4f8;line-height:28px;height:28px;border:none;text-indent:8px;width:100%}.sis-scope ._component_lx560_8 ._input_lx560_66._withLeftIcon_lx560_76{text-indent:32px}.sis-scope ._component_lx560_8 ._input_lx560_66::placeholder{color:#b0b5bf}.sis-scope ._component_lx560_8 ._input_lx560_66:focus{border:1px solid #5b6372}.sis-scope ._component_lx560_8 ._input_lx560_66._large_lx560_19{height:34px;line-height:34px}.sis-scope ._component_lx560_8 ._input_lx560_66::-ms-reveal{display:none}._searchInputWrapper_otzmq_1 div{background:#f4f4f8;border-radius:4px;border:1px solid #5b6372}._searchInputWrapper_otzmq_1 div span{margin-left:-6px;z-index:1071!important}._searchInputWrapper_otzmq_1 div input{position:relative;z-index:1070;background:transparent;text-indent:0;border:none!important}._dropdownButton_xulrt_21{display:inline-flex;align-items:center;cursor:pointer;background:#f4f4f8;border-radius:4px;height:28px;min-width:192px}._dropdownButton_xulrt_21._inlineVariant_xulrt_30{background:none;height:18px;border:none;text-indent:0;min-width:initial}._dropdownButton_xulrt_21._inlineVariant_xulrt_30._open_xulrt_37{border:none}._dropdownButton_xulrt_21._open_xulrt_37{border:1px solid #5b6372}._dropdownButton_xulrt_21._disabled_xulrt_43{color:#bdc1c7;background:#f4f4f8;pointer-events:none}._dropdownButton_xulrt_21 ._selectedIcon_xulrt_48{flex-shrink:0}._dropdownButton_xulrt_21 ._chosenTitle_xulrt_51{margin-left:12px;flex-grow:1;overflow:hidden;white-space:nowrap;text-overflow:ellipsis}._dropdownButton_xulrt_21 ._clickIcon_xulrt_58{flex-shrink:0;margin-right:2px}._menu_1lxhu_1{margin:0;position:initial;box-shadow:none}._menu_1lxhu_1 li{padding:0 5px;height:28px}.sis-scope .btn--dark .btn__text{padding:5px 20px}.sis-scope .btn--gray{background:#f4f4f8}.sis-scope .btn--gray:disabled{background:#f4f4f8;opacity:1}.sis-scope .btn--gray:disabled:hover{background:#d1d1d7}.sis-scope .btn--gray:disabled .app-icon,.sis-scope .btn--gray:disabled .btn__text{opacity:.4}.sis-scope ._sharedComponentsButton_t1p0l_31{line-height:18px}.sis-scope ._sharedComponentsButtonText_t1p0l_34{padding:5px 20px}.sis-scope .btn._btnSecondary_t1p0l_37{border:1px solid #5b6372;background-color:#fff}.sis-scope .btn._btnSecondary_t1p0l_37:hover{background-color:#f4f4f8}.sis-scope .btn._btnSecondary_t1p0l_37:disabled{background-color:#fff}.sis-scope .btn._btnSecondary_t1p0l_37:disabled:hover{background-color:#fff}._item_fvqjc_1{margin-bottom:12px;cursor:pointer;height:18px;user-select:none}._item_fvqjc_1:last-child{margin-bottom:0}._item_fvqjc_1 ._icon_fvqjc_10{margin-top:-3px}')), document.head.appendChild(e);
    }
  } catch (t) {
    console.error("vite-plugin-css-injected-by-js", t);
  }
})();
function Pc(e) {
  "@babel/helpers - typeof";
  return Pc = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Pc(e);
}
function cl(e) {
  ba(1, arguments);
  var t = Object.prototype.toString.call(e);
  return e instanceof Date || Pc(e) === "object" && t === "[object Date]" ? new Date(e.getTime()) : typeof e == "number" || t === "[object Number]" ? new Date(e) : ((typeof e == "string" || t === "[object String]") && typeof console != "undefined" && (console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"), console.warn(new Error().stack)), /* @__PURE__ */ new Date(NaN));
}
function fie(e, t) {
  ba(2, arguments);
  var n = cl(e), r = $c(t);
  if (isNaN(r))
    return /* @__PURE__ */ new Date(NaN);
  if (!r)
    return n;
  var o = n.getDate(), i = new Date(n.getTime());
  i.setMonth(n.getMonth() + r + 1, 0);
  var a = i.getDate();
  return o >= a ? i : (n.setFullYear(i.getFullYear(), i.getMonth(), o), n);
}
var pie = {};
function hie() {
  return pie;
}
function oM(e, t) {
  var n, r, o, i, a, s, c, l;
  ba(1, arguments);
  var d = hie(), f = $c((n = (r = (o = (i = t == null ? void 0 : t.weekStartsOn) !== null && i !== void 0 ? i : t == null || (a = t.locale) === null || a === void 0 || (s = a.options) === null || s === void 0 ? void 0 : s.weekStartsOn) !== null && o !== void 0 ? o : d.weekStartsOn) !== null && r !== void 0 ? r : (c = d.locale) === null || c === void 0 || (l = c.options) === null || l === void 0 ? void 0 : l.weekStartsOn) !== null && n !== void 0 ? n : 0);
  if (!(f >= 0 && f <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var p = cl(e), m = p.getUTCDay(), v = (m < f ? 7 : 0) + m - f;
  return p.setUTCDate(p.getUTCDate() - v), p.setUTCHours(0, 0, 0, 0), p;
}
var mie = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, qD = function(t, n, r) {
  var o, i = mie[t];
  return typeof i == "string" ? o = i : n === 1 ? o = i.one : o = i.other.replace("{{count}}", n.toString()), r != null && r.addSuffix ? r.comparison && r.comparison > 0 ? "in " + o : o + " ago" : o;
};
function rt(e) {
  return function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = t.width ? String(t.width) : e.defaultWidth, r = e.formats[n] || e.formats[e.defaultWidth];
    return r;
  };
}
var gie = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, vie = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, bie = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, yie = {
  date: rt({
    formats: gie,
    defaultWidth: "full"
  }),
  time: rt({
    formats: vie,
    defaultWidth: "full"
  }),
  dateTime: rt({
    formats: bie,
    defaultWidth: "full"
  })
}, _ie = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, GD = function(t, n, r, o) {
  return _ie[t];
};
function De(e) {
  return function(t, n) {
    var r = n != null && n.context ? String(n.context) : "standalone", o;
    if (r === "formatting" && e.formattingValues) {
      var i = e.defaultFormattingWidth || e.defaultWidth, a = n != null && n.width ? String(n.width) : i;
      o = e.formattingValues[a] || e.formattingValues[i];
    } else {
      var s = e.defaultWidth, c = n != null && n.width ? String(n.width) : e.defaultWidth;
      o = e.values[c] || e.values[s];
    }
    var l = e.argumentCallback ? e.argumentCallback(t) : t;
    return o[l];
  };
}
var wie = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, xie = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, Cie = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
  wide: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
}, Sie = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
}, Tie = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, Eie = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, kie = function(t, n) {
  var r = Number(t), o = r % 100;
  if (o > 20 || o < 10)
    switch (o % 10) {
      case 1:
        return r + "st";
      case 2:
        return r + "nd";
      case 3:
        return r + "rd";
    }
  return r + "th";
}, YD = {
  ordinalNumber: kie,
  era: De({
    values: wie,
    defaultWidth: "wide"
  }),
  quarter: De({
    values: xie,
    defaultWidth: "wide",
    argumentCallback: function(t) {
      return t - 1;
    }
  }),
  month: De({
    values: Cie,
    defaultWidth: "wide"
  }),
  day: De({
    values: Sie,
    defaultWidth: "wide"
  }),
  dayPeriod: De({
    values: Tie,
    defaultWidth: "wide",
    formattingValues: Eie,
    defaultFormattingWidth: "wide"
  })
};
function Ie(e) {
  return function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = n.width, o = r && e.matchPatterns[r] || e.matchPatterns[e.defaultMatchWidth], i = t.match(o);
    if (!i)
      return null;
    var a = i[0], s = r && e.parsePatterns[r] || e.parsePatterns[e.defaultParseWidth], c = Array.isArray(s) ? Rie(s, function(f) {
      return f.test(a);
    }) : Mie(s, function(f) {
      return f.test(a);
    }), l;
    l = e.valueCallback ? e.valueCallback(c) : c, l = n.valueCallback ? n.valueCallback(l) : l;
    var d = t.slice(a.length);
    return {
      value: l,
      rest: d
    };
  };
}
function Mie(e, t) {
  for (var n in e)
    if (e.hasOwnProperty(n) && t(e[n]))
      return n;
}
function Rie(e, t) {
  for (var n = 0; n < e.length; n++)
    if (t(e[n]))
      return n;
}
function vo(e) {
  return function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = t.match(e.matchPattern);
    if (!r)
      return null;
    var o = r[0], i = t.match(e.parsePattern);
    if (!i)
      return null;
    var a = e.valueCallback ? e.valueCallback(i[0]) : i[0];
    a = n.valueCallback ? n.valueCallback(a) : a;
    var s = t.slice(o.length);
    return {
      value: a,
      rest: s
    };
  };
}
var Pie = /^(\d+)(th|st|nd|rd)?/i, Oie = /\d+/i, Nie = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, Aie = {
  any: [/^b/i, /^(a|c)/i]
}, Die = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, Iie = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Lie = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, $ie = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, Fie = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, zie = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, Bie = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, Hie = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, ZD = {
  ordinalNumber: vo({
    matchPattern: Pie,
    parsePattern: Oie,
    valueCallback: function(t) {
      return parseInt(t, 10);
    }
  }),
  era: Ie({
    matchPatterns: Nie,
    defaultMatchWidth: "wide",
    parsePatterns: Aie,
    defaultParseWidth: "any"
  }),
  quarter: Ie({
    matchPatterns: Die,
    defaultMatchWidth: "wide",
    parsePatterns: Iie,
    defaultParseWidth: "any",
    valueCallback: function(t) {
      return t + 1;
    }
  }),
  month: Ie({
    matchPatterns: Lie,
    defaultMatchWidth: "wide",
    parsePatterns: $ie,
    defaultParseWidth: "any"
  }),
  day: Ie({
    matchPatterns: Fie,
    defaultMatchWidth: "wide",
    parsePatterns: zie,
    defaultParseWidth: "any"
  }),
  dayPeriod: Ie({
    matchPatterns: Bie,
    defaultMatchWidth: "any",
    parsePatterns: Hie,
    defaultParseWidth: "any"
  })
}, iM = {
  code: "en-US",
  formatDistance: qD,
  formatLong: yie,
  formatRelative: GD,
  localize: YD,
  match: ZD,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
function XD(e, t) {
  ba(2, arguments);
  var n = $c(t);
  return fie(e, n * 12);
}
function KD(e, t) {
  ba(2, arguments);
  var n = $c(t);
  return XD(e, -n);
}
function jie(e) {
  ba(1, arguments);
  var t = cl(e), n = t.getFullYear(), r = t.getMonth(), o = /* @__PURE__ */ new Date(0);
  return o.setFullYear(n, r + 1, 0), o.setHours(0, 0, 0, 0), o.getDate();
}
function Wie(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Uy(e, t) {
  return Uy = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, o) {
    return r.__proto__ = o, r;
  }, Uy(e, t);
}
function Vie(e, t) {
  if (Pc(e) != "object" || !e)
    return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (Pc(r) != "object")
      return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function Uie(e) {
  var t = Vie(e, "string");
  return Pc(t) == "symbol" ? t : t + "";
}
function qie(e, t, n) {
  return t = Uie(t), t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function Gie(e, t) {
  ba(2, arguments);
  var n = cl(e), r = $c(t), o = n.getFullYear(), i = n.getDate(), a = /* @__PURE__ */ new Date(0);
  a.setFullYear(o, r, 15), a.setHours(0, 0, 0, 0);
  var s = jie(a);
  return n.setMonth(r, Math.min(i, s)), n;
}
function Yie(e, t) {
  ba(2, arguments);
  var n = cl(e), r = $c(t);
  return isNaN(n.getTime()) ? /* @__PURE__ */ new Date(NaN) : (n.setFullYear(r), n);
}
function Qs(e, t, n) {
  ba(2, arguments);
  var r = oM(e, n), o = oM(t, n);
  return r.getTime() === o.getTime();
}
var aM = {
  lessThanXSeconds: {
    standalone: {
      one: "weniger als 1 Sekunde",
      other: "weniger als {{count}} Sekunden"
    },
    withPreposition: {
      one: "weniger als 1 Sekunde",
      other: "weniger als {{count}} Sekunden"
    }
  },
  xSeconds: {
    standalone: {
      one: "1 Sekunde",
      other: "{{count}} Sekunden"
    },
    withPreposition: {
      one: "1 Sekunde",
      other: "{{count}} Sekunden"
    }
  },
  halfAMinute: {
    standalone: "halbe Minute",
    withPreposition: "halben Minute"
  },
  lessThanXMinutes: {
    standalone: {
      one: "weniger als 1 Minute",
      other: "weniger als {{count}} Minuten"
    },
    withPreposition: {
      one: "weniger als 1 Minute",
      other: "weniger als {{count}} Minuten"
    }
  },
  xMinutes: {
    standalone: {
      one: "1 Minute",
      other: "{{count}} Minuten"
    },
    withPreposition: {
      one: "1 Minute",
      other: "{{count}} Minuten"
    }
  },
  aboutXHours: {
    standalone: {
      one: "etwa 1 Stunde",
      other: "etwa {{count}} Stunden"
    },
    withPreposition: {
      one: "etwa 1 Stunde",
      other: "etwa {{count}} Stunden"
    }
  },
  xHours: {
    standalone: {
      one: "1 Stunde",
      other: "{{count}} Stunden"
    },
    withPreposition: {
      one: "1 Stunde",
      other: "{{count}} Stunden"
    }
  },
  xDays: {
    standalone: {
      one: "1 Tag",
      other: "{{count}} Tage"
    },
    withPreposition: {
      one: "1 Tag",
      other: "{{count}} Tagen"
    }
  },
  aboutXWeeks: {
    standalone: {
      one: "etwa 1 Woche",
      other: "etwa {{count}} Wochen"
    },
    withPreposition: {
      one: "etwa 1 Woche",
      other: "etwa {{count}} Wochen"
    }
  },
  xWeeks: {
    standalone: {
      one: "1 Woche",
      other: "{{count}} Wochen"
    },
    withPreposition: {
      one: "1 Woche",
      other: "{{count}} Wochen"
    }
  },
  aboutXMonths: {
    standalone: {
      one: "etwa 1 Monat",
      other: "etwa {{count}} Monate"
    },
    withPreposition: {
      one: "etwa 1 Monat",
      other: "etwa {{count}} Monaten"
    }
  },
  xMonths: {
    standalone: {
      one: "1 Monat",
      other: "{{count}} Monate"
    },
    withPreposition: {
      one: "1 Monat",
      other: "{{count}} Monaten"
    }
  },
  aboutXYears: {
    standalone: {
      one: "etwa 1 Jahr",
      other: "etwa {{count}} Jahre"
    },
    withPreposition: {
      one: "etwa 1 Jahr",
      other: "etwa {{count}} Jahren"
    }
  },
  xYears: {
    standalone: {
      one: "1 Jahr",
      other: "{{count}} Jahre"
    },
    withPreposition: {
      one: "1 Jahr",
      other: "{{count}} Jahren"
    }
  },
  overXYears: {
    standalone: {
      one: "mehr als 1 Jahr",
      other: "mehr als {{count}} Jahre"
    },
    withPreposition: {
      one: "mehr als 1 Jahr",
      other: "mehr als {{count}} Jahren"
    }
  },
  almostXYears: {
    standalone: {
      one: "fast 1 Jahr",
      other: "fast {{count}} Jahre"
    },
    withPreposition: {
      one: "fast 1 Jahr",
      other: "fast {{count}} Jahren"
    }
  }
}, Zie = function(t, n, r) {
  var o, i = r != null && r.addSuffix ? aM[t].withPreposition : aM[t].standalone;
  return typeof i == "string" ? o = i : n === 1 ? o = i.one : o = i.other.replace("{{count}}", String(n)), r != null && r.addSuffix ? r.comparison && r.comparison > 0 ? "in " + o : "vor " + o : o;
}, Xie = {
  full: "EEEE, do MMMM y",
  // Montag, 7. Januar 2018
  long: "do MMMM y",
  // 7. Januar 2018
  medium: "do MMM y",
  // 7. Jan. 2018
  short: "dd.MM.y"
  // 07.01.2018
}, Kie = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, Jie = {
  full: "{{date}} 'um' {{time}}",
  long: "{{date}} 'um' {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, Qie = {
  date: rt({
    formats: Xie,
    defaultWidth: "full"
  }),
  time: rt({
    formats: Kie,
    defaultWidth: "full"
  }),
  dateTime: rt({
    formats: Jie,
    defaultWidth: "full"
  })
}, eae = {
  lastWeek: "'letzten' eeee 'um' p",
  yesterday: "'gestern um' p",
  today: "'heute um' p",
  tomorrow: "'morgen um' p",
  nextWeek: "eeee 'um' p",
  other: "P"
}, tae = function(t, n, r, o) {
  return eae[t];
}, nae = {
  narrow: ["v.Chr.", "n.Chr."],
  abbreviated: ["v.Chr.", "n.Chr."],
  wide: ["vor Christus", "nach Christus"]
}, rae = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1. Quartal", "2. Quartal", "3. Quartal", "4. Quartal"]
}, qy = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["Jan", "Feb", "Mär", "Apr", "Mai", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dez"],
  wide: ["Januar", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"]
}, oae = {
  narrow: qy.narrow,
  abbreviated: ["Jan.", "Feb.", "März", "Apr.", "Mai", "Juni", "Juli", "Aug.", "Sep.", "Okt.", "Nov.", "Dez."],
  wide: qy.wide
}, iae = {
  narrow: ["S", "M", "D", "M", "D", "F", "S"],
  short: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
  abbreviated: ["So.", "Mo.", "Di.", "Mi.", "Do.", "Fr.", "Sa."],
  wide: ["Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag"]
}, aae = {
  narrow: {
    am: "vm.",
    pm: "nm.",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "Morgen",
    afternoon: "Nachm.",
    evening: "Abend",
    night: "Nacht"
  },
  abbreviated: {
    am: "vorm.",
    pm: "nachm.",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "Morgen",
    afternoon: "Nachmittag",
    evening: "Abend",
    night: "Nacht"
  },
  wide: {
    am: "vormittags",
    pm: "nachmittags",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "Morgen",
    afternoon: "Nachmittag",
    evening: "Abend",
    night: "Nacht"
  }
}, sae = {
  narrow: {
    am: "vm.",
    pm: "nm.",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "morgens",
    afternoon: "nachm.",
    evening: "abends",
    night: "nachts"
  },
  abbreviated: {
    am: "vorm.",
    pm: "nachm.",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "morgens",
    afternoon: "nachmittags",
    evening: "abends",
    night: "nachts"
  },
  wide: {
    am: "vormittags",
    pm: "nachmittags",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "morgens",
    afternoon: "nachmittags",
    evening: "abends",
    night: "nachts"
  }
}, lae = function(t) {
  var n = Number(t);
  return n + ".";
}, cae = {
  ordinalNumber: lae,
  era: De({
    values: nae,
    defaultWidth: "wide"
  }),
  quarter: De({
    values: rae,
    defaultWidth: "wide",
    argumentCallback: function(t) {
      return t - 1;
    }
  }),
  month: De({
    values: qy,
    formattingValues: oae,
    defaultWidth: "wide"
  }),
  day: De({
    values: iae,
    defaultWidth: "wide"
  }),
  dayPeriod: De({
    values: aae,
    defaultWidth: "wide",
    formattingValues: sae,
    defaultFormattingWidth: "wide"
  })
}, uae = /^(\d+)(\.)?/i, dae = /\d+/i, fae = {
  narrow: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
  abbreviated: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
  wide: /^(vor Christus|vor unserer Zeitrechnung|nach Christus|unserer Zeitrechnung)/i
}, pae = {
  any: [/^v/i, /^n/i]
}, hae = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](\.)? Quartal/i
}, mae = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, gae = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(j[aä]n|feb|mär[z]?|apr|mai|jun[i]?|jul[i]?|aug|sep|okt|nov|dez)\.?/i,
  wide: /^(januar|februar|märz|april|mai|juni|juli|august|september|oktober|november|dezember)/i
}, vae = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^j[aä]/i, /^f/i, /^mär/i, /^ap/i, /^mai/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, bae = {
  narrow: /^[smdmf]/i,
  short: /^(so|mo|di|mi|do|fr|sa)/i,
  abbreviated: /^(son?|mon?|die?|mit?|don?|fre?|sam?)\.?/i,
  wide: /^(sonntag|montag|dienstag|mittwoch|donnerstag|freitag|samstag)/i
}, yae = {
  any: [/^so/i, /^mo/i, /^di/i, /^mi/i, /^do/i, /^f/i, /^sa/i]
}, _ae = {
  narrow: /^(vm\.?|nm\.?|Mitternacht|Mittag|morgens|nachm\.?|abends|nachts)/i,
  abbreviated: /^(vorm\.?|nachm\.?|Mitternacht|Mittag|morgens|nachm\.?|abends|nachts)/i,
  wide: /^(vormittags|nachmittags|Mitternacht|Mittag|morgens|nachmittags|abends|nachts)/i
}, wae = {
  any: {
    am: /^v/i,
    pm: /^n/i,
    midnight: /^Mitte/i,
    noon: /^Mitta/i,
    morning: /morgens/i,
    afternoon: /nachmittags/i,
    // will never be matched. Afternoon is matched by `pm`
    evening: /abends/i,
    night: /nachts/i
    // will never be matched. Night is matched by `pm`
  }
}, xae = {
  ordinalNumber: vo({
    matchPattern: uae,
    parsePattern: dae,
    valueCallback: function(t) {
      return parseInt(t);
    }
  }),
  era: Ie({
    matchPatterns: fae,
    defaultMatchWidth: "wide",
    parsePatterns: pae,
    defaultParseWidth: "any"
  }),
  quarter: Ie({
    matchPatterns: hae,
    defaultMatchWidth: "wide",
    parsePatterns: mae,
    defaultParseWidth: "any",
    valueCallback: function(t) {
      return t + 1;
    }
  }),
  month: Ie({
    matchPatterns: gae,
    defaultMatchWidth: "wide",
    parsePatterns: vae,
    defaultParseWidth: "any"
  }),
  day: Ie({
    matchPatterns: bae,
    defaultMatchWidth: "wide",
    parsePatterns: yae,
    defaultParseWidth: "any"
  }),
  dayPeriod: Ie({
    matchPatterns: _ae,
    defaultMatchWidth: "wide",
    parsePatterns: wae,
    defaultParseWidth: "any"
  })
}, Cae = {
  code: "de",
  formatDistance: Zie,
  formatLong: Qie,
  formatRelative: tae,
  localize: cae,
  match: xae,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, Sae = {
  full: "EEEE, d MMMM yyyy",
  long: "d MMMM yyyy",
  medium: "d MMM yyyy",
  short: "dd/MM/yyyy"
}, Tae = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, Eae = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, kae = {
  date: rt({
    formats: Sae,
    defaultWidth: "full"
  }),
  time: rt({
    formats: Tae,
    defaultWidth: "full"
  }),
  dateTime: rt({
    formats: Eae,
    defaultWidth: "full"
  })
}, Mae = {
  code: "en-GB",
  formatDistance: qD,
  formatLong: kae,
  formatRelative: GD,
  localize: YD,
  match: ZD,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, Rae = {
  lessThanXSeconds: {
    one: "menos de un segundo",
    other: "menos de {{count}} segundos"
  },
  xSeconds: {
    one: "1 segundo",
    other: "{{count}} segundos"
  },
  halfAMinute: "medio minuto",
  lessThanXMinutes: {
    one: "menos de un minuto",
    other: "menos de {{count}} minutos"
  },
  xMinutes: {
    one: "1 minuto",
    other: "{{count}} minutos"
  },
  aboutXHours: {
    one: "alrededor de 1 hora",
    other: "alrededor de {{count}} horas"
  },
  xHours: {
    one: "1 hora",
    other: "{{count}} horas"
  },
  xDays: {
    one: "1 día",
    other: "{{count}} días"
  },
  aboutXWeeks: {
    one: "alrededor de 1 semana",
    other: "alrededor de {{count}} semanas"
  },
  xWeeks: {
    one: "1 semana",
    other: "{{count}} semanas"
  },
  aboutXMonths: {
    one: "alrededor de 1 mes",
    other: "alrededor de {{count}} meses"
  },
  xMonths: {
    one: "1 mes",
    other: "{{count}} meses"
  },
  aboutXYears: {
    one: "alrededor de 1 año",
    other: "alrededor de {{count}} años"
  },
  xYears: {
    one: "1 año",
    other: "{{count}} años"
  },
  overXYears: {
    one: "más de 1 año",
    other: "más de {{count}} años"
  },
  almostXYears: {
    one: "casi 1 año",
    other: "casi {{count}} años"
  }
}, Pae = function(t, n, r) {
  var o, i = Rae[t];
  return typeof i == "string" ? o = i : n === 1 ? o = i.one : o = i.other.replace("{{count}}", n.toString()), r != null && r.addSuffix ? r.comparison && r.comparison > 0 ? "en " + o : "hace " + o : o;
}, Oae = {
  full: "EEEE, d 'de' MMMM 'de' y",
  long: "d 'de' MMMM 'de' y",
  medium: "d MMM y",
  short: "dd/MM/y"
}, Nae = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, Aae = {
  full: "{{date}} 'a las' {{time}}",
  long: "{{date}} 'a las' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, Dae = {
  date: rt({
    formats: Oae,
    defaultWidth: "full"
  }),
  time: rt({
    formats: Nae,
    defaultWidth: "full"
  }),
  dateTime: rt({
    formats: Aae,
    defaultWidth: "full"
  })
}, Iae = {
  lastWeek: "'el' eeee 'pasado a la' p",
  yesterday: "'ayer a la' p",
  today: "'hoy a la' p",
  tomorrow: "'mañana a la' p",
  nextWeek: "eeee 'a la' p",
  other: "P"
}, Lae = {
  lastWeek: "'el' eeee 'pasado a las' p",
  yesterday: "'ayer a las' p",
  today: "'hoy a las' p",
  tomorrow: "'mañana a las' p",
  nextWeek: "eeee 'a las' p",
  other: "P"
}, $ae = function(t, n, r, o) {
  return n.getUTCHours() !== 1 ? Lae[t] : Iae[t];
}, Fae = {
  narrow: ["AC", "DC"],
  abbreviated: ["AC", "DC"],
  wide: ["antes de cristo", "después de cristo"]
}, zae = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["T1", "T2", "T3", "T4"],
  wide: ["1º trimestre", "2º trimestre", "3º trimestre", "4º trimestre"]
}, Bae = {
  narrow: ["e", "f", "m", "a", "m", "j", "j", "a", "s", "o", "n", "d"],
  abbreviated: ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic"],
  wide: ["enero", "febrero", "marzo", "abril", "mayo", "junio", "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"]
}, Hae = {
  narrow: ["d", "l", "m", "m", "j", "v", "s"],
  short: ["do", "lu", "ma", "mi", "ju", "vi", "sá"],
  abbreviated: ["dom", "lun", "mar", "mié", "jue", "vie", "sáb"],
  wide: ["domingo", "lunes", "martes", "miércoles", "jueves", "viernes", "sábado"]
}, jae = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mn",
    noon: "md",
    morning: "mañana",
    afternoon: "tarde",
    evening: "tarde",
    night: "noche"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "medianoche",
    noon: "mediodia",
    morning: "mañana",
    afternoon: "tarde",
    evening: "tarde",
    night: "noche"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "medianoche",
    noon: "mediodia",
    morning: "mañana",
    afternoon: "tarde",
    evening: "tarde",
    night: "noche"
  }
}, Wae = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mn",
    noon: "md",
    morning: "de la mañana",
    afternoon: "de la tarde",
    evening: "de la tarde",
    night: "de la noche"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "medianoche",
    noon: "mediodia",
    morning: "de la mañana",
    afternoon: "de la tarde",
    evening: "de la tarde",
    night: "de la noche"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "medianoche",
    noon: "mediodia",
    morning: "de la mañana",
    afternoon: "de la tarde",
    evening: "de la tarde",
    night: "de la noche"
  }
}, Vae = function(t, n) {
  var r = Number(t);
  return r + "º";
}, Uae = {
  ordinalNumber: Vae,
  era: De({
    values: Fae,
    defaultWidth: "wide"
  }),
  quarter: De({
    values: zae,
    defaultWidth: "wide",
    argumentCallback: function(t) {
      return Number(t) - 1;
    }
  }),
  month: De({
    values: Bae,
    defaultWidth: "wide"
  }),
  day: De({
    values: Hae,
    defaultWidth: "wide"
  }),
  dayPeriod: De({
    values: jae,
    defaultWidth: "wide",
    formattingValues: Wae,
    defaultFormattingWidth: "wide"
  })
}, qae = /^(\d+)(º)?/i, Gae = /\d+/i, Yae = {
  narrow: /^(ac|dc|a|d)/i,
  abbreviated: /^(a\.?\s?c\.?|a\.?\s?e\.?\s?c\.?|d\.?\s?c\.?|e\.?\s?c\.?)/i,
  wide: /^(antes de cristo|antes de la era com[uú]n|despu[eé]s de cristo|era com[uú]n)/i
}, Zae = {
  any: [/^ac/i, /^dc/i],
  wide: [/^(antes de cristo|antes de la era com[uú]n)/i, /^(despu[eé]s de cristo|era com[uú]n)/i]
}, Xae = {
  narrow: /^[1234]/i,
  abbreviated: /^T[1234]/i,
  wide: /^[1234](º)? trimestre/i
}, Kae = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Jae = {
  narrow: /^[efmajsond]/i,
  abbreviated: /^(ene|feb|mar|abr|may|jun|jul|ago|sep|oct|nov|dic)/i,
  wide: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i
}, Qae = {
  narrow: [/^e/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^en/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i]
}, ese = {
  narrow: /^[dlmjvs]/i,
  short: /^(do|lu|ma|mi|ju|vi|s[áa])/i,
  abbreviated: /^(dom|lun|mar|mi[ée]|jue|vie|s[áa]b)/i,
  wide: /^(domingo|lunes|martes|mi[ée]rcoles|jueves|viernes|s[áa]bado)/i
}, tse = {
  narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^j/i, /^v/i, /^s/i],
  any: [/^do/i, /^lu/i, /^ma/i, /^mi/i, /^ju/i, /^vi/i, /^sa/i]
}, nse = {
  narrow: /^(a|p|mn|md|(de la|a las) (mañana|tarde|noche))/i,
  any: /^([ap]\.?\s?m\.?|medianoche|mediodia|(de la|a las) (mañana|tarde|noche))/i
}, rse = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mn/i,
    noon: /^md/i,
    morning: /mañana/i,
    afternoon: /tarde/i,
    evening: /tarde/i,
    night: /noche/i
  }
}, ose = {
  ordinalNumber: vo({
    matchPattern: qae,
    parsePattern: Gae,
    valueCallback: function(t) {
      return parseInt(t, 10);
    }
  }),
  era: Ie({
    matchPatterns: Yae,
    defaultMatchWidth: "wide",
    parsePatterns: Zae,
    defaultParseWidth: "any"
  }),
  quarter: Ie({
    matchPatterns: Xae,
    defaultMatchWidth: "wide",
    parsePatterns: Kae,
    defaultParseWidth: "any",
    valueCallback: function(t) {
      return t + 1;
    }
  }),
  month: Ie({
    matchPatterns: Jae,
    defaultMatchWidth: "wide",
    parsePatterns: Qae,
    defaultParseWidth: "any"
  }),
  day: Ie({
    matchPatterns: ese,
    defaultMatchWidth: "wide",
    parsePatterns: tse,
    defaultParseWidth: "any"
  }),
  dayPeriod: Ie({
    matchPatterns: nse,
    defaultMatchWidth: "any",
    parsePatterns: rse,
    defaultParseWidth: "any"
  })
}, ise = {
  code: "es",
  formatDistance: Pae,
  formatLong: Dae,
  formatRelative: $ae,
  localize: Uae,
  match: ose,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
}, ase = {
  lessThanXSeconds: {
    one: "moins d’une seconde",
    other: "moins de {{count}} secondes"
  },
  xSeconds: {
    one: "1 seconde",
    other: "{{count}} secondes"
  },
  halfAMinute: "30 secondes",
  lessThanXMinutes: {
    one: "moins d’une minute",
    other: "moins de {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "environ 1 heure",
    other: "environ {{count}} heures"
  },
  xHours: {
    one: "1 heure",
    other: "{{count}} heures"
  },
  xDays: {
    one: "1 jour",
    other: "{{count}} jours"
  },
  aboutXWeeks: {
    one: "environ 1 semaine",
    other: "environ {{count}} semaines"
  },
  xWeeks: {
    one: "1 semaine",
    other: "{{count}} semaines"
  },
  aboutXMonths: {
    one: "environ 1 mois",
    other: "environ {{count}} mois"
  },
  xMonths: {
    one: "1 mois",
    other: "{{count}} mois"
  },
  aboutXYears: {
    one: "environ 1 an",
    other: "environ {{count}} ans"
  },
  xYears: {
    one: "1 an",
    other: "{{count}} ans"
  },
  overXYears: {
    one: "plus d’un an",
    other: "plus de {{count}} ans"
  },
  almostXYears: {
    one: "presqu’un an",
    other: "presque {{count}} ans"
  }
}, sse = function(t, n, r) {
  var o, i = ase[t];
  return typeof i == "string" ? o = i : n === 1 ? o = i.one : o = i.other.replace("{{count}}", String(n)), r != null && r.addSuffix ? r.comparison && r.comparison > 0 ? "dans " + o : "il y a " + o : o;
}, lse = {
  full: "EEEE d MMMM y",
  long: "d MMMM y",
  medium: "d MMM y",
  short: "dd/MM/y"
}, cse = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, use = {
  full: "{{date}} 'à' {{time}}",
  long: "{{date}} 'à' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, dse = {
  date: rt({
    formats: lse,
    defaultWidth: "full"
  }),
  time: rt({
    formats: cse,
    defaultWidth: "full"
  }),
  dateTime: rt({
    formats: use,
    defaultWidth: "full"
  })
}, fse = {
  lastWeek: "eeee 'dernier à' p",
  yesterday: "'hier à' p",
  today: "'aujourd’hui à' p",
  tomorrow: "'demain à' p'",
  nextWeek: "eeee 'prochain à' p",
  other: "P"
}, pse = function(t, n, r, o) {
  return fse[t];
}, hse = {
  narrow: ["av. J.-C", "ap. J.-C"],
  abbreviated: ["av. J.-C", "ap. J.-C"],
  wide: ["avant Jésus-Christ", "après Jésus-Christ"]
}, mse = {
  narrow: ["T1", "T2", "T3", "T4"],
  abbreviated: ["1er trim.", "2ème trim.", "3ème trim.", "4ème trim."],
  wide: ["1er trimestre", "2ème trimestre", "3ème trimestre", "4ème trimestre"]
}, gse = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["janv.", "févr.", "mars", "avr.", "mai", "juin", "juil.", "août", "sept.", "oct.", "nov.", "déc."],
  wide: ["janvier", "février", "mars", "avril", "mai", "juin", "juillet", "août", "septembre", "octobre", "novembre", "décembre"]
}, vse = {
  narrow: ["D", "L", "M", "M", "J", "V", "S"],
  short: ["di", "lu", "ma", "me", "je", "ve", "sa"],
  abbreviated: ["dim.", "lun.", "mar.", "mer.", "jeu.", "ven.", "sam."],
  wide: ["dimanche", "lundi", "mardi", "mercredi", "jeudi", "vendredi", "samedi"]
}, bse = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "minuit",
    noon: "midi",
    morning: "mat.",
    afternoon: "ap.m.",
    evening: "soir",
    night: "mat."
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "minuit",
    noon: "midi",
    morning: "matin",
    afternoon: "après-midi",
    evening: "soir",
    night: "matin"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "minuit",
    noon: "midi",
    morning: "du matin",
    afternoon: "de l’après-midi",
    evening: "du soir",
    night: "du matin"
  }
}, yse = function(t, n) {
  var r = Number(t), o = n == null ? void 0 : n.unit;
  if (r === 0)
    return "0";
  var i = ["year", "week", "hour", "minute", "second"], a;
  return r === 1 ? a = o && i.includes(o) ? "ère" : "er" : a = "ème", r + a;
}, _se = {
  ordinalNumber: yse,
  era: De({
    values: hse,
    defaultWidth: "wide"
  }),
  quarter: De({
    values: mse,
    defaultWidth: "wide",
    argumentCallback: function(t) {
      return t - 1;
    }
  }),
  month: De({
    values: gse,
    defaultWidth: "wide"
  }),
  day: De({
    values: vse,
    defaultWidth: "wide"
  }),
  dayPeriod: De({
    values: bse,
    defaultWidth: "wide"
  })
}, wse = /^(\d+)(ième|ère|ème|er|e)?/i, xse = /\d+/i, Cse = {
  narrow: /^(av\.J\.C|ap\.J\.C|ap\.J\.-C)/i,
  abbreviated: /^(av\.J\.-C|av\.J-C|apr\.J\.-C|apr\.J-C|ap\.J-C)/i,
  wide: /^(avant Jésus-Christ|après Jésus-Christ)/i
}, Sse = {
  any: [/^av/i, /^ap/i]
}, Tse = {
  narrow: /^T?[1234]/i,
  abbreviated: /^[1234](er|ème|e)? trim\.?/i,
  wide: /^[1234](er|ème|e)? trimestre/i
}, Ese = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, kse = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(janv|févr|mars|avr|mai|juin|juill|juil|août|sept|oct|nov|déc)\.?/i,
  wide: /^(janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i
}, Mse = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^av/i, /^ma/i, /^juin/i, /^juil/i, /^ao/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, Rse = {
  narrow: /^[lmjvsd]/i,
  short: /^(di|lu|ma|me|je|ve|sa)/i,
  abbreviated: /^(dim|lun|mar|mer|jeu|ven|sam)\.?/i,
  wide: /^(dimanche|lundi|mardi|mercredi|jeudi|vendredi|samedi)/i
}, Pse = {
  narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^j/i, /^v/i, /^s/i],
  any: [/^di/i, /^lu/i, /^ma/i, /^me/i, /^je/i, /^ve/i, /^sa/i]
}, Ose = {
  narrow: /^(a|p|minuit|midi|mat\.?|ap\.?m\.?|soir|nuit)/i,
  any: /^([ap]\.?\s?m\.?|du matin|de l'après[-\s]midi|du soir|de la nuit)/i
}, Nse = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^min/i,
    noon: /^mid/i,
    morning: /mat/i,
    afternoon: /ap/i,
    evening: /soir/i,
    night: /nuit/i
  }
}, Ase = {
  ordinalNumber: vo({
    matchPattern: wse,
    parsePattern: xse,
    valueCallback: function(t) {
      return parseInt(t);
    }
  }),
  era: Ie({
    matchPatterns: Cse,
    defaultMatchWidth: "wide",
    parsePatterns: Sse,
    defaultParseWidth: "any"
  }),
  quarter: Ie({
    matchPatterns: Tse,
    defaultMatchWidth: "wide",
    parsePatterns: Ese,
    defaultParseWidth: "any",
    valueCallback: function(t) {
      return t + 1;
    }
  }),
  month: Ie({
    matchPatterns: kse,
    defaultMatchWidth: "wide",
    parsePatterns: Mse,
    defaultParseWidth: "any"
  }),
  day: Ie({
    matchPatterns: Rse,
    defaultMatchWidth: "wide",
    parsePatterns: Pse,
    defaultParseWidth: "any"
  }),
  dayPeriod: Ie({
    matchPatterns: Ose,
    defaultMatchWidth: "any",
    parsePatterns: Nse,
    defaultParseWidth: "any"
  })
}, Dse = {
  code: "fr",
  formatDistance: sse,
  formatLong: dse,
  formatRelative: pse,
  localize: _se,
  match: Ase,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, Ise = {
  lessThanXSeconds: {
    one: "meno di un secondo",
    other: "meno di {{count}} secondi"
  },
  xSeconds: {
    one: "un secondo",
    other: "{{count}} secondi"
  },
  halfAMinute: "alcuni secondi",
  lessThanXMinutes: {
    one: "meno di un minuto",
    other: "meno di {{count}} minuti"
  },
  xMinutes: {
    one: "un minuto",
    other: "{{count}} minuti"
  },
  aboutXHours: {
    one: "circa un'ora",
    other: "circa {{count}} ore"
  },
  xHours: {
    one: "un'ora",
    other: "{{count}} ore"
  },
  xDays: {
    one: "un giorno",
    other: "{{count}} giorni"
  },
  aboutXWeeks: {
    one: "circa una settimana",
    other: "circa {{count}} settimane"
  },
  xWeeks: {
    one: "una settimana",
    other: "{{count}} settimane"
  },
  aboutXMonths: {
    one: "circa un mese",
    other: "circa {{count}} mesi"
  },
  xMonths: {
    one: "un mese",
    other: "{{count}} mesi"
  },
  aboutXYears: {
    one: "circa un anno",
    other: "circa {{count}} anni"
  },
  xYears: {
    one: "un anno",
    other: "{{count}} anni"
  },
  overXYears: {
    one: "più di un anno",
    other: "più di {{count}} anni"
  },
  almostXYears: {
    one: "quasi un anno",
    other: "quasi {{count}} anni"
  }
}, Lse = function(t, n, r) {
  var o, i = Ise[t];
  return typeof i == "string" ? o = i : n === 1 ? o = i.one : o = i.other.replace("{{count}}", n.toString()), r != null && r.addSuffix ? r.comparison && r.comparison > 0 ? "tra " + o : o + " fa" : o;
}, $se = {
  full: "EEEE d MMMM y",
  long: "d MMMM y",
  medium: "d MMM y",
  short: "dd/MM/y"
}, Fse = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, zse = {
  full: "{{date}} {{time}}",
  long: "{{date}} {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, Bse = {
  date: rt({
    formats: $se,
    defaultWidth: "full"
  }),
  time: rt({
    formats: Fse,
    defaultWidth: "full"
  }),
  dateTime: rt({
    formats: zse,
    defaultWidth: "full"
  })
}, Aw = ["domenica", "lunedì", "martedì", "mercoledì", "giovedì", "venerdì", "sabato"];
function Hse(e) {
  switch (e) {
    case 0:
      return "'domenica scorsa alle' p";
    default:
      return "'" + Aw[e] + " scorso alle' p";
  }
}
function sM(e) {
  return "'" + Aw[e] + " alle' p";
}
function jse(e) {
  switch (e) {
    case 0:
      return "'domenica prossima alle' p";
    default:
      return "'" + Aw[e] + " prossimo alle' p";
  }
}
var Wse = {
  lastWeek: function(t, n, r) {
    var o = t.getUTCDay();
    return Qs(t, n, r) ? sM(o) : Hse(o);
  },
  yesterday: "'ieri alle' p",
  today: "'oggi alle' p",
  tomorrow: "'domani alle' p",
  nextWeek: function(t, n, r) {
    var o = t.getUTCDay();
    return Qs(t, n, r) ? sM(o) : jse(o);
  },
  other: "P"
}, Vse = function(t, n, r, o) {
  var i = Wse[t];
  return typeof i == "function" ? i(n, r, o) : i;
}, Use = {
  narrow: ["aC", "dC"],
  abbreviated: ["a.C.", "d.C."],
  wide: ["avanti Cristo", "dopo Cristo"]
}, qse = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["T1", "T2", "T3", "T4"],
  wide: ["1º trimestre", "2º trimestre", "3º trimestre", "4º trimestre"]
}, Gse = {
  narrow: ["G", "F", "M", "A", "M", "G", "L", "A", "S", "O", "N", "D"],
  abbreviated: ["gen", "feb", "mar", "apr", "mag", "giu", "lug", "ago", "set", "ott", "nov", "dic"],
  wide: ["gennaio", "febbraio", "marzo", "aprile", "maggio", "giugno", "luglio", "agosto", "settembre", "ottobre", "novembre", "dicembre"]
}, Yse = {
  narrow: ["D", "L", "M", "M", "G", "V", "S"],
  short: ["dom", "lun", "mar", "mer", "gio", "ven", "sab"],
  abbreviated: ["dom", "lun", "mar", "mer", "gio", "ven", "sab"],
  wide: ["domenica", "lunedì", "martedì", "mercoledì", "giovedì", "venerdì", "sabato"]
}, Zse = {
  narrow: {
    am: "m.",
    pm: "p.",
    midnight: "mezzanotte",
    noon: "mezzogiorno",
    morning: "mattina",
    afternoon: "pomeriggio",
    evening: "sera",
    night: "notte"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "mezzanotte",
    noon: "mezzogiorno",
    morning: "mattina",
    afternoon: "pomeriggio",
    evening: "sera",
    night: "notte"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "mezzanotte",
    noon: "mezzogiorno",
    morning: "mattina",
    afternoon: "pomeriggio",
    evening: "sera",
    night: "notte"
  }
}, Xse = {
  narrow: {
    am: "m.",
    pm: "p.",
    midnight: "mezzanotte",
    noon: "mezzogiorno",
    morning: "di mattina",
    afternoon: "del pomeriggio",
    evening: "di sera",
    night: "di notte"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "mezzanotte",
    noon: "mezzogiorno",
    morning: "di mattina",
    afternoon: "del pomeriggio",
    evening: "di sera",
    night: "di notte"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "mezzanotte",
    noon: "mezzogiorno",
    morning: "di mattina",
    afternoon: "del pomeriggio",
    evening: "di sera",
    night: "di notte"
  }
}, Kse = function(t, n) {
  var r = Number(t);
  return String(r);
}, Jse = {
  ordinalNumber: Kse,
  era: De({
    values: Use,
    defaultWidth: "wide"
  }),
  quarter: De({
    values: qse,
    defaultWidth: "wide",
    argumentCallback: function(t) {
      return t - 1;
    }
  }),
  month: De({
    values: Gse,
    defaultWidth: "wide"
  }),
  day: De({
    values: Yse,
    defaultWidth: "wide"
  }),
  dayPeriod: De({
    values: Zse,
    defaultWidth: "wide",
    formattingValues: Xse,
    defaultFormattingWidth: "wide"
  })
}, Qse = /^(\d+)(º)?/i, ele = /\d+/i, tle = {
  narrow: /^(aC|dC)/i,
  abbreviated: /^(a\.?\s?C\.?|a\.?\s?e\.?\s?v\.?|d\.?\s?C\.?|e\.?\s?v\.?)/i,
  wide: /^(avanti Cristo|avanti Era Volgare|dopo Cristo|Era Volgare)/i
}, nle = {
  any: [/^a/i, /^(d|e)/i]
}, rle = {
  narrow: /^[1234]/i,
  abbreviated: /^t[1234]/i,
  wide: /^[1234](º)? trimestre/i
}, ole = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, ile = {
  narrow: /^[gfmalsond]/i,
  abbreviated: /^(gen|feb|mar|apr|mag|giu|lug|ago|set|ott|nov|dic)/i,
  wide: /^(gennaio|febbraio|marzo|aprile|maggio|giugno|luglio|agosto|settembre|ottobre|novembre|dicembre)/i
}, ale = {
  narrow: [/^g/i, /^f/i, /^m/i, /^a/i, /^m/i, /^g/i, /^l/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ge/i, /^f/i, /^mar/i, /^ap/i, /^mag/i, /^gi/i, /^l/i, /^ag/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, sle = {
  narrow: /^[dlmgvs]/i,
  short: /^(do|lu|ma|me|gi|ve|sa)/i,
  abbreviated: /^(dom|lun|mar|mer|gio|ven|sab)/i,
  wide: /^(domenica|luned[i|ì]|marted[i|ì]|mercoled[i|ì]|gioved[i|ì]|venerd[i|ì]|sabato)/i
}, lle = {
  narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^g/i, /^v/i, /^s/i],
  any: [/^d/i, /^l/i, /^ma/i, /^me/i, /^g/i, /^v/i, /^s/i]
}, cle = {
  narrow: /^(a|m\.|p|mezzanotte|mezzogiorno|(di|del) (mattina|pomeriggio|sera|notte))/i,
  any: /^([ap]\.?\s?m\.?|mezzanotte|mezzogiorno|(di|del) (mattina|pomeriggio|sera|notte))/i
}, ule = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mezza/i,
    noon: /^mezzo/i,
    morning: /mattina/i,
    afternoon: /pomeriggio/i,
    evening: /sera/i,
    night: /notte/i
  }
}, dle = {
  ordinalNumber: vo({
    matchPattern: Qse,
    parsePattern: ele,
    valueCallback: function(t) {
      return parseInt(t, 10);
    }
  }),
  era: Ie({
    matchPatterns: tle,
    defaultMatchWidth: "wide",
    parsePatterns: nle,
    defaultParseWidth: "any"
  }),
  quarter: Ie({
    matchPatterns: rle,
    defaultMatchWidth: "wide",
    parsePatterns: ole,
    defaultParseWidth: "any",
    valueCallback: function(t) {
      return t + 1;
    }
  }),
  month: Ie({
    matchPatterns: ile,
    defaultMatchWidth: "wide",
    parsePatterns: ale,
    defaultParseWidth: "any"
  }),
  day: Ie({
    matchPatterns: sle,
    defaultMatchWidth: "wide",
    parsePatterns: lle,
    defaultParseWidth: "any"
  }),
  dayPeriod: Ie({
    matchPatterns: cle,
    defaultMatchWidth: "any",
    parsePatterns: ule,
    defaultParseWidth: "any"
  })
}, fle = {
  code: "it",
  formatDistance: Lse,
  formatLong: Bse,
  formatRelative: Vse,
  localize: Jse,
  match: dle,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, ple = {
  lessThanXSeconds: {
    one: "1秒未満",
    other: "{{count}}秒未満",
    oneWithSuffix: "約1秒",
    otherWithSuffix: "約{{count}}秒"
  },
  xSeconds: {
    one: "1秒",
    other: "{{count}}秒"
  },
  halfAMinute: "30秒",
  lessThanXMinutes: {
    one: "1分未満",
    other: "{{count}}分未満",
    oneWithSuffix: "約1分",
    otherWithSuffix: "約{{count}}分"
  },
  xMinutes: {
    one: "1分",
    other: "{{count}}分"
  },
  aboutXHours: {
    one: "約1時間",
    other: "約{{count}}時間"
  },
  xHours: {
    one: "1時間",
    other: "{{count}}時間"
  },
  xDays: {
    one: "1日",
    other: "{{count}}日"
  },
  aboutXWeeks: {
    one: "約1週間",
    other: "約{{count}}週間"
  },
  xWeeks: {
    one: "1週間",
    other: "{{count}}週間"
  },
  aboutXMonths: {
    one: "約1か月",
    other: "約{{count}}か月"
  },
  xMonths: {
    one: "1か月",
    other: "{{count}}か月"
  },
  aboutXYears: {
    one: "約1年",
    other: "約{{count}}年"
  },
  xYears: {
    one: "1年",
    other: "{{count}}年"
  },
  overXYears: {
    one: "1年以上",
    other: "{{count}}年以上"
  },
  almostXYears: {
    one: "1年近く",
    other: "{{count}}年近く"
  }
}, hle = function(t, n, r) {
  r = r || {};
  var o, i = ple[t];
  return typeof i == "string" ? o = i : n === 1 ? r.addSuffix && i.oneWithSuffix ? o = i.oneWithSuffix : o = i.one : r.addSuffix && i.otherWithSuffix ? o = i.otherWithSuffix.replace("{{count}}", String(n)) : o = i.other.replace("{{count}}", String(n)), r.addSuffix ? r.comparison && r.comparison > 0 ? o + "後" : o + "前" : o;
}, mle = {
  full: "y年M月d日EEEE",
  long: "y年M月d日",
  medium: "y/MM/dd",
  short: "y/MM/dd"
}, gle = {
  full: "H時mm分ss秒 zzzz",
  long: "H:mm:ss z",
  medium: "H:mm:ss",
  short: "H:mm"
}, vle = {
  full: "{{date}} {{time}}",
  long: "{{date}} {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, ble = {
  date: rt({
    formats: mle,
    defaultWidth: "full"
  }),
  time: rt({
    formats: gle,
    defaultWidth: "full"
  }),
  dateTime: rt({
    formats: vle,
    defaultWidth: "full"
  })
}, yle = {
  lastWeek: "先週のeeeeのp",
  yesterday: "昨日のp",
  today: "今日のp",
  tomorrow: "明日のp",
  nextWeek: "翌週のeeeeのp",
  other: "P"
}, _le = function(t, n, r, o) {
  return yle[t];
}, wle = {
  narrow: ["BC", "AC"],
  abbreviated: ["紀元前", "西暦"],
  wide: ["紀元前", "西暦"]
}, xle = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["第1四半期", "第2四半期", "第3四半期", "第4四半期"]
}, Cle = {
  narrow: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"],
  abbreviated: ["1月", "2月", "3月", "4月", "5月", "6月", "7月", "8月", "9月", "10月", "11月", "12月"],
  wide: ["1月", "2月", "3月", "4月", "5月", "6月", "7月", "8月", "9月", "10月", "11月", "12月"]
}, Sle = {
  narrow: ["日", "月", "火", "水", "木", "金", "土"],
  short: ["日", "月", "火", "水", "木", "金", "土"],
  abbreviated: ["日", "月", "火", "水", "木", "金", "土"],
  wide: ["日曜日", "月曜日", "火曜日", "水曜日", "木曜日", "金曜日", "土曜日"]
}, Tle = {
  narrow: {
    am: "午前",
    pm: "午後",
    midnight: "深夜",
    noon: "正午",
    morning: "朝",
    afternoon: "午後",
    evening: "夜",
    night: "深夜"
  },
  abbreviated: {
    am: "午前",
    pm: "午後",
    midnight: "深夜",
    noon: "正午",
    morning: "朝",
    afternoon: "午後",
    evening: "夜",
    night: "深夜"
  },
  wide: {
    am: "午前",
    pm: "午後",
    midnight: "深夜",
    noon: "正午",
    morning: "朝",
    afternoon: "午後",
    evening: "夜",
    night: "深夜"
  }
}, Ele = {
  narrow: {
    am: "午前",
    pm: "午後",
    midnight: "深夜",
    noon: "正午",
    morning: "朝",
    afternoon: "午後",
    evening: "夜",
    night: "深夜"
  },
  abbreviated: {
    am: "午前",
    pm: "午後",
    midnight: "深夜",
    noon: "正午",
    morning: "朝",
    afternoon: "午後",
    evening: "夜",
    night: "深夜"
  },
  wide: {
    am: "午前",
    pm: "午後",
    midnight: "深夜",
    noon: "正午",
    morning: "朝",
    afternoon: "午後",
    evening: "夜",
    night: "深夜"
  }
}, kle = function(t, n) {
  var r = Number(t), o = String(n == null ? void 0 : n.unit);
  switch (o) {
    case "year":
      return "".concat(r, "年");
    case "quarter":
      return "第".concat(r, "四半期");
    case "month":
      return "".concat(r, "月");
    case "week":
      return "第".concat(r, "週");
    case "date":
      return "".concat(r, "日");
    case "hour":
      return "".concat(r, "時");
    case "minute":
      return "".concat(r, "分");
    case "second":
      return "".concat(r, "秒");
    default:
      return "".concat(r);
  }
}, Mle = {
  ordinalNumber: kle,
  era: De({
    values: wle,
    defaultWidth: "wide"
  }),
  quarter: De({
    values: xle,
    defaultWidth: "wide",
    argumentCallback: function(t) {
      return Number(t) - 1;
    }
  }),
  month: De({
    values: Cle,
    defaultWidth: "wide"
  }),
  day: De({
    values: Sle,
    defaultWidth: "wide"
  }),
  dayPeriod: De({
    values: Tle,
    defaultWidth: "wide",
    formattingValues: Ele,
    defaultFormattingWidth: "wide"
  })
}, Rle = /^第?\d+(年|四半期|月|週|日|時|分|秒)?/i, Ple = /\d+/i, Ole = {
  narrow: /^(B\.?C\.?|A\.?D\.?)/i,
  abbreviated: /^(紀元[前後]|西暦)/i,
  wide: /^(紀元[前後]|西暦)/i
}, Nle = {
  narrow: [/^B/i, /^A/i],
  any: [/^(紀元前)/i, /^(西暦|紀元後)/i]
}, Ale = {
  narrow: /^[1234]/i,
  abbreviated: /^Q[1234]/i,
  wide: /^第[1234一二三四１２３４]四半期/i
}, Dle = {
  any: [/(1|一|１)/i, /(2|二|２)/i, /(3|三|３)/i, /(4|四|４)/i]
}, Ile = {
  narrow: /^([123456789]|1[012])/,
  abbreviated: /^([123456789]|1[012])月/i,
  wide: /^([123456789]|1[012])月/i
}, Lle = {
  any: [/^1\D/, /^2/, /^3/, /^4/, /^5/, /^6/, /^7/, /^8/, /^9/, /^10/, /^11/, /^12/]
}, $le = {
  narrow: /^[日月火水木金土]/,
  short: /^[日月火水木金土]/,
  abbreviated: /^[日月火水木金土]/,
  wide: /^[日月火水木金土]曜日/
}, Fle = {
  any: [/^日/, /^月/, /^火/, /^水/, /^木/, /^金/, /^土/]
}, zle = {
  any: /^(AM|PM|午前|午後|正午|深夜|真夜中|夜|朝)/i
}, Ble = {
  any: {
    am: /^(A|午前)/i,
    pm: /^(P|午後)/i,
    midnight: /^深夜|真夜中/i,
    noon: /^正午/i,
    morning: /^朝/i,
    afternoon: /^午後/i,
    evening: /^夜/i,
    night: /^深夜/i
  }
}, Hle = {
  ordinalNumber: vo({
    matchPattern: Rle,
    parsePattern: Ple,
    valueCallback: function(t) {
      return parseInt(t, 10);
    }
  }),
  era: Ie({
    matchPatterns: Ole,
    defaultMatchWidth: "wide",
    parsePatterns: Nle,
    defaultParseWidth: "any"
  }),
  quarter: Ie({
    matchPatterns: Ale,
    defaultMatchWidth: "wide",
    parsePatterns: Dle,
    defaultParseWidth: "any",
    valueCallback: function(t) {
      return t + 1;
    }
  }),
  month: Ie({
    matchPatterns: Ile,
    defaultMatchWidth: "wide",
    parsePatterns: Lle,
    defaultParseWidth: "any"
  }),
  day: Ie({
    matchPatterns: $le,
    defaultMatchWidth: "wide",
    parsePatterns: Fle,
    defaultParseWidth: "any"
  }),
  dayPeriod: Ie({
    matchPatterns: zle,
    defaultMatchWidth: "any",
    parsePatterns: Ble,
    defaultParseWidth: "any"
  })
}, jle = {
  code: "ja",
  formatDistance: hle,
  formatLong: ble,
  formatRelative: _le,
  localize: Mle,
  match: Hle,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
}, Wle = {
  lessThanXSeconds: {
    one: "1초 미만",
    other: "{{count}}초 미만"
  },
  xSeconds: {
    one: "1초",
    other: "{{count}}초"
  },
  halfAMinute: "30초",
  lessThanXMinutes: {
    one: "1분 미만",
    other: "{{count}}분 미만"
  },
  xMinutes: {
    one: "1분",
    other: "{{count}}분"
  },
  aboutXHours: {
    one: "약 1시간",
    other: "약 {{count}}시간"
  },
  xHours: {
    one: "1시간",
    other: "{{count}}시간"
  },
  xDays: {
    one: "1일",
    other: "{{count}}일"
  },
  aboutXWeeks: {
    one: "약 1주",
    other: "약 {{count}}주"
  },
  xWeeks: {
    one: "1주",
    other: "{{count}}주"
  },
  aboutXMonths: {
    one: "약 1개월",
    other: "약 {{count}}개월"
  },
  xMonths: {
    one: "1개월",
    other: "{{count}}개월"
  },
  aboutXYears: {
    one: "약 1년",
    other: "약 {{count}}년"
  },
  xYears: {
    one: "1년",
    other: "{{count}}년"
  },
  overXYears: {
    one: "1년 이상",
    other: "{{count}}년 이상"
  },
  almostXYears: {
    one: "거의 1년",
    other: "거의 {{count}}년"
  }
}, Vle = function(t, n, r) {
  var o, i = Wle[t];
  return typeof i == "string" ? o = i : n === 1 ? o = i.one : o = i.other.replace("{{count}}", n.toString()), r != null && r.addSuffix ? r.comparison && r.comparison > 0 ? o + " 후" : o + " 전" : o;
}, Ule = {
  full: "y년 M월 d일 EEEE",
  long: "y년 M월 d일",
  medium: "y.MM.dd",
  short: "y.MM.dd"
}, qle = {
  full: "a H시 mm분 ss초 zzzz",
  long: "a H:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, Gle = {
  full: "{{date}} {{time}}",
  long: "{{date}} {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, Yle = {
  date: rt({
    formats: Ule,
    defaultWidth: "full"
  }),
  time: rt({
    formats: qle,
    defaultWidth: "full"
  }),
  dateTime: rt({
    formats: Gle,
    defaultWidth: "full"
  })
}, Zle = {
  lastWeek: "'지난' eeee p",
  yesterday: "'어제' p",
  today: "'오늘' p",
  tomorrow: "'내일' p",
  nextWeek: "'다음' eeee p",
  other: "P"
}, Xle = function(t, n, r, o) {
  return Zle[t];
}, Kle = {
  narrow: ["BC", "AD"],
  abbreviated: ["BC", "AD"],
  wide: ["기원전", "서기"]
}, Jle = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1분기", "2분기", "3분기", "4분기"]
}, Qle = {
  narrow: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"],
  abbreviated: ["1월", "2월", "3월", "4월", "5월", "6월", "7월", "8월", "9월", "10월", "11월", "12월"],
  wide: ["1월", "2월", "3월", "4월", "5월", "6월", "7월", "8월", "9월", "10월", "11월", "12월"]
}, ece = {
  narrow: ["일", "월", "화", "수", "목", "금", "토"],
  short: ["일", "월", "화", "수", "목", "금", "토"],
  abbreviated: ["일", "월", "화", "수", "목", "금", "토"],
  wide: ["일요일", "월요일", "화요일", "수요일", "목요일", "금요일", "토요일"]
}, tce = {
  narrow: {
    am: "오전",
    pm: "오후",
    midnight: "자정",
    noon: "정오",
    morning: "아침",
    afternoon: "오후",
    evening: "저녁",
    night: "밤"
  },
  abbreviated: {
    am: "오전",
    pm: "오후",
    midnight: "자정",
    noon: "정오",
    morning: "아침",
    afternoon: "오후",
    evening: "저녁",
    night: "밤"
  },
  wide: {
    am: "오전",
    pm: "오후",
    midnight: "자정",
    noon: "정오",
    morning: "아침",
    afternoon: "오후",
    evening: "저녁",
    night: "밤"
  }
}, nce = {
  narrow: {
    am: "오전",
    pm: "오후",
    midnight: "자정",
    noon: "정오",
    morning: "아침",
    afternoon: "오후",
    evening: "저녁",
    night: "밤"
  },
  abbreviated: {
    am: "오전",
    pm: "오후",
    midnight: "자정",
    noon: "정오",
    morning: "아침",
    afternoon: "오후",
    evening: "저녁",
    night: "밤"
  },
  wide: {
    am: "오전",
    pm: "오후",
    midnight: "자정",
    noon: "정오",
    morning: "아침",
    afternoon: "오후",
    evening: "저녁",
    night: "밤"
  }
}, rce = function(t, n) {
  var r = Number(t), o = String(n == null ? void 0 : n.unit);
  switch (o) {
    case "minute":
    case "second":
      return String(r);
    case "date":
      return r + "일";
    default:
      return r + "번째";
  }
}, oce = {
  ordinalNumber: rce,
  era: De({
    values: Kle,
    defaultWidth: "wide"
  }),
  quarter: De({
    values: Jle,
    defaultWidth: "wide",
    argumentCallback: function(t) {
      return t - 1;
    }
  }),
  month: De({
    values: Qle,
    defaultWidth: "wide"
  }),
  day: De({
    values: ece,
    defaultWidth: "wide"
  }),
  dayPeriod: De({
    values: tce,
    defaultWidth: "wide",
    formattingValues: nce,
    defaultFormattingWidth: "wide"
  })
}, ice = /^(\d+)(일|번째)?/i, ace = /\d+/i, sce = {
  narrow: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(기원전|서기)/i
}, lce = {
  any: [/^(bc|기원전)/i, /^(ad|서기)/i]
}, cce = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234]사?분기/i
}, uce = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, dce = {
  narrow: /^(1[012]|[123456789])/,
  abbreviated: /^(1[012]|[123456789])월/i,
  wide: /^(1[012]|[123456789])월/i
}, fce = {
  any: [/^1월?$/, /^2/, /^3/, /^4/, /^5/, /^6/, /^7/, /^8/, /^9/, /^10/, /^11/, /^12/]
}, pce = {
  narrow: /^[일월화수목금토]/,
  short: /^[일월화수목금토]/,
  abbreviated: /^[일월화수목금토]/,
  wide: /^[일월화수목금토]요일/
}, hce = {
  any: [/^일/, /^월/, /^화/, /^수/, /^목/, /^금/, /^토/]
}, mce = {
  any: /^(am|pm|오전|오후|자정|정오|아침|저녁|밤)/i
}, gce = {
  any: {
    am: /^(am|오전)/i,
    pm: /^(pm|오후)/i,
    midnight: /^자정/i,
    noon: /^정오/i,
    morning: /^아침/i,
    afternoon: /^오후/i,
    evening: /^저녁/i,
    night: /^밤/i
  }
}, vce = {
  ordinalNumber: vo({
    matchPattern: ice,
    parsePattern: ace,
    valueCallback: function(t) {
      return parseInt(t, 10);
    }
  }),
  era: Ie({
    matchPatterns: sce,
    defaultMatchWidth: "wide",
    parsePatterns: lce,
    defaultParseWidth: "any"
  }),
  quarter: Ie({
    matchPatterns: cce,
    defaultMatchWidth: "wide",
    parsePatterns: uce,
    defaultParseWidth: "any",
    valueCallback: function(t) {
      return t + 1;
    }
  }),
  month: Ie({
    matchPatterns: dce,
    defaultMatchWidth: "wide",
    parsePatterns: fce,
    defaultParseWidth: "any"
  }),
  day: Ie({
    matchPatterns: pce,
    defaultMatchWidth: "wide",
    parsePatterns: hce,
    defaultParseWidth: "any"
  }),
  dayPeriod: Ie({
    matchPatterns: mce,
    defaultMatchWidth: "any",
    parsePatterns: gce,
    defaultParseWidth: "any"
  })
}, bce = {
  code: "ko",
  formatDistance: Vle,
  formatLong: Yle,
  formatRelative: Xle,
  localize: oce,
  match: vce,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
}, yce = {
  lessThanXSeconds: {
    one: "minder dan een seconde",
    other: "minder dan {{count}} seconden"
  },
  xSeconds: {
    one: "1 seconde",
    other: "{{count}} seconden"
  },
  halfAMinute: "een halve minuut",
  lessThanXMinutes: {
    one: "minder dan een minuut",
    other: "minder dan {{count}} minuten"
  },
  xMinutes: {
    one: "een minuut",
    other: "{{count}} minuten"
  },
  aboutXHours: {
    one: "ongeveer 1 uur",
    other: "ongeveer {{count}} uur"
  },
  xHours: {
    one: "1 uur",
    other: "{{count}} uur"
  },
  xDays: {
    one: "1 dag",
    other: "{{count}} dagen"
  },
  aboutXWeeks: {
    one: "ongeveer 1 week",
    other: "ongeveer {{count}} weken"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weken"
  },
  aboutXMonths: {
    one: "ongeveer 1 maand",
    other: "ongeveer {{count}} maanden"
  },
  xMonths: {
    one: "1 maand",
    other: "{{count}} maanden"
  },
  aboutXYears: {
    one: "ongeveer 1 jaar",
    other: "ongeveer {{count}} jaar"
  },
  xYears: {
    one: "1 jaar",
    other: "{{count}} jaar"
  },
  overXYears: {
    one: "meer dan 1 jaar",
    other: "meer dan {{count}} jaar"
  },
  almostXYears: {
    one: "bijna 1 jaar",
    other: "bijna {{count}} jaar"
  }
}, _ce = function(t, n, r) {
  var o, i = yce[t];
  return typeof i == "string" ? o = i : n === 1 ? o = i.one : o = i.other.replace("{{count}}", String(n)), r != null && r.addSuffix ? r.comparison && r.comparison > 0 ? "over " + o : o + " geleden" : o;
}, wce = {
  full: "EEEE d MMMM y",
  long: "d MMMM y",
  medium: "d MMM y",
  short: "dd-MM-y"
}, xce = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, Cce = {
  full: "{{date}} 'om' {{time}}",
  long: "{{date}} 'om' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, Sce = {
  date: rt({
    formats: wce,
    defaultWidth: "full"
  }),
  time: rt({
    formats: xce,
    defaultWidth: "full"
  }),
  dateTime: rt({
    formats: Cce,
    defaultWidth: "full"
  })
}, Tce = {
  lastWeek: "'afgelopen' eeee 'om' p",
  yesterday: "'gisteren om' p",
  today: "'vandaag om' p",
  tomorrow: "'morgen om' p",
  nextWeek: "eeee 'om' p",
  other: "P"
}, Ece = function(t, n, r, o) {
  return Tce[t];
}, kce = {
  narrow: ["v.C.", "n.C."],
  abbreviated: ["v.Chr.", "n.Chr."],
  wide: ["voor Christus", "na Christus"]
}, Mce = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["K1", "K2", "K3", "K4"],
  wide: ["1e kwartaal", "2e kwartaal", "3e kwartaal", "4e kwartaal"]
}, Rce = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["jan.", "feb.", "mrt.", "apr.", "mei", "jun.", "jul.", "aug.", "sep.", "okt.", "nov.", "dec."],
  wide: ["januari", "februari", "maart", "april", "mei", "juni", "juli", "augustus", "september", "oktober", "november", "december"]
}, Pce = {
  narrow: ["Z", "M", "D", "W", "D", "V", "Z"],
  short: ["zo", "ma", "di", "wo", "do", "vr", "za"],
  abbreviated: ["zon", "maa", "din", "woe", "don", "vri", "zat"],
  wide: ["zondag", "maandag", "dinsdag", "woensdag", "donderdag", "vrijdag", "zaterdag"]
}, Oce = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "middernacht",
    noon: "het middaguur",
    morning: "'s ochtends",
    afternoon: "'s middags",
    evening: "'s avonds",
    night: "'s nachts"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "middernacht",
    noon: "het middaguur",
    morning: "'s ochtends",
    afternoon: "'s middags",
    evening: "'s avonds",
    night: "'s nachts"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "middernacht",
    noon: "het middaguur",
    morning: "'s ochtends",
    afternoon: "'s middags",
    evening: "'s avonds",
    night: "'s nachts"
  }
}, Nce = function(t, n) {
  var r = Number(t);
  return r + "e";
}, Ace = {
  ordinalNumber: Nce,
  era: De({
    values: kce,
    defaultWidth: "wide"
  }),
  quarter: De({
    values: Mce,
    defaultWidth: "wide",
    argumentCallback: function(t) {
      return t - 1;
    }
  }),
  month: De({
    values: Rce,
    defaultWidth: "wide"
  }),
  day: De({
    values: Pce,
    defaultWidth: "wide"
  }),
  dayPeriod: De({
    values: Oce,
    defaultWidth: "wide"
  })
}, Dce = /^(\d+)e?/i, Ice = /\d+/i, Lce = {
  narrow: /^([vn]\.? ?C\.?)/,
  abbreviated: /^([vn]\. ?Chr\.?)/,
  wide: /^((voor|na) Christus)/
}, $ce = {
  any: [/^v/, /^n/]
}, Fce = {
  narrow: /^[1234]/i,
  abbreviated: /^K[1234]/i,
  wide: /^[1234]e kwartaal/i
}, zce = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Bce = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan.|feb.|mrt.|apr.|mei|jun.|jul.|aug.|sep.|okt.|nov.|dec.)/i,
  wide: /^(januari|februari|maart|april|mei|juni|juli|augustus|september|oktober|november|december)/i
}, Hce = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^jan/i, /^feb/i, /^m(r|a)/i, /^apr/i, /^mei/i, /^jun/i, /^jul/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i]
}, jce = {
  narrow: /^[zmdwv]/i,
  short: /^(zo|ma|di|wo|do|vr|za)/i,
  abbreviated: /^(zon|maa|din|woe|don|vri|zat)/i,
  wide: /^(zondag|maandag|dinsdag|woensdag|donderdag|vrijdag|zaterdag)/i
}, Wce = {
  narrow: [/^z/i, /^m/i, /^d/i, /^w/i, /^d/i, /^v/i, /^z/i],
  any: [/^zo/i, /^ma/i, /^di/i, /^wo/i, /^do/i, /^vr/i, /^za/i]
}, Vce = {
  any: /^(am|pm|middernacht|het middaguur|'s (ochtends|middags|avonds|nachts))/i
}, Uce = {
  any: {
    am: /^am/i,
    pm: /^pm/i,
    midnight: /^middernacht/i,
    noon: /^het middaguur/i,
    morning: /ochtend/i,
    afternoon: /middag/i,
    evening: /avond/i,
    night: /nacht/i
  }
}, qce = {
  ordinalNumber: vo({
    matchPattern: Dce,
    parsePattern: Ice,
    valueCallback: function(t) {
      return parseInt(t, 10);
    }
  }),
  era: Ie({
    matchPatterns: Lce,
    defaultMatchWidth: "wide",
    parsePatterns: $ce,
    defaultParseWidth: "any"
  }),
  quarter: Ie({
    matchPatterns: Fce,
    defaultMatchWidth: "wide",
    parsePatterns: zce,
    defaultParseWidth: "any",
    valueCallback: function(t) {
      return t + 1;
    }
  }),
  month: Ie({
    matchPatterns: Bce,
    defaultMatchWidth: "wide",
    parsePatterns: Hce,
    defaultParseWidth: "any"
  }),
  day: Ie({
    matchPatterns: jce,
    defaultMatchWidth: "wide",
    parsePatterns: Wce,
    defaultParseWidth: "any"
  }),
  dayPeriod: Ie({
    matchPatterns: Vce,
    defaultMatchWidth: "any",
    parsePatterns: Uce,
    defaultParseWidth: "any"
  })
}, Gce = {
  code: "nl",
  formatDistance: _ce,
  formatLong: Sce,
  formatRelative: Ece,
  localize: Ace,
  match: qce,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, Yce = {
  lessThanXSeconds: {
    one: "menos de um segundo",
    other: "menos de {{count}} segundos"
  },
  xSeconds: {
    one: "1 segundo",
    other: "{{count}} segundos"
  },
  halfAMinute: "meio minuto",
  lessThanXMinutes: {
    one: "menos de um minuto",
    other: "menos de {{count}} minutos"
  },
  xMinutes: {
    one: "1 minuto",
    other: "{{count}} minutos"
  },
  aboutXHours: {
    one: "aproximadamente 1 hora",
    other: "aproximadamente {{count}} horas"
  },
  xHours: {
    one: "1 hora",
    other: "{{count}} horas"
  },
  xDays: {
    one: "1 dia",
    other: "{{count}} dias"
  },
  aboutXWeeks: {
    one: "aproximadamente 1 semana",
    other: "aproximadamente {{count}} semanas"
  },
  xWeeks: {
    one: "1 semana",
    other: "{{count}} semanas"
  },
  aboutXMonths: {
    one: "aproximadamente 1 mês",
    other: "aproximadamente {{count}} meses"
  },
  xMonths: {
    one: "1 mês",
    other: "{{count}} meses"
  },
  aboutXYears: {
    one: "aproximadamente 1 ano",
    other: "aproximadamente {{count}} anos"
  },
  xYears: {
    one: "1 ano",
    other: "{{count}} anos"
  },
  overXYears: {
    one: "mais de 1 ano",
    other: "mais de {{count}} anos"
  },
  almostXYears: {
    one: "quase 1 ano",
    other: "quase {{count}} anos"
  }
}, Zce = function(t, n, r) {
  var o, i = Yce[t];
  return typeof i == "string" ? o = i : n === 1 ? o = i.one : o = i.other.replace("{{count}}", String(n)), r != null && r.addSuffix ? r.comparison && r.comparison > 0 ? "daqui a " + o : "há " + o : o;
}, Xce = {
  full: "EEEE, d 'de' MMMM 'de' y",
  long: "d 'de' MMMM 'de' y",
  medium: "d 'de' MMM 'de' y",
  short: "dd/MM/y"
}, Kce = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, Jce = {
  full: "{{date}} 'às' {{time}}",
  long: "{{date}} 'às' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, Qce = {
  date: rt({
    formats: Xce,
    defaultWidth: "full"
  }),
  time: rt({
    formats: Kce,
    defaultWidth: "full"
  }),
  dateTime: rt({
    formats: Jce,
    defaultWidth: "full"
  })
}, eue = {
  lastWeek: function(t) {
    var n = t.getUTCDay(), r = n === 0 || n === 6 ? "último" : "última";
    return "'" + r + "' eeee 'às' p";
  },
  yesterday: "'ontem às' p",
  today: "'hoje às' p",
  tomorrow: "'amanhã às' p",
  nextWeek: "eeee 'às' p",
  other: "P"
}, tue = function(t, n, r, o) {
  var i = eue[t];
  return typeof i == "function" ? i(n) : i;
}, nue = {
  narrow: ["aC", "dC"],
  abbreviated: ["a.C.", "d.C."],
  wide: ["antes de Cristo", "depois de Cristo"]
}, rue = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["T1", "T2", "T3", "T4"],
  wide: ["1º trimestre", "2º trimestre", "3º trimestre", "4º trimestre"]
}, oue = {
  narrow: ["j", "f", "m", "a", "m", "j", "j", "a", "s", "o", "n", "d"],
  abbreviated: ["jan", "fev", "mar", "abr", "mai", "jun", "jul", "ago", "set", "out", "nov", "dez"],
  wide: ["janeiro", "fevereiro", "março", "abril", "maio", "junho", "julho", "agosto", "setembro", "outubro", "novembro", "dezembro"]
}, iue = {
  narrow: ["d", "s", "t", "q", "q", "s", "s"],
  short: ["dom", "seg", "ter", "qua", "qui", "sex", "sáb"],
  abbreviated: ["dom", "seg", "ter", "qua", "qui", "sex", "sáb"],
  wide: ["domingo", "segunda-feira", "terça-feira", "quarta-feira", "quinta-feira", "sexta-feira", "sábado"]
}, aue = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "meia-noite",
    noon: "meio-dia",
    morning: "manhã",
    afternoon: "tarde",
    evening: "noite",
    night: "madrugada"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "meia-noite",
    noon: "meio-dia",
    morning: "manhã",
    afternoon: "tarde",
    evening: "noite",
    night: "madrugada"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "meia-noite",
    noon: "meio-dia",
    morning: "manhã",
    afternoon: "tarde",
    evening: "noite",
    night: "madrugada"
  }
}, sue = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "meia-noite",
    noon: "meio-dia",
    morning: "da manhã",
    afternoon: "da tarde",
    evening: "da noite",
    night: "da madrugada"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "meia-noite",
    noon: "meio-dia",
    morning: "da manhã",
    afternoon: "da tarde",
    evening: "da noite",
    night: "da madrugada"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "meia-noite",
    noon: "meio-dia",
    morning: "da manhã",
    afternoon: "da tarde",
    evening: "da noite",
    night: "da madrugada"
  }
}, lue = function(t, n) {
  var r = Number(t);
  return r + "º";
}, cue = {
  ordinalNumber: lue,
  era: De({
    values: nue,
    defaultWidth: "wide"
  }),
  quarter: De({
    values: rue,
    defaultWidth: "wide",
    argumentCallback: function(t) {
      return t - 1;
    }
  }),
  month: De({
    values: oue,
    defaultWidth: "wide"
  }),
  day: De({
    values: iue,
    defaultWidth: "wide"
  }),
  dayPeriod: De({
    values: aue,
    defaultWidth: "wide",
    formattingValues: sue,
    defaultFormattingWidth: "wide"
  })
}, uue = /^(\d+)(º|ª)?/i, due = /\d+/i, fue = {
  narrow: /^(ac|dc|a|d)/i,
  abbreviated: /^(a\.?\s?c\.?|a\.?\s?e\.?\s?c\.?|d\.?\s?c\.?|e\.?\s?c\.?)/i,
  wide: /^(antes de cristo|antes da era comum|depois de cristo|era comum)/i
}, pue = {
  any: [/^ac/i, /^dc/i],
  wide: [/^(antes de cristo|antes da era comum)/i, /^(depois de cristo|era comum)/i]
}, hue = {
  narrow: /^[1234]/i,
  abbreviated: /^T[1234]/i,
  wide: /^[1234](º|ª)? trimestre/i
}, mue = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, gue = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|fev|mar|abr|mai|jun|jul|ago|set|out|nov|dez)/i,
  wide: /^(janeiro|fevereiro|março|abril|maio|junho|julho|agosto|setembro|outubro|novembro|dezembro)/i
}, vue = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ab/i, /^mai/i, /^jun/i, /^jul/i, /^ag/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, bue = {
  narrow: /^[dstq]/i,
  short: /^(dom|seg|ter|qua|qui|sex|s[áa]b)/i,
  abbreviated: /^(dom|seg|ter|qua|qui|sex|s[áa]b)/i,
  wide: /^(domingo|segunda-?\s?feira|terça-?\s?feira|quarta-?\s?feira|quinta-?\s?feira|sexta-?\s?feira|s[áa]bado)/i
}, yue = {
  narrow: [/^d/i, /^s/i, /^t/i, /^q/i, /^q/i, /^s/i, /^s/i],
  any: [/^d/i, /^seg/i, /^t/i, /^qua/i, /^qui/i, /^sex/i, /^s[áa]/i]
}, _ue = {
  narrow: /^(a|p|meia-?\s?noite|meio-?\s?dia|(da) (manh[ãa]|tarde|noite|madrugada))/i,
  any: /^([ap]\.?\s?m\.?|meia-?\s?noite|meio-?\s?dia|(da) (manh[ãa]|tarde|noite|madrugada))/i
}, wue = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^meia/i,
    noon: /^meio/i,
    morning: /manh[ãa]/i,
    afternoon: /tarde/i,
    evening: /noite/i,
    night: /madrugada/i
  }
}, xue = {
  ordinalNumber: vo({
    matchPattern: uue,
    parsePattern: due,
    valueCallback: function(t) {
      return parseInt(t, 10);
    }
  }),
  era: Ie({
    matchPatterns: fue,
    defaultMatchWidth: "wide",
    parsePatterns: pue,
    defaultParseWidth: "any"
  }),
  quarter: Ie({
    matchPatterns: hue,
    defaultMatchWidth: "wide",
    parsePatterns: mue,
    defaultParseWidth: "any",
    valueCallback: function(t) {
      return t + 1;
    }
  }),
  month: Ie({
    matchPatterns: gue,
    defaultMatchWidth: "wide",
    parsePatterns: vue,
    defaultParseWidth: "any"
  }),
  day: Ie({
    matchPatterns: bue,
    defaultMatchWidth: "wide",
    parsePatterns: yue,
    defaultParseWidth: "any"
  }),
  dayPeriod: Ie({
    matchPatterns: _ue,
    defaultMatchWidth: "any",
    parsePatterns: wue,
    defaultParseWidth: "any"
  })
}, Cue = {
  code: "pt",
  formatDistance: Zce,
  formatLong: Qce,
  formatRelative: tue,
  localize: cue,
  match: xue,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
function Fu(e, t) {
  if (e.one !== void 0 && t === 1)
    return e.one;
  var n = t % 10, r = t % 100;
  return n === 1 && r !== 11 ? e.singularNominative.replace("{{count}}", String(t)) : n >= 2 && n <= 4 && (r < 10 || r > 20) ? e.singularGenitive.replace("{{count}}", String(t)) : e.pluralGenitive.replace("{{count}}", String(t));
}
function Tr(e) {
  return function(t, n) {
    return n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? e.future ? Fu(e.future, t) : "через " + Fu(e.regular, t) : e.past ? Fu(e.past, t) : Fu(e.regular, t) + " назад" : Fu(e.regular, t);
  };
}
var Sue = {
  lessThanXSeconds: Tr({
    regular: {
      one: "меньше секунды",
      singularNominative: "меньше {{count}} секунды",
      singularGenitive: "меньше {{count}} секунд",
      pluralGenitive: "меньше {{count}} секунд"
    },
    future: {
      one: "меньше, чем через секунду",
      singularNominative: "меньше, чем через {{count}} секунду",
      singularGenitive: "меньше, чем через {{count}} секунды",
      pluralGenitive: "меньше, чем через {{count}} секунд"
    }
  }),
  xSeconds: Tr({
    regular: {
      singularNominative: "{{count}} секунда",
      singularGenitive: "{{count}} секунды",
      pluralGenitive: "{{count}} секунд"
    },
    past: {
      singularNominative: "{{count}} секунду назад",
      singularGenitive: "{{count}} секунды назад",
      pluralGenitive: "{{count}} секунд назад"
    },
    future: {
      singularNominative: "через {{count}} секунду",
      singularGenitive: "через {{count}} секунды",
      pluralGenitive: "через {{count}} секунд"
    }
  }),
  halfAMinute: function(t, n) {
    return n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "через полминуты" : "полминуты назад" : "полминуты";
  },
  lessThanXMinutes: Tr({
    regular: {
      one: "меньше минуты",
      singularNominative: "меньше {{count}} минуты",
      singularGenitive: "меньше {{count}} минут",
      pluralGenitive: "меньше {{count}} минут"
    },
    future: {
      one: "меньше, чем через минуту",
      singularNominative: "меньше, чем через {{count}} минуту",
      singularGenitive: "меньше, чем через {{count}} минуты",
      pluralGenitive: "меньше, чем через {{count}} минут"
    }
  }),
  xMinutes: Tr({
    regular: {
      singularNominative: "{{count}} минута",
      singularGenitive: "{{count}} минуты",
      pluralGenitive: "{{count}} минут"
    },
    past: {
      singularNominative: "{{count}} минуту назад",
      singularGenitive: "{{count}} минуты назад",
      pluralGenitive: "{{count}} минут назад"
    },
    future: {
      singularNominative: "через {{count}} минуту",
      singularGenitive: "через {{count}} минуты",
      pluralGenitive: "через {{count}} минут"
    }
  }),
  aboutXHours: Tr({
    regular: {
      singularNominative: "около {{count}} часа",
      singularGenitive: "около {{count}} часов",
      pluralGenitive: "около {{count}} часов"
    },
    future: {
      singularNominative: "приблизительно через {{count}} час",
      singularGenitive: "приблизительно через {{count}} часа",
      pluralGenitive: "приблизительно через {{count}} часов"
    }
  }),
  xHours: Tr({
    regular: {
      singularNominative: "{{count}} час",
      singularGenitive: "{{count}} часа",
      pluralGenitive: "{{count}} часов"
    }
  }),
  xDays: Tr({
    regular: {
      singularNominative: "{{count}} день",
      singularGenitive: "{{count}} дня",
      pluralGenitive: "{{count}} дней"
    }
  }),
  aboutXWeeks: Tr({
    regular: {
      singularNominative: "около {{count}} недели",
      singularGenitive: "около {{count}} недель",
      pluralGenitive: "около {{count}} недель"
    },
    future: {
      singularNominative: "приблизительно через {{count}} неделю",
      singularGenitive: "приблизительно через {{count}} недели",
      pluralGenitive: "приблизительно через {{count}} недель"
    }
  }),
  xWeeks: Tr({
    regular: {
      singularNominative: "{{count}} неделя",
      singularGenitive: "{{count}} недели",
      pluralGenitive: "{{count}} недель"
    }
  }),
  aboutXMonths: Tr({
    regular: {
      singularNominative: "около {{count}} месяца",
      singularGenitive: "около {{count}} месяцев",
      pluralGenitive: "около {{count}} месяцев"
    },
    future: {
      singularNominative: "приблизительно через {{count}} месяц",
      singularGenitive: "приблизительно через {{count}} месяца",
      pluralGenitive: "приблизительно через {{count}} месяцев"
    }
  }),
  xMonths: Tr({
    regular: {
      singularNominative: "{{count}} месяц",
      singularGenitive: "{{count}} месяца",
      pluralGenitive: "{{count}} месяцев"
    }
  }),
  aboutXYears: Tr({
    regular: {
      singularNominative: "около {{count}} года",
      singularGenitive: "около {{count}} лет",
      pluralGenitive: "около {{count}} лет"
    },
    future: {
      singularNominative: "приблизительно через {{count}} год",
      singularGenitive: "приблизительно через {{count}} года",
      pluralGenitive: "приблизительно через {{count}} лет"
    }
  }),
  xYears: Tr({
    regular: {
      singularNominative: "{{count}} год",
      singularGenitive: "{{count}} года",
      pluralGenitive: "{{count}} лет"
    }
  }),
  overXYears: Tr({
    regular: {
      singularNominative: "больше {{count}} года",
      singularGenitive: "больше {{count}} лет",
      pluralGenitive: "больше {{count}} лет"
    },
    future: {
      singularNominative: "больше, чем через {{count}} год",
      singularGenitive: "больше, чем через {{count}} года",
      pluralGenitive: "больше, чем через {{count}} лет"
    }
  }),
  almostXYears: Tr({
    regular: {
      singularNominative: "почти {{count}} год",
      singularGenitive: "почти {{count}} года",
      pluralGenitive: "почти {{count}} лет"
    },
    future: {
      singularNominative: "почти через {{count}} год",
      singularGenitive: "почти через {{count}} года",
      pluralGenitive: "почти через {{count}} лет"
    }
  })
}, Tue = function(t, n, r) {
  return Sue[t](n, r);
}, Eue = {
  full: "EEEE, d MMMM y 'г.'",
  long: "d MMMM y 'г.'",
  medium: "d MMM y 'г.'",
  short: "dd.MM.y"
}, kue = {
  full: "H:mm:ss zzzz",
  long: "H:mm:ss z",
  medium: "H:mm:ss",
  short: "H:mm"
}, Mue = {
  any: "{{date}}, {{time}}"
}, Rue = {
  date: rt({
    formats: Eue,
    defaultWidth: "full"
  }),
  time: rt({
    formats: kue,
    defaultWidth: "full"
  }),
  dateTime: rt({
    formats: Mue,
    defaultWidth: "any"
  })
}, Dw = ["воскресенье", "понедельник", "вторник", "среду", "четверг", "пятницу", "субботу"];
function Pue(e) {
  var t = Dw[e];
  switch (e) {
    case 0:
      return "'в прошлое " + t + " в' p";
    case 1:
    case 2:
    case 4:
      return "'в прошлый " + t + " в' p";
    case 3:
    case 5:
    case 6:
      return "'в прошлую " + t + " в' p";
  }
}
function lM(e) {
  var t = Dw[e];
  return e === 2 ? "'во " + t + " в' p" : "'в " + t + " в' p";
}
function Oue(e) {
  var t = Dw[e];
  switch (e) {
    case 0:
      return "'в следующее " + t + " в' p";
    case 1:
    case 2:
    case 4:
      return "'в следующий " + t + " в' p";
    case 3:
    case 5:
    case 6:
      return "'в следующую " + t + " в' p";
  }
}
var Nue = {
  lastWeek: function(t, n, r) {
    var o = t.getUTCDay();
    return Qs(t, n, r) ? lM(o) : Pue(o);
  },
  yesterday: "'вчера в' p",
  today: "'сегодня в' p",
  tomorrow: "'завтра в' p",
  nextWeek: function(t, n, r) {
    var o = t.getUTCDay();
    return Qs(t, n, r) ? lM(o) : Oue(o);
  },
  other: "P"
}, Aue = function(t, n, r, o) {
  var i = Nue[t];
  return typeof i == "function" ? i(n, r, o) : i;
}, Due = {
  narrow: ["до н.э.", "н.э."],
  abbreviated: ["до н. э.", "н. э."],
  wide: ["до нашей эры", "нашей эры"]
}, Iue = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["1-й кв.", "2-й кв.", "3-й кв.", "4-й кв."],
  wide: ["1-й квартал", "2-й квартал", "3-й квартал", "4-й квартал"]
}, Lue = {
  narrow: ["Я", "Ф", "М", "А", "М", "И", "И", "А", "С", "О", "Н", "Д"],
  abbreviated: ["янв.", "фев.", "март", "апр.", "май", "июнь", "июль", "авг.", "сент.", "окт.", "нояб.", "дек."],
  wide: ["январь", "февраль", "март", "апрель", "май", "июнь", "июль", "август", "сентябрь", "октябрь", "ноябрь", "декабрь"]
}, $ue = {
  narrow: ["Я", "Ф", "М", "А", "М", "И", "И", "А", "С", "О", "Н", "Д"],
  abbreviated: ["янв.", "фев.", "мар.", "апр.", "мая", "июн.", "июл.", "авг.", "сент.", "окт.", "нояб.", "дек."],
  wide: ["января", "февраля", "марта", "апреля", "мая", "июня", "июля", "августа", "сентября", "октября", "ноября", "декабря"]
}, Fue = {
  narrow: ["В", "П", "В", "С", "Ч", "П", "С"],
  short: ["вс", "пн", "вт", "ср", "чт", "пт", "сб"],
  abbreviated: ["вск", "пнд", "втр", "срд", "чтв", "птн", "суб"],
  wide: ["воскресенье", "понедельник", "вторник", "среда", "четверг", "пятница", "суббота"]
}, zue = {
  narrow: {
    am: "ДП",
    pm: "ПП",
    midnight: "полн.",
    noon: "полд.",
    morning: "утро",
    afternoon: "день",
    evening: "веч.",
    night: "ночь"
  },
  abbreviated: {
    am: "ДП",
    pm: "ПП",
    midnight: "полн.",
    noon: "полд.",
    morning: "утро",
    afternoon: "день",
    evening: "веч.",
    night: "ночь"
  },
  wide: {
    am: "ДП",
    pm: "ПП",
    midnight: "полночь",
    noon: "полдень",
    morning: "утро",
    afternoon: "день",
    evening: "вечер",
    night: "ночь"
  }
}, Bue = {
  narrow: {
    am: "ДП",
    pm: "ПП",
    midnight: "полн.",
    noon: "полд.",
    morning: "утра",
    afternoon: "дня",
    evening: "веч.",
    night: "ночи"
  },
  abbreviated: {
    am: "ДП",
    pm: "ПП",
    midnight: "полн.",
    noon: "полд.",
    morning: "утра",
    afternoon: "дня",
    evening: "веч.",
    night: "ночи"
  },
  wide: {
    am: "ДП",
    pm: "ПП",
    midnight: "полночь",
    noon: "полдень",
    morning: "утра",
    afternoon: "дня",
    evening: "вечера",
    night: "ночи"
  }
}, Hue = function(t, n) {
  var r = Number(t), o = n == null ? void 0 : n.unit, i;
  return o === "date" ? i = "-е" : o === "week" || o === "minute" || o === "second" ? i = "-я" : i = "-й", r + i;
}, jue = {
  ordinalNumber: Hue,
  era: De({
    values: Due,
    defaultWidth: "wide"
  }),
  quarter: De({
    values: Iue,
    defaultWidth: "wide",
    argumentCallback: function(t) {
      return t - 1;
    }
  }),
  month: De({
    values: Lue,
    defaultWidth: "wide",
    formattingValues: $ue,
    defaultFormattingWidth: "wide"
  }),
  day: De({
    values: Fue,
    defaultWidth: "wide"
  }),
  dayPeriod: De({
    values: zue,
    defaultWidth: "any",
    formattingValues: Bue,
    defaultFormattingWidth: "wide"
  })
}, Wue = /^(\d+)(-?(е|я|й|ое|ье|ая|ья|ый|ой|ий|ый))?/i, Vue = /\d+/i, Uue = {
  narrow: /^((до )?н\.?\s?э\.?)/i,
  abbreviated: /^((до )?н\.?\s?э\.?)/i,
  wide: /^(до нашей эры|нашей эры|наша эра)/i
}, que = {
  any: [/^д/i, /^н/i]
}, Gue = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234](-?[ыои]?й?)? кв.?/i,
  wide: /^[1234](-?[ыои]?й?)? квартал/i
}, Yue = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Zue = {
  narrow: /^[яфмаисонд]/i,
  abbreviated: /^(янв|фев|март?|апр|ма[йя]|июн[ья]?|июл[ья]?|авг|сент?|окт|нояб?|дек)\.?/i,
  wide: /^(январ[ья]|феврал[ья]|марта?|апрел[ья]|ма[йя]|июн[ья]|июл[ья]|августа?|сентябр[ья]|октябр[ья]|октябр[ья]|ноябр[ья]|декабр[ья])/i
}, Xue = {
  narrow: [/^я/i, /^ф/i, /^м/i, /^а/i, /^м/i, /^и/i, /^и/i, /^а/i, /^с/i, /^о/i, /^н/i, /^я/i],
  any: [/^я/i, /^ф/i, /^мар/i, /^ап/i, /^ма[йя]/i, /^июн/i, /^июл/i, /^ав/i, /^с/i, /^о/i, /^н/i, /^д/i]
}, Kue = {
  narrow: /^[впсч]/i,
  short: /^(вс|во|пн|по|вт|ср|чт|че|пт|пя|сб|су)\.?/i,
  abbreviated: /^(вск|вос|пнд|пон|втр|вто|срд|сре|чтв|чет|птн|пят|суб).?/i,
  wide: /^(воскресень[ея]|понедельника?|вторника?|сред[аы]|четверга?|пятниц[аы]|суббот[аы])/i
}, Jue = {
  narrow: [/^в/i, /^п/i, /^в/i, /^с/i, /^ч/i, /^п/i, /^с/i],
  any: [/^в[ос]/i, /^п[он]/i, /^в/i, /^ср/i, /^ч/i, /^п[ят]/i, /^с[уб]/i]
}, Que = {
  narrow: /^([дп]п|полн\.?|полд\.?|утр[оа]|день|дня|веч\.?|ноч[ьи])/i,
  abbreviated: /^([дп]п|полн\.?|полд\.?|утр[оа]|день|дня|веч\.?|ноч[ьи])/i,
  wide: /^([дп]п|полночь|полдень|утр[оа]|день|дня|вечера?|ноч[ьи])/i
}, ede = {
  any: {
    am: /^дп/i,
    pm: /^пп/i,
    midnight: /^полн/i,
    noon: /^полд/i,
    morning: /^у/i,
    afternoon: /^д[ен]/i,
    evening: /^в/i,
    night: /^н/i
  }
}, tde = {
  ordinalNumber: vo({
    matchPattern: Wue,
    parsePattern: Vue,
    valueCallback: function(t) {
      return parseInt(t, 10);
    }
  }),
  era: Ie({
    matchPatterns: Uue,
    defaultMatchWidth: "wide",
    parsePatterns: que,
    defaultParseWidth: "any"
  }),
  quarter: Ie({
    matchPatterns: Gue,
    defaultMatchWidth: "wide",
    parsePatterns: Yue,
    defaultParseWidth: "any",
    valueCallback: function(t) {
      return t + 1;
    }
  }),
  month: Ie({
    matchPatterns: Zue,
    defaultMatchWidth: "wide",
    parsePatterns: Xue,
    defaultParseWidth: "any"
  }),
  day: Ie({
    matchPatterns: Kue,
    defaultMatchWidth: "wide",
    parsePatterns: Jue,
    defaultParseWidth: "any"
  }),
  dayPeriod: Ie({
    matchPatterns: Que,
    defaultMatchWidth: "wide",
    parsePatterns: ede,
    defaultParseWidth: "any"
  })
}, nde = {
  code: "ru",
  formatDistance: Tue,
  formatLong: Rue,
  formatRelative: Aue,
  localize: jue,
  match: tde,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
}, rde = {
  lessThanXSeconds: {
    one: "bir saniyeden az",
    other: "{{count}} saniyeden az"
  },
  xSeconds: {
    one: "1 saniye",
    other: "{{count}} saniye"
  },
  halfAMinute: "yarım dakika",
  lessThanXMinutes: {
    one: "bir dakikadan az",
    other: "{{count}} dakikadan az"
  },
  xMinutes: {
    one: "1 dakika",
    other: "{{count}} dakika"
  },
  aboutXHours: {
    one: "yaklaşık 1 saat",
    other: "yaklaşık {{count}} saat"
  },
  xHours: {
    one: "1 saat",
    other: "{{count}} saat"
  },
  xDays: {
    one: "1 gün",
    other: "{{count}} gün"
  },
  aboutXWeeks: {
    one: "yaklaşık 1 hafta",
    other: "yaklaşık {{count}} hafta"
  },
  xWeeks: {
    one: "1 hafta",
    other: "{{count}} hafta"
  },
  aboutXMonths: {
    one: "yaklaşık 1 ay",
    other: "yaklaşık {{count}} ay"
  },
  xMonths: {
    one: "1 ay",
    other: "{{count}} ay"
  },
  aboutXYears: {
    one: "yaklaşık 1 yıl",
    other: "yaklaşık {{count}} yıl"
  },
  xYears: {
    one: "1 yıl",
    other: "{{count}} yıl"
  },
  overXYears: {
    one: "1 yıldan fazla",
    other: "{{count}} yıldan fazla"
  },
  almostXYears: {
    one: "neredeyse 1 yıl",
    other: "neredeyse {{count}} yıl"
  }
}, ode = function(t, n, r) {
  var o, i = rde[t];
  return typeof i == "string" ? o = i : n === 1 ? o = i.one : o = i.other.replace("{{count}}", n.toString()), r != null && r.addSuffix ? r.comparison && r.comparison > 0 ? o + " sonra" : o + " önce" : o;
}, ide = {
  full: "d MMMM y EEEE",
  long: "d MMMM y",
  medium: "d MMM y",
  short: "dd.MM.yyyy"
}, ade = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, sde = {
  full: "{{date}} 'saat' {{time}}",
  long: "{{date}} 'saat' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, lde = {
  date: rt({
    formats: ide,
    defaultWidth: "full"
  }),
  time: rt({
    formats: ade,
    defaultWidth: "full"
  }),
  dateTime: rt({
    formats: sde,
    defaultWidth: "full"
  })
}, cde = {
  lastWeek: "'geçen hafta' eeee 'saat' p",
  yesterday: "'dün saat' p",
  today: "'bugün saat' p",
  tomorrow: "'yarın saat' p",
  nextWeek: "eeee 'saat' p",
  other: "P"
}, ude = function(t, n, r, o) {
  return cde[t];
}, dde = {
  narrow: ["MÖ", "MS"],
  abbreviated: ["MÖ", "MS"],
  wide: ["Milattan Önce", "Milattan Sonra"]
}, fde = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["1Ç", "2Ç", "3Ç", "4Ç"],
  wide: ["İlk çeyrek", "İkinci Çeyrek", "Üçüncü çeyrek", "Son çeyrek"]
}, pde = {
  narrow: ["O", "Ş", "M", "N", "M", "H", "T", "A", "E", "E", "K", "A"],
  abbreviated: ["Oca", "Şub", "Mar", "Nis", "May", "Haz", "Tem", "Ağu", "Eyl", "Eki", "Kas", "Ara"],
  wide: ["Ocak", "Şubat", "Mart", "Nisan", "Mayıs", "Haziran", "Temmuz", "Ağustos", "Eylül", "Ekim", "Kasım", "Aralık"]
}, hde = {
  narrow: ["P", "P", "S", "Ç", "P", "C", "C"],
  short: ["Pz", "Pt", "Sa", "Ça", "Pe", "Cu", "Ct"],
  abbreviated: ["Paz", "Pzt", "Sal", "Çar", "Per", "Cum", "Cts"],
  wide: ["Pazar", "Pazartesi", "Salı", "Çarşamba", "Perşembe", "Cuma", "Cumartesi"]
}, mde = {
  narrow: {
    am: "öö",
    pm: "ös",
    midnight: "gy",
    noon: "ö",
    morning: "sa",
    afternoon: "ös",
    evening: "ak",
    night: "ge"
  },
  abbreviated: {
    am: "ÖÖ",
    pm: "ÖS",
    midnight: "gece yarısı",
    noon: "öğle",
    morning: "sabah",
    afternoon: "öğleden sonra",
    evening: "akşam",
    night: "gece"
  },
  wide: {
    am: "Ö.Ö.",
    pm: "Ö.S.",
    midnight: "gece yarısı",
    noon: "öğle",
    morning: "sabah",
    afternoon: "öğleden sonra",
    evening: "akşam",
    night: "gece"
  }
}, gde = {
  narrow: {
    am: "öö",
    pm: "ös",
    midnight: "gy",
    noon: "ö",
    morning: "sa",
    afternoon: "ös",
    evening: "ak",
    night: "ge"
  },
  abbreviated: {
    am: "ÖÖ",
    pm: "ÖS",
    midnight: "gece yarısı",
    noon: "öğlen",
    morning: "sabahleyin",
    afternoon: "öğleden sonra",
    evening: "akşamleyin",
    night: "geceleyin"
  },
  wide: {
    am: "ö.ö.",
    pm: "ö.s.",
    midnight: "gece yarısı",
    noon: "öğlen",
    morning: "sabahleyin",
    afternoon: "öğleden sonra",
    evening: "akşamleyin",
    night: "geceleyin"
  }
}, vde = function(t, n) {
  var r = Number(t);
  return r + ".";
}, bde = {
  ordinalNumber: vde,
  era: De({
    values: dde,
    defaultWidth: "wide"
  }),
  quarter: De({
    values: fde,
    defaultWidth: "wide",
    argumentCallback: function(t) {
      return Number(t) - 1;
    }
  }),
  month: De({
    values: pde,
    defaultWidth: "wide"
  }),
  day: De({
    values: hde,
    defaultWidth: "wide"
  }),
  dayPeriod: De({
    values: mde,
    defaultWidth: "wide",
    formattingValues: gde,
    defaultFormattingWidth: "wide"
  })
}, yde = /^(\d+)(\.)?/i, _de = /\d+/i, wde = {
  narrow: /^(mö|ms)/i,
  abbreviated: /^(mö|ms)/i,
  wide: /^(milattan önce|milattan sonra)/i
}, xde = {
  any: [/(^mö|^milattan önce)/i, /(^ms|^milattan sonra)/i]
}, Cde = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234]ç/i,
  wide: /^((i|İ)lk|(i|İ)kinci|üçüncü|son) çeyrek/i
}, Sde = {
  any: [/1/i, /2/i, /3/i, /4/i],
  abbreviated: [/1ç/i, /2ç/i, /3ç/i, /4ç/i],
  wide: [/^(i|İ)lk çeyrek/i, /(i|İ)kinci çeyrek/i, /üçüncü çeyrek/i, /son çeyrek/i]
}, Tde = {
  narrow: /^[oşmnhtaek]/i,
  abbreviated: /^(oca|şub|mar|nis|may|haz|tem|ağu|eyl|eki|kas|ara)/i,
  wide: /^(ocak|şubat|mart|nisan|mayıs|haziran|temmuz|ağustos|eylül|ekim|kasım|aralık)/i
}, Ede = {
  narrow: [/^o/i, /^ş/i, /^m/i, /^n/i, /^m/i, /^h/i, /^t/i, /^a/i, /^e/i, /^e/i, /^k/i, /^a/i],
  any: [/^o/i, /^ş/i, /^mar/i, /^n/i, /^may/i, /^h/i, /^t/i, /^ağ/i, /^ey/i, /^ek/i, /^k/i, /^ar/i]
}, kde = {
  narrow: /^[psçc]/i,
  short: /^(pz|pt|sa|ça|pe|cu|ct)/i,
  abbreviated: /^(paz|pzt|sal|çar|per|cum|cts)/i,
  wide: /^(pazar(?!tesi)|pazartesi|salı|çarşamba|perşembe|cuma(?!rtesi)|cumartesi)/i
}, Mde = {
  narrow: [/^p/i, /^p/i, /^s/i, /^ç/i, /^p/i, /^c/i, /^c/i],
  any: [/^pz/i, /^pt/i, /^sa/i, /^ça/i, /^pe/i, /^cu/i, /^ct/i],
  wide: [/^pazar(?!tesi)/i, /^pazartesi/i, /^salı/i, /^çarşamba/i, /^perşembe/i, /^cuma(?!rtesi)/i, /^cumartesi/i]
}, Rde = {
  narrow: /^(öö|ös|gy|ö|sa|ös|ak|ge)/i,
  any: /^(ö\.?\s?[ös]\.?|öğleden sonra|gece yarısı|öğle|(sabah|öğ|akşam|gece)(leyin))/i
}, Pde = {
  any: {
    am: /^ö\.?ö\.?/i,
    pm: /^ö\.?s\.?/i,
    midnight: /^(gy|gece yarısı)/i,
    noon: /^öğ/i,
    morning: /^sa/i,
    afternoon: /^öğleden sonra/i,
    evening: /^ak/i,
    night: /^ge/i
  }
}, Ode = {
  ordinalNumber: vo({
    matchPattern: yde,
    parsePattern: _de,
    valueCallback: function(t) {
      return parseInt(t, 10);
    }
  }),
  era: Ie({
    matchPatterns: wde,
    defaultMatchWidth: "wide",
    parsePatterns: xde,
    defaultParseWidth: "any"
  }),
  quarter: Ie({
    matchPatterns: Cde,
    defaultMatchWidth: "wide",
    parsePatterns: Sde,
    defaultParseWidth: "any",
    valueCallback: function(t) {
      return t + 1;
    }
  }),
  month: Ie({
    matchPatterns: Tde,
    defaultMatchWidth: "wide",
    parsePatterns: Ede,
    defaultParseWidth: "any"
  }),
  day: Ie({
    matchPatterns: kde,
    defaultMatchWidth: "wide",
    parsePatterns: Mde,
    defaultParseWidth: "any"
  }),
  dayPeriod: Ie({
    matchPatterns: Rde,
    defaultMatchWidth: "any",
    parsePatterns: Pde,
    defaultParseWidth: "any"
  })
}, Nde = {
  code: "tr",
  formatDistance: ode,
  formatLong: lde,
  formatRelative: ude,
  localize: bde,
  match: Ode,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
};
function zu(e, t) {
  if (e.one !== void 0 && t === 1)
    return e.one;
  var n = t % 10, r = t % 100;
  return n === 1 && r !== 11 ? e.singularNominative.replace("{{count}}", String(t)) : n >= 2 && n <= 4 && (r < 10 || r > 20) ? e.singularGenitive.replace("{{count}}", String(t)) : e.pluralGenitive.replace("{{count}}", String(t));
}
function Er(e) {
  return function(t, n) {
    return n && n.addSuffix ? n.comparison && n.comparison > 0 ? e.future ? zu(e.future, t) : "за " + zu(e.regular, t) : e.past ? zu(e.past, t) : zu(e.regular, t) + " тому" : zu(e.regular, t);
  };
}
var Ade = function(t, n) {
  return n && n.addSuffix ? n.comparison && n.comparison > 0 ? "за півхвилини" : "півхвилини тому" : "півхвилини";
}, Dde = {
  lessThanXSeconds: Er({
    regular: {
      one: "менше секунди",
      singularNominative: "менше {{count}} секунди",
      singularGenitive: "менше {{count}} секунд",
      pluralGenitive: "менше {{count}} секунд"
    },
    future: {
      one: "менше, ніж за секунду",
      singularNominative: "менше, ніж за {{count}} секунду",
      singularGenitive: "менше, ніж за {{count}} секунди",
      pluralGenitive: "менше, ніж за {{count}} секунд"
    }
  }),
  xSeconds: Er({
    regular: {
      singularNominative: "{{count}} секунда",
      singularGenitive: "{{count}} секунди",
      pluralGenitive: "{{count}} секунд"
    },
    past: {
      singularNominative: "{{count}} секунду тому",
      singularGenitive: "{{count}} секунди тому",
      pluralGenitive: "{{count}} секунд тому"
    },
    future: {
      singularNominative: "за {{count}} секунду",
      singularGenitive: "за {{count}} секунди",
      pluralGenitive: "за {{count}} секунд"
    }
  }),
  halfAMinute: Ade,
  lessThanXMinutes: Er({
    regular: {
      one: "менше хвилини",
      singularNominative: "менше {{count}} хвилини",
      singularGenitive: "менше {{count}} хвилин",
      pluralGenitive: "менше {{count}} хвилин"
    },
    future: {
      one: "менше, ніж за хвилину",
      singularNominative: "менше, ніж за {{count}} хвилину",
      singularGenitive: "менше, ніж за {{count}} хвилини",
      pluralGenitive: "менше, ніж за {{count}} хвилин"
    }
  }),
  xMinutes: Er({
    regular: {
      singularNominative: "{{count}} хвилина",
      singularGenitive: "{{count}} хвилини",
      pluralGenitive: "{{count}} хвилин"
    },
    past: {
      singularNominative: "{{count}} хвилину тому",
      singularGenitive: "{{count}} хвилини тому",
      pluralGenitive: "{{count}} хвилин тому"
    },
    future: {
      singularNominative: "за {{count}} хвилину",
      singularGenitive: "за {{count}} хвилини",
      pluralGenitive: "за {{count}} хвилин"
    }
  }),
  aboutXHours: Er({
    regular: {
      singularNominative: "близько {{count}} години",
      singularGenitive: "близько {{count}} годин",
      pluralGenitive: "близько {{count}} годин"
    },
    future: {
      singularNominative: "приблизно за {{count}} годину",
      singularGenitive: "приблизно за {{count}} години",
      pluralGenitive: "приблизно за {{count}} годин"
    }
  }),
  xHours: Er({
    regular: {
      singularNominative: "{{count}} годину",
      singularGenitive: "{{count}} години",
      pluralGenitive: "{{count}} годин"
    }
  }),
  xDays: Er({
    regular: {
      singularNominative: "{{count}} день",
      singularGenitive: "{{count}} днi",
      pluralGenitive: "{{count}} днів"
    }
  }),
  aboutXWeeks: Er({
    regular: {
      singularNominative: "близько {{count}} тижня",
      singularGenitive: "близько {{count}} тижнів",
      pluralGenitive: "близько {{count}} тижнів"
    },
    future: {
      singularNominative: "приблизно за {{count}} тиждень",
      singularGenitive: "приблизно за {{count}} тижні",
      pluralGenitive: "приблизно за {{count}} тижнів"
    }
  }),
  xWeeks: Er({
    regular: {
      singularNominative: "{{count}} тиждень",
      singularGenitive: "{{count}} тижні",
      pluralGenitive: "{{count}} тижнів"
    }
  }),
  aboutXMonths: Er({
    regular: {
      singularNominative: "близько {{count}} місяця",
      singularGenitive: "близько {{count}} місяців",
      pluralGenitive: "близько {{count}} місяців"
    },
    future: {
      singularNominative: "приблизно за {{count}} місяць",
      singularGenitive: "приблизно за {{count}} місяці",
      pluralGenitive: "приблизно за {{count}} місяців"
    }
  }),
  xMonths: Er({
    regular: {
      singularNominative: "{{count}} місяць",
      singularGenitive: "{{count}} місяці",
      pluralGenitive: "{{count}} місяців"
    }
  }),
  aboutXYears: Er({
    regular: {
      singularNominative: "близько {{count}} року",
      singularGenitive: "близько {{count}} років",
      pluralGenitive: "близько {{count}} років"
    },
    future: {
      singularNominative: "приблизно за {{count}} рік",
      singularGenitive: "приблизно за {{count}} роки",
      pluralGenitive: "приблизно за {{count}} років"
    }
  }),
  xYears: Er({
    regular: {
      singularNominative: "{{count}} рік",
      singularGenitive: "{{count}} роки",
      pluralGenitive: "{{count}} років"
    }
  }),
  overXYears: Er({
    regular: {
      singularNominative: "більше {{count}} року",
      singularGenitive: "більше {{count}} років",
      pluralGenitive: "більше {{count}} років"
    },
    future: {
      singularNominative: "більше, ніж за {{count}} рік",
      singularGenitive: "більше, ніж за {{count}} роки",
      pluralGenitive: "більше, ніж за {{count}} років"
    }
  }),
  almostXYears: Er({
    regular: {
      singularNominative: "майже {{count}} рік",
      singularGenitive: "майже {{count}} роки",
      pluralGenitive: "майже {{count}} років"
    },
    future: {
      singularNominative: "майже за {{count}} рік",
      singularGenitive: "майже за {{count}} роки",
      pluralGenitive: "майже за {{count}} років"
    }
  })
}, Ide = function(t, n, r) {
  return r = r || {}, Dde[t](n, r);
}, Lde = {
  full: "EEEE, do MMMM y 'р.'",
  long: "do MMMM y 'р.'",
  medium: "d MMM y 'р.'",
  short: "dd.MM.y"
}, $de = {
  full: "H:mm:ss zzzz",
  long: "H:mm:ss z",
  medium: "H:mm:ss",
  short: "H:mm"
}, Fde = {
  full: "{{date}} 'о' {{time}}",
  long: "{{date}} 'о' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, zde = {
  date: rt({
    formats: Lde,
    defaultWidth: "full"
  }),
  time: rt({
    formats: $de,
    defaultWidth: "full"
  }),
  dateTime: rt({
    formats: Fde,
    defaultWidth: "full"
  })
}, Iw = ["неділю", "понеділок", "вівторок", "середу", "четвер", "п’ятницю", "суботу"];
function Bde(e) {
  var t = Iw[e];
  switch (e) {
    case 0:
    case 3:
    case 5:
    case 6:
      return "'у минулу " + t + " о' p";
    case 1:
    case 2:
    case 4:
      return "'у минулий " + t + " о' p";
  }
}
function JD(e) {
  var t = Iw[e];
  return "'у " + t + " о' p";
}
function Hde(e) {
  var t = Iw[e];
  switch (e) {
    case 0:
    case 3:
    case 5:
    case 6:
      return "'у наступну " + t + " о' p";
    case 1:
    case 2:
    case 4:
      return "'у наступний " + t + " о' p";
  }
}
var jde = function(t, n, r) {
  var o = cl(t), i = o.getUTCDay();
  return Qs(o, n, r) ? JD(i) : Bde(i);
}, Wde = function(t, n, r) {
  var o = cl(t), i = o.getUTCDay();
  return Qs(o, n, r) ? JD(i) : Hde(i);
}, Vde = {
  lastWeek: jde,
  yesterday: "'вчора о' p",
  today: "'сьогодні о' p",
  tomorrow: "'завтра о' p",
  nextWeek: Wde,
  other: "P"
}, Ude = function(t, n, r, o) {
  var i = Vde[t];
  return typeof i == "function" ? i(n, r, o) : i;
}, qde = {
  narrow: ["до н.е.", "н.е."],
  abbreviated: ["до н. е.", "н. е."],
  wide: ["до нашої ери", "нашої ери"]
}, Gde = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["1-й кв.", "2-й кв.", "3-й кв.", "4-й кв."],
  wide: ["1-й квартал", "2-й квартал", "3-й квартал", "4-й квартал"]
}, Yde = {
  // ДСТУ 3582:2013
  narrow: ["С", "Л", "Б", "К", "Т", "Ч", "Л", "С", "В", "Ж", "Л", "Г"],
  abbreviated: ["січ.", "лют.", "берез.", "квіт.", "трав.", "черв.", "лип.", "серп.", "верес.", "жовт.", "листоп.", "груд."],
  wide: ["січень", "лютий", "березень", "квітень", "травень", "червень", "липень", "серпень", "вересень", "жовтень", "листопад", "грудень"]
}, Zde = {
  narrow: ["С", "Л", "Б", "К", "Т", "Ч", "Л", "С", "В", "Ж", "Л", "Г"],
  abbreviated: ["січ.", "лют.", "берез.", "квіт.", "трав.", "черв.", "лип.", "серп.", "верес.", "жовт.", "листоп.", "груд."],
  wide: ["січня", "лютого", "березня", "квітня", "травня", "червня", "липня", "серпня", "вересня", "жовтня", "листопада", "грудня"]
}, Xde = {
  narrow: ["Н", "П", "В", "С", "Ч", "П", "С"],
  short: ["нд", "пн", "вт", "ср", "чт", "пт", "сб"],
  abbreviated: ["нед", "пон", "вів", "сер", "чтв", "птн", "суб"],
  wide: ["неділя", "понеділок", "вівторок", "середа", "четвер", "п’ятниця", "субота"]
}, Kde = {
  narrow: {
    am: "ДП",
    pm: "ПП",
    midnight: "півн.",
    noon: "пол.",
    morning: "ранок",
    afternoon: "день",
    evening: "веч.",
    night: "ніч"
  },
  abbreviated: {
    am: "ДП",
    pm: "ПП",
    midnight: "півн.",
    noon: "пол.",
    morning: "ранок",
    afternoon: "день",
    evening: "веч.",
    night: "ніч"
  },
  wide: {
    am: "ДП",
    pm: "ПП",
    midnight: "північ",
    noon: "полудень",
    morning: "ранок",
    afternoon: "день",
    evening: "вечір",
    night: "ніч"
  }
}, Jde = {
  narrow: {
    am: "ДП",
    pm: "ПП",
    midnight: "півн.",
    noon: "пол.",
    morning: "ранку",
    afternoon: "дня",
    evening: "веч.",
    night: "ночі"
  },
  abbreviated: {
    am: "ДП",
    pm: "ПП",
    midnight: "півн.",
    noon: "пол.",
    morning: "ранку",
    afternoon: "дня",
    evening: "веч.",
    night: "ночі"
  },
  wide: {
    am: "ДП",
    pm: "ПП",
    midnight: "північ",
    noon: "полудень",
    morning: "ранку",
    afternoon: "дня",
    evening: "веч.",
    night: "ночі"
  }
}, Qde = function(t, n) {
  var r = String(n == null ? void 0 : n.unit), o = Number(t), i;
  return r === "date" ? o === 3 || o === 23 ? i = "-є" : i = "-е" : r === "minute" || r === "second" || r === "hour" ? i = "-а" : i = "-й", o + i;
}, efe = {
  ordinalNumber: Qde,
  era: De({
    values: qde,
    defaultWidth: "wide"
  }),
  quarter: De({
    values: Gde,
    defaultWidth: "wide",
    argumentCallback: function(t) {
      return t - 1;
    }
  }),
  month: De({
    values: Yde,
    defaultWidth: "wide",
    formattingValues: Zde,
    defaultFormattingWidth: "wide"
  }),
  day: De({
    values: Xde,
    defaultWidth: "wide"
  }),
  dayPeriod: De({
    values: Kde,
    defaultWidth: "any",
    formattingValues: Jde,
    defaultFormattingWidth: "wide"
  })
}, tfe = /^(\d+)(-?(е|й|є|а|я))?/i, nfe = /\d+/i, rfe = {
  narrow: /^((до )?н\.?\s?е\.?)/i,
  abbreviated: /^((до )?н\.?\s?е\.?)/i,
  wide: /^(до нашої ери|нашої ери|наша ера)/i
}, ofe = {
  any: [/^д/i, /^н/i]
}, ife = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234](-?[иі]?й?)? кв.?/i,
  wide: /^[1234](-?[иі]?й?)? квартал/i
}, afe = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, sfe = {
  narrow: /^[слбктчвжг]/i,
  abbreviated: /^(січ|лют|бер(ез)?|квіт|трав|черв|лип|серп|вер(ес)?|жовт|лис(топ)?|груд)\.?/i,
  wide: /^(січень|січня|лютий|лютого|березень|березня|квітень|квітня|травень|травня|червня|червень|липень|липня|серпень|серпня|вересень|вересня|жовтень|жовтня|листопад[а]?|грудень|грудня)/i
}, lfe = {
  narrow: [/^с/i, /^л/i, /^б/i, /^к/i, /^т/i, /^ч/i, /^л/i, /^с/i, /^в/i, /^ж/i, /^л/i, /^г/i],
  any: [/^сі/i, /^лю/i, /^б/i, /^к/i, /^т/i, /^ч/i, /^лип/i, /^се/i, /^в/i, /^ж/i, /^лис/i, /^г/i]
}, cfe = {
  narrow: /^[нпвсч]/i,
  short: /^(нд|пн|вт|ср|чт|пт|сб)\.?/i,
  abbreviated: /^(нед|пон|вів|сер|че?тв|птн?|суб)\.?/i,
  wide: /^(неділ[яі]|понеділ[ок][ка]|вівтор[ок][ка]|серед[аи]|четвер(га)?|п\W*?ятниц[яі]|субот[аи])/i
}, ufe = {
  narrow: [/^н/i, /^п/i, /^в/i, /^с/i, /^ч/i, /^п/i, /^с/i],
  any: [/^н/i, /^п[он]/i, /^в/i, /^с[ер]/i, /^ч/i, /^п\W*?[ят]/i, /^с[уб]/i]
}, dfe = {
  narrow: /^([дп]п|півн\.?|пол\.?|ранок|ранку|день|дня|веч\.?|ніч|ночі)/i,
  abbreviated: /^([дп]п|півн\.?|пол\.?|ранок|ранку|день|дня|веч\.?|ніч|ночі)/i,
  wide: /^([дп]п|північ|полудень|ранок|ранку|день|дня|вечір|вечора|ніч|ночі)/i
}, ffe = {
  any: {
    am: /^дп/i,
    pm: /^пп/i,
    midnight: /^півн/i,
    noon: /^пол/i,
    morning: /^р/i,
    afternoon: /^д[ен]/i,
    evening: /^в/i,
    night: /^н/i
  }
}, pfe = {
  ordinalNumber: vo({
    matchPattern: tfe,
    parsePattern: nfe,
    valueCallback: function(t) {
      return parseInt(t, 10);
    }
  }),
  era: Ie({
    matchPatterns: rfe,
    defaultMatchWidth: "wide",
    parsePatterns: ofe,
    defaultParseWidth: "any"
  }),
  quarter: Ie({
    matchPatterns: ife,
    defaultMatchWidth: "wide",
    parsePatterns: afe,
    defaultParseWidth: "any",
    valueCallback: function(t) {
      return t + 1;
    }
  }),
  month: Ie({
    matchPatterns: sfe,
    defaultMatchWidth: "wide",
    parsePatterns: lfe,
    defaultParseWidth: "any"
  }),
  day: Ie({
    matchPatterns: cfe,
    defaultMatchWidth: "wide",
    parsePatterns: ufe,
    defaultParseWidth: "any"
  }),
  dayPeriod: Ie({
    matchPatterns: dfe,
    defaultMatchWidth: "wide",
    parsePatterns: ffe,
    defaultParseWidth: "any"
  })
}, hfe = {
  code: "uk",
  formatDistance: Ide,
  formatLong: zde,
  formatRelative: Ude,
  localize: efe,
  match: pfe,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
}, mfe = {
  lessThanXSeconds: {
    one: "不到 1 秒",
    other: "不到 {{count}} 秒"
  },
  xSeconds: {
    one: "1 秒",
    other: "{{count}} 秒"
  },
  halfAMinute: "半分钟",
  lessThanXMinutes: {
    one: "不到 1 分钟",
    other: "不到 {{count}} 分钟"
  },
  xMinutes: {
    one: "1 分钟",
    other: "{{count}} 分钟"
  },
  xHours: {
    one: "1 小时",
    other: "{{count}} 小时"
  },
  aboutXHours: {
    one: "大约 1 小时",
    other: "大约 {{count}} 小时"
  },
  xDays: {
    one: "1 天",
    other: "{{count}} 天"
  },
  aboutXWeeks: {
    one: "大约 1 个星期",
    other: "大约 {{count}} 个星期"
  },
  xWeeks: {
    one: "1 个星期",
    other: "{{count}} 个星期"
  },
  aboutXMonths: {
    one: "大约 1 个月",
    other: "大约 {{count}} 个月"
  },
  xMonths: {
    one: "1 个月",
    other: "{{count}} 个月"
  },
  aboutXYears: {
    one: "大约 1 年",
    other: "大约 {{count}} 年"
  },
  xYears: {
    one: "1 年",
    other: "{{count}} 年"
  },
  overXYears: {
    one: "超过 1 年",
    other: "超过 {{count}} 年"
  },
  almostXYears: {
    one: "将近 1 年",
    other: "将近 {{count}} 年"
  }
}, gfe = function(t, n, r) {
  var o, i = mfe[t];
  return typeof i == "string" ? o = i : n === 1 ? o = i.one : o = i.other.replace("{{count}}", String(n)), r != null && r.addSuffix ? r.comparison && r.comparison > 0 ? o + "内" : o + "前" : o;
}, vfe = {
  full: "y'年'M'月'd'日' EEEE",
  long: "y'年'M'月'd'日'",
  medium: "yyyy-MM-dd",
  short: "yy-MM-dd"
}, bfe = {
  full: "zzzz a h:mm:ss",
  long: "z a h:mm:ss",
  medium: "a h:mm:ss",
  short: "a h:mm"
}, yfe = {
  full: "{{date}} {{time}}",
  long: "{{date}} {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, _fe = {
  date: rt({
    formats: vfe,
    defaultWidth: "full"
  }),
  time: rt({
    formats: bfe,
    defaultWidth: "full"
  }),
  dateTime: rt({
    formats: yfe,
    defaultWidth: "full"
  })
};
function cM(e, t, n) {
  var r = "eeee p";
  return Qs(e, t, n) ? r : e.getTime() > t.getTime() ? "'下个'" + r : "'上个'" + r;
}
var wfe = {
  lastWeek: cM,
  // days before yesterday, maybe in this week or last week
  yesterday: "'昨天' p",
  today: "'今天' p",
  tomorrow: "'明天' p",
  nextWeek: cM,
  // days after tomorrow, maybe in this week or next week
  other: "PP p"
}, xfe = function(t, n, r, o) {
  var i = wfe[t];
  return typeof i == "function" ? i(n, r, o) : i;
}, Cfe = {
  narrow: ["前", "公元"],
  abbreviated: ["前", "公元"],
  wide: ["公元前", "公元"]
}, Sfe = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["第一季", "第二季", "第三季", "第四季"],
  wide: ["第一季度", "第二季度", "第三季度", "第四季度"]
}, Tfe = {
  narrow: ["一", "二", "三", "四", "五", "六", "七", "八", "九", "十", "十一", "十二"],
  abbreviated: ["1月", "2月", "3月", "4月", "5月", "6月", "7月", "8月", "9月", "10月", "11月", "12月"],
  wide: ["一月", "二月", "三月", "四月", "五月", "六月", "七月", "八月", "九月", "十月", "十一月", "十二月"]
}, Efe = {
  narrow: ["日", "一", "二", "三", "四", "五", "六"],
  short: ["日", "一", "二", "三", "四", "五", "六"],
  abbreviated: ["周日", "周一", "周二", "周三", "周四", "周五", "周六"],
  wide: ["星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"]
}, kfe = {
  narrow: {
    am: "上",
    pm: "下",
    midnight: "凌晨",
    noon: "午",
    morning: "早",
    afternoon: "下午",
    evening: "晚",
    night: "夜"
  },
  abbreviated: {
    am: "上午",
    pm: "下午",
    midnight: "凌晨",
    noon: "中午",
    morning: "早晨",
    afternoon: "中午",
    evening: "晚上",
    night: "夜间"
  },
  wide: {
    am: "上午",
    pm: "下午",
    midnight: "凌晨",
    noon: "中午",
    morning: "早晨",
    afternoon: "中午",
    evening: "晚上",
    night: "夜间"
  }
}, Mfe = {
  narrow: {
    am: "上",
    pm: "下",
    midnight: "凌晨",
    noon: "午",
    morning: "早",
    afternoon: "下午",
    evening: "晚",
    night: "夜"
  },
  abbreviated: {
    am: "上午",
    pm: "下午",
    midnight: "凌晨",
    noon: "中午",
    morning: "早晨",
    afternoon: "中午",
    evening: "晚上",
    night: "夜间"
  },
  wide: {
    am: "上午",
    pm: "下午",
    midnight: "凌晨",
    noon: "中午",
    morning: "早晨",
    afternoon: "中午",
    evening: "晚上",
    night: "夜间"
  }
}, Rfe = function(t, n) {
  var r = Number(t);
  switch (n == null ? void 0 : n.unit) {
    case "date":
      return r.toString() + "日";
    case "hour":
      return r.toString() + "时";
    case "minute":
      return r.toString() + "分";
    case "second":
      return r.toString() + "秒";
    default:
      return "第 " + r.toString();
  }
}, Pfe = {
  ordinalNumber: Rfe,
  era: De({
    values: Cfe,
    defaultWidth: "wide"
  }),
  quarter: De({
    values: Sfe,
    defaultWidth: "wide",
    argumentCallback: function(t) {
      return t - 1;
    }
  }),
  month: De({
    values: Tfe,
    defaultWidth: "wide"
  }),
  day: De({
    values: Efe,
    defaultWidth: "wide"
  }),
  dayPeriod: De({
    values: kfe,
    defaultWidth: "wide",
    formattingValues: Mfe,
    defaultFormattingWidth: "wide"
  })
}, Ofe = /^(第\s*)?\d+(日|时|分|秒)?/i, Nfe = /\d+/i, Afe = {
  narrow: /^(前)/i,
  abbreviated: /^(前)/i,
  wide: /^(公元前|公元)/i
}, Dfe = {
  any: [/^(前)/i, /^(公元)/i]
}, Ife = {
  narrow: /^[1234]/i,
  abbreviated: /^第[一二三四]刻/i,
  wide: /^第[一二三四]刻钟/i
}, Lfe = {
  any: [/(1|一)/i, /(2|二)/i, /(3|三)/i, /(4|四)/i]
}, $fe = {
  narrow: /^(一|二|三|四|五|六|七|八|九|十[二一])/i,
  abbreviated: /^(一|二|三|四|五|六|七|八|九|十[二一]|\d|1[12])月/i,
  wide: /^(一|二|三|四|五|六|七|八|九|十[二一])月/i
}, Ffe = {
  narrow: [/^一/i, /^二/i, /^三/i, /^四/i, /^五/i, /^六/i, /^七/i, /^八/i, /^九/i, /^十(?!(一|二))/i, /^十一/i, /^十二/i],
  any: [/^一|1/i, /^二|2/i, /^三|3/i, /^四|4/i, /^五|5/i, /^六|6/i, /^七|7/i, /^八|8/i, /^九|9/i, /^十(?!(一|二))|10/i, /^十一|11/i, /^十二|12/i]
}, zfe = {
  narrow: /^[一二三四五六日]/i,
  short: /^[一二三四五六日]/i,
  abbreviated: /^周[一二三四五六日]/i,
  wide: /^星期[一二三四五六日]/i
}, Bfe = {
  any: [/日/i, /一/i, /二/i, /三/i, /四/i, /五/i, /六/i]
}, Hfe = {
  any: /^(上午?|下午?|午夜|[中正]午|早上?|下午|晚上?|凌晨|)/i
}, jfe = {
  any: {
    am: /^上午?/i,
    pm: /^下午?/i,
    midnight: /^午夜/i,
    noon: /^[中正]午/i,
    morning: /^早上/i,
    afternoon: /^下午/i,
    evening: /^晚上?/i,
    night: /^凌晨/i
  }
}, Wfe = {
  ordinalNumber: vo({
    matchPattern: Ofe,
    parsePattern: Nfe,
    valueCallback: function(t) {
      return parseInt(t, 10);
    }
  }),
  era: Ie({
    matchPatterns: Afe,
    defaultMatchWidth: "wide",
    parsePatterns: Dfe,
    defaultParseWidth: "any"
  }),
  quarter: Ie({
    matchPatterns: Ife,
    defaultMatchWidth: "wide",
    parsePatterns: Lfe,
    defaultParseWidth: "any",
    valueCallback: function(t) {
      return t + 1;
    }
  }),
  month: Ie({
    matchPatterns: $fe,
    defaultMatchWidth: "wide",
    parsePatterns: Ffe,
    defaultParseWidth: "any"
  }),
  day: Ie({
    matchPatterns: zfe,
    defaultMatchWidth: "wide",
    parsePatterns: Bfe,
    defaultParseWidth: "any"
  }),
  dayPeriod: Ie({
    matchPatterns: Hfe,
    defaultMatchWidth: "any",
    parsePatterns: jfe,
    defaultParseWidth: "any"
  })
}, Vfe = {
  code: "zh-CN",
  formatDistance: gfe,
  formatLong: _fe,
  formatRelative: xfe,
  localize: Pfe,
  match: Wfe,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, Ufe = Math.ceil, qfe = Math.max;
function Gfe(e, t, n, r) {
  for (var o = -1, i = qfe(Ufe((t - e) / (n || 1)), 0), a = Array(i); i--; )
    a[++o] = e, e += n;
  return a;
}
function Yfe(e, t, n) {
  if (!eO(n))
    return !1;
  var r = typeof t;
  return (r == "number" ? g_(n) && M$(t, n.length) : r == "string" && t in n) ? R$(n[t], e) : !1;
}
function Zfe(e) {
  return function(t, n, r) {
    return r && typeof r != "number" && Yfe(t, n, r) && (n = r = void 0), t = xv(t), n === void 0 ? (n = t, t = 0) : n = xv(n), r = r === void 0 ? t < n ? 1 : -1 : xv(r), Gfe(t, n, r);
  };
}
var xp = Zfe();
const QD = (e) => {
  const [t, n] = [];
  switch (t) {
    case "de":
      return Cae;
    case "fr":
      return Dse;
    case "es":
      return ise;
    case "it":
      return fle;
    case "ja":
      return jle;
    case "ko":
      return bce;
    case "nl":
      return Gce;
    case "pt":
      return Cue;
    case "ru":
      return nde;
    case "tr":
      return Nde;
    case "zh":
      return Vfe;
    case "uk":
      return hfe;
    case "en":
      return n.toLowerCase() === "gb" ? Mae : iM;
    default:
      return iM;
  }
};
xp(4), xp(12), xp(7), xp(24);
var Gy = { exports: {} }, eI = { exports: {} };
(function(e) {
  function t(n) {
    return n && n.__esModule ? n : {
      default: n
    };
  }
  e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
})(eI);
var on = eI.exports, Yy = { exports: {} }, Zy = { exports: {} }, tI = { exports: {} };
(function(e) {
  function t(n) {
    "@babel/helpers - typeof";
    return e.exports = t = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
      return typeof r;
    } : function(r) {
      return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
    }, e.exports.__esModule = !0, e.exports.default = e.exports, t(n);
  }
  e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
})(tI);
var nI = tI.exports, Xy = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = n;
  function n(r, o) {
    if (o.length < r)
      throw new TypeError(r + " argument" + (r > 1 ? "s" : "") + " required, but only " + o.length + " present");
  }
  e.exports = t.default;
})(Xy, Xy.exports);
var Dr = Xy.exports;
(function(e, t) {
  var n = on.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var r = n(nI), o = n(Dr);
  function i(a) {
    return (0, o.default)(1, arguments), a instanceof Date || (0, r.default)(a) === "object" && Object.prototype.toString.call(a) === "[object Date]";
  }
  e.exports = t.default;
})(Zy, Zy.exports);
var Xfe = Zy.exports, Ky = { exports: {} };
(function(e, t) {
  var n = on.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var r = n(nI), o = n(Dr);
  function i(a) {
    (0, o.default)(1, arguments);
    var s = Object.prototype.toString.call(a);
    return a instanceof Date || (0, r.default)(a) === "object" && s === "[object Date]" ? new Date(a.getTime()) : typeof a == "number" || s === "[object Number]" ? new Date(a) : ((typeof a == "string" || s === "[object String]") && typeof console != "undefined" && (console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"), console.warn(new Error().stack)), /* @__PURE__ */ new Date(NaN));
  }
  e.exports = t.default;
})(Ky, Ky.exports);
var Ui = Ky.exports;
(function(e, t) {
  var n = on.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = a;
  var r = n(Xfe), o = n(Ui), i = n(Dr);
  function a(s) {
    if ((0, i.default)(1, arguments), !(0, r.default)(s) && typeof s != "number")
      return !1;
    var c = (0, o.default)(s);
    return !isNaN(Number(c));
  }
  e.exports = t.default;
})(Yy, Yy.exports);
var Kfe = Yy.exports, Jy = { exports: {} }, Qy = { exports: {} }, e1 = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = n;
  function n(r) {
    if (r === null || r === !0 || r === !1)
      return NaN;
    var o = Number(r);
    return isNaN(o) ? o : o < 0 ? Math.ceil(o) : Math.floor(o);
  }
  e.exports = t.default;
})(e1, e1.exports);
var ul = e1.exports;
const Jfe = /* @__PURE__ */ ya(ul);
(function(e, t) {
  var n = on.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = a;
  var r = n(ul), o = n(Ui), i = n(Dr);
  function a(s, c) {
    (0, i.default)(2, arguments);
    var l = (0, o.default)(s).getTime(), d = (0, r.default)(c);
    return new Date(l + d);
  }
  e.exports = t.default;
})(Qy, Qy.exports);
var Qfe = Qy.exports;
(function(e, t) {
  var n = on.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = a;
  var r = n(Qfe), o = n(Dr), i = n(ul);
  function a(s, c) {
    (0, o.default)(2, arguments);
    var l = (0, i.default)(c);
    return (0, r.default)(s, -l);
  }
  e.exports = t.default;
})(Jy, Jy.exports);
var epe = Jy.exports, t1 = { exports: {} }, n1 = { exports: {} };
(function(e, t) {
  var n = on.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = a;
  var r = n(Ui), o = n(Dr), i = 864e5;
  function a(s) {
    (0, o.default)(1, arguments);
    var c = (0, r.default)(s), l = c.getTime();
    c.setUTCMonth(0, 1), c.setUTCHours(0, 0, 0, 0);
    var d = c.getTime(), f = l - d;
    return Math.floor(f / i) + 1;
  }
  e.exports = t.default;
})(n1, n1.exports);
var tpe = n1.exports, r1 = { exports: {} }, o1 = { exports: {} };
(function(e, t) {
  var n = on.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var r = n(Ui), o = n(Dr);
  function i(a) {
    (0, o.default)(1, arguments);
    var s = 1, c = (0, r.default)(a), l = c.getUTCDay(), d = (l < s ? 7 : 0) + l - s;
    return c.setUTCDate(c.getUTCDate() - d), c.setUTCHours(0, 0, 0, 0), c;
  }
  e.exports = t.default;
})(o1, o1.exports);
var Lw = o1.exports, i1 = { exports: {} }, a1 = { exports: {} };
(function(e, t) {
  var n = on.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = a;
  var r = n(Ui), o = n(Dr), i = n(Lw);
  function a(s) {
    (0, o.default)(1, arguments);
    var c = (0, r.default)(s), l = c.getUTCFullYear(), d = /* @__PURE__ */ new Date(0);
    d.setUTCFullYear(l + 1, 0, 4), d.setUTCHours(0, 0, 0, 0);
    var f = (0, i.default)(d), p = /* @__PURE__ */ new Date(0);
    p.setUTCFullYear(l, 0, 4), p.setUTCHours(0, 0, 0, 0);
    var m = (0, i.default)(p);
    return c.getTime() >= f.getTime() ? l + 1 : c.getTime() >= m.getTime() ? l : l - 1;
  }
  e.exports = t.default;
})(a1, a1.exports);
var rI = a1.exports;
(function(e, t) {
  var n = on.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = a;
  var r = n(rI), o = n(Lw), i = n(Dr);
  function a(s) {
    (0, i.default)(1, arguments);
    var c = (0, r.default)(s), l = /* @__PURE__ */ new Date(0);
    l.setUTCFullYear(c, 0, 4), l.setUTCHours(0, 0, 0, 0);
    var d = (0, o.default)(l);
    return d;
  }
  e.exports = t.default;
})(i1, i1.exports);
var npe = i1.exports;
(function(e, t) {
  var n = on.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = c;
  var r = n(Ui), o = n(Lw), i = n(npe), a = n(Dr), s = 6048e5;
  function c(l) {
    (0, a.default)(1, arguments);
    var d = (0, r.default)(l), f = (0, o.default)(d).getTime() - (0, i.default)(d).getTime();
    return Math.round(f / s) + 1;
  }
  e.exports = t.default;
})(r1, r1.exports);
var rpe = r1.exports, s1 = { exports: {} }, l1 = { exports: {} }, dl = {};
Object.defineProperty(dl, "__esModule", {
  value: !0
});
dl.getDefaultOptions = ope;
dl.setDefaultOptions = ipe;
var oI = {};
function ope() {
  return oI;
}
function ipe(e) {
  oI = e;
}
(function(e, t) {
  var n = on.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = s;
  var r = n(Ui), o = n(Dr), i = n(ul), a = dl;
  function s(c, l) {
    var d, f, p, m, v, g, b, x;
    (0, o.default)(1, arguments);
    var T = (0, a.getDefaultOptions)(), S = (0, i.default)((d = (f = (p = (m = l == null ? void 0 : l.weekStartsOn) !== null && m !== void 0 ? m : l == null || (v = l.locale) === null || v === void 0 || (g = v.options) === null || g === void 0 ? void 0 : g.weekStartsOn) !== null && p !== void 0 ? p : T.weekStartsOn) !== null && f !== void 0 ? f : (b = T.locale) === null || b === void 0 || (x = b.options) === null || x === void 0 ? void 0 : x.weekStartsOn) !== null && d !== void 0 ? d : 0);
    if (!(S >= 0 && S <= 6))
      throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    var _ = (0, r.default)(c), w = _.getUTCDay(), k = (w < S ? 7 : 0) + w - S;
    return _.setUTCDate(_.getUTCDate() - k), _.setUTCHours(0, 0, 0, 0), _;
  }
  e.exports = t.default;
})(l1, l1.exports);
var $w = l1.exports, c1 = { exports: {} }, u1 = { exports: {} };
(function(e, t) {
  var n = on.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = c;
  var r = n(Ui), o = n(Dr), i = n($w), a = n(ul), s = dl;
  function c(l, d) {
    var f, p, m, v, g, b, x, T;
    (0, o.default)(1, arguments);
    var S = (0, r.default)(l), _ = S.getUTCFullYear(), w = (0, s.getDefaultOptions)(), k = (0, a.default)((f = (p = (m = (v = d == null ? void 0 : d.firstWeekContainsDate) !== null && v !== void 0 ? v : d == null || (g = d.locale) === null || g === void 0 || (b = g.options) === null || b === void 0 ? void 0 : b.firstWeekContainsDate) !== null && m !== void 0 ? m : w.firstWeekContainsDate) !== null && p !== void 0 ? p : (x = w.locale) === null || x === void 0 || (T = x.options) === null || T === void 0 ? void 0 : T.firstWeekContainsDate) !== null && f !== void 0 ? f : 1);
    if (!(k >= 1 && k <= 7))
      throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
    var E = /* @__PURE__ */ new Date(0);
    E.setUTCFullYear(_ + 1, 0, k), E.setUTCHours(0, 0, 0, 0);
    var R = (0, i.default)(E, d), P = /* @__PURE__ */ new Date(0);
    P.setUTCFullYear(_, 0, k), P.setUTCHours(0, 0, 0, 0);
    var A = (0, i.default)(P, d);
    return S.getTime() >= R.getTime() ? _ + 1 : S.getTime() >= A.getTime() ? _ : _ - 1;
  }
  e.exports = t.default;
})(u1, u1.exports);
var iI = u1.exports;
(function(e, t) {
  var n = on.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = c;
  var r = n(iI), o = n(Dr), i = n($w), a = n(ul), s = dl;
  function c(l, d) {
    var f, p, m, v, g, b, x, T;
    (0, o.default)(1, arguments);
    var S = (0, s.getDefaultOptions)(), _ = (0, a.default)((f = (p = (m = (v = d == null ? void 0 : d.firstWeekContainsDate) !== null && v !== void 0 ? v : d == null || (g = d.locale) === null || g === void 0 || (b = g.options) === null || b === void 0 ? void 0 : b.firstWeekContainsDate) !== null && m !== void 0 ? m : S.firstWeekContainsDate) !== null && p !== void 0 ? p : (x = S.locale) === null || x === void 0 || (T = x.options) === null || T === void 0 ? void 0 : T.firstWeekContainsDate) !== null && f !== void 0 ? f : 1), w = (0, r.default)(l, d), k = /* @__PURE__ */ new Date(0);
    k.setUTCFullYear(w, 0, _), k.setUTCHours(0, 0, 0, 0);
    var E = (0, i.default)(k, d);
    return E;
  }
  e.exports = t.default;
})(c1, c1.exports);
var ape = c1.exports;
(function(e, t) {
  var n = on.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = c;
  var r = n(Ui), o = n($w), i = n(ape), a = n(Dr), s = 6048e5;
  function c(l, d) {
    (0, a.default)(1, arguments);
    var f = (0, r.default)(l), p = (0, o.default)(f, d).getTime() - (0, i.default)(f, d).getTime();
    return Math.round(p / s) + 1;
  }
  e.exports = t.default;
})(s1, s1.exports);
var spe = s1.exports, d1 = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = n;
  function n(r, o) {
    for (var i = r < 0 ? "-" : "", a = Math.abs(r).toString(); a.length < o; )
      a = "0" + a;
    return i + a;
  }
  e.exports = t.default;
})(d1, d1.exports);
var aI = d1.exports, f1 = { exports: {} };
(function(e, t) {
  var n = on.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = void 0;
  var r = n(aI), o = {
    // Year
    y: function(s, c) {
      var l = s.getUTCFullYear(), d = l > 0 ? l : 1 - l;
      return (0, r.default)(c === "yy" ? d % 100 : d, c.length);
    },
    // Month
    M: function(s, c) {
      var l = s.getUTCMonth();
      return c === "M" ? String(l + 1) : (0, r.default)(l + 1, 2);
    },
    // Day of the month
    d: function(s, c) {
      return (0, r.default)(s.getUTCDate(), c.length);
    },
    // AM or PM
    a: function(s, c) {
      var l = s.getUTCHours() / 12 >= 1 ? "pm" : "am";
      switch (c) {
        case "a":
        case "aa":
          return l.toUpperCase();
        case "aaa":
          return l;
        case "aaaaa":
          return l[0];
        case "aaaa":
        default:
          return l === "am" ? "a.m." : "p.m.";
      }
    },
    // Hour [1-12]
    h: function(s, c) {
      return (0, r.default)(s.getUTCHours() % 12 || 12, c.length);
    },
    // Hour [0-23]
    H: function(s, c) {
      return (0, r.default)(s.getUTCHours(), c.length);
    },
    // Minute
    m: function(s, c) {
      return (0, r.default)(s.getUTCMinutes(), c.length);
    },
    // Second
    s: function(s, c) {
      return (0, r.default)(s.getUTCSeconds(), c.length);
    },
    // Fraction of second
    S: function(s, c) {
      var l = c.length, d = s.getUTCMilliseconds(), f = Math.floor(d * Math.pow(10, l - 3));
      return (0, r.default)(f, c.length);
    }
  }, i = o;
  t.default = i, e.exports = t.default;
})(f1, f1.exports);
var lpe = f1.exports;
(function(e, t) {
  var n = on.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = void 0;
  var r = n(tpe), o = n(rpe), i = n(rI), a = n(spe), s = n(iI), c = n(aI), l = n(lpe), d = {
    am: "am",
    pm: "pm",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }, f = {
    // Era
    G: function(x, T, S) {
      var _ = x.getUTCFullYear() > 0 ? 1 : 0;
      switch (T) {
        case "G":
        case "GG":
        case "GGG":
          return S.era(_, {
            width: "abbreviated"
          });
        case "GGGGG":
          return S.era(_, {
            width: "narrow"
          });
        case "GGGG":
        default:
          return S.era(_, {
            width: "wide"
          });
      }
    },
    // Year
    y: function(x, T, S) {
      if (T === "yo") {
        var _ = x.getUTCFullYear(), w = _ > 0 ? _ : 1 - _;
        return S.ordinalNumber(w, {
          unit: "year"
        });
      }
      return l.default.y(x, T);
    },
    // Local week-numbering year
    Y: function(x, T, S, _) {
      var w = (0, s.default)(x, _), k = w > 0 ? w : 1 - w;
      if (T === "YY") {
        var E = k % 100;
        return (0, c.default)(E, 2);
      }
      return T === "Yo" ? S.ordinalNumber(k, {
        unit: "year"
      }) : (0, c.default)(k, T.length);
    },
    // ISO week-numbering year
    R: function(x, T) {
      var S = (0, i.default)(x);
      return (0, c.default)(S, T.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function(x, T) {
      var S = x.getUTCFullYear();
      return (0, c.default)(S, T.length);
    },
    // Quarter
    Q: function(x, T, S) {
      var _ = Math.ceil((x.getUTCMonth() + 1) / 3);
      switch (T) {
        case "Q":
          return String(_);
        case "QQ":
          return (0, c.default)(_, 2);
        case "Qo":
          return S.ordinalNumber(_, {
            unit: "quarter"
          });
        case "QQQ":
          return S.quarter(_, {
            width: "abbreviated",
            context: "formatting"
          });
        case "QQQQQ":
          return S.quarter(_, {
            width: "narrow",
            context: "formatting"
          });
        case "QQQQ":
        default:
          return S.quarter(_, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    // Stand-alone quarter
    q: function(x, T, S) {
      var _ = Math.ceil((x.getUTCMonth() + 1) / 3);
      switch (T) {
        case "q":
          return String(_);
        case "qq":
          return (0, c.default)(_, 2);
        case "qo":
          return S.ordinalNumber(_, {
            unit: "quarter"
          });
        case "qqq":
          return S.quarter(_, {
            width: "abbreviated",
            context: "standalone"
          });
        case "qqqqq":
          return S.quarter(_, {
            width: "narrow",
            context: "standalone"
          });
        case "qqqq":
        default:
          return S.quarter(_, {
            width: "wide",
            context: "standalone"
          });
      }
    },
    // Month
    M: function(x, T, S) {
      var _ = x.getUTCMonth();
      switch (T) {
        case "M":
        case "MM":
          return l.default.M(x, T);
        case "Mo":
          return S.ordinalNumber(_ + 1, {
            unit: "month"
          });
        case "MMM":
          return S.month(_, {
            width: "abbreviated",
            context: "formatting"
          });
        case "MMMMM":
          return S.month(_, {
            width: "narrow",
            context: "formatting"
          });
        case "MMMM":
        default:
          return S.month(_, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    // Stand-alone month
    L: function(x, T, S) {
      var _ = x.getUTCMonth();
      switch (T) {
        case "L":
          return String(_ + 1);
        case "LL":
          return (0, c.default)(_ + 1, 2);
        case "Lo":
          return S.ordinalNumber(_ + 1, {
            unit: "month"
          });
        case "LLL":
          return S.month(_, {
            width: "abbreviated",
            context: "standalone"
          });
        case "LLLLL":
          return S.month(_, {
            width: "narrow",
            context: "standalone"
          });
        case "LLLL":
        default:
          return S.month(_, {
            width: "wide",
            context: "standalone"
          });
      }
    },
    // Local week of year
    w: function(x, T, S, _) {
      var w = (0, a.default)(x, _);
      return T === "wo" ? S.ordinalNumber(w, {
        unit: "week"
      }) : (0, c.default)(w, T.length);
    },
    // ISO week of year
    I: function(x, T, S) {
      var _ = (0, o.default)(x);
      return T === "Io" ? S.ordinalNumber(_, {
        unit: "week"
      }) : (0, c.default)(_, T.length);
    },
    // Day of the month
    d: function(x, T, S) {
      return T === "do" ? S.ordinalNumber(x.getUTCDate(), {
        unit: "date"
      }) : l.default.d(x, T);
    },
    // Day of year
    D: function(x, T, S) {
      var _ = (0, r.default)(x);
      return T === "Do" ? S.ordinalNumber(_, {
        unit: "dayOfYear"
      }) : (0, c.default)(_, T.length);
    },
    // Day of week
    E: function(x, T, S) {
      var _ = x.getUTCDay();
      switch (T) {
        case "E":
        case "EE":
        case "EEE":
          return S.day(_, {
            width: "abbreviated",
            context: "formatting"
          });
        case "EEEEE":
          return S.day(_, {
            width: "narrow",
            context: "formatting"
          });
        case "EEEEEE":
          return S.day(_, {
            width: "short",
            context: "formatting"
          });
        case "EEEE":
        default:
          return S.day(_, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    // Local day of week
    e: function(x, T, S, _) {
      var w = x.getUTCDay(), k = (w - _.weekStartsOn + 8) % 7 || 7;
      switch (T) {
        case "e":
          return String(k);
        case "ee":
          return (0, c.default)(k, 2);
        case "eo":
          return S.ordinalNumber(k, {
            unit: "day"
          });
        case "eee":
          return S.day(w, {
            width: "abbreviated",
            context: "formatting"
          });
        case "eeeee":
          return S.day(w, {
            width: "narrow",
            context: "formatting"
          });
        case "eeeeee":
          return S.day(w, {
            width: "short",
            context: "formatting"
          });
        case "eeee":
        default:
          return S.day(w, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    // Stand-alone local day of week
    c: function(x, T, S, _) {
      var w = x.getUTCDay(), k = (w - _.weekStartsOn + 8) % 7 || 7;
      switch (T) {
        case "c":
          return String(k);
        case "cc":
          return (0, c.default)(k, T.length);
        case "co":
          return S.ordinalNumber(k, {
            unit: "day"
          });
        case "ccc":
          return S.day(w, {
            width: "abbreviated",
            context: "standalone"
          });
        case "ccccc":
          return S.day(w, {
            width: "narrow",
            context: "standalone"
          });
        case "cccccc":
          return S.day(w, {
            width: "short",
            context: "standalone"
          });
        case "cccc":
        default:
          return S.day(w, {
            width: "wide",
            context: "standalone"
          });
      }
    },
    // ISO day of week
    i: function(x, T, S) {
      var _ = x.getUTCDay(), w = _ === 0 ? 7 : _;
      switch (T) {
        case "i":
          return String(w);
        case "ii":
          return (0, c.default)(w, T.length);
        case "io":
          return S.ordinalNumber(w, {
            unit: "day"
          });
        case "iii":
          return S.day(_, {
            width: "abbreviated",
            context: "formatting"
          });
        case "iiiii":
          return S.day(_, {
            width: "narrow",
            context: "formatting"
          });
        case "iiiiii":
          return S.day(_, {
            width: "short",
            context: "formatting"
          });
        case "iiii":
        default:
          return S.day(_, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    // AM or PM
    a: function(x, T, S) {
      var _ = x.getUTCHours(), w = _ / 12 >= 1 ? "pm" : "am";
      switch (T) {
        case "a":
        case "aa":
          return S.dayPeriod(w, {
            width: "abbreviated",
            context: "formatting"
          });
        case "aaa":
          return S.dayPeriod(w, {
            width: "abbreviated",
            context: "formatting"
          }).toLowerCase();
        case "aaaaa":
          return S.dayPeriod(w, {
            width: "narrow",
            context: "formatting"
          });
        case "aaaa":
        default:
          return S.dayPeriod(w, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    // AM, PM, midnight, noon
    b: function(x, T, S) {
      var _ = x.getUTCHours(), w;
      switch (_ === 12 ? w = d.noon : _ === 0 ? w = d.midnight : w = _ / 12 >= 1 ? "pm" : "am", T) {
        case "b":
        case "bb":
          return S.dayPeriod(w, {
            width: "abbreviated",
            context: "formatting"
          });
        case "bbb":
          return S.dayPeriod(w, {
            width: "abbreviated",
            context: "formatting"
          }).toLowerCase();
        case "bbbbb":
          return S.dayPeriod(w, {
            width: "narrow",
            context: "formatting"
          });
        case "bbbb":
        default:
          return S.dayPeriod(w, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function(x, T, S) {
      var _ = x.getUTCHours(), w;
      switch (_ >= 17 ? w = d.evening : _ >= 12 ? w = d.afternoon : _ >= 4 ? w = d.morning : w = d.night, T) {
        case "B":
        case "BB":
        case "BBB":
          return S.dayPeriod(w, {
            width: "abbreviated",
            context: "formatting"
          });
        case "BBBBB":
          return S.dayPeriod(w, {
            width: "narrow",
            context: "formatting"
          });
        case "BBBB":
        default:
          return S.dayPeriod(w, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    // Hour [1-12]
    h: function(x, T, S) {
      if (T === "ho") {
        var _ = x.getUTCHours() % 12;
        return _ === 0 && (_ = 12), S.ordinalNumber(_, {
          unit: "hour"
        });
      }
      return l.default.h(x, T);
    },
    // Hour [0-23]
    H: function(x, T, S) {
      return T === "Ho" ? S.ordinalNumber(x.getUTCHours(), {
        unit: "hour"
      }) : l.default.H(x, T);
    },
    // Hour [0-11]
    K: function(x, T, S) {
      var _ = x.getUTCHours() % 12;
      return T === "Ko" ? S.ordinalNumber(_, {
        unit: "hour"
      }) : (0, c.default)(_, T.length);
    },
    // Hour [1-24]
    k: function(x, T, S) {
      var _ = x.getUTCHours();
      return _ === 0 && (_ = 24), T === "ko" ? S.ordinalNumber(_, {
        unit: "hour"
      }) : (0, c.default)(_, T.length);
    },
    // Minute
    m: function(x, T, S) {
      return T === "mo" ? S.ordinalNumber(x.getUTCMinutes(), {
        unit: "minute"
      }) : l.default.m(x, T);
    },
    // Second
    s: function(x, T, S) {
      return T === "so" ? S.ordinalNumber(x.getUTCSeconds(), {
        unit: "second"
      }) : l.default.s(x, T);
    },
    // Fraction of second
    S: function(x, T) {
      return l.default.S(x, T);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function(x, T, S, _) {
      var w = _._originalDate || x, k = w.getTimezoneOffset();
      if (k === 0)
        return "Z";
      switch (T) {
        case "X":
          return m(k);
        case "XXXX":
        case "XX":
          return v(k);
        case "XXXXX":
        case "XXX":
        default:
          return v(k, ":");
      }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function(x, T, S, _) {
      var w = _._originalDate || x, k = w.getTimezoneOffset();
      switch (T) {
        case "x":
          return m(k);
        case "xxxx":
        case "xx":
          return v(k);
        case "xxxxx":
        case "xxx":
        default:
          return v(k, ":");
      }
    },
    // Timezone (GMT)
    O: function(x, T, S, _) {
      var w = _._originalDate || x, k = w.getTimezoneOffset();
      switch (T) {
        case "O":
        case "OO":
        case "OOO":
          return "GMT" + p(k, ":");
        case "OOOO":
        default:
          return "GMT" + v(k, ":");
      }
    },
    // Timezone (specific non-location)
    z: function(x, T, S, _) {
      var w = _._originalDate || x, k = w.getTimezoneOffset();
      switch (T) {
        case "z":
        case "zz":
        case "zzz":
          return "GMT" + p(k, ":");
        case "zzzz":
        default:
          return "GMT" + v(k, ":");
      }
    },
    // Seconds timestamp
    t: function(x, T, S, _) {
      var w = _._originalDate || x, k = Math.floor(w.getTime() / 1e3);
      return (0, c.default)(k, T.length);
    },
    // Milliseconds timestamp
    T: function(x, T, S, _) {
      var w = _._originalDate || x, k = w.getTime();
      return (0, c.default)(k, T.length);
    }
  };
  function p(b, x) {
    var T = b > 0 ? "-" : "+", S = Math.abs(b), _ = Math.floor(S / 60), w = S % 60;
    if (w === 0)
      return T + String(_);
    var k = x;
    return T + String(_) + k + (0, c.default)(w, 2);
  }
  function m(b, x) {
    if (b % 60 === 0) {
      var T = b > 0 ? "-" : "+";
      return T + (0, c.default)(Math.abs(b) / 60, 2);
    }
    return v(b, x);
  }
  function v(b, x) {
    var T = x || "", S = b > 0 ? "-" : "+", _ = Math.abs(b), w = (0, c.default)(Math.floor(_ / 60), 2), k = (0, c.default)(_ % 60, 2);
    return S + w + T + k;
  }
  var g = f;
  t.default = g, e.exports = t.default;
})(t1, t1.exports);
var cpe = t1.exports, p1 = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = void 0;
  var n = function(c, l) {
    switch (c) {
      case "P":
        return l.date({
          width: "short"
        });
      case "PP":
        return l.date({
          width: "medium"
        });
      case "PPP":
        return l.date({
          width: "long"
        });
      case "PPPP":
      default:
        return l.date({
          width: "full"
        });
    }
  }, r = function(c, l) {
    switch (c) {
      case "p":
        return l.time({
          width: "short"
        });
      case "pp":
        return l.time({
          width: "medium"
        });
      case "ppp":
        return l.time({
          width: "long"
        });
      case "pppp":
      default:
        return l.time({
          width: "full"
        });
    }
  }, o = function(c, l) {
    var d = c.match(/(P+)(p+)?/) || [], f = d[1], p = d[2];
    if (!p)
      return n(c, l);
    var m;
    switch (f) {
      case "P":
        m = l.dateTime({
          width: "short"
        });
        break;
      case "PP":
        m = l.dateTime({
          width: "medium"
        });
        break;
      case "PPP":
        m = l.dateTime({
          width: "long"
        });
        break;
      case "PPPP":
      default:
        m = l.dateTime({
          width: "full"
        });
        break;
    }
    return m.replace("{{date}}", n(f, l)).replace("{{time}}", r(p, l));
  }, i = {
    p: r,
    P: o
  }, a = i;
  t.default = a, e.exports = t.default;
})(p1, p1.exports);
var upe = p1.exports, h1 = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = n;
  function n(r) {
    var o = new Date(Date.UTC(r.getFullYear(), r.getMonth(), r.getDate(), r.getHours(), r.getMinutes(), r.getSeconds(), r.getMilliseconds()));
    return o.setUTCFullYear(r.getFullYear()), r.getTime() - o.getTime();
  }
  e.exports = t.default;
})(h1, h1.exports);
var sI = h1.exports;
const uM = /* @__PURE__ */ ya(sI);
var wf = {};
Object.defineProperty(wf, "__esModule", {
  value: !0
});
wf.isProtectedDayOfYearToken = ppe;
wf.isProtectedWeekYearToken = hpe;
wf.throwProtectedError = mpe;
var dpe = ["D", "DD"], fpe = ["YY", "YYYY"];
function ppe(e) {
  return dpe.indexOf(e) !== -1;
}
function hpe(e) {
  return fpe.indexOf(e) !== -1;
}
function mpe(e, t, n) {
  if (e === "YYYY")
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(t, "`) for formatting years to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "YY")
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(t, "`) for formatting years to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "D")
    throw new RangeError("Use `d` instead of `D` (in `".concat(t, "`) for formatting days of the month to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "DD")
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(t, "`) for formatting days of the month to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}
var m1 = { exports: {} }, g1 = { exports: {} }, v1 = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = void 0;
  var n = {
    lessThanXSeconds: {
      one: "less than a second",
      other: "less than {{count}} seconds"
    },
    xSeconds: {
      one: "1 second",
      other: "{{count}} seconds"
    },
    halfAMinute: "half a minute",
    lessThanXMinutes: {
      one: "less than a minute",
      other: "less than {{count}} minutes"
    },
    xMinutes: {
      one: "1 minute",
      other: "{{count}} minutes"
    },
    aboutXHours: {
      one: "about 1 hour",
      other: "about {{count}} hours"
    },
    xHours: {
      one: "1 hour",
      other: "{{count}} hours"
    },
    xDays: {
      one: "1 day",
      other: "{{count}} days"
    },
    aboutXWeeks: {
      one: "about 1 week",
      other: "about {{count}} weeks"
    },
    xWeeks: {
      one: "1 week",
      other: "{{count}} weeks"
    },
    aboutXMonths: {
      one: "about 1 month",
      other: "about {{count}} months"
    },
    xMonths: {
      one: "1 month",
      other: "{{count}} months"
    },
    aboutXYears: {
      one: "about 1 year",
      other: "about {{count}} years"
    },
    xYears: {
      one: "1 year",
      other: "{{count}} years"
    },
    overXYears: {
      one: "over 1 year",
      other: "over {{count}} years"
    },
    almostXYears: {
      one: "almost 1 year",
      other: "almost {{count}} years"
    }
  }, r = function(a, s, c) {
    var l, d = n[a];
    return typeof d == "string" ? l = d : s === 1 ? l = d.one : l = d.other.replace("{{count}}", s.toString()), c != null && c.addSuffix ? c.comparison && c.comparison > 0 ? "in " + l : l + " ago" : l;
  }, o = r;
  t.default = o, e.exports = t.default;
})(v1, v1.exports);
var gpe = v1.exports, b1 = { exports: {} }, y1 = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = n;
  function n(r) {
    return function() {
      var o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, i = o.width ? String(o.width) : r.defaultWidth, a = r.formats[i] || r.formats[r.defaultWidth];
      return a;
    };
  }
  e.exports = t.default;
})(y1, y1.exports);
var vpe = y1.exports;
(function(e, t) {
  var n = on.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = void 0;
  var r = n(vpe), o = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
  }, i = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
  }, a = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
  }, s = {
    date: (0, r.default)({
      formats: o,
      defaultWidth: "full"
    }),
    time: (0, r.default)({
      formats: i,
      defaultWidth: "full"
    }),
    dateTime: (0, r.default)({
      formats: a,
      defaultWidth: "full"
    })
  }, c = s;
  t.default = c, e.exports = t.default;
})(b1, b1.exports);
var bpe = b1.exports, _1 = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = void 0;
  var n = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: "P"
  }, r = function(a, s, c, l) {
    return n[a];
  }, o = r;
  t.default = o, e.exports = t.default;
})(_1, _1.exports);
var ype = _1.exports, w1 = { exports: {} }, x1 = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = n;
  function n(r) {
    return function(o, i) {
      var a = i != null && i.context ? String(i.context) : "standalone", s;
      if (a === "formatting" && r.formattingValues) {
        var c = r.defaultFormattingWidth || r.defaultWidth, l = i != null && i.width ? String(i.width) : c;
        s = r.formattingValues[l] || r.formattingValues[c];
      } else {
        var d = r.defaultWidth, f = i != null && i.width ? String(i.width) : r.defaultWidth;
        s = r.values[f] || r.values[d];
      }
      var p = r.argumentCallback ? r.argumentCallback(o) : o;
      return s[p];
    };
  }
  e.exports = t.default;
})(x1, x1.exports);
var _pe = x1.exports;
(function(e, t) {
  var n = on.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = void 0;
  var r = n(_pe), o = {
    narrow: ["B", "A"],
    abbreviated: ["BC", "AD"],
    wide: ["Before Christ", "Anno Domini"]
  }, i = {
    narrow: ["1", "2", "3", "4"],
    abbreviated: ["Q1", "Q2", "Q3", "Q4"],
    wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
  }, a = {
    narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
    abbreviated: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
    wide: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
  }, s = {
    narrow: ["S", "M", "T", "W", "T", "F", "S"],
    short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
    abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
    wide: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
  }, c = {
    narrow: {
      am: "a",
      pm: "p",
      midnight: "mi",
      noon: "n",
      morning: "morning",
      afternoon: "afternoon",
      evening: "evening",
      night: "night"
    },
    abbreviated: {
      am: "AM",
      pm: "PM",
      midnight: "midnight",
      noon: "noon",
      morning: "morning",
      afternoon: "afternoon",
      evening: "evening",
      night: "night"
    },
    wide: {
      am: "a.m.",
      pm: "p.m.",
      midnight: "midnight",
      noon: "noon",
      morning: "morning",
      afternoon: "afternoon",
      evening: "evening",
      night: "night"
    }
  }, l = {
    narrow: {
      am: "a",
      pm: "p",
      midnight: "mi",
      noon: "n",
      morning: "in the morning",
      afternoon: "in the afternoon",
      evening: "in the evening",
      night: "at night"
    },
    abbreviated: {
      am: "AM",
      pm: "PM",
      midnight: "midnight",
      noon: "noon",
      morning: "in the morning",
      afternoon: "in the afternoon",
      evening: "in the evening",
      night: "at night"
    },
    wide: {
      am: "a.m.",
      pm: "p.m.",
      midnight: "midnight",
      noon: "noon",
      morning: "in the morning",
      afternoon: "in the afternoon",
      evening: "in the evening",
      night: "at night"
    }
  }, d = function(v, g) {
    var b = Number(v), x = b % 100;
    if (x > 20 || x < 10)
      switch (x % 10) {
        case 1:
          return b + "st";
        case 2:
          return b + "nd";
        case 3:
          return b + "rd";
      }
    return b + "th";
  }, f = {
    ordinalNumber: d,
    era: (0, r.default)({
      values: o,
      defaultWidth: "wide"
    }),
    quarter: (0, r.default)({
      values: i,
      defaultWidth: "wide",
      argumentCallback: function(v) {
        return v - 1;
      }
    }),
    month: (0, r.default)({
      values: a,
      defaultWidth: "wide"
    }),
    day: (0, r.default)({
      values: s,
      defaultWidth: "wide"
    }),
    dayPeriod: (0, r.default)({
      values: c,
      defaultWidth: "wide",
      formattingValues: l,
      defaultFormattingWidth: "wide"
    })
  }, p = f;
  t.default = p, e.exports = t.default;
})(w1, w1.exports);
var wpe = w1.exports, C1 = { exports: {} }, S1 = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = n;
  function n(i) {
    return function(a) {
      var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, c = s.width, l = c && i.matchPatterns[c] || i.matchPatterns[i.defaultMatchWidth], d = a.match(l);
      if (!d)
        return null;
      var f = d[0], p = c && i.parsePatterns[c] || i.parsePatterns[i.defaultParseWidth], m = Array.isArray(p) ? o(p, function(b) {
        return b.test(f);
      }) : r(p, function(b) {
        return b.test(f);
      }), v;
      v = i.valueCallback ? i.valueCallback(m) : m, v = s.valueCallback ? s.valueCallback(v) : v;
      var g = a.slice(f.length);
      return {
        value: v,
        rest: g
      };
    };
  }
  function r(i, a) {
    for (var s in i)
      if (i.hasOwnProperty(s) && a(i[s]))
        return s;
  }
  function o(i, a) {
    for (var s = 0; s < i.length; s++)
      if (a(i[s]))
        return s;
  }
  e.exports = t.default;
})(S1, S1.exports);
var xpe = S1.exports, T1 = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = n;
  function n(r) {
    return function(o) {
      var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, a = o.match(r.matchPattern);
      if (!a)
        return null;
      var s = a[0], c = o.match(r.parsePattern);
      if (!c)
        return null;
      var l = r.valueCallback ? r.valueCallback(c[0]) : c[0];
      l = i.valueCallback ? i.valueCallback(l) : l;
      var d = o.slice(s.length);
      return {
        value: l,
        rest: d
      };
    };
  }
  e.exports = t.default;
})(T1, T1.exports);
var Cpe = T1.exports;
(function(e, t) {
  var n = on.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = void 0;
  var r = n(xpe), o = n(Cpe), i = /^(\d+)(th|st|nd|rd)?/i, a = /\d+/i, s = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
  }, c = {
    any: [/^b/i, /^(a|c)/i]
  }, l = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
  }, d = {
    any: [/1/i, /2/i, /3/i, /4/i]
  }, f = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
  }, p = {
    narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
    any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
  }, m = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
  }, v = {
    narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
    any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
  }, g = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
  }, b = {
    any: {
      am: /^a/i,
      pm: /^p/i,
      midnight: /^mi/i,
      noon: /^no/i,
      morning: /morning/i,
      afternoon: /afternoon/i,
      evening: /evening/i,
      night: /night/i
    }
  }, x = {
    ordinalNumber: (0, o.default)({
      matchPattern: i,
      parsePattern: a,
      valueCallback: function(_) {
        return parseInt(_, 10);
      }
    }),
    era: (0, r.default)({
      matchPatterns: s,
      defaultMatchWidth: "wide",
      parsePatterns: c,
      defaultParseWidth: "any"
    }),
    quarter: (0, r.default)({
      matchPatterns: l,
      defaultMatchWidth: "wide",
      parsePatterns: d,
      defaultParseWidth: "any",
      valueCallback: function(_) {
        return _ + 1;
      }
    }),
    month: (0, r.default)({
      matchPatterns: f,
      defaultMatchWidth: "wide",
      parsePatterns: p,
      defaultParseWidth: "any"
    }),
    day: (0, r.default)({
      matchPatterns: m,
      defaultMatchWidth: "wide",
      parsePatterns: v,
      defaultParseWidth: "any"
    }),
    dayPeriod: (0, r.default)({
      matchPatterns: g,
      defaultMatchWidth: "any",
      parsePatterns: b,
      defaultParseWidth: "any"
    })
  }, T = x;
  t.default = T, e.exports = t.default;
})(C1, C1.exports);
var Spe = C1.exports;
(function(e, t) {
  var n = on.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = void 0;
  var r = n(gpe), o = n(bpe), i = n(ype), a = n(wpe), s = n(Spe), c = {
    code: "en-US",
    formatDistance: r.default,
    formatLong: o.default,
    formatRelative: i.default,
    localize: a.default,
    match: s.default,
    options: {
      weekStartsOn: 0,
      firstWeekContainsDate: 1
    }
  }, l = c;
  t.default = l, e.exports = t.default;
})(g1, g1.exports);
var Tpe = g1.exports;
(function(e, t) {
  var n = on.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = void 0;
  var r = n(Tpe), o = r.default;
  t.default = o, e.exports = t.default;
})(m1, m1.exports);
var Epe = m1.exports;
(function(e, t) {
  var n = on.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = S;
  var r = n(Kfe), o = n(epe), i = n(Ui), a = n(cpe), s = n(upe), c = n(sI), l = wf, d = n(ul), f = n(Dr), p = dl, m = n(Epe), v = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, g = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, b = /^'([^]*?)'?$/, x = /''/g, T = /[a-zA-Z]/;
  function S(w, k, E) {
    var R, P, A, D, N, F, $, I, j, U, G, V, H, q, Q, X, K, J;
    (0, f.default)(2, arguments);
    var ne = String(k), ae = (0, p.getDefaultOptions)(), te = (R = (P = E == null ? void 0 : E.locale) !== null && P !== void 0 ? P : ae.locale) !== null && R !== void 0 ? R : m.default, le = (0, d.default)((A = (D = (N = (F = E == null ? void 0 : E.firstWeekContainsDate) !== null && F !== void 0 ? F : E == null || ($ = E.locale) === null || $ === void 0 || (I = $.options) === null || I === void 0 ? void 0 : I.firstWeekContainsDate) !== null && N !== void 0 ? N : ae.firstWeekContainsDate) !== null && D !== void 0 ? D : (j = ae.locale) === null || j === void 0 || (U = j.options) === null || U === void 0 ? void 0 : U.firstWeekContainsDate) !== null && A !== void 0 ? A : 1);
    if (!(le >= 1 && le <= 7))
      throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
    var ce = (0, d.default)((G = (V = (H = (q = E == null ? void 0 : E.weekStartsOn) !== null && q !== void 0 ? q : E == null || (Q = E.locale) === null || Q === void 0 || (X = Q.options) === null || X === void 0 ? void 0 : X.weekStartsOn) !== null && H !== void 0 ? H : ae.weekStartsOn) !== null && V !== void 0 ? V : (K = ae.locale) === null || K === void 0 || (J = K.options) === null || J === void 0 ? void 0 : J.weekStartsOn) !== null && G !== void 0 ? G : 0);
    if (!(ce >= 0 && ce <= 6))
      throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    if (!te.localize)
      throw new RangeError("locale must contain localize property");
    if (!te.formatLong)
      throw new RangeError("locale must contain formatLong property");
    var fe = (0, i.default)(w);
    if (!(0, r.default)(fe))
      throw new RangeError("Invalid time value");
    var ee = (0, c.default)(fe), me = (0, o.default)(fe, ee), oe = {
      firstWeekContainsDate: le,
      weekStartsOn: ce,
      locale: te,
      _originalDate: fe
    }, ve = ne.match(g).map(function(we) {
      var ye = we[0];
      if (ye === "p" || ye === "P") {
        var Ce = s.default[ye];
        return Ce(we, te.formatLong);
      }
      return we;
    }).join("").match(v).map(function(we) {
      if (we === "''")
        return "'";
      var ye = we[0];
      if (ye === "'")
        return _(we);
      var Ce = a.default[ye];
      if (Ce)
        return !(E != null && E.useAdditionalWeekYearTokens) && (0, l.isProtectedWeekYearToken)(we) && (0, l.throwProtectedError)(we, k, String(w)), !(E != null && E.useAdditionalDayOfYearTokens) && (0, l.isProtectedDayOfYearToken)(we) && (0, l.throwProtectedError)(we, k, String(w)), Ce(me, we, te.localize, oe);
      if (ye.match(T))
        throw new RangeError("Format string contains an unescaped latin alphabet character `" + ye + "`");
      return we;
    }).join("");
    return ve;
  }
  function _(w) {
    var k = w.match(b);
    return k ? k[1].replace(x, "'") : w;
  }
  e.exports = t.default;
})(Gy, Gy.exports);
var kpe = Gy.exports;
const Mpe = /* @__PURE__ */ ya(kpe);
function dM(e, t, n) {
  var r = Ope(e, n.timeZone, n.locale);
  return r.formatToParts ? Rpe(r, t) : Ppe(r, t);
}
function Rpe(e, t) {
  for (var n = e.formatToParts(t), r = n.length - 1; r >= 0; --r)
    if (n[r].type === "timeZoneName")
      return n[r].value;
}
function Ppe(e, t) {
  var n = e.format(t).replace(/\u200E/g, ""), r = / [\w-+ ]+$/.exec(n);
  return r ? r[0].substr(1) : "";
}
function Ope(e, t, n) {
  if (n && !n.code)
    throw new Error(
      "date-fns-tz error: Please set a language code on the locale object imported from date-fns, e.g. `locale.code = 'en-US'`"
    );
  return new Intl.DateTimeFormat(n ? [n.code, "en-US"] : void 0, {
    timeZone: t,
    timeZoneName: e
  });
}
function Npe(e, t) {
  var n = Lpe(t);
  return n.formatToParts ? Dpe(n, e) : Ipe(n, e);
}
var Ape = {
  year: 0,
  month: 1,
  day: 2,
  hour: 3,
  minute: 4,
  second: 5
};
function Dpe(e, t) {
  try {
    for (var n = e.formatToParts(t), r = [], o = 0; o < n.length; o++) {
      var i = Ape[n[o].type];
      i >= 0 && (r[i] = parseInt(n[o].value, 10));
    }
    return r;
  } catch (a) {
    if (a instanceof RangeError)
      return [NaN];
    throw a;
  }
}
function Ipe(e, t) {
  var n = e.format(t), r = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(n);
  return [r[3], r[1], r[2], r[4], r[5], r[6]];
}
var G0 = {};
function Lpe(e) {
  if (!G0[e]) {
    var t = new Intl.DateTimeFormat("en-US", {
      hourCycle: "h23",
      timeZone: "America/New_York",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    }).format(/* @__PURE__ */ new Date("2014-06-25T04:00:00.123Z")), n = t === "06/25/2014, 00:00:00" || t === "‎06‎/‎25‎/‎2014‎ ‎00‎:‎00‎:‎00";
    G0[e] = n ? new Intl.DateTimeFormat("en-US", {
      hourCycle: "h23",
      timeZone: e,
      year: "numeric",
      month: "numeric",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    }) : new Intl.DateTimeFormat("en-US", {
      hour12: !1,
      timeZone: e,
      year: "numeric",
      month: "numeric",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    });
  }
  return G0[e];
}
function lI(e, t, n, r, o, i, a) {
  var s = /* @__PURE__ */ new Date(0);
  return s.setUTCFullYear(e, t, n), s.setUTCHours(r, o, i, a), s;
}
var fM = 36e5, $pe = 6e4, Y0 = {
  timezone: /([Z+-].*)$/,
  timezoneZ: /^(Z)$/,
  timezoneHH: /^([+-]\d{2})$/,
  timezoneHHMM: /^([+-])(\d{2}):?(\d{2})$/
};
function Fw(e, t, n) {
  var r, o;
  if (!e || (r = Y0.timezoneZ.exec(e), r))
    return 0;
  var i;
  if (r = Y0.timezoneHH.exec(e), r)
    return i = parseInt(r[1], 10), pM(i) ? -(i * fM) : NaN;
  if (r = Y0.timezoneHHMM.exec(e), r) {
    i = parseInt(r[2], 10);
    var a = parseInt(r[3], 10);
    return pM(i, a) ? (o = Math.abs(i) * fM + a * $pe, r[1] === "+" ? -o : o) : NaN;
  }
  if (Bpe(e)) {
    t = new Date(t || Date.now());
    var s = n ? t : Fpe(t), c = E1(s, e), l = n ? c : zpe(t, c, e);
    return -l;
  }
  return NaN;
}
function Fpe(e) {
  return lI(
    e.getFullYear(),
    e.getMonth(),
    e.getDate(),
    e.getHours(),
    e.getMinutes(),
    e.getSeconds(),
    e.getMilliseconds()
  );
}
function E1(e, t) {
  var n = Npe(e, t), r = lI(
    n[0],
    n[1] - 1,
    n[2],
    n[3] % 24,
    n[4],
    n[5],
    0
  ).getTime(), o = e.getTime(), i = o % 1e3;
  return o -= i >= 0 ? i : 1e3 + i, r - o;
}
function zpe(e, t, n) {
  var r = e.getTime(), o = r - t, i = E1(new Date(o), n);
  if (t === i)
    return t;
  o -= i - t;
  var a = E1(new Date(o), n);
  return i === a ? i : Math.max(i, a);
}
function pM(e, t) {
  return -23 <= e && e <= 23 && (t == null || 0 <= t && t <= 59);
}
var hM = {};
function Bpe(e) {
  if (hM[e])
    return !0;
  try {
    return hM[e] = !0, !0;
  } catch (t) {
    return !1;
  }
}
var Hpe = 60 * 1e3, jpe = {
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(e, t, n, r) {
    var o = Z0(r.timeZone, e);
    if (o === 0)
      return "Z";
    switch (t) {
      case "X":
        return mM(o);
      case "XXXX":
      case "XX":
        return ql(o);
      case "XXXXX":
      case "XXX":
      default:
        return ql(o, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(e, t, n, r) {
    var o = Z0(r.timeZone, e);
    switch (t) {
      case "x":
        return mM(o);
      case "xxxx":
      case "xx":
        return ql(o);
      case "xxxxx":
      case "xxx":
      default:
        return ql(o, ":");
    }
  },
  // Timezone (GMT)
  O: function(e, t, n, r) {
    var o = Z0(r.timeZone, e);
    switch (t) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + Wpe(o, ":");
      case "OOOO":
      default:
        return "GMT" + ql(o, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(e, t, n, r) {
    switch (t) {
      case "z":
      case "zz":
      case "zzz":
        return dM("short", e, r);
      case "zzzz":
      default:
        return dM("long", e, r);
    }
  }
};
function Z0(e, t) {
  var n = e ? Fw(e, t, !0) / Hpe : t.getTimezoneOffset();
  if (Number.isNaN(n))
    throw new RangeError("Invalid time zone specified: " + e);
  return n;
}
function om(e, t) {
  for (var n = e < 0 ? "-" : "", r = Math.abs(e).toString(); r.length < t; )
    r = "0" + r;
  return n + r;
}
function ql(e, t) {
  var n = t || "", r = e > 0 ? "-" : "+", o = Math.abs(e), i = om(Math.floor(o / 60), 2), a = om(Math.floor(o % 60), 2);
  return r + i + n + a;
}
function mM(e, t) {
  if (e % 60 === 0) {
    var n = e > 0 ? "-" : "+";
    return n + om(Math.abs(e) / 60, 2);
  }
  return ql(e, t);
}
function Wpe(e, t) {
  var n = e > 0 ? "-" : "+", r = Math.abs(e), o = Math.floor(r / 60), i = r % 60;
  if (i === 0)
    return n + String(o);
  var a = t;
  return n + String(o) + a + om(i, 2);
}
var Vpe = /(Z|[+-]\d{2}(?::?\d{2})?| UTC| [a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?)$/, X0 = 36e5, gM = 6e4, Upe = 2, Pr = {
  dateTimePattern: /^([0-9W+-]+)(T| )(.*)/,
  datePattern: /^([0-9W+-]+)(.*)/,
  plainTime: /:/,
  // year tokens
  YY: /^(\d{2})$/,
  YYY: [
    /^([+-]\d{2})$/,
    // 0 additional digits
    /^([+-]\d{3})$/,
    // 1 additional digit
    /^([+-]\d{4})$/
    // 2 additional digits
  ],
  YYYY: /^(\d{4})/,
  YYYYY: [
    /^([+-]\d{4})/,
    // 0 additional digits
    /^([+-]\d{5})/,
    // 1 additional digit
    /^([+-]\d{6})/
    // 2 additional digits
  ],
  // date tokens
  MM: /^-(\d{2})$/,
  DDD: /^-?(\d{3})$/,
  MMDD: /^-?(\d{2})-?(\d{2})$/,
  Www: /^-?W(\d{2})$/,
  WwwD: /^-?W(\d{2})-?(\d{1})$/,
  HH: /^(\d{2}([.,]\d*)?)$/,
  HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
  HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,
  // time zone tokens (to identify the presence of a tz)
  timeZone: Vpe
};
function cI(e, t) {
  if (arguments.length < 1)
    throw new TypeError("1 argument required, but only " + arguments.length + " present");
  if (e === null)
    return /* @__PURE__ */ new Date(NaN);
  var n = t || {}, r = n.additionalDigits == null ? Upe : Jfe(n.additionalDigits);
  if (r !== 2 && r !== 1 && r !== 0)
    throw new RangeError("additionalDigits must be 0, 1 or 2");
  if (e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]")
    return new Date(e.getTime());
  if (typeof e == "number" || Object.prototype.toString.call(e) === "[object Number]")
    return new Date(e);
  if (!(typeof e == "string" || Object.prototype.toString.call(e) === "[object String]"))
    return /* @__PURE__ */ new Date(NaN);
  var o = qpe(e), i = Gpe(o.date, r), a = i.year, s = i.restDateString, c = Ype(s, a);
  if (isNaN(c))
    return /* @__PURE__ */ new Date(NaN);
  if (c) {
    var l = c.getTime(), d = 0, f;
    if (o.time && (d = Zpe(o.time), isNaN(d)))
      return /* @__PURE__ */ new Date(NaN);
    if (o.timeZone || n.timeZone) {
      if (f = Fw(o.timeZone || n.timeZone, new Date(l + d)), isNaN(f))
        return /* @__PURE__ */ new Date(NaN);
    } else
      f = uM(new Date(l + d)), f = uM(new Date(l + d + f));
    return new Date(l + d + f);
  } else
    return /* @__PURE__ */ new Date(NaN);
}
function qpe(e) {
  var t = {}, n = Pr.dateTimePattern.exec(e), r;
  if (n ? (t.date = n[1], r = n[3]) : (n = Pr.datePattern.exec(e), n ? (t.date = n[1], r = n[2]) : (t.date = null, r = e)), r) {
    var o = Pr.timeZone.exec(r);
    o ? (t.time = r.replace(o[1], ""), t.timeZone = o[1].trim()) : t.time = r;
  }
  return t;
}
function Gpe(e, t) {
  var n = Pr.YYY[t], r = Pr.YYYYY[t], o;
  if (o = Pr.YYYY.exec(e) || r.exec(e), o) {
    var i = o[1];
    return {
      year: parseInt(i, 10),
      restDateString: e.slice(i.length)
    };
  }
  if (o = Pr.YY.exec(e) || n.exec(e), o) {
    var a = o[1];
    return {
      year: parseInt(a, 10) * 100,
      restDateString: e.slice(a.length)
    };
  }
  return {
    year: null
  };
}
function Ype(e, t) {
  if (t === null)
    return null;
  var n, r, o, i;
  if (e.length === 0)
    return r = /* @__PURE__ */ new Date(0), r.setUTCFullYear(t), r;
  if (n = Pr.MM.exec(e), n)
    return r = /* @__PURE__ */ new Date(0), o = parseInt(n[1], 10) - 1, bM(t, o) ? (r.setUTCFullYear(t, o), r) : /* @__PURE__ */ new Date(NaN);
  if (n = Pr.DDD.exec(e), n) {
    r = /* @__PURE__ */ new Date(0);
    var a = parseInt(n[1], 10);
    return Jpe(t, a) ? (r.setUTCFullYear(t, 0, a), r) : /* @__PURE__ */ new Date(NaN);
  }
  if (n = Pr.MMDD.exec(e), n) {
    r = /* @__PURE__ */ new Date(0), o = parseInt(n[1], 10) - 1;
    var s = parseInt(n[2], 10);
    return bM(t, o, s) ? (r.setUTCFullYear(t, o, s), r) : /* @__PURE__ */ new Date(NaN);
  }
  if (n = Pr.Www.exec(e), n)
    return i = parseInt(n[1], 10) - 1, yM(t, i) ? vM(t, i) : /* @__PURE__ */ new Date(NaN);
  if (n = Pr.WwwD.exec(e), n) {
    i = parseInt(n[1], 10) - 1;
    var c = parseInt(n[2], 10) - 1;
    return yM(t, i, c) ? vM(t, i, c) : /* @__PURE__ */ new Date(NaN);
  }
  return null;
}
function Zpe(e) {
  var t, n, r;
  if (t = Pr.HH.exec(e), t)
    return n = parseFloat(t[1].replace(",", ".")), K0(n) ? n % 24 * X0 : NaN;
  if (t = Pr.HHMM.exec(e), t)
    return n = parseInt(t[1], 10), r = parseFloat(t[2].replace(",", ".")), K0(n, r) ? n % 24 * X0 + r * gM : NaN;
  if (t = Pr.HHMMSS.exec(e), t) {
    n = parseInt(t[1], 10), r = parseInt(t[2], 10);
    var o = parseFloat(t[3].replace(",", "."));
    return K0(n, r, o) ? n % 24 * X0 + r * gM + o * 1e3 : NaN;
  }
  return null;
}
function vM(e, t, n) {
  t = t || 0, n = n || 0;
  var r = /* @__PURE__ */ new Date(0);
  r.setUTCFullYear(e, 0, 4);
  var o = r.getUTCDay() || 7, i = t * 7 + n + 1 - o;
  return r.setUTCDate(r.getUTCDate() + i), r;
}
var Xpe = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], Kpe = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function uI(e) {
  return e % 400 === 0 || e % 4 === 0 && e % 100 !== 0;
}
function bM(e, t, n) {
  if (t < 0 || t > 11)
    return !1;
  if (n != null) {
    if (n < 1)
      return !1;
    var r = uI(e);
    if (r && n > Kpe[t] || !r && n > Xpe[t])
      return !1;
  }
  return !0;
}
function Jpe(e, t) {
  if (t < 1)
    return !1;
  var n = uI(e);
  return !(n && t > 366 || !n && t > 365);
}
function yM(e, t, n) {
  return !(t < 0 || t > 52 || n != null && (n < 0 || n > 6));
}
function K0(e, t, n) {
  return !(e != null && (e < 0 || e >= 25) || t != null && (t < 0 || t >= 60) || n != null && (n < 0 || n >= 60));
}
var Qpe = /([xXOz]+)|''|'(''|[^'])+('|$)/g;
function dI(e, t, n) {
  var r = String(t), o = n || {}, i = r.match(Qpe);
  if (i) {
    var a = cI(o.originalDate || e, o);
    r = i.reduce(function(s, c) {
      if (c[0] === "'")
        return s;
      var l = s.indexOf(c), d = s[l - 1] === "'", f = s.replace(
        c,
        "'" + jpe[c[0]](a, c, null, o) + "'"
      );
      return d ? f.substring(0, l - 1) + f.substring(l + 1) : f;
    }, r);
  }
  return Mpe(e, r, o);
}
function ls(e, t, n) {
  const r = new RegExp("'[^']+'|(" + t + ")", "g");
  return e.replace(
    r,
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/replace#specifying_a_function_as_the_replacement
    function(i, a) {
      return a ? n(i) : i;
    }
  );
}
const ehe = [
  "shortDate",
  "shortTime",
  "short",
  // Purposely ordered so that this is after other values that contain `short`
  "mediumDate",
  "mediumTime",
  "medium",
  // Purposely ordered so that this is after other values that contain `medium`
  "longDate",
  "fullDate"
], the = Object.freeze({
  fullDate: "EEEE, MMMM d, y",
  longDate: "MMMM d, y",
  medium: "MMM d, y h:mm:ss a",
  mediumDate: "MMM d, y",
  mediumTime: "h:mm:ss a",
  short: "M/d/yy h:mm a",
  shortDate: "M/d/yy",
  shortTime: "h:mm a"
});
function nhe(e, t) {
  if (!t.formatLong)
    return console.warn("Locale does not have formatLong property. Using default date formats."), the[e];
  switch (e) {
    case "fullDate":
      return t.formatLong.date({ width: "full" });
    case "longDate":
      return t.formatLong.date({ width: "long" });
    case "mediumDate":
      return t.formatLong.date({ width: "medium" });
    case "shortDate":
      return t.formatLong.date({ width: "short" });
    case "mediumTime":
      return t.formatLong.time({ width: "medium" });
    case "shortTime":
      return t.formatLong.time({ width: "short" });
    case "medium":
      return t.formatLong.dateTime({ width: "medium" }).replace("{{date}}", t.formatLong.date({ width: "medium" })).replace("{{time}}", t.formatLong.time({ width: "medium" }));
    case "short":
      return t.formatLong.dateTime({ width: "short" }).replace("{{date}}", t.formatLong.date({ width: "short" })).replace("{{time}}", t.formatLong.time({ width: "short" }));
  }
}
function rhe(e, t) {
  if (!(e.includes("short") || e.includes("medium") || e.includes("long") || e.includes("full")))
    return e;
  let n = e;
  return ehe.forEach((r) => {
    const o = nhe(r, t);
    n = ls(n, r, function() {
      return o;
    });
  }), n;
}
var k1 = { exports: {} }, M1 = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = n;
  function n(r, o) {
    if (r == null)
      throw new TypeError("assign requires that input parameter not be null or undefined");
    for (var i in o)
      Object.prototype.hasOwnProperty.call(o, i) && (r[i] = o[i]);
    return r;
  }
  e.exports = t.default;
})(M1, M1.exports);
var ohe = M1.exports;
(function(e, t) {
  var n = on.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = o;
  var r = n(ohe);
  function o(i) {
    return (0, r.default)({}, i);
  }
  e.exports = t.default;
})(k1, k1.exports);
var ihe = k1.exports;
const ahe = /* @__PURE__ */ ya(ihe);
function she(e, t, n) {
  var r = cI(e, n), o = Fw(t, r, !0), i = new Date(r.getTime() - o), a = /* @__PURE__ */ new Date(0);
  return a.setFullYear(i.getUTCFullYear(), i.getUTCMonth(), i.getUTCDate()), a.setHours(i.getUTCHours(), i.getUTCMinutes(), i.getUTCSeconds(), i.getUTCMilliseconds()), a;
}
function qd(e, t, n, r) {
  var o = ahe(r);
  return o.timeZone = t, o.originalDate = e, dI(she(e, t), n, o);
}
function lhe(e) {
  return e.includes("sss") ? ls(
    e,
    "sss",
    function() {
      return "SSS";
    }
  ) : e;
}
function che(e, t, n) {
  if (!(e.includes("a") || e.includes("A")))
    return e;
  let r = ls(e, "a", function() {
    return `\0${qd(t, n, "a").toLowerCase()}\0`;
  });
  return r = ls(r, "A", function() {
    return `\0${qd(t, n, "a").toUpperCase()}\0`;
  }), r = r.replace(/\0\0/g, ""), r = r.replace(/\0/g, "'"), r;
}
function uhe(e, t, n, r) {
  return e.includes("Z") ? ls(e, "Z", function() {
    return qd(t, n, "xx", { locale: r });
  }) : e;
}
function dhe(e, t, n) {
  return fI(e, t, n) ? KD(e, 1) : e;
}
function fhe(e, t) {
  return t <= e.getMonth();
}
function fI(e, t, n) {
  const r = ![vhe, zw].includes(t);
  return n > hI && r && fhe(e, n);
}
function phe(e, t, n, r) {
  return !r && fI(e, t, n) ? XD(e, 1) : e;
}
function hhe(e, t) {
  if (t > 0) {
    const n = (e.getMonth() + t) % 12;
    return Gie(e, n);
  }
  return e;
}
function mhe(e, t, n, r, o, i) {
  if (!e.includes("y"))
    return e;
  const a = phe(
    t,
    r,
    i,
    o
  );
  let s = e;
  if (["yyyy", "yy", "y", "yp", "yyyp"].some((l) => e.includes(l)) && (n = "Etc/GMT-14"), e.includes("yp")) {
    const l = KD(a, 1);
    s = ls(
      e,
      "yp|yyyp",
      function(f) {
        const p = "y".repeat(f.length);
        return qd(l, n, p);
      }
    );
  }
  return ls(
    s,
    "yyyy|yy|y",
    function(d) {
      return qd(a, n, d);
    }
  );
}
function ghe(e, t, n, r) {
  if (!e.includes("Q"))
    return e;
  let o = t.getMonth();
  r && [zw, bhe, yhe, pI].includes(n) && (o -= r > o ? r - 12 : r);
  const i = parseInt(String(o / 3)) + 1;
  return ls(
    e,
    "QQ|Q",
    function(c) {
      return `${c.length === 2 ? "'Quarter '" : "'Q'"}${i}`;
    }
  );
}
const vhe = "years", zw = "quarters", bhe = "months", yhe = "weeks", pI = "days", hI = 0, _he = 1, mI = Object.freeze({
  weekFirstDay: _he,
  isFiscalOn: !1,
  fiscalMonth: hI,
  selectedDateLevel: pI,
  timeZone: "UTC"
});
function Bw(e, t, n = QD(), r = mI) {
  return e.getFullYear() < 100 && (e = Yie(e, 1900 + e.getFullYear())), r.isFiscalOn || (e = dhe(e, r.selectedDateLevel, r.fiscalMonth)), t = rhe(t, n), t = lhe(t), t = che(t, e, r.timeZone), t = uhe(t, e, r.timeZone, n), t = mhe(
    t,
    e,
    r.timeZone,
    r.selectedDateLevel,
    r.isFiscalOn,
    r.fiscalMonth
  ), !r.isFiscalOn && r.selectedDateLevel === zw && (e = hhe(e, r.fiscalMonth)), t = ghe(
    t,
    e,
    r.selectedDateLevel,
    r.fiscalMonth
  ), dI(e, t, {
    locale: n,
    weekStartsOn: r.weekFirstDay
  });
}
const Hw = "#F2F2F2", jw = 4, whe = {
  chart: {
    backgroundColor: "#FFFFFF",
    textColor: "#000000",
    secondaryTextColor: "#E4E4E4",
    panelBackgroundColor: "#F6F6F6",
    animation: {
      init: {
        duration: "auto"
      },
      redraw: {
        duration: "auto"
      }
    }
  },
  typography: {
    fontFamily: '"Open Sans","Roboto","Helvetica","Arial",sans-serif',
    primaryTextColor: "#5B6372",
    secondaryTextColor: "#9EA2AB"
  },
  palette: {
    variantColors: ["#00cee6", "#9b9bd7", "#6eda55", "#fc7570", "#fbb755", "#218a8c"]
  },
  general: {
    backgroundColor: "#ffffff",
    brandColor: "#ffcb05",
    primaryButtonTextColor: "#3a4356",
    primaryButtonHoverColor: "#f2b900"
  },
  widget: {
    spaceAround: "None",
    cornerRadius: "None",
    shadow: "None",
    border: !1,
    borderColor: "#9EA2AB",
    header: {
      titleTextColor: "#5B6372",
      titleAlignment: "Left",
      dividerLine: !1,
      dividerLineColor: "#5B6372",
      backgroundColor: "#FFFFFF"
    }
  },
  dashboard: {
    backgroundColor: "#FFFFFF",
    dividerLineWidth: jw,
    dividerLineColor: Hw
  },
  filter: {
    panel: {
      titleColor: "#5B6372",
      backgroundColor: "#F6F6F6"
    }
  },
  aiChat: {
    backgroundColor: "rgba(244, 244, 248, 1)",
    primaryTextColor: "rgba(38, 46, 61, 0.8)",
    secondaryTextColor: "rgba(38, 46, 61, 0.55)",
    primaryFontSize: ["13px", "18px"],
    body: {
      paddingLeft: "16px",
      paddingRight: "16px",
      paddingTop: "16px",
      paddingBottom: "1px",
      gapBetweenMessages: "16px"
    },
    footer: {
      paddingLeft: "16px",
      paddingRight: "16px",
      paddingTop: "12px",
      paddingBottom: "16px"
    },
    userMessages: {
      backgroundColor: "rgba(255, 255, 255, 1)"
    },
    systemMessages: {
      backgroundColor: "rgba(255, 255, 255, 1)"
    },
    input: {
      backgroundColor: "rgba(255, 255, 255, 1)",
      focus: {
        outlineColor: "rgba(38, 46, 61, 0.5)"
      }
    },
    header: {
      textColor: "rgba(38, 46, 61, 0.8)",
      backgroundColor: "rgba(255, 255, 255, 1)"
    },
    dropup: {
      backgroundColor: "rgba(255, 255, 255, 1)",
      boxShadow: "0px 1px 2px rgba(9, 9, 10, 0.1), 0px 2px 4px rgba(9, 9, 10, 0.1)",
      borderRadius: "4px",
      headers: {
        textColor: "rgba(38, 46, 61, 0.8)",
        hover: {
          backgroundColor: "rgba(244, 244, 248, 1)"
        }
      },
      items: {
        textColor: "rgba(38, 46, 61, 0.8)",
        hover: {
          backgroundColor: "rgba(244, 244, 248, 1)"
        }
      }
    },
    border: "1px solid #c6c9ce",
    borderRadius: "30px",
    suggestions: {
      textColor: "rgba(38, 46, 61, 1)",
      backgroundColor: "rgba(244, 244, 248, 1)",
      border: "1px solid",
      borderRadius: "16px",
      borderGradient: ["rgba(75, 153, 233, 1)", "rgba(102, 57, 191, 1)"],
      hover: {
        textColor: "rgba(38, 46, 61, 1)",
        backgroundColor: "rgba(12, 14, 18, 0.07)"
      },
      loadingGradient: ["rgba(194, 196, 203, 1)", "rgba(236, 236, 239, 1)"],
      gap: "8px"
    },
    clickableMessages: {
      textColor: "rgba(38, 46, 61, 1)",
      backgroundColor: "rgba(244, 244, 248, 1)",
      border: "1px solid",
      borderGradient: ["rgba(75, 153, 233, 1)", "rgba(102, 57, 191, 1)"],
      hover: {
        textColor: "rgba(38, 46, 61, 1)",
        backgroundColor: "rgba(12, 14, 18, 0.07)"
      }
    },
    dataTopics: {
      backgroundColor: "rgba(255, 255, 255, 1)",
      items: {
        textColor: "rgba(38, 46, 61, 1)",
        backgroundColor: "rgba(244, 244, 248, 1)"
      }
    },
    icons: {
      color: "rgba(38, 46, 61, 0.67)",
      feedbackIcons: {
        hoverColor: "rgba(12, 14, 18, 0.07)"
      }
    },
    tooltips: {
      backgroundColor: "rgba(255, 255, 255, 1)",
      textColor: "rgba(38, 46, 61, 0.8)",
      boxShadow: "0px 4px 12px 0px rgba(9, 9, 10, 0.20), 0px 1px 4px 0px rgba(9, 9, 10, 0.10)"
    }
  }
}, xhe = {
  chart: {
    backgroundColor: "#313138",
    textColor: "#FFFFFF",
    secondaryTextColor: "#C5C8CF",
    panelBackgroundColor: "#313138",
    animation: {
      init: {
        duration: "auto"
      },
      redraw: {
        duration: "auto"
      }
    }
  },
  typography: {
    fontFamily: '"Open Sans","Roboto","Helvetica","Arial",sans-serif',
    primaryTextColor: "#FFFFFF",
    secondaryTextColor: "#C5C8CF"
  },
  palette: {
    variantColors: ["#00cee6", "#9b9bd7", "#6eda55", "#fc7570", "#fbb755", "#218a8c"]
    // Variant colors remain the same
  },
  general: {
    backgroundColor: "#16161C",
    brandColor: "#FFCB05",
    primaryButtonTextColor: "#3A4356",
    primaryButtonHoverColor: "#F2B900"
  },
  widget: {
    spaceAround: "None",
    cornerRadius: "None",
    shadow: "None",
    border: !1,
    borderColor: "#C5C8CF",
    header: {
      titleTextColor: "#FFFFFF",
      titleAlignment: "Left",
      dividerLine: !1,
      dividerLineColor: "#FFFFFF",
      backgroundColor: "#313138"
    }
  },
  dashboard: {
    backgroundColor: "#313138",
    dividerLineWidth: jw,
    dividerLineColor: Hw
  },
  filter: {
    panel: {
      titleColor: "#FFFFFF",
      backgroundColor: "#313138"
    }
  },
  aiChat: {
    backgroundColor: "rgba(23, 28, 38, 1)",
    primaryTextColor: "rgba(242, 247, 255, 0.9)",
    secondaryTextColor: "rgba(242, 247, 255, 0.4)",
    primaryFontSize: ["13px", "18px"],
    body: {
      paddingLeft: "16px",
      paddingRight: "16px",
      paddingTop: "16px",
      paddingBottom: "1px",
      gapBetweenMessages: "16px"
    },
    footer: {
      paddingLeft: "16px",
      paddingRight: "16px",
      paddingTop: "12px",
      paddingBottom: "16px"
    },
    userMessages: {
      backgroundColor: "rgba(31, 92, 153, 1)"
    },
    systemMessages: {
      backgroundColor: "rgba(46, 55, 77, 1)"
    },
    input: {
      backgroundColor: "rgba(242, 247, 255, 0.1)",
      focus: {
        outlineColor: "rgba(242, 247, 255, 0.5)"
      }
    },
    header: {
      backgroundColor: "#313138",
      textColor: "rgba(242, 247, 255, 0.9)"
    },
    dropup: {
      backgroundColor: "rgba(38, 46, 64, 1)",
      boxShadow: "0px 1px 4px 0px #020203, 0px 2px 12px 2px rgba(2, 2, 3, 0.25)",
      borderRadius: "8px",
      headers: {
        textColor: "rgba(242, 247, 255, 0.6)",
        hover: {
          backgroundColor: "rgba(242, 247, 255, 0.1)"
        }
      },
      items: {
        textColor: "rgba(242, 247, 255, 0.9)",
        hover: {
          backgroundColor: "rgba(242, 247, 255, 0.1)"
        }
      }
    },
    border: !1,
    borderRadius: "30px",
    suggestions: {
      textColor: "rgba(88, 192, 244, 1)",
      backgroundColor: "rgba(23, 28, 38, 1)",
      border: "1px solid",
      borderRadius: "16px",
      borderGradient: ["rgba(75, 153, 233, 1)", "rgba(102, 57, 191, 1)"],
      hover: {
        textColor: "rgba(88, 192, 244, 1)",
        backgroundColor: "rgba(242, 247, 255, 0.1)"
      },
      loadingGradient: ["rgba(242, 247, 255, 0.1)", "rgba(242, 247, 255, 0.3)"],
      gap: "8px"
    },
    clickableMessages: {
      textColor: "rgba(88, 192, 244, 1)",
      backgroundColor: "rgba(23, 28, 38, 1)",
      border: "1px solid",
      borderGradient: ["rgba(75, 153, 233, 1)", "rgba(102, 57, 191, 1)"],
      hover: {
        textColor: "rgba(88, 192, 244, 1)",
        backgroundColor: "rgba(242, 247, 255, 0.1)"
      }
    },
    dataTopics: {
      backgroundColor: "rgba(23, 28, 38, 1)",
      items: {
        textColor: "rgba(242, 247, 255, 0.9)",
        backgroundColor: "rgba(46, 55, 77, 1)"
      }
    },
    icons: {
      color: "rgba(242, 247, 255, 0.5)",
      feedbackIcons: {
        hoverColor: "rgba(242, 247, 255, 0.1)"
      }
    },
    tooltips: {
      textColor: "rgba(242, 247, 255, 0.9)",
      backgroundColor: "rgba(46, 55, 77, 1)",
      boxShadow: "0px 1px 8px 0px #020203, 0px 4px 24px 4px rgba(2, 2, 3, 0.25)"
    }
  }
}, Ww = (e = !1) => e ? Li(xhe) : Li(whe), Cp = {
  none: "None",
  small: "Small",
  medium: "Medium",
  large: "Large",
  left: "Left",
  center: "Center",
  right: "Right",
  light: "Light",
  dark: "Dark"
};
function Che(e, t, n) {
  const r = {
    chart: {
      textColor: e.dashboards.widgetTextColor,
      backgroundColor: e.dashboards.widgetBackgroundColor,
      secondaryTextColor: e.dashboards.widgetSecondaryTextColor,
      panelBackgroundColor: e.dashboards.widgetBackgroundColor,
      animation: {
        init: {
          duration: "auto"
        },
        redraw: {
          duration: "auto"
        }
      }
    },
    typography: {
      fontFamily: e.typography.fontFamily,
      primaryTextColor: e.typography.primaryTextColor,
      secondaryTextColor: e.typography.secondaryTextColor,
      fontsLoader: {
        fonts: The(
          e.typography.fontFamily,
          n,
          e.typography.customFontSelected
        )
      }
    },
    palette: {
      variantColors: t.colors
    },
    general: {
      brandColor: e.general.brandColor,
      backgroundColor: e.general.backgroundColor,
      primaryButtonTextColor: e.general.primaryButtonTextColor,
      primaryButtonHoverColor: e.general.primaryButtonHoverColor
    },
    widget: {
      spaceAround: Cp[e.dashboards.widgetSpacing],
      cornerRadius: Cp[e.dashboards.widgetCornerRadius],
      shadow: Cp[e.dashboards.widgetShadow],
      border: e.dashboards.widgetBorderEnabled,
      borderColor: e.dashboards.widgetBorderColor,
      header: {
        titleTextColor: e.dashboards.widgetTitleColor,
        titleAlignment: Cp[e.dashboards.widgetTitleAlignment],
        dividerLine: e.dashboards.widgetTitleDividerEnabled,
        dividerLineColor: e.dashboards.widgetTitleDividerColor,
        backgroundColor: e.dashboards.widgetTitleBackgroundColor
      }
    },
    dashboard: {
      backgroundColor: e.dashboards.layoutBackgroundColor,
      dividerLineWidth: jw,
      dividerLineColor: Hw
    },
    filter: {
      panel: {
        titleColor: e.dashboards.panelTitleTextColor,
        backgroundColor: e.dashboards.panelBackgroundColor
      }
    }
  };
  return Ci.withOptions({ mergeArrays: !1 }, Ww(), r);
}
function She(e) {
  return e.dashboards.colorPaletteName;
}
function The(e, t, n) {
  const i = n ? "fonts/" : "resources/base/fonts/";
  return [
    {
      fontFamily: e,
      fontWeight: "normal",
      fontStyle: "normal",
      src: [
        {
          url: `${t}${i}${e}-Regular.eot`
        },
        {
          local: `${e}-Regular`
        },
        {
          url: `${t}${i}${e}-Regular.eot?#iefix`,
          // eslint-disable-next-line sonarjs/no-duplicate-string
          format: "embedded-opentype"
        },
        {
          url: `${t}${i}${e}-Regular.ttf`,
          format: "truetype"
        }
      ]
    },
    {
      fontFamily: e,
      fontWeight: 600,
      fontStyle: "normal",
      src: [
        {
          url: `${t}${i}${e}-SemiBold.eot`
        },
        {
          local: `${e}-SemiBold`
        },
        {
          url: `${t}${i}${e}-SemiBold.eot?#iefix`,
          format: "embedded-opentype"
        },
        {
          url: `${t}${i}${e}-SemiBold.ttf`,
          format: "truetype"
        }
      ]
    },
    {
      fontFamily: e,
      fontWeight: "bold",
      fontStyle: "normal",
      src: [
        {
          url: `${t}${i}${e}-Bold.eot`
        },
        {
          local: `${e}-Bold`
        },
        {
          url: `${t}${i}${e}-Bold.eot?#iefix`,
          format: "embedded-opentype"
        },
        {
          url: `${t}${i}${e}-Bold.ttf`,
          format: "truetype"
        }
      ]
    }
  ];
}
function Ehe(e, t) {
  return Mo(this, null, function* () {
    const n = yield khe(e, t);
    if (!n)
      throw new vt("errors.themeNotFound", { themeOid: e });
    const r = She(n), o = yield Mhe(r, t);
    return Che(n, o, t.url);
  });
}
function khe(e, t) {
  return Mo(this, null, function* () {
    return t.get(`api/v1/themes/${e}`).catch(() => {
      throw new vt("errors.themeNotFound", { themeOid: e });
    });
  });
}
function Mhe(e, t) {
  return Mo(this, null, function* () {
    const n = yield t.get(
      `api/palettes/${e}`
    );
    if (n && "status" in n && n.status === "error")
      throw new vt("errors.paletteNotFound", { paletteName: e });
    return n;
  });
}
function Rhe(e) {
  return "value" in e;
}
function Phe(e) {
  return "valuePromise" in e;
}
const Ohe = (e, t) => {
  const n = /* @__PURE__ */ new Map();
  return { withCache: (i) => (...a) => Mo(void 0, null, function* () {
    const s = e(...a);
    if (n.has(s)) {
      const c = n.get(s);
      if (Rhe(c))
        return c.value;
      if (Phe(c))
        return c.valuePromise;
      throw new vt("errors.unexpectedCacheValue");
    } else {
      const c = i(...a);
      return n.set(s, { valuePromise: c, createdAt: /* @__PURE__ */ new Date() }), c.then((l) => (n.set(s, { value: l, createdAt: /* @__PURE__ */ new Date() }), t != null && t.cacheMaxSize && n.size > t.cacheMaxSize && Nhe(n), l));
    }
  }), clearCache: (i) => {
    if (i) {
      n.delete(i);
      return;
    }
    n.clear();
  } };
};
function Nhe(e) {
  const t = Array.from(e.keys()), n = t.reduce((r, o) => {
    const i = e.get(o), a = e.get(r);
    return i.createdAt < a.createdAt ? o : r;
  }, t[0]);
  e.delete(n);
}
const Vw = (e, t) => {
  const {
    dataSource: n,
    dimensions: r = [],
    measures: o = [],
    filters: i = [],
    filterRelations: a,
    highlights: s = [],
    count: c,
    offset: l,
    ungroup: d
  } = e;
  i && i.forEach((p) => p.isScope = !0), s && s.forEach((p) => p.isScope = !0);
  const f = n || t;
  if (!f)
    throw new vt("errors.executeQueryNoDataSource");
  return {
    dataSource: f,
    attributes: r,
    // internally, dimensions are represented by attributes
    measures: o,
    filters: i,
    filterRelations: a,
    highlights: s,
    count: c,
    offset: l,
    ungroup: d
  };
};
function Cg(e, t, n) {
  const r = Vw(e, t == null ? void 0 : t.defaultDataSource);
  return t.queryClient.executeQuery(r, n).resultPromise.catch((o) => {
    throw o.message.includes(
      "SecondsLevelIsNotSupportedException"
    ) ? new vt("errors.secondsDateTimeLevelSupportedOnlyForLive") : o;
  });
}
const u$e = (e, t, n) => {
  const r = Vw(e, t == null ? void 0 : t.defaultDataSource);
  return t.queryClient.executeCsvQuery(r, n).resultPromise;
}, d$e = (e, t, n) => {
  const {
    dataSource: r,
    rows: o = [],
    columns: i = [],
    values: a = [],
    grandTotals: s = {},
    filters: c = [],
    filterRelations: l,
    highlights: d = [],
    count: f,
    offset: p
  } = e;
  c && c.forEach((v) => v.isScope = !0), d && d.forEach((v) => v.isScope = !0);
  const m = r || (t == null ? void 0 : t.defaultDataSource);
  if (!m)
    throw new vt("errors.executeQueryNoDataSource");
  return t.queryClient.executePivotQuery(
    {
      dataSource: m,
      // internally, for clarity, dimensions for "rows" and "columns"
      // are represented by "rowsAttributes" and "columnsAttributes"
      rowsAttributes: o,
      columnsAttributes: i,
      // internally, "values" is represented by "measures", which is used in JAQL
      measures: a,
      grandTotals: s,
      filters: c,
      filterRelations: l,
      highlights: d,
      count: f,
      offset: p
    },
    n
  ).resultPromise;
}, Ahe = (e) => JSON.stringify(ge(se({}, tz(e, !1)), {
  queryGuid: ""
})), Dhe = (e, t) => {
  const n = Vw(e, t == null ? void 0 : t.defaultDataSource);
  return Ahe(n);
}, Ihe = 250, { withCache: Lhe, clearCache: $he } = Ohe(Dhe, {
  cacheMaxSize: Ihe
}), gI = Lhe(Cg), f$e = $he, vI = ol({
  isInitialized: !1,
  tracking: {
    enabled: !0,
    packageName: "sdk-ui"
  }
}), Gn = () => rl(vI), _M = "composesdk", bI = (e, t, n, r = !1) => {
  const o = Object.assign({ action: e, cat: _M, eventType: "product", direct: !0 }, t);
  return r && (process.env.NODE_ENV === "development" || process.env.NODE_ENV === "test") ? (console.debug("DEBUG: event payload to send", o), Promise.resolve()) : n.post("api/activities/", [o], {
    cache: "no-store",
    redirect: "error",
    referrerPolicy: "same-origin",
    priority: "low"
    // Tracking requests can be low priority
  }).catch((i) => {
    console.error(`unable to log action=${e}, category=${_M}`, i);
  });
}, Fhe = {
  sdkComponentInit: { internal: !0, external: !0 },
  sdkHookInit: { internal: !0, external: !0 },
  sdkError: { internal: !0, external: !1 },
  sdkCliExec: { internal: !0, external: !1 },
  sdkAngularServiceMethodExecuted: { internal: !0, external: !0 }
}, wM = (e, t, n, r, o) => {
  const i = Fhe[`${e}`];
  return i.internal && bI(e, t, n, o), i.external && r && r(se({ action: e }, t)), Promise.resolve();
}, Uw = () => {
  const { tracking: e, app: t } = Gn(), n = bt(
    (o, i = {}, a = !1) => t ? wM(
      o,
      i,
      t.httpClient,
      e.onTrackingEvent,
      a
    ) : Promise.resolve(),
    [e, t]
  ), r = bt(
    (o, i = !1) => {
      if (!t)
        return Promise.resolve();
      const { packageName: a, packageVersion: s, component: c, error: l } = o;
      let d = "";
      return typeof l == "string" ? d = l : l instanceof Error && (d = l.message || l.toString()), wM(
        "sdkError",
        {
          packageName: a,
          packageVersion: s,
          component: c,
          error: d
        },
        t.httpClient,
        e.onTrackingEvent,
        i
      );
    },
    [e, t]
  );
  return {
    trackEvent: n,
    trackError: r
  };
}, zhe = "sdkComponentInit", yI = ol(!1), Bhe = ({
  skipNested: e = !0,
  children: t
}) => /* @__PURE__ */ z(yI.Provider, { value: e, children: t }), Hhe = (e, t) => {
  const { tracking: n } = Gn(), { trackEvent: r } = Uw(), o = rl(yI), i = it(!1);
  mt(() => {
    if (!n)
      return;
    if (!i.current && !o) {
      const s = {
        packageName: n.packageName,
        packageVersion: "1.22.0",
        componentName: e,
        attributesUsed: Object.entries(t).filter(([, c]) => !!c).map(([c]) => c).join(", ")
      };
      r(zhe, s, !n.enabled).finally(
        () => i.current = !0
      );
    }
  }, [e, t, n, o, r]);
};
var jhe = "[object Boolean]";
function _I(e) {
  return e === !0 || e === !1 || sf(e) && xm(e) == jhe;
}
class wI extends af {
  constructor(n) {
    super(n);
    Ln(this, "componentName");
    Ln(this, "context");
    Ln(this, "handler");
    Ln(this, "httpClient");
    Ln(this, "postponedErrors", []);
    this.handler = n.handler, this.componentName = n.componentName;
  }
  componentDidMount() {
    var n;
    this.context.isInitialized && (this.httpClient = (n = this.context.app) == null ? void 0 : n.httpClient);
  }
  componentDidCatch(n) {
    throw this.context.tracking.enabled && (this.httpClient ? this.sendErrorTracking(n) : this.postponedErrors.push(n)), n;
  }
  sendErrorTracking(n) {
    try {
      this.handler({
        packageName: "sdk-ui",
        packageVersion: "1.22.0",
        component: this.componentName,
        error: n
      });
    } catch (r) {
      console.log("Failed to send tracking error event: ", r);
    }
  }
  render() {
    return this.httpClient && this.postponedErrors.length > 0 && this.postponedErrors.forEach((n) => this.sendErrorTracking(n)), this.postponedErrors = [], this.props.children;
  }
}
Ln(wI, "contextType", vI);
const Whe = ({
  componentName: e,
  config: t
}) => {
  const { skip: n, transparent: r } = t || {};
  return (o) => function(a) {
    const { trackError: s } = Uw();
    return _I(n) && n || Sd(n) && n(a) ? /* @__PURE__ */ z(o, se({}, a)) : (Hhe(e, a), // If component is transperent for tracking, nested components will be tracked
    /* @__PURE__ */ z(Bhe, { skipNested: !r, children: /* @__PURE__ */ z(wI, { componentName: e, handler: s, children: /* @__PURE__ */ z(o, se({}, a)) }) }));
  };
}, Vhe = "_container_1wquj_1", Uhe = "_card_1wquj_11", qhe = "_text_1wquj_19", J0 = {
  container: Vhe,
  card: Uhe,
  text: qhe
};
function Ghe({ color: e = "#FFCB05" }) {
  return /* @__PURE__ */ z("svg", { width: "53px", height: "53px", viewBox: "0 0 53 53", children: /* @__PURE__ */ z("g", { stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd", children: /* @__PURE__ */ _e("g", { children: [
    /* @__PURE__ */ z(
      "polygon",
      {
        points: "26.4996 -0.000100000005 -0.000400000001 26.5009 26.4996 52.9999 53.0006 26.5009",
        fill: e
      }
    ),
    /* @__PURE__ */ z(
      "path",
      {
        d: "M24.5,39.054 L24.5,35.054 L28.5,35.054 L28.5,39.054 L24.5,39.054 Z M28.5,31.0536 L24.5,31.0536 L23.5,13.0536 L29.5,13.0536 L28.5,31.0536 Z",
        fill: "#FFFFFF"
      }
    )
  ] }) }) });
}
const xI = ol({ themeSettings: Ww() }), Yn = () => rl(xI), Yhe = ({
  error: e = new vt("errors.componentRenderError")
}) => {
  var p, m, v, g, b, x;
  const { themeSettings: t } = Yn(), { app: n } = Gn(), { t: r } = Bi(), [o, i] = Ge(!1), a = () => {
    i(!0);
  }, s = () => {
    i(!1);
  }, c = /* @__PURE__ */ z("div", { className: "csdk-flex csdk-justify-center csdk-mb-[10px]", children: /* @__PURE__ */ z(Ghe, { color: (p = t == null ? void 0 : t.general) == null ? void 0 : p.brandColor }) }), l = e instanceof P$ ? r(e.key, se({}, e.interpolationOptions)) : r(e instanceof Error ? e.message : e), d = r("errorBoxText", {
    errorMessage: l,
    interpolation: { escapeValue: !1 }
  }), f = (v = (m = n == null ? void 0 : n.settings) == null ? void 0 : m.errorBoundaryConfig) == null ? void 0 : v.alwaysShowErrorText;
  return /* @__PURE__ */ z(
    "div",
    {
      onMouseEnter: f ? void 0 : a,
      onMouseLeave: f ? void 0 : s,
      className: J0.container,
      "aria-label": "error-box",
      children: /* @__PURE__ */ _e(
        "div",
        {
          className: J0.card,
          style: {
            backgroundColor: ((g = t == null ? void 0 : t.general) == null ? void 0 : g.backgroundColor) || "rgba(255,255,255,0.5)"
          },
          children: [
            c,
            (f || o) && /* @__PURE__ */ z(
              "div",
              {
                className: J0.text,
                style: {
                  color: ((b = t == null ? void 0 : t.typography) == null ? void 0 : b.primaryTextColor) || "#5b6372",
                  fontFamily: ((x = t == null ? void 0 : t.typography) == null ? void 0 : x.fontFamily) || "inherit"
                },
                children: d
              }
            )
          ]
        }
      )
    }
  );
};
let Zhe = class extends af {
  constructor(n) {
    var r;
    super(n);
    Ln(this, "showErrorBox", !1);
    Ln(this, "context");
    this.showErrorBox = (r = n.showErrorBox) != null ? r : !!n.resetKeys, this.state = { error: null };
  }
  static getDerivedStateFromError(n) {
    return { error: n };
  }
  componentDidCatch(n) {
    this.setState({ error: n });
  }
  componentDidUpdate(n, r) {
    r.error !== null && Xhe(n.resetKeys, this.props.resetKeys) && this.setState({ error: null });
  }
  render() {
    const n = this.state.error || this.props.error;
    return n && this.showErrorBox ? /* @__PURE__ */ z(Yhe, { error: n }) : this.props.children;
  }
};
function Xhe(e = [], t = []) {
  return e.length !== t.length || e.some((n, r) => !Object.is(n, t[r]));
}
const Khe = () => (e) => function(n) {
  return /* @__PURE__ */ z(Zhe, { resetKeys: Object.values(n), children: /* @__PURE__ */ z(e, se({}, n)) });
}, CI = ({ color: e }) => {
  const t = {
    backgroundColor: e || "#333333",
    float: "left",
    width: "10px",
    height: "10px",
    marginRight: "7px",
    WebkitAnimation: "loading-dots-animation 1.8s infinite ease-in-out",
    animation: "loading-dots-animation 1.8s infinite ease-in-out",
    borderRadius: "50%",
    opacity: 0.75
  }, n = ge(se({}, t), {
    WebkitAnimationDelay: "-0.32s",
    animationDelay: "-0.32s"
  }), r = ge(se({}, t), {
    WebkitAnimationDelay: "-0.16s",
    animationDelay: "-0.16s"
  }), o = ge(se({}, t), {
    marginRight: "unset"
  });
  return /* @__PURE__ */ _e("div", { children: [
    /* @__PURE__ */ z("style", { children: `
          @keyframes loading-dots-animation {
              ${Object.entries({
      "0%, 80%, 100%": {
        WebkitTransform: "scale(0) rotate(0deg)",
        transform: "scale(0) rotate(0deg)"
      },
      "40%": {
        WebkitTransform: "scale(1) rotate(0.02deg)",
        transform: "scale(1) rotate(0.02deg)"
      }
    }).map(
      ([a, s]) => `${a} { ${Object.entries(s).map(([c, l]) => `${c}: ${l};`).join("")} }`
    ).join("")}
            }
            ` }),
    /* @__PURE__ */ z("div", { style: n }),
    /* @__PURE__ */ z("div", { style: r }),
    /* @__PURE__ */ z("div", { style: o })
  ] });
}, qw = ({
  themeSettings: e,
  onCancel: t
}) => {
  const { t: n } = Bi(), r = e != null && e.chart.backgroundColor ? { backgroundColor: e.chart.backgroundColor } : void 0;
  return /* @__PURE__ */ z(
    "div",
    {
      style: r,
      className: "csdk-h-full csdk-bg-white csdk-p-[20px]",
      "aria-label": "csdk-loading-indicator",
      children: /* @__PURE__ */ _e(
        "div",
        {
          style: r,
          className: "csdk-h-full csdk-bg-background-priority csdk-flex csdk-flex-col csdk-gap-y-4 csdk-items-center csdk-justify-center",
          children: [
            /* @__PURE__ */ z(CI, { color: e == null ? void 0 : e.chart.textColor }),
            t && /* @__PURE__ */ z(
              "div",
              {
                className: "csdk-text-ai-sm csdk-text-text-link csdk-cursor-pointer",
                onClick: t,
                children: n("cancel")
              }
            )
          ]
        }
      )
    }
  );
}, Jhe = ({
  shouldSkipSisenseContextWaiting: e,
  customContextErrorMessageKey: t
}) => (n) => function(o) {
  if (Qhe(e, o))
    return /* @__PURE__ */ z(n, se({}, o));
  const { app: i, isInitialized: a } = Gn();
  if (!a) {
    const s = t || "errors.noSisenseContext";
    throw new vt(s);
  }
  return i ? /* @__PURE__ */ z(n, se({}, o)) : /* @__PURE__ */ z(qw, {});
};
function Qhe(e, t) {
  return _I(e) && e || Sd(e) && e(t);
}
function eme() {
  const [e, t] = Ge(null);
  return mt(() => {
    O$().initPromise.then((n) => t(n));
  }, []), e;
}
const tme = ({ children: e, userLanguage: t }) => {
  const n = eme();
  return mt(() => {
    t && (n == null ? void 0 : n.language) !== t && (n == null || n.changeLanguage(t));
  }, [n, t]), n && /* @__PURE__ */ z(LF, { i18n: n, children: e });
}, nme = () => (e) => function(n) {
  const { isInitialized: r } = Gn();
  return r ? /* @__PURE__ */ z(e, se({}, n)) : /* @__PURE__ */ z(tme, { children: /* @__PURE__ */ z(e, se({}, n)) });
}, Gw = ol(null), Sg = () => rl(Gw);
function ot(e, t) {
  if (e == null)
    return {};
  var n = {};
  for (var r in e)
    if (Object.prototype.hasOwnProperty.call(e, r)) {
      if (t.indexOf(r) >= 0)
        continue;
      n[r] = e[r];
    }
  return n;
}
var R1 = { exports: {} }, It = {};
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var xM;
function rme() {
  if (xM)
    return It;
  xM = 1;
  var e = Symbol.for("react.element"), t = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), r = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), i = Symbol.for("react.provider"), a = Symbol.for("react.context"), s = Symbol.for("react.server_context"), c = Symbol.for("react.forward_ref"), l = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), p = Symbol.for("react.lazy"), m = Symbol.for("react.offscreen"), v;
  v = Symbol.for("react.module.reference");
  function g(b) {
    if (typeof b == "object" && b !== null) {
      var x = b.$$typeof;
      switch (x) {
        case e:
          switch (b = b.type, b) {
            case n:
            case o:
            case r:
            case l:
            case d:
              return b;
            default:
              switch (b = b && b.$$typeof, b) {
                case s:
                case a:
                case c:
                case p:
                case f:
                case i:
                  return b;
                default:
                  return x;
              }
          }
        case t:
          return x;
      }
    }
  }
  return It.ContextConsumer = a, It.ContextProvider = i, It.Element = e, It.ForwardRef = c, It.Fragment = n, It.Lazy = p, It.Memo = f, It.Portal = t, It.Profiler = o, It.StrictMode = r, It.Suspense = l, It.SuspenseList = d, It.isAsyncMode = function() {
    return !1;
  }, It.isConcurrentMode = function() {
    return !1;
  }, It.isContextConsumer = function(b) {
    return g(b) === a;
  }, It.isContextProvider = function(b) {
    return g(b) === i;
  }, It.isElement = function(b) {
    return typeof b == "object" && b !== null && b.$$typeof === e;
  }, It.isForwardRef = function(b) {
    return g(b) === c;
  }, It.isFragment = function(b) {
    return g(b) === n;
  }, It.isLazy = function(b) {
    return g(b) === p;
  }, It.isMemo = function(b) {
    return g(b) === f;
  }, It.isPortal = function(b) {
    return g(b) === t;
  }, It.isProfiler = function(b) {
    return g(b) === o;
  }, It.isStrictMode = function(b) {
    return g(b) === r;
  }, It.isSuspense = function(b) {
    return g(b) === l;
  }, It.isSuspenseList = function(b) {
    return g(b) === d;
  }, It.isValidElementType = function(b) {
    return typeof b == "string" || typeof b == "function" || b === n || b === o || b === r || b === l || b === d || b === m || typeof b == "object" && b !== null && (b.$$typeof === p || b.$$typeof === f || b.$$typeof === i || b.$$typeof === a || b.$$typeof === c || b.$$typeof === v || b.getModuleId !== void 0);
  }, It.typeOf = g, It;
}
var Lt = {};
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var CM;
function ome() {
  return CM || (CM = 1, process.env.NODE_ENV !== "production" && function() {
    var e = Symbol.for("react.element"), t = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), r = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), i = Symbol.for("react.provider"), a = Symbol.for("react.context"), s = Symbol.for("react.server_context"), c = Symbol.for("react.forward_ref"), l = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), p = Symbol.for("react.lazy"), m = Symbol.for("react.offscreen"), v = !1, g = !1, b = !1, x = !1, T = !1, S;
    S = Symbol.for("react.module.reference");
    function _(oe) {
      return !!(typeof oe == "string" || typeof oe == "function" || oe === n || oe === o || T || oe === r || oe === l || oe === d || x || oe === m || v || g || b || typeof oe == "object" && oe !== null && (oe.$$typeof === p || oe.$$typeof === f || oe.$$typeof === i || oe.$$typeof === a || oe.$$typeof === c || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      oe.$$typeof === S || oe.getModuleId !== void 0));
    }
    function w(oe) {
      if (typeof oe == "object" && oe !== null) {
        var ve = oe.$$typeof;
        switch (ve) {
          case e:
            var we = oe.type;
            switch (we) {
              case n:
              case o:
              case r:
              case l:
              case d:
                return we;
              default:
                var ye = we && we.$$typeof;
                switch (ye) {
                  case s:
                  case a:
                  case c:
                  case p:
                  case f:
                  case i:
                    return ye;
                  default:
                    return ve;
                }
            }
          case t:
            return ve;
        }
      }
    }
    var k = a, E = i, R = e, P = c, A = n, D = p, N = f, F = t, $ = o, I = r, j = l, U = d, G = !1, V = !1;
    function H(oe) {
      return G || (G = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function q(oe) {
      return V || (V = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function Q(oe) {
      return w(oe) === a;
    }
    function X(oe) {
      return w(oe) === i;
    }
    function K(oe) {
      return typeof oe == "object" && oe !== null && oe.$$typeof === e;
    }
    function J(oe) {
      return w(oe) === c;
    }
    function ne(oe) {
      return w(oe) === n;
    }
    function ae(oe) {
      return w(oe) === p;
    }
    function te(oe) {
      return w(oe) === f;
    }
    function le(oe) {
      return w(oe) === t;
    }
    function ce(oe) {
      return w(oe) === o;
    }
    function fe(oe) {
      return w(oe) === r;
    }
    function ee(oe) {
      return w(oe) === l;
    }
    function me(oe) {
      return w(oe) === d;
    }
    Lt.ContextConsumer = k, Lt.ContextProvider = E, Lt.Element = R, Lt.ForwardRef = P, Lt.Fragment = A, Lt.Lazy = D, Lt.Memo = N, Lt.Portal = F, Lt.Profiler = $, Lt.StrictMode = I, Lt.Suspense = j, Lt.SuspenseList = U, Lt.isAsyncMode = H, Lt.isConcurrentMode = q, Lt.isContextConsumer = Q, Lt.isContextProvider = X, Lt.isElement = K, Lt.isForwardRef = J, Lt.isFragment = ne, Lt.isLazy = ae, Lt.isMemo = te, Lt.isPortal = le, Lt.isProfiler = ce, Lt.isStrictMode = fe, Lt.isSuspense = ee, Lt.isSuspenseList = me, Lt.isValidElementType = _, Lt.typeOf = w;
  }()), Lt;
}
process.env.NODE_ENV === "production" ? R1.exports = rme() : R1.exports = ome();
var Gd = R1.exports, P1 = { exports: {} }, Sp = { exports: {} }, $t = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var SM;
function ime() {
  if (SM)
    return $t;
  SM = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, a = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, c = e ? Symbol.for("react.async_mode") : 60111, l = e ? Symbol.for("react.concurrent_mode") : 60111, d = e ? Symbol.for("react.forward_ref") : 60112, f = e ? Symbol.for("react.suspense") : 60113, p = e ? Symbol.for("react.suspense_list") : 60120, m = e ? Symbol.for("react.memo") : 60115, v = e ? Symbol.for("react.lazy") : 60116, g = e ? Symbol.for("react.block") : 60121, b = e ? Symbol.for("react.fundamental") : 60117, x = e ? Symbol.for("react.responder") : 60118, T = e ? Symbol.for("react.scope") : 60119;
  function S(w) {
    if (typeof w == "object" && w !== null) {
      var k = w.$$typeof;
      switch (k) {
        case t:
          switch (w = w.type, w) {
            case c:
            case l:
            case r:
            case i:
            case o:
            case f:
              return w;
            default:
              switch (w = w && w.$$typeof, w) {
                case s:
                case d:
                case v:
                case m:
                case a:
                  return w;
                default:
                  return k;
              }
          }
        case n:
          return k;
      }
    }
  }
  function _(w) {
    return S(w) === l;
  }
  return $t.AsyncMode = c, $t.ConcurrentMode = l, $t.ContextConsumer = s, $t.ContextProvider = a, $t.Element = t, $t.ForwardRef = d, $t.Fragment = r, $t.Lazy = v, $t.Memo = m, $t.Portal = n, $t.Profiler = i, $t.StrictMode = o, $t.Suspense = f, $t.isAsyncMode = function(w) {
    return _(w) || S(w) === c;
  }, $t.isConcurrentMode = _, $t.isContextConsumer = function(w) {
    return S(w) === s;
  }, $t.isContextProvider = function(w) {
    return S(w) === a;
  }, $t.isElement = function(w) {
    return typeof w == "object" && w !== null && w.$$typeof === t;
  }, $t.isForwardRef = function(w) {
    return S(w) === d;
  }, $t.isFragment = function(w) {
    return S(w) === r;
  }, $t.isLazy = function(w) {
    return S(w) === v;
  }, $t.isMemo = function(w) {
    return S(w) === m;
  }, $t.isPortal = function(w) {
    return S(w) === n;
  }, $t.isProfiler = function(w) {
    return S(w) === i;
  }, $t.isStrictMode = function(w) {
    return S(w) === o;
  }, $t.isSuspense = function(w) {
    return S(w) === f;
  }, $t.isValidElementType = function(w) {
    return typeof w == "string" || typeof w == "function" || w === r || w === l || w === i || w === o || w === f || w === p || typeof w == "object" && w !== null && (w.$$typeof === v || w.$$typeof === m || w.$$typeof === a || w.$$typeof === s || w.$$typeof === d || w.$$typeof === b || w.$$typeof === x || w.$$typeof === T || w.$$typeof === g);
  }, $t.typeOf = S, $t;
}
var Ft = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var TM;
function ame() {
  return TM || (TM = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, a = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, c = e ? Symbol.for("react.async_mode") : 60111, l = e ? Symbol.for("react.concurrent_mode") : 60111, d = e ? Symbol.for("react.forward_ref") : 60112, f = e ? Symbol.for("react.suspense") : 60113, p = e ? Symbol.for("react.suspense_list") : 60120, m = e ? Symbol.for("react.memo") : 60115, v = e ? Symbol.for("react.lazy") : 60116, g = e ? Symbol.for("react.block") : 60121, b = e ? Symbol.for("react.fundamental") : 60117, x = e ? Symbol.for("react.responder") : 60118, T = e ? Symbol.for("react.scope") : 60119;
    function S(ee) {
      return typeof ee == "string" || typeof ee == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      ee === r || ee === l || ee === i || ee === o || ee === f || ee === p || typeof ee == "object" && ee !== null && (ee.$$typeof === v || ee.$$typeof === m || ee.$$typeof === a || ee.$$typeof === s || ee.$$typeof === d || ee.$$typeof === b || ee.$$typeof === x || ee.$$typeof === T || ee.$$typeof === g);
    }
    function _(ee) {
      if (typeof ee == "object" && ee !== null) {
        var me = ee.$$typeof;
        switch (me) {
          case t:
            var oe = ee.type;
            switch (oe) {
              case c:
              case l:
              case r:
              case i:
              case o:
              case f:
                return oe;
              default:
                var ve = oe && oe.$$typeof;
                switch (ve) {
                  case s:
                  case d:
                  case v:
                  case m:
                  case a:
                    return ve;
                  default:
                    return me;
                }
            }
          case n:
            return me;
        }
      }
    }
    var w = c, k = l, E = s, R = a, P = t, A = d, D = r, N = v, F = m, $ = n, I = i, j = o, U = f, G = !1;
    function V(ee) {
      return G || (G = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), H(ee) || _(ee) === c;
    }
    function H(ee) {
      return _(ee) === l;
    }
    function q(ee) {
      return _(ee) === s;
    }
    function Q(ee) {
      return _(ee) === a;
    }
    function X(ee) {
      return typeof ee == "object" && ee !== null && ee.$$typeof === t;
    }
    function K(ee) {
      return _(ee) === d;
    }
    function J(ee) {
      return _(ee) === r;
    }
    function ne(ee) {
      return _(ee) === v;
    }
    function ae(ee) {
      return _(ee) === m;
    }
    function te(ee) {
      return _(ee) === n;
    }
    function le(ee) {
      return _(ee) === i;
    }
    function ce(ee) {
      return _(ee) === o;
    }
    function fe(ee) {
      return _(ee) === f;
    }
    Ft.AsyncMode = w, Ft.ConcurrentMode = k, Ft.ContextConsumer = E, Ft.ContextProvider = R, Ft.Element = P, Ft.ForwardRef = A, Ft.Fragment = D, Ft.Lazy = N, Ft.Memo = F, Ft.Portal = $, Ft.Profiler = I, Ft.StrictMode = j, Ft.Suspense = U, Ft.isAsyncMode = V, Ft.isConcurrentMode = H, Ft.isContextConsumer = q, Ft.isContextProvider = Q, Ft.isElement = X, Ft.isForwardRef = K, Ft.isFragment = J, Ft.isLazy = ne, Ft.isMemo = ae, Ft.isPortal = te, Ft.isProfiler = le, Ft.isStrictMode = ce, Ft.isSuspense = fe, Ft.isValidElementType = S, Ft.typeOf = _;
  }()), Ft;
}
var EM;
function SI() {
  return EM || (EM = 1, process.env.NODE_ENV === "production" ? Sp.exports = ime() : Sp.exports = ame()), Sp.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var Q0, kM;
function sme() {
  if (kM)
    return Q0;
  kM = 1;
  var e = Object.getOwnPropertySymbols, t = Object.prototype.hasOwnProperty, n = Object.prototype.propertyIsEnumerable;
  function r(i) {
    if (i == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(i);
  }
  function o() {
    try {
      if (!Object.assign)
        return !1;
      var i = new String("abc");
      if (i[5] = "de", Object.getOwnPropertyNames(i)[0] === "5")
        return !1;
      for (var a = {}, s = 0; s < 10; s++)
        a["_" + String.fromCharCode(s)] = s;
      var c = Object.getOwnPropertyNames(a).map(function(d) {
        return a[d];
      });
      if (c.join("") !== "0123456789")
        return !1;
      var l = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(d) {
        l[d] = d;
      }), Object.keys(Object.assign({}, l)).join("") === "abcdefghijklmnopqrst";
    } catch (d) {
      return !1;
    }
  }
  return Q0 = o() ? Object.assign : function(i, a) {
    for (var s, c = r(i), l, d = 1; d < arguments.length; d++) {
      s = Object(arguments[d]);
      for (var f in s)
        t.call(s, f) && (c[f] = s[f]);
      if (e) {
        l = e(s);
        for (var p = 0; p < l.length; p++)
          n.call(s, l[p]) && (c[l[p]] = s[l[p]]);
      }
    }
    return c;
  }, Q0;
}
var eb, MM;
function Yw() {
  if (MM)
    return eb;
  MM = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return eb = e, eb;
}
var tb, RM;
function TI() {
  return RM || (RM = 1, tb = Function.call.bind(Object.prototype.hasOwnProperty)), tb;
}
var nb, PM;
function lme() {
  if (PM)
    return nb;
  PM = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var t = Yw(), n = {}, r = TI();
    e = function(i) {
      var a = "Warning: " + i;
      typeof console != "undefined" && console.error(a);
      try {
        throw new Error(a);
      } catch (s) {
      }
    };
  }
  function o(i, a, s, c, l) {
    if (process.env.NODE_ENV !== "production") {
      for (var d in i)
        if (r(i, d)) {
          var f;
          try {
            if (typeof i[d] != "function") {
              var p = Error(
                (c || "React class") + ": " + s + " type `" + d + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof i[d] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw p.name = "Invariant Violation", p;
            }
            f = i[d](a, d, c, s, null, t);
          } catch (v) {
            f = v;
          }
          if (f && !(f instanceof Error) && e(
            (c || "React class") + ": type specification of " + s + " `" + d + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof f + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), f instanceof Error && !(f.message in n)) {
            n[f.message] = !0;
            var m = l ? l() : "";
            e(
              "Failed " + s + " type: " + f.message + (m != null ? m : "")
            );
          }
        }
    }
  }
  return o.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (n = {});
  }, nb = o, nb;
}
var rb, OM;
function cme() {
  if (OM)
    return rb;
  OM = 1;
  var e = SI(), t = sme(), n = Yw(), r = TI(), o = lme(), i = function() {
  };
  process.env.NODE_ENV !== "production" && (i = function(s) {
    var c = "Warning: " + s;
    typeof console != "undefined" && console.error(c);
    try {
      throw new Error(c);
    } catch (l) {
    }
  });
  function a() {
    return null;
  }
  return rb = function(s, c) {
    var l = typeof Symbol == "function" && Symbol.iterator, d = "@@iterator";
    function f(H) {
      var q = H && (l && H[l] || H[d]);
      if (typeof q == "function")
        return q;
    }
    var p = "<<anonymous>>", m = {
      array: x("array"),
      bigint: x("bigint"),
      bool: x("boolean"),
      func: x("function"),
      number: x("number"),
      object: x("object"),
      string: x("string"),
      symbol: x("symbol"),
      any: T(),
      arrayOf: S,
      element: _(),
      elementType: w(),
      instanceOf: k,
      node: A(),
      objectOf: R,
      oneOf: E,
      oneOfType: P,
      shape: N,
      exact: F
    };
    function v(H, q) {
      return H === q ? H !== 0 || 1 / H === 1 / q : H !== H && q !== q;
    }
    function g(H, q) {
      this.message = H, this.data = q && typeof q == "object" ? q : {}, this.stack = "";
    }
    g.prototype = Error.prototype;
    function b(H) {
      if (process.env.NODE_ENV !== "production")
        var q = {}, Q = 0;
      function X(J, ne, ae, te, le, ce, fe) {
        if (te = te || p, ce = ce || ae, fe !== n) {
          if (c) {
            var ee = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw ee.name = "Invariant Violation", ee;
          } else if (process.env.NODE_ENV !== "production" && typeof console != "undefined") {
            var me = te + ":" + ae;
            !q[me] && // Avoid spamming the console because they are often not actionable except for lib authors
            Q < 3 && (i(
              "You are manually calling a React.PropTypes validation function for the `" + ce + "` prop on `" + te + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), q[me] = !0, Q++);
          }
        }
        return ne[ae] == null ? J ? ne[ae] === null ? new g("The " + le + " `" + ce + "` is marked as required " + ("in `" + te + "`, but its value is `null`.")) : new g("The " + le + " `" + ce + "` is marked as required in " + ("`" + te + "`, but its value is `undefined`.")) : null : H(ne, ae, te, le, ce);
      }
      var K = X.bind(null, !1);
      return K.isRequired = X.bind(null, !0), K;
    }
    function x(H) {
      function q(Q, X, K, J, ne, ae) {
        var te = Q[X], le = j(te);
        if (le !== H) {
          var ce = U(te);
          return new g(
            "Invalid " + J + " `" + ne + "` of type " + ("`" + ce + "` supplied to `" + K + "`, expected ") + ("`" + H + "`."),
            { expectedType: H }
          );
        }
        return null;
      }
      return b(q);
    }
    function T() {
      return b(a);
    }
    function S(H) {
      function q(Q, X, K, J, ne) {
        if (typeof H != "function")
          return new g("Property `" + ne + "` of component `" + K + "` has invalid PropType notation inside arrayOf.");
        var ae = Q[X];
        if (!Array.isArray(ae)) {
          var te = j(ae);
          return new g("Invalid " + J + " `" + ne + "` of type " + ("`" + te + "` supplied to `" + K + "`, expected an array."));
        }
        for (var le = 0; le < ae.length; le++) {
          var ce = H(ae, le, K, J, ne + "[" + le + "]", n);
          if (ce instanceof Error)
            return ce;
        }
        return null;
      }
      return b(q);
    }
    function _() {
      function H(q, Q, X, K, J) {
        var ne = q[Q];
        if (!s(ne)) {
          var ae = j(ne);
          return new g("Invalid " + K + " `" + J + "` of type " + ("`" + ae + "` supplied to `" + X + "`, expected a single ReactElement."));
        }
        return null;
      }
      return b(H);
    }
    function w() {
      function H(q, Q, X, K, J) {
        var ne = q[Q];
        if (!e.isValidElementType(ne)) {
          var ae = j(ne);
          return new g("Invalid " + K + " `" + J + "` of type " + ("`" + ae + "` supplied to `" + X + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return b(H);
    }
    function k(H) {
      function q(Q, X, K, J, ne) {
        if (!(Q[X] instanceof H)) {
          var ae = H.name || p, te = V(Q[X]);
          return new g("Invalid " + J + " `" + ne + "` of type " + ("`" + te + "` supplied to `" + K + "`, expected ") + ("instance of `" + ae + "`."));
        }
        return null;
      }
      return b(q);
    }
    function E(H) {
      if (!Array.isArray(H))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? i(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : i("Invalid argument supplied to oneOf, expected an array.")), a;
      function q(Q, X, K, J, ne) {
        for (var ae = Q[X], te = 0; te < H.length; te++)
          if (v(ae, H[te]))
            return null;
        var le = JSON.stringify(H, function(fe, ee) {
          var me = U(ee);
          return me === "symbol" ? String(ee) : ee;
        });
        return new g("Invalid " + J + " `" + ne + "` of value `" + String(ae) + "` " + ("supplied to `" + K + "`, expected one of " + le + "."));
      }
      return b(q);
    }
    function R(H) {
      function q(Q, X, K, J, ne) {
        if (typeof H != "function")
          return new g("Property `" + ne + "` of component `" + K + "` has invalid PropType notation inside objectOf.");
        var ae = Q[X], te = j(ae);
        if (te !== "object")
          return new g("Invalid " + J + " `" + ne + "` of type " + ("`" + te + "` supplied to `" + K + "`, expected an object."));
        for (var le in ae)
          if (r(ae, le)) {
            var ce = H(ae, le, K, J, ne + "." + le, n);
            if (ce instanceof Error)
              return ce;
          }
        return null;
      }
      return b(q);
    }
    function P(H) {
      if (!Array.isArray(H))
        return process.env.NODE_ENV !== "production" && i("Invalid argument supplied to oneOfType, expected an instance of array."), a;
      for (var q = 0; q < H.length; q++) {
        var Q = H[q];
        if (typeof Q != "function")
          return i(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + G(Q) + " at index " + q + "."
          ), a;
      }
      function X(K, J, ne, ae, te) {
        for (var le = [], ce = 0; ce < H.length; ce++) {
          var fe = H[ce], ee = fe(K, J, ne, ae, te, n);
          if (ee == null)
            return null;
          ee.data && r(ee.data, "expectedType") && le.push(ee.data.expectedType);
        }
        var me = le.length > 0 ? ", expected one of type [" + le.join(", ") + "]" : "";
        return new g("Invalid " + ae + " `" + te + "` supplied to " + ("`" + ne + "`" + me + "."));
      }
      return b(X);
    }
    function A() {
      function H(q, Q, X, K, J) {
        return $(q[Q]) ? null : new g("Invalid " + K + " `" + J + "` supplied to " + ("`" + X + "`, expected a ReactNode."));
      }
      return b(H);
    }
    function D(H, q, Q, X, K) {
      return new g(
        (H || "React class") + ": " + q + " type `" + Q + "." + X + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + K + "`."
      );
    }
    function N(H) {
      function q(Q, X, K, J, ne) {
        var ae = Q[X], te = j(ae);
        if (te !== "object")
          return new g("Invalid " + J + " `" + ne + "` of type `" + te + "` " + ("supplied to `" + K + "`, expected `object`."));
        for (var le in H) {
          var ce = H[le];
          if (typeof ce != "function")
            return D(K, J, ne, le, U(ce));
          var fe = ce(ae, le, K, J, ne + "." + le, n);
          if (fe)
            return fe;
        }
        return null;
      }
      return b(q);
    }
    function F(H) {
      function q(Q, X, K, J, ne) {
        var ae = Q[X], te = j(ae);
        if (te !== "object")
          return new g("Invalid " + J + " `" + ne + "` of type `" + te + "` " + ("supplied to `" + K + "`, expected `object`."));
        var le = t({}, Q[X], H);
        for (var ce in le) {
          var fe = H[ce];
          if (r(H, ce) && typeof fe != "function")
            return D(K, J, ne, ce, U(fe));
          if (!fe)
            return new g(
              "Invalid " + J + " `" + ne + "` key `" + ce + "` supplied to `" + K + "`.\nBad object: " + JSON.stringify(Q[X], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(H), null, "  ")
            );
          var ee = fe(ae, ce, K, J, ne + "." + ce, n);
          if (ee)
            return ee;
        }
        return null;
      }
      return b(q);
    }
    function $(H) {
      switch (typeof H) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !H;
        case "object":
          if (Array.isArray(H))
            return H.every($);
          if (H === null || s(H))
            return !0;
          var q = f(H);
          if (q) {
            var Q = q.call(H), X;
            if (q !== H.entries) {
              for (; !(X = Q.next()).done; )
                if (!$(X.value))
                  return !1;
            } else
              for (; !(X = Q.next()).done; ) {
                var K = X.value;
                if (K && !$(K[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function I(H, q) {
      return H === "symbol" ? !0 : q ? q["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && q instanceof Symbol : !1;
    }
    function j(H) {
      var q = typeof H;
      return Array.isArray(H) ? "array" : H instanceof RegExp ? "object" : I(q, H) ? "symbol" : q;
    }
    function U(H) {
      if (typeof H == "undefined" || H === null)
        return "" + H;
      var q = j(H);
      if (q === "object") {
        if (H instanceof Date)
          return "date";
        if (H instanceof RegExp)
          return "regexp";
      }
      return q;
    }
    function G(H) {
      var q = U(H);
      switch (q) {
        case "array":
        case "object":
          return "an " + q;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + q;
        default:
          return q;
      }
    }
    function V(H) {
      return !H.constructor || !H.constructor.name ? p : H.constructor.name;
    }
    return m.checkPropTypes = o, m.resetWarningCache = o.resetWarningCache, m.PropTypes = m, m;
  }, rb;
}
var ob, NM;
function ume() {
  if (NM)
    return ob;
  NM = 1;
  var e = Yw();
  function t() {
  }
  function n() {
  }
  return n.resetWarningCache = t, ob = function() {
    function r(a, s, c, l, d, f) {
      if (f !== e) {
        var p = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw p.name = "Invariant Violation", p;
      }
    }
    r.isRequired = r;
    function o() {
      return r;
    }
    var i = {
      array: r,
      bigint: r,
      bool: r,
      func: r,
      number: r,
      object: r,
      string: r,
      symbol: r,
      any: r,
      arrayOf: o,
      element: r,
      elementType: r,
      instanceOf: o,
      node: r,
      objectOf: o,
      oneOf: o,
      oneOfType: o,
      shape: o,
      exact: o,
      checkPropTypes: n,
      resetWarningCache: t
    };
    return i.PropTypes = i, i;
  }, ob;
}
if (process.env.NODE_ENV !== "production") {
  var dme = SI(), fme = !0;
  P1.exports = cme()(dme.isElement, fme);
} else
  P1.exports = ume()();
var Jr = P1.exports;
const M = /* @__PURE__ */ ya(Jr);
function EI(e) {
  var t, n, r = "";
  if (typeof e == "string" || typeof e == "number")
    r += e;
  else if (typeof e == "object")
    if (Array.isArray(e)) {
      var o = e.length;
      for (t = 0; t < o; t++)
        e[t] && (n = EI(e[t])) && (r && (r += " "), r += n);
    } else
      for (n in e)
        e[n] && (r && (r += " "), r += n);
  return r;
}
function lt() {
  for (var e, t, n = 0, r = "", o = arguments.length; n < o; n++)
    (e = arguments[n]) && (t = EI(e)) && (r && (r += " "), r += t);
  return r;
}
function Pn(e, t, n = void 0) {
  const r = {};
  return Object.keys(e).forEach(
    // `Object.keys(slots)` can't be wider than `T` because we infer `T` from `slots`.
    // @ts-expect-error https://github.com/microsoft/TypeScript/pull/12253#issuecomment-263132208
    (o) => {
      r[o] = e[o].reduce((i, a) => {
        if (a) {
          const s = t(a);
          s !== "" && i.push(s), n && n[a] && i.push(n[a]);
        }
        return i;
      }, []).join(" ");
    }
  ), r;
}
function ma(e, t, n, r, o) {
  if (process.env.NODE_ENV === "production")
    return null;
  const i = e[t], a = o || t;
  return i == null ? null : i && i.nodeType !== 1 ? new Error(`Invalid ${r} \`${a}\` supplied to \`${n}\`. Expected an HTMLElement.`) : null;
}
const pme = /* @__PURE__ */ B.createContext(), Zw = () => {
  const e = B.useContext(pme);
  return e != null ? e : !1;
};
function O1(e, t) {
  typeof e == "function" ? e(t) : e && (e.current = t);
}
function Kr(...e) {
  return B.useMemo(() => e.every((t) => t == null) ? null : (t) => {
    e.forEach((n) => {
      O1(n, t);
    });
  }, e);
}
function kI(e) {
  return typeof e == "string";
}
function nd(e, t, n) {
  return e === void 0 || kI(e) ? t : ue({}, t, {
    ownerState: ue({}, t.ownerState, n)
  });
}
function MI(e, t = []) {
  if (e === void 0)
    return {};
  const n = {};
  return Object.keys(e).filter((r) => r.match(/^on[A-Z]/) && typeof e[r] == "function" && !t.includes(r)).forEach((r) => {
    n[r] = e[r];
  }), n;
}
function AM(e) {
  if (e === void 0)
    return {};
  const t = {};
  return Object.keys(e).filter((n) => !(n.match(/^on[A-Z]/) && typeof e[n] == "function")).forEach((n) => {
    t[n] = e[n];
  }), t;
}
function hme(e) {
  const {
    getSlotProps: t,
    additionalProps: n,
    externalSlotProps: r,
    externalForwardedProps: o,
    className: i
  } = e;
  if (!t) {
    const m = lt(n == null ? void 0 : n.className, i, o == null ? void 0 : o.className, r == null ? void 0 : r.className), v = ue({}, n == null ? void 0 : n.style, o == null ? void 0 : o.style, r == null ? void 0 : r.style), g = ue({}, n, o, r);
    return m.length > 0 && (g.className = m), Object.keys(v).length > 0 && (g.style = v), {
      props: g,
      internalRef: void 0
    };
  }
  const a = MI(ue({}, o, r)), s = AM(r), c = AM(o), l = t(a), d = lt(l == null ? void 0 : l.className, n == null ? void 0 : n.className, i, o == null ? void 0 : o.className, r == null ? void 0 : r.className), f = ue({}, l == null ? void 0 : l.style, n == null ? void 0 : n.style, o == null ? void 0 : o.style, r == null ? void 0 : r.style), p = ue({}, l, n, c, s);
  return d.length > 0 && (p.className = d), Object.keys(f).length > 0 && (p.style = f), {
    props: p,
    internalRef: l.ref
  };
}
function mme(e, t, n) {
  return typeof e == "function" ? e(t, n) : e;
}
const gme = ["elementType", "externalSlotProps", "ownerState", "skipResolvingSlotProps"];
function cs(e) {
  var t;
  const {
    elementType: n,
    externalSlotProps: r,
    ownerState: o,
    skipResolvingSlotProps: i = !1
  } = e, a = ot(e, gme), s = i ? {} : mme(r, o), {
    props: c,
    internalRef: l
  } = hme(ue({}, a, {
    externalSlotProps: s
  })), d = Kr(l, s == null ? void 0 : s.ref, (t = e.additionalProps) == null ? void 0 : t.ref);
  return nd(n, ue({}, c, {
    ref: d
  }), o);
}
function qr(e) {
  return e && e.ownerDocument || document;
}
var xf = {};
const vme = /* @__PURE__ */ Go(IF);
var ib = { exports: {} }, DM;
function bme() {
  return DM || (DM = 1, function(e) {
    function t(n, r) {
      if (n == null)
        return {};
      var o = {};
      for (var i in n)
        if (Object.prototype.hasOwnProperty.call(n, i)) {
          if (r.indexOf(i) >= 0)
            continue;
          o[i] = n[i];
        }
      return o;
    }
    e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(ib)), ib.exports;
}
let N1;
typeof document == "object" && (N1 = BO({
  key: "css",
  prepend: !0
}));
function RI(e) {
  const {
    injectFirst: t,
    children: n
  } = e;
  return t && N1 ? /* @__PURE__ */ z(UO, {
    value: N1,
    children: n
  }) : n;
}
process.env.NODE_ENV !== "production" && (RI.propTypes = {
  /**
   * Your component tree.
   */
  children: M.node,
  /**
   * By default, the styles are injected last in the <head> element of the page.
   * As a result, they gain more specificity than any other style sheet.
   * If you want to override MUI's styles, set this prop.
   */
  injectFirst: M.bool
});
function yme(e) {
  return e == null || Object.keys(e).length === 0;
}
function PI(e) {
  const {
    styles: t,
    defaultTheme: n = {}
  } = e;
  return /* @__PURE__ */ z(P_, {
    styles: typeof t == "function" ? (o) => t(yme(o) ? n : o) : t
  });
}
process.env.NODE_ENV !== "production" && (PI.propTypes = {
  defaultTheme: M.object,
  styles: M.oneOfType([M.array, M.string, M.object, M.func])
});
/**
 * @mui/styled-engine v5.16.6
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
function _me(e, t) {
  const n = Fo(e, t);
  return process.env.NODE_ENV !== "production" ? (...r) => {
    const o = typeof e == "string" ? `"${e}"` : "component";
    return r.length === 0 ? console.error([`MUI: Seems like you called \`styled(${o})()\` without a \`style\` argument.`, 'You must provide a `styles` argument: `styled("div")(styleYouForgotToPass)`.'].join(`
`)) : r.some((i) => i === void 0) && console.error(`MUI: the styled(${o})(...args) API requires all its args to be defined.`), n(...r);
  } : n;
}
const wme = (e, t) => {
  Array.isArray(e.__emotion_styles) && (e.__emotion_styles = t(e.__emotion_styles));
}, xme = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  GlobalStyles: PI,
  StyledEngineProvider: RI,
  ThemeContext: Hi,
  css: ra,
  default: _me,
  internal_processStyles: wme,
  keyframes: us
}, Symbol.toStringTag, { value: "Module" })), OI = /* @__PURE__ */ Go(xme);
function Va(e) {
  if (typeof e != "object" || e === null)
    return !1;
  const t = Object.getPrototypeOf(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}
function NI(e) {
  if (!Va(e))
    return e;
  const t = {};
  return Object.keys(e).forEach((n) => {
    t[n] = NI(e[n]);
  }), t;
}
function Yd(e, t, n = {
  clone: !0
}) {
  const r = n.clone ? ue({}, e) : e;
  return Va(e) && Va(t) && Object.keys(t).forEach((o) => {
    Va(t[o]) && // Avoid prototype pollution
    Object.prototype.hasOwnProperty.call(e, o) && Va(e[o]) ? r[o] = Yd(e[o], t[o], n) : n.clone ? r[o] = Va(t[o]) ? NI(t[o]) : t[o] : r[o] = t[o];
  }), r;
}
const Cme = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Yd,
  isPlainObject: Va
}, Symbol.toStringTag, { value: "Module" })), Sme = /* @__PURE__ */ Go(Cme);
function AI(e) {
  let t = "https://mui.com/production-error/?code=" + e;
  for (let n = 1; n < arguments.length; n += 1)
    t += "&args[]=" + encodeURIComponent(arguments[n]);
  return "Minified MUI error #" + e + "; visit " + t + " for the full message.";
}
const Tme = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: AI
}, Symbol.toStringTag, { value: "Module" }));
function Xw(e) {
  if (typeof e != "string")
    throw new Error(process.env.NODE_ENV !== "production" ? "MUI: `capitalize(string)` expects a string argument." : AI(7));
  return e.charAt(0).toUpperCase() + e.slice(1);
}
const Eme = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Xw
}, Symbol.toStringTag, { value: "Module" })), kme = /* @__PURE__ */ Go(Eme), Mme = /^\s*function(?:\s|\s*\/\*.*\*\/\s*)+([^(\s/]*)\s*/;
function DI(e) {
  const t = `${e}`.match(Mme);
  return t && t[1] || "";
}
function II(e, t = "") {
  return e.displayName || e.name || DI(e) || t;
}
function IM(e, t, n) {
  const r = II(t);
  return e.displayName || (r !== "" ? `${n}(${r})` : n);
}
function Rme(e) {
  if (e != null) {
    if (typeof e == "string")
      return e;
    if (typeof e == "function")
      return II(e, "Component");
    if (typeof e == "object")
      switch (e.$$typeof) {
        case Gd.ForwardRef:
          return IM(e, e.render, "ForwardRef");
        case Gd.Memo:
          return IM(e, e.type, "memo");
        default:
          return;
      }
  }
}
const Pme = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Rme,
  getFunctionName: DI
}, Symbol.toStringTag, { value: "Module" })), Ome = /* @__PURE__ */ Go(Pme), Nme = ["values", "unit", "step"], Ame = (e) => {
  const t = Object.keys(e).map((n) => ({
    key: n,
    val: e[n]
  })) || [];
  return t.sort((n, r) => n.val - r.val), t.reduce((n, r) => ue({}, n, {
    [r.key]: r.val
  }), {});
};
function LI(e) {
  const {
    // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values: t = {
      xs: 0,
      // phone
      sm: 600,
      // tablet
      md: 900,
      // small laptop
      lg: 1200,
      // desktop
      xl: 1536
      // large screen
    },
    unit: n = "px",
    step: r = 5
  } = e, o = ot(e, Nme), i = Ame(t), a = Object.keys(i);
  function s(p) {
    return `@media (min-width:${typeof t[p] == "number" ? t[p] : p}${n})`;
  }
  function c(p) {
    return `@media (max-width:${(typeof t[p] == "number" ? t[p] : p) - r / 100}${n})`;
  }
  function l(p, m) {
    const v = a.indexOf(m);
    return `@media (min-width:${typeof t[p] == "number" ? t[p] : p}${n}) and (max-width:${(v !== -1 && typeof t[a[v]] == "number" ? t[a[v]] : m) - r / 100}${n})`;
  }
  function d(p) {
    return a.indexOf(p) + 1 < a.length ? l(p, a[a.indexOf(p) + 1]) : s(p);
  }
  function f(p) {
    const m = a.indexOf(p);
    return m === 0 ? s(a[1]) : m === a.length - 1 ? c(a[m]) : l(p, a[a.indexOf(p) + 1]).replace("@media", "@media not all and");
  }
  return ue({
    keys: a,
    values: i,
    up: s,
    down: c,
    between: l,
    only: d,
    not: f,
    unit: n
  }, o);
}
const Dme = {
  borderRadius: 4
}, gs = process.env.NODE_ENV !== "production" ? M.oneOfType([M.number, M.string, M.object, M.array]) : {};
function _d(e, t) {
  return t ? Yd(e, t, {
    clone: !1
    // No need to clone deep, it's way faster.
  }) : e;
}
const Kw = {
  xs: 0,
  // phone
  sm: 600,
  // tablet
  md: 900,
  // small laptop
  lg: 1200,
  // desktop
  xl: 1536
  // large screen
}, LM = {
  // Sorted ASC by size. That's important.
  // It can't be configured as it's used statically for propTypes.
  keys: ["xs", "sm", "md", "lg", "xl"],
  up: (e) => `@media (min-width:${Kw[e]}px)`
};
function ga(e, t, n) {
  const r = e.theme || {};
  if (Array.isArray(t)) {
    const i = r.breakpoints || LM;
    return t.reduce((a, s, c) => (a[i.up(i.keys[c])] = n(t[c]), a), {});
  }
  if (typeof t == "object") {
    const i = r.breakpoints || LM;
    return Object.keys(t).reduce((a, s) => {
      if (Object.keys(i.values || Kw).indexOf(s) !== -1) {
        const c = i.up(s);
        a[c] = n(t[s], s);
      } else {
        const c = s;
        a[c] = t[c];
      }
      return a;
    }, {});
  }
  return n(t);
}
function Ime(e = {}) {
  var t;
  return ((t = e.keys) == null ? void 0 : t.reduce((r, o) => {
    const i = e.up(o);
    return r[i] = {}, r;
  }, {})) || {};
}
function Lme(e, t) {
  return e.reduce((n, r) => {
    const o = n[r];
    return (!o || Object.keys(o).length === 0) && delete n[r], n;
  }, t);
}
function Tg(e, t, n = !0) {
  if (!t || typeof t != "string")
    return null;
  if (e && e.vars && n) {
    const r = `vars.${t}`.split(".").reduce((o, i) => o && o[i] ? o[i] : null, e);
    if (r != null)
      return r;
  }
  return t.split(".").reduce((r, o) => r && r[o] != null ? r[o] : null, e);
}
function im(e, t, n, r = n) {
  let o;
  return typeof e == "function" ? o = e(n) : Array.isArray(e) ? o = e[n] || r : o = Tg(e, n) || r, t && (o = t(o, r, e)), o;
}
function On(e) {
  const {
    prop: t,
    cssProperty: n = e.prop,
    themeKey: r,
    transform: o
  } = e, i = (a) => {
    if (a[t] == null)
      return null;
    const s = a[t], c = a.theme, l = Tg(c, r) || {};
    return ga(a, s, (f) => {
      let p = im(l, o, f);
      return f === p && typeof f == "string" && (p = im(l, o, `${t}${f === "default" ? "" : Xw(f)}`, f)), n === !1 ? p : {
        [n]: p
      };
    });
  };
  return i.propTypes = process.env.NODE_ENV !== "production" ? {
    [t]: gs
  } : {}, i.filterProps = [t], i;
}
function $me(e) {
  const t = {};
  return (n) => (t[n] === void 0 && (t[n] = e(n)), t[n]);
}
const Fme = {
  m: "margin",
  p: "padding"
}, zme = {
  t: "Top",
  r: "Right",
  b: "Bottom",
  l: "Left",
  x: ["Left", "Right"],
  y: ["Top", "Bottom"]
}, $M = {
  marginX: "mx",
  marginY: "my",
  paddingX: "px",
  paddingY: "py"
}, Bme = $me((e) => {
  if (e.length > 2)
    if ($M[e])
      e = $M[e];
    else
      return [e];
  const [t, n] = e.split(""), r = Fme[t], o = zme[n] || "";
  return Array.isArray(o) ? o.map((i) => r + i) : [r + o];
}), Eg = ["m", "mt", "mr", "mb", "ml", "mx", "my", "margin", "marginTop", "marginRight", "marginBottom", "marginLeft", "marginX", "marginY", "marginInline", "marginInlineStart", "marginInlineEnd", "marginBlock", "marginBlockStart", "marginBlockEnd"], kg = ["p", "pt", "pr", "pb", "pl", "px", "py", "padding", "paddingTop", "paddingRight", "paddingBottom", "paddingLeft", "paddingX", "paddingY", "paddingInline", "paddingInlineStart", "paddingInlineEnd", "paddingBlock", "paddingBlockStart", "paddingBlockEnd"], Hme = [...Eg, ...kg];
function Cf(e, t, n, r) {
  var o;
  const i = (o = Tg(e, t, !1)) != null ? o : n;
  return typeof i == "number" ? (a) => typeof a == "string" ? a : (process.env.NODE_ENV !== "production" && typeof a != "number" && console.error(`MUI: Expected ${r} argument to be a number or a string, got ${a}.`), i * a) : Array.isArray(i) ? (a) => typeof a == "string" ? a : (process.env.NODE_ENV !== "production" && (Number.isInteger(a) ? a > i.length - 1 && console.error([`MUI: The value provided (${a}) overflows.`, `The supported values are: ${JSON.stringify(i)}.`, `${a} > ${i.length - 1}, you need to add the missing values.`].join(`
`)) : console.error([`MUI: The \`theme.${t}\` array type cannot be combined with non integer values.You should either use an integer value that can be used as index, or define the \`theme.${t}\` as a number.`].join(`
`))), i[a]) : typeof i == "function" ? i : (process.env.NODE_ENV !== "production" && console.error([`MUI: The \`theme.${t}\` value (${i}) is invalid.`, "It should be a number, an array or a function."].join(`
`)), () => {
  });
}
function $I(e) {
  return Cf(e, "spacing", 8, "spacing");
}
function Sf(e, t) {
  if (typeof t == "string" || t == null)
    return t;
  const n = Math.abs(t), r = e(n);
  return t >= 0 ? r : typeof r == "number" ? -r : `-${r}`;
}
function jme(e, t) {
  return (n) => e.reduce((r, o) => (r[o] = Sf(t, n), r), {});
}
function Wme(e, t, n, r) {
  if (t.indexOf(n) === -1)
    return null;
  const o = Bme(n), i = jme(o, r), a = e[n];
  return ga(e, a, i);
}
function FI(e, t) {
  const n = $I(e.theme);
  return Object.keys(e).map((r) => Wme(e, t, r, n)).reduce(_d, {});
}
function _n(e) {
  return FI(e, Eg);
}
_n.propTypes = process.env.NODE_ENV !== "production" ? Eg.reduce((e, t) => (e[t] = gs, e), {}) : {};
_n.filterProps = Eg;
function wn(e) {
  return FI(e, kg);
}
wn.propTypes = process.env.NODE_ENV !== "production" ? kg.reduce((e, t) => (e[t] = gs, e), {}) : {};
wn.filterProps = kg;
process.env.NODE_ENV !== "production" && Hme.reduce((e, t) => (e[t] = gs, e), {});
function Vme(e = 8) {
  if (e.mui)
    return e;
  const t = $I({
    spacing: e
  }), n = (...r) => (process.env.NODE_ENV !== "production" && (r.length <= 4 || console.error(`MUI: Too many arguments provided, expected between 0 and 4, got ${r.length}`)), (r.length === 0 ? [1] : r).map((i) => {
    const a = t(i);
    return typeof a == "number" ? `${a}px` : a;
  }).join(" "));
  return n.mui = !0, n;
}
function Mg(...e) {
  const t = e.reduce((r, o) => (o.filterProps.forEach((i) => {
    r[i] = o;
  }), r), {}), n = (r) => Object.keys(r).reduce((o, i) => t[i] ? _d(o, t[i](r)) : o, {});
  return n.propTypes = process.env.NODE_ENV !== "production" ? e.reduce((r, o) => Object.assign(r, o.propTypes), {}) : {}, n.filterProps = e.reduce((r, o) => r.concat(o.filterProps), []), n;
}
function $o(e) {
  return typeof e != "number" ? e : `${e}px solid`;
}
function Ko(e, t) {
  return On({
    prop: e,
    themeKey: "borders",
    transform: t
  });
}
const Ume = Ko("border", $o), qme = Ko("borderTop", $o), Gme = Ko("borderRight", $o), Yme = Ko("borderBottom", $o), Zme = Ko("borderLeft", $o), Xme = Ko("borderColor"), Kme = Ko("borderTopColor"), Jme = Ko("borderRightColor"), Qme = Ko("borderBottomColor"), ege = Ko("borderLeftColor"), tge = Ko("outline", $o), nge = Ko("outlineColor"), Rg = (e) => {
  if (e.borderRadius !== void 0 && e.borderRadius !== null) {
    const t = Cf(e.theme, "shape.borderRadius", 4, "borderRadius"), n = (r) => ({
      borderRadius: Sf(t, r)
    });
    return ga(e, e.borderRadius, n);
  }
  return null;
};
Rg.propTypes = process.env.NODE_ENV !== "production" ? {
  borderRadius: gs
} : {};
Rg.filterProps = ["borderRadius"];
Mg(Ume, qme, Gme, Yme, Zme, Xme, Kme, Jme, Qme, ege, Rg, tge, nge);
const Pg = (e) => {
  if (e.gap !== void 0 && e.gap !== null) {
    const t = Cf(e.theme, "spacing", 8, "gap"), n = (r) => ({
      gap: Sf(t, r)
    });
    return ga(e, e.gap, n);
  }
  return null;
};
Pg.propTypes = process.env.NODE_ENV !== "production" ? {
  gap: gs
} : {};
Pg.filterProps = ["gap"];
const Og = (e) => {
  if (e.columnGap !== void 0 && e.columnGap !== null) {
    const t = Cf(e.theme, "spacing", 8, "columnGap"), n = (r) => ({
      columnGap: Sf(t, r)
    });
    return ga(e, e.columnGap, n);
  }
  return null;
};
Og.propTypes = process.env.NODE_ENV !== "production" ? {
  columnGap: gs
} : {};
Og.filterProps = ["columnGap"];
const Ng = (e) => {
  if (e.rowGap !== void 0 && e.rowGap !== null) {
    const t = Cf(e.theme, "spacing", 8, "rowGap"), n = (r) => ({
      rowGap: Sf(t, r)
    });
    return ga(e, e.rowGap, n);
  }
  return null;
};
Ng.propTypes = process.env.NODE_ENV !== "production" ? {
  rowGap: gs
} : {};
Ng.filterProps = ["rowGap"];
const rge = On({
  prop: "gridColumn"
}), oge = On({
  prop: "gridRow"
}), ige = On({
  prop: "gridAutoFlow"
}), age = On({
  prop: "gridAutoColumns"
}), sge = On({
  prop: "gridAutoRows"
}), lge = On({
  prop: "gridTemplateColumns"
}), cge = On({
  prop: "gridTemplateRows"
}), uge = On({
  prop: "gridTemplateAreas"
}), dge = On({
  prop: "gridArea"
});
Mg(Pg, Og, Ng, rge, oge, ige, age, sge, lge, cge, uge, dge);
function fc(e, t) {
  return t === "grey" ? t : e;
}
const fge = On({
  prop: "color",
  themeKey: "palette",
  transform: fc
}), pge = On({
  prop: "bgcolor",
  cssProperty: "backgroundColor",
  themeKey: "palette",
  transform: fc
}), hge = On({
  prop: "backgroundColor",
  themeKey: "palette",
  transform: fc
});
Mg(fge, pge, hge);
function so(e) {
  return e <= 1 && e !== 0 ? `${e * 100}%` : e;
}
const mge = On({
  prop: "width",
  transform: so
}), Jw = (e) => {
  if (e.maxWidth !== void 0 && e.maxWidth !== null) {
    const t = (n) => {
      var r, o;
      const i = ((r = e.theme) == null || (r = r.breakpoints) == null || (r = r.values) == null ? void 0 : r[n]) || Kw[n];
      return i ? ((o = e.theme) == null || (o = o.breakpoints) == null ? void 0 : o.unit) !== "px" ? {
        maxWidth: `${i}${e.theme.breakpoints.unit}`
      } : {
        maxWidth: i
      } : {
        maxWidth: so(n)
      };
    };
    return ga(e, e.maxWidth, t);
  }
  return null;
};
Jw.filterProps = ["maxWidth"];
const gge = On({
  prop: "minWidth",
  transform: so
}), vge = On({
  prop: "height",
  transform: so
}), bge = On({
  prop: "maxHeight",
  transform: so
}), yge = On({
  prop: "minHeight",
  transform: so
});
On({
  prop: "size",
  cssProperty: "width",
  transform: so
});
On({
  prop: "size",
  cssProperty: "height",
  transform: so
});
const _ge = On({
  prop: "boxSizing"
});
Mg(mge, Jw, gge, vge, bge, yge, _ge);
const Tf = {
  // borders
  border: {
    themeKey: "borders",
    transform: $o
  },
  borderTop: {
    themeKey: "borders",
    transform: $o
  },
  borderRight: {
    themeKey: "borders",
    transform: $o
  },
  borderBottom: {
    themeKey: "borders",
    transform: $o
  },
  borderLeft: {
    themeKey: "borders",
    transform: $o
  },
  borderColor: {
    themeKey: "palette"
  },
  borderTopColor: {
    themeKey: "palette"
  },
  borderRightColor: {
    themeKey: "palette"
  },
  borderBottomColor: {
    themeKey: "palette"
  },
  borderLeftColor: {
    themeKey: "palette"
  },
  outline: {
    themeKey: "borders",
    transform: $o
  },
  outlineColor: {
    themeKey: "palette"
  },
  borderRadius: {
    themeKey: "shape.borderRadius",
    style: Rg
  },
  // palette
  color: {
    themeKey: "palette",
    transform: fc
  },
  bgcolor: {
    themeKey: "palette",
    cssProperty: "backgroundColor",
    transform: fc
  },
  backgroundColor: {
    themeKey: "palette",
    transform: fc
  },
  // spacing
  p: {
    style: wn
  },
  pt: {
    style: wn
  },
  pr: {
    style: wn
  },
  pb: {
    style: wn
  },
  pl: {
    style: wn
  },
  px: {
    style: wn
  },
  py: {
    style: wn
  },
  padding: {
    style: wn
  },
  paddingTop: {
    style: wn
  },
  paddingRight: {
    style: wn
  },
  paddingBottom: {
    style: wn
  },
  paddingLeft: {
    style: wn
  },
  paddingX: {
    style: wn
  },
  paddingY: {
    style: wn
  },
  paddingInline: {
    style: wn
  },
  paddingInlineStart: {
    style: wn
  },
  paddingInlineEnd: {
    style: wn
  },
  paddingBlock: {
    style: wn
  },
  paddingBlockStart: {
    style: wn
  },
  paddingBlockEnd: {
    style: wn
  },
  m: {
    style: _n
  },
  mt: {
    style: _n
  },
  mr: {
    style: _n
  },
  mb: {
    style: _n
  },
  ml: {
    style: _n
  },
  mx: {
    style: _n
  },
  my: {
    style: _n
  },
  margin: {
    style: _n
  },
  marginTop: {
    style: _n
  },
  marginRight: {
    style: _n
  },
  marginBottom: {
    style: _n
  },
  marginLeft: {
    style: _n
  },
  marginX: {
    style: _n
  },
  marginY: {
    style: _n
  },
  marginInline: {
    style: _n
  },
  marginInlineStart: {
    style: _n
  },
  marginInlineEnd: {
    style: _n
  },
  marginBlock: {
    style: _n
  },
  marginBlockStart: {
    style: _n
  },
  marginBlockEnd: {
    style: _n
  },
  // display
  displayPrint: {
    cssProperty: !1,
    transform: (e) => ({
      "@media print": {
        display: e
      }
    })
  },
  display: {},
  overflow: {},
  textOverflow: {},
  visibility: {},
  whiteSpace: {},
  // flexbox
  flexBasis: {},
  flexDirection: {},
  flexWrap: {},
  justifyContent: {},
  alignItems: {},
  alignContent: {},
  order: {},
  flex: {},
  flexGrow: {},
  flexShrink: {},
  alignSelf: {},
  justifyItems: {},
  justifySelf: {},
  // grid
  gap: {
    style: Pg
  },
  rowGap: {
    style: Ng
  },
  columnGap: {
    style: Og
  },
  gridColumn: {},
  gridRow: {},
  gridAutoFlow: {},
  gridAutoColumns: {},
  gridAutoRows: {},
  gridTemplateColumns: {},
  gridTemplateRows: {},
  gridTemplateAreas: {},
  gridArea: {},
  // positions
  position: {},
  zIndex: {
    themeKey: "zIndex"
  },
  top: {},
  right: {},
  bottom: {},
  left: {},
  // shadows
  boxShadow: {
    themeKey: "shadows"
  },
  // sizing
  width: {
    transform: so
  },
  maxWidth: {
    style: Jw
  },
  minWidth: {
    transform: so
  },
  height: {
    transform: so
  },
  maxHeight: {
    transform: so
  },
  minHeight: {
    transform: so
  },
  boxSizing: {},
  // typography
  fontFamily: {
    themeKey: "typography"
  },
  fontSize: {
    themeKey: "typography"
  },
  fontStyle: {
    themeKey: "typography"
  },
  fontWeight: {
    themeKey: "typography"
  },
  letterSpacing: {},
  textTransform: {},
  lineHeight: {},
  textAlign: {},
  typography: {
    cssProperty: !1,
    themeKey: "typography"
  }
};
function wge(...e) {
  const t = e.reduce((r, o) => r.concat(Object.keys(o)), []), n = new Set(t);
  return e.every((r) => n.size === Object.keys(r).length);
}
function xge(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function zI() {
  function e(n, r, o, i) {
    const a = {
      [n]: r,
      theme: o
    }, s = i[n];
    if (!s)
      return {
        [n]: r
      };
    const {
      cssProperty: c = n,
      themeKey: l,
      transform: d,
      style: f
    } = s;
    if (r == null)
      return null;
    if (l === "typography" && r === "inherit")
      return {
        [n]: r
      };
    const p = Tg(o, l) || {};
    return f ? f(a) : ga(a, r, (v) => {
      let g = im(p, d, v);
      return v === g && typeof v == "string" && (g = im(p, d, `${n}${v === "default" ? "" : Xw(v)}`, v)), c === !1 ? g : {
        [c]: g
      };
    });
  }
  function t(n) {
    var r;
    const {
      sx: o,
      theme: i = {}
    } = n || {};
    if (!o)
      return null;
    const a = (r = i.unstable_sxConfig) != null ? r : Tf;
    function s(c) {
      let l = c;
      if (typeof c == "function")
        l = c(i);
      else if (typeof c != "object")
        return c;
      if (!l)
        return null;
      const d = Ime(i.breakpoints), f = Object.keys(d);
      let p = d;
      return Object.keys(l).forEach((m) => {
        const v = xge(l[m], i);
        if (v != null)
          if (typeof v == "object")
            if (a[m])
              p = _d(p, e(m, v, i, a));
            else {
              const g = ga({
                theme: i
              }, v, (b) => ({
                [m]: b
              }));
              wge(g, v) ? p[m] = t({
                sx: v,
                theme: i
              }) : p = _d(p, g);
            }
          else
            p = _d(p, e(m, v, i, a));
      }), Lme(f, p);
    }
    return Array.isArray(o) ? o.map(s) : s(o);
  }
  return t;
}
const Ag = zI();
Ag.filterProps = ["sx"];
function BI(e, t) {
  const n = this;
  return n.vars && typeof n.getColorSchemeSelector == "function" ? {
    [n.getColorSchemeSelector(e).replace(/(\[[^\]]+\])/, "*:where($1)")]: t
  } : n.palette.mode === e ? t : {};
}
const Cge = ["breakpoints", "palette", "spacing", "shape"];
function Qw(e = {}, ...t) {
  const {
    breakpoints: n = {},
    palette: r = {},
    spacing: o,
    shape: i = {}
  } = e, a = ot(e, Cge), s = LI(n), c = Vme(o);
  let l = Yd({
    breakpoints: s,
    direction: "ltr",
    components: {},
    // Inject component definitions.
    palette: ue({
      mode: "light"
    }, r),
    spacing: c,
    shape: ue({}, Dme, i)
  }, a);
  return l.applyStyles = BI, l = t.reduce((d, f) => Yd(d, f), l), l.unstable_sxConfig = ue({}, Tf, a == null ? void 0 : a.unstable_sxConfig), l.unstable_sx = function(f) {
    return Ag({
      sx: f,
      theme: this
    });
  }, l;
}
const Sge = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Qw,
  private_createBreakpoints: LI,
  unstable_applyStyles: BI
}, Symbol.toStringTag, { value: "Module" })), Tge = /* @__PURE__ */ Go(Sge), Ege = ["sx"], kge = (e) => {
  var t, n;
  const r = {
    systemProps: {},
    otherProps: {}
  }, o = (t = e == null || (n = e.theme) == null ? void 0 : n.unstable_sxConfig) != null ? t : Tf;
  return Object.keys(e).forEach((i) => {
    o[i] ? r.systemProps[i] = e[i] : r.otherProps[i] = e[i];
  }), r;
};
function HI(e) {
  const {
    sx: t
  } = e, n = ot(e, Ege), {
    systemProps: r,
    otherProps: o
  } = kge(n);
  let i;
  return Array.isArray(t) ? i = [r, ...t] : typeof t == "function" ? i = (...a) => {
    const s = t(...a);
    return Va(s) ? ue({}, r, s) : r;
  } : i = ue({}, r, t), ue({}, o, {
    sx: i
  });
}
const Mge = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Ag,
  extendSxProp: HI,
  unstable_createStyleFunctionSx: zI,
  unstable_defaultSxConfig: Tf
}, Symbol.toStringTag, { value: "Module" })), Rge = /* @__PURE__ */ Go(Mge);
var Yc = on;
Object.defineProperty(xf, "__esModule", {
  value: !0
});
var Pge = xf.default = Vge;
xf.shouldForwardProp = rh;
xf.systemDefaultTheme = void 0;
var No = Yc(vme), A1 = Yc(bme()), FM = zge(OI), Oge = Sme, Nge = Yc(kme), Age = Yc(Ome), Dge = Yc(Tge), Ige = Yc(Rge);
const Lge = ["ownerState"], $ge = ["variants"], Fge = ["name", "slot", "skipVariantsResolver", "skipSx", "overridesResolver"];
function jI(e) {
  if (typeof WeakMap != "function")
    return null;
  var t = /* @__PURE__ */ new WeakMap(), n = /* @__PURE__ */ new WeakMap();
  return (jI = function(r) {
    return r ? n : t;
  })(e);
}
function zge(e, t) {
  if (e && e.__esModule)
    return e;
  if (e === null || typeof e != "object" && typeof e != "function")
    return { default: e };
  var n = jI(t);
  if (n && n.has(e))
    return n.get(e);
  var r = { __proto__: null }, o = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var i in e)
    if (i !== "default" && Object.prototype.hasOwnProperty.call(e, i)) {
      var a = o ? Object.getOwnPropertyDescriptor(e, i) : null;
      a && (a.get || a.set) ? Object.defineProperty(r, i, a) : r[i] = e[i];
    }
  return r.default = e, n && n.set(e, r), r;
}
function Bge(e) {
  return Object.keys(e).length === 0;
}
function Hge(e) {
  return typeof e == "string" && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  e.charCodeAt(0) > 96;
}
function rh(e) {
  return e !== "ownerState" && e !== "theme" && e !== "sx" && e !== "as";
}
const jge = xf.systemDefaultTheme = (0, Dge.default)(), zM = (e) => e && e.charAt(0).toLowerCase() + e.slice(1);
function Tp({
  defaultTheme: e,
  theme: t,
  themeId: n
}) {
  return Bge(t) ? e : t[n] || t;
}
function Wge(e) {
  return e ? (t, n) => n[e] : null;
}
function oh(e, t) {
  let {
    ownerState: n
  } = t, r = (0, A1.default)(t, Lge);
  const o = typeof e == "function" ? e((0, No.default)({
    ownerState: n
  }, r)) : e;
  if (Array.isArray(o))
    return o.flatMap((i) => oh(i, (0, No.default)({
      ownerState: n
    }, r)));
  if (o && typeof o == "object" && Array.isArray(o.variants)) {
    const {
      variants: i = []
    } = o;
    let s = (0, A1.default)(o, $ge);
    return i.forEach((c) => {
      let l = !0;
      typeof c.props == "function" ? l = c.props((0, No.default)({
        ownerState: n
      }, r, n)) : Object.keys(c.props).forEach((d) => {
        (n == null ? void 0 : n[d]) !== c.props[d] && r[d] !== c.props[d] && (l = !1);
      }), l && (Array.isArray(s) || (s = [s]), s.push(typeof c.style == "function" ? c.style((0, No.default)({
        ownerState: n
      }, r, n)) : c.style));
    }), s;
  }
  return o;
}
function Vge(e = {}) {
  const {
    themeId: t,
    defaultTheme: n = jge,
    rootShouldForwardProp: r = rh,
    slotShouldForwardProp: o = rh
  } = e, i = (a) => (0, Ige.default)((0, No.default)({}, a, {
    theme: Tp((0, No.default)({}, a, {
      defaultTheme: n,
      themeId: t
    }))
  }));
  return i.__mui_systemSx = !0, (a, s = {}) => {
    (0, FM.internal_processStyles)(a, (w) => w.filter((k) => !(k != null && k.__mui_systemSx)));
    const {
      name: c,
      slot: l,
      skipVariantsResolver: d,
      skipSx: f,
      // TODO v6: remove `lowercaseFirstLetter()` in the next major release
      // For more details: https://github.com/mui/material-ui/pull/37908
      overridesResolver: p = Wge(zM(l))
    } = s, m = (0, A1.default)(s, Fge), v = d !== void 0 ? d : (
      // TODO v6: remove `Root` in the next major release
      // For more details: https://github.com/mui/material-ui/pull/37908
      l && l !== "Root" && l !== "root" || !1
    ), g = f || !1;
    let b;
    process.env.NODE_ENV !== "production" && c && (b = `${c}-${zM(l || "Root")}`);
    let x = rh;
    l === "Root" || l === "root" ? x = r : l ? x = o : Hge(a) && (x = void 0);
    const T = (0, FM.default)(a, (0, No.default)({
      shouldForwardProp: x,
      label: b
    }, m)), S = (w) => typeof w == "function" && w.__emotion_real !== w || (0, Oge.isPlainObject)(w) ? (k) => oh(w, (0, No.default)({}, k, {
      theme: Tp({
        theme: k.theme,
        defaultTheme: n,
        themeId: t
      })
    })) : w, _ = (w, ...k) => {
      let E = S(w);
      const R = k ? k.map(S) : [];
      c && p && R.push((D) => {
        const N = Tp((0, No.default)({}, D, {
          defaultTheme: n,
          themeId: t
        }));
        if (!N.components || !N.components[c] || !N.components[c].styleOverrides)
          return null;
        const F = N.components[c].styleOverrides, $ = {};
        return Object.entries(F).forEach(([I, j]) => {
          $[I] = oh(j, (0, No.default)({}, D, {
            theme: N
          }));
        }), p(D, $);
      }), c && !v && R.push((D) => {
        var N;
        const F = Tp((0, No.default)({}, D, {
          defaultTheme: n,
          themeId: t
        })), $ = F == null || (N = F.components) == null || (N = N[c]) == null ? void 0 : N.variants;
        return oh({
          variants: $
        }, (0, No.default)({}, D, {
          theme: F
        }));
      }), g || R.push(i);
      const P = R.length - k.length;
      if (Array.isArray(w) && P > 0) {
        const D = new Array(P).fill("");
        E = [...w, ...D], E.raw = [...w.raw, ...D];
      }
      const A = T(E, ...R);
      if (process.env.NODE_ENV !== "production") {
        let D;
        c && (D = `${c}${(0, Nge.default)(l || "")}`), D === void 0 && (D = `Styled(${(0, Age.default)(a)})`), A.displayName = D;
      }
      return a.muiName && (A.muiName = a.muiName), A;
    };
    return T.withConfig && (_.withConfig = T.withConfig), _;
  };
}
function am(e) {
  let t = "https://mui.com/production-error/?code=" + e;
  for (let n = 1; n < arguments.length; n += 1)
    t += "&args[]=" + encodeURIComponent(arguments[n]);
  return "Minified MUI error #" + e + "; visit " + t + " for the full message.";
}
function Gl(e) {
  if (typeof e != "object" || e === null)
    return !1;
  const t = Object.getPrototypeOf(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}
function WI(e) {
  if (!Gl(e))
    return e;
  const t = {};
  return Object.keys(e).forEach((n) => {
    t[n] = WI(e[n]);
  }), t;
}
function pc(e, t, n = {
  clone: !0
}) {
  const r = n.clone ? ue({}, e) : e;
  return Gl(e) && Gl(t) && Object.keys(t).forEach((o) => {
    Gl(t[o]) && // Avoid prototype pollution
    Object.prototype.hasOwnProperty.call(e, o) && Gl(e[o]) ? r[o] = pc(e[o], t[o], n) : n.clone ? r[o] = Gl(t[o]) ? WI(t[o]) : t[o] : r[o] = t[o];
  }), r;
}
const BM = (e) => e, Uge = () => {
  let e = BM;
  return {
    configure(t) {
      e = t;
    },
    generate(t) {
      return e(t);
    },
    reset() {
      e = BM;
    }
  };
}, qge = Uge(), Gge = {
  active: "active",
  checked: "checked",
  completed: "completed",
  disabled: "disabled",
  error: "error",
  expanded: "expanded",
  focused: "focused",
  focusVisible: "focusVisible",
  open: "open",
  readOnly: "readOnly",
  required: "required",
  selected: "selected"
};
function hn(e, t, n = "Mui") {
  const r = Gge[t];
  return r ? `${n}-${r}` : `${qge.generate(e)}-${t}`;
}
function Yge(e, t) {
  return ue({
    toolbar: {
      minHeight: 56,
      [e.up("xs")]: {
        "@media (orientation: landscape)": {
          minHeight: 48
        }
      },
      [e.up("sm")]: {
        minHeight: 64
      }
    }
  }, t);
}
var Nn = {};
const Zge = /* @__PURE__ */ Go(Tme);
function Xge(e, t = Number.MIN_SAFE_INTEGER, n = Number.MAX_SAFE_INTEGER) {
  return Math.max(t, Math.min(e, n));
}
const Kge = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Xge
}, Symbol.toStringTag, { value: "Module" })), Jge = /* @__PURE__ */ Go(Kge);
var VI = on;
Object.defineProperty(Nn, "__esModule", {
  value: !0
});
var Mn = Nn.alpha = YI;
Nn.blend = uve;
Nn.colorChannel = void 0;
var Qge = Nn.darken = tx;
Nn.decomposeColor = Vo;
var HM = Nn.emphasize = ZI, jM = Nn.getContrastRatio = ive;
Nn.getLuminance = sm;
Nn.hexToRgb = UI;
Nn.hslToRgb = GI;
var eve = Nn.lighten = nx;
Nn.private_safeAlpha = ave;
Nn.private_safeColorChannel = void 0;
Nn.private_safeDarken = sve;
Nn.private_safeEmphasize = cve;
Nn.private_safeLighten = lve;
Nn.recomposeColor = Zc;
Nn.rgbToHex = ove;
var WM = VI(Zge), tve = VI(Jge);
function ex(e, t = 0, n = 1) {
  return process.env.NODE_ENV !== "production" && (e < t || e > n) && console.error(`MUI: The value provided ${e} is out of range [${t}, ${n}].`), (0, tve.default)(e, t, n);
}
function UI(e) {
  e = e.slice(1);
  const t = new RegExp(`.{1,${e.length >= 6 ? 2 : 1}}`, "g");
  let n = e.match(t);
  return n && n[0].length === 1 && (n = n.map((r) => r + r)), n ? `rgb${n.length === 4 ? "a" : ""}(${n.map((r, o) => o < 3 ? parseInt(r, 16) : Math.round(parseInt(r, 16) / 255 * 1e3) / 1e3).join(", ")})` : "";
}
function nve(e) {
  const t = e.toString(16);
  return t.length === 1 ? `0${t}` : t;
}
function Vo(e) {
  if (e.type)
    return e;
  if (e.charAt(0) === "#")
    return Vo(UI(e));
  const t = e.indexOf("("), n = e.substring(0, t);
  if (["rgb", "rgba", "hsl", "hsla", "color"].indexOf(n) === -1)
    throw new Error(process.env.NODE_ENV !== "production" ? `MUI: Unsupported \`${e}\` color.
The following formats are supported: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color().` : (0, WM.default)(9, e));
  let r = e.substring(t + 1, e.length - 1), o;
  if (n === "color") {
    if (r = r.split(" "), o = r.shift(), r.length === 4 && r[3].charAt(0) === "/" && (r[3] = r[3].slice(1)), ["srgb", "display-p3", "a98-rgb", "prophoto-rgb", "rec-2020"].indexOf(o) === -1)
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: unsupported \`${o}\` color space.
The following color spaces are supported: srgb, display-p3, a98-rgb, prophoto-rgb, rec-2020.` : (0, WM.default)(10, o));
  } else
    r = r.split(",");
  return r = r.map((i) => parseFloat(i)), {
    type: n,
    values: r,
    colorSpace: o
  };
}
const qI = (e) => {
  const t = Vo(e);
  return t.values.slice(0, 3).map((n, r) => t.type.indexOf("hsl") !== -1 && r !== 0 ? `${n}%` : n).join(" ");
};
Nn.colorChannel = qI;
const rve = (e, t) => {
  try {
    return qI(e);
  } catch (n) {
    return t && process.env.NODE_ENV !== "production" && console.warn(t), e;
  }
};
Nn.private_safeColorChannel = rve;
function Zc(e) {
  const {
    type: t,
    colorSpace: n
  } = e;
  let {
    values: r
  } = e;
  return t.indexOf("rgb") !== -1 ? r = r.map((o, i) => i < 3 ? parseInt(o, 10) : o) : t.indexOf("hsl") !== -1 && (r[1] = `${r[1]}%`, r[2] = `${r[2]}%`), t.indexOf("color") !== -1 ? r = `${n} ${r.join(" ")}` : r = `${r.join(", ")}`, `${t}(${r})`;
}
function ove(e) {
  if (e.indexOf("#") === 0)
    return e;
  const {
    values: t
  } = Vo(e);
  return `#${t.map((n, r) => nve(r === 3 ? Math.round(255 * n) : n)).join("")}`;
}
function GI(e) {
  e = Vo(e);
  const {
    values: t
  } = e, n = t[0], r = t[1] / 100, o = t[2] / 100, i = r * Math.min(o, 1 - o), a = (l, d = (l + n / 30) % 12) => o - i * Math.max(Math.min(d - 3, 9 - d, 1), -1);
  let s = "rgb";
  const c = [Math.round(a(0) * 255), Math.round(a(8) * 255), Math.round(a(4) * 255)];
  return e.type === "hsla" && (s += "a", c.push(t[3])), Zc({
    type: s,
    values: c
  });
}
function sm(e) {
  e = Vo(e);
  let t = e.type === "hsl" || e.type === "hsla" ? Vo(GI(e)).values : e.values;
  return t = t.map((n) => (e.type !== "color" && (n /= 255), n <= 0.03928 ? n / 12.92 : ro((n + 0.055) / 1.055, 2.4))), Number((0.2126 * t[0] + 0.7152 * t[1] + 0.0722 * t[2]).toFixed(3));
}
function ive(e, t) {
  const n = sm(e), r = sm(t);
  return (Math.max(n, r) + 0.05) / (Math.min(n, r) + 0.05);
}
function YI(e, t) {
  return e = Vo(e), t = ex(t), (e.type === "rgb" || e.type === "hsl") && (e.type += "a"), e.type === "color" ? e.values[3] = `/${t}` : e.values[3] = t, Zc(e);
}
function ave(e, t, n) {
  try {
    return YI(e, t);
  } catch (r) {
    return n && process.env.NODE_ENV !== "production" && console.warn(n), e;
  }
}
function tx(e, t) {
  if (e = Vo(e), t = ex(t), e.type.indexOf("hsl") !== -1)
    e.values[2] *= 1 - t;
  else if (e.type.indexOf("rgb") !== -1 || e.type.indexOf("color") !== -1)
    for (let n = 0; n < 3; n += 1)
      e.values[n] *= 1 - t;
  return Zc(e);
}
function sve(e, t, n) {
  try {
    return tx(e, t);
  } catch (r) {
    return n && process.env.NODE_ENV !== "production" && console.warn(n), e;
  }
}
function nx(e, t) {
  if (e = Vo(e), t = ex(t), e.type.indexOf("hsl") !== -1)
    e.values[2] += (100 - e.values[2]) * t;
  else if (e.type.indexOf("rgb") !== -1)
    for (let n = 0; n < 3; n += 1)
      e.values[n] += (255 - e.values[n]) * t;
  else if (e.type.indexOf("color") !== -1)
    for (let n = 0; n < 3; n += 1)
      e.values[n] += (1 - e.values[n]) * t;
  return Zc(e);
}
function lve(e, t, n) {
  try {
    return nx(e, t);
  } catch (r) {
    return n && process.env.NODE_ENV !== "production" && console.warn(n), e;
  }
}
function ZI(e, t = 0.15) {
  return sm(e) > 0.5 ? tx(e, t) : nx(e, t);
}
function cve(e, t, n) {
  try {
    return ZI(e, t);
  } catch (r) {
    return n && process.env.NODE_ENV !== "production" && console.warn(n), e;
  }
}
function uve(e, t, n, r = 1) {
  const o = (c, l) => Math.round(ro(ro(c, 1 / r) * (1 - n) + ro(l, 1 / r) * n, r)), i = Vo(e), a = Vo(t), s = [o(i.values[0], a.values[0]), o(i.values[1], a.values[1]), o(i.values[2], a.values[2])];
  return Zc({
    type: "rgb",
    values: s
  });
}
const Zd = {
  black: "#000",
  white: "#fff"
}, dve = {
  50: "#fafafa",
  100: "#f5f5f5",
  200: "#eeeeee",
  300: "#e0e0e0",
  400: "#bdbdbd",
  500: "#9e9e9e",
  600: "#757575",
  700: "#616161",
  800: "#424242",
  900: "#212121",
  A100: "#f5f5f5",
  A200: "#eeeeee",
  A400: "#bdbdbd",
  A700: "#616161"
}, $l = {
  50: "#f3e5f5",
  100: "#e1bee7",
  200: "#ce93d8",
  300: "#ba68c8",
  400: "#ab47bc",
  500: "#9c27b0",
  600: "#8e24aa",
  700: "#7b1fa2",
  800: "#6a1b9a",
  900: "#4a148c",
  A100: "#ea80fc",
  A200: "#e040fb",
  A400: "#d500f9",
  A700: "#aa00ff"
}, Fl = {
  50: "#ffebee",
  100: "#ffcdd2",
  200: "#ef9a9a",
  300: "#e57373",
  400: "#ef5350",
  500: "#f44336",
  600: "#e53935",
  700: "#d32f2f",
  800: "#c62828",
  900: "#b71c1c",
  A100: "#ff8a80",
  A200: "#ff5252",
  A400: "#ff1744",
  A700: "#d50000"
}, Bu = {
  50: "#fff3e0",
  100: "#ffe0b2",
  200: "#ffcc80",
  300: "#ffb74d",
  400: "#ffa726",
  500: "#ff9800",
  600: "#fb8c00",
  700: "#f57c00",
  800: "#ef6c00",
  900: "#e65100",
  A100: "#ffd180",
  A200: "#ffab40",
  A400: "#ff9100",
  A700: "#ff6d00"
}, zl = {
  50: "#e3f2fd",
  100: "#bbdefb",
  200: "#90caf9",
  300: "#64b5f6",
  400: "#42a5f5",
  500: "#2196f3",
  600: "#1e88e5",
  700: "#1976d2",
  800: "#1565c0",
  900: "#0d47a1",
  A100: "#82b1ff",
  A200: "#448aff",
  A400: "#2979ff",
  A700: "#2962ff"
}, Bl = {
  50: "#e1f5fe",
  100: "#b3e5fc",
  200: "#81d4fa",
  300: "#4fc3f7",
  400: "#29b6f6",
  500: "#03a9f4",
  600: "#039be5",
  700: "#0288d1",
  800: "#0277bd",
  900: "#01579b",
  A100: "#80d8ff",
  A200: "#40c4ff",
  A400: "#00b0ff",
  A700: "#0091ea"
}, Hl = {
  50: "#e8f5e9",
  100: "#c8e6c9",
  200: "#a5d6a7",
  300: "#81c784",
  400: "#66bb6a",
  500: "#4caf50",
  600: "#43a047",
  700: "#388e3c",
  800: "#2e7d32",
  900: "#1b5e20",
  A100: "#b9f6ca",
  A200: "#69f0ae",
  A400: "#00e676",
  A700: "#00c853"
}, fve = ["mode", "contrastThreshold", "tonalOffset"], VM = {
  // The colors used to style the text.
  text: {
    // The most important text.
    primary: "rgba(0, 0, 0, 0.87)",
    // Secondary text.
    secondary: "rgba(0, 0, 0, 0.6)",
    // Disabled text have even lower visual prominence.
    disabled: "rgba(0, 0, 0, 0.38)"
  },
  // The color used to divide different elements.
  divider: "rgba(0, 0, 0, 0.12)",
  // The background colors used to style the surfaces.
  // Consistency between these values is important.
  background: {
    paper: Zd.white,
    default: Zd.white
  },
  // The colors used to style the action elements.
  action: {
    // The color of an active action like an icon button.
    active: "rgba(0, 0, 0, 0.54)",
    // The color of an hovered action.
    hover: "rgba(0, 0, 0, 0.04)",
    hoverOpacity: 0.04,
    // The color of a selected action.
    selected: "rgba(0, 0, 0, 0.08)",
    selectedOpacity: 0.08,
    // The color of a disabled action.
    disabled: "rgba(0, 0, 0, 0.26)",
    // The background color of a disabled action.
    disabledBackground: "rgba(0, 0, 0, 0.12)",
    disabledOpacity: 0.38,
    focus: "rgba(0, 0, 0, 0.12)",
    focusOpacity: 0.12,
    activatedOpacity: 0.12
  }
}, ab = {
  text: {
    primary: Zd.white,
    secondary: "rgba(255, 255, 255, 0.7)",
    disabled: "rgba(255, 255, 255, 0.5)",
    icon: "rgba(255, 255, 255, 0.5)"
  },
  divider: "rgba(255, 255, 255, 0.12)",
  background: {
    paper: "#121212",
    default: "#121212"
  },
  action: {
    active: Zd.white,
    hover: "rgba(255, 255, 255, 0.08)",
    hoverOpacity: 0.08,
    selected: "rgba(255, 255, 255, 0.16)",
    selectedOpacity: 0.16,
    disabled: "rgba(255, 255, 255, 0.3)",
    disabledBackground: "rgba(255, 255, 255, 0.12)",
    disabledOpacity: 0.38,
    focus: "rgba(255, 255, 255, 0.12)",
    focusOpacity: 0.12,
    activatedOpacity: 0.24
  }
};
function UM(e, t, n, r) {
  const o = r.light || r, i = r.dark || r * 1.5;
  e[t] || (e.hasOwnProperty(n) ? e[t] = e[n] : t === "light" ? e.light = eve(e.main, o) : t === "dark" && (e.dark = Qge(e.main, i)));
}
function pve(e = "light") {
  return e === "dark" ? {
    main: zl[200],
    light: zl[50],
    dark: zl[400]
  } : {
    main: zl[700],
    light: zl[400],
    dark: zl[800]
  };
}
function hve(e = "light") {
  return e === "dark" ? {
    main: $l[200],
    light: $l[50],
    dark: $l[400]
  } : {
    main: $l[500],
    light: $l[300],
    dark: $l[700]
  };
}
function mve(e = "light") {
  return e === "dark" ? {
    main: Fl[500],
    light: Fl[300],
    dark: Fl[700]
  } : {
    main: Fl[700],
    light: Fl[400],
    dark: Fl[800]
  };
}
function gve(e = "light") {
  return e === "dark" ? {
    main: Bl[400],
    light: Bl[300],
    dark: Bl[700]
  } : {
    main: Bl[700],
    light: Bl[500],
    dark: Bl[900]
  };
}
function vve(e = "light") {
  return e === "dark" ? {
    main: Hl[400],
    light: Hl[300],
    dark: Hl[700]
  } : {
    main: Hl[800],
    light: Hl[500],
    dark: Hl[900]
  };
}
function bve(e = "light") {
  return e === "dark" ? {
    main: Bu[400],
    light: Bu[300],
    dark: Bu[700]
  } : {
    main: "#ed6c02",
    // closest to orange[800] that pass 3:1.
    light: Bu[500],
    dark: Bu[900]
  };
}
function yve(e) {
  const {
    mode: t = "light",
    contrastThreshold: n = 3,
    tonalOffset: r = 0.2
  } = e, o = ot(e, fve), i = e.primary || pve(t), a = e.secondary || hve(t), s = e.error || mve(t), c = e.info || gve(t), l = e.success || vve(t), d = e.warning || bve(t);
  function f(g) {
    const b = jM(g, ab.text.primary) >= n ? ab.text.primary : VM.text.primary;
    if (process.env.NODE_ENV !== "production") {
      const x = jM(g, b);
      x < 3 && console.error([`MUI: The contrast ratio of ${x}:1 for ${b} on ${g}`, "falls below the WCAG recommended absolute minimum contrast ratio of 3:1.", "https://www.w3.org/TR/2008/REC-WCAG20-20081211/#visual-audio-contrast-contrast"].join(`
`));
    }
    return b;
  }
  const p = ({
    color: g,
    name: b,
    mainShade: x = 500,
    lightShade: T = 300,
    darkShade: S = 700
  }) => {
    if (g = ue({}, g), !g.main && g[x] && (g.main = g[x]), !g.hasOwnProperty("main"))
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: The color${b ? ` (${b})` : ""} provided to augmentColor(color) is invalid.
The color object needs to have a \`main\` property or a \`${x}\` property.` : am(11, b ? ` (${b})` : "", x));
    if (typeof g.main != "string")
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: The color${b ? ` (${b})` : ""} provided to augmentColor(color) is invalid.
\`color.main\` should be a string, but \`${JSON.stringify(g.main)}\` was provided instead.

Did you intend to use one of the following approaches?

import { green } from "@mui/material/colors";

const theme1 = createTheme({ palette: {
  primary: green,
} });

const theme2 = createTheme({ palette: {
  primary: { main: green[500] },
} });` : am(12, b ? ` (${b})` : "", JSON.stringify(g.main)));
    return UM(g, "light", T, r), UM(g, "dark", S, r), g.contrastText || (g.contrastText = f(g.main)), g;
  }, m = {
    dark: ab,
    light: VM
  };
  return process.env.NODE_ENV !== "production" && (m[t] || console.error(`MUI: The palette mode \`${t}\` is not supported.`)), pc(ue({
    // A collection of common colors.
    common: ue({}, Zd),
    // prevent mutable object.
    // The palette mode, can be light or dark.
    mode: t,
    // The colors used to represent primary interface elements for a user.
    primary: p({
      color: i,
      name: "primary"
    }),
    // The colors used to represent secondary interface elements for a user.
    secondary: p({
      color: a,
      name: "secondary",
      mainShade: "A400",
      lightShade: "A200",
      darkShade: "A700"
    }),
    // The colors used to represent interface elements that the user should be made aware of.
    error: p({
      color: s,
      name: "error"
    }),
    // The colors used to represent potentially dangerous actions or important messages.
    warning: p({
      color: d,
      name: "warning"
    }),
    // The colors used to present information to the user that is neutral and not necessarily important.
    info: p({
      color: c,
      name: "info"
    }),
    // The colors used to indicate the successful completion of an action that user triggered.
    success: p({
      color: l,
      name: "success"
    }),
    // The grey colors.
    grey: dve,
    // Used by `getContrastText()` to maximize the contrast between
    // the background and the text.
    contrastThreshold: n,
    // Takes a background color and returns the text color that maximizes the contrast.
    getContrastText: f,
    // Generate a rich color object.
    augmentColor: p,
    // Used by the functions below to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    tonalOffset: r
  }, m[t]), o);
}
const _ve = ["fontFamily", "fontSize", "fontWeightLight", "fontWeightRegular", "fontWeightMedium", "fontWeightBold", "htmlFontSize", "allVariants", "pxToRem"];
function wve(e) {
  return Math.round(e * 1e5) / 1e5;
}
const qM = {
  textTransform: "uppercase"
}, GM = '"Roboto", "Helvetica", "Arial", sans-serif';
function xve(e, t) {
  const n = typeof t == "function" ? t(e) : t, {
    fontFamily: r = GM,
    // The default font size of the Material Specification.
    fontSize: o = 14,
    // px
    fontWeightLight: i = 300,
    fontWeightRegular: a = 400,
    fontWeightMedium: s = 500,
    fontWeightBold: c = 700,
    // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize: l = 16,
    // Apply the CSS properties to all the variants.
    allVariants: d,
    pxToRem: f
  } = n, p = ot(n, _ve);
  process.env.NODE_ENV !== "production" && (typeof o != "number" && console.error("MUI: `fontSize` is required to be a number."), typeof l != "number" && console.error("MUI: `htmlFontSize` is required to be a number."));
  const m = o / 14, v = f || ((x) => `${x / l * m}rem`), g = (x, T, S, _, w) => ue({
    fontFamily: r,
    fontWeight: x,
    fontSize: v(T),
    // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
    lineHeight: S
  }, r === GM ? {
    letterSpacing: `${wve(_ / T)}em`
  } : {}, w, d), b = {
    h1: g(i, 96, 1.167, -1.5),
    h2: g(i, 60, 1.2, -0.5),
    h3: g(a, 48, 1.167, 0),
    h4: g(a, 34, 1.235, 0.25),
    h5: g(a, 24, 1.334, 0),
    h6: g(s, 20, 1.6, 0.15),
    subtitle1: g(a, 16, 1.75, 0.15),
    subtitle2: g(s, 14, 1.57, 0.1),
    body1: g(a, 16, 1.5, 0.15),
    body2: g(a, 14, 1.43, 0.15),
    button: g(s, 14, 1.75, 0.4, qM),
    caption: g(a, 12, 1.66, 0.4),
    overline: g(a, 12, 2.66, 1, qM),
    // TODO v6: Remove handling of 'inherit' variant from the theme as it is already handled in Material UI's Typography component. Also, remember to remove the associated types.
    inherit: {
      fontFamily: "inherit",
      fontWeight: "inherit",
      fontSize: "inherit",
      lineHeight: "inherit",
      letterSpacing: "inherit"
    }
  };
  return pc(ue({
    htmlFontSize: l,
    pxToRem: v,
    fontFamily: r,
    fontSize: o,
    fontWeightLight: i,
    fontWeightRegular: a,
    fontWeightMedium: s,
    fontWeightBold: c
  }, b), p, {
    clone: !1
    // No need to clone deep
  });
}
const Cve = 0.2, Sve = 0.14, Tve = 0.12;
function cn(...e) {
  return [`${e[0]}px ${e[1]}px ${e[2]}px ${e[3]}px rgba(0,0,0,${Cve})`, `${e[4]}px ${e[5]}px ${e[6]}px ${e[7]}px rgba(0,0,0,${Sve})`, `${e[8]}px ${e[9]}px ${e[10]}px ${e[11]}px rgba(0,0,0,${Tve})`].join(",");
}
const Eve = ["none", cn(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0), cn(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0), cn(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0), cn(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0), cn(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0), cn(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0), cn(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1), cn(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2), cn(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2), cn(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3), cn(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3), cn(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4), cn(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4), cn(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4), cn(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5), cn(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5), cn(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5), cn(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6), cn(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6), cn(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7), cn(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7), cn(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7), cn(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8), cn(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)], kve = ["duration", "easing", "delay"], Mve = {
  // This is the most common easing curve.
  easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
  // Objects enter the screen at full velocity from off-screen and
  // slowly decelerate to a resting point.
  easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
  // Objects leave the screen at full velocity. They do not decelerate when off-screen.
  easeIn: "cubic-bezier(0.4, 0, 1, 1)",
  // The sharp curve is used by objects that may return to the screen at any time.
  sharp: "cubic-bezier(0.4, 0, 0.6, 1)"
}, Rve = {
  shortest: 150,
  shorter: 200,
  short: 250,
  // most basic recommended timing
  standard: 300,
  // this is to be used in complex animations
  complex: 375,
  // recommended when something is entering screen
  enteringScreen: 225,
  // recommended when something is leaving screen
  leavingScreen: 195
};
function YM(e) {
  return `${Math.round(e)}ms`;
}
function Pve(e) {
  if (!e)
    return 0;
  const t = e / 36;
  return Math.round((4 + 15 * ro(t, 0.25) + t / 5) * 10);
}
function Ove(e) {
  const t = ue({}, Mve, e.easing), n = ue({}, Rve, e.duration);
  return ue({
    getAutoHeightDuration: Pve,
    create: (o = ["all"], i = {}) => {
      const {
        duration: a = n.standard,
        easing: s = t.easeInOut,
        delay: c = 0
      } = i, l = ot(i, kve);
      if (process.env.NODE_ENV !== "production") {
        const d = (p) => typeof p == "string", f = (p) => !isNaN(parseFloat(p));
        !d(o) && !Array.isArray(o) && console.error('MUI: Argument "props" must be a string or Array.'), !f(a) && !d(a) && console.error(`MUI: Argument "duration" must be a number or a string but found ${a}.`), d(s) || console.error('MUI: Argument "easing" must be a string.'), !f(c) && !d(c) && console.error('MUI: Argument "delay" must be a number or a string.'), typeof i != "object" && console.error(["MUI: Secong argument of transition.create must be an object.", "Arguments should be either `create('prop1', options)` or `create(['prop1', 'prop2'], options)`"].join(`
`)), Object.keys(l).length !== 0 && console.error(`MUI: Unrecognized argument(s) [${Object.keys(l).join(",")}].`);
      }
      return (Array.isArray(o) ? o : [o]).map((d) => `${d} ${typeof a == "string" ? a : YM(a)} ${s} ${typeof c == "string" ? c : YM(c)}`).join(",");
    }
  }, e, {
    easing: t,
    duration: n
  });
}
const Nve = {
  mobileStepper: 1e3,
  fab: 1050,
  speedDial: 1050,
  appBar: 1100,
  drawer: 1200,
  modal: 1300,
  snackbar: 1400,
  tooltip: 1500
}, Ave = ["breakpoints", "mixins", "spacing", "palette", "transitions", "typography", "shape"];
function Dve(e = {}, ...t) {
  const {
    mixins: n = {},
    palette: r = {},
    transitions: o = {},
    typography: i = {}
  } = e, a = ot(e, Ave);
  if (e.vars)
    throw new Error(process.env.NODE_ENV !== "production" ? "MUI: `vars` is a private field used for CSS variables support.\nPlease use another name." : am(18));
  const s = yve(r), c = Qw(e);
  let l = pc(c, {
    mixins: Yge(c.breakpoints, n),
    palette: s,
    // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
    shadows: Eve.slice(),
    typography: xve(s, i),
    transitions: Ove(o),
    zIndex: ue({}, Nve)
  });
  if (l = pc(l, a), l = t.reduce((d, f) => pc(d, f), l), process.env.NODE_ENV !== "production") {
    const d = ["active", "checked", "completed", "disabled", "error", "expanded", "focused", "focusVisible", "required", "selected"], f = (p, m) => {
      let v;
      for (v in p) {
        const g = p[v];
        if (d.indexOf(v) !== -1 && Object.keys(g).length > 0) {
          if (process.env.NODE_ENV !== "production") {
            const b = hn("", v);
            console.error([`MUI: The \`${m}\` component increases the CSS specificity of the \`${v}\` internal state.`, "You can not override it like this: ", JSON.stringify(p, null, 2), "", `Instead, you need to use the '&.${b}' syntax:`, JSON.stringify({
              root: {
                [`&.${b}`]: g
              }
            }, null, 2), "", "https://mui.com/r/state-classes-guide"].join(`
`));
          }
          p[v] = {};
        }
      }
    };
    Object.keys(l.components).forEach((p) => {
      const m = l.components[p].styleOverrides;
      m && p.indexOf("Mui") === 0 && f(m, p);
    });
  }
  return l.unstable_sxConfig = ue({}, Tf, a == null ? void 0 : a.unstable_sxConfig), l.unstable_sx = function(f) {
    return Ag({
      sx: f,
      theme: this
    });
  }, l;
}
const XI = Dve(), KI = "$$material";
function Ive(e) {
  return e !== "ownerState" && e !== "theme" && e !== "sx" && e !== "as";
}
const Dg = (e) => Ive(e) && e !== "classes", ct = Pge({
  themeId: KI,
  defaultTheme: XI,
  rootShouldForwardProp: Dg
});
function D1(e, t) {
  const n = ue({}, t);
  return Object.keys(e).forEach((r) => {
    if (r.toString().match(/^(components|slots)$/))
      n[r] = ue({}, e[r], n[r]);
    else if (r.toString().match(/^(componentsProps|slotProps)$/)) {
      const o = e[r] || {}, i = t[r];
      n[r] = {}, !i || !Object.keys(i) ? n[r] = o : !o || !Object.keys(o) ? n[r] = i : (n[r] = ue({}, i), Object.keys(o).forEach((a) => {
        n[r][a] = D1(o[a], i[a]);
      }));
    } else
      n[r] === void 0 && (n[r] = e[r]);
  }), n;
}
const Lve = /* @__PURE__ */ B.createContext(void 0);
function $ve(e) {
  const {
    theme: t,
    name: n,
    props: r
  } = e;
  if (!t || !t.components || !t.components[n])
    return r;
  const o = t.components[n];
  return o.defaultProps ? D1(o.defaultProps, r) : !o.styleOverrides && !o.variants ? D1(o, r) : r;
}
function Fve({
  props: e,
  name: t
}) {
  const n = B.useContext(Lve);
  return $ve({
    props: e,
    name: t,
    theme: {
      components: n
    }
  });
}
function xn(e) {
  return Fve(e);
}
const lm = /* @__PURE__ */ B.createContext({});
process.env.NODE_ENV !== "production" && (lm.displayName = "ListContext");
function un(e, t, n = "Mui") {
  const r = {};
  return t.forEach((o) => {
    r[o] = hn(e, o, n);
  }), r;
}
function zve(e) {
  return hn("MuiList", e);
}
un("MuiList", ["root", "padding", "dense", "subheader"]);
const Bve = ["children", "className", "component", "dense", "disablePadding", "subheader"], Hve = (e) => {
  const {
    classes: t,
    disablePadding: n,
    dense: r,
    subheader: o
  } = e;
  return Pn({
    root: ["root", !n && "padding", r && "dense", o && "subheader"]
  }, zve, t);
}, jve = ct("ul", {
  name: "MuiList",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, !n.disablePadding && t.padding, n.dense && t.dense, n.subheader && t.subheader];
  }
})(({
  ownerState: e
}) => ue({
  listStyle: "none",
  margin: 0,
  padding: 0,
  position: "relative"
}, !e.disablePadding && {
  paddingTop: 8,
  paddingBottom: 8
}, e.subheader && {
  paddingTop: 0
})), JI = /* @__PURE__ */ B.forwardRef(function(t, n) {
  const r = xn({
    props: t,
    name: "MuiList"
  }), {
    children: o,
    className: i,
    component: a = "ul",
    dense: s = !1,
    disablePadding: c = !1,
    subheader: l
  } = r, d = ot(r, Bve), f = B.useMemo(() => ({
    dense: s
  }), [s]), p = ue({}, r, {
    component: a,
    dense: s,
    disablePadding: c
  }), m = Hve(p);
  return /* @__PURE__ */ z(lm.Provider, {
    value: f,
    children: /* @__PURE__ */ _e(jve, ue({
      as: a,
      className: lt(m.root, i),
      ref: n,
      ownerState: p
    }, d, {
      children: [l, o]
    }))
  });
});
process.env.NODE_ENV !== "production" && (JI.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: M.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: M.object,
  /**
   * @ignore
   */
  className: M.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: M.elementType,
  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input is used for
   * the list and list items.
   * The prop is available to descendant components as the `dense` context.
   * @default false
   */
  dense: M.bool,
  /**
   * If `true`, vertical padding is removed from the list.
   * @default false
   */
  disablePadding: M.bool,
  /**
   * The content of the subheader, normally `ListSubheader`.
   */
  subheader: M.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: M.oneOfType([M.arrayOf(M.oneOfType([M.func, M.object, M.bool])), M.func, M.object])
});
function QI(e) {
  const t = e.documentElement.clientWidth;
  return Math.abs(window.innerWidth - t);
}
const el = typeof window != "undefined" ? B.useLayoutEffect : B.useEffect, Wve = ["actions", "autoFocus", "autoFocusItem", "children", "className", "disabledItemsFocusable", "disableListWrap", "onKeyDown", "variant"];
function sb(e, t, n) {
  return e === t ? e.firstChild : t && t.nextElementSibling ? t.nextElementSibling : n ? null : e.firstChild;
}
function ZM(e, t, n) {
  return e === t ? n ? e.firstChild : e.lastChild : t && t.previousElementSibling ? t.previousElementSibling : n ? null : e.lastChild;
}
function e5(e, t) {
  if (t === void 0)
    return !0;
  let n = e.innerText;
  return n === void 0 && (n = e.textContent), n = n.trim().toLowerCase(), n.length === 0 ? !1 : t.repeating ? n[0] === t.keys[0] : n.indexOf(t.keys.join("")) === 0;
}
function Hu(e, t, n, r, o, i) {
  let a = !1, s = o(e, t, t ? n : !1);
  for (; s; ) {
    if (s === e.firstChild) {
      if (a)
        return !1;
      a = !0;
    }
    const c = r ? !1 : s.disabled || s.getAttribute("aria-disabled") === "true";
    if (!s.hasAttribute("tabindex") || !e5(s, i) || c)
      s = o(e, s, n);
    else
      return s.focus(), !0;
  }
  return !1;
}
const t5 = /* @__PURE__ */ B.forwardRef(function(t, n) {
  const {
    // private
    // eslint-disable-next-line react/prop-types
    actions: r,
    autoFocus: o = !1,
    autoFocusItem: i = !1,
    children: a,
    className: s,
    disabledItemsFocusable: c = !1,
    disableListWrap: l = !1,
    onKeyDown: d,
    variant: f = "selectedMenu"
  } = t, p = ot(t, Wve), m = B.useRef(null), v = B.useRef({
    keys: [],
    repeating: !0,
    previousKeyMatched: !0,
    lastTime: null
  });
  el(() => {
    o && m.current.focus();
  }, [o]), B.useImperativeHandle(r, () => ({
    adjustStyleForScrollbar: (S, {
      direction: _
    }) => {
      const w = !m.current.style.width;
      if (S.clientHeight < m.current.clientHeight && w) {
        const k = `${QI(qr(S))}px`;
        m.current.style[_ === "rtl" ? "paddingLeft" : "paddingRight"] = k, m.current.style.width = `calc(100% + ${k})`;
      }
      return m.current;
    }
  }), []);
  const g = (S) => {
    const _ = m.current, w = S.key, k = qr(_).activeElement;
    if (w === "ArrowDown")
      S.preventDefault(), Hu(_, k, l, c, sb);
    else if (w === "ArrowUp")
      S.preventDefault(), Hu(_, k, l, c, ZM);
    else if (w === "Home")
      S.preventDefault(), Hu(_, null, l, c, sb);
    else if (w === "End")
      S.preventDefault(), Hu(_, null, l, c, ZM);
    else if (w.length === 1) {
      const E = v.current, R = w.toLowerCase(), P = performance.now();
      E.keys.length > 0 && (P - E.lastTime > 500 ? (E.keys = [], E.repeating = !0, E.previousKeyMatched = !0) : E.repeating && R !== E.keys[0] && (E.repeating = !1)), E.lastTime = P, E.keys.push(R);
      const A = k && !E.repeating && e5(k, E);
      E.previousKeyMatched && (A || Hu(_, k, !1, c, sb, E)) ? S.preventDefault() : E.previousKeyMatched = !1;
    }
    d && d(S);
  }, b = Kr(m, n);
  let x = -1;
  B.Children.forEach(a, (S, _) => {
    if (!/* @__PURE__ */ B.isValidElement(S)) {
      x === _ && (x += 1, x >= a.length && (x = -1));
      return;
    }
    process.env.NODE_ENV !== "production" && Gd.isFragment(S) && console.error(["MUI: The Menu component doesn't accept a Fragment as a child.", "Consider providing an array instead."].join(`
`)), S.props.disabled || (f === "selectedMenu" && S.props.selected || x === -1) && (x = _), x === _ && (S.props.disabled || S.props.muiSkipListHighlight || S.type.muiSkipListHighlight) && (x += 1, x >= a.length && (x = -1));
  });
  const T = B.Children.map(a, (S, _) => {
    if (_ === x) {
      const w = {};
      return i && (w.autoFocus = !0), S.props.tabIndex === void 0 && f === "selectedMenu" && (w.tabIndex = 0), /* @__PURE__ */ B.cloneElement(S, w);
    }
    return S;
  });
  return /* @__PURE__ */ z(JI, ue({
    role: "menu",
    ref: b,
    className: s,
    onKeyDown: g,
    tabIndex: o ? 0 : -1
  }, p, {
    children: T
  }));
});
process.env.NODE_ENV !== "production" && (t5.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, will focus the `[role="menu"]` container and move into tab order.
   * @default false
   */
  autoFocus: M.bool,
  /**
   * If `true`, will focus the first menuitem if `variant="menu"` or selected item
   * if `variant="selectedMenu"`.
   * @default false
   */
  autoFocusItem: M.bool,
  /**
   * MenuList contents, normally `MenuItem`s.
   */
  children: M.node,
  /**
   * @ignore
   */
  className: M.string,
  /**
   * If `true`, will allow focus on disabled items.
   * @default false
   */
  disabledItemsFocusable: M.bool,
  /**
   * If `true`, the menu items will not wrap focus.
   * @default false
   */
  disableListWrap: M.bool,
  /**
   * @ignore
   */
  onKeyDown: M.func,
  /**
   * The variant to use. Use `menu` to prevent selected items from impacting the initial focus
   * and the vertical alignment relative to the anchor element.
   * @default 'selectedMenu'
   */
  variant: M.oneOf(["menu", "selectedMenu"])
});
const Ig = M.oneOfType([M.func, M.object]);
function vs(e, t) {
  return process.env.NODE_ENV === "production" ? () => null : function(...r) {
    return e(...r) || t(...r);
  };
}
function Vve(e) {
  const {
    prototype: t = {}
  } = e;
  return !!t.isReactComponent;
}
function Uve(e, t, n, r, o) {
  const i = e[t], a = o || t;
  if (i == null || // When server-side rendering React doesn't warn either.
  // This is not an accurate check for SSR.
  // This is only in place for emotion compat.
  // TODO: Revisit once https://github.com/facebook/react/issues/20047 is resolved.
  typeof window == "undefined")
    return null;
  let s;
  return typeof i == "function" && !Vve(i) && (s = "Did you accidentally provide a plain function component instead?"), s !== void 0 ? new Error(`Invalid ${r} \`${a}\` supplied to \`${n}\`. Expected an element type that can hold a ref. ${s} For more information see https://mui.com/r/caveat-with-refs-guide`) : null;
}
const n5 = vs(M.elementType, Uve);
function qve(e) {
  const t = typeof e;
  switch (t) {
    case "number":
      return Number.isNaN(e) ? "NaN" : Number.isFinite(e) ? e !== Math.floor(e) ? "float" : "number" : "Infinity";
    case "object":
      return e === null ? "null" : e.constructor.name;
    default:
      return t;
  }
}
function Gve(e) {
  return typeof e == "number" && isFinite(e) && Math.floor(e) === e;
}
const Yve = Number.isInteger || Gve;
function r5(e, t, n, r) {
  const o = e[t];
  if (o == null || !Yve(o)) {
    const i = qve(o);
    return new RangeError(`Invalid ${r} \`${t}\` of type \`${i}\` supplied to \`${n}\`, expected \`integer\`.`);
  }
  return null;
}
function o5(e, t, ...n) {
  return e[t] === void 0 ? null : r5(e, t, ...n);
}
function I1() {
  return null;
}
o5.isRequired = r5;
I1.isRequired = I1;
const Ti = process.env.NODE_ENV === "production" ? I1 : o5;
function Zve(e, t = 166) {
  let n;
  function r(...o) {
    const i = () => {
      e.apply(this, o);
    };
    clearTimeout(n), n = setTimeout(i, t);
  }
  return r.clear = () => {
    clearTimeout(n);
  }, r;
}
function Xd(e) {
  return qr(e).defaultView || window;
}
const XM = {};
function Xve(e, t) {
  const n = B.useRef(XM);
  return n.current === XM && (n.current = e(t)), n;
}
const Kve = [];
function Jve(e) {
  B.useEffect(e, Kve);
}
class Ef {
  constructor() {
    this.currentId = null, this.clear = () => {
      this.currentId !== null && (clearTimeout(this.currentId), this.currentId = null);
    }, this.disposeEffect = () => this.clear;
  }
  static create() {
    return new Ef();
  }
  /**
   * Executes `fn` after `delay`, clearing any previously scheduled call.
   */
  start(t, n) {
    this.clear(), this.currentId = setTimeout(() => {
      this.currentId = null, n();
    }, t);
  }
}
function ac() {
  const e = Xve(Ef.create).current;
  return Jve(e.disposeEffect), e;
}
function Qve(e) {
  const {
    prototype: t = {}
  } = e;
  return !!t.isReactComponent;
}
function i5(e, t, n, r, o) {
  const i = e[t], a = o || t;
  if (i == null || // When server-side rendering React doesn't warn either.
  // This is not an accurate check for SSR.
  // This is only in place for Emotion compat.
  // TODO: Revisit once https://github.com/facebook/react/issues/20047 is resolved.
  typeof window == "undefined")
    return null;
  let s;
  const c = i.type;
  return typeof c == "function" && !Qve(c) && (s = "Did you accidentally use a plain function component for an element instead?"), s !== void 0 ? new Error(`Invalid ${r} \`${a}\` supplied to \`${n}\`. Expected an element that can hold a ref. ${s} For more information see https://mui.com/r/caveat-with-refs-guide`) : null;
}
const Xc = vs(M.element, i5);
Xc.isRequired = vs(M.element.isRequired, i5);
function a5(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, Uy(e, t);
}
const KM = {
  disabled: !1
};
var e0e = process.env.NODE_ENV !== "production" ? M.oneOfType([M.number, M.shape({
  enter: M.number,
  exit: M.number,
  appear: M.number
}).isRequired]) : null;
process.env.NODE_ENV !== "production" && M.oneOfType([M.string, M.shape({
  enter: M.string,
  exit: M.string,
  active: M.string
}), M.shape({
  enter: M.string,
  enterDone: M.string,
  enterActive: M.string,
  exit: M.string,
  exitDone: M.string,
  exitActive: M.string
})]);
const cm = et.createContext(null);
var rd = "unmounted", Ls = "exited", $s = "entering", Yl = "entered", L1 = "exiting", qi = /* @__PURE__ */ function(e) {
  a5(t, e);
  function t(r, o) {
    var i;
    i = e.call(this, r, o) || this;
    var a = o, s = a && !a.isMounting ? r.enter : r.appear, c;
    return i.appearStatus = null, r.in ? s ? (c = Ls, i.appearStatus = $s) : c = Yl : r.unmountOnExit || r.mountOnEnter ? c = rd : c = Ls, i.state = {
      status: c
    }, i.nextCallback = null, i;
  }
  t.getDerivedStateFromProps = function(o, i) {
    var a = o.in;
    return a && i.status === rd ? {
      status: Ls
    } : null;
  };
  var n = t.prototype;
  return n.componentDidMount = function() {
    this.updateStatus(!0, this.appearStatus);
  }, n.componentDidUpdate = function(o) {
    var i = null;
    if (o !== this.props) {
      var a = this.state.status;
      this.props.in ? a !== $s && a !== Yl && (i = $s) : (a === $s || a === Yl) && (i = L1);
    }
    this.updateStatus(!1, i);
  }, n.componentWillUnmount = function() {
    this.cancelNextCallback();
  }, n.getTimeouts = function() {
    var o = this.props.timeout, i, a, s;
    return i = a = s = o, o != null && typeof o != "number" && (i = o.exit, a = o.enter, s = o.appear !== void 0 ? o.appear : a), {
      exit: i,
      enter: a,
      appear: s
    };
  }, n.updateStatus = function(o, i) {
    o === void 0 && (o = !1), i !== null ? (this.cancelNextCallback(), i === $s ? ((this.props.unmountOnExit || this.props.mountOnEnter) && (this.props.nodeRef ? this.props.nodeRef.current : _r.findDOMNode(this)), this.performEnter(o)) : this.performExit()) : this.props.unmountOnExit && this.state.status === Ls && this.setState({
      status: rd
    });
  }, n.performEnter = function(o) {
    var i = this, a = this.props.enter, s = this.context ? this.context.isMounting : o, c = this.props.nodeRef ? [s] : [_r.findDOMNode(this), s], l = c[0], d = c[1], f = this.getTimeouts(), p = s ? f.appear : f.enter;
    if (!o && !a || KM.disabled) {
      this.safeSetState({
        status: Yl
      }, function() {
        i.props.onEntered(l);
      });
      return;
    }
    this.props.onEnter(l, d), this.safeSetState({
      status: $s
    }, function() {
      i.props.onEntering(l, d), i.onTransitionEnd(p, function() {
        i.safeSetState({
          status: Yl
        }, function() {
          i.props.onEntered(l, d);
        });
      });
    });
  }, n.performExit = function() {
    var o = this, i = this.props.exit, a = this.getTimeouts(), s = this.props.nodeRef ? void 0 : _r.findDOMNode(this);
    if (!i || KM.disabled) {
      this.safeSetState({
        status: Ls
      }, function() {
        o.props.onExited(s);
      });
      return;
    }
    this.props.onExit(s), this.safeSetState({
      status: L1
    }, function() {
      o.props.onExiting(s), o.onTransitionEnd(a.exit, function() {
        o.safeSetState({
          status: Ls
        }, function() {
          o.props.onExited(s);
        });
      });
    });
  }, n.cancelNextCallback = function() {
    this.nextCallback !== null && (this.nextCallback.cancel(), this.nextCallback = null);
  }, n.safeSetState = function(o, i) {
    i = this.setNextCallback(i), this.setState(o, i);
  }, n.setNextCallback = function(o) {
    var i = this, a = !0;
    return this.nextCallback = function(s) {
      a && (a = !1, i.nextCallback = null, o(s));
    }, this.nextCallback.cancel = function() {
      a = !1;
    }, this.nextCallback;
  }, n.onTransitionEnd = function(o, i) {
    this.setNextCallback(i);
    var a = this.props.nodeRef ? this.props.nodeRef.current : _r.findDOMNode(this), s = o == null && !this.props.addEndListener;
    if (!a || s) {
      setTimeout(this.nextCallback, 0);
      return;
    }
    if (this.props.addEndListener) {
      var c = this.props.nodeRef ? [this.nextCallback] : [a, this.nextCallback], l = c[0], d = c[1];
      this.props.addEndListener(l, d);
    }
    o != null && setTimeout(this.nextCallback, o);
  }, n.render = function() {
    var o = this.state.status;
    if (o === rd)
      return null;
    var i = this.props, a = i.children, s = ot(i, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);
    return (
      // allows for nested Transitions
      /* @__PURE__ */ et.createElement(cm.Provider, {
        value: null
      }, typeof a == "function" ? a(o, s) : et.cloneElement(et.Children.only(a), s))
    );
  }, t;
}(et.Component);
qi.contextType = cm;
qi.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * A React reference to DOM element that need to transition:
   * https://stackoverflow.com/a/51127130/4671932
   *
   *   - When `nodeRef` prop is used, `node` is not passed to callback functions
   *      (e.g. `onEnter`) because user already has direct access to the node.
   *   - When changing `key` prop of `Transition` in a `TransitionGroup` a new
   *     `nodeRef` need to be provided to `Transition` with changed `key` prop
   *     (see
   *     [test/CSSTransition-test.js](https://github.com/reactjs/react-transition-group/blob/13435f897b3ab71f6e19d724f145596f5910581c/test/CSSTransition-test.js#L362-L437)).
   */
  nodeRef: M.shape({
    current: typeof Element == "undefined" ? M.any : function(e, t, n, r, o, i) {
      var a = e[t];
      return M.instanceOf(a && "ownerDocument" in a ? a.ownerDocument.defaultView.Element : Element)(e, t, n, r, o, i);
    }
  }),
  /**
   * A `function` child can be used instead of a React element. This function is
   * called with the current transition status (`'entering'`, `'entered'`,
   * `'exiting'`, `'exited'`), which can be used to apply context
   * specific props to a component.
   *
   * ```jsx
   * <Transition in={this.state.in} timeout={150}>
   *   {state => (
   *     <MyComponent className={`fade fade-${state}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: M.oneOfType([M.func.isRequired, M.element.isRequired]).isRequired,
  /**
   * Show the component; triggers the enter or exit states
   */
  in: M.bool,
  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: M.bool,
  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: M.bool,
  /**
   * By default the child component does not perform the enter transition when
   * it first mounts, regardless of the value of `in`. If you want this
   * behavior, set both `appear` and `in` to `true`.
   *
   * > **Note**: there are no special appear states like `appearing`/`appeared`, this prop
   * > only adds an additional enter transition. However, in the
   * > `<CSSTransition>` component that first enter transition does result in
   * > additional `.appear-*` classes, that way you can choose to style it
   * > differently.
   */
  appear: M.bool,
  /**
   * Enable or disable enter transitions.
   */
  enter: M.bool,
  /**
   * Enable or disable exit transitions.
   */
  exit: M.bool,
  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided.
   *
   * You may specify a single timeout for all transitions:
   *
   * ```jsx
   * timeout={500}
   * ```
   *
   * or individually:
   *
   * ```jsx
   * timeout={{
   *  appear: 500,
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * - `appear` defaults to the value of `enter`
   * - `enter` defaults to `0`
   * - `exit` defaults to `0`
   *
   * @type {number | { enter?: number, exit?: number, appear?: number }}
   */
  timeout: function(t) {
    var n = e0e;
    t.addEndListener || (n = n.isRequired);
    for (var r = arguments.length, o = new Array(r > 1 ? r - 1 : 0), i = 1; i < r; i++)
      o[i - 1] = arguments[i];
    return n.apply(void 0, [t].concat(o));
  },
  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. Timeouts are still used as a fallback if provided.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: M.func,
  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: M.func,
  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: M.func,
  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: M.func,
  /**
   * Callback fired before the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: M.func,
  /**
   * Callback fired after the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: M.func,
  /**
   * Callback fired after the "exited" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: M.func
} : {};
function jl() {
}
qi.defaultProps = {
  in: !1,
  mountOnEnter: !1,
  unmountOnExit: !1,
  appear: !1,
  enter: !0,
  exit: !0,
  onEnter: jl,
  onEntering: jl,
  onEntered: jl,
  onExit: jl,
  onExiting: jl,
  onExited: jl
};
qi.UNMOUNTED = rd;
qi.EXITED = Ls;
qi.ENTERING = $s;
qi.ENTERED = Yl;
qi.EXITING = L1;
function rx(e, t) {
  var n = function(i) {
    return t && sa(i) ? t(i) : i;
  }, r = /* @__PURE__ */ Object.create(null);
  return e && JP.map(e, function(o) {
    return o;
  }).forEach(function(o) {
    r[o.key] = n(o);
  }), r;
}
function t0e(e, t) {
  e = e || {}, t = t || {};
  function n(d) {
    return d in t ? t[d] : e[d];
  }
  var r = /* @__PURE__ */ Object.create(null), o = [];
  for (var i in e)
    i in t ? o.length && (r[i] = o, o = []) : o.push(i);
  var a, s = {};
  for (var c in t) {
    if (r[c])
      for (a = 0; a < r[c].length; a++) {
        var l = r[c][a];
        s[r[c][a]] = n(l);
      }
    s[c] = n(c);
  }
  for (a = 0; a < o.length; a++)
    s[o[a]] = n(o[a]);
  return s;
}
function js(e, t, n) {
  return n[t] != null ? n[t] : e.props[t];
}
function n0e(e, t) {
  return rx(e.children, function(n) {
    return es(n, {
      onExited: t.bind(null, n),
      in: !0,
      appear: js(n, "appear", e),
      enter: js(n, "enter", e),
      exit: js(n, "exit", e)
    });
  });
}
function r0e(e, t, n) {
  var r = rx(e.children), o = t0e(t, r);
  return Object.keys(o).forEach(function(i) {
    var a = o[i];
    if (sa(a)) {
      var s = i in t, c = i in r, l = t[i], d = sa(l) && !l.props.in;
      c && (!s || d) ? o[i] = es(a, {
        onExited: n.bind(null, a),
        in: !0,
        exit: js(a, "exit", e),
        enter: js(a, "enter", e)
      }) : !c && s && !d ? o[i] = es(a, {
        in: !1
      }) : c && s && sa(l) && (o[i] = es(a, {
        onExited: n.bind(null, a),
        in: l.props.in,
        exit: js(a, "exit", e),
        enter: js(a, "enter", e)
      }));
    }
  }), o;
}
var o0e = Object.values || function(e) {
  return Object.keys(e).map(function(t) {
    return e[t];
  });
}, i0e = {
  component: "div",
  childFactory: function(t) {
    return t;
  }
}, ox = /* @__PURE__ */ function(e) {
  a5(t, e);
  function t(r, o) {
    var i;
    i = e.call(this, r, o) || this;
    var a = i.handleExited.bind(Wie(i));
    return i.state = {
      contextValue: {
        isMounting: !0
      },
      handleExited: a,
      firstRender: !0
    }, i;
  }
  var n = t.prototype;
  return n.componentDidMount = function() {
    this.mounted = !0, this.setState({
      contextValue: {
        isMounting: !1
      }
    });
  }, n.componentWillUnmount = function() {
    this.mounted = !1;
  }, t.getDerivedStateFromProps = function(o, i) {
    var a = i.children, s = i.handleExited, c = i.firstRender;
    return {
      children: c ? n0e(o, s) : r0e(o, a, s),
      firstRender: !1
    };
  }, n.handleExited = function(o, i) {
    var a = rx(this.props.children);
    o.key in a || (o.props.onExited && o.props.onExited(i), this.mounted && this.setState(function(s) {
      var c = ue({}, s.children);
      return delete c[o.key], {
        children: c
      };
    }));
  }, n.render = function() {
    var o = this.props, i = o.component, a = o.childFactory, s = ot(o, ["component", "childFactory"]), c = this.state.contextValue, l = o0e(this.state.children).map(a);
    return delete s.appear, delete s.enter, delete s.exit, i === null ? /* @__PURE__ */ et.createElement(cm.Provider, {
      value: c
    }, l) : /* @__PURE__ */ et.createElement(cm.Provider, {
      value: c
    }, /* @__PURE__ */ et.createElement(i, s, l));
  }, t;
}(et.Component);
ox.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * `<TransitionGroup>` renders a `<div>` by default. You can change this
   * behavior by providing a `component` prop.
   * If you use React v16+ and would like to avoid a wrapping `<div>` element
   * you can pass in `component={null}`. This is useful if the wrapping div
   * borks your css styles.
   */
  component: M.any,
  /**
   * A set of `<Transition>` components, that are toggled `in` and out as they
   * leave. the `<TransitionGroup>` will inject specific transition props, so
   * remember to spread them through if you are wrapping the `<Transition>` as
   * with our `<Fade>` example.
   *
   * While this component is meant for multiple `Transition` or `CSSTransition`
   * children, sometimes you may want to have a single transition child with
   * content that you want to be transitioned out and in when you change it
   * (e.g. routes, images etc.) In that case you can change the `key` prop of
   * the transition child as you change its content, this will cause
   * `TransitionGroup` to transition the child out and back in.
   */
  children: M.node,
  /**
   * A convenience prop that enables or disables appear animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  appear: M.bool,
  /**
   * A convenience prop that enables or disables enter animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  enter: M.bool,
  /**
   * A convenience prop that enables or disables exit animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  exit: M.bool,
  /**
   * You may need to apply reactive updates to a child as it is exiting.
   * This is generally done by using `cloneElement` however in the case of an exiting
   * child the element has already been removed and not accessible to the consumer.
   *
   * If you do need to update a child as it leaves you can provide a `childFactory`
   * to wrap every child, even the ones that are leaving.
   *
   * @type Function(child: ReactElement) -> ReactElement
   */
  childFactory: M.func
} : {};
ox.defaultProps = i0e;
function a0e(e) {
  return Object.keys(e).length === 0;
}
function s0e(e = null) {
  const t = B.useContext(Hi);
  return !t || a0e(t) ? e : t;
}
const l0e = Qw();
function c0e(e = l0e) {
  return s0e(e);
}
function Lg() {
  const e = c0e(XI);
  return process.env.NODE_ENV !== "production" && B.useDebugValue(e), e[KI] || e;
}
function um(e, t) {
  var n, r;
  const {
    timeout: o,
    easing: i,
    style: a = {}
  } = e;
  return {
    duration: (n = a.transitionDuration) != null ? n : typeof o == "number" ? o : o[t.mode] || 0,
    easing: (r = a.transitionTimingFunction) != null ? r : typeof i == "object" ? i[t.mode] : i,
    delay: a.transitionDelay
  };
}
const u0e = ["addEndListener", "appear", "children", "easing", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "style", "timeout", "TransitionComponent"];
function $1(e) {
  return `scale(${e}, ${ro(e, 2)})`;
}
const d0e = {
  entering: {
    opacity: 1,
    transform: $1(1)
  },
  entered: {
    opacity: 1,
    transform: "none"
  }
}, lb = typeof navigator != "undefined" && /^((?!chrome|android).)*(safari|mobile)/i.test(navigator.userAgent) && /(os |version\/)15(.|_)4/i.test(navigator.userAgent), Kd = /* @__PURE__ */ B.forwardRef(function(t, n) {
  const {
    addEndListener: r,
    appear: o = !0,
    children: i,
    easing: a,
    in: s,
    onEnter: c,
    onEntered: l,
    onEntering: d,
    onExit: f,
    onExited: p,
    onExiting: m,
    style: v,
    timeout: g = "auto",
    // eslint-disable-next-line react/prop-types
    TransitionComponent: b = qi
  } = t, x = ot(t, u0e), T = ac(), S = B.useRef(), _ = Lg(), w = B.useRef(null), k = Kr(w, i.ref, n), E = (I) => (j) => {
    if (I) {
      const U = w.current;
      j === void 0 ? I(U) : I(U, j);
    }
  }, R = E(d), P = E((I, j) => {
    const {
      duration: U,
      delay: G,
      easing: V
    } = um({
      style: v,
      timeout: g,
      easing: a
    }, {
      mode: "enter"
    });
    let H;
    g === "auto" ? (H = _.transitions.getAutoHeightDuration(I.clientHeight), S.current = H) : H = U, I.style.transition = [_.transitions.create("opacity", {
      duration: H,
      delay: G
    }), _.transitions.create("transform", {
      duration: lb ? H : H * 0.666,
      delay: G,
      easing: V
    })].join(","), c && c(I, j);
  }), A = E(l), D = E(m), N = E((I) => {
    const {
      duration: j,
      delay: U,
      easing: G
    } = um({
      style: v,
      timeout: g,
      easing: a
    }, {
      mode: "exit"
    });
    let V;
    g === "auto" ? (V = _.transitions.getAutoHeightDuration(I.clientHeight), S.current = V) : V = j, I.style.transition = [_.transitions.create("opacity", {
      duration: V,
      delay: U
    }), _.transitions.create("transform", {
      duration: lb ? V : V * 0.666,
      delay: lb ? U : U || V * 0.333,
      easing: G
    })].join(","), I.style.opacity = 0, I.style.transform = $1(0.75), f && f(I);
  }), F = E(p);
  return /* @__PURE__ */ z(b, ue({
    appear: o,
    in: s,
    nodeRef: w,
    onEnter: P,
    onEntered: A,
    onEntering: R,
    onExit: N,
    onExited: F,
    onExiting: D,
    addEndListener: (I) => {
      g === "auto" && T.start(S.current || 0, I), r && r(w.current, I);
    },
    timeout: g === "auto" ? null : g
  }, x, {
    children: (I, j) => /* @__PURE__ */ B.cloneElement(i, ue({
      style: ue({
        opacity: 0,
        transform: $1(0.75),
        visibility: I === "exited" && !s ? "hidden" : void 0
      }, d0e[I], v, i.props.style),
      ref: k
    }, j))
  }));
});
process.env.NODE_ENV !== "production" && (Kd.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Add a custom transition end trigger. Called with the transitioning DOM
   * node and a done callback. Allows for more fine grained transition end
   * logic. Note: Timeouts are still used as a fallback if provided.
   */
  addEndListener: M.func,
  /**
   * Perform the enter transition when it first mounts if `in` is also `true`.
   * Set this to `false` to disable this behavior.
   * @default true
   */
  appear: M.bool,
  /**
   * A single child content element.
   */
  children: Xc.isRequired,
  /**
   * The transition timing function.
   * You may specify a single easing or a object containing enter and exit values.
   */
  easing: M.oneOfType([M.shape({
    enter: M.string,
    exit: M.string
  }), M.string]),
  /**
   * If `true`, the component will transition in.
   */
  in: M.bool,
  /**
   * @ignore
   */
  onEnter: M.func,
  /**
   * @ignore
   */
  onEntered: M.func,
  /**
   * @ignore
   */
  onEntering: M.func,
  /**
   * @ignore
   */
  onExit: M.func,
  /**
   * @ignore
   */
  onExited: M.func,
  /**
   * @ignore
   */
  onExiting: M.func,
  /**
   * @ignore
   */
  style: M.object,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   *
   * Set to 'auto' to automatically calculate transition time based on height.
   * @default 'auto'
   */
  timeout: M.oneOfType([M.oneOf(["auto"]), M.number, M.shape({
    appear: M.number,
    enter: M.number,
    exit: M.number
  })])
});
Kd.muiSupportAuto = !0;
const f0e = "exact-prop: ​";
function s5(e) {
  return process.env.NODE_ENV === "production" ? e : ue({}, e, {
    [f0e]: (t) => {
      const n = Object.keys(t).filter((r) => !e.hasOwnProperty(r));
      return n.length > 0 ? new Error(`The following props are not supported: ${n.map((r) => `\`${r}\``).join(", ")}. Please remove them.`) : null;
    }
  });
}
function xt(e) {
  if (typeof e != "string")
    throw new Error(process.env.NODE_ENV !== "production" ? "MUI: `capitalize(string)` expects a string argument." : am(7));
  return e.charAt(0).toUpperCase() + e.slice(1);
}
function JM(...e) {
  return e.reduce((t, n) => n == null ? t : function(...o) {
    t.apply(this, o), n.apply(this, o);
  }, () => {
  });
}
let QM = 0;
function p0e(e) {
  const [t, n] = B.useState(e), r = e || t;
  return B.useEffect(() => {
    t == null && (QM += 1, n(`mui-${QM}`));
  }, [t]), r;
}
const eR = B[`useId${Math.random()}`.slice(0, 5)];
function h0e(e) {
  if (eR !== void 0) {
    const t = eR();
    return e != null ? e : t;
  }
  return p0e(e);
}
function l5({
  controlled: e,
  default: t,
  name: n,
  state: r = "value"
}) {
  const {
    current: o
  } = B.useRef(e !== void 0), [i, a] = B.useState(t), s = o ? e : i;
  if (process.env.NODE_ENV !== "production") {
    B.useEffect(() => {
      o !== (e !== void 0) && console.error([`MUI: A component is changing the ${o ? "" : "un"}controlled ${r} state of ${n} to be ${o ? "un" : ""}controlled.`, "Elements should not switch from uncontrolled to controlled (or vice versa).", `Decide between using a controlled or uncontrolled ${n} element for the lifetime of the component.`, "The nature of the state is determined during the first render. It's considered controlled if the value is not `undefined`.", "More info: https://fb.me/react-controlled-components"].join(`
`));
    }, [r, n, e]);
    const {
      current: l
    } = B.useRef(t);
    B.useEffect(() => {
      !o && !Object.is(l, t) && console.error([`MUI: A component is changing the default ${r} state of an uncontrolled ${n} after being initialized. To suppress this warning opt to use a controlled ${n}.`].join(`
`));
    }, [JSON.stringify(t)]);
  }
  const c = B.useCallback((l) => {
    o || a(l);
  }, []);
  return [s, c];
}
function Ja(e) {
  const t = B.useRef(e);
  return el(() => {
    t.current = e;
  }), B.useRef((...n) => (
    // @ts-expect-error hide `this`
    (0, t.current)(...n)
  )).current;
}
let $g = !0, F1 = !1;
const m0e = new Ef(), g0e = {
  text: !0,
  search: !0,
  url: !0,
  tel: !0,
  email: !0,
  password: !0,
  number: !0,
  date: !0,
  month: !0,
  week: !0,
  time: !0,
  datetime: !0,
  "datetime-local": !0
};
function v0e(e) {
  const {
    type: t,
    tagName: n
  } = e;
  return !!(n === "INPUT" && g0e[t] && !e.readOnly || n === "TEXTAREA" && !e.readOnly || e.isContentEditable);
}
function b0e(e) {
  e.metaKey || e.altKey || e.ctrlKey || ($g = !0);
}
function cb() {
  $g = !1;
}
function y0e() {
  this.visibilityState === "hidden" && F1 && ($g = !0);
}
function _0e(e) {
  e.addEventListener("keydown", b0e, !0), e.addEventListener("mousedown", cb, !0), e.addEventListener("pointerdown", cb, !0), e.addEventListener("touchstart", cb, !0), e.addEventListener("visibilitychange", y0e, !0);
}
function w0e(e) {
  const {
    target: t
  } = e;
  try {
    return t.matches(":focus-visible");
  } catch (n) {
  }
  return $g || v0e(t);
}
function c5() {
  const e = B.useCallback((o) => {
    o != null && _0e(o.ownerDocument);
  }, []), t = B.useRef(!1);
  function n() {
    return t.current ? (F1 = !0, m0e.start(100, () => {
      F1 = !1;
    }), t.current = !1, !0) : !1;
  }
  function r(o) {
    return w0e(o) ? (t.current = !0, !0) : !1;
  }
  return {
    isFocusVisibleRef: t,
    onFocus: r,
    onBlur: n,
    ref: e
  };
}
function u5(e, t) {
  const n = ue({}, t);
  return Object.keys(e).forEach((r) => {
    if (r.toString().match(/^(components|slots)$/))
      n[r] = ue({}, e[r], n[r]);
    else if (r.toString().match(/^(componentsProps|slotProps)$/)) {
      const o = e[r] || {}, i = t[r];
      n[r] = {}, !i || !Object.keys(i) ? n[r] = o : !o || !Object.keys(o) ? n[r] = i : (n[r] = ue({}, i), Object.keys(o).forEach((a) => {
        n[r][a] = u5(o[a], i[a]);
      }));
    } else
      n[r] === void 0 && (n[r] = e[r]);
  }), n;
}
function x0e(e) {
  const t = qr(e);
  return t.body === e ? Xd(e).innerWidth > t.documentElement.clientWidth : e.scrollHeight > e.clientHeight;
}
function wd(e, t) {
  t ? e.setAttribute("aria-hidden", "true") : e.removeAttribute("aria-hidden");
}
function tR(e) {
  return parseInt(Xd(e).getComputedStyle(e).paddingRight, 10) || 0;
}
function C0e(e) {
  const n = ["TEMPLATE", "SCRIPT", "STYLE", "LINK", "MAP", "META", "NOSCRIPT", "PICTURE", "COL", "COLGROUP", "PARAM", "SLOT", "SOURCE", "TRACK"].indexOf(e.tagName) !== -1, r = e.tagName === "INPUT" && e.getAttribute("type") === "hidden";
  return n || r;
}
function nR(e, t, n, r, o) {
  const i = [t, n, ...r];
  [].forEach.call(e.children, (a) => {
    const s = i.indexOf(a) === -1, c = !C0e(a);
    s && c && wd(a, o);
  });
}
function ub(e, t) {
  let n = -1;
  return e.some((r, o) => t(r) ? (n = o, !0) : !1), n;
}
function S0e(e, t) {
  const n = [], r = e.container;
  if (!t.disableScrollLock) {
    if (x0e(r)) {
      const a = QI(qr(r));
      n.push({
        value: r.style.paddingRight,
        property: "padding-right",
        el: r
      }), r.style.paddingRight = `${tR(r) + a}px`;
      const s = qr(r).querySelectorAll(".mui-fixed");
      [].forEach.call(s, (c) => {
        n.push({
          value: c.style.paddingRight,
          property: "padding-right",
          el: c
        }), c.style.paddingRight = `${tR(c) + a}px`;
      });
    }
    let i;
    if (r.parentNode instanceof DocumentFragment)
      i = qr(r).body;
    else {
      const a = r.parentElement, s = Xd(r);
      i = (a == null ? void 0 : a.nodeName) === "HTML" && s.getComputedStyle(a).overflowY === "scroll" ? a : r;
    }
    n.push({
      value: i.style.overflow,
      property: "overflow",
      el: i
    }, {
      value: i.style.overflowX,
      property: "overflow-x",
      el: i
    }, {
      value: i.style.overflowY,
      property: "overflow-y",
      el: i
    }), i.style.overflow = "hidden";
  }
  return () => {
    n.forEach(({
      value: i,
      el: a,
      property: s
    }) => {
      i ? a.style.setProperty(s, i) : a.style.removeProperty(s);
    });
  };
}
function T0e(e) {
  const t = [];
  return [].forEach.call(e.children, (n) => {
    n.getAttribute("aria-hidden") === "true" && t.push(n);
  }), t;
}
class E0e {
  constructor() {
    this.containers = void 0, this.modals = void 0, this.modals = [], this.containers = [];
  }
  add(t, n) {
    let r = this.modals.indexOf(t);
    if (r !== -1)
      return r;
    r = this.modals.length, this.modals.push(t), t.modalRef && wd(t.modalRef, !1);
    const o = T0e(n);
    nR(n, t.mount, t.modalRef, o, !0);
    const i = ub(this.containers, (a) => a.container === n);
    return i !== -1 ? (this.containers[i].modals.push(t), r) : (this.containers.push({
      modals: [t],
      container: n,
      restore: null,
      hiddenSiblings: o
    }), r);
  }
  mount(t, n) {
    const r = ub(this.containers, (i) => i.modals.indexOf(t) !== -1), o = this.containers[r];
    o.restore || (o.restore = S0e(o, n));
  }
  remove(t, n = !0) {
    const r = this.modals.indexOf(t);
    if (r === -1)
      return r;
    const o = ub(this.containers, (a) => a.modals.indexOf(t) !== -1), i = this.containers[o];
    if (i.modals.splice(i.modals.indexOf(t), 1), this.modals.splice(r, 1), i.modals.length === 0)
      i.restore && i.restore(), t.modalRef && wd(t.modalRef, n), nR(i.container, t.mount, t.modalRef, i.hiddenSiblings, !1), this.containers.splice(o, 1);
    else {
      const a = i.modals[i.modals.length - 1];
      a.modalRef && wd(a.modalRef, !1);
    }
    return r;
  }
  isTopModal(t) {
    return this.modals.length > 0 && this.modals[this.modals.length - 1] === t;
  }
}
const k0e = ["input", "select", "textarea", "a[href]", "button", "[tabindex]", "audio[controls]", "video[controls]", '[contenteditable]:not([contenteditable="false"])'].join(",");
function M0e(e) {
  const t = parseInt(e.getAttribute("tabindex") || "", 10);
  return Number.isNaN(t) ? e.contentEditable === "true" || (e.nodeName === "AUDIO" || e.nodeName === "VIDEO" || e.nodeName === "DETAILS") && e.getAttribute("tabindex") === null ? 0 : e.tabIndex : t;
}
function R0e(e) {
  if (e.tagName !== "INPUT" || e.type !== "radio" || !e.name)
    return !1;
  const t = (r) => e.ownerDocument.querySelector(`input[type="radio"]${r}`);
  let n = t(`[name="${e.name}"]:checked`);
  return n || (n = t(`[name="${e.name}"]`)), n !== e;
}
function P0e(e) {
  return !(e.disabled || e.tagName === "INPUT" && e.type === "hidden" || R0e(e));
}
function O0e(e) {
  const t = [], n = [];
  return Array.from(e.querySelectorAll(k0e)).forEach((r, o) => {
    const i = M0e(r);
    i === -1 || !P0e(r) || (i === 0 ? t.push(r) : n.push({
      documentOrder: o,
      tabIndex: i,
      node: r
    }));
  }), n.sort((r, o) => r.tabIndex === o.tabIndex ? r.documentOrder - o.documentOrder : r.tabIndex - o.tabIndex).map((r) => r.node).concat(t);
}
function N0e() {
  return !0;
}
function dm(e) {
  const {
    children: t,
    disableAutoFocus: n = !1,
    disableEnforceFocus: r = !1,
    disableRestoreFocus: o = !1,
    getTabbable: i = O0e,
    isEnabled: a = N0e,
    open: s
  } = e, c = B.useRef(!1), l = B.useRef(null), d = B.useRef(null), f = B.useRef(null), p = B.useRef(null), m = B.useRef(!1), v = B.useRef(null), g = Kr(t.ref, v), b = B.useRef(null);
  B.useEffect(() => {
    !s || !v.current || (m.current = !n);
  }, [n, s]), B.useEffect(() => {
    if (!s || !v.current)
      return;
    const S = qr(v.current);
    return v.current.contains(S.activeElement) || (v.current.hasAttribute("tabIndex") || (process.env.NODE_ENV !== "production" && console.error(["MUI: The modal content node does not accept focus.", 'For the benefit of assistive technologies, the tabIndex of the node is being set to "-1".'].join(`
`)), v.current.setAttribute("tabIndex", "-1")), m.current && v.current.focus()), () => {
      o || (f.current && f.current.focus && (c.current = !0, f.current.focus()), f.current = null);
    };
  }, [s]), B.useEffect(() => {
    if (!s || !v.current)
      return;
    const S = qr(v.current), _ = (E) => {
      b.current = E, !(r || !a() || E.key !== "Tab") && S.activeElement === v.current && E.shiftKey && (c.current = !0, d.current && d.current.focus());
    }, w = () => {
      const E = v.current;
      if (E === null)
        return;
      if (!S.hasFocus() || !a() || c.current) {
        c.current = !1;
        return;
      }
      if (E.contains(S.activeElement) || r && S.activeElement !== l.current && S.activeElement !== d.current)
        return;
      if (S.activeElement !== p.current)
        p.current = null;
      else if (p.current !== null)
        return;
      if (!m.current)
        return;
      let R = [];
      if ((S.activeElement === l.current || S.activeElement === d.current) && (R = i(v.current)), R.length > 0) {
        var P, A;
        const D = !!((P = b.current) != null && P.shiftKey && ((A = b.current) == null ? void 0 : A.key) === "Tab"), N = R[0], F = R[R.length - 1];
        typeof N != "string" && typeof F != "string" && (D ? F.focus() : N.focus());
      } else
        E.focus();
    };
    S.addEventListener("focusin", w), S.addEventListener("keydown", _, !0);
    const k = setInterval(() => {
      S.activeElement && S.activeElement.tagName === "BODY" && w();
    }, 50);
    return () => {
      clearInterval(k), S.removeEventListener("focusin", w), S.removeEventListener("keydown", _, !0);
    };
  }, [n, r, o, a, s, i]);
  const x = (S) => {
    f.current === null && (f.current = S.relatedTarget), m.current = !0, p.current = S.target;
    const _ = t.props.onFocus;
    _ && _(S);
  }, T = (S) => {
    f.current === null && (f.current = S.relatedTarget), m.current = !0;
  };
  return /* @__PURE__ */ _e(B.Fragment, {
    children: [/* @__PURE__ */ z("div", {
      tabIndex: s ? 0 : -1,
      onFocus: T,
      ref: l,
      "data-testid": "sentinelStart"
    }), /* @__PURE__ */ B.cloneElement(t, {
      ref: g,
      onFocus: x
    }), /* @__PURE__ */ z("div", {
      tabIndex: s ? 0 : -1,
      onFocus: T,
      ref: d,
      "data-testid": "sentinelEnd"
    })]
  });
}
process.env.NODE_ENV !== "production" && (dm.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A single child content element.
   */
  children: Xc,
  /**
   * If `true`, the focus trap will not automatically shift focus to itself when it opens, and
   * replace it to the last focused element when it closes.
   * This also works correctly with any focus trap children that have the `disableAutoFocus` prop.
   *
   * Generally this should never be set to `true` as it makes the focus trap less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableAutoFocus: M.bool,
  /**
   * If `true`, the focus trap will not prevent focus from leaving the focus trap while open.
   *
   * Generally this should never be set to `true` as it makes the focus trap less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableEnforceFocus: M.bool,
  /**
   * If `true`, the focus trap will not restore focus to previously focused element once
   * focus trap is hidden or unmounted.
   * @default false
   */
  disableRestoreFocus: M.bool,
  /**
   * Returns an array of ordered tabbable nodes (i.e. in tab order) within the root.
   * For instance, you can provide the "tabbable" npm dependency.
   * @param {HTMLElement} root
   */
  getTabbable: M.func,
  /**
   * This prop extends the `open` prop.
   * It allows to toggle the open state without having to wait for a rerender when changing the `open` prop.
   * This prop should be memoized.
   * It can be used to support multiple focus trap mounted at the same time.
   * @default function defaultIsEnabled(): boolean {
   *   return true;
   * }
   */
  isEnabled: M.func,
  /**
   * If `true`, focus is locked.
   */
  open: M.bool.isRequired
});
process.env.NODE_ENV !== "production" && (dm.propTypes = s5(dm.propTypes));
function A0e(e) {
  return typeof e == "function" ? e() : e;
}
const Jd = /* @__PURE__ */ B.forwardRef(function(t, n) {
  const {
    children: r,
    container: o,
    disablePortal: i = !1
  } = t, [a, s] = B.useState(null), c = Kr(/* @__PURE__ */ B.isValidElement(r) ? r.ref : null, n);
  if (el(() => {
    i || s(A0e(o) || document.body);
  }, [o, i]), el(() => {
    if (a && !i)
      return O1(n, a), () => {
        O1(n, null);
      };
  }, [n, a, i]), i) {
    if (/* @__PURE__ */ B.isValidElement(r)) {
      const l = {
        ref: c
      };
      return /* @__PURE__ */ B.cloneElement(r, l);
    }
    return /* @__PURE__ */ z(B.Fragment, {
      children: r
    });
  }
  return /* @__PURE__ */ z(B.Fragment, {
    children: a && /* @__PURE__ */ MO.createPortal(r, a)
  });
});
process.env.NODE_ENV !== "production" && (Jd.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The children to render into the `container`.
   */
  children: M.node,
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * You can also provide a callback, which is called in a React layout effect.
   * This lets you set the container from a ref, and also makes server-side rendering possible.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: M.oneOfType([ma, M.func]),
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: M.bool
});
process.env.NODE_ENV !== "production" && (Jd.propTypes = s5(Jd.propTypes));
const D0e = ["addEndListener", "appear", "children", "easing", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "style", "timeout", "TransitionComponent"], I0e = {
  entering: {
    opacity: 1
  },
  entered: {
    opacity: 1
  }
}, d5 = /* @__PURE__ */ B.forwardRef(function(t, n) {
  const r = Lg(), o = {
    enter: r.transitions.duration.enteringScreen,
    exit: r.transitions.duration.leavingScreen
  }, {
    addEndListener: i,
    appear: a = !0,
    children: s,
    easing: c,
    in: l,
    onEnter: d,
    onEntered: f,
    onEntering: p,
    onExit: m,
    onExited: v,
    onExiting: g,
    style: b,
    timeout: x = o,
    // eslint-disable-next-line react/prop-types
    TransitionComponent: T = qi
  } = t, S = ot(t, D0e), _ = B.useRef(null), w = Kr(_, s.ref, n), k = ($) => (I) => {
    if ($) {
      const j = _.current;
      I === void 0 ? $(j) : $(j, I);
    }
  }, E = k(p), R = k(($, I) => {
    const j = um({
      style: b,
      timeout: x,
      easing: c
    }, {
      mode: "enter"
    });
    $.style.webkitTransition = r.transitions.create("opacity", j), $.style.transition = r.transitions.create("opacity", j), d && d($, I);
  }), P = k(f), A = k(g), D = k(($) => {
    const I = um({
      style: b,
      timeout: x,
      easing: c
    }, {
      mode: "exit"
    });
    $.style.webkitTransition = r.transitions.create("opacity", I), $.style.transition = r.transitions.create("opacity", I), m && m($);
  }), N = k(v);
  return /* @__PURE__ */ z(T, ue({
    appear: a,
    in: l,
    nodeRef: _,
    onEnter: R,
    onEntered: P,
    onEntering: E,
    onExit: D,
    onExited: N,
    onExiting: A,
    addEndListener: ($) => {
      i && i(_.current, $);
    },
    timeout: x
  }, S, {
    children: ($, I) => /* @__PURE__ */ B.cloneElement(s, ue({
      style: ue({
        opacity: 0,
        visibility: $ === "exited" && !l ? "hidden" : void 0
      }, I0e[$], b, s.props.style),
      ref: w
    }, I))
  }));
});
process.env.NODE_ENV !== "production" && (d5.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Add a custom transition end trigger. Called with the transitioning DOM
   * node and a done callback. Allows for more fine grained transition end
   * logic. Note: Timeouts are still used as a fallback if provided.
   */
  addEndListener: M.func,
  /**
   * Perform the enter transition when it first mounts if `in` is also `true`.
   * Set this to `false` to disable this behavior.
   * @default true
   */
  appear: M.bool,
  /**
   * A single child content element.
   */
  children: Xc.isRequired,
  /**
   * The transition timing function.
   * You may specify a single easing or a object containing enter and exit values.
   */
  easing: M.oneOfType([M.shape({
    enter: M.string,
    exit: M.string
  }), M.string]),
  /**
   * If `true`, the component will transition in.
   */
  in: M.bool,
  /**
   * @ignore
   */
  onEnter: M.func,
  /**
   * @ignore
   */
  onEntered: M.func,
  /**
   * @ignore
   */
  onEntering: M.func,
  /**
   * @ignore
   */
  onExit: M.func,
  /**
   * @ignore
   */
  onExited: M.func,
  /**
   * @ignore
   */
  onExiting: M.func,
  /**
   * @ignore
   */
  style: M.object,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   * @default {
   *   enter: theme.transitions.duration.enteringScreen,
   *   exit: theme.transitions.duration.leavingScreen,
   * }
   */
  timeout: M.oneOfType([M.number, M.shape({
    appear: M.number,
    enter: M.number,
    exit: M.number
  })])
});
function L0e(e) {
  return hn("MuiBackdrop", e);
}
un("MuiBackdrop", ["root", "invisible"]);
const $0e = ["children", "className", "component", "components", "componentsProps", "invisible", "open", "slotProps", "slots", "TransitionComponent", "transitionDuration"], F0e = (e) => {
  const {
    classes: t,
    invisible: n
  } = e;
  return Pn({
    root: ["root", n && "invisible"]
  }, L0e, t);
}, z0e = ct("div", {
  name: "MuiBackdrop",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.invisible && t.invisible];
  }
})(({
  ownerState: e
}) => ue({
  position: "fixed",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  right: 0,
  bottom: 0,
  top: 0,
  left: 0,
  backgroundColor: "rgba(0, 0, 0, 0.5)",
  WebkitTapHighlightColor: "transparent"
}, e.invisible && {
  backgroundColor: "transparent"
})), f5 = /* @__PURE__ */ B.forwardRef(function(t, n) {
  var r, o, i;
  const a = xn({
    props: t,
    name: "MuiBackdrop"
  }), {
    children: s,
    className: c,
    component: l = "div",
    components: d = {},
    componentsProps: f = {},
    invisible: p = !1,
    open: m,
    slotProps: v = {},
    slots: g = {},
    TransitionComponent: b = d5,
    transitionDuration: x
  } = a, T = ot(a, $0e), S = ue({}, a, {
    component: l,
    invisible: p
  }), _ = F0e(S), w = (r = v.root) != null ? r : f.root;
  return /* @__PURE__ */ z(b, ue({
    in: m,
    timeout: x
  }, T, {
    children: /* @__PURE__ */ z(z0e, ue({
      "aria-hidden": !0
    }, w, {
      as: (o = (i = g.root) != null ? i : d.Root) != null ? o : l,
      className: lt(_.root, c, w == null ? void 0 : w.className),
      ownerState: ue({}, S, w == null ? void 0 : w.ownerState),
      classes: _,
      ref: n,
      children: s
    }))
  }));
});
process.env.NODE_ENV !== "production" && (f5.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: M.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: M.object,
  /**
   * @ignore
   */
  className: M.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: M.elementType,
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */
  components: M.shape({
    Root: M.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `slotProps` prop.
   * It's recommended to use the `slotProps` prop instead, as `componentsProps` will be deprecated in the future.
   *
   * @default {}
   */
  componentsProps: M.shape({
    root: M.object
  }),
  /**
   * If `true`, the backdrop is invisible.
   * It can be used when rendering a popover or a custom select component.
   * @default false
   */
  invisible: M.bool,
  /**
   * If `true`, the component is shown.
   */
  open: M.bool.isRequired,
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slotProps: M.shape({
    root: M.object
  }),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: M.shape({
    root: M.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: M.oneOfType([M.arrayOf(M.oneOfType([M.func, M.object, M.bool])), M.func, M.object]),
  /**
   * The component used for the transition.
   * [Follow this guide](/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @default Fade
   */
  TransitionComponent: M.elementType,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */
  transitionDuration: M.oneOfType([M.number, M.shape({
    appear: M.number,
    enter: M.number,
    exit: M.number
  })])
});
function B0e(e) {
  return typeof e == "function" ? e() : e;
}
function H0e(e) {
  return e ? e.props.hasOwnProperty("in") : !1;
}
const j0e = new E0e();
function W0e(e) {
  const {
    container: t,
    disableEscapeKeyDown: n = !1,
    disableScrollLock: r = !1,
    // @ts-ignore internal logic - Base UI supports the manager as a prop too
    manager: o = j0e,
    closeAfterTransition: i = !1,
    onTransitionEnter: a,
    onTransitionExited: s,
    children: c,
    onClose: l,
    open: d,
    rootRef: f
  } = e, p = B.useRef({}), m = B.useRef(null), v = B.useRef(null), g = Kr(v, f), [b, x] = B.useState(!d), T = H0e(c);
  let S = !0;
  (e["aria-hidden"] === "false" || e["aria-hidden"] === !1) && (S = !1);
  const _ = () => qr(m.current), w = () => (p.current.modalRef = v.current, p.current.mount = m.current, p.current), k = () => {
    o.mount(w(), {
      disableScrollLock: r
    }), v.current && (v.current.scrollTop = 0);
  }, E = Ja(() => {
    const j = B0e(t) || _().body;
    o.add(w(), j), v.current && k();
  }), R = B.useCallback(() => o.isTopModal(w()), [o]), P = Ja((j) => {
    m.current = j, j && (d && R() ? k() : v.current && wd(v.current, S));
  }), A = B.useCallback(() => {
    o.remove(w(), S);
  }, [S, o]);
  B.useEffect(() => () => {
    A();
  }, [A]), B.useEffect(() => {
    d ? E() : (!T || !i) && A();
  }, [d, A, T, i, E]);
  const D = (j) => (U) => {
    var G;
    (G = j.onKeyDown) == null || G.call(j, U), !(U.key !== "Escape" || U.which === 229 || // Wait until IME is settled.
    !R()) && (n || (U.stopPropagation(), l && l(U, "escapeKeyDown")));
  }, N = (j) => (U) => {
    var G;
    (G = j.onClick) == null || G.call(j, U), U.target === U.currentTarget && l && l(U, "backdropClick");
  };
  return {
    getRootProps: (j = {}) => {
      const U = MI(e);
      delete U.onTransitionEnter, delete U.onTransitionExited;
      const G = ue({}, U, j);
      return ue({
        role: "presentation"
      }, G, {
        onKeyDown: D(G),
        ref: g
      });
    },
    getBackdropProps: (j = {}) => {
      const U = j;
      return ue({
        "aria-hidden": !0
      }, U, {
        onClick: N(U),
        open: d
      });
    },
    getTransitionProps: () => {
      const j = () => {
        x(!1), a && a();
      }, U = () => {
        x(!0), s && s(), i && A();
      };
      return {
        onEnter: JM(j, c == null ? void 0 : c.props.onEnter),
        onExited: JM(U, c == null ? void 0 : c.props.onExited)
      };
    },
    rootRef: g,
    portalRef: P,
    isTopModal: R,
    exited: b,
    hasTransition: T
  };
}
function V0e(e) {
  return hn("MuiModal", e);
}
un("MuiModal", ["root", "hidden", "backdrop"]);
const U0e = ["BackdropComponent", "BackdropProps", "classes", "className", "closeAfterTransition", "children", "container", "component", "components", "componentsProps", "disableAutoFocus", "disableEnforceFocus", "disableEscapeKeyDown", "disablePortal", "disableRestoreFocus", "disableScrollLock", "hideBackdrop", "keepMounted", "onBackdropClick", "onClose", "onTransitionEnter", "onTransitionExited", "open", "slotProps", "slots", "theme"], q0e = (e) => {
  const {
    open: t,
    exited: n,
    classes: r
  } = e;
  return Pn({
    root: ["root", !t && n && "hidden"],
    backdrop: ["backdrop"]
  }, V0e, r);
}, G0e = ct("div", {
  name: "MuiModal",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, !n.open && n.exited && t.hidden];
  }
})(({
  theme: e,
  ownerState: t
}) => ue({
  position: "fixed",
  zIndex: (e.vars || e).zIndex.modal,
  right: 0,
  bottom: 0,
  top: 0,
  left: 0
}, !t.open && t.exited && {
  visibility: "hidden"
})), Y0e = ct(f5, {
  name: "MuiModal",
  slot: "Backdrop",
  overridesResolver: (e, t) => t.backdrop
})({
  zIndex: -1
}), p5 = /* @__PURE__ */ B.forwardRef(function(t, n) {
  var r, o, i, a, s, c;
  const l = xn({
    name: "MuiModal",
    props: t
  }), {
    BackdropComponent: d = Y0e,
    BackdropProps: f,
    className: p,
    closeAfterTransition: m = !1,
    children: v,
    container: g,
    component: b,
    components: x = {},
    componentsProps: T = {},
    disableAutoFocus: S = !1,
    disableEnforceFocus: _ = !1,
    disableEscapeKeyDown: w = !1,
    disablePortal: k = !1,
    disableRestoreFocus: E = !1,
    disableScrollLock: R = !1,
    hideBackdrop: P = !1,
    keepMounted: A = !1,
    onBackdropClick: D,
    open: N,
    slotProps: F,
    slots: $
    // eslint-disable-next-line react/prop-types
  } = l, I = ot(l, U0e), j = ue({}, l, {
    closeAfterTransition: m,
    disableAutoFocus: S,
    disableEnforceFocus: _,
    disableEscapeKeyDown: w,
    disablePortal: k,
    disableRestoreFocus: E,
    disableScrollLock: R,
    hideBackdrop: P,
    keepMounted: A
  }), {
    getRootProps: U,
    getBackdropProps: G,
    getTransitionProps: V,
    portalRef: H,
    isTopModal: q,
    exited: Q,
    hasTransition: X
  } = W0e(ue({}, j, {
    rootRef: n
  })), K = ue({}, j, {
    exited: Q
  }), J = q0e(K), ne = {};
  if (v.props.tabIndex === void 0 && (ne.tabIndex = "-1"), X) {
    const {
      onEnter: me,
      onExited: oe
    } = V();
    ne.onEnter = me, ne.onExited = oe;
  }
  const ae = (r = (o = $ == null ? void 0 : $.root) != null ? o : x.Root) != null ? r : G0e, te = (i = (a = $ == null ? void 0 : $.backdrop) != null ? a : x.Backdrop) != null ? i : d, le = (s = F == null ? void 0 : F.root) != null ? s : T.root, ce = (c = F == null ? void 0 : F.backdrop) != null ? c : T.backdrop, fe = cs({
    elementType: ae,
    externalSlotProps: le,
    externalForwardedProps: I,
    getSlotProps: U,
    additionalProps: {
      ref: n,
      as: b
    },
    ownerState: K,
    className: lt(p, le == null ? void 0 : le.className, J == null ? void 0 : J.root, !K.open && K.exited && (J == null ? void 0 : J.hidden))
  }), ee = cs({
    elementType: te,
    externalSlotProps: ce,
    additionalProps: f,
    getSlotProps: (me) => G(ue({}, me, {
      onClick: (oe) => {
        D && D(oe), me != null && me.onClick && me.onClick(oe);
      }
    })),
    className: lt(ce == null ? void 0 : ce.className, f == null ? void 0 : f.className, J == null ? void 0 : J.backdrop),
    ownerState: K
  });
  return !A && !N && (!X || Q) ? null : /* @__PURE__ */ z(Jd, {
    ref: H,
    container: g,
    disablePortal: k,
    children: /* @__PURE__ */ _e(ae, ue({}, fe, {
      children: [!P && d ? /* @__PURE__ */ z(te, ue({}, ee)) : null, /* @__PURE__ */ z(dm, {
        disableEnforceFocus: _,
        disableAutoFocus: S,
        disableRestoreFocus: E,
        isEnabled: q,
        open: N,
        children: /* @__PURE__ */ B.cloneElement(v, ne)
      })]
    }))
  });
});
process.env.NODE_ENV !== "production" && (p5.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A backdrop component. This prop enables custom backdrop rendering.
   * @deprecated Use `slots.backdrop` instead. While this prop currently works, it will be removed in the next major version.
   * Use the `slots.backdrop` prop to make your application ready for the next version of Material UI.
   * @default styled(Backdrop, {
   *   name: 'MuiModal',
   *   slot: 'Backdrop',
   *   overridesResolver: (props, styles) => {
   *     return styles.backdrop;
   *   },
   * })({
   *   zIndex: -1,
   * })
   */
  BackdropComponent: M.elementType,
  /**
   * Props applied to the [`Backdrop`](/material-ui/api/backdrop/) element.
   * @deprecated Use `slotProps.backdrop` instead.
   */
  BackdropProps: M.object,
  /**
   * A single child content element.
   */
  children: Xc.isRequired,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: M.object,
  /**
   * @ignore
   */
  className: M.string,
  /**
   * When set to true the Modal waits until a nested Transition is completed before closing.
   * @default false
   */
  closeAfterTransition: M.bool,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: M.elementType,
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */
  components: M.shape({
    Backdrop: M.elementType,
    Root: M.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `slotProps` prop.
   * It's recommended to use the `slotProps` prop instead, as `componentsProps` will be deprecated in the future.
   *
   * @default {}
   */
  componentsProps: M.shape({
    backdrop: M.oneOfType([M.func, M.object]),
    root: M.oneOfType([M.func, M.object])
  }),
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * You can also provide a callback, which is called in a React layout effect.
   * This lets you set the container from a ref, and also makes server-side rendering possible.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: M.oneOfType([ma, M.func]),
  /**
   * If `true`, the modal will not automatically shift focus to itself when it opens, and
   * replace it to the last focused element when it closes.
   * This also works correctly with any modal children that have the `disableAutoFocus` prop.
   *
   * Generally this should never be set to `true` as it makes the modal less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableAutoFocus: M.bool,
  /**
   * If `true`, the modal will not prevent focus from leaving the modal while open.
   *
   * Generally this should never be set to `true` as it makes the modal less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableEnforceFocus: M.bool,
  /**
   * If `true`, hitting escape will not fire the `onClose` callback.
   * @default false
   */
  disableEscapeKeyDown: M.bool,
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: M.bool,
  /**
   * If `true`, the modal will not restore focus to previously focused element once
   * modal is hidden or unmounted.
   * @default false
   */
  disableRestoreFocus: M.bool,
  /**
   * Disable the scroll lock behavior.
   * @default false
   */
  disableScrollLock: M.bool,
  /**
   * If `true`, the backdrop is not rendered.
   * @default false
   */
  hideBackdrop: M.bool,
  /**
   * Always keep the children in the DOM.
   * This prop can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Modal.
   * @default false
   */
  keepMounted: M.bool,
  /**
   * Callback fired when the backdrop is clicked.
   * @deprecated Use the `onClose` prop with the `reason` argument to handle the `backdropClick` events.
   */
  onBackdropClick: M.func,
  /**
   * Callback fired when the component requests to be closed.
   * The `reason` parameter can optionally be used to control the response to `onClose`.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`.
   */
  onClose: M.func,
  /**
   * A function called when a transition enters.
   */
  onTransitionEnter: M.func,
  /**
   * A function called when a transition has exited.
   */
  onTransitionExited: M.func,
  /**
   * If `true`, the component is shown.
   */
  open: M.bool.isRequired,
  /**
   * The props used for each slot inside the Modal.
   * @default {}
   */
  slotProps: M.shape({
    backdrop: M.oneOfType([M.func, M.object]),
    root: M.oneOfType([M.func, M.object])
  }),
  /**
   * The components used for each slot inside the Modal.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: M.shape({
    backdrop: M.elementType,
    root: M.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: M.oneOfType([M.arrayOf(M.oneOfType([M.func, M.object, M.bool])), M.func, M.object])
});
const rR = (e) => {
  let t;
  return e < 1 ? t = 5.11916 * ro(e, 2) : t = 4.5 * Math.log(e + 1) + 2, (t / 100).toFixed(2);
};
function Z0e(e) {
  return hn("MuiPaper", e);
}
un("MuiPaper", ["root", "rounded", "outlined", "elevation", "elevation0", "elevation1", "elevation2", "elevation3", "elevation4", "elevation5", "elevation6", "elevation7", "elevation8", "elevation9", "elevation10", "elevation11", "elevation12", "elevation13", "elevation14", "elevation15", "elevation16", "elevation17", "elevation18", "elevation19", "elevation20", "elevation21", "elevation22", "elevation23", "elevation24"]);
const X0e = ["className", "component", "elevation", "square", "variant"], K0e = (e) => {
  const {
    square: t,
    elevation: n,
    variant: r,
    classes: o
  } = e, i = {
    root: ["root", r, !t && "rounded", r === "elevation" && `elevation${n}`]
  };
  return Pn(i, Z0e, o);
}, J0e = ct("div", {
  name: "MuiPaper",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, t[n.variant], !n.square && t.rounded, n.variant === "elevation" && t[`elevation${n.elevation}`]];
  }
})(({
  theme: e,
  ownerState: t
}) => {
  var n;
  return ue({
    backgroundColor: (e.vars || e).palette.background.paper,
    color: (e.vars || e).palette.text.primary,
    transition: e.transitions.create("box-shadow")
  }, !t.square && {
    borderRadius: e.shape.borderRadius
  }, t.variant === "outlined" && {
    border: `1px solid ${(e.vars || e).palette.divider}`
  }, t.variant === "elevation" && ue({
    boxShadow: (e.vars || e).shadows[t.elevation]
  }, !e.vars && e.palette.mode === "dark" && {
    backgroundImage: `linear-gradient(${Mn("#fff", rR(t.elevation))}, ${Mn("#fff", rR(t.elevation))})`
  }, e.vars && {
    backgroundImage: (n = e.vars.overlays) == null ? void 0 : n[t.elevation]
  }));
}), ix = /* @__PURE__ */ B.forwardRef(function(t, n) {
  const r = xn({
    props: t,
    name: "MuiPaper"
  }), {
    className: o,
    component: i = "div",
    elevation: a = 1,
    square: s = !1,
    variant: c = "elevation"
  } = r, l = ot(r, X0e), d = ue({}, r, {
    component: i,
    elevation: a,
    square: s,
    variant: c
  }), f = K0e(d);
  return process.env.NODE_ENV !== "production" && Lg().shadows[a] === void 0 && console.error([`MUI: The elevation provided <Paper elevation={${a}}> is not available in the theme.`, `Please make sure that \`theme.shadows[${a}]\` is defined.`].join(`
`)), /* @__PURE__ */ z(J0e, ue({
    as: i,
    ownerState: d,
    className: lt(f.root, o),
    ref: n
  }, l));
});
process.env.NODE_ENV !== "production" && (ix.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: M.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: M.object,
  /**
   * @ignore
   */
  className: M.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: M.elementType,
  /**
   * Shadow depth, corresponds to `dp` in the spec.
   * It accepts values between 0 and 24 inclusive.
   * @default 1
   */
  elevation: vs(Ti, (e) => {
    const {
      elevation: t,
      variant: n
    } = e;
    return t > 0 && n === "outlined" ? new Error(`MUI: Combining \`elevation={${t}}\` with \`variant="${n}"\` has no effect. Either use \`elevation={0}\` or use a different \`variant\`.`) : null;
  }),
  /**
   * If `true`, rounded corners are disabled.
   * @default false
   */
  square: M.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: M.oneOfType([M.arrayOf(M.oneOfType([M.func, M.object, M.bool])), M.func, M.object]),
  /**
   * The variant to use.
   * @default 'elevation'
   */
  variant: M.oneOfType([M.oneOf(["elevation", "outlined"]), M.string])
});
function Q0e(e) {
  return hn("MuiPopover", e);
}
un("MuiPopover", ["root", "paper"]);
const ebe = ["onEntering"], tbe = ["action", "anchorEl", "anchorOrigin", "anchorPosition", "anchorReference", "children", "className", "container", "elevation", "marginThreshold", "open", "PaperProps", "slots", "slotProps", "transformOrigin", "TransitionComponent", "transitionDuration", "TransitionProps", "disableScrollLock"], nbe = ["slotProps"];
function oR(e, t) {
  let n = 0;
  return typeof t == "number" ? n = t : t === "center" ? n = e.height / 2 : t === "bottom" && (n = e.height), n;
}
function iR(e, t) {
  let n = 0;
  return typeof t == "number" ? n = t : t === "center" ? n = e.width / 2 : t === "right" && (n = e.width), n;
}
function aR(e) {
  return [e.horizontal, e.vertical].map((t) => typeof t == "number" ? `${t}px` : t).join(" ");
}
function ih(e) {
  return typeof e == "function" ? e() : e;
}
const rbe = (e) => {
  const {
    classes: t
  } = e;
  return Pn({
    root: ["root"],
    paper: ["paper"]
  }, Q0e, t);
}, obe = ct(p5, {
  name: "MuiPopover",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({}), h5 = ct(ix, {
  name: "MuiPopover",
  slot: "Paper",
  overridesResolver: (e, t) => t.paper
})({
  position: "absolute",
  overflowY: "auto",
  overflowX: "hidden",
  // So we see the popover when it's empty.
  // It's most likely on issue on userland.
  minWidth: 16,
  minHeight: 16,
  maxWidth: "calc(100% - 32px)",
  maxHeight: "calc(100% - 32px)",
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0
}), ax = /* @__PURE__ */ B.forwardRef(function(t, n) {
  var r, o, i;
  const a = xn({
    props: t,
    name: "MuiPopover"
  }), {
    action: s,
    anchorEl: c,
    anchorOrigin: l = {
      vertical: "top",
      horizontal: "left"
    },
    anchorPosition: d,
    anchorReference: f = "anchorEl",
    children: p,
    className: m,
    container: v,
    elevation: g = 8,
    marginThreshold: b = 16,
    open: x,
    PaperProps: T = {},
    slots: S,
    slotProps: _,
    transformOrigin: w = {
      vertical: "top",
      horizontal: "left"
    },
    TransitionComponent: k = Kd,
    transitionDuration: E = "auto",
    TransitionProps: {
      onEntering: R
    } = {},
    disableScrollLock: P = !1
  } = a, A = ot(a.TransitionProps, ebe), D = ot(a, tbe), N = (r = _ == null ? void 0 : _.paper) != null ? r : T, F = B.useRef(), $ = Kr(F, N.ref), I = ue({}, a, {
    anchorOrigin: l,
    anchorReference: f,
    elevation: g,
    marginThreshold: b,
    externalPaperSlotProps: N,
    transformOrigin: w,
    TransitionComponent: k,
    transitionDuration: E,
    TransitionProps: A
  }), j = rbe(I), U = B.useCallback(() => {
    if (f === "anchorPosition")
      return process.env.NODE_ENV !== "production" && (d || console.error('MUI: You need to provide a `anchorPosition` prop when using <Popover anchorReference="anchorPosition" />.')), d;
    const me = ih(c), oe = me && me.nodeType === 1 ? me : qr(F.current).body, ve = oe.getBoundingClientRect();
    if (process.env.NODE_ENV !== "production") {
      const we = oe.getBoundingClientRect();
      process.env.NODE_ENV !== "test" && we.top === 0 && we.left === 0 && we.right === 0 && we.bottom === 0 && console.warn(["MUI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
    }
    return {
      top: ve.top + oR(ve, l.vertical),
      left: ve.left + iR(ve, l.horizontal)
    };
  }, [c, l.horizontal, l.vertical, d, f]), G = B.useCallback((me) => ({
    vertical: oR(me, w.vertical),
    horizontal: iR(me, w.horizontal)
  }), [w.horizontal, w.vertical]), V = B.useCallback((me) => {
    const oe = {
      width: me.offsetWidth,
      height: me.offsetHeight
    }, ve = G(oe);
    if (f === "none")
      return {
        top: null,
        left: null,
        transformOrigin: aR(ve)
      };
    const we = U();
    let ye = we.top - ve.vertical, Ce = we.left - ve.horizontal;
    const Se = ye + oe.height, Te = Ce + oe.width, Ae = Xd(ih(c)), je = Ae.innerHeight - b, Me = Ae.innerWidth - b;
    if (b !== null && ye < b) {
      const ze = ye - b;
      ye -= ze, ve.vertical += ze;
    } else if (b !== null && Se > je) {
      const ze = Se - je;
      ye -= ze, ve.vertical += ze;
    }
    if (process.env.NODE_ENV !== "production" && oe.height > je && oe.height && je && console.error(["MUI: The popover component is too tall.", `Some part of it can not be seen on the screen (${oe.height - je}px).`, "Please consider adding a `max-height` to improve the user-experience."].join(`
`)), b !== null && Ce < b) {
      const ze = Ce - b;
      Ce -= ze, ve.horizontal += ze;
    } else if (Te > Me) {
      const ze = Te - Me;
      Ce -= ze, ve.horizontal += ze;
    }
    return {
      top: `${Math.round(ye)}px`,
      left: `${Math.round(Ce)}px`,
      transformOrigin: aR(ve)
    };
  }, [c, f, U, G, b]), [H, q] = B.useState(x), Q = B.useCallback(() => {
    const me = F.current;
    if (!me)
      return;
    const oe = V(me);
    oe.top !== null && (me.style.top = oe.top), oe.left !== null && (me.style.left = oe.left), me.style.transformOrigin = oe.transformOrigin, q(!0);
  }, [V]);
  B.useEffect(() => (P && window.addEventListener("scroll", Q), () => window.removeEventListener("scroll", Q)), [c, P, Q]);
  const X = (me, oe) => {
    R && R(me, oe), Q();
  }, K = () => {
    q(!1);
  };
  B.useEffect(() => {
    x && Q();
  }), B.useImperativeHandle(s, () => x ? {
    updatePosition: () => {
      Q();
    }
  } : null, [x, Q]), B.useEffect(() => {
    if (!x)
      return;
    const me = Zve(() => {
      Q();
    }), oe = Xd(c);
    return oe.addEventListener("resize", me), () => {
      me.clear(), oe.removeEventListener("resize", me);
    };
  }, [c, x, Q]);
  let J = E;
  E === "auto" && !k.muiSupportAuto && (J = void 0);
  const ne = v || (c ? qr(ih(c)).body : void 0), ae = (o = S == null ? void 0 : S.root) != null ? o : obe, te = (i = S == null ? void 0 : S.paper) != null ? i : h5, le = cs({
    elementType: te,
    externalSlotProps: ue({}, N, {
      style: H ? N.style : ue({}, N.style, {
        opacity: 0
      })
    }),
    additionalProps: {
      elevation: g,
      ref: $
    },
    ownerState: I,
    className: lt(j.paper, N == null ? void 0 : N.className)
  }), ce = cs({
    elementType: ae,
    externalSlotProps: (_ == null ? void 0 : _.root) || {},
    externalForwardedProps: D,
    additionalProps: {
      ref: n,
      slotProps: {
        backdrop: {
          invisible: !0
        }
      },
      container: ne,
      open: x
    },
    ownerState: I,
    className: lt(j.root, m)
  }), {
    slotProps: fe
  } = ce, ee = ot(ce, nbe);
  return /* @__PURE__ */ z(ae, ue({}, ee, !kI(ae) && {
    slotProps: fe,
    disableScrollLock: P
  }, {
    children: /* @__PURE__ */ z(k, ue({
      appear: !0,
      in: x,
      onEntering: X,
      onExited: K,
      timeout: J
    }, A, {
      children: /* @__PURE__ */ z(te, ue({}, le, {
        children: p
      }))
    }))
  }));
});
process.env.NODE_ENV !== "production" && (ax.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A ref for imperative actions.
   * It currently only supports updatePosition() action.
   */
  action: Ig,
  /**
   * An HTML element, [PopoverVirtualElement](/material-ui/react-popover/#virtual-element),
   * or a function that returns either.
   * It's used to set the position of the popover.
   */
  anchorEl: vs(M.oneOfType([ma, M.func]), (e) => {
    if (e.open && (!e.anchorReference || e.anchorReference === "anchorEl")) {
      const t = ih(e.anchorEl);
      if (t && t.nodeType === 1) {
        const n = t.getBoundingClientRect();
        if (process.env.NODE_ENV !== "test" && n.top === 0 && n.left === 0 && n.right === 0 && n.bottom === 0)
          return new Error(["MUI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
      } else
        return new Error(["MUI: The `anchorEl` prop provided to the component is invalid.", `It should be an Element or PopoverVirtualElement instance but it's \`${t}\` instead.`].join(`
`));
    }
    return null;
  }),
  /**
   * This is the point on the anchor where the popover's
   * `anchorEl` will attach to. This is not used when the
   * anchorReference is 'anchorPosition'.
   *
   * Options:
   * vertical: [top, center, bottom];
   * horizontal: [left, center, right].
   * @default {
   *   vertical: 'top',
   *   horizontal: 'left',
   * }
   */
  anchorOrigin: M.shape({
    horizontal: M.oneOfType([M.oneOf(["center", "left", "right"]), M.number]).isRequired,
    vertical: M.oneOfType([M.oneOf(["bottom", "center", "top"]), M.number]).isRequired
  }),
  /**
   * This is the position that may be used to set the position of the popover.
   * The coordinates are relative to the application's client area.
   */
  anchorPosition: M.shape({
    left: M.number.isRequired,
    top: M.number.isRequired
  }),
  /**
   * This determines which anchor prop to refer to when setting
   * the position of the popover.
   * @default 'anchorEl'
   */
  anchorReference: M.oneOf(["anchorEl", "anchorPosition", "none"]),
  /**
   * The content of the component.
   */
  children: M.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: M.object,
  /**
   * @ignore
   */
  className: M.string,
  /**
   * An HTML element, component instance, or function that returns either.
   * The `container` will passed to the Modal component.
   *
   * By default, it uses the body of the anchorEl's top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: M.oneOfType([ma, M.func]),
  /**
   * Disable the scroll lock behavior.
   * @default false
   */
  disableScrollLock: M.bool,
  /**
   * The elevation of the popover.
   * @default 8
   */
  elevation: Ti,
  /**
   * Specifies how close to the edge of the window the popover can appear.
   * If null, the popover will not be constrained by the window.
   * @default 16
   */
  marginThreshold: M.number,
  /**
   * Callback fired when the component requests to be closed.
   * The `reason` parameter can optionally be used to control the response to `onClose`.
   */
  onClose: M.func,
  /**
   * If `true`, the component is shown.
   */
  open: M.bool.isRequired,
  /**
   * Props applied to the [`Paper`](/material-ui/api/paper/) element.
   *
   * This prop is an alias for `slotProps.paper` and will be overriden by it if both are used.
   * @deprecated Use `slotProps.paper` instead.
   *
   * @default {}
   */
  PaperProps: M.shape({
    component: n5
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @default {}
   */
  slotProps: M.shape({
    paper: M.oneOfType([M.func, M.object]),
    root: M.oneOfType([M.func, M.object])
  }),
  /**
   * The components used for each slot inside.
   *
   * @default {}
   */
  slots: M.shape({
    paper: M.elementType,
    root: M.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: M.oneOfType([M.arrayOf(M.oneOfType([M.func, M.object, M.bool])), M.func, M.object]),
  /**
   * This is the point on the popover which
   * will attach to the anchor's origin.
   *
   * Options:
   * vertical: [top, center, bottom, x(px)];
   * horizontal: [left, center, right, x(px)].
   * @default {
   *   vertical: 'top',
   *   horizontal: 'left',
   * }
   */
  transformOrigin: M.shape({
    horizontal: M.oneOfType([M.oneOf(["center", "left", "right"]), M.number]).isRequired,
    vertical: M.oneOfType([M.oneOf(["bottom", "center", "top"]), M.number]).isRequired
  }),
  /**
   * The component used for the transition.
   * [Follow this guide](/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @default Grow
   */
  TransitionComponent: M.elementType,
  /**
   * Set to 'auto' to automatically calculate transition time based on height.
   * @default 'auto'
   */
  transitionDuration: M.oneOfType([M.oneOf(["auto"]), M.number, M.shape({
    appear: M.number,
    enter: M.number,
    exit: M.number
  })]),
  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](https://reactcommunity.org/react-transition-group/transition/) component.
   * @default {}
   */
  TransitionProps: M.object
});
function ibe(e) {
  return hn("MuiMenu", e);
}
un("MuiMenu", ["root", "paper", "list"]);
const abe = ["onEntering"], sbe = ["autoFocus", "children", "className", "disableAutoFocusItem", "MenuListProps", "onClose", "open", "PaperProps", "PopoverClasses", "transitionDuration", "TransitionProps", "variant", "slots", "slotProps"], lbe = {
  vertical: "top",
  horizontal: "right"
}, cbe = {
  vertical: "top",
  horizontal: "left"
}, ube = (e) => {
  const {
    classes: t
  } = e;
  return Pn({
    root: ["root"],
    paper: ["paper"],
    list: ["list"]
  }, ibe, t);
}, dbe = ct(ax, {
  shouldForwardProp: (e) => Dg(e) || e === "classes",
  name: "MuiMenu",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({}), fbe = ct(h5, {
  name: "MuiMenu",
  slot: "Paper",
  overridesResolver: (e, t) => t.paper
})({
  // specZ: The maximum height of a simple menu should be one or more rows less than the view
  // height. This ensures a tappable area outside of the simple menu with which to dismiss
  // the menu.
  maxHeight: "calc(100% - 96px)",
  // Add iOS momentum scrolling for iOS < 13.0
  WebkitOverflowScrolling: "touch"
}), pbe = ct(t5, {
  name: "MuiMenu",
  slot: "List",
  overridesResolver: (e, t) => t.list
})({
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0
}), sx = /* @__PURE__ */ B.forwardRef(function(t, n) {
  var r, o;
  const i = xn({
    props: t,
    name: "MuiMenu"
  }), {
    autoFocus: a = !0,
    children: s,
    className: c,
    disableAutoFocusItem: l = !1,
    MenuListProps: d = {},
    onClose: f,
    open: p,
    PaperProps: m = {},
    PopoverClasses: v,
    transitionDuration: g = "auto",
    TransitionProps: {
      onEntering: b
    } = {},
    variant: x = "selectedMenu",
    slots: T = {},
    slotProps: S = {}
  } = i, _ = ot(i.TransitionProps, abe), w = ot(i, sbe), k = Zw(), E = ue({}, i, {
    autoFocus: a,
    disableAutoFocusItem: l,
    MenuListProps: d,
    onEntering: b,
    PaperProps: m,
    transitionDuration: g,
    TransitionProps: _,
    variant: x
  }), R = ube(E), P = a && !l && p, A = B.useRef(null), D = (G, V) => {
    A.current && A.current.adjustStyleForScrollbar(G, {
      direction: k ? "rtl" : "ltr"
    }), b && b(G, V);
  }, N = (G) => {
    G.key === "Tab" && (G.preventDefault(), f && f(G, "tabKeyDown"));
  };
  let F = -1;
  B.Children.map(s, (G, V) => {
    /* @__PURE__ */ B.isValidElement(G) && (process.env.NODE_ENV !== "production" && Gd.isFragment(G) && console.error(["MUI: The Menu component doesn't accept a Fragment as a child.", "Consider providing an array instead."].join(`
`)), G.props.disabled || (x === "selectedMenu" && G.props.selected || F === -1) && (F = V));
  });
  const $ = (r = T.paper) != null ? r : fbe, I = (o = S.paper) != null ? o : m, j = cs({
    elementType: T.root,
    externalSlotProps: S.root,
    ownerState: E,
    className: [R.root, c]
  }), U = cs({
    elementType: $,
    externalSlotProps: I,
    ownerState: E,
    className: R.paper
  });
  return /* @__PURE__ */ z(dbe, ue({
    onClose: f,
    anchorOrigin: {
      vertical: "bottom",
      horizontal: k ? "right" : "left"
    },
    transformOrigin: k ? lbe : cbe,
    slots: {
      paper: $,
      root: T.root
    },
    slotProps: {
      root: j,
      paper: U
    },
    open: p,
    ref: n,
    transitionDuration: g,
    TransitionProps: ue({
      onEntering: D
    }, _),
    ownerState: E
  }, w, {
    classes: v,
    children: /* @__PURE__ */ z(pbe, ue({
      onKeyDown: N,
      actions: A,
      autoFocus: a && (F === -1 || l),
      autoFocusItem: P,
      variant: x
    }, d, {
      className: lt(R.list, d.className),
      children: s
    }))
  }));
});
process.env.NODE_ENV !== "production" && (sx.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * An HTML element, or a function that returns one.
   * It's used to set the position of the menu.
   */
  anchorEl: M.oneOfType([ma, M.func]),
  /**
   * If `true` (Default) will focus the `[role="menu"]` if no focusable child is found. Disabled
   * children are not focusable. If you set this prop to `false` focus will be placed
   * on the parent modal container. This has severe accessibility implications
   * and should only be considered if you manage focus otherwise.
   * @default true
   */
  autoFocus: M.bool,
  /**
   * Menu contents, normally `MenuItem`s.
   */
  children: M.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: M.object,
  /**
   * @ignore
   */
  className: M.string,
  /**
   * When opening the menu will not focus the active item but the `[role="menu"]`
   * unless `autoFocus` is also set to `false`. Not using the default means not
   * following WAI-ARIA authoring practices. Please be considerate about possible
   * accessibility implications.
   * @default false
   */
  disableAutoFocusItem: M.bool,
  /**
   * Props applied to the [`MenuList`](/material-ui/api/menu-list/) element.
   * @default {}
   */
  MenuListProps: M.object,
  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`, `"tabKeyDown"`.
   */
  onClose: M.func,
  /**
   * If `true`, the component is shown.
   */
  open: M.bool.isRequired,
  /**
   * @ignore
   */
  PaperProps: M.object,
  /**
   * `classes` prop applied to the [`Popover`](/material-ui/api/popover/) element.
   */
  PopoverClasses: M.object,
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @default {}
   */
  slotProps: M.shape({
    paper: M.oneOfType([M.func, M.object]),
    root: M.oneOfType([M.func, M.object])
  }),
  /**
   * The components used for each slot inside.
   *
   * @default {}
   */
  slots: M.shape({
    paper: M.elementType,
    root: M.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: M.oneOfType([M.arrayOf(M.oneOfType([M.func, M.object, M.bool])), M.func, M.object]),
  /**
   * The length of the transition in `ms`, or 'auto'
   * @default 'auto'
   */
  transitionDuration: M.oneOfType([M.oneOf(["auto"]), M.number, M.shape({
    appear: M.number,
    enter: M.number,
    exit: M.number
  })]),
  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](https://reactcommunity.org/react-transition-group/transition/) component.
   * @default {}
   */
  TransitionProps: M.object,
  /**
   * The variant to use. Use `menu` to prevent selected items from impacting the initial focus.
   * @default 'selectedMenu'
   */
  variant: M.oneOf(["menu", "selectedMenu"])
});
const hbe = ({ children: e, open: t, position: n, onClose: r }) => {
  const { themeSettings: o } = Yn();
  return /* @__PURE__ */ z(
    sx,
    {
      MenuListProps: {
        dense: !0,
        sx: {
          paddingTop: 0,
          paddingBottom: 0,
          fontFamily: o.typography.fontFamily
        }
      },
      anchorReference: "anchorPosition",
      anchorPosition: n != null ? n : { left: 0, top: 0 },
      disableEnforceFocus: !0,
      disableRestoreFocus: !0,
      open: t,
      onClose: r,
      slotProps: {
        paper: {
          sx: {
            borderRadius: 0,
            border: "1px solid #bababa",
            boxShadow: "0 2px 4px 0 rgba(0,0,0,0.3)",
            fontFamily: o.typography.fontFamily
          }
        }
      },
      children: e
    }
  );
};
function m5(e) {
  const {
    className: t,
    classes: n,
    pulsate: r = !1,
    rippleX: o,
    rippleY: i,
    rippleSize: a,
    in: s,
    onExited: c,
    timeout: l
  } = e, [d, f] = B.useState(!1), p = lt(t, n.ripple, n.rippleVisible, r && n.ripplePulsate), m = {
    width: a,
    height: a,
    top: -(a / 2) + i,
    left: -(a / 2) + o
  }, v = lt(n.child, d && n.childLeaving, r && n.childPulsate);
  return !s && !d && f(!0), B.useEffect(() => {
    if (!s && c != null) {
      const g = setTimeout(c, l);
      return () => {
        clearTimeout(g);
      };
    }
  }, [c, s, l]), /* @__PURE__ */ z("span", {
    className: p,
    style: m,
    children: /* @__PURE__ */ z("span", {
      className: v
    })
  });
}
process.env.NODE_ENV !== "production" && (m5.propTypes = {
  /**
   * Override or extend the styles applied to the component.
   */
  classes: M.object.isRequired,
  className: M.string,
  /**
   * @ignore - injected from TransitionGroup
   */
  in: M.bool,
  /**
   * @ignore - injected from TransitionGroup
   */
  onExited: M.func,
  /**
   * If `true`, the ripple pulsates, typically indicating the keyboard focus state of an element.
   */
  pulsate: M.bool,
  /**
   * Diameter of the ripple.
   */
  rippleSize: M.number,
  /**
   * Horizontal position of the ripple center.
   */
  rippleX: M.number,
  /**
   * Vertical position of the ripple center.
   */
  rippleY: M.number,
  /**
   * exit delay
   */
  timeout: M.number.isRequired
});
const Io = un("MuiTouchRipple", ["root", "ripple", "rippleVisible", "ripplePulsate", "child", "childLeaving", "childPulsate"]), mbe = ["center", "classes", "className"];
let Fg = (e) => e, sR, lR, cR, uR;
const z1 = 550, gbe = 80, vbe = us(sR || (sR = Fg`
  0% {
    transform: scale(0);
    opacity: 0.1;
  }

  100% {
    transform: scale(1);
    opacity: 0.3;
  }
`)), bbe = us(lR || (lR = Fg`
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`)), ybe = us(cR || (cR = Fg`
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.92);
  }

  100% {
    transform: scale(1);
  }
`)), _be = ct("span", {
  name: "MuiTouchRipple",
  slot: "Root"
})({
  overflow: "hidden",
  pointerEvents: "none",
  position: "absolute",
  zIndex: 0,
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  borderRadius: "inherit"
}), wbe = ct(m5, {
  name: "MuiTouchRipple",
  slot: "Ripple"
})(uR || (uR = Fg`
  opacity: 0;
  position: absolute;

  &.${0} {
    opacity: 0.3;
    transform: scale(1);
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  &.${0} {
    animation-duration: ${0}ms;
  }

  & .${0} {
    opacity: 1;
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: currentColor;
  }

  & .${0} {
    opacity: 0;
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  & .${0} {
    position: absolute;
    /* @noflip */
    left: 0px;
    top: 0;
    animation-name: ${0};
    animation-duration: 2500ms;
    animation-timing-function: ${0};
    animation-iteration-count: infinite;
    animation-delay: 200ms;
  }
`), Io.rippleVisible, vbe, z1, ({
  theme: e
}) => e.transitions.easing.easeInOut, Io.ripplePulsate, ({
  theme: e
}) => e.transitions.duration.shorter, Io.child, Io.childLeaving, bbe, z1, ({
  theme: e
}) => e.transitions.easing.easeInOut, Io.childPulsate, ybe, ({
  theme: e
}) => e.transitions.easing.easeInOut), g5 = /* @__PURE__ */ B.forwardRef(function(t, n) {
  const r = xn({
    props: t,
    name: "MuiTouchRipple"
  }), {
    center: o = !1,
    classes: i = {},
    className: a
  } = r, s = ot(r, mbe), [c, l] = B.useState([]), d = B.useRef(0), f = B.useRef(null);
  B.useEffect(() => {
    f.current && (f.current(), f.current = null);
  }, [c]);
  const p = B.useRef(!1), m = ac(), v = B.useRef(null), g = B.useRef(null), b = B.useCallback((_) => {
    const {
      pulsate: w,
      rippleX: k,
      rippleY: E,
      rippleSize: R,
      cb: P
    } = _;
    l((A) => [...A, /* @__PURE__ */ z(wbe, {
      classes: {
        ripple: lt(i.ripple, Io.ripple),
        rippleVisible: lt(i.rippleVisible, Io.rippleVisible),
        ripplePulsate: lt(i.ripplePulsate, Io.ripplePulsate),
        child: lt(i.child, Io.child),
        childLeaving: lt(i.childLeaving, Io.childLeaving),
        childPulsate: lt(i.childPulsate, Io.childPulsate)
      },
      timeout: z1,
      pulsate: w,
      rippleX: k,
      rippleY: E,
      rippleSize: R
    }, d.current)]), d.current += 1, f.current = P;
  }, [i]), x = B.useCallback((_ = {}, w = {}, k = () => {
  }) => {
    const {
      pulsate: E = !1,
      center: R = o || w.pulsate,
      fakeElement: P = !1
      // For test purposes
    } = w;
    if ((_ == null ? void 0 : _.type) === "mousedown" && p.current) {
      p.current = !1;
      return;
    }
    (_ == null ? void 0 : _.type) === "touchstart" && (p.current = !0);
    const A = P ? null : g.current, D = A ? A.getBoundingClientRect() : {
      width: 0,
      height: 0,
      left: 0,
      top: 0
    };
    let N, F, $;
    if (R || _ === void 0 || _.clientX === 0 && _.clientY === 0 || !_.clientX && !_.touches)
      N = Math.round(D.width / 2), F = Math.round(D.height / 2);
    else {
      const {
        clientX: I,
        clientY: j
      } = _.touches && _.touches.length > 0 ? _.touches[0] : _;
      N = Math.round(I - D.left), F = Math.round(j - D.top);
    }
    if (R)
      $ = Math.sqrt((2 * ro(D.width, 2) + ro(D.height, 2)) / 3), $ % 2 === 0 && ($ += 1);
    else {
      const I = Math.max(Math.abs((A ? A.clientWidth : 0) - N), N) * 2 + 2, j = Math.max(Math.abs((A ? A.clientHeight : 0) - F), F) * 2 + 2;
      $ = Math.sqrt(ro(I, 2) + ro(j, 2));
    }
    _ != null && _.touches ? v.current === null && (v.current = () => {
      b({
        pulsate: E,
        rippleX: N,
        rippleY: F,
        rippleSize: $,
        cb: k
      });
    }, m.start(gbe, () => {
      v.current && (v.current(), v.current = null);
    })) : b({
      pulsate: E,
      rippleX: N,
      rippleY: F,
      rippleSize: $,
      cb: k
    });
  }, [o, b, m]), T = B.useCallback(() => {
    x({}, {
      pulsate: !0
    });
  }, [x]), S = B.useCallback((_, w) => {
    if (m.clear(), (_ == null ? void 0 : _.type) === "touchend" && v.current) {
      v.current(), v.current = null, m.start(0, () => {
        S(_, w);
      });
      return;
    }
    v.current = null, l((k) => k.length > 0 ? k.slice(1) : k), f.current = w;
  }, [m]);
  return B.useImperativeHandle(n, () => ({
    pulsate: T,
    start: x,
    stop: S
  }), [T, x, S]), /* @__PURE__ */ z(_be, ue({
    className: lt(Io.root, i.root, a),
    ref: g
  }, s, {
    children: /* @__PURE__ */ z(ox, {
      component: null,
      exit: !0,
      children: c
    })
  }));
});
process.env.NODE_ENV !== "production" && (g5.propTypes = {
  /**
   * If `true`, the ripple starts at the center of the component
   * rather than at the point of interaction.
   */
  center: M.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: M.object,
  /**
   * @ignore
   */
  className: M.string
});
function xbe(e) {
  return hn("MuiButtonBase", e);
}
const Cbe = un("MuiButtonBase", ["root", "disabled", "focusVisible"]), Sbe = ["action", "centerRipple", "children", "className", "component", "disabled", "disableRipple", "disableTouchRipple", "focusRipple", "focusVisibleClassName", "LinkComponent", "onBlur", "onClick", "onContextMenu", "onDragLeave", "onFocus", "onFocusVisible", "onKeyDown", "onKeyUp", "onMouseDown", "onMouseLeave", "onMouseUp", "onTouchEnd", "onTouchMove", "onTouchStart", "tabIndex", "TouchRippleProps", "touchRippleRef", "type"], Tbe = (e) => {
  const {
    disabled: t,
    focusVisible: n,
    focusVisibleClassName: r,
    classes: o
  } = e, a = Pn({
    root: ["root", t && "disabled", n && "focusVisible"]
  }, xbe, o);
  return n && r && (a.root += ` ${r}`), a;
}, Ebe = ct("button", {
  name: "MuiButtonBase",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  position: "relative",
  boxSizing: "border-box",
  WebkitTapHighlightColor: "transparent",
  backgroundColor: "transparent",
  // Reset default value
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0,
  border: 0,
  margin: 0,
  // Remove the margin in Safari
  borderRadius: 0,
  padding: 0,
  // Remove the padding in Firefox
  cursor: "pointer",
  userSelect: "none",
  verticalAlign: "middle",
  MozAppearance: "none",
  // Reset
  WebkitAppearance: "none",
  // Reset
  textDecoration: "none",
  // So we take precedent over the style of a native <a /> element.
  color: "inherit",
  "&::-moz-focus-inner": {
    borderStyle: "none"
    // Remove Firefox dotted outline.
  },
  [`&.${Cbe.disabled}`]: {
    pointerEvents: "none",
    // Disable link interactions
    cursor: "default"
  },
  "@media print": {
    colorAdjust: "exact"
  }
}), Kc = /* @__PURE__ */ B.forwardRef(function(t, n) {
  const r = xn({
    props: t,
    name: "MuiButtonBase"
  }), {
    action: o,
    centerRipple: i = !1,
    children: a,
    className: s,
    component: c = "button",
    disabled: l = !1,
    disableRipple: d = !1,
    disableTouchRipple: f = !1,
    focusRipple: p = !1,
    LinkComponent: m = "a",
    onBlur: v,
    onClick: g,
    onContextMenu: b,
    onDragLeave: x,
    onFocus: T,
    onFocusVisible: S,
    onKeyDown: _,
    onKeyUp: w,
    onMouseDown: k,
    onMouseLeave: E,
    onMouseUp: R,
    onTouchEnd: P,
    onTouchMove: A,
    onTouchStart: D,
    tabIndex: N = 0,
    TouchRippleProps: F,
    touchRippleRef: $,
    type: I
  } = r, j = ot(r, Sbe), U = B.useRef(null), G = B.useRef(null), V = Kr(G, $), {
    isFocusVisibleRef: H,
    onFocus: q,
    onBlur: Q,
    ref: X
  } = c5(), [K, J] = B.useState(!1);
  l && K && J(!1), B.useImperativeHandle(o, () => ({
    focusVisible: () => {
      J(!0), U.current.focus();
    }
  }), []);
  const [ne, ae] = B.useState(!1);
  B.useEffect(() => {
    ae(!0);
  }, []);
  const te = ne && !d && !l;
  B.useEffect(() => {
    K && p && !d && ne && G.current.pulsate();
  }, [d, p, K, ne]);
  function le(Ee, st, Vt = f) {
    return Ja((Ct) => (st && st(Ct), !Vt && G.current && G.current[Ee](Ct), !0));
  }
  const ce = le("start", k), fe = le("stop", b), ee = le("stop", x), me = le("stop", R), oe = le("stop", (Ee) => {
    K && Ee.preventDefault(), E && E(Ee);
  }), ve = le("start", D), we = le("stop", P), ye = le("stop", A), Ce = le("stop", (Ee) => {
    Q(Ee), H.current === !1 && J(!1), v && v(Ee);
  }, !1), Se = Ja((Ee) => {
    U.current || (U.current = Ee.currentTarget), q(Ee), H.current === !0 && (J(!0), S && S(Ee)), T && T(Ee);
  }), Te = () => {
    const Ee = U.current;
    return c && c !== "button" && !(Ee.tagName === "A" && Ee.href);
  }, Ae = B.useRef(!1), je = Ja((Ee) => {
    p && !Ae.current && K && G.current && Ee.key === " " && (Ae.current = !0, G.current.stop(Ee, () => {
      G.current.start(Ee);
    })), Ee.target === Ee.currentTarget && Te() && Ee.key === " " && Ee.preventDefault(), _ && _(Ee), Ee.target === Ee.currentTarget && Te() && Ee.key === "Enter" && !l && (Ee.preventDefault(), g && g(Ee));
  }), Me = Ja((Ee) => {
    p && Ee.key === " " && G.current && K && !Ee.defaultPrevented && (Ae.current = !1, G.current.stop(Ee, () => {
      G.current.pulsate(Ee);
    })), w && w(Ee), g && Ee.target === Ee.currentTarget && Te() && Ee.key === " " && !Ee.defaultPrevented && g(Ee);
  });
  let ze = c;
  ze === "button" && (j.href || j.to) && (ze = m);
  const ft = {};
  ze === "button" ? (ft.type = I === void 0 ? "button" : I, ft.disabled = l) : (!j.href && !j.to && (ft.role = "button"), l && (ft["aria-disabled"] = l));
  const Ue = Kr(n, X, U);
  process.env.NODE_ENV !== "production" && B.useEffect(() => {
    te && !G.current && console.error(["MUI: The `component` prop provided to ButtonBase is invalid.", "Please make sure the children prop is rendered in this custom component."].join(`
`));
  }, [te]);
  const Be = ue({}, r, {
    centerRipple: i,
    component: c,
    disabled: l,
    disableRipple: d,
    disableTouchRipple: f,
    focusRipple: p,
    tabIndex: N,
    focusVisible: K
  }), Pe = Tbe(Be);
  return /* @__PURE__ */ _e(Ebe, ue({
    as: ze,
    className: lt(Pe.root, s),
    ownerState: Be,
    onBlur: Ce,
    onClick: g,
    onContextMenu: fe,
    onFocus: Se,
    onKeyDown: je,
    onKeyUp: Me,
    onMouseDown: ce,
    onMouseLeave: oe,
    onMouseUp: me,
    onDragLeave: ee,
    onTouchEnd: we,
    onTouchMove: ye,
    onTouchStart: ve,
    ref: Ue,
    tabIndex: l ? -1 : N,
    type: I
  }, ft, j, {
    children: [a, te ? (
      /* TouchRipple is only needed client-side, x2 boost on the server. */
      /* @__PURE__ */ z(g5, ue({
        ref: V,
        center: i
      }, F))
    ) : null]
  }));
});
process.env.NODE_ENV !== "production" && (Kc.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A ref for imperative actions.
   * It currently only supports `focusVisible()` action.
   */
  action: Ig,
  /**
   * If `true`, the ripples are centered.
   * They won't start at the cursor interaction position.
   * @default false
   */
  centerRipple: M.bool,
  /**
   * The content of the component.
   */
  children: M.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: M.object,
  /**
   * @ignore
   */
  className: M.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: n5,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: M.bool,
  /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */
  disableRipple: M.bool,
  /**
   * If `true`, the touch ripple effect is disabled.
   * @default false
   */
  disableTouchRipple: M.bool,
  /**
   * If `true`, the base button will have a keyboard focus ripple.
   * @default false
   */
  focusRipple: M.bool,
  /**
   * This prop can help identify which element has keyboard focus.
   * The class name will be applied when the element gains the focus through keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/HEAD/explainer.md).
   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
   * if needed.
   */
  focusVisibleClassName: M.string,
  /**
   * @ignore
   */
  href: M.any,
  /**
   * The component used to render a link when the `href` prop is provided.
   * @default 'a'
   */
  LinkComponent: M.elementType,
  /**
   * @ignore
   */
  onBlur: M.func,
  /**
   * @ignore
   */
  onClick: M.func,
  /**
   * @ignore
   */
  onContextMenu: M.func,
  /**
   * @ignore
   */
  onDragLeave: M.func,
  /**
   * @ignore
   */
  onFocus: M.func,
  /**
   * Callback fired when the component is focused with a keyboard.
   * We trigger a `onFocus` callback too.
   */
  onFocusVisible: M.func,
  /**
   * @ignore
   */
  onKeyDown: M.func,
  /**
   * @ignore
   */
  onKeyUp: M.func,
  /**
   * @ignore
   */
  onMouseDown: M.func,
  /**
   * @ignore
   */
  onMouseLeave: M.func,
  /**
   * @ignore
   */
  onMouseUp: M.func,
  /**
   * @ignore
   */
  onTouchEnd: M.func,
  /**
   * @ignore
   */
  onTouchMove: M.func,
  /**
   * @ignore
   */
  onTouchStart: M.func,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: M.oneOfType([M.arrayOf(M.oneOfType([M.func, M.object, M.bool])), M.func, M.object]),
  /**
   * @default 0
   */
  tabIndex: M.number,
  /**
   * Props applied to the `TouchRipple` element.
   */
  TouchRippleProps: M.object,
  /**
   * A ref that points to the `TouchRipple` element.
   */
  touchRippleRef: M.oneOfType([M.func, M.shape({
    current: M.shape({
      pulsate: M.func.isRequired,
      start: M.func.isRequired,
      stop: M.func.isRequired
    })
  })]),
  /**
   * @ignore
   */
  type: M.oneOfType([M.oneOf(["button", "reset", "submit"]), M.string])
});
function kbe(e) {
  return hn("MuiDivider", e);
}
const dR = un("MuiDivider", ["root", "absolute", "fullWidth", "inset", "middle", "flexItem", "light", "vertical", "withChildren", "withChildrenVertical", "textAlignRight", "textAlignLeft", "wrapper", "wrapperVertical"]), Mbe = ["absolute", "children", "className", "component", "flexItem", "light", "orientation", "role", "textAlign", "variant"], Rbe = (e) => {
  const {
    absolute: t,
    children: n,
    classes: r,
    flexItem: o,
    light: i,
    orientation: a,
    textAlign: s,
    variant: c
  } = e;
  return Pn({
    root: ["root", t && "absolute", c, i && "light", a === "vertical" && "vertical", o && "flexItem", n && "withChildren", n && a === "vertical" && "withChildrenVertical", s === "right" && a !== "vertical" && "textAlignRight", s === "left" && a !== "vertical" && "textAlignLeft"],
    wrapper: ["wrapper", a === "vertical" && "wrapperVertical"]
  }, kbe, r);
}, Pbe = ct("div", {
  name: "MuiDivider",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.absolute && t.absolute, t[n.variant], n.light && t.light, n.orientation === "vertical" && t.vertical, n.flexItem && t.flexItem, n.children && t.withChildren, n.children && n.orientation === "vertical" && t.withChildrenVertical, n.textAlign === "right" && n.orientation !== "vertical" && t.textAlignRight, n.textAlign === "left" && n.orientation !== "vertical" && t.textAlignLeft];
  }
})(({
  theme: e,
  ownerState: t
}) => ue({
  margin: 0,
  // Reset browser default style.
  flexShrink: 0,
  borderWidth: 0,
  borderStyle: "solid",
  borderColor: (e.vars || e).palette.divider,
  borderBottomWidth: "thin"
}, t.absolute && {
  position: "absolute",
  bottom: 0,
  left: 0,
  width: "100%"
}, t.light && {
  borderColor: e.vars ? `rgba(${e.vars.palette.dividerChannel} / 0.08)` : Mn(e.palette.divider, 0.08)
}, t.variant === "inset" && {
  marginLeft: 72
}, t.variant === "middle" && t.orientation === "horizontal" && {
  marginLeft: e.spacing(2),
  marginRight: e.spacing(2)
}, t.variant === "middle" && t.orientation === "vertical" && {
  marginTop: e.spacing(1),
  marginBottom: e.spacing(1)
}, t.orientation === "vertical" && {
  height: "100%",
  borderBottomWidth: 0,
  borderRightWidth: "thin"
}, t.flexItem && {
  alignSelf: "stretch",
  height: "auto"
}), ({
  ownerState: e
}) => ue({}, e.children && {
  display: "flex",
  whiteSpace: "nowrap",
  textAlign: "center",
  border: 0,
  borderTopStyle: "solid",
  borderLeftStyle: "solid",
  "&::before, &::after": {
    content: '""',
    alignSelf: "center"
  }
}), ({
  theme: e,
  ownerState: t
}) => ue({}, t.children && t.orientation !== "vertical" && {
  "&::before, &::after": {
    width: "100%",
    borderTop: `thin solid ${(e.vars || e).palette.divider}`,
    borderTopStyle: "inherit"
  }
}), ({
  theme: e,
  ownerState: t
}) => ue({}, t.children && t.orientation === "vertical" && {
  flexDirection: "column",
  "&::before, &::after": {
    height: "100%",
    borderLeft: `thin solid ${(e.vars || e).palette.divider}`,
    borderLeftStyle: "inherit"
  }
}), ({
  ownerState: e
}) => ue({}, e.textAlign === "right" && e.orientation !== "vertical" && {
  "&::before": {
    width: "90%"
  },
  "&::after": {
    width: "10%"
  }
}, e.textAlign === "left" && e.orientation !== "vertical" && {
  "&::before": {
    width: "10%"
  },
  "&::after": {
    width: "90%"
  }
})), Obe = ct("span", {
  name: "MuiDivider",
  slot: "Wrapper",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.wrapper, n.orientation === "vertical" && t.wrapperVertical];
  }
})(({
  theme: e,
  ownerState: t
}) => ue({
  display: "inline-block",
  paddingLeft: `calc(${e.spacing(1)} * 1.2)`,
  paddingRight: `calc(${e.spacing(1)} * 1.2)`
}, t.orientation === "vertical" && {
  paddingTop: `calc(${e.spacing(1)} * 1.2)`,
  paddingBottom: `calc(${e.spacing(1)} * 1.2)`
})), Qd = /* @__PURE__ */ B.forwardRef(function(t, n) {
  const r = xn({
    props: t,
    name: "MuiDivider"
  }), {
    absolute: o = !1,
    children: i,
    className: a,
    component: s = i ? "div" : "hr",
    flexItem: c = !1,
    light: l = !1,
    orientation: d = "horizontal",
    role: f = s !== "hr" ? "separator" : void 0,
    textAlign: p = "center",
    variant: m = "fullWidth"
  } = r, v = ot(r, Mbe), g = ue({}, r, {
    absolute: o,
    component: s,
    flexItem: c,
    light: l,
    orientation: d,
    role: f,
    textAlign: p,
    variant: m
  }), b = Rbe(g);
  return /* @__PURE__ */ z(Pbe, ue({
    as: s,
    className: lt(b.root, a),
    role: f,
    ref: n,
    ownerState: g
  }, v, {
    children: i ? /* @__PURE__ */ z(Obe, {
      className: b.wrapper,
      ownerState: g,
      children: i
    }) : null
  }));
});
Qd.muiSkipListHighlight = !0;
process.env.NODE_ENV !== "production" && (Qd.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Absolutely position the element.
   * @default false
   */
  absolute: M.bool,
  /**
   * The content of the component.
   */
  children: M.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: M.object,
  /**
   * @ignore
   */
  className: M.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: M.elementType,
  /**
   * If `true`, a vertical divider will have the correct height when used in flex container.
   * (By default, a vertical divider will have a calculated height of `0px` if it is the child of a flex container.)
   * @default false
   */
  flexItem: M.bool,
  /**
   * If `true`, the divider will have a lighter color.
   * @default false
   * @deprecated Use <Divider sx={{ opacity: 0.6 }} /> (or any opacity or color) instead. [How to migrate](/material-ui/migration/migrating-from-deprecated-apis/)
   */
  light: M.bool,
  /**
   * The component orientation.
   * @default 'horizontal'
   */
  orientation: M.oneOf(["horizontal", "vertical"]),
  /**
   * @ignore
   */
  role: M.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: M.oneOfType([M.arrayOf(M.oneOfType([M.func, M.object, M.bool])), M.func, M.object]),
  /**
   * The text alignment.
   * @default 'center'
   */
  textAlign: M.oneOf(["center", "left", "right"]),
  /**
   * The variant to use.
   * @default 'fullWidth'
   */
  variant: M.oneOfType([M.oneOf(["fullWidth", "inset", "middle"]), M.string])
});
const fR = un("MuiListItemIcon", ["root", "alignItemsFlexStart"]);
function Nbe(e) {
  return hn("MuiTypography", e);
}
un("MuiTypography", ["root", "h1", "h2", "h3", "h4", "h5", "h6", "subtitle1", "subtitle2", "body1", "body2", "inherit", "button", "caption", "overline", "alignLeft", "alignRight", "alignCenter", "alignJustify", "noWrap", "gutterBottom", "paragraph"]);
const Abe = ["align", "className", "component", "gutterBottom", "noWrap", "paragraph", "variant", "variantMapping"], Dbe = (e) => {
  const {
    align: t,
    gutterBottom: n,
    noWrap: r,
    paragraph: o,
    variant: i,
    classes: a
  } = e, s = {
    root: ["root", i, e.align !== "inherit" && `align${xt(t)}`, n && "gutterBottom", r && "noWrap", o && "paragraph"]
  };
  return Pn(s, Nbe, a);
}, Ibe = ct("span", {
  name: "MuiTypography",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.variant && t[n.variant], n.align !== "inherit" && t[`align${xt(n.align)}`], n.noWrap && t.noWrap, n.gutterBottom && t.gutterBottom, n.paragraph && t.paragraph];
  }
})(({
  theme: e,
  ownerState: t
}) => ue({
  margin: 0
}, t.variant === "inherit" && {
  // Some elements, like <button> on Chrome have default font that doesn't inherit, reset this.
  font: "inherit"
}, t.variant !== "inherit" && e.typography[t.variant], t.align !== "inherit" && {
  textAlign: t.align
}, t.noWrap && {
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap"
}, t.gutterBottom && {
  marginBottom: "0.35em"
}, t.paragraph && {
  marginBottom: 16
})), pR = {
  h1: "h1",
  h2: "h2",
  h3: "h3",
  h4: "h4",
  h5: "h5",
  h6: "h6",
  subtitle1: "h6",
  subtitle2: "h6",
  body1: "p",
  body2: "p",
  inherit: "p"
}, Lbe = {
  primary: "primary.main",
  textPrimary: "text.primary",
  secondary: "secondary.main",
  textSecondary: "text.secondary",
  error: "error.main"
}, $be = (e) => Lbe[e] || e, si = /* @__PURE__ */ B.forwardRef(function(t, n) {
  const r = xn({
    props: t,
    name: "MuiTypography"
  }), o = $be(r.color), i = HI(ue({}, r, {
    color: o
  })), {
    align: a = "inherit",
    className: s,
    component: c,
    gutterBottom: l = !1,
    noWrap: d = !1,
    paragraph: f = !1,
    variant: p = "body1",
    variantMapping: m = pR
  } = i, v = ot(i, Abe), g = ue({}, i, {
    align: a,
    color: o,
    className: s,
    component: c,
    gutterBottom: l,
    noWrap: d,
    paragraph: f,
    variant: p,
    variantMapping: m
  }), b = c || (f ? "p" : m[p] || pR[p]) || "span", x = Dbe(g);
  return /* @__PURE__ */ z(Ibe, ue({
    as: b,
    ref: n,
    ownerState: g,
    className: lt(x.root, s)
  }, v));
});
process.env.NODE_ENV !== "production" && (si.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Set the text-align on the component.
   * @default 'inherit'
   */
  align: M.oneOf(["center", "inherit", "justify", "left", "right"]),
  /**
   * The content of the component.
   */
  children: M.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: M.object,
  /**
   * @ignore
   */
  className: M.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: M.elementType,
  /**
   * If `true`, the text will have a bottom margin.
   * @default false
   */
  gutterBottom: M.bool,
  /**
   * If `true`, the text will not wrap, but instead will truncate with a text overflow ellipsis.
   *
   * Note that text overflow can only happen with block or inline-block level elements
   * (the element needs to have a width in order to overflow).
   * @default false
   */
  noWrap: M.bool,
  /**
   * If `true`, the element will be a paragraph element.
   * @default false
   */
  paragraph: M.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: M.oneOfType([M.arrayOf(M.oneOfType([M.func, M.object, M.bool])), M.func, M.object]),
  /**
   * Applies the theme typography styles.
   * @default 'body1'
   */
  variant: M.oneOfType([M.oneOf(["body1", "body2", "button", "caption", "h1", "h2", "h3", "h4", "h5", "h6", "inherit", "overline", "subtitle1", "subtitle2"]), M.string]),
  /**
   * The component maps the variant prop to a range of different HTML element types.
   * For instance, subtitle1 to `<h6>`.
   * If you wish to change that mapping, you can provide your own.
   * Alternatively, you can use the `component` prop.
   * @default {
   *   h1: 'h1',
   *   h2: 'h2',
   *   h3: 'h3',
   *   h4: 'h4',
   *   h5: 'h5',
   *   h6: 'h6',
   *   subtitle1: 'h6',
   *   subtitle2: 'h6',
   *   body1: 'p',
   *   body2: 'p',
   *   inherit: 'p',
   * }
   */
  variantMapping: M.object
});
const hR = un("MuiListItemText", ["root", "multiline", "dense", "inset", "primary", "secondary"]);
function Fbe(e) {
  return hn("MuiMenuItem", e);
}
const ju = un("MuiMenuItem", ["root", "focusVisible", "dense", "disabled", "divider", "gutters", "selected"]), zbe = ["autoFocus", "component", "dense", "divider", "disableGutters", "focusVisibleClassName", "role", "tabIndex", "className"], Bbe = (e, t) => {
  const {
    ownerState: n
  } = e;
  return [t.root, n.dense && t.dense, n.divider && t.divider, !n.disableGutters && t.gutters];
}, Hbe = (e) => {
  const {
    disabled: t,
    dense: n,
    divider: r,
    disableGutters: o,
    selected: i,
    classes: a
  } = e, c = Pn({
    root: ["root", n && "dense", t && "disabled", !o && "gutters", r && "divider", i && "selected"]
  }, Fbe, a);
  return ue({}, a, c);
}, jbe = ct(Kc, {
  shouldForwardProp: (e) => Dg(e) || e === "classes",
  name: "MuiMenuItem",
  slot: "Root",
  overridesResolver: Bbe
})(({
  theme: e,
  ownerState: t
}) => ue({}, e.typography.body1, {
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "center",
  position: "relative",
  textDecoration: "none",
  minHeight: 48,
  paddingTop: 6,
  paddingBottom: 6,
  boxSizing: "border-box",
  whiteSpace: "nowrap"
}, !t.disableGutters && {
  paddingLeft: 16,
  paddingRight: 16
}, t.divider && {
  borderBottom: `1px solid ${(e.vars || e).palette.divider}`,
  backgroundClip: "padding-box"
}, {
  "&:hover": {
    textDecoration: "none",
    backgroundColor: (e.vars || e).palette.action.hover,
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: "transparent"
    }
  },
  [`&.${ju.selected}`]: {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.selectedOpacity})` : Mn(e.palette.primary.main, e.palette.action.selectedOpacity),
    [`&.${ju.focusVisible}`]: {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.focusOpacity}))` : Mn(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.focusOpacity)
    }
  },
  [`&.${ju.selected}:hover`]: {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.hoverOpacity}))` : Mn(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.selectedOpacity})` : Mn(e.palette.primary.main, e.palette.action.selectedOpacity)
    }
  },
  [`&.${ju.focusVisible}`]: {
    backgroundColor: (e.vars || e).palette.action.focus
  },
  [`&.${ju.disabled}`]: {
    opacity: (e.vars || e).palette.action.disabledOpacity
  },
  [`& + .${dR.root}`]: {
    marginTop: e.spacing(1),
    marginBottom: e.spacing(1)
  },
  [`& + .${dR.inset}`]: {
    marginLeft: 52
  },
  [`& .${hR.root}`]: {
    marginTop: 0,
    marginBottom: 0
  },
  [`& .${hR.inset}`]: {
    paddingLeft: 36
  },
  [`& .${fR.root}`]: {
    minWidth: 36
  }
}, !t.dense && {
  [e.breakpoints.up("sm")]: {
    minHeight: "auto"
  }
}, t.dense && ue({
  minHeight: 32,
  // https://m2.material.io/components/menus#specs > Dense
  paddingTop: 4,
  paddingBottom: 4
}, e.typography.body2, {
  [`& .${fR.root} svg`]: {
    fontSize: "1.25rem"
  }
}))), lx = /* @__PURE__ */ B.forwardRef(function(t, n) {
  const r = xn({
    props: t,
    name: "MuiMenuItem"
  }), {
    autoFocus: o = !1,
    component: i = "li",
    dense: a = !1,
    divider: s = !1,
    disableGutters: c = !1,
    focusVisibleClassName: l,
    role: d = "menuitem",
    tabIndex: f,
    className: p
  } = r, m = ot(r, zbe), v = B.useContext(lm), g = B.useMemo(() => ({
    dense: a || v.dense || !1,
    disableGutters: c
  }), [v.dense, a, c]), b = B.useRef(null);
  el(() => {
    o && (b.current ? b.current.focus() : process.env.NODE_ENV !== "production" && console.error("MUI: Unable to set focus to a MenuItem whose component has not been rendered."));
  }, [o]);
  const x = ue({}, r, {
    dense: g.dense,
    divider: s,
    disableGutters: c
  }), T = Hbe(r), S = Kr(b, n);
  let _;
  return r.disabled || (_ = f !== void 0 ? f : -1), /* @__PURE__ */ z(lm.Provider, {
    value: g,
    children: /* @__PURE__ */ z(jbe, ue({
      ref: S,
      role: d,
      tabIndex: _,
      component: i,
      focusVisibleClassName: lt(T.focusVisible, l),
      className: lt(T.root, p)
    }, m, {
      ownerState: x,
      classes: T
    }))
  });
});
process.env.NODE_ENV !== "production" && (lx.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, the list item is focused during the first mount.
   * Focus will also be triggered if the value changes from false to true.
   * @default false
   */
  autoFocus: M.bool,
  /**
   * The content of the component.
   */
  children: M.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: M.object,
  /**
   * @ignore
   */
  className: M.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: M.elementType,
  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input is used.
   * The prop defaults to the value inherited from the parent Menu component.
   * @default false
   */
  dense: M.bool,
  /**
   * @ignore
   */
  disabled: M.bool,
  /**
   * If `true`, the left and right padding is removed.
   * @default false
   */
  disableGutters: M.bool,
  /**
   * If `true`, a 1px light border is added to the bottom of the menu item.
   * @default false
   */
  divider: M.bool,
  /**
   * This prop can help identify which element has keyboard focus.
   * The class name will be applied when the element gains the focus through keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/HEAD/explainer.md).
   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
   * if needed.
   */
  focusVisibleClassName: M.string,
  /**
   * @ignore
   */
  role: M.string,
  /**
   * If `true`, the component is selected.
   * @default false
   */
  selected: M.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: M.oneOfType([M.arrayOf(M.oneOfType([M.func, M.object, M.bool])), M.func, M.object]),
  /**
   * @default 0
   */
  tabIndex: M.number
});
const Wbe = ({ children: e, disabled: t, style: n, className: r = "", onClick: o }) => {
  const { themeSettings: i } = Yn();
  return /* @__PURE__ */ z("div", { className: `csdk-menu-item ${r}`, children: /* @__PURE__ */ z(
    lx,
    {
      disabled: t,
      sx: se({
        width: "100%",
        minWidth: "170px",
        height: "29px",
        minHeight: "29px",
        fontFamily: i.typography.fontFamily,
        fontSize: "13px",
        paddingLeft: "30px",
        paddingRight: "15px",
        color: "#5b6372",
        "&:hover": {
          backgroundColor: "#f4f4f8"
        }
      }, n),
      onClick: o,
      children: /* @__PURE__ */ z("div", { className: "csdk-menu-item-content", children: e })
    }
  ) });
};
function Vbe(e) {
  return hn("MuiListSubheader", e);
}
un("MuiListSubheader", ["root", "colorPrimary", "colorInherit", "gutters", "inset", "sticky"]);
const Ube = ["className", "color", "component", "disableGutters", "disableSticky", "inset"], qbe = (e) => {
  const {
    classes: t,
    color: n,
    disableGutters: r,
    inset: o,
    disableSticky: i
  } = e, a = {
    root: ["root", n !== "default" && `color${xt(n)}`, !r && "gutters", o && "inset", !i && "sticky"]
  };
  return Pn(a, Vbe, t);
}, Gbe = ct("li", {
  name: "MuiListSubheader",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.color !== "default" && t[`color${xt(n.color)}`], !n.disableGutters && t.gutters, n.inset && t.inset, !n.disableSticky && t.sticky];
  }
})(({
  theme: e,
  ownerState: t
}) => ue({
  boxSizing: "border-box",
  lineHeight: "48px",
  listStyle: "none",
  color: (e.vars || e).palette.text.secondary,
  fontFamily: e.typography.fontFamily,
  fontWeight: e.typography.fontWeightMedium,
  fontSize: e.typography.pxToRem(14)
}, t.color === "primary" && {
  color: (e.vars || e).palette.primary.main
}, t.color === "inherit" && {
  color: "inherit"
}, !t.disableGutters && {
  paddingLeft: 16,
  paddingRight: 16
}, t.inset && {
  paddingLeft: 72
}, !t.disableSticky && {
  position: "sticky",
  top: 0,
  zIndex: 1,
  backgroundColor: (e.vars || e).palette.background.paper
})), cx = /* @__PURE__ */ B.forwardRef(function(t, n) {
  const r = xn({
    props: t,
    name: "MuiListSubheader"
  }), {
    className: o,
    color: i = "default",
    component: a = "li",
    disableGutters: s = !1,
    disableSticky: c = !1,
    inset: l = !1
  } = r, d = ot(r, Ube), f = ue({}, r, {
    color: i,
    component: a,
    disableGutters: s,
    disableSticky: c,
    inset: l
  }), p = qbe(f);
  return /* @__PURE__ */ z(Gbe, ue({
    as: a,
    className: lt(p.root, o),
    ref: n,
    ownerState: f
  }, d));
});
cx.muiSkipListHighlight = !0;
process.env.NODE_ENV !== "production" && (cx.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: M.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: M.object,
  /**
   * @ignore
   */
  className: M.string,
  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   * @default 'default'
   */
  color: M.oneOf(["default", "inherit", "primary"]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: M.elementType,
  /**
   * If `true`, the List Subheader will not have gutters.
   * @default false
   */
  disableGutters: M.bool,
  /**
   * If `true`, the List Subheader will not stick to the top during scroll.
   * @default false
   */
  disableSticky: M.bool,
  /**
   * If `true`, the List Subheader is indented.
   * @default false
   */
  inset: M.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: M.oneOfType([M.arrayOf(M.oneOfType([M.func, M.object, M.bool])), M.func, M.object])
});
const Ybe = ({ children: e }) => {
  const { themeSettings: t } = Yn();
  return /* @__PURE__ */ z(
    cx,
    {
      sx: {
        width: "100%",
        minWidth: "170px",
        backgroundColor: "#f2f2f2",
        borderBottom: "1px solid #e6e6e6",
        height: "29px",
        lineHeight: "29px",
        fontFamily: t.typography.fontFamily,
        fontSize: "13px",
        paddingLeft: "15px",
        paddingRight: "15px",
        color: "#5b6372"
      },
      children: e
    }
  );
};
function Zbe({ color: e = "#5B6372" }) {
  return /* @__PURE__ */ z("svg", { width: "24px", height: "24px", viewBox: "0 0 24 24", children: /* @__PURE__ */ z(
    "path",
    {
      fill: e,
      d: "M13.34 12.5l-2.72-3.175a.5.5 0 1 1 .76-.65l2.998 3.5a.5.5 0 0 1 0 .65l-2.998 3.5a.5.5 0 1 1-.76-.65l2.72-3.175z"
    }
  ) });
}
function Xbe(e) {
  return hn("MuiSvgIcon", e);
}
un("MuiSvgIcon", ["root", "colorPrimary", "colorSecondary", "colorAction", "colorError", "colorDisabled", "fontSizeInherit", "fontSizeSmall", "fontSizeMedium", "fontSizeLarge"]);
const Kbe = ["children", "className", "color", "component", "fontSize", "htmlColor", "inheritViewBox", "titleAccess", "viewBox"], Jbe = (e) => {
  const {
    color: t,
    fontSize: n,
    classes: r
  } = e, o = {
    root: ["root", t !== "inherit" && `color${xt(t)}`, `fontSize${xt(n)}`]
  };
  return Pn(o, Xbe, r);
}, Qbe = ct("svg", {
  name: "MuiSvgIcon",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.color !== "inherit" && t[`color${xt(n.color)}`], t[`fontSize${xt(n.fontSize)}`]];
  }
})(({
  theme: e,
  ownerState: t
}) => {
  var n, r, o, i, a, s, c, l, d, f, p, m, v;
  return {
    userSelect: "none",
    width: "1em",
    height: "1em",
    display: "inline-block",
    // the <svg> will define the property that has `currentColor`
    // for example heroicons uses fill="none" and stroke="currentColor"
    fill: t.hasSvgAsChild ? void 0 : "currentColor",
    flexShrink: 0,
    transition: (n = e.transitions) == null || (r = n.create) == null ? void 0 : r.call(n, "fill", {
      duration: (o = e.transitions) == null || (o = o.duration) == null ? void 0 : o.shorter
    }),
    fontSize: {
      inherit: "inherit",
      small: ((i = e.typography) == null || (a = i.pxToRem) == null ? void 0 : a.call(i, 20)) || "1.25rem",
      medium: ((s = e.typography) == null || (c = s.pxToRem) == null ? void 0 : c.call(s, 24)) || "1.5rem",
      large: ((l = e.typography) == null || (d = l.pxToRem) == null ? void 0 : d.call(l, 35)) || "2.1875rem"
    }[t.fontSize],
    // TODO v5 deprecate, v6 remove for sx
    color: (f = (p = (e.vars || e).palette) == null || (p = p[t.color]) == null ? void 0 : p.main) != null ? f : {
      action: (m = (e.vars || e).palette) == null || (m = m.action) == null ? void 0 : m.active,
      disabled: (v = (e.vars || e).palette) == null || (v = v.action) == null ? void 0 : v.disabled,
      inherit: void 0
    }[t.color]
  };
}), fm = /* @__PURE__ */ B.forwardRef(function(t, n) {
  const r = xn({
    props: t,
    name: "MuiSvgIcon"
  }), {
    children: o,
    className: i,
    color: a = "inherit",
    component: s = "svg",
    fontSize: c = "medium",
    htmlColor: l,
    inheritViewBox: d = !1,
    titleAccess: f,
    viewBox: p = "0 0 24 24"
  } = r, m = ot(r, Kbe), v = /* @__PURE__ */ B.isValidElement(o) && o.type === "svg", g = ue({}, r, {
    color: a,
    component: s,
    fontSize: c,
    instanceFontSize: t.fontSize,
    inheritViewBox: d,
    viewBox: p,
    hasSvgAsChild: v
  }), b = {};
  d || (b.viewBox = p);
  const x = Jbe(g);
  return /* @__PURE__ */ _e(Qbe, ue({
    as: s,
    className: lt(x.root, i),
    focusable: "false",
    color: l,
    "aria-hidden": f ? void 0 : !0,
    role: f ? "img" : void 0,
    ref: n
  }, b, m, v && o.props, {
    ownerState: g,
    children: [v ? o.props.children : o, f ? /* @__PURE__ */ z("title", {
      children: f
    }) : null]
  }));
});
process.env.NODE_ENV !== "production" && (fm.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Node passed into the SVG element.
   */
  children: M.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: M.object,
  /**
   * @ignore
   */
  className: M.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * You can use the `htmlColor` prop to apply a color attribute to the SVG element.
   * @default 'inherit'
   */
  color: M.oneOfType([M.oneOf(["inherit", "action", "disabled", "primary", "secondary", "error", "info", "success", "warning"]), M.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: M.elementType,
  /**
   * The fontSize applied to the icon. Defaults to 24px, but can be configure to inherit font size.
   * @default 'medium'
   */
  fontSize: M.oneOfType([M.oneOf(["inherit", "large", "medium", "small"]), M.string]),
  /**
   * Applies a color attribute to the SVG element.
   */
  htmlColor: M.string,
  /**
   * If `true`, the root node will inherit the custom `component`'s viewBox and the `viewBox`
   * prop will be ignored.
   * Useful when you want to reference a custom `component` and have `SvgIcon` pass that
   * `component`'s viewBox to the root node.
   * @default false
   */
  inheritViewBox: M.bool,
  /**
   * The shape-rendering attribute. The behavior of the different options is described on the
   * [MDN Web Docs](https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/shape-rendering).
   * If you are having issues with blurry icons you should investigate this prop.
   */
  shapeRendering: M.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: M.oneOfType([M.arrayOf(M.oneOfType([M.func, M.object, M.bool])), M.func, M.object]),
  /**
   * Provides a human-readable title for the element that contains it.
   * https://www.w3.org/TR/SVG-access/#Equivalent
   */
  titleAccess: M.string,
  /**
   * Allows you to redefine what the coordinates without units mean inside an SVG element.
   * For example, if the SVG element is 500 (width) by 200 (height),
   * and you pass viewBox="0 0 50 20",
   * this means that the coordinates inside the SVG will go from the top left corner (0,0)
   * to bottom right (50,20) and each unit will be worth 10px.
   * @default '0 0 24 24'
   */
  viewBox: M.string
});
fm.muiName = "SvgIcon";
function kf(e, t) {
  function n(r, o) {
    return /* @__PURE__ */ z(fm, ue({
      "data-testid": `${t}Icon`,
      ref: o
    }, r, {
      children: e
    }));
  }
  return process.env.NODE_ENV !== "production" && (n.displayName = `${t}Icon`), n.muiName = fm.muiName, /* @__PURE__ */ B.memo(/* @__PURE__ */ B.forwardRef(n));
}
function eye(e) {
  return hn("MuiIconButton", e);
}
const tye = un("MuiIconButton", ["root", "disabled", "colorInherit", "colorPrimary", "colorSecondary", "colorError", "colorInfo", "colorSuccess", "colorWarning", "edgeStart", "edgeEnd", "sizeSmall", "sizeMedium", "sizeLarge"]), nye = ["edge", "children", "className", "color", "disabled", "disableFocusRipple", "size"], rye = (e) => {
  const {
    classes: t,
    disabled: n,
    color: r,
    edge: o,
    size: i
  } = e, a = {
    root: ["root", n && "disabled", r !== "default" && `color${xt(r)}`, o && `edge${xt(o)}`, `size${xt(i)}`]
  };
  return Pn(a, eye, t);
}, oye = ct(Kc, {
  name: "MuiIconButton",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.color !== "default" && t[`color${xt(n.color)}`], n.edge && t[`edge${xt(n.edge)}`], t[`size${xt(n.size)}`]];
  }
})(({
  theme: e,
  ownerState: t
}) => ue({
  textAlign: "center",
  flex: "0 0 auto",
  fontSize: e.typography.pxToRem(24),
  padding: 8,
  borderRadius: "50%",
  overflow: "visible",
  // Explicitly set the default value to solve a bug on IE11.
  color: (e.vars || e).palette.action.active,
  transition: e.transitions.create("background-color", {
    duration: e.transitions.duration.shortest
  })
}, !t.disableRipple && {
  "&:hover": {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.action.activeChannel} / ${e.vars.palette.action.hoverOpacity})` : Mn(e.palette.action.active, e.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: "transparent"
    }
  }
}, t.edge === "start" && {
  marginLeft: t.size === "small" ? -3 : -12
}, t.edge === "end" && {
  marginRight: t.size === "small" ? -3 : -12
}), ({
  theme: e,
  ownerState: t
}) => {
  var n;
  const r = (n = (e.vars || e).palette) == null ? void 0 : n[t.color];
  return ue({}, t.color === "inherit" && {
    color: "inherit"
  }, t.color !== "inherit" && t.color !== "default" && ue({
    color: r == null ? void 0 : r.main
  }, !t.disableRipple && {
    "&:hover": ue({}, r && {
      backgroundColor: e.vars ? `rgba(${r.mainChannel} / ${e.vars.palette.action.hoverOpacity})` : Mn(r.main, e.palette.action.hoverOpacity)
    }, {
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: "transparent"
      }
    })
  }), t.size === "small" && {
    padding: 5,
    fontSize: e.typography.pxToRem(18)
  }, t.size === "large" && {
    padding: 12,
    fontSize: e.typography.pxToRem(28)
  }, {
    [`&.${tye.disabled}`]: {
      backgroundColor: "transparent",
      color: (e.vars || e).palette.action.disabled
    }
  });
}), ef = /* @__PURE__ */ B.forwardRef(function(t, n) {
  const r = xn({
    props: t,
    name: "MuiIconButton"
  }), {
    edge: o = !1,
    children: i,
    className: a,
    color: s = "default",
    disabled: c = !1,
    disableFocusRipple: l = !1,
    size: d = "medium"
  } = r, f = ot(r, nye), p = ue({}, r, {
    edge: o,
    color: s,
    disabled: c,
    disableFocusRipple: l,
    size: d
  }), m = rye(p);
  return /* @__PURE__ */ z(oye, ue({
    className: lt(m.root, a),
    centerRipple: !0,
    focusRipple: !l,
    disabled: c,
    ref: n
  }, f, {
    ownerState: p,
    children: i
  }));
});
process.env.NODE_ENV !== "production" && (ef.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The icon to display.
   */
  children: vs(M.node, (e) => B.Children.toArray(e.children).some((n) => /* @__PURE__ */ B.isValidElement(n) && n.props.onClick) ? new Error(["MUI: You are providing an onClick event listener to a child of a button element.", "Prefer applying it to the IconButton directly.", "This guarantees that the whole <button> will be responsive to click events."].join(`
`)) : null),
  /**
   * Override or extend the styles applied to the component.
   */
  classes: M.object,
  /**
   * @ignore
   */
  className: M.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'default'
   */
  color: M.oneOfType([M.oneOf(["inherit", "default", "primary", "secondary", "error", "info", "success", "warning"]), M.string]),
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: M.bool,
  /**
   * If `true`, the  keyboard focus ripple is disabled.
   * @default false
   */
  disableFocusRipple: M.bool,
  /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */
  disableRipple: M.bool,
  /**
   * If given, uses a negative margin to counteract the padding on one
   * side (this is often helpful for aligning the left or right
   * side of the icon with content above or below, without ruining the border
   * size and shape).
   * @default false
   */
  edge: M.oneOf(["end", "start", !1]),
  /**
   * The size of the component.
   * `small` is equivalent to the dense button styling.
   * @default 'medium'
   */
  size: M.oneOfType([M.oneOf(["small", "medium", "large"]), M.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: M.oneOfType([M.arrayOf(M.oneOfType([M.func, M.object, M.bool])), M.func, M.object])
});
var ux = {};
Object.defineProperty(ux, "__esModule", {
  value: !0
});
var v5 = ux.default = void 0, iye = sye(et), aye = OI;
function b5(e) {
  if (typeof WeakMap != "function")
    return null;
  var t = /* @__PURE__ */ new WeakMap(), n = /* @__PURE__ */ new WeakMap();
  return (b5 = function(r) {
    return r ? n : t;
  })(e);
}
function sye(e, t) {
  if (e && e.__esModule)
    return e;
  if (e === null || typeof e != "object" && typeof e != "function")
    return { default: e };
  var n = b5(t);
  if (n && n.has(e))
    return n.get(e);
  var r = { __proto__: null }, o = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var i in e)
    if (i !== "default" && Object.prototype.hasOwnProperty.call(e, i)) {
      var a = o ? Object.getOwnPropertyDescriptor(e, i) : null;
      a && (a.get || a.set) ? Object.defineProperty(r, i, a) : r[i] = e[i];
    }
  return r.default = e, n && n.set(e, r), r;
}
function lye(e) {
  return Object.keys(e).length === 0;
}
function cye(e = null) {
  const t = iye.useContext(aye.ThemeContext);
  return !t || lye(t) ? e : t;
}
v5 = ux.default = cye;
var Gr = "top", Uo = "bottom", qo = "right", Yr = "left", dx = "auto", Mf = [Gr, Uo, qo, Yr], Oc = "start", tf = "end", uye = "clippingParents", y5 = "viewport", Wu = "popper", dye = "reference", mR = /* @__PURE__ */ Mf.reduce(function(e, t) {
  return e.concat([t + "-" + Oc, t + "-" + tf]);
}, []), _5 = /* @__PURE__ */ [].concat(Mf, [dx]).reduce(function(e, t) {
  return e.concat([t, t + "-" + Oc, t + "-" + tf]);
}, []), fye = "beforeRead", pye = "read", hye = "afterRead", mye = "beforeMain", gye = "main", vye = "afterMain", bye = "beforeWrite", yye = "write", _ye = "afterWrite", wye = [fye, pye, hye, mye, gye, vye, bye, yye, _ye];
function zi(e) {
  return e ? (e.nodeName || "").toLowerCase() : null;
}
function go(e) {
  if (e == null)
    return window;
  if (e.toString() !== "[object Window]") {
    var t = e.ownerDocument;
    return t && t.defaultView || window;
  }
  return e;
}
function tl(e) {
  var t = go(e).Element;
  return e instanceof t || e instanceof Element;
}
function Bo(e) {
  var t = go(e).HTMLElement;
  return e instanceof t || e instanceof HTMLElement;
}
function fx(e) {
  if (typeof ShadowRoot == "undefined")
    return !1;
  var t = go(e).ShadowRoot;
  return e instanceof t || e instanceof ShadowRoot;
}
function xye(e) {
  var t = e.state;
  Object.keys(t.elements).forEach(function(n) {
    var r = t.styles[n] || {}, o = t.attributes[n] || {}, i = t.elements[n];
    !Bo(i) || !zi(i) || (Object.assign(i.style, r), Object.keys(o).forEach(function(a) {
      var s = o[a];
      s === !1 ? i.removeAttribute(a) : i.setAttribute(a, s === !0 ? "" : s);
    }));
  });
}
function Cye(e) {
  var t = e.state, n = {
    popper: {
      position: t.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(t.elements.popper.style, n.popper), t.styles = n, t.elements.arrow && Object.assign(t.elements.arrow.style, n.arrow), function() {
    Object.keys(t.elements).forEach(function(r) {
      var o = t.elements[r], i = t.attributes[r] || {}, a = Object.keys(t.styles.hasOwnProperty(r) ? t.styles[r] : n[r]), s = a.reduce(function(c, l) {
        return c[l] = "", c;
      }, {});
      !Bo(o) || !zi(o) || (Object.assign(o.style, s), Object.keys(i).forEach(function(c) {
        o.removeAttribute(c);
      }));
    });
  };
}
const Sye = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: xye,
  effect: Cye,
  requires: ["computeStyles"]
};
function Di(e) {
  return e.split("-")[0];
}
var Us = Math.max, pm = Math.min, Nc = Math.round;
function B1() {
  var e = navigator.userAgentData;
  return e != null && e.brands && Array.isArray(e.brands) ? e.brands.map(function(t) {
    return t.brand + "/" + t.version;
  }).join(" ") : navigator.userAgent;
}
function w5() {
  return !/^((?!chrome|android).)*safari/i.test(B1());
}
function Ac(e, t, n) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  var r = e.getBoundingClientRect(), o = 1, i = 1;
  t && Bo(e) && (o = e.offsetWidth > 0 && Nc(r.width) / e.offsetWidth || 1, i = e.offsetHeight > 0 && Nc(r.height) / e.offsetHeight || 1);
  var a = tl(e) ? go(e) : window, s = a.visualViewport, c = !w5() && n, l = (r.left + (c && s ? s.offsetLeft : 0)) / o, d = (r.top + (c && s ? s.offsetTop : 0)) / i, f = r.width / o, p = r.height / i;
  return {
    width: f,
    height: p,
    top: d,
    right: l + f,
    bottom: d + p,
    left: l,
    x: l,
    y: d
  };
}
function px(e) {
  var t = Ac(e), n = e.offsetWidth, r = e.offsetHeight;
  return Math.abs(t.width - n) <= 1 && (n = t.width), Math.abs(t.height - r) <= 1 && (r = t.height), {
    x: e.offsetLeft,
    y: e.offsetTop,
    width: n,
    height: r
  };
}
function x5(e, t) {
  var n = t.getRootNode && t.getRootNode();
  if (e.contains(t))
    return !0;
  if (n && fx(n)) {
    var r = t;
    do {
      if (r && e.isSameNode(r))
        return !0;
      r = r.parentNode || r.host;
    } while (r);
  }
  return !1;
}
function va(e) {
  return go(e).getComputedStyle(e);
}
function Tye(e) {
  return ["table", "td", "th"].indexOf(zi(e)) >= 0;
}
function bs(e) {
  return ((tl(e) ? e.ownerDocument : (
    // $FlowFixMe[prop-missing]
    e.document
  )) || window.document).documentElement;
}
function zg(e) {
  return zi(e) === "html" ? e : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    e.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    e.parentNode || // DOM Element detected
    (fx(e) ? e.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    bs(e)
  );
}
function gR(e) {
  return !Bo(e) || // https://github.com/popperjs/popper-core/issues/837
  va(e).position === "fixed" ? null : e.offsetParent;
}
function Eye(e) {
  var t = /firefox/i.test(B1()), n = /Trident/i.test(B1());
  if (n && Bo(e)) {
    var r = va(e);
    if (r.position === "fixed")
      return null;
  }
  var o = zg(e);
  for (fx(o) && (o = o.host); Bo(o) && ["html", "body"].indexOf(zi(o)) < 0; ) {
    var i = va(o);
    if (i.transform !== "none" || i.perspective !== "none" || i.contain === "paint" || ["transform", "perspective"].indexOf(i.willChange) !== -1 || t && i.willChange === "filter" || t && i.filter && i.filter !== "none")
      return o;
    o = o.parentNode;
  }
  return null;
}
function Rf(e) {
  for (var t = go(e), n = gR(e); n && Tye(n) && va(n).position === "static"; )
    n = gR(n);
  return n && (zi(n) === "html" || zi(n) === "body" && va(n).position === "static") ? t : n || Eye(e) || t;
}
function hx(e) {
  return ["top", "bottom"].indexOf(e) >= 0 ? "x" : "y";
}
function xd(e, t, n) {
  return Us(e, pm(t, n));
}
function kye(e, t, n) {
  var r = xd(e, t, n);
  return r > n ? n : r;
}
function C5() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function S5(e) {
  return Object.assign({}, C5(), e);
}
function T5(e, t) {
  return t.reduce(function(n, r) {
    return n[r] = e, n;
  }, {});
}
var Mye = function(t, n) {
  return t = typeof t == "function" ? t(Object.assign({}, n.rects, {
    placement: n.placement
  })) : t, S5(typeof t != "number" ? t : T5(t, Mf));
};
function Rye(e) {
  var t, n = e.state, r = e.name, o = e.options, i = n.elements.arrow, a = n.modifiersData.popperOffsets, s = Di(n.placement), c = hx(s), l = [Yr, qo].indexOf(s) >= 0, d = l ? "height" : "width";
  if (!(!i || !a)) {
    var f = Mye(o.padding, n), p = px(i), m = c === "y" ? Gr : Yr, v = c === "y" ? Uo : qo, g = n.rects.reference[d] + n.rects.reference[c] - a[c] - n.rects.popper[d], b = a[c] - n.rects.reference[c], x = Rf(i), T = x ? c === "y" ? x.clientHeight || 0 : x.clientWidth || 0 : 0, S = g / 2 - b / 2, _ = f[m], w = T - p[d] - f[v], k = T / 2 - p[d] / 2 + S, E = xd(_, k, w), R = c;
    n.modifiersData[r] = (t = {}, t[R] = E, t.centerOffset = E - k, t);
  }
}
function Pye(e) {
  var t = e.state, n = e.options, r = n.element, o = r === void 0 ? "[data-popper-arrow]" : r;
  o != null && (typeof o == "string" && (o = t.elements.popper.querySelector(o), !o) || x5(t.elements.popper, o) && (t.elements.arrow = o));
}
const Oye = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: Rye,
  effect: Pye,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function Dc(e) {
  return e.split("-")[1];
}
var Nye = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function Aye(e, t) {
  var n = e.x, r = e.y, o = t.devicePixelRatio || 1;
  return {
    x: Nc(n * o) / o || 0,
    y: Nc(r * o) / o || 0
  };
}
function vR(e) {
  var t, n = e.popper, r = e.popperRect, o = e.placement, i = e.variation, a = e.offsets, s = e.position, c = e.gpuAcceleration, l = e.adaptive, d = e.roundOffsets, f = e.isFixed, p = a.x, m = p === void 0 ? 0 : p, v = a.y, g = v === void 0 ? 0 : v, b = typeof d == "function" ? d({
    x: m,
    y: g
  }) : {
    x: m,
    y: g
  };
  m = b.x, g = b.y;
  var x = a.hasOwnProperty("x"), T = a.hasOwnProperty("y"), S = Yr, _ = Gr, w = window;
  if (l) {
    var k = Rf(n), E = "clientHeight", R = "clientWidth";
    if (k === go(n) && (k = bs(n), va(k).position !== "static" && s === "absolute" && (E = "scrollHeight", R = "scrollWidth")), k = k, o === Gr || (o === Yr || o === qo) && i === tf) {
      _ = Uo;
      var P = f && k === w && w.visualViewport ? w.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        k[E]
      );
      g -= P - r.height, g *= c ? 1 : -1;
    }
    if (o === Yr || (o === Gr || o === Uo) && i === tf) {
      S = qo;
      var A = f && k === w && w.visualViewport ? w.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        k[R]
      );
      m -= A - r.width, m *= c ? 1 : -1;
    }
  }
  var D = Object.assign({
    position: s
  }, l && Nye), N = d === !0 ? Aye({
    x: m,
    y: g
  }, go(n)) : {
    x: m,
    y: g
  };
  if (m = N.x, g = N.y, c) {
    var F;
    return Object.assign({}, D, (F = {}, F[_] = T ? "0" : "", F[S] = x ? "0" : "", F.transform = (w.devicePixelRatio || 1) <= 1 ? "translate(" + m + "px, " + g + "px)" : "translate3d(" + m + "px, " + g + "px, 0)", F));
  }
  return Object.assign({}, D, (t = {}, t[_] = T ? g + "px" : "", t[S] = x ? m + "px" : "", t.transform = "", t));
}
function Dye(e) {
  var t = e.state, n = e.options, r = n.gpuAcceleration, o = r === void 0 ? !0 : r, i = n.adaptive, a = i === void 0 ? !0 : i, s = n.roundOffsets, c = s === void 0 ? !0 : s, l = {
    placement: Di(t.placement),
    variation: Dc(t.placement),
    popper: t.elements.popper,
    popperRect: t.rects.popper,
    gpuAcceleration: o,
    isFixed: t.options.strategy === "fixed"
  };
  t.modifiersData.popperOffsets != null && (t.styles.popper = Object.assign({}, t.styles.popper, vR(Object.assign({}, l, {
    offsets: t.modifiersData.popperOffsets,
    position: t.options.strategy,
    adaptive: a,
    roundOffsets: c
  })))), t.modifiersData.arrow != null && (t.styles.arrow = Object.assign({}, t.styles.arrow, vR(Object.assign({}, l, {
    offsets: t.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: c
  })))), t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-placement": t.placement
  });
}
const Iye = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: Dye,
  data: {}
};
var Ep = {
  passive: !0
};
function Lye(e) {
  var t = e.state, n = e.instance, r = e.options, o = r.scroll, i = o === void 0 ? !0 : o, a = r.resize, s = a === void 0 ? !0 : a, c = go(t.elements.popper), l = [].concat(t.scrollParents.reference, t.scrollParents.popper);
  return i && l.forEach(function(d) {
    d.addEventListener("scroll", n.update, Ep);
  }), s && c.addEventListener("resize", n.update, Ep), function() {
    i && l.forEach(function(d) {
      d.removeEventListener("scroll", n.update, Ep);
    }), s && c.removeEventListener("resize", n.update, Ep);
  };
}
const $ye = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: Lye,
  data: {}
};
var Fye = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function ah(e) {
  return e.replace(/left|right|bottom|top/g, function(t) {
    return Fye[t];
  });
}
var zye = {
  start: "end",
  end: "start"
};
function bR(e) {
  return e.replace(/start|end/g, function(t) {
    return zye[t];
  });
}
function mx(e) {
  var t = go(e), n = t.pageXOffset, r = t.pageYOffset;
  return {
    scrollLeft: n,
    scrollTop: r
  };
}
function gx(e) {
  return Ac(bs(e)).left + mx(e).scrollLeft;
}
function Bye(e, t) {
  var n = go(e), r = bs(e), o = n.visualViewport, i = r.clientWidth, a = r.clientHeight, s = 0, c = 0;
  if (o) {
    i = o.width, a = o.height;
    var l = w5();
    (l || !l && t === "fixed") && (s = o.offsetLeft, c = o.offsetTop);
  }
  return {
    width: i,
    height: a,
    x: s + gx(e),
    y: c
  };
}
function Hye(e) {
  var t, n = bs(e), r = mx(e), o = (t = e.ownerDocument) == null ? void 0 : t.body, i = Us(n.scrollWidth, n.clientWidth, o ? o.scrollWidth : 0, o ? o.clientWidth : 0), a = Us(n.scrollHeight, n.clientHeight, o ? o.scrollHeight : 0, o ? o.clientHeight : 0), s = -r.scrollLeft + gx(e), c = -r.scrollTop;
  return va(o || n).direction === "rtl" && (s += Us(n.clientWidth, o ? o.clientWidth : 0) - i), {
    width: i,
    height: a,
    x: s,
    y: c
  };
}
function vx(e) {
  var t = va(e), n = t.overflow, r = t.overflowX, o = t.overflowY;
  return /auto|scroll|overlay|hidden/.test(n + o + r);
}
function E5(e) {
  return ["html", "body", "#document"].indexOf(zi(e)) >= 0 ? e.ownerDocument.body : Bo(e) && vx(e) ? e : E5(zg(e));
}
function Cd(e, t) {
  var n;
  t === void 0 && (t = []);
  var r = E5(e), o = r === ((n = e.ownerDocument) == null ? void 0 : n.body), i = go(r), a = o ? [i].concat(i.visualViewport || [], vx(r) ? r : []) : r, s = t.concat(a);
  return o ? s : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    s.concat(Cd(zg(a)))
  );
}
function H1(e) {
  return Object.assign({}, e, {
    left: e.x,
    top: e.y,
    right: e.x + e.width,
    bottom: e.y + e.height
  });
}
function jye(e, t) {
  var n = Ac(e, !1, t === "fixed");
  return n.top = n.top + e.clientTop, n.left = n.left + e.clientLeft, n.bottom = n.top + e.clientHeight, n.right = n.left + e.clientWidth, n.width = e.clientWidth, n.height = e.clientHeight, n.x = n.left, n.y = n.top, n;
}
function yR(e, t, n) {
  return t === y5 ? H1(Bye(e, n)) : tl(t) ? jye(t, n) : H1(Hye(bs(e)));
}
function Wye(e) {
  var t = Cd(zg(e)), n = ["absolute", "fixed"].indexOf(va(e).position) >= 0, r = n && Bo(e) ? Rf(e) : e;
  return tl(r) ? t.filter(function(o) {
    return tl(o) && x5(o, r) && zi(o) !== "body";
  }) : [];
}
function Vye(e, t, n, r) {
  var o = t === "clippingParents" ? Wye(e) : [].concat(t), i = [].concat(o, [n]), a = i[0], s = i.reduce(function(c, l) {
    var d = yR(e, l, r);
    return c.top = Us(d.top, c.top), c.right = pm(d.right, c.right), c.bottom = pm(d.bottom, c.bottom), c.left = Us(d.left, c.left), c;
  }, yR(e, a, r));
  return s.width = s.right - s.left, s.height = s.bottom - s.top, s.x = s.left, s.y = s.top, s;
}
function k5(e) {
  var t = e.reference, n = e.element, r = e.placement, o = r ? Di(r) : null, i = r ? Dc(r) : null, a = t.x + t.width / 2 - n.width / 2, s = t.y + t.height / 2 - n.height / 2, c;
  switch (o) {
    case Gr:
      c = {
        x: a,
        y: t.y - n.height
      };
      break;
    case Uo:
      c = {
        x: a,
        y: t.y + t.height
      };
      break;
    case qo:
      c = {
        x: t.x + t.width,
        y: s
      };
      break;
    case Yr:
      c = {
        x: t.x - n.width,
        y: s
      };
      break;
    default:
      c = {
        x: t.x,
        y: t.y
      };
  }
  var l = o ? hx(o) : null;
  if (l != null) {
    var d = l === "y" ? "height" : "width";
    switch (i) {
      case Oc:
        c[l] = c[l] - (t[d] / 2 - n[d] / 2);
        break;
      case tf:
        c[l] = c[l] + (t[d] / 2 - n[d] / 2);
        break;
    }
  }
  return c;
}
function nf(e, t) {
  t === void 0 && (t = {});
  var n = t, r = n.placement, o = r === void 0 ? e.placement : r, i = n.strategy, a = i === void 0 ? e.strategy : i, s = n.boundary, c = s === void 0 ? uye : s, l = n.rootBoundary, d = l === void 0 ? y5 : l, f = n.elementContext, p = f === void 0 ? Wu : f, m = n.altBoundary, v = m === void 0 ? !1 : m, g = n.padding, b = g === void 0 ? 0 : g, x = S5(typeof b != "number" ? b : T5(b, Mf)), T = p === Wu ? dye : Wu, S = e.rects.popper, _ = e.elements[v ? T : p], w = Vye(tl(_) ? _ : _.contextElement || bs(e.elements.popper), c, d, a), k = Ac(e.elements.reference), E = k5({
    reference: k,
    element: S,
    strategy: "absolute",
    placement: o
  }), R = H1(Object.assign({}, S, E)), P = p === Wu ? R : k, A = {
    top: w.top - P.top + x.top,
    bottom: P.bottom - w.bottom + x.bottom,
    left: w.left - P.left + x.left,
    right: P.right - w.right + x.right
  }, D = e.modifiersData.offset;
  if (p === Wu && D) {
    var N = D[o];
    Object.keys(A).forEach(function(F) {
      var $ = [qo, Uo].indexOf(F) >= 0 ? 1 : -1, I = [Gr, Uo].indexOf(F) >= 0 ? "y" : "x";
      A[F] += N[I] * $;
    });
  }
  return A;
}
function Uye(e, t) {
  t === void 0 && (t = {});
  var n = t, r = n.placement, o = n.boundary, i = n.rootBoundary, a = n.padding, s = n.flipVariations, c = n.allowedAutoPlacements, l = c === void 0 ? _5 : c, d = Dc(r), f = d ? s ? mR : mR.filter(function(v) {
    return Dc(v) === d;
  }) : Mf, p = f.filter(function(v) {
    return l.indexOf(v) >= 0;
  });
  p.length === 0 && (p = f);
  var m = p.reduce(function(v, g) {
    return v[g] = nf(e, {
      placement: g,
      boundary: o,
      rootBoundary: i,
      padding: a
    })[Di(g)], v;
  }, {});
  return Object.keys(m).sort(function(v, g) {
    return m[v] - m[g];
  });
}
function qye(e) {
  if (Di(e) === dx)
    return [];
  var t = ah(e);
  return [bR(e), t, bR(t)];
}
function Gye(e) {
  var t = e.state, n = e.options, r = e.name;
  if (!t.modifiersData[r]._skip) {
    for (var o = n.mainAxis, i = o === void 0 ? !0 : o, a = n.altAxis, s = a === void 0 ? !0 : a, c = n.fallbackPlacements, l = n.padding, d = n.boundary, f = n.rootBoundary, p = n.altBoundary, m = n.flipVariations, v = m === void 0 ? !0 : m, g = n.allowedAutoPlacements, b = t.options.placement, x = Di(b), T = x === b, S = c || (T || !v ? [ah(b)] : qye(b)), _ = [b].concat(S).reduce(function(K, J) {
      return K.concat(Di(J) === dx ? Uye(t, {
        placement: J,
        boundary: d,
        rootBoundary: f,
        padding: l,
        flipVariations: v,
        allowedAutoPlacements: g
      }) : J);
    }, []), w = t.rects.reference, k = t.rects.popper, E = /* @__PURE__ */ new Map(), R = !0, P = _[0], A = 0; A < _.length; A++) {
      var D = _[A], N = Di(D), F = Dc(D) === Oc, $ = [Gr, Uo].indexOf(N) >= 0, I = $ ? "width" : "height", j = nf(t, {
        placement: D,
        boundary: d,
        rootBoundary: f,
        altBoundary: p,
        padding: l
      }), U = $ ? F ? qo : Yr : F ? Uo : Gr;
      w[I] > k[I] && (U = ah(U));
      var G = ah(U), V = [];
      if (i && V.push(j[N] <= 0), s && V.push(j[U] <= 0, j[G] <= 0), V.every(function(K) {
        return K;
      })) {
        P = D, R = !1;
        break;
      }
      E.set(D, V);
    }
    if (R)
      for (var H = v ? 3 : 1, q = function(J) {
        var ne = _.find(function(ae) {
          var te = E.get(ae);
          if (te)
            return te.slice(0, J).every(function(le) {
              return le;
            });
        });
        if (ne)
          return P = ne, "break";
      }, Q = H; Q > 0; Q--) {
        var X = q(Q);
        if (X === "break")
          break;
      }
    t.placement !== P && (t.modifiersData[r]._skip = !0, t.placement = P, t.reset = !0);
  }
}
const Yye = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: Gye,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function _R(e, t, n) {
  return n === void 0 && (n = {
    x: 0,
    y: 0
  }), {
    top: e.top - t.height - n.y,
    right: e.right - t.width + n.x,
    bottom: e.bottom - t.height + n.y,
    left: e.left - t.width - n.x
  };
}
function wR(e) {
  return [Gr, qo, Uo, Yr].some(function(t) {
    return e[t] >= 0;
  });
}
function Zye(e) {
  var t = e.state, n = e.name, r = t.rects.reference, o = t.rects.popper, i = t.modifiersData.preventOverflow, a = nf(t, {
    elementContext: "reference"
  }), s = nf(t, {
    altBoundary: !0
  }), c = _R(a, r), l = _R(s, o, i), d = wR(c), f = wR(l);
  t.modifiersData[n] = {
    referenceClippingOffsets: c,
    popperEscapeOffsets: l,
    isReferenceHidden: d,
    hasPopperEscaped: f
  }, t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-reference-hidden": d,
    "data-popper-escaped": f
  });
}
const Xye = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: Zye
};
function Kye(e, t, n) {
  var r = Di(e), o = [Yr, Gr].indexOf(r) >= 0 ? -1 : 1, i = typeof n == "function" ? n(Object.assign({}, t, {
    placement: e
  })) : n, a = i[0], s = i[1];
  return a = a || 0, s = (s || 0) * o, [Yr, qo].indexOf(r) >= 0 ? {
    x: s,
    y: a
  } : {
    x: a,
    y: s
  };
}
function Jye(e) {
  var t = e.state, n = e.options, r = e.name, o = n.offset, i = o === void 0 ? [0, 0] : o, a = _5.reduce(function(d, f) {
    return d[f] = Kye(f, t.rects, i), d;
  }, {}), s = a[t.placement], c = s.x, l = s.y;
  t.modifiersData.popperOffsets != null && (t.modifiersData.popperOffsets.x += c, t.modifiersData.popperOffsets.y += l), t.modifiersData[r] = a;
}
const Qye = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: Jye
};
function e1e(e) {
  var t = e.state, n = e.name;
  t.modifiersData[n] = k5({
    reference: t.rects.reference,
    element: t.rects.popper,
    strategy: "absolute",
    placement: t.placement
  });
}
const t1e = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: e1e,
  data: {}
};
function n1e(e) {
  return e === "x" ? "y" : "x";
}
function r1e(e) {
  var t = e.state, n = e.options, r = e.name, o = n.mainAxis, i = o === void 0 ? !0 : o, a = n.altAxis, s = a === void 0 ? !1 : a, c = n.boundary, l = n.rootBoundary, d = n.altBoundary, f = n.padding, p = n.tether, m = p === void 0 ? !0 : p, v = n.tetherOffset, g = v === void 0 ? 0 : v, b = nf(t, {
    boundary: c,
    rootBoundary: l,
    padding: f,
    altBoundary: d
  }), x = Di(t.placement), T = Dc(t.placement), S = !T, _ = hx(x), w = n1e(_), k = t.modifiersData.popperOffsets, E = t.rects.reference, R = t.rects.popper, P = typeof g == "function" ? g(Object.assign({}, t.rects, {
    placement: t.placement
  })) : g, A = typeof P == "number" ? {
    mainAxis: P,
    altAxis: P
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, P), D = t.modifiersData.offset ? t.modifiersData.offset[t.placement] : null, N = {
    x: 0,
    y: 0
  };
  if (k) {
    if (i) {
      var F, $ = _ === "y" ? Gr : Yr, I = _ === "y" ? Uo : qo, j = _ === "y" ? "height" : "width", U = k[_], G = U + b[$], V = U - b[I], H = m ? -R[j] / 2 : 0, q = T === Oc ? E[j] : R[j], Q = T === Oc ? -R[j] : -E[j], X = t.elements.arrow, K = m && X ? px(X) : {
        width: 0,
        height: 0
      }, J = t.modifiersData["arrow#persistent"] ? t.modifiersData["arrow#persistent"].padding : C5(), ne = J[$], ae = J[I], te = xd(0, E[j], K[j]), le = S ? E[j] / 2 - H - te - ne - A.mainAxis : q - te - ne - A.mainAxis, ce = S ? -E[j] / 2 + H + te + ae + A.mainAxis : Q + te + ae + A.mainAxis, fe = t.elements.arrow && Rf(t.elements.arrow), ee = fe ? _ === "y" ? fe.clientTop || 0 : fe.clientLeft || 0 : 0, me = (F = D == null ? void 0 : D[_]) != null ? F : 0, oe = U + le - me - ee, ve = U + ce - me, we = xd(m ? pm(G, oe) : G, U, m ? Us(V, ve) : V);
      k[_] = we, N[_] = we - U;
    }
    if (s) {
      var ye, Ce = _ === "x" ? Gr : Yr, Se = _ === "x" ? Uo : qo, Te = k[w], Ae = w === "y" ? "height" : "width", je = Te + b[Ce], Me = Te - b[Se], ze = [Gr, Yr].indexOf(x) !== -1, ft = (ye = D == null ? void 0 : D[w]) != null ? ye : 0, Ue = ze ? je : Te - E[Ae] - R[Ae] - ft + A.altAxis, Be = ze ? Te + E[Ae] + R[Ae] - ft - A.altAxis : Me, Pe = m && ze ? kye(Ue, Te, Be) : xd(m ? Ue : je, Te, m ? Be : Me);
      k[w] = Pe, N[w] = Pe - Te;
    }
    t.modifiersData[r] = N;
  }
}
const o1e = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: r1e,
  requiresIfExists: ["offset"]
};
function i1e(e) {
  return {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  };
}
function a1e(e) {
  return e === go(e) || !Bo(e) ? mx(e) : i1e(e);
}
function s1e(e) {
  var t = e.getBoundingClientRect(), n = Nc(t.width) / e.offsetWidth || 1, r = Nc(t.height) / e.offsetHeight || 1;
  return n !== 1 || r !== 1;
}
function l1e(e, t, n) {
  n === void 0 && (n = !1);
  var r = Bo(t), o = Bo(t) && s1e(t), i = bs(t), a = Ac(e, o, n), s = {
    scrollLeft: 0,
    scrollTop: 0
  }, c = {
    x: 0,
    y: 0
  };
  return (r || !r && !n) && ((zi(t) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  vx(i)) && (s = a1e(t)), Bo(t) ? (c = Ac(t, !0), c.x += t.clientLeft, c.y += t.clientTop) : i && (c.x = gx(i))), {
    x: a.left + s.scrollLeft - c.x,
    y: a.top + s.scrollTop - c.y,
    width: a.width,
    height: a.height
  };
}
function c1e(e) {
  var t = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Set(), r = [];
  e.forEach(function(i) {
    t.set(i.name, i);
  });
  function o(i) {
    n.add(i.name);
    var a = [].concat(i.requires || [], i.requiresIfExists || []);
    a.forEach(function(s) {
      if (!n.has(s)) {
        var c = t.get(s);
        c && o(c);
      }
    }), r.push(i);
  }
  return e.forEach(function(i) {
    n.has(i.name) || o(i);
  }), r;
}
function u1e(e) {
  var t = c1e(e);
  return wye.reduce(function(n, r) {
    return n.concat(t.filter(function(o) {
      return o.phase === r;
    }));
  }, []);
}
function d1e(e) {
  var t;
  return function() {
    return t || (t = new Promise(function(n) {
      Promise.resolve().then(function() {
        t = void 0, n(e());
      });
    })), t;
  };
}
function f1e(e) {
  var t = e.reduce(function(n, r) {
    var o = n[r.name];
    return n[r.name] = o ? Object.assign({}, o, r, {
      options: Object.assign({}, o.options, r.options),
      data: Object.assign({}, o.data, r.data)
    }) : r, n;
  }, {});
  return Object.keys(t).map(function(n) {
    return t[n];
  });
}
var xR = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function CR() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return !t.some(function(r) {
    return !(r && typeof r.getBoundingClientRect == "function");
  });
}
function p1e(e) {
  e === void 0 && (e = {});
  var t = e, n = t.defaultModifiers, r = n === void 0 ? [] : n, o = t.defaultOptions, i = o === void 0 ? xR : o;
  return function(s, c, l) {
    l === void 0 && (l = i);
    var d = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, xR, i),
      modifiersData: {},
      elements: {
        reference: s,
        popper: c
      },
      attributes: {},
      styles: {}
    }, f = [], p = !1, m = {
      state: d,
      setOptions: function(x) {
        var T = typeof x == "function" ? x(d.options) : x;
        g(), d.options = Object.assign({}, i, d.options, T), d.scrollParents = {
          reference: tl(s) ? Cd(s) : s.contextElement ? Cd(s.contextElement) : [],
          popper: Cd(c)
        };
        var S = u1e(f1e([].concat(r, d.options.modifiers)));
        return d.orderedModifiers = S.filter(function(_) {
          return _.enabled;
        }), v(), m.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!p) {
          var x = d.elements, T = x.reference, S = x.popper;
          if (CR(T, S)) {
            d.rects = {
              reference: l1e(T, Rf(S), d.options.strategy === "fixed"),
              popper: px(S)
            }, d.reset = !1, d.placement = d.options.placement, d.orderedModifiers.forEach(function(A) {
              return d.modifiersData[A.name] = Object.assign({}, A.data);
            });
            for (var _ = 0; _ < d.orderedModifiers.length; _++) {
              if (d.reset === !0) {
                d.reset = !1, _ = -1;
                continue;
              }
              var w = d.orderedModifiers[_], k = w.fn, E = w.options, R = E === void 0 ? {} : E, P = w.name;
              typeof k == "function" && (d = k({
                state: d,
                options: R,
                name: P,
                instance: m
              }) || d);
            }
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: d1e(function() {
        return new Promise(function(b) {
          m.forceUpdate(), b(d);
        });
      }),
      destroy: function() {
        g(), p = !0;
      }
    };
    if (!CR(s, c))
      return m;
    m.setOptions(l).then(function(b) {
      !p && l.onFirstUpdate && l.onFirstUpdate(b);
    });
    function v() {
      d.orderedModifiers.forEach(function(b) {
        var x = b.name, T = b.options, S = T === void 0 ? {} : T, _ = b.effect;
        if (typeof _ == "function") {
          var w = _({
            state: d,
            name: x,
            instance: m,
            options: S
          }), k = function() {
          };
          f.push(w || k);
        }
      });
    }
    function g() {
      f.forEach(function(b) {
        return b();
      }), f = [];
    }
    return m;
  };
}
var h1e = [$ye, t1e, Iye, Sye, Qye, Yye, o1e, Oye, Xye], m1e = /* @__PURE__ */ p1e({
  defaultModifiers: h1e
});
function g1e(e) {
  return hn("MuiPopper", e);
}
un("MuiPopper", ["root"]);
const v1e = ["anchorEl", "children", "direction", "disablePortal", "modifiers", "open", "placement", "popperOptions", "popperRef", "slotProps", "slots", "TransitionProps", "ownerState"], b1e = ["anchorEl", "children", "container", "direction", "disablePortal", "keepMounted", "modifiers", "open", "placement", "popperOptions", "popperRef", "style", "transition", "slotProps", "slots"];
function y1e(e, t) {
  if (t === "ltr")
    return e;
  switch (e) {
    case "bottom-end":
      return "bottom-start";
    case "bottom-start":
      return "bottom-end";
    case "top-end":
      return "top-start";
    case "top-start":
      return "top-end";
    default:
      return e;
  }
}
function hm(e) {
  return typeof e == "function" ? e() : e;
}
function Bg(e) {
  return e.nodeType !== void 0;
}
function _1e(e) {
  return !Bg(e);
}
const w1e = (e) => {
  const {
    classes: t
  } = e;
  return Pn({
    root: ["root"]
  }, g1e, t);
}, x1e = {}, C1e = /* @__PURE__ */ B.forwardRef(function(t, n) {
  var r;
  const {
    anchorEl: o,
    children: i,
    direction: a,
    disablePortal: s,
    modifiers: c,
    open: l,
    placement: d,
    popperOptions: f,
    popperRef: p,
    slotProps: m = {},
    slots: v = {},
    TransitionProps: g
    // @ts-ignore internal logic
    // prevent from spreading to DOM, it can come from the parent component e.g. Select.
  } = t, b = ot(t, v1e), x = B.useRef(null), T = Kr(x, n), S = B.useRef(null), _ = Kr(S, p), w = B.useRef(_);
  el(() => {
    w.current = _;
  }, [_]), B.useImperativeHandle(p, () => S.current, []);
  const k = y1e(d, a), [E, R] = B.useState(k), [P, A] = B.useState(hm(o));
  B.useEffect(() => {
    S.current && S.current.forceUpdate();
  }), B.useEffect(() => {
    o && A(hm(o));
  }, [o]), el(() => {
    if (!P || !l)
      return;
    const I = (G) => {
      R(G.placement);
    };
    if (process.env.NODE_ENV !== "production" && P && Bg(P) && P.nodeType === 1) {
      const G = P.getBoundingClientRect();
      process.env.NODE_ENV !== "test" && G.top === 0 && G.left === 0 && G.right === 0 && G.bottom === 0 && console.warn(["MUI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
    }
    let j = [{
      name: "preventOverflow",
      options: {
        altBoundary: s
      }
    }, {
      name: "flip",
      options: {
        altBoundary: s
      }
    }, {
      name: "onUpdate",
      enabled: !0,
      phase: "afterWrite",
      fn: ({
        state: G
      }) => {
        I(G);
      }
    }];
    c != null && (j = j.concat(c)), f && f.modifiers != null && (j = j.concat(f.modifiers));
    const U = m1e(P, x.current, ue({
      placement: k
    }, f, {
      modifiers: j
    }));
    return w.current(U), () => {
      U.destroy(), w.current(null);
    };
  }, [P, s, c, l, f, k]);
  const D = {
    placement: E
  };
  g !== null && (D.TransitionProps = g);
  const N = w1e(t), F = (r = v.root) != null ? r : "div", $ = cs({
    elementType: F,
    externalSlotProps: m.root,
    externalForwardedProps: b,
    additionalProps: {
      role: "tooltip",
      ref: T
    },
    ownerState: t,
    className: N.root
  });
  return /* @__PURE__ */ z(F, ue({}, $, {
    children: typeof i == "function" ? i(D) : i
  }));
}), M5 = /* @__PURE__ */ B.forwardRef(function(t, n) {
  const {
    anchorEl: r,
    children: o,
    container: i,
    direction: a = "ltr",
    disablePortal: s = !1,
    keepMounted: c = !1,
    modifiers: l,
    open: d,
    placement: f = "bottom",
    popperOptions: p = x1e,
    popperRef: m,
    style: v,
    transition: g = !1,
    slotProps: b = {},
    slots: x = {}
  } = t, T = ot(t, b1e), [S, _] = B.useState(!0), w = () => {
    _(!1);
  }, k = () => {
    _(!0);
  };
  if (!c && !d && (!g || S))
    return null;
  let E;
  if (i)
    E = i;
  else if (r) {
    const A = hm(r);
    E = A && Bg(A) ? qr(A).body : qr(null).body;
  }
  const R = !d && c && (!g || S) ? "none" : void 0, P = g ? {
    in: d,
    onEnter: w,
    onExited: k
  } : void 0;
  return /* @__PURE__ */ z(Jd, {
    disablePortal: s,
    container: E,
    children: /* @__PURE__ */ z(C1e, ue({
      anchorEl: r,
      direction: a,
      disablePortal: s,
      modifiers: l,
      ref: n,
      open: g ? !S : d,
      placement: f,
      popperOptions: p,
      popperRef: m,
      slotProps: b,
      slots: x
    }, T, {
      style: ue({
        // Prevents scroll issue, waiting for Popper.js to add this style once initiated.
        position: "fixed",
        // Fix Popper.js display issue
        top: 0,
        left: 0,
        display: R
      }, v),
      TransitionProps: P,
      children: o
    }))
  });
});
process.env.NODE_ENV !== "production" && (M5.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * An HTML element, [virtualElement](https://popper.js.org/docs/v2/virtual-elements/),
   * or a function that returns either.
   * It's used to set the position of the popper.
   * The return value will passed as the reference object of the Popper instance.
   */
  anchorEl: vs(M.oneOfType([ma, M.object, M.func]), (e) => {
    if (e.open) {
      const t = hm(e.anchorEl);
      if (t && Bg(t) && t.nodeType === 1) {
        const n = t.getBoundingClientRect();
        if (process.env.NODE_ENV !== "test" && n.top === 0 && n.left === 0 && n.right === 0 && n.bottom === 0)
          return new Error(["MUI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
      } else if (!t || typeof t.getBoundingClientRect != "function" || _1e(t) && t.contextElement != null && t.contextElement.nodeType !== 1)
        return new Error(["MUI: The `anchorEl` prop provided to the component is invalid.", "It should be an HTML element instance or a virtualElement ", "(https://popper.js.org/docs/v2/virtual-elements/)."].join(`
`));
    }
    return null;
  }),
  /**
   * Popper render function or node.
   */
  children: M.oneOfType([M.node, M.func]),
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * You can also provide a callback, which is called in a React layout effect.
   * This lets you set the container from a ref, and also makes server-side rendering possible.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: M.oneOfType([ma, M.func]),
  /**
   * Direction of the text.
   * @default 'ltr'
   */
  direction: M.oneOf(["ltr", "rtl"]),
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: M.bool,
  /**
   * Always keep the children in the DOM.
   * This prop can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Popper.
   * @default false
   */
  keepMounted: M.bool,
  /**
   * Popper.js is based on a "plugin-like" architecture,
   * most of its features are fully encapsulated "modifiers".
   *
   * A modifier is a function that is called each time Popper.js needs to
   * compute the position of the popper.
   * For this reason, modifiers should be very performant to avoid bottlenecks.
   * To learn how to create a modifier, [read the modifiers documentation](https://popper.js.org/docs/v2/modifiers/).
   */
  modifiers: M.arrayOf(M.shape({
    data: M.object,
    effect: M.func,
    enabled: M.bool,
    fn: M.func,
    name: M.any,
    options: M.object,
    phase: M.oneOf(["afterMain", "afterRead", "afterWrite", "beforeMain", "beforeRead", "beforeWrite", "main", "read", "write"]),
    requires: M.arrayOf(M.string),
    requiresIfExists: M.arrayOf(M.string)
  })),
  /**
   * If `true`, the component is shown.
   */
  open: M.bool.isRequired,
  /**
   * Popper placement.
   * @default 'bottom'
   */
  placement: M.oneOf(["auto-end", "auto-start", "auto", "bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
  /**
   * Options provided to the [`Popper.js`](https://popper.js.org/docs/v2/constructors/#options) instance.
   * @default {}
   */
  popperOptions: M.shape({
    modifiers: M.array,
    onFirstUpdate: M.func,
    placement: M.oneOf(["auto-end", "auto-start", "auto", "bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
    strategy: M.oneOf(["absolute", "fixed"])
  }),
  /**
   * A ref that points to the used popper instance.
   */
  popperRef: Ig,
  /**
   * The props used for each slot inside the Popper.
   * @default {}
   */
  slotProps: M.shape({
    root: M.oneOfType([M.func, M.object])
  }),
  /**
   * The components used for each slot inside the Popper.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: M.shape({
    root: M.elementType
  }),
  /**
   * Help supporting a react-transition-group/Transition component.
   * @default false
   */
  transition: M.bool
});
const S1e = ["anchorEl", "component", "components", "componentsProps", "container", "disablePortal", "keepMounted", "modifiers", "open", "placement", "popperOptions", "popperRef", "transition", "slots", "slotProps"], T1e = ct(M5, {
  name: "MuiPopper",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({}), Hg = /* @__PURE__ */ B.forwardRef(function(t, n) {
  var r;
  const o = v5(), i = xn({
    props: t,
    name: "MuiPopper"
  }), {
    anchorEl: a,
    component: s,
    components: c,
    componentsProps: l,
    container: d,
    disablePortal: f,
    keepMounted: p,
    modifiers: m,
    open: v,
    placement: g,
    popperOptions: b,
    popperRef: x,
    transition: T,
    slots: S,
    slotProps: _
  } = i, w = ot(i, S1e), k = (r = S == null ? void 0 : S.root) != null ? r : c == null ? void 0 : c.Root, E = ue({
    anchorEl: a,
    container: d,
    disablePortal: f,
    keepMounted: p,
    modifiers: m,
    open: v,
    placement: g,
    popperOptions: b,
    popperRef: x,
    transition: T
  }, w);
  return /* @__PURE__ */ z(T1e, ue({
    as: s,
    direction: o == null ? void 0 : o.direction,
    slots: {
      root: k
    },
    slotProps: _ != null ? _ : l
  }, E, {
    ref: n
  }));
});
process.env.NODE_ENV !== "production" && (Hg.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * An HTML element, [virtualElement](https://popper.js.org/docs/v2/virtual-elements/),
   * or a function that returns either.
   * It's used to set the position of the popper.
   * The return value will passed as the reference object of the Popper instance.
   */
  anchorEl: M.oneOfType([ma, M.object, M.func]),
  /**
   * Popper render function or node.
   */
  children: M.oneOfType([M.node, M.func]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: M.elementType,
  /**
   * The components used for each slot inside the Popper.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  components: M.shape({
    Root: M.elementType
  }),
  /**
   * The props used for each slot inside the Popper.
   * @default {}
   */
  componentsProps: M.shape({
    root: M.oneOfType([M.func, M.object])
  }),
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * You can also provide a callback, which is called in a React layout effect.
   * This lets you set the container from a ref, and also makes server-side rendering possible.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: M.oneOfType([ma, M.func]),
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: M.bool,
  /**
   * Always keep the children in the DOM.
   * This prop can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Popper.
   * @default false
   */
  keepMounted: M.bool,
  /**
   * Popper.js is based on a "plugin-like" architecture,
   * most of its features are fully encapsulated "modifiers".
   *
   * A modifier is a function that is called each time Popper.js needs to
   * compute the position of the popper.
   * For this reason, modifiers should be very performant to avoid bottlenecks.
   * To learn how to create a modifier, [read the modifiers documentation](https://popper.js.org/docs/v2/modifiers/).
   */
  modifiers: M.arrayOf(M.shape({
    data: M.object,
    effect: M.func,
    enabled: M.bool,
    fn: M.func,
    name: M.any,
    options: M.object,
    phase: M.oneOf(["afterMain", "afterRead", "afterWrite", "beforeMain", "beforeRead", "beforeWrite", "main", "read", "write"]),
    requires: M.arrayOf(M.string),
    requiresIfExists: M.arrayOf(M.string)
  })),
  /**
   * If `true`, the component is shown.
   */
  open: M.bool.isRequired,
  /**
   * Popper placement.
   * @default 'bottom'
   */
  placement: M.oneOf(["auto-end", "auto-start", "auto", "bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
  /**
   * Options provided to the [`Popper.js`](https://popper.js.org/docs/v2/constructors/#options) instance.
   * @default {}
   */
  popperOptions: M.shape({
    modifiers: M.array,
    onFirstUpdate: M.func,
    placement: M.oneOf(["auto-end", "auto-start", "auto", "bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
    strategy: M.oneOf(["absolute", "fixed"])
  }),
  /**
   * A ref that points to the used popper instance.
   */
  popperRef: Ig,
  /**
   * The props used for each slot inside the Popper.
   * @default {}
   */
  slotProps: M.shape({
    root: M.oneOfType([M.func, M.object])
  }),
  /**
   * The components used for each slot inside the Popper.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: M.shape({
    root: M.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: M.oneOfType([M.arrayOf(M.oneOfType([M.func, M.object, M.bool])), M.func, M.object]),
  /**
   * Help supporting a react-transition-group/Transition component.
   * @default false
   */
  transition: M.bool
});
const E1e = kf(/* @__PURE__ */ z("path", {
  d: "M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
}), "MoreHoriz"), k1e = ["slots", "slotProps"], M1e = ct(Kc)(({
  theme: e
}) => ue({
  display: "flex",
  marginLeft: `calc(${e.spacing(1)} * 0.5)`,
  marginRight: `calc(${e.spacing(1)} * 0.5)`
}, e.palette.mode === "light" ? {
  backgroundColor: e.palette.grey[100],
  color: e.palette.grey[700]
} : {
  backgroundColor: e.palette.grey[700],
  color: e.palette.grey[100]
}, {
  borderRadius: 2,
  "&:hover, &:focus": ue({}, e.palette.mode === "light" ? {
    backgroundColor: e.palette.grey[200]
  } : {
    backgroundColor: e.palette.grey[600]
  }),
  "&:active": ue({
    boxShadow: e.shadows[0]
  }, e.palette.mode === "light" ? {
    backgroundColor: HM(e.palette.grey[200], 0.12)
  } : {
    backgroundColor: HM(e.palette.grey[600], 0.12)
  })
})), R1e = ct(E1e)({
  width: 24,
  height: 16
});
function R5(e) {
  const {
    slots: t = {},
    slotProps: n = {}
  } = e, r = ot(e, k1e), o = e;
  return /* @__PURE__ */ z("li", {
    children: /* @__PURE__ */ z(M1e, ue({
      focusRipple: !0
    }, r, {
      ownerState: o,
      children: /* @__PURE__ */ z(R1e, ue({
        as: t.CollapsedIcon,
        ownerState: o
      }, n.collapsedIcon))
    }))
  });
}
process.env.NODE_ENV !== "production" && (R5.propTypes = {
  /**
   * The props used for the CollapsedIcon slot.
   * @default {}
   */
  slotProps: M.shape({
    collapsedIcon: M.oneOfType([M.func, M.object])
  }),
  /**
   * The components used for each slot inside the BreadcumbCollapsed.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: M.shape({
    CollapsedIcon: M.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: M.object
});
function P1e(e) {
  return hn("MuiBreadcrumbs", e);
}
const O1e = un("MuiBreadcrumbs", ["root", "ol", "li", "separator"]), N1e = ["children", "className", "component", "slots", "slotProps", "expandText", "itemsAfterCollapse", "itemsBeforeCollapse", "maxItems", "separator"], A1e = (e) => {
  const {
    classes: t
  } = e;
  return Pn({
    root: ["root"],
    li: ["li"],
    ol: ["ol"],
    separator: ["separator"]
  }, P1e, t);
}, D1e = ct(si, {
  name: "MuiBreadcrumbs",
  slot: "Root",
  overridesResolver: (e, t) => [{
    [`& .${O1e.li}`]: t.li
  }, t.root]
})({}), I1e = ct("ol", {
  name: "MuiBreadcrumbs",
  slot: "Ol",
  overridesResolver: (e, t) => t.ol
})({
  display: "flex",
  flexWrap: "wrap",
  alignItems: "center",
  padding: 0,
  margin: 0,
  listStyle: "none"
}), L1e = ct("li", {
  name: "MuiBreadcrumbs",
  slot: "Separator",
  overridesResolver: (e, t) => t.separator
})({
  display: "flex",
  userSelect: "none",
  marginLeft: 8,
  marginRight: 8
});
function $1e(e, t, n, r) {
  return e.reduce((o, i, a) => (a < e.length - 1 ? o = o.concat(i, /* @__PURE__ */ z(L1e, {
    "aria-hidden": !0,
    className: t,
    ownerState: r,
    children: n
  }, `separator-${a}`)) : o.push(i), o), []);
}
const P5 = /* @__PURE__ */ B.forwardRef(function(t, n) {
  const r = xn({
    props: t,
    name: "MuiBreadcrumbs"
  }), {
    children: o,
    className: i,
    component: a = "nav",
    slots: s = {},
    slotProps: c = {},
    expandText: l = "Show path",
    itemsAfterCollapse: d = 1,
    itemsBeforeCollapse: f = 1,
    maxItems: p = 8,
    separator: m = "/"
  } = r, v = ot(r, N1e), [g, b] = B.useState(!1), x = ue({}, r, {
    component: a,
    expanded: g,
    expandText: l,
    itemsAfterCollapse: d,
    itemsBeforeCollapse: f,
    maxItems: p,
    separator: m
  }), T = A1e(x), S = cs({
    elementType: s.CollapsedIcon,
    externalSlotProps: c.collapsedIcon,
    ownerState: x
  }), _ = B.useRef(null), w = (E) => {
    const R = () => {
      b(!0);
      const P = _.current.querySelector("a[href],button,[tabindex]");
      P && P.focus();
    };
    return f + d >= E.length ? (process.env.NODE_ENV !== "production" && console.error(["MUI: You have provided an invalid combination of props to the Breadcrumbs.", `itemsAfterCollapse={${d}} + itemsBeforeCollapse={${f}} >= maxItems={${p}}`].join(`
`)), E) : [...E.slice(0, f), /* @__PURE__ */ z(R5, {
      "aria-label": l,
      slots: {
        CollapsedIcon: s.CollapsedIcon
      },
      slotProps: {
        collapsedIcon: S
      },
      onClick: R
    }, "ellipsis"), ...E.slice(E.length - d, E.length)];
  }, k = B.Children.toArray(o).filter((E) => (process.env.NODE_ENV !== "production" && Gd.isFragment(E) && console.error(["MUI: The Breadcrumbs component doesn't accept a Fragment as a child.", "Consider providing an array instead."].join(`
`)), /* @__PURE__ */ B.isValidElement(E))).map((E, R) => /* @__PURE__ */ z("li", {
    className: T.li,
    children: E
  }, `child-${R}`));
  return /* @__PURE__ */ z(D1e, ue({
    ref: n,
    component: a,
    color: "text.secondary",
    className: lt(T.root, i),
    ownerState: x
  }, v, {
    children: /* @__PURE__ */ z(I1e, {
      className: T.ol,
      ref: _,
      ownerState: x,
      children: $1e(g || p && k.length <= p ? k : w(k), T.separator, m, x)
    })
  }));
});
process.env.NODE_ENV !== "production" && (P5.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: M.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: M.object,
  /**
   * @ignore
   */
  className: M.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: M.elementType,
  /**
   * Override the default label for the expand button.
   *
   * For localization purposes, you can use the provided [translations](/material-ui/guides/localization/).
   * @default 'Show path'
   */
  expandText: M.string,
  /**
   * If max items is exceeded, the number of items to show after the ellipsis.
   * @default 1
   */
  itemsAfterCollapse: Ti,
  /**
   * If max items is exceeded, the number of items to show before the ellipsis.
   * @default 1
   */
  itemsBeforeCollapse: Ti,
  /**
   * Specifies the maximum number of breadcrumbs to display. When there are more
   * than the maximum number, only the first `itemsBeforeCollapse` and last `itemsAfterCollapse`
   * will be shown, with an ellipsis in between.
   * @default 8
   */
  maxItems: Ti,
  /**
   * Custom separator node.
   * @default '/'
   */
  separator: M.node,
  /**
   * The props used for each slot inside the Breadcumb.
   * @default {}
   */
  slotProps: M.shape({
    collapsedIcon: M.oneOfType([M.func, M.object])
  }),
  /**
   * The components used for each slot inside the Breadcumb.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: M.shape({
    CollapsedIcon: M.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: M.oneOfType([M.arrayOf(M.oneOfType([M.func, M.object, M.bool])), M.func, M.object])
});
function F1e(e) {
  return hn("MuiButton", e);
}
const kp = un("MuiButton", ["root", "text", "textInherit", "textPrimary", "textSecondary", "textSuccess", "textError", "textInfo", "textWarning", "outlined", "outlinedInherit", "outlinedPrimary", "outlinedSecondary", "outlinedSuccess", "outlinedError", "outlinedInfo", "outlinedWarning", "contained", "containedInherit", "containedPrimary", "containedSecondary", "containedSuccess", "containedError", "containedInfo", "containedWarning", "disableElevation", "focusVisible", "disabled", "colorInherit", "colorPrimary", "colorSecondary", "colorSuccess", "colorError", "colorInfo", "colorWarning", "textSizeSmall", "textSizeMedium", "textSizeLarge", "outlinedSizeSmall", "outlinedSizeMedium", "outlinedSizeLarge", "containedSizeSmall", "containedSizeMedium", "containedSizeLarge", "sizeMedium", "sizeSmall", "sizeLarge", "fullWidth", "startIcon", "endIcon", "icon", "iconSizeSmall", "iconSizeMedium", "iconSizeLarge"]), O5 = /* @__PURE__ */ B.createContext({});
process.env.NODE_ENV !== "production" && (O5.displayName = "ButtonGroupContext");
const N5 = /* @__PURE__ */ B.createContext(void 0);
process.env.NODE_ENV !== "production" && (N5.displayName = "ButtonGroupButtonContext");
const z1e = ["children", "color", "component", "className", "disabled", "disableElevation", "disableFocusRipple", "endIcon", "focusVisibleClassName", "fullWidth", "size", "startIcon", "type", "variant"], B1e = (e) => {
  const {
    color: t,
    disableElevation: n,
    fullWidth: r,
    size: o,
    variant: i,
    classes: a
  } = e, s = {
    root: ["root", i, `${i}${xt(t)}`, `size${xt(o)}`, `${i}Size${xt(o)}`, `color${xt(t)}`, n && "disableElevation", r && "fullWidth"],
    label: ["label"],
    startIcon: ["icon", "startIcon", `iconSize${xt(o)}`],
    endIcon: ["icon", "endIcon", `iconSize${xt(o)}`]
  }, c = Pn(s, F1e, a);
  return ue({}, a, c);
}, A5 = (e) => ue({}, e.size === "small" && {
  "& > *:nth-of-type(1)": {
    fontSize: 18
  }
}, e.size === "medium" && {
  "& > *:nth-of-type(1)": {
    fontSize: 20
  }
}, e.size === "large" && {
  "& > *:nth-of-type(1)": {
    fontSize: 22
  }
}), H1e = ct(Kc, {
  shouldForwardProp: (e) => Dg(e) || e === "classes",
  name: "MuiButton",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, t[n.variant], t[`${n.variant}${xt(n.color)}`], t[`size${xt(n.size)}`], t[`${n.variant}Size${xt(n.size)}`], n.color === "inherit" && t.colorInherit, n.disableElevation && t.disableElevation, n.fullWidth && t.fullWidth];
  }
})(({
  theme: e,
  ownerState: t
}) => {
  var n, r;
  const o = e.palette.mode === "light" ? e.palette.grey[300] : e.palette.grey[800], i = e.palette.mode === "light" ? e.palette.grey.A100 : e.palette.grey[700];
  return ue({}, e.typography.button, {
    minWidth: 64,
    padding: "6px 16px",
    borderRadius: (e.vars || e).shape.borderRadius,
    transition: e.transitions.create(["background-color", "box-shadow", "border-color", "color"], {
      duration: e.transitions.duration.short
    }),
    "&:hover": ue({
      textDecoration: "none",
      backgroundColor: e.vars ? `rgba(${e.vars.palette.text.primaryChannel} / ${e.vars.palette.action.hoverOpacity})` : Mn(e.palette.text.primary, e.palette.action.hoverOpacity),
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: "transparent"
      }
    }, t.variant === "text" && t.color !== "inherit" && {
      backgroundColor: e.vars ? `rgba(${e.vars.palette[t.color].mainChannel} / ${e.vars.palette.action.hoverOpacity})` : Mn(e.palette[t.color].main, e.palette.action.hoverOpacity),
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: "transparent"
      }
    }, t.variant === "outlined" && t.color !== "inherit" && {
      border: `1px solid ${(e.vars || e).palette[t.color].main}`,
      backgroundColor: e.vars ? `rgba(${e.vars.palette[t.color].mainChannel} / ${e.vars.palette.action.hoverOpacity})` : Mn(e.palette[t.color].main, e.palette.action.hoverOpacity),
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: "transparent"
      }
    }, t.variant === "contained" && {
      backgroundColor: e.vars ? e.vars.palette.Button.inheritContainedHoverBg : i,
      boxShadow: (e.vars || e).shadows[4],
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        boxShadow: (e.vars || e).shadows[2],
        backgroundColor: (e.vars || e).palette.grey[300]
      }
    }, t.variant === "contained" && t.color !== "inherit" && {
      backgroundColor: (e.vars || e).palette[t.color].dark,
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: (e.vars || e).palette[t.color].main
      }
    }),
    "&:active": ue({}, t.variant === "contained" && {
      boxShadow: (e.vars || e).shadows[8]
    }),
    [`&.${kp.focusVisible}`]: ue({}, t.variant === "contained" && {
      boxShadow: (e.vars || e).shadows[6]
    }),
    [`&.${kp.disabled}`]: ue({
      color: (e.vars || e).palette.action.disabled
    }, t.variant === "outlined" && {
      border: `1px solid ${(e.vars || e).palette.action.disabledBackground}`
    }, t.variant === "contained" && {
      color: (e.vars || e).palette.action.disabled,
      boxShadow: (e.vars || e).shadows[0],
      backgroundColor: (e.vars || e).palette.action.disabledBackground
    })
  }, t.variant === "text" && {
    padding: "6px 8px"
  }, t.variant === "text" && t.color !== "inherit" && {
    color: (e.vars || e).palette[t.color].main
  }, t.variant === "outlined" && {
    padding: "5px 15px",
    border: "1px solid currentColor"
  }, t.variant === "outlined" && t.color !== "inherit" && {
    color: (e.vars || e).palette[t.color].main,
    border: e.vars ? `1px solid rgba(${e.vars.palette[t.color].mainChannel} / 0.5)` : `1px solid ${Mn(e.palette[t.color].main, 0.5)}`
  }, t.variant === "contained" && {
    color: e.vars ? (
      // this is safe because grey does not change between default light/dark mode
      e.vars.palette.text.primary
    ) : (n = (r = e.palette).getContrastText) == null ? void 0 : n.call(r, e.palette.grey[300]),
    backgroundColor: e.vars ? e.vars.palette.Button.inheritContainedBg : o,
    boxShadow: (e.vars || e).shadows[2]
  }, t.variant === "contained" && t.color !== "inherit" && {
    color: (e.vars || e).palette[t.color].contrastText,
    backgroundColor: (e.vars || e).palette[t.color].main
  }, t.color === "inherit" && {
    color: "inherit",
    borderColor: "currentColor"
  }, t.size === "small" && t.variant === "text" && {
    padding: "4px 5px",
    fontSize: e.typography.pxToRem(13)
  }, t.size === "large" && t.variant === "text" && {
    padding: "8px 11px",
    fontSize: e.typography.pxToRem(15)
  }, t.size === "small" && t.variant === "outlined" && {
    padding: "3px 9px",
    fontSize: e.typography.pxToRem(13)
  }, t.size === "large" && t.variant === "outlined" && {
    padding: "7px 21px",
    fontSize: e.typography.pxToRem(15)
  }, t.size === "small" && t.variant === "contained" && {
    padding: "4px 10px",
    fontSize: e.typography.pxToRem(13)
  }, t.size === "large" && t.variant === "contained" && {
    padding: "8px 22px",
    fontSize: e.typography.pxToRem(15)
  }, t.fullWidth && {
    width: "100%"
  });
}, ({
  ownerState: e
}) => e.disableElevation && {
  boxShadow: "none",
  "&:hover": {
    boxShadow: "none"
  },
  [`&.${kp.focusVisible}`]: {
    boxShadow: "none"
  },
  "&:active": {
    boxShadow: "none"
  },
  [`&.${kp.disabled}`]: {
    boxShadow: "none"
  }
}), j1e = ct("span", {
  name: "MuiButton",
  slot: "StartIcon",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.startIcon, t[`iconSize${xt(n.size)}`]];
  }
})(({
  ownerState: e
}) => ue({
  display: "inherit",
  marginRight: 8,
  marginLeft: -4
}, e.size === "small" && {
  marginLeft: -2
}, A5(e))), W1e = ct("span", {
  name: "MuiButton",
  slot: "EndIcon",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.endIcon, t[`iconSize${xt(n.size)}`]];
  }
})(({
  ownerState: e
}) => ue({
  display: "inherit",
  marginRight: -4,
  marginLeft: 8
}, e.size === "small" && {
  marginRight: -2
}, A5(e))), mm = /* @__PURE__ */ B.forwardRef(function(t, n) {
  const r = B.useContext(O5), o = B.useContext(N5), i = u5(r, t), a = xn({
    props: i,
    name: "MuiButton"
  }), {
    children: s,
    color: c = "primary",
    component: l = "button",
    className: d,
    disabled: f = !1,
    disableElevation: p = !1,
    disableFocusRipple: m = !1,
    endIcon: v,
    focusVisibleClassName: g,
    fullWidth: b = !1,
    size: x = "medium",
    startIcon: T,
    type: S,
    variant: _ = "text"
  } = a, w = ot(a, z1e), k = ue({}, a, {
    color: c,
    component: l,
    disabled: f,
    disableElevation: p,
    disableFocusRipple: m,
    fullWidth: b,
    size: x,
    type: S,
    variant: _
  }), E = B1e(k), R = T && /* @__PURE__ */ z(j1e, {
    className: E.startIcon,
    ownerState: k,
    children: T
  }), P = v && /* @__PURE__ */ z(W1e, {
    className: E.endIcon,
    ownerState: k,
    children: v
  }), A = o || "";
  return /* @__PURE__ */ _e(H1e, ue({
    ownerState: k,
    className: lt(r.className, E.root, d, A),
    component: l,
    disabled: f,
    focusRipple: !m,
    focusVisibleClassName: lt(E.focusVisible, g),
    ref: n,
    type: S
  }, w, {
    classes: E,
    children: [R, s, P]
  }));
});
process.env.NODE_ENV !== "production" && (mm.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: M.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: M.object,
  /**
   * @ignore
   */
  className: M.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: M.oneOfType([M.oneOf(["inherit", "primary", "secondary", "success", "error", "info", "warning"]), M.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: M.elementType,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: M.bool,
  /**
   * If `true`, no elevation is used.
   * @default false
   */
  disableElevation: M.bool,
  /**
   * If `true`, the  keyboard focus ripple is disabled.
   * @default false
   */
  disableFocusRipple: M.bool,
  /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */
  disableRipple: M.bool,
  /**
   * Element placed after the children.
   */
  endIcon: M.node,
  /**
   * @ignore
   */
  focusVisibleClassName: M.string,
  /**
   * If `true`, the button will take up the full width of its container.
   * @default false
   */
  fullWidth: M.bool,
  /**
   * The URL to link to when the button is clicked.
   * If defined, an `a` element will be used as the root node.
   */
  href: M.string,
  /**
   * The size of the component.
   * `small` is equivalent to the dense button styling.
   * @default 'medium'
   */
  size: M.oneOfType([M.oneOf(["small", "medium", "large"]), M.string]),
  /**
   * Element placed before the children.
   */
  startIcon: M.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: M.oneOfType([M.arrayOf(M.oneOfType([M.func, M.object, M.bool])), M.func, M.object]),
  /**
   * @ignore
   */
  type: M.oneOfType([M.oneOf(["button", "reset", "submit"]), M.string]),
  /**
   * The variant to use.
   * @default 'text'
   */
  variant: M.oneOfType([M.oneOf(["contained", "outlined", "text"]), M.string])
});
function V1e(e) {
  return hn("MuiCard", e);
}
un("MuiCard", ["root"]);
const U1e = ["className", "raised"], q1e = (e) => {
  const {
    classes: t
  } = e;
  return Pn({
    root: ["root"]
  }, V1e, t);
}, G1e = ct(ix, {
  name: "MuiCard",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(() => ({
  overflow: "hidden"
})), D5 = /* @__PURE__ */ B.forwardRef(function(t, n) {
  const r = xn({
    props: t,
    name: "MuiCard"
  }), {
    className: o,
    raised: i = !1
  } = r, a = ot(r, U1e), s = ue({}, r, {
    raised: i
  }), c = q1e(s);
  return /* @__PURE__ */ z(G1e, ue({
    className: lt(c.root, o),
    elevation: i ? 8 : void 0,
    ref: n,
    ownerState: s
  }, a));
});
process.env.NODE_ENV !== "production" && (D5.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: M.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: M.object,
  /**
   * @ignore
   */
  className: M.string,
  /**
   * If `true`, the card will use raised styling.
   * @default false
   */
  raised: vs(M.bool, (e) => e.raised && e.variant === "outlined" ? new Error('MUI: Combining `raised={true}` with `variant="outlined"` has no effect.') : null),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: M.oneOfType([M.arrayOf(M.oneOfType([M.func, M.object, M.bool])), M.func, M.object])
});
function Y1e(e) {
  return hn("MuiCardContent", e);
}
un("MuiCardContent", ["root"]);
const Z1e = ["className", "component"], X1e = (e) => {
  const {
    classes: t
  } = e;
  return Pn({
    root: ["root"]
  }, Y1e, t);
}, K1e = ct("div", {
  name: "MuiCardContent",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(() => ({
  padding: 16,
  "&:last-child": {
    paddingBottom: 24
  }
})), I5 = /* @__PURE__ */ B.forwardRef(function(t, n) {
  const r = xn({
    props: t,
    name: "MuiCardContent"
  }), {
    className: o,
    component: i = "div"
  } = r, a = ot(r, Z1e), s = ue({}, r, {
    component: i
  }), c = X1e(s);
  return /* @__PURE__ */ z(K1e, ue({
    as: i,
    className: lt(c.root, o),
    ownerState: s,
    ref: n
  }, a));
});
process.env.NODE_ENV !== "production" && (I5.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: M.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: M.object,
  /**
   * @ignore
   */
  className: M.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: M.elementType,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: M.oneOfType([M.arrayOf(M.oneOfType([M.func, M.object, M.bool])), M.func, M.object])
});
function J1e(e) {
  return hn("MuiPagination", e);
}
un("MuiPagination", ["root", "ul", "outlined", "text"]);
const Q1e = ["boundaryCount", "componentName", "count", "defaultPage", "disabled", "hideNextButton", "hidePrevButton", "onChange", "page", "showFirstButton", "showLastButton", "siblingCount"];
function e_e(e = {}) {
  const {
    boundaryCount: t = 1,
    componentName: n = "usePagination",
    count: r = 1,
    defaultPage: o = 1,
    disabled: i = !1,
    hideNextButton: a = !1,
    hidePrevButton: s = !1,
    onChange: c,
    page: l,
    showFirstButton: d = !1,
    showLastButton: f = !1,
    siblingCount: p = 1
  } = e, m = ot(e, Q1e), [v, g] = l5({
    controlled: l,
    default: o,
    name: n,
    state: "page"
  }), b = (P, A) => {
    l || g(A), c && c(P, A);
  }, x = (P, A) => {
    const D = A - P + 1;
    return Array.from({
      length: D
    }, (N, F) => P + F);
  }, T = x(1, Math.min(t, r)), S = x(Math.max(r - t + 1, t + 1), r), _ = Math.max(
    Math.min(
      // Natural start
      v - p,
      // Lower boundary when page is high
      r - t - p * 2 - 1
    ),
    // Greater than startPages
    t + 2
  ), w = Math.min(
    Math.max(
      // Natural end
      v + p,
      // Upper boundary when page is low
      t + p * 2 + 2
    ),
    // Less than endPages
    S.length > 0 ? S[0] - 2 : r - 1
  ), k = [
    ...d ? ["first"] : [],
    ...s ? [] : ["previous"],
    ...T,
    // Start ellipsis
    // eslint-disable-next-line no-nested-ternary
    ..._ > t + 2 ? ["start-ellipsis"] : t + 1 < r - t ? [t + 1] : [],
    // Sibling pages
    ...x(_, w),
    // End ellipsis
    // eslint-disable-next-line no-nested-ternary
    ...w < r - t - 1 ? ["end-ellipsis"] : r - t > t ? [r - t] : [],
    ...S,
    ...a ? [] : ["next"],
    ...f ? ["last"] : []
  ], E = (P) => {
    switch (P) {
      case "first":
        return 1;
      case "previous":
        return v - 1;
      case "next":
        return v + 1;
      case "last":
        return r;
      default:
        return null;
    }
  }, R = k.map((P) => typeof P == "number" ? {
    onClick: (A) => {
      b(A, P);
    },
    type: "page",
    page: P,
    selected: P === v,
    disabled: i,
    "aria-current": P === v ? "true" : void 0
  } : {
    onClick: (A) => {
      b(A, E(P));
    },
    type: P,
    page: E(P),
    selected: !1,
    disabled: i || P.indexOf("ellipsis") === -1 && (P === "next" || P === "last" ? v >= r : v <= 1)
  });
  return ue({
    items: R
  }, m);
}
function t_e(e) {
  return hn("MuiPaginationItem", e);
}
const Oo = un("MuiPaginationItem", ["root", "page", "sizeSmall", "sizeLarge", "text", "textPrimary", "textSecondary", "outlined", "outlinedPrimary", "outlinedSecondary", "rounded", "ellipsis", "firstLast", "previousNext", "focusVisible", "disabled", "selected", "icon", "colorPrimary", "colorSecondary"]), SR = kf(/* @__PURE__ */ z("path", {
  d: "M18.41 16.59L13.82 12l4.59-4.59L17 6l-6 6 6 6zM6 6h2v12H6z"
}), "FirstPage"), TR = kf(/* @__PURE__ */ z("path", {
  d: "M5.59 7.41L10.18 12l-4.59 4.59L7 18l6-6-6-6zM16 6h2v12h-2z"
}), "LastPage"), ER = kf(/* @__PURE__ */ z("path", {
  d: "M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"
}), "NavigateBefore"), kR = kf(/* @__PURE__ */ z("path", {
  d: "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
}), "NavigateNext"), n_e = ["className", "color", "component", "components", "disabled", "page", "selected", "shape", "size", "slots", "type", "variant"], L5 = (e, t) => {
  const {
    ownerState: n
  } = e;
  return [t.root, t[n.variant], t[`size${xt(n.size)}`], n.variant === "text" && t[`text${xt(n.color)}`], n.variant === "outlined" && t[`outlined${xt(n.color)}`], n.shape === "rounded" && t.rounded, n.type === "page" && t.page, (n.type === "start-ellipsis" || n.type === "end-ellipsis") && t.ellipsis, (n.type === "previous" || n.type === "next") && t.previousNext, (n.type === "first" || n.type === "last") && t.firstLast];
}, r_e = (e) => {
  const {
    classes: t,
    color: n,
    disabled: r,
    selected: o,
    size: i,
    shape: a,
    type: s,
    variant: c
  } = e, l = {
    root: ["root", `size${xt(i)}`, c, a, n !== "standard" && `color${xt(n)}`, n !== "standard" && `${c}${xt(n)}`, r && "disabled", o && "selected", {
      page: "page",
      first: "firstLast",
      last: "firstLast",
      "start-ellipsis": "ellipsis",
      "end-ellipsis": "ellipsis",
      previous: "previousNext",
      next: "previousNext"
    }[s]],
    icon: ["icon"]
  };
  return Pn(l, t_e, t);
}, o_e = ct("div", {
  name: "MuiPaginationItem",
  slot: "Root",
  overridesResolver: L5
})(({
  theme: e,
  ownerState: t
}) => ue({}, e.typography.body2, {
  borderRadius: 32 / 2,
  textAlign: "center",
  boxSizing: "border-box",
  minWidth: 32,
  padding: "0 6px",
  margin: "0 3px",
  color: (e.vars || e).palette.text.primary,
  height: "auto",
  [`&.${Oo.disabled}`]: {
    opacity: (e.vars || e).palette.action.disabledOpacity
  }
}, t.size === "small" && {
  minWidth: 26,
  borderRadius: 26 / 2,
  margin: "0 1px",
  padding: "0 4px"
}, t.size === "large" && {
  minWidth: 40,
  borderRadius: 40 / 2,
  padding: "0 10px",
  fontSize: e.typography.pxToRem(15)
})), i_e = ct(Kc, {
  name: "MuiPaginationItem",
  slot: "Root",
  overridesResolver: L5
})(({
  theme: e,
  ownerState: t
}) => ue({}, e.typography.body2, {
  borderRadius: 32 / 2,
  textAlign: "center",
  boxSizing: "border-box",
  minWidth: 32,
  height: 32,
  padding: "0 6px",
  margin: "0 3px",
  color: (e.vars || e).palette.text.primary,
  [`&.${Oo.focusVisible}`]: {
    backgroundColor: (e.vars || e).palette.action.focus
  },
  [`&.${Oo.disabled}`]: {
    opacity: (e.vars || e).palette.action.disabledOpacity
  },
  transition: e.transitions.create(["color", "background-color"], {
    duration: e.transitions.duration.short
  }),
  "&:hover": {
    backgroundColor: (e.vars || e).palette.action.hover,
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: "transparent"
    }
  },
  [`&.${Oo.selected}`]: {
    backgroundColor: (e.vars || e).palette.action.selected,
    "&:hover": {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.action.selectedChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.hoverOpacity}))` : Mn(e.palette.action.selected, e.palette.action.selectedOpacity + e.palette.action.hoverOpacity),
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: (e.vars || e).palette.action.selected
      }
    },
    [`&.${Oo.focusVisible}`]: {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.action.selectedChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.focusOpacity}))` : Mn(e.palette.action.selected, e.palette.action.selectedOpacity + e.palette.action.focusOpacity)
    },
    [`&.${Oo.disabled}`]: {
      opacity: 1,
      color: (e.vars || e).palette.action.disabled,
      backgroundColor: (e.vars || e).palette.action.selected
    }
  }
}, t.size === "small" && {
  minWidth: 26,
  height: 26,
  borderRadius: 26 / 2,
  margin: "0 1px",
  padding: "0 4px"
}, t.size === "large" && {
  minWidth: 40,
  height: 40,
  borderRadius: 40 / 2,
  padding: "0 10px",
  fontSize: e.typography.pxToRem(15)
}, t.shape === "rounded" && {
  borderRadius: (e.vars || e).shape.borderRadius
}), ({
  theme: e,
  ownerState: t
}) => ue({}, t.variant === "text" && {
  [`&.${Oo.selected}`]: ue({}, t.color !== "standard" && {
    color: (e.vars || e).palette[t.color].contrastText,
    backgroundColor: (e.vars || e).palette[t.color].main,
    "&:hover": {
      backgroundColor: (e.vars || e).palette[t.color].dark,
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: (e.vars || e).palette[t.color].main
      }
    },
    [`&.${Oo.focusVisible}`]: {
      backgroundColor: (e.vars || e).palette[t.color].dark
    }
  }, {
    [`&.${Oo.disabled}`]: {
      color: (e.vars || e).palette.action.disabled
    }
  })
}, t.variant === "outlined" && {
  border: e.vars ? `1px solid rgba(${e.vars.palette.common.onBackgroundChannel} / 0.23)` : `1px solid ${e.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)"}`,
  [`&.${Oo.selected}`]: ue({}, t.color !== "standard" && {
    color: (e.vars || e).palette[t.color].main,
    border: `1px solid ${e.vars ? `rgba(${e.vars.palette[t.color].mainChannel} / 0.5)` : Mn(e.palette[t.color].main, 0.5)}`,
    backgroundColor: e.vars ? `rgba(${e.vars.palette[t.color].mainChannel} / ${e.vars.palette.action.activatedOpacity})` : Mn(e.palette[t.color].main, e.palette.action.activatedOpacity),
    "&:hover": {
      backgroundColor: e.vars ? `rgba(${e.vars.palette[t.color].mainChannel} / calc(${e.vars.palette.action.activatedOpacity} + ${e.vars.palette.action.focusOpacity}))` : Mn(e.palette[t.color].main, e.palette.action.activatedOpacity + e.palette.action.focusOpacity),
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: "transparent"
      }
    },
    [`&.${Oo.focusVisible}`]: {
      backgroundColor: e.vars ? `rgba(${e.vars.palette[t.color].mainChannel} / calc(${e.vars.palette.action.activatedOpacity} + ${e.vars.palette.action.focusOpacity}))` : Mn(e.palette[t.color].main, e.palette.action.activatedOpacity + e.palette.action.focusOpacity)
    }
  }, {
    [`&.${Oo.disabled}`]: {
      borderColor: (e.vars || e).palette.action.disabledBackground,
      color: (e.vars || e).palette.action.disabled
    }
  })
})), a_e = ct("div", {
  name: "MuiPaginationItem",
  slot: "Icon",
  overridesResolver: (e, t) => t.icon
})(({
  theme: e,
  ownerState: t
}) => ue({
  fontSize: e.typography.pxToRem(20),
  margin: "0 -8px"
}, t.size === "small" && {
  fontSize: e.typography.pxToRem(18)
}, t.size === "large" && {
  fontSize: e.typography.pxToRem(22)
})), $5 = /* @__PURE__ */ B.forwardRef(function(t, n) {
  const r = xn({
    props: t,
    name: "MuiPaginationItem"
  }), {
    className: o,
    color: i = "standard",
    component: a,
    components: s = {},
    disabled: c = !1,
    page: l,
    selected: d = !1,
    shape: f = "circular",
    size: p = "medium",
    slots: m = {},
    type: v = "page",
    variant: g = "text"
  } = r, b = ot(r, n_e), x = ue({}, r, {
    color: i,
    disabled: c,
    selected: d,
    shape: f,
    size: p,
    type: v,
    variant: g
  }), T = Zw(), S = r_e(x), w = (T ? {
    previous: m.next || s.next || kR,
    next: m.previous || s.previous || ER,
    last: m.first || s.first || SR,
    first: m.last || s.last || TR
  } : {
    previous: m.previous || s.previous || ER,
    next: m.next || s.next || kR,
    first: m.first || s.first || SR,
    last: m.last || s.last || TR
  })[v];
  return v === "start-ellipsis" || v === "end-ellipsis" ? /* @__PURE__ */ z(o_e, {
    ref: n,
    ownerState: x,
    className: lt(S.root, o),
    children: "…"
  }) : /* @__PURE__ */ _e(i_e, ue({
    ref: n,
    ownerState: x,
    component: a,
    disabled: c,
    className: lt(S.root, o)
  }, b, {
    children: [v === "page" && l, w ? /* @__PURE__ */ z(a_e, {
      as: w,
      ownerState: x,
      className: S.icon
    }) : null]
  }));
});
process.env.NODE_ENV !== "production" && ($5.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  children: M.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: M.object,
  /**
   * @ignore
   */
  className: M.string,
  /**
   * The active color.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'standard'
   */
  color: M.oneOfType([M.oneOf(["primary", "secondary", "standard"]), M.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: M.elementType,
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */
  components: M.shape({
    first: M.elementType,
    last: M.elementType,
    next: M.elementType,
    previous: M.elementType
  }),
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: M.bool,
  /**
   * The current page number.
   */
  page: M.node,
  /**
   * If `true` the pagination item is selected.
   * @default false
   */
  selected: M.bool,
  /**
   * The shape of the pagination item.
   * @default 'circular'
   */
  shape: M.oneOf(["circular", "rounded"]),
  /**
   * The size of the component.
   * @default 'medium'
   */
  size: M.oneOfType([M.oneOf(["small", "medium", "large"]), M.string]),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: M.shape({
    first: M.elementType,
    last: M.elementType,
    next: M.elementType,
    previous: M.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: M.oneOfType([M.arrayOf(M.oneOfType([M.func, M.object, M.bool])), M.func, M.object]),
  /**
   * The type of pagination item.
   * @default 'page'
   */
  type: M.oneOf(["end-ellipsis", "first", "last", "next", "page", "previous", "start-ellipsis"]),
  /**
   * The variant to use.
   * @default 'text'
   */
  variant: M.oneOfType([M.oneOf(["outlined", "text"]), M.string])
});
const s_e = ["boundaryCount", "className", "color", "count", "defaultPage", "disabled", "getItemAriaLabel", "hideNextButton", "hidePrevButton", "onChange", "page", "renderItem", "shape", "showFirstButton", "showLastButton", "siblingCount", "size", "variant"], l_e = (e) => {
  const {
    classes: t,
    variant: n
  } = e;
  return Pn({
    root: ["root", n],
    ul: ["ul"]
  }, J1e, t);
}, c_e = ct("nav", {
  name: "MuiPagination",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, t[n.variant]];
  }
})({}), u_e = ct("ul", {
  name: "MuiPagination",
  slot: "Ul",
  overridesResolver: (e, t) => t.ul
})({
  display: "flex",
  flexWrap: "wrap",
  alignItems: "center",
  padding: 0,
  margin: 0,
  listStyle: "none"
});
function d_e(e, t, n) {
  return e === "page" ? `${n ? "" : "Go to "}page ${t}` : `Go to ${e} page`;
}
const F5 = /* @__PURE__ */ B.forwardRef(function(t, n) {
  const r = xn({
    props: t,
    name: "MuiPagination"
  }), {
    boundaryCount: o = 1,
    className: i,
    color: a = "standard",
    count: s = 1,
    defaultPage: c = 1,
    disabled: l = !1,
    getItemAriaLabel: d = d_e,
    hideNextButton: f = !1,
    hidePrevButton: p = !1,
    renderItem: m = (R) => /* @__PURE__ */ z($5, ue({}, R)),
    shape: v = "circular",
    showFirstButton: g = !1,
    showLastButton: b = !1,
    siblingCount: x = 1,
    size: T = "medium",
    variant: S = "text"
  } = r, _ = ot(r, s_e), {
    items: w
  } = e_e(ue({}, r, {
    componentName: "Pagination"
  })), k = ue({}, r, {
    boundaryCount: o,
    color: a,
    count: s,
    defaultPage: c,
    disabled: l,
    getItemAriaLabel: d,
    hideNextButton: f,
    hidePrevButton: p,
    renderItem: m,
    shape: v,
    showFirstButton: g,
    showLastButton: b,
    siblingCount: x,
    size: T,
    variant: S
  }), E = l_e(k);
  return /* @__PURE__ */ z(c_e, ue({
    "aria-label": "pagination navigation",
    className: lt(E.root, i),
    ownerState: k,
    ref: n
  }, _, {
    children: /* @__PURE__ */ z(u_e, {
      className: E.ul,
      ownerState: k,
      children: w.map((R, P) => /* @__PURE__ */ z("li", {
        children: m(ue({}, R, {
          color: a,
          "aria-label": d(R.type, R.page, R.selected),
          shape: v,
          size: T,
          variant: S
        }))
      }, P))
    })
  }));
});
process.env.NODE_ENV !== "production" && (F5.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Number of always visible pages at the beginning and end.
   * @default 1
   */
  boundaryCount: Ti,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: M.object,
  /**
   * @ignore
   */
  className: M.string,
  /**
   * The active color.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'standard'
   */
  color: M.oneOfType([M.oneOf(["primary", "secondary", "standard"]), M.string]),
  /**
   * The total number of pages.
   * @default 1
   */
  count: Ti,
  /**
   * The page selected by default when the component is uncontrolled.
   * @default 1
   */
  defaultPage: Ti,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: M.bool,
  /**
   * Accepts a function which returns a string value that provides a user-friendly name for the current page.
   * This is important for screen reader users.
   *
   * For localization purposes, you can use the provided [translations](/material-ui/guides/localization/).
   * @param {string} type The link or button type to format ('page' | 'first' | 'last' | 'next' | 'previous' | 'start-ellipsis' | 'end-ellipsis'). Defaults to 'page'.
   * @param {number} page The page number to format.
   * @param {bool} selected If true, the current page is selected.
   * @returns {string}
   */
  getItemAriaLabel: M.func,
  /**
   * If `true`, hide the next-page button.
   * @default false
   */
  hideNextButton: M.bool,
  /**
   * If `true`, hide the previous-page button.
   * @default false
   */
  hidePrevButton: M.bool,
  /**
   * Callback fired when the page is changed.
   *
   * @param {React.ChangeEvent<unknown>} event The event source of the callback.
   * @param {number} page The page selected.
   */
  onChange: M.func,
  /**
   * The current page. Unlike `TablePagination`, which starts numbering from `0`, this pagination starts from `1`.
   */
  page: Ti,
  /**
   * Render the item.
   * @param {PaginationRenderItemParams} params The props to spread on a PaginationItem.
   * @returns {ReactNode}
   * @default (item) => <PaginationItem {...item} />
   */
  renderItem: M.func,
  /**
   * The shape of the pagination items.
   * @default 'circular'
   */
  shape: M.oneOf(["circular", "rounded"]),
  /**
   * If `true`, show the first-page button.
   * @default false
   */
  showFirstButton: M.bool,
  /**
   * If `true`, show the last-page button.
   * @default false
   */
  showLastButton: M.bool,
  /**
   * Number of always visible pages before and after the current page.
   * @default 1
   */
  siblingCount: Ti,
  /**
   * The size of the component.
   * @default 'medium'
   */
  size: M.oneOfType([M.oneOf(["small", "medium", "large"]), M.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: M.oneOfType([M.arrayOf(M.oneOfType([M.func, M.object, M.bool])), M.func, M.object]),
  /**
   * The variant to use.
   * @default 'text'
   */
  variant: M.oneOfType([M.oneOf(["outlined", "text"]), M.string])
});
function f_e(e) {
  return hn("MuiTooltip", e);
}
const Qa = un("MuiTooltip", ["popper", "popperInteractive", "popperArrow", "popperClose", "tooltip", "tooltipArrow", "touch", "tooltipPlacementLeft", "tooltipPlacementRight", "tooltipPlacementTop", "tooltipPlacementBottom", "arrow"]), p_e = ["arrow", "children", "classes", "components", "componentsProps", "describeChild", "disableFocusListener", "disableHoverListener", "disableInteractive", "disableTouchListener", "enterDelay", "enterNextDelay", "enterTouchDelay", "followCursor", "id", "leaveDelay", "leaveTouchDelay", "onClose", "onOpen", "open", "placement", "PopperComponent", "PopperProps", "slotProps", "slots", "title", "TransitionComponent", "TransitionProps"];
function h_e(e) {
  return Math.round(e * 1e5) / 1e5;
}
const m_e = (e) => {
  const {
    classes: t,
    disableInteractive: n,
    arrow: r,
    touch: o,
    placement: i
  } = e, a = {
    popper: ["popper", !n && "popperInteractive", r && "popperArrow"],
    tooltip: ["tooltip", r && "tooltipArrow", o && "touch", `tooltipPlacement${xt(i.split("-")[0])}`],
    arrow: ["arrow"]
  };
  return Pn(a, f_e, t);
}, g_e = ct(Hg, {
  name: "MuiTooltip",
  slot: "Popper",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.popper, !n.disableInteractive && t.popperInteractive, n.arrow && t.popperArrow, !n.open && t.popperClose];
  }
})(({
  theme: e,
  ownerState: t,
  open: n
}) => ue({
  zIndex: (e.vars || e).zIndex.tooltip,
  pointerEvents: "none"
}, !t.disableInteractive && {
  pointerEvents: "auto"
}, !n && {
  pointerEvents: "none"
}, t.arrow && {
  [`&[data-popper-placement*="bottom"] .${Qa.arrow}`]: {
    top: 0,
    marginTop: "-0.71em",
    "&::before": {
      transformOrigin: "0 100%"
    }
  },
  [`&[data-popper-placement*="top"] .${Qa.arrow}`]: {
    bottom: 0,
    marginBottom: "-0.71em",
    "&::before": {
      transformOrigin: "100% 0"
    }
  },
  [`&[data-popper-placement*="right"] .${Qa.arrow}`]: ue({}, t.isRtl ? {
    right: 0,
    marginRight: "-0.71em"
  } : {
    left: 0,
    marginLeft: "-0.71em"
  }, {
    height: "1em",
    width: "0.71em",
    "&::before": {
      transformOrigin: "100% 100%"
    }
  }),
  [`&[data-popper-placement*="left"] .${Qa.arrow}`]: ue({}, t.isRtl ? {
    left: 0,
    marginLeft: "-0.71em"
  } : {
    right: 0,
    marginRight: "-0.71em"
  }, {
    height: "1em",
    width: "0.71em",
    "&::before": {
      transformOrigin: "0 0"
    }
  })
})), v_e = ct("div", {
  name: "MuiTooltip",
  slot: "Tooltip",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.tooltip, n.touch && t.touch, n.arrow && t.tooltipArrow, t[`tooltipPlacement${xt(n.placement.split("-")[0])}`]];
  }
})(({
  theme: e,
  ownerState: t
}) => ue({
  backgroundColor: e.vars ? e.vars.palette.Tooltip.bg : Mn(e.palette.grey[700], 0.92),
  borderRadius: (e.vars || e).shape.borderRadius,
  color: (e.vars || e).palette.common.white,
  fontFamily: e.typography.fontFamily,
  padding: "4px 8px",
  fontSize: e.typography.pxToRem(11),
  maxWidth: 300,
  margin: 2,
  wordWrap: "break-word",
  fontWeight: e.typography.fontWeightMedium
}, t.arrow && {
  position: "relative",
  margin: 0
}, t.touch && {
  padding: "8px 16px",
  fontSize: e.typography.pxToRem(14),
  lineHeight: `${h_e(16 / 14)}em`,
  fontWeight: e.typography.fontWeightRegular
}, {
  [`.${Qa.popper}[data-popper-placement*="left"] &`]: ue({
    transformOrigin: "right center"
  }, t.isRtl ? ue({
    marginLeft: "14px"
  }, t.touch && {
    marginLeft: "24px"
  }) : ue({
    marginRight: "14px"
  }, t.touch && {
    marginRight: "24px"
  })),
  [`.${Qa.popper}[data-popper-placement*="right"] &`]: ue({
    transformOrigin: "left center"
  }, t.isRtl ? ue({
    marginRight: "14px"
  }, t.touch && {
    marginRight: "24px"
  }) : ue({
    marginLeft: "14px"
  }, t.touch && {
    marginLeft: "24px"
  })),
  [`.${Qa.popper}[data-popper-placement*="top"] &`]: ue({
    transformOrigin: "center bottom",
    marginBottom: "14px"
  }, t.touch && {
    marginBottom: "24px"
  }),
  [`.${Qa.popper}[data-popper-placement*="bottom"] &`]: ue({
    transformOrigin: "center top",
    marginTop: "14px"
  }, t.touch && {
    marginTop: "24px"
  })
})), b_e = ct("span", {
  name: "MuiTooltip",
  slot: "Arrow",
  overridesResolver: (e, t) => t.arrow
})(({
  theme: e
}) => ({
  overflow: "hidden",
  position: "absolute",
  width: "1em",
  height: "0.71em",
  boxSizing: "border-box",
  color: e.vars ? e.vars.palette.Tooltip.bg : Mn(e.palette.grey[700], 0.9),
  "&::before": {
    content: '""',
    margin: "auto",
    display: "block",
    width: "100%",
    height: "100%",
    backgroundColor: "currentColor",
    transform: "rotate(45deg)"
  }
}));
let Mp = !1;
const MR = new Ef();
let Vu = {
  x: 0,
  y: 0
};
function Rp(e, t) {
  return (n, ...r) => {
    t && t(n, ...r), e(n, ...r);
  };
}
const bx = /* @__PURE__ */ B.forwardRef(function(t, n) {
  var r, o, i, a, s, c, l, d, f, p, m, v, g, b, x, T, S, _, w;
  const k = xn({
    props: t,
    name: "MuiTooltip"
  }), {
    arrow: E = !1,
    children: R,
    components: P = {},
    componentsProps: A = {},
    describeChild: D = !1,
    disableFocusListener: N = !1,
    disableHoverListener: F = !1,
    disableInteractive: $ = !1,
    disableTouchListener: I = !1,
    enterDelay: j = 100,
    enterNextDelay: U = 0,
    enterTouchDelay: G = 700,
    followCursor: V = !1,
    id: H,
    leaveDelay: q = 0,
    leaveTouchDelay: Q = 1500,
    onClose: X,
    onOpen: K,
    open: J,
    placement: ne = "bottom",
    PopperComponent: ae,
    PopperProps: te = {},
    slotProps: le = {},
    slots: ce = {},
    title: fe,
    TransitionComponent: ee = Kd,
    TransitionProps: me
  } = k, oe = ot(k, p_e), ve = /* @__PURE__ */ B.isValidElement(R) ? R : /* @__PURE__ */ z("span", {
    children: R
  }), we = Lg(), ye = Zw(), [Ce, Se] = B.useState(), [Te, Ae] = B.useState(null), je = B.useRef(!1), Me = $ || V, ze = ac(), ft = ac(), Ue = ac(), Be = ac(), [Pe, Ee] = l5({
    controlled: J,
    default: !1,
    name: "Tooltip",
    state: "open"
  });
  let st = Pe;
  if (process.env.NODE_ENV !== "production") {
    const {
      current: Le
    } = B.useRef(J !== void 0);
    B.useEffect(() => {
      Ce && Ce.disabled && !Le && fe !== "" && Ce.tagName.toLowerCase() === "button" && console.error(["MUI: You are providing a disabled `button` child to the Tooltip component.", "A disabled element does not fire events.", "Tooltip needs to listen to the child element's events to display the title.", "", "Add a simple wrapper element, such as a `span`."].join(`
`));
    }, [fe, Ce, Le]);
  }
  const Vt = h0e(H), Ct = B.useRef(), Ne = Ja(() => {
    Ct.current !== void 0 && (document.body.style.WebkitUserSelect = Ct.current, Ct.current = void 0), Be.clear();
  });
  B.useEffect(() => Ne, [Ne]);
  const Ve = (Le) => {
    MR.clear(), Mp = !0, Ee(!0), K && !st && K(Le);
  }, ut = Ja(
    /**
     * @param {React.SyntheticEvent | Event} event
     */
    (Le) => {
      MR.start(800 + q, () => {
        Mp = !1;
      }), Ee(!1), X && st && X(Le), ze.start(we.transitions.duration.shortest, () => {
        je.current = !1;
      });
    }
  ), Ut = (Le) => {
    je.current && Le.type !== "touchstart" || (Ce && Ce.removeAttribute("title"), ft.clear(), Ue.clear(), j || Mp && U ? ft.start(Mp ? U : j, () => {
      Ve(Le);
    }) : Ve(Le));
  }, St = (Le) => {
    ft.clear(), Ue.start(q, () => {
      ut(Le);
    });
  }, {
    isFocusVisibleRef: Zn,
    onBlur: Cn,
    onFocus: an,
    ref: xr
  } = c5(), [, Vn] = B.useState(!1), An = (Le) => {
    Cn(Le), Zn.current === !1 && (Vn(!1), St(Le));
  }, kt = (Le) => {
    Ce || Se(Le.currentTarget), an(Le), Zn.current === !0 && (Vn(!0), Ut(Le));
  }, Tt = (Le) => {
    je.current = !0;
    const dn = ve.props;
    dn.onTouchStart && dn.onTouchStart(Le);
  }, Nt = (Le) => {
    Tt(Le), Ue.clear(), ze.clear(), Ne(), Ct.current = document.body.style.WebkitUserSelect, document.body.style.WebkitUserSelect = "none", Be.start(G, () => {
      document.body.style.WebkitUserSelect = Ct.current, Ut(Le);
    });
  }, Cr = (Le) => {
    ve.props.onTouchEnd && ve.props.onTouchEnd(Le), Ne(), Ue.start(Q, () => {
      ut(Le);
    });
  };
  B.useEffect(() => {
    if (!st)
      return;
    function Le(dn) {
      (dn.key === "Escape" || dn.key === "Esc") && ut(dn);
    }
    return document.addEventListener("keydown", Le), () => {
      document.removeEventListener("keydown", Le);
    };
  }, [ut, st]);
  const Xn = Kr(ve.ref, xr, Se, n);
  !fe && fe !== 0 && (st = !1);
  const mn = B.useRef(), Kn = (Le) => {
    const dn = ve.props;
    dn.onMouseMove && dn.onMouseMove(Le), Vu = {
      x: Le.clientX,
      y: Le.clientY
    }, mn.current && mn.current.update();
  }, Un = {}, Bt = typeof fe == "string";
  D ? (Un.title = !st && Bt && !F ? fe : null, Un["aria-describedby"] = st ? Vt : null) : (Un["aria-label"] = Bt ? fe : null, Un["aria-labelledby"] = st && !Bt ? Vt : null);
  const gt = ue({}, Un, oe, ve.props, {
    className: lt(oe.className, ve.props.className),
    onTouchStart: Tt,
    ref: Xn
  }, V ? {
    onMouseMove: Kn
  } : {});
  process.env.NODE_ENV !== "production" && (gt["data-mui-internal-clone-element"] = !0, B.useEffect(() => {
    Ce && !Ce.getAttribute("data-mui-internal-clone-element") && console.error(["MUI: The `children` component of the Tooltip is not forwarding its props correctly.", "Please make sure that props are spread on the same element that the ref is applied to."].join(`
`));
  }, [Ce]));
  const Zt = {};
  I || (gt.onTouchStart = Nt, gt.onTouchEnd = Cr), F || (gt.onMouseOver = Rp(Ut, gt.onMouseOver), gt.onMouseLeave = Rp(St, gt.onMouseLeave), Me || (Zt.onMouseOver = Ut, Zt.onMouseLeave = St)), N || (gt.onFocus = Rp(kt, gt.onFocus), gt.onBlur = Rp(An, gt.onBlur), Me || (Zt.onFocus = kt, Zt.onBlur = An)), process.env.NODE_ENV !== "production" && ve.props.title && console.error(["MUI: You have provided a `title` prop to the child of <Tooltip />.", `Remove this title prop \`${ve.props.title}\` or the Tooltip component.`].join(`
`));
  const ke = B.useMemo(() => {
    var Le;
    let dn = [{
      name: "arrow",
      enabled: !!Te,
      options: {
        element: Te,
        padding: 4
      }
    }];
    return (Le = te.popperOptions) != null && Le.modifiers && (dn = dn.concat(te.popperOptions.modifiers)), ue({}, te.popperOptions, {
      modifiers: dn
    });
  }, [Te, te]), gn = ue({}, k, {
    isRtl: ye,
    arrow: E,
    disableInteractive: Me,
    placement: ne,
    PopperComponentProp: ae,
    touch: je.current
  }), ir = m_e(gn), Jn = (r = (o = ce.popper) != null ? o : P.Popper) != null ? r : g_e, qn = (i = (a = (s = ce.transition) != null ? s : P.Transition) != null ? a : ee) != null ? i : Kd, Sn = (c = (l = ce.tooltip) != null ? l : P.Tooltip) != null ? c : v_e, Qn = (d = (f = ce.arrow) != null ? f : P.Arrow) != null ? d : b_e, er = nd(Jn, ue({}, te, (p = le.popper) != null ? p : A.popper, {
    className: lt(ir.popper, te == null ? void 0 : te.className, (m = (v = le.popper) != null ? v : A.popper) == null ? void 0 : m.className)
  }), gn), mr = nd(qn, ue({}, me, (g = le.transition) != null ? g : A.transition), gn), Ir = nd(Sn, ue({}, (b = le.tooltip) != null ? b : A.tooltip, {
    className: lt(ir.tooltip, (x = (T = le.tooltip) != null ? T : A.tooltip) == null ? void 0 : x.className)
  }), gn), Ye = nd(Qn, ue({}, (S = le.arrow) != null ? S : A.arrow, {
    className: lt(ir.arrow, (_ = (w = le.arrow) != null ? w : A.arrow) == null ? void 0 : _.className)
  }), gn);
  return /* @__PURE__ */ _e(B.Fragment, {
    children: [/* @__PURE__ */ B.cloneElement(ve, gt), /* @__PURE__ */ z(Jn, ue({
      as: ae != null ? ae : Hg,
      placement: ne,
      anchorEl: V ? {
        getBoundingClientRect: () => ({
          top: Vu.y,
          left: Vu.x,
          right: Vu.x,
          bottom: Vu.y,
          width: 0,
          height: 0
        })
      } : Ce,
      popperRef: mn,
      open: Ce ? st : !1,
      id: Vt,
      transition: !0
    }, Zt, er, {
      popperOptions: ke,
      children: ({
        TransitionProps: Le
      }) => /* @__PURE__ */ z(qn, ue({
        timeout: we.transitions.duration.shorter
      }, Le, mr, {
        children: /* @__PURE__ */ _e(Sn, ue({}, Ir, {
          children: [fe, E ? /* @__PURE__ */ z(Qn, ue({}, Ye, {
            ref: Ae
          })) : null]
        }))
      }))
    }))]
  });
});
process.env.NODE_ENV !== "production" && (bx.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, adds an arrow to the tooltip.
   * @default false
   */
  arrow: M.bool,
  /**
   * Tooltip reference element.
   */
  children: Xc.isRequired,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: M.object,
  /**
   * @ignore
   */
  className: M.string,
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */
  components: M.shape({
    Arrow: M.elementType,
    Popper: M.elementType,
    Tooltip: M.elementType,
    Transition: M.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `slotProps` prop.
   * It's recommended to use the `slotProps` prop instead, as `componentsProps` will be deprecated in the future.
   *
   * @default {}
   */
  componentsProps: M.shape({
    arrow: M.object,
    popper: M.object,
    tooltip: M.object,
    transition: M.object
  }),
  /**
   * Set to `true` if the `title` acts as an accessible description.
   * By default the `title` acts as an accessible label for the child.
   * @default false
   */
  describeChild: M.bool,
  /**
   * Do not respond to focus-visible events.
   * @default false
   */
  disableFocusListener: M.bool,
  /**
   * Do not respond to hover events.
   * @default false
   */
  disableHoverListener: M.bool,
  /**
   * Makes a tooltip not interactive, i.e. it will close when the user
   * hovers over the tooltip before the `leaveDelay` is expired.
   * @default false
   */
  disableInteractive: M.bool,
  /**
   * Do not respond to long press touch events.
   * @default false
   */
  disableTouchListener: M.bool,
  /**
   * The number of milliseconds to wait before showing the tooltip.
   * This prop won't impact the enter touch delay (`enterTouchDelay`).
   * @default 100
   */
  enterDelay: M.number,
  /**
   * The number of milliseconds to wait before showing the tooltip when one was already recently opened.
   * @default 0
   */
  enterNextDelay: M.number,
  /**
   * The number of milliseconds a user must touch the element before showing the tooltip.
   * @default 700
   */
  enterTouchDelay: M.number,
  /**
   * If `true`, the tooltip follow the cursor over the wrapped element.
   * @default false
   */
  followCursor: M.bool,
  /**
   * This prop is used to help implement the accessibility logic.
   * If you don't provide this prop. It falls back to a randomly generated id.
   */
  id: M.string,
  /**
   * The number of milliseconds to wait before hiding the tooltip.
   * This prop won't impact the leave touch delay (`leaveTouchDelay`).
   * @default 0
   */
  leaveDelay: M.number,
  /**
   * The number of milliseconds after the user stops touching an element before hiding the tooltip.
   * @default 1500
   */
  leaveTouchDelay: M.number,
  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   */
  onClose: M.func,
  /**
   * Callback fired when the component requests to be open.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   */
  onOpen: M.func,
  /**
   * If `true`, the component is shown.
   */
  open: M.bool,
  /**
   * Tooltip placement.
   * @default 'bottom'
   */
  placement: M.oneOf(["bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
  /**
   * The component used for the popper.
   * @default Popper
   */
  PopperComponent: M.elementType,
  /**
   * Props applied to the [`Popper`](/material-ui/api/popper/) element.
   * @default {}
   */
  PopperProps: M.object,
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slotProps: M.shape({
    arrow: M.object,
    popper: M.object,
    tooltip: M.object,
    transition: M.object
  }),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: M.shape({
    arrow: M.elementType,
    popper: M.elementType,
    tooltip: M.elementType,
    transition: M.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: M.oneOfType([M.arrayOf(M.oneOfType([M.func, M.object, M.bool])), M.func, M.object]),
  /**
   * Tooltip title. Zero-length titles string, undefined, null and false are never displayed.
   */
  title: M.node,
  /**
   * The component used for the transition.
   * [Follow this guide](/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @default Grow
   */
  TransitionComponent: M.elementType,
  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](https://reactcommunity.org/react-transition-group/transition/) component.
   */
  TransitionProps: M.object
});
const y_e = ({
  children: e,
  label: t,
  allowOpen: n,
  disabled: r,
  style: o,
  className: i = ""
}) => {
  const { themeSettings: a } = Yn(), s = it(null), c = it(null), [l, d] = Ge(!1), f = bt(() => {
    r || d(!0);
  }, [r]), p = bt(() => d(!1), []), m = bt(() => d(!0), []), v = bt(() => d(!1), []), g = l && n;
  return /* @__PURE__ */ _e("div", { ref: s, className: `csdk-menu-item ${i}`, children: [
    /* @__PURE__ */ z(
      lx,
      {
        disabled: r,
        sx: se({
          width: "100%",
          minWidth: "170px",
          height: "29px",
          minHeight: "29px",
          fontFamily: a.typography.fontFamily,
          fontSize: "13px",
          paddingLeft: "30px",
          paddingRight: "0px",
          color: "#5b6372",
          "&:hover": {
            backgroundColor: "#f4f4f8"
          }
        }, o),
        onMouseEnter: f,
        onMouseLeave: p,
        children: /* @__PURE__ */ _e(
          "div",
          {
            className: "csdk-menu-item-content",
            style: {
              width: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between"
            },
            children: [
              t,
              /* @__PURE__ */ z(Zbe, {})
            ]
          }
        )
      }
    ),
    /* @__PURE__ */ z(
      sx,
      {
        ref: c,
        style: { pointerEvents: "none" },
        anchorEl: s.current,
        anchorOrigin: {
          horizontal: "right",
          vertical: "top"
        },
        transformOrigin: {
          horizontal: "left",
          vertical: "top"
        },
        open: g,
        autoFocus: !1,
        disableAutoFocus: !0,
        disableEnforceFocus: !0,
        MenuListProps: {
          sx: {
            paddingTop: 0,
            paddingBottom: 0
          }
        },
        slotProps: {
          paper: {
            sx: {
              borderRadius: 0,
              border: "1px solid #bababa",
              boxShadow: "0 2px 4px 0 rgba(0,0,0,0.3)",
              fontFamily: a.typography.fontFamily
            }
          }
        },
        onClose: () => {
          d(!1);
        },
        onMouseEnter: m,
        onMouseLeave: v,
        children: /* @__PURE__ */ z("div", { style: { pointerEvents: "auto" }, children: e })
      }
    )
  ] });
}, __e = ({
  position: e,
  itemSections: t,
  children: n,
  closeContextMenu: r
}) => {
  const [o, i] = Ge(t), a = !!e;
  mt(() => {
    t && i(t);
  }, [t]);
  const s = bt(
    (c, l) => {
      const { sectionTitle: d, items: f = [] } = c;
      return /* @__PURE__ */ _e("div", { className: "csdk-menu-section", children: [
        d && /* @__PURE__ */ z(Ybe, { children: d }),
        f.map((p, m) => {
          const { subItems: v } = p;
          return v && v.length ? /* @__PURE__ */ z(
            y_e,
            {
              label: p.caption,
              allowOpen: a,
              style: p.style,
              className: p.class,
              children: v.map(s)
            },
            m
          ) : /* @__PURE__ */ z(
            Wbe,
            {
              disabled: p.disabled,
              style: p.style,
              className: p.class,
              onClick: () => {
                var b;
                r(), (b = p.onClick) == null || b.call(p);
              },
              children: p.caption
            },
            m
          );
        })
      ] }, l != null ? l : d);
    },
    [r, a]
  );
  return /* @__PURE__ */ z(fo, { children: /* @__PURE__ */ _e(hbe, { position: e != null ? e : null, open: a, onClose: r, children: [
    o == null ? void 0 : o.map(s),
    n
  ] }) });
}, w_e = ({ children: e, onBeforeMenuOpen: t }) => {
  const [n, r] = Ge(null), o = bt(
    (s) => {
      const c = t ? t(s) : s;
      c && r(c);
    },
    [t]
  ), i = bt(() => {
    r(null);
  }, []), a = We(() => ({
    openMenu: o,
    closeMenu: i
  }), [o, i]);
  return /* @__PURE__ */ _e(Gw.Provider, { value: a, children: [
    /* @__PURE__ */ z(
      __e,
      {
        position: n == null ? void 0 : n.position,
        itemSections: n == null ? void 0 : n.itemSections,
        closeContextMenu: i
      }
    ),
    e
  ] });
}, x_e = ({ children: e, onBeforeMenuOpen: t }) => {
  const n = Sg(), r = bt(
    (a) => {
      const s = t ? t(a) : a;
      s && (n == null || n.openMenu(s));
    },
    [t, n]
  ), o = bt(() => {
    n == null || n.closeMenu();
  }, [n]), i = {
    openMenu: r,
    closeMenu: o
  };
  return /* @__PURE__ */ z(Gw.Provider, { value: i, children: e });
}, C_e = ({ children: e, onBeforeMenuOpen: t }) => Sg() ? t ? /* @__PURE__ */ z(x_e, { onBeforeMenuOpen: t, children: e }) : /* @__PURE__ */ z(fo, { children: e }) : /* @__PURE__ */ z(w_e, { onBeforeMenuOpen: t, children: e }), S_e = ({ shouldHaveOwnMenuRoot: e } = {}) => (t) => function(r) {
  const i = !!Sg();
  return e && !i ? /* @__PURE__ */ z(C_e, { children: /* @__PURE__ */ z(t, se({}, r)) }) : /* @__PURE__ */ z(t, se({}, r));
}, T_e = (e) => (t) => (t.displayName = e, t), Jc = (e) => {
  const {
    componentName: t,
    shouldSkipSisenseContextWaiting: n,
    trackingConfig: r = {},
    customContextErrorMessageKey: o,
    shouldHaveOwnMenuRoot: i
  } = e;
  return (a) => N$(
    T_e(t),
    Jhe({
      shouldSkipSisenseContextWaiting: n,
      customContextErrorMessageKey: o
    }),
    Whe({ componentName: t, config: r }),
    Khe(),
    nme(),
    S_e({ shouldHaveOwnMenuRoot: i })
  )(a);
}, E_e = (e, t) => {
  const n = ge(se({}, e), {
    x: e.breakBy,
    breakBy: []
  });
  let r = tO(n, t);
  if (e.breakBy.some(
    ({ column: { type: i }, numberFormatConfig: a }) => is(i) && a
  )) {
    const i = r.xValues.map((a) => {
      const s = [];
      return e.breakBy.forEach(({ column: { type: c }, numberFormatConfig: l }, d) => {
        const f = Fc(l), p = a.xValues[d];
        is(c) ? s.push(
          as(f, parseFloat(p))
        ) : s.push(a.xValues[d]);
      }), ge(se({}, a), {
        xValues: s
      });
    });
    r = ge(se({}, r), {
      xValues: i
    });
  }
  return ge(se({}, r), {
    type: "categorical"
  });
}, Pp = (e, t) => {
  if (!t || t.length !== 1)
    return [void 0, void 0];
  const n = Mr(e, t[0].column.name);
  return n ? [Rr(e.rows[0], n), t[0].column.name] : [void 0, void 0];
}, k_e = (e, t) => {
  var s;
  const n = { type: "indicator" };
  if (!((s = e.value) != null && s.length) || t.rows.length === 0)
    return n;
  const [r] = Pp(t, e.value);
  if (r === void 0)
    return n;
  const [o] = Pp(t, e.secondary), [i] = Pp(t, e.min), [a] = Pp(t, e.max);
  return {
    type: "indicator",
    value: r,
    secondary: o,
    min: i,
    max: a
  };
}, M_e = (e, t) => {
  const n = e.category && Mr(t, e.category.column.name);
  n && (n.direction = A$(e.category.sortType));
  const r = D$(
    t,
    [],
    n ? [n] : [],
    (n == null ? void 0 : n.direction) === 0 ? $p : void 0
  ), o = I$(t.rows, n ? [n] : []), i = Mr(t, e.boxMin.column.name), a = Mr(t, e.boxMedian.column.name), s = Mr(t, e.boxMax.column.name), c = Mr(t, e.whiskerMin.column.name), l = Mr(t, e.whiskerMax.column.name), d = e.outliers && Mr(t, e.outliers.column.name), f = [], p = [];
  r.forEach((v, g) => {
    const b = o[v.key], x = b ? b[0] : [], T = n && !!nO(x, n);
    f.push({
      q1: i ? Rr(x, i) : 0,
      median: a ? Rr(x, a) : 0,
      q3: s ? Rr(x, s) : 0,
      low: c ? Rr(x, c) : 0,
      high: l ? Rr(x, l) : 0,
      blur: T
    });
    const S = d ? x[d.index].rawValue.split(",").map((_) => parseFloat(_)) : [];
    p.push(
      ...S.map(
        (_) => ({
          x: g,
          y: _,
          blur: T
        })
      )
    );
  });
  const m = [
    {
      name: e.valueTitle,
      title: e.valueTitle,
      data: f
    }
  ];
  return p.length > 0 && m.push({
    name: e.valueTitle,
    title: e.valueTitle,
    data: p
  }), {
    type: "boxplot",
    xValues: r,
    series: m
  };
};
function R_e(e) {
  return e.type === "boxplot";
}
const P_e = (e, t) => {
  let n = {
    type: "range",
    steps: e.steps
  };
  if (e.rangeMode !== "auto") {
    const a = parseFloat(`${e.minvalue}`), s = parseFloat(`${e.midvalue}`), c = parseFloat(`${e.maxvalue}`);
    n = se(se(se(se({}, n), a && { minValue: a }), s && { midValue: s }), c && { maxValue: c });
  }
  const r = ad(t, 0), o = hc(r, 0.2), i = hc(r, -0.2);
  switch (e.rangeMode) {
    case "auto":
      return ge(se({}, n), {
        minColor: F$(r),
        maxColor: i
      });
    case "both":
      return ge(se({}, n), {
        minColor: e.min || o,
        maxColor: e.max || i
      });
    case "min":
      return ge(se({}, n), {
        minColor: e.min || o,
        maxColor: BC
      });
    case "max":
      return ge(se({}, n), {
        minColor: BC,
        maxColor: e.max || i
      });
  }
}, j1 = (e, t) => {
  if (e !== void 0)
    switch (e.type) {
      case "color":
        return {
          type: "uniform",
          color: e.color || ad(t, e.colorIndex || 0)
        };
      case "range":
        return P_e(e, t);
      case "condition":
        return {
          type: "conditional",
          conditions: e.conditions.filter(
            (n) => typeof n.expression == "string"
          ),
          defaultColor: ad(t, 0)
        };
      default:
        return L$(ad(t, 0));
    }
}, jg = (e) => Object.entries(e).reduce((t, [n, { color: r }]) => (t[n] = r, t), {}), O_e = (e) => e.reduce((t, n) => {
  var r, o;
  return (r = n.format) != null && r.members && (t[$$(n.jaql.title)] = jg((o = n.format) == null ? void 0 : o.members)), t;
}, {}), N_e = rO({
  getValueFromDataStructure: (e) => e.originalValue,
  applyColorToDataStructure: (e, t) => ge(se({}, e), {
    color: t
  })
}), A_e = j1({
  type: "range",
  steps: 5,
  rangeMode: "auto"
}), D_e = (e, t) => {
  var a, s;
  const n = Mr(t, e.geo.column.name), r = Mr(
    t,
    (s = (a = e.color) == null ? void 0 : a.column.name) != null ? s : e.geo.column.name
  );
  if (!n || !r)
    throw new vt("errors.requiredColumnMissing");
  const o = t.rows.map((c) => {
    var p;
    const l = Rr(c, r), d = Fc((p = e.color) == null ? void 0 : p.numberFormatConfig), f = as(d, l);
    return {
      geoName: Rr(c, n),
      originalValue: l,
      formattedOriginalValue: f
    };
  });
  let i;
  return e.color && (i = N_e(
    o,
    e.color.color || A_e
  )), {
    type: "areamap",
    geoData: i || o
  };
};
function z5(e, t, n) {
  var r = -1, o = e.length;
  t < 0 && (t = -t > o ? 0 : o + t), n = n > o ? o : n, n < 0 && (n += o), o = t > n ? 0 : n - t >>> 0, t >>>= 0;
  for (var i = Array(o); ++r < o; )
    i[r] = e[r + t];
  return i;
}
function B5(e, t, n) {
  var r = e.length;
  return n = n === void 0 ? r : n, !t && n >= r ? e : z5(e, t, n);
}
function I_e(e, t, n, r) {
  for (var o = e.length, i = n + -1; ++i < o; )
    if (t(e[i], i, e))
      return i;
  return -1;
}
function L_e(e) {
  return e !== e;
}
function $_e(e, t, n) {
  for (var r = n - 1, o = e.length; ++r < o; )
    if (e[r] === t)
      return r;
  return -1;
}
function yx(e, t, n) {
  return t === t ? $_e(e, t, n) : I_e(e, L_e, n);
}
function F_e(e, t) {
  for (var n = e.length; n-- && yx(t, e[n], 0) > -1; )
    ;
  return n;
}
function z_e(e, t) {
  for (var n = -1, r = e.length; ++n < r && yx(t, e[n], 0) > -1; )
    ;
  return n;
}
function B_e(e) {
  return e.split("");
}
var H_e = "\\ud800-\\udfff", j_e = "\\u0300-\\u036f", W_e = "\\ufe20-\\ufe2f", V_e = "\\u20d0-\\u20ff", U_e = j_e + W_e + V_e, q_e = "\\ufe0e\\ufe0f", G_e = "\\u200d", Y_e = RegExp("[" + G_e + H_e + U_e + q_e + "]");
function H5(e) {
  return Y_e.test(e);
}
var j5 = "\\ud800-\\udfff", Z_e = "\\u0300-\\u036f", X_e = "\\ufe20-\\ufe2f", K_e = "\\u20d0-\\u20ff", J_e = Z_e + X_e + K_e, Q_e = "\\ufe0e\\ufe0f", ewe = "[" + j5 + "]", W1 = "[" + J_e + "]", V1 = "\\ud83c[\\udffb-\\udfff]", twe = "(?:" + W1 + "|" + V1 + ")", W5 = "[^" + j5 + "]", V5 = "(?:\\ud83c[\\udde6-\\uddff]){2}", U5 = "[\\ud800-\\udbff][\\udc00-\\udfff]", nwe = "\\u200d", q5 = twe + "?", G5 = "[" + Q_e + "]?", rwe = "(?:" + nwe + "(?:" + [W5, V5, U5].join("|") + ")" + G5 + q5 + ")*", owe = G5 + q5 + rwe, iwe = "(?:" + [W5 + W1 + "?", W1, V5, U5, ewe].join("|") + ")", awe = RegExp(V1 + "(?=" + V1 + ")|" + iwe + owe, "g");
function swe(e) {
  return e.match(awe) || [];
}
function U1(e) {
  return H5(e) ? swe(e) : B_e(e);
}
function lwe(e, t, n) {
  if (e = lf(e), e && (n || t === void 0))
    return z$(e);
  if (!e || !(t = B$(t)))
    return e;
  var r = U1(e), o = U1(t), i = z_e(r, o), a = F_e(r, o) + 1;
  return B5(r, i, a).join("");
}
var cwe = "[object Date]";
function uwe(e) {
  return sf(e) && xm(e) == cwe;
}
var RR = HC && HC.isDate, dwe = RR ? H$(RR) : uwe;
const fwe = (e, t = -1) => {
  var r, o, i;
  return [
    ...(r = e.rows) != null ? r : [],
    ...(o = e.columns) != null ? o : [],
    ...(i = e.values) != null ? i : []
  ][t];
}, pwe = (e) => {
  const t = e && "numberFormatConfig" in e ? e.numberFormatConfig : void 0;
  return Fc(t);
}, hwe = (e) => {
  const t = Wr(e), n = iO(t);
  return (t == null ? void 0 : t.dateFormat) || oO(n);
}, mwe = "N\\A", h$e = (e, t) => (n, r) => {
  var c, l;
  const o = (r == null ? void 0 : r.panel) === "measures", i = n.userType === qt.CORNER, a = fwe(e, (c = r == null ? void 0 : r.field) == null ? void 0 : c.index);
  if (o || i || !a) {
    n.content = n.value;
    return;
  }
  const s = hwe(a);
  switch ((l = r == null ? void 0 : r.jaql) == null ? void 0 : l.datatype) {
    case "numeric":
      n.content = as(
        pwe(a),
        parseFloat(`${n.value}`)
      );
      break;
    case "datetime":
      n.content = Y5(n.value, t, s);
      break;
    default:
      n.content = n.value;
  }
  n.content === "" && (n.content = mwe);
};
function Y5(e, t, n) {
  if (!n)
    return e;
  const r = aO(e);
  return gwe(r) ? e : t(r, n);
}
function gwe(e) {
  return e.toString() === "Invalid Date";
}
function rr(e) {
  const t = "type" in e.column ? e.column.type : "numeric";
  let n = (r) => `${r}`;
  if (is(t)) {
    const r = Fc(
      e && "numberFormatConfig" in e ? e.numberFormatConfig : void 0
    );
    n = (o) => as(r, parseFloat(`${o}`));
  }
  if (dh(t)) {
    const r = e.dateFormat || oO(iO(e)), o = (i, a) => Bw(i, a);
    n = (i) => Y5(dwe(i) ? i.toISOString() : i, o, r);
  }
  return (r) => r === void 0 ? "" : n(r);
}
function zt(e, t) {
  return se(se({
    id: e,
    dataOption: t
  }, ci.isAttribute(t.column) && {
    attribute: t.column
  }), ci.isMeasure(t.column) && {
    measure: t.column
  });
}
const Wg = (e) => {
  var t, n, r, o, i, a, s, c;
  return {
    value: (t = e.custom) == null ? void 0 : t.rawValue,
    categoryValue: (r = (n = e.custom) == null ? void 0 : n.xValue) == null ? void 0 : r[0],
    seriesValue: (s = (a = (i = (o = e.series) == null ? void 0 : o.options) == null ? void 0 : i.custom) == null ? void 0 : a.rawValue) == null ? void 0 : s[0],
    categoryDisplayValue: (c = e.name) != null ? c : e.category
  };
}, vwe = (e, t) => {
  const n = t.x.map((s, c) => {
    var d, f;
    const l = (f = (d = e.custom) == null ? void 0 : d.xValue) == null ? void 0 : f[c];
    return ge(se({}, zt(`category.${c}`, s)), {
      value: l,
      displayValue: rr(s)(l)
    });
  }), r = t.y.length >= 2, o = t.y.filter((s, c) => !r || e.series.index === c).flatMap((s) => {
    var l;
    const c = (l = e.custom) == null ? void 0 : l.rawValue;
    return ge(se({}, zt(`value.${e.series.index}`, s)), {
      value: c,
      displayValue: rr(s)(c)
    });
  }), i = t.breakBy.map((s, c) => {
    var d, f, p;
    const l = (p = (f = (d = e.series) == null ? void 0 : d.options.custom) == null ? void 0 : f.rawValue) == null ? void 0 : p[0];
    return ge(se({}, zt(`breakBy.${c}`, s)), {
      value: l,
      displayValue: rr(s)(l)
    });
  }), a = {
    category: n,
    value: o,
    breakBy: i
  };
  return ge(se({}, Wg(e)), {
    entries: a
  });
}, bwe = (e, t) => {
  const n = t.x.map((s, c) => {
    var d, f;
    const l = (f = (d = e.custom) == null ? void 0 : d.xValue) == null ? void 0 : f[c];
    return ge(se({}, zt(`category.${c}`, s)), {
      value: l,
      displayValue: rr(s)(l)
    });
  }), r = t.rangeValues.length >= 2, o = t.rangeValues.filter((s, c) => !r || e.series.index === c).flatMap((s) => s.map((c, l) => {
    var m, v;
    const d = l === 0, f = `value.${e.series.index}.${d ? "lowerBound" : "upperBound"}`, p = d ? (m = e.options) == null ? void 0 : m.low : (v = e.options) == null ? void 0 : v.high;
    return ge(se({}, zt(f, c)), {
      value: p,
      displayValue: rr(c)(p)
    });
  })), i = t.breakBy.map((s, c) => {
    var d, f, p;
    const l = (p = (f = (d = e.series) == null ? void 0 : d.options.custom) == null ? void 0 : f.rawValue) == null ? void 0 : p[0];
    return ge(se({}, zt(`breakBy.${c}`, s)), {
      value: l,
      displayValue: rr(s)(l)
    });
  }), a = {
    category: n,
    value: o,
    breakBy: i
  };
  return ge(se({}, Wg(e)), {
    entries: a
  });
}, ywe = (e, t) => {
  var r, o, i, a, s;
  const n = {};
  if (t.x) {
    const c = e.custom.maskedX;
    n.x = ge(se({}, zt("x", t.x)), {
      value: c,
      // todo: add formatter after fixing scatter option to contain raw value.
      displayValue: c
    });
  }
  if (t.y) {
    const c = e.custom.maskedY;
    n.y = ge(se({}, zt("y", t.y)), {
      value: c,
      displayValue: c
    });
  }
  if (t.breakByPoint) {
    const c = (r = e.custom) == null ? void 0 : r.maskedBreakByPoint;
    n.breakByPoint = ge(se({}, zt("breakByPoint", t.breakByPoint)), {
      value: (o = e.custom) == null ? void 0 : o.maskedBreakByPoint,
      displayValue: c
    });
  }
  if (t.breakByColor) {
    const c = (i = e.custom) == null ? void 0 : i.maskedBreakByColor;
    n.breakByColor = ge(se({}, zt("breakByColor", t.breakByColor)), {
      value: c,
      displayValue: c
    });
  }
  if (t.size) {
    const c = e.custom.maskedSize;
    n.size = ge(se({}, zt("size", t.size)), {
      value: c,
      displayValue: c
    });
  }
  return {
    x: e.x,
    y: e.y,
    size: e.z,
    breakByPoint: (a = e.custom) == null ? void 0 : a.maskedBreakByPoint,
    breakByColor: (s = e.custom) == null ? void 0 : s.maskedBreakByColor,
    entries: n
  };
}, _we = (e, t) => {
  const n = t.breakBy.map((i, a) => {
    var c, l;
    const s = (l = (c = e.custom) == null ? void 0 : c.xValue) == null ? void 0 : l[a];
    return ge(se({}, zt(`category.${a}`, i)), {
      value: s,
      displayValue: rr(i)(s)
    });
  }), r = t.y.map((i, a) => {
    var c;
    const s = (c = e.custom) == null ? void 0 : c.rawValue;
    return ge(se({}, zt(`value.${a}`, i)), {
      value: s,
      displayValue: rr(i)(s)
    });
  }), o = {
    category: n,
    value: r
  };
  return {
    value: e.options.custom.number1,
    categoryValue: e.options.name,
    categoryDisplayValue: e.name,
    entries: o
  };
}, wwe = (e, t) => {
  const n = t.breakBy.map((a, s) => {
    var l, d;
    const c = (d = (l = e.custom) == null ? void 0 : l.xValue) == null ? void 0 : d[s];
    return ge(se({}, zt(`category.${s}`, a)), {
      value: c,
      displayValue: rr(a)(c)
    });
  }), r = t.y.length >= 2, o = t.y.filter((a, s) => !r || e.series.index === s).map((a, s) => {
    var l;
    const c = (l = e.custom) == null ? void 0 : l.rawValue;
    return ge(se({}, zt(`value.${s}`, a)), {
      value: c,
      displayValue: rr(a)(c)
    });
  }), i = {
    category: n,
    value: o
  };
  return ge(se({}, Wg(e)), {
    entries: i
  });
}, xwe = (e, t) => {
  const n = e.options.custom.level, r = n !== e.options.custom.levelsCount, o = t.breakBy.slice(0, n).map((c, l) => {
    var f, p, m, v;
    const d = r ? (p = (f = e.custom) == null ? void 0 : f.rawValues) == null ? void 0 : p[l] : (v = (m = e.custom) == null ? void 0 : m.xValue) == null ? void 0 : v[l];
    return ge(se({}, zt(`category.${l}`, c)), {
      value: d,
      // todo: add formatter after fixing formatting on chart UI level. Currently it aligned.
      displayValue: d
    });
  }), i = t.y.length >= 2, a = t.y.filter((c, l) => !i || e.series.index === l).map((c, l) => {
    var f;
    const d = r ? e.value : (f = e.custom) == null ? void 0 : f.rawValue;
    return ge(se({}, zt(`value.${l}`, c)), {
      value: d,
      displayValue: rr(c)(d)
    });
  }), s = {
    category: o,
    value: a
  };
  return ge(se({}, Wg(e)), {
    entries: s
  });
}, Cwe = (e, t) => {
  var o;
  const n = e.series.type === "scatter", r = {};
  if (n) {
    const i = e.options.y;
    r.value = [
      ge(se({}, zt("value.0.outlier", t.outliers)), {
        value: i,
        displayValue: rr(t.outliers)(i)
      })
    ];
  } else
    r.value = [
      ge(se({}, zt("value.0.boxMin", t.boxMin)), {
        value: e.options.q1,
        displayValue: rr(t.boxMin)(e.options.q1)
      }),
      ge(se({}, zt("value.0.boxMedian", t.boxMedian)), {
        value: e.options.median,
        displayValue: rr(t.boxMedian)(e.options.median)
      }),
      ge(se({}, zt("value.0.boxMax", t.boxMax)), {
        value: e.options.q3,
        displayValue: rr(t.boxMax)(e.options.q3)
      }),
      ge(se({}, zt("value.0.whiskerMin", t.whiskerMin)), {
        value: e.options.low,
        displayValue: rr(t.whiskerMin)(e.options.low)
      }),
      ge(se({}, zt("value.0.whiskerMax", t.whiskerMax)), {
        value: e.options.high,
        displayValue: rr(t.whiskerMax)(e.options.high)
      })
    ];
  if (t.category) {
    const i = (o = e.custom.xValue) == null ? void 0 : o[0];
    r.category = [
      ge(se({}, zt("category.0", t.category)), {
        value: i,
        displayValue: rr(t.category)(i)
      })
    ];
  }
  return {
    boxMin: e.options.q1,
    boxMedian: e.options.median,
    boxMax: e.options.q3,
    whiskerMin: e.options.low,
    whiskerMax: e.options.high,
    outlier: e.options.y,
    categoryValue: e.category,
    categoryDisplayValue: e.category,
    entries: r
  };
};
function db(e, t) {
  switch (e.series.chart.options.chart.type) {
    case "bubble":
    case "scatter":
      return ywe(e, t);
    case "funnel":
      return _we(e, t);
    case "pie":
      return wwe(e, t);
    case "treemap":
    case "sunburst":
      return xwe(e, t);
    case "boxplot":
      return Cwe(e, t);
    case "arearange":
      return bwe(e, t);
    default:
      return vwe(e, t);
  }
}
const Z5 = ",";
function Swe(e) {
  return e.join(`${Z5} `);
}
function Twe(e) {
  return e.split(Z5).map(lwe);
}
function Ewe(e) {
  switch (e) {
    case "city":
      return "city";
    case "state":
      return "adm";
    case "country":
      return "country";
  }
}
function kwe(e, t) {
  const { name: n, rawName: r, coordinates: o, value: i, colorValue: a, details: s } = e, l = {
    geo: t.locations.map((d, f) => ge(se({}, zt(`geo.${f}`, d)), {
      value: r[f]
    }))
  };
  if (t.size && (l.size = ge(se({}, zt("size", t.size)), {
    value: i
  })), t.colorBy && (l.colorBy = ge(se({}, zt("colorBy", t.colorBy)), {
    value: a
  })), t.details) {
    const d = zt("details", t.details);
    d.measure && (l.details = ge(se({}, d), {
      value: s
    }));
  }
  return {
    categories: r,
    displayName: n,
    coordinates: {
      lat: o.lat,
      lng: o.lng
    },
    value: i,
    entries: l
  };
}
const Mwe = "N\\A", Rwe = 1, Pwe = (e, t) => {
  const n = Owe(e), r = e.locations && v_(
    t,
    e.locations.map(({ column: { name: c } }) => c)
  ), o = e.size && Mr(t, e.size.column.name), i = e.colorBy && Mr(t, e.colorBy.column.name), a = e.details && Mr(t, e.details.column.name);
  return {
    type: "scattermap",
    locations: t.rows.filter((c) => r.some((l) => Rr(c, l) !== Mwe)).map((c) => {
      const l = r.map((m) => Rr(c, m)), d = Swe(l);
      let f;
      n && (f = {
        lat: Rr(c, r[0]),
        lng: Rr(c, r[1])
      });
      const p = r[0] && !!nO(c, r[0]);
      return se(ge(se(se({
        name: d,
        rawName: l,
        value: o ? Rr(c, o) : Rwe
      }, i && { colorValue: Rr(c, i) }), a && { details: Rr(c, a) }), {
        blur: p
      }), f ? { coordinates: f } : null);
    })
  };
};
function Owe(e) {
  return e.locations.length === 2 && e.locations.filter(({ column: { type: t } }) => is(t)).length === 2;
}
const Nwe = (e, t, n) => {
  if (_a(e))
    return j$(t) ? W$(
      t,
      n
    ) : tO(t, n);
  if (zc(e))
    return E_e(t, n);
  if (ca(e))
    return V$(t, n);
  if (Bc(e))
    return Pwe(t, n);
  if (Cm(e))
    return k_e(
      t,
      n
    );
  if (il(e))
    return M_e(t, n);
  if (Hc(e))
    return D_e(
      t,
      n
    );
  if (jc(e))
    return U$(t, n);
  throw new vt("errors.unexpectedChartType", { chartType: e });
};
function Awe(e, t) {
  var n = e == null ? 0 : e.length;
  return !!n && yx(e, t, 0) > -1;
}
var Dwe = 1 / 0, Iwe = Cv && 1 / sO(new Cv([, -0]))[1] == Dwe ? function(e) {
  return new Cv(e);
} : q$, Lwe = 200;
function X5(e, t, n) {
  var r = -1, o = Awe, i = e.length, a = !0, s = [], c = s;
  if (i >= Lwe) {
    var l = t ? null : Iwe(e);
    if (l)
      return sO(l);
    a = !1, o = Y$, c = new G$();
  } else
    c = t ? [] : s;
  e:
    for (; ++r < i; ) {
      var d = e[r], f = t ? t(d) : d;
      if (d = d !== 0 ? d : 0, a && f === f) {
        for (var p = c.length; p--; )
          if (c[p] === f)
            continue e;
        t && c.push(f), s.push(d);
      } else
        o(c, f, n) || (c !== s && c.push(f), s.push(d));
    }
  return s;
}
function $we(e) {
  return sf(e) && g_(e);
}
var Fwe = lO(function(e) {
  return X5(Z$(e, 1, $we, !0));
});
const K5 = (e, t, n, r = {}) => {
  if (cO(e))
    return { rows: [], columns: [] };
  const o = Fwe(
    v_(
      e,
      t.map((d) => d.name)
    )
  ), i = e, s = [
    ...n.map((d) => {
      var f, p;
      return {
        // uses original data column name
        column: (f = r[d.name]) != null ? f : d.name,
        title: d.name,
        agg: (p = d.aggregation) != null ? p : "sum"
        // only simple aggregations
      };
    }),
    { column: $p, title: $p, agg: "min" }
  ], c = X$(i, o, s), l = Mr(c, $p);
  if (!l)
    throw new vt("errors.noRowNumColumn");
  return uO(c, [l]);
};
class Pf {
  /**
   * Converts degrees to radians.
   *
   * @param {number} angle
   * @returns {number}
   */
  degToRad(t) {
    return t * Math.PI / 180;
  }
  /**
   * Returns fit string measure.
   *
   * @param {object} ctx
   * @param {string} string
   * @param {number} maxWidth
   * @param {string} font
   * @returns {object}
   */
  getFitStringMeasure(t, n, r, o) {
    t.font = o;
    let i = this.getStringWidth(t, n);
    const a = "…", s = this.getStringWidth(t, a);
    if (i <= r)
      return {
        string: n,
        width: i
      };
    if (s >= r)
      return {
        string: a,
        width: s
      };
    do
      n = n.slice(0, n.length - 1), i = this.getStringWidth(t, n);
    while (i + s > r);
    return {
      string: n + a,
      width: i + s
    };
  }
  /**
   * Returns string width.
   *
   * @param {object} ctx
   * @param {string} string
   * @returns {number}
   */
  getStringWidth(t, n) {
    return Math.ceil(t.measureText(n).width);
  }
  /**
   * Rounds a number downward to its nearest integer with specified number of decimals.
   *
   * @param {number} value
   * @param {number} decimals
   * @returns {number}
   */
  floor(t, n) {
    n = typeof n == "number" ? n : 0;
    const r = Math.pow(10, n);
    return Math.round(t * r) / r;
  }
  /**
   * Sets canvas width and height considering device pixel ratio.
   *
   * @param {HTMLElement} canvas
   * @param {CanvasRenderingContext2D} ctx
   * @param {number} width
   * @param {number} height
   */
  setCanvasSizes(t, n, r, o) {
    const i = window.devicePixelRatio || 1;
    t.width = r * i, t.height = o * i, t.style.width = r + "px", t.style.height = o + "px", n.scale(i, i);
  }
}
const Zl = new Pf(), Os = function(e, t) {
  return Zl.floor(e * t.value, t.decimals);
};
function zwe(e, t) {
  const n = {};
  return e.forEach((r) => {
    t.some(function(o) {
      return o.key === r ? (n[r] = o, !0) : !1;
    });
  }), n;
}
function Bwe(e, t, n) {
  const { showTitle: r, showSecondary: o, skin: i, maxHeight: a, maxWidth: s, borderWidth: c } = n;
  for (let l = 0; l < t.length; l++) {
    const d = t[l], f = d.value, p = Os(f, e.valueSectionMarginBottom), v = Os(f, e.indicatorVerticalMargin) * 2;
    let g = f + p + v;
    if (r && i === "vertical") {
      const b = Os(f, e.titleSectionHeight);
      g += b;
    }
    if (o) {
      const b = Os(f, e.secSectionHeight), x = Os(f, e.secSectionMarginTop);
      g += b + x + (c || 0);
    }
    if (g <= a) {
      const b = Os(f, e.numericMinWidth), T = Os(f, e.indicatorHorizontalMargin) * 2;
      if (b + T <= s)
        return ge(se({}, d), {
          maxWidth: s - T,
          maxHeight: a - v
        });
    }
  }
  return null;
}
class Hwe {
  /**
   * Returns base measure data.
   *
   * @param {object} data
   * @param {object} options
   * @param {HTMLElement} container
   * @returns {BaseMeasure|null}
   */
  getBaseMeasure(t, n, r) {
    const o = n, i = "sizes" in o ? o.sizes : [], a = o.relativeSizes, s = o.measureKeys.concat(), c = Math.floor(r.clientWidth), l = Math.floor(r.clientHeight), d = zwe(
      s,
      a
    );
    return Bwe(d, i, {
      maxWidth: c,
      maxHeight: l,
      showTitle: t.showTitle,
      showSecondary: t.showSecondary,
      skin: t.skin,
      borderWidth: "borderWidth" in o ? o.borderWidth : 0
    });
  }
  /**
   * Renders indicator numeric simple widget.
   *
   * @param canvas
   * @param data
   * @param options
   * @param baseMeasure
   */
  render(t, n, r, o) {
    const i = t.getContext("2d");
    let a;
    r.height = o.value, r.maxWidth = o.maxWidth, r.maxHeight = o.maxHeight, a = r.height, r.fitValueMeasure = this.getFitValueMeasure(i, n, r), n.showTitle && (r.fitTitleMeasure = this.getFitTitleMeasure(i, n, r), a += n.skin === "vertical" ? r.titleSectionHeight : 0), n.showSecondary && (r.fitSecondaryMeasure = this.getFitSecondaryMeasure(i, n, r), a += r.valueSectionMarginBottom + r.secSectionHeight + r.secSectionMarginTop + r.borderWidth);
    const s = this.getCanvasWidth(n, r);
    r.width = s, r.height = a, Zl.setCanvasSizes(t, i, s, a), this.draw(i, n, r);
  }
  /**
   * Returns fit title measure data.
   *
   * @param ctx
   * @param data
   * @param options
   */
  getFitTitleMeasure(t, n, r) {
    const o = n.skin === "horizontal", i = r.maxWidth - (o ? r.fitValueMeasure.width + r.valueSectionMarginRight : 0);
    if (o && i + r.titleSectionMinWidth <= 0)
      return;
    const a = Zl.getFitStringMeasure(
      t,
      n.title.text,
      i,
      r.titleFont
    );
    return a.width += o ? r.valueSectionMarginRight : 0, a.key = "title", a;
  }
  /**
   * Returns fit value measure data.
   *
   * @param ctx
   * @param data
   * @param options
   */
  getFitValueMeasure(t, n, r) {
    const o = Zl.getFitStringMeasure(
      t,
      n.value.text,
      r.maxWidth,
      r.valueFont
    );
    return o.key = "value", o;
  }
  /**
   * Returns fit value measure data.
   *
   * @param ctx
   * @param data
   * @param options
   */
  getFitSecondaryMeasure(t, n, r) {
    const o = r.secDividerWidth, i = r.maxWidth - o, a = i - r.secTitleMinWidth, s = Zl.getFitStringMeasure(
      t,
      n.secondary.text,
      a,
      r.secondaryValueFont
    ), c = i - s.width, l = Zl.getFitStringMeasure(
      t,
      n.secondaryTitle.text,
      c,
      r.secondaryTitleFont
    );
    return {
      width: l.width + s.width + o,
      titleString: l.string,
      valueString: s.string,
      key: "secondary"
    };
  }
  /**
   * Returns canvas width.
   *
   * @param data
   * @param options
   */
  getCanvasWidth(t, n) {
    let r;
    const o = n.fitTitleMeasure, i = n.fitValueMeasure, a = n.fitSecondaryMeasure;
    if (n.fitMeasures.some(
      (c) => {
        const l = n[c.key], d = t[c.dataKey];
        return !!(l && d && l[c.prop] !== d.text);
      }
    ))
      return n.maxWidth;
    if (t.skin === "vertical") {
      let l = o && o.width > i.width ? o : i;
      l = a && a.width > l.width ? a : l, r = l.width;
    } else
      r = i.width, o && (r += o.width), a && a.width > r && (r = a.width);
    return r;
  }
  /**
   * Draws indicator numeric bar widget.
   *
   * @param ctx
   * @param data
   * @param options
   */
  draw(t, n, r) {
    this.clearCanvas(t, r), this.drawValue(t, n, r), n.showTitle && this.drawTitle(t, n, r), n.showSecondary && this.drawSecondary(t, r);
  }
  /**
   * Clears the canvas.
   *
   * @param ctx
   * @param options
   */
  clearCanvas(t, n) {
    t.fillStyle = n.backgroundColor, t.fillRect(0, 0, n.width, n.height);
  }
  /**
   * Draws the title section.
   *
   * @param ctx
   * @param data
   * @param options
   */
  drawTitle(t, n, r) {
    !r.fitTitleMeasure || n.skin === "horizontal" && r.fitValueMeasure.string !== n[r.fitValueMeasure.key].text || (t.font = r.titleFont, t.fillStyle = r.titleColor, n.skin === "vertical" ? (t.textAlign = "center", t.textBaseline = "middle", t.fillText(
      r.fitTitleMeasure.string,
      r.width / 2,
      r.titleSectionHeight / 2
    )) : (t.textAlign = "left", t.textBaseline = "top", t.fillText(
      r.fitTitleMeasure.string,
      r.fitValueMeasure.width + r.valueSectionMarginRight,
      r.titleSectionMarginTop
    )));
  }
  /**
   * Draws the value section.
   *
   * @param ctx
   * @param data
   * @param options
   */
  drawValue(t, n, r) {
    const o = n.skin === "vertical";
    t.fillStyle = r.valueColor || n.color, t.font = r.valueFont, t.textAlign = o ? "center" : "left", t.textBaseline = "middle", t.fillText(
      r.fitValueMeasure.string,
      o ? r.width / 2 : 0,
      (n.showTitle && o ? r.titleSectionHeight : 0) + r.valueSectionHeight / 2
    );
  }
  /**
   * Draws the secondary section.
   *
   * @param ctx
   * @param options
   */
  drawSecondary(t, n) {
    let r = n.height - n.secSectionHeight / 2;
    t.font = n.secondaryTitleFont, t.fillStyle = n.secondaryTitleColor, t.textAlign = "left", t.textBaseline = "middle", t.fillText(n.fitSecondaryMeasure.titleString, 0, r), t.font = n.secondaryValueFont, t.fillStyle = n.secondaryValueColor, t.textAlign = "right", t.fillText(n.fitSecondaryMeasure.valueString, n.width, r), t.strokeStyle = n.borderColor, t.beginPath(), r = n.height - n.secSectionHeight - n.secSectionMarginTop - n.borderWidth, t.moveTo(0, r), t.lineTo(n.width, r), t.stroke();
  }
}
const Xl = new Pf(), Op = function(e, t) {
  return Xl.floor(e * t.value, t.decimals);
};
function jwe(e, t) {
  const n = {};
  return e.forEach((r) => {
    t.some(function(o) {
      return o.key === r ? (n[r] = o, !0) : !1;
    });
  }), n;
}
function Wwe(e, t, n) {
  const { showTitle: r, showSecondary: o, maxHeight: i, maxWidth: a, bracketThickness: s } = n;
  for (let c = 0; c < t.length; c++) {
    const l = t[c], d = l.value, f = Op(d, e.indicatorMargin);
    let p = d + f;
    if (r) {
      const m = Op(d, e.titleSectionHeight);
      p += m;
    }
    if (o) {
      const m = Op(d, e.secSectionHeight);
      p += m;
    }
    if (p <= i) {
      const m = Op(d, e.numericMinWidth), v = f * 2;
      if (m + s * 2 + v <= a)
        return ge(se({}, l), {
          maxWidth: a - v,
          maxHeight: i - f
        });
    }
  }
  return null;
}
class Vwe {
  /**
   * Returns base measure data.
   *
   * @param {object} data
   * @param {object} options
   * @param {HTMLElement} container
   * @returns {BaseMeasure|null}
   */
  getBaseMeasure(t, n, r) {
    const o = n, i = "sizes" in o ? o.sizes : [], a = o.relativeSizes, s = o.measureKeys.concat(), c = Math.floor(r.clientWidth), l = Math.floor(r.clientHeight), d = jwe(
      s,
      a
    );
    return Wwe(d, i, {
      maxWidth: c,
      maxHeight: l,
      showTitle: t.showTitle,
      showSecondary: t.showSecondary,
      bracketThickness: o.bracketThickness
    });
  }
  /**
   * Renders indicator numeric bar widget.
   *
   * @param canvas
   * @param data
   * @param options
   * @param baseMeasure
   */
  render(t, n, r, o) {
    const i = t.getContext("2d");
    let a;
    r.height = o.value, r.maxWidth = o.maxWidth, r.maxHeight = o.maxHeight, r.offsetY = 0, a = r.height, n.showTitle && (r.fitTitleMeasure = this.getFitTitleMeasure(i, n, r), a += r.titleSectionHeight), r.fitValueMeasure = this.getFitValueMeasure(i, n, r), n.showSecondary && (r.fitSecondaryMeasure = this.getFitSecondaryMeasure(i, n, r), a += r.secSectionHeight);
    const s = this.getCanvasWidth(n, r);
    r.width = s, r.height = a, Xl.setCanvasSizes(t, i, s, a), this.draw(i, n, r);
  }
  /**
   * Returns fit title measure data.
   *
   * @param ctx
   * @param data
   * @param options
   */
  getFitTitleMeasure(t, n, r) {
    const o = r.bracketWidth * 2 + r.titleHorizontalMargin * 2, i = r.maxWidth - o, a = Xl.getFitStringMeasure(
      t,
      n.title.text,
      i,
      r.titleFont
    );
    return a.width += o, a.key = "title", a;
  }
  /**
   * Returns fit value measure data.
   *
   * @param ctx
   * @param data
   * @param options
   */
  getFitValueMeasure(t, n, r) {
    const o = r.bracketThickness * 2, i = r.maxWidth - o, a = Xl.getFitStringMeasure(
      t,
      n.value.text,
      i,
      r.valueFont
    );
    return a.width += o, a.key = "value", a;
  }
  /**
   * Returns fit value measure data.
   *
   * @param ctx
   * @param data
   * @param options
   */
  getFitSecondaryMeasure(t, n, r) {
    const o = r.bracketWidth * 2 + r.secDividerWidth, i = r.maxWidth - o, a = i - r.secTitleMinWidth, s = Xl.getFitStringMeasure(
      t,
      n.secondary.text,
      a,
      r.secondaryValueFont
    ), c = i - s.width, l = Xl.getFitStringMeasure(
      t,
      n.secondaryTitle.text,
      c,
      r.secondaryTitleFont
    );
    return {
      width: l.width + s.width + o,
      titleString: l.string,
      valueString: s.string,
      key: "secondary"
    };
  }
  /**
   * Returns canvas width.
   *
   * @param data
   * @param options
   */
  getCanvasWidth(t, n) {
    let r = n.numericMinWidth + n.bracketThickness * 2;
    const o = n.fitTitleMeasure, i = n.fitValueMeasure;
    let s = o && o.width > i.width ? o : i;
    const c = n.fitSecondaryMeasure, l = c && c.width > s.width;
    let d;
    return s = l ? c : s, l ? d = s.titleString !== t.secondaryTitle.text || s.valueString !== t.secondary.text : d = s.string !== t[s.key].text, d ? r = n.maxWidth : s.width > r && (r = s.width), r;
  }
  /**
   * Draws indicator numeric bar widget.
   *
   * @param ctx
   * @param data
   * @param options
   */
  draw(t, n, r) {
    this.clearCanvas(t, r), n.showTitle && this.drawTitle(t, r), this.drawValue(t, n, r), n.showSecondary && this.drawSecondary(t, r), (n.showTitle || n.showSecondary) && this.drawBrackets(t, n, r);
  }
  /**
   * Clears the canvas.
   *
   * @param ctx
   * @param options
   */
  clearCanvas(t, n) {
    t.fillStyle = n.backgroundColor, t.fillRect(0, 0, n.width, n.height);
  }
  /**
   * Draws the title section.
   *
   * @param ctx
   * @param options
   */
  drawTitle(t, n) {
    t.font = n.titleFont, t.fillStyle = n.titleColor, t.textAlign = "center", t.textBaseline = "middle", t.fillText(n.fitTitleMeasure.string, n.width / 2, n.titleSectionHeight / 2), n.offsetY += n.titleSectionHeight;
  }
  /**
   * Draws the value section.
   *
   * @param ctx
   * @param data
   * @param options
   */
  drawValue(t, n, r) {
    const o = r.offsetY;
    t.fillStyle = r.valueColor, t.fillRect(1, o, r.width - r.bracketThickness * 2, r.valueSectionHeight), t.font = r.valueFont, t.fillStyle = "white", t.textAlign = "center", t.textBaseline = "middle", t.fillText(
      r.fitValueMeasure.string,
      r.width / 2,
      o + r.valueSectionHeight / 2
    );
  }
  /**
   * Draws the secondary section.
   *
   * @param ctx
   * @param options
   */
  drawSecondary(t, n) {
    const r = n.height - n.secBottomMargin;
    t.font = n.secondaryTitleFont, t.fillStyle = n.secondaryTitleColor, t.textAlign = "left", t.textBaseline = "bottom", t.fillText(n.fitSecondaryMeasure.titleString, n.bracketWidth, r), t.font = n.secondaryValueFont, t.fillStyle = n.secondaryValueColor, t.textAlign = "right", t.textBaseline = "bottom", t.fillText(n.fitSecondaryMeasure.valueString, n.width - n.bracketWidth, r);
  }
  /**
   * Draws the left and right brackets.
   *
   * @param ctx
   * @param data
   * @param options
   */
  drawBrackets(t, n, r) {
    t.strokeStyle = r.bracketColor, t.beginPath(), n.showTitle ? (t.moveTo(r.bracketWidth + 0.5, 0.5), t.lineTo(0.5, 0.5)) : t.moveTo(0.5, 0.5), t.lineTo(0.5, r.height - 0.5), n.showSecondary && t.lineTo(r.bracketWidth + 0.5, r.height - 0.5), t.stroke(), n.showTitle ? (t.moveTo(r.width - (r.bracketWidth + 0.5), 0.5), t.lineTo(r.width - 0.5, 0.5)) : t.moveTo(r.width - 0.5, 0.5), t.lineTo(r.width - 0.5, r.height - 0.5), n.showSecondary && t.lineTo(r.width - (r.bracketWidth + 0.5), r.height - 0.5), t.stroke(), t.closePath();
  }
}
const pn = new Pf(), Wl = function(e, t) {
  return pn.floor(e * t.value, t.decimals);
};
function Uwe(e, t) {
  const n = {};
  return e.forEach((r) => {
    t.some(function(o) {
      return o.key === r ? (n[r] = o, !0) : !1;
    });
  }), n;
}
function qwe(e, t, n) {
  const { maxWidth: r, maxHeight: o, showTitle: i, showSecondary: a } = n;
  for (let s = 0; s < t.length; s++) {
    const c = t[s], l = c.value, d = Wl(
      l,
      e.valueSectionHeight
    ), f = Wl(
      l,
      e.indicatorMargin
    ), p = Math.ceil(f * 1.5);
    let m = l + d + p;
    if (i) {
      const v = Wl(l, e.titleSectionHeight);
      m += v;
    }
    if (a) {
      const v = Wl(l, e.secSectionHeight);
      m += v;
    }
    if (m <= o) {
      const v = Wl(l, e.gaugeWidth), g = Wl(l, e.bracketWidth), b = f * 2;
      if (v + g * 2 + b <= r)
        return ge(se({}, c), {
          maxWidth: r - b,
          maxHeight: o - p
        });
    }
  }
  return null;
}
class Gwe {
  /**
   * Returns base measure data.
   */
  getBaseMeasure(t, n, r) {
    const o = n, i = "gaugeHeights" in o ? o.gaugeHeights : void 0;
    if (!i)
      return null;
    const a = o.relativeSizes, s = o.measureKeys.concat(), c = Math.floor(r.clientWidth), l = Math.floor(r.clientHeight), d = Uwe(
      s,
      a
    );
    return qwe(d, i, {
      maxWidth: c,
      maxHeight: l,
      showTitle: t.showTitle,
      showSecondary: t.showSecondary
    });
  }
  /**
   * Renders indicator gauge widget.
   *
   * @param {HTMLElement} canvas
   * @param {object} data
   * @param {object} options
   * @param {object} baseMeasure
   */
  render(t, n, r, o) {
    const i = t.getContext("2d");
    let a = 0, s;
    r.gaugeHeight = o.value, r.size = o.size, r.maxWidth = o.maxWidth, r.maxHeight = o.maxHeight, r.offsetY = 0, s = r.gaugeHeight + r.valueSectionHeight, n.showTitle && (r.fitTitleMeasure = this.getFitTitleMeasure(i, n, r), s += r.titleSectionHeight), r.fitValueMeasure = this.getFitValueMeasure(i, n, r), n.showSecondary && (r.fitSecondaryMeasure = this.getFitSecondaryMeasure(i, n, r), s += r.secSectionHeight), a = this.getCanvasWidth(n, r), r.width = a, r.height = s, pn.setCanvasSizes(t, i, a, s), this.draw(i, n, r);
  }
  /**
   * Returns fit title measure data.
   *
   * @param ctx
   * @param data
   * @param options
   */
  getFitTitleMeasure(t, n, r) {
    const o = r.bracketWidth * 2 + r.titleHorizontalMargin * 2, i = r.maxWidth - o, a = pn.getFitStringMeasure(
      t,
      n.title.text,
      i,
      r.titleFont
    );
    return a.width += o, a.key = "title", a;
  }
  /**
   * Returns fit value measure data.
   *
   * @param ctx
   * @param data
   * @param options
   */
  getFitValueMeasure(t, n, r) {
    const o = r.bracketThickness * 2, i = r.maxWidth - o, a = pn.getFitStringMeasure(
      t,
      n.value.text,
      i,
      r.valueFont
    );
    return a.width += o, a.key = "value", a;
  }
  /**
   * Returns fit value measure data.
   *
   * @param ctx
   * @param data
   * @param options
   */
  getFitSecondaryMeasure(t, n, r) {
    const o = r.bracketWidth * 2 + r.secDividerWidth, i = r.maxWidth - o, a = i - r.secTitleMinWidth, s = pn.getFitStringMeasure(
      t,
      n.secondary.text,
      a,
      r.secondaryValueFont
    ), c = i - s.width, l = pn.getFitStringMeasure(
      t,
      n.secondaryTitle.text,
      c,
      r.secondaryTitleFont
    );
    return {
      width: l.width + s.width + o,
      titleString: l.string,
      valueString: s.string,
      key: "secondary"
    };
  }
  /**
   * Returns canvas width.
   *
   * @param data
   * @param options
   */
  getCanvasWidth(t, n) {
    let r = n.gaugeWidth + n.bracketWidth * 2;
    const o = n.fitTitleMeasure, i = n.fitValueMeasure;
    let s = o && o.width > i.width ? o : i;
    const c = n.fitSecondaryMeasure, l = c && c.width > s.width;
    let d;
    return s = l ? c : s, l ? d = s.titleString !== t.secondaryTitle.text || s.valueString !== t.secondary.text : d = s.string !== t[s.key].text, d ? r = n.maxWidth : s.width > r && (r = s.width), r;
  }
  /**
   * Draws indicator numeric bar widget.
   *
   * @param ctx
   * @param data
   * @param options
   */
  draw(t, n, r) {
    this.clearCanvas(t, r), n.showTitle && this.drawTitle(t, r), this.drawGauge(t, n, r), this.drawValue(t, n, r), n.showSecondary && this.drawSecondary(t, r), this.drawBrackets(t, n, r);
  }
  /**
   * Clears the canvas.
   *
   * @param ctx
   * @param options
   */
  clearCanvas(t, n) {
    t.fillStyle = n.backgroundColor, t.fillRect(0, 0, n.width, n.height);
  }
  /**
   * Draws the title section.
   *
   * @param ctx
   * @param options
   */
  drawTitle(t, n) {
    t.font = n.titleFont, t.fillStyle = n.titleColor, t.textAlign = "center", t.textBaseline = "middle", t.fillText(
      n.fitTitleMeasure.string,
      n.width / 2,
      (n.titleSectionHeight - n.titleBottomMargin) / 2
    ), n.offsetY += n.titleSectionHeight;
  }
  /**
   * Draws the gauge section.
   *
   * @param ctx
   * @param data
   * @param options
   */
  drawGauge(t, n, r) {
    r.gaugeCenterX = r.width / 2, r.gaugeCenterY = r.offsetY + r.gaugeHeight - r.gaugeBottomMargin, r.needleAngle = this.getNeedleAngle(n, r), n.skin === 2 && n.conditions && n.conditions.length ? this.drawConditionalDial(t, n, r) : this.drawSimpleDial(t, n, r), n.showTicks && r.size !== "micro" && this.drawTicks(t, n, r), this.drawNeedle(t, r), n.showLabels && r.size !== "micro" && this.drawLabels(t, n, r), r.offsetY += r.gaugeHeight;
  }
  /**
   * Draws the value section.
   *
   * @param ctx
   * @param data
   * @param options
   */
  drawValue(t, n, r) {
    t.fillStyle = r.valueColor, t.fillRect(
      1,
      r.offsetY,
      r.width - r.bracketThickness * 2,
      r.valueSectionHeight
    ), t.font = r.valueFont, t.fillStyle = "white", t.textAlign = "center", t.textBaseline = "middle", t.fillText(
      r.fitValueMeasure.string,
      r.width / 2,
      r.offsetY + r.valueSectionHeight / 2
    );
  }
  /**
   * Draws the secondary section.
   *
   * @param ctx
   * @param options
   */
  drawSecondary(t, n) {
    const r = n.height - n.secBottomMargin;
    t.font = n.secondaryTitleFont, t.fillStyle = n.secondaryTitleColor, t.textAlign = "left", t.textBaseline = "bottom", t.fillText(n.fitSecondaryMeasure.titleString, n.bracketWidth, r), t.font = n.secondaryValueFont, t.fillStyle = n.secondaryValueColor, t.textAlign = "right", t.textBaseline = "bottom", t.fillText(n.fitSecondaryMeasure.valueString, n.width - n.bracketWidth, r);
  }
  /**
   * Draws the left and right brackets.
   *
   * @param ctx
   * @param data
   * @param options
   */
  drawBrackets(t, n, r) {
    const o = n.showTitle ? (r.titleSectionHeight - r.titleBottomMargin) / 2 : 0;
    t.strokeStyle = r.bracketColor, t.beginPath(), t.moveTo(r.bracketWidth + 0.5, o + 0.5), t.lineTo(0.5, o + 0.5), t.lineTo(0.5, r.height - 0.5), n.showSecondary && t.lineTo(r.bracketWidth + 0.5, r.height - 0.5), t.stroke(), t.moveTo(r.width - (r.bracketWidth + 0.5), o + 0.5), t.lineTo(r.width - 0.5, o + 0.5), t.lineTo(r.width - 0.5, r.height - 0.5), n.showSecondary && t.lineTo(r.width - (r.bracketWidth + 0.5), r.height - 0.5), t.stroke(), t.closePath();
  }
  /**
   * Returns the gauge needle angle.
   *
   * @param data
   * @param options
   */
  getNeedleAngle(t, n) {
    const r = +t.min.data, o = +t.max.data, i = +(t.value.data || 0);
    return i < r ? n.startAngle - n.overDegrees : i > o ? n.endAngle + n.overDegrees : this.getAngle(n, i, r, o);
  }
  /**
   * Returns the angle according to the passed value, min and max arguments.
   *
   * @param options
   * @param value
   * @param min
   * @param max
   */
  getAngle(t, n, r, o) {
    const i = (t.endAngle - t.startAngle) / (o - r);
    return (n - r) * i + t.startAngle;
  }
  /**
   * Draws conditional dial section.
   *
   * @param ctx
   * @param data
   * @param options
   */
  drawConditionalDial(t, n, r) {
    const o = n.conditions, i = +n.min.data, a = +n.max.data, s = pn.degToRad(r.startAngle + 180), c = pn.degToRad(r.endAngle + 180);
    let l;
    const d = (f) => this.getAngle(r, f, i, a);
    for (this.drawArc(t, r, s, c, r.defaultDialColor), l = o.length - 1; l >= 0; l--) {
      const f = o[l];
      let p = +f.data, m, v = NaN, g = NaN, b = NaN, x = NaN;
      const T = 0.25;
      switch (f.operator) {
        case "<":
          if (p <= i)
            break;
          p = p > a ? a : p, m = d(p), v = s, g = pn.degToRad(m + 180);
          break;
        case ">":
          if (p >= a)
            break;
          p = p < i ? i : p, m = d(p), v = pn.degToRad(m + 180), g = c;
          break;
        case "≤":
          if (p < i)
            break;
          p = p > a ? a : p, m = d(p), v = s, g = pn.degToRad(
            m + (m + T <= r.endAngle ? T : 0) + 180
          );
          break;
        case "≥":
          if (p > a)
            break;
          p = p < i ? i : p, m = d(p), v = pn.degToRad(
            m - (m - T >= r.startAngle ? T : 0) + 180
          ), g = c;
          break;
        case "=":
          if (p < i || p > a)
            break;
          m = d(p), v = pn.degToRad(
            m - (m - T >= r.startAngle ? T : 0) + 180
          ), g = pn.degToRad(
            m + (m + T <= r.endAngle ? T : 0) + 180
          );
          break;
        case "≠":
          if (p < i || p > a)
            v = s, g = c;
          else if (p === i || p === a) {
            const S = p === i;
            v = pn.degToRad(r.startAngle + (S ? T : 0) + 180), g = pn.degToRad(r.endAngle - (S ? 0 : T) + 180);
          } else
            m = d(p), v = s, g = pn.degToRad(
              m - (m - T >= r.startAngle ? T : 0) + 180
            ), b = pn.degToRad(
              m + (m + T <= r.endAngle ? T : 0) + 180
            ), x = c;
      }
      !isNaN(v) && !isNaN(g) && this.drawArc(t, r, v, g, f.color), !isNaN(b) && !isNaN(x) && this.drawArc(t, r, b, x, f.color);
    }
  }
  /**
   * Draws simple dial section.
   *
   * @param ctx
   * @param data
   * @param options
   */
  drawSimpleDial(t, n, r) {
    const o = pn.degToRad(r.startAngle + 180), i = pn.degToRad(r.needleAngle + 180), a = pn.degToRad(r.endAngle + 180);
    r.needleAngle > r.startAngle && r.needleAngle < r.endAngle ? (this.drawArc(t, r, o, i, r.valueColor), t.globalAlpha = r.gaugeOpacity, this.drawArc(t, r, i, a, r.valueColor)) : (r.needleAngle <= r.startAngle && (t.globalAlpha = r.gaugeOpacity), this.drawArc(t, r, o, a, r.valueColor)), t.globalAlpha = 1;
  }
  /**
   * Draws the gauge arc section.
   *
   * @param ctx
   * @param options
   * @param startAngleRad
   * @param endAngleRad
   * @param color
   */
  drawArc(t, n, r, o, i) {
    t.fillStyle = i, t.beginPath(), t.arc(
      n.gaugeCenterX,
      n.gaugeCenterY,
      n.outerArcRadius,
      r,
      o
    ), t.arc(
      n.gaugeCenterX,
      n.gaugeCenterY,
      n.innerArcRadius,
      o,
      r,
      !0
    ), t.fill();
  }
  /**
   * Draws the gauge ticks.
   *
   * @param ctx
   * @param data
   * @param options
   */
  drawTicks(t, n, r) {
    const o = r.startAngle, i = r.endAngle, a = r.tickDegreesIncrement, s = r.needleAngle;
    let c;
    for (c = o; c <= i; c += a) {
      const l = pn.degToRad(c), d = r.gaugeCenterX - r.lengthToTick * Math.cos(l), f = r.gaugeCenterY - r.lengthToTick * Math.sin(l), p = s < o, m = s >= c - a / 2 && s < c + a / 2, v = c === i && s >= c;
      t.fillStyle = !p && m || v ? n.color : r.tickColor, t.beginPath(), t.arc(d, f, r.tickRadius, 0, 2 * Math.PI), t.fill();
    }
  }
  /**
   * Draws the gauge needle.
   *
   * @param {object} ctx
   * @param {object} options
   */
  drawNeedle(t, n) {
    const r = pn.degToRad(n.needleAngle);
    t.fillStyle = n.needleColor, t.save(), t.translate(n.gaugeCenterX, n.gaugeCenterY), t.rotate(r), t.translate(-n.gaugeCenterX, -n.gaugeCenterY), t.beginPath(), t.arc(
      n.gaugeCenterX,
      n.gaugeCenterY,
      n.needleBaseRadius,
      0.5 * Math.PI,
      1.5 * Math.PI,
      !0
    ), t.lineTo(n.gaugeCenterX - n.needleLength, n.gaugeCenterY), t.fill(), t.restore();
  }
  /**
   * Draws the gauge labels.
   *
   * @param ctx
   * @param data
   * @param options
   */
  drawLabels(t, n, r) {
    t.font = r.labelFont, t.fillStyle = r.labelColor, t.textAlign = "right", t.textBaseline = "middle", t.fillText(n.min.text, r.gaugeCenterX - r.labelMargin, r.gaugeCenterY), t.textAlign = "left", t.fillText(n.max.text, r.gaugeCenterX + r.labelMargin, r.gaugeCenterY);
  }
}
const bi = new Pf();
class Ywe {
  /**
   * Renders indicator ticker widget.
   *
   * @param {HTMLElement} canvas
   * @param {object} data
   * @param {object} options
   * @param {HTMLElement} container
   */
  render(t, n, r, o) {
    const i = t.getContext("2d"), a = Math.floor(o.clientWidth) - r.horizontalMargin * 2, s = r.sectionMinWidth;
    let c = 0, l = 0, d = 0, f = 0, p = 0, m = 0, v = 0, g = 0, b;
    if (i.font = r.valueFont, b = bi.getStringWidth(i, n.value.text), r.offsetX = 0, n.title.text += ":", n.secondaryTitle && (n.secondaryTitle.text += ":"), n.showTitle && (i.font = r.titleFont, m = bi.getStringWidth(i, n.value.text), p = bi.getStringWidth(i, n.title.text), l = p < s ? p : s, b += l + r.textPadding), n.showSecondary && (i.font = r.secondaryValueFont, g = bi.getStringWidth(i, n.secondary.text), f = g < s ? g : s, b += f, i.font = r.secondaryTitleFont || "", v = bi.getStringWidth(i, n.secondaryTitle.text), d = v < s ? v : s, b += d + r.horizontalPadding * 2 + r.dividerWidth + r.textPadding), n.type === "gauge") {
      const T = r.horizontalPadding * 2 + r.dividerWidth;
      if (r.forceTickerView) {
        const _ = m + p + v + g + r.textPadding * 4 + T, w = a - T - _;
        r.barWidth = Math.max(w, r.barWidth);
      }
      const S = r.barWidth + T;
      b += S, r.showTickerBar = b <= a || !0, c += r.showTickerBar ? S : 0;
    }
    c += n.showTitle ? r.textPadding : 0, c += n.showSecondary ? r.horizontalPadding * 2 + r.dividerWidth + r.textPadding : 0;
    const x = a - c - l - d - f;
    if (r.fitValueMeasure = bi.getFitStringMeasure(
      i,
      n.value.text,
      x,
      r.valueFont
    ), c += r.fitValueMeasure.width, n.showSecondary) {
      const T = a - c - l - d;
      let S;
      r.fitSecValueMeasure = bi.getFitStringMeasure(
        i,
        n.secondary.text,
        T,
        r.secondaryValueFont
      ), c += r.fitSecValueMeasure.width;
      const _ = a - c, w = _ / 2;
      n.showTitle ? p + v > _ ? p > w && v > w ? S = w : v > w && p <= w ? S = _ - p : S = v : S = v : S = _, r.fitSecTitleMeasure = bi.getFitStringMeasure(
        i,
        n.secondaryTitle.text,
        S,
        r.secondaryTitleFont
      ), c += r.fitSecTitleMeasure.width;
    }
    if (n.showTitle) {
      const T = a - c;
      r.fitTitleMeasure = bi.getFitStringMeasure(
        i,
        n.title.text,
        T,
        r.titleFont
      ), c += r.fitTitleMeasure.width;
    }
    r.width = c, bi.setCanvasSizes(t, i, c, r.height), this.draw(i, n, r);
  }
  /**
   * Draws indicator ticker widget.
   *
   * @param ctx
   * @param data
   * @param options
   */
  draw(t, n, r) {
    this.clearCanvas(t, r), n.type === "gauge" && r.showTickerBar && (this.drawTickerBar(t, n, r), this.drawDivider(t, r)), t.textBaseline = "middle", n.showTitle && this.drawTitle(t, r), this.drawValue(t, n, r), n.showSecondary && (this.drawDivider(t, r), this.drawSecondary(t, r));
  }
  /**
   * Clears the canvas.
   *
   * @param ctx
   * @param options
   */
  clearCanvas(t, n) {
    t.fillStyle = n.backgroundColor, t.fillRect(0, 0, n.width, n.height);
  }
  /**
   * Draws the ticker bar section.
   *
   * @param {object} ctx
   * @param {object} data
   * @param {object} options
   */
  drawTickerBar(t, n, r) {
    var l;
    const o = +n.min.data, i = +n.max.data, a = +(((l = n.value) == null ? void 0 : l.data) || 0), s = Math.round((r.height - r.barHeight) / 2);
    let c;
    if (t.fillStyle = r.valueColor, a <= o)
      t.globalAlpha = r.barOpacity, t.fillRect(r.offsetX, s, r.barWidth, r.barHeight), c = 0;
    else if (a >= i)
      t.fillRect(r.offsetX, s, r.barWidth, r.barHeight), c = r.barWidth - r.tickerBarWidth;
    else {
      const d = (a - Math.abs(o)) / (i - o), f = r.barWidth * d;
      t.fillRect(r.offsetX, s, f, r.barHeight), t.globalAlpha = r.barOpacity, t.fillRect(
        r.offsetX + f,
        s,
        r.barWidth - f,
        r.barHeight
      ), f > r.barWidth - r.tickerBarWidth ? c = r.barWidth - r.tickerBarWidth : f < r.tickerBarWidth ? c = 0 : c = f - 1;
    }
    t.globalAlpha = 1, t.fillStyle = r.barHandleColor, t.fillRect(
      r.offsetX + c,
      Math.round((r.height - r.tickerBarHeight) / 2),
      r.tickerBarWidth,
      r.tickerBarHeight
    ), r.offsetX += r.barWidth;
  }
  /**
   * Draws the divider.
   *
   * @param ctx
   * @param options
   */
  drawDivider(t, n) {
    t.fillStyle = n.dividerColor, t.fillRect(
      n.offsetX + n.horizontalPadding,
      Math.round((n.height - n.dividerHeight) / 2),
      n.dividerWidth,
      n.dividerHeight
    ), n.offsetX += n.horizontalPadding * 2 + n.dividerWidth;
  }
  /**
   * Draws the title section.
   *
   * @param ctx
   * @param options
   */
  drawTitle(t, n) {
    t.font = n.titleFont, t.fillStyle = n.titleColor, t.fillText(n.fitTitleMeasure.string, n.offsetX, Math.floor(n.height / 2)), n.offsetX += n.fitTitleMeasure.width + n.textPadding;
  }
  /**
   * Draws the value section.
   *
   * @param ctx
   * @param data
   * @param options
   */
  drawValue(t, n, r) {
    t.font = r.valueFont, t.fillStyle = r.valueColor || n.color, t.fillText(r.fitValueMeasure.string, r.offsetX, Math.floor(r.height / 2)), r.offsetX += r.fitValueMeasure.width;
  }
  /**
   * Draws the secondary section.
   *
   * @param ctx
   * @param options
   */
  drawSecondary(t, n) {
    t.font = n.secondaryTitleFont, t.fillStyle = n.secondaryTitleColor, t.fillText(
      n.fitSecTitleMeasure.string,
      n.offsetX,
      Math.floor(n.height / 2)
    ), n.offsetX += n.fitSecTitleMeasure.width + n.textPadding, t.font = n.secondaryValueFont, t.fillStyle = n.secondaryValueColor, t.fillText(
      n.fitSecValueMeasure.string,
      n.offsetX,
      Math.floor(n.height / 2)
    );
  }
}
const PR = {
  fontFamily: "opensansregular, sans-serif",
  title: {
    color: "rgb(68, 81, 102)",
    fontSizes: {
      big: 22,
      medium: 18,
      small: 15,
      micro: 12
    }
  },
  value: {
    color: "rgb(0,206,230)",
    fontSizes: {
      big: 66,
      medium: 46,
      small: 32,
      micro: 23
    }
  },
  secondaryTitle: {
    color: "rgb(163, 163, 163)",
    fontSizes: {
      big: 20,
      medium: 14,
      small: 10,
      micro: 10
    }
  },
  secondaryValue: {
    fontWeight: 800,
    color: "rgb(163, 163, 163)",
    fontSizes: {
      big: 20,
      medium: 14,
      small: 10,
      micro: 10
    }
  },
  textKeys: ["title", "value", "secondaryTitle", "secondaryValue"],
  backgroundColor: "rgb(255, 255, 255)",
  borderColor: "rgb(215, 215, 215)",
  borderWidth: 1,
  relativeSizes: [
    {
      key: "titleSectionHeight",
      value: 0.5,
      decimals: 0
    },
    {
      key: "titleSectionMarginTop",
      value: 0.13,
      decimals: 0
    },
    {
      key: "titleSectionMinWidth",
      value: 0.29,
      decimals: 0
    },
    {
      key: "numericMinWidth",
      value: 4.69,
      decimals: 0
    },
    {
      key: "valueSectionHeight",
      value: 1,
      decimals: 0
    },
    {
      key: "valueSectionMarginRight",
      value: 0.14,
      decimals: 0
    },
    {
      key: "valueSectionMarginBottom",
      value: 0.07,
      decimals: 0
    },
    {
      key: "secSectionHeight",
      value: 0.34,
      decimals: 0
    },
    {
      key: "secSectionMarginTop",
      value: 0.14,
      decimals: 0
    },
    {
      key: "secDividerWidth",
      value: 0.14,
      decimals: 0
    },
    {
      key: "secTitleMinWidth",
      value: 0.29,
      decimals: 0
    },
    {
      key: "indicatorHorizontalMargin",
      value: 0.31,
      decimals: 0
    },
    {
      key: "indicatorVerticalMargin",
      value: 0.46,
      decimals: 0
    }
  ],
  measureKeys: [
    "indicatorMargin",
    "numericMinWidth",
    "titleSectionHeight",
    "secSectionHeight",
    "valueSectionMarginBottom",
    "secSectionMarginTop",
    "indicatorHorizontalMargin",
    "indicatorVerticalMargin"
  ],
  sizes: [
    {
      size: "big",
      value: 70
    },
    {
      size: "medium",
      value: 49
    },
    {
      size: "small",
      value: 34
    },
    {
      size: "micro",
      value: 24
    }
  ],
  fitMeasures: [
    {
      key: "fitTitleMeasure",
      prop: "string",
      dataKey: "title"
    },
    {
      key: "fitValueMeasure",
      prop: "string",
      dataKey: "value"
    },
    {
      key: "fitSecondaryMeasure",
      prop: "titleString",
      dataKey: "secondaryTitle"
    },
    {
      key: "fitSecondaryMeasure",
      prop: "valueString",
      dataKey: "secondary"
    }
  ]
}, Zwe = {
  fontFamily: "opensansregular, sans-serif",
  title: {
    color: "rgb(68, 81, 102)",
    fontSizes: { big: 22, medium: 18, small: 15, micro: 12 }
  },
  value: {
    color: "rgb(255, 255, 255)",
    fontSizes: { big: 45, medium: 31, small: 22, micro: 15 }
  },
  secondaryTitle: {
    color: "rgb(163, 163, 163)",
    fontSizes: { big: 20, medium: 14, small: 10, micro: 10 }
  },
  secondaryValue: {
    fontWeight: 800,
    color: "rgb(163, 163, 163)",
    fontSizes: { big: 20, medium: 14, small: 10, micro: 10 }
  },
  textKeys: ["title", "value", "secondaryTitle", "secondaryValue"],
  backgroundColor: "rgb(255, 255, 255)",
  bracketColor: "rgb(198, 198, 198)",
  bracketThickness: 1,
  relativeSizes: [
    { key: "titleSectionHeight", value: 1, decimals: 0 },
    { key: "titleHorizontalMargin", value: 0.16, decimals: 0 },
    { key: "numericMinWidth", value: 4.69, decimals: 0 },
    { key: "valueSectionHeight", value: 1, decimals: 0 },
    { key: "secSectionHeight", value: 1, decimals: 0 },
    { key: "secBottomMargin", value: 0.14, decimals: 0 },
    { key: "secDividerWidth", value: 0.14, decimals: 0 },
    { key: "secTitleMinWidth", value: 0.29, decimals: 0 },
    { key: "bracketWidth", value: 0.21, decimals: 0 },
    { key: "indicatorMargin", value: 0.64, decimals: 0 }
  ],
  measureKeys: [
    "indicatorMargin",
    "numericMinWidth",
    "bracketWidth",
    "titleSectionHeight",
    "secSectionHeight"
  ],
  sizes: [
    { size: "big", value: 70, maxWidth: 1261, maxHeight: 665 },
    { size: "medium", value: 49 },
    { size: "small", value: 34 },
    { size: "micro", value: 24 }
  ]
}, Xwe = {
  fontFamily: "opensansregular, sans-serif",
  title: {
    color: "rgb(68, 81, 102)",
    fontSizes: { big: 22, medium: 18, small: 15, micro: 12 }
  },
  value: {
    color: "rgb(255, 255, 255)",
    fontSizes: { big: 45, medium: 31, small: 22, micro: 15 }
  },
  secondaryTitle: {
    color: "rgb(163, 163, 163)",
    fontSizes: { big: 20, medium: 14, small: 10, micro: 10 }
  },
  secondaryValue: {
    fontWeight: 800,
    color: "rgb(163, 163, 163)",
    fontSizes: { big: 20, medium: 14, small: 10, micro: 10 }
  },
  label: {
    color: "rgb(68, 81, 102)",
    fontSizes: { big: 18, medium: 13, small: 9, micro: 9 }
  },
  textKeys: ["title", "value", "secondaryTitle", "secondaryValue", "label"],
  backgroundColor: "rgb(255, 255, 255)",
  tickColor: "rgb(0, 0, 0)",
  needleColor: "rgb(43, 51, 66)",
  bracketColor: "rgb(198, 198, 198)",
  defaultDialColor: "rgb(179, 179, 179)",
  gaugeOpacity: 0.5,
  startAngle: 20,
  endAngle: 160,
  overDegrees: 5,
  tickDegreesIncrement: 10,
  bracketThickness: 1,
  relativeSizes: [
    { key: "titleSectionHeight", value: 0.26, decimals: 0 },
    { key: "titleHorizontalMargin", value: 0.08, decimals: 0 },
    { key: "titleBottomMargin", value: 0.1, decimals: 0 },
    { key: "gaugeWidth", value: 1.33, decimals: 0 },
    { key: "gaugeBottomMargin", value: 0.19, decimals: 0 },
    { key: "outerArcRadius", value: 0.63, decimals: 0 },
    {
      key: "innerArcRadius",
      dataKey: "skin",
      values: { 1: 0.24, 2: 0.51 },
      decimals: 0
    },
    { key: "lengthToTick", value: 0.7, decimals: 0 },
    { key: "tickRadius", value: 0.01, decimals: 1 },
    {
      key: "needleLength",
      dataKey: "skin",
      values: { 1: 0.52, 2: 0.58 },
      decimals: 0
    },
    { key: "needleBaseRadius", value: 0.04, decimals: 0 },
    { key: "labelMargin", value: 0.26, decimals: 0 },
    { key: "valueSectionHeight", value: 0.36, decimals: 0 },
    { key: "secSectionHeight", value: 0.36, decimals: 0 },
    { key: "secBottomMargin", value: 0.05, decimals: 0 },
    { key: "secDividerWidth", value: 0.05, decimals: 0 },
    { key: "secTitleMinWidth", value: 0.1, decimals: 0 },
    { key: "bracketWidth", value: 0.08, decimals: 0 },
    { key: "indicatorMargin", value: 0.14, decimals: 0 }
  ],
  gaugeHeights: [
    { size: "big", value: 192, maxWidth: 1297, maxHeight: 1075 },
    { size: "medium", value: 134 },
    { size: "small", value: 94 },
    { size: "micro", value: 66 }
  ],
  measureKeys: [
    "indicatorMargin",
    "gaugeWidth",
    "bracketWidth",
    "titleSectionHeight",
    "valueSectionHeight",
    "secSectionHeight"
  ]
}, Kwe = {
  fontFamily: "Open Sans",
  fontSize: 15,
  title: {
    color: "rgb(68, 81, 102)"
  },
  value: {
    fontWeight: 800
  },
  secondaryTitle: {
    color: "rgb(163, 163, 163)"
  },
  secondaryValue: {
    color: "rgb(163, 163, 163)"
  },
  textKeys: ["title", "value", "secondaryTitle", "secondaryValue"],
  backgroundColor: "transparent",
  dividerColor: "rgb(39, 42, 52)",
  barHandleColor: "rgb(43, 51, 66)",
  height: 35,
  horizontalMargin: 15,
  barWidth: 100,
  barHeight: 11,
  barOpacity: 0.5,
  tickerBarWidth: 2,
  tickerBarHeight: 13,
  horizontalPadding: 9,
  textPadding: 6,
  sectionMinWidth: 20,
  dividerWidth: 1,
  dividerHeight: 13,
  forceTickerView: !1
};
function Jwe(e, t) {
  const n = Li(Kwe);
  if (n.forceTickerView = t.forceTickerView, n.fontFamily = t.fontFamily, n.backgroundColor = t.backgroundColor, n.value.color = t.value.color, n.title.color = t.title.color, n.secondaryTitle.color = t.secondaryTitle.color, n.secondaryValue.color = t.secondaryTitle.color, t.tickerBarHeight) {
    const r = t.tickerBarHeight;
    n.barHeight = r, n.tickerBarHeight = r + 2;
  }
  return n.forceTickerView && (n.height = e.offsetHeight), n;
}
const Qwe = new Pf(), exe = new Hwe(), txe = new Vwe(), nxe = new Gwe(), rxe = new Ywe();
class oxe {
  /**
   * Returns render service according to the passed indicator type.
   *
   * @param type
   * @returns
   */
  getService(t) {
    switch (t) {
      case "numericSimple":
        return exe;
      case "numericBar":
        return txe;
      case "gauge":
        return nxe;
      case "ticker":
        return rxe;
    }
  }
  /**
   * Main method for rendering indicator.
   *
   * @param {HTMLElement} canvas
   * @param {object} legacyDataOptions
   * @param {object} options
   * @param {HTMLElement} container
   */
  render(t, n, r, o) {
    let i = this.getService(n.type);
    const a = "getBaseMeasure" in i ? i.getBaseMeasure(n, r, o) : void 0;
    if (!a || r.forceTickerView) {
      i = this.getService("ticker");
      const s = Jwe(t, r);
      this.setTextOptions(s), i.render(t, n, s, o);
      return;
    }
    this.calculateRelativeSizes(n, r, a.value), this.setTextOptions(r, a.size), i.render(
      t,
      n,
      r,
      a
    );
  }
  /**
   * Calculates relative sizes based on the base size value.
   *
   * @param {object} legacyDataOptions
   * @param {object} options
   * @param {number} baseValue
   */
  calculateRelativeSizes(t, n, r) {
    const { relativeSizes: o } = n;
    o.forEach(function(i) {
      let a;
      if ("dataKey" in i && "values" in i && i.dataKey in t)
        a = i.values[t[i.dataKey]];
      else if ("value" in i)
        a = i.value;
      else
        throw new vt("errors.indicatorInvalidRelativeSize");
      const s = a * r;
      n[i.key] = Qwe.floor(s, i.decimals);
    });
  }
  /**
   * Sets text options.
   *
   * @param {object} options
   * @param {string} size
   */
  setTextOptions(t, n) {
    t.textKeys.forEach(function(r) {
      const o = t[r], i = o.fontStyle ? `${o.fontStyle} ` : "", a = o.fontVariant ? `${o.fontVariant} ` : "", s = o.fontWeight ? `${o.fontWeight} ` : "", c = `${Number.parseFloat(
        o.fontSizes && o.fontSizes[n] || o.fontSize || t.fontSize
      )}px `, l = o.fontFamily || t.fontFamily, { color: d } = o;
      t[`${r}Font`] = i + a + s + c + l, t[`${r}Color`] = d;
    });
  }
}
function J5(e) {
  var n;
  const t = (n = e.value) == null ? void 0 : n[0];
  if (t && "color" in t)
    return t.color;
}
function ixe(e, t, n) {
  if (!axe(e))
    return n;
  const o = dO(
    e
  ).getColor(t);
  return o ? ge(se({}, n), {
    value: ge(se({}, n.value), {
      color: o
    })
  }) : n;
}
function axe(e) {
  return typeof e == "string" || e.type === "uniform" || e.type === "conditional";
}
const sxe = (e, t) => {
  const n = J5(t);
  return n && e.value ? dO(
    n
  ).getColor(fh(e.value) ? e.value : 0) : null;
}, lxe = (e, t, n) => {
  var f, p, m, v, g, b, x, T, S, _, w, k;
  const r = fh(e.min) ? e.min : 0, o = fh(e.max) ? e.max : 100, i = Np(n, "value"), a = Np(n, "secondary"), s = Np(n, "min"), c = Np(n, "max"), l = sxe(e, n), d = t.indicatorType === "gauge" ? 1 : "vertical";
  return ge(se(se({}, uxe), l ? { color: l } : null), {
    type: cxe(
      t.indicatorType,
      "numericSubtype" in t ? t.numericSubtype : void 0
    ) || "numericSimple",
    skin: t.skin || d,
    title: { text: (m = (p = (f = t.indicatorComponents) == null ? void 0 : f.title) == null ? void 0 : p.text) != null ? m : "" },
    min: { data: r, text: as(s, r) },
    max: { data: o, text: as(c, o) },
    value: {
      data: e.value,
      text: OR(e.value, i)
    },
    secondary: {
      data: e.secondary,
      text: OR(e.secondary, a)
    },
    secondaryTitle: {
      text: (b = (g = (v = t.indicatorComponents) == null ? void 0 : v.secondaryTitle) == null ? void 0 : g.text) != null ? b : ""
    },
    showSecondary: e.secondary !== void 0,
    showTitle: !!((T = (x = t.indicatorComponents) == null ? void 0 : x.title) != null && T.shouldBeShown),
    showLabels: !!((_ = (S = t.indicatorComponents) == null ? void 0 : S.labels) != null && _.shouldBeShown),
    showTicks: !!((k = (w = t.indicatorComponents) == null ? void 0 : w.ticks) != null && k.shouldBeShown)
  });
};
function cxe(e, t) {
  return e === "numeric" ? t : e;
}
function Np(e, t) {
  var r;
  const n = (r = e[t]) == null ? void 0 : r[0];
  return Fc(
    n && "numberFormatConfig" in n ? n.numberFormatConfig : {}
  );
}
const uxe = {
  color: "#00cee6",
  showSecondary: !1
};
function OR(e, t) {
  return e === void 0 ? "" : isNaN(e) ? "#N/A" : as(t, e);
}
function dxe(e, t, n) {
  const r = Li(n);
  for (const o in t) {
    const i = t[o], a = fxe(e, i);
    a && Q5(r, o, a);
  }
  return r;
}
function Q5(e, t, n) {
  const r = t.split(".");
  if (r.length === 1)
    if (r[0] in e)
      e[r[0]] = n;
    else
      return;
  else {
    const [o, ...i] = r;
    if (!(o in e))
      return;
    const a = e[o];
    if (!eL(a))
      return;
    Q5(a, i.join("."), n);
  }
}
function fxe(e, t) {
  const n = t.split(".");
  let r = e;
  for (const o of n) {
    if (!eL(r) || !(o in r))
      return;
    r = r[o];
  }
  return r;
}
function eL(e) {
  return typeof e == "object" && e !== null;
}
function pxe(e, t, n) {
  return dxe(
    e,
    t,
    n
  );
}
const hxe = {
  fontFamily: "typography.fontFamily",
  "title.color": "chart.textColor",
  backgroundColor: "chart.backgroundColor",
  "label.color": "chart.textColor",
  "secondaryTitle.color": "chart.secondaryTextColor",
  "secondaryValue.color": "chart.secondaryTextColor",
  "value.color": "palette.variantColors.0"
}, mxe = (e, t) => {
  const { chartData: n, dataOptions: r, themeSettings: o } = t, { type: i } = e;
  let a;
  switch (i) {
    case "gauge":
      a = Xwe;
      break;
    case "numeric":
      e.numericSubtype === "numericBar" ? a = Zwe : a = PR;
      break;
    default:
      a = PR;
  }
  o && (a = pxe(
    o,
    hxe,
    a
  ));
  const s = J5(r);
  return s && n.value && fh(n.value) && (a = ixe(
    s,
    n.value,
    a
  )), se(ge(se({}, a), {
    forceTickerView: e.forceTickerView
  }), e.type === "gauge" && e.tickerBarHeight ? { tickerBarHeight: e.tickerBarHeight } : null);
};
function Ic(e, t) {
  return fO(e, t);
}
function gxe(e) {
  return typeof e == "string";
}
function vxe(e) {
  var c;
  const t = Yn().themeSettings, [n, r] = Ge(
    Ww()
  ), [o, i] = Ge(null), a = (c = Gn().app) == null ? void 0 : c.httpClient;
  return mt(() => {
    e && (gxe(e) ? a && Ehe(e, a).then(r).catch(i) : r(e));
  }, [e, a]), o ? [null, o] : Ic(t, n) ? [t, null] : [Ci.withOptions(
    { mergeArrays: !1 },
    t,
    n
  ), null];
}
const bxe = (e, t) => {
  const n = it(document.createElement("style")), [r, o] = Ge([]), i = We(
    () => e.filter((a) => !t.includes(NR(a))),
    [e, t]
  );
  return mt(() => {
    if (i.length) {
      n.current = document.createElement("style");
      const a = i.map(yxe);
      n.current.innerHTML = a.join(`
`), document.head.appendChild(n.current), o(i.map(NR));
    }
    return () => {
      var a;
      (a = n.current) == null || a.remove();
    };
  }, [i]), r;
};
function NR(e) {
  return `${e.fontFamily}|${e.fontWeight}|${e.fontStyle}`;
}
function yxe(e) {
  return `@font-face {
          font-family: "${e.fontFamily}";
          font-weight: ${e.fontWeight};
          font-style: ${e.fontStyle};
          ${e.src.map(
    (t) => `src: ${Object.entries(t).map(([n, r]) => `${n}('${r}')`).join(" ")};`
  ).join(`
`)}
      }`;
}
const AR = ol({
  loadedFonts: []
}), _xe = ({
  fonts: e,
  children: t
}) => {
  var i;
  const { loadedFonts: n } = rl(AR), { themeSettings: r } = Yn(), o = bxe(
    e || ((i = r.typography.fontsLoader) == null ? void 0 : i.fonts) || [],
    n
  );
  return /* @__PURE__ */ z(AR.Provider, { value: { loadedFonts: [...n, ...o] }, children: t });
}, wxe = Jc({
  componentName: "ThemeProvider",
  trackingConfig: {
    skip: (e) => !!e.skipTracking,
    transparent: !0
  },
  shouldSkipSisenseContextWaiting: !0
})((e) => {
  const { theme: t, children: n } = e, [r, o] = vxe(t);
  if (o)
    throw o;
  return /* @__PURE__ */ z(fo, { children: r && /* @__PURE__ */ z(xI.Provider, { value: { themeSettings: r }, children: /* @__PURE__ */ z(_xe, { children: n }) }) });
}), xxe = ({
  chartData: e,
  dataOptions: t,
  designOptions: n
}) => {
  var a;
  const r = it(null), o = it(null), { themeSettings: i } = Yn();
  return mt(() => {
    if (!o.current || !r.current)
      return;
    const s = new oxe(), c = lxe(
      e,
      n,
      t
    ), l = mxe(
      {
        type: n.indicatorType,
        numericSubtype: "numericSubtype" in n ? n.numericSubtype : void 0,
        forceTickerView: n.forceTickerView,
        tickerBarHeight: n.tickerBarHeight
      },
      {
        chartData: e,
        dataOptions: t,
        themeSettings: i
      }
    );
    s.render(
      o.current,
      c,
      l,
      r.current
    );
  }, [e, t, n, i]), /* @__PURE__ */ z(
    "div",
    {
      ref: r,
      style: {
        display: "flex",
        justifyContent: "center",
        width: "100%",
        height: "100%",
        alignItems: "center",
        backgroundColor: (a = i == null ? void 0 : i.chart) == null ? void 0 : a.backgroundColor
      },
      "aria-label": "indicator-root",
      children: /* @__PURE__ */ z("canvas", { ref: o })
    }
  );
}, Cxe = (e) => e.type === "indicator", Sxe = (e) => "min" in e, Txe = (e) => "indicatorComponents" in e, Exe = (e) => !!e.chartData && Cxe(e.chartData) && Sxe(e.dataOptions) && Txe(e.designOptions);
var q1 = { exports: {} };
/* @preserve
 * Leaflet 1.9.4, a JS library for interactive maps. https://leafletjs.com
 * (c) 2010-2023 Vladimir Agafonkin, (c) 2010-2011 CloudMade
 */
(function(e, t) {
  (function(n, r) {
    r(t);
  })(Ua, function(n) {
    var r = "1.9.4";
    function o(u) {
      var h, C, O, W;
      for (C = 1, O = arguments.length; C < O; C++) {
        W = arguments[C];
        for (h in W)
          u[h] = W[h];
      }
      return u;
    }
    var i = Object.create || /* @__PURE__ */ function() {
      function u() {
      }
      return function(h) {
        return u.prototype = h, new u();
      };
    }();
    function a(u, h) {
      var C = Array.prototype.slice;
      if (u.bind)
        return u.bind.apply(u, C.call(arguments, 1));
      var O = C.call(arguments, 2);
      return function() {
        return u.apply(h, O.length ? O.concat(C.call(arguments)) : arguments);
      };
    }
    var s = 0;
    function c(u) {
      return "_leaflet_id" in u || (u._leaflet_id = ++s), u._leaflet_id;
    }
    function l(u, h, C) {
      var O, W, Y, ie;
      return ie = function() {
        O = !1, W && (Y.apply(C, W), W = !1);
      }, Y = function() {
        O ? W = arguments : (u.apply(C, arguments), setTimeout(ie, h), O = !0);
      }, Y;
    }
    function d(u, h, C) {
      var O = h[1], W = h[0], Y = O - W;
      return u === O && C ? u : ((u - W) % Y + Y) % Y + W;
    }
    function f() {
      return !1;
    }
    function p(u, h) {
      if (h === !1)
        return u;
      var C = Math.pow(10, h === void 0 ? 6 : h);
      return Math.round(u * C) / C;
    }
    function m(u) {
      return u.trim ? u.trim() : u.replace(/^\s+|\s+$/g, "");
    }
    function v(u) {
      return m(u).split(/\s+/);
    }
    function g(u, h) {
      Object.prototype.hasOwnProperty.call(u, "options") || (u.options = u.options ? i(u.options) : {});
      for (var C in h)
        u.options[C] = h[C];
      return u.options;
    }
    function b(u, h, C) {
      var O = [];
      for (var W in u)
        O.push(encodeURIComponent(C ? W.toUpperCase() : W) + "=" + encodeURIComponent(u[W]));
      return (!h || h.indexOf("?") === -1 ? "?" : "&") + O.join("&");
    }
    var x = /\{ *([\w_ -]+) *\}/g;
    function T(u, h) {
      return u.replace(x, function(C, O) {
        var W = h[O];
        if (W === void 0)
          throw new Error("No value provided for variable " + C);
        return typeof W == "function" && (W = W(h)), W;
      });
    }
    var S = Array.isArray || function(u) {
      return Object.prototype.toString.call(u) === "[object Array]";
    };
    function _(u, h) {
      for (var C = 0; C < u.length; C++)
        if (u[C] === h)
          return C;
      return -1;
    }
    var w = "data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=";
    function k(u) {
      return window["webkit" + u] || window["moz" + u] || window["ms" + u];
    }
    var E = 0;
    function R(u) {
      var h = +/* @__PURE__ */ new Date(), C = Math.max(0, 16 - (h - E));
      return E = h + C, window.setTimeout(u, C);
    }
    var P = window.requestAnimationFrame || k("RequestAnimationFrame") || R, A = window.cancelAnimationFrame || k("CancelAnimationFrame") || k("CancelRequestAnimationFrame") || function(u) {
      window.clearTimeout(u);
    };
    function D(u, h, C) {
      if (C && P === R)
        u.call(h);
      else
        return P.call(window, a(u, h));
    }
    function N(u) {
      u && A.call(window, u);
    }
    var F = {
      __proto__: null,
      extend: o,
      create: i,
      bind: a,
      get lastId() {
        return s;
      },
      stamp: c,
      throttle: l,
      wrapNum: d,
      falseFn: f,
      formatNum: p,
      trim: m,
      splitWords: v,
      setOptions: g,
      getParamString: b,
      template: T,
      isArray: S,
      indexOf: _,
      emptyImageUrl: w,
      requestFn: P,
      cancelFn: A,
      requestAnimFrame: D,
      cancelAnimFrame: N
    };
    function $() {
    }
    $.extend = function(u) {
      var h = function() {
        g(this), this.initialize && this.initialize.apply(this, arguments), this.callInitHooks();
      }, C = h.__super__ = this.prototype, O = i(C);
      O.constructor = h, h.prototype = O;
      for (var W in this)
        Object.prototype.hasOwnProperty.call(this, W) && W !== "prototype" && W !== "__super__" && (h[W] = this[W]);
      return u.statics && o(h, u.statics), u.includes && (I(u.includes), o.apply(null, [O].concat(u.includes))), o(O, u), delete O.statics, delete O.includes, O.options && (O.options = C.options ? i(C.options) : {}, o(O.options, u.options)), O._initHooks = [], O.callInitHooks = function() {
        if (!this._initHooksCalled) {
          C.callInitHooks && C.callInitHooks.call(this), this._initHooksCalled = !0;
          for (var Y = 0, ie = O._initHooks.length; Y < ie; Y++)
            O._initHooks[Y].call(this);
        }
      }, h;
    }, $.include = function(u) {
      var h = this.prototype.options;
      return o(this.prototype, u), u.options && (this.prototype.options = h, this.mergeOptions(u.options)), this;
    }, $.mergeOptions = function(u) {
      return o(this.prototype.options, u), this;
    }, $.addInitHook = function(u) {
      var h = Array.prototype.slice.call(arguments, 1), C = typeof u == "function" ? u : function() {
        this[u].apply(this, h);
      };
      return this.prototype._initHooks = this.prototype._initHooks || [], this.prototype._initHooks.push(C), this;
    };
    function I(u) {
      if (!(typeof L == "undefined" || !L || !L.Mixin)) {
        u = S(u) ? u : [u];
        for (var h = 0; h < u.length; h++)
          u[h] === L.Mixin.Events && console.warn("Deprecated include of L.Mixin.Events: this property will be removed in future releases, please inherit from L.Evented instead.", new Error().stack);
      }
    }
    var j = {
      /* @method on(type: String, fn: Function, context?: Object): this
       * Adds a listener function (`fn`) to a particular event type of the object. You can optionally specify the context of the listener (object the this keyword will point to). You can also pass several space-separated types (e.g. `'click dblclick'`).
       *
       * @alternative
       * @method on(eventMap: Object): this
       * Adds a set of type/listener pairs, e.g. `{click: onClick, mousemove: onMouseMove}`
       */
      on: function(u, h, C) {
        if (typeof u == "object")
          for (var O in u)
            this._on(O, u[O], h);
        else {
          u = v(u);
          for (var W = 0, Y = u.length; W < Y; W++)
            this._on(u[W], h, C);
        }
        return this;
      },
      /* @method off(type: String, fn?: Function, context?: Object): this
       * Removes a previously added listener function. If no function is specified, it will remove all the listeners of that particular event from the object. Note that if you passed a custom context to `on`, you must pass the same context to `off` in order to remove the listener.
       *
       * @alternative
       * @method off(eventMap: Object): this
       * Removes a set of type/listener pairs.
       *
       * @alternative
       * @method off: this
       * Removes all listeners to all events on the object. This includes implicitly attached events.
       */
      off: function(u, h, C) {
        if (!arguments.length)
          delete this._events;
        else if (typeof u == "object")
          for (var O in u)
            this._off(O, u[O], h);
        else {
          u = v(u);
          for (var W = arguments.length === 1, Y = 0, ie = u.length; Y < ie; Y++)
            W ? this._off(u[Y]) : this._off(u[Y], h, C);
        }
        return this;
      },
      // attach listener (without syntactic sugar now)
      _on: function(u, h, C, O) {
        if (typeof h != "function") {
          console.warn("wrong listener type: " + typeof h);
          return;
        }
        if (this._listens(u, h, C) === !1) {
          C === this && (C = void 0);
          var W = { fn: h, ctx: C };
          O && (W.once = !0), this._events = this._events || {}, this._events[u] = this._events[u] || [], this._events[u].push(W);
        }
      },
      _off: function(u, h, C) {
        var O, W, Y;
        if (this._events && (O = this._events[u], !!O)) {
          if (arguments.length === 1) {
            if (this._firingCount)
              for (W = 0, Y = O.length; W < Y; W++)
                O[W].fn = f;
            delete this._events[u];
            return;
          }
          if (typeof h != "function") {
            console.warn("wrong listener type: " + typeof h);
            return;
          }
          var ie = this._listens(u, h, C);
          if (ie !== !1) {
            var de = O[ie];
            this._firingCount && (de.fn = f, this._events[u] = O = O.slice()), O.splice(ie, 1);
          }
        }
      },
      // @method fire(type: String, data?: Object, propagate?: Boolean): this
      // Fires an event of the specified type. You can optionally provide a data
      // object — the first argument of the listener function will contain its
      // properties. The event can optionally be propagated to event parents.
      fire: function(u, h, C) {
        if (!this.listens(u, C))
          return this;
        var O = o({}, h, {
          type: u,
          target: this,
          sourceTarget: h && h.sourceTarget || this
        });
        if (this._events) {
          var W = this._events[u];
          if (W) {
            this._firingCount = this._firingCount + 1 || 1;
            for (var Y = 0, ie = W.length; Y < ie; Y++) {
              var de = W[Y], he = de.fn;
              de.once && this.off(u, he, de.ctx), he.call(de.ctx || this, O);
            }
            this._firingCount--;
          }
        }
        return C && this._propagateEvent(O), this;
      },
      // @method listens(type: String, propagate?: Boolean): Boolean
      // @method listens(type: String, fn: Function, context?: Object, propagate?: Boolean): Boolean
      // Returns `true` if a particular event type has any listeners attached to it.
      // The verification can optionally be propagated, it will return `true` if parents have the listener attached to it.
      listens: function(u, h, C, O) {
        typeof u != "string" && console.warn('"string" type argument expected');
        var W = h;
        typeof h != "function" && (O = !!h, W = void 0, C = void 0);
        var Y = this._events && this._events[u];
        if (Y && Y.length && this._listens(u, W, C) !== !1)
          return !0;
        if (O) {
          for (var ie in this._eventParents)
            if (this._eventParents[ie].listens(u, h, C, O))
              return !0;
        }
        return !1;
      },
      // returns the index (number) or false
      _listens: function(u, h, C) {
        if (!this._events)
          return !1;
        var O = this._events[u] || [];
        if (!h)
          return !!O.length;
        C === this && (C = void 0);
        for (var W = 0, Y = O.length; W < Y; W++)
          if (O[W].fn === h && O[W].ctx === C)
            return W;
        return !1;
      },
      // @method once(…): this
      // Behaves as [`on(…)`](#evented-on), except the listener will only get fired once and then removed.
      once: function(u, h, C) {
        if (typeof u == "object")
          for (var O in u)
            this._on(O, u[O], h, !0);
        else {
          u = v(u);
          for (var W = 0, Y = u.length; W < Y; W++)
            this._on(u[W], h, C, !0);
        }
        return this;
      },
      // @method addEventParent(obj: Evented): this
      // Adds an event parent - an `Evented` that will receive propagated events
      addEventParent: function(u) {
        return this._eventParents = this._eventParents || {}, this._eventParents[c(u)] = u, this;
      },
      // @method removeEventParent(obj: Evented): this
      // Removes an event parent, so it will stop receiving propagated events
      removeEventParent: function(u) {
        return this._eventParents && delete this._eventParents[c(u)], this;
      },
      _propagateEvent: function(u) {
        for (var h in this._eventParents)
          this._eventParents[h].fire(u.type, o({
            layer: u.target,
            propagatedFrom: u.target
          }, u), !0);
      }
    };
    j.addEventListener = j.on, j.removeEventListener = j.clearAllEventListeners = j.off, j.addOneTimeEventListener = j.once, j.fireEvent = j.fire, j.hasEventListeners = j.listens;
    var U = $.extend(j);
    function G(u, h, C) {
      this.x = C ? Math.round(u) : u, this.y = C ? Math.round(h) : h;
    }
    var V = Math.trunc || function(u) {
      return u > 0 ? Math.floor(u) : Math.ceil(u);
    };
    G.prototype = {
      // @method clone(): Point
      // Returns a copy of the current point.
      clone: function() {
        return new G(this.x, this.y);
      },
      // @method add(otherPoint: Point): Point
      // Returns the result of addition of the current and the given points.
      add: function(u) {
        return this.clone()._add(H(u));
      },
      _add: function(u) {
        return this.x += u.x, this.y += u.y, this;
      },
      // @method subtract(otherPoint: Point): Point
      // Returns the result of subtraction of the given point from the current.
      subtract: function(u) {
        return this.clone()._subtract(H(u));
      },
      _subtract: function(u) {
        return this.x -= u.x, this.y -= u.y, this;
      },
      // @method divideBy(num: Number): Point
      // Returns the result of division of the current point by the given number.
      divideBy: function(u) {
        return this.clone()._divideBy(u);
      },
      _divideBy: function(u) {
        return this.x /= u, this.y /= u, this;
      },
      // @method multiplyBy(num: Number): Point
      // Returns the result of multiplication of the current point by the given number.
      multiplyBy: function(u) {
        return this.clone()._multiplyBy(u);
      },
      _multiplyBy: function(u) {
        return this.x *= u, this.y *= u, this;
      },
      // @method scaleBy(scale: Point): Point
      // Multiply each coordinate of the current point by each coordinate of
      // `scale`. In linear algebra terms, multiply the point by the
      // [scaling matrix](https://en.wikipedia.org/wiki/Scaling_%28geometry%29#Matrix_representation)
      // defined by `scale`.
      scaleBy: function(u) {
        return new G(this.x * u.x, this.y * u.y);
      },
      // @method unscaleBy(scale: Point): Point
      // Inverse of `scaleBy`. Divide each coordinate of the current point by
      // each coordinate of `scale`.
      unscaleBy: function(u) {
        return new G(this.x / u.x, this.y / u.y);
      },
      // @method round(): Point
      // Returns a copy of the current point with rounded coordinates.
      round: function() {
        return this.clone()._round();
      },
      _round: function() {
        return this.x = Math.round(this.x), this.y = Math.round(this.y), this;
      },
      // @method floor(): Point
      // Returns a copy of the current point with floored coordinates (rounded down).
      floor: function() {
        return this.clone()._floor();
      },
      _floor: function() {
        return this.x = Math.floor(this.x), this.y = Math.floor(this.y), this;
      },
      // @method ceil(): Point
      // Returns a copy of the current point with ceiled coordinates (rounded up).
      ceil: function() {
        return this.clone()._ceil();
      },
      _ceil: function() {
        return this.x = Math.ceil(this.x), this.y = Math.ceil(this.y), this;
      },
      // @method trunc(): Point
      // Returns a copy of the current point with truncated coordinates (rounded towards zero).
      trunc: function() {
        return this.clone()._trunc();
      },
      _trunc: function() {
        return this.x = V(this.x), this.y = V(this.y), this;
      },
      // @method distanceTo(otherPoint: Point): Number
      // Returns the cartesian distance between the current and the given points.
      distanceTo: function(u) {
        u = H(u);
        var h = u.x - this.x, C = u.y - this.y;
        return Math.sqrt(h * h + C * C);
      },
      // @method equals(otherPoint: Point): Boolean
      // Returns `true` if the given point has the same coordinates.
      equals: function(u) {
        return u = H(u), u.x === this.x && u.y === this.y;
      },
      // @method contains(otherPoint: Point): Boolean
      // Returns `true` if both coordinates of the given point are less than the corresponding current point coordinates (in absolute values).
      contains: function(u) {
        return u = H(u), Math.abs(u.x) <= Math.abs(this.x) && Math.abs(u.y) <= Math.abs(this.y);
      },
      // @method toString(): String
      // Returns a string representation of the point for debugging purposes.
      toString: function() {
        return "Point(" + p(this.x) + ", " + p(this.y) + ")";
      }
    };
    function H(u, h, C) {
      return u instanceof G ? u : S(u) ? new G(u[0], u[1]) : u == null ? u : typeof u == "object" && "x" in u && "y" in u ? new G(u.x, u.y) : new G(u, h, C);
    }
    function q(u, h) {
      if (u)
        for (var C = h ? [u, h] : u, O = 0, W = C.length; O < W; O++)
          this.extend(C[O]);
    }
    q.prototype = {
      // @method extend(point: Point): this
      // Extends the bounds to contain the given point.
      // @alternative
      // @method extend(otherBounds: Bounds): this
      // Extend the bounds to contain the given bounds
      extend: function(u) {
        var h, C;
        if (!u)
          return this;
        if (u instanceof G || typeof u[0] == "number" || "x" in u)
          h = C = H(u);
        else if (u = Q(u), h = u.min, C = u.max, !h || !C)
          return this;
        return !this.min && !this.max ? (this.min = h.clone(), this.max = C.clone()) : (this.min.x = Math.min(h.x, this.min.x), this.max.x = Math.max(C.x, this.max.x), this.min.y = Math.min(h.y, this.min.y), this.max.y = Math.max(C.y, this.max.y)), this;
      },
      // @method getCenter(round?: Boolean): Point
      // Returns the center point of the bounds.
      getCenter: function(u) {
        return H(
          (this.min.x + this.max.x) / 2,
          (this.min.y + this.max.y) / 2,
          u
        );
      },
      // @method getBottomLeft(): Point
      // Returns the bottom-left point of the bounds.
      getBottomLeft: function() {
        return H(this.min.x, this.max.y);
      },
      // @method getTopRight(): Point
      // Returns the top-right point of the bounds.
      getTopRight: function() {
        return H(this.max.x, this.min.y);
      },
      // @method getTopLeft(): Point
      // Returns the top-left point of the bounds (i.e. [`this.min`](#bounds-min)).
      getTopLeft: function() {
        return this.min;
      },
      // @method getBottomRight(): Point
      // Returns the bottom-right point of the bounds (i.e. [`this.max`](#bounds-max)).
      getBottomRight: function() {
        return this.max;
      },
      // @method getSize(): Point
      // Returns the size of the given bounds
      getSize: function() {
        return this.max.subtract(this.min);
      },
      // @method contains(otherBounds: Bounds): Boolean
      // Returns `true` if the rectangle contains the given one.
      // @alternative
      // @method contains(point: Point): Boolean
      // Returns `true` if the rectangle contains the given point.
      contains: function(u) {
        var h, C;
        return typeof u[0] == "number" || u instanceof G ? u = H(u) : u = Q(u), u instanceof q ? (h = u.min, C = u.max) : h = C = u, h.x >= this.min.x && C.x <= this.max.x && h.y >= this.min.y && C.y <= this.max.y;
      },
      // @method intersects(otherBounds: Bounds): Boolean
      // Returns `true` if the rectangle intersects the given bounds. Two bounds
      // intersect if they have at least one point in common.
      intersects: function(u) {
        u = Q(u);
        var h = this.min, C = this.max, O = u.min, W = u.max, Y = W.x >= h.x && O.x <= C.x, ie = W.y >= h.y && O.y <= C.y;
        return Y && ie;
      },
      // @method overlaps(otherBounds: Bounds): Boolean
      // Returns `true` if the rectangle overlaps the given bounds. Two bounds
      // overlap if their intersection is an area.
      overlaps: function(u) {
        u = Q(u);
        var h = this.min, C = this.max, O = u.min, W = u.max, Y = W.x > h.x && O.x < C.x, ie = W.y > h.y && O.y < C.y;
        return Y && ie;
      },
      // @method isValid(): Boolean
      // Returns `true` if the bounds are properly initialized.
      isValid: function() {
        return !!(this.min && this.max);
      },
      // @method pad(bufferRatio: Number): Bounds
      // Returns bounds created by extending or retracting the current bounds by a given ratio in each direction.
      // For example, a ratio of 0.5 extends the bounds by 50% in each direction.
      // Negative values will retract the bounds.
      pad: function(u) {
        var h = this.min, C = this.max, O = Math.abs(h.x - C.x) * u, W = Math.abs(h.y - C.y) * u;
        return Q(
          H(h.x - O, h.y - W),
          H(C.x + O, C.y + W)
        );
      },
      // @method equals(otherBounds: Bounds): Boolean
      // Returns `true` if the rectangle is equivalent to the given bounds.
      equals: function(u) {
        return u ? (u = Q(u), this.min.equals(u.getTopLeft()) && this.max.equals(u.getBottomRight())) : !1;
      }
    };
    function Q(u, h) {
      return !u || u instanceof q ? u : new q(u, h);
    }
    function X(u, h) {
      if (u)
        for (var C = h ? [u, h] : u, O = 0, W = C.length; O < W; O++)
          this.extend(C[O]);
    }
    X.prototype = {
      // @method extend(latlng: LatLng): this
      // Extend the bounds to contain the given point
      // @alternative
      // @method extend(otherBounds: LatLngBounds): this
      // Extend the bounds to contain the given bounds
      extend: function(u) {
        var h = this._southWest, C = this._northEast, O, W;
        if (u instanceof J)
          O = u, W = u;
        else if (u instanceof X) {
          if (O = u._southWest, W = u._northEast, !O || !W)
            return this;
        } else
          return u ? this.extend(ne(u) || K(u)) : this;
        return !h && !C ? (this._southWest = new J(O.lat, O.lng), this._northEast = new J(W.lat, W.lng)) : (h.lat = Math.min(O.lat, h.lat), h.lng = Math.min(O.lng, h.lng), C.lat = Math.max(W.lat, C.lat), C.lng = Math.max(W.lng, C.lng)), this;
      },
      // @method pad(bufferRatio: Number): LatLngBounds
      // Returns bounds created by extending or retracting the current bounds by a given ratio in each direction.
      // For example, a ratio of 0.5 extends the bounds by 50% in each direction.
      // Negative values will retract the bounds.
      pad: function(u) {
        var h = this._southWest, C = this._northEast, O = Math.abs(h.lat - C.lat) * u, W = Math.abs(h.lng - C.lng) * u;
        return new X(
          new J(h.lat - O, h.lng - W),
          new J(C.lat + O, C.lng + W)
        );
      },
      // @method getCenter(): LatLng
      // Returns the center point of the bounds.
      getCenter: function() {
        return new J(
          (this._southWest.lat + this._northEast.lat) / 2,
          (this._southWest.lng + this._northEast.lng) / 2
        );
      },
      // @method getSouthWest(): LatLng
      // Returns the south-west point of the bounds.
      getSouthWest: function() {
        return this._southWest;
      },
      // @method getNorthEast(): LatLng
      // Returns the north-east point of the bounds.
      getNorthEast: function() {
        return this._northEast;
      },
      // @method getNorthWest(): LatLng
      // Returns the north-west point of the bounds.
      getNorthWest: function() {
        return new J(this.getNorth(), this.getWest());
      },
      // @method getSouthEast(): LatLng
      // Returns the south-east point of the bounds.
      getSouthEast: function() {
        return new J(this.getSouth(), this.getEast());
      },
      // @method getWest(): Number
      // Returns the west longitude of the bounds
      getWest: function() {
        return this._southWest.lng;
      },
      // @method getSouth(): Number
      // Returns the south latitude of the bounds
      getSouth: function() {
        return this._southWest.lat;
      },
      // @method getEast(): Number
      // Returns the east longitude of the bounds
      getEast: function() {
        return this._northEast.lng;
      },
      // @method getNorth(): Number
      // Returns the north latitude of the bounds
      getNorth: function() {
        return this._northEast.lat;
      },
      // @method contains(otherBounds: LatLngBounds): Boolean
      // Returns `true` if the rectangle contains the given one.
      // @alternative
      // @method contains (latlng: LatLng): Boolean
      // Returns `true` if the rectangle contains the given point.
      contains: function(u) {
        typeof u[0] == "number" || u instanceof J || "lat" in u ? u = ne(u) : u = K(u);
        var h = this._southWest, C = this._northEast, O, W;
        return u instanceof X ? (O = u.getSouthWest(), W = u.getNorthEast()) : O = W = u, O.lat >= h.lat && W.lat <= C.lat && O.lng >= h.lng && W.lng <= C.lng;
      },
      // @method intersects(otherBounds: LatLngBounds): Boolean
      // Returns `true` if the rectangle intersects the given bounds. Two bounds intersect if they have at least one point in common.
      intersects: function(u) {
        u = K(u);
        var h = this._southWest, C = this._northEast, O = u.getSouthWest(), W = u.getNorthEast(), Y = W.lat >= h.lat && O.lat <= C.lat, ie = W.lng >= h.lng && O.lng <= C.lng;
        return Y && ie;
      },
      // @method overlaps(otherBounds: LatLngBounds): Boolean
      // Returns `true` if the rectangle overlaps the given bounds. Two bounds overlap if their intersection is an area.
      overlaps: function(u) {
        u = K(u);
        var h = this._southWest, C = this._northEast, O = u.getSouthWest(), W = u.getNorthEast(), Y = W.lat > h.lat && O.lat < C.lat, ie = W.lng > h.lng && O.lng < C.lng;
        return Y && ie;
      },
      // @method toBBoxString(): String
      // Returns a string with bounding box coordinates in a 'southwest_lng,southwest_lat,northeast_lng,northeast_lat' format. Useful for sending requests to web services that return geo data.
      toBBoxString: function() {
        return [this.getWest(), this.getSouth(), this.getEast(), this.getNorth()].join(",");
      },
      // @method equals(otherBounds: LatLngBounds, maxMargin?: Number): Boolean
      // Returns `true` if the rectangle is equivalent (within a small margin of error) to the given bounds. The margin of error can be overridden by setting `maxMargin` to a small number.
      equals: function(u, h) {
        return u ? (u = K(u), this._southWest.equals(u.getSouthWest(), h) && this._northEast.equals(u.getNorthEast(), h)) : !1;
      },
      // @method isValid(): Boolean
      // Returns `true` if the bounds are properly initialized.
      isValid: function() {
        return !!(this._southWest && this._northEast);
      }
    };
    function K(u, h) {
      return u instanceof X ? u : new X(u, h);
    }
    function J(u, h, C) {
      if (isNaN(u) || isNaN(h))
        throw new Error("Invalid LatLng object: (" + u + ", " + h + ")");
      this.lat = +u, this.lng = +h, C !== void 0 && (this.alt = +C);
    }
    J.prototype = {
      // @method equals(otherLatLng: LatLng, maxMargin?: Number): Boolean
      // Returns `true` if the given `LatLng` point is at the same position (within a small margin of error). The margin of error can be overridden by setting `maxMargin` to a small number.
      equals: function(u, h) {
        if (!u)
          return !1;
        u = ne(u);
        var C = Math.max(
          Math.abs(this.lat - u.lat),
          Math.abs(this.lng - u.lng)
        );
        return C <= (h === void 0 ? 1e-9 : h);
      },
      // @method toString(): String
      // Returns a string representation of the point (for debugging purposes).
      toString: function(u) {
        return "LatLng(" + p(this.lat, u) + ", " + p(this.lng, u) + ")";
      },
      // @method distanceTo(otherLatLng: LatLng): Number
      // Returns the distance (in meters) to the given `LatLng` calculated using the [Spherical Law of Cosines](https://en.wikipedia.org/wiki/Spherical_law_of_cosines).
      distanceTo: function(u) {
        return te.distance(this, ne(u));
      },
      // @method wrap(): LatLng
      // Returns a new `LatLng` object with the longitude wrapped so it's always between -180 and +180 degrees.
      wrap: function() {
        return te.wrapLatLng(this);
      },
      // @method toBounds(sizeInMeters: Number): LatLngBounds
      // Returns a new `LatLngBounds` object in which each boundary is `sizeInMeters/2` meters apart from the `LatLng`.
      toBounds: function(u) {
        var h = 180 * u / 40075017, C = h / Math.cos(Math.PI / 180 * this.lat);
        return K(
          [this.lat - h, this.lng - C],
          [this.lat + h, this.lng + C]
        );
      },
      clone: function() {
        return new J(this.lat, this.lng, this.alt);
      }
    };
    function ne(u, h, C) {
      return u instanceof J ? u : S(u) && typeof u[0] != "object" ? u.length === 3 ? new J(u[0], u[1], u[2]) : u.length === 2 ? new J(u[0], u[1]) : null : u == null ? u : typeof u == "object" && "lat" in u ? new J(u.lat, "lng" in u ? u.lng : u.lon, u.alt) : h === void 0 ? null : new J(u, h, C);
    }
    var ae = {
      // @method latLngToPoint(latlng: LatLng, zoom: Number): Point
      // Projects geographical coordinates into pixel coordinates for a given zoom.
      latLngToPoint: function(u, h) {
        var C = this.projection.project(u), O = this.scale(h);
        return this.transformation._transform(C, O);
      },
      // @method pointToLatLng(point: Point, zoom: Number): LatLng
      // The inverse of `latLngToPoint`. Projects pixel coordinates on a given
      // zoom into geographical coordinates.
      pointToLatLng: function(u, h) {
        var C = this.scale(h), O = this.transformation.untransform(u, C);
        return this.projection.unproject(O);
      },
      // @method project(latlng: LatLng): Point
      // Projects geographical coordinates into coordinates in units accepted for
      // this CRS (e.g. meters for EPSG:3857, for passing it to WMS services).
      project: function(u) {
        return this.projection.project(u);
      },
      // @method unproject(point: Point): LatLng
      // Given a projected coordinate returns the corresponding LatLng.
      // The inverse of `project`.
      unproject: function(u) {
        return this.projection.unproject(u);
      },
      // @method scale(zoom: Number): Number
      // Returns the scale used when transforming projected coordinates into
      // pixel coordinates for a particular zoom. For example, it returns
      // `256 * 2^zoom` for Mercator-based CRS.
      scale: function(u) {
        return 256 * Math.pow(2, u);
      },
      // @method zoom(scale: Number): Number
      // Inverse of `scale()`, returns the zoom level corresponding to a scale
      // factor of `scale`.
      zoom: function(u) {
        return Math.log(u / 256) / Math.LN2;
      },
      // @method getProjectedBounds(zoom: Number): Bounds
      // Returns the projection's bounds scaled and transformed for the provided `zoom`.
      getProjectedBounds: function(u) {
        if (this.infinite)
          return null;
        var h = this.projection.bounds, C = this.scale(u), O = this.transformation.transform(h.min, C), W = this.transformation.transform(h.max, C);
        return new q(O, W);
      },
      // @method distance(latlng1: LatLng, latlng2: LatLng): Number
      // Returns the distance between two geographical coordinates.
      // @property code: String
      // Standard code name of the CRS passed into WMS services (e.g. `'EPSG:3857'`)
      //
      // @property wrapLng: Number[]
      // An array of two numbers defining whether the longitude (horizontal) coordinate
      // axis wraps around a given range and how. Defaults to `[-180, 180]` in most
      // geographical CRSs. If `undefined`, the longitude axis does not wrap around.
      //
      // @property wrapLat: Number[]
      // Like `wrapLng`, but for the latitude (vertical) axis.
      // wrapLng: [min, max],
      // wrapLat: [min, max],
      // @property infinite: Boolean
      // If true, the coordinate space will be unbounded (infinite in both axes)
      infinite: !1,
      // @method wrapLatLng(latlng: LatLng): LatLng
      // Returns a `LatLng` where lat and lng has been wrapped according to the
      // CRS's `wrapLat` and `wrapLng` properties, if they are outside the CRS's bounds.
      wrapLatLng: function(u) {
        var h = this.wrapLng ? d(u.lng, this.wrapLng, !0) : u.lng, C = this.wrapLat ? d(u.lat, this.wrapLat, !0) : u.lat, O = u.alt;
        return new J(C, h, O);
      },
      // @method wrapLatLngBounds(bounds: LatLngBounds): LatLngBounds
      // Returns a `LatLngBounds` with the same size as the given one, ensuring
      // that its center is within the CRS's bounds.
      // Only accepts actual `L.LatLngBounds` instances, not arrays.
      wrapLatLngBounds: function(u) {
        var h = u.getCenter(), C = this.wrapLatLng(h), O = h.lat - C.lat, W = h.lng - C.lng;
        if (O === 0 && W === 0)
          return u;
        var Y = u.getSouthWest(), ie = u.getNorthEast(), de = new J(Y.lat - O, Y.lng - W), he = new J(ie.lat - O, ie.lng - W);
        return new X(de, he);
      }
    }, te = o({}, ae, {
      wrapLng: [-180, 180],
      // Mean Earth Radius, as recommended for use by
      // the International Union of Geodesy and Geophysics,
      // see https://rosettacode.org/wiki/Haversine_formula
      R: 6371e3,
      // distance between two geographical points using spherical law of cosines approximation
      distance: function(u, h) {
        var C = Math.PI / 180, O = u.lat * C, W = h.lat * C, Y = Math.sin((h.lat - u.lat) * C / 2), ie = Math.sin((h.lng - u.lng) * C / 2), de = Y * Y + Math.cos(O) * Math.cos(W) * ie * ie, he = 2 * Math.atan2(Math.sqrt(de), Math.sqrt(1 - de));
        return this.R * he;
      }
    }), le = 6378137, ce = {
      R: le,
      MAX_LATITUDE: 85.0511287798,
      project: function(u) {
        var h = Math.PI / 180, C = this.MAX_LATITUDE, O = Math.max(Math.min(C, u.lat), -C), W = Math.sin(O * h);
        return new G(
          this.R * u.lng * h,
          this.R * Math.log((1 + W) / (1 - W)) / 2
        );
      },
      unproject: function(u) {
        var h = 180 / Math.PI;
        return new J(
          (2 * Math.atan(Math.exp(u.y / this.R)) - Math.PI / 2) * h,
          u.x * h / this.R
        );
      },
      bounds: function() {
        var u = le * Math.PI;
        return new q([-u, -u], [u, u]);
      }()
    };
    function fe(u, h, C, O) {
      if (S(u)) {
        this._a = u[0], this._b = u[1], this._c = u[2], this._d = u[3];
        return;
      }
      this._a = u, this._b = h, this._c = C, this._d = O;
    }
    fe.prototype = {
      // @method transform(point: Point, scale?: Number): Point
      // Returns a transformed point, optionally multiplied by the given scale.
      // Only accepts actual `L.Point` instances, not arrays.
      transform: function(u, h) {
        return this._transform(u.clone(), h);
      },
      // destructive transform (faster)
      _transform: function(u, h) {
        return h = h || 1, u.x = h * (this._a * u.x + this._b), u.y = h * (this._c * u.y + this._d), u;
      },
      // @method untransform(point: Point, scale?: Number): Point
      // Returns the reverse transformation of the given point, optionally divided
      // by the given scale. Only accepts actual `L.Point` instances, not arrays.
      untransform: function(u, h) {
        return h = h || 1, new G(
          (u.x / h - this._b) / this._a,
          (u.y / h - this._d) / this._c
        );
      }
    };
    function ee(u, h, C, O) {
      return new fe(u, h, C, O);
    }
    var me = o({}, te, {
      code: "EPSG:3857",
      projection: ce,
      transformation: function() {
        var u = 0.5 / (Math.PI * ce.R);
        return ee(u, 0.5, -u, 0.5);
      }()
    }), oe = o({}, me, {
      code: "EPSG:900913"
    });
    function ve(u) {
      return document.createElementNS("http://www.w3.org/2000/svg", u);
    }
    function we(u, h) {
      var C = "", O, W, Y, ie, de, he;
      for (O = 0, Y = u.length; O < Y; O++) {
        for (de = u[O], W = 0, ie = de.length; W < ie; W++)
          he = de[W], C += (W ? "L" : "M") + he.x + " " + he.y;
        C += h ? ke.svg ? "z" : "x" : "";
      }
      return C || "M0 0";
    }
    var ye = document.documentElement.style, Ce = "ActiveXObject" in window, Se = Ce && !document.addEventListener, Te = "msLaunchUri" in navigator && !("documentMode" in document), Ae = Zt("webkit"), je = Zt("android"), Me = Zt("android 2") || Zt("android 3"), ze = parseInt(/WebKit\/([0-9]+)|$/.exec(navigator.userAgent)[1], 10), ft = je && Zt("Google") && ze < 537 && !("AudioNode" in window), Ue = !!window.opera, Be = !Te && Zt("chrome"), Pe = Zt("gecko") && !Ae && !Ue && !Ce, Ee = !Be && Zt("safari"), st = Zt("phantom"), Vt = "OTransition" in ye, Ct = navigator.platform.indexOf("Win") === 0, Ne = Ce && "transition" in ye, Ve = "WebKitCSSMatrix" in window && "m11" in new window.WebKitCSSMatrix() && !Me, ut = "MozPerspective" in ye, Ut = !window.L_DISABLE_3D && (Ne || Ve || ut) && !Vt && !st, St = typeof orientation != "undefined" || Zt("mobile"), Zn = St && Ae, Cn = St && Ve, an = !window.PointerEvent && window.MSPointerEvent, xr = !!(window.PointerEvent || an), Vn = "ontouchstart" in window || !!window.TouchEvent, An = !window.L_NO_TOUCH && (Vn || xr), kt = St && Ue, Tt = St && Pe, Nt = (window.devicePixelRatio || window.screen.deviceXDPI / window.screen.logicalXDPI) > 1, Cr = function() {
      var u = !1;
      try {
        var h = Object.defineProperty({}, "passive", {
          get: function() {
            u = !0;
          }
        });
        window.addEventListener("testPassiveEventSupport", f, h), window.removeEventListener("testPassiveEventSupport", f, h);
      } catch (C) {
      }
      return u;
    }(), Xn = function() {
      return !!document.createElement("canvas").getContext;
    }(), mn = !!(document.createElementNS && ve("svg").createSVGRect), Kn = !!mn && function() {
      var u = document.createElement("div");
      return u.innerHTML = "<svg/>", (u.firstChild && u.firstChild.namespaceURI) === "http://www.w3.org/2000/svg";
    }(), Un = !mn && function() {
      try {
        var u = document.createElement("div");
        u.innerHTML = '<v:shape adj="1"/>';
        var h = u.firstChild;
        return h.style.behavior = "url(#default#VML)", h && typeof h.adj == "object";
      } catch (C) {
        return !1;
      }
    }(), Bt = navigator.platform.indexOf("Mac") === 0, gt = navigator.platform.indexOf("Linux") === 0;
    function Zt(u) {
      return navigator.userAgent.toLowerCase().indexOf(u) >= 0;
    }
    var ke = {
      ie: Ce,
      ielt9: Se,
      edge: Te,
      webkit: Ae,
      android: je,
      android23: Me,
      androidStock: ft,
      opera: Ue,
      chrome: Be,
      gecko: Pe,
      safari: Ee,
      phantom: st,
      opera12: Vt,
      win: Ct,
      ie3d: Ne,
      webkit3d: Ve,
      gecko3d: ut,
      any3d: Ut,
      mobile: St,
      mobileWebkit: Zn,
      mobileWebkit3d: Cn,
      msPointer: an,
      pointer: xr,
      touch: An,
      touchNative: Vn,
      mobileOpera: kt,
      mobileGecko: Tt,
      retina: Nt,
      passiveEvents: Cr,
      canvas: Xn,
      svg: mn,
      vml: Un,
      inlineSvg: Kn,
      mac: Bt,
      linux: gt
    }, gn = ke.msPointer ? "MSPointerDown" : "pointerdown", ir = ke.msPointer ? "MSPointerMove" : "pointermove", Jn = ke.msPointer ? "MSPointerUp" : "pointerup", qn = ke.msPointer ? "MSPointerCancel" : "pointercancel", Sn = {
      touchstart: gn,
      touchmove: ir,
      touchend: Jn,
      touchcancel: qn
    }, Qn = {
      touchstart: hl,
      touchmove: Gi,
      touchend: Gi,
      touchcancel: Gi
    }, er = {}, mr = !1;
    function Ir(u, h, C) {
      return h === "touchstart" && uu(), Qn[h] ? (C = Qn[h].bind(this, C), u.addEventListener(Sn[h], C, !1), C) : (console.warn("wrong event specified:", h), f);
    }
    function Ye(u, h, C) {
      if (!Sn[h]) {
        console.warn("wrong event specified:", h);
        return;
      }
      u.removeEventListener(Sn[h], C, !1);
    }
    function Le(u) {
      er[u.pointerId] = u;
    }
    function dn(u) {
      er[u.pointerId] && (er[u.pointerId] = u);
    }
    function ar(u) {
      delete er[u.pointerId];
    }
    function uu() {
      mr || (document.addEventListener(gn, Le, !0), document.addEventListener(ir, dn, !0), document.addEventListener(Jn, ar, !0), document.addEventListener(qn, ar, !0), mr = !0);
    }
    function Gi(u, h) {
      if (h.pointerType !== (h.MSPOINTER_TYPE_MOUSE || "mouse")) {
        h.touches = [];
        for (var C in er)
          h.touches.push(er[C]);
        h.changedTouches = [h], u(h);
      }
    }
    function hl(u, h) {
      h.MSPOINTER_TYPE_TOUCH && h.pointerType === h.MSPOINTER_TYPE_TOUCH && vn(h), Gi(u, h);
    }
    function Yi(u) {
      var h = {}, C, O;
      for (O in u)
        C = u[O], h[O] = C && C.bind ? C.bind(u) : C;
      return u = h, h.type = "dblclick", h.detail = 2, h.isTrusted = !1, h._simulated = !0, h;
    }
    var ml = 200;
    function du(u, h) {
      u.addEventListener("dblclick", h);
      var C = 0, O;
      function W(Y) {
        if (Y.detail !== 1) {
          O = Y.detail;
          return;
        }
        if (!(Y.pointerType === "mouse" || Y.sourceCapabilities && !Y.sourceCapabilities.firesTouchEvents)) {
          var ie = eC(Y);
          if (!(ie.some(function(he) {
            return he instanceof HTMLLabelElement && he.attributes.for;
          }) && !ie.some(function(he) {
            return he instanceof HTMLInputElement || he instanceof HTMLSelectElement;
          }))) {
            var de = Date.now();
            de - C <= ml ? (O++, O === 2 && h(Yi(Y))) : O = 1, C = de;
          }
        }
      }
      return u.addEventListener("click", W), {
        dblclick: h,
        simDblclick: W
      };
    }
    function Zi(u, h) {
      u.removeEventListener("dblclick", h.dblclick), u.removeEventListener("click", h.simDblclick);
    }
    var Ta = Ea(
      ["transform", "webkitTransform", "OTransform", "MozTransform", "msTransform"]
    ), Xi = Ea(
      ["webkitTransition", "transition", "OTransition", "MozTransition", "msTransition"]
    ), Qr = Xi === "webkitTransition" || Xi === "OTransition" ? Xi + "End" : "transitionend";
    function yo(u) {
      return typeof u == "string" ? document.getElementById(u) : u;
    }
    function Qo(u, h) {
      var C = u.style[h] || u.currentStyle && u.currentStyle[h];
      if ((!C || C === "auto") && document.defaultView) {
        var O = document.defaultView.getComputedStyle(u, null);
        C = O ? O[h] : null;
      }
      return C === "auto" ? null : C;
    }
    function pt(u, h, C) {
      var O = document.createElement(u);
      return O.className = h || "", C && C.appendChild(O), O;
    }
    function Et(u) {
      var h = u.parentNode;
      h && h.removeChild(u);
    }
    function _o(u) {
      for (; u.firstChild; )
        u.removeChild(u.firstChild);
    }
    function wo(u) {
      var h = u.parentNode;
      h && h.lastChild !== u && h.appendChild(u);
    }
    function eo(u) {
      var h = u.parentNode;
      h && h.firstChild !== u && h.insertBefore(u, h.firstChild);
    }
    function to(u, h) {
      if (u.classList !== void 0)
        return u.classList.contains(h);
      var C = Ki(u);
      return C.length > 0 && new RegExp("(^|\\s)" + h + "(\\s|$)").test(C);
    }
    function tt(u, h) {
      if (u.classList !== void 0)
        for (var C = v(h), O = 0, W = C.length; O < W; O++)
          u.classList.add(C[O]);
      else if (!to(u, h)) {
        var Y = Ki(u);
        xs(u, (Y ? Y + " " : "") + h);
      }
    }
    function Xt(u, h) {
      u.classList !== void 0 ? u.classList.remove(h) : xs(u, m((" " + Ki(u) + " ").replace(" " + h + " ", " ")));
    }
    function xs(u, h) {
      u.className.baseVal === void 0 ? u.className = h : u.className.baseVal = h;
    }
    function Ki(u) {
      return u.correspondingElement && (u = u.correspondingElement), u.className.baseVal === void 0 ? u.className : u.className.baseVal;
    }
    function gr(u, h) {
      "opacity" in u.style ? u.style.opacity = h : "filter" in u.style && fu(u, h);
    }
    function fu(u, h) {
      var C = !1, O = "DXImageTransform.Microsoft.Alpha";
      try {
        C = u.filters.item(O);
      } catch (W) {
        if (h === 1)
          return;
      }
      h = Math.round(h * 100), C ? (C.Enabled = h !== 100, C.Opacity = h) : u.style.filter += " progid:" + O + "(opacity=" + h + ")";
    }
    function Ea(u) {
      for (var h = document.documentElement.style, C = 0; C < u.length; C++)
        if (u[C] in h)
          return u[C];
      return !1;
    }
    function xo(u, h, C) {
      var O = h || new G(0, 0);
      u.style[Ta] = (ke.ie3d ? "translate(" + O.x + "px," + O.y + "px)" : "translate3d(" + O.x + "px," + O.y + "px,0)") + (C ? " scale(" + C + ")" : "");
    }
    function sn(u, h) {
      u._leaflet_pos = h, ke.any3d ? xo(u, h) : (u.style.left = h.x + "px", u.style.top = h.y + "px");
    }
    function ei(u) {
      return u._leaflet_pos || new G(0, 0);
    }
    var di, tr, ka;
    if ("onselectstart" in document)
      di = function() {
        Ze(window, "selectstart", vn);
      }, tr = function() {
        xe(window, "selectstart", vn);
      };
    else {
      var no = Ea(
        ["userSelect", "WebkitUserSelect", "OUserSelect", "MozUserSelect", "msUserSelect"]
      );
      di = function() {
        if (no) {
          var u = document.documentElement.style;
          ka = u[no], u[no] = "none";
        }
      }, tr = function() {
        no && (document.documentElement.style[no] = ka, ka = void 0);
      };
    }
    function Co() {
      Ze(window, "dragstart", vn);
    }
    function fi() {
      xe(window, "dragstart", vn);
    }
    var Ji, pi;
    function Ma(u) {
      for (; u.tabIndex === -1; )
        u = u.parentNode;
      u.style && (hi(), Ji = u, pi = u.style.outlineStyle, u.style.outlineStyle = "none", Ze(window, "keydown", hi));
    }
    function hi() {
      Ji && (Ji.style.outlineStyle = pi, Ji = void 0, pi = void 0, xe(window, "keydown", hi));
    }
    function Cs(u) {
      do
        u = u.parentNode;
      while ((!u.offsetWidth || !u.offsetHeight) && u !== document.body);
      return u;
    }
    function Ss(u) {
      var h = u.getBoundingClientRect();
      return {
        x: h.width / u.offsetWidth || 1,
        y: h.height / u.offsetHeight || 1,
        boundingClientRect: h
      };
    }
    var pu = {
      __proto__: null,
      TRANSFORM: Ta,
      TRANSITION: Xi,
      TRANSITION_END: Qr,
      get: yo,
      getStyle: Qo,
      create: pt,
      remove: Et,
      empty: _o,
      toFront: wo,
      toBack: eo,
      hasClass: to,
      addClass: tt,
      removeClass: Xt,
      setClass: xs,
      getClass: Ki,
      setOpacity: gr,
      testProp: Ea,
      setTransform: xo,
      setPosition: sn,
      getPosition: ei,
      get disableTextSelection() {
        return di;
      },
      get enableTextSelection() {
        return tr;
      },
      disableImageDrag: Co,
      enableImageDrag: fi,
      preventOutline: Ma,
      restoreOutline: hi,
      getSizedParentNode: Cs,
      getScale: Ss
    };
    function Ze(u, h, C, O) {
      if (h && typeof h == "object")
        for (var W in h)
          Tn(u, W, h[W], C);
      else {
        h = v(h);
        for (var Y = 0, ie = h.length; Y < ie; Y++)
          Tn(u, h[Y], C, O);
      }
      return this;
    }
    var So = "_leaflet_events";
    function xe(u, h, C, O) {
      if (arguments.length === 1)
        ht(u), delete u[So];
      else if (h && typeof h == "object")
        for (var W in h)
          Kt(u, W, h[W], C);
      else if (h = v(h), arguments.length === 2)
        ht(u, function(de) {
          return _(h, de) !== -1;
        });
      else
        for (var Y = 0, ie = h.length; Y < ie; Y++)
          Kt(u, h[Y], C, O);
      return this;
    }
    function ht(u, h) {
      for (var C in u[So]) {
        var O = C.split(/\d/)[0];
        (!h || h(O)) && Kt(u, O, null, null, C);
      }
    }
    var Dn = {
      mouseenter: "mouseover",
      mouseleave: "mouseout",
      wheel: !("onwheel" in window) && "mousewheel"
    };
    function Tn(u, h, C, O) {
      var W = h + c(C) + (O ? "_" + c(O) : "");
      if (u[So] && u[So][W])
        return this;
      var Y = function(de) {
        return C.call(O || u, de || window.event);
      }, ie = Y;
      !ke.touchNative && ke.pointer && h.indexOf("touch") === 0 ? Y = Ir(u, h, Y) : ke.touch && h === "dblclick" ? Y = du(u, Y) : "addEventListener" in u ? h === "touchstart" || h === "touchmove" || h === "wheel" || h === "mousewheel" ? u.addEventListener(Dn[h] || h, Y, ke.passiveEvents ? { passive: !1 } : !1) : h === "mouseenter" || h === "mouseleave" ? (Y = function(de) {
        de = de || window.event, cv(u, de) && ie(de);
      }, u.addEventListener(Dn[h], Y, !1)) : u.addEventListener(h, ie, !1) : u.attachEvent("on" + h, Y), u[So] = u[So] || {}, u[So][W] = Y;
    }
    function Kt(u, h, C, O, W) {
      W = W || h + c(C) + (O ? "_" + c(O) : "");
      var Y = u[So] && u[So][W];
      if (!Y)
        return this;
      !ke.touchNative && ke.pointer && h.indexOf("touch") === 0 ? Ye(u, h, Y) : ke.touch && h === "dblclick" ? Zi(u, Y) : "removeEventListener" in u ? u.removeEventListener(Dn[h] || h, Y, !1) : u.detachEvent("on" + h, Y), u[So][W] = null;
    }
    function To(u) {
      return u.stopPropagation ? u.stopPropagation() : u.originalEvent ? u.originalEvent._stopped = !0 : u.cancelBubble = !0, this;
    }
    function Ts(u) {
      return Tn(u, "wheel", To), this;
    }
    function Ra(u) {
      return Ze(u, "mousedown touchstart dblclick contextmenu", To), u._leaflet_disable_click = !0, this;
    }
    function vn(u) {
      return u.preventDefault ? u.preventDefault() : u.returnValue = !1, this;
    }
    function Es(u) {
      return vn(u), To(u), this;
    }
    function eC(u) {
      if (u.composedPath)
        return u.composedPath();
      for (var h = [], C = u.target; C; )
        h.push(C), C = C.parentNode;
      return h;
    }
    function tC(u, h) {
      if (!h)
        return new G(u.clientX, u.clientY);
      var C = Ss(h), O = C.boundingClientRect;
      return new G(
        // offset.left/top values are in page scale (like clientX/Y),
        // whereas clientLeft/Top (border width) values are the original values (before CSS scale applies).
        (u.clientX - O.left) / C.x - h.clientLeft,
        (u.clientY - O.top) / C.y - h.clientTop
      );
    }
    var M6 = ke.linux && ke.chrome ? window.devicePixelRatio : ke.mac ? window.devicePixelRatio * 3 : window.devicePixelRatio > 0 ? 2 * window.devicePixelRatio : 1;
    function nC(u) {
      return ke.edge ? u.wheelDeltaY / 2 : (
        // Don't trust window-geometry-based delta
        u.deltaY && u.deltaMode === 0 ? -u.deltaY / M6 : (
          // Pixels
          u.deltaY && u.deltaMode === 1 ? -u.deltaY * 20 : (
            // Lines
            u.deltaY && u.deltaMode === 2 ? -u.deltaY * 60 : (
              // Pages
              u.deltaX || u.deltaZ ? 0 : (
                // Skip horizontal/depth wheel events
                u.wheelDelta ? (u.wheelDeltaY || u.wheelDelta) / 2 : (
                  // Legacy IE pixels
                  u.detail && Math.abs(u.detail) < 32765 ? -u.detail * 20 : (
                    // Legacy Moz lines
                    u.detail ? u.detail / -32765 * 60 : (
                      // Legacy Moz pages
                      0
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
    function cv(u, h) {
      var C = h.relatedTarget;
      if (!C)
        return !0;
      try {
        for (; C && C !== u; )
          C = C.parentNode;
      } catch (O) {
        return !1;
      }
      return C !== u;
    }
    var R6 = {
      __proto__: null,
      on: Ze,
      off: xe,
      stopPropagation: To,
      disableScrollPropagation: Ts,
      disableClickPropagation: Ra,
      preventDefault: vn,
      stop: Es,
      getPropagationPath: eC,
      getMousePosition: tC,
      getWheelDelta: nC,
      isExternalTarget: cv,
      addListener: Ze,
      removeListener: xe
    }, rC = U.extend({
      // @method run(el: HTMLElement, newPos: Point, duration?: Number, easeLinearity?: Number)
      // Run an animation of a given element to a new position, optionally setting
      // duration in seconds (`0.25` by default) and easing linearity factor (3rd
      // argument of the [cubic bezier curve](https://cubic-bezier.com/#0,0,.5,1),
      // `0.5` by default).
      run: function(u, h, C, O) {
        this.stop(), this._el = u, this._inProgress = !0, this._duration = C || 0.25, this._easeOutPower = 1 / Math.max(O || 0.5, 0.2), this._startPos = ei(u), this._offset = h.subtract(this._startPos), this._startTime = +/* @__PURE__ */ new Date(), this.fire("start"), this._animate();
      },
      // @method stop()
      // Stops the animation (if currently running).
      stop: function() {
        this._inProgress && (this._step(!0), this._complete());
      },
      _animate: function() {
        this._animId = D(this._animate, this), this._step();
      },
      _step: function(u) {
        var h = +/* @__PURE__ */ new Date() - this._startTime, C = this._duration * 1e3;
        h < C ? this._runFrame(this._easeOut(h / C), u) : (this._runFrame(1), this._complete());
      },
      _runFrame: function(u, h) {
        var C = this._startPos.add(this._offset.multiplyBy(u));
        h && C._round(), sn(this._el, C), this.fire("step");
      },
      _complete: function() {
        N(this._animId), this._inProgress = !1, this.fire("end");
      },
      _easeOut: function(u) {
        return 1 - Math.pow(1 - u, this._easeOutPower);
      }
    }), yt = U.extend({
      options: {
        // @section Map State Options
        // @option crs: CRS = L.CRS.EPSG3857
        // The [Coordinate Reference System](#crs) to use. Don't change this if you're not
        // sure what it means.
        crs: me,
        // @option center: LatLng = undefined
        // Initial geographic center of the map
        center: void 0,
        // @option zoom: Number = undefined
        // Initial map zoom level
        zoom: void 0,
        // @option minZoom: Number = *
        // Minimum zoom level of the map.
        // If not specified and at least one `GridLayer` or `TileLayer` is in the map,
        // the lowest of their `minZoom` options will be used instead.
        minZoom: void 0,
        // @option maxZoom: Number = *
        // Maximum zoom level of the map.
        // If not specified and at least one `GridLayer` or `TileLayer` is in the map,
        // the highest of their `maxZoom` options will be used instead.
        maxZoom: void 0,
        // @option layers: Layer[] = []
        // Array of layers that will be added to the map initially
        layers: [],
        // @option maxBounds: LatLngBounds = null
        // When this option is set, the map restricts the view to the given
        // geographical bounds, bouncing the user back if the user tries to pan
        // outside the view. To set the restriction dynamically, use
        // [`setMaxBounds`](#map-setmaxbounds) method.
        maxBounds: void 0,
        // @option renderer: Renderer = *
        // The default method for drawing vector layers on the map. `L.SVG`
        // or `L.Canvas` by default depending on browser support.
        renderer: void 0,
        // @section Animation Options
        // @option zoomAnimation: Boolean = true
        // Whether the map zoom animation is enabled. By default it's enabled
        // in all browsers that support CSS3 Transitions except Android.
        zoomAnimation: !0,
        // @option zoomAnimationThreshold: Number = 4
        // Won't animate zoom if the zoom difference exceeds this value.
        zoomAnimationThreshold: 4,
        // @option fadeAnimation: Boolean = true
        // Whether the tile fade animation is enabled. By default it's enabled
        // in all browsers that support CSS3 Transitions except Android.
        fadeAnimation: !0,
        // @option markerZoomAnimation: Boolean = true
        // Whether markers animate their zoom with the zoom animation, if disabled
        // they will disappear for the length of the animation. By default it's
        // enabled in all browsers that support CSS3 Transitions except Android.
        markerZoomAnimation: !0,
        // @option transform3DLimit: Number = 2^23
        // Defines the maximum size of a CSS translation transform. The default
        // value should not be changed unless a web browser positions layers in
        // the wrong place after doing a large `panBy`.
        transform3DLimit: 8388608,
        // Precision limit of a 32-bit float
        // @section Interaction Options
        // @option zoomSnap: Number = 1
        // Forces the map's zoom level to always be a multiple of this, particularly
        // right after a [`fitBounds()`](#map-fitbounds) or a pinch-zoom.
        // By default, the zoom level snaps to the nearest integer; lower values
        // (e.g. `0.5` or `0.1`) allow for greater granularity. A value of `0`
        // means the zoom level will not be snapped after `fitBounds` or a pinch-zoom.
        zoomSnap: 1,
        // @option zoomDelta: Number = 1
        // Controls how much the map's zoom level will change after a
        // [`zoomIn()`](#map-zoomin), [`zoomOut()`](#map-zoomout), pressing `+`
        // or `-` on the keyboard, or using the [zoom controls](#control-zoom).
        // Values smaller than `1` (e.g. `0.5`) allow for greater granularity.
        zoomDelta: 1,
        // @option trackResize: Boolean = true
        // Whether the map automatically handles browser window resize to update itself.
        trackResize: !0
      },
      initialize: function(u, h) {
        h = g(this, h), this._handlers = [], this._layers = {}, this._zoomBoundLayers = {}, this._sizeChanged = !0, this._initContainer(u), this._initLayout(), this._onResize = a(this._onResize, this), this._initEvents(), h.maxBounds && this.setMaxBounds(h.maxBounds), h.zoom !== void 0 && (this._zoom = this._limitZoom(h.zoom)), h.center && h.zoom !== void 0 && this.setView(ne(h.center), h.zoom, { reset: !0 }), this.callInitHooks(), this._zoomAnimated = Xi && ke.any3d && !ke.mobileOpera && this.options.zoomAnimation, this._zoomAnimated && (this._createAnimProxy(), Ze(this._proxy, Qr, this._catchTransitionEnd, this)), this._addLayers(this.options.layers);
      },
      // @section Methods for modifying map state
      // @method setView(center: LatLng, zoom: Number, options?: Zoom/pan options): this
      // Sets the view of the map (geographical center and zoom) with the given
      // animation options.
      setView: function(u, h, C) {
        if (h = h === void 0 ? this._zoom : this._limitZoom(h), u = this._limitCenter(ne(u), h, this.options.maxBounds), C = C || {}, this._stop(), this._loaded && !C.reset && C !== !0) {
          C.animate !== void 0 && (C.zoom = o({ animate: C.animate }, C.zoom), C.pan = o({ animate: C.animate, duration: C.duration }, C.pan));
          var O = this._zoom !== h ? this._tryAnimatedZoom && this._tryAnimatedZoom(u, h, C.zoom) : this._tryAnimatedPan(u, C.pan);
          if (O)
            return clearTimeout(this._sizeTimer), this;
        }
        return this._resetView(u, h, C.pan && C.pan.noMoveStart), this;
      },
      // @method setZoom(zoom: Number, options?: Zoom/pan options): this
      // Sets the zoom of the map.
      setZoom: function(u, h) {
        return this._loaded ? this.setView(this.getCenter(), u, { zoom: h }) : (this._zoom = u, this);
      },
      // @method zoomIn(delta?: Number, options?: Zoom options): this
      // Increases the zoom of the map by `delta` ([`zoomDelta`](#map-zoomdelta) by default).
      zoomIn: function(u, h) {
        return u = u || (ke.any3d ? this.options.zoomDelta : 1), this.setZoom(this._zoom + u, h);
      },
      // @method zoomOut(delta?: Number, options?: Zoom options): this
      // Decreases the zoom of the map by `delta` ([`zoomDelta`](#map-zoomdelta) by default).
      zoomOut: function(u, h) {
        return u = u || (ke.any3d ? this.options.zoomDelta : 1), this.setZoom(this._zoom - u, h);
      },
      // @method setZoomAround(latlng: LatLng, zoom: Number, options: Zoom options): this
      // Zooms the map while keeping a specified geographical point on the map
      // stationary (e.g. used internally for scroll zoom and double-click zoom).
      // @alternative
      // @method setZoomAround(offset: Point, zoom: Number, options: Zoom options): this
      // Zooms the map while keeping a specified pixel on the map (relative to the top-left corner) stationary.
      setZoomAround: function(u, h, C) {
        var O = this.getZoomScale(h), W = this.getSize().divideBy(2), Y = u instanceof G ? u : this.latLngToContainerPoint(u), ie = Y.subtract(W).multiplyBy(1 - 1 / O), de = this.containerPointToLatLng(W.add(ie));
        return this.setView(de, h, { zoom: C });
      },
      _getBoundsCenterZoom: function(u, h) {
        h = h || {}, u = u.getBounds ? u.getBounds() : K(u);
        var C = H(h.paddingTopLeft || h.padding || [0, 0]), O = H(h.paddingBottomRight || h.padding || [0, 0]), W = this.getBoundsZoom(u, !1, C.add(O));
        if (W = typeof h.maxZoom == "number" ? Math.min(h.maxZoom, W) : W, W === 1 / 0)
          return {
            center: u.getCenter(),
            zoom: W
          };
        var Y = O.subtract(C).divideBy(2), ie = this.project(u.getSouthWest(), W), de = this.project(u.getNorthEast(), W), he = this.unproject(ie.add(de).divideBy(2).add(Y), W);
        return {
          center: he,
          zoom: W
        };
      },
      // @method fitBounds(bounds: LatLngBounds, options?: fitBounds options): this
      // Sets a map view that contains the given geographical bounds with the
      // maximum zoom level possible.
      fitBounds: function(u, h) {
        if (u = K(u), !u.isValid())
          throw new Error("Bounds are not valid.");
        var C = this._getBoundsCenterZoom(u, h);
        return this.setView(C.center, C.zoom, h);
      },
      // @method fitWorld(options?: fitBounds options): this
      // Sets a map view that mostly contains the whole world with the maximum
      // zoom level possible.
      fitWorld: function(u) {
        return this.fitBounds([[-90, -180], [90, 180]], u);
      },
      // @method panTo(latlng: LatLng, options?: Pan options): this
      // Pans the map to a given center.
      panTo: function(u, h) {
        return this.setView(u, this._zoom, { pan: h });
      },
      // @method panBy(offset: Point, options?: Pan options): this
      // Pans the map by a given number of pixels (animated).
      panBy: function(u, h) {
        if (u = H(u).round(), h = h || {}, !u.x && !u.y)
          return this.fire("moveend");
        if (h.animate !== !0 && !this.getSize().contains(u))
          return this._resetView(this.unproject(this.project(this.getCenter()).add(u)), this.getZoom()), this;
        if (this._panAnim || (this._panAnim = new rC(), this._panAnim.on({
          step: this._onPanTransitionStep,
          end: this._onPanTransitionEnd
        }, this)), h.noMoveStart || this.fire("movestart"), h.animate !== !1) {
          tt(this._mapPane, "leaflet-pan-anim");
          var C = this._getMapPanePos().subtract(u).round();
          this._panAnim.run(this._mapPane, C, h.duration || 0.25, h.easeLinearity);
        } else
          this._rawPanBy(u), this.fire("move").fire("moveend");
        return this;
      },
      // @method flyTo(latlng: LatLng, zoom?: Number, options?: Zoom/pan options): this
      // Sets the view of the map (geographical center and zoom) performing a smooth
      // pan-zoom animation.
      flyTo: function(u, h, C) {
        if (C = C || {}, C.animate === !1 || !ke.any3d)
          return this.setView(u, h, C);
        this._stop();
        var O = this.project(this.getCenter()), W = this.project(u), Y = this.getSize(), ie = this._zoom;
        u = ne(u), h = h === void 0 ? ie : h;
        var de = Math.max(Y.x, Y.y), he = de * this.getZoomScale(ie, h), be = W.distanceTo(O) || 1, Oe = 1.42, qe = Oe * Oe;
        function dt(In) {
          var Zf = In ? -1 : 1, v$ = In ? he : de, b$ = he * he - de * de + Zf * qe * qe * be * be, y$ = 2 * v$ * qe * be, _v = b$ / y$, $C = Math.sqrt(_v * _v + 1) - _v, _$ = $C < 1e-9 ? -18 : Math.log($C);
          return _$;
        }
        function Sr(In) {
          return (Math.exp(In) - Math.exp(-In)) / 2;
        }
        function nr(In) {
          return (Math.exp(In) + Math.exp(-In)) / 2;
        }
        function ko(In) {
          return Sr(In) / nr(In);
        }
        var Lr = dt(0);
        function wl(In) {
          return de * (nr(Lr) / nr(Lr + Oe * In));
        }
        function p$(In) {
          return de * (nr(Lr) * ko(Lr + Oe * In) - Sr(Lr)) / qe;
        }
        function h$(In) {
          return 1 - Math.pow(1 - In, 1.5);
        }
        var m$ = Date.now(), IC = (dt(1) - Lr) / Oe, g$ = C.duration ? 1e3 * C.duration : 1e3 * IC * 0.8;
        function LC() {
          var In = (Date.now() - m$) / g$, Zf = h$(In) * IC;
          In <= 1 ? (this._flyToFrame = D(LC, this), this._move(
            this.unproject(O.add(W.subtract(O).multiplyBy(p$(Zf) / be)), ie),
            this.getScaleZoom(de / wl(Zf), ie),
            { flyTo: !0 }
          )) : this._move(u, h)._moveEnd(!0);
        }
        return this._moveStart(!0, C.noMoveStart), LC.call(this), this;
      },
      // @method flyToBounds(bounds: LatLngBounds, options?: fitBounds options): this
      // Sets the view of the map with a smooth animation like [`flyTo`](#map-flyto),
      // but takes a bounds parameter like [`fitBounds`](#map-fitbounds).
      flyToBounds: function(u, h) {
        var C = this._getBoundsCenterZoom(u, h);
        return this.flyTo(C.center, C.zoom, h);
      },
      // @method setMaxBounds(bounds: LatLngBounds): this
      // Restricts the map view to the given bounds (see the [maxBounds](#map-maxbounds) option).
      setMaxBounds: function(u) {
        return u = K(u), this.listens("moveend", this._panInsideMaxBounds) && this.off("moveend", this._panInsideMaxBounds), u.isValid() ? (this.options.maxBounds = u, this._loaded && this._panInsideMaxBounds(), this.on("moveend", this._panInsideMaxBounds)) : (this.options.maxBounds = null, this);
      },
      // @method setMinZoom(zoom: Number): this
      // Sets the lower limit for the available zoom levels (see the [minZoom](#map-minzoom) option).
      setMinZoom: function(u) {
        var h = this.options.minZoom;
        return this.options.minZoom = u, this._loaded && h !== u && (this.fire("zoomlevelschange"), this.getZoom() < this.options.minZoom) ? this.setZoom(u) : this;
      },
      // @method setMaxZoom(zoom: Number): this
      // Sets the upper limit for the available zoom levels (see the [maxZoom](#map-maxzoom) option).
      setMaxZoom: function(u) {
        var h = this.options.maxZoom;
        return this.options.maxZoom = u, this._loaded && h !== u && (this.fire("zoomlevelschange"), this.getZoom() > this.options.maxZoom) ? this.setZoom(u) : this;
      },
      // @method panInsideBounds(bounds: LatLngBounds, options?: Pan options): this
      // Pans the map to the closest view that would lie inside the given bounds (if it's not already), controlling the animation using the options specific, if any.
      panInsideBounds: function(u, h) {
        this._enforcingBounds = !0;
        var C = this.getCenter(), O = this._limitCenter(C, this._zoom, K(u));
        return C.equals(O) || this.panTo(O, h), this._enforcingBounds = !1, this;
      },
      // @method panInside(latlng: LatLng, options?: padding options): this
      // Pans the map the minimum amount to make the `latlng` visible. Use
      // padding options to fit the display to more restricted bounds.
      // If `latlng` is already within the (optionally padded) display bounds,
      // the map will not be panned.
      panInside: function(u, h) {
        h = h || {};
        var C = H(h.paddingTopLeft || h.padding || [0, 0]), O = H(h.paddingBottomRight || h.padding || [0, 0]), W = this.project(this.getCenter()), Y = this.project(u), ie = this.getPixelBounds(), de = Q([ie.min.add(C), ie.max.subtract(O)]), he = de.getSize();
        if (!de.contains(Y)) {
          this._enforcingBounds = !0;
          var be = Y.subtract(de.getCenter()), Oe = de.extend(Y).getSize().subtract(he);
          W.x += be.x < 0 ? -Oe.x : Oe.x, W.y += be.y < 0 ? -Oe.y : Oe.y, this.panTo(this.unproject(W), h), this._enforcingBounds = !1;
        }
        return this;
      },
      // @method invalidateSize(options: Zoom/pan options): this
      // Checks if the map container size changed and updates the map if so —
      // call it after you've changed the map size dynamically, also animating
      // pan by default. If `options.pan` is `false`, panning will not occur.
      // If `options.debounceMoveend` is `true`, it will delay `moveend` event so
      // that it doesn't happen often even if the method is called many
      // times in a row.
      // @alternative
      // @method invalidateSize(animate: Boolean): this
      // Checks if the map container size changed and updates the map if so —
      // call it after you've changed the map size dynamically, also animating
      // pan by default.
      invalidateSize: function(u) {
        if (!this._loaded)
          return this;
        u = o({
          animate: !1,
          pan: !0
        }, u === !0 ? { animate: !0 } : u);
        var h = this.getSize();
        this._sizeChanged = !0, this._lastCenter = null;
        var C = this.getSize(), O = h.divideBy(2).round(), W = C.divideBy(2).round(), Y = O.subtract(W);
        return !Y.x && !Y.y ? this : (u.animate && u.pan ? this.panBy(Y) : (u.pan && this._rawPanBy(Y), this.fire("move"), u.debounceMoveend ? (clearTimeout(this._sizeTimer), this._sizeTimer = setTimeout(a(this.fire, this, "moveend"), 200)) : this.fire("moveend")), this.fire("resize", {
          oldSize: h,
          newSize: C
        }));
      },
      // @section Methods for modifying map state
      // @method stop(): this
      // Stops the currently running `panTo` or `flyTo` animation, if any.
      stop: function() {
        return this.setZoom(this._limitZoom(this._zoom)), this.options.zoomSnap || this.fire("viewreset"), this._stop();
      },
      // @section Geolocation methods
      // @method locate(options?: Locate options): this
      // Tries to locate the user using the Geolocation API, firing a [`locationfound`](#map-locationfound)
      // event with location data on success or a [`locationerror`](#map-locationerror) event on failure,
      // and optionally sets the map view to the user's location with respect to
      // detection accuracy (or to the world view if geolocation failed).
      // Note that, if your page doesn't use HTTPS, this method will fail in
      // modern browsers ([Chrome 50 and newer](https://sites.google.com/a/chromium.org/dev/Home/chromium-security/deprecating-powerful-features-on-insecure-origins))
      // See `Locate options` for more details.
      locate: function(u) {
        if (u = this._locateOptions = o({
          timeout: 1e4,
          watch: !1
          // setView: false
          // maxZoom: <Number>
          // maximumAge: 0
          // enableHighAccuracy: false
        }, u), !("geolocation" in navigator))
          return this._handleGeolocationError({
            code: 0,
            message: "Geolocation not supported."
          }), this;
        var h = a(this._handleGeolocationResponse, this), C = a(this._handleGeolocationError, this);
        return u.watch ? this._locationWatchId = navigator.geolocation.watchPosition(h, C, u) : navigator.geolocation.getCurrentPosition(h, C, u), this;
      },
      // @method stopLocate(): this
      // Stops watching location previously initiated by `map.locate({watch: true})`
      // and aborts resetting the map view if map.locate was called with
      // `{setView: true}`.
      stopLocate: function() {
        return navigator.geolocation && navigator.geolocation.clearWatch && navigator.geolocation.clearWatch(this._locationWatchId), this._locateOptions && (this._locateOptions.setView = !1), this;
      },
      _handleGeolocationError: function(u) {
        if (this._container._leaflet_id) {
          var h = u.code, C = u.message || (h === 1 ? "permission denied" : h === 2 ? "position unavailable" : "timeout");
          this._locateOptions.setView && !this._loaded && this.fitWorld(), this.fire("locationerror", {
            code: h,
            message: "Geolocation error: " + C + "."
          });
        }
      },
      _handleGeolocationResponse: function(u) {
        if (this._container._leaflet_id) {
          var h = u.coords.latitude, C = u.coords.longitude, O = new J(h, C), W = O.toBounds(u.coords.accuracy * 2), Y = this._locateOptions;
          if (Y.setView) {
            var ie = this.getBoundsZoom(W);
            this.setView(O, Y.maxZoom ? Math.min(ie, Y.maxZoom) : ie);
          }
          var de = {
            latlng: O,
            bounds: W,
            timestamp: u.timestamp
          };
          for (var he in u.coords)
            typeof u.coords[he] == "number" && (de[he] = u.coords[he]);
          this.fire("locationfound", de);
        }
      },
      // TODO Appropriate docs section?
      // @section Other Methods
      // @method addHandler(name: String, HandlerClass: Function): this
      // Adds a new `Handler` to the map, given its name and constructor function.
      addHandler: function(u, h) {
        if (!h)
          return this;
        var C = this[u] = new h(this);
        return this._handlers.push(C), this.options[u] && C.enable(), this;
      },
      // @method remove(): this
      // Destroys the map and clears all related event listeners.
      remove: function() {
        if (this._initEvents(!0), this.options.maxBounds && this.off("moveend", this._panInsideMaxBounds), this._containerId !== this._container._leaflet_id)
          throw new Error("Map container is being reused by another instance");
        try {
          delete this._container._leaflet_id, delete this._containerId;
        } catch (h) {
          this._container._leaflet_id = void 0, this._containerId = void 0;
        }
        this._locationWatchId !== void 0 && this.stopLocate(), this._stop(), Et(this._mapPane), this._clearControlPos && this._clearControlPos(), this._resizeRequest && (N(this._resizeRequest), this._resizeRequest = null), this._clearHandlers(), this._loaded && this.fire("unload");
        var u;
        for (u in this._layers)
          this._layers[u].remove();
        for (u in this._panes)
          Et(this._panes[u]);
        return this._layers = [], this._panes = [], delete this._mapPane, delete this._renderer, this;
      },
      // @section Other Methods
      // @method createPane(name: String, container?: HTMLElement): HTMLElement
      // Creates a new [map pane](#map-pane) with the given name if it doesn't exist already,
      // then returns it. The pane is created as a child of `container`, or
      // as a child of the main map pane if not set.
      createPane: function(u, h) {
        var C = "leaflet-pane" + (u ? " leaflet-" + u.replace("Pane", "") + "-pane" : ""), O = pt("div", C, h || this._mapPane);
        return u && (this._panes[u] = O), O;
      },
      // @section Methods for Getting Map State
      // @method getCenter(): LatLng
      // Returns the geographical center of the map view
      getCenter: function() {
        return this._checkIfLoaded(), this._lastCenter && !this._moved() ? this._lastCenter.clone() : this.layerPointToLatLng(this._getCenterLayerPoint());
      },
      // @method getZoom(): Number
      // Returns the current zoom level of the map view
      getZoom: function() {
        return this._zoom;
      },
      // @method getBounds(): LatLngBounds
      // Returns the geographical bounds visible in the current map view
      getBounds: function() {
        var u = this.getPixelBounds(), h = this.unproject(u.getBottomLeft()), C = this.unproject(u.getTopRight());
        return new X(h, C);
      },
      // @method getMinZoom(): Number
      // Returns the minimum zoom level of the map (if set in the `minZoom` option of the map or of any layers), or `0` by default.
      getMinZoom: function() {
        return this.options.minZoom === void 0 ? this._layersMinZoom || 0 : this.options.minZoom;
      },
      // @method getMaxZoom(): Number
      // Returns the maximum zoom level of the map (if set in the `maxZoom` option of the map or of any layers).
      getMaxZoom: function() {
        return this.options.maxZoom === void 0 ? this._layersMaxZoom === void 0 ? 1 / 0 : this._layersMaxZoom : this.options.maxZoom;
      },
      // @method getBoundsZoom(bounds: LatLngBounds, inside?: Boolean, padding?: Point): Number
      // Returns the maximum zoom level on which the given bounds fit to the map
      // view in its entirety. If `inside` (optional) is set to `true`, the method
      // instead returns the minimum zoom level on which the map view fits into
      // the given bounds in its entirety.
      getBoundsZoom: function(u, h, C) {
        u = K(u), C = H(C || [0, 0]);
        var O = this.getZoom() || 0, W = this.getMinZoom(), Y = this.getMaxZoom(), ie = u.getNorthWest(), de = u.getSouthEast(), he = this.getSize().subtract(C), be = Q(this.project(de, O), this.project(ie, O)).getSize(), Oe = ke.any3d ? this.options.zoomSnap : 1, qe = he.x / be.x, dt = he.y / be.y, Sr = h ? Math.max(qe, dt) : Math.min(qe, dt);
        return O = this.getScaleZoom(Sr, O), Oe && (O = Math.round(O / (Oe / 100)) * (Oe / 100), O = h ? Math.ceil(O / Oe) * Oe : Math.floor(O / Oe) * Oe), Math.max(W, Math.min(Y, O));
      },
      // @method getSize(): Point
      // Returns the current size of the map container (in pixels).
      getSize: function() {
        return (!this._size || this._sizeChanged) && (this._size = new G(
          this._container.clientWidth || 0,
          this._container.clientHeight || 0
        ), this._sizeChanged = !1), this._size.clone();
      },
      // @method getPixelBounds(): Bounds
      // Returns the bounds of the current map view in projected pixel
      // coordinates (sometimes useful in layer and overlay implementations).
      getPixelBounds: function(u, h) {
        var C = this._getTopLeftPoint(u, h);
        return new q(C, C.add(this.getSize()));
      },
      // TODO: Check semantics - isn't the pixel origin the 0,0 coord relative to
      // the map pane? "left point of the map layer" can be confusing, specially
      // since there can be negative offsets.
      // @method getPixelOrigin(): Point
      // Returns the projected pixel coordinates of the top left point of
      // the map layer (useful in custom layer and overlay implementations).
      getPixelOrigin: function() {
        return this._checkIfLoaded(), this._pixelOrigin;
      },
      // @method getPixelWorldBounds(zoom?: Number): Bounds
      // Returns the world's bounds in pixel coordinates for zoom level `zoom`.
      // If `zoom` is omitted, the map's current zoom level is used.
      getPixelWorldBounds: function(u) {
        return this.options.crs.getProjectedBounds(u === void 0 ? this.getZoom() : u);
      },
      // @section Other Methods
      // @method getPane(pane: String|HTMLElement): HTMLElement
      // Returns a [map pane](#map-pane), given its name or its HTML element (its identity).
      getPane: function(u) {
        return typeof u == "string" ? this._panes[u] : u;
      },
      // @method getPanes(): Object
      // Returns a plain object containing the names of all [panes](#map-pane) as keys and
      // the panes as values.
      getPanes: function() {
        return this._panes;
      },
      // @method getContainer: HTMLElement
      // Returns the HTML element that contains the map.
      getContainer: function() {
        return this._container;
      },
      // @section Conversion Methods
      // @method getZoomScale(toZoom: Number, fromZoom: Number): Number
      // Returns the scale factor to be applied to a map transition from zoom level
      // `fromZoom` to `toZoom`. Used internally to help with zoom animations.
      getZoomScale: function(u, h) {
        var C = this.options.crs;
        return h = h === void 0 ? this._zoom : h, C.scale(u) / C.scale(h);
      },
      // @method getScaleZoom(scale: Number, fromZoom: Number): Number
      // Returns the zoom level that the map would end up at, if it is at `fromZoom`
      // level and everything is scaled by a factor of `scale`. Inverse of
      // [`getZoomScale`](#map-getZoomScale).
      getScaleZoom: function(u, h) {
        var C = this.options.crs;
        h = h === void 0 ? this._zoom : h;
        var O = C.zoom(u * C.scale(h));
        return isNaN(O) ? 1 / 0 : O;
      },
      // @method project(latlng: LatLng, zoom: Number): Point
      // Projects a geographical coordinate `LatLng` according to the projection
      // of the map's CRS, then scales it according to `zoom` and the CRS's
      // `Transformation`. The result is pixel coordinate relative to
      // the CRS origin.
      project: function(u, h) {
        return h = h === void 0 ? this._zoom : h, this.options.crs.latLngToPoint(ne(u), h);
      },
      // @method unproject(point: Point, zoom: Number): LatLng
      // Inverse of [`project`](#map-project).
      unproject: function(u, h) {
        return h = h === void 0 ? this._zoom : h, this.options.crs.pointToLatLng(H(u), h);
      },
      // @method layerPointToLatLng(point: Point): LatLng
      // Given a pixel coordinate relative to the [origin pixel](#map-getpixelorigin),
      // returns the corresponding geographical coordinate (for the current zoom level).
      layerPointToLatLng: function(u) {
        var h = H(u).add(this.getPixelOrigin());
        return this.unproject(h);
      },
      // @method latLngToLayerPoint(latlng: LatLng): Point
      // Given a geographical coordinate, returns the corresponding pixel coordinate
      // relative to the [origin pixel](#map-getpixelorigin).
      latLngToLayerPoint: function(u) {
        var h = this.project(ne(u))._round();
        return h._subtract(this.getPixelOrigin());
      },
      // @method wrapLatLng(latlng: LatLng): LatLng
      // Returns a `LatLng` where `lat` and `lng` has been wrapped according to the
      // map's CRS's `wrapLat` and `wrapLng` properties, if they are outside the
      // CRS's bounds.
      // By default this means longitude is wrapped around the dateline so its
      // value is between -180 and +180 degrees.
      wrapLatLng: function(u) {
        return this.options.crs.wrapLatLng(ne(u));
      },
      // @method wrapLatLngBounds(bounds: LatLngBounds): LatLngBounds
      // Returns a `LatLngBounds` with the same size as the given one, ensuring that
      // its center is within the CRS's bounds.
      // By default this means the center longitude is wrapped around the dateline so its
      // value is between -180 and +180 degrees, and the majority of the bounds
      // overlaps the CRS's bounds.
      wrapLatLngBounds: function(u) {
        return this.options.crs.wrapLatLngBounds(K(u));
      },
      // @method distance(latlng1: LatLng, latlng2: LatLng): Number
      // Returns the distance between two geographical coordinates according to
      // the map's CRS. By default this measures distance in meters.
      distance: function(u, h) {
        return this.options.crs.distance(ne(u), ne(h));
      },
      // @method containerPointToLayerPoint(point: Point): Point
      // Given a pixel coordinate relative to the map container, returns the corresponding
      // pixel coordinate relative to the [origin pixel](#map-getpixelorigin).
      containerPointToLayerPoint: function(u) {
        return H(u).subtract(this._getMapPanePos());
      },
      // @method layerPointToContainerPoint(point: Point): Point
      // Given a pixel coordinate relative to the [origin pixel](#map-getpixelorigin),
      // returns the corresponding pixel coordinate relative to the map container.
      layerPointToContainerPoint: function(u) {
        return H(u).add(this._getMapPanePos());
      },
      // @method containerPointToLatLng(point: Point): LatLng
      // Given a pixel coordinate relative to the map container, returns
      // the corresponding geographical coordinate (for the current zoom level).
      containerPointToLatLng: function(u) {
        var h = this.containerPointToLayerPoint(H(u));
        return this.layerPointToLatLng(h);
      },
      // @method latLngToContainerPoint(latlng: LatLng): Point
      // Given a geographical coordinate, returns the corresponding pixel coordinate
      // relative to the map container.
      latLngToContainerPoint: function(u) {
        return this.layerPointToContainerPoint(this.latLngToLayerPoint(ne(u)));
      },
      // @method mouseEventToContainerPoint(ev: MouseEvent): Point
      // Given a MouseEvent object, returns the pixel coordinate relative to the
      // map container where the event took place.
      mouseEventToContainerPoint: function(u) {
        return tC(u, this._container);
      },
      // @method mouseEventToLayerPoint(ev: MouseEvent): Point
      // Given a MouseEvent object, returns the pixel coordinate relative to
      // the [origin pixel](#map-getpixelorigin) where the event took place.
      mouseEventToLayerPoint: function(u) {
        return this.containerPointToLayerPoint(this.mouseEventToContainerPoint(u));
      },
      // @method mouseEventToLatLng(ev: MouseEvent): LatLng
      // Given a MouseEvent object, returns geographical coordinate where the
      // event took place.
      mouseEventToLatLng: function(u) {
        return this.layerPointToLatLng(this.mouseEventToLayerPoint(u));
      },
      // map initialization methods
      _initContainer: function(u) {
        var h = this._container = yo(u);
        if (h) {
          if (h._leaflet_id)
            throw new Error("Map container is already initialized.");
        } else
          throw new Error("Map container not found.");
        Ze(h, "scroll", this._onScroll, this), this._containerId = c(h);
      },
      _initLayout: function() {
        var u = this._container;
        this._fadeAnimated = this.options.fadeAnimation && ke.any3d, tt(u, "leaflet-container" + (ke.touch ? " leaflet-touch" : "") + (ke.retina ? " leaflet-retina" : "") + (ke.ielt9 ? " leaflet-oldie" : "") + (ke.safari ? " leaflet-safari" : "") + (this._fadeAnimated ? " leaflet-fade-anim" : ""));
        var h = Qo(u, "position");
        h !== "absolute" && h !== "relative" && h !== "fixed" && h !== "sticky" && (u.style.position = "relative"), this._initPanes(), this._initControlPos && this._initControlPos();
      },
      _initPanes: function() {
        var u = this._panes = {};
        this._paneRenderers = {}, this._mapPane = this.createPane("mapPane", this._container), sn(this._mapPane, new G(0, 0)), this.createPane("tilePane"), this.createPane("overlayPane"), this.createPane("shadowPane"), this.createPane("markerPane"), this.createPane("tooltipPane"), this.createPane("popupPane"), this.options.markerZoomAnimation || (tt(u.markerPane, "leaflet-zoom-hide"), tt(u.shadowPane, "leaflet-zoom-hide"));
      },
      // private methods that modify map state
      // @section Map state change events
      _resetView: function(u, h, C) {
        sn(this._mapPane, new G(0, 0));
        var O = !this._loaded;
        this._loaded = !0, h = this._limitZoom(h), this.fire("viewprereset");
        var W = this._zoom !== h;
        this._moveStart(W, C)._move(u, h)._moveEnd(W), this.fire("viewreset"), O && this.fire("load");
      },
      _moveStart: function(u, h) {
        return u && this.fire("zoomstart"), h || this.fire("movestart"), this;
      },
      _move: function(u, h, C, O) {
        h === void 0 && (h = this._zoom);
        var W = this._zoom !== h;
        return this._zoom = h, this._lastCenter = u, this._pixelOrigin = this._getNewPixelOrigin(u), O ? C && C.pinch && this.fire("zoom", C) : ((W || C && C.pinch) && this.fire("zoom", C), this.fire("move", C)), this;
      },
      _moveEnd: function(u) {
        return u && this.fire("zoomend"), this.fire("moveend");
      },
      _stop: function() {
        return N(this._flyToFrame), this._panAnim && this._panAnim.stop(), this;
      },
      _rawPanBy: function(u) {
        sn(this._mapPane, this._getMapPanePos().subtract(u));
      },
      _getZoomSpan: function() {
        return this.getMaxZoom() - this.getMinZoom();
      },
      _panInsideMaxBounds: function() {
        this._enforcingBounds || this.panInsideBounds(this.options.maxBounds);
      },
      _checkIfLoaded: function() {
        if (!this._loaded)
          throw new Error("Set map center and zoom first.");
      },
      // DOM event handling
      // @section Interaction events
      _initEvents: function(u) {
        this._targets = {}, this._targets[c(this._container)] = this;
        var h = u ? xe : Ze;
        h(this._container, "click dblclick mousedown mouseup mouseover mouseout mousemove contextmenu keypress keydown keyup", this._handleDOMEvent, this), this.options.trackResize && h(window, "resize", this._onResize, this), ke.any3d && this.options.transform3DLimit && (u ? this.off : this.on).call(this, "moveend", this._onMoveEnd);
      },
      _onResize: function() {
        N(this._resizeRequest), this._resizeRequest = D(
          function() {
            this.invalidateSize({ debounceMoveend: !0 });
          },
          this
        );
      },
      _onScroll: function() {
        this._container.scrollTop = 0, this._container.scrollLeft = 0;
      },
      _onMoveEnd: function() {
        var u = this._getMapPanePos();
        Math.max(Math.abs(u.x), Math.abs(u.y)) >= this.options.transform3DLimit && this._resetView(this.getCenter(), this.getZoom());
      },
      _findEventTargets: function(u, h) {
        for (var C = [], O, W = h === "mouseout" || h === "mouseover", Y = u.target || u.srcElement, ie = !1; Y; ) {
          if (O = this._targets[c(Y)], O && (h === "click" || h === "preclick") && this._draggableMoved(O)) {
            ie = !0;
            break;
          }
          if (O && O.listens(h, !0) && (W && !cv(Y, u) || (C.push(O), W)) || Y === this._container)
            break;
          Y = Y.parentNode;
        }
        return !C.length && !ie && !W && this.listens(h, !0) && (C = [this]), C;
      },
      _isClickDisabled: function(u) {
        for (; u && u !== this._container; ) {
          if (u._leaflet_disable_click)
            return !0;
          u = u.parentNode;
        }
      },
      _handleDOMEvent: function(u) {
        var h = u.target || u.srcElement;
        if (!(!this._loaded || h._leaflet_disable_events || u.type === "click" && this._isClickDisabled(h))) {
          var C = u.type;
          C === "mousedown" && Ma(h), this._fireDOMEvent(u, C);
        }
      },
      _mouseEvents: ["click", "dblclick", "mouseover", "mouseout", "contextmenu"],
      _fireDOMEvent: function(u, h, C) {
        if (u.type === "click") {
          var O = o({}, u);
          O.type = "preclick", this._fireDOMEvent(O, O.type, C);
        }
        var W = this._findEventTargets(u, h);
        if (C) {
          for (var Y = [], ie = 0; ie < C.length; ie++)
            C[ie].listens(h, !0) && Y.push(C[ie]);
          W = Y.concat(W);
        }
        if (W.length) {
          h === "contextmenu" && vn(u);
          var de = W[0], he = {
            originalEvent: u
          };
          if (u.type !== "keypress" && u.type !== "keydown" && u.type !== "keyup") {
            var be = de.getLatLng && (!de._radius || de._radius <= 10);
            he.containerPoint = be ? this.latLngToContainerPoint(de.getLatLng()) : this.mouseEventToContainerPoint(u), he.layerPoint = this.containerPointToLayerPoint(he.containerPoint), he.latlng = be ? de.getLatLng() : this.layerPointToLatLng(he.layerPoint);
          }
          for (ie = 0; ie < W.length; ie++)
            if (W[ie].fire(h, he, !0), he.originalEvent._stopped || W[ie].options.bubblingMouseEvents === !1 && _(this._mouseEvents, h) !== -1)
              return;
        }
      },
      _draggableMoved: function(u) {
        return u = u.dragging && u.dragging.enabled() ? u : this, u.dragging && u.dragging.moved() || this.boxZoom && this.boxZoom.moved();
      },
      _clearHandlers: function() {
        for (var u = 0, h = this._handlers.length; u < h; u++)
          this._handlers[u].disable();
      },
      // @section Other Methods
      // @method whenReady(fn: Function, context?: Object): this
      // Runs the given function `fn` when the map gets initialized with
      // a view (center and zoom) and at least one layer, or immediately
      // if it's already initialized, optionally passing a function context.
      whenReady: function(u, h) {
        return this._loaded ? u.call(h || this, { target: this }) : this.on("load", u, h), this;
      },
      // private methods for getting map state
      _getMapPanePos: function() {
        return ei(this._mapPane) || new G(0, 0);
      },
      _moved: function() {
        var u = this._getMapPanePos();
        return u && !u.equals([0, 0]);
      },
      _getTopLeftPoint: function(u, h) {
        var C = u && h !== void 0 ? this._getNewPixelOrigin(u, h) : this.getPixelOrigin();
        return C.subtract(this._getMapPanePos());
      },
      _getNewPixelOrigin: function(u, h) {
        var C = this.getSize()._divideBy(2);
        return this.project(u, h)._subtract(C)._add(this._getMapPanePos())._round();
      },
      _latLngToNewLayerPoint: function(u, h, C) {
        var O = this._getNewPixelOrigin(C, h);
        return this.project(u, h)._subtract(O);
      },
      _latLngBoundsToNewLayerBounds: function(u, h, C) {
        var O = this._getNewPixelOrigin(C, h);
        return Q([
          this.project(u.getSouthWest(), h)._subtract(O),
          this.project(u.getNorthWest(), h)._subtract(O),
          this.project(u.getSouthEast(), h)._subtract(O),
          this.project(u.getNorthEast(), h)._subtract(O)
        ]);
      },
      // layer point of the current center
      _getCenterLayerPoint: function() {
        return this.containerPointToLayerPoint(this.getSize()._divideBy(2));
      },
      // offset of the specified place to the current center in pixels
      _getCenterOffset: function(u) {
        return this.latLngToLayerPoint(u).subtract(this._getCenterLayerPoint());
      },
      // adjust center for view to get inside bounds
      _limitCenter: function(u, h, C) {
        if (!C)
          return u;
        var O = this.project(u, h), W = this.getSize().divideBy(2), Y = new q(O.subtract(W), O.add(W)), ie = this._getBoundsOffset(Y, C, h);
        return Math.abs(ie.x) <= 1 && Math.abs(ie.y) <= 1 ? u : this.unproject(O.add(ie), h);
      },
      // adjust offset for view to get inside bounds
      _limitOffset: function(u, h) {
        if (!h)
          return u;
        var C = this.getPixelBounds(), O = new q(C.min.add(u), C.max.add(u));
        return u.add(this._getBoundsOffset(O, h));
      },
      // returns offset needed for pxBounds to get inside maxBounds at a specified zoom
      _getBoundsOffset: function(u, h, C) {
        var O = Q(
          this.project(h.getNorthEast(), C),
          this.project(h.getSouthWest(), C)
        ), W = O.min.subtract(u.min), Y = O.max.subtract(u.max), ie = this._rebound(W.x, -Y.x), de = this._rebound(W.y, -Y.y);
        return new G(ie, de);
      },
      _rebound: function(u, h) {
        return u + h > 0 ? Math.round(u - h) / 2 : Math.max(0, Math.ceil(u)) - Math.max(0, Math.floor(h));
      },
      _limitZoom: function(u) {
        var h = this.getMinZoom(), C = this.getMaxZoom(), O = ke.any3d ? this.options.zoomSnap : 1;
        return O && (u = Math.round(u / O) * O), Math.max(h, Math.min(C, u));
      },
      _onPanTransitionStep: function() {
        this.fire("move");
      },
      _onPanTransitionEnd: function() {
        Xt(this._mapPane, "leaflet-pan-anim"), this.fire("moveend");
      },
      _tryAnimatedPan: function(u, h) {
        var C = this._getCenterOffset(u)._trunc();
        return (h && h.animate) !== !0 && !this.getSize().contains(C) ? !1 : (this.panBy(C, h), !0);
      },
      _createAnimProxy: function() {
        var u = this._proxy = pt("div", "leaflet-proxy leaflet-zoom-animated");
        this._panes.mapPane.appendChild(u), this.on("zoomanim", function(h) {
          var C = Ta, O = this._proxy.style[C];
          xo(this._proxy, this.project(h.center, h.zoom), this.getZoomScale(h.zoom, 1)), O === this._proxy.style[C] && this._animatingZoom && this._onZoomTransitionEnd();
        }, this), this.on("load moveend", this._animMoveEnd, this), this._on("unload", this._destroyAnimProxy, this);
      },
      _destroyAnimProxy: function() {
        Et(this._proxy), this.off("load moveend", this._animMoveEnd, this), delete this._proxy;
      },
      _animMoveEnd: function() {
        var u = this.getCenter(), h = this.getZoom();
        xo(this._proxy, this.project(u, h), this.getZoomScale(h, 1));
      },
      _catchTransitionEnd: function(u) {
        this._animatingZoom && u.propertyName.indexOf("transform") >= 0 && this._onZoomTransitionEnd();
      },
      _nothingToAnimate: function() {
        return !this._container.getElementsByClassName("leaflet-zoom-animated").length;
      },
      _tryAnimatedZoom: function(u, h, C) {
        if (this._animatingZoom)
          return !0;
        if (C = C || {}, !this._zoomAnimated || C.animate === !1 || this._nothingToAnimate() || Math.abs(h - this._zoom) > this.options.zoomAnimationThreshold)
          return !1;
        var O = this.getZoomScale(h), W = this._getCenterOffset(u)._divideBy(1 - 1 / O);
        return C.animate !== !0 && !this.getSize().contains(W) ? !1 : (D(function() {
          this._moveStart(!0, C.noMoveStart || !1)._animateZoom(u, h, !0);
        }, this), !0);
      },
      _animateZoom: function(u, h, C, O) {
        this._mapPane && (C && (this._animatingZoom = !0, this._animateToCenter = u, this._animateToZoom = h, tt(this._mapPane, "leaflet-zoom-anim")), this.fire("zoomanim", {
          center: u,
          zoom: h,
          noUpdate: O
        }), this._tempFireZoomEvent || (this._tempFireZoomEvent = this._zoom !== this._animateToZoom), this._move(this._animateToCenter, this._animateToZoom, void 0, !0), setTimeout(a(this._onZoomTransitionEnd, this), 250));
      },
      _onZoomTransitionEnd: function() {
        this._animatingZoom && (this._mapPane && Xt(this._mapPane, "leaflet-zoom-anim"), this._animatingZoom = !1, this._move(this._animateToCenter, this._animateToZoom, void 0, !0), this._tempFireZoomEvent && this.fire("zoom"), delete this._tempFireZoomEvent, this.fire("move"), this._moveEnd(!0));
      }
    });
    function P6(u, h) {
      return new yt(u, h);
    }
    var ti = $.extend({
      // @section
      // @aka Control Options
      options: {
        // @option position: String = 'topright'
        // The position of the control (one of the map corners). Possible values are `'topleft'`,
        // `'topright'`, `'bottomleft'` or `'bottomright'`
        position: "topright"
      },
      initialize: function(u) {
        g(this, u);
      },
      /* @section
       * Classes extending L.Control will inherit the following methods:
       *
       * @method getPosition: string
       * Returns the position of the control.
       */
      getPosition: function() {
        return this.options.position;
      },
      // @method setPosition(position: string): this
      // Sets the position of the control.
      setPosition: function(u) {
        var h = this._map;
        return h && h.removeControl(this), this.options.position = u, h && h.addControl(this), this;
      },
      // @method getContainer: HTMLElement
      // Returns the HTMLElement that contains the control.
      getContainer: function() {
        return this._container;
      },
      // @method addTo(map: Map): this
      // Adds the control to the given map.
      addTo: function(u) {
        this.remove(), this._map = u;
        var h = this._container = this.onAdd(u), C = this.getPosition(), O = u._controlCorners[C];
        return tt(h, "leaflet-control"), C.indexOf("bottom") !== -1 ? O.insertBefore(h, O.firstChild) : O.appendChild(h), this._map.on("unload", this.remove, this), this;
      },
      // @method remove: this
      // Removes the control from the map it is currently active on.
      remove: function() {
        return this._map ? (Et(this._container), this.onRemove && this.onRemove(this._map), this._map.off("unload", this.remove, this), this._map = null, this) : this;
      },
      _refocusOnMap: function(u) {
        this._map && u && u.screenX > 0 && u.screenY > 0 && this._map.getContainer().focus();
      }
    }), hu = function(u) {
      return new ti(u);
    };
    yt.include({
      // @method addControl(control: Control): this
      // Adds the given control to the map
      addControl: function(u) {
        return u.addTo(this), this;
      },
      // @method removeControl(control: Control): this
      // Removes the given control from the map
      removeControl: function(u) {
        return u.remove(), this;
      },
      _initControlPos: function() {
        var u = this._controlCorners = {}, h = "leaflet-", C = this._controlContainer = pt("div", h + "control-container", this._container);
        function O(W, Y) {
          var ie = h + W + " " + h + Y;
          u[W + Y] = pt("div", ie, C);
        }
        O("top", "left"), O("top", "right"), O("bottom", "left"), O("bottom", "right");
      },
      _clearControlPos: function() {
        for (var u in this._controlCorners)
          Et(this._controlCorners[u]);
        Et(this._controlContainer), delete this._controlCorners, delete this._controlContainer;
      }
    });
    var oC = ti.extend({
      // @section
      // @aka Control.Layers options
      options: {
        // @option collapsed: Boolean = true
        // If `true`, the control will be collapsed into an icon and expanded on mouse hover, touch, or keyboard activation.
        collapsed: !0,
        position: "topright",
        // @option autoZIndex: Boolean = true
        // If `true`, the control will assign zIndexes in increasing order to all of its layers so that the order is preserved when switching them on/off.
        autoZIndex: !0,
        // @option hideSingleBase: Boolean = false
        // If `true`, the base layers in the control will be hidden when there is only one.
        hideSingleBase: !1,
        // @option sortLayers: Boolean = false
        // Whether to sort the layers. When `false`, layers will keep the order
        // in which they were added to the control.
        sortLayers: !1,
        // @option sortFunction: Function = *
        // A [compare function](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/sort)
        // that will be used for sorting the layers, when `sortLayers` is `true`.
        // The function receives both the `L.Layer` instances and their names, as in
        // `sortFunction(layerA, layerB, nameA, nameB)`.
        // By default, it sorts layers alphabetically by their name.
        sortFunction: function(u, h, C, O) {
          return C < O ? -1 : O < C ? 1 : 0;
        }
      },
      initialize: function(u, h, C) {
        g(this, C), this._layerControlInputs = [], this._layers = [], this._lastZIndex = 0, this._handlingClick = !1, this._preventClick = !1;
        for (var O in u)
          this._addLayer(u[O], O);
        for (O in h)
          this._addLayer(h[O], O, !0);
      },
      onAdd: function(u) {
        this._initLayout(), this._update(), this._map = u, u.on("zoomend", this._checkDisabledLayers, this);
        for (var h = 0; h < this._layers.length; h++)
          this._layers[h].layer.on("add remove", this._onLayerChange, this);
        return this._container;
      },
      addTo: function(u) {
        return ti.prototype.addTo.call(this, u), this._expandIfNotCollapsed();
      },
      onRemove: function() {
        this._map.off("zoomend", this._checkDisabledLayers, this);
        for (var u = 0; u < this._layers.length; u++)
          this._layers[u].layer.off("add remove", this._onLayerChange, this);
      },
      // @method addBaseLayer(layer: Layer, name: String): this
      // Adds a base layer (radio button entry) with the given name to the control.
      addBaseLayer: function(u, h) {
        return this._addLayer(u, h), this._map ? this._update() : this;
      },
      // @method addOverlay(layer: Layer, name: String): this
      // Adds an overlay (checkbox entry) with the given name to the control.
      addOverlay: function(u, h) {
        return this._addLayer(u, h, !0), this._map ? this._update() : this;
      },
      // @method removeLayer(layer: Layer): this
      // Remove the given layer from the control.
      removeLayer: function(u) {
        u.off("add remove", this._onLayerChange, this);
        var h = this._getLayer(c(u));
        return h && this._layers.splice(this._layers.indexOf(h), 1), this._map ? this._update() : this;
      },
      // @method expand(): this
      // Expand the control container if collapsed.
      expand: function() {
        tt(this._container, "leaflet-control-layers-expanded"), this._section.style.height = null;
        var u = this._map.getSize().y - (this._container.offsetTop + 50);
        return u < this._section.clientHeight ? (tt(this._section, "leaflet-control-layers-scrollbar"), this._section.style.height = u + "px") : Xt(this._section, "leaflet-control-layers-scrollbar"), this._checkDisabledLayers(), this;
      },
      // @method collapse(): this
      // Collapse the control container if expanded.
      collapse: function() {
        return Xt(this._container, "leaflet-control-layers-expanded"), this;
      },
      _initLayout: function() {
        var u = "leaflet-control-layers", h = this._container = pt("div", u), C = this.options.collapsed;
        h.setAttribute("aria-haspopup", !0), Ra(h), Ts(h);
        var O = this._section = pt("section", u + "-list");
        C && (this._map.on("click", this.collapse, this), Ze(h, {
          mouseenter: this._expandSafely,
          mouseleave: this.collapse
        }, this));
        var W = this._layersLink = pt("a", u + "-toggle", h);
        W.href = "#", W.title = "Layers", W.setAttribute("role", "button"), Ze(W, {
          keydown: function(Y) {
            Y.keyCode === 13 && this._expandSafely();
          },
          // Certain screen readers intercept the key event and instead send a click event
          click: function(Y) {
            vn(Y), this._expandSafely();
          }
        }, this), C || this.expand(), this._baseLayersList = pt("div", u + "-base", O), this._separator = pt("div", u + "-separator", O), this._overlaysList = pt("div", u + "-overlays", O), h.appendChild(O);
      },
      _getLayer: function(u) {
        for (var h = 0; h < this._layers.length; h++)
          if (this._layers[h] && c(this._layers[h].layer) === u)
            return this._layers[h];
      },
      _addLayer: function(u, h, C) {
        this._map && u.on("add remove", this._onLayerChange, this), this._layers.push({
          layer: u,
          name: h,
          overlay: C
        }), this.options.sortLayers && this._layers.sort(a(function(O, W) {
          return this.options.sortFunction(O.layer, W.layer, O.name, W.name);
        }, this)), this.options.autoZIndex && u.setZIndex && (this._lastZIndex++, u.setZIndex(this._lastZIndex)), this._expandIfNotCollapsed();
      },
      _update: function() {
        if (!this._container)
          return this;
        _o(this._baseLayersList), _o(this._overlaysList), this._layerControlInputs = [];
        var u, h, C, O, W = 0;
        for (C = 0; C < this._layers.length; C++)
          O = this._layers[C], this._addItem(O), h = h || O.overlay, u = u || !O.overlay, W += O.overlay ? 0 : 1;
        return this.options.hideSingleBase && (u = u && W > 1, this._baseLayersList.style.display = u ? "" : "none"), this._separator.style.display = h && u ? "" : "none", this;
      },
      _onLayerChange: function(u) {
        this._handlingClick || this._update();
        var h = this._getLayer(c(u.target)), C = h.overlay ? u.type === "add" ? "overlayadd" : "overlayremove" : u.type === "add" ? "baselayerchange" : null;
        C && this._map.fire(C, h);
      },
      // IE7 bugs out if you create a radio dynamically, so you have to do it this hacky way (see https://stackoverflow.com/a/119079)
      _createRadioElement: function(u, h) {
        var C = '<input type="radio" class="leaflet-control-layers-selector" name="' + u + '"' + (h ? ' checked="checked"' : "") + "/>", O = document.createElement("div");
        return O.innerHTML = C, O.firstChild;
      },
      _addItem: function(u) {
        var h = document.createElement("label"), C = this._map.hasLayer(u.layer), O;
        u.overlay ? (O = document.createElement("input"), O.type = "checkbox", O.className = "leaflet-control-layers-selector", O.defaultChecked = C) : O = this._createRadioElement("leaflet-base-layers_" + c(this), C), this._layerControlInputs.push(O), O.layerId = c(u.layer), Ze(O, "click", this._onInputClick, this);
        var W = document.createElement("span");
        W.innerHTML = " " + u.name;
        var Y = document.createElement("span");
        h.appendChild(Y), Y.appendChild(O), Y.appendChild(W);
        var ie = u.overlay ? this._overlaysList : this._baseLayersList;
        return ie.appendChild(h), this._checkDisabledLayers(), h;
      },
      _onInputClick: function() {
        if (!this._preventClick) {
          var u = this._layerControlInputs, h, C, O = [], W = [];
          this._handlingClick = !0;
          for (var Y = u.length - 1; Y >= 0; Y--)
            h = u[Y], C = this._getLayer(h.layerId).layer, h.checked ? O.push(C) : h.checked || W.push(C);
          for (Y = 0; Y < W.length; Y++)
            this._map.hasLayer(W[Y]) && this._map.removeLayer(W[Y]);
          for (Y = 0; Y < O.length; Y++)
            this._map.hasLayer(O[Y]) || this._map.addLayer(O[Y]);
          this._handlingClick = !1, this._refocusOnMap();
        }
      },
      _checkDisabledLayers: function() {
        for (var u = this._layerControlInputs, h, C, O = this._map.getZoom(), W = u.length - 1; W >= 0; W--)
          h = u[W], C = this._getLayer(h.layerId).layer, h.disabled = C.options.minZoom !== void 0 && O < C.options.minZoom || C.options.maxZoom !== void 0 && O > C.options.maxZoom;
      },
      _expandIfNotCollapsed: function() {
        return this._map && !this.options.collapsed && this.expand(), this;
      },
      _expandSafely: function() {
        var u = this._section;
        this._preventClick = !0, Ze(u, "click", vn), this.expand();
        var h = this;
        setTimeout(function() {
          xe(u, "click", vn), h._preventClick = !1;
        });
      }
    }), O6 = function(u, h, C) {
      return new oC(u, h, C);
    }, uv = ti.extend({
      // @section
      // @aka Control.Zoom options
      options: {
        position: "topleft",
        // @option zoomInText: String = '<span aria-hidden="true">+</span>'
        // The text set on the 'zoom in' button.
        zoomInText: '<span aria-hidden="true">+</span>',
        // @option zoomInTitle: String = 'Zoom in'
        // The title set on the 'zoom in' button.
        zoomInTitle: "Zoom in",
        // @option zoomOutText: String = '<span aria-hidden="true">&#x2212;</span>'
        // The text set on the 'zoom out' button.
        zoomOutText: '<span aria-hidden="true">&#x2212;</span>',
        // @option zoomOutTitle: String = 'Zoom out'
        // The title set on the 'zoom out' button.
        zoomOutTitle: "Zoom out"
      },
      onAdd: function(u) {
        var h = "leaflet-control-zoom", C = pt("div", h + " leaflet-bar"), O = this.options;
        return this._zoomInButton = this._createButton(
          O.zoomInText,
          O.zoomInTitle,
          h + "-in",
          C,
          this._zoomIn
        ), this._zoomOutButton = this._createButton(
          O.zoomOutText,
          O.zoomOutTitle,
          h + "-out",
          C,
          this._zoomOut
        ), this._updateDisabled(), u.on("zoomend zoomlevelschange", this._updateDisabled, this), C;
      },
      onRemove: function(u) {
        u.off("zoomend zoomlevelschange", this._updateDisabled, this);
      },
      disable: function() {
        return this._disabled = !0, this._updateDisabled(), this;
      },
      enable: function() {
        return this._disabled = !1, this._updateDisabled(), this;
      },
      _zoomIn: function(u) {
        !this._disabled && this._map._zoom < this._map.getMaxZoom() && this._map.zoomIn(this._map.options.zoomDelta * (u.shiftKey ? 3 : 1));
      },
      _zoomOut: function(u) {
        !this._disabled && this._map._zoom > this._map.getMinZoom() && this._map.zoomOut(this._map.options.zoomDelta * (u.shiftKey ? 3 : 1));
      },
      _createButton: function(u, h, C, O, W) {
        var Y = pt("a", C, O);
        return Y.innerHTML = u, Y.href = "#", Y.title = h, Y.setAttribute("role", "button"), Y.setAttribute("aria-label", h), Ra(Y), Ze(Y, "click", Es), Ze(Y, "click", W, this), Ze(Y, "click", this._refocusOnMap, this), Y;
      },
      _updateDisabled: function() {
        var u = this._map, h = "leaflet-disabled";
        Xt(this._zoomInButton, h), Xt(this._zoomOutButton, h), this._zoomInButton.setAttribute("aria-disabled", "false"), this._zoomOutButton.setAttribute("aria-disabled", "false"), (this._disabled || u._zoom === u.getMinZoom()) && (tt(this._zoomOutButton, h), this._zoomOutButton.setAttribute("aria-disabled", "true")), (this._disabled || u._zoom === u.getMaxZoom()) && (tt(this._zoomInButton, h), this._zoomInButton.setAttribute("aria-disabled", "true"));
      }
    });
    yt.mergeOptions({
      zoomControl: !0
    }), yt.addInitHook(function() {
      this.options.zoomControl && (this.zoomControl = new uv(), this.addControl(this.zoomControl));
    });
    var N6 = function(u) {
      return new uv(u);
    }, iC = ti.extend({
      // @section
      // @aka Control.Scale options
      options: {
        position: "bottomleft",
        // @option maxWidth: Number = 100
        // Maximum width of the control in pixels. The width is set dynamically to show round values (e.g. 100, 200, 500).
        maxWidth: 100,
        // @option metric: Boolean = True
        // Whether to show the metric scale line (m/km).
        metric: !0,
        // @option imperial: Boolean = True
        // Whether to show the imperial scale line (mi/ft).
        imperial: !0
        // @option updateWhenIdle: Boolean = false
        // If `true`, the control is updated on [`moveend`](#map-moveend), otherwise it's always up-to-date (updated on [`move`](#map-move)).
      },
      onAdd: function(u) {
        var h = "leaflet-control-scale", C = pt("div", h), O = this.options;
        return this._addScales(O, h + "-line", C), u.on(O.updateWhenIdle ? "moveend" : "move", this._update, this), u.whenReady(this._update, this), C;
      },
      onRemove: function(u) {
        u.off(this.options.updateWhenIdle ? "moveend" : "move", this._update, this);
      },
      _addScales: function(u, h, C) {
        u.metric && (this._mScale = pt("div", h, C)), u.imperial && (this._iScale = pt("div", h, C));
      },
      _update: function() {
        var u = this._map, h = u.getSize().y / 2, C = u.distance(
          u.containerPointToLatLng([0, h]),
          u.containerPointToLatLng([this.options.maxWidth, h])
        );
        this._updateScales(C);
      },
      _updateScales: function(u) {
        this.options.metric && u && this._updateMetric(u), this.options.imperial && u && this._updateImperial(u);
      },
      _updateMetric: function(u) {
        var h = this._getRoundNum(u), C = h < 1e3 ? h + " m" : h / 1e3 + " km";
        this._updateScale(this._mScale, C, h / u);
      },
      _updateImperial: function(u) {
        var h = u * 3.2808399, C, O, W;
        h > 5280 ? (C = h / 5280, O = this._getRoundNum(C), this._updateScale(this._iScale, O + " mi", O / C)) : (W = this._getRoundNum(h), this._updateScale(this._iScale, W + " ft", W / h));
      },
      _updateScale: function(u, h, C) {
        u.style.width = Math.round(this.options.maxWidth * C) + "px", u.innerHTML = h;
      },
      _getRoundNum: function(u) {
        var h = Math.pow(10, (Math.floor(u) + "").length - 1), C = u / h;
        return C = C >= 10 ? 10 : C >= 5 ? 5 : C >= 3 ? 3 : C >= 2 ? 2 : 1, h * C;
      }
    }), A6 = function(u) {
      return new iC(u);
    }, D6 = '<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="12" height="8" viewBox="0 0 12 8" class="leaflet-attribution-flag"><path fill="#4C7BE1" d="M0 0h12v4H0z"/><path fill="#FFD500" d="M0 4h12v3H0z"/><path fill="#E0BC00" d="M0 7h12v1H0z"/></svg>', dv = ti.extend({
      // @section
      // @aka Control.Attribution options
      options: {
        position: "bottomright",
        // @option prefix: String|false = 'Leaflet'
        // The HTML text shown before the attributions. Pass `false` to disable.
        prefix: '<a href="https://leafletjs.com" title="A JavaScript library for interactive maps">' + (ke.inlineSvg ? D6 + " " : "") + "Leaflet</a>"
      },
      initialize: function(u) {
        g(this, u), this._attributions = {};
      },
      onAdd: function(u) {
        u.attributionControl = this, this._container = pt("div", "leaflet-control-attribution"), Ra(this._container);
        for (var h in u._layers)
          u._layers[h].getAttribution && this.addAttribution(u._layers[h].getAttribution());
        return this._update(), u.on("layeradd", this._addAttribution, this), this._container;
      },
      onRemove: function(u) {
        u.off("layeradd", this._addAttribution, this);
      },
      _addAttribution: function(u) {
        u.layer.getAttribution && (this.addAttribution(u.layer.getAttribution()), u.layer.once("remove", function() {
          this.removeAttribution(u.layer.getAttribution());
        }, this));
      },
      // @method setPrefix(prefix: String|false): this
      // The HTML text shown before the attributions. Pass `false` to disable.
      setPrefix: function(u) {
        return this.options.prefix = u, this._update(), this;
      },
      // @method addAttribution(text: String): this
      // Adds an attribution text (e.g. `'&copy; OpenStreetMap contributors'`).
      addAttribution: function(u) {
        return u ? (this._attributions[u] || (this._attributions[u] = 0), this._attributions[u]++, this._update(), this) : this;
      },
      // @method removeAttribution(text: String): this
      // Removes an attribution text.
      removeAttribution: function(u) {
        return u ? (this._attributions[u] && (this._attributions[u]--, this._update()), this) : this;
      },
      _update: function() {
        if (this._map) {
          var u = [];
          for (var h in this._attributions)
            this._attributions[h] && u.push(h);
          var C = [];
          this.options.prefix && C.push(this.options.prefix), u.length && C.push(u.join(", ")), this._container.innerHTML = C.join(' <span aria-hidden="true">|</span> ');
        }
      }
    });
    yt.mergeOptions({
      attributionControl: !0
    }), yt.addInitHook(function() {
      this.options.attributionControl && new dv().addTo(this);
    });
    var I6 = function(u) {
      return new dv(u);
    };
    ti.Layers = oC, ti.Zoom = uv, ti.Scale = iC, ti.Attribution = dv, hu.layers = O6, hu.zoom = N6, hu.scale = A6, hu.attribution = I6;
    var mi = $.extend({
      initialize: function(u) {
        this._map = u;
      },
      // @method enable(): this
      // Enables the handler
      enable: function() {
        return this._enabled ? this : (this._enabled = !0, this.addHooks(), this);
      },
      // @method disable(): this
      // Disables the handler
      disable: function() {
        return this._enabled ? (this._enabled = !1, this.removeHooks(), this) : this;
      },
      // @method enabled(): Boolean
      // Returns `true` if the handler is enabled
      enabled: function() {
        return !!this._enabled;
      }
      // @section Extension methods
      // Classes inheriting from `Handler` must implement the two following methods:
      // @method addHooks()
      // Called when the handler is enabled, should add event hooks.
      // @method removeHooks()
      // Called when the handler is disabled, should remove the event hooks added previously.
    });
    mi.addTo = function(u, h) {
      return u.addHandler(h, this), this;
    };
    var L6 = { Events: j }, aC = ke.touch ? "touchstart mousedown" : "mousedown", Pa = U.extend({
      options: {
        // @section
        // @aka Draggable options
        // @option clickTolerance: Number = 3
        // The max number of pixels a user can shift the mouse pointer during a click
        // for it to be considered a valid click (as opposed to a mouse drag).
        clickTolerance: 3
      },
      // @constructor L.Draggable(el: HTMLElement, dragHandle?: HTMLElement, preventOutline?: Boolean, options?: Draggable options)
      // Creates a `Draggable` object for moving `el` when you start dragging the `dragHandle` element (equals `el` itself by default).
      initialize: function(u, h, C, O) {
        g(this, O), this._element = u, this._dragStartTarget = h || u, this._preventOutline = C;
      },
      // @method enable()
      // Enables the dragging ability
      enable: function() {
        this._enabled || (Ze(this._dragStartTarget, aC, this._onDown, this), this._enabled = !0);
      },
      // @method disable()
      // Disables the dragging ability
      disable: function() {
        this._enabled && (Pa._dragging === this && this.finishDrag(!0), xe(this._dragStartTarget, aC, this._onDown, this), this._enabled = !1, this._moved = !1);
      },
      _onDown: function(u) {
        if (this._enabled && (this._moved = !1, !to(this._element, "leaflet-zoom-anim"))) {
          if (u.touches && u.touches.length !== 1) {
            Pa._dragging === this && this.finishDrag();
            return;
          }
          if (!(Pa._dragging || u.shiftKey || u.which !== 1 && u.button !== 1 && !u.touches) && (Pa._dragging = this, this._preventOutline && Ma(this._element), Co(), di(), !this._moving)) {
            this.fire("down");
            var h = u.touches ? u.touches[0] : u, C = Cs(this._element);
            this._startPoint = new G(h.clientX, h.clientY), this._startPos = ei(this._element), this._parentScale = Ss(C);
            var O = u.type === "mousedown";
            Ze(document, O ? "mousemove" : "touchmove", this._onMove, this), Ze(document, O ? "mouseup" : "touchend touchcancel", this._onUp, this);
          }
        }
      },
      _onMove: function(u) {
        if (this._enabled) {
          if (u.touches && u.touches.length > 1) {
            this._moved = !0;
            return;
          }
          var h = u.touches && u.touches.length === 1 ? u.touches[0] : u, C = new G(h.clientX, h.clientY)._subtract(this._startPoint);
          !C.x && !C.y || Math.abs(C.x) + Math.abs(C.y) < this.options.clickTolerance || (C.x /= this._parentScale.x, C.y /= this._parentScale.y, vn(u), this._moved || (this.fire("dragstart"), this._moved = !0, tt(document.body, "leaflet-dragging"), this._lastTarget = u.target || u.srcElement, window.SVGElementInstance && this._lastTarget instanceof window.SVGElementInstance && (this._lastTarget = this._lastTarget.correspondingUseElement), tt(this._lastTarget, "leaflet-drag-target")), this._newPos = this._startPos.add(C), this._moving = !0, this._lastEvent = u, this._updatePosition());
        }
      },
      _updatePosition: function() {
        var u = { originalEvent: this._lastEvent };
        this.fire("predrag", u), sn(this._element, this._newPos), this.fire("drag", u);
      },
      _onUp: function() {
        this._enabled && this.finishDrag();
      },
      finishDrag: function(u) {
        Xt(document.body, "leaflet-dragging"), this._lastTarget && (Xt(this._lastTarget, "leaflet-drag-target"), this._lastTarget = null), xe(document, "mousemove touchmove", this._onMove, this), xe(document, "mouseup touchend touchcancel", this._onUp, this), fi(), tr();
        var h = this._moved && this._moving;
        this._moving = !1, Pa._dragging = !1, h && this.fire("dragend", {
          noInertia: u,
          distance: this._newPos.distanceTo(this._startPos)
        });
      }
    });
    function sC(u, h, C) {
      var O, W = [1, 4, 2, 8], Y, ie, de, he, be, Oe, qe, dt;
      for (Y = 0, Oe = u.length; Y < Oe; Y++)
        u[Y]._code = ks(u[Y], h);
      for (de = 0; de < 4; de++) {
        for (qe = W[de], O = [], Y = 0, Oe = u.length, ie = Oe - 1; Y < Oe; ie = Y++)
          he = u[Y], be = u[ie], he._code & qe ? be._code & qe || (dt = Ff(be, he, qe, h, C), dt._code = ks(dt, h), O.push(dt)) : (be._code & qe && (dt = Ff(be, he, qe, h, C), dt._code = ks(dt, h), O.push(dt)), O.push(he));
        u = O;
      }
      return u;
    }
    function lC(u, h) {
      var C, O, W, Y, ie, de, he, be, Oe;
      if (!u || u.length === 0)
        throw new Error("latlngs not passed");
      Eo(u) || (console.warn("latlngs are not flat! Only the first ring will be used"), u = u[0]);
      var qe = ne([0, 0]), dt = K(u), Sr = dt.getNorthWest().distanceTo(dt.getSouthWest()) * dt.getNorthEast().distanceTo(dt.getNorthWest());
      Sr < 1700 && (qe = fv(u));
      var nr = u.length, ko = [];
      for (C = 0; C < nr; C++) {
        var Lr = ne(u[C]);
        ko.push(h.project(ne([Lr.lat - qe.lat, Lr.lng - qe.lng])));
      }
      for (de = he = be = 0, C = 0, O = nr - 1; C < nr; O = C++)
        W = ko[C], Y = ko[O], ie = W.y * Y.x - Y.y * W.x, he += (W.x + Y.x) * ie, be += (W.y + Y.y) * ie, de += ie * 3;
      de === 0 ? Oe = ko[0] : Oe = [he / de, be / de];
      var wl = h.unproject(H(Oe));
      return ne([wl.lat + qe.lat, wl.lng + qe.lng]);
    }
    function fv(u) {
      for (var h = 0, C = 0, O = 0, W = 0; W < u.length; W++) {
        var Y = ne(u[W]);
        h += Y.lat, C += Y.lng, O++;
      }
      return ne([h / O, C / O]);
    }
    var $6 = {
      __proto__: null,
      clipPolygon: sC,
      polygonCenter: lC,
      centroid: fv
    };
    function cC(u, h) {
      if (!h || !u.length)
        return u.slice();
      var C = h * h;
      return u = B6(u, C), u = z6(u, C), u;
    }
    function uC(u, h, C) {
      return Math.sqrt(mu(u, h, C, !0));
    }
    function F6(u, h, C) {
      return mu(u, h, C);
    }
    function z6(u, h) {
      var C = u.length, O = typeof Uint8Array != "undefined" ? Uint8Array : Array, W = new O(C);
      W[0] = W[C - 1] = 1, pv(u, W, h, 0, C - 1);
      var Y, ie = [];
      for (Y = 0; Y < C; Y++)
        W[Y] && ie.push(u[Y]);
      return ie;
    }
    function pv(u, h, C, O, W) {
      var Y = 0, ie, de, he;
      for (de = O + 1; de <= W - 1; de++)
        he = mu(u[de], u[O], u[W], !0), he > Y && (ie = de, Y = he);
      Y > C && (h[ie] = 1, pv(u, h, C, O, ie), pv(u, h, C, ie, W));
    }
    function B6(u, h) {
      for (var C = [u[0]], O = 1, W = 0, Y = u.length; O < Y; O++)
        H6(u[O], u[W]) > h && (C.push(u[O]), W = O);
      return W < Y - 1 && C.push(u[Y - 1]), C;
    }
    var dC;
    function fC(u, h, C, O, W) {
      var Y = O ? dC : ks(u, C), ie = ks(h, C), de, he, be;
      for (dC = ie; ; ) {
        if (!(Y | ie))
          return [u, h];
        if (Y & ie)
          return !1;
        de = Y || ie, he = Ff(u, h, de, C, W), be = ks(he, C), de === Y ? (u = he, Y = be) : (h = he, ie = be);
      }
    }
    function Ff(u, h, C, O, W) {
      var Y = h.x - u.x, ie = h.y - u.y, de = O.min, he = O.max, be, Oe;
      return C & 8 ? (be = u.x + Y * (he.y - u.y) / ie, Oe = he.y) : C & 4 ? (be = u.x + Y * (de.y - u.y) / ie, Oe = de.y) : C & 2 ? (be = he.x, Oe = u.y + ie * (he.x - u.x) / Y) : C & 1 && (be = de.x, Oe = u.y + ie * (de.x - u.x) / Y), new G(be, Oe, W);
    }
    function ks(u, h) {
      var C = 0;
      return u.x < h.min.x ? C |= 1 : u.x > h.max.x && (C |= 2), u.y < h.min.y ? C |= 4 : u.y > h.max.y && (C |= 8), C;
    }
    function H6(u, h) {
      var C = h.x - u.x, O = h.y - u.y;
      return C * C + O * O;
    }
    function mu(u, h, C, O) {
      var W = h.x, Y = h.y, ie = C.x - W, de = C.y - Y, he = ie * ie + de * de, be;
      return he > 0 && (be = ((u.x - W) * ie + (u.y - Y) * de) / he, be > 1 ? (W = C.x, Y = C.y) : be > 0 && (W += ie * be, Y += de * be)), ie = u.x - W, de = u.y - Y, O ? ie * ie + de * de : new G(W, Y);
    }
    function Eo(u) {
      return !S(u[0]) || typeof u[0][0] != "object" && typeof u[0][0] != "undefined";
    }
    function pC(u) {
      return console.warn("Deprecated use of _flat, please use L.LineUtil.isFlat instead."), Eo(u);
    }
    function hC(u, h) {
      var C, O, W, Y, ie, de, he, be;
      if (!u || u.length === 0)
        throw new Error("latlngs not passed");
      Eo(u) || (console.warn("latlngs are not flat! Only the first ring will be used"), u = u[0]);
      var Oe = ne([0, 0]), qe = K(u), dt = qe.getNorthWest().distanceTo(qe.getSouthWest()) * qe.getNorthEast().distanceTo(qe.getNorthWest());
      dt < 1700 && (Oe = fv(u));
      var Sr = u.length, nr = [];
      for (C = 0; C < Sr; C++) {
        var ko = ne(u[C]);
        nr.push(h.project(ne([ko.lat - Oe.lat, ko.lng - Oe.lng])));
      }
      for (C = 0, O = 0; C < Sr - 1; C++)
        O += nr[C].distanceTo(nr[C + 1]) / 2;
      if (O === 0)
        be = nr[0];
      else
        for (C = 0, Y = 0; C < Sr - 1; C++)
          if (ie = nr[C], de = nr[C + 1], W = ie.distanceTo(de), Y += W, Y > O) {
            he = (Y - O) / W, be = [
              de.x - he * (de.x - ie.x),
              de.y - he * (de.y - ie.y)
            ];
            break;
          }
      var Lr = h.unproject(H(be));
      return ne([Lr.lat + Oe.lat, Lr.lng + Oe.lng]);
    }
    var j6 = {
      __proto__: null,
      simplify: cC,
      pointToSegmentDistance: uC,
      closestPointOnSegment: F6,
      clipSegment: fC,
      _getEdgeIntersection: Ff,
      _getBitCode: ks,
      _sqClosestPointOnSegment: mu,
      isFlat: Eo,
      _flat: pC,
      polylineCenter: hC
    }, hv = {
      project: function(u) {
        return new G(u.lng, u.lat);
      },
      unproject: function(u) {
        return new J(u.y, u.x);
      },
      bounds: new q([-180, -90], [180, 90])
    }, mv = {
      R: 6378137,
      R_MINOR: 6356752314245179e-9,
      bounds: new q([-2003750834279e-5, -1549657073972e-5], [2003750834279e-5, 1876465623138e-5]),
      project: function(u) {
        var h = Math.PI / 180, C = this.R, O = u.lat * h, W = this.R_MINOR / C, Y = Math.sqrt(1 - W * W), ie = Y * Math.sin(O), de = Math.tan(Math.PI / 4 - O / 2) / Math.pow((1 - ie) / (1 + ie), Y / 2);
        return O = -C * Math.log(Math.max(de, 1e-10)), new G(u.lng * h * C, O);
      },
      unproject: function(u) {
        for (var h = 180 / Math.PI, C = this.R, O = this.R_MINOR / C, W = Math.sqrt(1 - O * O), Y = Math.exp(-u.y / C), ie = Math.PI / 2 - 2 * Math.atan(Y), de = 0, he = 0.1, be; de < 15 && Math.abs(he) > 1e-7; de++)
          be = W * Math.sin(ie), be = Math.pow((1 - be) / (1 + be), W / 2), he = Math.PI / 2 - 2 * Math.atan(Y * be) - ie, ie += he;
        return new J(ie * h, u.x * h / C);
      }
    }, W6 = {
      __proto__: null,
      LonLat: hv,
      Mercator: mv,
      SphericalMercator: ce
    }, V6 = o({}, te, {
      code: "EPSG:3395",
      projection: mv,
      transformation: function() {
        var u = 0.5 / (Math.PI * mv.R);
        return ee(u, 0.5, -u, 0.5);
      }()
    }), mC = o({}, te, {
      code: "EPSG:4326",
      projection: hv,
      transformation: ee(1 / 180, 1, -1 / 180, 0.5)
    }), U6 = o({}, ae, {
      projection: hv,
      transformation: ee(1, 0, -1, 0),
      scale: function(u) {
        return Math.pow(2, u);
      },
      zoom: function(u) {
        return Math.log(u) / Math.LN2;
      },
      distance: function(u, h) {
        var C = h.lng - u.lng, O = h.lat - u.lat;
        return Math.sqrt(C * C + O * O);
      },
      infinite: !0
    });
    ae.Earth = te, ae.EPSG3395 = V6, ae.EPSG3857 = me, ae.EPSG900913 = oe, ae.EPSG4326 = mC, ae.Simple = U6;
    var ni = U.extend({
      // Classes extending `L.Layer` will inherit the following options:
      options: {
        // @option pane: String = 'overlayPane'
        // By default the layer will be added to the map's [overlay pane](#map-overlaypane). Overriding this option will cause the layer to be placed on another pane by default.
        pane: "overlayPane",
        // @option attribution: String = null
        // String to be shown in the attribution control, e.g. "© OpenStreetMap contributors". It describes the layer data and is often a legal obligation towards copyright holders and tile providers.
        attribution: null,
        bubblingMouseEvents: !0
      },
      /* @section
       * Classes extending `L.Layer` will inherit the following methods:
       *
       * @method addTo(map: Map|LayerGroup): this
       * Adds the layer to the given map or layer group.
       */
      addTo: function(u) {
        return u.addLayer(this), this;
      },
      // @method remove: this
      // Removes the layer from the map it is currently active on.
      remove: function() {
        return this.removeFrom(this._map || this._mapToAdd);
      },
      // @method removeFrom(map: Map): this
      // Removes the layer from the given map
      //
      // @alternative
      // @method removeFrom(group: LayerGroup): this
      // Removes the layer from the given `LayerGroup`
      removeFrom: function(u) {
        return u && u.removeLayer(this), this;
      },
      // @method getPane(name? : String): HTMLElement
      // Returns the `HTMLElement` representing the named pane on the map. If `name` is omitted, returns the pane for this layer.
      getPane: function(u) {
        return this._map.getPane(u ? this.options[u] || u : this.options.pane);
      },
      addInteractiveTarget: function(u) {
        return this._map._targets[c(u)] = this, this;
      },
      removeInteractiveTarget: function(u) {
        return delete this._map._targets[c(u)], this;
      },
      // @method getAttribution: String
      // Used by the `attribution control`, returns the [attribution option](#gridlayer-attribution).
      getAttribution: function() {
        return this.options.attribution;
      },
      _layerAdd: function(u) {
        var h = u.target;
        if (h.hasLayer(this)) {
          if (this._map = h, this._zoomAnimated = h._zoomAnimated, this.getEvents) {
            var C = this.getEvents();
            h.on(C, this), this.once("remove", function() {
              h.off(C, this);
            }, this);
          }
          this.onAdd(h), this.fire("add"), h.fire("layeradd", { layer: this });
        }
      }
    });
    yt.include({
      // @method addLayer(layer: Layer): this
      // Adds the given layer to the map
      addLayer: function(u) {
        if (!u._layerAdd)
          throw new Error("The provided object is not a Layer.");
        var h = c(u);
        return this._layers[h] ? this : (this._layers[h] = u, u._mapToAdd = this, u.beforeAdd && u.beforeAdd(this), this.whenReady(u._layerAdd, u), this);
      },
      // @method removeLayer(layer: Layer): this
      // Removes the given layer from the map.
      removeLayer: function(u) {
        var h = c(u);
        return this._layers[h] ? (this._loaded && u.onRemove(this), delete this._layers[h], this._loaded && (this.fire("layerremove", { layer: u }), u.fire("remove")), u._map = u._mapToAdd = null, this) : this;
      },
      // @method hasLayer(layer: Layer): Boolean
      // Returns `true` if the given layer is currently added to the map
      hasLayer: function(u) {
        return c(u) in this._layers;
      },
      /* @method eachLayer(fn: Function, context?: Object): this
       * Iterates over the layers of the map, optionally specifying context of the iterator function.
       * ```
       * map.eachLayer(function(layer){
       *     layer.bindPopup('Hello');
       * });
       * ```
       */
      eachLayer: function(u, h) {
        for (var C in this._layers)
          u.call(h, this._layers[C]);
        return this;
      },
      _addLayers: function(u) {
        u = u ? S(u) ? u : [u] : [];
        for (var h = 0, C = u.length; h < C; h++)
          this.addLayer(u[h]);
      },
      _addZoomLimit: function(u) {
        (!isNaN(u.options.maxZoom) || !isNaN(u.options.minZoom)) && (this._zoomBoundLayers[c(u)] = u, this._updateZoomLevels());
      },
      _removeZoomLimit: function(u) {
        var h = c(u);
        this._zoomBoundLayers[h] && (delete this._zoomBoundLayers[h], this._updateZoomLevels());
      },
      _updateZoomLevels: function() {
        var u = 1 / 0, h = -1 / 0, C = this._getZoomSpan();
        for (var O in this._zoomBoundLayers) {
          var W = this._zoomBoundLayers[O].options;
          u = W.minZoom === void 0 ? u : Math.min(u, W.minZoom), h = W.maxZoom === void 0 ? h : Math.max(h, W.maxZoom);
        }
        this._layersMaxZoom = h === -1 / 0 ? void 0 : h, this._layersMinZoom = u === 1 / 0 ? void 0 : u, C !== this._getZoomSpan() && this.fire("zoomlevelschange"), this.options.maxZoom === void 0 && this._layersMaxZoom && this.getZoom() > this._layersMaxZoom && this.setZoom(this._layersMaxZoom), this.options.minZoom === void 0 && this._layersMinZoom && this.getZoom() < this._layersMinZoom && this.setZoom(this._layersMinZoom);
      }
    });
    var gl = ni.extend({
      initialize: function(u, h) {
        g(this, h), this._layers = {};
        var C, O;
        if (u)
          for (C = 0, O = u.length; C < O; C++)
            this.addLayer(u[C]);
      },
      // @method addLayer(layer: Layer): this
      // Adds the given layer to the group.
      addLayer: function(u) {
        var h = this.getLayerId(u);
        return this._layers[h] = u, this._map && this._map.addLayer(u), this;
      },
      // @method removeLayer(layer: Layer): this
      // Removes the given layer from the group.
      // @alternative
      // @method removeLayer(id: Number): this
      // Removes the layer with the given internal ID from the group.
      removeLayer: function(u) {
        var h = u in this._layers ? u : this.getLayerId(u);
        return this._map && this._layers[h] && this._map.removeLayer(this._layers[h]), delete this._layers[h], this;
      },
      // @method hasLayer(layer: Layer): Boolean
      // Returns `true` if the given layer is currently added to the group.
      // @alternative
      // @method hasLayer(id: Number): Boolean
      // Returns `true` if the given internal ID is currently added to the group.
      hasLayer: function(u) {
        var h = typeof u == "number" ? u : this.getLayerId(u);
        return h in this._layers;
      },
      // @method clearLayers(): this
      // Removes all the layers from the group.
      clearLayers: function() {
        return this.eachLayer(this.removeLayer, this);
      },
      // @method invoke(methodName: String, …): this
      // Calls `methodName` on every layer contained in this group, passing any
      // additional parameters. Has no effect if the layers contained do not
      // implement `methodName`.
      invoke: function(u) {
        var h = Array.prototype.slice.call(arguments, 1), C, O;
        for (C in this._layers)
          O = this._layers[C], O[u] && O[u].apply(O, h);
        return this;
      },
      onAdd: function(u) {
        this.eachLayer(u.addLayer, u);
      },
      onRemove: function(u) {
        this.eachLayer(u.removeLayer, u);
      },
      // @method eachLayer(fn: Function, context?: Object): this
      // Iterates over the layers of the group, optionally specifying context of the iterator function.
      // ```js
      // group.eachLayer(function (layer) {
      // 	layer.bindPopup('Hello');
      // });
      // ```
      eachLayer: function(u, h) {
        for (var C in this._layers)
          u.call(h, this._layers[C]);
        return this;
      },
      // @method getLayer(id: Number): Layer
      // Returns the layer with the given internal ID.
      getLayer: function(u) {
        return this._layers[u];
      },
      // @method getLayers(): Layer[]
      // Returns an array of all the layers added to the group.
      getLayers: function() {
        var u = [];
        return this.eachLayer(u.push, u), u;
      },
      // @method setZIndex(zIndex: Number): this
      // Calls `setZIndex` on every layer contained in this group, passing the z-index.
      setZIndex: function(u) {
        return this.invoke("setZIndex", u);
      },
      // @method getLayerId(layer: Layer): Number
      // Returns the internal ID for a layer
      getLayerId: function(u) {
        return c(u);
      }
    }), q6 = function(u, h) {
      return new gl(u, h);
    }, Qi = gl.extend({
      addLayer: function(u) {
        return this.hasLayer(u) ? this : (u.addEventParent(this), gl.prototype.addLayer.call(this, u), this.fire("layeradd", { layer: u }));
      },
      removeLayer: function(u) {
        return this.hasLayer(u) ? (u in this._layers && (u = this._layers[u]), u.removeEventParent(this), gl.prototype.removeLayer.call(this, u), this.fire("layerremove", { layer: u })) : this;
      },
      // @method setStyle(style: Path options): this
      // Sets the given path options to each layer of the group that has a `setStyle` method.
      setStyle: function(u) {
        return this.invoke("setStyle", u);
      },
      // @method bringToFront(): this
      // Brings the layer group to the top of all other layers
      bringToFront: function() {
        return this.invoke("bringToFront");
      },
      // @method bringToBack(): this
      // Brings the layer group to the back of all other layers
      bringToBack: function() {
        return this.invoke("bringToBack");
      },
      // @method getBounds(): LatLngBounds
      // Returns the LatLngBounds of the Feature Group (created from bounds and coordinates of its children).
      getBounds: function() {
        var u = new X();
        for (var h in this._layers) {
          var C = this._layers[h];
          u.extend(C.getBounds ? C.getBounds() : C.getLatLng());
        }
        return u;
      }
    }), G6 = function(u, h) {
      return new Qi(u, h);
    }, vl = $.extend({
      /* @section
       * @aka Icon options
       *
       * @option iconUrl: String = null
       * **(required)** The URL to the icon image (absolute or relative to your script path).
       *
       * @option iconRetinaUrl: String = null
       * The URL to a retina sized version of the icon image (absolute or relative to your
       * script path). Used for Retina screen devices.
       *
       * @option iconSize: Point = null
       * Size of the icon image in pixels.
       *
       * @option iconAnchor: Point = null
       * The coordinates of the "tip" of the icon (relative to its top left corner). The icon
       * will be aligned so that this point is at the marker's geographical location. Centered
       * by default if size is specified, also can be set in CSS with negative margins.
       *
       * @option popupAnchor: Point = [0, 0]
       * The coordinates of the point from which popups will "open", relative to the icon anchor.
       *
       * @option tooltipAnchor: Point = [0, 0]
       * The coordinates of the point from which tooltips will "open", relative to the icon anchor.
       *
       * @option shadowUrl: String = null
       * The URL to the icon shadow image. If not specified, no shadow image will be created.
       *
       * @option shadowRetinaUrl: String = null
       *
       * @option shadowSize: Point = null
       * Size of the shadow image in pixels.
       *
       * @option shadowAnchor: Point = null
       * The coordinates of the "tip" of the shadow (relative to its top left corner) (the same
       * as iconAnchor if not specified).
       *
       * @option className: String = ''
       * A custom class name to assign to both icon and shadow images. Empty by default.
       */
      options: {
        popupAnchor: [0, 0],
        tooltipAnchor: [0, 0],
        // @option crossOrigin: Boolean|String = false
        // Whether the crossOrigin attribute will be added to the tiles.
        // If a String is provided, all tiles will have their crossOrigin attribute set to the String provided. This is needed if you want to access tile pixel data.
        // Refer to [CORS Settings](https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_settings_attributes) for valid String values.
        crossOrigin: !1
      },
      initialize: function(u) {
        g(this, u);
      },
      // @method createIcon(oldIcon?: HTMLElement): HTMLElement
      // Called internally when the icon has to be shown, returns a `<img>` HTML element
      // styled according to the options.
      createIcon: function(u) {
        return this._createIcon("icon", u);
      },
      // @method createShadow(oldIcon?: HTMLElement): HTMLElement
      // As `createIcon`, but for the shadow beneath it.
      createShadow: function(u) {
        return this._createIcon("shadow", u);
      },
      _createIcon: function(u, h) {
        var C = this._getIconUrl(u);
        if (!C) {
          if (u === "icon")
            throw new Error("iconUrl not set in Icon options (see the docs).");
          return null;
        }
        var O = this._createImg(C, h && h.tagName === "IMG" ? h : null);
        return this._setIconStyles(O, u), (this.options.crossOrigin || this.options.crossOrigin === "") && (O.crossOrigin = this.options.crossOrigin === !0 ? "" : this.options.crossOrigin), O;
      },
      _setIconStyles: function(u, h) {
        var C = this.options, O = C[h + "Size"];
        typeof O == "number" && (O = [O, O]);
        var W = H(O), Y = H(h === "shadow" && C.shadowAnchor || C.iconAnchor || W && W.divideBy(2, !0));
        u.className = "leaflet-marker-" + h + " " + (C.className || ""), Y && (u.style.marginLeft = -Y.x + "px", u.style.marginTop = -Y.y + "px"), W && (u.style.width = W.x + "px", u.style.height = W.y + "px");
      },
      _createImg: function(u, h) {
        return h = h || document.createElement("img"), h.src = u, h;
      },
      _getIconUrl: function(u) {
        return ke.retina && this.options[u + "RetinaUrl"] || this.options[u + "Url"];
      }
    });
    function Y6(u) {
      return new vl(u);
    }
    var gu = vl.extend({
      options: {
        iconUrl: "marker-icon.png",
        iconRetinaUrl: "marker-icon-2x.png",
        shadowUrl: "marker-shadow.png",
        iconSize: [25, 41],
        iconAnchor: [12, 41],
        popupAnchor: [1, -34],
        tooltipAnchor: [16, -28],
        shadowSize: [41, 41]
      },
      _getIconUrl: function(u) {
        return typeof gu.imagePath != "string" && (gu.imagePath = this._detectIconPath()), (this.options.imagePath || gu.imagePath) + vl.prototype._getIconUrl.call(this, u);
      },
      _stripUrl: function(u) {
        var h = function(C, O, W) {
          var Y = O.exec(C);
          return Y && Y[W];
        };
        return u = h(u, /^url\((['"])?(.+)\1\)$/, 2), u && h(u, /^(.*)marker-icon\.png$/, 1);
      },
      _detectIconPath: function() {
        var u = pt("div", "leaflet-default-icon-path", document.body), h = Qo(u, "background-image") || Qo(u, "backgroundImage");
        if (document.body.removeChild(u), h = this._stripUrl(h), h)
          return h;
        var C = document.querySelector('link[href$="leaflet.css"]');
        return C ? C.href.substring(0, C.href.length - 11 - 1) : "";
      }
    }), gC = mi.extend({
      initialize: function(u) {
        this._marker = u;
      },
      addHooks: function() {
        var u = this._marker._icon;
        this._draggable || (this._draggable = new Pa(u, u, !0)), this._draggable.on({
          dragstart: this._onDragStart,
          predrag: this._onPreDrag,
          drag: this._onDrag,
          dragend: this._onDragEnd
        }, this).enable(), tt(u, "leaflet-marker-draggable");
      },
      removeHooks: function() {
        this._draggable.off({
          dragstart: this._onDragStart,
          predrag: this._onPreDrag,
          drag: this._onDrag,
          dragend: this._onDragEnd
        }, this).disable(), this._marker._icon && Xt(this._marker._icon, "leaflet-marker-draggable");
      },
      moved: function() {
        return this._draggable && this._draggable._moved;
      },
      _adjustPan: function(u) {
        var h = this._marker, C = h._map, O = this._marker.options.autoPanSpeed, W = this._marker.options.autoPanPadding, Y = ei(h._icon), ie = C.getPixelBounds(), de = C.getPixelOrigin(), he = Q(
          ie.min._subtract(de).add(W),
          ie.max._subtract(de).subtract(W)
        );
        if (!he.contains(Y)) {
          var be = H(
            (Math.max(he.max.x, Y.x) - he.max.x) / (ie.max.x - he.max.x) - (Math.min(he.min.x, Y.x) - he.min.x) / (ie.min.x - he.min.x),
            (Math.max(he.max.y, Y.y) - he.max.y) / (ie.max.y - he.max.y) - (Math.min(he.min.y, Y.y) - he.min.y) / (ie.min.y - he.min.y)
          ).multiplyBy(O);
          C.panBy(be, { animate: !1 }), this._draggable._newPos._add(be), this._draggable._startPos._add(be), sn(h._icon, this._draggable._newPos), this._onDrag(u), this._panRequest = D(this._adjustPan.bind(this, u));
        }
      },
      _onDragStart: function() {
        this._oldLatLng = this._marker.getLatLng(), this._marker.closePopup && this._marker.closePopup(), this._marker.fire("movestart").fire("dragstart");
      },
      _onPreDrag: function(u) {
        this._marker.options.autoPan && (N(this._panRequest), this._panRequest = D(this._adjustPan.bind(this, u)));
      },
      _onDrag: function(u) {
        var h = this._marker, C = h._shadow, O = ei(h._icon), W = h._map.layerPointToLatLng(O);
        C && sn(C, O), h._latlng = W, u.latlng = W, u.oldLatLng = this._oldLatLng, h.fire("move", u).fire("drag", u);
      },
      _onDragEnd: function(u) {
        N(this._panRequest), delete this._oldLatLng, this._marker.fire("moveend").fire("dragend", u);
      }
    }), zf = ni.extend({
      // @section
      // @aka Marker options
      options: {
        // @option icon: Icon = *
        // Icon instance to use for rendering the marker.
        // See [Icon documentation](#L.Icon) for details on how to customize the marker icon.
        // If not specified, a common instance of `L.Icon.Default` is used.
        icon: new gu(),
        // Option inherited from "Interactive layer" abstract class
        interactive: !0,
        // @option keyboard: Boolean = true
        // Whether the marker can be tabbed to with a keyboard and clicked by pressing enter.
        keyboard: !0,
        // @option title: String = ''
        // Text for the browser tooltip that appear on marker hover (no tooltip by default).
        // [Useful for accessibility](https://leafletjs.com/examples/accessibility/#markers-must-be-labelled).
        title: "",
        // @option alt: String = 'Marker'
        // Text for the `alt` attribute of the icon image.
        // [Useful for accessibility](https://leafletjs.com/examples/accessibility/#markers-must-be-labelled).
        alt: "Marker",
        // @option zIndexOffset: Number = 0
        // By default, marker images zIndex is set automatically based on its latitude. Use this option if you want to put the marker on top of all others (or below), specifying a high value like `1000` (or high negative value, respectively).
        zIndexOffset: 0,
        // @option opacity: Number = 1.0
        // The opacity of the marker.
        opacity: 1,
        // @option riseOnHover: Boolean = false
        // If `true`, the marker will get on top of others when you hover the mouse over it.
        riseOnHover: !1,
        // @option riseOffset: Number = 250
        // The z-index offset used for the `riseOnHover` feature.
        riseOffset: 250,
        // @option pane: String = 'markerPane'
        // `Map pane` where the markers icon will be added.
        pane: "markerPane",
        // @option shadowPane: String = 'shadowPane'
        // `Map pane` where the markers shadow will be added.
        shadowPane: "shadowPane",
        // @option bubblingMouseEvents: Boolean = false
        // When `true`, a mouse event on this marker will trigger the same event on the map
        // (unless [`L.DomEvent.stopPropagation`](#domevent-stoppropagation) is used).
        bubblingMouseEvents: !1,
        // @option autoPanOnFocus: Boolean = true
        // When `true`, the map will pan whenever the marker is focused (via
        // e.g. pressing `tab` on the keyboard) to ensure the marker is
        // visible within the map's bounds
        autoPanOnFocus: !0,
        // @section Draggable marker options
        // @option draggable: Boolean = false
        // Whether the marker is draggable with mouse/touch or not.
        draggable: !1,
        // @option autoPan: Boolean = false
        // Whether to pan the map when dragging this marker near its edge or not.
        autoPan: !1,
        // @option autoPanPadding: Point = Point(50, 50)
        // Distance (in pixels to the left/right and to the top/bottom) of the
        // map edge to start panning the map.
        autoPanPadding: [50, 50],
        // @option autoPanSpeed: Number = 10
        // Number of pixels the map should pan by.
        autoPanSpeed: 10
      },
      /* @section
       *
       * In addition to [shared layer methods](#Layer) like `addTo()` and `remove()` and [popup methods](#Popup) like bindPopup() you can also use the following methods:
       */
      initialize: function(u, h) {
        g(this, h), this._latlng = ne(u);
      },
      onAdd: function(u) {
        this._zoomAnimated = this._zoomAnimated && u.options.markerZoomAnimation, this._zoomAnimated && u.on("zoomanim", this._animateZoom, this), this._initIcon(), this.update();
      },
      onRemove: function(u) {
        this.dragging && this.dragging.enabled() && (this.options.draggable = !0, this.dragging.removeHooks()), delete this.dragging, this._zoomAnimated && u.off("zoomanim", this._animateZoom, this), this._removeIcon(), this._removeShadow();
      },
      getEvents: function() {
        return {
          zoom: this.update,
          viewreset: this.update
        };
      },
      // @method getLatLng: LatLng
      // Returns the current geographical position of the marker.
      getLatLng: function() {
        return this._latlng;
      },
      // @method setLatLng(latlng: LatLng): this
      // Changes the marker position to the given point.
      setLatLng: function(u) {
        var h = this._latlng;
        return this._latlng = ne(u), this.update(), this.fire("move", { oldLatLng: h, latlng: this._latlng });
      },
      // @method setZIndexOffset(offset: Number): this
      // Changes the [zIndex offset](#marker-zindexoffset) of the marker.
      setZIndexOffset: function(u) {
        return this.options.zIndexOffset = u, this.update();
      },
      // @method getIcon: Icon
      // Returns the current icon used by the marker
      getIcon: function() {
        return this.options.icon;
      },
      // @method setIcon(icon: Icon): this
      // Changes the marker icon.
      setIcon: function(u) {
        return this.options.icon = u, this._map && (this._initIcon(), this.update()), this._popup && this.bindPopup(this._popup, this._popup.options), this;
      },
      getElement: function() {
        return this._icon;
      },
      update: function() {
        if (this._icon && this._map) {
          var u = this._map.latLngToLayerPoint(this._latlng).round();
          this._setPos(u);
        }
        return this;
      },
      _initIcon: function() {
        var u = this.options, h = "leaflet-zoom-" + (this._zoomAnimated ? "animated" : "hide"), C = u.icon.createIcon(this._icon), O = !1;
        C !== this._icon && (this._icon && this._removeIcon(), O = !0, u.title && (C.title = u.title), C.tagName === "IMG" && (C.alt = u.alt || "")), tt(C, h), u.keyboard && (C.tabIndex = "0", C.setAttribute("role", "button")), this._icon = C, u.riseOnHover && this.on({
          mouseover: this._bringToFront,
          mouseout: this._resetZIndex
        }), this.options.autoPanOnFocus && Ze(C, "focus", this._panOnFocus, this);
        var W = u.icon.createShadow(this._shadow), Y = !1;
        W !== this._shadow && (this._removeShadow(), Y = !0), W && (tt(W, h), W.alt = ""), this._shadow = W, u.opacity < 1 && this._updateOpacity(), O && this.getPane().appendChild(this._icon), this._initInteraction(), W && Y && this.getPane(u.shadowPane).appendChild(this._shadow);
      },
      _removeIcon: function() {
        this.options.riseOnHover && this.off({
          mouseover: this._bringToFront,
          mouseout: this._resetZIndex
        }), this.options.autoPanOnFocus && xe(this._icon, "focus", this._panOnFocus, this), Et(this._icon), this.removeInteractiveTarget(this._icon), this._icon = null;
      },
      _removeShadow: function() {
        this._shadow && Et(this._shadow), this._shadow = null;
      },
      _setPos: function(u) {
        this._icon && sn(this._icon, u), this._shadow && sn(this._shadow, u), this._zIndex = u.y + this.options.zIndexOffset, this._resetZIndex();
      },
      _updateZIndex: function(u) {
        this._icon && (this._icon.style.zIndex = this._zIndex + u);
      },
      _animateZoom: function(u) {
        var h = this._map._latLngToNewLayerPoint(this._latlng, u.zoom, u.center).round();
        this._setPos(h);
      },
      _initInteraction: function() {
        if (this.options.interactive && (tt(this._icon, "leaflet-interactive"), this.addInteractiveTarget(this._icon), gC)) {
          var u = this.options.draggable;
          this.dragging && (u = this.dragging.enabled(), this.dragging.disable()), this.dragging = new gC(this), u && this.dragging.enable();
        }
      },
      // @method setOpacity(opacity: Number): this
      // Changes the opacity of the marker.
      setOpacity: function(u) {
        return this.options.opacity = u, this._map && this._updateOpacity(), this;
      },
      _updateOpacity: function() {
        var u = this.options.opacity;
        this._icon && gr(this._icon, u), this._shadow && gr(this._shadow, u);
      },
      _bringToFront: function() {
        this._updateZIndex(this.options.riseOffset);
      },
      _resetZIndex: function() {
        this._updateZIndex(0);
      },
      _panOnFocus: function() {
        var u = this._map;
        if (u) {
          var h = this.options.icon.options, C = h.iconSize ? H(h.iconSize) : H(0, 0), O = h.iconAnchor ? H(h.iconAnchor) : H(0, 0);
          u.panInside(this._latlng, {
            paddingTopLeft: O,
            paddingBottomRight: C.subtract(O)
          });
        }
      },
      _getPopupAnchor: function() {
        return this.options.icon.options.popupAnchor;
      },
      _getTooltipAnchor: function() {
        return this.options.icon.options.tooltipAnchor;
      }
    });
    function Z6(u, h) {
      return new zf(u, h);
    }
    var Oa = ni.extend({
      // @section
      // @aka Path options
      options: {
        // @option stroke: Boolean = true
        // Whether to draw stroke along the path. Set it to `false` to disable borders on polygons or circles.
        stroke: !0,
        // @option color: String = '#3388ff'
        // Stroke color
        color: "#3388ff",
        // @option weight: Number = 3
        // Stroke width in pixels
        weight: 3,
        // @option opacity: Number = 1.0
        // Stroke opacity
        opacity: 1,
        // @option lineCap: String= 'round'
        // A string that defines [shape to be used at the end](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-linecap) of the stroke.
        lineCap: "round",
        // @option lineJoin: String = 'round'
        // A string that defines [shape to be used at the corners](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-linejoin) of the stroke.
        lineJoin: "round",
        // @option dashArray: String = null
        // A string that defines the stroke [dash pattern](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-dasharray). Doesn't work on `Canvas`-powered layers in [some old browsers](https://developer.mozilla.org/docs/Web/API/CanvasRenderingContext2D/setLineDash#Browser_compatibility).
        dashArray: null,
        // @option dashOffset: String = null
        // A string that defines the [distance into the dash pattern to start the dash](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-dashoffset). Doesn't work on `Canvas`-powered layers in [some old browsers](https://developer.mozilla.org/docs/Web/API/CanvasRenderingContext2D/setLineDash#Browser_compatibility).
        dashOffset: null,
        // @option fill: Boolean = depends
        // Whether to fill the path with color. Set it to `false` to disable filling on polygons or circles.
        fill: !1,
        // @option fillColor: String = *
        // Fill color. Defaults to the value of the [`color`](#path-color) option
        fillColor: null,
        // @option fillOpacity: Number = 0.2
        // Fill opacity.
        fillOpacity: 0.2,
        // @option fillRule: String = 'evenodd'
        // A string that defines [how the inside of a shape](https://developer.mozilla.org/docs/Web/SVG/Attribute/fill-rule) is determined.
        fillRule: "evenodd",
        // className: '',
        // Option inherited from "Interactive layer" abstract class
        interactive: !0,
        // @option bubblingMouseEvents: Boolean = true
        // When `true`, a mouse event on this path will trigger the same event on the map
        // (unless [`L.DomEvent.stopPropagation`](#domevent-stoppropagation) is used).
        bubblingMouseEvents: !0
      },
      beforeAdd: function(u) {
        this._renderer = u.getRenderer(this);
      },
      onAdd: function() {
        this._renderer._initPath(this), this._reset(), this._renderer._addPath(this);
      },
      onRemove: function() {
        this._renderer._removePath(this);
      },
      // @method redraw(): this
      // Redraws the layer. Sometimes useful after you changed the coordinates that the path uses.
      redraw: function() {
        return this._map && this._renderer._updatePath(this), this;
      },
      // @method setStyle(style: Path options): this
      // Changes the appearance of a Path based on the options in the `Path options` object.
      setStyle: function(u) {
        return g(this, u), this._renderer && (this._renderer._updateStyle(this), this.options.stroke && u && Object.prototype.hasOwnProperty.call(u, "weight") && this._updateBounds()), this;
      },
      // @method bringToFront(): this
      // Brings the layer to the top of all path layers.
      bringToFront: function() {
        return this._renderer && this._renderer._bringToFront(this), this;
      },
      // @method bringToBack(): this
      // Brings the layer to the bottom of all path layers.
      bringToBack: function() {
        return this._renderer && this._renderer._bringToBack(this), this;
      },
      getElement: function() {
        return this._path;
      },
      _reset: function() {
        this._project(), this._update();
      },
      _clickTolerance: function() {
        return (this.options.stroke ? this.options.weight / 2 : 0) + (this._renderer.options.tolerance || 0);
      }
    }), Bf = Oa.extend({
      // @section
      // @aka CircleMarker options
      options: {
        fill: !0,
        // @option radius: Number = 10
        // Radius of the circle marker, in pixels
        radius: 10
      },
      initialize: function(u, h) {
        g(this, h), this._latlng = ne(u), this._radius = this.options.radius;
      },
      // @method setLatLng(latLng: LatLng): this
      // Sets the position of a circle marker to a new location.
      setLatLng: function(u) {
        var h = this._latlng;
        return this._latlng = ne(u), this.redraw(), this.fire("move", { oldLatLng: h, latlng: this._latlng });
      },
      // @method getLatLng(): LatLng
      // Returns the current geographical position of the circle marker
      getLatLng: function() {
        return this._latlng;
      },
      // @method setRadius(radius: Number): this
      // Sets the radius of a circle marker. Units are in pixels.
      setRadius: function(u) {
        return this.options.radius = this._radius = u, this.redraw();
      },
      // @method getRadius(): Number
      // Returns the current radius of the circle
      getRadius: function() {
        return this._radius;
      },
      setStyle: function(u) {
        var h = u && u.radius || this._radius;
        return Oa.prototype.setStyle.call(this, u), this.setRadius(h), this;
      },
      _project: function() {
        this._point = this._map.latLngToLayerPoint(this._latlng), this._updateBounds();
      },
      _updateBounds: function() {
        var u = this._radius, h = this._radiusY || u, C = this._clickTolerance(), O = [u + C, h + C];
        this._pxBounds = new q(this._point.subtract(O), this._point.add(O));
      },
      _update: function() {
        this._map && this._updatePath();
      },
      _updatePath: function() {
        this._renderer._updateCircle(this);
      },
      _empty: function() {
        return this._radius && !this._renderer._bounds.intersects(this._pxBounds);
      },
      // Needed by the `Canvas` renderer for interactivity
      _containsPoint: function(u) {
        return u.distanceTo(this._point) <= this._radius + this._clickTolerance();
      }
    });
    function X6(u, h) {
      return new Bf(u, h);
    }
    var gv = Bf.extend({
      initialize: function(u, h, C) {
        if (typeof h == "number" && (h = o({}, C, { radius: h })), g(this, h), this._latlng = ne(u), isNaN(this.options.radius))
          throw new Error("Circle radius cannot be NaN");
        this._mRadius = this.options.radius;
      },
      // @method setRadius(radius: Number): this
      // Sets the radius of a circle. Units are in meters.
      setRadius: function(u) {
        return this._mRadius = u, this.redraw();
      },
      // @method getRadius(): Number
      // Returns the current radius of a circle. Units are in meters.
      getRadius: function() {
        return this._mRadius;
      },
      // @method getBounds(): LatLngBounds
      // Returns the `LatLngBounds` of the path.
      getBounds: function() {
        var u = [this._radius, this._radiusY || this._radius];
        return new X(
          this._map.layerPointToLatLng(this._point.subtract(u)),
          this._map.layerPointToLatLng(this._point.add(u))
        );
      },
      setStyle: Oa.prototype.setStyle,
      _project: function() {
        var u = this._latlng.lng, h = this._latlng.lat, C = this._map, O = C.options.crs;
        if (O.distance === te.distance) {
          var W = Math.PI / 180, Y = this._mRadius / te.R / W, ie = C.project([h + Y, u]), de = C.project([h - Y, u]), he = ie.add(de).divideBy(2), be = C.unproject(he).lat, Oe = Math.acos((Math.cos(Y * W) - Math.sin(h * W) * Math.sin(be * W)) / (Math.cos(h * W) * Math.cos(be * W))) / W;
          (isNaN(Oe) || Oe === 0) && (Oe = Y / Math.cos(Math.PI / 180 * h)), this._point = he.subtract(C.getPixelOrigin()), this._radius = isNaN(Oe) ? 0 : he.x - C.project([be, u - Oe]).x, this._radiusY = he.y - ie.y;
        } else {
          var qe = O.unproject(O.project(this._latlng).subtract([this._mRadius, 0]));
          this._point = C.latLngToLayerPoint(this._latlng), this._radius = this._point.x - C.latLngToLayerPoint(qe).x;
        }
        this._updateBounds();
      }
    });
    function K6(u, h, C) {
      return new gv(u, h, C);
    }
    var ea = Oa.extend({
      // @section
      // @aka Polyline options
      options: {
        // @option smoothFactor: Number = 1.0
        // How much to simplify the polyline on each zoom level. More means
        // better performance and smoother look, and less means more accurate representation.
        smoothFactor: 1,
        // @option noClip: Boolean = false
        // Disable polyline clipping.
        noClip: !1
      },
      initialize: function(u, h) {
        g(this, h), this._setLatLngs(u);
      },
      // @method getLatLngs(): LatLng[]
      // Returns an array of the points in the path, or nested arrays of points in case of multi-polyline.
      getLatLngs: function() {
        return this._latlngs;
      },
      // @method setLatLngs(latlngs: LatLng[]): this
      // Replaces all the points in the polyline with the given array of geographical points.
      setLatLngs: function(u) {
        return this._setLatLngs(u), this.redraw();
      },
      // @method isEmpty(): Boolean
      // Returns `true` if the Polyline has no LatLngs.
      isEmpty: function() {
        return !this._latlngs.length;
      },
      // @method closestLayerPoint(p: Point): Point
      // Returns the point closest to `p` on the Polyline.
      closestLayerPoint: function(u) {
        for (var h = 1 / 0, C = null, O = mu, W, Y, ie = 0, de = this._parts.length; ie < de; ie++)
          for (var he = this._parts[ie], be = 1, Oe = he.length; be < Oe; be++) {
            W = he[be - 1], Y = he[be];
            var qe = O(u, W, Y, !0);
            qe < h && (h = qe, C = O(u, W, Y));
          }
        return C && (C.distance = Math.sqrt(h)), C;
      },
      // @method getCenter(): LatLng
      // Returns the center ([centroid](https://en.wikipedia.org/wiki/Centroid)) of the polyline.
      getCenter: function() {
        if (!this._map)
          throw new Error("Must add layer to map before using getCenter()");
        return hC(this._defaultShape(), this._map.options.crs);
      },
      // @method getBounds(): LatLngBounds
      // Returns the `LatLngBounds` of the path.
      getBounds: function() {
        return this._bounds;
      },
      // @method addLatLng(latlng: LatLng, latlngs?: LatLng[]): this
      // Adds a given point to the polyline. By default, adds to the first ring of
      // the polyline in case of a multi-polyline, but can be overridden by passing
      // a specific ring as a LatLng array (that you can earlier access with [`getLatLngs`](#polyline-getlatlngs)).
      addLatLng: function(u, h) {
        return h = h || this._defaultShape(), u = ne(u), h.push(u), this._bounds.extend(u), this.redraw();
      },
      _setLatLngs: function(u) {
        this._bounds = new X(), this._latlngs = this._convertLatLngs(u);
      },
      _defaultShape: function() {
        return Eo(this._latlngs) ? this._latlngs : this._latlngs[0];
      },
      // recursively convert latlngs input into actual LatLng instances; calculate bounds along the way
      _convertLatLngs: function(u) {
        for (var h = [], C = Eo(u), O = 0, W = u.length; O < W; O++)
          C ? (h[O] = ne(u[O]), this._bounds.extend(h[O])) : h[O] = this._convertLatLngs(u[O]);
        return h;
      },
      _project: function() {
        var u = new q();
        this._rings = [], this._projectLatlngs(this._latlngs, this._rings, u), this._bounds.isValid() && u.isValid() && (this._rawPxBounds = u, this._updateBounds());
      },
      _updateBounds: function() {
        var u = this._clickTolerance(), h = new G(u, u);
        this._rawPxBounds && (this._pxBounds = new q([
          this._rawPxBounds.min.subtract(h),
          this._rawPxBounds.max.add(h)
        ]));
      },
      // recursively turns latlngs into a set of rings with projected coordinates
      _projectLatlngs: function(u, h, C) {
        var O = u[0] instanceof J, W = u.length, Y, ie;
        if (O) {
          for (ie = [], Y = 0; Y < W; Y++)
            ie[Y] = this._map.latLngToLayerPoint(u[Y]), C.extend(ie[Y]);
          h.push(ie);
        } else
          for (Y = 0; Y < W; Y++)
            this._projectLatlngs(u[Y], h, C);
      },
      // clip polyline by renderer bounds so that we have less to render for performance
      _clipPoints: function() {
        var u = this._renderer._bounds;
        if (this._parts = [], !(!this._pxBounds || !this._pxBounds.intersects(u))) {
          if (this.options.noClip) {
            this._parts = this._rings;
            return;
          }
          var h = this._parts, C, O, W, Y, ie, de, he;
          for (C = 0, W = 0, Y = this._rings.length; C < Y; C++)
            for (he = this._rings[C], O = 0, ie = he.length; O < ie - 1; O++)
              de = fC(he[O], he[O + 1], u, O, !0), de && (h[W] = h[W] || [], h[W].push(de[0]), (de[1] !== he[O + 1] || O === ie - 2) && (h[W].push(de[1]), W++));
        }
      },
      // simplify each clipped part of the polyline for performance
      _simplifyPoints: function() {
        for (var u = this._parts, h = this.options.smoothFactor, C = 0, O = u.length; C < O; C++)
          u[C] = cC(u[C], h);
      },
      _update: function() {
        this._map && (this._clipPoints(), this._simplifyPoints(), this._updatePath());
      },
      _updatePath: function() {
        this._renderer._updatePoly(this);
      },
      // Needed by the `Canvas` renderer for interactivity
      _containsPoint: function(u, h) {
        var C, O, W, Y, ie, de, he = this._clickTolerance();
        if (!this._pxBounds || !this._pxBounds.contains(u))
          return !1;
        for (C = 0, Y = this._parts.length; C < Y; C++)
          for (de = this._parts[C], O = 0, ie = de.length, W = ie - 1; O < ie; W = O++)
            if (!(!h && O === 0) && uC(u, de[W], de[O]) <= he)
              return !0;
        return !1;
      }
    });
    function J6(u, h) {
      return new ea(u, h);
    }
    ea._flat = pC;
    var bl = ea.extend({
      options: {
        fill: !0
      },
      isEmpty: function() {
        return !this._latlngs.length || !this._latlngs[0].length;
      },
      // @method getCenter(): LatLng
      // Returns the center ([centroid](http://en.wikipedia.org/wiki/Centroid)) of the Polygon.
      getCenter: function() {
        if (!this._map)
          throw new Error("Must add layer to map before using getCenter()");
        return lC(this._defaultShape(), this._map.options.crs);
      },
      _convertLatLngs: function(u) {
        var h = ea.prototype._convertLatLngs.call(this, u), C = h.length;
        return C >= 2 && h[0] instanceof J && h[0].equals(h[C - 1]) && h.pop(), h;
      },
      _setLatLngs: function(u) {
        ea.prototype._setLatLngs.call(this, u), Eo(this._latlngs) && (this._latlngs = [this._latlngs]);
      },
      _defaultShape: function() {
        return Eo(this._latlngs[0]) ? this._latlngs[0] : this._latlngs[0][0];
      },
      _clipPoints: function() {
        var u = this._renderer._bounds, h = this.options.weight, C = new G(h, h);
        if (u = new q(u.min.subtract(C), u.max.add(C)), this._parts = [], !(!this._pxBounds || !this._pxBounds.intersects(u))) {
          if (this.options.noClip) {
            this._parts = this._rings;
            return;
          }
          for (var O = 0, W = this._rings.length, Y; O < W; O++)
            Y = sC(this._rings[O], u, !0), Y.length && this._parts.push(Y);
        }
      },
      _updatePath: function() {
        this._renderer._updatePoly(this, !0);
      },
      // Needed by the `Canvas` renderer for interactivity
      _containsPoint: function(u) {
        var h = !1, C, O, W, Y, ie, de, he, be;
        if (!this._pxBounds || !this._pxBounds.contains(u))
          return !1;
        for (Y = 0, he = this._parts.length; Y < he; Y++)
          for (C = this._parts[Y], ie = 0, be = C.length, de = be - 1; ie < be; de = ie++)
            O = C[ie], W = C[de], O.y > u.y != W.y > u.y && u.x < (W.x - O.x) * (u.y - O.y) / (W.y - O.y) + O.x && (h = !h);
        return h || ea.prototype._containsPoint.call(this, u, !0);
      }
    });
    function Q6(u, h) {
      return new bl(u, h);
    }
    var ta = Qi.extend({
      /* @section
       * @aka GeoJSON options
       *
       * @option pointToLayer: Function = *
       * A `Function` defining how GeoJSON points spawn Leaflet layers. It is internally
       * called when data is added, passing the GeoJSON point feature and its `LatLng`.
       * The default is to spawn a default `Marker`:
       * ```js
       * function(geoJsonPoint, latlng) {
       * 	return L.marker(latlng);
       * }
       * ```
       *
       * @option style: Function = *
       * A `Function` defining the `Path options` for styling GeoJSON lines and polygons,
       * called internally when data is added.
       * The default value is to not override any defaults:
       * ```js
       * function (geoJsonFeature) {
       * 	return {}
       * }
       * ```
       *
       * @option onEachFeature: Function = *
       * A `Function` that will be called once for each created `Feature`, after it has
       * been created and styled. Useful for attaching events and popups to features.
       * The default is to do nothing with the newly created layers:
       * ```js
       * function (feature, layer) {}
       * ```
       *
       * @option filter: Function = *
       * A `Function` that will be used to decide whether to include a feature or not.
       * The default is to include all features:
       * ```js
       * function (geoJsonFeature) {
       * 	return true;
       * }
       * ```
       * Note: dynamically changing the `filter` option will have effect only on newly
       * added data. It will _not_ re-evaluate already included features.
       *
       * @option coordsToLatLng: Function = *
       * A `Function` that will be used for converting GeoJSON coordinates to `LatLng`s.
       * The default is the `coordsToLatLng` static method.
       *
       * @option markersInheritOptions: Boolean = false
       * Whether default Markers for "Point" type Features inherit from group options.
       */
      initialize: function(u, h) {
        g(this, h), this._layers = {}, u && this.addData(u);
      },
      // @method addData( <GeoJSON> data ): this
      // Adds a GeoJSON object to the layer.
      addData: function(u) {
        var h = S(u) ? u : u.features, C, O, W;
        if (h) {
          for (C = 0, O = h.length; C < O; C++)
            W = h[C], (W.geometries || W.geometry || W.features || W.coordinates) && this.addData(W);
          return this;
        }
        var Y = this.options;
        if (Y.filter && !Y.filter(u))
          return this;
        var ie = Hf(u, Y);
        return ie ? (ie.feature = Vf(u), ie.defaultOptions = ie.options, this.resetStyle(ie), Y.onEachFeature && Y.onEachFeature(u, ie), this.addLayer(ie)) : this;
      },
      // @method resetStyle( <Path> layer? ): this
      // Resets the given vector layer's style to the original GeoJSON style, useful for resetting style after hover events.
      // If `layer` is omitted, the style of all features in the current layer is reset.
      resetStyle: function(u) {
        return u === void 0 ? this.eachLayer(this.resetStyle, this) : (u.options = o({}, u.defaultOptions), this._setLayerStyle(u, this.options.style), this);
      },
      // @method setStyle( <Function> style ): this
      // Changes styles of GeoJSON vector layers with the given style function.
      setStyle: function(u) {
        return this.eachLayer(function(h) {
          this._setLayerStyle(h, u);
        }, this);
      },
      _setLayerStyle: function(u, h) {
        u.setStyle && (typeof h == "function" && (h = h(u.feature)), u.setStyle(h));
      }
    });
    function Hf(u, h) {
      var C = u.type === "Feature" ? u.geometry : u, O = C ? C.coordinates : null, W = [], Y = h && h.pointToLayer, ie = h && h.coordsToLatLng || vv, de, he, be, Oe;
      if (!O && !C)
        return null;
      switch (C.type) {
        case "Point":
          return de = ie(O), vC(Y, u, de, h);
        case "MultiPoint":
          for (be = 0, Oe = O.length; be < Oe; be++)
            de = ie(O[be]), W.push(vC(Y, u, de, h));
          return new Qi(W);
        case "LineString":
        case "MultiLineString":
          return he = jf(O, C.type === "LineString" ? 0 : 1, ie), new ea(he, h);
        case "Polygon":
        case "MultiPolygon":
          return he = jf(O, C.type === "Polygon" ? 1 : 2, ie), new bl(he, h);
        case "GeometryCollection":
          for (be = 0, Oe = C.geometries.length; be < Oe; be++) {
            var qe = Hf({
              geometry: C.geometries[be],
              type: "Feature",
              properties: u.properties
            }, h);
            qe && W.push(qe);
          }
          return new Qi(W);
        case "FeatureCollection":
          for (be = 0, Oe = C.features.length; be < Oe; be++) {
            var dt = Hf(C.features[be], h);
            dt && W.push(dt);
          }
          return new Qi(W);
        default:
          throw new Error("Invalid GeoJSON object.");
      }
    }
    function vC(u, h, C, O) {
      return u ? u(h, C) : new zf(C, O && O.markersInheritOptions && O);
    }
    function vv(u) {
      return new J(u[1], u[0], u[2]);
    }
    function jf(u, h, C) {
      for (var O = [], W = 0, Y = u.length, ie; W < Y; W++)
        ie = h ? jf(u[W], h - 1, C) : (C || vv)(u[W]), O.push(ie);
      return O;
    }
    function bv(u, h) {
      return u = ne(u), u.alt !== void 0 ? [p(u.lng, h), p(u.lat, h), p(u.alt, h)] : [p(u.lng, h), p(u.lat, h)];
    }
    function Wf(u, h, C, O) {
      for (var W = [], Y = 0, ie = u.length; Y < ie; Y++)
        W.push(h ? Wf(u[Y], Eo(u[Y]) ? 0 : h - 1, C, O) : bv(u[Y], O));
      return !h && C && W.length > 0 && W.push(W[0].slice()), W;
    }
    function yl(u, h) {
      return u.feature ? o({}, u.feature, { geometry: h }) : Vf(h);
    }
    function Vf(u) {
      return u.type === "Feature" || u.type === "FeatureCollection" ? u : {
        type: "Feature",
        properties: {},
        geometry: u
      };
    }
    var yv = {
      toGeoJSON: function(u) {
        return yl(this, {
          type: "Point",
          coordinates: bv(this.getLatLng(), u)
        });
      }
    };
    zf.include(yv), gv.include(yv), Bf.include(yv), ea.include({
      toGeoJSON: function(u) {
        var h = !Eo(this._latlngs), C = Wf(this._latlngs, h ? 1 : 0, !1, u);
        return yl(this, {
          type: (h ? "Multi" : "") + "LineString",
          coordinates: C
        });
      }
    }), bl.include({
      toGeoJSON: function(u) {
        var h = !Eo(this._latlngs), C = h && !Eo(this._latlngs[0]), O = Wf(this._latlngs, C ? 2 : h ? 1 : 0, !0, u);
        return h || (O = [O]), yl(this, {
          type: (C ? "Multi" : "") + "Polygon",
          coordinates: O
        });
      }
    }), gl.include({
      toMultiPoint: function(u) {
        var h = [];
        return this.eachLayer(function(C) {
          h.push(C.toGeoJSON(u).geometry.coordinates);
        }), yl(this, {
          type: "MultiPoint",
          coordinates: h
        });
      },
      // @method toGeoJSON(precision?: Number|false): Object
      // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
      // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the layer group (as a GeoJSON `FeatureCollection`, `GeometryCollection`, or `MultiPoint`).
      toGeoJSON: function(u) {
        var h = this.feature && this.feature.geometry && this.feature.geometry.type;
        if (h === "MultiPoint")
          return this.toMultiPoint(u);
        var C = h === "GeometryCollection", O = [];
        return this.eachLayer(function(W) {
          if (W.toGeoJSON) {
            var Y = W.toGeoJSON(u);
            if (C)
              O.push(Y.geometry);
            else {
              var ie = Vf(Y);
              ie.type === "FeatureCollection" ? O.push.apply(O, ie.features) : O.push(ie);
            }
          }
        }), C ? yl(this, {
          geometries: O,
          type: "GeometryCollection"
        }) : {
          type: "FeatureCollection",
          features: O
        };
      }
    });
    function bC(u, h) {
      return new ta(u, h);
    }
    var e$ = bC, Uf = ni.extend({
      // @section
      // @aka ImageOverlay options
      options: {
        // @option opacity: Number = 1.0
        // The opacity of the image overlay.
        opacity: 1,
        // @option alt: String = ''
        // Text for the `alt` attribute of the image (useful for accessibility).
        alt: "",
        // @option interactive: Boolean = false
        // If `true`, the image overlay will emit [mouse events](#interactive-layer) when clicked or hovered.
        interactive: !1,
        // @option crossOrigin: Boolean|String = false
        // Whether the crossOrigin attribute will be added to the image.
        // If a String is provided, the image will have its crossOrigin attribute set to the String provided. This is needed if you want to access image pixel data.
        // Refer to [CORS Settings](https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_settings_attributes) for valid String values.
        crossOrigin: !1,
        // @option errorOverlayUrl: String = ''
        // URL to the overlay image to show in place of the overlay that failed to load.
        errorOverlayUrl: "",
        // @option zIndex: Number = 1
        // The explicit [zIndex](https://developer.mozilla.org/docs/Web/CSS/CSS_Positioning/Understanding_z_index) of the overlay layer.
        zIndex: 1,
        // @option className: String = ''
        // A custom class name to assign to the image. Empty by default.
        className: ""
      },
      initialize: function(u, h, C) {
        this._url = u, this._bounds = K(h), g(this, C);
      },
      onAdd: function() {
        this._image || (this._initImage(), this.options.opacity < 1 && this._updateOpacity()), this.options.interactive && (tt(this._image, "leaflet-interactive"), this.addInteractiveTarget(this._image)), this.getPane().appendChild(this._image), this._reset();
      },
      onRemove: function() {
        Et(this._image), this.options.interactive && this.removeInteractiveTarget(this._image);
      },
      // @method setOpacity(opacity: Number): this
      // Sets the opacity of the overlay.
      setOpacity: function(u) {
        return this.options.opacity = u, this._image && this._updateOpacity(), this;
      },
      setStyle: function(u) {
        return u.opacity && this.setOpacity(u.opacity), this;
      },
      // @method bringToFront(): this
      // Brings the layer to the top of all overlays.
      bringToFront: function() {
        return this._map && wo(this._image), this;
      },
      // @method bringToBack(): this
      // Brings the layer to the bottom of all overlays.
      bringToBack: function() {
        return this._map && eo(this._image), this;
      },
      // @method setUrl(url: String): this
      // Changes the URL of the image.
      setUrl: function(u) {
        return this._url = u, this._image && (this._image.src = u), this;
      },
      // @method setBounds(bounds: LatLngBounds): this
      // Update the bounds that this ImageOverlay covers
      setBounds: function(u) {
        return this._bounds = K(u), this._map && this._reset(), this;
      },
      getEvents: function() {
        var u = {
          zoom: this._reset,
          viewreset: this._reset
        };
        return this._zoomAnimated && (u.zoomanim = this._animateZoom), u;
      },
      // @method setZIndex(value: Number): this
      // Changes the [zIndex](#imageoverlay-zindex) of the image overlay.
      setZIndex: function(u) {
        return this.options.zIndex = u, this._updateZIndex(), this;
      },
      // @method getBounds(): LatLngBounds
      // Get the bounds that this ImageOverlay covers
      getBounds: function() {
        return this._bounds;
      },
      // @method getElement(): HTMLElement
      // Returns the instance of [`HTMLImageElement`](https://developer.mozilla.org/docs/Web/API/HTMLImageElement)
      // used by this overlay.
      getElement: function() {
        return this._image;
      },
      _initImage: function() {
        var u = this._url.tagName === "IMG", h = this._image = u ? this._url : pt("img");
        if (tt(h, "leaflet-image-layer"), this._zoomAnimated && tt(h, "leaflet-zoom-animated"), this.options.className && tt(h, this.options.className), h.onselectstart = f, h.onmousemove = f, h.onload = a(this.fire, this, "load"), h.onerror = a(this._overlayOnError, this, "error"), (this.options.crossOrigin || this.options.crossOrigin === "") && (h.crossOrigin = this.options.crossOrigin === !0 ? "" : this.options.crossOrigin), this.options.zIndex && this._updateZIndex(), u) {
          this._url = h.src;
          return;
        }
        h.src = this._url, h.alt = this.options.alt;
      },
      _animateZoom: function(u) {
        var h = this._map.getZoomScale(u.zoom), C = this._map._latLngBoundsToNewLayerBounds(this._bounds, u.zoom, u.center).min;
        xo(this._image, C, h);
      },
      _reset: function() {
        var u = this._image, h = new q(
          this._map.latLngToLayerPoint(this._bounds.getNorthWest()),
          this._map.latLngToLayerPoint(this._bounds.getSouthEast())
        ), C = h.getSize();
        sn(u, h.min), u.style.width = C.x + "px", u.style.height = C.y + "px";
      },
      _updateOpacity: function() {
        gr(this._image, this.options.opacity);
      },
      _updateZIndex: function() {
        this._image && this.options.zIndex !== void 0 && this.options.zIndex !== null && (this._image.style.zIndex = this.options.zIndex);
      },
      _overlayOnError: function() {
        this.fire("error");
        var u = this.options.errorOverlayUrl;
        u && this._url !== u && (this._url = u, this._image.src = u);
      },
      // @method getCenter(): LatLng
      // Returns the center of the ImageOverlay.
      getCenter: function() {
        return this._bounds.getCenter();
      }
    }), t$ = function(u, h, C) {
      return new Uf(u, h, C);
    }, yC = Uf.extend({
      // @section
      // @aka VideoOverlay options
      options: {
        // @option autoplay: Boolean = true
        // Whether the video starts playing automatically when loaded.
        // On some browsers autoplay will only work with `muted: true`
        autoplay: !0,
        // @option loop: Boolean = true
        // Whether the video will loop back to the beginning when played.
        loop: !0,
        // @option keepAspectRatio: Boolean = true
        // Whether the video will save aspect ratio after the projection.
        // Relevant for supported browsers. See [browser compatibility](https://developer.mozilla.org/en-US/docs/Web/CSS/object-fit)
        keepAspectRatio: !0,
        // @option muted: Boolean = false
        // Whether the video starts on mute when loaded.
        muted: !1,
        // @option playsInline: Boolean = true
        // Mobile browsers will play the video right where it is instead of open it up in fullscreen mode.
        playsInline: !0
      },
      _initImage: function() {
        var u = this._url.tagName === "VIDEO", h = this._image = u ? this._url : pt("video");
        if (tt(h, "leaflet-image-layer"), this._zoomAnimated && tt(h, "leaflet-zoom-animated"), this.options.className && tt(h, this.options.className), h.onselectstart = f, h.onmousemove = f, h.onloadeddata = a(this.fire, this, "load"), u) {
          for (var C = h.getElementsByTagName("source"), O = [], W = 0; W < C.length; W++)
            O.push(C[W].src);
          this._url = C.length > 0 ? O : [h.src];
          return;
        }
        S(this._url) || (this._url = [this._url]), !this.options.keepAspectRatio && Object.prototype.hasOwnProperty.call(h.style, "objectFit") && (h.style.objectFit = "fill"), h.autoplay = !!this.options.autoplay, h.loop = !!this.options.loop, h.muted = !!this.options.muted, h.playsInline = !!this.options.playsInline;
        for (var Y = 0; Y < this._url.length; Y++) {
          var ie = pt("source");
          ie.src = this._url[Y], h.appendChild(ie);
        }
      }
      // @method getElement(): HTMLVideoElement
      // Returns the instance of [`HTMLVideoElement`](https://developer.mozilla.org/docs/Web/API/HTMLVideoElement)
      // used by this overlay.
    });
    function n$(u, h, C) {
      return new yC(u, h, C);
    }
    var _C = Uf.extend({
      _initImage: function() {
        var u = this._image = this._url;
        tt(u, "leaflet-image-layer"), this._zoomAnimated && tt(u, "leaflet-zoom-animated"), this.options.className && tt(u, this.options.className), u.onselectstart = f, u.onmousemove = f;
      }
      // @method getElement(): SVGElement
      // Returns the instance of [`SVGElement`](https://developer.mozilla.org/docs/Web/API/SVGElement)
      // used by this overlay.
    });
    function r$(u, h, C) {
      return new _C(u, h, C);
    }
    var gi = ni.extend({
      // @section
      // @aka DivOverlay options
      options: {
        // @option interactive: Boolean = false
        // If true, the popup/tooltip will listen to the mouse events.
        interactive: !1,
        // @option offset: Point = Point(0, 0)
        // The offset of the overlay position.
        offset: [0, 0],
        // @option className: String = ''
        // A custom CSS class name to assign to the overlay.
        className: "",
        // @option pane: String = undefined
        // `Map pane` where the overlay will be added.
        pane: void 0,
        // @option content: String|HTMLElement|Function = ''
        // Sets the HTML content of the overlay while initializing. If a function is passed the source layer will be
        // passed to the function. The function should return a `String` or `HTMLElement` to be used in the overlay.
        content: ""
      },
      initialize: function(u, h) {
        u && (u instanceof J || S(u)) ? (this._latlng = ne(u), g(this, h)) : (g(this, u), this._source = h), this.options.content && (this._content = this.options.content);
      },
      // @method openOn(map: Map): this
      // Adds the overlay to the map.
      // Alternative to `map.openPopup(popup)`/`.openTooltip(tooltip)`.
      openOn: function(u) {
        return u = arguments.length ? u : this._source._map, u.hasLayer(this) || u.addLayer(this), this;
      },
      // @method close(): this
      // Closes the overlay.
      // Alternative to `map.closePopup(popup)`/`.closeTooltip(tooltip)`
      // and `layer.closePopup()`/`.closeTooltip()`.
      close: function() {
        return this._map && this._map.removeLayer(this), this;
      },
      // @method toggle(layer?: Layer): this
      // Opens or closes the overlay bound to layer depending on its current state.
      // Argument may be omitted only for overlay bound to layer.
      // Alternative to `layer.togglePopup()`/`.toggleTooltip()`.
      toggle: function(u) {
        return this._map ? this.close() : (arguments.length ? this._source = u : u = this._source, this._prepareOpen(), this.openOn(u._map)), this;
      },
      onAdd: function(u) {
        this._zoomAnimated = u._zoomAnimated, this._container || this._initLayout(), u._fadeAnimated && gr(this._container, 0), clearTimeout(this._removeTimeout), this.getPane().appendChild(this._container), this.update(), u._fadeAnimated && gr(this._container, 1), this.bringToFront(), this.options.interactive && (tt(this._container, "leaflet-interactive"), this.addInteractiveTarget(this._container));
      },
      onRemove: function(u) {
        u._fadeAnimated ? (gr(this._container, 0), this._removeTimeout = setTimeout(a(Et, void 0, this._container), 200)) : Et(this._container), this.options.interactive && (Xt(this._container, "leaflet-interactive"), this.removeInteractiveTarget(this._container));
      },
      // @namespace DivOverlay
      // @method getLatLng: LatLng
      // Returns the geographical point of the overlay.
      getLatLng: function() {
        return this._latlng;
      },
      // @method setLatLng(latlng: LatLng): this
      // Sets the geographical point where the overlay will open.
      setLatLng: function(u) {
        return this._latlng = ne(u), this._map && (this._updatePosition(), this._adjustPan()), this;
      },
      // @method getContent: String|HTMLElement
      // Returns the content of the overlay.
      getContent: function() {
        return this._content;
      },
      // @method setContent(htmlContent: String|HTMLElement|Function): this
      // Sets the HTML content of the overlay. If a function is passed the source layer will be passed to the function.
      // The function should return a `String` or `HTMLElement` to be used in the overlay.
      setContent: function(u) {
        return this._content = u, this.update(), this;
      },
      // @method getElement: String|HTMLElement
      // Returns the HTML container of the overlay.
      getElement: function() {
        return this._container;
      },
      // @method update: null
      // Updates the overlay content, layout and position. Useful for updating the overlay after something inside changed, e.g. image loaded.
      update: function() {
        this._map && (this._container.style.visibility = "hidden", this._updateContent(), this._updateLayout(), this._updatePosition(), this._container.style.visibility = "", this._adjustPan());
      },
      getEvents: function() {
        var u = {
          zoom: this._updatePosition,
          viewreset: this._updatePosition
        };
        return this._zoomAnimated && (u.zoomanim = this._animateZoom), u;
      },
      // @method isOpen: Boolean
      // Returns `true` when the overlay is visible on the map.
      isOpen: function() {
        return !!this._map && this._map.hasLayer(this);
      },
      // @method bringToFront: this
      // Brings this overlay in front of other overlays (in the same map pane).
      bringToFront: function() {
        return this._map && wo(this._container), this;
      },
      // @method bringToBack: this
      // Brings this overlay to the back of other overlays (in the same map pane).
      bringToBack: function() {
        return this._map && eo(this._container), this;
      },
      // prepare bound overlay to open: update latlng pos / content source (for FeatureGroup)
      _prepareOpen: function(u) {
        var h = this._source;
        if (!h._map)
          return !1;
        if (h instanceof Qi) {
          h = null;
          var C = this._source._layers;
          for (var O in C)
            if (C[O]._map) {
              h = C[O];
              break;
            }
          if (!h)
            return !1;
          this._source = h;
        }
        if (!u)
          if (h.getCenter)
            u = h.getCenter();
          else if (h.getLatLng)
            u = h.getLatLng();
          else if (h.getBounds)
            u = h.getBounds().getCenter();
          else
            throw new Error("Unable to get source layer LatLng.");
        return this.setLatLng(u), this._map && this.update(), !0;
      },
      _updateContent: function() {
        if (this._content) {
          var u = this._contentNode, h = typeof this._content == "function" ? this._content(this._source || this) : this._content;
          if (typeof h == "string")
            u.innerHTML = h;
          else {
            for (; u.hasChildNodes(); )
              u.removeChild(u.firstChild);
            u.appendChild(h);
          }
          this.fire("contentupdate");
        }
      },
      _updatePosition: function() {
        if (this._map) {
          var u = this._map.latLngToLayerPoint(this._latlng), h = H(this.options.offset), C = this._getAnchor();
          this._zoomAnimated ? sn(this._container, u.add(C)) : h = h.add(u).add(C);
          var O = this._containerBottom = -h.y, W = this._containerLeft = -Math.round(this._containerWidth / 2) + h.x;
          this._container.style.bottom = O + "px", this._container.style.left = W + "px";
        }
      },
      _getAnchor: function() {
        return [0, 0];
      }
    });
    yt.include({
      _initOverlay: function(u, h, C, O) {
        var W = h;
        return W instanceof u || (W = new u(O).setContent(h)), C && W.setLatLng(C), W;
      }
    }), ni.include({
      _initOverlay: function(u, h, C, O) {
        var W = C;
        return W instanceof u ? (g(W, O), W._source = this) : (W = h && !O ? h : new u(O, this), W.setContent(C)), W;
      }
    });
    var qf = gi.extend({
      // @section
      // @aka Popup options
      options: {
        // @option pane: String = 'popupPane'
        // `Map pane` where the popup will be added.
        pane: "popupPane",
        // @option offset: Point = Point(0, 7)
        // The offset of the popup position.
        offset: [0, 7],
        // @option maxWidth: Number = 300
        // Max width of the popup, in pixels.
        maxWidth: 300,
        // @option minWidth: Number = 50
        // Min width of the popup, in pixels.
        minWidth: 50,
        // @option maxHeight: Number = null
        // If set, creates a scrollable container of the given height
        // inside a popup if its content exceeds it.
        // The scrollable container can be styled using the
        // `leaflet-popup-scrolled` CSS class selector.
        maxHeight: null,
        // @option autoPan: Boolean = true
        // Set it to `false` if you don't want the map to do panning animation
        // to fit the opened popup.
        autoPan: !0,
        // @option autoPanPaddingTopLeft: Point = null
        // The margin between the popup and the top left corner of the map
        // view after autopanning was performed.
        autoPanPaddingTopLeft: null,
        // @option autoPanPaddingBottomRight: Point = null
        // The margin between the popup and the bottom right corner of the map
        // view after autopanning was performed.
        autoPanPaddingBottomRight: null,
        // @option autoPanPadding: Point = Point(5, 5)
        // Equivalent of setting both top left and bottom right autopan padding to the same value.
        autoPanPadding: [5, 5],
        // @option keepInView: Boolean = false
        // Set it to `true` if you want to prevent users from panning the popup
        // off of the screen while it is open.
        keepInView: !1,
        // @option closeButton: Boolean = true
        // Controls the presence of a close button in the popup.
        closeButton: !0,
        // @option autoClose: Boolean = true
        // Set it to `false` if you want to override the default behavior of
        // the popup closing when another popup is opened.
        autoClose: !0,
        // @option closeOnEscapeKey: Boolean = true
        // Set it to `false` if you want to override the default behavior of
        // the ESC key for closing of the popup.
        closeOnEscapeKey: !0,
        // @option closeOnClick: Boolean = *
        // Set it if you want to override the default behavior of the popup closing when user clicks
        // on the map. Defaults to the map's [`closePopupOnClick`](#map-closepopuponclick) option.
        // @option className: String = ''
        // A custom CSS class name to assign to the popup.
        className: ""
      },
      // @namespace Popup
      // @method openOn(map: Map): this
      // Alternative to `map.openPopup(popup)`.
      // Adds the popup to the map and closes the previous one.
      openOn: function(u) {
        return u = arguments.length ? u : this._source._map, !u.hasLayer(this) && u._popup && u._popup.options.autoClose && u.removeLayer(u._popup), u._popup = this, gi.prototype.openOn.call(this, u);
      },
      onAdd: function(u) {
        gi.prototype.onAdd.call(this, u), u.fire("popupopen", { popup: this }), this._source && (this._source.fire("popupopen", { popup: this }, !0), this._source instanceof Oa || this._source.on("preclick", To));
      },
      onRemove: function(u) {
        gi.prototype.onRemove.call(this, u), u.fire("popupclose", { popup: this }), this._source && (this._source.fire("popupclose", { popup: this }, !0), this._source instanceof Oa || this._source.off("preclick", To));
      },
      getEvents: function() {
        var u = gi.prototype.getEvents.call(this);
        return (this.options.closeOnClick !== void 0 ? this.options.closeOnClick : this._map.options.closePopupOnClick) && (u.preclick = this.close), this.options.keepInView && (u.moveend = this._adjustPan), u;
      },
      _initLayout: function() {
        var u = "leaflet-popup", h = this._container = pt(
          "div",
          u + " " + (this.options.className || "") + " leaflet-zoom-animated"
        ), C = this._wrapper = pt("div", u + "-content-wrapper", h);
        if (this._contentNode = pt("div", u + "-content", C), Ra(h), Ts(this._contentNode), Ze(h, "contextmenu", To), this._tipContainer = pt("div", u + "-tip-container", h), this._tip = pt("div", u + "-tip", this._tipContainer), this.options.closeButton) {
          var O = this._closeButton = pt("a", u + "-close-button", h);
          O.setAttribute("role", "button"), O.setAttribute("aria-label", "Close popup"), O.href = "#close", O.innerHTML = '<span aria-hidden="true">&#215;</span>', Ze(O, "click", function(W) {
            vn(W), this.close();
          }, this);
        }
      },
      _updateLayout: function() {
        var u = this._contentNode, h = u.style;
        h.width = "", h.whiteSpace = "nowrap";
        var C = u.offsetWidth;
        C = Math.min(C, this.options.maxWidth), C = Math.max(C, this.options.minWidth), h.width = C + 1 + "px", h.whiteSpace = "", h.height = "";
        var O = u.offsetHeight, W = this.options.maxHeight, Y = "leaflet-popup-scrolled";
        W && O > W ? (h.height = W + "px", tt(u, Y)) : Xt(u, Y), this._containerWidth = this._container.offsetWidth;
      },
      _animateZoom: function(u) {
        var h = this._map._latLngToNewLayerPoint(this._latlng, u.zoom, u.center), C = this._getAnchor();
        sn(this._container, h.add(C));
      },
      _adjustPan: function() {
        if (this.options.autoPan) {
          if (this._map._panAnim && this._map._panAnim.stop(), this._autopanning) {
            this._autopanning = !1;
            return;
          }
          var u = this._map, h = parseInt(Qo(this._container, "marginBottom"), 10) || 0, C = this._container.offsetHeight + h, O = this._containerWidth, W = new G(this._containerLeft, -C - this._containerBottom);
          W._add(ei(this._container));
          var Y = u.layerPointToContainerPoint(W), ie = H(this.options.autoPanPadding), de = H(this.options.autoPanPaddingTopLeft || ie), he = H(this.options.autoPanPaddingBottomRight || ie), be = u.getSize(), Oe = 0, qe = 0;
          Y.x + O + he.x > be.x && (Oe = Y.x + O - be.x + he.x), Y.x - Oe - de.x < 0 && (Oe = Y.x - de.x), Y.y + C + he.y > be.y && (qe = Y.y + C - be.y + he.y), Y.y - qe - de.y < 0 && (qe = Y.y - de.y), (Oe || qe) && (this.options.keepInView && (this._autopanning = !0), u.fire("autopanstart").panBy([Oe, qe]));
        }
      },
      _getAnchor: function() {
        return H(this._source && this._source._getPopupAnchor ? this._source._getPopupAnchor() : [0, 0]);
      }
    }), o$ = function(u, h) {
      return new qf(u, h);
    };
    yt.mergeOptions({
      closePopupOnClick: !0
    }), yt.include({
      // @method openPopup(popup: Popup): this
      // Opens the specified popup while closing the previously opened (to make sure only one is opened at one time for usability).
      // @alternative
      // @method openPopup(content: String|HTMLElement, latlng: LatLng, options?: Popup options): this
      // Creates a popup with the specified content and options and opens it in the given point on a map.
      openPopup: function(u, h, C) {
        return this._initOverlay(qf, u, h, C).openOn(this), this;
      },
      // @method closePopup(popup?: Popup): this
      // Closes the popup previously opened with [openPopup](#map-openpopup) (or the given one).
      closePopup: function(u) {
        return u = arguments.length ? u : this._popup, u && u.close(), this;
      }
    }), ni.include({
      // @method bindPopup(content: String|HTMLElement|Function|Popup, options?: Popup options): this
      // Binds a popup to the layer with the passed `content` and sets up the
      // necessary event listeners. If a `Function` is passed it will receive
      // the layer as the first argument and should return a `String` or `HTMLElement`.
      bindPopup: function(u, h) {
        return this._popup = this._initOverlay(qf, this._popup, u, h), this._popupHandlersAdded || (this.on({
          click: this._openPopup,
          keypress: this._onKeyPress,
          remove: this.closePopup,
          move: this._movePopup
        }), this._popupHandlersAdded = !0), this;
      },
      // @method unbindPopup(): this
      // Removes the popup previously bound with `bindPopup`.
      unbindPopup: function() {
        return this._popup && (this.off({
          click: this._openPopup,
          keypress: this._onKeyPress,
          remove: this.closePopup,
          move: this._movePopup
        }), this._popupHandlersAdded = !1, this._popup = null), this;
      },
      // @method openPopup(latlng?: LatLng): this
      // Opens the bound popup at the specified `latlng` or at the default popup anchor if no `latlng` is passed.
      openPopup: function(u) {
        return this._popup && (this instanceof Qi || (this._popup._source = this), this._popup._prepareOpen(u || this._latlng) && this._popup.openOn(this._map)), this;
      },
      // @method closePopup(): this
      // Closes the popup bound to this layer if it is open.
      closePopup: function() {
        return this._popup && this._popup.close(), this;
      },
      // @method togglePopup(): this
      // Opens or closes the popup bound to this layer depending on its current state.
      togglePopup: function() {
        return this._popup && this._popup.toggle(this), this;
      },
      // @method isPopupOpen(): boolean
      // Returns `true` if the popup bound to this layer is currently open.
      isPopupOpen: function() {
        return this._popup ? this._popup.isOpen() : !1;
      },
      // @method setPopupContent(content: String|HTMLElement|Popup): this
      // Sets the content of the popup bound to this layer.
      setPopupContent: function(u) {
        return this._popup && this._popup.setContent(u), this;
      },
      // @method getPopup(): Popup
      // Returns the popup bound to this layer.
      getPopup: function() {
        return this._popup;
      },
      _openPopup: function(u) {
        if (!(!this._popup || !this._map)) {
          Es(u);
          var h = u.layer || u.target;
          if (this._popup._source === h && !(h instanceof Oa)) {
            this._map.hasLayer(this._popup) ? this.closePopup() : this.openPopup(u.latlng);
            return;
          }
          this._popup._source = h, this.openPopup(u.latlng);
        }
      },
      _movePopup: function(u) {
        this._popup.setLatLng(u.latlng);
      },
      _onKeyPress: function(u) {
        u.originalEvent.keyCode === 13 && this._openPopup(u);
      }
    });
    var Gf = gi.extend({
      // @section
      // @aka Tooltip options
      options: {
        // @option pane: String = 'tooltipPane'
        // `Map pane` where the tooltip will be added.
        pane: "tooltipPane",
        // @option offset: Point = Point(0, 0)
        // Optional offset of the tooltip position.
        offset: [0, 0],
        // @option direction: String = 'auto'
        // Direction where to open the tooltip. Possible values are: `right`, `left`,
        // `top`, `bottom`, `center`, `auto`.
        // `auto` will dynamically switch between `right` and `left` according to the tooltip
        // position on the map.
        direction: "auto",
        // @option permanent: Boolean = false
        // Whether to open the tooltip permanently or only on mouseover.
        permanent: !1,
        // @option sticky: Boolean = false
        // If true, the tooltip will follow the mouse instead of being fixed at the feature center.
        sticky: !1,
        // @option opacity: Number = 0.9
        // Tooltip container opacity.
        opacity: 0.9
      },
      onAdd: function(u) {
        gi.prototype.onAdd.call(this, u), this.setOpacity(this.options.opacity), u.fire("tooltipopen", { tooltip: this }), this._source && (this.addEventParent(this._source), this._source.fire("tooltipopen", { tooltip: this }, !0));
      },
      onRemove: function(u) {
        gi.prototype.onRemove.call(this, u), u.fire("tooltipclose", { tooltip: this }), this._source && (this.removeEventParent(this._source), this._source.fire("tooltipclose", { tooltip: this }, !0));
      },
      getEvents: function() {
        var u = gi.prototype.getEvents.call(this);
        return this.options.permanent || (u.preclick = this.close), u;
      },
      _initLayout: function() {
        var u = "leaflet-tooltip", h = u + " " + (this.options.className || "") + " leaflet-zoom-" + (this._zoomAnimated ? "animated" : "hide");
        this._contentNode = this._container = pt("div", h), this._container.setAttribute("role", "tooltip"), this._container.setAttribute("id", "leaflet-tooltip-" + c(this));
      },
      _updateLayout: function() {
      },
      _adjustPan: function() {
      },
      _setPosition: function(u) {
        var h, C, O = this._map, W = this._container, Y = O.latLngToContainerPoint(O.getCenter()), ie = O.layerPointToContainerPoint(u), de = this.options.direction, he = W.offsetWidth, be = W.offsetHeight, Oe = H(this.options.offset), qe = this._getAnchor();
        de === "top" ? (h = he / 2, C = be) : de === "bottom" ? (h = he / 2, C = 0) : de === "center" ? (h = he / 2, C = be / 2) : de === "right" ? (h = 0, C = be / 2) : de === "left" ? (h = he, C = be / 2) : ie.x < Y.x ? (de = "right", h = 0, C = be / 2) : (de = "left", h = he + (Oe.x + qe.x) * 2, C = be / 2), u = u.subtract(H(h, C, !0)).add(Oe).add(qe), Xt(W, "leaflet-tooltip-right"), Xt(W, "leaflet-tooltip-left"), Xt(W, "leaflet-tooltip-top"), Xt(W, "leaflet-tooltip-bottom"), tt(W, "leaflet-tooltip-" + de), sn(W, u);
      },
      _updatePosition: function() {
        var u = this._map.latLngToLayerPoint(this._latlng);
        this._setPosition(u);
      },
      setOpacity: function(u) {
        this.options.opacity = u, this._container && gr(this._container, u);
      },
      _animateZoom: function(u) {
        var h = this._map._latLngToNewLayerPoint(this._latlng, u.zoom, u.center);
        this._setPosition(h);
      },
      _getAnchor: function() {
        return H(this._source && this._source._getTooltipAnchor && !this.options.sticky ? this._source._getTooltipAnchor() : [0, 0]);
      }
    }), i$ = function(u, h) {
      return new Gf(u, h);
    };
    yt.include({
      // @method openTooltip(tooltip: Tooltip): this
      // Opens the specified tooltip.
      // @alternative
      // @method openTooltip(content: String|HTMLElement, latlng: LatLng, options?: Tooltip options): this
      // Creates a tooltip with the specified content and options and open it.
      openTooltip: function(u, h, C) {
        return this._initOverlay(Gf, u, h, C).openOn(this), this;
      },
      // @method closeTooltip(tooltip: Tooltip): this
      // Closes the tooltip given as parameter.
      closeTooltip: function(u) {
        return u.close(), this;
      }
    }), ni.include({
      // @method bindTooltip(content: String|HTMLElement|Function|Tooltip, options?: Tooltip options): this
      // Binds a tooltip to the layer with the passed `content` and sets up the
      // necessary event listeners. If a `Function` is passed it will receive
      // the layer as the first argument and should return a `String` or `HTMLElement`.
      bindTooltip: function(u, h) {
        return this._tooltip && this.isTooltipOpen() && this.unbindTooltip(), this._tooltip = this._initOverlay(Gf, this._tooltip, u, h), this._initTooltipInteractions(), this._tooltip.options.permanent && this._map && this._map.hasLayer(this) && this.openTooltip(), this;
      },
      // @method unbindTooltip(): this
      // Removes the tooltip previously bound with `bindTooltip`.
      unbindTooltip: function() {
        return this._tooltip && (this._initTooltipInteractions(!0), this.closeTooltip(), this._tooltip = null), this;
      },
      _initTooltipInteractions: function(u) {
        if (!(!u && this._tooltipHandlersAdded)) {
          var h = u ? "off" : "on", C = {
            remove: this.closeTooltip,
            move: this._moveTooltip
          };
          this._tooltip.options.permanent ? C.add = this._openTooltip : (C.mouseover = this._openTooltip, C.mouseout = this.closeTooltip, C.click = this._openTooltip, this._map ? this._addFocusListeners() : C.add = this._addFocusListeners), this._tooltip.options.sticky && (C.mousemove = this._moveTooltip), this[h](C), this._tooltipHandlersAdded = !u;
        }
      },
      // @method openTooltip(latlng?: LatLng): this
      // Opens the bound tooltip at the specified `latlng` or at the default tooltip anchor if no `latlng` is passed.
      openTooltip: function(u) {
        return this._tooltip && (this instanceof Qi || (this._tooltip._source = this), this._tooltip._prepareOpen(u) && (this._tooltip.openOn(this._map), this.getElement ? this._setAriaDescribedByOnLayer(this) : this.eachLayer && this.eachLayer(this._setAriaDescribedByOnLayer, this))), this;
      },
      // @method closeTooltip(): this
      // Closes the tooltip bound to this layer if it is open.
      closeTooltip: function() {
        if (this._tooltip)
          return this._tooltip.close();
      },
      // @method toggleTooltip(): this
      // Opens or closes the tooltip bound to this layer depending on its current state.
      toggleTooltip: function() {
        return this._tooltip && this._tooltip.toggle(this), this;
      },
      // @method isTooltipOpen(): boolean
      // Returns `true` if the tooltip bound to this layer is currently open.
      isTooltipOpen: function() {
        return this._tooltip.isOpen();
      },
      // @method setTooltipContent(content: String|HTMLElement|Tooltip): this
      // Sets the content of the tooltip bound to this layer.
      setTooltipContent: function(u) {
        return this._tooltip && this._tooltip.setContent(u), this;
      },
      // @method getTooltip(): Tooltip
      // Returns the tooltip bound to this layer.
      getTooltip: function() {
        return this._tooltip;
      },
      _addFocusListeners: function() {
        this.getElement ? this._addFocusListenersOnLayer(this) : this.eachLayer && this.eachLayer(this._addFocusListenersOnLayer, this);
      },
      _addFocusListenersOnLayer: function(u) {
        var h = typeof u.getElement == "function" && u.getElement();
        h && (Ze(h, "focus", function() {
          this._tooltip._source = u, this.openTooltip();
        }, this), Ze(h, "blur", this.closeTooltip, this));
      },
      _setAriaDescribedByOnLayer: function(u) {
        var h = typeof u.getElement == "function" && u.getElement();
        h && h.setAttribute("aria-describedby", this._tooltip._container.id);
      },
      _openTooltip: function(u) {
        if (!(!this._tooltip || !this._map)) {
          if (this._map.dragging && this._map.dragging.moving() && !this._openOnceFlag) {
            this._openOnceFlag = !0;
            var h = this;
            this._map.once("moveend", function() {
              h._openOnceFlag = !1, h._openTooltip(u);
            });
            return;
          }
          this._tooltip._source = u.layer || u.target, this.openTooltip(this._tooltip.options.sticky ? u.latlng : void 0);
        }
      },
      _moveTooltip: function(u) {
        var h = u.latlng, C, O;
        this._tooltip.options.sticky && u.originalEvent && (C = this._map.mouseEventToContainerPoint(u.originalEvent), O = this._map.containerPointToLayerPoint(C), h = this._map.layerPointToLatLng(O)), this._tooltip.setLatLng(h);
      }
    });
    var wC = vl.extend({
      options: {
        // @section
        // @aka DivIcon options
        iconSize: [12, 12],
        // also can be set through CSS
        // iconAnchor: (Point),
        // popupAnchor: (Point),
        // @option html: String|HTMLElement = ''
        // Custom HTML code to put inside the div element, empty by default. Alternatively,
        // an instance of `HTMLElement`.
        html: !1,
        // @option bgPos: Point = [0, 0]
        // Optional relative position of the background, in pixels
        bgPos: null,
        className: "leaflet-div-icon"
      },
      createIcon: function(u) {
        var h = u && u.tagName === "DIV" ? u : document.createElement("div"), C = this.options;
        if (C.html instanceof Element ? (_o(h), h.appendChild(C.html)) : h.innerHTML = C.html !== !1 ? C.html : "", C.bgPos) {
          var O = H(C.bgPos);
          h.style.backgroundPosition = -O.x + "px " + -O.y + "px";
        }
        return this._setIconStyles(h, "icon"), h;
      },
      createShadow: function() {
        return null;
      }
    });
    function a$(u) {
      return new wC(u);
    }
    vl.Default = gu;
    var vu = ni.extend({
      // @section
      // @aka GridLayer options
      options: {
        // @option tileSize: Number|Point = 256
        // Width and height of tiles in the grid. Use a number if width and height are equal, or `L.point(width, height)` otherwise.
        tileSize: 256,
        // @option opacity: Number = 1.0
        // Opacity of the tiles. Can be used in the `createTile()` function.
        opacity: 1,
        // @option updateWhenIdle: Boolean = (depends)
        // Load new tiles only when panning ends.
        // `true` by default on mobile browsers, in order to avoid too many requests and keep smooth navigation.
        // `false` otherwise in order to display new tiles _during_ panning, since it is easy to pan outside the
        // [`keepBuffer`](#gridlayer-keepbuffer) option in desktop browsers.
        updateWhenIdle: ke.mobile,
        // @option updateWhenZooming: Boolean = true
        // By default, a smooth zoom animation (during a [touch zoom](#map-touchzoom) or a [`flyTo()`](#map-flyto)) will update grid layers every integer zoom level. Setting this option to `false` will update the grid layer only when the smooth animation ends.
        updateWhenZooming: !0,
        // @option updateInterval: Number = 200
        // Tiles will not update more than once every `updateInterval` milliseconds when panning.
        updateInterval: 200,
        // @option zIndex: Number = 1
        // The explicit zIndex of the tile layer.
        zIndex: 1,
        // @option bounds: LatLngBounds = undefined
        // If set, tiles will only be loaded inside the set `LatLngBounds`.
        bounds: null,
        // @option minZoom: Number = 0
        // The minimum zoom level down to which this layer will be displayed (inclusive).
        minZoom: 0,
        // @option maxZoom: Number = undefined
        // The maximum zoom level up to which this layer will be displayed (inclusive).
        maxZoom: void 0,
        // @option maxNativeZoom: Number = undefined
        // Maximum zoom number the tile source has available. If it is specified,
        // the tiles on all zoom levels higher than `maxNativeZoom` will be loaded
        // from `maxNativeZoom` level and auto-scaled.
        maxNativeZoom: void 0,
        // @option minNativeZoom: Number = undefined
        // Minimum zoom number the tile source has available. If it is specified,
        // the tiles on all zoom levels lower than `minNativeZoom` will be loaded
        // from `minNativeZoom` level and auto-scaled.
        minNativeZoom: void 0,
        // @option noWrap: Boolean = false
        // Whether the layer is wrapped around the antimeridian. If `true`, the
        // GridLayer will only be displayed once at low zoom levels. Has no
        // effect when the [map CRS](#map-crs) doesn't wrap around. Can be used
        // in combination with [`bounds`](#gridlayer-bounds) to prevent requesting
        // tiles outside the CRS limits.
        noWrap: !1,
        // @option pane: String = 'tilePane'
        // `Map pane` where the grid layer will be added.
        pane: "tilePane",
        // @option className: String = ''
        // A custom class name to assign to the tile layer. Empty by default.
        className: "",
        // @option keepBuffer: Number = 2
        // When panning the map, keep this many rows and columns of tiles before unloading them.
        keepBuffer: 2
      },
      initialize: function(u) {
        g(this, u);
      },
      onAdd: function() {
        this._initContainer(), this._levels = {}, this._tiles = {}, this._resetView();
      },
      beforeAdd: function(u) {
        u._addZoomLimit(this);
      },
      onRemove: function(u) {
        this._removeAllTiles(), Et(this._container), u._removeZoomLimit(this), this._container = null, this._tileZoom = void 0;
      },
      // @method bringToFront: this
      // Brings the tile layer to the top of all tile layers.
      bringToFront: function() {
        return this._map && (wo(this._container), this._setAutoZIndex(Math.max)), this;
      },
      // @method bringToBack: this
      // Brings the tile layer to the bottom of all tile layers.
      bringToBack: function() {
        return this._map && (eo(this._container), this._setAutoZIndex(Math.min)), this;
      },
      // @method getContainer: HTMLElement
      // Returns the HTML element that contains the tiles for this layer.
      getContainer: function() {
        return this._container;
      },
      // @method setOpacity(opacity: Number): this
      // Changes the [opacity](#gridlayer-opacity) of the grid layer.
      setOpacity: function(u) {
        return this.options.opacity = u, this._updateOpacity(), this;
      },
      // @method setZIndex(zIndex: Number): this
      // Changes the [zIndex](#gridlayer-zindex) of the grid layer.
      setZIndex: function(u) {
        return this.options.zIndex = u, this._updateZIndex(), this;
      },
      // @method isLoading: Boolean
      // Returns `true` if any tile in the grid layer has not finished loading.
      isLoading: function() {
        return this._loading;
      },
      // @method redraw: this
      // Causes the layer to clear all the tiles and request them again.
      redraw: function() {
        if (this._map) {
          this._removeAllTiles();
          var u = this._clampZoom(this._map.getZoom());
          u !== this._tileZoom && (this._tileZoom = u, this._updateLevels()), this._update();
        }
        return this;
      },
      getEvents: function() {
        var u = {
          viewprereset: this._invalidateAll,
          viewreset: this._resetView,
          zoom: this._resetView,
          moveend: this._onMoveEnd
        };
        return this.options.updateWhenIdle || (this._onMove || (this._onMove = l(this._onMoveEnd, this.options.updateInterval, this)), u.move = this._onMove), this._zoomAnimated && (u.zoomanim = this._animateZoom), u;
      },
      // @section Extension methods
      // Layers extending `GridLayer` shall reimplement the following method.
      // @method createTile(coords: Object, done?: Function): HTMLElement
      // Called only internally, must be overridden by classes extending `GridLayer`.
      // Returns the `HTMLElement` corresponding to the given `coords`. If the `done` callback
      // is specified, it must be called when the tile has finished loading and drawing.
      createTile: function() {
        return document.createElement("div");
      },
      // @section
      // @method getTileSize: Point
      // Normalizes the [tileSize option](#gridlayer-tilesize) into a point. Used by the `createTile()` method.
      getTileSize: function() {
        var u = this.options.tileSize;
        return u instanceof G ? u : new G(u, u);
      },
      _updateZIndex: function() {
        this._container && this.options.zIndex !== void 0 && this.options.zIndex !== null && (this._container.style.zIndex = this.options.zIndex);
      },
      _setAutoZIndex: function(u) {
        for (var h = this.getPane().children, C = -u(-1 / 0, 1 / 0), O = 0, W = h.length, Y; O < W; O++)
          Y = h[O].style.zIndex, h[O] !== this._container && Y && (C = u(C, +Y));
        isFinite(C) && (this.options.zIndex = C + u(-1, 1), this._updateZIndex());
      },
      _updateOpacity: function() {
        if (this._map && !ke.ielt9) {
          gr(this._container, this.options.opacity);
          var u = +/* @__PURE__ */ new Date(), h = !1, C = !1;
          for (var O in this._tiles) {
            var W = this._tiles[O];
            if (!(!W.current || !W.loaded)) {
              var Y = Math.min(1, (u - W.loaded) / 200);
              gr(W.el, Y), Y < 1 ? h = !0 : (W.active ? C = !0 : this._onOpaqueTile(W), W.active = !0);
            }
          }
          C && !this._noPrune && this._pruneTiles(), h && (N(this._fadeFrame), this._fadeFrame = D(this._updateOpacity, this));
        }
      },
      _onOpaqueTile: f,
      _initContainer: function() {
        this._container || (this._container = pt("div", "leaflet-layer " + (this.options.className || "")), this._updateZIndex(), this.options.opacity < 1 && this._updateOpacity(), this.getPane().appendChild(this._container));
      },
      _updateLevels: function() {
        var u = this._tileZoom, h = this.options.maxZoom;
        if (u !== void 0) {
          for (var C in this._levels)
            C = Number(C), this._levels[C].el.children.length || C === u ? (this._levels[C].el.style.zIndex = h - Math.abs(u - C), this._onUpdateLevel(C)) : (Et(this._levels[C].el), this._removeTilesAtZoom(C), this._onRemoveLevel(C), delete this._levels[C]);
          var O = this._levels[u], W = this._map;
          return O || (O = this._levels[u] = {}, O.el = pt("div", "leaflet-tile-container leaflet-zoom-animated", this._container), O.el.style.zIndex = h, O.origin = W.project(W.unproject(W.getPixelOrigin()), u).round(), O.zoom = u, this._setZoomTransform(O, W.getCenter(), W.getZoom()), this._onCreateLevel(O)), this._level = O, O;
        }
      },
      _onUpdateLevel: f,
      _onRemoveLevel: f,
      _onCreateLevel: f,
      _pruneTiles: function() {
        if (this._map) {
          var u, h, C = this._map.getZoom();
          if (C > this.options.maxZoom || C < this.options.minZoom) {
            this._removeAllTiles();
            return;
          }
          for (u in this._tiles)
            h = this._tiles[u], h.retain = h.current;
          for (u in this._tiles)
            if (h = this._tiles[u], h.current && !h.active) {
              var O = h.coords;
              this._retainParent(O.x, O.y, O.z, O.z - 5) || this._retainChildren(O.x, O.y, O.z, O.z + 2);
            }
          for (u in this._tiles)
            this._tiles[u].retain || this._removeTile(u);
        }
      },
      _removeTilesAtZoom: function(u) {
        for (var h in this._tiles)
          this._tiles[h].coords.z === u && this._removeTile(h);
      },
      _removeAllTiles: function() {
        for (var u in this._tiles)
          this._removeTile(u);
      },
      _invalidateAll: function() {
        for (var u in this._levels)
          Et(this._levels[u].el), this._onRemoveLevel(Number(u)), delete this._levels[u];
        this._removeAllTiles(), this._tileZoom = void 0;
      },
      _retainParent: function(u, h, C, O) {
        var W = Math.floor(u / 2), Y = Math.floor(h / 2), ie = C - 1, de = new G(+W, +Y);
        de.z = +ie;
        var he = this._tileCoordsToKey(de), be = this._tiles[he];
        return be && be.active ? (be.retain = !0, !0) : (be && be.loaded && (be.retain = !0), ie > O ? this._retainParent(W, Y, ie, O) : !1);
      },
      _retainChildren: function(u, h, C, O) {
        for (var W = 2 * u; W < 2 * u + 2; W++)
          for (var Y = 2 * h; Y < 2 * h + 2; Y++) {
            var ie = new G(W, Y);
            ie.z = C + 1;
            var de = this._tileCoordsToKey(ie), he = this._tiles[de];
            if (he && he.active) {
              he.retain = !0;
              continue;
            } else
              he && he.loaded && (he.retain = !0);
            C + 1 < O && this._retainChildren(W, Y, C + 1, O);
          }
      },
      _resetView: function(u) {
        var h = u && (u.pinch || u.flyTo);
        this._setView(this._map.getCenter(), this._map.getZoom(), h, h);
      },
      _animateZoom: function(u) {
        this._setView(u.center, u.zoom, !0, u.noUpdate);
      },
      _clampZoom: function(u) {
        var h = this.options;
        return h.minNativeZoom !== void 0 && u < h.minNativeZoom ? h.minNativeZoom : h.maxNativeZoom !== void 0 && h.maxNativeZoom < u ? h.maxNativeZoom : u;
      },
      _setView: function(u, h, C, O) {
        var W = Math.round(h);
        this.options.maxZoom !== void 0 && W > this.options.maxZoom || this.options.minZoom !== void 0 && W < this.options.minZoom ? W = void 0 : W = this._clampZoom(W);
        var Y = this.options.updateWhenZooming && W !== this._tileZoom;
        (!O || Y) && (this._tileZoom = W, this._abortLoading && this._abortLoading(), this._updateLevels(), this._resetGrid(), W !== void 0 && this._update(u), C || this._pruneTiles(), this._noPrune = !!C), this._setZoomTransforms(u, h);
      },
      _setZoomTransforms: function(u, h) {
        for (var C in this._levels)
          this._setZoomTransform(this._levels[C], u, h);
      },
      _setZoomTransform: function(u, h, C) {
        var O = this._map.getZoomScale(C, u.zoom), W = u.origin.multiplyBy(O).subtract(this._map._getNewPixelOrigin(h, C)).round();
        ke.any3d ? xo(u.el, W, O) : sn(u.el, W);
      },
      _resetGrid: function() {
        var u = this._map, h = u.options.crs, C = this._tileSize = this.getTileSize(), O = this._tileZoom, W = this._map.getPixelWorldBounds(this._tileZoom);
        W && (this._globalTileRange = this._pxBoundsToTileRange(W)), this._wrapX = h.wrapLng && !this.options.noWrap && [
          Math.floor(u.project([0, h.wrapLng[0]], O).x / C.x),
          Math.ceil(u.project([0, h.wrapLng[1]], O).x / C.y)
        ], this._wrapY = h.wrapLat && !this.options.noWrap && [
          Math.floor(u.project([h.wrapLat[0], 0], O).y / C.x),
          Math.ceil(u.project([h.wrapLat[1], 0], O).y / C.y)
        ];
      },
      _onMoveEnd: function() {
        !this._map || this._map._animatingZoom || this._update();
      },
      _getTiledPixelBounds: function(u) {
        var h = this._map, C = h._animatingZoom ? Math.max(h._animateToZoom, h.getZoom()) : h.getZoom(), O = h.getZoomScale(C, this._tileZoom), W = h.project(u, this._tileZoom).floor(), Y = h.getSize().divideBy(O * 2);
        return new q(W.subtract(Y), W.add(Y));
      },
      // Private method to load tiles in the grid's active zoom level according to map bounds
      _update: function(u) {
        var h = this._map;
        if (h) {
          var C = this._clampZoom(h.getZoom());
          if (u === void 0 && (u = h.getCenter()), this._tileZoom !== void 0) {
            var O = this._getTiledPixelBounds(u), W = this._pxBoundsToTileRange(O), Y = W.getCenter(), ie = [], de = this.options.keepBuffer, he = new q(
              W.getBottomLeft().subtract([de, -de]),
              W.getTopRight().add([de, -de])
            );
            if (!(isFinite(W.min.x) && isFinite(W.min.y) && isFinite(W.max.x) && isFinite(W.max.y)))
              throw new Error("Attempted to load an infinite number of tiles");
            for (var be in this._tiles) {
              var Oe = this._tiles[be].coords;
              (Oe.z !== this._tileZoom || !he.contains(new G(Oe.x, Oe.y))) && (this._tiles[be].current = !1);
            }
            if (Math.abs(C - this._tileZoom) > 1) {
              this._setView(u, C);
              return;
            }
            for (var qe = W.min.y; qe <= W.max.y; qe++)
              for (var dt = W.min.x; dt <= W.max.x; dt++) {
                var Sr = new G(dt, qe);
                if (Sr.z = this._tileZoom, !!this._isValidTile(Sr)) {
                  var nr = this._tiles[this._tileCoordsToKey(Sr)];
                  nr ? nr.current = !0 : ie.push(Sr);
                }
              }
            if (ie.sort(function(Lr, wl) {
              return Lr.distanceTo(Y) - wl.distanceTo(Y);
            }), ie.length !== 0) {
              this._loading || (this._loading = !0, this.fire("loading"));
              var ko = document.createDocumentFragment();
              for (dt = 0; dt < ie.length; dt++)
                this._addTile(ie[dt], ko);
              this._level.el.appendChild(ko);
            }
          }
        }
      },
      _isValidTile: function(u) {
        var h = this._map.options.crs;
        if (!h.infinite) {
          var C = this._globalTileRange;
          if (!h.wrapLng && (u.x < C.min.x || u.x > C.max.x) || !h.wrapLat && (u.y < C.min.y || u.y > C.max.y))
            return !1;
        }
        if (!this.options.bounds)
          return !0;
        var O = this._tileCoordsToBounds(u);
        return K(this.options.bounds).overlaps(O);
      },
      _keyToBounds: function(u) {
        return this._tileCoordsToBounds(this._keyToTileCoords(u));
      },
      _tileCoordsToNwSe: function(u) {
        var h = this._map, C = this.getTileSize(), O = u.scaleBy(C), W = O.add(C), Y = h.unproject(O, u.z), ie = h.unproject(W, u.z);
        return [Y, ie];
      },
      // converts tile coordinates to its geographical bounds
      _tileCoordsToBounds: function(u) {
        var h = this._tileCoordsToNwSe(u), C = new X(h[0], h[1]);
        return this.options.noWrap || (C = this._map.wrapLatLngBounds(C)), C;
      },
      // converts tile coordinates to key for the tile cache
      _tileCoordsToKey: function(u) {
        return u.x + ":" + u.y + ":" + u.z;
      },
      // converts tile cache key to coordinates
      _keyToTileCoords: function(u) {
        var h = u.split(":"), C = new G(+h[0], +h[1]);
        return C.z = +h[2], C;
      },
      _removeTile: function(u) {
        var h = this._tiles[u];
        h && (Et(h.el), delete this._tiles[u], this.fire("tileunload", {
          tile: h.el,
          coords: this._keyToTileCoords(u)
        }));
      },
      _initTile: function(u) {
        tt(u, "leaflet-tile");
        var h = this.getTileSize();
        u.style.width = h.x + "px", u.style.height = h.y + "px", u.onselectstart = f, u.onmousemove = f, ke.ielt9 && this.options.opacity < 1 && gr(u, this.options.opacity);
      },
      _addTile: function(u, h) {
        var C = this._getTilePos(u), O = this._tileCoordsToKey(u), W = this.createTile(this._wrapCoords(u), a(this._tileReady, this, u));
        this._initTile(W), this.createTile.length < 2 && D(a(this._tileReady, this, u, null, W)), sn(W, C), this._tiles[O] = {
          el: W,
          coords: u,
          current: !0
        }, h.appendChild(W), this.fire("tileloadstart", {
          tile: W,
          coords: u
        });
      },
      _tileReady: function(u, h, C) {
        h && this.fire("tileerror", {
          error: h,
          tile: C,
          coords: u
        });
        var O = this._tileCoordsToKey(u);
        C = this._tiles[O], C && (C.loaded = +/* @__PURE__ */ new Date(), this._map._fadeAnimated ? (gr(C.el, 0), N(this._fadeFrame), this._fadeFrame = D(this._updateOpacity, this)) : (C.active = !0, this._pruneTiles()), h || (tt(C.el, "leaflet-tile-loaded"), this.fire("tileload", {
          tile: C.el,
          coords: u
        })), this._noTilesToLoad() && (this._loading = !1, this.fire("load"), ke.ielt9 || !this._map._fadeAnimated ? D(this._pruneTiles, this) : setTimeout(a(this._pruneTiles, this), 250)));
      },
      _getTilePos: function(u) {
        return u.scaleBy(this.getTileSize()).subtract(this._level.origin);
      },
      _wrapCoords: function(u) {
        var h = new G(
          this._wrapX ? d(u.x, this._wrapX) : u.x,
          this._wrapY ? d(u.y, this._wrapY) : u.y
        );
        return h.z = u.z, h;
      },
      _pxBoundsToTileRange: function(u) {
        var h = this.getTileSize();
        return new q(
          u.min.unscaleBy(h).floor(),
          u.max.unscaleBy(h).ceil().subtract([1, 1])
        );
      },
      _noTilesToLoad: function() {
        for (var u in this._tiles)
          if (!this._tiles[u].loaded)
            return !1;
        return !0;
      }
    });
    function s$(u) {
      return new vu(u);
    }
    var _l = vu.extend({
      // @section
      // @aka TileLayer options
      options: {
        // @option minZoom: Number = 0
        // The minimum zoom level down to which this layer will be displayed (inclusive).
        minZoom: 0,
        // @option maxZoom: Number = 18
        // The maximum zoom level up to which this layer will be displayed (inclusive).
        maxZoom: 18,
        // @option subdomains: String|String[] = 'abc'
        // Subdomains of the tile service. Can be passed in the form of one string (where each letter is a subdomain name) or an array of strings.
        subdomains: "abc",
        // @option errorTileUrl: String = ''
        // URL to the tile image to show in place of the tile that failed to load.
        errorTileUrl: "",
        // @option zoomOffset: Number = 0
        // The zoom number used in tile URLs will be offset with this value.
        zoomOffset: 0,
        // @option tms: Boolean = false
        // If `true`, inverses Y axis numbering for tiles (turn this on for [TMS](https://en.wikipedia.org/wiki/Tile_Map_Service) services).
        tms: !1,
        // @option zoomReverse: Boolean = false
        // If set to true, the zoom number used in tile URLs will be reversed (`maxZoom - zoom` instead of `zoom`)
        zoomReverse: !1,
        // @option detectRetina: Boolean = false
        // If `true` and user is on a retina display, it will request four tiles of half the specified size and a bigger zoom level in place of one to utilize the high resolution.
        detectRetina: !1,
        // @option crossOrigin: Boolean|String = false
        // Whether the crossOrigin attribute will be added to the tiles.
        // If a String is provided, all tiles will have their crossOrigin attribute set to the String provided. This is needed if you want to access tile pixel data.
        // Refer to [CORS Settings](https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_settings_attributes) for valid String values.
        crossOrigin: !1,
        // @option referrerPolicy: Boolean|String = false
        // Whether the referrerPolicy attribute will be added to the tiles.
        // If a String is provided, all tiles will have their referrerPolicy attribute set to the String provided.
        // This may be needed if your map's rendering context has a strict default but your tile provider expects a valid referrer
        // (e.g. to validate an API token).
        // Refer to [HTMLImageElement.referrerPolicy](https://developer.mozilla.org/en-US/docs/Web/API/HTMLImageElement/referrerPolicy) for valid String values.
        referrerPolicy: !1
      },
      initialize: function(u, h) {
        this._url = u, h = g(this, h), h.detectRetina && ke.retina && h.maxZoom > 0 ? (h.tileSize = Math.floor(h.tileSize / 2), h.zoomReverse ? (h.zoomOffset--, h.minZoom = Math.min(h.maxZoom, h.minZoom + 1)) : (h.zoomOffset++, h.maxZoom = Math.max(h.minZoom, h.maxZoom - 1)), h.minZoom = Math.max(0, h.minZoom)) : h.zoomReverse ? h.minZoom = Math.min(h.maxZoom, h.minZoom) : h.maxZoom = Math.max(h.minZoom, h.maxZoom), typeof h.subdomains == "string" && (h.subdomains = h.subdomains.split("")), this.on("tileunload", this._onTileRemove);
      },
      // @method setUrl(url: String, noRedraw?: Boolean): this
      // Updates the layer's URL template and redraws it (unless `noRedraw` is set to `true`).
      // If the URL does not change, the layer will not be redrawn unless
      // the noRedraw parameter is set to false.
      setUrl: function(u, h) {
        return this._url === u && h === void 0 && (h = !0), this._url = u, h || this.redraw(), this;
      },
      // @method createTile(coords: Object, done?: Function): HTMLElement
      // Called only internally, overrides GridLayer's [`createTile()`](#gridlayer-createtile)
      // to return an `<img>` HTML element with the appropriate image URL given `coords`. The `done`
      // callback is called when the tile has been loaded.
      createTile: function(u, h) {
        var C = document.createElement("img");
        return Ze(C, "load", a(this._tileOnLoad, this, h, C)), Ze(C, "error", a(this._tileOnError, this, h, C)), (this.options.crossOrigin || this.options.crossOrigin === "") && (C.crossOrigin = this.options.crossOrigin === !0 ? "" : this.options.crossOrigin), typeof this.options.referrerPolicy == "string" && (C.referrerPolicy = this.options.referrerPolicy), C.alt = "", C.src = this.getTileUrl(u), C;
      },
      // @section Extension methods
      // @uninheritable
      // Layers extending `TileLayer` might reimplement the following method.
      // @method getTileUrl(coords: Object): String
      // Called only internally, returns the URL for a tile given its coordinates.
      // Classes extending `TileLayer` can override this function to provide custom tile URL naming schemes.
      getTileUrl: function(u) {
        var h = {
          r: ke.retina ? "@2x" : "",
          s: this._getSubdomain(u),
          x: u.x,
          y: u.y,
          z: this._getZoomForUrl()
        };
        if (this._map && !this._map.options.crs.infinite) {
          var C = this._globalTileRange.max.y - u.y;
          this.options.tms && (h.y = C), h["-y"] = C;
        }
        return T(this._url, o(h, this.options));
      },
      _tileOnLoad: function(u, h) {
        ke.ielt9 ? setTimeout(a(u, this, null, h), 0) : u(null, h);
      },
      _tileOnError: function(u, h, C) {
        var O = this.options.errorTileUrl;
        O && h.getAttribute("src") !== O && (h.src = O), u(C, h);
      },
      _onTileRemove: function(u) {
        u.tile.onload = null;
      },
      _getZoomForUrl: function() {
        var u = this._tileZoom, h = this.options.maxZoom, C = this.options.zoomReverse, O = this.options.zoomOffset;
        return C && (u = h - u), u + O;
      },
      _getSubdomain: function(u) {
        var h = Math.abs(u.x + u.y) % this.options.subdomains.length;
        return this.options.subdomains[h];
      },
      // stops loading all tiles in the background layer
      _abortLoading: function() {
        var u, h;
        for (u in this._tiles)
          if (this._tiles[u].coords.z !== this._tileZoom && (h = this._tiles[u].el, h.onload = f, h.onerror = f, !h.complete)) {
            h.src = w;
            var C = this._tiles[u].coords;
            Et(h), delete this._tiles[u], this.fire("tileabort", {
              tile: h,
              coords: C
            });
          }
      },
      _removeTile: function(u) {
        var h = this._tiles[u];
        if (h)
          return h.el.setAttribute("src", w), vu.prototype._removeTile.call(this, u);
      },
      _tileReady: function(u, h, C) {
        if (!(!this._map || C && C.getAttribute("src") === w))
          return vu.prototype._tileReady.call(this, u, h, C);
      }
    });
    function xC(u, h) {
      return new _l(u, h);
    }
    var CC = _l.extend({
      // @section
      // @aka TileLayer.WMS options
      // If any custom options not documented here are used, they will be sent to the
      // WMS server as extra parameters in each request URL. This can be useful for
      // [non-standard vendor WMS parameters](https://docs.geoserver.org/stable/en/user/services/wms/vendor.html).
      defaultWmsParams: {
        service: "WMS",
        request: "GetMap",
        // @option layers: String = ''
        // **(required)** Comma-separated list of WMS layers to show.
        layers: "",
        // @option styles: String = ''
        // Comma-separated list of WMS styles.
        styles: "",
        // @option format: String = 'image/jpeg'
        // WMS image format (use `'image/png'` for layers with transparency).
        format: "image/jpeg",
        // @option transparent: Boolean = false
        // If `true`, the WMS service will return images with transparency.
        transparent: !1,
        // @option version: String = '1.1.1'
        // Version of the WMS service to use
        version: "1.1.1"
      },
      options: {
        // @option crs: CRS = null
        // Coordinate Reference System to use for the WMS requests, defaults to
        // map CRS. Don't change this if you're not sure what it means.
        crs: null,
        // @option uppercase: Boolean = false
        // If `true`, WMS request parameter keys will be uppercase.
        uppercase: !1
      },
      initialize: function(u, h) {
        this._url = u;
        var C = o({}, this.defaultWmsParams);
        for (var O in h)
          O in this.options || (C[O] = h[O]);
        h = g(this, h);
        var W = h.detectRetina && ke.retina ? 2 : 1, Y = this.getTileSize();
        C.width = Y.x * W, C.height = Y.y * W, this.wmsParams = C;
      },
      onAdd: function(u) {
        this._crs = this.options.crs || u.options.crs, this._wmsVersion = parseFloat(this.wmsParams.version);
        var h = this._wmsVersion >= 1.3 ? "crs" : "srs";
        this.wmsParams[h] = this._crs.code, _l.prototype.onAdd.call(this, u);
      },
      getTileUrl: function(u) {
        var h = this._tileCoordsToNwSe(u), C = this._crs, O = Q(C.project(h[0]), C.project(h[1])), W = O.min, Y = O.max, ie = (this._wmsVersion >= 1.3 && this._crs === mC ? [W.y, W.x, Y.y, Y.x] : [W.x, W.y, Y.x, Y.y]).join(","), de = _l.prototype.getTileUrl.call(this, u);
        return de + b(this.wmsParams, de, this.options.uppercase) + (this.options.uppercase ? "&BBOX=" : "&bbox=") + ie;
      },
      // @method setParams(params: Object, noRedraw?: Boolean): this
      // Merges an object with the new parameters and re-requests tiles on the current screen (unless `noRedraw` was set to true).
      setParams: function(u, h) {
        return o(this.wmsParams, u), h || this.redraw(), this;
      }
    });
    function l$(u, h) {
      return new CC(u, h);
    }
    _l.WMS = CC, xC.wms = l$;
    var na = ni.extend({
      // @section
      // @aka Renderer options
      options: {
        // @option padding: Number = 0.1
        // How much to extend the clip area around the map view (relative to its size)
        // e.g. 0.1 would be 10% of map view in each direction
        padding: 0.1
      },
      initialize: function(u) {
        g(this, u), c(this), this._layers = this._layers || {};
      },
      onAdd: function() {
        this._container || (this._initContainer(), tt(this._container, "leaflet-zoom-animated")), this.getPane().appendChild(this._container), this._update(), this.on("update", this._updatePaths, this);
      },
      onRemove: function() {
        this.off("update", this._updatePaths, this), this._destroyContainer();
      },
      getEvents: function() {
        var u = {
          viewreset: this._reset,
          zoom: this._onZoom,
          moveend: this._update,
          zoomend: this._onZoomEnd
        };
        return this._zoomAnimated && (u.zoomanim = this._onAnimZoom), u;
      },
      _onAnimZoom: function(u) {
        this._updateTransform(u.center, u.zoom);
      },
      _onZoom: function() {
        this._updateTransform(this._map.getCenter(), this._map.getZoom());
      },
      _updateTransform: function(u, h) {
        var C = this._map.getZoomScale(h, this._zoom), O = this._map.getSize().multiplyBy(0.5 + this.options.padding), W = this._map.project(this._center, h), Y = O.multiplyBy(-C).add(W).subtract(this._map._getNewPixelOrigin(u, h));
        ke.any3d ? xo(this._container, Y, C) : sn(this._container, Y);
      },
      _reset: function() {
        this._update(), this._updateTransform(this._center, this._zoom);
        for (var u in this._layers)
          this._layers[u]._reset();
      },
      _onZoomEnd: function() {
        for (var u in this._layers)
          this._layers[u]._project();
      },
      _updatePaths: function() {
        for (var u in this._layers)
          this._layers[u]._update();
      },
      _update: function() {
        var u = this.options.padding, h = this._map.getSize(), C = this._map.containerPointToLayerPoint(h.multiplyBy(-u)).round();
        this._bounds = new q(C, C.add(h.multiplyBy(1 + u * 2)).round()), this._center = this._map.getCenter(), this._zoom = this._map.getZoom();
      }
    }), SC = na.extend({
      // @section
      // @aka Canvas options
      options: {
        // @option tolerance: Number = 0
        // How much to extend the click tolerance around a path/object on the map.
        tolerance: 0
      },
      getEvents: function() {
        var u = na.prototype.getEvents.call(this);
        return u.viewprereset = this._onViewPreReset, u;
      },
      _onViewPreReset: function() {
        this._postponeUpdatePaths = !0;
      },
      onAdd: function() {
        na.prototype.onAdd.call(this), this._draw();
      },
      _initContainer: function() {
        var u = this._container = document.createElement("canvas");
        Ze(u, "mousemove", this._onMouseMove, this), Ze(u, "click dblclick mousedown mouseup contextmenu", this._onClick, this), Ze(u, "mouseout", this._handleMouseOut, this), u._leaflet_disable_events = !0, this._ctx = u.getContext("2d");
      },
      _destroyContainer: function() {
        N(this._redrawRequest), delete this._ctx, Et(this._container), xe(this._container), delete this._container;
      },
      _updatePaths: function() {
        if (!this._postponeUpdatePaths) {
          var u;
          this._redrawBounds = null;
          for (var h in this._layers)
            u = this._layers[h], u._update();
          this._redraw();
        }
      },
      _update: function() {
        if (!(this._map._animatingZoom && this._bounds)) {
          na.prototype._update.call(this);
          var u = this._bounds, h = this._container, C = u.getSize(), O = ke.retina ? 2 : 1;
          sn(h, u.min), h.width = O * C.x, h.height = O * C.y, h.style.width = C.x + "px", h.style.height = C.y + "px", ke.retina && this._ctx.scale(2, 2), this._ctx.translate(-u.min.x, -u.min.y), this.fire("update");
        }
      },
      _reset: function() {
        na.prototype._reset.call(this), this._postponeUpdatePaths && (this._postponeUpdatePaths = !1, this._updatePaths());
      },
      _initPath: function(u) {
        this._updateDashArray(u), this._layers[c(u)] = u;
        var h = u._order = {
          layer: u,
          prev: this._drawLast,
          next: null
        };
        this._drawLast && (this._drawLast.next = h), this._drawLast = h, this._drawFirst = this._drawFirst || this._drawLast;
      },
      _addPath: function(u) {
        this._requestRedraw(u);
      },
      _removePath: function(u) {
        var h = u._order, C = h.next, O = h.prev;
        C ? C.prev = O : this._drawLast = O, O ? O.next = C : this._drawFirst = C, delete u._order, delete this._layers[c(u)], this._requestRedraw(u);
      },
      _updatePath: function(u) {
        this._extendRedrawBounds(u), u._project(), u._update(), this._requestRedraw(u);
      },
      _updateStyle: function(u) {
        this._updateDashArray(u), this._requestRedraw(u);
      },
      _updateDashArray: function(u) {
        if (typeof u.options.dashArray == "string") {
          var h = u.options.dashArray.split(/[, ]+/), C = [], O, W;
          for (W = 0; W < h.length; W++) {
            if (O = Number(h[W]), isNaN(O))
              return;
            C.push(O);
          }
          u.options._dashArray = C;
        } else
          u.options._dashArray = u.options.dashArray;
      },
      _requestRedraw: function(u) {
        this._map && (this._extendRedrawBounds(u), this._redrawRequest = this._redrawRequest || D(this._redraw, this));
      },
      _extendRedrawBounds: function(u) {
        if (u._pxBounds) {
          var h = (u.options.weight || 0) + 1;
          this._redrawBounds = this._redrawBounds || new q(), this._redrawBounds.extend(u._pxBounds.min.subtract([h, h])), this._redrawBounds.extend(u._pxBounds.max.add([h, h]));
        }
      },
      _redraw: function() {
        this._redrawRequest = null, this._redrawBounds && (this._redrawBounds.min._floor(), this._redrawBounds.max._ceil()), this._clear(), this._draw(), this._redrawBounds = null;
      },
      _clear: function() {
        var u = this._redrawBounds;
        if (u) {
          var h = u.getSize();
          this._ctx.clearRect(u.min.x, u.min.y, h.x, h.y);
        } else
          this._ctx.save(), this._ctx.setTransform(1, 0, 0, 1, 0, 0), this._ctx.clearRect(0, 0, this._container.width, this._container.height), this._ctx.restore();
      },
      _draw: function() {
        var u, h = this._redrawBounds;
        if (this._ctx.save(), h) {
          var C = h.getSize();
          this._ctx.beginPath(), this._ctx.rect(h.min.x, h.min.y, C.x, C.y), this._ctx.clip();
        }
        this._drawing = !0;
        for (var O = this._drawFirst; O; O = O.next)
          u = O.layer, (!h || u._pxBounds && u._pxBounds.intersects(h)) && u._updatePath();
        this._drawing = !1, this._ctx.restore();
      },
      _updatePoly: function(u, h) {
        if (this._drawing) {
          var C, O, W, Y, ie = u._parts, de = ie.length, he = this._ctx;
          if (de) {
            for (he.beginPath(), C = 0; C < de; C++) {
              for (O = 0, W = ie[C].length; O < W; O++)
                Y = ie[C][O], he[O ? "lineTo" : "moveTo"](Y.x, Y.y);
              h && he.closePath();
            }
            this._fillStroke(he, u);
          }
        }
      },
      _updateCircle: function(u) {
        if (!(!this._drawing || u._empty())) {
          var h = u._point, C = this._ctx, O = Math.max(Math.round(u._radius), 1), W = (Math.max(Math.round(u._radiusY), 1) || O) / O;
          W !== 1 && (C.save(), C.scale(1, W)), C.beginPath(), C.arc(h.x, h.y / W, O, 0, Math.PI * 2, !1), W !== 1 && C.restore(), this._fillStroke(C, u);
        }
      },
      _fillStroke: function(u, h) {
        var C = h.options;
        C.fill && (u.globalAlpha = C.fillOpacity, u.fillStyle = C.fillColor || C.color, u.fill(C.fillRule || "evenodd")), C.stroke && C.weight !== 0 && (u.setLineDash && u.setLineDash(h.options && h.options._dashArray || []), u.globalAlpha = C.opacity, u.lineWidth = C.weight, u.strokeStyle = C.color, u.lineCap = C.lineCap, u.lineJoin = C.lineJoin, u.stroke());
      },
      // Canvas obviously doesn't have mouse events for individual drawn objects,
      // so we emulate that by calculating what's under the mouse on mousemove/click manually
      _onClick: function(u) {
        for (var h = this._map.mouseEventToLayerPoint(u), C, O, W = this._drawFirst; W; W = W.next)
          C = W.layer, C.options.interactive && C._containsPoint(h) && (!(u.type === "click" || u.type === "preclick") || !this._map._draggableMoved(C)) && (O = C);
        this._fireEvent(O ? [O] : !1, u);
      },
      _onMouseMove: function(u) {
        if (!(!this._map || this._map.dragging.moving() || this._map._animatingZoom)) {
          var h = this._map.mouseEventToLayerPoint(u);
          this._handleMouseHover(u, h);
        }
      },
      _handleMouseOut: function(u) {
        var h = this._hoveredLayer;
        h && (Xt(this._container, "leaflet-interactive"), this._fireEvent([h], u, "mouseout"), this._hoveredLayer = null, this._mouseHoverThrottled = !1);
      },
      _handleMouseHover: function(u, h) {
        if (!this._mouseHoverThrottled) {
          for (var C, O, W = this._drawFirst; W; W = W.next)
            C = W.layer, C.options.interactive && C._containsPoint(h) && (O = C);
          O !== this._hoveredLayer && (this._handleMouseOut(u), O && (tt(this._container, "leaflet-interactive"), this._fireEvent([O], u, "mouseover"), this._hoveredLayer = O)), this._fireEvent(this._hoveredLayer ? [this._hoveredLayer] : !1, u), this._mouseHoverThrottled = !0, setTimeout(a(function() {
            this._mouseHoverThrottled = !1;
          }, this), 32);
        }
      },
      _fireEvent: function(u, h, C) {
        this._map._fireDOMEvent(h, C || h.type, u);
      },
      _bringToFront: function(u) {
        var h = u._order;
        if (h) {
          var C = h.next, O = h.prev;
          if (C)
            C.prev = O;
          else
            return;
          O ? O.next = C : C && (this._drawFirst = C), h.prev = this._drawLast, this._drawLast.next = h, h.next = null, this._drawLast = h, this._requestRedraw(u);
        }
      },
      _bringToBack: function(u) {
        var h = u._order;
        if (h) {
          var C = h.next, O = h.prev;
          if (O)
            O.next = C;
          else
            return;
          C ? C.prev = O : O && (this._drawLast = O), h.prev = null, h.next = this._drawFirst, this._drawFirst.prev = h, this._drawFirst = h, this._requestRedraw(u);
        }
      }
    });
    function TC(u) {
      return ke.canvas ? new SC(u) : null;
    }
    var bu = function() {
      try {
        return document.namespaces.add("lvml", "urn:schemas-microsoft-com:vml"), function(u) {
          return document.createElement("<lvml:" + u + ' class="lvml">');
        };
      } catch (u) {
      }
      return function(u) {
        return document.createElement("<" + u + ' xmlns="urn:schemas-microsoft.com:vml" class="lvml">');
      };
    }(), c$ = {
      _initContainer: function() {
        this._container = pt("div", "leaflet-vml-container");
      },
      _update: function() {
        this._map._animatingZoom || (na.prototype._update.call(this), this.fire("update"));
      },
      _initPath: function(u) {
        var h = u._container = bu("shape");
        tt(h, "leaflet-vml-shape " + (this.options.className || "")), h.coordsize = "1 1", u._path = bu("path"), h.appendChild(u._path), this._updateStyle(u), this._layers[c(u)] = u;
      },
      _addPath: function(u) {
        var h = u._container;
        this._container.appendChild(h), u.options.interactive && u.addInteractiveTarget(h);
      },
      _removePath: function(u) {
        var h = u._container;
        Et(h), u.removeInteractiveTarget(h), delete this._layers[c(u)];
      },
      _updateStyle: function(u) {
        var h = u._stroke, C = u._fill, O = u.options, W = u._container;
        W.stroked = !!O.stroke, W.filled = !!O.fill, O.stroke ? (h || (h = u._stroke = bu("stroke")), W.appendChild(h), h.weight = O.weight + "px", h.color = O.color, h.opacity = O.opacity, O.dashArray ? h.dashStyle = S(O.dashArray) ? O.dashArray.join(" ") : O.dashArray.replace(/( *, *)/g, " ") : h.dashStyle = "", h.endcap = O.lineCap.replace("butt", "flat"), h.joinstyle = O.lineJoin) : h && (W.removeChild(h), u._stroke = null), O.fill ? (C || (C = u._fill = bu("fill")), W.appendChild(C), C.color = O.fillColor || O.color, C.opacity = O.fillOpacity) : C && (W.removeChild(C), u._fill = null);
      },
      _updateCircle: function(u) {
        var h = u._point.round(), C = Math.round(u._radius), O = Math.round(u._radiusY || C);
        this._setPath(u, u._empty() ? "M0 0" : "AL " + h.x + "," + h.y + " " + C + "," + O + " 0," + 65535 * 360);
      },
      _setPath: function(u, h) {
        u._path.v = h;
      },
      _bringToFront: function(u) {
        wo(u._container);
      },
      _bringToBack: function(u) {
        eo(u._container);
      }
    }, Yf = ke.vml ? bu : ve, yu = na.extend({
      _initContainer: function() {
        this._container = Yf("svg"), this._container.setAttribute("pointer-events", "none"), this._rootGroup = Yf("g"), this._container.appendChild(this._rootGroup);
      },
      _destroyContainer: function() {
        Et(this._container), xe(this._container), delete this._container, delete this._rootGroup, delete this._svgSize;
      },
      _update: function() {
        if (!(this._map._animatingZoom && this._bounds)) {
          na.prototype._update.call(this);
          var u = this._bounds, h = u.getSize(), C = this._container;
          (!this._svgSize || !this._svgSize.equals(h)) && (this._svgSize = h, C.setAttribute("width", h.x), C.setAttribute("height", h.y)), sn(C, u.min), C.setAttribute("viewBox", [u.min.x, u.min.y, h.x, h.y].join(" ")), this.fire("update");
        }
      },
      // methods below are called by vector layers implementations
      _initPath: function(u) {
        var h = u._path = Yf("path");
        u.options.className && tt(h, u.options.className), u.options.interactive && tt(h, "leaflet-interactive"), this._updateStyle(u), this._layers[c(u)] = u;
      },
      _addPath: function(u) {
        this._rootGroup || this._initContainer(), this._rootGroup.appendChild(u._path), u.addInteractiveTarget(u._path);
      },
      _removePath: function(u) {
        Et(u._path), u.removeInteractiveTarget(u._path), delete this._layers[c(u)];
      },
      _updatePath: function(u) {
        u._project(), u._update();
      },
      _updateStyle: function(u) {
        var h = u._path, C = u.options;
        h && (C.stroke ? (h.setAttribute("stroke", C.color), h.setAttribute("stroke-opacity", C.opacity), h.setAttribute("stroke-width", C.weight), h.setAttribute("stroke-linecap", C.lineCap), h.setAttribute("stroke-linejoin", C.lineJoin), C.dashArray ? h.setAttribute("stroke-dasharray", C.dashArray) : h.removeAttribute("stroke-dasharray"), C.dashOffset ? h.setAttribute("stroke-dashoffset", C.dashOffset) : h.removeAttribute("stroke-dashoffset")) : h.setAttribute("stroke", "none"), C.fill ? (h.setAttribute("fill", C.fillColor || C.color), h.setAttribute("fill-opacity", C.fillOpacity), h.setAttribute("fill-rule", C.fillRule || "evenodd")) : h.setAttribute("fill", "none"));
      },
      _updatePoly: function(u, h) {
        this._setPath(u, we(u._parts, h));
      },
      _updateCircle: function(u) {
        var h = u._point, C = Math.max(Math.round(u._radius), 1), O = Math.max(Math.round(u._radiusY), 1) || C, W = "a" + C + "," + O + " 0 1,0 ", Y = u._empty() ? "M0 0" : "M" + (h.x - C) + "," + h.y + W + C * 2 + ",0 " + W + -C * 2 + ",0 ";
        this._setPath(u, Y);
      },
      _setPath: function(u, h) {
        u._path.setAttribute("d", h);
      },
      // SVG does not have the concept of zIndex so we resort to changing the DOM order of elements
      _bringToFront: function(u) {
        wo(u._path);
      },
      _bringToBack: function(u) {
        eo(u._path);
      }
    });
    ke.vml && yu.include(c$);
    function EC(u) {
      return ke.svg || ke.vml ? new yu(u) : null;
    }
    yt.include({
      // @namespace Map; @method getRenderer(layer: Path): Renderer
      // Returns the instance of `Renderer` that should be used to render the given
      // `Path`. It will ensure that the `renderer` options of the map and paths
      // are respected, and that the renderers do exist on the map.
      getRenderer: function(u) {
        var h = u.options.renderer || this._getPaneRenderer(u.options.pane) || this.options.renderer || this._renderer;
        return h || (h = this._renderer = this._createRenderer()), this.hasLayer(h) || this.addLayer(h), h;
      },
      _getPaneRenderer: function(u) {
        if (u === "overlayPane" || u === void 0)
          return !1;
        var h = this._paneRenderers[u];
        return h === void 0 && (h = this._createRenderer({ pane: u }), this._paneRenderers[u] = h), h;
      },
      _createRenderer: function(u) {
        return this.options.preferCanvas && TC(u) || EC(u);
      }
    });
    var kC = bl.extend({
      initialize: function(u, h) {
        bl.prototype.initialize.call(this, this._boundsToLatLngs(u), h);
      },
      // @method setBounds(latLngBounds: LatLngBounds): this
      // Redraws the rectangle with the passed bounds.
      setBounds: function(u) {
        return this.setLatLngs(this._boundsToLatLngs(u));
      },
      _boundsToLatLngs: function(u) {
        return u = K(u), [
          u.getSouthWest(),
          u.getNorthWest(),
          u.getNorthEast(),
          u.getSouthEast()
        ];
      }
    });
    function u$(u, h) {
      return new kC(u, h);
    }
    yu.create = Yf, yu.pointsToPath = we, ta.geometryToLayer = Hf, ta.coordsToLatLng = vv, ta.coordsToLatLngs = jf, ta.latLngToCoords = bv, ta.latLngsToCoords = Wf, ta.getFeature = yl, ta.asFeature = Vf, yt.mergeOptions({
      // @option boxZoom: Boolean = true
      // Whether the map can be zoomed to a rectangular area specified by
      // dragging the mouse while pressing the shift key.
      boxZoom: !0
    });
    var MC = mi.extend({
      initialize: function(u) {
        this._map = u, this._container = u._container, this._pane = u._panes.overlayPane, this._resetStateTimeout = 0, u.on("unload", this._destroy, this);
      },
      addHooks: function() {
        Ze(this._container, "mousedown", this._onMouseDown, this);
      },
      removeHooks: function() {
        xe(this._container, "mousedown", this._onMouseDown, this);
      },
      moved: function() {
        return this._moved;
      },
      _destroy: function() {
        Et(this._pane), delete this._pane;
      },
      _resetState: function() {
        this._resetStateTimeout = 0, this._moved = !1;
      },
      _clearDeferredResetState: function() {
        this._resetStateTimeout !== 0 && (clearTimeout(this._resetStateTimeout), this._resetStateTimeout = 0);
      },
      _onMouseDown: function(u) {
        if (!u.shiftKey || u.which !== 1 && u.button !== 1)
          return !1;
        this._clearDeferredResetState(), this._resetState(), di(), Co(), this._startPoint = this._map.mouseEventToContainerPoint(u), Ze(document, {
          contextmenu: Es,
          mousemove: this._onMouseMove,
          mouseup: this._onMouseUp,
          keydown: this._onKeyDown
        }, this);
      },
      _onMouseMove: function(u) {
        this._moved || (this._moved = !0, this._box = pt("div", "leaflet-zoom-box", this._container), tt(this._container, "leaflet-crosshair"), this._map.fire("boxzoomstart")), this._point = this._map.mouseEventToContainerPoint(u);
        var h = new q(this._point, this._startPoint), C = h.getSize();
        sn(this._box, h.min), this._box.style.width = C.x + "px", this._box.style.height = C.y + "px";
      },
      _finish: function() {
        this._moved && (Et(this._box), Xt(this._container, "leaflet-crosshair")), tr(), fi(), xe(document, {
          contextmenu: Es,
          mousemove: this._onMouseMove,
          mouseup: this._onMouseUp,
          keydown: this._onKeyDown
        }, this);
      },
      _onMouseUp: function(u) {
        if (!(u.which !== 1 && u.button !== 1) && (this._finish(), !!this._moved)) {
          this._clearDeferredResetState(), this._resetStateTimeout = setTimeout(a(this._resetState, this), 0);
          var h = new X(
            this._map.containerPointToLatLng(this._startPoint),
            this._map.containerPointToLatLng(this._point)
          );
          this._map.fitBounds(h).fire("boxzoomend", { boxZoomBounds: h });
        }
      },
      _onKeyDown: function(u) {
        u.keyCode === 27 && (this._finish(), this._clearDeferredResetState(), this._resetState());
      }
    });
    yt.addInitHook("addHandler", "boxZoom", MC), yt.mergeOptions({
      // @option doubleClickZoom: Boolean|String = true
      // Whether the map can be zoomed in by double clicking on it and
      // zoomed out by double clicking while holding shift. If passed
      // `'center'`, double-click zoom will zoom to the center of the
      //  view regardless of where the mouse was.
      doubleClickZoom: !0
    });
    var RC = mi.extend({
      addHooks: function() {
        this._map.on("dblclick", this._onDoubleClick, this);
      },
      removeHooks: function() {
        this._map.off("dblclick", this._onDoubleClick, this);
      },
      _onDoubleClick: function(u) {
        var h = this._map, C = h.getZoom(), O = h.options.zoomDelta, W = u.originalEvent.shiftKey ? C - O : C + O;
        h.options.doubleClickZoom === "center" ? h.setZoom(W) : h.setZoomAround(u.containerPoint, W);
      }
    });
    yt.addInitHook("addHandler", "doubleClickZoom", RC), yt.mergeOptions({
      // @option dragging: Boolean = true
      // Whether the map is draggable with mouse/touch or not.
      dragging: !0,
      // @section Panning Inertia Options
      // @option inertia: Boolean = *
      // If enabled, panning of the map will have an inertia effect where
      // the map builds momentum while dragging and continues moving in
      // the same direction for some time. Feels especially nice on touch
      // devices. Enabled by default.
      inertia: !0,
      // @option inertiaDeceleration: Number = 3000
      // The rate with which the inertial movement slows down, in pixels/second².
      inertiaDeceleration: 3400,
      // px/s^2
      // @option inertiaMaxSpeed: Number = Infinity
      // Max speed of the inertial movement, in pixels/second.
      inertiaMaxSpeed: 1 / 0,
      // px/s
      // @option easeLinearity: Number = 0.2
      easeLinearity: 0.2,
      // TODO refactor, move to CRS
      // @option worldCopyJump: Boolean = false
      // With this option enabled, the map tracks when you pan to another "copy"
      // of the world and seamlessly jumps to the original one so that all overlays
      // like markers and vector layers are still visible.
      worldCopyJump: !1,
      // @option maxBoundsViscosity: Number = 0.0
      // If `maxBounds` is set, this option will control how solid the bounds
      // are when dragging the map around. The default value of `0.0` allows the
      // user to drag outside the bounds at normal speed, higher values will
      // slow down map dragging outside bounds, and `1.0` makes the bounds fully
      // solid, preventing the user from dragging outside the bounds.
      maxBoundsViscosity: 0
    });
    var PC = mi.extend({
      addHooks: function() {
        if (!this._draggable) {
          var u = this._map;
          this._draggable = new Pa(u._mapPane, u._container), this._draggable.on({
            dragstart: this._onDragStart,
            drag: this._onDrag,
            dragend: this._onDragEnd
          }, this), this._draggable.on("predrag", this._onPreDragLimit, this), u.options.worldCopyJump && (this._draggable.on("predrag", this._onPreDragWrap, this), u.on("zoomend", this._onZoomEnd, this), u.whenReady(this._onZoomEnd, this));
        }
        tt(this._map._container, "leaflet-grab leaflet-touch-drag"), this._draggable.enable(), this._positions = [], this._times = [];
      },
      removeHooks: function() {
        Xt(this._map._container, "leaflet-grab"), Xt(this._map._container, "leaflet-touch-drag"), this._draggable.disable();
      },
      moved: function() {
        return this._draggable && this._draggable._moved;
      },
      moving: function() {
        return this._draggable && this._draggable._moving;
      },
      _onDragStart: function() {
        var u = this._map;
        if (u._stop(), this._map.options.maxBounds && this._map.options.maxBoundsViscosity) {
          var h = K(this._map.options.maxBounds);
          this._offsetLimit = Q(
            this._map.latLngToContainerPoint(h.getNorthWest()).multiplyBy(-1),
            this._map.latLngToContainerPoint(h.getSouthEast()).multiplyBy(-1).add(this._map.getSize())
          ), this._viscosity = Math.min(1, Math.max(0, this._map.options.maxBoundsViscosity));
        } else
          this._offsetLimit = null;
        u.fire("movestart").fire("dragstart"), u.options.inertia && (this._positions = [], this._times = []);
      },
      _onDrag: function(u) {
        if (this._map.options.inertia) {
          var h = this._lastTime = +/* @__PURE__ */ new Date(), C = this._lastPos = this._draggable._absPos || this._draggable._newPos;
          this._positions.push(C), this._times.push(h), this._prunePositions(h);
        }
        this._map.fire("move", u).fire("drag", u);
      },
      _prunePositions: function(u) {
        for (; this._positions.length > 1 && u - this._times[0] > 50; )
          this._positions.shift(), this._times.shift();
      },
      _onZoomEnd: function() {
        var u = this._map.getSize().divideBy(2), h = this._map.latLngToLayerPoint([0, 0]);
        this._initialWorldOffset = h.subtract(u).x, this._worldWidth = this._map.getPixelWorldBounds().getSize().x;
      },
      _viscousLimit: function(u, h) {
        return u - (u - h) * this._viscosity;
      },
      _onPreDragLimit: function() {
        if (!(!this._viscosity || !this._offsetLimit)) {
          var u = this._draggable._newPos.subtract(this._draggable._startPos), h = this._offsetLimit;
          u.x < h.min.x && (u.x = this._viscousLimit(u.x, h.min.x)), u.y < h.min.y && (u.y = this._viscousLimit(u.y, h.min.y)), u.x > h.max.x && (u.x = this._viscousLimit(u.x, h.max.x)), u.y > h.max.y && (u.y = this._viscousLimit(u.y, h.max.y)), this._draggable._newPos = this._draggable._startPos.add(u);
        }
      },
      _onPreDragWrap: function() {
        var u = this._worldWidth, h = Math.round(u / 2), C = this._initialWorldOffset, O = this._draggable._newPos.x, W = (O - h + C) % u + h - C, Y = (O + h + C) % u - h - C, ie = Math.abs(W + C) < Math.abs(Y + C) ? W : Y;
        this._draggable._absPos = this._draggable._newPos.clone(), this._draggable._newPos.x = ie;
      },
      _onDragEnd: function(u) {
        var h = this._map, C = h.options, O = !C.inertia || u.noInertia || this._times.length < 2;
        if (h.fire("dragend", u), O)
          h.fire("moveend");
        else {
          this._prunePositions(+/* @__PURE__ */ new Date());
          var W = this._lastPos.subtract(this._positions[0]), Y = (this._lastTime - this._times[0]) / 1e3, ie = C.easeLinearity, de = W.multiplyBy(ie / Y), he = de.distanceTo([0, 0]), be = Math.min(C.inertiaMaxSpeed, he), Oe = de.multiplyBy(be / he), qe = be / (C.inertiaDeceleration * ie), dt = Oe.multiplyBy(-qe / 2).round();
          !dt.x && !dt.y ? h.fire("moveend") : (dt = h._limitOffset(dt, h.options.maxBounds), D(function() {
            h.panBy(dt, {
              duration: qe,
              easeLinearity: ie,
              noMoveStart: !0,
              animate: !0
            });
          }));
        }
      }
    });
    yt.addInitHook("addHandler", "dragging", PC), yt.mergeOptions({
      // @option keyboard: Boolean = true
      // Makes the map focusable and allows users to navigate the map with keyboard
      // arrows and `+`/`-` keys.
      keyboard: !0,
      // @option keyboardPanDelta: Number = 80
      // Amount of pixels to pan when pressing an arrow key.
      keyboardPanDelta: 80
    });
    var OC = mi.extend({
      keyCodes: {
        left: [37],
        right: [39],
        down: [40],
        up: [38],
        zoomIn: [187, 107, 61, 171],
        zoomOut: [189, 109, 54, 173]
      },
      initialize: function(u) {
        this._map = u, this._setPanDelta(u.options.keyboardPanDelta), this._setZoomDelta(u.options.zoomDelta);
      },
      addHooks: function() {
        var u = this._map._container;
        u.tabIndex <= 0 && (u.tabIndex = "0"), Ze(u, {
          focus: this._onFocus,
          blur: this._onBlur,
          mousedown: this._onMouseDown
        }, this), this._map.on({
          focus: this._addHooks,
          blur: this._removeHooks
        }, this);
      },
      removeHooks: function() {
        this._removeHooks(), xe(this._map._container, {
          focus: this._onFocus,
          blur: this._onBlur,
          mousedown: this._onMouseDown
        }, this), this._map.off({
          focus: this._addHooks,
          blur: this._removeHooks
        }, this);
      },
      _onMouseDown: function() {
        if (!this._focused) {
          var u = document.body, h = document.documentElement, C = u.scrollTop || h.scrollTop, O = u.scrollLeft || h.scrollLeft;
          this._map._container.focus(), window.scrollTo(O, C);
        }
      },
      _onFocus: function() {
        this._focused = !0, this._map.fire("focus");
      },
      _onBlur: function() {
        this._focused = !1, this._map.fire("blur");
      },
      _setPanDelta: function(u) {
        var h = this._panKeys = {}, C = this.keyCodes, O, W;
        for (O = 0, W = C.left.length; O < W; O++)
          h[C.left[O]] = [-1 * u, 0];
        for (O = 0, W = C.right.length; O < W; O++)
          h[C.right[O]] = [u, 0];
        for (O = 0, W = C.down.length; O < W; O++)
          h[C.down[O]] = [0, u];
        for (O = 0, W = C.up.length; O < W; O++)
          h[C.up[O]] = [0, -1 * u];
      },
      _setZoomDelta: function(u) {
        var h = this._zoomKeys = {}, C = this.keyCodes, O, W;
        for (O = 0, W = C.zoomIn.length; O < W; O++)
          h[C.zoomIn[O]] = u;
        for (O = 0, W = C.zoomOut.length; O < W; O++)
          h[C.zoomOut[O]] = -u;
      },
      _addHooks: function() {
        Ze(document, "keydown", this._onKeyDown, this);
      },
      _removeHooks: function() {
        xe(document, "keydown", this._onKeyDown, this);
      },
      _onKeyDown: function(u) {
        if (!(u.altKey || u.ctrlKey || u.metaKey)) {
          var h = u.keyCode, C = this._map, O;
          if (h in this._panKeys) {
            if (!C._panAnim || !C._panAnim._inProgress)
              if (O = this._panKeys[h], u.shiftKey && (O = H(O).multiplyBy(3)), C.options.maxBounds && (O = C._limitOffset(H(O), C.options.maxBounds)), C.options.worldCopyJump) {
                var W = C.wrapLatLng(C.unproject(C.project(C.getCenter()).add(O)));
                C.panTo(W);
              } else
                C.panBy(O);
          } else if (h in this._zoomKeys)
            C.setZoom(C.getZoom() + (u.shiftKey ? 3 : 1) * this._zoomKeys[h]);
          else if (h === 27 && C._popup && C._popup.options.closeOnEscapeKey)
            C.closePopup();
          else
            return;
          Es(u);
        }
      }
    });
    yt.addInitHook("addHandler", "keyboard", OC), yt.mergeOptions({
      // @section Mouse wheel options
      // @option scrollWheelZoom: Boolean|String = true
      // Whether the map can be zoomed by using the mouse wheel. If passed `'center'`,
      // it will zoom to the center of the view regardless of where the mouse was.
      scrollWheelZoom: !0,
      // @option wheelDebounceTime: Number = 40
      // Limits the rate at which a wheel can fire (in milliseconds). By default
      // user can't zoom via wheel more often than once per 40 ms.
      wheelDebounceTime: 40,
      // @option wheelPxPerZoomLevel: Number = 60
      // How many scroll pixels (as reported by [L.DomEvent.getWheelDelta](#domevent-getwheeldelta))
      // mean a change of one full zoom level. Smaller values will make wheel-zooming
      // faster (and vice versa).
      wheelPxPerZoomLevel: 60
    });
    var NC = mi.extend({
      addHooks: function() {
        Ze(this._map._container, "wheel", this._onWheelScroll, this), this._delta = 0;
      },
      removeHooks: function() {
        xe(this._map._container, "wheel", this._onWheelScroll, this);
      },
      _onWheelScroll: function(u) {
        var h = nC(u), C = this._map.options.wheelDebounceTime;
        this._delta += h, this._lastMousePos = this._map.mouseEventToContainerPoint(u), this._startTime || (this._startTime = +/* @__PURE__ */ new Date());
        var O = Math.max(C - (+/* @__PURE__ */ new Date() - this._startTime), 0);
        clearTimeout(this._timer), this._timer = setTimeout(a(this._performZoom, this), O), Es(u);
      },
      _performZoom: function() {
        var u = this._map, h = u.getZoom(), C = this._map.options.zoomSnap || 0;
        u._stop();
        var O = this._delta / (this._map.options.wheelPxPerZoomLevel * 4), W = 4 * Math.log(2 / (1 + Math.exp(-Math.abs(O)))) / Math.LN2, Y = C ? Math.ceil(W / C) * C : W, ie = u._limitZoom(h + (this._delta > 0 ? Y : -Y)) - h;
        this._delta = 0, this._startTime = null, ie && (u.options.scrollWheelZoom === "center" ? u.setZoom(h + ie) : u.setZoomAround(this._lastMousePos, h + ie));
      }
    });
    yt.addInitHook("addHandler", "scrollWheelZoom", NC);
    var d$ = 600;
    yt.mergeOptions({
      // @section Touch interaction options
      // @option tapHold: Boolean
      // Enables simulation of `contextmenu` event, default is `true` for mobile Safari.
      tapHold: ke.touchNative && ke.safari && ke.mobile,
      // @option tapTolerance: Number = 15
      // The max number of pixels a user can shift his finger during touch
      // for it to be considered a valid tap.
      tapTolerance: 15
    });
    var AC = mi.extend({
      addHooks: function() {
        Ze(this._map._container, "touchstart", this._onDown, this);
      },
      removeHooks: function() {
        xe(this._map._container, "touchstart", this._onDown, this);
      },
      _onDown: function(u) {
        if (clearTimeout(this._holdTimeout), u.touches.length === 1) {
          var h = u.touches[0];
          this._startPos = this._newPos = new G(h.clientX, h.clientY), this._holdTimeout = setTimeout(a(function() {
            this._cancel(), this._isTapValid() && (Ze(document, "touchend", vn), Ze(document, "touchend touchcancel", this._cancelClickPrevent), this._simulateEvent("contextmenu", h));
          }, this), d$), Ze(document, "touchend touchcancel contextmenu", this._cancel, this), Ze(document, "touchmove", this._onMove, this);
        }
      },
      _cancelClickPrevent: function u() {
        xe(document, "touchend", vn), xe(document, "touchend touchcancel", u);
      },
      _cancel: function() {
        clearTimeout(this._holdTimeout), xe(document, "touchend touchcancel contextmenu", this._cancel, this), xe(document, "touchmove", this._onMove, this);
      },
      _onMove: function(u) {
        var h = u.touches[0];
        this._newPos = new G(h.clientX, h.clientY);
      },
      _isTapValid: function() {
        return this._newPos.distanceTo(this._startPos) <= this._map.options.tapTolerance;
      },
      _simulateEvent: function(u, h) {
        var C = new MouseEvent(u, {
          bubbles: !0,
          cancelable: !0,
          view: window,
          // detail: 1,
          screenX: h.screenX,
          screenY: h.screenY,
          clientX: h.clientX,
          clientY: h.clientY
          // button: 2,
          // buttons: 2
        });
        C._simulated = !0, h.target.dispatchEvent(C);
      }
    });
    yt.addInitHook("addHandler", "tapHold", AC), yt.mergeOptions({
      // @section Touch interaction options
      // @option touchZoom: Boolean|String = *
      // Whether the map can be zoomed by touch-dragging with two fingers. If
      // passed `'center'`, it will zoom to the center of the view regardless of
      // where the touch events (fingers) were. Enabled for touch-capable web
      // browsers.
      touchZoom: ke.touch,
      // @option bounceAtZoomLimits: Boolean = true
      // Set it to false if you don't want the map to zoom beyond min/max zoom
      // and then bounce back when pinch-zooming.
      bounceAtZoomLimits: !0
    });
    var DC = mi.extend({
      addHooks: function() {
        tt(this._map._container, "leaflet-touch-zoom"), Ze(this._map._container, "touchstart", this._onTouchStart, this);
      },
      removeHooks: function() {
        Xt(this._map._container, "leaflet-touch-zoom"), xe(this._map._container, "touchstart", this._onTouchStart, this);
      },
      _onTouchStart: function(u) {
        var h = this._map;
        if (!(!u.touches || u.touches.length !== 2 || h._animatingZoom || this._zooming)) {
          var C = h.mouseEventToContainerPoint(u.touches[0]), O = h.mouseEventToContainerPoint(u.touches[1]);
          this._centerPoint = h.getSize()._divideBy(2), this._startLatLng = h.containerPointToLatLng(this._centerPoint), h.options.touchZoom !== "center" && (this._pinchStartLatLng = h.containerPointToLatLng(C.add(O)._divideBy(2))), this._startDist = C.distanceTo(O), this._startZoom = h.getZoom(), this._moved = !1, this._zooming = !0, h._stop(), Ze(document, "touchmove", this._onTouchMove, this), Ze(document, "touchend touchcancel", this._onTouchEnd, this), vn(u);
        }
      },
      _onTouchMove: function(u) {
        if (!(!u.touches || u.touches.length !== 2 || !this._zooming)) {
          var h = this._map, C = h.mouseEventToContainerPoint(u.touches[0]), O = h.mouseEventToContainerPoint(u.touches[1]), W = C.distanceTo(O) / this._startDist;
          if (this._zoom = h.getScaleZoom(W, this._startZoom), !h.options.bounceAtZoomLimits && (this._zoom < h.getMinZoom() && W < 1 || this._zoom > h.getMaxZoom() && W > 1) && (this._zoom = h._limitZoom(this._zoom)), h.options.touchZoom === "center") {
            if (this._center = this._startLatLng, W === 1)
              return;
          } else {
            var Y = C._add(O)._divideBy(2)._subtract(this._centerPoint);
            if (W === 1 && Y.x === 0 && Y.y === 0)
              return;
            this._center = h.unproject(h.project(this._pinchStartLatLng, this._zoom).subtract(Y), this._zoom);
          }
          this._moved || (h._moveStart(!0, !1), this._moved = !0), N(this._animRequest);
          var ie = a(h._move, h, this._center, this._zoom, { pinch: !0, round: !1 }, void 0);
          this._animRequest = D(ie, this, !0), vn(u);
        }
      },
      _onTouchEnd: function() {
        if (!this._moved || !this._zooming) {
          this._zooming = !1;
          return;
        }
        this._zooming = !1, N(this._animRequest), xe(document, "touchmove", this._onTouchMove, this), xe(document, "touchend touchcancel", this._onTouchEnd, this), this._map.options.zoomAnimation ? this._map._animateZoom(this._center, this._map._limitZoom(this._zoom), !0, this._map.options.zoomSnap) : this._map._resetView(this._center, this._map._limitZoom(this._zoom));
      }
    });
    yt.addInitHook("addHandler", "touchZoom", DC), yt.BoxZoom = MC, yt.DoubleClickZoom = RC, yt.Drag = PC, yt.Keyboard = OC, yt.ScrollWheelZoom = NC, yt.TapHold = AC, yt.TouchZoom = DC, n.Bounds = q, n.Browser = ke, n.CRS = ae, n.Canvas = SC, n.Circle = gv, n.CircleMarker = Bf, n.Class = $, n.Control = ti, n.DivIcon = wC, n.DivOverlay = gi, n.DomEvent = R6, n.DomUtil = pu, n.Draggable = Pa, n.Evented = U, n.FeatureGroup = Qi, n.GeoJSON = ta, n.GridLayer = vu, n.Handler = mi, n.Icon = vl, n.ImageOverlay = Uf, n.LatLng = J, n.LatLngBounds = X, n.Layer = ni, n.LayerGroup = gl, n.LineUtil = j6, n.Map = yt, n.Marker = zf, n.Mixin = L6, n.Path = Oa, n.Point = G, n.PolyUtil = $6, n.Polygon = bl, n.Polyline = ea, n.Popup = qf, n.PosAnimation = rC, n.Projection = W6, n.Rectangle = kC, n.Renderer = na, n.SVG = yu, n.SVGOverlay = _C, n.TileLayer = _l, n.Tooltip = Gf, n.Transformation = fe, n.Util = F, n.VideoOverlay = yC, n.bind = a, n.bounds = Q, n.canvas = TC, n.circle = K6, n.circleMarker = X6, n.control = hu, n.divIcon = a$, n.extend = o, n.featureGroup = G6, n.geoJSON = bC, n.geoJson = e$, n.gridLayer = s$, n.icon = Y6, n.imageOverlay = t$, n.latLng = ne, n.latLngBounds = K, n.layerGroup = q6, n.map = P6, n.marker = Z6, n.point = H, n.polygon = Q6, n.polyline = J6, n.popup = o$, n.rectangle = u$, n.setOptions = g, n.stamp = c, n.svg = EC, n.svgOverlay = r$, n.tileLayer = xC, n.tooltip = i$, n.transformation = ee, n.version = r, n.videoOverlay = n$;
    var f$ = window.L;
    n.noConflict = function() {
      return window.L = f$, this;
    }, window.L = n;
  });
})(q1, q1.exports);
var kxe = q1.exports;
const Ii = /* @__PURE__ */ ya(kxe), Mxe = Object.freeze({
  usa: "united states",
  switzerland: "switzerland country",
  uk: "united kingdom"
});
function Rxe(e, t) {
  const n = Mxe[e.toLowerCase()];
  return n && (t[n] = e), n || e;
}
function Pxe(e, t) {
  return t[e.toLowerCase()] || e;
}
const Oxe = (e, t) => {
  const { app: n } = Gn(), [r, o] = Ge([]), i = it(e), a = bt(() => Mo(void 0, null, function* () {
    if (!n || !e)
      return;
    const s = {}, c = Ewe(t), l = yield n.httpClient.post("api/v1/geo/locations", se({
      locations: e.map((v) => ({
        name: Rxe(v.name, s)
      }))
    }, c && { geoLevel: c })), d = i.current !== e;
    if (!l || d)
      return;
    const f = l.reduce((v, g) => {
      const b = ge(se({}, g), {
        name: Pxe(g.name, s)
      });
      return v[b.name] = b, v;
    }, {}), p = [], m = e.map((v) => (f[v.name] || p.push(v.name), se(se({}, v), f[v.name] ? { coordinates: f[v.name].latLng } : null)));
    p.length && console.warn(`Locations "${p.join(", ")}" coordinates not found`), o(m);
  }), [n, o, e, t]);
  return mt(() => {
    e && (i.current = e, e.some((c) => !!c.coordinates) ? o(e) : a());
  }, [e, n, a, o]), r;
};
function Nxe(e) {
  let t = Number.MAX_VALUE, n = Number.MIN_VALUE;
  return e.forEach((r) => {
    isNaN(r) || (t = Math.min(t, r), n = Math.max(n, r));
  }), {
    min: t,
    max: n
  };
}
function Axe(e, t = 4, n = 24) {
  let r = 0;
  const { min: o, max: i } = Nxe(e.map(({ value: s }) => s)), a = n - t;
  return r = i - o, e.map((s) => r === 0 ? t : (s.value - o) / r * a + t);
}
const Dxe = () => {
  const { app: e } = Gn(), [t, n] = Ge(null), r = bt(() => Mo(void 0, null, function* () {
    if (!e)
      return;
    const o = yield e.httpClient.get(
      "api/v1/settings/system"
    );
    o && n(o.geo);
  }), [n, e]);
  return mt(() => {
    r();
  }, [e, r]), t;
}, Ixe = "#00cee6", Lxe = rO({
  getValueFromDataStructure: ({ colorValue: e }) => parseFloat(`${e}`),
  applyColorToDataStructure: (e, t) => ge(se({}, e), { color: t })
});
function $xe(e, t) {
  return t ? Lxe(
    e.map(({ colorValue: n }) => ({ colorValue: n })),
    t
  ).map(({ color: n }) => n) : e.map(() => Ixe);
}
function tL(e) {
  return {
    isLight: ["hollow", "filled-light"].includes(e),
    isFilled: ["filled", "filled-light"].includes(e)
  };
}
function nL(e) {
  const { color: t, size: n, fill: r, blur: o } = e, { isFilled: i } = tL(r), c = o ? {
    filled: 0.1,
    "filled-light": 0.1,
    hollow: 0.2,
    "hollow-bold": 0.25
  }[r] : {
    filled: 0.5,
    "filled-light": 0.2,
    hollow: 0.35,
    "hollow-bold": 0.9
  }[r];
  return {
    radius: n,
    fillOpacity: c,
    opacity: c,
    fillColor: i ? t : "transparent",
    color: i ? "transparent" : t,
    stroke: !i,
    weight: i ? 0 : 2,
    customStyle: e
  };
}
function Fxe({ coordinates: e, style: t }) {
  const n = new Ii.CircleMarker(
    {
      lat: e.lat,
      lng: e.lng
    },
    nL(t)
  );
  return n.on("mouseover", zxe), n.on("mouseout", Bxe), n;
}
function zxe(e) {
  const t = e.target, n = t.options.customStyle, { isFilled: r, isLight: o } = tL(n.fill);
  return t.setStyle(
    r ? {
      stroke: !0,
      weight: 2,
      opacity: o ? 0.5 : 0.7,
      fillOpacity: o ? 0.5 : 0.7
    } : {
      weight: 3,
      opacity: o ? 0.6 : 1
    }
  ), t;
}
function Bxe(e) {
  const t = e.target, n = t.options.customStyle;
  t.setStyle(nL(n));
}
function Hxe(e) {
  e.forEach((t) => t.remove());
}
function jxe(e, t) {
  const n = `
      © <a href='https://www.mapbox.com/about/maps/'>Mapbox</a>
      © <a href='http://www.openstreetmap.org/copyright'>OpenStreetMap</a>
      <strong>
        <a href='https://www.mapbox.com/map-feedback/' target='_blank'>
          Improve this map
        </a>
      </strong>`, r = "© <a href='http://www.openstreetmap.org/copyright'>OpenStreetMap</a>", o = Ii.control.attribution();
  return t.indexOf("mapbox") > -1 ? o.addAttribution(n).addTo(e) : t.indexOf("openstreetmap") > -1 && o.addAttribution(r).addTo(e), o;
}
const Wxe = 250;
function rL(e) {
  const t = e.chart.animation.init.duration === "auto" ? Wxe : e.chart.animation.init.duration;
  return {
    animate: t !== 0,
    duration: t / 1e3
  };
}
function Vxe(e, t, n = {}) {
  t.length && e.fitBounds(
    t.map((r) => [r.getLatLng().lat, r.getLatLng().lng]),
    se({
      maxZoom: 4
    }, n)
  );
}
var Uxe = "Expected a function";
function qxe(e, t, n) {
  if (typeof e != "function")
    throw new TypeError(Uxe);
  return setTimeout(function() {
    e.apply(void 0, n);
  }, t);
}
var Gxe = lO(function(e, t, n) {
  return qxe(e, Tb(t) || 0, n);
}), sh = /* @__PURE__ */ ((e) => (e[e.YES = 0] = "YES", e[e.NO = 1] = "NO", e[e.LOADING = 2] = "LOADING", e))(sh || {});
const Yxe = "#9EA2AB", DR = "N/A", fb = 10, Zxe = `
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="green"
    class="csdk-animate-spin"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z"
      fill="transparent"
      fillOpacity="0.3"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20 12C20 16.4183 16.4183 20 12 20C11.2844 20 10.5908 19.906 9.93078 19.7298C9.96227 19.5889 9.97888 19.4423 9.97888 19.2918C9.97888 18.1873 9.08345 17.2918 7.97888 17.2918C6.87431 17.2918 5.97888 18.1873 5.97888 19.2918C5.97888 20.3964 6.87431 21.2918 7.97888 21.2918C8.56576 21.2918 9.0936 21.0391 9.45946 20.6364C10.2652 20.8731 11.1178 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3V4C16.4183 4 20 7.58172 20 12Z"
      fill="#22C3C3"
    />
  </svg>
`, Xxe = (e) => {
  const t = `
    <div>
      <div>${aa("...")}</div>
      <div>${aa(`Showing first ${fb} results`)}</div>
    </div>
  `;
  return `
    <div>
      ${e.slice(0, fb).map((n) => `<div>${aa(n)}</div>`).join("")}
      ${e.length > fb ? t : ""}
    </div>
  `;
}, pb = (e) => `
    <span style="padding-right: 20px">
      ${aa(e, Yxe)}
    </span>
  `, Kxe = () => `
    <span style="verical-align: bottom">
      ${aa(Zxe)}
    </span>
  `, Ap = (e, t, n = 1) => {
  const r = Sv(t.size, e.value, `${e.value}`), o = Sv(
    t.colorBy,
    e.colorValue,
    `${e.colorValue}`
  ), i = t.details && wr(t.details) && Sv(t.details, e.details, `${e.details}`);
  return K$(`
    <div style="text-align: left">
        <div>${aa(e.name)}</div>
        <div class="csdk-scattermap-tooltip-row">
        ${t.size ? pb(sd(t.size)) : ""}
        ${t.size ? aa(r) : ""}
        </div>
        <div class="csdk-scattermap-tooltip-row">
        ${t.colorBy ? pb(sd(t.colorBy)) : ""}
        ${t.colorBy ? aa(o || DR) : ""}
        </div>
        <div class="csdk-scattermap-tooltip-row">
        ${(n === 2 || n === 0) && t.details ? pb(sd(t.details)) : ""}
        ${n === 2 ? Kxe() : ""}
        ${n === 0 && t.details && wr(t.details) ? aa(i || DR) : ""}
        </div>
        <div>
        ${n === 0 && t.details && !wr(t.details) ? Xxe(e.details) : ""}
        </div>
    </div>
  `);
}, Jxe = 600, Qxe = 11, eCe = ({
  dataOptions: e,
  dataSource: t,
  filters: n = []
}) => {
  const { app: r } = Gn(), o = bt(
    (a) => Mo(void 0, null, function* () {
      if (!r || !e.details || wr(e.details))
        return [];
      const s = e.locations.map((d, f) => {
        const p = ua(d), m = Twe(a)[f];
        return Sm(p, [m]);
      }), c = {
        dataSource: t,
        dimensions: [ua(e.details)],
        filters: pO(n, s),
        count: Qxe
      };
      return (yield Cg(c, r)).rows.map(([d]) => d.text);
    }),
    [r, e, t, n]
  );
  return bt(
    (a) => {
      if (!e.details || e.details && !wr(e.details) && !t)
        return {
          content: Ap(a, e)
        };
      if (wr(e.details))
        return {
          content: Ap(a, e, sh.YES)
        };
      const s = new Promise(
        (l) => Gxe(l, Jxe)
      ), c = Promise.all([o(a.name), s]).then(
        ([l]) => Ap(
          ge(se({}, a), { details: l }),
          e,
          sh.YES
        )
      );
      return {
        content: Ap(a, e, sh.LOADING),
        postponedContent: c
      };
    },
    [e, t, o]
  );
}, tCe = ({
  chartData: e,
  dataOptions: t,
  dataSource: n,
  filters: r = [],
  designOptions: o,
  onDataPointClick: i
}) => {
  const { locations: a } = e, s = Dxe(), { themeSettings: c } = Yn(), l = Oxe(a, t.locationLevel), { filters: d } = b_(r), f = eCe({
    dataOptions: t,
    dataSource: n,
    filters: d
  }), p = it(null), m = it(null), v = We(
    () => Axe(
      l,
      t.size ? o.markers.size.minSize : o.markers.size.defaultSize,
      t.size ? o.markers.size.maxSize : o.markers.size.defaultSize
    ),
    [l, t, o]
  ), g = We(
    () => {
      var _;
      return $xe(l, (_ = t.colorBy) == null ? void 0 : _.color);
    },
    [l, t]
  ), b = it([]), x = it(Ii.layerGroup([])), T = it(null), S = it(null);
  return mt(() => {
    p.current && !m.current && (m.current = Ii.map(p.current, {
      attributionControl: !1,
      scrollWheelZoom: !0,
      minZoom: 1,
      worldCopyJump: !0
    }), x.current.addTo(m.current), m.current.fitWorld());
  }, []), mt(() => {
    b.current && (Hxe(b.current), b.current = []), l && (l.forEach((_, w) => {
      if (!_.coordinates)
        return;
      const k = Fxe({
        coordinates: _.coordinates,
        style: {
          color: g[w],
          size: v[w],
          fill: o.markers.fill,
          blur: !!_.blur
        }
      });
      b.current.push(k), k.addTo(x.current), i && k.on("click", (E) => {
        i(
          kwe(_, t),
          E.originalEvent
        );
      }), k.bindTooltip(() => {
        const { content: E, postponedContent: R } = f(_);
        return R == null || R.then((P) => k.setTooltipContent(P)), E;
      });
    }), Vxe(
      m.current,
      b.current,
      rL(c)
    ));
  }, [
    l,
    g,
    v,
    o,
    c,
    t,
    f,
    i
  ]), mt(() => {
    var _;
    s && (T.current && T.current.remove(), T.current = Ii.tileLayer(s.maps_api_provider, {
      zoomOffset: -1,
      tileSize: 512
    }), m.current && (T.current.addTo(m.current), (_ = S.current) == null || _.remove(), S.current = jxe(m.current, s.maps_api_provider)));
  }, [s]), /* @__PURE__ */ z(
    "div",
    {
      className: "csdk-map-container",
      ref: p,
      style: {
        width: "100%",
        height: "100%"
      }
    }
  );
}, oL = (e) => e.type === "scattermap" && "locations" in e, nCe = (e) => "locations" in e, rCe = (e) => "markers" in e, oCe = (e) => !!e.chartData && oL(e.chartData) && nCe(e.dataOptions) && rCe(e.designOptions);
function lh(e) {
  return e === null;
}
const iCe = (e, t, {
  onDataPointClick: n,
  onDataPointContextMenu: r,
  onDataPointsSelected: o
} = {}) => {
  var a;
  const i = {
    chart: { events: {} },
    plotOptions: {
      series: {
        point: {
          events: {
            // will be overwritten if onDataPointClick is provided
            click: () => {
            }
          }
        }
      }
    }
  };
  return o && (i.chart.zoomType = "x", ["scatter", "bubble"].includes((a = e.chart) == null ? void 0 : a.type) && (i.chart.zoomType = "xy"), i.chart.events.selection = (s) => {
    s.preventDefault();
    const { xAxis: c, yAxis: l, originalEvent: d } = s, f = aCe(c[0], l[0]);
    f.forEach((p) => {
      p.state = "";
    }), o(
      f.map((p) => db(p, t)),
      d
    );
  }), n && (i.plotOptions.series.point.events.click = (s) => {
    s.point.state = "hover", n(db(s.point, t), s);
  }), r && (i.plotOptions.series.point.events.contextmenu = (s) => {
    s.preventDefault(), r(db(s.point, t), s);
  }), J$(e, i);
}, aCe = (e, t) => {
  const n = e.axis.series.flatMap((o) => o.points).filter(({ x: o, y: i }) => {
    const a = o >= e.min && o <= e.max, s = !lh(i);
    return a && s;
  });
  if (!t)
    return n;
  const r = t.axis.series.flatMap((o) => o.points).filter(({ y: o }) => o >= t.min && o <= t.max);
  return n.filter((o) => r.includes(o));
}, sCe = (e, t) => {
  var p;
  if (!t)
    return e;
  const n = {
    backgroundColor: t.chart.backgroundColor
  }, r = {
    style: {
      fontFamily: t.typography.fontFamily
    }
  }, o = {
    itemStyle: {
      color: t.chart.textColor,
      fontFamily: t.typography.fontFamily
    }
  }, a = {
    series: {
      dataLabels: {
        style: {
          color: t.chart.textColor,
          fontFamily: t.typography.fontFamily
        }
      }
    }
  }, s = {
    activeDataLabelStyle: {
      color: t.chart.textColor
    },
    breadcrumbs: {
      buttonTheme: {
        fill: t.general.brandColor,
        stroke: t.general.brandColor,
        style: {
          color: t.general.primaryButtonTextColor
        },
        states: {
          hover: {
            fill: t.general.primaryButtonHoverColor,
            stroke: t.general.primaryButtonHoverColor
          }
        }
      }
    }
  }, c = {
    chart: n,
    tooltip: r,
    legend: o,
    plotOptions: a,
    drilldown: s
  }, l = {
    labels: {
      style: {
        color: t.chart.textColor,
        fontFamily: t.typography.fontFamily
      }
    },
    title: {
      style: {
        color: t.chart.textColor,
        fontFamily: t.typography.fontFamily
      }
    }
  }, d = {
    color: t == null ? void 0 : t.chart.backgroundColor,
    label: {
      style: {
        color: t.chart.textColor,
        fontFamily: t.typography.fontFamily
      }
    }
  }, f = Ci(e, c);
  return f.xAxis = (p = f.xAxis) == null ? void 0 : p.map((m) => {
    var v;
    return m.plotBands = (v = m.plotBands) == null ? void 0 : v.map((g) => Ci(g, ge(se({}, d), {
      color: g.color || (t == null ? void 0 : t.chart.backgroundColor)
    }))), Ci(m, l);
  }), f.yAxis && (f.yAxis = f.yAxis.map((m) => {
    var v;
    return m.plotBands = (v = m.plotBands) == null ? void 0 : v.map((g) => Ci(g, ge(se({}, d), {
      color: g.color || (t == null ? void 0 : t.chart.backgroundColor)
    }))), Ci(m, l);
  })), f;
}, lCe = 600, cCe = 300, uCe = (e, t, n) => {
  const r = {
    duration: t.chart.animation.init.duration === "auto" ? lCe : t.chart.animation.init.duration
  }, o = {
    duration: t.chart.animation.redraw.duration === "auto" ? cCe : t.chart.animation.redraw.duration
  };
  return Ci(e, {
    accessibility: { enabled: n },
    chart: { animation: o },
    plotOptions: {
      series: { animation: r }
    },
    boost: { useGPUTranslations: !0, usePreAllocated: !0 }
  });
}, dCe = "_alert_box_10ttx_1", fCe = "_content_10ttx_8", pCe = "_alert_10ttx_1", hb = {
  alert_box: dCe,
  content: fCe,
  alert: pCe
}, hCe = ({ alerts: e = [] }) => /* @__PURE__ */ z("div", { className: hb.alert_box, children: /* @__PURE__ */ z("div", {
  className: hb.content,
  // prevents alert duplication
  children: [...new Set(e)].map((t, n) => /* @__PURE__ */ z("div", { className: hb.alert, children: t }, `alert-${n}`))
}) });
function mCe(e, t, n) {
  n = typeof n == "function" ? n : void 0;
  var r = n ? n(e, t) : void 0;
  return r === void 0 ? fO(e, t, void 0, n) : !!r;
}
var iL = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r(et);
  })(typeof self != "undefined" ? self : Ua, function(n) {
    return function(r) {
      function o(a) {
        if (i[a])
          return i[a].exports;
        var s = i[a] = { i: a, l: !1, exports: {} };
        return r[a].call(s.exports, s, s.exports, o), s.l = !0, s.exports;
      }
      var i = {};
      return o.m = r, o.c = i, o.d = function(a, s, c) {
        o.o(a, s) || Object.defineProperty(a, s, { configurable: !1, enumerable: !0, get: c });
      }, o.n = function(a) {
        var s = a && a.__esModule ? function() {
          return a.default;
        } : function() {
          return a;
        };
        return o.d(s, "a", s), s;
      }, o.o = function(a, s) {
        return Object.prototype.hasOwnProperty.call(a, s);
      }, o.p = "", o(o.s = 0);
    }([function(r, o, i) {
      function a() {
        return a = Object.assign ? Object.assign.bind() : function(T) {
          for (var S = 1; S < arguments.length; S++) {
            var _ = arguments[S];
            for (var w in _)
              Object.prototype.hasOwnProperty.call(_, w) && (T[w] = _[w]);
          }
          return T;
        }, a.apply(this, arguments);
      }
      function s(T) {
        return f(T) || d(T) || l(T) || c();
      }
      function c() {
        throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
      }
      function l(T, S) {
        if (T) {
          if (typeof T == "string")
            return p(T, S);
          var _ = Object.prototype.toString.call(T).slice(8, -1);
          return _ === "Object" && T.constructor && (_ = T.constructor.name), _ === "Map" || _ === "Set" ? Array.from(T) : _ === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(_) ? p(T, S) : void 0;
        }
      }
      function d(T) {
        if (typeof Symbol != "undefined" && T[Symbol.iterator] != null || T["@@iterator"] != null)
          return Array.from(T);
      }
      function f(T) {
        if (Array.isArray(T))
          return p(T);
      }
      function p(T, S) {
        (S == null || S > T.length) && (S = T.length);
        for (var _ = 0, w = new Array(S); _ < S; _++)
          w[_] = T[_];
        return w;
      }
      function m(T) {
        "@babel/helpers - typeof";
        return (m = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(S) {
          return typeof S;
        } : function(S) {
          return S && typeof Symbol == "function" && S.constructor === Symbol && S !== Symbol.prototype ? "symbol" : typeof S;
        })(T);
      }
      Object.defineProperty(o, "__esModule", { value: !0 }), i.d(o, "HighchartsReact", function() {
        return x;
      });
      var v = i(1), g = i.n(v), b = typeof window != "undefined" ? v.useLayoutEffect : v.useEffect, x = Object(v.memo)(Object(v.forwardRef)(function(T, S) {
        var _ = Object(v.useRef)(), w = Object(v.useRef)(), k = Object(v.useRef)(T.constructorType), E = Object(v.useRef)(T.highcharts);
        return b(function() {
          function R() {
            var A = T.highcharts || (typeof window == "undefined" ? "undefined" : m(window)) === "object" && window.Highcharts, D = T.constructorType || "chart";
            A ? A[D] ? T.options ? w.current = A[D](_.current, T.options, T.callback) : console.warn('The "options" property was not passed.') : console.warn('The "constructorType" property is incorrect or some required module is not imported.') : console.warn('The "highcharts" property was not passed.');
          }
          if (w.current) {
            if (T.allowChartUpdate !== !1)
              if (T.constructorType !== k.current || T.highcharts !== E.current)
                k.current = T.constructorType, E.current = T.highcharts, R();
              else if (!T.immutable && w.current) {
                var P;
                (P = w.current).update.apply(P, [T.options].concat(s(T.updateArgs || [!0, !0])));
              } else
                R();
          } else
            R();
        }, [T.options, T.allowChartUpdate, T.updateArgs, T.containerProps, T.highcharts, T.constructorType]), b(function() {
          return function() {
            w.current && (w.current.destroy(), w.current = null);
          };
        }, []), Object(v.useImperativeHandle)(S, function() {
          return { get chart() {
            return w.current;
          }, container: _ };
        }, []), g.a.createElement("div", a({}, T.containerProps, { ref: _ }));
      }));
      o.default = x;
    }, function(r, o) {
      r.exports = n;
    }]);
  });
})(iL);
var gCe = iL.exports;
const vCe = /* @__PURE__ */ ya(gCe);
function aL(e) {
  const t = it(void 0);
  return mt(() => {
    t.current = e;
  }, [e]), t.current;
}
var sL = { exports: {} };
(function(e) {
  (function(t) {
    e.exports ? e.exports = t : t(Highcharts);
  })(function(t) {
    var n = t.relativeLength;
    t.wrap(t.seriesTypes.column.prototype, "translate", function(r) {
      var o = this.options, i = o.topMargin || 0, a = o.bottomMargin || 0;
      r.call(this), this.points.forEach(function(s) {
        var c = s.shapeArgs, l = c.width, d = c.height, f = c.x, p = c.y, m = n(o.borderRadiusTopLeft || 0, l), v = n(o.borderRadiusTopRight || 0, l), g = n(o.borderRadiusBottomRight || 0, l), b = n(o.borderRadiusBottomLeft || 0, l);
        if (m || v || g || b) {
          var x = Math.min(l, d) / 2;
          m > x && (m = x), v > x && (v = x), g > x && (g = x), b > x && (b = x), s.dlBox = s.shapeArgs, s.shapeType = "path", s.shapeArgs = {
            d: [
              ["M", f + m, p + i],
              // top side
              ["L", f + l - v, p + i],
              // top right corner
              ["C", f + l - v / 2, p, f + l, p + v / 2, f + l, p + v],
              // right side
              ["L", f + l, p + d - g],
              // bottom right corner
              ["C", f + l, p + d - g / 2, f + l - g / 2, p + d, f + l - g, p + d + a],
              // bottom side
              ["L", f + b, p + d + a],
              // bottom left corner
              ["C", f + b / 2, p + d, f, p + d - b / 2, f, p + d - b],
              // left side
              ["L", f, p + m],
              // top left corner
              ["C", f, p + m / 2, f + m / 2, p, f + m, p],
              ["Z"]
            ]
          };
        }
      });
    });
  });
})(sL);
var bCe = sL.exports;
const yCe = /* @__PURE__ */ ya(bCe), _Ce = () => {
  (function(e) {
    e.seriesTypes.line.prototype.drawLegendSymbol = e.seriesTypes.area.prototype.drawLegendSymbol, Fa.wrap(
      Fa.Series.types.treemap.prototype,
      "pointAttribs",
      function(t, ...n) {
        var i;
        const r = t.call(this, ...n), o = n[0];
        return (i = o.options.custom) != null && i.blur && (r.fill = Fa.color(o.color).setOpacity(0.2).get("rgba"), r.stroke = Fa.color(r.stroke).setOpacity(0.2).get("rgba")), r;
      }
    );
  })(Fa), function(e) {
    e.Point.prototype.importEvents = function() {
      const t = this;
      this.importedEvents && this.importedEvents.forEach(function(o) {
        o();
      }), this.importedEvents = [];
      const n = e.merge(t.series.options.point, t.options), r = n.events;
      t.events = r, e.objectEach(r, function(o, i) {
        e.isFunction(o) && t.importedEvents.push(e.addEvent(t, i, o));
      });
    };
  }(Fa), yCe(Fa);
};
_Ce();
const wCe = T$(
  function({ options: t }) {
    var d, f, p, m, v, g;
    const n = aL(t), r = bt(
      (b) => {
        var T, S, _, w, k, E, R, P;
        const x = t;
        !((w = (_ = (S = (T = x == null ? void 0 : x.plotOptions) == null ? void 0 : T.series) == null ? void 0 : S.point) == null ? void 0 : _.events) != null && w.click) && !((P = (R = (E = (k = x == null ? void 0 : x.plotOptions) == null ? void 0 : k.series) == null ? void 0 : E.point) == null ? void 0 : R.events) != null && P.contextmenu) && (b.container.onclick = null);
      },
      [t]
    ), o = (b) => b == null ? void 0 : b.some(({ data: x }) => x.some((T) => !!T.marker)), i = (n == null ? void 0 : n.xAxis) && (t == null ? void 0 : t.xAxis) && ((d = n == null ? void 0 : n.xAxis[0]) == null ? void 0 : d.type) !== ((f = t == null ? void 0 : t.xAxis[0]) == null ? void 0 : f.type), a = !!n && ((p = n == null ? void 0 : n.navigator) == null ? void 0 : p.enabled) !== ((m = t == null ? void 0 : t.navigator) == null ? void 0 : m.enabled), s = o(n == null ? void 0 : n.series) && !o(t == null ? void 0 : t.series), c = !!n && ((v = n == null ? void 0 : n.chart) == null ? void 0 : v.type) !== ((g = t == null ? void 0 : t.chart) == null ? void 0 : g.type), l = i || a || c || s;
    return /* @__PURE__ */ z(
      vCe,
      {
        highcharts: Fa,
        options: Li(t),
        containerProps: {
          style: {
            // Container should inherit parent size for correct chart size calculation by Highcharts
            height: "100%",
            width: "100%"
          }
        },
        immutable: l,
        callback: r
      }
    );
  },
  // A memoization props comparator that performs a deep object comparison instead of using
  // the default comparator based on `Object.is`, which cannot compare different objects
  (e, t) => mCe(e, t, (n, r) => Sd(n) && Sd(r) ? n.toString() === r.toString() : void 0)
), xCe = (e) => e, CCe = ({
  chartType: e,
  chartData: t,
  dataOptions: n,
  designOptions: r,
  onDataPointClick: o,
  onDataPointContextMenu: i,
  onDataPointsSelected: a,
  onBeforeRender: s = xCe
}) => {
  const { app: c } = Gn(), { t: l } = Bi(), d = [], f = bt(
    (v, g) => Bw(v, g, c == null ? void 0 : c.settings.locale, c == null ? void 0 : c.settings.dateConfig),
    []
  ), { themeSettings: p } = Yn(), m = We(() => {
    var _;
    const { options: v, alerts: g } = Q$(
      t,
      e,
      r,
      n,
      l,
      p,
      f
    );
    d.push(...g);
    const b = ((_ = c == null ? void 0 : c.settings.accessibilityConfig) == null ? void 0 : _.enabled) || !1, x = uCe(
      v,
      p,
      b
    ), T = iCe(
      x,
      n,
      {
        onDataPointClick: o,
        onDataPointContextMenu: i,
        onDataPointsSelected: a
      }
    ), S = sCe(
      T,
      p
    );
    return s(
      S
    );
  }, [
    e,
    t,
    n,
    r,
    p,
    o,
    i,
    s,
    l
  ]);
  return m && /* @__PURE__ */ _e(
    "div",
    {
      "aria-label": "chart-root",
      style: {
        display: "flex",
        justifyContent: "center",
        height: "100%",
        width: "100%"
      },
      children: [
        !!d.length && /* @__PURE__ */ z(hCe, { alerts: d }),
        /* @__PURE__ */ z(wCe, { options: m })
      ]
    }
  );
}, SCe = [
  ...hO,
  ...mO,
  ...gO,
  ...vO,
  ...bO
], lL = (e) => SCe.includes(e), TCe = (e) => !!e.chartType && lL(e.chartType) && !!e.chartData, ECe = "_wrapper_g0ngm_1", kCe = "_title_g0ngm_7", MCe = "_image_g0ngm_18", mb = {
  wrapper: ECe,
  title: kCe,
  image: MCe
}, RCe = "data:image/svg+xml,%3c?xml%20version='1.0'%20encoding='utf-8'?%3e%3c!--%20Generator:%20Adobe%20Illustrator%2017.1.0,%20SVG%20Export%20Plug-In%20.%20SVG%20Version:%206.00%20Build%200)%20--%3e%3c!DOCTYPE%20svg%20PUBLIC%20'-//W3C//DTD%20SVG%201.1//EN'%20'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3e%3csvg%20version='1.1'%20xmlns='http://www.w3.org/2000/svg'%20xmlns:xlink='http://www.w3.org/1999/xlink'%20x='0px'%20y='0px'%20viewBox='0%200%20566%20700'%20enable-background='new%200%200%20566%20700'%20xml:space='preserve'%3e%3cg%20id='Layer_1'%3e%3crect%20x='50.5'%20y='558.5'%20fill='%23E4E4E4'%20width='466'%20height='2'/%3e%3cg%3e%3cpath%20fill='%23E4E4E4'%20d='M487.5,531.5h-410v-68.9l0.3-0.3l144-155.7l104.2,88.1l161.6-179.5V531.5z%20M79.5,529.5h406V220.4%20L326.1,397.5l-104.2-88.2l-142.4,154V529.5z'/%3e%3c/g%3e%3c/g%3e%3cg%20id='specctr'%3e%3cg%20id='Dimensions'%3e%3c/g%3e%3c/g%3e%3c/svg%3e", PCe = "data:image/svg+xml,%3c?xml%20version='1.0'%20encoding='utf-8'?%3e%3c!--%20Generator:%20Adobe%20Illustrator%2017.1.0,%20SVG%20Export%20Plug-In%20.%20SVG%20Version:%206.00%20Build%200)%20--%3e%3c!DOCTYPE%20svg%20PUBLIC%20'-//W3C//DTD%20SVG%201.1//EN'%20'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3e%3csvg%20version='1.1'%20xmlns='http://www.w3.org/2000/svg'%20xmlns:xlink='http://www.w3.org/1999/xlink'%20x='0px'%20y='0px'%20viewBox='0%200%20566%20700'%20enable-background='new%200%200%20566%20700'%20xml:space='preserve'%3e%3cg%20id='Layer_1'%3e%3crect%20x='25.5'%20y='558.5'%20fill='%23E4E4E4'%20width='516'%20height='2'/%3e%3cpath%20fill='%23E4E4E4'%20d='M518.9,188.1c-18.1,0-32.8,14.7-32.8,32.8c0,10,4.5,19,11.7,25.1l-129,162.8c-5.5-4.1-12.2-6.5-19.6-6.5%20c-10.4,0-19.7,4.9-25.7,12.5l-96.4-71.5c3.7-5.3,5.9-11.8,5.9-18.7c0-18.1-14.7-32.8-32.8-32.8c-18.1,0-32.8,14.7-32.8,32.8%20c0,9.2,3.8,17.5,9.9,23.5L69.5,465.4c-5.8-5-13.2-8-21.4-8c-18.1,0-32.8,14.7-32.8,32.8S30,523,48.1,523s32.8-14.7,32.8-32.8%20c0-9.2-3.8-17.5-9.9-23.5l107.8-117.4c5.8,5,13.2,8,21.4,8c10.4,0,19.7-4.9,25.7-12.5l96.4,71.5c-3.7,5.3-5.9,11.8-5.9,18.7%20c0,18.1,14.7,32.8,32.8,32.8s32.8-14.7,32.8-32.8c0-10-4.5-19-11.7-25.1l129-162.8c5.5,4.1,12.2,6.5,19.6,6.5%20c18.1,0,32.8-14.7,32.8-32.8S537,188.1,518.9,188.1z%20M48.1,521c-17,0-30.8-13.8-30.8-30.8s13.8-30.8,30.8-30.8%20c7.7,0,14.7,2.8,20.1,7.5c0.5,0.4,1,0.9,1.5,1.4c5.7,5.6,9.3,13.4,9.3,22C78.9,507.2,65,521,48.1,521z%20M200.2,355.4%20c-7.7,0-14.7-2.8-20.1-7.5c-0.5-0.4-1-0.9-1.5-1.4c-5.7-5.6-9.3-13.4-9.3-22c0-17,13.8-30.8,30.8-30.8c17,0,30.8,13.8,30.8,30.8%20c0,6.5-2,12.5-5.5,17.5c-0.4,0.5-0.8,1.1-1.2,1.6C218.7,350.8,210,355.4,200.2,355.4z%20M349.3,465.9c-17,0-30.8-13.8-30.8-30.8%20c0-6.5,2-12.5,5.5-17.5c0.4-0.5,0.8-1.1,1.2-1.6c5.6-7.1,14.4-11.7,24.1-11.7c6.9,0,13.2,2.3,18.3,6.1c0.5,0.4,1.1,0.8,1.6,1.2%20c6.7,5.7,10.9,14.1,10.9,23.5C380.1,452,366.3,465.9,349.3,465.9z%20M518.9,251.7c-6.9,0-13.2-2.3-18.3-6.1c-0.5-0.4-1.1-0.8-1.6-1.2%20c-6.7-5.7-10.9-14.1-10.9-23.5c0-17,13.8-30.8,30.8-30.8s30.8,13.8,30.8,30.8S535.9,251.7,518.9,251.7z'/%3e%3c/g%3e%3cg%20id='specctr'%3e%3cg%20id='Dimensions'%3e%3c/g%3e%3c/g%3e%3c/svg%3e", OCe = "data:image/svg+xml,%3c?xml%20version='1.0'%20encoding='utf-8'?%3e%3c!--%20Generator:%20Adobe%20Illustrator%2017.1.0,%20SVG%20Export%20Plug-In%20.%20SVG%20Version:%206.00%20Build%200)%20--%3e%3c!DOCTYPE%20svg%20PUBLIC%20'-//W3C//DTD%20SVG%201.1//EN'%20'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3e%3csvg%20version='1.1'%20xmlns='http://www.w3.org/2000/svg'%20xmlns:xlink='http://www.w3.org/1999/xlink'%20x='0px'%20y='0px'%20viewBox='0%200%20566%20700'%20enable-background='new%200%200%20566%20700'%20xml:space='preserve'%3e%3cg%20id='Layer_1'%3e%3crect%20x='64.5'%20y='201.5'%20fill='%23E4E4E4'%20width='2'%20height='381'/%3e%3cg%3e%3cpath%20fill='%23E4E4E4'%20d='M447.5,560.5h-357v-60h357V560.5z%20M92.5,558.5h353v-56h-353V558.5z'/%3e%3c/g%3e%3cg%3e%3cpath%20fill='%23E4E4E4'%20d='M292.5,468.5h-202v-60h202V468.5z%20M92.5,466.5h198v-56h-198V466.5z'/%3e%3c/g%3e%3cg%3e%3cpath%20fill='%23E4E4E4'%20d='M526.5,377.5h-436v-60h436V377.5z%20M92.5,375.5h432v-56h-432V375.5z'/%3e%3c/g%3e%3cg%3e%3cpath%20fill='%23E4E4E4'%20d='M368.5,285.5h-278v-59h278V285.5z%20M92.5,283.5h274v-55h-274V283.5z'/%3e%3c/g%3e%3c/g%3e%3cg%20id='specctr'%3e%3cg%20id='Dimensions'%3e%3c/g%3e%3c/g%3e%3c/svg%3e", NCe = "data:image/svg+xml,%3c?xml%20version='1.0'%20encoding='utf-8'?%3e%3c!--%20Generator:%20Adobe%20Illustrator%2017.1.0,%20SVG%20Export%20Plug-In%20.%20SVG%20Version:%206.00%20Build%200)%20--%3e%3c!DOCTYPE%20svg%20PUBLIC%20'-//W3C//DTD%20SVG%201.1//EN'%20'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3e%3csvg%20version='1.1'%20xmlns='http://www.w3.org/2000/svg'%20xmlns:xlink='http://www.w3.org/1999/xlink'%20x='0px'%20y='0px'%20viewBox='0%200%20566%20700'%20enable-background='new%200%200%20566%20700'%20xml:space='preserve'%3e%3cg%20id='Layer_1'%3e%3crect%20x='78'%20y='558.5'%20fill='%23E4E4E4'%20width='410'%20height='2'/%3e%3cg%3e%3cg%3e%3cpath%20fill='%23E4E4E4'%20d='M463,533.5h-61v-207h61V533.5z%20M404,531.5h57v-203h-57V531.5z'/%3e%3c/g%3e%3cg%3e%3cpath%20fill='%23E4E4E4'%20d='M363,533.5h-61v-152h61V533.5z%20M304,531.5h57v-148h-57V531.5z'/%3e%3c/g%3e%3cg%3e%3cpath%20fill='%23E4E4E4'%20d='M263,533.5h-61v-316h61V533.5z%20M204,531.5h57v-312h-57V531.5z'/%3e%3c/g%3e%3cg%3e%3cpath%20fill='%23E4E4E4'%20d='M163,533.5h-62v-248h62V533.5z%20M103,531.5h58v-244h-58V531.5z'/%3e%3c/g%3e%3c/g%3e%3c/g%3e%3cg%20id='specctr'%3e%3cg%20id='Dimensions'%3e%3c/g%3e%3c/g%3e%3c/svg%3e", ACe = "data:image/svg+xml,%3c?xml%20version='1.0'%20encoding='utf-8'?%3e%3c!--%20Generator:%20Adobe%20Illustrator%2017.1.0,%20SVG%20Export%20Plug-In%20.%20SVG%20Version:%206.00%20Build%200)%20--%3e%3c!DOCTYPE%20svg%20PUBLIC%20'-//W3C//DTD%20SVG%201.1//EN'%20'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3e%3csvg%20version='1.1'%20xmlns='http://www.w3.org/2000/svg'%20xmlns:xlink='http://www.w3.org/1999/xlink'%20x='0px'%20y='0px'%20viewBox='0%200%20566%20700'%20enable-background='new%200%200%20566%20700'%20xml:space='preserve'%3e%3cg%20id='Layer_1'%3e%3cg%3e%3cpath%20fill='%23E4E4E4'%20d='M298.5,607.2c-12.6,0-25.3-1.1-37.6-3.2l-1-0.2l29.6-198l-27.1,61l-20.3-12.1l45.2-52.6L126.8,524.6%20l-0.6-0.8c-12.1-15.5-21.8-32.7-29-50.9l-0.4-0.9l0.9-0.4l181.4-70.1l-149.6,20.9v-47.1l158.4,22.1L97.5,323.8l0.4-0.9%20c7.3-18,17.1-34.9,29.3-50.4l0.6-0.8L282,389.2l-76.9-89.5l34.5-20.2l49.9,112.2l-29.6-198l1-0.2c12.4-2.1,25-3.2,37.6-3.2%20c8,0,16.1,0.4,23.9,1.3l1,0.1l-0.2,1l-29.7,198.8l83.2-187.1l0.9,0.3c19.5,7.5,37.7,17.7,54.3,30.3l0.8,0.6L301.2,389.2l132.5-101%20l28,44.9l-166,64.2L511.5,367l0.1,1c1.6,10.2,2.4,20.6,2.4,30.8c0,10.2-0.8,20.6-2.4,30.8l-0.1,1l-207.1-29l95.5,36.9l-18.5,28.9%20l-85.5-65.1l108.5,126.3l-45.5,23.8l-65.1-146.5l29.9,199.9l-1,0.1C314.4,606.8,306.4,607.2,298.5,607.2z%20M262.2,602.2%20c12,2,24.2,3,36.3,3c7.4,0,15.1-0.4,22.7-1.2l-29.7-198.5L262.2,602.2z%20M295.3,404.7l64.5,144.9l41.4-21.7L295.3,404.7l0.1,0.1%20L295.3,404.7z%20M99.4,473.1c7,17.4,16.3,33.8,27.8,48.7l158.3-120.6L99.4,473.1z%20M297.8,401.2l83.1,63.3l16-25L297.8,401.2z%20M245.2,454.3l16.3,9.7l26.4-59.4L245.2,454.3z%20M298.8,398.8l211,29.5c1.4-9.8,2.2-19.7,2.2-29.5c0-9.8-0.7-19.7-2.2-29.5%20L298.8,398.8z%20M131.5,377.6V420l152.2-21.2L131.5,377.6z%20M433.2,291.1L297.8,394.2l160.9-62.2L433.2,291.1z%20M100.1,322.6%20l185.2,71.6L128.2,274.5C116.6,289.3,107.2,305.5,100.1,322.6z%20M377.9,207.1L295.3,393l0,0l0,0L430,236.1%20C414,224.1,396.5,214.3,377.9,207.1z%20M287.9,393L287.9,393l-49.2-110.6l-30.5,17.8L287.9,393L287.9,393z%20M262.2,195.3L291.6,392%20l29.6-198.5c-7.5-0.8-15.1-1.2-22.7-1.2C286.4,192.3,274.2,193.4,262.2,195.3z'/%3e%3c/g%3e%3c/g%3e%3cg%20id='specctr'%3e%3cg%20id='Dimensions'%3e%3c/g%3e%3c/g%3e%3c/svg%3e", DCe = "data:image/svg+xml,%3csvg%20width='616'%20height='559'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%3e%3cpath%20fill='none'%20stroke='%23E4E4E4'%20id='svg_1'%20stroke-width='2'%20d='m97.44781,156.99998l419.1042,0l-24.42354,59.30477l-370.25707,0l-24.42359,-59.30477zm29.93028,72.6737l359.24347,0l-24.42354,59.30458l-310.39633,0l-24.42361,-59.30458zm54.35357,131.97891l-24.4232,-59.30521l299.38335,0l-24.42422,59.30521l-250.53593,0zm220.60617,72.6737l-190.67573,0l-24.42491,-59.30458l239.52554,0l-24.42491,59.30458zm-3.92305,72.6737l-182.82963,0l1.26325,-59.30458l180.30313,0l1.26325,59.30458z'/%3e%3c/g%3e%3c/svg%3e", ICe = "data:image/svg+xml,%3c?xml%20version='1.0'%20encoding='utf-8'?%3e%3c!--%20Generator:%20Adobe%20Illustrator%2017.1.0,%20SVG%20Export%20Plug-In%20.%20SVG%20Version:%206.00%20Build%200)%20--%3e%3c!DOCTYPE%20svg%20PUBLIC%20'-//W3C//DTD%20SVG%201.1//EN'%20'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3e%3csvg%20version='1.1'%20xmlns='http://www.w3.org/2000/svg'%20xmlns:xlink='http://www.w3.org/1999/xlink'%20x='0px'%20y='0px'%20viewBox='0%200%20566%20700'%20enable-background='new%200%200%20566%20700'%20xml:space='preserve'%3e%3cg%20id='Layer_1'%3e%3cg%3e%3cg%3e%3cpath%20fill='%23E4E4E4'%20d='M480.4,506.2l-162.3-106L509.4,431l-0.2,1c-4.3,26.5-13.8,51.2-28.4,73.4L480.4,506.2z%20M327,403.7%20l152.7,99.8c13.9-21.5,23.1-45.3,27.3-70.8L327,403.7z'/%3e%3c/g%3e%3cg%3e%3cpath%20fill='%23E4E4E4'%20d='M275.3,586.8C170.9,586.8,86,502,86,397.7c0-50.6,19.6-98.1,55.1-133.8c35.6-35.7,83-55.5,133.5-55.5h1%20v188.7l158.3,103.1l-0.5,0.8C398.1,554.8,339.1,586.8,275.3,586.8z%20M273.5,210.7c-49.6,0.3-96.1,19.7-131.1,54.8%20C107.3,300.7,88,347.7,88,397.7c0,103.2,84,187.1,187.4,187.1c62.7,0,120.9-31.4,155.7-83.9L273.5,398.3V210.7z'/%3e%3c/g%3e%3cg%3e%3cpath%20fill='%23E4E4E4'%20d='M482.8,408.7l-1-0.2l-187.3-30V188.5h1c74.8,0,142.7,44.1,173.1,112.2c15.2,34.1,20.2,71.1,14.4,107%20L482.8,408.7z%20M296.5,376.9l184.6,29.5c5.5-35.2,0.5-71.4-14.4-104.9c-29.9-67.1-96.6-110.5-170.2-110.9V376.9z'/%3e%3c/g%3e%3c/g%3e%3c/g%3e%3cg%20id='specctr'%3e%3cg%20id='Dimensions'%3e%3c/g%3e%3c/g%3e%3c/svg%3e", LCe = "data:image/svg+xml,%3c?xml%20version='1.0'%20encoding='utf-8'?%3e%3c!--%20Generator:%20Adobe%20Illustrator%2017.1.0,%20SVG%20Export%20Plug-In%20.%20SVG%20Version:%206.00%20Build%200)%20--%3e%3c!DOCTYPE%20svg%20PUBLIC%20'-//W3C//DTD%20SVG%201.1//EN'%20'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3e%3csvg%20version='1.1'%20xmlns='http://www.w3.org/2000/svg'%20xmlns:xlink='http://www.w3.org/1999/xlink'%20x='0px'%20y='0px'%20viewBox='0%200%20566%20700'%20enable-background='new%200%200%20566%20700'%20xml:space='preserve'%3e%3cg%20id='Layer_1'%3e%3cpolygon%20fill='%23E4E4E4'%20points='80,575%2080,233%2078,233%2078,575%2078,577%2080,577%20497,577%20497,575%20'/%3e%3cg%3e%3cpath%20fill='%23E4E4E4'%20d='M374.7,480.1c-29.7,0-53.9-24.2-53.9-53.9c0-29.7,24.2-53.9,53.9-53.9s53.9,24.2,53.9,53.9%20C428.6,455.9,404.4,480.1,374.7,480.1z%20M374.7,374.3c-28.6,0-51.9,23.3-51.9,51.9s23.3,51.9,51.9,51.9s51.9-23.3,51.9-51.9%20S403.3,374.3,374.7,374.3z'/%3e%3c/g%3e%3cg%3e%3cpath%20fill='%23E4E4E4'%20d='M264.2,395.2c-22,0-40-17.9-40-40c0-22,17.9-40,40-40s40,17.9,40,40C304.2,377.3,286.2,395.2,264.2,395.2z%20M264.2,317.3c-20.9,0-38,17-38,38c0,20.9,17,38,38,38s38-17,38-38C302.2,334.3,285.1,317.3,264.2,317.3z'/%3e%3c/g%3e%3cg%3e%3cpath%20fill='%23E4E4E4'%20d='M413.7,351.2c-38.8,0-70.3-31.6-70.3-70.3c0-38.8,31.6-70.3,70.3-70.3s70.3,31.5,70.3,70.3%20C484,319.6,452.4,351.2,413.7,351.2z%20M413.7,212.5c-37.7,0-68.3,30.7-68.3,68.3c0,37.7,30.7,68.3,68.3,68.3%20c37.7,0,68.3-30.7,68.3-68.3C482,243.2,451.3,212.5,413.7,212.5z'/%3e%3c/g%3e%3cg%3e%3cpath%20fill='%23E4E4E4'%20d='M228.9,489C228.9,489,228.9,489,228.9,489c-15.8,0-29.7-10.1-34.5-25.2c-3-9.2-2.2-19,2.3-27.7%20c4.4-8.6,11.9-15,21.2-18c3.6-1.2,7.4-1.8,11.1-1.8c15.8,0,29.7,10.1,34.5,25.2c3,9.2,2.2,19.1-2.3,27.7c-4.4,8.6-11.9,15-21.2,18%20C236.4,488.4,232.6,489,228.9,489z%20M228.9,418.4c-3.6,0-7.1,0.6-10.5,1.7c-8.7,2.8-15.8,8.8-20,17c-4.2,8.1-4.9,17.4-2.1,26.1%20c4.6,14.2,17.7,23.8,32.6,23.8c3.6,0,7.1-0.6,10.5-1.7c8.7-2.8,15.8-8.8,20-17c4.2-8.1,4.9-17.4,2.1-26.2%20C256.9,428,243.8,418.4,228.9,418.4z'/%3e%3c/g%3e%3cg%3e%3cpath%20fill='%23E4E4E4'%20d='M147.5,548C147.5,548,147.5,548,147.5,548c-9.4,0-17.6-6-20.4-14.9c-3.6-11.3,2.6-23.4,13.9-27%20c2.1-0.7,4.4-1,6.6-1c9.3,0,17.6,6,20.4,14.9c3.6,11.3-2.6,23.3-13.9,27C152,547.7,149.7,548,147.5,548z%20M147.5,507.1%20c-2,0-4,0.3-6,0.9c-10.2,3.3-15.9,14.2-12.6,24.4c2.6,8.1,10,13.5,18.5,13.5c0,0,0,0,0,0c2,0,4-0.3,6-0.9%20c10.2-3.3,15.8-14.3,12.6-24.5C163.4,512.5,156,507.1,147.5,507.1z'/%3e%3c/g%3e%3c/g%3e%3cg%20id='specctr'%3e%3cg%20id='Dimensions'%3e%3c/g%3e%3c/g%3e%3c/svg%3e", $Ce = "data:image/svg+xml,%3c?xml%20version='1.0'%20encoding='utf-8'?%3e%3c!--%20Generator:%20Adobe%20Illustrator%2017.1.0,%20SVG%20Export%20Plug-In%20.%20SVG%20Version:%206.00%20Build%200)%20--%3e%3c!DOCTYPE%20svg%20PUBLIC%20'-//W3C//DTD%20SVG%201.1//EN'%20'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3e%3csvg%20version='1.1'%20xmlns='http://www.w3.org/2000/svg'%20xmlns:xlink='http://www.w3.org/1999/xlink'%20x='0px'%20y='0px'%20viewBox='0%200%20566%20700'%20enable-background='new%200%200%20566%20700'%20xml:space='preserve'%3e%3cg%20id='Layer_1'%3e%3cg%3e%3cpath%20fill='%23E4E4E4'%20d='M307.6,337.5h-28.6l-3.4,41.7h28.6L307.6,337.5z%20M278.4,376.7l3-36.7h23.5l-3,36.7H278.4z'/%3e%3cpath%20fill='%23E4E4E4'%20d='M262.9,415.9h12l2.4-28.6h23.5l-2.4,28.6h12l2.4-28.6h18.6v-10.5h-17.5l3-36.7h17.7v-10.5h-16.8l2.4-28.6%20h-12l-2.4,28.6h-23.5l2.4-28.6h-12l-2.4,28.6h-18.5V340h17.5l-3,36.7h-17.7v10.5h16.8L262.9,415.9z%20M251.1,384.7v-5.5h17.5%20l3.4-41.7h-17.8V332h18.3l2.4-28.6h7l-2.4,28.6h28.6l2.4-28.6h7l-2.4,28.6h17v5.5h-17.5l-3.4,41.7H329v5.5h-18.4l-2.4,28.6h-7%20l2.4-28.6h-28.6l-2.4,28.6h-7l2.4-28.6H251.1z'/%3e%3cpath%20fill='%23E4E4E4'%20d='M84,269.1v178.8h396.6V269.1H84z%20M478.2,445.4H86.5V271.6h391.6V445.4z'/%3e%3c/g%3e%3c/g%3e%3cg%20id='specctr'%3e%3cg%20id='Dimensions'%3e%3c/g%3e%3c/g%3e%3c/svg%3e", FCe = "data:image/svg+xml,%3c?xml%20version='1.0'%20encoding='utf-8'?%3e%3c!--%20Generator:%20Adobe%20Illustrator%2018.1.1,%20SVG%20Export%20Plug-In%20.%20SVG%20Version:%206.00%20Build%200)%20--%3e%3csvg%20version='1.1'%20xmlns='http://www.w3.org/2000/svg'%20xmlns:xlink='http://www.w3.org/1999/xlink'%20x='0px'%20y='0px'%20viewBox='0%200%20566.5%20700.5'%20enable-background='new%200%200%20566.5%20700.5'%20xml:space='preserve'%3e%3cg%20id='Layer_2'%3e%3crect%20x='-5057'%20y='-6963'%20fill='transparent'%20stroke='%23000000'%20stroke-miterlimit='10'%20width='16156.4'%20height='16115.1'/%3e%3c/g%3e%3cg%20id='Layer_1'%3e%3cpath%20fill='%23E4E4E4'%20d='M399,207h-2H284h-2H170h-2H53v35v4v31v2v31v2v30v2v31v2v30v2v31v2v31v2v34h115h2h112h2h113h2h116v-34v-2%20v-31v-2v-31v-2v-30v-2v-31v-2v-30v-2v-31v-2v-31v-4v-35H399z%20M397,211v31H284v-31H397z%20M282,279v31H170v-31H282z%20M170,277v-31h112%20v31H170z%20M282,312v30H170v-30H282z%20M282,344v31H170v-31H282z%20M282,377v30H170v-30H282z%20M282,409v31H170v-31H282z%20M282,442v31H170%20v-31H282z%20M284,442h113v31H284V442z%20M284,440v-31h113v31H284z%20M284,407v-30h113v30H284z%20M284,375v-31h113v31H284z%20M284,342v-30h113%20v30H284z%20M284,310v-31h113v31H284z%20M284,277v-31h113v31H284z%20M282,211v31H170v-31H282z%20M57,211h111v31H57V211z%20M57,246h111v31H57%20V246z%20M57,279h111v31H57V279z%20M57,312h111v30H57V312z%20M57,344h111v31H57V344z%20M57,377h111v30H57V377z%20M57,409h111v31H57V409z%20M57,442h111v31H57V442z%20M57,505v-30h111v30H57z%20M170,505v-30h112v30H170z%20M284,505v-30h113v30H284z%20M511,505H399v-30h112V505z%20M511,473H399v-31h112V473z%20M511,440H399v-31h112V440z%20M511,407H399v-30h112V407z%20M511,375H399v-31h112V375z%20M511,342H399v-30h112%20V342z%20M511,310H399v-31h112V310z%20M511,277H399v-31h112V277z%20M399,242v-31h112v31H399z'/%3e%3c/g%3e%3cg%20id='specctr'%3e%3cg%20id='Dimensions'%3e%3c/g%3e%3c/g%3e%3c/svg%3e", zCe = "data:image/svg+xml,%3c?xml%20version='1.0'%20encoding='utf-8'?%3e%3c!--%20Generator:%20Adobe%20Illustrator%2017.1.0,%20SVG%20Export%20Plug-In%20.%20SVG%20Version:%206.00%20Build%200)%20--%3e%3c!DOCTYPE%20svg%20PUBLIC%20'-//W3C//DTD%20SVG%201.1//EN'%20'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3e%3csvg%20version='1.1'%20xmlns='http://www.w3.org/2000/svg'%20xmlns:xlink='http://www.w3.org/1999/xlink'%20x='0px'%20y='0px'%20viewBox='0%200%20566%20700'%20enable-background='new%200%200%20566%20700'%20xml:space='preserve'%3e%3cg%20id='Layer_1'%3e%3c/g%3e%3cg%20id='specctr'%3e%3cg%20id='Dimensions'%3e%3cpath%20fill='%23E4E4E4'%20d='M52,202.5v200v2v104h462v-306H52z%20M510,402.5H225v-196h285V402.5z%20M56,206.5h167v196H56V206.5z%20M56,404.5%20h298v100H56V404.5z%20M356,504.5v-100h154v100H356z'/%3e%3c/g%3e%3c/g%3e%3c/svg%3e", IR = "data:image/svg+xml,%3c?xml%20version='1.0'%20encoding='utf-8'?%3e%3c!--%20Generator:%20Adobe%20Illustrator%2017.1.0,%20SVG%20Export%20Plug-In%20.%20SVG%20Version:%206.00%20Build%200)%20--%3e%3c!DOCTYPE%20svg%20PUBLIC%20'-//W3C//DTD%20SVG%201.1//EN'%20'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3e%3csvg%20version='1.1'%20xmlns='http://www.w3.org/2000/svg'%20xmlns:xlink='http://www.w3.org/1999/xlink'%20x='0px'%20y='0px'%20viewBox='0%200%20566%20700'%20enable-background='new%200%200%20566%20700'%20xml:space='preserve'%3e%3cg%20id='Layer_1'%3e%3cg%3e%3cpath%20fill='%23E4E4E4'%20d='M276.8,521.3c-0.5,0-0.9-0.1-1.3-0.2l-0.3-0.1l-0.2-0.2c-0.5-0.6-1-1.3-0.8-1.9c-1-0.6-2.6-0.6-4-0.6%20c-1,0-1.8,0-2.5-0.2l-0.3-0.1l-0.2-0.2c-0.5-0.6-2.8-1.7-4.5-2.5c-1.9-0.9-3.8-1.7-4.8-2.5l-0.2-0.2l-0.1-0.3c-2-5-2.7-6.5-3-7%20c-0.1-0.3-0.2-0.4-0.2-0.6c-0.1-0.6,0-1.1,0.1-1.4c0.1-0.5,0.2-1-1.2-3.5c-0.4-0.6-2.4-2.7-3.6-3.8l-0.2-0.2l-1.1-3%20c-1.8-1.6-3.5-5.2-5.1-8.3c-0.7-1.4-1.3-2.6-1.8-3.5c-1.1-1.6-2-2.4-2.9-3.2c-1.1-1-2.2-2-3.8-4.3c-2.1-0.3-3.7,0-5.3,0.4%20c-2,0.4-3.9,0.8-6-0.3c-0.4,0.5-1.1,1.8-1.6,2.7c-1.6,2.9-3.4,6.3-5.8,5.3c-12.1-4.7-13.8-9.4-14.9-12.4c-0.1-0.3-0.2-0.6-0.3-0.8%20l-0.1-0.2l0-0.2c0.2-2.3,0.1-2.4-0.3-3.1c-0.4-0.7-1-1.7-1.9-4.2c-4.3-2.4-8.1-7.1-10.8-10.5c-1.1-1.3-2-2.5-2.7-3.2%20c-0.1,0-0.2-0.1-0.4-0.1l0,0.2l-0.9-0.1c-2.4-0.3-7.4-0.9-14.7-1.2l-1,4.1l-0.4,0.2c-2.2,1-6.3,1.8-8.9,0.7l0,0l-9.4-1.9%20c-5.6,0.2-10.8-2.5-14.6-4.5l-0.9-0.5c-4.7-2.3-8.4-4.5-11.4-6.3c-1.2-0.7-2.2-1.3-3.2-1.9c-5.5-3.1-9.2-5.2-15.9-8.5l-0.5-0.2%20l-0.1-0.5c-0.1-0.7-0.1-1.2-0.1-1.6c0-0.1,0-0.3,0-0.4l-5.3-0.6c-6-0.7-12.2-1.3-16.2-1.5l-0.1,0.1l-0.7-0.1l0.1-1.1l-0.5-0.7%20c-0.3,0.2-0.4,0.5-0.4,0.6c0.1-1-1.4-8.7-2.7-10.8c-1.4-2.1-3.1-3.5-5.6-4.5l-0.3-0.1l-0.2-0.2c-0.7-0.9-0.8-2.2-0.8-3.1%20c-0.3-0.1-0.6-0.2-1.1-0.3c-1.8-0.6-6.9-4.8-7.6-6.2c-0.8-0.8-2.2-1.9-3.2-1.9c-2.7,0-4.7-0.8-5.8-2.4c-1.7-2.4-0.9-5.9-0.1-8%20c-1.4-2.2-2.9-5.5-4.2-8.4c-1.2-2.7-2.5-5.4-3.2-6.3l-0.2-0.2l0-0.3c-0.2-1.6-0.5-4.7,2.1-6.5c0.1-0.9-0.3-1.2-1.2-1.8%20c-0.9-0.7-2.2-1.6-2.8-3.6c-0.3-0.9-0.1-3.3,0.1-5.1c0,0-0.1,0-0.1,0c-0.2-0.1-0.5-0.4-0.7-0.9l-0.1-0.3l0.1-0.3%20c0.3-0.8,0.4-1.2,0.4-1.4c-0.1-0.1-0.3-0.4-0.4-0.7l-0.1-0.5l0,0c0,0-0.1-0.1-0.1-0.1c-0.6-0.6-1.3-1.2-1.7-2.2l-0.3-0.5l0.4-0.5%20c0.4-0.6,0.3-1.1-0.1-2.5c-0.2-0.6-0.4-1.3-0.5-2c0,0,0,0,0,0c-1.3-0.9-4-2.8-3.1-9.6c0.4-2.6,0.5-4.7,0.6-6.6%20c0.1-0.8,0.1-1.6,0.2-2.5c-0.8-1-2.8-4.1-2.3-7.1c0.3-1.6,1.2-2.9,2.8-3.9c1.5-2.9,3.3-8.8,3.6-12.7c-0.7-1.2-0.5-2.7-0.2-4.7%20c0.1-0.7,0.2-1.5,0.3-2.4c0.4-4.3,2.4-8.3,5.1-10.4c3.3-8.1,7.8-19.4,11.2-28.6l-0.4-0.3l0.3-0.9c-1-0.6-0.9-2-0.9-2.5%20c0.1-1.4,1.1-2.6,1.8-3.4c0,0,0,0,0.1-0.1c-0.6-1.6-0.6-1.9-0.4-3.7c0.2-1,0.9-1.5,1.4-1.7c0-0.9-0.2-2.8-0.3-4.4%20c-0.3-3.2-0.7-7.2-0.5-10.1c0.1-2.1,0.9-3.4,2.2-3.8c3.8-1.2,10.8,7.2,12.9,9.7l0.5,0.6l-0.4,0.6c-1.2,1.7-0.2,6.3,0.8,8.6%20c0.3-1.3,0.9-3.2,2.7-3.7l0.2-3.6l0.1,0c0-0.4-0.1-1.3-0.2-2c-0.4-2.8-0.5-4.3,0-5.1c0-0.3-0.4-1.1-0.6-1.6%20c-0.6-1.1-1.2-2.4-0.8-3.7l0.3-1.1l1,0.4c2.4,1,29.9,7.4,44.2,10.6c2.8,0.3,7.6,1.6,8.4,1.8c0.4,0,1.5,0.2,4.9,0.8%20c7.5,1.3,23.2,4,42.1,6.6c14.2,2,31.3,3.6,47.7,5.1l54.2,1.4c2.1-0.3,4.4-0.4,14.5-0.4v-1c0-2.1,0.8-2.3,2.8-2.8l0.3-0.1%20c1.4-0.2,3.3,2.6,3.6,4c0.1,0.7,0.7,2.1,1.3,2.6c1.1,0.9,1.9,1,2.7,1.1c0.4,0.1,0.8,0.1,1.2,0.2c0.1,0,0.4,0.1,0.7,0.2%20c0.8,0.2,2.8,0.7,3.3,0.6c8.4-1,8.6-0.5,9.1,0c0.1,0.1,0.1,0.4,0.1,0.9v0.2l-0.1,0.3c-0.2,0.2-0.3,0.5-0.4,0.7%20c3.4,0.4,6.8,2.2,8,3c2.4-1.1,4.4-1.3,7.2-1.6c1-0.1,2.2-0.2,3.5-0.4l5.5-0.3c3-1,6.7-2.1,7.8-1.8l0.2,0.1l0.2,0.2%20c0.6,0.5,1.3,2.4,0.5,4.1c-1,2.2-3.8,3.1-8.4,2.6l-0.2,0l-0.2-0.1c-1-0.6-6.7,1.9-8.1,2.9c-0.8,0.6-6.6,6.7-9.9,10.4%20c1.5-0.3,3.2-1,4.7-1.7c1.3-0.6,2.5-1.1,3.4-1.2l0.6-0.1l0.8,1.4c0.2,0.2,0.3,0.4,0.4,0.5c0.2,0.6-0.2,1-0.4,1.2%20c-0.1,0.1-0.1,0.1-0.2,0.2c1,0.2,1.8,0.4,2.4,0.6c0.5-0.1,2.4-0.4,2.6-1.5c0-0.2,0.1-0.5,0.2-0.7l2.1-2.9l-0.2,2.3%20c2.1-0.8,6.4-2.8,8.6-5.2c0.6-1.8,3.7-3.6,4.4-3.9c0.2-0.1,0.4-0.2,0.5-0.3c0.7-0.4,1.8-1,2.7-0.6c0.6,0.2,1,0.7,1.3,1.4l0.1,0.2%20l0,0.2c-0.2,2.4-2.1,2.5-2.8,2.6c-0.1,0-0.2,0-0.2,0c-0.1,0-0.4,0.3-0.7,0.7c0.2,0.7-0.1,1.5-0.5,2.1c2-0.2,4.5,0.4,8.1,3.9%20c0.5-0.1,1.2-0.2,1.9-0.3l0.3,0l0.3,0.2c1.3,0.9,4.8-1.3,6.3-2.2c0.8-0.5,1.2-0.7,1.6-0.8l0.1,0c0.7-0.1,1.4-0.2,2-0.3%20c1.9-0.3,3.4-0.5,4.4-1.1l1.1-0.6l0.4,1.5c0.2,0.8,0.5,1.7,1,1.9c0.6,0.3,1.8,0,3.3-0.7l1.3-0.6l0.1,1.4c0.1,0.5,1.6,2.4,2.4,3.4%20c0.5,0.7,1.1,1.6,1.4,2l1.1,1.8h-1.9c-1.3,0-3.1-0.1-4.7,0c0,0,0-0.1,0-0.1c-0.1,0.1-0.1,0.1-0.3,0.6l11.1,4.2l0.2,0.2%20c0.1,0.1,1.4,1.6,2.3,3.9l0,0.1c0.6,2.6,1.3,7.7,1.3,7.8l0.1,0.9l-0.9,0.2c-0.3,0.1-0.5,0.1-0.6,0.1c0,0,0,0,0,0%20c-0.6,2.3-1.2,3.9-2.8,4.3c-0.5,1.4-0.2,1.9-0.1,2.1c0.2,0.2,0.5,0.3,0.7,0.3l1.6-1.3c0.2-0.9,0.8-2.9,3.5-4.5l0.3-0.2l0.3,0%20c2.8,0.1,4,2.2,4.5,3.1l0.2,0.5c1.2,5.7,3.2,7.3,3.2,7.3l0.4,0.3l0,0.5c-0.1,1.8-0.3,3.9-0.2,4.4c0.2,0.8,0,2.1-0.2,2.6%20c-0.2,0.6-0.4,1-0.7,1.2c0,0.2,0.2,0.3,0.2,0.6v0.7l-0.8,0.3c-0.2,0.1-0.4,0.1-0.5,0.2c0,0,0,0,0,0l0.1,0.5l-0.3,0.4%20c-0.5,0.6-1.1,0.7-1.5,0.9c-0.4,0.1-0.4,0.1-0.5,0.2c-0.1,0.3-0.1,0.4-0.1,0.4c0,0.1,0.2,0.3,0.3,0.5l0.7,0.9l-0.7,0.6%20c-0.6,0.5-2,2.2-2.6,3.7c2.2,0.5,5.9,1.4,7.4,1.7c1.2-1.3,2.6-1.7,3.5-2c0.1,0,0.2-0.1,0.3-0.1l0-0.2l2.8-1.1l1.8-2.1%20c0.1-0.1,2.4-3.3,5.5-4.1l0.3-0.2l2.1-0.7c0.3-0.1,0.8-0.3,1.3-0.4c0.8-0.2,1.7-0.5,2.2-0.8l0.2-0.1l0.2,0c0,0,1-0.2,2.5-0.2%20c0.2-0.3,0.4-0.7,0.7-1.1c1.1-1.6,3.3-4.9,3.6-5.7l0.3-0.8l0.6,0.1c0-0.1,0.1-0.2,0.1-0.3c0.2-0.4,0.4-0.8,0.7-1.4%20c0-0.7-0.3-1.2-0.7-2c-0.4-0.7-0.9-1.4-1.1-2.4c-0.1-0.2-0.3-0.4-0.3-0.5v0c0-0.1,0.2-0.2,0.2-0.2l-0.1-0.1c0-0.3-0.1-0.5-0.1-0.7%20V291l1.6,5.8c0.1-0.1,0.3-0.1,0.5-0.2c1.3-0.5,5-1,9.2-1.5c1.5-0.2,2.8-0.3,3.4-0.4c1.8-0.4,4.6-1.2,5.3-1.7%20c0.8-0.6,1.7-1.8,2.2-2.3c0.1-1.5,0-3.8-0.6-4.4c-0.1-0.1-0.3-0.2-0.6-0.1l-1.1,0.2l-0.1-1.1c-0.1-1.6,0.9-2.8,1.3-3.1%20c5-7.8,9-11.1,9.2-11.2l0.2-0.1l12-3l0-0.4l0.8-0.2c4.5-0.9,8.2-2,11.2-2.8c1-0.3,1.9-0.6,2.7-0.8c0-0.3,0-0.6,0-0.8%20c0.2-1.4,1.6-2.8,3.3-3.3c0.1,0,0.1-0.1,0.2-0.1l1.3-3v-1.5c-0.4-0.5-0.8-1.3-0.5-2c0.2-0.4,0.6-0.9,1.7-0.8%20c0.5-0.6,1-2.9,1.2-10.6c0-0.8,0-1.5,0.1-1.8l0-0.4l0.3-0.3c0.7-0.6,1.2-2.3,1.7-3.7c0.6-2,1.2-3.9,2.6-4.7l0.8-0.4l0.5,0.8%20c0.2,0.4,1.1,1.4,2,1.3c0.9-0.2,1.5-0.7,2.1-1.3c0.8-0.7,1.7-1.5,3-1.5h0.3l0.3,0.2c3.6,2.8,4.2,3.6,4.9,4.9%20c0.2,0.3,0.4,0.7,0.7,1.1l0.1,0.3c0.2,0.6,0.6,2.1,1.1,4c0.8,2.7,1.8,6.3,2.2,7.5c0.2,0.1,0.7,0.1,1.1,0c2-0.2,2.5,1.3,2.8,2.4%20c0.1,0.4,0.3,0.9,0.6,1.4c0.1,0,0.3,0.1,0.4,0.2c0.9,0.6,1.2,2.1,1.5,3.6c0.1,0.5,0.2,1.2,0.3,1.5l0.5,0.4l-0.3,0.7%20c-0.4,0.9-1.5,2.5-2.5,4c-0.2,0.4-0.4,0.6-0.5,0.8c-0.9,2.3-2.9,4-5.4,4.7c-1.3,0.3-2.4,0.3-3.2-0.1c-0.2,1.2-0.4,2.5-0.3,3.2%20l0,0.8l-1.8,0.6c-0.4,2-2.1,4-3.6,4.9c0.1,0.7,0.4,1.6,0.6,2.5c0.6,2.3,1.3,4.7,0.8,6.3l-0.1,0.4l-0.4,0.2%20c-1.8,0.8-3.9,1.4-5.5,1.6c0.3,0.4,0.9,0.8,2,1.4l0.9,0.4l-0.5,0.9c-0.2,0.4,0.1,2.1,0.2,2.9c0.1,0.5,0.1,0.9,0.2,1.2%20c1.7,2.5,3,3.3,3.6,3.1c0.5-0.1,0.9-0.9,0.9-1.3l0.1-0.7l0.7-0.2c2.2-0.5,3.5,1.3,4.2,2.4c0.1,0.2,0.3,0.4,0.4,0.6%20c1.4,0.2,4,0.4,4.9,0.3l1.1-0.2v1.2c0,0.5,0,1.4-4.1,2.5c-1.4,0.3-2.7,0.1-3.8-0.5c-0.6,0.5-1.3,0.7-1.9,0.6%20c-0.5-0.1-0.8-0.3-1.1-0.5c-0.4,0.3-1,0.7-1.5,0.9l-1.7,0.5l0.2-0.8c-0.9-0.1-2.3-0.2-3.8-0.2c0.6,1.1,1.5,2.5,2.1,3.5l0.4,0.6%20l-0.4,0.6c-2.1,2.8-5.7,4.7-5.9,4.8l-0.2,0.1c-3,0.8-14.2,8-19.4,11.4l1.3,0.1l0.2,0.7c0,0.2,1.1,4.6,0,9%20c-1.1,4.2-3.8,8.9-3.9,9.1l-0.9,1.6l-1.5-3l-2-0.4l-2.3-1.3c0.6,1.2,1.3,2.7,1.6,3.3l0.1,0.2c0.4,3.5,1.5,5.4,1.5,5.4l0.2,0.3%20l-0.3,4.6l0.2,0.1l-0.1,0.9c0,0,0,0.2-0.1,0.4l-0.1,1.6h-0.9c-0.1,0.1-0.4,0.4-0.7,0.8c-1.1,1.2-2.5,0.8-3.4,0.4%20c-0.1,0.2-0.3,0.4-0.6,0.5c-0.3,0.1-0.6,0.1-0.8,0.1c0,0,0,0,0,0c-0.6,0.4-1.5,0.2-2.7-0.6c0.2,0.6,0.1,1.2,0,1.7%20c0,0.2-0.1,0.6-0.1,0.7c0.3,0.4,0.4,0.8,0.5,1c0.1,0.2,0.1,0.3,0.4,0.5c0.5,0.4,0.6,0.8,0.6,1.1c0,0.6-0.4,1-0.7,1.2%20c0,0-0.1,0.1-0.1,0.1c0.1,0.1,0.4,0.4,1,0.8c0.4,0.3,1.3,0.9,1.1,1.8c-0.2,0.9-1.1,1-1.9,1.2c-0.2,0-0.5,0.1-0.8,0.2%20c0.2,0.3,0.6,0.8,1.6,1.6c0.9,0.8,1.5,1.9,1.7,2.8h1.1c0.8,0,1.4,0.4,1.7,0.8c2.3-0.2,6.4-0.4,8.7,5.2c1.3,3.1-2.5,8-2.9,8.6%20l-0.1,0.1c-0.7,0.6-1.8,0.5-3,0.5c-0.1,0-0.2,0-0.3,0l0.4,0.3l-0.1,0.6c0,0.2-0.1,0.5-0.2,0.7c-0.1,0.5-0.2,0.8-0.1,1.1%20c0.1,0,0.2,0,0.2,0c0.5-0.1,1.3-0.3,2,0.2c0.5,0.4,0.7,0.9,0.8,1.8c0.2,1-0.8,2.4-1.2,2.9l-0.7,0.9l-0.7-0.7c-0.2,0-1.2,0-4.3,1.7%20c-3.3,1.4-5.3,5.8-6,9.1l-0.1,0.2l-0.2,0.2c-0.6,0.7-1.8,1.5-2,1.5l-0.2,0.1l-0.2,0c-1.7,0.1-2.5,0.5-3.1,0.9%20c-0.3,0.2-0.7,0.4-1.1,0.4c-0.2,0.4-0.6,0.9-1.1,1.5c-0.4,0.5-0.8,1-1.1,1.5c-2.2,5.6-4.7,9.1-4.8,9.3l-0.1,0.2%20c-0.1,0.1-1.3,1.2-2.8,2.1c-0.4,1.3-0.7,2.4-0.7,2.4l-0.2,0.6l-0.6,0.1c-0.8,0.1-1.9,0.5-2.7,0.8c0.6,1.4,0.2,2.4-0.2,2.9%20c-0.7,0.8-1.8,1.2-2.7,1.2c-0.3,0.8-0.7,1.5-1.1,2.1c-1.8,4-3.6,10.4-3.6,15.2c1.1,1.2,1.8,3.4,2.5,5.6c0.3,0.9,0.6,1.9,0.9,2.7%20c1.3,3.1,6.4,11.1,7.5,12.4c0.5,0.1,1.4,0.3,2.2,1.1c1.4,1.3,2.1,3.6,2.1,6.8c0,0.2,0,0.4-0.1,0.6c1.3,2.8,4.1,8.3,7.1,11.1%20l0.2,0.2l0,0.2c1.1,2.9,2.3,11,2.3,13.3v0.5l-0.4,0.3c-1.5,1-1.5,4.8-1.5,6.6c0,1.4,0,1.8-0.5,2.2l-0.4,0.3l-0.5-0.1%20c-0.7-0.2-1.5,0.3-2.3,0.7c-1,0.6-2.4,1.4-3.6,0.1c-0.4-0.4-0.3-0.9-0.3-1.1c0-0.1,0-0.1,0.1-0.2c0-0.1-0.1-0.1-0.1-0.2%20c-0.1-0.1-0.2-0.3-0.2-0.4c-0.1,0-0.4,0.1-0.8,0.5l-1.1,0.8l-0.5-1.3c-1-2.9-4.9-5.2-8.6-7.1l-0.5-0.2l-0.1-0.5%20c-0.2-1.6-1-2.9-2.1-3.5c-1.1-0.6-1.5-1.9-1.7-3c-0.5,0.1-0.9-0.1-1.1-0.2l-0.7-0.2l0-0.5c-2.6-1.4-3.9-4.2-5.2-7.1l-0.1-0.2%20l0-0.3c0.1-0.7,0.4-1.4,0.7-2.2c-0.1,0.1-0.2,0.2-0.3,0.3c-0.4,0.3-1,0.3-1.6,0.1l-0.3-0.1l-0.2-0.2c-0.3-0.3-0.5-0.4-0.6-0.5%20c-0.4-0.3-0.9-0.7-0.7-1.7c0.2-3.5,0.6-6.1,0.6-6.2c0.3-1.7,0.4-4.6-0.5-5.3l-0.1-0.1l-0.1-0.1c-0.7-1.1-1.3-1.8-2.2-2.1%20c-3.3-1-5.5-2.7-6.7-5c-1.3-0.5-2.5-1.8-3.1-2.9c-1.6-0.3-5.1-0.6-6.2,0.8l-0.1,0.1l-0.1,0.1c-1.1,0.7-1.9,1.4-2.6,2%20c-1.6,1.4-2.8,2.4-6.5,2.3c-2.6-0.2-3.3-0.9-4-2c-0.4-0.7-0.9-1.4-3.5-1.9c-1.1-0.2-1.9-0.4-2.4-0.4c0,0.2,0,0.4-0.1,0.6%20c-0.4,0.8-1.3,0.8-1.6,0.9c-2.1,0.2-2.8-0.8-3.2-1.4c-2.9,1-5.4-0.8-7.1-2c0,0-0.1-0.1-0.1-0.1c0,0,0,0-0.1,0.1l-0.2,0.3%20c0,0.1,0,0.1,0,0.2l0,0.4l-0.2,0.3c-1.1,1.3-3.5,1.8-3.7,1.8l-0.8,0.2l-0.3-0.7c-0.2-0.6-0.8-1.7-1.3-2.7c0,0.2-0.1,0.4-0.1,0.6%20c-0.2,1.2-0.3,2.2-1.1,2.6c-0.1,0.1-0.1,0.3-0.2,0.4c-0.1,0.3-0.4,1-1.1,1c-0.4,0-0.7-0.1-0.9-0.3h-0.4c-0.8,0-1-0.6-1.1-1.4%20c-2.4,0.5-7,1.7-10,3.8c0.1,0.1,0.1,0.3,0.1,0.4c0,0.8-0.6,1.2-1.3,1.5c-0.7,0.4-1.4,0.8-1.3,1.2l0,0.3c0,0.1,0,0.2,0,0.2%20c0.3,0.1,0.7,0.4,1.3,0.8l0.1-0.1l0.6,0.2c6,2.4,6.5,3.4,6.6,3.8c0.1,0.2,0.2,0.5,0.2,0.7v0c0,0.5-0.2,1.8-1.4,2.3%20c-1.3,0.6-3.3-0.3-6.3-2.7c-0.2-0.2-0.4-0.2-0.4-0.2c0,0-0.2,0.1-0.3,0.1c-0.3,0.2-1,0.5-1.7,0.2c-0.1,0.7-0.4,1.5-1.2,2.2%20l-0.5,0.4l-0.6-0.3c-3.4-1.6-4.1-1.2-4.1-1.2c0,0.1-0.1,0.3-0.1,0.4c0,0.1,0,0.3,0,0.4l-0.1,0.7l-0.7,0.1%20c-2.3,0.4-4.2,0.3-6.2-1.1l-0.3-0.2l0-0.2c-0.3-0.4-0.8-1-1.3-2.2c-0.3-0.2-0.7-0.3-1.2-0.5c-0.9-0.2-2-0.3-2.6-1.7%20c-0.3-0.1-0.8-0.1-1.2-0.1h-0.3l-0.2-0.3c-0.4-0.2-1.2-0.4-1.5-0.1c-0.2,0.2-0.1,0.5-0.1,0.8l0.2,0.7l-0.6,0.4%20c-2.9,1.9-6.9,0.5-10.8-0.9c-0.9-0.3-1.8-0.6-2.6-0.9c-2,0.7-4.3,1.2-6,1.2l-0.2,0c-0.1,0-0.1,0-0.2-0.1c-1.4,1-5.1,2.4-6.8,3%20c-0.2,0.8-0.6,2-1.8,2.6l-3.8,3.4l-4.1,2.9l-5,2.2c-0.5,0.5-1.1,0.9-1.6,1.3l0.6,0.4l-1.1,0.8c-0.5,0.3-1,0.7-1.7,1.2%20c-1.6,1.1-4,2.7-4.4,3.9l-0.5,1.9l-0.7-1c0.2,0.9-0.5,1.8-0.9,2.5c-0.1,0.2-0.2,0.3-0.3,0.4l-0.3,0.6l-0.7-0.1l-0.3,1.8%20c-0.1,0.5-0.3,2.1-0.3,2.7c0,0.6,0.3,1.8,0.6,3.1c0.6,2.7,1.4,6,1.2,8.2c0.4,0.1,0.7,0.4,0.9,0.6c0.7,0.9,0.2,2.1,0.1,2.4%20l-0.1,0.1c0,0.1-0.1,0.2-0.1,0.3c-0.1,0.3-0.3,0.8-0.9,1.1c-0.4,0.2-0.8,0.1-1.2,0C278.8,521,277.8,521.3,276.8,521.3z%20M274.9,519.6c0.1,0.2,0.3,0.3,0.4,0.3c0.2,0.1,0.4,0,0.5,0l-0.4-0.5L274.9,519.6z%20M275.5,519.3l0.5,0.4l0.2-0.5c0,0,0,0,0,0%20c0-0.1,0-0.2,0-0.3L275.5,519.3z%20M276.3,519.3c0.9,0.1,2.2-0.3,2.6-0.5l0.4-0.2l0.4,0.2c0-0.1,0.1-0.3,0.2-0.4%20c0-0.1,0-0.1,0.1-0.2c-0.1,0-0.2,0-0.3,0l-1.8,0.3l0.7-1.6c0.6-1.6-0.3-5.6-1-8.3c-0.4-1.5-0.7-2.7-0.7-3.5c0-0.3,0-0.7,0.1-1.1%20l-1.4,0.7l2.7-6.3l1,0.1l0,0c0.2-0.3,0.5-0.8,0.6-1c0,0-0.1,0-0.1-0.1l-0.9-0.4l0.4-0.9c0.3-0.7,1.3-1.3,2.2-1.4%20c0.1,0,0.1,0,0.2,0c0.9-1.5,2.9-2.8,4.8-4.1c0.1-0.1,0.3-0.2,0.4-0.3l-0.4-0.7l0.6-0.6c0.2-0.2,0.4-0.3,0.6-0.3%20c0.5-0.3,1.4-0.9,2.3-1.7l0.1-0.1l5.2-2.3l3.8-2.7l4-3.6c0.7-0.3,0.9-1.5,0.9-1.7l0.1-0.6l0.6-0.2c3-1.1,6.5-2.3,7-2.8l0.5,0.8%20h1.2v-1.1c0-0.1-0.3-0.2-0.4-0.2c0.1,0,0.2,0.1,0.3,0.1c1.5,0,3.7-0.5,5.5-1.2l0.3-0.1l0.3,0.1c1,0.3,2,0.7,3,1%20c3.1,1.1,6.3,2.2,8.5,1.3c-0.1-1.2,0.5-1.8,0.9-2.1c1-0.8,2.5-0.7,3.5-0.3c1.1,0.1,2.1,0.6,2.2,0.6l0.4,0.2l0.1,0.4%20c0.2,0.7,0.5,0.8,1.4,1c0.6,0.2,1.4,0.4,2.1,1l0.2,0.2l0.1,0.2c0.6,1.3,1,1.9,1.2,2.1c0,0,0,0,0,0c1.1,0.7,2.1,0.9,3.8,0.7%20c0.1-0.5,0.4-1.1,1-1.4c1.1-0.6,2.7-0.3,5.3,0.8c0.1-0.3,0.1-0.8,0-1.3c-0.1-0.4-0.2-1.2,0.5-1.6c0.7-0.4,1.4,0.2,1.8,0.6%20c0.2,0.2,0.3,0.2,0.3,0.2c0,0,0.1-0.1,0.2-0.1c0.2-0.1,0.6-0.3,1-0.3c-0.2-0.1-0.3-0.3-0.5-0.5c-0.3-0.2-0.5-0.4-0.6-0.5%20c-0.2,0-0.4-0.1-0.6-0.2c-0.7-0.4-0.8-1.2-0.8-1.9c-0.1-0.6-0.1-1.1,0.1-1.5c-0.3,0-0.6,0-0.9-0.1c-0.9-0.3-1.6-1.1-2.2-2.3%20l-0.2-0.4l0.2-0.4c0.3-0.5,0.6-1,0.8-1.4c0-0.1,0.1-0.1,0.1-0.2l-0.1-0.2l0.5-0.6c0.5-0.5,1.1-0.5,2.6,0.1c0.3,0,0.6,0.1,0.9,0.3%20l0.8,0.3l-0.1,0.4c0.1,0.1,0.2,0.2,0.2,0.3c0.2,0.2,0.4,0.5,0.6,0.7c3.7-2.6,9.3-3.9,11.5-4.3l0.6-0.1l0.1,0.5l0.3-0.6%20c-0.3-0.1-0.6-0.1-0.8,0l0.4-0.2l0.5,0.1c0.2,0.1,0.5,0.2,0.7,0.7l0.2,0.5c0.1-0.1,0.2-0.2,0.4-0.3c0.1-0.2,0.2-0.8,0.2-1.3%20c0.2-1.1,0.3-2.4,1.1-3.2l0.7-0.7l0.7,0.7c0.9,0.9,1.9,2.9,2.4,4c0.6-0.2,1-0.4,1.4-0.8c0-0.4,0.1-0.7,0.1-1v-0.3%20c0-0.1,0.1-0.2,0.1-0.3l0-0.1l0-0.1c0-0.2,0-0.4,0-0.5c-0.2-0.6-0.7-1.4-0.9-1.7l1.6-1.2c0.4,0.4,1,1.2,1.3,2.4%20c0.1,0.2,0.1,0.3,0.1,0.5c0.4,0.2,0.8,0.5,1.3,0.8c1.6,1.1,3.5,2.5,5.5,1.7c0.9-0.4,1.7-0.1,2.2,0.9c0.2,0.3,0.3,0.5,0.9,0.5%20c-0.1-0.3-0.1-0.6,0.1-1c0.5-0.7,1.4-0.7,5,0c3.2,0.7,4.1,1.7,4.8,2.8c0.4,0.6,0.6,0.9,2.4,1c2.9,0.2,3.6-0.4,5.1-1.8%20c0.7-0.6,1.5-1.3,2.6-2.1c2.3-2.7,7.9-1.4,8.6-1.3l0.5,0.1l0.2,0.5c0.4,0.9,1.5,2.2,2.5,2.4l0.5,0.1l0.2,0.4%20c0.8,2,2.7,3.4,5.6,4.3l0.1,0c1.2,0.5,2.2,1.4,3.1,2.8c1.9,1.8,1.2,6.2,1,7l0,0c0,0-0.4,2.6-0.6,6c0.1,0.1,0.2,0.2,0.4,0.3%20c0-0.1,0.1-0.2,0.1-0.3c0.1-0.5,0.4-1.3,1.2-1.7c0.8-0.3,1.6,0.1,2.2,0.5c0.3,0.1,0.5,0.3,0.6,0.6c0.4,0.7-0.1,1.6-0.7,2.8%20c-0.3,0.6-0.6,1.3-0.8,1.8c1.2,2.8,2.5,5.1,4.7,6.1l0.4,0.1l0-0.1l1,0l1,0l0,1c0,1,0.3,2.3,0.9,2.7c1.5,0.8,2.6,2.5,3,4.5%20c3.4,1.8,7,4.1,8.6,6.9c0.4-0.2,0.9-0.3,1.4-0.2c0.8,0.2,1.2,0.9,1.5,1.4c0.1,0.2,0.2,0.3,0.3,0.5c0.1,0.1,0.2,0.3,0.3,0.4%20c0.2-0.1,0.4-0.2,0.6-0.3c0.7-0.4,1.6-0.9,2.6-1c0-0.1,0-0.3,0-0.4c0-2.3,0.1-6,2-7.8c-0.1-2.4-1.2-9.2-2.2-11.9%20c-3.4-3.3-6.4-9.6-7.6-12.2l-2.4-5.1l2.4,2.4c-0.2-2-0.9-3-1.4-3.5c-0.6-0.5-1.1-0.6-1.1-0.6l0,0l-0.1,0l-0.1,0%20c-1.7-0.4-8-11.7-8.8-13.6c-0.4-0.9-0.7-1.9-1-2.9c-0.6-1.8-1.3-3.9-2-4.8l-0.5-0.4l0.4-0.5l-0.5,0c-0.1-5.2,1.9-12.1,3.8-16.6%20l0.1-0.2c0.5-0.7,1-1.5,1.1-2.3l0.2-1.3l1.2,0.5c0.2,0.1,1.2,0,1.5-0.4c0.3-0.4-0.2-1.2-0.5-1.5l-0.8-1.1l1.3-0.4%20c0,0,0.2-0.1,0.3-0.1c0.7-0.3,2-0.8,3.2-1.1c0.2-0.5,0.4-1.3,0.6-2.2l0.1-0.4l0.4-0.2c1.2-0.7,2.4-1.7,2.7-2%20c0.4-0.6,2.5-3.9,4.5-8.9l0.1-0.2c0.3-0.5,0.8-1.1,1.2-1.7c0.3-0.4,0.7-0.9,0.9-1.2c-0.2-0.4-0.2-0.8,0.1-1.2%20c0.5-0.6,1.2-0.3,1.6,0c0.1,0,0.1-0.1,0.2-0.1c0.6-0.4,1.7-1,3.7-1.1c0.4-0.2,0.8-0.6,1.1-0.8c0.4-1.9,2.3-8.2,7.1-10.2%20c2.3-1.3,4.2-2,5.4-1.9c0.2-0.4,0.4-0.7,0.4-0.8c0-0.2,0-0.3,0-0.3c-0.1,0-0.2,0-0.3,0.1c-0.5,0.1-1,0.2-1.6,0l-0.3-0.1l-0.2-0.2%20c-0.9-1.2-0.6-2.4-0.4-3.2c0,0,0,0,0-0.1c-0.4-0.5-0.8-1.2-0.7-1.8c0-0.5,0.3-0.9,0.8-1.1l0.3-0.1c0.5-0.1,1.2-0.1,1.9,0%20c0.5,0,1.3,0,1.6,0c1.7-2.2,3.1-5.1,2.5-6.4c-1.8-4.5-4.9-4.2-6.9-4c-0.1,0-0.3,0-0.4,0c-0.3,0.1-0.5,0.1-0.8,0%20c-0.5,0-1-0.2-1.2-0.8l0.1-0.1l-1,0v-2c-1,0-1.1,0.5-1.1,0.8c0-0.3-0.3-1.4-1.1-2.1c-1.9-1.6-2.7-2.7-2.4-3.8%20c0.2-0.9,1-1.2,1.8-1.4c-0.8-0.7-1.3-1.3-1.3-2c0-0.6,0.2-1,0.5-1.3c-0.3-0.4-0.5-0.7-0.6-1c-0.1-0.2-0.1-0.3-0.2-0.5%20c-0.5-0.8-0.4-1.6-0.3-2.2c0-0.2,0.1-0.4,0.1-0.5c-0.6-0.7-0.9-1.3-1.3-1.9l-0.6-1l1.2-0.5c0.6-0.3,1.7-0.7,2.6,0.1%20c0.5,0.4,0.9,0.7,1.2,0.9l0.4-0.3c0.2-0.1,0.4-0.2,0.7-0.1l0-0.1l0.5-0.4c0.6-0.3,1.1-0.1,1.5,0.2c1,0.6,1.4,0.7,1.7,0.4%20c0.5-0.5,0.7-0.8,0.9-0.9l0,0c0.1-0.2,0.2-0.4,0.3-0.7l0.1-1.8l0.2-3c-0.4-0.7-1.3-2.7-1.6-5.8c-0.4-1-2-4-2.5-5.1l-0.7-1.3%20l2.6-0.3l4.2,2.3l2.5,0.5l0.2,0.5c0.9-1.7,2.2-4.5,2.8-6.9c0.7-2.9,0.4-6,0.1-7.3l-2.7-0.2l0.5-2.5l0.3-0.2%20c0.7-0.5,16.6-11,20.9-12.4c0.5-0.3,3-1.7,4.7-3.7c-1.2-1.9-2.6-4.4-2.7-4.5l-0.8-1.5l1.7,0c4.2,0.1,6,0.3,6.8,0.5%20c0.4-0.2,0.9-0.6,1.2-0.9l0.4-0.4c-0.2,0.1-0.4,0.2-0.7,0.3c-1.9,0.5-3.8-1-5.9-4.2l-0.1-0.2l0-0.3c0-0.3-0.1-0.8-0.2-1.3%20c-0.2-1.3-0.4-2.3-0.3-3.1c-1.5-0.8-2.2-1.6-2.5-2.2l-0.2-0.2c-0.2-0.2-0.4-0.6-0.2-1.2c0,0,0,0,0,0c0,0.1-0.1,0.1-0.1,0.1%20c0,0,0-0.2-0.2-0.5c-0.1-0.1-0.9-1.5-0.4-2.3l0.3-0.5l0.6,0.1c0.6,0.1,0.8,0.5,1.4,2c1.1-0.1,3-0.5,4.9-1.3%20c0.1-1.1-0.5-3.1-0.9-4.7c-0.4-1.3-0.7-2.5-0.8-3.5l-0.1-0.9l0.9-0.2c1-0.2,2.9-2.4,3.1-4.1l0-0.7l1.7-0.5%20c0.1-1.6,0.5-3.9,0.7-4.7c0-0.1,0-0.2,0-0.2l0.1-0.6l0.6-0.2l1.6-0.5l-0.3,1.4c0.1,0.1,0.2,0.3,0.5,0.5c0.1,0,1,0.2,2.3-0.3%20c1-0.3,2.7-1.2,3.5-3.2c0-0.2,0.2-0.4,0.7-1.2c0.6-0.9,1.6-2.3,2.1-3.3c-0.2-0.5-0.3-1.1-0.4-1.9c-0.1-0.6-0.3-1.7-0.5-2.1%20l-0.4,0.1l-0.4-0.6c-0.5-0.8-0.8-1.6-1-2.3c-0.4-1.1-0.4-1.1-0.7-1c-0.7,0.1-2.6,0.2-3.1-1c-0.4-1-1.5-4.7-2.4-7.9%20c-0.5-1.7-0.9-3.1-1.1-3.8c-0.3-0.4-0.5-0.8-0.7-1.1c-0.6-1-0.9-1.5-4.1-4.1c-0.4,0.1-0.8,0.4-1.4,0.9c-0.8,0.7-1.7,1.5-3.1,1.8%20c-1.4,0.2-2.5-0.6-3.2-1.3c-0.4,0.7-0.8,1.9-1.1,2.9c-0.5,1.7-1,3.4-2,4.4c0,0.3,0,0.7,0,1.3c-0.1,6.6-0.5,11-2,12.2%20c-0.2,0.1-0.4,0.2-0.6,0.3l0.1,0.1l0,2.6l-3.9,8.7l0.2-3.8c-0.7,0.4-1.1,0.9-1.2,1.3l0.6-0.2l-0.1,0.8l0.4,0.2l-0.4,0.8%20c0,0,0,0,0,0.1c0,0.1,0,0.3,0,0.4c0,0,0,0,0,0.1l-1.1-0.1c-1,0.3-2.2,0.6-3.5,1c-2.8,0.8-6.3,1.9-10.5,2.7c0,0.1,0,0.2,0,0.2l0,0%20c0,0.7-0.2,1-0.9,1.1c-0.5,0-0.8-0.2-0.9-0.5l-11.3,2.8c-0.8,0.7-4.4,4-8.7,10.7l-0.2,0.2c0,0-0.3,0.3-0.6,0.8%20c0.4,0.1,0.7,0.3,1,0.6c1.7,1.6,1.3,5.6,1.2,6.4l0,0.2l-0.1,0.2c-0.1,0.1-1.4,2-2.7,3c-1.3,1-5.4,1.9-6.2,2.1%20c-0.8,0.1-2,0.3-3.6,0.5c-3,0.4-7.5,0.9-8.7,1.4c-0.4,0.2-0.5,0.3-0.5,0.4c0,0,0,0.1,0,0.2c0,0.1,0.1,0.3,0.1,0.4%20c0.1,0.7,0.4,1.3,0.8,1.9c0.5,0.9,1,1.9,0.9,3.3l0,0.3l-0.1,0.2c-0.4,0.5-0.6,1-0.8,1.4c-0.2,0.5-0.6,1.2-1.2,1.4%20c-0.6,1.1-2,3.2-3.5,5.5c0,0,0,0,0,0h0.3l-1.3,1.6c-0.5,0.6-1,0.5-1.3,0.4c-1,0-1.8,0.1-2.1,0.1c-0.7,0.3-1.6,0.6-2.4,0.9%20c-0.5,0.1-0.9,0.3-1.2,0.4l-1.5,0.5v0.1l-0.8,0.2c-2.1,0.4-4.2,2.6-4.8,3.5l-2.2,2.5l-2.5,1c-0.3,0.3-0.8,0.4-1.2,0.6%20c-0.8,0.3-2,0.6-2.9,1.8l-0.3,0.4l-0.6-0.1c-1.3-0.2-7.7-1.7-8.9-2h-1.1l0.1-1.1c0.2-1.9,1.8-4.1,2.9-5.2%20c-0.4-0.6-0.5-1.2-0.1-2.3c0.4-1,1.3-1.2,1.8-1.4c0,0,0,0,0,0c0-0.2,0-0.3,0.1-0.5c0.2-0.4,0.5-0.7,0.9-0.9c-0.2-0.5,0-1,0.4-1.4%20l0.2-0.2l0.3,0c0.2-0.1,0.4-1,0.4-1.5c-0.2-0.5-0.1-1.5,0.1-4.7c-0.8-0.8-2.4-3-3.5-7.9l0-0.1c-0.4-0.8-1-1.9-2.5-2.1%20c-2.2,1.5-2.3,3.1-2.3,3.1l0,0.5l-0.3,0.3l-2.4,2l-0.3,0c-0.2,0-1.8,0.2-2.8-1c-0.8-1-0.8-2.7,0-4.8l0.2-0.8h0.7%20c0.5,0,0.9,0.2,1.7-3.2l0.1-0.4l0.5-0.2c0.2-0.1,0.4-0.1,0.5-0.2c-0.2-1.8-0.7-4.8-1.1-6.6c-0.6-1.5-1.4-2.6-1.7-3.1l-10.5-4%20l-0.3,0.4l-1.2,1.9c0.1,0.5,0.2,1,0.3,1.3l0.3,0.8l-0.8,0.4c-0.7,0.4-1.1,0.9-1.4,1.2c0.1,0.1,0.2,0.2,0.2,0.4%20c0.6,1.2,0.8,3.8-1.4,5.5l-0.2,0.1c-1.4,0.6-2.3,0.3-2.7-0.1c-0.4-0.3-0.6-0.7-0.7-1c-3.1,4.5-2.7,8.2-2.4,10.7%20c0.1,0.5,0.1,0.9,0.1,1.3l0,0.1l0,0.1c-0.1,1.6-0.4,2.2-0.7,2.6c0,0,0,0.1,0,0.1c0.2,0.7,0.7,2,1.3,3.3c0.8,1.9,1.8,4,2.1,5.8%20c0.9,6.1-0.1,9.9-2.7,16.2l-0.3,0.6h-0.7c-0.2,0-5.4,0.3-8.5-0.4l-0.8-0.2v-0.4c-2.2-1.7-3.3-4.9-3.1-9.9h0l-0.2-0.9l0.4-0.2%20c-0.7-2.8-1.3-6-0.8-11.6l0.8-6.6c0,0,0.3-2.3,1.6-7.5c-0.2,0-0.4,0-0.6,0c-0.5,0.7-0.9,1.3-1.2,1.8c-0.5,0.9-1.1,1.9-2.3,1.6%20c-0.7-0.1-1.2-0.4-1.5-1c-0.4-1,0.2-1.9,1-3.2c0.7-1.1,1.6-2.5,1.6-3.7c0,0,0,0,0,0c0,0,0,0,0,0c0-0.1,0-0.1,0-0.2l0.4,0l0.4-0.4%20l-0.3-0.7c0.4-0.3,1.4-2.1,2-3.4c0.6-1.3,1.3-2.6,1.9-3.5l0.4-0.6l0.7,0.1c0.5,0.1,0.6,0.1,0.6,0.1h0c0,0,0.1-0.1,0.1-0.2%20c0.3-0.4,0.8-1,2-1.5l1.7-0.7l-0.2,1.1c1.1-1.6,3.7-2.2,5.3-2.6c0.3-0.1,0.5-0.1,0.7-0.2c0.1-0.1,0.2,0,0.3-0.2%20c0.3-0.4,0.8-0.9,2-0.9c0,0,0,0,0,0c2.8,0,3.9,0.3,5.2,1.2c0.1-0.2,0.2-0.4,0.3-0.6c0.1-0.1,0.1-0.2,0.2-0.3l0.3-0.4l0.5-0.1%20c1.1-0.1,2.3-0.2,3.4-0.2c-0.1-0.1-0.1-0.1-0.2-0.2c-1.2-1.5-1.9-2.5-2.4-3.3c-1.7,0.6-3,0.7-4,0.2c-1.1-0.5-1.6-1.5-1.9-2.4%20c-1.1,0.4-2.4,0.6-3.9,0.8c-0.6,0.1-1.2,0.2-1.9,0.3c-0.2,0.1-0.7,0.4-1.1,0.6c-2.2,1.3-5.7,3.5-8.1,2.3c-0.9,0.1-1.9,0.3-1.9,0.3%20l-0.5,0.1l-0.4-0.4c-4.5-4.6-6.5-4-8.8-3.2l-1.1,0.3l-0.3-1c-0.3-1.1-0.5-1.9,0-2.5c0.2-0.2,0.4-0.3,0.6-0.4l0.9-1.4%20c0.5-0.9,1-1.4,1.4-1.8c-1.3,0.7-2.7,2-2.8,2.5l-0.1,0.3l-0.2,0.2c-2,2.2-7.7,5.6-10.6,6.2c-0.8,2.2-3.9,2.7-4.6,2.7h-0.2%20l-0.2-0.1c-0.8-0.3-1.7-0.5-3.1-0.8l-0.5-0.1l-0.2-0.5c-0.4-1-0.2-1.8,0.1-2.2c-0.6,0.2-1.4,0.5-2.2,0.9c-2.2,1-4.9,2.2-7.3,1.9%20l-0.5,0.5l-1.5-1.3c0.8-1.1,11.6-12.7,12.7-13.3c0,0,7.2-4.4,10.1-3c3.3,0.3,5.4-0.1,6.1-1.3c0.4-0.6,0.3-1.3,0.1-1.7%20c-1.1,0.2-4,1-6.5,1.8l-0.3,0.1l-5.5,0.3c-1.2,0.2-2.4,0.3-3.4,0.4c-2.8,0.3-4.7,0.5-7,1.6l-0.5,0.2l-0.5-0.3c0,0-4.6-3-8.4-3%20c-0.5,0-0.9-0.2-1.1-0.7c-0.1-0.2-0.4-0.7,0.3-1.9c-1,0-2.9,0.1-6.4,0.6c-0.8,0.2-2.2-0.2-4.1-0.6c-0.3-0.1-0.5-0.1-0.7-0.2%20c-0.3-0.1-0.6-0.1-0.9-0.2c-0.9-0.1-2.2-0.3-3.7-1.6c-1.1-1-1.8-2.9-1.9-3.7c-0.2-0.8-1.1-2-1.6-2.3c-0.5,0.1-1,0.2-1.2,0.3%20c0,0.1,0,0.2,0,0.5v2.8h-1c-10.9,0-13.2,0.1-15.2,0.5l-0.1,0.1l-0.1,0l-54.3-1.4c-16.4-1.5-33.6-3.1-47.8-5.1%20c-19-2.7-34.7-5.3-42.2-6.6c-2.5-0.4-4.5-0.8-4.8-0.8l-0.2,0c-0.1,0-5.4-1.6-8.2-1.8l0.1-0.6l-0.1,0.6c-1.6-0.4-35.1-8-43.1-10.3%20c0.1,0.4,0.3,0.8,0.5,1.2c0.5,1.1,1.1,2.2,0.7,3.2l-0.1,0.3c-0.1,0.6,0.1,2.6,0.3,3.8c0.2,1.7,0.3,2.5,0.1,3.1l-0.2,4.6l-0.9,0.1%20c-1.1,0.1-1.4,0.9-1.8,2.7c-0.1,0.7-0.3,1.3-0.6,1.8c-0.2,0.4-0.6,0.6-1,0.6c-0.8,0-1.3-0.8-1.8-1.7c-1.2-2.4-2.7-7.6-1.3-10.6%20c-3.7-4.6-8.6-9.1-10.3-8.6c-0.4,0.1-0.7,0.9-0.8,2c-0.2,2.7,0.2,6.6,0.5,9.7c0.5,4.7,0.5,5.7-0.2,6.2c-0.2,0.1-0.4,0.2-0.5,0.2%20c-0.1,0.1-0.2,0.2-0.2,0.2c-0.2,1.6-0.2,1.6,0.4,3.1l0,0.1c0.2,0.6-0.2,1-0.7,1.5c-0.5,0.5-1.3,1.4-1.3,2.1c0,0.2,0,0.3,0,0.4%20L61,246l-0.9,3.3l0.5,0.4l-0.2,0.7c-3.4,9.5-8.2,21.3-11.6,29.6l-0.1,0.3l-0.2,0.2c-2.4,1.7-4.2,5.3-4.5,9.1%20c-0.1,0.9-0.2,1.7-0.3,2.4c-0.2,1.7-0.4,2.9,0,3.5l-1,0.6l1.3,0.1c-0.2,4.3-2.2,11-4,14.2l-0.1,0.2l-0.2,0.1%20c-1.2,0.7-1.9,1.6-2.1,2.7c-0.5,2.7,2.1,5.8,2.1,5.8l0.3,0.3l0,0.4c-0.1,1-0.1,1.9-0.2,2.8c-0.1,2-0.3,4.1-0.7,6.8%20c-0.7,5.6,1.2,7,2.3,7.7c0.1,0.1,0.3,0.2,0.4,0.3l0.3,0.2l0.1,0.4c0.1,0.8,0.4,1.6,0.5,2.2c0.4,1.3,0.8,2.5,0.2,3.7%20c0.3,0.4,0.7,0.7,1,1.1c0.4,0.4,0.8,0.7,1.1,1.2l0.2,0.2l0.1,0.8l-0.2,0.2c0,0.3,0,0.6-0.1,1.1l1.2-0.2l-0.6,1.6%20c-0.4,1.2-0.7,4.7-0.4,5.4c0.4,1.4,1.1,2,2,2.5c1.1,0.8,2.5,1.7,1.9,4.2l-0.1,0.5l-0.4,0.2c-1.6,0.8-1.8,2.3-1.6,4.5%20c0.9,1.2,2.1,3.7,3.3,6.5c1.4,3,2.9,6.5,4.4,8.5l0.3,0.4l-0.2,0.5c-1.1,2.8-1.3,5.3-0.3,6.6c0.7,1,2.1,1.5,4.1,1.5%20c2.3,0,4.7,2.6,4.9,2.9l1.6,1.8c1.5,1.4,3.8,3.3,4.9,3.6c0.2,0.1,0.3,0.1,0.4,0.1c0.4-0.2,0.9-0.1,1.3-0.1l1,0.2l-0.2,1%20c-0.1,0.7-0.1,2,0.2,2.7c2.7,1.1,4.7,2.7,6.2,5.1c1.1,1.7,2.8,8.1,3,11.1c4.1,0.2,10.1,0.8,16,1.5l6.9,0.8l0.1,0.8%20c0.1,0.6,0.1,1,0.1,1.5c0,0.3,0,0.5,0,0.9c6.5,3.2,10.1,5.3,15.5,8.4c1,0.5,2,1.2,3.2,1.9c2.9,1.8,6.6,4,11.2,6.2l0.9,0.5%20c3.9,2,8.7,4.5,13.8,4.2l0.1,0l9.9,2.1c1.6,0.8,4.8,0.4,7-0.5l1.1-4.7l0.8,0c6.7,0.2,11.6,0.7,14.7,1.1l0-0.2l1,0.2%20c0.7,0,1.3,0.1,1.9,0.3l0.2,0.1l0.2,0.2c0.8,0.8,1.9,2.1,3.1,3.6c2.7,3.4,6.5,8,10.5,10.2l0.4,0.2l0.1,0.4%20c0.8,2.6,1.4,3.6,1.8,4.2c0.7,1.1,0.8,1.6,0.6,4.1c0.1,0.2,0.2,0.4,0.2,0.7c1,2.9,2.5,6.9,13.7,11.3c0.8,0.3,2.6-3,3.4-4.4%20c1.2-2.3,2-3.8,3.2-3.9l0.4,0l0.3,0.2c1.7,1.1,3.1,0.8,5.1,0.4c1.7-0.4,3.8-0.8,6.4-0.3l0.4,0.1l0.2,0.4c1.6,2.4,2.6,3.3,3.7,4.4%20c0.9,0.9,1.9,1.8,3.2,3.6c0.6,1,1.2,2.3,1.9,3.7c1.4,2.9,3.2,6.6,4.8,7.9l0.2,0.2l1.1,3c0.8,0.8,3.2,3.1,3.7,4.1%20c1.7,2.9,1.7,3.8,1.5,4.9c0,0.2-0.1,0.4-0.1,0.7c0,0,0,0.1,0.1,0.1c0.3,0.6,1,2,3,6.9c1,0.7,2.6,1.4,4.2,2.2%20c2.5,1.2,4.2,2,5.1,2.8c0.4,0.1,1,0,1.6,0c2.1,0,5-0.1,6.4,2.2c0,0.1,0.1,0.1,0.1,0.1l-0.5,0.3C276.2,519,276.3,519.2,276.3,519.3%20z%20M358.2,474.6c0.2,0.1,0.5,0.3,0.8,0.5c3.2,2.7,4.1,2.5,4.1,2.5c0-0.1,0-0.5,0-0.6c0,0,0-0.1,0-0.1c-0.7-0.5-2.8-1.5-4.7-2.3%20C358.4,474.6,358.3,474.6,358.2,474.6z%20M353.7,467.1c0.3,0.5,0.6,0.8,0.8,0.8c0.1,0,0.1,0,0.1,0l0.2-0.1l0.2,0%20c0.2,0,0.5-0.1,0.8-0.2c0.1-0.1,0.3-0.1,0.5-0.2c-0.1-0.2-0.3-0.3-0.4-0.5c-0.1-0.2-0.3-0.4-0.4-0.5c-0.4-0.2-0.8-0.3-1-0.3%20c-0.1,0.1-0.1,0.2-0.2,0.3C354,466.6,353.9,466.9,353.7,467.1z%20M365.3,327.2c2.3,0.4,5.4,0.3,6.7,0.3c2.3-5.7,3.1-9.1,2.3-14.5%20c-0.3-1.5-1.2-3.5-2-5.3c-0.7-1.5-1.2-2.8-1.5-3.7c-0.1-0.8,0-1.2,0.3-1.7c0.1-0.1,0.2-0.3,0.3-1.5c0-0.3-0.1-0.7-0.1-1.1%20c-0.3-2.7-0.8-7.1,3-12.4l0.2-0.2l3.3-2.5l-0.3,2.4c-0.1,0.5,0,1.2,0.2,1.3c0,0,0.2,0.1,0.6-0.1c0.7-0.6,0.9-1.3,1-1.7%20c0-0.4,0-0.7-0.1-1l-1.3,0.4l0.5-1.8c0-0.1,0.4-1.5,2-2.7c-0.1-0.6-0.2-1.1-0.3-1.2l-0.1-0.4l2-3.2l-0.1-0.1%20c-1.3-1-1.9-1.4-4.4-1.4c-0.3,0-0.3,0-0.5,0.3c-0.2,0.2-0.4,0.6-0.9,0.9l-0.2,0.1c-0.3,0.1-0.6,0.2-1.1,0.3%20c-1.2,0.3-3.6,0.8-4.2,1.8c0.1,1.4-0.8,2.6-1.9,3.2c-0.3,0.2-0.6,0.3-0.9,0.3l-0.1,0.2l-0.9-0.3l-0.9-0.4l0.4-0.9%20c0,0,0-0.1,0.1-0.1c-0.3,0.2-0.7,0.2-1.3,0.2c-0.5,0.8-1,1.8-1.5,2.8c-0.9,1.8-1.6,3.2-2.3,3.9c0,0.9-0.3,1.7-0.6,2.5l0.3-0.1%20c0.2,0,1.8-0.3,3,0.5l0.6,0.4l-0.2,0.7c-1.4,5.7-1.7,8.1-1.7,8.1l-0.8,6.5c-0.5,5.9,0.2,8.9,1,11.8l0.3,1l-0.7,0.2%20c-0.1,4.2,0.8,7.1,2.6,8.1L365.3,327.2z%20M517,298.6l0.6,1.2c0.1,0.2,0.3,0.4,0.4,0.4c0.1,0,0.4-0.1,0.8-0.5l0.6-0.6l0.5,0.3%20c-0.1-0.2-0.3-0.4-0.4-0.6c-0.6-0.9-1-1.4-1.5-1.6C517.7,297.8,517.4,298.2,517,298.6z%20M356.1,260.5c-0.2,0-0.8,0.3-1.1,0.5%20c-0.1,0.1-0.2,0.1-0.3,0.1c0,0,0.1,0,0.1,0c0.1,0,0.3,0,0.4,0C355.9,261,356.1,261,356.1,260.5%20C356.2,260.5,356.2,260.5,356.1,260.5C356.2,260.5,356.1,260.5,356.1,260.5z'/%3e%3c/g%3e%3c/g%3e%3cg%20id='specctr'%3e%3cg%20id='Dimensions'%3e%3c/g%3e%3c/g%3e%3c/svg%3e", BCe = "data:image/svg+xml,%3c?xml%20version='1.0'%20encoding='UTF-8'?%3e%3csvg%20width='477px'%20height='689px'%20viewBox='0%200%20477%20689'%20version='1.1'%20xmlns='http://www.w3.org/2000/svg'%20xmlns:xlink='http://www.w3.org/1999/xlink'%3e%3c!--%20Generator:%20sketchtool%2040.1%20(33804)%20-%20http://www.bohemiancoding.com/sketch%20--%3e%3ctitle%3eD5222DCB-A5E7-4783-ABD3-E5AAF56D153F%3c/title%3e%3cdesc%3eCreated%20with%20sketchtool.%3c/desc%3e%3cdefs%3e%3crect%20id='path-1'%20x='0.760775862'%20y='88.8671642'%20width='90'%20height='138'%3e%3c/rect%3e%3cmask%20id='mask-2'%20maskContentUnits='userSpaceOnUse'%20maskUnits='objectBoundingBox'%20x='0'%20y='0'%20width='90'%20height='138'%20fill='white'%3e%3cuse%20xlink:href='%23path-1'%3e%3c/use%3e%3c/mask%3e%3c/defs%3e%3cg%20id='Page-1'%20stroke='none'%20stroke-width='1'%20fill='none'%20fill-rule='evenodd'%3e%3cg%20id='box-and-whiskers-plot'%20transform='translate(-1362.000000,%20-6618.000000)'%20stroke='%23E5E5E5'%3e%3cg%20id='boxplot_small'%20transform='translate(1362.000000,%206618.000000)'%3e%3cg%20id='Group-40'%20transform='translate(193.000000,%20187.000000)'%3e%3cg%20id='Group-39'%20transform='translate(0.239224,%200.132836)'%3e%3cuse%20id='Rectangle-32'%20mask='url(%23mask-2)'%20stroke-width='2'%20xlink:href='%23path-1'%3e%3c/use%3e%3cpath%20d='M0.760775862,185.367164%20L90.7607759,185.367164'%20id='Path-63'%20fill='%23D8D8D8'%3e%3c/path%3e%3cpath%20d='M0.760775862,313.367164%20L90.7607759,313.367164'%20id='Path-63'%20fill='%23D8D8D8'%3e%3c/path%3e%3cpath%20d='M0.760775862,1.36716418%20L90.7607759,1.36716418'%20id='Path-63-Copy'%20fill='%23D8D8D8'%3e%3c/path%3e%3cpath%20d='M46.2607759,0.867164179%20L46.2607759,88.8671642'%20id='Path-64'%20fill='%23D8D8D8'%3e%3c/path%3e%3cpath%20d='M46.2607759,225.867164%20L46.2607759,313.867164'%20id='Path-64'%20fill='%23D8D8D8'%3e%3c/path%3e%3c/g%3e%3c/g%3e%3c/g%3e%3c/g%3e%3c/g%3e%3c/svg%3e", HCe = "data:image/svg+xml,%3c?xml%20version='1.0'%20encoding='utf-8'?%3e%3c!--%20Generator:%20Adobe%20Illustrator%2017.1.0,%20SVG%20Export%20Plug-In%20.%20SVG%20Version:%206.00%20Build%200)%20--%3e%3c!DOCTYPE%20svg%20PUBLIC%20'-//W3C//DTD%20SVG%201.1//EN'%20'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3e%3csvg%20version='1.1'%20xmlns='http://www.w3.org/2000/svg'%20xmlns:xlink='http://www.w3.org/1999/xlink'%20x='0px'%20y='0px'%20viewBox='0%200%20566%20700'%20enable-background='new%200%200%20566%20700'%20xml:space='preserve'%3e%3cg%20id='Layer_1'%3e%3c/g%3e%3cg%20id='specctr'%3e%3cg%20id='Dimensions'%3e%3cg%3e%3cpath%20fill='%23E4E4E4'%20d='M148.3,490.8l-1-1.3c-25.5-31.2-39.6-70.6-39.6-111c0-40.4,14.1-79.8,39.6-111l1-1.3l26.9,26.9l-0.8,1%20c-38.6,49.6-38.6,118.9,0,168.6l0.8,1L148.3,490.8z%20M148.5,270.8c-24.4,30.4-37.9,68.6-37.9,107.8c0,39.1,13.4,77.4,37.9,107.8%20l22.7-22.7c-38.4-50.3-38.4-119.9,0-170.2L148.5,270.8z'/%3e%3c/g%3e%3cg%3e%3cpath%20fill='%23E4E4E4'%20d='M368.3,270.8l-1-0.8c-23.9-18.6-53.9-28.9-84.3-28.9c-30.4,0-60.3,10.2-84.3,28.9l-1,0.8l-26.9-26.9%20l1.3-1c31.2-25.5,70.6-39.6,111-39.6c40.4,0,79.8,14.1,111,39.6l1.3,1L368.3,270.8z%20M283,238.1c30.6,0,60.8,10.2,85.1,28.7%20l22.7-22.7c-30.4-24.4-68.6-37.9-107.8-37.9c-39.2,0-77.4,13.4-107.8,37.9l22.7,22.7C222.2,248.3,252.4,238.1,283,238.1z'/%3e%3c/g%3e%3cg%3e%3cpath%20fill='%23E4E4E4'%20d='M417.7,490.8l-26.9-26.9l0.8-1c38.6-49.6,38.6-118.9,0-168.6l-0.8-1l26.9-26.9l1,1.3%20c25.5,31.2,39.6,70.6,39.6,111c0,40.4-14.1,79.8-39.6,111L417.7,490.8z%20M394.8,463.7l22.7,22.7c24.4-30.4,37.9-68.6,37.9-107.8%20c0-39.1-13.4-77.3-37.9-107.8l-22.7,22.7C433.1,343.8,433.1,413.4,394.8,463.7z'/%3e%3c/g%3e%3cg%3e%3cpath%20fill='%23E4E4E4'%20d='M283,553.9L283,553.9c-40.4,0-79.8-14.1-111-39.6l-1.3-1l26.9-26.9l1,0.8c23.9,18.6,53.9,28.9,84.3,28.9%20c30.4,0,60.4-10.2,84.3-28.9l1-0.8l26.9,26.9l-1.3,1C362.8,539.9,323.4,553.9,283,553.9z%20M175.2,513.1%20c30.4,24.4,68.6,37.9,107.7,37.9h0.1c39.1,0,77.3-13.4,107.8-37.9l-22.7-22.7c-24.3,18.5-54.4,28.7-85.1,28.7%20c-30.6,0-60.8-10.2-85.1-28.7L175.2,513.1z'/%3e%3c/g%3e%3cg%3e%3cpath%20fill='%23E4E4E4'%20d='M283,458c-43.8,0-79.4-35.6-79.4-79.4c0-43.8,35.6-79.4,79.4-79.4c43.8,0,79.4,35.6,79.4,79.4%20C362.4,422.4,326.8,458,283,458z%20M283,302.2c-42.1,0-76.4,34.3-76.4,76.4c0,42.1,34.3,76.4,76.4,76.4c42.1,0,76.4-34.3,76.4-76.4%20C359.4,336.5,325.1,302.2,283,302.2z'/%3e%3c/g%3e%3cg%3e%3cpath%20fill='%23E4E4E4'%20d='M283,493c-63.1,0-114.4-51.3-114.4-114.4S219.9,264.2,283,264.2c63.1,0,114.4,51.3,114.4,114.4%20S346.1,493,283,493z%20M283,267.2c-61.4,0-111.4,50-111.4,111.4S221.6,490,283,490c61.4,0,111.4-50,111.4-111.4%20S344.4,267.2,283,267.2z'/%3e%3c/g%3e%3c/g%3e%3c/g%3e%3c/svg%3e", LR = {
  area: RCe,
  line: PCe,
  bar: OCe,
  column: NCe,
  polar: ACe,
  funnel: DCe,
  pie: ICe,
  scatter: LCe,
  indicator: $Ce,
  table: FCe,
  treemap: zCe,
  areamap: IR,
  scattermap: IR,
  boxplot: BCe,
  sunburst: HCe
};
function jCe(e) {
  var n;
  return (n = LR[e]) != null ? n : LR["bar"];
}
const cL = ({ iconType: e }) => {
  var s;
  const { themeSettings: t } = Yn(), n = it(null), [r, o] = Ge({
    width: null,
    height: null
  });
  mt(() => {
    n.current && o({
      width: n.current.offsetWidth,
      height: n.current.offsetHeight
    });
  }, []);
  const i = jCe(e), { t: a } = Bi();
  return /* @__PURE__ */ _e("div", { ref: n, className: mb.wrapper, children: [
    /* @__PURE__ */ z(
      "div",
      {
        className: mb.title,
        style: {
          fontFamily: (s = t.typography) == null ? void 0 : s.fontFamily,
          fontSize: WCe(r.width, r.height)
        },
        children: a("chartNoData")
      }
    ),
    i ? /* @__PURE__ */ z("img", { className: mb.image, src: i }) : null
  ] });
};
function WCe(e, t) {
  return !e || !t ? "18px" : e < 300 ? `${Math.max(Math.sqrt(e * e + t * t) * 0.045, 18)}px` : `${Math.min(Math.max(t * 0.09, 18), 60)}px`;
}
const VCe = (e, t, n) => ({
  width: (t == null ? void 0 : t.width) || (e == null ? void 0 : e.width) || n.width,
  height: (t == null ? void 0 : t.height) || (e == null ? void 0 : e.height) || n.height
}), Vg = ({
  children: e,
  defaultSize: t,
  size: n,
  rerenderOnResize: r = !1,
  useContentSize: o,
  onSizeChange: i
}) => {
  const a = it(null), [s, c] = Ge(), l = bt(() => {
    var S, _;
    const T = {
      width: (S = a.current) == null ? void 0 : S.offsetWidth,
      height: (_ = a.current) == null ? void 0 : _.offsetHeight
    };
    c((w) => {
      const k = (w == null ? void 0 : w.width) === 0 && T.width === t.width, E = (w == null ? void 0 : w.height) === 0 && T.height === t.height, R = {
        width: k ? w.width : T.width,
        height: E ? w.height : T.height
      };
      return Ic(w, R) ? w : R;
    });
  }, [a, t]);
  Lc(() => {
    l();
  }, [l]), mt(() => (window.addEventListener("resize", l), () => window.removeEventListener("resize", l)), [l]);
  const d = We(
    () => VCe(s, n, t),
    [s, t, n]
  ), f = !!s;
  mt(() => {
    f && i && i(d);
  }, [d, f, i]);
  const p = {
    width: n != null && n.width && !(o != null && o.width) ? `${n.width}px` : "100%",
    height: n != null && n.height && !(o != null && o.height) ? `${n.height}px` : "100%"
  }, m = (s == null ? void 0 : s.width) || (s == null ? void 0 : s.width) === void 0, v = (s == null ? void 0 : s.height) || (s == null ? void 0 : s.width) === void 0, g = {
    width: m || o != null && o.width ? "100%" : `${d.width}px`,
    height: v || o != null && o.height ? "100%" : `${d.height}px`,
    position: "relative"
  }, b = o != null && o.width || o != null && o.height ? {
    position: "static",
    width: "100%",
    height: "100%"
  } : {
    position: "absolute",
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  }, x = r ? `${d == null ? void 0 : d.width}${d == null ? void 0 : d.height}` : "";
  return /* @__PURE__ */ z("div", { style: p, ref: a, children: /* @__PURE__ */ z("div", { style: g, children: /* @__PURE__ */ z("div", { style: b, children: d && (typeof e == "function" ? e(d) : e) }) }, x) });
}, UCe = {
  width: 400,
  height: 500
}, _x = (e) => eF(e) ? {
  width: 400,
  height: 500
} : Cm(e) ? {
  width: 200,
  height: 200
} : {
  width: 400,
  height: 400
}, qCe = 25, uL = (e, { hasHeader: t } = {}) => {
  const n = e === "pivot" ? UCe : _x(e);
  return t && (n.height = n.height + qCe), n;
}, GCe = [
  {
    officialName: "Afghanistan",
    allNames: ["af", "afġānistān", "afghanistan", "afg"],
    id: "AFG"
  },
  {
    id: "ALA",
    officialName: "Åland Islands",
    allNames: ["ax", "ala", "åland islands", "aland islands"]
  },
  {
    officialName: "Albania",
    allNames: ["al", "shqipëri", "shqipëria", "shqipnia", "albania", "alb"],
    id: "ALB"
  },
  {
    officialName: "Algeria",
    allNames: ["dz", "dzayer", "algérie", "algeria", "dza"],
    id: "DZA"
  },
  {
    officialName: "American Samoa",
    allNames: ["as", "amerika sāmoa", "amelika sāmoa", "sāmoa amelika", "american samoa", "asm"],
    id: "ASM"
  },
  {
    id: "AND",
    officialName: "Andorra",
    allNames: ["ad", "and", "andorra"]
  },
  {
    officialName: "Angola",
    allNames: ["ao", "república de angola", "ʁɛpublika de an'ɡɔla", "angola", "ago"],
    id: "AGO"
  },
  {
    officialName: "Anguilla",
    allNames: ["ai", "anguilla", "aia"],
    id: "AIA"
  },
  {
    id: "ATA",
    officialName: "Antarctica",
    allNames: ["aq", "ata", "antarctica"]
  },
  {
    officialName: "Antigua and Barbuda",
    allNames: ["ag", "antigua and barbuda", "atg"],
    id: "ATG"
  },
  {
    officialName: "Argentina",
    allNames: ["ar", "argentine republic", "república argentina", "argentina", "arg"],
    id: "ARG"
  },
  {
    officialName: "Armenia",
    allNames: [
      "am",
      "hayastan",
      "republic of armenia",
      "հայաստանի հանրապետություն",
      "armenia",
      "arm"
    ],
    id: "ARM"
  },
  {
    officialName: "Aruba",
    allNames: ["aw", "aruba", "abw"],
    id: "ABW"
  },
  {
    officialName: "Australia",
    allNames: ["au", "australia", "aus"],
    id: "AUS"
  },
  {
    officialName: "Austria",
    allNames: ["at", "österreich", "osterreich", "oesterreich", "austria", "aut"],
    id: "AUT"
  },
  {
    officialName: "Azerbaijan",
    allNames: [
      "az",
      "republic of azerbaijan",
      "azərbaycan respublikası",
      "azerbaijan",
      "aze",
      "azerbaijan republic"
    ],
    id: "AZE"
  },
  {
    officialName: "Bahrain",
    allNames: ["bh", "kingdom of bahrain", "mamlakat al-baḥrayn", "bahrain", "bhr"],
    id: "BHR"
  },
  {
    officialName: "Bangladesh",
    allNames: [
      "bd",
      "people's republic of bangladesh",
      "gônôprôjatôntri bangladesh",
      "bangladesh",
      "bgd"
    ],
    id: "BGD"
  },
  {
    officialName: "Barbados",
    allNames: ["bb", "barbados", "brb"],
    id: "BRB"
  },
  {
    officialName: "Belarus",
    allNames: [
      "by",
      "bielaruś",
      "republic of belarus",
      "белоруссия",
      "республика беларусь",
      "belorussiya",
      "respublika belarus’",
      "belarus",
      "blr"
    ],
    id: "BLR"
  },
  {
    officialName: "Belgium",
    allNames: [
      "be",
      "belgië",
      "belgie",
      "belgien",
      "belgique",
      "kingdom of belgium",
      "koninkrijk belgië",
      "royaume de belgique",
      "königreich belgien",
      "belgium",
      "bel"
    ],
    id: "BEL"
  },
  {
    officialName: "Belize",
    allNames: ["bz", "belize", "blz"],
    id: "BLZ"
  },
  {
    officialName: "Benin",
    allNames: ["bj", "republic of benin", "république du bénin", "benin", "ben"],
    id: "BEN"
  },
  {
    officialName: "Bermuda",
    allNames: ["bm", "the islands ofbermuda", "the bermudas", "somers isles", "bermuda", "bmu"],
    id: "BMU"
  },
  {
    officialName: "Bhutan",
    allNames: ["bt", "kingdom of bhutan", "bhutan", "btn"],
    id: "BTN"
  },
  {
    officialName: "Bolivia",
    allNames: [
      "bo",
      "buliwya",
      "wuliwya",
      "plurinational state of bolivia",
      "estado plurinacional de bolivia",
      "buliwya mamallaqta",
      "wuliwya suyu",
      "tetã volívia",
      "bolivia",
      "bol",
      "plurinational state of"
    ],
    id: "BOL"
  },
  {
    id: "BES",
    officialName: "Bonaire",
    allNames: ["bq", "bes", "bonaire", "sint eustatius and saba", "caribbean netherlands"]
  },
  {
    officialName: "Bosnia and Herzegovina",
    allNames: ["ba", "bosnia-herzegovina", "босна и херцеговина", "bosnia and herzegovina", "bih"],
    id: "BIH"
  },
  {
    officialName: "Botswana",
    allNames: ["bw", "republic of botswana", "lefatshe la botswana", "botswana", "bwa"],
    id: "BWA"
  },
  {
    id: "BVT",
    officialName: "Bouvet Island",
    allNames: ["bv", "bvt", "bouvet island"]
  },
  {
    officialName: "Brazil",
    allNames: [
      "br",
      "brasil",
      "federative republic of brazil",
      "república federativa do brasil",
      "brazil",
      "bra"
    ],
    id: "BRA"
  },
  {
    officialName: "British Indian Ocean Territory",
    allNames: ["io", "british indian ocean territory", "iot"],
    id: "IOT"
  },
  {
    officialName: "Brunei",
    allNames: [
      "bn",
      "nation of brunei",
      "the abode of peace",
      "brunei",
      "brn",
      "brunei darussalam"
    ],
    id: "BRN"
  },
  {
    officialName: "Bulgaria",
    allNames: ["bg", "republic of bulgaria", "република българия", "bulgaria", "bgr"],
    id: "BGR"
  },
  {
    officialName: "Burkina Faso",
    allNames: ["bf", "burkina faso", "bfa"],
    id: "BFA"
  },
  {
    officialName: "Burundi",
    allNames: [
      "bi",
      "republic of burundi",
      "republika y'uburundi",
      "république du burundi",
      "burundi",
      "bdi"
    ],
    id: "BDI"
  },
  {
    officialName: "Cambodia",
    allNames: ["kh", "kingdom of cambodia", "cambodia", "khm"],
    id: "KHM"
  },
  {
    officialName: "Cameroon",
    allNames: ["cm", "republic of cameroon", "république du cameroun", "cameroon", "cmr"],
    id: "CMR"
  },
  {
    officialName: "Canada",
    allNames: ["ca", "canada", "can"],
    id: "CAN"
  },
  {
    officialName: "Cape Verde",
    allNames: ["cv", "republic of cabo verde", "república de cabo verde", "cape verde", "cpv"],
    id: "CPV"
  },
  {
    officialName: "Cayman Islands",
    allNames: ["ky", "cayman islands", "cym"],
    id: "CYM"
  },
  {
    officialName: "Central African Republic",
    allNames: [
      "cf",
      "central african republic",
      "république centrafricaine",
      "central african republic",
      "caf"
    ],
    id: "CAF"
  },
  {
    officialName: "Chad",
    allNames: ["td", "tchad", "republic of chad", "république du tchad", "chad", "tcd"],
    id: "TCD"
  },
  {
    officialName: "Chile",
    allNames: ["cl", "republic of chile", "república de chile", "chile", "chl"],
    id: "CHL"
  },
  {
    officialName: "China",
    allNames: [
      "cn",
      "zhōngguó",
      "zhongguo",
      "zhonghua",
      "people's republic of china",
      "中华人民共和国",
      "zhōnghuá rénmín gònghéguó",
      "china",
      "chn"
    ],
    id: "CHN"
  },
  {
    officialName: "Christmas Island",
    allNames: ["cx", "territory of christmas island", "christmas island", "cxr"],
    id: "CXR"
  },
  {
    officialName: "Cocos (Keeling) Islands",
    allNames: [
      "cc",
      "territoryof the cocos (keeling) islands",
      "keeling islands",
      "cocos (keeling) islands",
      "cck",
      "cocos islands",
      "cocos [keeling] islands"
    ],
    id: "CCK"
  },
  {
    officialName: "Colombia",
    allNames: ["co", "republic of colombia", "república de colombia", "colombia", "col"],
    id: "COL"
  },
  {
    officialName: "Comoros",
    allNames: [
      "km",
      "union of the comoros",
      "union des comores",
      "udzima wa komori",
      "al-ittiḥād al-qumurī",
      "comoros",
      "com"
    ],
    id: "COM"
  },
  {
    officialName: "Cook Islands",
    allNames: ["ck", "kūki 'āirani", "cook islands", "cok"],
    id: "COK"
  },
  {
    officialName: "Costa Rica",
    allNames: ["cr", "republic of costa rica", "república de costa rica", "costa rica", "cri"],
    id: "CRI"
  },
  {
    officialName: "Croatia",
    allNames: [
      "hr",
      "hrvatska",
      "republic of croatia",
      "republika hrvatska",
      "croatia",
      "hrv",
      "croatia, republic of",
      "croatia democratic republic of the"
    ],
    id: "HRV"
  },
  {
    officialName: "Cuba",
    allNames: ["cu", "republic of cuba", "república de cuba", "cuba", "cub"],
    id: "CUB"
  },
  {
    id: "CUW",
    officialName: "Curaçao",
    allNames: ["cw", "cuw", "curaçao", "curacao"]
  },
  {
    officialName: "Cyprus",
    allNames: [
      "cy",
      "kýpros",
      "kıbrıs",
      "republic of cyprus",
      "κυπριακή δημοκρατία",
      "kıbrıs cumhuriyeti",
      "cyprus",
      "cyp"
    ],
    id: "CYP"
  },
  {
    officialName: "Czech Republic",
    allNames: ["cz", "česká republika", "česko", "czech republic", "cze"],
    id: "CZE"
  },
  {
    officialName: "Democratic Republic of the Congo",
    allNames: [
      "cd",
      "dr congo",
      "congo-kinshasa",
      "drc",
      "democratic republic of the congo",
      "cod",
      "congo (kinshasa)",
      "the democratic republic of the congo",
      "congo, the democratic republic of the",
      "congo [drc]",
      "congo, dem. rep."
    ],
    id: "COD"
  },
  {
    officialName: "Denmark",
    allNames: ["dk", "danmark", "kingdom of denmark", "kongeriget danmark", "denmark", "dnk"],
    id: "DNK"
  },
  {
    officialName: "Djibouti",
    allNames: [
      "dj",
      "jabuuti",
      "gabuuti",
      "republic of djibouti",
      "république de djibouti",
      "gabuutih ummuuno",
      "jamhuuriyadda jabuuti",
      "djibouti",
      "dji"
    ],
    id: "DJI"
  },
  {
    officialName: "Dominica",
    allNames: ["dm", "dominique", "wai‘tu kubuli", "commonwealth of dominica", "dominica", "dma"],
    id: "DMA"
  },
  {
    officialName: "Dominican Republic",
    allNames: ["do", "dominican republic", "dom"],
    id: "DOM"
  },
  {
    officialName: "East Timor",
    allNames: [
      "tl",
      "east timor",
      "democratic republic of timor-leste",
      "república democrática de timor-leste",
      "repúblika demokrátika timór-leste",
      "east timor",
      "tls",
      "timor-leste"
    ],
    id: "TLS"
  },
  {
    officialName: "Ecuador",
    allNames: ["ec", "republic of ecuador", "república del ecuador", "ecuador", "ecu"],
    id: "ECU"
  },
  {
    officialName: "Egypt",
    allNames: ["eg", "arab republic of egypt", "egypt", "egy"],
    id: "EGY"
  },
  {
    officialName: "El Salvador",
    allNames: ["sv", "republic of el salvador", "república de el salvador", "el salvador", "slv"],
    id: "SLV"
  },
  {
    officialName: "Equatorial Guinea",
    allNames: [
      "gq",
      "republic of equatorial guinea",
      "república de guinea ecuatorial",
      "république de guinée équatoriale",
      "república da guiné equatorial",
      "equatorial guinea",
      "gnq"
    ],
    id: "GNQ"
  },
  {
    officialName: "Eritrea",
    allNames: [
      "er",
      "state of eritrea",
      "ሃገረ ኤርትራ",
      "dawlatiritriyá",
      "ʾertrā",
      "iritriyā",
      "eritrea",
      "eri"
    ],
    id: "ERI"
  },
  {
    officialName: "Estonia",
    allNames: ["ee", "eesti", "republic of estonia", "eesti vabariik", "estonia", "est"],
    id: "EST"
  },
  {
    officialName: "Ethiopia",
    allNames: [
      "et",
      "ʾītyōṗṗyā",
      "federal democratic republic of ethiopia",
      "የኢትዮጵያ ፌዴራላዊ ዲሞክራሲያዊ ሪፐብሊክ",
      "ethiopia",
      "eth"
    ],
    id: "ETH"
  },
  {
    officialName: "Falkland Islands",
    allNames: [
      "fk",
      "islas malvinas",
      "falkland islands",
      "flk",
      "falkland islands (malvinas)",
      "falkland islands (islas malvinas)",
      "falkland islands [malvinas]",
      "falkland islands [islas malvinas]"
    ],
    id: "FLK"
  },
  {
    officialName: "Faroe Islands",
    allNames: ["fo", "føroyar", "færøerne", "faroe islands", "fro"],
    id: "FRO"
  },
  {
    officialName: "Federated States of Micronesia",
    allNames: [
      "fm",
      "federated states of micronesia",
      "federated states of micronesia",
      "fsm",
      "micronesia",
      "federated states of"
    ],
    id: "FSM"
  },
  {
    officialName: "Fiji",
    allNames: [
      "fj",
      "viti",
      "republic of fiji",
      "matanitu ko viti",
      "fijī gaṇarājya",
      "fiji",
      "fji"
    ],
    id: "FJI"
  },
  {
    officialName: "Finland",
    allNames: [
      "fi",
      "suomi",
      "republic of finland",
      "suomen tasavalta",
      "republiken finland",
      "finland",
      "fin"
    ],
    id: "FIN"
  },
  {
    officialName: "France",
    allNames: ["fr", "french republic", "république française", "france", "fra"],
    id: "FRA"
  },
  {
    officialName: "French Guiana",
    allNames: ["gf", "guiana", "guyane", "french guiana", "guf"],
    id: "GUF"
  },
  {
    officialName: "French Polynesia",
    allNames: [
      "pf",
      "polynésie française",
      "french polynesia",
      "pōrīnetia farāni",
      "french polynesia",
      "pyf"
    ],
    id: "PYF"
  },
  {
    officialName: "French Southern and Antarctic Lands",
    allNames: ["tf", "french southern andantarctic lands", "atf", "french southern territories"],
    id: "ATF"
  },
  {
    officialName: "Gabon",
    allNames: ["ga", "gabonese republic", "république gabonaise", "gabon", "gab", "gabon republic"],
    id: "GAB"
  },
  {
    officialName: "Georgia",
    allNames: ["ge", "sakartvelo", "georgia", "geo"],
    id: "GEO"
  },
  {
    officialName: "Germany",
    allNames: ["de", "federal republic of germany", "bundesrepublik deutschland", "germany", "deu"],
    id: "DEU"
  },
  {
    officialName: "Ghana",
    allNames: ["gh", "ghana", "gha"],
    id: "GHA"
  },
  {
    officialName: "Gibraltar",
    allNames: ["gi", "gibraltar", "gib"],
    id: "GIB"
  },
  {
    officialName: "Greece",
    allNames: ["gr", "elláda", "hellenic republic", "ελληνική δημοκρατία", "greece", "grc"],
    id: "GRC"
  },
  {
    officialName: "Greenland",
    allNames: ["gl", "grønland", "greenland", "grl"],
    id: "GRL"
  },
  {
    officialName: "Grenada",
    allNames: ["gd", "grenada", "grd"],
    id: "GRD"
  },
  {
    officialName: "Guadeloupe",
    allNames: ["gp", "gwadloup", "guadeloupe", "glp"],
    id: "GLP"
  },
  {
    officialName: "Guam",
    allNames: ["gu", "guåhån", "guam", "gum"],
    id: "GUM"
  },
  {
    officialName: "Guatemala",
    allNames: ["gt", "guatemala", "gtm"],
    id: "GTM"
  },
  {
    officialName: "Guernsey",
    allNames: ["gg", "bailiwick of guernsey", "bailliage de guernesey", "guernsey", "ggy"],
    id: "GGY"
  },
  {
    officialName: "Guinea",
    allNames: ["gn", "republic of guinea", "république de guinée", "guinea", "gin"],
    id: "GIN"
  },
  {
    officialName: "Guinea-Bissau",
    allNames: [
      "gw",
      "republic of guinea-bissau",
      "república da guiné-bissau",
      "guinea-bissau",
      "gnb"
    ],
    id: "GNB"
  },
  {
    officialName: "Guyana",
    allNames: ["gy", "co-operative republic of guyana", "guyana", "guy"],
    id: "GUY"
  },
  {
    officialName: "Haiti",
    allNames: ["ht", "republic of haiti", "république d'haïti", "repiblik ayiti", "haiti", "hti"],
    id: "HTI"
  },
  {
    officialName: "Heard Island and McDonald Islands",
    allNames: ["hm", "heard island and mcdonald islands", "hmd", "heard and mcdonald islands"],
    id: "HMD"
  },
  {
    officialName: "Honduras",
    allNames: ["hn", "republic of honduras", "república de honduras", "honduras", "hnd"],
    id: "HND"
  },
  {
    officialName: "Hong Kong",
    allNames: ["hk", "香港", "hongkong", "hkg", "hong kong", "hong kong, china"],
    id: "HKG"
  },
  {
    officialName: "Hungary",
    allNames: ["hu", "hungary", "hun"],
    id: "HUN"
  },
  {
    officialName: "Iceland",
    allNames: ["is", "island", "republic of iceland", "lýðveldið ísland", "iceland", "isl"],
    id: "ISL"
  },
  {
    officialName: "India",
    allNames: ["in", "bhārat", "republic of india", "bharat ganrajya", "india", "ind"],
    id: "IND"
  },
  {
    officialName: "Indonesia",
    allNames: ["id", "republic of indonesia", "republik indonesia", "indonesia", "idn"],
    id: "IDN"
  },
  {
    officialName: "Iran",
    allNames: [
      "ir",
      "islamic republic of iran",
      "jomhuri-ye eslāmi-ye irān",
      "iran",
      "irn",
      "islamic republic of"
    ],
    id: "IRN"
  },
  {
    officialName: "Iraq",
    allNames: ["iq", "republic of iraq", "jumhūriyyat al-‘irāq", "iraq", "irq"],
    id: "IRQ"
  },
  {
    officialName: "Ireland",
    allNames: ["ie", "éire", "republic of ireland", "poblacht na héireann", "ireland", "irl"],
    id: "IRL"
  },
  {
    officialName: "Isle of Man",
    allNames: ["im", "ellan vannin", "mann", "mannin", "isle of man", "imn"],
    id: "IMN"
  },
  {
    officialName: "Israel",
    allNames: ["il", "state of israel", "medīnat yisrā'el", "israel", "isr"],
    id: "ISR"
  },
  {
    officialName: "Italy",
    allNames: ["it", "italian republic", "repubblica italiana", "italy", "ita"],
    id: "ITA"
  },
  {
    officialName: "Ivory Coast",
    allNames: [
      "ci",
      "ivory coast",
      "republic of côte d'ivoire",
      "république de côte d'ivoire",
      "ivory coast",
      "civ",
      "côte d'ivoire",
      "cote d'ivoire",
      "cote divoire",
      "cã´te d'ivoire",
      "cote d'lvoire"
    ],
    id: "CIV"
  },
  {
    officialName: "Jamaica",
    allNames: ["jm", "jamaica", "jam"],
    id: "JAM"
  },
  {
    officialName: "Japan",
    allNames: ["jp", "nippon", "nihon", "japan", "jpn"],
    id: "JPN"
  },
  {
    officialName: "Jersey",
    allNames: [
      "je",
      "bailiwick of jersey",
      "bailliage de jersey",
      "bailliage dé jèrri",
      "jersey",
      "jey"
    ],
    id: "JEY"
  },
  {
    officialName: "Jordan",
    allNames: [
      "jo",
      "hashemite kingdomof jordan",
      "al-mamlakah al-urdunīyah al-hāshimīyah",
      "jordan",
      "jor"
    ],
    id: "JOR"
  },
  {
    officialName: "Kazakhstan",
    allNames: [
      "kz",
      "qazaqstan",
      "казахстан",
      "republic of kazakhstan",
      "қазақстан республикасы",
      "qazaqstan respublïkası",
      "республика казахстан",
      "respublika kazakhstan",
      "kazakhstan",
      "kaz"
    ],
    id: "KAZ"
  },
  {
    officialName: "Kenya",
    allNames: ["ke", "republic of kenya", "jamhuri ya kenya", "kenya", "ken"],
    id: "KEN"
  },
  {
    officialName: "Kiribati",
    allNames: ["ki", "republic of kiribati", "ribaberiki kiribati", "kiribati", "kir"],
    id: "KIR"
  },
  {
    officialName: "Kuwait",
    allNames: ["kw", "state of kuwait", "dawlat al-kuwait", "kuwait", "kwt"],
    id: "KWT"
  },
  {
    officialName: "Kyrgyzstan",
    allNames: [
      "kg",
      "киргизия",
      "kyrgyz republic",
      "кыргыз республикасы",
      "kyrgyz respublikasy",
      "kyrgyzstan",
      "kgz"
    ],
    id: "KGZ"
  },
  {
    officialName: "Laos",
    allNames: [
      "la",
      "lao",
      "lao people's democratic republic",
      "sathalanalat paxathipatai paxaxon lao",
      "laos",
      "lao"
    ],
    id: "LAO"
  },
  {
    officialName: "Latvia",
    allNames: ["lv", "republic of latvia", "latvijas republika", "latvia", "lva"],
    id: "LVA"
  },
  {
    officialName: "Lebanon",
    allNames: ["lb", "lebanese republic", "al-jumhūrīyah al-libnānīyah", "lebanon", "lbn"],
    id: "LBN"
  },
  {
    officialName: "Lesotho",
    allNames: ["ls", "kingdom of lesotho", "muso oa lesotho", "lesotho", "lso"],
    id: "LSO"
  },
  {
    officialName: "Liberia",
    allNames: ["lr", "republic of liberia", "liberia", "lbr"],
    id: "LBR"
  },
  {
    officialName: "Libya",
    allNames: ["ly", "state of libya", "dawlat libya", "libya", "lby"],
    id: "LBY"
  },
  {
    officialName: "Liechtenstein",
    allNames: [
      "li",
      "principality of liechtenstein",
      "fürstentum liechtenstein",
      "liechtenstein",
      "lie"
    ],
    id: "LIE"
  },
  {
    officialName: "Lithuania",
    allNames: ["lt", "republic of lithuania", "lietuvos respublika", "lithuania", "ltu"],
    id: "LTU"
  },
  {
    officialName: "Luxembourg",
    allNames: [
      "lu",
      "grand duchy of luxembourg",
      "grand-duché de luxembourg",
      "großherzogtum luxemburg",
      "groussherzogtum lëtzebuerg",
      "luxembourg",
      "lux"
    ],
    id: "LUX"
  },
  {
    officialName: "Macau",
    allNames: [
      "mo",
      "澳门",
      "macao special administrative region of the people's republic of china",
      "中華人民共和國澳門特別行政區",
      "região administrativa especial de macau da república popular da china",
      "macau",
      "mac",
      "macao",
      "macao, china",
      "macau, china"
    ],
    id: "MAC"
  },
  {
    officialName: "Madagascar",
    allNames: [
      "mg",
      "republic of madagascar",
      "repoblikan'i madagasikara",
      "république de madagascar",
      "madagascar",
      "mdg"
    ],
    id: "MDG"
  },
  {
    officialName: "Malawi",
    allNames: ["mw", "republic of malawi", "malawi", "mwi"],
    id: "MWI"
  },
  {
    officialName: "Malaysia",
    allNames: ["my", "malaysia", "mys"],
    id: "MYS"
  },
  {
    officialName: "Maldives",
    allNames: [
      "mv",
      "maldive islands",
      "republic of the maldives",
      "dhivehi raajjeyge jumhooriyya",
      "maldives",
      "mdv"
    ],
    id: "MDV"
  },
  {
    officialName: "Mali",
    allNames: ["ml", "republic of mali", "république du mali", "mali", "mli"],
    id: "MLI"
  },
  {
    officialName: "Malta",
    allNames: ["mt", "republic of malta", "repubblika ta' malta", "malta", "mlt"],
    id: "MLT"
  },
  {
    officialName: "Marshall Islands",
    allNames: [
      "mh",
      "republic of the marshall islands",
      "aolepān aorōkin m̧ajeļ",
      "marshall islands",
      "mhl"
    ],
    id: "MHL"
  },
  {
    officialName: "Martinique",
    allNames: ["mq", "martinique", "mtq"],
    id: "MTQ"
  },
  {
    officialName: "Mauritania",
    allNames: [
      "mr",
      "islamic republic of mauritania",
      "al-jumhūriyyah al-ʾislāmiyyah al-mūrītāniyyah",
      "mauritania",
      "mrt"
    ],
    id: "MRT"
  },
  {
    officialName: "Mauritius",
    allNames: ["mu", "republic of mauritius", "république de maurice", "mauritius", "mus"],
    id: "MUS"
  },
  {
    officialName: "Mayotte",
    allNames: ["yt", "department of mayotte", "département de mayotte", "mayotte", "myt"],
    id: "MYT"
  },
  {
    officialName: "Mexico",
    allNames: [
      "mx",
      "mexicanos",
      "united mexican states",
      "estados unidos mexicanos",
      "mexico",
      "mex"
    ],
    id: "MEX"
  },
  {
    officialName: "Moldova",
    allNames: ["md", "republic of moldova", "republica moldova", "moldova", "mda", "republic of"],
    id: "MDA"
  },
  {
    officialName: "Monaco",
    allNames: ["mc", "principality of monaco", "principauté de monaco", "monaco", "mco"],
    id: "MCO"
  },
  {
    officialName: "Mongolia",
    allNames: ["mn", "mongolia", "mng"],
    id: "MNG"
  },
  {
    id: "MNE",
    officialName: "Montenegro",
    allNames: ["me", "mne", "montenegro"]
  },
  {
    officialName: "Montserrat",
    allNames: ["ms", "montserrat", "msr"],
    id: "MSR"
  },
  {
    officialName: "Morocco",
    allNames: [
      "ma",
      "kingdom of morocco",
      "al-mamlakah al-maġribiyah",
      "morocco",
      "mar",
      "morroco"
    ],
    id: "MAR"
  },
  {
    officialName: "Mozambique",
    allNames: ["mz", "republic of mozambique", "república de moçambique", "mozambique", "moz"],
    id: "MOZ"
  },
  {
    id: "MMR",
    officialName: "Myanmar",
    allNames: ["mm", "mmr", "myanmar", "myanmar (burma)", "myanmar [burma]", "burma"]
  },
  {
    officialName: "Namibia",
    allNames: ["na", "namibië", "republic of namibia", "namibia", "nam"],
    id: "NAM"
  },
  {
    officialName: "Nauru",
    allNames: [
      "nr",
      "naoero",
      "pleasant island",
      "republic of nauru",
      "ripublik naoero",
      "nauru",
      "nru"
    ],
    id: "NRU"
  },
  {
    officialName: "Nepal",
    allNames: [
      "np",
      "federal democratic republic of nepal",
      "loktāntrik ganatantra nepāl",
      "nepal",
      "npl"
    ],
    id: "NPL"
  },
  {
    officialName: "Netherlands",
    allNames: ["nl", "holland", "nederland", "netherlands", "nld", "the netherlands"],
    id: "NLD"
  },
  {
    officialName: "New Caledonia",
    allNames: ["nc", "new caledonia", "ncl"],
    id: "NCL"
  },
  {
    officialName: "New Zealand",
    allNames: ["nz", "aotearoa", "new zealand", "nzl"],
    id: "NZL"
  },
  {
    officialName: "Nicaragua",
    allNames: ["ni", "republic of nicaragua", "república de nicaragua", "nicaragua", "nic"],
    id: "NIC"
  },
  {
    officialName: "Niger",
    allNames: ["ne", "nijar", "republic of niger", "république du niger", "niger", "ner"],
    id: "NER"
  },
  {
    officialName: "Nigeria",
    allNames: ["ng", "nijeriya", "naíjíríà", "federal republic of nigeria", "nigeria", "nga"],
    id: "NGA"
  },
  {
    officialName: "Niue",
    allNames: ["nu", "niue", "niu"],
    id: "NIU"
  },
  {
    officialName: "Norfolk Island",
    allNames: [
      "nf",
      "territory of norfolk island",
      "teratri of norf'k ailen",
      "norfolk island",
      "nfk"
    ],
    id: "NFK"
  },
  {
    officialName: "North Korea",
    allNames: [
      "kp",
      "democratic people's republic of korea",
      "조선민주주의인민공화국",
      "chosŏn minjujuŭi inmin konghwaguk",
      "north korea",
      "prk",
      "korea, democratic people's republic of",
      "korea, north"
    ],
    id: "PRK"
  },
  {
    officialName: "Northern Mariana Islands",
    allNames: [
      "mp",
      "commonwealth of the northern mariana islands",
      "sankattan siha na islas mariånas",
      "northern mariana islands",
      "mnp"
    ],
    id: "MNP"
  },
  {
    officialName: "Norway",
    allNames: [
      "no",
      "norge",
      "noreg",
      "kingdom of norway",
      "kongeriket norge",
      "kongeriket noreg",
      "norway",
      "nor"
    ],
    id: "NOR"
  },
  {
    officialName: "Oman",
    allNames: ["om", "sultanate of oman", "salṭanat ʻumān", "oman", "omn"],
    id: "OMN"
  },
  {
    officialName: "Pakistan",
    allNames: [
      "pk",
      "pākistān",
      "islamic republic of pakistan",
      "islāmī jumhūriya'eh pākistān",
      "pakistan",
      "pak"
    ],
    id: "PAK"
  },
  {
    officialName: "Palau",
    allNames: ["pw", "republic of palau", "beluuer a belau", "palau", "plw"],
    id: "PLW"
  },
  {
    id: "PSE",
    officialName: "Palestinian Authority",
    allNames: ["ps", "pse", "palestinian authority", "palestinian territory"]
  },
  {
    officialName: "Panama",
    allNames: ["pa", "republic of panama", "república de panamá", "panama", "pan"],
    id: "PAN"
  },
  {
    officialName: "Papua New Guinea",
    allNames: [
      "pg",
      "independent state of papua new guinea",
      "independen stet bilong papua niugini",
      "papua new guinea",
      "png"
    ],
    id: "PNG"
  },
  {
    officialName: "Paraguay",
    allNames: [
      "py",
      "republic of paraguay",
      "república del paraguay",
      "tetã paraguái",
      "paraguay",
      "pry"
    ],
    id: "PRY"
  },
  {
    officialName: "Peru",
    allNames: ["pe", "republic of peru", "república del perú", "peru", "per"],
    id: "PER"
  },
  {
    officialName: "Philippines",
    allNames: ["ph", "republic of the philippines", "repúblika ng pilipinas", "philippines", "phl"],
    id: "PHL"
  },
  {
    officialName: "Pitcairn Islands",
    allNames: [
      "pn",
      "pitcairn henderson ducie and oeno islands",
      "pitcairn islands",
      "pcn",
      "pitcairn"
    ],
    id: "PCN"
  },
  {
    officialName: "Poland",
    allNames: ["pl", "republic of poland", "rzeczpospolita polska", "poland", "pol"],
    id: "POL"
  },
  {
    officialName: "Portugal",
    allNames: [
      "pt",
      "portuguesa",
      "portuguese republic",
      "república portuguesa",
      "portugal",
      "prt"
    ],
    id: "PRT"
  },
  {
    officialName: "Puerto Rico",
    allNames: [
      "pr",
      "commonwealth of puerto rico",
      "estado libre asociado de puerto rico",
      "puerto rico",
      "pri"
    ],
    id: "PRI"
  },
  {
    officialName: "Qatar",
    allNames: ["qa", "state of qatar", "dawlat qaṭar", "qatar", "qat"],
    id: "QAT"
  },
  {
    officialName: "Republic of Macedonia",
    allNames: [
      "mk",
      "republic of macedonia",
      "република македонија",
      "republic of macedonia",
      "mkd",
      "macedonia",
      "macedonia (fyrom)",
      "macedonia [fyrom]",
      "the former yugoslav republic of",
      "the former yugoslav republic of macedonia"
    ],
    id: "MKD"
  },
  {
    officialName: "Republic of the Congo",
    allNames: [
      "cg",
      "congo-brazzaville",
      "republic of the congo",
      "cog",
      "congo (brazzaville)",
      "congo [republic]",
      "congo",
      "congo, rep."
    ],
    id: "COG"
  },
  {
    officialName: "Réunion",
    allNames: ["re", "reunion", "réunion", "reu", "rã©union"],
    id: "REU"
  },
  {
    officialName: "Romania",
    allNames: ["ro", "rumania", "roumania", "românia", "romania", "rou"],
    id: "ROU"
  },
  {
    officialName: "Russia",
    allNames: [
      "ru",
      "rossiya",
      "russian federation",
      "российская федерация",
      "rossiyskaya federatsiya",
      "russia",
      "rus"
    ],
    id: "RUS"
  },
  {
    officialName: "Rwanda",
    allNames: [
      "rw",
      "republic of rwanda",
      "repubulika y'u rwanda",
      "république du rwanda",
      "rwanda",
      "rwa"
    ],
    id: "RWA"
  },
  {
    id: "BLM",
    officialName: "Saint Barthélemy",
    allNames: ["bl", "blm", "saint barthélemy", "saint barthelemy", "st barthelemy"]
  },
  {
    officialName: "Saint Helena",
    allNames: ["sh", "saint helena", "shn", "st helena", "ascension and tristan da cunha"],
    id: "SHN"
  },
  {
    officialName: "Saint Kitts and Nevis",
    allNames: [
      "kn",
      "federation of saint christopher and nevis",
      "saint kitts and nevis",
      "kna",
      "st kitts and nevis",
      "saint kitts-nevis",
      "st kitts-nevis"
    ],
    id: "KNA"
  },
  {
    officialName: "Saint Lucia",
    allNames: ["lc", "saint lucia", "lca", "st lucia"],
    id: "LCA"
  },
  {
    officialName: "Saint Pierre and Miquelon",
    allNames: [
      "pm",
      "collectivité territoriale de saint-pierre-et-miquelon",
      "saint pierre andmiquelon",
      "spm",
      "st pierre and miquelon",
      "saint pierre and miquelon",
      "st. pierre and miquelon"
    ],
    id: "SPM"
  },
  {
    officialName: "Saint Vincent and the Grenadines",
    allNames: ["vc", "saint vincent and the grenadines", "vct", "st vincent and the grenadines"],
    id: "VCT"
  },
  {
    officialName: "Samoa",
    allNames: [
      "ws",
      "independent state of samoa",
      "malo saʻoloto tutoʻatasi o sāmoa",
      "samoa",
      "wsm",
      "western samoa"
    ],
    id: "WSM"
  },
  {
    officialName: "San Marino",
    allNames: ["sm", "republic of san marino", "repubblica di san marino", "san marino", "smr"],
    id: "SMR"
  },
  {
    officialName: "São Tomé and Príncipe",
    allNames: [
      "st",
      "democratic republic of são tomé and príncipe",
      "república democrática de são tomé e príncipe",
      "são tomé and príncipe",
      "stp",
      "sao tome and principe",
      "sã£o tomã© and prã­ncipe"
    ],
    id: "STP"
  },
  {
    officialName: "Saudi Arabia",
    allNames: [
      "sa",
      "kingdom of saudi arabia",
      "al-mamlakah al-‘arabiyyah as-su‘ūdiyyah",
      "saudi arabia",
      "sau"
    ],
    id: "SAU"
  },
  {
    officialName: "Senegal",
    allNames: ["sn", "republic of senegal", "république du sénégal", "senegal", "sen"],
    id: "SEN"
  },
  {
    id: "SRB",
    officialName: "Serbia",
    allNames: ["rs", "srb", "serbia"]
  },
  {
    officialName: "Seychelles",
    allNames: [
      "sc",
      "republic of seychelles",
      "repiblik sesel",
      "république des seychelles",
      "seychelles",
      "syc"
    ],
    id: "SYC"
  },
  {
    officialName: "Sierra Leone",
    allNames: ["sl", "republic of sierra leone", "sierra leone", "sle"],
    id: "SLE"
  },
  {
    officialName: "Singapore",
    allNames: ["sg", "singapura", "republik singapura", "新加坡共和国", "singapore", "sgp"],
    id: "SGP"
  },
  {
    officialName: "Slovakia",
    allNames: [
      "sk",
      "slovak republic",
      "slovenská republika",
      "slovakia",
      "svk",
      "slovakia (slovak republic)"
    ],
    id: "SVK"
  },
  {
    officialName: "Slovenia",
    allNames: ["si", "republic of slovenia", "republika slovenija", "slovenia", "svn"],
    id: "SVN"
  },
  {
    officialName: "Solomon Islands",
    allNames: ["sb", "solomon islands", "slb"],
    id: "SLB"
  },
  {
    officialName: "Somalia",
    allNames: [
      "so",
      "aṣ-ṣūmāl",
      "federal republic of somalia",
      "jamhuuriyadda federaalka soomaaliya",
      "jumhūriyyat aṣ-ṣūmāl al-fiderāliyya",
      "somalia",
      "som"
    ],
    id: "SOM"
  },
  {
    officialName: "South Africa",
    allNames: ["za", "rsa", "suid-afrika", "republic of south africa", "south africa", "zaf"],
    id: "ZAF"
  },
  {
    officialName: "South Georgia",
    allNames: ["gs", "south georgia and the south sandwich islands", "south georgia", "sgs"],
    id: "SGS"
  },
  {
    officialName: "South Korea",
    allNames: [
      "kr",
      "republic of korea",
      "south korea",
      "kor",
      "korea,  republic of",
      "korea, south"
    ],
    id: "KOR"
  },
  {
    officialName: "South Sudan",
    allNames: ["ss", "south sudan", "ssd"],
    id: "SSD"
  },
  {
    officialName: "Spain",
    allNames: ["es", "kingdom of spain", "reino deespaña", "spain", "esp"],
    id: "ESP"
  },
  {
    officialName: "Sri Lanka",
    allNames: ["lk", "ilaṅkai", "democraticsocialist republic of sri lanka", "sri lanka", "lka"],
    id: "LKA"
  },
  {
    id: "SXM",
    officialName: "St Maarten",
    allNames: [
      "sx",
      "sxm",
      "st maarten",
      "sint maarten",
      "sint maarten (dutch part)",
      "saint-martin (pays-bas)"
    ]
  },
  {
    id: "MAF",
    officialName: "St Martin (French part)",
    allNames: [
      "mf",
      "maf",
      "st martin (french part)",
      "saint martin (french part)",
      "saint-martin (france)"
    ]
  },
  {
    officialName: "Sudan",
    allNames: ["sd", "republic of the sudan", "jumhūrīyat as-sūdān", "sudan", "sdn"],
    id: "SDN"
  },
  {
    officialName: "Suriname",
    allNames: [
      "sr",
      "sarnam",
      "sranangron",
      "republic of suriname",
      "republiek suriname",
      "suriname",
      "sur"
    ],
    id: "SUR"
  },
  {
    officialName: "Svalbard and Jan Mayen",
    allNames: ["sj", "svalbard and jan mayen islands", "svalbard and jan mayen", "sjm"],
    id: "SJM"
  },
  {
    officialName: "Swaziland",
    allNames: [
      "sz",
      "weswatini",
      "swatini",
      "ngwane",
      "kingdom of swaziland",
      "umbuso waseswatini",
      "swaziland",
      "swz"
    ],
    id: "SWZ"
  },
  {
    officialName: "Sweden",
    allNames: ["se", "kingdom of sweden", "konungariket sverige", "sweden", "swe"],
    id: "SWE"
  },
  {
    officialName: "Switzerland",
    allNames: [
      "ch",
      "swiss confederation",
      "schweiz",
      "suisse",
      "svizzera",
      "svizra",
      "switzerland",
      "che"
    ],
    id: "CHE"
  },
  {
    officialName: "Syria",
    allNames: [
      "sy",
      "syrian arab republic",
      "al-jumhūrīyah al-ʻarabīyah as-sūrīyah",
      "syria",
      "syr"
    ],
    id: "SYR"
  },
  {
    officialName: "Taiwan",
    allNames: [
      "tw",
      "táiwān",
      "republic of china",
      "中華民國",
      "zhōnghuá mínguó",
      "taiwan",
      "twn",
      "taiwan, province of china"
    ],
    id: "TWN"
  },
  {
    officialName: "Tajikistan",
    allNames: [
      "tj",
      "toçikiston",
      "republic of tajikistan",
      "ҷумҳурии тоҷикистон",
      "çumhuriyi toçikiston",
      "tajikistan",
      "tjk"
    ],
    id: "TJK"
  },
  {
    officialName: "Tanzania",
    allNames: [
      "tz",
      "united republic of tanzania",
      "jamhuri ya muungano wa tanzania",
      "tanzania",
      "tza",
      "united republic of"
    ],
    id: "TZA"
  },
  {
    officialName: "Thailand",
    allNames: [
      "th",
      "prathet",
      "thai",
      "kingdom of thailand",
      "ราชอาณาจักรไทย",
      "ratcha anachak thai",
      "thailand",
      "tha"
    ],
    id: "THA"
  },
  {
    officialName: "The Bahamas",
    allNames: ["bs", "commonwealth of the bahamas", "the bahamas", "bhs", "bahamas"],
    id: "BHS"
  },
  {
    officialName: "The Gambia",
    allNames: ["gm", "republic of the gambia", "the gambia", "gmb", "gambia"],
    id: "GMB"
  },
  {
    officialName: "Togo",
    allNames: ["tg", "togolese", "togolese republic", "république togolaise", "togo", "tgo"],
    id: "TGO"
  },
  {
    officialName: "Tokelau",
    allNames: ["tk", "tokelau", "tkl"],
    id: "TKL"
  },
  {
    officialName: "Tonga",
    allNames: ["to", "tonga", "ton"],
    id: "TON"
  },
  {
    officialName: "Trinidad and Tobago",
    allNames: ["tt", "republic of trinidad and tobago", "trinidad and tobago", "tto"],
    id: "TTO"
  },
  {
    officialName: "Tunisia",
    allNames: ["tn", "republic of tunisia", "al-jumhūriyyah at-tūnisiyyah", "tunisia", "tun"],
    id: "TUN"
  },
  {
    officialName: "Turkey",
    allNames: ["tr", "turkiye", "republic of turkey", "türkiye cumhuriyeti", "turkey", "tur"],
    id: "TUR"
  },
  {
    officialName: "Turkmenistan",
    allNames: ["tm", "turkmenistan", "tkm"],
    id: "TKM"
  },
  {
    id: "TCA",
    officialName: "Turks and Caicos Islands",
    allNames: ["tc", "tca", "turks and caicos islands"]
  },
  {
    officialName: "Tuvalu",
    allNames: ["tv", "tuvalu", "tuv"],
    id: "TUV"
  },
  {
    officialName: "Uganda",
    allNames: ["ug", "republic of uganda", "jamhuri ya uganda", "uganda", "uga"],
    id: "UGA"
  },
  {
    officialName: "Ukraine",
    allNames: ["ua", "ukrayina", "ukraine", "ukr"],
    id: "UKR"
  },
  {
    officialName: "United Arab Emirates",
    allNames: ["ae", "uae", "united arab emirates", "are"],
    id: "ARE"
  },
  {
    officialName: "United Kingdom",
    allNames: ["gb", "uk", "great britain", "united kingdom", "gbr", "britain", "england"],
    id: "GBR"
  },
  {
    officialName: "United States",
    allNames: ["us", "usa", "united states of america", "united states", "usa"],
    id: "USA"
  },
  {
    id: "UMI",
    officialName: "United States Minor Outlying Islands",
    allNames: ["um", "umi", "united states minor outlying islands"]
  },
  {
    officialName: "Uruguay",
    allNames: [
      "uy",
      "oriental republic of uruguay",
      "república oriental del uruguay",
      "uruguay",
      "ury"
    ],
    id: "URY"
  },
  {
    officialName: "Uzbekistan",
    allNames: [
      "uz",
      "republic of uzbekistan",
      "o‘zbekiston respublikasi",
      "ўзбекистон республикаси",
      "uzbekistan",
      "uzb"
    ],
    id: "UZB"
  },
  {
    officialName: "Vanuatu",
    allNames: [
      "vu",
      "republic of vanuatu",
      "ripablik blong vanuatu",
      "république de vanuatu",
      "vanuatu",
      "vut"
    ],
    id: "VUT"
  },
  {
    id: "VAT",
    officialName: "Vatican",
    allNames: [
      "va",
      "vat",
      "vatican",
      "vatican city",
      "vatican city state",
      "holy see (vatican city state)",
      "holy see [vatican city state]"
    ]
  },
  {
    officialName: "Venezuela",
    allNames: [
      "ve",
      "bolivarian republic of venezuela",
      "república bolivariana de venezuela",
      "venezuela",
      "ven",
      "bolivarian republic of"
    ],
    id: "VEN"
  },
  {
    officialName: "Vietnam",
    allNames: [
      "vn",
      "socialist republic of vietnam",
      "cộng hòa xã hội chủ nghĩa việt nam",
      "vietnam",
      "vnm",
      "viet nam"
    ],
    id: "VNM"
  },
  {
    id: "VGB",
    officialName: "Virgin Islands",
    allNames: [
      "vg",
      "vgb",
      "virgin islands",
      "british",
      "british virgin islands",
      "virgin islands (british)"
    ]
  },
  {
    id: "VIR",
    officialName: "Virgin Islands",
    allNames: [
      "vi",
      "vir",
      "virgin islands",
      "u.s.",
      "us virgin islands",
      "u.s. virgin islands",
      "virgin islands (u.s.)"
    ]
  },
  {
    officialName: "Wallis and Futuna",
    allNames: [
      "wf",
      "territory of the wallis and futuna islands",
      "territoire des îles wallis et futuna",
      "wallis and futuna",
      "wlf",
      "wallis and futuna islands"
    ],
    id: "WLF"
  },
  {
    officialName: "Western Sahara",
    allNames: ["eh", "taneẓroft tutrimt", "western sahara", "esh"],
    id: "ESH"
  },
  {
    officialName: "Yemen",
    allNames: ["ye", "yemeni republic", "al-jumhūriyyah al-yamaniyyah", "yemen", "yem"],
    id: "YEM"
  },
  {
    officialName: "Zambia",
    allNames: ["zm", "republic of zambia", "zambia", "zmb"],
    id: "ZMB"
  },
  {
    officialName: "Zimbabwe",
    allNames: ["zw", "republic of zimbabwe", "zimbabwe", "zwe"],
    id: "ZWE"
  }
], YCe = "#d6d9dc", ZCe = "#FBFAFA";
function XCe(e, t, n) {
  return e.reduce((o, i) => {
    const a = i.id;
    let s;
    if (n === "world") {
      const c = GCe.find(
        (l) => l.id === a
      );
      c ? s = t.find(
        (l) => c.allNames.includes(
          l.geoName.trim().toLowerCase()
        )
      ) : s = t.find(
        (l) => l.geoName.trim().toLowerCase() === i.properties.name.trim().toLowerCase()
      );
    } else
      s = t.find(
        (c) => c.geoName.trim().toLowerCase() === i.properties.name.trim().toLowerCase()
      );
    return o[a] = {
      geoDataElement: s,
      style: {
        color: YCe,
        weight: 1,
        opacity: 1,
        fillColor: s && s.color || ZCe,
        fillOpacity: 1
      },
      displayName: (s == null ? void 0 : s.geoName) || i.properties.name
    }, o;
  }, {});
}
const KCe = ({ geoJson: e, geoData: t, dataOptions: n, mapType: r }) => {
  const { themeSettings: o } = Yn(), i = it(null), a = it(null), [s] = Ge(Ii.layerGroup()), c = We(
    () => XCe(e.features, t, r),
    [e, t, r]
  );
  return mt(() => {
    i.current && !a.current && (a.current = t2e(i.current, r), s.addTo(a.current));
  }, [s, r]), mt(() => {
    const l = Ii.geoJSON(
      n2e(e, c),
      {
        style: (d) => c[d.id].style,
        onEachFeature: (d, f) => {
          f.bindTooltip(
            e2e(d, c, n.originalValueTitle),
            { sticky: !0 }
          ), f.on({
            mouseover: (p) => {
              const m = p.target;
              JCe(m, d.id, c);
            },
            mouseout: (p) => {
              const m = p.target;
              QCe(m, d.id, c);
            }
          }), n.onAreaClick && f.on({
            click: (p) => {
              const m = c[d.id].geoDataElement;
              m && n.onAreaClick(m, p.originalEvent);
            }
          });
        }
      }
    );
    a.current && (s.clearLayers(), s.addLayer(l), a.current.fitBounds(
      l.getBounds(),
      rL(o)
    ));
  }, [n, c, e, s, o]), /* @__PURE__ */ z(
    "div",
    {
      ref: i,
      className: "csdk-map-container",
      style: {
        width: "100%",
        height: "100%",
        minWidth: "300px",
        minHeight: "400px",
        backgroundColor: "#c2dbe9"
      }
    }
  );
};
function JCe(e, t, n) {
  if (n[t]) {
    const o = n[t].style.fillColor;
    e.setStyle({
      weight: 2,
      color: hc(o, -0.2),
      fillColor: hc(o, 0.05),
      dashArray: "",
      fillOpacity: 1,
      opacity: 1
    }), e.bringToFront();
  }
}
function QCe(e, t, n) {
  e.setStyle(n[t].style);
}
function e2e(e, t, n) {
  const r = t[e.id], { formattedOriginalValue: o } = r.geoDataElement || {};
  return `
  <div>
    <span>${r.displayName}<span>
    ${r.geoDataElement && o !== void 0 ? `<br/>${n}: <span>${o}<span>` : ""}
  </div>`;
}
function t2e(e, t) {
  return t === "world" ? Ii.map(e, {
    attributionControl: !1,
    scrollWheelZoom: !0,
    minZoom: 1,
    zoom: 1,
    maxZoom: 5,
    center: [0, 0]
  }) : Ii.map(e, {
    crs: new Ii.Proj.CRS(
      "EPSG:5070",
      "+proj=aea +lat_1=29.5 +lat_2=45.5 +lat_0=23 +lon_0=-96 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
      {
        resolutions: [16384, 10240, 8192, 4096]
      }
    ),
    center: [35.96852047262865, -96.96520768859223],
    zoom: 0.4,
    maxZoom: 3,
    attributionControl: !1
  });
}
function n2e(e, t) {
  if (t.ATA && t.ATA.geoDataElement)
    return e;
  {
    const n = e.features.filter((r) => r.id !== "ATA");
    return ge(se({}, e), {
      features: n
    });
  }
}
class dL {
  constructor(t, n) {
    Ln(this, "httpClient");
    Ln(this, "defaultDataSource");
    /**
     * Get all dashboards
     */
    Ln(this, "getDashboards", (t = {}) => {
      const { fields: n, expand: r, searchByTitle: o } = t, i = new URLSearchParams(se(se(se({}, o && { name: o }), (n == null ? void 0 : n.length) && { fields: n == null ? void 0 : n.join(",") }), (r == null ? void 0 : r.length) && { expand: r == null ? void 0 : r.join(",") })).toString();
      return this.httpClient.get(`api/v1/dashboards?${i}`);
    });
    /**
     * Get a specific dashboard
     */
    Ln(this, "getDashboard", (t, n = {}) => {
      const { fields: r } = n, o = new URLSearchParams(se({}, (r == null ? void 0 : r.length) && { fields: r == null ? void 0 : r.join(",") })).toString();
      return this.httpClient.get(`api/v1/dashboards/${t}?${o}`).catch(() => {
        throw new vt("errors.dashboardInvalidIdentifier");
      });
    });
    /**
     * Get all widgets of a specific dashboard
     */
    Ln(this, "getDashboardWidgets", (t) => this.httpClient.get(`api/v1/dashboards/${t}/widgets`).catch(() => {
      throw new vt("errors.dashboardWidgetsInvalidIdentifiers");
    }));
    /**
     * Get a specific widget from a dashboard
     */
    Ln(this, "getWidget", (t, n) => this.httpClient.get(`api/v1/dashboards/${n}/widgets/${t}`).catch(() => {
      throw new vt("errors.dashboardWidgetInvalidIdentifiers");
    }));
    /**
     * Get a GeoJSON data for all countries
     */
    Ln(this, "getCountriesGeoJson", () => this.httpClient.get("api/v1/geo/geojson/world"));
    /**
     * Get a GeoJSON data for all USA states
     */
    Ln(this, "getUsaStatesGeoJson", () => this.httpClient.get("api/v1/geo/geojson/usa"));
    /**
     * Get all palettes
     */
    Ln(this, "getPalettes", () => this.httpClient.get("api/palettes"));
    /**
     * Get hierarchies
     */
    Ln(this, "getHierarchies", ({
      dataSource: t = this.defaultDataSource,
      dimension: n,
      ids: r,
      alwaysIncluded: o
    }) => {
      const i = "granularity" in n;
      let a = "";
      if (!t)
        throw new vt("errors.missingDataSource");
      if (i) {
        const { level: c, dateTimeLevel: l } = n.translateGranularityToJaql();
        a = c != null ? c : l;
      }
      const s = new URLSearchParams(se(se(se({
        elasticube: y_(t),
        table: tF(n),
        column: nF(n)
      }, a && { dateLevel: a }), o && { alwaysIncluded: `${o}` }), (r == null ? void 0 : r.length) && { ids: r.join(",") })).toString();
      return this.httpClient.get(`/api/elasticubes/hierarchies?${s}`).then((c = []) => rF(o) && (r == null ? void 0 : r.length) ? c.filter(({ _id: d }) => r.includes(d)) : c);
    });
    /**
     * Partially update a dashboard
     */
    Ln(this, "patchDashboard", (t, n) => this.httpClient.patch(`api/v1/dashboards/${t}`, n));
    if (!t)
      throw new vt("errors.httpClientNotFound");
    this.httpClient = t, this.defaultDataSource = n;
  }
}
const r2e = () => {
  const { app: e } = Gn();
  return We(() => new dL(e == null ? void 0 : e.httpClient, e == null ? void 0 : e.defaultDataSource), [e]);
}, o2e = (e) => {
  const t = r2e(), [n, r] = Ge(), [o, i] = Ge(), a = l2e();
  return mt(() => {
    if (!a)
      return;
    Mo(void 0, null, function* () {
      try {
        const c = c2e(e, a), l = i2e(c);
        if (l)
          r(l);
        else {
          u2e(e);
          let d;
          switch (e) {
            case "world":
              d = t.getCountriesGeoJson;
              break;
            case "usa":
              d = t.getUsaStatesGeoJson;
              break;
            default:
              throw new vt("errors.unsupportedMapType", { mapType: e });
          }
          const f = yield d();
          if (!f)
            throw new vt("errors.mapLoadingFailed");
          const p = e === "world" ? s2e(f) : f;
          a2e(p, c), r(p);
        }
      } catch (c) {
        i(c);
      }
    });
  }, [t, e, a]), { geoJson: n, error: o };
};
function i2e(e) {
  const t = localStorage.getItem(e);
  if (t)
    return JSON.parse(t);
}
function a2e(e, t) {
  localStorage.setItem(t, JSON.stringify(e));
}
function s2e(e) {
  const t = Li(e);
  return t.features.forEach((n) => {
    var r;
    n.id === "-99" && (n.id = (r = n.properties) == null ? void 0 : r.name);
  }), t;
}
function l2e() {
  const { app: e } = Gn();
  return e == null ? void 0 : e.settings.serverVersion;
}
function c2e(e, t) {
  return `geoJson_${e}_${t}`;
}
function u2e(e) {
  Object.keys(localStorage).forEach((n) => {
    n.startsWith(`geoJson_${e}`) && localStorage.removeItem(n);
  });
}
function d2e(e, t) {
  const n = {};
  return t.geo && (n.geo = [
    ge(se({}, zt("geo.0", t.geo)), {
      value: e.geoName
    })
  ]), t.color && (n.color = [
    ge(se({}, zt("color.0", t.color)), {
      value: e.originalValue
    })
  ]), ge(se({}, e), {
    entries: n
  });
}
const f2e = ({
  chartData: e,
  dataOptions: t,
  designOptions: n,
  onDataPointClick: r
}) => {
  var c, l;
  const { themeSettings: o } = Yn(), { geoJson: i } = o2e(n.mapType), a = We(() => t.color ? e.geoData : e.geoData.map((d) => ge(se({}, d), {
    color: ad(o.palette.variantColors, 0)
  })), [e.geoData, t, o]), s = bt(
    (d, f) => {
      if (!r)
        return;
      const p = d2e(d, t);
      r(p, f);
    },
    [t, r]
  );
  return /* @__PURE__ */ z(fo, { children: i && /* @__PURE__ */ z(
    KCe,
    {
      geoJson: i,
      geoData: a,
      dataOptions: {
        originalValueTitle: ((c = t.color) == null ? void 0 : c.column.title) || ((l = t.color) == null ? void 0 : l.column.name) || "",
        onAreaClick: s
      },
      mapType: n.mapType
    }
  ) });
}, fL = (e) => e.type === "areamap" && "geoData" in e, p2e = (e) => "geo" in e, h2e = (e) => "mapType" in e, m2e = (e) => !!e.chartData && fL(e.chartData) && p2e(e.dataOptions) && h2e(e.designOptions), Dp = ({
  isVisible: e,
  themeSettings: t,
  children: n
}) => /* @__PURE__ */ _e("div", { id: "overlay", className: "csdk-relative csdk-h-full", children: [
  e && // z-index is set to 401, which is higher than max z-index of 400 on areamap
  /* @__PURE__ */ z(
    "div",
    {
      className: "csdk-absolute csdk-h-full csdk-w-full csdk-z-[401] csdk-opacity-80",
      "aria-label": "csdk-loading-overlay",
      children: /* @__PURE__ */ z("div", { className: "csdk-h-full csdk-bg-transparent", children: /* @__PURE__ */ z(
        "div",
        {
          className: "csdk-h-full csdk-flex csdk-flex-col csdk-gap-y-4 csdk-items-center csdk-justify-center csdk-bg-transparent",
          children: /* @__PURE__ */ z(
            "div",
            {
              style: { backgroundColor: t.general.backgroundColor },
              className: "csdk-p-1.5 csdk-bg-background-priority csdk-rounded-full",
              children: /* @__PURE__ */ z(CI, { color: t == null ? void 0 : t.chart.textColor })
            }
          )
        }
      ) })
    }
  ),
  n
] });
function G1(e, t, n = QD(), r = mI) {
  const o = /* @__PURE__ */ new Map();
  return [
    ...t.breakBy ? t.breakBy : [],
    ...t.x ? Array.isArray(t.x) ? t.x : [t.x] : [],
    ...t.columns ? t.columns : []
  ].forEach(function(a) {
    if (wr(a) || !a.dateFormat)
      return;
    const s = e.columns.findIndex(function(l) {
      return l.name === a.column.name && dh(a.column.type) && dh(l.type);
    });
    s !== -1 && o.set(s, a.dateFormat);
  }), o.size === 0 || (e.rows = e.rows.map(function(a) {
    return a.map(function(c, l) {
      const d = o.get(l);
      if (!d)
        return c;
      let f, p;
      if (oF(c))
        f = se({}, c);
      else {
        const v = yO(`${c}`, "datetime");
        p = new Date(v.value), f = { data: p.toISOString(), text: `${c}` };
      }
      if (!f.data)
        return c;
      let m = f.text;
      try {
        m = Bw(aO(f.data), d, n, r);
      } catch (v) {
        console.error(v);
      }
      return f.text = m, f;
    });
  })), e;
}
function g2e(e, t) {
  return b2e(e, t);
}
const v2e = {
  pie: {
    category: 3,
    value: 1
  },
  funnel: {
    category: 1,
    value: 1
  },
  treemap: {
    category: 3,
    value: 1
  },
  sunburst: {
    category: 6,
    value: 1
  }
};
function b2e(e, t) {
  const n = v2e[e];
  t.category.length > n.category && console.warn(
    `Maximum 'category' length is limited to ${n.category} for '${e}' chart. Taken first ${n.category} categories`
  );
  const r = t.category.slice(0, n.category);
  let o = t.value;
  return (e !== "pie" || t.category.length > 0) && (t.value.length > n.value && console.warn(
    `Maximum 'value' length is limited to ${n.value} for '${e}' chart. Taken first ${n.value} values`
  ), o = t.value.slice(0, n.value)), ge(se({}, t), {
    category: r,
    value: o
  });
}
const pL = (e) => {
  const t = {}, n = (r) => `$measure${r}_`;
  return e.forEach((r, o) => {
    const i = r.name, s = `${n(o)}${i}`;
    r.name = s, t[s] = i;
  }), t;
}, y2e = (e, t) => {
  if (t === "funnel") {
    const n = Ci(e);
    if (n.breakBy.length > 0 && n.breakBy[0].sortType === void 0 && n.y.length > 0 && n.y[0].sortType === void 0)
      return n.y[0].sortType = "sortDesc", n;
  }
  return e;
}, hL = (e, t, n, r, o, i) => {
  if (t.length + n.length === 0)
    throw new vt("errors.dataOptions.noDimensionsAndMeasures");
  return t.forEach((a) => {
    if (e.columns.findIndex((c) => c.name === a.name) === -1)
      throw new vt("errors.dataOptions.attributeNotFound", {
        attributeName: a.name
      });
  }), n.forEach((a) => {
    if (e.columns.findIndex(
      (c) => c.name === a.name || c.name === r[a.name]
    ) === -1)
      throw new vt("errors.dataOptions.measureNotFound", {
        measureName: r[a.name]
      });
  }), o && o.forEach((a) => {
    if (e.columns.findIndex((c) => c.name === a.attribute.name) === -1)
      throw new vt("errors.dataOptions.filterAttributeNotFound", {
        attributeName: a.attribute.name
      });
  }), i && i.forEach((a) => {
    if (e.columns.findIndex((c) => c.name === a.attribute.name) === -1)
      throw new vt("errors.dataOptions.highlightAttributeNotFound", {
        attributeName: a.attribute.name
      });
  }), !0;
};
function _2e(e, t) {
  switch (e) {
    case "pie":
    case "funnel":
    case "treemap":
      return g2e(
        e,
        t
      );
    default:
      return t;
  }
}
const mL = () => {
  const [e, t] = Ge();
  if (e)
    throw e;
  return t;
}, w2e = (e, t) => {
  switch (t) {
    case "iqr":
      return WF(e);
    case "extremums":
      return VF(e);
    case "standardDeviation":
      return UF(e);
  }
}, x2e = (e, t) => {
  switch (t) {
    case "iqr":
      return qF(e);
    case "standardDeviation":
      return GF(e);
  }
}, C2e = (e, t, n) => {
  const { column: r, style: o } = iF(e);
  let i = w2e(
    r,
    t
  ), a;
  return o && (i = i.map(
    (s) => se({
      column: s
    }, o)
  )), n && (a = x2e(r, t), a && o && (a = se({
    column: a
  }, o))), {
    values: i,
    outliers: a
  };
}, S2e = (e) => e.value.length > 1, gL = (e) => {
  var f;
  const { category: t } = e;
  let n, r, o;
  if (S2e(e))
    n = e.value, o = e.valueTitle, r = (f = e.outliers) == null ? void 0 : f[0];
  else {
    const { outliersEnabled: p, boxType: m } = e, v = Wr(e.value[0]), { values: g, outliers: b } = C2e(
      v,
      m,
      !!p
    );
    n = g, r = b, o = sd(v);
  }
  const [i, a, s, c, l, d] = n;
  return {
    category: t[0] && Wr(t[0]),
    boxMin: i && zn(i),
    boxMedian: a && zn(a),
    boxMax: s && zn(s),
    whiskerMin: c && zn(c),
    whiskerMax: l && zn(l),
    outliersCount: d && zn(d),
    outliers: r && Wr(r),
    valueTitle: o
  };
}, T2e = 2e4;
function Uu(e, t) {
  if (t) {
    const n = t.column.name, r = e.findIndex((o) => o.name === n);
    return r === -1 ? null : r;
  }
  return null;
}
const vL = (e, t, n) => {
  let r = 0, o = 4, i = 5, a = 0, s = 1;
  return n && (r = Uu(e.columns, n.category), o = Uu(e.columns, n.whiskerMin), i = Uu(e.columns, n.whiskerMax), a = Uu(t.columns, n.category), s = Uu(t.columns, n.outliers)), lh(s) ? e : {
    columns: [...e.columns, t.columns[s]],
    rows: e.rows.map((l) => {
      const d = lh(r) ? null : l[r].data, f = l[i].data, p = l[o].data, m = t.rows.filter((v) => {
        const g = lh(a) ? null : v[a].data, b = v[s].data;
        return g === d && // manually removes points located between the whiskers, due to the back-end issue that returns incorrect points
        (b < p || b > f);
      }).map((v) => v[s].data).join(",");
      return [
        ...l,
        {
          data: m
        }
      ];
    })
  };
};
function m$e(e, t, n) {
  const r = n && gL(n);
  return vL(e, t, r);
}
const E2e = (c, l) => Mo(void 0, [c, l], function* ({
  app: e,
  chartDataOptions: t,
  dataSource: n,
  attributes: r,
  measures: o,
  filters: i,
  highlights: a
}, s) {
  var v;
  const d = {
    dataSource: n,
    dimensions: t.category ? [r[0]] : [],
    measures: o,
    filters: i,
    highlights: a
  }, f = yield s(d, e);
  let p = f;
  const m = t.outliersCount ? k2e(f, t.outliersCount.column.name) : 0;
  if (t.outliers && m < T2e) {
    const g = {
      dataSource: n,
      dimensions: r,
      measures: [],
      filters: i,
      highlights: a
    };
    try {
      const b = yield s(g, e);
      p = vL(
        f,
        b,
        t
      );
    } catch (b) {
      if ((v = b == null ? void 0 : b.message) != null && v.includes("UnsupportedFunctionalityException"))
        console.warn("Functionality not supported by platform: Boxplot outliers");
      else
        throw b;
    }
  }
  return p;
}), k2e = (e, t) => {
  const n = e.columns.findIndex(
    ({ name: o }) => o === t
  );
  let r = 0;
  return e.rows.forEach((o) => {
    r += parseInt(o[n].data);
  }), r;
}, M2e = (e) => e === "funnel" ? e : aF(e), R2e = (e, t, n, r, o, i, a, s, c, l) => {
  var x;
  const d = mL(), f = We(() => M2e(n), [n]), p = We(() => [void 0, t], [t]), [m, v] = Ge({}), { app: g } = Gn(), b = (x = g == null ? void 0 : g.settings.queryCacheConfig) != null && x.enabled ? gI : Cg;
  return mt(() => {
    let T = !1;
    const { filters: S, relations: _ } = b_(a);
    if (ss(e)) {
      if (!g)
        return;
      let w;
      n === "boxplot" ? w = E2e(
        {
          app: g,
          chartDataOptions: t,
          dataSource: e,
          attributes: r,
          measures: o,
          filters: S,
          highlights: s
        },
        b
      ) : w = b(
        {
          dataSource: e,
          dimensions: r,
          measures: o,
          filters: S,
          filterRelations: _,
          highlights: s,
          count: g.settings.queryLimit
        },
        g
      );
      const k = g == null ? void 0 : g.settings.loadingIndicatorConfig, E = setTimeout(() => {
        k != null && k.enabled && (l == null || l(!0));
      }, k == null ? void 0 : k.delay);
      w.then((R) => {
        const P = G1(
          R,
          t,
          g == null ? void 0 : g.settings.locale,
          g == null ? void 0 : g.settings.dateConfig
        );
        T || v({ [f]: [P, t] });
      }).catch((R) => {
        d(R);
      }).finally(() => {
        clearTimeout(E), k != null && k.enabled && (l == null || l(!1));
      });
    } else {
      hL(
        e,
        r,
        o,
        i,
        S,
        s
      );
      const w = G1(
        e,
        t,
        g == null ? void 0 : g.settings.locale,
        g == null ? void 0 : g.settings.dateConfig
      );
      v({ [f]: [w, t] });
    }
    return () => {
      T = !0;
    };
  }, [n, t, e, a, s, g, c]), m[f] || p;
}, $R = {
  city: 4,
  state: 3,
  country: 2,
  auto: 1
};
function P2e(e) {
  return e.filter((n) => "geoLevel" in n && n.geoLevel).map((n) => n.geoLevel).reduce((n, r) => $R[r] > $R[n] ? r : n, "auto");
}
function O2e(e) {
  const { geo: t, size: n, colorBy: r, details: o } = e;
  return {
    locations: t.map(Wr),
    size: n && zn(n),
    colorBy: r && zn(r),
    details: o && ld(o),
    locationLevel: P2e(t)
  };
}
function N2e(e) {
  var i;
  const t = e.value.map((a) => {
    if (a != null && a.chartType)
      return [zn(a)];
    const f = a, { lowerBound: s, upperBound: c, title: l } = f, d = xl(f, ["lowerBound", "upperBound", "title"]);
    return [
      zn(se({
        column: Eb(s, { title: l })
      }, d)),
      zn(se({
        column: Eb(c, { title: l })
      }, d))
    ];
  }), n = t.flat(), r = t.filter((a) => a.length === 2), o = t.filter((a) => a.length === 1).flat();
  return {
    x: e.category.map(Wr),
    breakBy: ((i = e.breakBy) == null ? void 0 : i.map(Wr)) || [],
    y: n,
    rangeValues: r,
    seriesValues: o,
    seriesToColorMap: e.seriesToColorMap
  };
}
function A2e(e, t) {
  if (_a(e))
    return D2e(t);
  if (zc(e))
    return I2e(t);
  if (Cm(e))
    return L2e(t);
  if (ca(e))
    return $2e(t);
  if (il(e))
    return gL(
      t
    );
  if (Hc(e))
    return F2e(t);
  if (Bc(e))
    return O2e(t);
  if (jc(e))
    return N2e(t);
  throw new vt("errors.unexpectedChartType", { chartType: e });
}
const D2e = (e) => {
  var t;
  return {
    x: e.category.map(Wr),
    y: e.value.map(zn),
    // breakBy may be undefined. If so, default to empty array
    breakBy: ((t = e.breakBy) == null ? void 0 : t.map(Wr)) || [],
    seriesToColorMap: e.seriesToColorMap
  };
}, I2e = (e) => ({
  y: e.value.map(zn),
  breakBy: e.category.map(Wr),
  seriesToColorMap: e.seriesToColorMap
}), L2e = (e) => {
  var t, n, r, o, i, a;
  return {
    value: (t = e.value) == null ? void 0 : t.map(zn),
    secondary: (n = e.secondary) == null ? void 0 : n.map(zn),
    min: (o = (r = e.min) == null ? void 0 : r.map(zn)) == null ? void 0 : o.map(FR("min")),
    max: (a = (i = e.max) == null ? void 0 : i.map(zn)) == null ? void 0 : a.map(FR("max"))
  };
}, FR = (e) => (t) => {
  const { column: n } = t, r = "aggregation" in n && n.aggregation || e;
  return ge(se({}, t), {
    column: Eb(n, { aggregation: r })
  });
}, $2e = (e) => {
  const { x: t, y: n, breakByPoint: r, breakByColor: o, size: i, seriesToColorMap: a } = e;
  return {
    x: t && ld(t),
    y: n && ld(n),
    breakByPoint: r && Wr(r),
    breakByColor: o && ld(o),
    size: i && zn(i),
    seriesToColorMap: a
  };
}, F2e = (e) => ({
  geo: e.geo && Wr(e.geo[0]),
  color: e.color && zn(e.color[0])
});
function z2e(e, t) {
  let n = [];
  return ca(t) ? n = ["x", "y", "breakByPoint", "breakByColor"] : _a(t) || zc(t) || jc(t) ? n = ["x", "breakBy"] : il(t) ? n = ["category", "outliers"] : Hc(t) ? n = ["geo"] : Bc(t) && (n = ["locations"]), n.flatMap((o) => {
    var i;
    return (i = e[o]) != null ? i : [];
  }).filter((o) => !wr(o)).map(({ column: o }) => o);
}
function B2e(e, t) {
  let n = [];
  return Cm(t) ? n = ["value", "secondary", "min", "max"] : ca(t) ? n = ["x", "y", "breakByColor", "size"] : _a(t) || zc(t) || jc(t) ? n = ["y"] : il(t) ? n = [
    "boxMin",
    "boxMedian",
    "boxMax",
    "whiskerMin",
    "whiskerMax",
    "outliersCount"
  ] : Hc(t) ? n = ["color"] : Bc(t) && (n = ["size", "colorBy", "details"]), n.flatMap((o) => {
    var i;
    return (i = e[o]) != null ? i : [];
  }).filter(wr).map(({ column: o }) => o);
}
function H2e(e) {
  return {
    columns: e.columns.map(ld)
  };
}
function g$e(e) {
  var t, n, r;
  return {
    rows: (t = e.rows) == null ? void 0 : t.map(Wr),
    columns: (n = e.columns) == null ? void 0 : n.map(Wr),
    values: (r = e.values) == null ? void 0 : r.map(zn),
    grandTotals: e.grandTotals
  };
}
function j2e(e, t) {
  {
    const n = _2e(t, e), r = A2e(
      t,
      n
    ), o = y2e(r, t), i = z2e(o, t), a = B2e(o, t);
    return {
      dataOptions: o,
      attributes: i,
      measures: a
    };
  }
}
const W2e = (e, t) => We(() => {
  const { dataOptions: n, attributes: r, measures: o } = j2e(
    e,
    t
  ), i = pL(o);
  return {
    dataOptions: n,
    attributes: r,
    measures: o,
    dataColumnNamesMapping: i
  };
}, [e, t]);
function V2e(e) {
  const {
    dataSet: t,
    chartType: n,
    chartData: r,
    internalDataOptions: o,
    designOptions: i,
    onBeforeRender: a,
    onDataPointClick: s,
    onDataPointContextMenu: c,
    onDataPointsSelected: l,
    filters: d
  } = e;
  return !o || !i ? null : {
    dataSource: ss(t) ? t : null,
    chartType: n,
    chartData: r,
    dataOptions: o,
    designOptions: i,
    onBeforeRender: a,
    onDataPointClick: s,
    onDataPointContextMenu: c,
    onDataPointsSelected: l,
    filters: d
  };
}
const U2e = (e) => e === "indicator", q2e = (e, t) => e === "scatter" && "scatterDataTable" in t ? t.scatterDataTable.length === 0 : e === "areamap" && fL(t) ? t.geoData.length === 0 : e === "scattermap" && oL(t) ? t.locations.length === 0 : e === "boxplot" && R_e(t) ? t.xValues.length === 0 : "series" in t && t.series.length === 0, Y1 = (e) => {
  const {
    chartType: t,
    dataSet: n,
    dataOptions: r,
    filters: o,
    highlights: i,
    styleOptions: a,
    refreshCounter: s,
    onDataPointClick: c,
    onDataPointContextMenu: l,
    onDataPointsSelected: d,
    onBeforeRender: f,
    onDataReady: p
  } = e, [m, v] = Ge(!1), g = _x(t), { themeSettings: b } = Yn(), {
    dataOptions: x,
    attributes: T,
    measures: S,
    dataColumnNamesMapping: _
  } = W2e(r, t), [w, k] = R2e(
    n,
    x,
    t,
    T,
    S,
    _,
    o,
    i,
    s,
    v
  ), E = We(() => r ? sF(t, k, a) : null, [r, t, k, a]), R = We(() => {
    if (!w || !r)
      return null;
    let A;
    if (p && (A = p(w), !G2e(A)))
      throw new vt("errors.incorrectOnDataReadyHandler");
    let N = _O(A || w);
    return ss(n) || (N = K5(
      N,
      T,
      S,
      _
    )), Nwe(t, k, N);
  }, [w, t]), P = V2e({
    dataSet: n,
    chartType: t,
    chartData: R,
    internalDataOptions: k,
    designOptions: E,
    onBeforeRender: f,
    onDataPointClick: c,
    onDataPointContextMenu: l,
    onDataPointsSelected: d,
    filters: o
  });
  return P ? /* @__PURE__ */ z(
    Vg,
    {
      defaultSize: g,
      size: {
        width: a == null ? void 0 : a.width,
        height: a == null ? void 0 : a.height
      },
      rerenderOnResize: U2e(t),
      children: () => R ? q2e(t, R) ? /* @__PURE__ */ z(cL, { iconType: t }) : t === "scattermap" && oCe(P) ? /* @__PURE__ */ z(Dp, { themeSettings: b, isVisible: m, children: /* @__PURE__ */ z(tCe, se({}, P)) }) : t === "indicator" && Exe(P) ? /* @__PURE__ */ z(Dp, { themeSettings: b, isVisible: m, children: /* @__PURE__ */ z(xxe, se({}, P)) }) : t === "areamap" && m2e(P) ? /* @__PURE__ */ z(Dp, { themeSettings: b, isVisible: m, children: /* @__PURE__ */ z(f2e, se({}, P)) }) : lL(t) && TCe(P) ? /* @__PURE__ */ z(Dp, { themeSettings: b, isVisible: m, children: /* @__PURE__ */ z(
        CCe,
        ge(se({}, P), {
          designOptions: se({}, P.designOptions)
        })
      ) }) : null : /* @__PURE__ */ z(qw, { themeSettings: b })
    }
  ) : null;
};
function G2e(e) {
  return e && typeof e == "object" && "columns" in e && ph(e.columns) && "rows" in e && ph(e.rows);
}
const Y2e = (e) => {
  const t = [], n = [];
  for (const r of e.columns)
    wr(r) ? n.push(__(r)) : t.push(ua(r));
  return { attributes: t, measures: n };
}, Z2e = ({
  dataSet: e,
  dataOptions: t,
  filters: n,
  filterRelations: r,
  count: o,
  offset: i
}) => {
  const a = mL(), [s, c] = Ge(ss(e) ? null : e), [l, d] = Ge(!1), f = it(!0), { isInitialized: p, app: m } = Gn(), [v, g] = Ge(t);
  return mt(() => {
    var S;
    let b = !1;
    if (!t)
      return;
    const { attributes: x, measures: T } = Y2e(t);
    if (ss(e)) {
      if (!p) {
        a(new vt("errors.chartNoSisenseContext"));
        return;
      }
      if (!m || !f.current && i > 0)
        return;
      d(!0), ((S = m.settings.queryCacheConfig) != null && S.enabled ? gI : Cg)(
        {
          dataSource: e,
          dimensions: x,
          measures: T,
          filters: n,
          filterRelations: r,
          count: o + 1,
          offset: i,
          // ungroup is needed so query without aggregation returns correct result
          ungroup: !0
        },
        m
      ).then((w) => {
        if (b)
          return;
        f.current = w.rows.length > o;
        const k = f.current ? w.rows.slice(0, o) : w.rows;
        i > 0 ? c((E) => {
          const R = E == null ? void 0 : E.rows.length, P = R ? R > i ? E.rows.slice(0, i) : E.rows : null;
          return {
            columns: w.columns,
            rows: P ? [...P, ...k] : k
          };
        }) : c({
          columns: w.columns,
          rows: k
        }), g(t);
      }).finally(() => {
        d(!1);
      }).catch((w) => {
        b || a(w);
      });
    } else
      c(e), g(t);
    return () => {
      b = !0;
    };
  }, [
    m,
    e,
    t,
    n,
    r,
    i,
    o,
    p,
    a
  ]), [l ? null : s, v];
}, X2e = (e, t) => {
  if (cO(t))
    return { rows: [], columns: [] };
  const n = v_(t, e);
  return lF(t, n);
}, Z1 = ({
  column: e,
  sortType: t
}) => {
  switch ("getSort" in e ? e.getSort() : t) {
    case "sortAsc":
    case ts.Ascending:
      return 1;
    case "sortDesc":
    case ts.Descending:
      return -1;
    default:
      return 0;
  }
}, K2e = (e, t) => {
  const n = e.columns.find((r) => Z1(r) !== 0);
  if (n) {
    const r = Mr(t, n.column.name);
    r && (r.direction = Z1(n));
  }
  return t;
}, J2e = (e, t) => ({
  columns: e.columns.map((n) => {
    const r = n.column.name === t.name, o = Z1(n), i = o === 1 ? "sortDesc" : "sortAsc", a = o === 1 ? ts.Descending : ts.Ascending;
    return ge(se({}, n), {
      sortType: r ? i : "sortNone",
      column: "sort" in n.column ? n.column.sort(
        r ? a : ts.None
      ) : n.column
    });
  })
}), Q2e = (e, t) => {
  const n = X2e(
    e.columns.map(({ column: { name: r } }) => r),
    t
  );
  return K2e(e, n);
}, eSe = ({
  data: e,
  innerDataOptions: t,
  dataColumnNamesMapping: n,
  needToAggregate: r = !1
}) => {
  const { app: o } = Gn();
  return We(() => {
    if (!e || !t)
      return null;
    let i = _O(
      G1(e, t, o == null ? void 0 : o.settings.locale, o == null ? void 0 : o.settings.dateConfig)
    );
    const a = t.columns.filter((c) => !wr(c)).map(ua), s = t.columns.filter((c) => wr(c)).map(__);
    return hL(i, a, s, n), r && (i = K5(i, a, s, n)), Q2e(t, i);
  }, [e, t, r, n, o]);
};
var bL = {}, yL = {};
function zR(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function BR(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? zR(Object(n), !0).forEach(function(r) {
      qie(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : zR(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function cr(e) {
  return "Minified Redux error #" + e + "; visit https://redux.js.org/Errors?code=" + e + " for the full message or use the non-minified dev environment for full errors. ";
}
var HR = function() {
  return typeof Symbol == "function" && Symbol.observable || "@@observable";
}(), gb = function() {
  return Math.random().toString(36).substring(7).split("").join(".");
}, os = {
  INIT: "@@redux/INIT" + gb(),
  REPLACE: "@@redux/REPLACE" + gb(),
  PROBE_UNKNOWN_ACTION: function() {
    return "@@redux/PROBE_UNKNOWN_ACTION" + gb();
  }
};
function _L(e) {
  if (typeof e != "object" || e === null)
    return !1;
  for (var t = e; Object.getPrototypeOf(t) !== null; )
    t = Object.getPrototypeOf(t);
  return Object.getPrototypeOf(e) === t;
}
function tSe(e) {
  if (e === void 0)
    return "undefined";
  if (e === null)
    return "null";
  var t = typeof e;
  switch (t) {
    case "boolean":
    case "string":
    case "number":
    case "symbol":
    case "function":
      return t;
  }
  if (Array.isArray(e))
    return "array";
  if (oSe(e))
    return "date";
  if (rSe(e))
    return "error";
  var n = nSe(e);
  switch (n) {
    case "Symbol":
    case "Promise":
    case "WeakMap":
    case "WeakSet":
    case "Map":
    case "Set":
      return n;
  }
  return t.slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function nSe(e) {
  return typeof e.constructor == "function" ? e.constructor.name : null;
}
function rSe(e) {
  return e instanceof Error || typeof e.message == "string" && e.constructor && typeof e.constructor.stackTraceLimit == "number";
}
function oSe(e) {
  return e instanceof Date ? !0 : typeof e.toDateString == "function" && typeof e.getDate == "function" && typeof e.setDate == "function";
}
function Ha(e) {
  var t = typeof e;
  return process.env.NODE_ENV !== "production" && (t = tSe(e)), t;
}
function wx(e, t, n) {
  var r;
  if (typeof t == "function" && typeof n == "function" || typeof n == "function" && typeof arguments[3] == "function")
    throw new Error(process.env.NODE_ENV === "production" ? cr(0) : "It looks like you are passing several store enhancers to createStore(). This is not supported. Instead, compose them together to a single function. See https://redux.js.org/tutorials/fundamentals/part-4-store#creating-a-store-with-enhancers for an example.");
  if (typeof t == "function" && typeof n == "undefined" && (n = t, t = void 0), typeof n != "undefined") {
    if (typeof n != "function")
      throw new Error(process.env.NODE_ENV === "production" ? cr(1) : "Expected the enhancer to be a function. Instead, received: '" + Ha(n) + "'");
    return n(wx)(e, t);
  }
  if (typeof e != "function")
    throw new Error(process.env.NODE_ENV === "production" ? cr(2) : "Expected the root reducer to be a function. Instead, received: '" + Ha(e) + "'");
  var o = e, i = t, a = [], s = a, c = !1;
  function l() {
    s === a && (s = a.slice());
  }
  function d() {
    if (c)
      throw new Error(process.env.NODE_ENV === "production" ? cr(3) : "You may not call store.getState() while the reducer is executing. The reducer has already received the state as an argument. Pass it down from the top reducer instead of reading it from the store.");
    return i;
  }
  function f(g) {
    if (typeof g != "function")
      throw new Error(process.env.NODE_ENV === "production" ? cr(4) : "Expected the listener to be a function. Instead, received: '" + Ha(g) + "'");
    if (c)
      throw new Error(process.env.NODE_ENV === "production" ? cr(5) : "You may not call store.subscribe() while the reducer is executing. If you would like to be notified after the store has been updated, subscribe from a component and invoke store.getState() in the callback to access the latest state. See https://redux.js.org/api/store#subscribelistener for more details.");
    var b = !0;
    return l(), s.push(g), function() {
      if (b) {
        if (c)
          throw new Error(process.env.NODE_ENV === "production" ? cr(6) : "You may not unsubscribe from a store listener while the reducer is executing. See https://redux.js.org/api/store#subscribelistener for more details.");
        b = !1, l();
        var T = s.indexOf(g);
        s.splice(T, 1), a = null;
      }
    };
  }
  function p(g) {
    if (!_L(g))
      throw new Error(process.env.NODE_ENV === "production" ? cr(7) : "Actions must be plain objects. Instead, the actual type was: '" + Ha(g) + "'. You may need to add middleware to your store setup to handle dispatching other values, such as 'redux-thunk' to handle dispatching functions. See https://redux.js.org/tutorials/fundamentals/part-4-store#middleware and https://redux.js.org/tutorials/fundamentals/part-6-async-logic#using-the-redux-thunk-middleware for examples.");
    if (typeof g.type == "undefined")
      throw new Error(process.env.NODE_ENV === "production" ? cr(8) : 'Actions may not have an undefined "type" property. You may have misspelled an action type string constant.');
    if (c)
      throw new Error(process.env.NODE_ENV === "production" ? cr(9) : "Reducers may not dispatch actions.");
    try {
      c = !0, i = o(i, g);
    } finally {
      c = !1;
    }
    for (var b = a = s, x = 0; x < b.length; x++) {
      var T = b[x];
      T();
    }
    return g;
  }
  function m(g) {
    if (typeof g != "function")
      throw new Error(process.env.NODE_ENV === "production" ? cr(10) : "Expected the nextReducer to be a function. Instead, received: '" + Ha(g));
    o = g, p({
      type: os.REPLACE
    });
  }
  function v() {
    var g, b = f;
    return g = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function(T) {
        if (typeof T != "object" || T === null)
          throw new Error(process.env.NODE_ENV === "production" ? cr(11) : "Expected the observer to be an object. Instead, received: '" + Ha(T) + "'");
        function S() {
          T.next && T.next(d());
        }
        S();
        var _ = b(S);
        return {
          unsubscribe: _
        };
      }
    }, g[HR] = function() {
      return this;
    }, g;
  }
  return p({
    type: os.INIT
  }), r = {
    dispatch: p,
    subscribe: f,
    getState: d,
    replaceReducer: m
  }, r[HR] = v, r;
}
var iSe = wx;
function jR(e) {
  typeof console != "undefined" && typeof console.error == "function" && console.error(e);
  try {
    throw new Error(e);
  } catch (t) {
  }
}
function aSe(e, t, n, r) {
  var o = Object.keys(t), i = n && n.type === os.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
  if (o.length === 0)
    return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
  if (!_L(e))
    return "The " + i + ' has unexpected type of "' + Ha(e) + '". Expected argument to be an object with the following ' + ('keys: "' + o.join('", "') + '"');
  var a = Object.keys(e).filter(function(s) {
    return !t.hasOwnProperty(s) && !r[s];
  });
  if (a.forEach(function(s) {
    r[s] = !0;
  }), !(n && n.type === os.REPLACE) && a.length > 0)
    return "Unexpected " + (a.length > 1 ? "keys" : "key") + " " + ('"' + a.join('", "') + '" found in ' + i + ". ") + "Expected to find one of the known reducer keys instead: " + ('"' + o.join('", "') + '". Unexpected keys will be ignored.');
}
function sSe(e) {
  Object.keys(e).forEach(function(t) {
    var n = e[t], r = n(void 0, {
      type: os.INIT
    });
    if (typeof r == "undefined")
      throw new Error(process.env.NODE_ENV === "production" ? cr(12) : 'The slice reducer for key "' + t + `" returned undefined during initialization. If the state passed to the reducer is undefined, you must explicitly return the initial state. The initial state may not be undefined. If you don't want to set a value for this reducer, you can use null instead of undefined.`);
    if (typeof n(void 0, {
      type: os.PROBE_UNKNOWN_ACTION()
    }) == "undefined")
      throw new Error(process.env.NODE_ENV === "production" ? cr(13) : 'The slice reducer for key "' + t + '" returned undefined when probed with a random type. ' + ("Don't try to handle '" + os.INIT + `' or other actions in "redux/*" `) + "namespace. They are considered private. Instead, you must return the current state for any unknown actions, unless it is undefined, in which case you must return the initial state, regardless of the action type. The initial state may not be undefined, but can be null.");
  });
}
function lSe(e) {
  for (var t = Object.keys(e), n = {}, r = 0; r < t.length; r++) {
    var o = t[r];
    process.env.NODE_ENV !== "production" && typeof e[o] == "undefined" && jR('No reducer provided for key "' + o + '"'), typeof e[o] == "function" && (n[o] = e[o]);
  }
  var i = Object.keys(n), a;
  process.env.NODE_ENV !== "production" && (a = {});
  var s;
  try {
    sSe(n);
  } catch (c) {
    s = c;
  }
  return function(l, d) {
    if (l === void 0 && (l = {}), s)
      throw s;
    if (process.env.NODE_ENV !== "production") {
      var f = aSe(l, n, d, a);
      f && jR(f);
    }
    for (var p = !1, m = {}, v = 0; v < i.length; v++) {
      var g = i[v], b = n[g], x = l[g], T = b(x, d);
      if (typeof T == "undefined") {
        var S = d && d.type;
        throw new Error(process.env.NODE_ENV === "production" ? cr(14) : "When called with an action of type " + (S ? '"' + String(S) + '"' : "(unknown type)") + ', the slice reducer for key "' + g + '" returned undefined. To ignore an action, you must explicitly return the previous state. If you want this reducer to hold no value, you can return null instead of undefined.');
      }
      m[g] = T, p = p || T !== x;
    }
    return p = p || i.length !== Object.keys(l).length, p ? m : l;
  };
}
function WR(e, t) {
  return function() {
    return t(e.apply(this, arguments));
  };
}
function cSe(e, t) {
  if (typeof e == "function")
    return WR(e, t);
  if (typeof e != "object" || e === null)
    throw new Error(process.env.NODE_ENV === "production" ? cr(16) : "bindActionCreators expected an object or a function, but instead received: '" + Ha(e) + `'. Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?`);
  var n = {};
  for (var r in e) {
    var o = e[r];
    typeof o == "function" && (n[r] = WR(o, t));
  }
  return n;
}
function wL() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return t.length === 0 ? function(r) {
    return r;
  } : t.length === 1 ? t[0] : t.reduce(function(r, o) {
    return function() {
      return r(o.apply(void 0, arguments));
    };
  });
}
function uSe() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return function(r) {
    return function() {
      var o = r.apply(void 0, arguments), i = function() {
        throw new Error(process.env.NODE_ENV === "production" ? cr(15) : "Dispatching while constructing your middleware is not allowed. Other middleware would not be applied to this dispatch.");
      }, a = {
        getState: o.getState,
        dispatch: function() {
          return i.apply(void 0, arguments);
        }
      }, s = t.map(function(c) {
        return c(a);
      });
      return i = wL.apply(void 0, s)(o.dispatch), BR(BR({}, o), {}, {
        dispatch: i
      });
    };
  };
}
const dSe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  __DO_NOT_USE__ActionTypes: os,
  applyMiddleware: uSe,
  bindActionCreators: cSe,
  combineReducers: lSe,
  compose: wL,
  createStore: wx,
  legacy_createStore: iSe
}, Symbol.toStringTag, { value: "Module" })), xL = /* @__PURE__ */ Go(dSe);
var Qc = {};
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var t = function(o, i, a, s, c, l, d, f) {
    if (process.env.NODE_ENV !== "production" && i === void 0)
      throw new Error("invariant requires an error message argument");
    if (!o) {
      var p;
      if (i === void 0)
        p = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
      else {
        var m = [a, s, c, l, d, f], v = 0;
        p = new Error("Invariant Violation: " + i.replace(/%s/g, function() {
          return m[v++];
        }));
      }
      throw p.framesToPop = 1, p;
    }
  }, n = t;
  e.default = n;
})(Qc);
var fSe = Array.isArray, bo = fSe, pSe = typeof Ua == "object" && Ua && Ua.Object === Object && Ua, CL = pSe, hSe = CL, mSe = typeof self == "object" && self && self.Object === Object && self, gSe = hSe || mSe || Function("return this")(), Sa = gSe, vSe = Sa, bSe = vSe.Symbol, Of = bSe, VR = Of, SL = Object.prototype, ySe = SL.hasOwnProperty, _Se = SL.toString, qu = VR ? VR.toStringTag : void 0;
function wSe(e) {
  var t = ySe.call(e, qu), n = e[qu];
  try {
    e[qu] = void 0;
    var r = !0;
  } catch (i) {
  }
  var o = _Se.call(e);
  return r && (t ? e[qu] = n : delete e[qu]), o;
}
var xSe = wSe, CSe = Object.prototype, SSe = CSe.toString;
function TSe(e) {
  return SSe.call(e);
}
var ESe = TSe, UR = Of, kSe = xSe, MSe = ESe, RSe = "[object Null]", PSe = "[object Undefined]", qR = UR ? UR.toStringTag : void 0;
function OSe(e) {
  return e == null ? e === void 0 ? PSe : RSe : qR && qR in Object(e) ? kSe(e) : MSe(e);
}
var eu = OSe;
function NSe(e) {
  return e != null && typeof e == "object";
}
var tu = NSe, ASe = eu, DSe = tu, ISe = "[object Symbol]";
function LSe(e) {
  return typeof e == "symbol" || DSe(e) && ASe(e) == ISe;
}
var Ug = LSe, $Se = bo, FSe = Ug, zSe = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, BSe = /^\w*$/;
function HSe(e, t) {
  if ($Se(e))
    return !1;
  var n = typeof e;
  return n == "number" || n == "symbol" || n == "boolean" || e == null || FSe(e) ? !0 : BSe.test(e) || !zSe.test(e) || t != null && e in Object(t);
}
var xx = HSe;
function jSe(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
var Nf = jSe, WSe = eu, VSe = Nf, USe = "[object AsyncFunction]", qSe = "[object Function]", GSe = "[object GeneratorFunction]", YSe = "[object Proxy]";
function ZSe(e) {
  if (!VSe(e))
    return !1;
  var t = WSe(e);
  return t == qSe || t == GSe || t == USe || t == YSe;
}
var TL = ZSe, XSe = Sa, KSe = XSe["__core-js_shared__"], JSe = KSe, vb = JSe, GR = function() {
  var e = /[^.]+$/.exec(vb && vb.keys && vb.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}();
function QSe(e) {
  return !!GR && GR in e;
}
var eTe = QSe, tTe = Function.prototype, nTe = tTe.toString;
function rTe(e) {
  if (e != null) {
    try {
      return nTe.call(e);
    } catch (t) {
    }
    try {
      return e + "";
    } catch (t) {
    }
  }
  return "";
}
var EL = rTe, oTe = TL, iTe = eTe, aTe = Nf, sTe = EL, lTe = /[\\^$.*+?()[\]{}|]/g, cTe = /^\[object .+?Constructor\]$/, uTe = Function.prototype, dTe = Object.prototype, fTe = uTe.toString, pTe = dTe.hasOwnProperty, hTe = RegExp(
  "^" + fTe.call(pTe).replace(lTe, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function mTe(e) {
  if (!aTe(e) || iTe(e))
    return !1;
  var t = oTe(e) ? hTe : cTe;
  return t.test(sTe(e));
}
var gTe = mTe;
function vTe(e, t) {
  return e == null ? void 0 : e[t];
}
var bTe = vTe, yTe = gTe, _Te = bTe;
function wTe(e, t) {
  var n = _Te(e, t);
  return yTe(n) ? n : void 0;
}
var fl = wTe, xTe = fl, CTe = xTe(Object, "create"), qg = CTe, YR = qg;
function STe() {
  this.__data__ = YR ? YR(null) : {}, this.size = 0;
}
var TTe = STe;
function ETe(e) {
  var t = this.has(e) && delete this.__data__[e];
  return this.size -= t ? 1 : 0, t;
}
var kTe = ETe, MTe = qg, RTe = "__lodash_hash_undefined__", PTe = Object.prototype, OTe = PTe.hasOwnProperty;
function NTe(e) {
  var t = this.__data__;
  if (MTe) {
    var n = t[e];
    return n === RTe ? void 0 : n;
  }
  return OTe.call(t, e) ? t[e] : void 0;
}
var ATe = NTe, DTe = qg, ITe = Object.prototype, LTe = ITe.hasOwnProperty;
function $Te(e) {
  var t = this.__data__;
  return DTe ? t[e] !== void 0 : LTe.call(t, e);
}
var FTe = $Te, zTe = qg, BTe = "__lodash_hash_undefined__";
function HTe(e, t) {
  var n = this.__data__;
  return this.size += this.has(e) ? 0 : 1, n[e] = zTe && t === void 0 ? BTe : t, this;
}
var jTe = HTe, WTe = TTe, VTe = kTe, UTe = ATe, qTe = FTe, GTe = jTe;
function nu(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var r = e[t];
    this.set(r[0], r[1]);
  }
}
nu.prototype.clear = WTe;
nu.prototype.delete = VTe;
nu.prototype.get = UTe;
nu.prototype.has = qTe;
nu.prototype.set = GTe;
var YTe = nu;
function ZTe() {
  this.__data__ = [], this.size = 0;
}
var XTe = ZTe;
function KTe(e, t) {
  return e === t || e !== e && t !== t;
}
var Cx = KTe, JTe = Cx;
function QTe(e, t) {
  for (var n = e.length; n--; )
    if (JTe(e[n][0], t))
      return n;
  return -1;
}
var Gg = QTe, eEe = Gg, tEe = Array.prototype, nEe = tEe.splice;
function rEe(e) {
  var t = this.__data__, n = eEe(t, e);
  if (n < 0)
    return !1;
  var r = t.length - 1;
  return n == r ? t.pop() : nEe.call(t, n, 1), --this.size, !0;
}
var oEe = rEe, iEe = Gg;
function aEe(e) {
  var t = this.__data__, n = iEe(t, e);
  return n < 0 ? void 0 : t[n][1];
}
var sEe = aEe, lEe = Gg;
function cEe(e) {
  return lEe(this.__data__, e) > -1;
}
var uEe = cEe, dEe = Gg;
function fEe(e, t) {
  var n = this.__data__, r = dEe(n, e);
  return r < 0 ? (++this.size, n.push([e, t])) : n[r][1] = t, this;
}
var pEe = fEe, hEe = XTe, mEe = oEe, gEe = sEe, vEe = uEe, bEe = pEe;
function ru(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var r = e[t];
    this.set(r[0], r[1]);
  }
}
ru.prototype.clear = hEe;
ru.prototype.delete = mEe;
ru.prototype.get = gEe;
ru.prototype.has = vEe;
ru.prototype.set = bEe;
var Yg = ru, yEe = fl, _Ee = Sa, wEe = yEe(_Ee, "Map"), Sx = wEe, ZR = YTe, xEe = Yg, CEe = Sx;
function SEe() {
  this.size = 0, this.__data__ = {
    hash: new ZR(),
    map: new (CEe || xEe)(),
    string: new ZR()
  };
}
var TEe = SEe;
function EEe(e) {
  var t = typeof e;
  return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
}
var kEe = EEe, MEe = kEe;
function REe(e, t) {
  var n = e.__data__;
  return MEe(t) ? n[typeof t == "string" ? "string" : "hash"] : n.map;
}
var Zg = REe, PEe = Zg;
function OEe(e) {
  var t = PEe(this, e).delete(e);
  return this.size -= t ? 1 : 0, t;
}
var NEe = OEe, AEe = Zg;
function DEe(e) {
  return AEe(this, e).get(e);
}
var IEe = DEe, LEe = Zg;
function $Ee(e) {
  return LEe(this, e).has(e);
}
var FEe = $Ee, zEe = Zg;
function BEe(e, t) {
  var n = zEe(this, e), r = n.size;
  return n.set(e, t), this.size += n.size == r ? 0 : 1, this;
}
var HEe = BEe, jEe = TEe, WEe = NEe, VEe = IEe, UEe = FEe, qEe = HEe;
function ou(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var r = e[t];
    this.set(r[0], r[1]);
  }
}
ou.prototype.clear = jEe;
ou.prototype.delete = WEe;
ou.prototype.get = VEe;
ou.prototype.has = UEe;
ou.prototype.set = qEe;
var Tx = ou, kL = Tx, GEe = "Expected a function";
function Ex(e, t) {
  if (typeof e != "function" || t != null && typeof t != "function")
    throw new TypeError(GEe);
  var n = function() {
    var r = arguments, o = t ? t.apply(this, r) : r[0], i = n.cache;
    if (i.has(o))
      return i.get(o);
    var a = e.apply(this, r);
    return n.cache = i.set(o, a) || i, a;
  };
  return n.cache = new (Ex.Cache || kL)(), n;
}
Ex.Cache = kL;
var YEe = Ex, ZEe = YEe, XEe = 500;
function KEe(e) {
  var t = ZEe(e, function(r) {
    return n.size === XEe && n.clear(), r;
  }), n = t.cache;
  return t;
}
var JEe = KEe, QEe = JEe, eke = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, tke = /\\(\\)?/g, nke = QEe(function(e) {
  var t = [];
  return e.charCodeAt(0) === 46 && t.push(""), e.replace(eke, function(n, r, o, i) {
    t.push(o ? i.replace(tke, "$1") : r || n);
  }), t;
}), rke = nke;
function oke(e, t) {
  for (var n = -1, r = e == null ? 0 : e.length, o = Array(r); ++n < r; )
    o[n] = t(e[n], n, e);
  return o;
}
var ML = oke, XR = Of, ike = ML, ake = bo, ske = Ug, lke = 1 / 0, KR = XR ? XR.prototype : void 0, JR = KR ? KR.toString : void 0;
function RL(e) {
  if (typeof e == "string")
    return e;
  if (ake(e))
    return ike(e, RL) + "";
  if (ske(e))
    return JR ? JR.call(e) : "";
  var t = e + "";
  return t == "0" && 1 / e == -lke ? "-0" : t;
}
var cke = RL, uke = cke;
function dke(e) {
  return e == null ? "" : uke(e);
}
var fke = dke, pke = bo, hke = xx, mke = rke, gke = fke;
function vke(e, t) {
  return pke(e) ? e : hke(e, t) ? [e] : mke(gke(e));
}
var Xg = vke, bke = Ug, yke = 1 / 0;
function _ke(e) {
  if (typeof e == "string" || bke(e))
    return e;
  var t = e + "";
  return t == "0" && 1 / e == -yke ? "-0" : t;
}
var Af = _ke, wke = Xg, xke = Af;
function Cke(e, t) {
  t = wke(t, e);
  for (var n = 0, r = t.length; e != null && n < r; )
    e = e[xke(t[n++])];
  return n && n == r ? e : void 0;
}
var kx = Cke, Ske = fl, Tke = function() {
  try {
    var e = Ske(Object, "defineProperty");
    return e({}, "", {}), e;
  } catch (t) {
  }
}(), PL = Tke, QR = PL;
function Eke(e, t, n) {
  t == "__proto__" && QR ? QR(e, t, {
    configurable: !0,
    enumerable: !0,
    value: n,
    writable: !0
  }) : e[t] = n;
}
var kke = Eke, Mke = kke, Rke = Cx, Pke = Object.prototype, Oke = Pke.hasOwnProperty;
function Nke(e, t, n) {
  var r = e[t];
  (!(Oke.call(e, t) && Rke(r, n)) || n === void 0 && !(t in e)) && Mke(e, t, n);
}
var Ake = Nke, Dke = 9007199254740991, Ike = /^(?:0|[1-9]\d*)$/;
function Lke(e, t) {
  var n = typeof e;
  return t = t == null ? Dke : t, !!t && (n == "number" || n != "symbol" && Ike.test(e)) && e > -1 && e % 1 == 0 && e < t;
}
var Mx = Lke, $ke = Ake, Fke = Xg, zke = Mx, eP = Nf, Bke = Af;
function Hke(e, t, n, r) {
  if (!eP(e))
    return e;
  t = Fke(t, e);
  for (var o = -1, i = t.length, a = i - 1, s = e; s != null && ++o < i; ) {
    var c = Bke(t[o]), l = n;
    if (c === "__proto__" || c === "constructor" || c === "prototype")
      return e;
    if (o != a) {
      var d = s[c];
      l = r ? r(d, c, s) : void 0, l === void 0 && (l = eP(d) ? d : zke(t[o + 1]) ? [] : {});
    }
    $ke(s, c, l), s = s[c];
  }
  return e;
}
var jke = Hke, Wke = kx, Vke = jke, Uke = Xg;
function qke(e, t, n) {
  for (var r = -1, o = t.length, i = {}; ++r < o; ) {
    var a = t[r], s = Wke(e, a);
    n(s, a) && Vke(i, Uke(a, e), s);
  }
  return i;
}
var Gke = qke;
function Yke(e, t) {
  return e != null && t in Object(e);
}
var Zke = Yke, Xke = eu, Kke = tu, Jke = "[object Arguments]";
function Qke(e) {
  return Kke(e) && Xke(e) == Jke;
}
var eMe = Qke, tP = eMe, tMe = tu, OL = Object.prototype, nMe = OL.hasOwnProperty, rMe = OL.propertyIsEnumerable, oMe = tP(/* @__PURE__ */ function() {
  return arguments;
}()) ? tP : function(e) {
  return tMe(e) && nMe.call(e, "callee") && !rMe.call(e, "callee");
}, Kg = oMe, iMe = 9007199254740991;
function aMe(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= iMe;
}
var Rx = aMe, sMe = Xg, lMe = Kg, cMe = bo, uMe = Mx, dMe = Rx, fMe = Af;
function pMe(e, t, n) {
  t = sMe(t, e);
  for (var r = -1, o = t.length, i = !1; ++r < o; ) {
    var a = fMe(t[r]);
    if (!(i = e != null && n(e, a)))
      break;
    e = e[a];
  }
  return i || ++r != o ? i : (o = e == null ? 0 : e.length, !!o && dMe(o) && uMe(a, o) && (cMe(e) || lMe(e)));
}
var hMe = pMe, mMe = Zke, gMe = hMe;
function vMe(e, t) {
  return e != null && gMe(e, t, mMe);
}
var NL = vMe, bMe = Gke, yMe = NL;
function _Me(e, t) {
  return bMe(e, t, function(n, r) {
    return yMe(e, r);
  });
}
var wMe = _Me;
function xMe(e, t) {
  for (var n = -1, r = t.length, o = e.length; ++n < r; )
    e[o + n] = t[n];
  return e;
}
var AL = xMe, nP = Of, CMe = Kg, SMe = bo, rP = nP ? nP.isConcatSpreadable : void 0;
function TMe(e) {
  return SMe(e) || CMe(e) || !!(rP && e && e[rP]);
}
var EMe = TMe, kMe = AL, MMe = EMe;
function DL(e, t, n, r, o) {
  var i = -1, a = e.length;
  for (n || (n = MMe), o || (o = []); ++i < a; ) {
    var s = e[i];
    t > 0 && n(s) ? t > 1 ? DL(s, t - 1, n, r, o) : kMe(o, s) : r || (o[o.length] = s);
  }
  return o;
}
var RMe = DL, PMe = RMe;
function OMe(e) {
  var t = e == null ? 0 : e.length;
  return t ? PMe(e, 1) : [];
}
var NMe = OMe;
function AMe(e, t, n) {
  switch (n.length) {
    case 0:
      return e.call(t);
    case 1:
      return e.call(t, n[0]);
    case 2:
      return e.call(t, n[0], n[1]);
    case 3:
      return e.call(t, n[0], n[1], n[2]);
  }
  return e.apply(t, n);
}
var DMe = AMe, IMe = DMe, oP = Math.max;
function LMe(e, t, n) {
  return t = oP(t === void 0 ? e.length - 1 : t, 0), function() {
    for (var r = arguments, o = -1, i = oP(r.length - t, 0), a = Array(i); ++o < i; )
      a[o] = r[t + o];
    o = -1;
    for (var s = Array(t + 1); ++o < t; )
      s[o] = r[o];
    return s[t] = n(a), IMe(e, this, s);
  };
}
var $Me = LMe;
function FMe(e) {
  return function() {
    return e;
  };
}
var zMe = FMe;
function BMe(e) {
  return e;
}
var Px = BMe, HMe = zMe, iP = PL, jMe = Px, WMe = iP ? function(e, t) {
  return iP(e, "toString", {
    configurable: !0,
    enumerable: !1,
    value: HMe(t),
    writable: !0
  });
} : jMe, VMe = WMe, UMe = 800, qMe = 16, GMe = Date.now;
function YMe(e) {
  var t = 0, n = 0;
  return function() {
    var r = GMe(), o = qMe - (r - n);
    if (n = r, o > 0) {
      if (++t >= UMe)
        return arguments[0];
    } else
      t = 0;
    return e.apply(void 0, arguments);
  };
}
var ZMe = YMe, XMe = VMe, KMe = ZMe, JMe = KMe(XMe), QMe = JMe, eRe = NMe, tRe = $Me, nRe = QMe;
function rRe(e) {
  return nRe(tRe(e, void 0, eRe), e + "");
}
var oRe = rRe, iRe = wMe, aRe = oRe, sRe = aRe(function(e, t) {
  return e == null ? {} : iRe(e, t);
}), Ox = sRe, en = {};
Object.defineProperty(en, "__esModule", {
  value: !0
});
en.SCROLL_TO_Y = en.SCROLL_TO_X = en.SCROLL_END = en.SCROLL_START = en.PROP_CHANGE = en.INITIALIZE = en.COLUMN_RESIZE = en.COLUMN_REORDER_MOVE = en.COLUMN_REORDER_END = en.COLUMN_REORDER_START = void 0;
var lRe = "COLUMN_REORDER_START";
en.COLUMN_REORDER_START = lRe;
var cRe = "COLUMN_REORDER_END";
en.COLUMN_REORDER_END = cRe;
var uRe = "COLUMN_REORDER_MOVE";
en.COLUMN_REORDER_MOVE = uRe;
var dRe = "COLUMN_RESIZE";
en.COLUMN_RESIZE = dRe;
var fRe = "INITIALIZE";
en.INITIALIZE = fRe;
var pRe = "PROP_CHANGE";
en.PROP_CHANGE = pRe;
var hRe = "SCROLL_START";
en.SCROLL_START = hRe;
var mRe = "SCROLL_END";
en.SCROLL_END = mRe;
var gRe = "SCROLL_TO_X";
en.SCROLL_TO_X = gRe;
var vRe = "SCROLL_TO_Y";
en.SCROLL_TO_Y = vRe;
var ki = {};
Object.defineProperty(ki, "__esModule", {
  value: !0
});
ki.resizeColumn = ki.moveColumnReorder = ki.stopColumnReorder = ki.startColumnReorder = void 0;
var Jg = en, bRe = function(t) {
  return {
    type: Jg.COLUMN_REORDER_START,
    reorderData: t
  };
};
ki.startColumnReorder = bRe;
var yRe = function() {
  return {
    type: Jg.COLUMN_REORDER_END
  };
};
ki.stopColumnReorder = yRe;
var _Re = function(t) {
  return {
    type: Jg.COLUMN_REORDER_MOVE,
    deltaX: t
  };
};
ki.moveColumnReorder = _Re;
var wRe = function(t) {
  return {
    type: Jg.COLUMN_RESIZE,
    resizeData: t
  };
};
ki.resizeColumn = wRe;
var Mi = {};
Object.defineProperty(Mi, "__esModule", {
  value: !0
});
Mi.stopScroll = Mi.startScroll = Mi.scrollToY = Mi.scrollToX = void 0;
var Qg = en, xRe = function(t) {
  return {
    type: Qg.SCROLL_TO_X,
    scrollX: t
  };
};
Mi.scrollToX = xRe;
var CRe = function(t) {
  return {
    type: Qg.SCROLL_TO_Y,
    scrollY: t
  };
};
Mi.scrollToY = CRe;
var SRe = function() {
  return {
    type: Qg.SCROLL_START
  };
};
Mi.startScroll = SRe;
var TRe = function() {
  return {
    type: Qg.SCROLL_END
  };
};
Mi.stopScroll = TRe;
var IL = {}, ERe = eu, kRe = tu, MRe = "[object Number]";
function RRe(e) {
  return typeof e == "number" || kRe(e) && ERe(e) == MRe;
}
var PRe = RRe, ORe = PRe;
function NRe(e) {
  return ORe(e) && e != +e;
}
var ARe = NRe, Jo = {};
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  function t(s) {
    "@babel/helpers - typeof";
    return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? t = function(l) {
      return typeof l;
    } : t = function(l) {
      return l && typeof Symbol == "function" && l.constructor === Symbol && l !== Symbol.prototype ? "symbol" : typeof l;
    }, t(s);
  }
  var n = /\//g, r = {};
  function o(s) {
    return r[s] || (r[s] = s.replace(n, "_")), r[s];
  }
  function i(s) {
    var c;
    return t(s) == "object" ? c = Object.keys(s).filter(function(l) {
      return s[l];
    }) : c = Array.prototype.slice.call(arguments), c.map(o).join(" ");
  }
  var a = i;
  e.default = a;
})(Jo);
var LL = {};
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  function t(r, o, i, a, s) {
    a = a || setTimeout, s = s || clearTimeout;
    var c;
    function l() {
      for (var d = arguments.length, f = new Array(d), p = 0; p < d; p++)
        f[p] = arguments[p];
      l.reset();
      var m = function() {
        r.apply(i, f);
      };
      m.__SMmeta = r.__SMmeta, c = a(m, o);
    }
    return l.reset = function() {
      s(c);
    }, l;
  }
  var n = t;
  e.default = n;
})(LL);
var ys = {};
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  function t(r) {
    r || (r = "");
    var o, i = arguments.length;
    if (i > 1)
      for (var a = 1; a < i; a++)
        o = arguments[a], o && (r = (r ? r + " " : "") + o);
    return r;
  }
  var n = t;
  e.default = n;
})(ys);
var Df = {};
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  function t(o) {
    "@babel/helpers - typeof";
    return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? t = function(a) {
      return typeof a;
    } : t = function(a) {
      return a && typeof Symbol == "function" && a.constructor === Symbol && a !== Symbol.prototype ? "symbol" : typeof a;
    }, t(o);
  }
  function n(o, i) {
    if (o === i)
      return !0;
    if (t(o) !== "object" || o === null || t(i) !== "object" || i === null)
      return !1;
    var a = Object.keys(o), s = Object.keys(i);
    if (a.length !== s.length)
      return !1;
    for (var c = Object.prototype.hasOwnProperty.bind(i), l = 0; l < a.length; l++)
      if (!c(a[l]) || o[a[l]] !== i[a[l]])
        return !1;
    return !0;
  }
  var r = n;
  e.default = r;
})(Df);
var Nx = {}, _s = {};
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  function t(o) {
    return function() {
      return o;
    };
  }
  function n() {
  }
  n.thatReturns = t, n.thatReturnsFalse = t(!1), n.thatReturnsTrue = t(!0), n.thatReturnsNull = t(null), n.thatReturnsThis = function() {
    return this;
  }, n.thatReturnsArgument = function(o) {
    return o;
  };
  var r = n;
  e.default = r;
})(_s);
var $L = {}, FL = {};
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var t = !1, n, r, o, i, a, s, c, l, d, f, p, m, v, g, b;
  function x() {
    if (!t) {
      t = !0;
      var _ = navigator.userAgent, w = /(?:MSIE.(\d+\.\d+))|(?:(?:Firefox|GranParadiso|Iceweasel).(\d+\.\d+))|(?:Opera(?:.+Version.|.)(\d+\.\d+))|(?:AppleWebKit.(\d+(?:\.\d+)?))|(?:Trident\/\d+\.\d+.*rv:(\d+\.\d+))/.exec(_), k = /(Mac OS X)|(Windows)|(Linux)/.exec(_);
      if (m = /\b(iPhone|iP[ao]d)/.exec(_), v = /\b(iP[ao]d)/.exec(_), f = /Android/i.exec(_), g = /FBAN\/\w+;/i.exec(_), b = /Mobile/i.exec(_), p = !!/Win64/.exec(_), w) {
        n = w[1] ? parseFloat(w[1]) : w[5] ? parseFloat(w[5]) : NaN, n && document && document.documentMode && (n = document.documentMode);
        var E = /(?:Trident\/(\d+.\d+))/.exec(_);
        s = E ? parseFloat(E[1]) + 4 : n, r = w[2] ? parseFloat(w[2]) : NaN, o = w[3] ? parseFloat(w[3]) : NaN, i = w[4] ? parseFloat(w[4]) : NaN, i ? (w = /(?:Chrome\/(\d+\.\d+))/.exec(_), a = w && w[1] ? parseFloat(w[1]) : NaN) : a = NaN;
      } else
        n = r = o = a = i = NaN;
      if (k) {
        if (k[1]) {
          var R = /(?:Mac OS X (\d+(?:[._]\d+)?))/.exec(_);
          c = R ? parseFloat(R[1].replace("_", ".")) : !0;
        } else
          c = !1;
        l = !!k[2], d = !!k[3];
      } else
        c = l = d = !1;
    }
  }
  var T = {
    /**
     *  Check if the UA is Internet Explorer.
     *
     *
     *  @return float|NaN Version number (if match) or NaN.
     */
    ie: function() {
      return x() || n;
    },
    /**
     * Check if we're in Internet Explorer compatibility mode.
     *
     * @return bool true if in compatibility mode, false if
     * not compatibility mode or not ie
     */
    ieCompatibilityMode: function() {
      return x() || s > n;
    },
    /**
     * Whether the browser is 64-bit IE.  Really, this is kind of weak sauce;  we
     * only need this because Skype can't handle 64-bit IE yet.  We need to remove
     * this when we don't need it -- tracked by #601957.
     */
    ie64: function() {
      return T.ie() && p;
    },
    /**
     *  Check if the UA is Firefox.
     *
     *
     *  @return float|NaN Version number (if match) or NaN.
     */
    firefox: function() {
      return x() || r;
    },
    /**
     *  Check if the UA is Opera.
     *
     *
     *  @return float|NaN Version number (if match) or NaN.
     */
    opera: function() {
      return x() || o;
    },
    /**
     *  Check if the UA is WebKit.
     *
     *
     *  @return float|NaN Version number (if match) or NaN.
     */
    webkit: function() {
      return x() || i;
    },
    /**
     *  For Push
     *  WILL BE REMOVED VERY SOON. Use UserAgent_DEPRECATED.webkit
     */
    safari: function() {
      return T.webkit();
    },
    /**
     *  Check if the UA is a Chrome browser.
     *
     *
     *  @return float|NaN Version number (if match) or NaN.
     */
    chrome: function() {
      return x() || a;
    },
    /**
     *  Check if the user is running Windows.
     *
     *  @return bool `true' if the user's OS is Windows.
     */
    windows: function() {
      return x() || l;
    },
    /**
     *  Check if the user is running Mac OS X.
     *
     *  @return float|bool   Returns a float if a version number is detected,
     *                       otherwise true/false.
     */
    osx: function() {
      return x() || c;
    },
    /**
     * Check if the user is running Linux.
     *
     * @return bool `true' if the user's OS is some flavor of Linux.
     */
    linux: function() {
      return x() || d;
    },
    /**
     * Check if the user is running on an iPhone or iPod platform.
     *
     * @return bool `true' if the user is running some flavor of the
     *    iPhone OS.
     */
    iphone: function() {
      return x() || m;
    },
    mobile: function() {
      return x() || m || v || f || b;
    },
    nativeApp: function() {
      return x() || g;
    },
    android: function() {
      return x() || f;
    },
    ipad: function() {
      return x() || v;
    }
  }, S = T;
  e.default = S;
})(FL);
var zL = {}, Ax = {};
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var t = !!(typeof window != "undefined" && window.document && window.document.createElement), n = {
    canUseDOM: t,
    canUseWorkers: typeof Worker != "undefined",
    canUseEventListeners: t && !!(window.addEventListener || window.attachEvent),
    canUseViewport: t && !!window.screen,
    isInWorker: !t
    // For now, this is true - might change in the future.
  }, r = n;
  e.default = r;
})(Ax);
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var t = n(Ax);
  function n(a) {
    return a && a.__esModule ? a : { default: a };
  }
  var r;
  t.default.canUseDOM && (r = document.implementation && document.implementation.hasFeature && // always returns true in newer browsers as per the standard.
  // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
  document.implementation.hasFeature("", "") !== !0);
  /**
   * Checks if an event is supported in the current execution environment.
   *
   * NOTE: This will not work correctly for non-generic events such as `change`,
   * `reset`, `load`, `error`, and `select`.
   *
   * Borrows from Modernizr.
   *
   * @param {string} eventNameSuffix Event name, e.g. "click".
   * @param {?boolean} capture Check if the capture phase is supported.
   * @return {boolean} True if the event is supported.
   * @internal
   * @license Modernizr 3.0.0pre (Custom Build) | MIT
   */
  function o(a, s) {
    if (!t.default.canUseDOM || s && !("addEventListener" in document))
      return !1;
    var c = "on" + a, l = c in document;
    if (!l) {
      var d = document.createElement("div");
      d.setAttribute(c, "return;"), l = typeof d[c] == "function";
    }
    return !l && r && a === "wheel" && (l = document.implementation.hasFeature("Events.wheel", "3.0")), l;
  }
  var i = o;
  e.default = i;
})(zL);
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var t = r(FL), n = r(zL);
  function r(l) {
    return l && l.__esModule ? l : { default: l };
  }
  var o = 10, i = 40, a = 800;
  function s(l) {
    var d = 0, f = 0, p = 0, m = 0;
    return "detail" in l && (f = l.detail), "wheelDelta" in l && (f = -l.wheelDelta / 120), "wheelDeltaY" in l && (f = -l.wheelDeltaY / 120), "wheelDeltaX" in l && (d = -l.wheelDeltaX / 120), "axis" in l && l.axis === l.HORIZONTAL_AXIS && (d = f, f = 0), p = d * o, m = f * o, "deltaY" in l && (m = l.deltaY), "deltaX" in l && (p = l.deltaX), (p || m) && l.deltaMode && (l.deltaMode == 1 ? (p *= i, m *= i) : (p *= a, m *= a)), p && !d && (d = p < 1 ? -1 : 1), m && !f && (f = m < 1 ? -1 : 1), {
      spinX: d,
      spinY: f,
      pixelX: p,
      pixelY: m
    };
  }
  s.getEventType = function() {
    return t.default.firefox() ? "DOMMouseScroll" : (0, n.default)("wheel") ? "wheel" : "mousewheel";
  };
  var c = s;
  e.default = c;
})($L);
var ev = {}, BL = {}, iu = {};
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var t = typeof globalThis != "undefined" ? globalThis : typeof window != "undefined" ? window : typeof Ua != "undefined" ? Ua : typeof self != "undefined" ? self : {}, n = t;
  e.default = n;
})(iu);
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var t = n(iu);
  function n(i) {
    return i && i.__esModule ? i : { default: i };
  }
  var r = t.default.requestAnimationFrame || t.default.webkitRequestAnimationFrame || t.default.mozRequestAnimationFrame || t.default.oRequestAnimationFrame || t.default.msRequestAnimationFrame, o = r;
  e.default = o;
})(BL);
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var t = o(_s), n = o(BL), r = o(iu);
  function o(c) {
    return c && c.__esModule ? c : { default: c };
  }
  var i = 0, a = n.default || function(c) {
    var l = Date.now(), d = Math.max(0, 16 - (l - i));
    return i = l + d, r.default.setTimeout(function() {
      c(Date.now());
    }, d);
  };
  a(t.default);
  var s = a;
  e.default = s;
})(ev);
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var t = o(_s), n = o($L), r = o(ev);
  function o(d) {
    return d && d.__esModule ? d : { default: d };
  }
  function i(d, f) {
    if (!(d instanceof f))
      throw new TypeError("Cannot call a class as a function");
  }
  function a(d, f) {
    for (var p = 0; p < f.length; p++) {
      var m = f[p];
      m.enumerable = m.enumerable || !1, m.configurable = !0, "value" in m && (m.writable = !0), Object.defineProperty(d, m.key, m);
    }
  }
  function s(d, f, p) {
    return f && a(d.prototype, f), p && a(d, p), d;
  }
  var c = /* @__PURE__ */ function() {
    function d(f, p, m, v, g, b) {
      i(this, d), this._animationFrameID = null, this._deltaX = 0, this._deltaY = 0, this._didWheel = this._didWheel.bind(this), this._rootRef = null, typeof p != "function" && (p = p ? t.default.thatReturnsTrue : t.default.thatReturnsFalse), typeof m != "function" && (m = m ? t.default.thatReturnsTrue : t.default.thatReturnsFalse), this._handleScrollX = p, this._handleScrollY = m, this._preventDefault = g, this._stopPropagation = b, this._onWheelCallback = f, this.onWheel = this.onWheel.bind(this), this._isRTL = v;
    }
    return s(d, [{
      key: "onWheel",
      value: function(p) {
        this._preventDefault && p.preventDefault();
        var m = (0, n.default)(p);
        p.shiftKey && d._allowInternalAxesSwap() ? m = d._swapNormalizedWheelAxis(m) : p.shiftKey || (m.pixelX *= this._isRTL ? -1 : 1);
        var v = this._deltaX + m.pixelX, g = this._deltaY + m.pixelY, b = this._handleScrollX(v, g), x = this._handleScrollY(g, v);
        if (!(!b && !x) && !(this._rootRef && !this._contains(p.target))) {
          this._deltaX += b ? m.pixelX : 0, this._deltaY += x ? m.pixelY : 0, p.defaultPrevented || p.preventDefault();
          var T;
          (this._deltaX !== 0 || this._deltaY !== 0) && (this._stopPropagation && p.stopPropagation(), T = !0), T === !0 && this._animationFrameID === null && (this._animationFrameID = (0, r.default)(this._didWheel));
        }
      }
    }, {
      key: "setRoot",
      value: function(p) {
        this._rootRef = p;
      }
    }, {
      key: "_didWheel",
      value: function() {
        this._animationFrameID = null, this._onWheelCallback(this._deltaX, this._deltaY), this._deltaX = 0, this._deltaY = 0;
      }
    }, {
      key: "_contains",
      value: function(p) {
        for (var m = p; m != document.body; ) {
          if (m === this._rootRef)
            return !0;
          m = m.parentNode;
        }
        return !1;
      }
    }], [{
      key: "_swapNormalizedWheelAxis",
      value: function(p) {
        return {
          spinX: p.spinY,
          spinY: p.spinX,
          pixelX: p.pixelY,
          pixelY: p.pixelX
        };
      }
    }, {
      key: "_allowInternalAxesSwap",
      value: function() {
        return navigator.platform !== "MacIntel";
      }
    }]), d;
  }(), l = c;
  e.default = l;
})(Nx);
var HL = {}, pl = {}, gm = "NOT_FOUND";
function DRe(e) {
  var t;
  return {
    get: function(r) {
      return t && e(t.key, r) ? t.value : gm;
    },
    put: function(r, o) {
      t = {
        key: r,
        value: o
      };
    },
    getEntries: function() {
      return t ? [t] : [];
    },
    clear: function() {
      t = void 0;
    }
  };
}
function IRe(e, t) {
  var n = [];
  function r(s) {
    var c = n.findIndex(function(d) {
      return t(s, d.key);
    });
    if (c > -1) {
      var l = n[c];
      return c > 0 && (n.splice(c, 1), n.unshift(l)), l.value;
    }
    return gm;
  }
  function o(s, c) {
    r(s) === gm && (n.unshift({
      key: s,
      value: c
    }), n.length > e && n.pop());
  }
  function i() {
    return n;
  }
  function a() {
    n = [];
  }
  return {
    get: r,
    put: o,
    getEntries: i,
    clear: a
  };
}
var jL = function(t, n) {
  return t === n;
};
function LRe(e) {
  return function(n, r) {
    if (n === null || r === null || n.length !== r.length)
      return !1;
    for (var o = n.length, i = 0; i < o; i++)
      if (!e(n[i], r[i]))
        return !1;
    return !0;
  };
}
function WL(e, t) {
  var n = typeof t == "object" ? t : {
    equalityCheck: t
  }, r = n.equalityCheck, o = r === void 0 ? jL : r, i = n.maxSize, a = i === void 0 ? 1 : i, s = n.resultEqualityCheck, c = LRe(o), l = a === 1 ? DRe(c) : IRe(a, c);
  function d() {
    var f = l.get(arguments);
    if (f === gm) {
      if (f = e.apply(null, arguments), s) {
        var p = l.getEntries(), m = p.find(function(v) {
          return s(v.value, f);
        });
        m && (f = m.value);
      }
      l.put(arguments, f);
    }
    return f;
  }
  return d.clearCache = function() {
    return l.clear();
  }, d;
}
function $Re(e) {
  var t = Array.isArray(e[0]) ? e[0] : e;
  if (!t.every(function(r) {
    return typeof r == "function";
  })) {
    var n = t.map(function(r) {
      return typeof r == "function" ? "function " + (r.name || "unnamed") + "()" : typeof r;
    }).join(", ");
    throw new Error("createSelector expects all input-selectors to be functions, but received the following types: [" + n + "]");
  }
  return t;
}
function VL(e) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)
    n[r - 1] = arguments[r];
  var o = function() {
    for (var a = arguments.length, s = new Array(a), c = 0; c < a; c++)
      s[c] = arguments[c];
    var l = 0, d, f = {
      memoizeOptions: void 0
    }, p = s.pop();
    if (typeof p == "object" && (f = p, p = s.pop()), typeof p != "function")
      throw new Error("createSelector expects an output function after the inputs, but received: [" + typeof p + "]");
    var m = f, v = m.memoizeOptions, g = v === void 0 ? n : v, b = Array.isArray(g) ? g : [g], x = $Re(s), T = e.apply(void 0, [function() {
      return l++, p.apply(null, arguments);
    }].concat(b)), S = e(function() {
      for (var w = [], k = x.length, E = 0; E < k; E++)
        w.push(x[E].apply(null, arguments));
      return d = T.apply(null, w), d;
    });
    return Object.assign(S, {
      resultFunc: p,
      memoizedResultFunc: T,
      dependencies: x,
      lastResult: function() {
        return d;
      },
      recomputations: function() {
        return l;
      },
      resetRecomputations: function() {
        return l = 0;
      }
    }), S;
  };
  return o;
}
var UL = /* @__PURE__ */ VL(WL), FRe = function(t, n) {
  if (n === void 0 && (n = UL), typeof t != "object")
    throw new Error("createStructuredSelector expects first argument to be an object " + ("where each property is a selector, instead received a " + typeof t));
  var r = Object.keys(t), o = n(
    // @ts-ignore
    r.map(function(i) {
      return t[i];
    }),
    function() {
      for (var i = arguments.length, a = new Array(i), s = 0; s < i; s++)
        a[s] = arguments[s];
      return a.reduce(function(c, l, d) {
        return c[r[d]] = l, c;
      }, {});
    }
  );
  return o;
};
const zRe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  createSelector: UL,
  createSelectorCreator: VL,
  createStructuredSelector: FRe,
  defaultEqualityCheck: jL,
  defaultMemoize: WL
}, Symbol.toStringTag, { value: "Module" })), BRe = /* @__PURE__ */ Go(zRe);
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var t = BRe, n = r(Df);
  function r(i) {
    return i && i.__esModule ? i : { default: i };
  }
  var o = (0, t.createSelectorCreator)(t.defaultMemoize, n.default);
  e.default = o;
})(pl);
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var t = n(pl);
  function n(i) {
    return i && i.__esModule ? i : { default: i };
  }
  function r(i, a, s) {
    var c = 1, l = 1, d = i + 2, f = i + 1, p = 2;
    return a && (l++, f++, d++, p++), s && f++, {
      ariaGroupHeaderIndex: c,
      ariaHeaderIndex: l,
      ariaFooterIndex: d,
      ariaRowCount: f,
      ariaRowIndexOffset: p
    };
  }
  var o = (0, t.default)([function(i) {
    return i.rowsCount;
  }, function(i) {
    return i.groupHeaderHeight > 0;
  }, function(i) {
    return i.footerHeight > 0;
  }], r);
  e.default = o;
})(HL);
var qL = {};
function HRe(e, t) {
  for (var n = -1, r = e == null ? 0 : e.length; ++n < r && t(e[n], n, e) !== !1; )
    ;
  return e;
}
var jRe = HRe;
function WRe(e) {
  return function(t, n, r) {
    for (var o = -1, i = Object(t), a = r(t), s = a.length; s--; ) {
      var c = a[e ? s : ++o];
      if (n(i[c], c, i) === !1)
        break;
    }
    return t;
  };
}
var VRe = WRe, URe = VRe, qRe = URe(), GRe = qRe;
function YRe(e, t) {
  for (var n = -1, r = Array(e); ++n < e; )
    r[n] = t(n);
  return r;
}
var ZRe = YRe, X1 = { exports: {} };
function XRe() {
  return !1;
}
var KRe = XRe;
(function(e, t) {
  var n = Sa, r = KRe, o = t && !t.nodeType && t, i = o && !0 && e && !e.nodeType && e, a = i && i.exports === o, s = a ? n.Buffer : void 0, c = s ? s.isBuffer : void 0, l = c || r;
  e.exports = l;
})(X1, X1.exports);
var Dx = X1.exports, JRe = eu, QRe = Rx, ePe = tu, tPe = "[object Arguments]", nPe = "[object Array]", rPe = "[object Boolean]", oPe = "[object Date]", iPe = "[object Error]", aPe = "[object Function]", sPe = "[object Map]", lPe = "[object Number]", cPe = "[object Object]", uPe = "[object RegExp]", dPe = "[object Set]", fPe = "[object String]", pPe = "[object WeakMap]", hPe = "[object ArrayBuffer]", mPe = "[object DataView]", gPe = "[object Float32Array]", vPe = "[object Float64Array]", bPe = "[object Int8Array]", yPe = "[object Int16Array]", _Pe = "[object Int32Array]", wPe = "[object Uint8Array]", xPe = "[object Uint8ClampedArray]", CPe = "[object Uint16Array]", SPe = "[object Uint32Array]", Qt = {};
Qt[gPe] = Qt[vPe] = Qt[bPe] = Qt[yPe] = Qt[_Pe] = Qt[wPe] = Qt[xPe] = Qt[CPe] = Qt[SPe] = !0;
Qt[tPe] = Qt[nPe] = Qt[hPe] = Qt[rPe] = Qt[mPe] = Qt[oPe] = Qt[iPe] = Qt[aPe] = Qt[sPe] = Qt[lPe] = Qt[cPe] = Qt[uPe] = Qt[dPe] = Qt[fPe] = Qt[pPe] = !1;
function TPe(e) {
  return ePe(e) && QRe(e.length) && !!Qt[JRe(e)];
}
var EPe = TPe;
function kPe(e) {
  return function(t) {
    return e(t);
  };
}
var MPe = kPe, K1 = { exports: {} };
(function(e, t) {
  var n = CL, r = t && !t.nodeType && t, o = r && !0 && e && !e.nodeType && e, i = o && o.exports === r, a = i && n.process, s = function() {
    try {
      var c = o && o.require && o.require("util").types;
      return c || a && a.binding && a.binding("util");
    } catch (l) {
    }
  }();
  e.exports = s;
})(K1, K1.exports);
var RPe = K1.exports, PPe = EPe, OPe = MPe, aP = RPe, sP = aP && aP.isTypedArray, NPe = sP ? OPe(sP) : PPe, Ix = NPe, APe = ZRe, DPe = Kg, IPe = bo, LPe = Dx, $Pe = Mx, FPe = Ix, zPe = Object.prototype, BPe = zPe.hasOwnProperty;
function HPe(e, t) {
  var n = IPe(e), r = !n && DPe(e), o = !n && !r && LPe(e), i = !n && !r && !o && FPe(e), a = n || r || o || i, s = a ? APe(e.length, String) : [], c = s.length;
  for (var l in e)
    (t || BPe.call(e, l)) && !(a && // Safari 9 has enumerable `arguments.length` in strict mode.
    (l == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    o && (l == "offset" || l == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    i && (l == "buffer" || l == "byteLength" || l == "byteOffset") || // Skip index properties.
    $Pe(l, c))) && s.push(l);
  return s;
}
var jPe = HPe, WPe = Object.prototype;
function VPe(e) {
  var t = e && e.constructor, n = typeof t == "function" && t.prototype || WPe;
  return e === n;
}
var GL = VPe;
function UPe(e, t) {
  return function(n) {
    return e(t(n));
  };
}
var qPe = UPe, GPe = qPe, YPe = GPe(Object.keys, Object), ZPe = YPe, XPe = GL, KPe = ZPe, JPe = Object.prototype, QPe = JPe.hasOwnProperty;
function eOe(e) {
  if (!XPe(e))
    return KPe(e);
  var t = [];
  for (var n in Object(e))
    QPe.call(e, n) && n != "constructor" && t.push(n);
  return t;
}
var YL = eOe, tOe = TL, nOe = Rx;
function rOe(e) {
  return e != null && nOe(e.length) && !tOe(e);
}
var tv = rOe, oOe = jPe, iOe = YL, aOe = tv;
function sOe(e) {
  return aOe(e) ? oOe(e) : iOe(e);
}
var Lx = sOe, lOe = GRe, cOe = Lx;
function uOe(e, t) {
  return e && lOe(e, t, cOe);
}
var dOe = uOe, fOe = tv;
function pOe(e, t) {
  return function(n, r) {
    if (n == null)
      return n;
    if (!fOe(n))
      return e(n, r);
    for (var o = n.length, i = t ? o : -1, a = Object(n); (t ? i-- : ++i < o) && r(a[i], i, a) !== !1; )
      ;
    return n;
  };
}
var hOe = pOe, mOe = dOe, gOe = hOe, vOe = gOe(mOe), $x = vOe, bOe = Px;
function yOe(e) {
  return typeof e == "function" ? e : bOe;
}
var _Oe = yOe, wOe = jRe, xOe = $x, COe = _Oe, SOe = bo;
function TOe(e, t) {
  var n = SOe(e) ? wOe : xOe;
  return n(e, COe(t));
}
var Fx = TOe, zx = {}, EOe = Yg;
function kOe() {
  this.__data__ = new EOe(), this.size = 0;
}
var MOe = kOe;
function ROe(e) {
  var t = this.__data__, n = t.delete(e);
  return this.size = t.size, n;
}
var POe = ROe;
function OOe(e) {
  return this.__data__.get(e);
}
var NOe = OOe;
function AOe(e) {
  return this.__data__.has(e);
}
var DOe = AOe, IOe = Yg, LOe = Sx, $Oe = Tx, FOe = 200;
function zOe(e, t) {
  var n = this.__data__;
  if (n instanceof IOe) {
    var r = n.__data__;
    if (!LOe || r.length < FOe - 1)
      return r.push([e, t]), this.size = ++n.size, this;
    n = this.__data__ = new $Oe(r);
  }
  return n.set(e, t), this.size = n.size, this;
}
var BOe = zOe, HOe = Yg, jOe = MOe, WOe = POe, VOe = NOe, UOe = DOe, qOe = BOe;
function au(e) {
  var t = this.__data__ = new HOe(e);
  this.size = t.size;
}
au.prototype.clear = jOe;
au.prototype.delete = WOe;
au.prototype.get = VOe;
au.prototype.has = UOe;
au.prototype.set = qOe;
var ZL = au, GOe = "__lodash_hash_undefined__";
function YOe(e) {
  return this.__data__.set(e, GOe), this;
}
var ZOe = YOe;
function XOe(e) {
  return this.__data__.has(e);
}
var KOe = XOe, JOe = Tx, QOe = ZOe, e3e = KOe;
function vm(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.__data__ = new JOe(); ++t < n; )
    this.add(e[t]);
}
vm.prototype.add = vm.prototype.push = QOe;
vm.prototype.has = e3e;
var t3e = vm;
function n3e(e, t) {
  for (var n = -1, r = e == null ? 0 : e.length; ++n < r; )
    if (t(e[n], n, e))
      return !0;
  return !1;
}
var r3e = n3e;
function o3e(e, t) {
  return e.has(t);
}
var i3e = o3e, a3e = t3e, s3e = r3e, l3e = i3e, c3e = 1, u3e = 2;
function d3e(e, t, n, r, o, i) {
  var a = n & c3e, s = e.length, c = t.length;
  if (s != c && !(a && c > s))
    return !1;
  var l = i.get(e), d = i.get(t);
  if (l && d)
    return l == t && d == e;
  var f = -1, p = !0, m = n & u3e ? new a3e() : void 0;
  for (i.set(e, t), i.set(t, e); ++f < s; ) {
    var v = e[f], g = t[f];
    if (r)
      var b = a ? r(g, v, f, t, e, i) : r(v, g, f, e, t, i);
    if (b !== void 0) {
      if (b)
        continue;
      p = !1;
      break;
    }
    if (m) {
      if (!s3e(t, function(x, T) {
        if (!l3e(m, T) && (v === x || o(v, x, n, r, i)))
          return m.push(T);
      })) {
        p = !1;
        break;
      }
    } else if (!(v === g || o(v, g, n, r, i))) {
      p = !1;
      break;
    }
  }
  return i.delete(e), i.delete(t), p;
}
var XL = d3e, f3e = Sa, p3e = f3e.Uint8Array, h3e = p3e;
function m3e(e) {
  var t = -1, n = Array(e.size);
  return e.forEach(function(r, o) {
    n[++t] = [o, r];
  }), n;
}
var g3e = m3e;
function v3e(e) {
  var t = -1, n = Array(e.size);
  return e.forEach(function(r) {
    n[++t] = r;
  }), n;
}
var b3e = v3e, lP = Of, cP = h3e, y3e = Cx, _3e = XL, w3e = g3e, x3e = b3e, C3e = 1, S3e = 2, T3e = "[object Boolean]", E3e = "[object Date]", k3e = "[object Error]", M3e = "[object Map]", R3e = "[object Number]", P3e = "[object RegExp]", O3e = "[object Set]", N3e = "[object String]", A3e = "[object Symbol]", D3e = "[object ArrayBuffer]", I3e = "[object DataView]", uP = lP ? lP.prototype : void 0, bb = uP ? uP.valueOf : void 0;
function L3e(e, t, n, r, o, i, a) {
  switch (n) {
    case I3e:
      if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset)
        return !1;
      e = e.buffer, t = t.buffer;
    case D3e:
      return !(e.byteLength != t.byteLength || !i(new cP(e), new cP(t)));
    case T3e:
    case E3e:
    case R3e:
      return y3e(+e, +t);
    case k3e:
      return e.name == t.name && e.message == t.message;
    case P3e:
    case N3e:
      return e == t + "";
    case M3e:
      var s = w3e;
    case O3e:
      var c = r & C3e;
      if (s || (s = x3e), e.size != t.size && !c)
        return !1;
      var l = a.get(e);
      if (l)
        return l == t;
      r |= S3e, a.set(e, t);
      var d = _3e(s(e), s(t), r, o, i, a);
      return a.delete(e), d;
    case A3e:
      if (bb)
        return bb.call(e) == bb.call(t);
  }
  return !1;
}
var $3e = L3e, F3e = AL, z3e = bo;
function B3e(e, t, n) {
  var r = t(e);
  return z3e(e) ? r : F3e(r, n(e));
}
var H3e = B3e;
function j3e(e, t) {
  for (var n = -1, r = e == null ? 0 : e.length, o = 0, i = []; ++n < r; ) {
    var a = e[n];
    t(a, n, e) && (i[o++] = a);
  }
  return i;
}
var W3e = j3e;
function V3e() {
  return [];
}
var U3e = V3e, q3e = W3e, G3e = U3e, Y3e = Object.prototype, Z3e = Y3e.propertyIsEnumerable, dP = Object.getOwnPropertySymbols, X3e = dP ? function(e) {
  return e == null ? [] : (e = Object(e), q3e(dP(e), function(t) {
    return Z3e.call(e, t);
  }));
} : G3e, K3e = X3e, J3e = H3e, Q3e = K3e, eNe = Lx;
function tNe(e) {
  return J3e(e, eNe, Q3e);
}
var nNe = tNe, fP = nNe, rNe = 1, oNe = Object.prototype, iNe = oNe.hasOwnProperty;
function aNe(e, t, n, r, o, i) {
  var a = n & rNe, s = fP(e), c = s.length, l = fP(t), d = l.length;
  if (c != d && !a)
    return !1;
  for (var f = c; f--; ) {
    var p = s[f];
    if (!(a ? p in t : iNe.call(t, p)))
      return !1;
  }
  var m = i.get(e), v = i.get(t);
  if (m && v)
    return m == t && v == e;
  var g = !0;
  i.set(e, t), i.set(t, e);
  for (var b = a; ++f < c; ) {
    p = s[f];
    var x = e[p], T = t[p];
    if (r)
      var S = a ? r(T, x, p, t, e, i) : r(x, T, p, e, t, i);
    if (!(S === void 0 ? x === T || o(x, T, n, r, i) : S)) {
      g = !1;
      break;
    }
    b || (b = p == "constructor");
  }
  if (g && !b) {
    var _ = e.constructor, w = t.constructor;
    _ != w && "constructor" in e && "constructor" in t && !(typeof _ == "function" && _ instanceof _ && typeof w == "function" && w instanceof w) && (g = !1);
  }
  return i.delete(e), i.delete(t), g;
}
var sNe = aNe, lNe = fl, cNe = Sa, uNe = lNe(cNe, "DataView"), dNe = uNe, fNe = fl, pNe = Sa, hNe = fNe(pNe, "Promise"), mNe = hNe, gNe = fl, vNe = Sa, bNe = gNe(vNe, "Set"), yNe = bNe, _Ne = fl, wNe = Sa, xNe = _Ne(wNe, "WeakMap"), CNe = xNe, J1 = dNe, Q1 = Sx, e_ = mNe, t_ = yNe, n_ = CNe, KL = eu, su = EL, pP = "[object Map]", SNe = "[object Object]", hP = "[object Promise]", mP = "[object Set]", gP = "[object WeakMap]", vP = "[object DataView]", TNe = su(J1), ENe = su(Q1), kNe = su(e_), MNe = su(t_), RNe = su(n_), Fs = KL;
(J1 && Fs(new J1(new ArrayBuffer(1))) != vP || Q1 && Fs(new Q1()) != pP || e_ && Fs(e_.resolve()) != hP || t_ && Fs(new t_()) != mP || n_ && Fs(new n_()) != gP) && (Fs = function(e) {
  var t = KL(e), n = t == SNe ? e.constructor : void 0, r = n ? su(n) : "";
  if (r)
    switch (r) {
      case TNe:
        return vP;
      case ENe:
        return pP;
      case kNe:
        return hP;
      case MNe:
        return mP;
      case RNe:
        return gP;
    }
  return t;
});
var JL = Fs, yb = ZL, PNe = XL, ONe = $3e, NNe = sNe, bP = JL, yP = bo, _P = Dx, ANe = Ix, DNe = 1, wP = "[object Arguments]", xP = "[object Array]", Ip = "[object Object]", INe = Object.prototype, CP = INe.hasOwnProperty;
function LNe(e, t, n, r, o, i) {
  var a = yP(e), s = yP(t), c = a ? xP : bP(e), l = s ? xP : bP(t);
  c = c == wP ? Ip : c, l = l == wP ? Ip : l;
  var d = c == Ip, f = l == Ip, p = c == l;
  if (p && _P(e)) {
    if (!_P(t))
      return !1;
    a = !0, d = !1;
  }
  if (p && !d)
    return i || (i = new yb()), a || ANe(e) ? PNe(e, t, n, r, o, i) : ONe(e, t, c, n, r, o, i);
  if (!(n & DNe)) {
    var m = d && CP.call(e, "__wrapped__"), v = f && CP.call(t, "__wrapped__");
    if (m || v) {
      var g = m ? e.value() : e, b = v ? t.value() : t;
      return i || (i = new yb()), o(g, b, n, r, i);
    }
  }
  return p ? (i || (i = new yb()), NNe(e, t, n, r, o, i)) : !1;
}
var $Ne = LNe, FNe = $Ne, SP = tu;
function QL(e, t, n, r, o) {
  return e === t ? !0 : e == null || t == null || !SP(e) && !SP(t) ? e !== e && t !== t : FNe(e, t, n, r, QL, o);
}
var e4 = QL, zNe = ZL, BNe = e4, HNe = 1, jNe = 2;
function WNe(e, t, n, r) {
  var o = n.length, i = o, a = !r;
  if (e == null)
    return !i;
  for (e = Object(e); o--; ) {
    var s = n[o];
    if (a && s[2] ? s[1] !== e[s[0]] : !(s[0] in e))
      return !1;
  }
  for (; ++o < i; ) {
    s = n[o];
    var c = s[0], l = e[c], d = s[1];
    if (a && s[2]) {
      if (l === void 0 && !(c in e))
        return !1;
    } else {
      var f = new zNe();
      if (r)
        var p = r(l, d, c, e, t, f);
      if (!(p === void 0 ? BNe(d, l, HNe | jNe, r, f) : p))
        return !1;
    }
  }
  return !0;
}
var VNe = WNe, UNe = Nf;
function qNe(e) {
  return e === e && !UNe(e);
}
var t4 = qNe, GNe = t4, YNe = Lx;
function ZNe(e) {
  for (var t = YNe(e), n = t.length; n--; ) {
    var r = t[n], o = e[r];
    t[n] = [r, o, GNe(o)];
  }
  return t;
}
var XNe = ZNe;
function KNe(e, t) {
  return function(n) {
    return n == null ? !1 : n[e] === t && (t !== void 0 || e in Object(n));
  };
}
var n4 = KNe, JNe = VNe, QNe = XNe, eAe = n4;
function tAe(e) {
  var t = QNe(e);
  return t.length == 1 && t[0][2] ? eAe(t[0][0], t[0][1]) : function(n) {
    return n === e || JNe(n, e, t);
  };
}
var nAe = tAe, rAe = kx;
function oAe(e, t, n) {
  var r = e == null ? void 0 : rAe(e, t);
  return r === void 0 ? n : r;
}
var iAe = oAe, aAe = e4, sAe = iAe, lAe = NL, cAe = xx, uAe = t4, dAe = n4, fAe = Af, pAe = 1, hAe = 2;
function mAe(e, t) {
  return cAe(e) && uAe(t) ? dAe(fAe(e), t) : function(n) {
    var r = sAe(n, e);
    return r === void 0 && r === t ? lAe(n, e) : aAe(t, r, pAe | hAe);
  };
}
var gAe = mAe;
function vAe(e) {
  return function(t) {
    return t == null ? void 0 : t[e];
  };
}
var bAe = vAe, yAe = kx;
function _Ae(e) {
  return function(t) {
    return yAe(t, e);
  };
}
var wAe = _Ae, xAe = bAe, CAe = wAe, SAe = xx, TAe = Af;
function EAe(e) {
  return SAe(e) ? xAe(TAe(e)) : CAe(e);
}
var kAe = EAe, MAe = nAe, RAe = gAe, PAe = Px, OAe = bo, NAe = kAe;
function AAe(e) {
  return typeof e == "function" ? e : e == null ? PAe : typeof e == "object" ? OAe(e) ? RAe(e[0], e[1]) : MAe(e) : NAe(e);
}
var r4 = AAe, DAe = $x, IAe = tv;
function LAe(e, t) {
  var n = -1, r = IAe(e) ? Array(e.length) : [];
  return DAe(e, function(o, i, a) {
    r[++n] = t(o, i, a);
  }), r;
}
var $Ae = LAe, FAe = ML, zAe = r4, BAe = $Ae, HAe = bo;
function jAe(e, t) {
  var n = HAe(e) ? FAe : BAe;
  return n(e, zAe(t));
}
var o4 = jAe, ws = {};
function WAe(e, t, n, r) {
  var o = -1, i = e == null ? 0 : e.length;
  for (r && i && (n = e[++o]); ++o < i; )
    n = t(n, e[o], o, e);
  return n;
}
var VAe = WAe;
function UAe(e, t, n, r, o) {
  return o(e, function(i, a, s) {
    n = r ? (r = !1, i) : t(n, i, a, s);
  }), n;
}
var qAe = UAe, GAe = VAe, YAe = $x, ZAe = r4, XAe = qAe, KAe = bo;
function JAe(e, t, n) {
  var r = KAe(e) ? GAe : XAe, o = arguments.length < 3;
  return r(e, ZAe(t), n, o, YAe);
}
var QAe = JAe;
Object.defineProperty(ws, "__esModule", {
  value: !0
});
ws.sumPropWidths = tDe;
ws.getTotalWidth = nDe;
ws.getTotalFlexGrow = rDe;
var Bx = eDe(QAe);
function eDe(e) {
  return e && e.__esModule ? e : { default: e };
}
function tDe(e) {
  return (0, Bx.default)(e, function(t, n) {
    return t + n.props.width;
  }, 0);
}
function nDe(e) {
  return (0, Bx.default)(e, function(t, n) {
    return t + n.width;
  }, 0);
}
function rDe(e) {
  return (0, Bx.default)(e, function(t, n) {
    return t + (n.flexGrow || 0);
  }, 0);
}
var lu = {}, nv = {}, rv = {};
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  function t(r, o, i) {
    return r < o ? o : r > i ? i : r;
  }
  var n = t;
  e.default = n;
})(rv);
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = e.ScrollbarState = void 0;
  var t = o(rv), n = o(pl), r = ws;
  function o(m) {
    return m && m.__esModule ? m : { default: m };
  }
  var i = 1, a = 3, s = 6, c = {
    HIDDEN: "hidden",
    JOINT_SCROLLBARS: "JOINT_SCROLLBARS",
    VISIBLE: "visible"
  };
  e.ScrollbarState = c;
  function l(m, v, g, b, x, T, S) {
    var _ = v.cellGroupWrapperHeight, w = v.footerHeight, k = v.headerHeight, E = v.groupHeaderHeight, R = _ ? 0 : 2 * i, P = w + k + E + R, A = x.height, D = x.maxHeight, N = x.useMaxHeight, F = x.width, $ = Math.round(N ? D : A), I = $ - P, j = d(m, b, F, S), U = I, G = I;
    switch (j) {
      case c.VISIBLE: {
        U -= T, G -= T;
        break;
      }
      case c.JOINT_SCROLLBARS: {
        U -= T;
        break;
      }
    }
    return {
      bufferRowCount: f(G, g),
      minAvailableHeight: Math.max(U, 0),
      maxAvailableHeight: Math.max(G, 0),
      reservedHeight: P,
      scrollStateX: j
    };
  }
  function d(m, v, g, b) {
    var x = v.overflowX, T = v.showScrollbarX, S = (0, r.getTotalWidth)(m);
    return x === "hidden" || T === !1 ? c.HIDDEN : S > g ? c.VISIBLE : S > g - b ? c.JOINT_SCROLLBARS : c.HIDDEN;
  }
  function f(m, v) {
    var g = v.bufferRowCount, b = v.rowHeight, x = v.subRowHeight;
    if (g !== void 0)
      return console.log("buffer set: " + g), g;
    var T = b + x, S = Math.ceil(m / T) + 1;
    return (0, t.default)(Math.floor(S / 2), a, s);
  }
  var p = (0, n.default)([function(m) {
    return m.columnProps;
  }, function(m) {
    return m.elementHeights;
  }, function(m) {
    return m.rowSettings;
  }, function(m) {
    return m.scrollFlags;
  }, function(m) {
    return m.tableSize;
  }, function(m) {
    return m.scrollbarXHeight;
  }, function(m) {
    return m.scrollbarYWidth;
  }], l);
  e.default = p;
})(nv);
(function(e) {
  function t(l) {
    "@babel/helpers - typeof";
    return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? t = function(f) {
      return typeof f;
    } : t = function(f) {
      return f && typeof Symbol == "function" && f.constructor === Symbol && f !== Symbol.prototype ? "symbol" : typeof f;
    }, t(l);
  }
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var n = a(pl), r = i(nv);
  function o(l) {
    if (typeof WeakMap != "function")
      return null;
    var d = /* @__PURE__ */ new WeakMap(), f = /* @__PURE__ */ new WeakMap();
    return (o = function(m) {
      return m ? f : d;
    })(l);
  }
  function i(l, d) {
    if (l && l.__esModule)
      return l;
    if (l === null || t(l) !== "object" && typeof l != "function")
      return { default: l };
    var f = o(d);
    if (f && f.has(l))
      return f.get(l);
    var p = {}, m = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var v in l)
      if (v !== "default" && Object.prototype.hasOwnProperty.call(l, v)) {
        var g = m ? Object.getOwnPropertyDescriptor(l, v) : null;
        g && (g.get || g.set) ? Object.defineProperty(p, v, g) : p[v] = l[v];
      }
    return p.default = l, f && f.set(l, p), p;
  }
  function a(l) {
    return l && l.__esModule ? l : { default: l };
  }
  function s(l, d, f) {
    var p = f.overflowY, m = f.showScrollbarY, v = p !== "hidden" && m !== !1, g = l.minAvailableHeight, b = l.maxAvailableHeight, x = l.scrollStateX, T = !1, S = !1;
    x === r.ScrollbarState.VISIBLE && (S = !0), v && d > b && (T = !0), T && x === r.ScrollbarState.JOINT_SCROLLBARS && (S = !0);
    var _ = b;
    return S && (_ = g), {
      availableHeight: _,
      scrollEnabledX: S,
      scrollEnabledY: T
    };
  }
  var c = (0, n.default)([r.default, function(l) {
    return l.scrollContentHeight;
  }, function(l) {
    return l.scrollFlags;
  }], s);
  e.default = c;
})(lu);
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var t = a(Fx), n = a(o4), r = a(pl), o = ws, i = a(lu);
  function a(p) {
    return p && p.__esModule ? p : { default: p };
  }
  function s() {
    return s = Object.assign || function(p) {
      for (var m = 1; m < arguments.length; m++) {
        var v = arguments[m];
        for (var g in v)
          Object.prototype.hasOwnProperty.call(v, g) && (p[g] = v[g]);
      }
      return p;
    }, s.apply(this, arguments);
  }
  function c(p, m, v, g, b) {
    var x = v ? b : 0, T = g - x, S = l(p, m, T), _ = S.newColumnGroupProps, w = S.newColumnProps, k = d(w), E = k.fixedColumns, R = k.fixedRightColumns, P = k.scrollableColumns, A = T - (0, o.getTotalWidth)(E) - (0, o.getTotalWidth)(R), D = Math.max(0, (0, o.getTotalWidth)(w) - T);
    return {
      columnGroupProps: _,
      columnProps: w,
      availableScrollWidth: A,
      fixedColumns: E,
      fixedRightColumns: R,
      scrollableColumns: P,
      maxScrollX: D
    };
  }
  function l(p, m, v) {
    var g = m, b = (0, o.getTotalFlexGrow)(m);
    if (b !== 0) {
      var x = (0, o.getTotalWidth)(m), T = Math.max(v - x, 0);
      g = (0, n.default)(m, function(w) {
        var k = w.flexGrow;
        if (!k)
          return w;
        var E = Math.floor(k * T / b), R = w.width + E;
        return b -= k, T -= E, s({}, w, {
          width: R
        });
      });
    }
    var S = (0, n.default)(p, function() {
      return 0;
    });
    (0, t.default)(g, function(w) {
      w.groupIdx !== void 0 && (S[w.groupIdx] += w.width);
    });
    var _ = (0, n.default)(p, function(w, k) {
      return S[k] === w.width ? w : s({}, w, {
        width: S[k]
      });
    });
    return {
      newColumnGroupProps: _,
      newColumnProps: g
    };
  }
  function d(p) {
    var m = [], v = [], g = [];
    return (0, t.default)(p, function(b) {
      var x = g;
      b.fixed ? x = m : b.fixedRight && (x = v), x.push(b);
    }), {
      fixedColumns: m,
      fixedRightColumns: v,
      scrollableColumns: g
    };
  }
  var f = (0, r.default)([function(p) {
    return p.columnGroupProps;
  }, function(p) {
    return p.columnProps;
  }, function(p) {
    return (0, i.default)(p).scrollEnabledY;
  }, function(p) {
    return p.tableSize.width;
  }, function(p) {
    return p.scrollbarYWidth;
  }], c);
  e.default = f;
})(zx);
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var t = o(Fx), n = o(pl), r = o(zx);
  function o(s) {
    return s && s.__esModule ? s : { default: s };
  }
  function i(s, c) {
    var l = s.columnGroupProps, d = s.columnProps, f = [], p = [], m = [];
    (0, t.default)(l, function(x, T) {
      var S = {
        props: x,
        template: c.groupHeader[T]
      };
      x.fixed ? f.push(S) : x.fixedRight ? p.push(S) : m.push(S);
    });
    var v = {
      cell: [],
      header: [],
      footer: []
    }, g = {
      cell: [],
      header: [],
      footer: []
    }, b = {
      cell: [],
      header: [],
      footer: []
    };
    return (0, t.default)(d, function(x, T) {
      var S = b;
      x.fixed ? S = v : x.fixedRight && (S = g), S.cell.push({
        props: x,
        template: c.cell[T]
      }), S.header.push({
        props: x,
        template: c.header[T]
      }), S.footer.push({
        props: x,
        template: c.footer[T]
      });
    }), {
      fixedColumnGroups: f,
      fixedColumns: v,
      fixedRightColumnGroups: p,
      fixedRightColumns: g,
      scrollableColumnGroups: m,
      scrollableColumns: b
    };
  }
  var a = (0, n.default)([function(s) {
    return (0, r.default)(s);
  }, function(s) {
    return s.elementTemplates;
  }], i);
  e.default = a;
})(qL);
var Hx = {};
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var t = o(pl), n = o(nv), r = o(lu);
  function o(s) {
    return s && s.__esModule ? s : { default: s };
  }
  function i(s, c, l, d, f, p, m) {
    var v = f.availableHeight, g = f.scrollEnabledX, b = l;
    g && (b += m);
    var x = Math.min(v, d), T = p ? x : v, S = T + b, _ = T;
    c < S && (_ = c - b);
    var w = p ? d : Math.max(d, v), k = w + b;
    c && (k = Math.max(c, k));
    var E = s.footerHeight, R = s.groupHeaderHeight, P = s.headerHeight, A = R + P, D = A + _, N = D + E, F = Math.max(0, D - A);
    return {
      bodyHeight: x,
      bodyOffsetTop: A,
      componentHeight: S,
      contentHeight: k,
      footOffsetTop: D,
      scrollbarXOffsetTop: N,
      scrollbarYHeight: F,
      visibleRowsHeight: _
    };
  }
  var a = (0, t.default)([function(s) {
    return s.elementHeights;
  }, function(s) {
    return s.tableSize.ownerHeight;
  }, function(s) {
    return (0, n.default)(s).reservedHeight;
  }, function(s) {
    return s.scrollContentHeight;
  }, r.default, function(s) {
    return s.tableSize.useMaxHeight;
  }, function(s) {
    return s.scrollbarXHeight;
  }], i);
  e.default = a;
})(Hx);
var i4 = {}, ov = {}, a4 = {};
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var t = n(_s);
  function n(i) {
    return i && i.__esModule ? i : { default: i };
  }
  var r = {
    /**
     * Listen to DOM events during the bubble phase.
     *
     * @param {DOMEventTarget} target DOM element to register listener on.
     * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
     * @param {function} callback Callback function.
     * @return {object} Object with a `remove` method.
     */
    listen: function(a, s, c) {
      if (a.addEventListener)
        return a.addEventListener(s, c, !1), {
          remove: function() {
            a.removeEventListener(s, c, !1);
          }
        };
      if (a.attachEvent)
        return a.attachEvent("on" + s, c), {
          remove: function() {
            a.detachEvent("on" + s, c);
          }
        };
    },
    /**
     * Listen to DOM events during the capture phase.
     *
     * @param {DOMEventTarget} target DOM element to register listener on.
     * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
     * @param {function} callback Callback function.
     * @return {object} Object with a `remove` method.
     */
    capture: function(a, s, c) {
      return a.addEventListener ? (a.addEventListener(s, c, !0), {
        remove: function() {
          a.removeEventListener(s, c, !0);
        }
      }) : (process.env.NODE_ENV !== "production" && console.error("Attempted to listen to events during the capture phase on a browser that does not support the capture phase. Your application will not receive some events."), {
        remove: t.default
      });
    },
    registerDefault: function() {
    }
  }, o = r;
  e.default = o;
})(a4);
var s4 = {};
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var t = n(iu);
  function n(i) {
    return i && i.__esModule ? i : { default: i };
  }
  var r = t.default.cancelAnimationFrame || t.default.webkitCancelAnimationFrame || t.default.mozCancelAnimationFrame || t.default.oCancelAnimationFrame || t.default.msCancelAnimationFrame || t.default.clearTimeout, o = r;
  e.default = o;
})(s4);
var iv = {};
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  function t(o) {
    var i = 0, a = 0;
    if (!o.clientX || !o.clientY) {
      if (o.touches && o.touches.length > 0) {
        var s = o.touches[0];
        i = s.clientX, a = s.clientY;
      }
    } else
      i = o.clientX, a = o.clientY;
    return {
      x: i,
      y: a
    };
  }
  var n = {
    getCoordinatesFromEvent: t
  }, r = n;
  e.default = r;
})(iv);
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var t = i(a4), n = i(s4), r = i(ev), o = i(iv);
  function i(f) {
    return f && f.__esModule ? f : { default: f };
  }
  function a(f, p) {
    if (!(f instanceof p))
      throw new TypeError("Cannot call a class as a function");
  }
  function s(f, p) {
    for (var m = 0; m < p.length; m++) {
      var v = p[m];
      v.enumerable = v.enumerable || !1, v.configurable = !0, "value" in v && (v.writable = !0), Object.defineProperty(f, v.key, v);
    }
  }
  function c(f, p, m) {
    return p && s(f.prototype, p), f;
  }
  var l = /* @__PURE__ */ function() {
    function f(p, m, v, g) {
      a(this, f), this._isDragging = !1, this._isTouchEnabled = g, this._animationFrameID = null, this._domNode = v, this._onMove = p, this._onMoveEnd = m, this._onMouseEnd = this._onMouseEnd.bind(this), this._onMouseMove = this._onMouseMove.bind(this), this._onMouseUp = this._onMouseUp.bind(this), this._didMouseMove = this._didMouseMove.bind(this);
    }
    return c(f, [{
      key: "captureMouseMoves",
      value: function(m) {
        if (!this._eventMoveToken && !this._eventUpToken && !this._eventLeaveToken && (this._eventMoveToken = t.default.listen(this._domNode, "mousemove", this._onMouseMove), this._eventUpToken = t.default.listen(this._domNode, "mouseup", this._onMouseUp), this._eventLeaveToken = t.default.listen(this._domNode, "mouseleave", this._onMouseEnd)), this._isTouchEnabled && !this._eventTouchStartToken && !this._eventTouchMoveToken && !this._eventTouchEndToken && (this._eventTouchStartToken = t.default.listen(this._domNode, "touchstart", this._onMouseMove), this._eventTouchMoveToken = t.default.listen(this._domNode, "touchmove", this._onMouseMove), this._eventTouchEndToken = t.default.listen(this._domNode, "touchend", this._onMouseUp)), !this._isDragging) {
          this._deltaX = 0, this._deltaY = 0, this._isDragging = !0;
          var v = o.default.getCoordinatesFromEvent(m), g = v.x, b = v.y;
          this._x = g, this._y = b;
        }
        m.preventDefault();
      }
      /**
       * This releases all of the listeners on document.body.
       */
    }, {
      key: "releaseMouseMoves",
      value: function() {
        this._eventMoveToken && this._eventUpToken && this._eventLeaveToken && (this._eventMoveToken.remove(), this._eventMoveToken = null, this._eventUpToken.remove(), this._eventUpToken = null, this._eventLeaveToken.remove(), this._eventLeaveToken = null), this._isTouchEnabled && this._eventTouchStartToken && this._eventTouchMoveToken && this._eventTouchEndToken && (this._eventTouchStartToken.remove(), this._eventTouchStartToken = null, this._eventTouchMoveToken.remove(), this._eventTouchMoveToken = null, this._eventTouchEndToken.remove(), this._eventTouchEndToken = null), this._animationFrameID !== null && ((0, n.default)(this._animationFrameID), this._animationFrameID = null), this._isDragging && (this._isDragging = !1, this._x = null, this._y = null);
      }
      /**
       * Returns whether or not if the mouse movement is being tracked.
       */
    }, {
      key: "isDragging",
      value: function() {
        return this._isDragging;
      }
      /**
       * Calls onMove passed into constructor and updates internal state.
       */
    }, {
      key: "_onMouseMove",
      value: function(m) {
        var v = o.default.getCoordinatesFromEvent(m), g = v.x, b = v.y;
        this._deltaX += g - this._x, this._deltaY += b - this._y, this._animationFrameID === null && (this._animationFrameID = (0, r.default)(this._didMouseMove)), this._x = g, this._y = b, m.preventDefault();
      }
    }, {
      key: "_didMouseMove",
      value: function() {
        this._animationFrameID = null, this._onMove(this._deltaX, this._deltaY), this._deltaX = 0, this._deltaY = 0;
      }
      /**
       * Calls onMoveEnd passed into constructor and updates internal state.
       */
    }, {
      key: "_onMouseUp",
      value: function() {
        this._animationFrameID && this._didMouseMove(), this._onMoveEnd(!1);
      }
      /**
       * Calls onMoveEnd passed into the constructor, updates internal state, and cancels the move.
       */
    }, {
      key: "_onMouseEnd",
      value: function() {
        this._onMoveEnd(!0);
      }
    }]), f;
  }(), d = l;
  e.default = d;
})(ov);
(function(e) {
  function t(w) {
    "@babel/helpers - typeof";
    return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? t = function(E) {
      return typeof E;
    } : t = function(E) {
      return E && typeof Symbol == "function" && E.constructor === Symbol && E !== Symbol.prototype ? "symbol" : typeof E;
    }, t(w);
  }
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var n = s(et), r = s(Jr), o = s(rv), i = s(Jo), a = s(ov);
  function s(w) {
    return w && w.__esModule ? w : { default: w };
  }
  function c(w, k) {
    if (!(w instanceof k))
      throw new TypeError("Cannot call a class as a function");
  }
  function l(w, k) {
    for (var E = 0; E < k.length; E++) {
      var R = k[E];
      R.enumerable = R.enumerable || !1, R.configurable = !0, "value" in R && (R.writable = !0), Object.defineProperty(w, R.key, R);
    }
  }
  function d(w, k, E) {
    return k && l(w.prototype, k), w;
  }
  function f(w, k) {
    if (typeof k != "function" && k !== null)
      throw new TypeError("Super expression must either be null or a function");
    w.prototype = Object.create(k && k.prototype, { constructor: { value: w, writable: !0, configurable: !0 } }), k && p(w, k);
  }
  function p(w, k) {
    return p = Object.setPrototypeOf || function(R, P) {
      return R.__proto__ = P, R;
    }, p(w, k);
  }
  function m(w) {
    var k = b();
    return function() {
      var R = x(w), P;
      if (k) {
        var A = x(this).constructor;
        P = Reflect.construct(R, arguments, A);
      } else
        P = R.apply(this, arguments);
      return v(this, P);
    };
  }
  function v(w, k) {
    return k && (t(k) === "object" || typeof k == "function") ? k : g(w);
  }
  function g(w) {
    if (w === void 0)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return w;
  }
  function b() {
    if (typeof Reflect == "undefined" || !Reflect.construct || Reflect.construct.sham)
      return !1;
    if (typeof Proxy == "function")
      return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      })), !0;
    } catch (w) {
      return !1;
    }
  }
  function x(w) {
    return x = Object.setPrototypeOf ? Object.getPrototypeOf : function(E) {
      return E.__proto__ || Object.getPrototypeOf(E);
    }, x(w);
  }
  function T(w, k, E) {
    return k in w ? Object.defineProperty(w, k, { value: E, enumerable: !0, configurable: !0, writable: !0 }) : w[k] = E, w;
  }
  var S = /* @__PURE__ */ function(w) {
    f(E, w);
    var k = m(E);
    function E() {
      var R;
      c(this, E);
      for (var P = arguments.length, A = new Array(P), D = 0; D < P; D++)
        A[D] = arguments[D];
      return R = k.call.apply(k, [this].concat(A)), T(
        g(R),
        "state",
        /*object*/
        {
          width: 0,
          cursorDelta: 0
        }
      ), T(g(R), "_onMove", function(N) {
        R.props.isRTL && (N = -N);
        var F = R.state.cursorDelta + N, $ = (0, o.default)(F, R.props.minWidth, R.props.maxWidth);
        R.setState({
          width: $,
          cursorDelta: F
        });
      }), T(g(R), "_onColumnResizeEnd", function() {
        R._mouseMoveTracker && R._mouseMoveTracker.releaseMouseMoves(), R.props.onColumnResizeEnd(R.state.width, R.props.columnKey);
      }), R;
    }
    return d(E, [{
      key: "componentDidUpdate",
      value: function() {
        this.props.initialEvent && !this._mouseMoveTracker.isDragging() && (this._mouseMoveTracker.captureMouseMoves(this.props.initialEvent), this.setState({
          width: this.props.initialWidth,
          cursorDelta: this.props.initialWidth
        }));
      }
    }, {
      key: "componentDidMount",
      value: function() {
        this._mouseMoveTracker = new a.default(this._onMove, this._onColumnResizeEnd, document.body, this.props.touchEnabled);
      }
    }, {
      key: "componentWillUnmount",
      value: function() {
        this._mouseMoveTracker && (this._mouseMoveTracker.releaseMouseMoves(), this._mouseMoveTracker = null);
      }
    }, {
      key: "render",
      value: function() {
        var P = {
          width: this.state.width,
          height: this.props.height
        };
        return this.props.isRTL ? P.right = this.props.leftOffset : P.left = this.props.leftOffset, /* @__PURE__ */ n.default.createElement("div", {
          className: (0, i.default)({
            "fixedDataTableColumnResizerLineLayout/main": !0,
            "fixedDataTableColumnResizerLineLayout/hiddenElem": !this.props.visible,
            "public/fixedDataTableColumnResizerLine/main": !0
          }),
          style: P
        }, /* @__PURE__ */ n.default.createElement("div", {
          className: (0, i.default)("fixedDataTableColumnResizerLineLayout/mouseArea"),
          style: {
            height: this.props.height
          }
        }));
      }
    }]), E;
  }(n.default.PureComponent);
  T(S, "propTypes", {
    visible: r.default.bool.isRequired,
    /**
     * This is the height of the line
     */
    height: r.default.number.isRequired,
    /**
     * Offset from left border of the table, please note
     * that the line is a border on diff. So this is really the
     * offset of the column itself.
     */
    leftOffset: r.default.number.isRequired,
    /**
     * Height of the clickable region of the line.
     * This is assumed to be at the top of the line.
     */
    knobHeight: r.default.number.isRequired,
    /**
     * The line is a border on a diff, so this is essentially
     * the width of column.
     */
    initialWidth: r.default.number,
    /**
     * The minimum width this dragger will collapse to
     */
    minWidth: r.default.number,
    /**
     * The maximum width this dragger will collapse to
     */
    maxWidth: r.default.number,
    /**
     * Initial click event on the header cell.
     */
    initialEvent: r.default.object,
    /**
     * When resizing is complete this is called.
     */
    onColumnResizeEnd: r.default.func,
    /**
     * Column key for the column being resized.
     */
    columnKey: r.default.oneOfType([r.default.string, r.default.number]),
    /**
     * Whether the resize handle should respond to touch events or not.
     */
    touchEnabled: r.default.bool,
    /**
     * Whether the line should render in RTL mode
     */
    isRTL: r.default.bool
  });
  var _ = S;
  e.default = _;
})(i4);
var l4 = {};
function oDe(e, t) {
  return e == null || e !== e ? t : e;
}
var iDe = oDe, aDe = Math.max, sDe = Math.min;
function lDe(e, t, n) {
  return e >= sDe(t, n) && e < aDe(t, n);
}
var cDe = lDe, uDe = /\s/;
function dDe(e) {
  for (var t = e.length; t-- && uDe.test(e.charAt(t)); )
    ;
  return t;
}
var fDe = dDe, pDe = fDe, hDe = /^\s+/;
function mDe(e) {
  return e && e.slice(0, pDe(e) + 1).replace(hDe, "");
}
var gDe = mDe, vDe = gDe, TP = Nf, bDe = Ug, EP = NaN, yDe = /^[-+]0x[0-9a-f]+$/i, _De = /^0b[01]+$/i, wDe = /^0o[0-7]+$/i, xDe = parseInt;
function CDe(e) {
  if (typeof e == "number")
    return e;
  if (bDe(e))
    return EP;
  if (TP(e)) {
    var t = typeof e.valueOf == "function" ? e.valueOf() : e;
    e = TP(t) ? t + "" : t;
  }
  if (typeof e != "string")
    return e === 0 ? e : +e;
  e = vDe(e);
  var n = _De.test(e);
  return n || wDe.test(e) ? xDe(e.slice(2), n ? 2 : 8) : yDe.test(e) ? EP : +e;
}
var jx = CDe, SDe = jx, kP = 1 / 0, TDe = 17976931348623157e292;
function EDe(e) {
  if (!e)
    return e === 0 ? e : 0;
  if (e = SDe(e), e === kP || e === -kP) {
    var t = e < 0 ? -1 : 1;
    return t * TDe;
  }
  return e === e ? e : 0;
}
var kDe = EDe, MDe = cDe, MP = kDe, RDe = jx;
function PDe(e, t, n) {
  return t = MP(t), n === void 0 ? (n = t, t = 0) : n = MP(n), e = RDe(e), MDe(e, t, n);
}
var ODe = PDe;
function NDe(e) {
  return e == null;
}
var c4 = NDe, Wx = {}, u4 = {}, d4 = {}, Vx = {};
(function(e) {
  function t(P) {
    "@babel/helpers - typeof";
    return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? t = function(D) {
      return typeof D;
    } : t = function(D) {
      return D && typeof Symbol == "function" && D.constructor === Symbol && D !== Symbol.prototype ? "symbol" : typeof D;
    }, t(P);
  }
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var n = a(et), r = a(Jr), o = a(Jo), i = a(ys);
  function a(P) {
    return P && P.__esModule ? P : { default: P };
  }
  function s() {
    return s = Object.assign || function(P) {
      for (var A = 1; A < arguments.length; A++) {
        var D = arguments[A];
        for (var N in D)
          Object.prototype.hasOwnProperty.call(D, N) && (P[N] = D[N]);
      }
      return P;
    }, s.apply(this, arguments);
  }
  function c(P, A) {
    var D = Object.keys(P);
    if (Object.getOwnPropertySymbols) {
      var N = Object.getOwnPropertySymbols(P);
      A && (N = N.filter(function(F) {
        return Object.getOwnPropertyDescriptor(P, F).enumerable;
      })), D.push.apply(D, N);
    }
    return D;
  }
  function l(P) {
    for (var A = 1; A < arguments.length; A++) {
      var D = arguments[A] != null ? arguments[A] : {};
      A % 2 ? c(Object(D), !0).forEach(function(N) {
        k(P, N, D[N]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(P, Object.getOwnPropertyDescriptors(D)) : c(Object(D)).forEach(function(N) {
        Object.defineProperty(P, N, Object.getOwnPropertyDescriptor(D, N));
      });
    }
    return P;
  }
  function d(P, A) {
    if (P == null)
      return {};
    var D = f(P, A), N, F;
    if (Object.getOwnPropertySymbols) {
      var $ = Object.getOwnPropertySymbols(P);
      for (F = 0; F < $.length; F++)
        N = $[F], !(A.indexOf(N) >= 0) && Object.prototype.propertyIsEnumerable.call(P, N) && (D[N] = P[N]);
    }
    return D;
  }
  function f(P, A) {
    if (P == null)
      return {};
    var D = {}, N = Object.keys(P), F, $;
    for ($ = 0; $ < N.length; $++)
      F = N[$], !(A.indexOf(F) >= 0) && (D[F] = P[F]);
    return D;
  }
  function p(P, A) {
    if (!(P instanceof A))
      throw new TypeError("Cannot call a class as a function");
  }
  function m(P, A) {
    for (var D = 0; D < A.length; D++) {
      var N = A[D];
      N.enumerable = N.enumerable || !1, N.configurable = !0, "value" in N && (N.writable = !0), Object.defineProperty(P, N.key, N);
    }
  }
  function v(P, A, D) {
    return A && m(P.prototype, A), P;
  }
  function g(P, A) {
    if (typeof A != "function" && A !== null)
      throw new TypeError("Super expression must either be null or a function");
    P.prototype = Object.create(A && A.prototype, { constructor: { value: P, writable: !0, configurable: !0 } }), A && b(P, A);
  }
  function b(P, A) {
    return b = Object.setPrototypeOf || function(N, F) {
      return N.__proto__ = F, N;
    }, b(P, A);
  }
  function x(P) {
    var A = _();
    return function() {
      var N = w(P), F;
      if (A) {
        var $ = w(this).constructor;
        F = Reflect.construct(N, arguments, $);
      } else
        F = N.apply(this, arguments);
      return T(this, F);
    };
  }
  function T(P, A) {
    return A && (t(A) === "object" || typeof A == "function") ? A : S(P);
  }
  function S(P) {
    if (P === void 0)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return P;
  }
  function _() {
    if (typeof Reflect == "undefined" || !Reflect.construct || Reflect.construct.sham)
      return !1;
    if (typeof Proxy == "function")
      return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      })), !0;
    } catch (P) {
      return !1;
    }
  }
  function w(P) {
    return w = Object.setPrototypeOf ? Object.getPrototypeOf : function(D) {
      return D.__proto__ || Object.getPrototypeOf(D);
    }, w(P);
  }
  function k(P, A, D) {
    return A in P ? Object.defineProperty(P, A, { value: D, enumerable: !0, configurable: !0, writable: !0 }) : P[A] = D, P;
  }
  var E = /* @__PURE__ */ function(P) {
    g(D, P);
    var A = x(D);
    function D() {
      return p(this, D), A.apply(this, arguments);
    }
    return v(D, [{
      key: "render",
      value: function() {
        var F = this.props, $ = F.height, I = F.width, j = F.style, U = F.className, G = F.children, V = d(F, ["height", "width", "isVisible", "style", "className", "children", "columnKey", "rowIndex"]), H = l({
          height: $,
          width: I
        }, j);
        return /* @__PURE__ */ n.default.createElement("div", s({}, V, {
          className: (0, i.default)((0, o.default)("fixedDataTableCellLayout/wrap1"), (0, o.default)("public/fixedDataTableCell/wrap1"), U),
          style: H
        }), /* @__PURE__ */ n.default.createElement("div", {
          className: (0, i.default)((0, o.default)("fixedDataTableCellLayout/wrap2"), (0, o.default)("public/fixedDataTableCell/wrap2"))
        }, /* @__PURE__ */ n.default.createElement("div", {
          className: (0, i.default)((0, o.default)("fixedDataTableCellLayout/wrap3"), (0, o.default)("public/fixedDataTableCell/wrap3"))
        }, /* @__PURE__ */ n.default.createElement("div", {
          className: (0, o.default)("public/fixedDataTableCell/cellContent")
        }, G))));
      }
    }]), D;
  }(n.default.Component);
  k(E, "propTypes", {
    /**
     * Outer height of the cell.
     */
    height: r.default.number,
    /**
     * Outer width of the cell.
     */
    width: r.default.number,
    /**
     * Optional prop that if specified on the `Column` will be passed to the
     * cell. It can be used to uniquely identify which column is the cell is in.
     */
    columnKey: r.default.oneOfType([r.default.string, r.default.number]),
    /**
     * Optional prop that represents the rows index in the table.
     * For the 'cell' prop of a Column, this parameter will exist for any
     * cell in a row with a positive index.
     *
     * Below that entry point the user is welcome to consume or
     * pass the prop through at their discretion.
     */
    rowIndex: r.default.number,
    /**
     * Whether this cell is currently within the viewport.
     */
    isVisible: r.default.bool
  });
  var R = E;
  e.default = R;
})(Vx);
var f4 = {};
(function(e) {
  function t(w) {
    "@babel/helpers - typeof";
    return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? t = function(E) {
      return typeof E;
    } : t = function(E) {
      return E && typeof Symbol == "function" && E.constructor === Symbol && E !== Symbol.prototype ? "symbol" : typeof E;
    }, t(w);
  }
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var n = s(et), r = s(Jr), o = s(Jo), i = s(ov), a = s(iv);
  function s(w) {
    return w && w.__esModule ? w : { default: w };
  }
  function c(w, k) {
    if (!(w instanceof k))
      throw new TypeError("Cannot call a class as a function");
  }
  function l(w, k) {
    for (var E = 0; E < k.length; E++) {
      var R = k[E];
      R.enumerable = R.enumerable || !1, R.configurable = !0, "value" in R && (R.writable = !0), Object.defineProperty(w, R.key, R);
    }
  }
  function d(w, k, E) {
    return k && l(w.prototype, k), w;
  }
  function f(w, k) {
    if (typeof k != "function" && k !== null)
      throw new TypeError("Super expression must either be null or a function");
    w.prototype = Object.create(k && k.prototype, { constructor: { value: w, writable: !0, configurable: !0 } }), k && p(w, k);
  }
  function p(w, k) {
    return p = Object.setPrototypeOf || function(R, P) {
      return R.__proto__ = P, R;
    }, p(w, k);
  }
  function m(w) {
    var k = b();
    return function() {
      var R = x(w), P;
      if (k) {
        var A = x(this).constructor;
        P = Reflect.construct(R, arguments, A);
      } else
        P = R.apply(this, arguments);
      return v(this, P);
    };
  }
  function v(w, k) {
    return k && (t(k) === "object" || typeof k == "function") ? k : g(w);
  }
  function g(w) {
    if (w === void 0)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return w;
  }
  function b() {
    if (typeof Reflect == "undefined" || !Reflect.construct || Reflect.construct.sham)
      return !1;
    if (typeof Proxy == "function")
      return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      })), !0;
    } catch (w) {
      return !1;
    }
  }
  function x(w) {
    return x = Object.setPrototypeOf ? Object.getPrototypeOf : function(E) {
      return E.__proto__ || Object.getPrototypeOf(E);
    }, x(w);
  }
  function T(w, k, E) {
    return k in w ? Object.defineProperty(w, k, { value: E, enumerable: !0, configurable: !0, writable: !0 }) : w[k] = E, w;
  }
  var S = /* @__PURE__ */ function(w) {
    f(E, w);
    var k = m(E);
    function E() {
      var R;
      c(this, E);
      for (var P = arguments.length, A = new Array(P), D = 0; D < P; D++)
        A[D] = arguments[D];
      return R = k.call.apply(k, [this].concat(A)), T(
        g(R),
        "state",
        /*object*/
        {
          dragDistance: 0
        }
      ), T(g(R), "onMouseDown", function(N) {
        var F = N.target.getBoundingClientRect(), $ = a.default.getCoordinatesFromEvent(N), I = $.x - F.left, j = I + N.target.parentElement.offsetLeft;
        R._mouseMoveTracker = new i.default(R._onMove, R._onColumnReorderEnd, document.body, R.props.touchEnabled), R._mouseMoveTracker.captureMouseMoves(N), R.setState({
          dragDistance: 0
        }), R.props.onMouseDown({
          columnKey: R.props.columnKey,
          mouseLocation: {
            dragDistance: 0,
            inElement: I,
            inColumnGroup: j
          }
        }), R._distance = 0, R._animating = !0, R.frameId = requestAnimationFrame(R._updateState), R.props.touchEnabled && N.stopPropagation();
      }), T(g(R), "_onMove", function(N) {
        R._distance = R.state.dragDistance + N * (R.props.isRTL ? -1 : 1);
      }), T(g(R), "_onColumnReorderEnd", function(N) {
        R._animating = !1, cancelAnimationFrame(R.frameId), R.frameId = null, R._mouseMoveTracker && R._mouseMoveTracker.releaseMouseMoves(), R.props.columnReorderingData.cancelReorder = N, R.props.onColumnReorderEnd();
      }), T(g(R), "_updateState", function() {
        R._animating && (R.frameId = requestAnimationFrame(R._updateState)), R.setState({
          dragDistance: R._distance
        }), R.props.onColumnReorderMove(R._distance);
      }), R;
    }
    return d(E, [{
      key: "componentWillUnmount",
      value: function() {
        this._mouseMoveTracker && (cancelAnimationFrame(this.frameId), this.frameId = null, this._mouseMoveTracker.releaseMouseMoves(), this._mouseMoveTracker = null);
      }
    }, {
      key: "render",
      value: function() {
        var P = {
          height: this.props.height
        };
        return /* @__PURE__ */ n.default.createElement("div", {
          className: (0, o.default)({
            "fixedDataTableCellLayout/columnReorderContainer": !0,
            "fixedDataTableCellLayout/columnReorderContainer/active": !1
          }),
          onMouseDown: this.onMouseDown,
          onTouchStart: this.props.touchEnabled ? this.onMouseDown : null,
          onTouchEnd: this.props.touchEnabled ? function(A) {
            return A.stopPropagation();
          } : null,
          onTouchMove: this.props.touchEnabled ? function(A) {
            return A.stopPropagation();
          } : null,
          style: P
        });
      }
    }]), E;
  }(n.default.PureComponent);
  T(S, "propTypes", {
    /**
     * When resizing is complete this is called.
     */
    onColumnReorderEnd: r.default.func,
    /**
     * Column key for the column being reordered.
     */
    columnKey: r.default.oneOfType([r.default.string, r.default.number]),
    /**
     * Whether the reorder handle should respond to touch events or not.
     */
    touchEnabled: r.default.bool,
    /**
     * If the component should render for RTL direction
     */
    isRTL: r.default.bool
  });
  var _ = S;
  e.default = _;
})(f4);
function p4() {
  var e = this.constructor.getDerivedStateFromProps(this.props, this.state);
  e != null && this.setState(e);
}
function h4(e) {
  function t(n) {
    var r = this.constructor.getDerivedStateFromProps(e, n);
    return r != null ? r : null;
  }
  this.setState(t.bind(this));
}
function m4(e, t) {
  try {
    var n = this.props, r = this.state;
    this.props = e, this.state = t, this.__reactInternalSnapshotFlag = !0, this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      n,
      r
    );
  } finally {
    this.props = n, this.state = r;
  }
}
p4.__suppressDeprecationWarning = !0;
h4.__suppressDeprecationWarning = !0;
m4.__suppressDeprecationWarning = !0;
function ADe(e) {
  var t = e.prototype;
  if (!t || !t.isReactComponent)
    throw new Error("Can only polyfill class components");
  if (typeof e.getDerivedStateFromProps != "function" && typeof t.getSnapshotBeforeUpdate != "function")
    return e;
  var n = null, r = null, o = null;
  if (typeof t.componentWillMount == "function" ? n = "componentWillMount" : typeof t.UNSAFE_componentWillMount == "function" && (n = "UNSAFE_componentWillMount"), typeof t.componentWillReceiveProps == "function" ? r = "componentWillReceiveProps" : typeof t.UNSAFE_componentWillReceiveProps == "function" && (r = "UNSAFE_componentWillReceiveProps"), typeof t.componentWillUpdate == "function" ? o = "componentWillUpdate" : typeof t.UNSAFE_componentWillUpdate == "function" && (o = "UNSAFE_componentWillUpdate"), n !== null || r !== null || o !== null) {
    var i = e.displayName || e.name, a = typeof e.getDerivedStateFromProps == "function" ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
    throw Error(
      `Unsafe legacy lifecycles will not be called for components using new component APIs.

` + i + " uses " + a + " but also contains the following legacy lifecycles:" + (n !== null ? `
  ` + n : "") + (r !== null ? `
  ` + r : "") + (o !== null ? `
  ` + o : "") + `

The above lifecycles should be removed. Learn more about this warning here:
https://fb.me/react-async-component-lifecycle-hooks`
    );
  }
  if (typeof e.getDerivedStateFromProps == "function" && (t.componentWillMount = p4, t.componentWillReceiveProps = h4), typeof t.getSnapshotBeforeUpdate == "function") {
    if (typeof t.componentDidUpdate != "function")
      throw new Error(
        "Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype"
      );
    t.componentWillUpdate = m4;
    var s = t.componentDidUpdate;
    t.componentDidUpdate = function(l, d, f) {
      var p = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : f;
      s.call(this, l, d, p);
    };
  }
  return e;
}
const DDe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  polyfill: ADe
}, Symbol.toStringTag, { value: "Module" })), g4 = /* @__PURE__ */ Go(DDe);
(function(e) {
  function t(D) {
    "@babel/helpers - typeof";
    return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? t = function(F) {
      return typeof F;
    } : t = function(F) {
      return F && typeof Symbol == "function" && F.constructor === Symbol && F !== Symbol.prototype ? "symbol" : typeof F;
    }, t(D);
  }
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var n = d(et), r = d(Jr), o = d(Jo), i = d(ys), a = d(Df), s = d(Vx), c = d(f4), l = g4;
  function d(D) {
    return D && D.__esModule ? D : { default: D };
  }
  function f() {
    return f = Object.assign || function(D) {
      for (var N = 1; N < arguments.length; N++) {
        var F = arguments[N];
        for (var $ in F)
          Object.prototype.hasOwnProperty.call(F, $) && (D[$] = F[$]);
      }
      return D;
    }, f.apply(this, arguments);
  }
  function p(D, N) {
    if (D == null)
      return {};
    var F = m(D, N), $, I;
    if (Object.getOwnPropertySymbols) {
      var j = Object.getOwnPropertySymbols(D);
      for (I = 0; I < j.length; I++)
        $ = j[I], !(N.indexOf($) >= 0) && Object.prototype.propertyIsEnumerable.call(D, $) && (F[$] = D[$]);
    }
    return F;
  }
  function m(D, N) {
    if (D == null)
      return {};
    var F = {}, $ = Object.keys(D), I, j;
    for (j = 0; j < $.length; j++)
      I = $[j], !(N.indexOf(I) >= 0) && (F[I] = D[I]);
    return F;
  }
  function v(D, N) {
    if (!(D instanceof N))
      throw new TypeError("Cannot call a class as a function");
  }
  function g(D, N) {
    for (var F = 0; F < N.length; F++) {
      var $ = N[F];
      $.enumerable = $.enumerable || !1, $.configurable = !0, "value" in $ && ($.writable = !0), Object.defineProperty(D, $.key, $);
    }
  }
  function b(D, N, F) {
    return N && g(D.prototype, N), F && g(D, F), D;
  }
  function x(D, N) {
    if (typeof N != "function" && N !== null)
      throw new TypeError("Super expression must either be null or a function");
    D.prototype = Object.create(N && N.prototype, { constructor: { value: D, writable: !0, configurable: !0 } }), N && T(D, N);
  }
  function T(D, N) {
    return T = Object.setPrototypeOf || function($, I) {
      return $.__proto__ = I, $;
    }, T(D, N);
  }
  function S(D) {
    var N = k();
    return function() {
      var $ = E(D), I;
      if (N) {
        var j = E(this).constructor;
        I = Reflect.construct($, arguments, j);
      } else
        I = $.apply(this, arguments);
      return _(this, I);
    };
  }
  function _(D, N) {
    return N && (t(N) === "object" || typeof N == "function") ? N : w(D);
  }
  function w(D) {
    if (D === void 0)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return D;
  }
  function k() {
    if (typeof Reflect == "undefined" || !Reflect.construct || Reflect.construct.sham)
      return !1;
    if (typeof Proxy == "function")
      return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      })), !0;
    } catch (D) {
      return !1;
    }
  }
  function E(D) {
    return E = Object.setPrototypeOf ? Object.getPrototypeOf : function(F) {
      return F.__proto__ || Object.getPrototypeOf(F);
    }, E(D);
  }
  function R(D, N, F) {
    return N in D ? Object.defineProperty(D, N, { value: F, enumerable: !0, configurable: !0, writable: !0 }) : D[N] = F, D;
  }
  var P = /* @__PURE__ */ function(D) {
    x(F, D);
    var N = S(F);
    function F() {
      var $;
      v(this, F);
      for (var I = arguments.length, j = new Array(I), U = 0; U < I; U++)
        j[U] = arguments[U];
      return $ = N.call.apply(N, [this].concat(j)), R(w($), "state", {
        isReorderingThisColumn: !1,
        displacement: 0,
        reorderingDisplacement: 0
      }), R(w($), "_onColumnResizerMouseDown", function(G) {
        $.props.onColumnResize($.props.left, $.props.width, $.props.minWidth, $.props.maxWidth, $.props.columnKey, G), $.props.touchEnabled && (G.preventDefault(), G.stopPropagation());
      }), R(w($), "_onColumnReorderMouseDown", function(G) {
        $.props.onColumnReorder($.props.columnKey, $.props.width, $.props.left, G);
      }), R(w($), "_suppressEvent", function(G) {
        G.preventDefault(), G.stopPropagation();
      }), $;
    }
    return b(F, [{
      key: "shouldComponentUpdate",
      value: function(I) {
        if (I.isScrolling && this.props.rowIndex === I.rowIndex && this.props.isVisible === I.isVisible)
          return !1;
        if (!I.pureRendering)
          return !0;
        var j = this.props, U = j.cell, G = p(j, ["cell"]), V = I.cell, H = p(I, ["cell"]);
        return !(0, a.default)(G, H) || !U || !V || U.type !== V.type || !(0, a.default)(U.props, V.props);
      }
    }, {
      key: "render",
      value: function() {
        var I = this.props, j = I.height, U = I.width, G = I.isVisible, V = I.columnKey, H = I.isHeaderOrFooter, q = p(I, ["height", "width", "isVisible", "columnKey", "isHeaderOrFooter"]), Q = {
          height: j,
          width: U
        };
        if (this.props.isRTL ? Q.right = q.left : Q.left = q.left, this.state.isReorderingThisColumn) {
          var X = this.props.isRTL ? -1 : 1;
          Q.transform = "translateX(".concat(this.state.displacement * X, "px) translateZ(0)"), Q.zIndex = 1;
        }
        var K = (0, i.default)((0, o.default)({
          "fixedDataTableCellLayout/main": !0,
          "fixedDataTableCellLayout/lastChild": q.lastChild,
          "fixedDataTableCellLayout/alignRight": q.align === "right",
          "fixedDataTableCellLayout/alignCenter": q.align === "center",
          "public/fixedDataTableCell/alignRight": q.align === "right",
          "public/fixedDataTableCell/highlighted": q.highlighted,
          "public/fixedDataTableCell/main": !0,
          "public/fixedDataTableCell/hasReorderHandle": !!q.onColumnReorder,
          "public/fixedDataTableCell/reordering": this.state.isReorderingThisColumn
        }), q.className), J;
        if (q.onColumnResize) {
          var ne = {
            height: j
          };
          J = /* @__PURE__ */ n.default.createElement("div", {
            className: (0, o.default)("fixedDataTableCellLayout/columnResizerContainer"),
            style: ne,
            onMouseDown: this._onColumnResizerMouseDown,
            onTouchStart: this.props.touchEnabled ? this._onColumnResizerMouseDown : null,
            onTouchEnd: this.props.touchEnabled ? this._suppressEvent : null,
            onTouchMove: this.props.touchEnabled ? this._suppressEvent : null
          }, /* @__PURE__ */ n.default.createElement("div", {
            className: (0, i.default)((0, o.default)("fixedDataTableCellLayout/columnResizerKnob"), (0, o.default)("public/fixedDataTableCell/columnResizerKnob")),
            style: ne
          }));
        }
        var ae;
        q.onColumnReorder && (ae = /* @__PURE__ */ n.default.createElement(c.default, f({
          columnKey: this.columnKey,
          touchEnabled: this.props.touchEnabled,
          onMouseDown: this._onColumnReorderMouseDown,
          onTouchStart: this._onColumnReorderMouseDown,
          height: j
        }, this.props)));
        var te = {
          columnKey: V,
          height: j,
          width: U,
          isVisible: G
        };
        q.rowIndex >= 0 && (te.rowIndex = q.rowIndex);
        var le;
        /* @__PURE__ */ n.default.isValidElement(q.cell) ? le = /* @__PURE__ */ n.default.cloneElement(q.cell, te) : typeof q.cell == "function" ? le = q.cell(te) : le = /* @__PURE__ */ n.default.createElement(s.default, te, q.cell);
        var ce = H ? "columnheader" : "gridcell";
        return /* @__PURE__ */ n.default.createElement("div", {
          className: K,
          style: Q,
          role: ce
        }, J, ae, le);
      }
    }], [{
      key: "getDerivedStateFromProps",
      value: function(I, j) {
        var U = I.left + j.displacement, G = {
          isReorderingThisColumn: !1
        };
        if (!I.isColumnReordering)
          return G.displacement = 0, G;
        var V = I.columnReorderingData.originalLeft, H = V + I.columnReorderingData.dragDistance, q = I.columnGroupWidth - I.columnReorderingData.columnWidth;
        if (H = Math.max(H, 0), H = Math.min(H, q), I.columnKey === I.columnReorderingData.columnKey)
          return G.displacement = H - I.left, G.isReorderingThisColumn = !0, G;
        var Q = H + I.columnReorderingData.columnWidth, X = H + I.columnReorderingData.columnWidth / 2, K = U + I.width / 2, J = X > K, ne = V > I.left, ae = !1;
        return J ? H < K && (ae = !0, ne ? G.displacement = I.columnReorderingData.columnWidth : G.displacement = 0) : Q > K && (ae = !0, ne ? G.displacement = 0 : G.displacement = I.columnReorderingData.columnWidth * -1), ae ? J ? I.columnReorderingData.columnAfter || (I.columnReorderingData.columnAfter = I.columnKey) : I.columnReorderingData.columnBefore = I.columnKey : J ? I.columnReorderingData.columnBefore = I.columnKey : I.columnReorderingData.columnAfter || (I.columnReorderingData.columnAfter = I.columnKey), G;
      }
    }]), F;
  }(n.default.Component);
  R(P, "propTypes_DISABLED_FOR_PERFORMANCE", {
    isScrolling: r.default.bool,
    align: r.default.oneOf(["left", "center", "right"]),
    className: r.default.string,
    highlighted: r.default.bool,
    width: r.default.number.isRequired,
    minWidth: r.default.number,
    maxWidth: r.default.number,
    height: r.default.number.isRequired,
    cell: r.default.oneOfType([r.default.string, r.default.element, r.default.func]),
    columnKey: r.default.oneOfType([r.default.string, r.default.number]),
    /**
     * The row index that will be passed to `cellRenderer` to render.
     */
    rowIndex: r.default.number.isRequired,
    /**
     * Callback for when resizer knob (in FixedDataTableCell) is clicked
     * to initialize resizing. Please note this is only on the cells
     * in the header.
     * @param number combinedWidth
     * @param number left
     * @param number width
     * @param number minWidth
     * @param number maxWidth
     * @param number|string columnKey
     * @param object event
     */
    onColumnResize: r.default.func,
    onColumnReorder: r.default.func,
    /**
     * The left offset in pixels of the cell.
     */
    left: r.default.number,
    /**
     * Flag for enhanced performance check
     */
    pureRendering: r.default.bool,
    /**
     * Whether touch is enabled or not.
     */
    touchEnabled: r.default.bool,
    /**
     * Whether the cell group is part of the header or footer
     */
    isHeaderOrFooter: r.default.bool,
    /**
     * If the component should render for RTL direction
     */
    isRTL: r.default.bool,
    /**
     * Whether this cell is visible (i.e, inside the viewport) or not.
     */
    isVisible: r.default.bool.isRequired
  }), R(
    P,
    "defaultProps",
    /*object*/
    {
      align: "left",
      highlighted: !1
    }
  );
  var A = (0, l.polyfill)(P);
  e.default = A;
})(d4);
var If = {}, Ux = {}, qx = {}, v4 = {};
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var t = /-(.)/g;
  function n(o) {
    return o.replace(t, function(i, a) {
      return a.toUpperCase();
    });
  }
  var r = n;
  e.default = r;
})(v4);
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var t = o(Qc), n = o(Ax), r = o(v4);
  function o(p) {
    return p && p.__esModule ? p : { default: p };
  }
  var i = {}, a = ["Webkit", "ms", "Moz", "O"], s = new RegExp("^(" + a.join("|") + ")"), c = n.default.canUseDOM ? document.createElement("div").style : {};
  function l(p) {
    for (var m = 0; m < a.length; m++) {
      var v = a[m] + p;
      if (v in c)
        return v;
    }
    return null;
  }
  function d(p) {
    var m = (0, r.default)(p);
    if (i[m] === void 0) {
      var v = m.charAt(0).toUpperCase() + m.slice(1);
      s.test(v) && (0, t.default)(!1, "getVendorPrefixedName must only be called with unprefixedCSS property names. It was called with %s", p), i[m] = m in c ? m : l(v);
    }
    return i[m];
  }
  var f = d;
  e.default = f;
})(qx);
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var t = n(qx);
  function n(i) {
    return i && i.__esModule ? i : { default: i };
  }
  var r = {
    /**
     * @return {bool} True if browser supports css animations.
     */
    hasCSSAnimations: function() {
      return !!(0, t.default)("animationName");
    },
    /**
     * @return {bool} True if browser supports css transforms.
     */
    hasCSSTransforms: function() {
      return !!(0, t.default)("transform");
    },
    /**
     * @return {bool} True if browser supports css 3d transforms.
     */
    hasCSS3DTransforms: function() {
      return !!(0, t.default)("perspective");
    },
    /**
     * @return {bool} True if browser supports css transitions.
     */
    hasCSSTransitions: function() {
      return !!(0, t.default)("transition");
    }
  }, o = r;
  e.default = o;
})(Ux);
var b4 = {};
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var t = o(Ux), n = o(qx), r = o(iu);
  function o(c) {
    return c && c.__esModule ? c : { default: c };
  }
  var i = (0, n.default)("transform");
  (0, n.default)("backfaceVisibility");
  var a = function() {
    if (t.default.hasCSSTransforms()) {
      var c = r.default.window ? r.default.window.navigator.userAgent : "UNKNOWN", l = /Safari\//.test(c) && !/Chrome\//.test(c);
      return !l && t.default.hasCSS3DTransforms() ? function(d, f, p) {
        d[i] = "translate3d(" + f + "px," + p + "px,0)";
      } : function(d, f, p) {
        d[i] = "translate(" + f + "px," + p + "px)";
      };
    } else
      return function(d, f, p) {
        d.left = f + "px", d.top = p + "px";
      };
  }(), s = a;
  e.default = s;
})(b4);
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var t = r(Ux), n = r(b4);
  function r(a) {
    return a && a.__esModule ? a : { default: a };
  }
  function o(a, s, c) {
    var l = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1, d = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !1;
    a.display !== "none" && (l ? (a.left = s + "px", a.top = c + "px") : (t.default.hasCSSTransforms() && (s *= d ? -1 : 1), (0, n.default)(a, s, c)), d && (a.right = a.left, a.left = "auto"));
  }
  var i = o;
  e.default = i;
})(If);
(function(e) {
  function t(A) {
    "@babel/helpers - typeof";
    return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? t = function(N) {
      return typeof N;
    } : t = function(N) {
      return N && typeof Symbol == "function" && N.constructor === Symbol && N !== Symbol.prototype ? "symbol" : typeof N;
    }, t(A);
  }
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var n = c(et), r = c(Jr), o = c(Jo), i = ws, a = c(d4), s = c(If);
  function c(A) {
    return A && A.__esModule ? A : { default: A };
  }
  function l() {
    return l = Object.assign || function(A) {
      for (var D = 1; D < arguments.length; D++) {
        var N = arguments[D];
        for (var F in N)
          Object.prototype.hasOwnProperty.call(N, F) && (A[F] = N[F]);
      }
      return A;
    }, l.apply(this, arguments);
  }
  function d(A, D) {
    if (A == null)
      return {};
    var N = f(A, D), F, $;
    if (Object.getOwnPropertySymbols) {
      var I = Object.getOwnPropertySymbols(A);
      for ($ = 0; $ < I.length; $++)
        F = I[$], !(D.indexOf(F) >= 0) && Object.prototype.propertyIsEnumerable.call(A, F) && (N[F] = A[F]);
    }
    return N;
  }
  function f(A, D) {
    if (A == null)
      return {};
    var N = {}, F = Object.keys(A), $, I;
    for (I = 0; I < F.length; I++)
      $ = F[I], !(D.indexOf($) >= 0) && (N[$] = A[$]);
    return N;
  }
  function p(A, D) {
    if (!(A instanceof D))
      throw new TypeError("Cannot call a class as a function");
  }
  function m(A, D) {
    for (var N = 0; N < D.length; N++) {
      var F = D[N];
      F.enumerable = F.enumerable || !1, F.configurable = !0, "value" in F && (F.writable = !0), Object.defineProperty(A, F.key, F);
    }
  }
  function v(A, D, N) {
    return D && m(A.prototype, D), A;
  }
  function g(A, D) {
    if (typeof D != "function" && D !== null)
      throw new TypeError("Super expression must either be null or a function");
    A.prototype = Object.create(D && D.prototype, { constructor: { value: A, writable: !0, configurable: !0 } }), D && b(A, D);
  }
  function b(A, D) {
    return b = Object.setPrototypeOf || function(F, $) {
      return F.__proto__ = $, F;
    }, b(A, D);
  }
  function x(A) {
    var D = _();
    return function() {
      var F = w(A), $;
      if (D) {
        var I = w(this).constructor;
        $ = Reflect.construct(F, arguments, I);
      } else
        $ = F.apply(this, arguments);
      return T(this, $);
    };
  }
  function T(A, D) {
    return D && (t(D) === "object" || typeof D == "function") ? D : S(A);
  }
  function S(A) {
    if (A === void 0)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return A;
  }
  function _() {
    if (typeof Reflect == "undefined" || !Reflect.construct || Reflect.construct.sham)
      return !1;
    if (typeof Proxy == "function")
      return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      })), !0;
    } catch (A) {
      return !1;
    }
  }
  function w(A) {
    return w = Object.setPrototypeOf ? Object.getPrototypeOf : function(N) {
      return N.__proto__ || Object.getPrototypeOf(N);
    }, w(A);
  }
  function k(A, D, N) {
    return D in A ? Object.defineProperty(A, D, { value: N, enumerable: !0, configurable: !0, writable: !0 }) : A[D] = N, A;
  }
  var E = /* @__PURE__ */ function(A) {
    g(N, A);
    var D = x(N);
    function N(F) {
      var $;
      return p(this, N), $ = D.call(this, F), k(S($), "_renderCell", function(I, j, U, G, V, H, q, Q, X) {
        var K = U.isResizable && $.props.onColumnResize, J = K ? $.props.onColumnResize : null, ne = U.isReorderable && $.props.onColumnReorder && I === -1 && q !== U.width, ae = ne ? $.props.onColumnReorder : null, te = U.cellClassName, le = U.pureRendering || !1;
        return /* @__PURE__ */ n.default.createElement(a.default, {
          isScrolling: $.props.isScrolling,
          isHeaderOrFooter: $.props.isHeaderOrFooter,
          align: U.align,
          className: te,
          height: j,
          key: H,
          maxWidth: U.maxWidth,
          minWidth: U.minWidth,
          touchEnabled: $.props.touchEnabled,
          onColumnResize: J,
          onColumnReorder: ae,
          onColumnReorderMove: $.props.onColumnReorderMove,
          onColumnReorderEnd: $.props.onColumnReorderEnd,
          isColumnReordering: Q,
          columnReorderingData: $.props.columnReorderingData,
          rowIndex: I,
          columnKey: U.columnKey,
          width: U.width,
          left: V,
          cell: G,
          columnGroupWidth: q,
          pureRendering: le,
          isRTL: $.props.isRTL,
          isVisible: $.props.isVisible && X
        });
      }), $._initialRender = !0, $;
    }
    return v(N, [{
      key: "componentDidMount",
      value: function() {
        this._initialRender = !1;
      }
    }, {
      key: "render",
      value: function() {
        for (var $ = this.props, I = $.columns, j = new Array(I.length), U = (0, i.sumPropWidths)(I), G = $.isColumnReordering && I.reduce(function(te, le) {
          return te || $.columnReorderingData.columnKey === le.props.columnKey;
        }, !1), V = 0, H = 0, q = I.length; H < q; H++) {
          var Q = I[H].props, X = I[H].template, K = Q.allowCellsRecycling && !G, J = V - $.left <= $.width && V - $.left + Q.width >= 0;
          if (!K || J) {
            var ne = Q.columnKey || "cell_" + H;
            j[H] = this._renderCell($.rowIndex, $.rowHeight, Q, X, V, ne, U, G, J);
          }
          V += Q.width;
        }
        var ae = {
          height: $.height,
          position: "absolute",
          width: U,
          zIndex: $.zIndex
        };
        return (0, s.default)(ae, -1 * $.left, 0, this._initialRender, this.props.isRTL), /* @__PURE__ */ n.default.createElement("div", {
          className: (0, o.default)("fixedDataTableCellGroupLayout/cellGroup"),
          style: ae
        }, j);
      }
    }]), N;
  }(n.default.Component);
  k(E, "propTypes_DISABLED_FOR_PERFORMANCE", {
    /**
     * Array of per column configuration properties.
     */
    columns: r.default.array.isRequired,
    isScrolling: r.default.bool,
    left: r.default.number,
    onColumnResize: r.default.func,
    onColumnReorder: r.default.func,
    onColumnReorderMove: r.default.func,
    onColumnReorderEnd: r.default.func,
    height: r.default.number.isRequired,
    /**
     * Height of fixedDataTableCellGroupLayout/cellGroupWrapper.
     */
    cellGroupWrapperHeight: r.default.number,
    rowHeight: r.default.number.isRequired,
    rowIndex: r.default.number.isRequired,
    width: r.default.number.isRequired,
    zIndex: r.default.number.isRequired,
    touchEnabled: r.default.bool,
    isHeaderOrFooter: r.default.bool,
    isRTL: r.default.bool,
    isVisible: r.default.bool.isRequired
  });
  var R = /* @__PURE__ */ function(A) {
    g(N, A);
    var D = x(N);
    function N() {
      var F;
      p(this, N);
      for (var $ = arguments.length, I = new Array($), j = 0; j < $; j++)
        I[j] = arguments[j];
      return F = D.call.apply(D, [this].concat(I)), k(S(F), "_onColumnResize", function(U, G, V, H, q, Q) {
        F.props.onColumnResize && F.props.onColumnResize(F.props.offsetLeft, U - F.props.left + G, G, V, H, q, Q);
      }), F;
    }
    return v(N, [{
      key: "shouldComponentUpdate",
      value: function($) {
        return !($.isScrolling && this.props.rowIndex === $.rowIndex && this.props.left === $.left && this.props.offsetLeft === $.offsetLeft && this.props.isVisible === $.isVisible);
      }
    }, {
      key: "render",
      value: function() {
        var $ = this.props, I = $.offsetLeft, j = d($, ["offsetLeft"]), U = {
          height: j.cellGroupWrapperHeight || j.height,
          width: j.width
        };
        this.props.isRTL ? U.right = I : U.left = I;
        var G = j.onColumnResize ? this._onColumnResize : null;
        return /* @__PURE__ */ n.default.createElement("div", {
          style: U,
          className: (0, o.default)("fixedDataTableCellGroupLayout/cellGroupWrapper")
        }, /* @__PURE__ */ n.default.createElement(E, l({}, j, {
          onColumnResize: G
        })));
      }
    }]), N;
  }(n.default.Component);
  k(R, "propTypes_DISABLED_FOR_PERFORMANCE", {
    isScrolling: r.default.bool,
    /**
     * Height of the row.
     */
    height: r.default.number.isRequired,
    offsetLeft: r.default.number,
    left: r.default.number,
    /**
     * Z-index on which the row will be displayed. Used e.g. for keeping
     * header and footer in front of other rows.
     */
    zIndex: r.default.number.isRequired
  }), k(
    R,
    "defaultProps",
    /*object*/
    {
      left: 0,
      offsetLeft: 0
    }
  );
  var P = R;
  e.default = P;
})(u4);
(function(e) {
  function t(N) {
    "@babel/helpers - typeof";
    return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? t = function($) {
      return typeof $;
    } : t = function($) {
      return $ && typeof Symbol == "function" && $.constructor === Symbol && $ !== Symbol.prototype ? "symbol" : typeof $;
    }, t(N);
  }
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var n = l(Jr), r = l(et), o = l(Jo), i = l(ys), a = ws, s = l(u4), c = l(If);
  function l(N) {
    return N && N.__esModule ? N : { default: N };
  }
  function d(N, F) {
    if (N == null)
      return {};
    var $ = f(N, F), I, j;
    if (Object.getOwnPropertySymbols) {
      var U = Object.getOwnPropertySymbols(N);
      for (j = 0; j < U.length; j++)
        I = U[j], !(F.indexOf(I) >= 0) && Object.prototype.propertyIsEnumerable.call(N, I) && ($[I] = N[I]);
    }
    return $;
  }
  function f(N, F) {
    if (N == null)
      return {};
    var $ = {}, I = Object.keys(N), j, U;
    for (U = 0; U < I.length; U++)
      j = I[U], !(F.indexOf(j) >= 0) && ($[j] = N[j]);
    return $;
  }
  function p() {
    return p = Object.assign || function(N) {
      for (var F = 1; F < arguments.length; F++) {
        var $ = arguments[F];
        for (var I in $)
          Object.prototype.hasOwnProperty.call($, I) && (N[I] = $[I]);
      }
      return N;
    }, p.apply(this, arguments);
  }
  function m(N, F) {
    if (!(N instanceof F))
      throw new TypeError("Cannot call a class as a function");
  }
  function v(N, F) {
    for (var $ = 0; $ < F.length; $++) {
      var I = F[$];
      I.enumerable = I.enumerable || !1, I.configurable = !0, "value" in I && (I.writable = !0), Object.defineProperty(N, I.key, I);
    }
  }
  function g(N, F, $) {
    return F && v(N.prototype, F), N;
  }
  function b(N, F) {
    if (typeof F != "function" && F !== null)
      throw new TypeError("Super expression must either be null or a function");
    N.prototype = Object.create(F && F.prototype, { constructor: { value: N, writable: !0, configurable: !0 } }), F && x(N, F);
  }
  function x(N, F) {
    return x = Object.setPrototypeOf || function(I, j) {
      return I.__proto__ = j, I;
    }, x(N, F);
  }
  function T(N) {
    var F = w();
    return function() {
      var I = k(N), j;
      if (F) {
        var U = k(this).constructor;
        j = Reflect.construct(I, arguments, U);
      } else
        j = I.apply(this, arguments);
      return S(this, j);
    };
  }
  function S(N, F) {
    return F && (t(F) === "object" || typeof F == "function") ? F : _(N);
  }
  function _(N) {
    if (N === void 0)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return N;
  }
  function w() {
    if (typeof Reflect == "undefined" || !Reflect.construct || Reflect.construct.sham)
      return !1;
    if (typeof Proxy == "function")
      return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      })), !0;
    } catch (N) {
      return !1;
    }
  }
  function k(N) {
    return k = Object.setPrototypeOf ? Object.getPrototypeOf : function($) {
      return $.__proto__ || Object.getPrototypeOf($);
    }, k(N);
  }
  function E(N, F, $) {
    return F in N ? Object.defineProperty(N, F, { value: $, enumerable: !0, configurable: !0, writable: !0 }) : N[F] = $, N;
  }
  var R = 1, P = /* @__PURE__ */ function(N) {
    b($, N);
    var F = T($);
    function $() {
      var I;
      m(this, $);
      for (var j = arguments.length, U = new Array(j), G = 0; G < j; G++)
        U[G] = arguments[G];
      return I = F.call.apply(F, [this].concat(U)), E(_(I), "mouseLeaveIndex", null), E(_(I), "_getRowExpanded", function(V) {
        if (I.props.rowExpanded) {
          var H = {
            rowIndex: I.props.index,
            height: V,
            width: I.props.width
          }, q;
          return /* @__PURE__ */ r.default.isValidElement(I.props.rowExpanded) ? q = /* @__PURE__ */ r.default.cloneElement(I.props.rowExpanded, H) : typeof I.props.rowExpanded == "function" && (q = I.props.rowExpanded(H)), q;
        }
      }), E(_(I), "_renderColumnsLeftShadow", function(V) {
        var H = (0, o.default)({
          "fixedDataTableRowLayout/fixedColumnsDivider": V > 0,
          "fixedDataTableRowLayout/columnsShadow": I.props.scrollLeft > 0,
          "public/fixedDataTableRow/fixedColumnsDivider": V > 0,
          "public/fixedDataTableRow/columnsShadow": I.props.scrollLeft > 0
        }), q = I.props.cellGroupWrapperHeight ? I.props.cellGroupWrapperHeight - R : I.props.height, Q = {
          left: V,
          height: q
        };
        return I.props.isRTL && (Q.right = V, Q.left = "auto"), /* @__PURE__ */ r.default.createElement("div", {
          className: H,
          style: Q
        });
      }), E(_(I), "_renderFixedRightColumnsShadow", function(V) {
        var H = (0, o.default)("fixedDataTableRowLayout/columnsShadow", "fixedDataTableRowLayout/columnsRightShadow", "fixedDataTableRowLayout/fixedColumnsDivider", "public/fixedDataTableRow/columnsShadow", "public/fixedDataTableRow/columnsRightShadow", "public/fixedDataTableRow/fixedColumnsDivider"), q = {
          height: I.props.height,
          left: V
        };
        return I.props.isRTL && (q.right = V, q.left = "auto"), /* @__PURE__ */ r.default.createElement("div", {
          className: H,
          style: q
        });
      }), E(_(I), "_renderColumnsRightShadow", function(V) {
        if (Math.ceil(I.props.scrollLeft + I.props.width) < Math.floor(V)) {
          var H = (0, o.default)("fixedDataTableRowLayout/columnsShadow", "fixedDataTableRowLayout/columnsRightShadow", "public/fixedDataTableRow/columnsShadow", "public/fixedDataTableRow/columnsRightShadow"), q = {
            height: I.props.height
          };
          return /* @__PURE__ */ r.default.createElement("div", {
            className: H,
            style: q
          });
        }
      }), E(_(I), "_onClick", function(V) {
        I.props.onClick(V, I.props.index);
      }), E(_(I), "_onContextMenu", function(V) {
        I.props.onContextMenu(V, I.props.index);
      }), E(_(I), "_onDoubleClick", function(V) {
        I.props.onDoubleClick(V, I.props.index);
      }), E(_(I), "_onMouseUp", function(V) {
        I.props.onMouseUp(V, I.props.index);
      }), E(_(I), "_onMouseDown", function(V) {
        I.props.onMouseDown(V, I.props.index);
      }), E(_(I), "_onMouseEnter", function(V) {
        I.mouseLeaveIndex = I.props.index, I.props.onMouseEnter && I.props.onMouseEnter(V, I.props.index);
      }), E(_(I), "_onMouseLeave", function(V) {
        I.mouseLeaveIndex === null && (I.mouseLeaveIndex = I.props.index), I.props.onMouseLeave(V, I.mouseLeaveIndex), I.mouseLeaveIndex = null;
      }), E(_(I), "_onTouchStart", function(V) {
        I.props.onTouchStart(V, I.props.index);
      }), E(_(I), "_onTouchEnd", function(V) {
        I.props.onTouchEnd(V, I.props.index);
      }), E(_(I), "_onTouchMove", function(V) {
        I.props.onTouchMove(V, I.props.index);
      }), I;
    }
    return g($, [{
      key: "shouldComponentUpdate",
      value: function(j) {
        return j.isScrolling ? j.visible ? this.props.visible !== j.visible ? !0 : !(this.props.index === j.index && this.props.scrollLeft === j.scrollLeft) : !1 : !0;
      }
    }, {
      key: "render",
      value: function() {
        var j = this.props.subRowHeight || 0, U = {
          width: this.props.width,
          height: this.props.height + j
        }, G = (0, o.default)({
          "fixedDataTableRowLayout/main": !0,
          "public/fixedDataTableRow/main": !0,
          "public/fixedDataTableRow/highlighted": this.props.index % 2 === 1,
          "public/fixedDataTableRow/odd": this.props.index % 2 === 1,
          "public/fixedDataTableRow/even": this.props.index % 2 === 0
        }), V = (0, a.sumPropWidths)(this.props.fixedColumns), H = /* @__PURE__ */ r.default.createElement(s.default, {
          key: "fixed_cells",
          isScrolling: this.props.isScrolling,
          height: this.props.height,
          cellGroupWrapperHeight: this.props.cellGroupWrapperHeight,
          left: 0,
          width: V,
          zIndex: 2,
          columns: this.props.fixedColumns,
          touchEnabled: this.props.touchEnabled,
          onColumnResize: this.props.onColumnResize,
          onColumnReorder: this.props.onColumnReorder,
          onColumnReorderMove: this.props.onColumnReorderMove,
          onColumnReorderEnd: this.props.onColumnReorderEnd,
          isColumnReordering: this.props.isColumnReordering,
          columnReorderingData: this.props.columnReorderingData,
          rowHeight: this.props.height,
          rowIndex: this.props.index,
          isHeaderOrFooter: this.props.isHeaderOrFooter,
          isRTL: this.props.isRTL,
          isVisible: this.props.visible
        }), q = this._renderColumnsLeftShadow(V), Q = (0, a.sumPropWidths)(this.props.fixedRightColumns), X = this.props.showScrollbarY ? this.props.scrollbarYWidth : 0, K = /* @__PURE__ */ r.default.createElement(s.default, {
          key: "fixed_right_cells",
          isScrolling: this.props.isScrolling,
          height: this.props.height,
          cellGroupWrapperHeight: this.props.cellGroupWrapperHeight,
          offsetLeft: this.props.width - Q - X,
          width: Q,
          zIndex: 2,
          columns: this.props.fixedRightColumns,
          touchEnabled: this.props.touchEnabled,
          onColumnResize: this.props.onColumnResize,
          onColumnReorder: this.props.onColumnReorder,
          onColumnReorderMove: this.props.onColumnReorderMove,
          onColumnReorderEnd: this.props.onColumnReorderEnd,
          isColumnReordering: this.props.isColumnReordering,
          columnReorderingData: this.props.columnReorderingData,
          rowHeight: this.props.height,
          rowIndex: this.props.index,
          isHeaderOrFooter: this.props.isHeaderOrFooter,
          isRTL: this.props.isRTL,
          isVisible: this.props.visible
        }), J = Q ? this._renderFixedRightColumnsShadow(this.props.width - Q - X - 5) : null, ne = /* @__PURE__ */ r.default.createElement(s.default, {
          key: "scrollable_cells",
          isScrolling: this.props.isScrolling,
          height: this.props.height,
          cellGroupWrapperHeight: this.props.cellGroupWrapperHeight,
          align: "right",
          left: this.props.scrollLeft,
          offsetLeft: V,
          width: this.props.width - V - Q - X,
          zIndex: 0,
          columns: this.props.scrollableColumns,
          touchEnabled: this.props.touchEnabled,
          onColumnResize: this.props.onColumnResize,
          onColumnReorder: this.props.onColumnReorder,
          onColumnReorderMove: this.props.onColumnReorderMove,
          onColumnReorderEnd: this.props.onColumnReorderEnd,
          isColumnReordering: this.props.isColumnReordering,
          columnReorderingData: this.props.columnReorderingData,
          rowHeight: this.props.height,
          rowIndex: this.props.index,
          isHeaderOrFooter: this.props.isHeaderOrFooter,
          isRTL: this.props.isRTL,
          isVisible: this.props.visible
        }), ae = (0, a.sumPropWidths)(this.props.scrollableColumns), te = this._renderColumnsRightShadow(V + ae), le = this._getRowExpanded(j), ce = {
          height: j,
          top: this.props.height,
          width: this.props.width
        }, fe = null;
        if (this.props.showScrollbarY) {
          var ee = {
            width: X,
            height: this.props.height,
            // Since the box-sizing = border-box the border on the table is included in the width
            // so we need to account for the left and right border
            left: this.props.isRTL ? 2 : this.props.width - X - 2
          };
          fe = /* @__PURE__ */ r.default.createElement("div", {
            style: ee,
            className: (0, o.default)("public/fixedDataTable/scrollbarSpacer")
          });
        }
        return /* @__PURE__ */ r.default.createElement("div", p({
          className: (0, i.default)(G, this.props.className),
          role: "row",
          "aria-rowindex": this.props.ariaRowIndex
        }, this.props.attributes, {
          onClick: this.props.onClick ? this._onClick : null,
          onContextMenu: this.props.onContextMenu ? this._onContextMenu : null,
          onDoubleClick: this.props.onDoubleClick ? this._onDoubleClick : null,
          onMouseDown: this.props.onMouseDown ? this._onMouseDown : null,
          onMouseUp: this.props.onMouseUp ? this._onMouseUp : null,
          onMouseEnter: this.props.onMouseEnter || this.props.onMouseLeave ? this._onMouseEnter : null,
          onMouseLeave: this.props.onMouseLeave ? this._onMouseLeave : null,
          onTouchStart: this.props.onTouchStart ? this._onTouchStart : null,
          onTouchEnd: this.props.onTouchEnd ? this._onTouchEnd : null,
          onTouchMove: this.props.onTouchMove ? this._onTouchMove : null,
          style: U
        }), /* @__PURE__ */ r.default.createElement("div", {
          className: (0, o.default)("fixedDataTableRowLayout/body")
        }, H, ne, q, K, J, fe), le && /* @__PURE__ */ r.default.createElement("div", {
          className: (0, o.default)("fixedDataTableRowLayout/rowExpanded"),
          style: ce
        }, le), te);
      }
    }]), $;
  }(r.default.Component);
  E(P, "propTypes", {
    isScrolling: n.default.bool,
    /**
     * Array of data for the fixed columns.
     */
    fixedColumns: n.default.array.isRequired,
    /**
     * Array of <FixedDataTableColumn /> for the fixed columns positioned at end of the table.
     */
    fixedRightColumns: n.default.array.isRequired,
    /**
     * Height of the row.
     */
    height: n.default.number.isRequired,
    /**
     * Height of fixedDataTableCellGroupLayout/cellGroupWrapper.
     */
    cellGroupWrapperHeight: n.default.number,
    /**
     * Height of the content to be displayed below the row.
     */
    subRowHeight: n.default.number,
    /**
     * the row expanded.
     */
    rowExpanded: n.default.oneOfType([n.default.element, n.default.func]),
    /**
     * The row index.
     */
    index: n.default.number.isRequired,
    /**
     * Array of data for the scrollable columns.
     */
    scrollableColumns: n.default.array.isRequired,
    /**
     * The distance between the left edge of the table and the leftmost portion
     * of the row currently visible in the table.
     */
    scrollLeft: n.default.number.isRequired,
    /**
     * Width of the row.
     */
    width: n.default.number.isRequired,
    /**
     * Fire when a row is clicked.
     */
    onClick: n.default.func,
    /**
     * Fire when a contextual-menu is requested above a row.
     */
    onContextMenu: n.default.func,
    /**
     * Fire when a row is double clicked.
     */
    onDoubleClick: n.default.func,
    /**
     * Callback for when resizer knob (in FixedDataTableCell) is clicked
     * to initialize resizing. Please note this is only on the cells
     * in the header.
     * @param number combinedWidth
     * @param number leftOffset
     * @param number cellWidth
     * @param number|string columnKey
     * @param object event
     */
    onColumnResize: n.default.func,
    isColumnReordering: n.default.bool,
    /**
     * Callback for when reorder handle (in FixedDataTableCell) is clicked
     * to initialize reordering. Please note this is only on the cells
     * in the header.
     * @param number|string columnKey
     * @param number cellWidth
     * @param number leftOffset
     * @param object event
     */
    onColumnReorder: n.default.func,
    /**
     * Callback for when a cell is moved while reordering.
     * @param number distance
     */
    onColumnReorderMove: n.default.func,
    /**
     * Callback for when the mouse is released to complete reordering.
     * @param number distance
     */
    onColumnReorderEnd: n.default.func,
    touchEnabled: n.default.bool,
    /**
     * Whether the row is part of the header or footer.
     */
    isHeaderOrFooter: n.default.bool,
    /**
     * The value of the aria-rowindex attribute.
     */
    ariaRowIndex: n.default.number,
    /**
     * Whether the grid should be in RTL mode
     */
    isRTL: n.default.bool,
    /**
     * DOM attributes to be applied to the row.
     */
    attributes: n.default.object
  });
  var A = /* @__PURE__ */ function(N) {
    b($, N);
    var F = T($);
    function $(I) {
      var j;
      return m(this, $), j = F.call(this, I), j._initialRender = !0, j;
    }
    return g($, [{
      key: "componentDidMount",
      value: function() {
        this._initialRender = !1;
      }
    }, {
      key: "shouldComponentUpdate",
      value: function(j) {
        return !j.isScrolling || this.props.visible !== j.visible ? !0 : j.visible ? !(j.isScrolling && this.props.index === j.index && this.props.offsetTop === j.offsetTop && this.props.scrollLeft === j.scrollLeft) : !1;
      }
    }, {
      key: "render",
      value: function() {
        var j = this.props, U = j.offsetTop, G = j.zIndex, V = d(j, ["offsetTop", "zIndex"]), H = {
          width: this.props.width,
          height: this.props.height,
          zIndex: G || 0,
          visibility: V.visible ? "visible" : "hidden"
        };
        return (0, c.default)(H, 0, U, this._initialRender, this.props.isRTL), /* @__PURE__ */ r.default.createElement("div", {
          style: H,
          className: (0, o.default)("fixedDataTableRowLayout/rowWrapper")
        }, /* @__PURE__ */ r.default.createElement(P, V));
      }
    }]), $;
  }(r.default.Component);
  E(A, "propTypes", {
    isScrolling: n.default.bool,
    /**
     * Height of the row.
     */
    height: n.default.number.isRequired,
    /**
     * Z-index on which the row will be displayed. Used e.g. for keeping
     * header and footer in front of other rows.
     */
    zIndex: n.default.number,
    /**
     * The vertical position where the row should render itself
     */
    offsetTop: n.default.number.isRequired,
    /**
     * Pass false to hide the row via CSS
     */
    visible: n.default.bool.isRequired,
    /**
     * Width of the row.
     */
    width: n.default.number.isRequired
  });
  var D = A;
  e.default = D;
})(Wx);
(function(e) {
  function t(D) {
    "@babel/helpers - typeof";
    return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? t = function(F) {
      return typeof F;
    } : t = function(F) {
      return F && typeof Symbol == "function" && F.constructor === Symbol && F !== Symbol.prototype ? "symbol" : typeof F;
    }, t(D);
  }
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var n = p(Jr), r = p(et), o = p(iDe), i = p(ODe), a = p(c4), s = p(Jo), c = p(_s), l = p(ys), d = p(Wx), f = p(If);
  function p(D) {
    return D && D.__esModule ? D : { default: D };
  }
  function m() {
    return m = Object.assign || function(D) {
      for (var N = 1; N < arguments.length; N++) {
        var F = arguments[N];
        for (var $ in F)
          Object.prototype.hasOwnProperty.call(F, $) && (D[$] = F[$]);
      }
      return D;
    }, m.apply(this, arguments);
  }
  function v(D, N) {
    if (!(D instanceof N))
      throw new TypeError("Cannot call a class as a function");
  }
  function g(D, N) {
    for (var F = 0; F < N.length; F++) {
      var $ = N[F];
      $.enumerable = $.enumerable || !1, $.configurable = !0, "value" in $ && ($.writable = !0), Object.defineProperty(D, $.key, $);
    }
  }
  function b(D, N, F) {
    return N && g(D.prototype, N), D;
  }
  function x(D, N) {
    if (typeof N != "function" && N !== null)
      throw new TypeError("Super expression must either be null or a function");
    D.prototype = Object.create(N && N.prototype, { constructor: { value: D, writable: !0, configurable: !0 } }), N && T(D, N);
  }
  function T(D, N) {
    return T = Object.setPrototypeOf || function($, I) {
      return $.__proto__ = I, $;
    }, T(D, N);
  }
  function S(D) {
    var N = k();
    return function() {
      var $ = E(D), I;
      if (N) {
        var j = E(this).constructor;
        I = Reflect.construct($, arguments, j);
      } else
        I = $.apply(this, arguments);
      return _(this, I);
    };
  }
  function _(D, N) {
    return N && (t(N) === "object" || typeof N == "function") ? N : w(D);
  }
  function w(D) {
    if (D === void 0)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return D;
  }
  function k() {
    if (typeof Reflect == "undefined" || !Reflect.construct || Reflect.construct.sham)
      return !1;
    if (typeof Proxy == "function")
      return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      })), !0;
    } catch (D) {
      return !1;
    }
  }
  function E(D) {
    return E = Object.setPrototypeOf ? Object.getPrototypeOf : function(F) {
      return F.__proto__ || Object.getPrototypeOf(F);
    }, E(D);
  }
  function R(D, N, F) {
    return N in D ? Object.defineProperty(D, N, { value: F, enumerable: !0, configurable: !0, writable: !0 }) : D[N] = F, D;
  }
  var P = /* @__PURE__ */ function(D) {
    x(F, D);
    var N = S(F);
    function F($) {
      var I;
      return v(this, F), I = N.call(this, $), I._staticRowArray = [], I._initialRender = !0, I;
    }
    return b(F, [{
      key: "componentDidMount",
      value: function() {
        this._initialRender = !1;
      }
    }, {
      key: "shouldComponentUpdate",
      value: function() {
        return !0;
      }
    }, {
      key: "componentWillUnmount",
      value: function() {
        this._staticRowArray.length = 0;
      }
    }, {
      key: "render",
      value: function() {
        var I = this.props, j = I.offsetTop, U = I.rowOffsets, G = I.scrollTop, V = I.isScrolling, H = I.rowsToRender;
        H = H || [], V ? this._staticRowArray.length = Math.max(this._staticRowArray.length, H.length) : this._staticRowArray.length = H.length;
        for (var q = 1e6, Q = j - G % q, X = 0; X < this._staticRowArray.length; X++) {
          var K, J = (0, o.default)(H[X], (K = this._staticRowArray[X]) === null || K === void 0 ? void 0 : K.props.index);
          if ((0, a.default)(J) || !(0, i.default)(J, 0, this.props.rowSettings.rowsCount)) {
            this._staticRowArray[X] = null;
            continue;
          }
          var ne = U[J] - Math.floor(G / q) * q;
          this._staticRowArray[X] = this.renderRow({
            rowIndex: J,
            key: X,
            rowOffsetTop: ne
          });
        }
        var ae = {};
        (0, f.default)(ae, 0, Q, !1);
        var te = this._staticRowArray.slice().sort(this.rowSortComparator);
        return /* @__PURE__ */ r.default.createElement("div", {
          style: ae
        }, te);
      }
      /**
       * @typedef RowProps
       * @prop {number} rowIndex
       * @prop {number} key
       * @prop {number} rowOffsetTop
       *
       * @param {RowProps} rowProps
       * @return {!Object}
       */
    }, {
      key: "renderRow",
      value: function(I) {
        var j = I.rowIndex, U = I.key, G = I.rowOffsetTop, V = this.props, H = V.rowClassNameGetter || c.default, q = {};
        q.height = this.props.rowSettings.rowHeightGetter(j), q.subRowHeight = this.props.rowSettings.subRowHeightGetter(j), q.offsetTop = G, q.key = V.rowKeyGetter ? V.rowKeyGetter(j) : U, q.attributes = V.rowSettings.rowAttributesGetter && V.rowSettings.rowAttributesGetter(j);
        var Q = j === V.rowSettings.rowsCount - 1 && V.showLastRowBorder;
        q.className = (0, l.default)(H(j), (0, s.default)("public/fixedDataTable/bodyRow"), (0, s.default)({
          "fixedDataTableLayout/hasBottomBorder": Q,
          "public/fixedDataTable/hasBottomBorder": Q
        }));
        var X = (0, i.default)(j, this.props.firstViewportRowIndex, this.props.endViewportRowIndex);
        return /* @__PURE__ */ r.default.createElement(d.default, m({
          key: U,
          index: j,
          ariaRowIndex: j + V.ariaRowIndexOffset,
          isScrolling: V.isScrolling,
          width: V.width,
          rowExpanded: V.rowExpanded,
          scrollLeft: Math.round(V.scrollLeft),
          fixedColumns: V.fixedColumns,
          fixedRightColumns: V.fixedRightColumns,
          scrollableColumns: V.scrollableColumns,
          onClick: V.onRowClick,
          onContextMenu: V.onRowContextMenu,
          onDoubleClick: V.onRowDoubleClick,
          onMouseDown: V.onRowMouseDown,
          onMouseUp: V.onRowMouseUp,
          onMouseEnter: V.onRowMouseEnter,
          onMouseLeave: V.onRowMouseLeave,
          onTouchStart: V.onRowTouchStart,
          onTouchEnd: V.onRowTouchEnd,
          onTouchMove: V.onRowTouchMove,
          showScrollbarY: V.showScrollbarY,
          scrollbarYWidth: V.scrollbarYWidth,
          isRTL: V.isRTL,
          visible: X
        }, q));
      }
      /**
       * @param {?React.ReactElement} rowA
       * @param {?React.ReactElement} rowB
       * @returns {number}
       * @private
       */
    }, {
      key: "rowSortComparator",
      value: function(I, j) {
        var U, G;
        return ((U = I == null ? void 0 : I.props.ariaRowIndex) !== null && U !== void 0 ? U : -1) - ((G = j == null ? void 0 : j.props.ariaRowIndex) !== null && G !== void 0 ? G : -1);
      }
    }]), F;
  }(r.default.Component);
  R(P, "propTypes", {
    ariaRowIndexOffset: n.default.number,
    isScrolling: n.default.bool,
    firstViewportRowIndex: n.default.number.isRequired,
    endViewportRowIndex: n.default.number.isRequired,
    fixedColumns: n.default.array.isRequired,
    fixedRightColumns: n.default.array.isRequired,
    height: n.default.number.isRequired,
    offsetTop: n.default.number.isRequired,
    onRowClick: n.default.func,
    onRowContextMenu: n.default.func,
    onRowDoubleClick: n.default.func,
    onRowMouseDown: n.default.func,
    onRowMouseUp: n.default.func,
    onRowMouseEnter: n.default.func,
    onRowMouseLeave: n.default.func,
    onRowTouchStart: n.default.func,
    onRowTouchEnd: n.default.func,
    onRowTouchMove: n.default.func,
    rowClassNameGetter: n.default.func,
    rowExpanded: n.default.oneOfType([n.default.element, n.default.func]),
    rowOffsets: n.default.object.isRequired,
    rowKeyGetter: n.default.func,
    rowSettings: n.default.shape({
      rowAttributesGetter: n.default.func,
      rowHeightGetter: n.default.func,
      rowsCount: n.default.number.isRequired,
      subRowHeightGetter: n.default.func
    }),
    rowsToRender: n.default.array.isRequired,
    scrollLeft: n.default.number.isRequired,
    scrollTop: n.default.number.isRequired,
    scrollableColumns: n.default.array.isRequired,
    showLastRowBorder: n.default.bool,
    showScrollbarY: n.default.bool,
    width: n.default.number.isRequired,
    isRTL: n.default.bool
  });
  var A = P;
  e.default = A;
})(l4);
var y4 = {};
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var t = r(_s), n = r(ev);
  function r(m) {
    return m && m.__esModule ? m : { default: m };
  }
  function o(m, v) {
    if (!(m instanceof v))
      throw new TypeError("Cannot call a class as a function");
  }
  function i(m, v) {
    for (var g = 0; g < v.length; g++) {
      var b = v[g];
      b.enumerable = b.enumerable || !1, b.configurable = !0, "value" in b && (b.writable = !0), Object.defineProperty(m, b.key, b);
    }
  }
  function a(m, v, g) {
    return v && i(m.prototype, v), m;
  }
  var s = 1.6, c = 1.6, l = 325, d = 100, f = /* @__PURE__ */ function() {
    function m(v, g, b, x, T) {
      o(this, m), this._dragAnimationId = null, this._trackerId = null, this._deltaX = 0, this._deltaY = 0, this._lastTouchX = 0, this._lastTouchY = 0, this._velocityX = 0, this._velocityY = 0, this._accumulatedDeltaX = 0, this._accumulatedDeltaY = 0, this._lastFrameTimestamp = Date.now(), this._autoScrollTimestamp = Date.now(), typeof g != "function" && (g = g ? t.default.thatReturnsTrue : t.default.thatReturnsFalse), typeof b != "function" && (b = b ? t.default.thatReturnsTrue : t.default.thatReturnsFalse), this._handleScrollX = g, this._handleScrollY = b, this._preventDefault = x, this._stopPropagation = T, this._onTouchScrollCallback = v, this._didTouchMove = this._didTouchMove.bind(this), this._track = this._track.bind(this), this._autoScroll = this._autoScroll.bind(this), this._startAutoScroll = this._startAutoScroll.bind(this), this.onTouchStart = this.onTouchStart.bind(this), this.onTouchEnd = this.onTouchEnd.bind(this), this.onTouchMove = this.onTouchMove.bind(this), this.onTouchCancel = this.onTouchCancel.bind(this);
    }
    return a(m, [{
      key: "onTouchStart",
      value: function(g) {
        this._lastTouchX = g.touches[0].pageX, this._lastTouchY = g.touches[0].pageY, this._velocityX = 0, this._velocityY = 0, this._accumulatedDeltaX = 0, this._accumulatedDeltaY = 0, this._lastFrameTimestamp = Date.now(), clearInterval(this._trackerId), this._trackerId = setInterval(this._track, d), this._stopPropagation && g.stopPropagation();
      }
    }, {
      key: "onTouchEnd",
      value: function(g) {
        clearInterval(this._trackerId), this._trackerId = null, (0, n.default)(this._startAutoScroll), this._stopPropagation && g.stopPropagation();
      }
    }, {
      key: "onTouchCancel",
      value: function(g) {
        clearInterval(this._trackerId), this._trackerId = null, this._stopPropagation && g.stopPropagation();
      }
    }, {
      key: "onTouchMove",
      value: function(g) {
        this._preventDefault && g.preventDefault();
        var b = g.touches[0].pageX, x = g.touches[0].pageY;
        this._deltaX = s * (this._lastTouchX - b), this._deltaY = s * (this._lastTouchY - x);
        var T = this._handleScrollX(this._deltaX, this._deltaY), S = this._handleScrollY(this._deltaY, this._deltaX);
        if (!(!T && !S)) {
          T ? this._lastTouchX = b : this._deltaX = 0, S ? this._lastTouchY = x : this._deltaY = 0, g.defaultPrevented || g.preventDefault();
          var _ = !1;
          (Math.abs(this._deltaX) > 2 || Math.abs(this._deltaY) > 2) && (this._stopPropagation && g.stopPropagation(), _ = !0), _ === !0 && this._dragAnimationId === null && (this._dragAnimationId = (0, n.default)(this._didTouchMove));
        }
      }
      /**
       * Fire scroll callback based on computed drag delta.
       * Also track accummulated delta so we can calculate velocity
       */
    }, {
      key: "_didTouchMove",
      value: function() {
        this._dragAnimationId = null, this._onTouchScrollCallback(this._deltaX, this._deltaY), this._accumulatedDeltaX += this._deltaX, this._accumulatedDeltaY += this._deltaY, this._deltaX = 0, this._deltaY = 0;
      }
      /**
       * Compute velocity based on a weighted average of drag over last 100 ms and
       * previous velocity.  Combining into a moving average results in a smoother scroll.
       */
    }, {
      key: "_track",
      value: function() {
        var g = Date.now(), b = g - this._lastFrameTimestamp, x = this._velocityX, T = this._velocityY, S = 0.8;
        b < d && (S *= b / d), x === 0 && T === 0 && (S = 1), this._velocityX = S * (d * this._accumulatedDeltaX / (1 + b)), S < 1 && (this._velocityX += (1 - S) * x), this._velocityY = S * (d * this._accumulatedDeltaY / (1 + b)), S < 1 && (this._velocityY += (1 - S) * T), this._accumulatedDeltaX = 0, this._accumulatedDeltaY = 0, this._lastFrameTimestamp = g;
      }
      /**
       * To kick off deceleration / momentum scrolling,
       * handle any scrolling from a drag which was waiting for an animation frame
       * Then update our velocity
       * Finally start the momentum scrolling handler (autoScroll)
       */
    }, {
      key: "_startAutoScroll",
      value: function() {
        this._autoScrollTimestamp = Date.now(), (this._deltaX > 0 || this.deltaY > 0) && this._didTouchMove(), this._track(), this._autoScroll();
      }
      /**
       * Compute a scroll delta with an exponential decay based on time elapsed since drag was released.
       * This is called recursively on animation frames until the delta is below a threshold (5 pixels)
       */
    }, {
      key: "_autoScroll",
      value: function() {
        var g = Date.now() - this._autoScrollTimestamp, b = c * Math.exp(-g / l), x = b * this._velocityX, T = b * this._velocityY;
        (Math.abs(x) <= 5 || !this._handleScrollX(x, T)) && (x = 0), (Math.abs(T) <= 5 || !this._handleScrollY(T, x)) && (T = 0), (x !== 0 || T !== 0) && (this._onTouchScrollCallback(x, T), (0, n.default)(this._autoScroll));
      }
    }]), m;
  }(), p = f;
  e.default = p;
})(y4);
(function(e) {
  function t(V) {
    "@babel/helpers - typeof";
    return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? t = function(q) {
      return typeof q;
    } : t = function(q) {
      return q && typeof Symbol == "function" && q.constructor === Symbol && q !== Symbol.prototype ? "symbol" : typeof q;
    }, t(V);
  }
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var n = S(et), r = S(Jr), o = S(ARe), i = S(Jo), a = S(LL), s = S(ys), c = S(Df), l = S(Nx), d = S(HL), f = S(qL), p = S(lu), m = S(Hx), v = S(i4), g = S(l4), b = S(iv), x = S(Wx), T = S(y4);
  function S(V) {
    return V && V.__esModule ? V : { default: V };
  }
  function _() {
    return _ = Object.assign || function(V) {
      for (var H = 1; H < arguments.length; H++) {
        var q = arguments[H];
        for (var Q in q)
          Object.prototype.hasOwnProperty.call(q, Q) && (V[Q] = q[Q]);
      }
      return V;
    }, _.apply(this, arguments);
  }
  function w(V, H) {
    if (!(V instanceof H))
      throw new TypeError("Cannot call a class as a function");
  }
  function k(V, H) {
    for (var q = 0; q < H.length; q++) {
      var Q = H[q];
      Q.enumerable = Q.enumerable || !1, Q.configurable = !0, "value" in Q && (Q.writable = !0), Object.defineProperty(V, Q.key, Q);
    }
  }
  function E(V, H, q) {
    return H && k(V.prototype, H), V;
  }
  function R(V, H) {
    if (typeof H != "function" && H !== null)
      throw new TypeError("Super expression must either be null or a function");
    V.prototype = Object.create(H && H.prototype, { constructor: { value: V, writable: !0, configurable: !0 } }), H && P(V, H);
  }
  function P(V, H) {
    return P = Object.setPrototypeOf || function(Q, X) {
      return Q.__proto__ = X, Q;
    }, P(V, H);
  }
  function A(V) {
    var H = F();
    return function() {
      var Q = $(V), X;
      if (H) {
        var K = $(this).constructor;
        X = Reflect.construct(Q, arguments, K);
      } else
        X = Q.apply(this, arguments);
      return D(this, X);
    };
  }
  function D(V, H) {
    return H && (t(H) === "object" || typeof H == "function") ? H : N(V);
  }
  function N(V) {
    if (V === void 0)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return V;
  }
  function F() {
    if (typeof Reflect == "undefined" || !Reflect.construct || Reflect.construct.sham)
      return !1;
    if (typeof Proxy == "function")
      return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      })), !0;
    } catch (V) {
      return !1;
    }
  }
  function $(V) {
    return $ = Object.setPrototypeOf ? Object.getPrototypeOf : function(q) {
      return q.__proto__ || Object.getPrototypeOf(q);
    }, $(V);
  }
  function I(V, H, q) {
    return H in V ? Object.defineProperty(V, H, { value: q, enumerable: !0, configurable: !0, writable: !0 }) : V[H] = q, V;
  }
  var j = 25, U = /* @__PURE__ */ function(V) {
    R(q, V);
    var H = A(q);
    function q(Q) {
      var X;
      return w(this, q), X = H.call(this, Q), I(N(X), "_shouldHandleTouchX", function(K) {
        return (
          /*boolean*/
          X.props.touchScrollEnabled && X._shouldHandleWheelX(K)
        );
      }), I(N(X), "_shouldHandleTouchY", function(K) {
        return (
          /*boolean*/
          X.props.touchScrollEnabled && X._shouldHandleWheelY(K)
        );
      }), I(N(X), "_shouldHandleWheelX", function(K) {
        var J = X.props, ne = J.maxScrollX, ae = J.scrollFlags, te = J.scrollX, le = ae.overflowX;
        return le === "hidden" || (K = Math.round(K), K === 0) ? !1 : K < 0 && te > 0 || K >= 0 && te < ne;
      }), I(N(X), "_shouldHandleWheelY", function(K) {
        var J = X.props, ne = J.maxScrollY, ae = J.scrollFlags, te = J.scrollY, le = ae.overflowY;
        return le === "hidden" || K === 0 || (K = Math.round(K), K === 0) ? !1 : K < 0 && te > 0 || K >= 0 && te < ne;
      }), I(N(X), "_reportContentHeight", function() {
        var K = (0, m.default)(X.props), J = K.contentHeight, ne = X.props.onContentHeightChange;
        J !== X._contentHeight && ne && ne(J), X._contentHeight = J;
      }), I(N(X), "_renderRows", function(K, J, ne, ae, te, le) {
        var ce = (0, p.default)(X.props), fe = ce.scrollEnabledY, ee = X.props;
        return /* @__PURE__ */ n.default.createElement(g.default, {
          ariaRowIndexOffset: le,
          isScrolling: ee.scrolling,
          fixedColumns: J,
          fixedRightColumns: ne,
          firstViewportRowIndex: ee.firstRowIndex,
          endViewportRowIndex: ee.endRowIndex,
          height: te,
          offsetTop: K,
          onRowClick: ee.onRowClick,
          onRowContextMenu: ee.onRowContextMenu,
          onRowDoubleClick: ee.onRowDoubleClick,
          onRowMouseUp: ee.onRowMouseUp,
          onRowMouseDown: ee.onRowMouseDown,
          onRowMouseEnter: ee.onRowMouseEnter,
          onRowMouseLeave: ee.onRowMouseLeave,
          onRowTouchStart: ee.touchScrollEnabled ? ee.onRowTouchStart : null,
          onRowTouchEnd: ee.touchScrollEnabled ? ee.onRowTouchEnd : null,
          onRowTouchMove: ee.touchScrollEnabled ? ee.onRowTouchMove : null,
          rowClassNameGetter: ee.rowClassNameGetter,
          rowExpanded: ee.rowExpanded,
          rowKeyGetter: ee.rowKeyGetter,
          rowSettings: ee.rowSettings,
          scrollLeft: ee.scrollX,
          scrollTop: ee.scrollY,
          scrollableColumns: ae,
          showLastRowBorder: !0,
          width: ee.tableSize.width,
          rowsToRender: ee.rows,
          rowOffsets: ee.rowOffsets,
          showScrollbarY: fe,
          scrollbarYWidth: ee.scrollbarYWidth,
          isRTL: ee.isRTL
        });
      }), I(N(X), "_onRef", function(K) {
        X._divRef = K, X._wheelHandler && (X.props.stopReactWheelPropagation ? X._wheelHandler.setRoot(K) : X._wheelHandler.setRoot(null));
      }), I(N(X), "_onColumnResize", function(K, J, ne, ae, te, le, ce) {
        var fe = b.default.getCoordinatesFromEvent(ce), ee = fe.x, me = fe.y;
        X.props.columnActions.resizeColumn({
          cellMinWidth: ae,
          cellMaxWidth: te,
          cellWidth: ne,
          columnKey: le,
          combinedWidth: K,
          clientX: ee,
          clientY: me,
          leftOffset: J
        });
      }), I(N(X), "_onColumnReorder", function(K, J, ne, ae) {
        X.props.columnActions.startColumnReorder({
          scrollStart: X.props.scrollX,
          columnKey: K,
          width: J,
          left: ne
        });
      }), I(N(X), "_onColumnReorderMove", function(K) {
        X.props.columnActions.moveColumnReorder(K);
      }), I(N(X), "_onColumnReorderEnd", function(K, J) {
        var ne = X.props, ae = ne.columnActions, te = ne.columnReorderingData, le = te.cancelReorder, ce = te.columnAfter, fe = te.columnBefore, ee = te.columnKey, me = te.scrollStart, oe = ne.onColumnReorderEndCallback, ve = ne.onHorizontalScroll, we = ne.scrollX;
        ae.stopColumnReorder(), !le && (oe({
          columnAfter: ce,
          columnBefore: fe,
          reorderColumn: ee
        }), me !== we && ve && ve(we));
      }), I(N(X), "_onScroll", function(K, J) {
        var ne = X.props, ae = ne.maxScrollX, te = ne.maxScrollY, le = ne.onHorizontalScroll, ce = ne.onVerticalScroll, fe = ne.scrollActions, ee = ne.scrollFlags, me = ne.scrollX, oe = ne.scrollY, ve = ee.overflowX, we = ee.overflowY, ye = me, Ce = oe;
        if (Math.abs(J) > Math.abs(K) && we !== "hidden")
          Ce += J, Ce = Ce < 0 ? 0 : Ce, Ce = Ce > te ? te : Ce, (!ce || ce(Ce)) && fe.scrollToY(Ce);
        else if (K && ve !== "hidden") {
          ye += K, ye = ye < 0 ? 0 : ye, ye = ye > ae ? ae : ye;
          var Se = Math.round(ye);
          (!le || le(Se)) && fe.scrollToX(Se);
        }
      }), I(N(X), "_scrollTo", function(K, J) {
        X._scrollToX(K), X._scrollToY(J);
      }), I(N(X), "_scrollToX", function(K) {
        var J = X.props, ne = J.onHorizontalScroll, ae = J.scrollActions, te = J.scrollX;
        if (K !== te) {
          var le = Math.round(K);
          (!ne || ne(le)) && ae.scrollToX(le);
        }
      }), I(N(X), "_scrollToY", function(K) {
        var J = X.props, ne = J.onVerticalScroll, ae = J.scrollActions, te = J.scrollY;
        K !== te && (!ne || ne(K)) && ae.scrollToY(K);
      }), I(N(X), "_didScroll", function(K) {
        var J = X.props, ne = J.onScrollStart, ae = J.scrollX, te = J.scrollY, le = J.onHorizontalScroll, ce = J.onVerticalScroll, fe = J.tableSize.ownerHeight, ee = J.scrolling, me = K.endRowIndex, oe = K.firstRowIndex, ve = K.scrollX, we = K.scrollY, ye = K.tableSize.ownerHeight, Ce = K.scrolling, Se = fe !== ye && !((0, o.default)(fe) && (0, o.default)(ye)), Te = ae !== ve, Ae = te !== we;
        !Se && !Te && !Ae || (!Ce && ee && ne && ne(ve, we, oe, me), Te && le && le(ae), Ae && ce && ce(te), X._didScrollStop());
      }), I(N(X), "_didScrollStopSync", function() {
        var K = X.props, J = K.endRowIndex, ne = K.firstRowIndex, ae = K.onScrollEnd, te = K.scrollActions, le = K.scrollX, ce = K.scrollY, fe = K.scrolling;
        fe && (te.stopScroll(), ae && ae(le, ce, ne, J));
      }), X._didScrollStop = (0, a.default)(X._didScrollStopSync, 200, N(X)), X._onKeyDown = X._onKeyDown.bind(N(X)), X._setupHandlers(), X;
    }
    return E(q, [{
      key: "componentWillUnmount",
      value: function() {
        this._cleanupHandlers(), this._didScrollStop.reset(), this._didScrollStopSync();
      }
    }, {
      key: "_setupHandlers",
      value: function() {
        this._wheelHandler || (this._wheelHandler = new l.default(this._onScroll, this._shouldHandleWheelX, this._shouldHandleWheelY, this.props.isRTL, this.props.stopScrollDefaultHandling, this.props.stopScrollPropagation)), this._touchHandler || (this._touchHandler = new T.default(this._onScroll, this._shouldHandleTouchX, this._shouldHandleTouchY, this.props.stopScrollDefaultHandling, this.props.stopScrollPropagation)), this._divRef && this._divRef.addEventListener("wheel", this._wheelHandler.onWheel, {
          passive: !1
        }), this.props.touchScrollEnabled && this._divRef && this._divRef.addEventListener("touchmove", this._touchHandler.onTouchMove, {
          passive: !1
        });
      }
    }, {
      key: "_cleanupHandlers",
      value: function() {
        this._wheelHandler && (this._divRef && this._divRef.removeEventListener("wheel", this._wheelHandler.onWheel, {
          passive: !1
        }), this._wheelHandler = null), this._touchHandler && (this._divRef && this._divRef.removeEventListener("touchmove", this._touchHandler.onTouchMove, {
          passive: !1
        }), this._touchHandler = null);
      }
    }, {
      key: "_onKeyDown",
      value: function(X) {
        var K = (0, m.default)(this.props), J = K.scrollbarYHeight;
        if (this.props.keyboardPageEnabled)
          switch (X.key) {
            case "PageDown":
              this._onScroll(0, J), X.preventDefault();
              break;
            case "PageUp":
              this._onScroll(0, J * -1), X.preventDefault();
              break;
          }
        if (this.props.keyboardScrollEnabled)
          switch (X.key) {
            case "ArrowDown":
              this._onScroll(0, j), X.preventDefault();
              break;
            case "ArrowUp":
              this._onScroll(0, j * -1), X.preventDefault();
              break;
            case "ArrowRight":
              this._onScroll(j, 0), X.preventDefault();
              break;
            case "ArrowLeft":
              this._onScroll(j * -1, 0), X.preventDefault();
              break;
          }
      }
    }, {
      key: "shouldComponentUpdate",
      value: function(X) {
        return !(0, c.default)(this.props, X);
      }
    }, {
      key: "componentDidMount",
      value: function() {
        this._setupHandlers(), this._reportContentHeight(), this._reportScrollBarsUpdates();
      }
    }, {
      key: "componentDidUpdate",
      value: function(X) {
        this._didScroll(X), this._reportContentHeight(), this._reportScrollBarsUpdates();
      }
      /**
       * Method to report scrollbars updates
       * @private
       */
    }, {
      key: "_reportScrollBarsUpdates",
      value: function() {
        var X = (0, m.default)(this.props), K = X.bodyOffsetTop, J = X.scrollbarXOffsetTop, ne = X.visibleRowsHeight, ae = this.props, te = ae.tableSize.width, le = ae.scrollContentHeight, ce = ae.scrollY, fe = ae.scrollX, ee = {
          viewportHeight: ne,
          contentHeight: le,
          scrollbarYOffsetTop: K,
          scrollY: ce,
          viewportWidth: te,
          contentWidth: te + this.props.maxScrollX,
          scrollbarXOffsetTop: J,
          scrollX: fe,
          scrollTo: this._scrollTo,
          scrollToX: this._scrollToX,
          scrollToY: this._scrollToY
        };
        (0, c.default)(this.previousScrollState, ee) || (this.props.onScrollBarsUpdate(ee), this.previousScrollState = ee);
      }
    }, {
      key: "render",
      value: function() {
        var X = (0, d.default)(this.props), K = X.ariaGroupHeaderIndex, J = X.ariaHeaderIndex, ne = X.ariaFooterIndex, ae = X.ariaRowCount, te = X.ariaRowIndexOffset, le = (0, f.default)(this.props), ce = le.fixedColumnGroups, fe = le.fixedColumns, ee = le.fixedRightColumnGroups, me = le.fixedRightColumns, oe = le.scrollableColumnGroups, ve = le.scrollableColumns, we = (0, m.default)(this.props), ye = we.bodyHeight, Ce = we.bodyOffsetTop, Se = we.componentHeight, Te = we.footOffsetTop, Ae = we.scrollbarXOffsetTop, je = we.visibleRowsHeight, Me = this.props, ze = Me.className, ft = Me.columnReorderingData, Ue = Me.columnResizingData, Be = Me.elementHeights, Pe = Me.isColumnReordering, Ee = Me.isColumnResizing, st = Me.gridAttributesGetter, Vt = Me.maxScrollY, Ct = Me.onColumnReorderEndCallback, Ne = Me.onColumnResizeEndCallback, Ve = Me.scrollContentHeight, ut = Me.scrollX, Ut = Me.scrollY, St = Me.scrolling, Zn = Me.tableSize, Cn = Me.touchScrollEnabled, an = Me.scrollbarYWidth, xr = Zn.ownerHeight, Vn = Zn.width, An = Be.cellGroupWrapperHeight, kt = Be.footerHeight, Tt = Be.groupHeaderHeight, Nt = Be.headerHeight, Cr = (0, p.default)(this.props), Xn = Cr.scrollEnabledX, mn = Cr.scrollEnabledY, Kn = Ct ? this._onColumnReorder : null, Un = st && st(), Bt;
        Tt > 0 && (Bt = /* @__PURE__ */ n.default.createElement(x.default, {
          key: "group_header",
          ariaRowIndex: K,
          isHeaderOrFooter: !0,
          isScrolling: St,
          className: (0, s.default)((0, i.default)("fixedDataTableLayout/header"), (0, i.default)("public/fixedDataTable/header")),
          width: Vn,
          height: Tt,
          cellGroupWrapperHeight: An,
          index: 0,
          zIndex: 1,
          offsetTop: 0,
          scrollLeft: ut,
          fixedColumns: ce,
          fixedRightColumns: ee,
          scrollableColumns: oe,
          visible: !0,
          onColumnResize: this._onColumnResize,
          onColumnReorder: Kn,
          onColumnReorderMove: this._onColumnReorderMove,
          showScrollbarY: mn,
          scrollbarYWidth: an,
          isRTL: this.props.isRTL
        }));
        var gt;
        mn && (gt = this.props.scrollbarY);
        var Zt;
        Xn && (Zt = this.props.scrollbarX);
        var ke = /* @__PURE__ */ n.default.createElement(v.default, {
          height: Se,
          initialWidth: Ue.width || 0,
          minWidth: Ue.minWidth || 0,
          maxWidth: Ue.maxWidth || Number.MAX_VALUE,
          visible: !!Ee,
          leftOffset: Ue.left || 0,
          knobHeight: Nt,
          initialEvent: Ue.initialEvent,
          onColumnResizeEnd: Ne,
          columnKey: Ue.key,
          touchEnabled: Cn,
          isRTL: this.props.isRTL
        }), gn = null;
        kt && (gn = /* @__PURE__ */ n.default.createElement(x.default, {
          key: "footer",
          ariaRowIndex: ne,
          isHeaderOrFooter: !0,
          isScrolling: St,
          className: (0, s.default)((0, i.default)("fixedDataTableLayout/footer"), (0, i.default)("public/fixedDataTable/footer")),
          width: Vn,
          height: kt,
          index: -1,
          zIndex: 1,
          offsetTop: Te,
          visible: !0,
          fixedColumns: fe.footer,
          fixedRightColumns: me.footer,
          scrollableColumns: ve.footer,
          scrollLeft: ut,
          showScrollbarY: mn,
          scrollbarYWidth: an,
          isRTL: this.props.isRTL
        }));
        var ir = this._renderRows(Ce, fe.cell, me.cell, ve.cell, ye, te), Jn = /* @__PURE__ */ n.default.createElement(x.default, {
          key: "header",
          ariaRowIndex: J,
          isHeaderOrFooter: !0,
          isScrolling: St,
          className: (0, s.default)((0, i.default)("fixedDataTableLayout/header"), (0, i.default)("public/fixedDataTable/header")),
          width: Vn,
          height: Nt,
          cellGroupWrapperHeight: An,
          index: -1,
          zIndex: 1,
          offsetTop: Tt,
          scrollLeft: ut,
          visible: !0,
          fixedColumns: fe.header,
          fixedRightColumns: me.header,
          scrollableColumns: ve.header,
          touchEnabled: Cn,
          onColumnResize: this._onColumnResize,
          onColumnReorder: Kn,
          onColumnReorderMove: this._onColumnReorderMove,
          onColumnReorderEnd: this._onColumnReorderEnd,
          isColumnReordering: !!Pe,
          columnReorderingData: ft,
          showScrollbarY: mn,
          scrollbarYWidth: an,
          isRTL: this.props.isRTL
        }), qn;
        Ut && (qn = /* @__PURE__ */ n.default.createElement("div", {
          className: (0, s.default)((0, i.default)("fixedDataTableLayout/topShadow"), (0, i.default)("public/fixedDataTable/topShadow")),
          style: {
            top: Ce
          }
        }));
        var Sn = xr && xr < Se && Ve > je, Qn;
        (Sn || Ut < Vt) && (Qn = /* @__PURE__ */ n.default.createElement("div", {
          className: (0, s.default)((0, i.default)("fixedDataTableLayout/bottomShadow"), (0, i.default)("public/fixedDataTable/bottomShadow")),
          style: {
            top: Te
          }
        }));
        var er = null;
        (this.props.keyboardPageEnabled || this.props.keyboardScrollEnabled) && (er = 0);
        var mr = ze;
        return this.props.isRTL && (mr = (0, s.default)(mr, "fixedDataTable_isRTL")), /* @__PURE__ */ n.default.createElement("div", _({
          className: (0, s.default)(mr, (0, i.default)("fixedDataTableLayout/main"), (0, i.default)("public/fixedDataTable/main")),
          role: "grid",
          "aria-rowcount": ae
        }, Un, {
          tabIndex: er,
          onKeyDown: this._onKeyDown,
          onTouchStart: Cn ? this._touchHandler.onTouchStart : null,
          onTouchEnd: Cn ? this._touchHandler.onTouchEnd : null,
          onTouchCancel: Cn ? this._touchHandler.onTouchCancel : null,
          ref: this._onRef,
          style: {
            height: Se,
            width: Vn
          }
        }), /* @__PURE__ */ n.default.createElement("div", {
          className: (0, i.default)("fixedDataTableLayout/rowsContainer"),
          style: {
            height: Ae,
            width: Vn
          }
        }, ke, Bt, Jn, ir, gn, qn, Qn), gt, Zt);
      }
    }]), q;
  }(n.default.Component);
  I(U, "propTypes", {
    // TODO (jordan) Remove propType of width without losing documentation (moved to tableSize)
    /**
     * Pixel width of table. If all columns do not fit,
     * a horizontal scrollbar will appear.
     */
    width: r.default.number.isRequired,
    // TODO (jordan) Remove propType of height without losing documentation (moved to tableSize)
    /**
     * Pixel height of table. If all rows do not fit,
     * a vertical scrollbar will appear.
     *
     * Either `height` or `maxHeight` must be specified.
     */
    height: r.default.number,
    /**
     * Class name to be passed into parent container
     */
    className: r.default.string,
    // TODO (jordan) Remove propType of maxHeight without losing documentation (moved to tableSize)
    /**
     * Maximum pixel height of table. If all rows do not fit,
     * a vertical scrollbar will appear.
     *
     * Either `height` or `maxHeight` must be specified.
     */
    maxHeight: r.default.number,
    // TODO (jordan) Remove propType of ownerHeight without losing documentation (moved to tableSize)
    /**
     * Pixel height of table's owner, this is used in a managed scrolling
     * situation when you want to slide the table up from below the fold
     * without having to constantly update the height on every scroll tick.
     * Instead, vary this property on scroll. By using `ownerHeight`, we
     * over-render the table while making sure the footer and horizontal
     * scrollbar of the table are visible when the current space for the table
     * in view is smaller than the final, over-flowing height of table. It
     * allows us to avoid resizing and reflowing table when it is moving in the
     * view.
     *
     * This is used if `ownerHeight < height` (or `maxHeight`).
     */
    ownerHeight: r.default.number,
    // TODO (jordan) Remove propType of overflowX & overflowY without losing documentation (moved to scrollFlags)
    overflowX: r.default.oneOf(["hidden", "auto"]),
    overflowY: r.default.oneOf(["hidden", "auto"]),
    /**
     * Boolean flag indicating of touch scrolling should be enabled
     * This feature is current in beta and may have bugs
     */
    touchScrollEnabled: r.default.bool,
    /**
     * Boolean flags to control if scrolling with keys is enabled
     */
    keyboardScrollEnabled: r.default.bool,
    keyboardPageEnabled: r.default.bool,
    /**
     * Scrollbar X to be rendered
     */
    scrollbarX: r.default.node,
    /**
     * Height to be reserved for scrollbar X
     */
    scrollbarXHeight: r.default.number,
    /**
     * Scrollbar Y to be rendered
     */
    scrollbarY: r.default.node,
    /**
     * Width to be reserved for scrollbar Y
     */
    scrollbarYWidth: r.default.number,
    /**
     * Function to listen to scroll bars related updates like scroll position, visible rows height, all rows height,....
     */
    onScrollBarsUpdate: r.default.func,
    // TODO Remove propType of defaultScrollbars without losing documentation (this is required for FixedDataTableContainer only)
    /**
     * Default scrollbars provided by FDT-2 will be rendered, pass false if you want to render custom scrollbars (by passing scrollbarX and scrollbarY props)
     */
    defaultScrollbars: r.default.bool,
    // TODO (jordan) Remove propType of showScrollbarX & showScrollbarY without losing documentation (moved to scrollFlags)
    /**
     * Hide the scrollbar but still enable scroll functionality
     */
    showScrollbarX: r.default.bool,
    showScrollbarY: r.default.bool,
    /**
     * Callback when horizontally scrolling the grid.
     *
     * Return false to stop propagation.
     */
    onHorizontalScroll: r.default.func,
    /**
     * Callback when vertically scrolling the grid.
     *
     * Return false to stop propagation.
     */
    onVerticalScroll: r.default.func,
    // TODO (jordan) Remove propType of rowsCount without losing documentation (moved to rowSettings)
    /**
     * Number of rows in the table.
     */
    rowsCount: r.default.number.isRequired,
    // TODO (jordan) Remove propType of rowHeight without losing documentation (moved to rowSettings)
    /**
     * Pixel height of rows unless `rowHeightGetter` is specified and returns
     * different value.
     */
    rowHeight: r.default.number.isRequired,
    // TODO (jordan) Remove propType of rowHeightGetter without losing documentation (moved to rowSettings)
    /**
     * If specified, `rowHeightGetter(index)` is called for each row and the
     * returned value overrides `rowHeight` for particular row.
     */
    rowHeightGetter: r.default.func,
    // TODO (jordan) Remove propType of subRowHeight without losing documentation (moved to rowSettings)
    /**
     * Pixel height of sub-row unless `subRowHeightGetter` is specified and returns
     * different value.  Defaults to 0 and no sub-row being displayed.
     */
    subRowHeight: r.default.number,
    // TODO (jordan) Remove propType of subRowHeightGetter without losing documentation (moved to rowSettings)
    /**
     * If specified, `subRowHeightGetter(index)` is called for each row and the
     * returned value overrides `subRowHeight` for particular row.
     */
    subRowHeightGetter: r.default.func,
    /**
     * The row expanded for table row.
     * This can either be a React element, or a function that generates
     * a React Element. By default, the React element passed in can expect to
     * receive the following props:
     *
     * ```
     * props: {
     *   rowIndex; number // (the row index)
     *   height: number // (supplied from subRowHeight or subRowHeightGetter)
     *   width: number // (supplied from the Table)
     * }
     * ```
     *
     * Because you are passing in your own React element, you can feel free to
     * pass in whatever props you may want or need.
     *
     * If you pass in a function, you will receive the same props object as the
     * first argument.
     */
    rowExpanded: r.default.oneOfType([r.default.element, r.default.func]),
    /**
     * To get any additional CSS classes that should be added to a row,
     * `rowClassNameGetter(index)` is called.
     */
    rowClassNameGetter: r.default.func,
    /**
     * If specified, `rowKeyGetter(index)` is called for each row and the
     * returned value overrides `key` for the particular row.
     */
    rowKeyGetter: r.default.func,
    // TODO (jordan) Remove propType of groupHeaderHeight without losing documentation (moved to elementHeights)
    /**
     * Pixel height of the column group header.
     */
    groupHeaderHeight: r.default.number,
    // TODO (jordan) Remove propType of headerHeight without losing documentation (moved to elementHeights)
    /**
     * Pixel height of header.
     */
    headerHeight: r.default.number.isRequired,
    /**
     * Pixel height of fixedDataTableCellGroupLayout/cellGroupWrapper.
     * Default is headerHeight and groupHeaderHeight.
     *
     * This can be used with CSS to make a header cell span both the group & normal header row.
     * Setting this to a value larger than height will cause the content to
     * overflow the height. This is useful when adding a 2nd table as the group
     * header and vertically merging the 2 headers when a column is not part
     * of a group. Here are the necessary CSS changes:
     *
     * Both headers:
     *  - cellGroupWrapper needs overflow-x: hidden and pointer-events: none
     *  - cellGroup needs pointer-events: auto to reenable them on child els
     * Group header:
     *  - Layout/main needs overflow: visible and a higher z-index
     *  - CellLayout/main needs overflow-y: visible
     *  - cellGroup needs overflow: visible
     */
    cellGroupWrapperHeight: r.default.number,
    // TODO (jordan) Remove propType of footerHeight without losing documentation (moved to elementHeights)
    /**
     * Pixel height of footer.
     */
    footerHeight: r.default.number,
    /**
     * Value of horizontal scroll.
     */
    scrollLeft: r.default.number,
    // TODO (jordan) Remove propType of scrollToRow & scrollToColumn without losing documentation
    /**
     * Index of column to scroll to.
     */
    scrollToColumn: r.default.number,
    /**
     * Value of vertical scroll.
     */
    scrollTop: r.default.number,
    /**
     * Index of row to scroll to.
     */
    scrollToRow: r.default.number,
    /**
     * Callback that is called when scrolling starts. The current horizontal and vertical scroll values,
     * and the current first and last row indexes will be provided to the callback.
     */
    onScrollStart: r.default.func,
    /**
     * Callback that is called when scrolling ends. The new horizontal and vertical scroll values,
     * and the new first and last row indexes will be provided to the callback.
     */
    onScrollEnd: r.default.func,
    /**
     * If enabled scroll events will not be propagated outside of the table.
     */
    stopReactWheelPropagation: r.default.bool,
    /**
     * If enabled scroll events will never be bubbled to the browser default handler.
     * If disabled (default when unspecified), scroll events will be bubbled up if the scroll
     * doesn't lead to a change in scroll offsets, which is preferable if you like
     * the page/container to scroll up when the table is already scrolled up max.
     */
    stopScrollDefaultHandling: r.default.bool,
    /**
     * If enabled scroll events will not be propagated outside of the table.
     */
    stopScrollPropagation: r.default.bool,
    /**
     * Callback that is called when `rowHeightGetter` returns a different height
     * for a row than the `rowHeight` prop. This is necessary because initially
     * table estimates heights of some parts of the content.
     */
    onContentHeightChange: r.default.func,
    /**
     * Callback that is called when a row is clicked.
     */
    onRowClick: r.default.func,
    /**
     * Callback that is called when a contextual-menu event happens on a row.
     */
    onRowContextMenu: r.default.func,
    /**
     * Callback that is called when a row is double clicked.
     */
    onRowDoubleClick: r.default.func,
    /**
     * Callback that is called when a mouse-down event happens on a row.
     */
    onRowMouseDown: r.default.func,
    /**
     * Callback that is called when a mouse-up event happens on a row.
     */
    onRowMouseUp: r.default.func,
    /**
     * Callback that is called when a mouse-enter event happens on a row.
     */
    onRowMouseEnter: r.default.func,
    /**
     * Callback that is called when a mouse-leave event happens on a row.
     */
    onRowMouseLeave: r.default.func,
    /**
     * Callback that is called when a touch-start event happens on a row.
     */
    onRowTouchStart: r.default.func,
    /**
     * Callback that is called when a touch-end event happens on a row.
     */
    onRowTouchEnd: r.default.func,
    /**
     * Callback that is called when a touch-move event happens on a row.
     */
    onRowTouchMove: r.default.func,
    /**
     * Callback that is called when resizer has been released
     * and column needs to be updated.
     *
     * Required if the isResizable property is true on any column.
     *
     * ```
     * function(
     *   newColumnWidth: number,
     *   columnKey: string,
     * )
     * ```
     */
    onColumnResizeEndCallback: r.default.func,
    /**
     * Callback that is called when reordering has been completed
     * and columns need to be updated.
     *
     * ```
     * function(
     *   event {
     *     columnBefore: string|undefined, // the column before the new location of this one
     *     columnAfter: string|undefined,  // the column after the new location of this one
     *     reorderColumn: string,          // the column key that was just reordered
     *   }
     * )
     * ```
     */
    onColumnReorderEndCallback: r.default.func,
    /**
     * Whether a column is currently being resized.
     */
    isColumnResizing: r.default.bool,
    /**
     * Whether columns are currently being reordered.
     */
    isColumnReordering: r.default.bool,
    /**
     * Whether the grid should be in RTL mode
     */
    isRTL: r.default.bool,
    // TODO (jordan) Remove propType of bufferRowCount without losing documentation
    /**
     * The number of rows outside the viewport to prerender. Defaults to roughly
     * half of the number of visible rows.
     */
    bufferRowCount: r.default.number,
    // TODO (pradeep): Move elementHeights to a selector instead of passing it through redux as state variables
    /**
     * Row heights of the header, groupheader, footer, and cell group wrapper
     * grouped into a single object.
     *
     * @ignore
     */
    elementHeights: r.default.shape({
      cellGroupWrapperHeight: r.default.number,
      footerHeight: r.default.number,
      groupHeaderHeight: r.default.number,
      headerHeight: r.default.number
    }),
    /**
     * Callback that returns an object of html attributes to add to the grid element
     */
    gridAttributesGetter: r.default.func,
    // TODO (pradeep) Remove propType of rowAttributesGetter without losing documentation (moved to rowSettings)
    /**
     * Callback that returns an object of html attributes to add to each row element.
     *
     * ```
     * function(rowIndex: number)
     * ```
     */
    rowAttributesGetter: r.default.func
  }), I(
    U,
    "defaultProps",
    /*object*/
    {
      elementHeights: {
        cellGroupWrapperHeight: void 0,
        footerHeight: 0,
        groupHeaderHeight: 0,
        headerHeight: 0
      },
      keyboardScrollEnabled: !1,
      keyboardPageEnabled: !1,
      touchScrollEnabled: !1,
      stopScrollPropagation: !1
    }
  );
  var G = U;
  e.default = G;
})(IL);
var _4 = {}, w4 = {}, x4 = {}, C4 = {};
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  function t(s, c) {
    if (!(s instanceof c))
      throw new TypeError("Cannot call a class as a function");
  }
  function n(s, c) {
    for (var l = 0; l < c.length; l++) {
      var d = c[l];
      d.enumerable = d.enumerable || !1, d.configurable = !0, "value" in d && (d.writable = !0), Object.defineProperty(s, d.key, d);
    }
  }
  function r(s, c, l) {
    return c && n(s.prototype, c), s;
  }
  function o(s, c) {
    return s < c;
  }
  var i = /* @__PURE__ */ function() {
    function s(c, l) {
      t(this, s), this._items = c || [], this._size = this._items.length, this._comparator = l || o, this._heapify();
    }
    return r(s, [{
      key: "empty",
      value: function() {
        return this._size === 0;
      }
      /*
       * @return {*}
       */
    }, {
      key: "pop",
      value: function() {
        if (this._size !== 0) {
          var l = this._items[0], d = this._items.pop();
          return this._size--, this._size > 0 && (this._items[0] = d, this._sinkDown(0)), l;
        }
      }
      /*
       * @param {*} item
       */
    }, {
      key: "push",
      value: function(l) {
        this._items[this._size++] = l, this._bubbleUp(this._size - 1);
      }
      /*
       * @return {number}
       */
    }, {
      key: "size",
      value: function() {
        return this._size;
      }
      /*
       * @return {*}
       */
    }, {
      key: "peek",
      value: function() {
        if (this._size !== 0)
          return this._items[0];
      }
    }, {
      key: "_heapify",
      value: function() {
        for (var l = Math.floor((this._size + 1) / 2); l >= 0; l--)
          this._sinkDown(l);
      }
      /*
       * @parent {number} index
       */
    }, {
      key: "_bubbleUp",
      value: function(l) {
        for (var d = this._items[l]; l > 0; ) {
          var f = Math.floor((l + 1) / 2) - 1, p = this._items[f];
          if (this._comparator(p, d))
            return;
          this._items[f] = d, this._items[l] = p, l = f;
        }
      }
      /*
       * @parent {number} index
       */
    }, {
      key: "_sinkDown",
      value: function(l) {
        for (var d = this._items[l]; ; ) {
          var f = 2 * (l + 1) - 1, p = 2 * (l + 1), m = -1;
          if (f < this._size) {
            var v = this._items[f];
            this._comparator(v, d) && (m = f);
          }
          if (p < this._size) {
            var g = this._items[p];
            this._comparator(g, d) && (m === -1 || this._comparator(g, this._items[m])) && (m = p);
          }
          if (m === -1)
            return;
          this._items[l] = this._items[m], this._items[m] = d, l = m;
        }
      }
    }]), s;
  }(), a = i;
  e.default = a;
})(C4);
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var t = r(C4), n = r(Qc);
  function r(l) {
    return l && l.__esModule ? l : { default: l };
  }
  function o(l, d) {
    if (!(l instanceof d))
      throw new TypeError("Cannot call a class as a function");
  }
  function i(l, d) {
    for (var f = 0; f < d.length; f++) {
      var p = d[f];
      p.enumerable = p.enumerable || !1, p.configurable = !0, "value" in p && (p.writable = !0), Object.defineProperty(l, p.key, p);
    }
  }
  function a(l, d, f) {
    return d && i(l.prototype, d), l;
  }
  var s = /* @__PURE__ */ function() {
    function l() {
      o(this, l), this._valueToPositionMap = {}, this._size = 0, this._smallValues = new t.default(
        [],
        // Initial data in the heap
        this._smallerComparator
      ), this._largeValues = new t.default(
        [],
        // Initial data in the heap
        this._greaterComparator
      ), this.getNewPositionForValue = this.getNewPositionForValue.bind(this), this.getValuePosition = this.getValuePosition.bind(this), this.getSize = this.getSize.bind(this), this.replaceFurthestValuePosition = this.replaceFurthestValuePosition.bind(this);
    }
    return a(l, [{
      key: "getSize",
      value: function() {
        return this._size;
      }
    }, {
      key: "getValuePosition",
      value: function(f) {
        return this._valueToPositionMap[f] === void 0 ? null : this._valueToPositionMap[f];
      }
    }, {
      key: "getNewPositionForValue",
      value: function(f) {
        (0, n.default)(this._valueToPositionMap[f] === void 0, "Shouldn't try to find new position for value already stored in BufferSet");
        var p = this._size;
        return this._size++, this._pushToHeaps(p, f), this._valueToPositionMap[f] = p, p;
      }
    }, {
      key: "replaceFurthestValuePosition",
      value: function(f, p, m) {
        if ((0, n.default)(this._valueToPositionMap[m] === void 0, "Shouldn't try to replace values with value already stored value in BufferSet"), this._cleanHeaps(), this._smallValues.empty() || this._largeValues.empty())
          return null;
        var v = this._smallValues.peek().value, g = this._largeValues.peek().value;
        if (v >= f && g <= p)
          return null;
        var b;
        f - v > g - p ? (b = v, this._smallValues.pop()) : (b = g, this._largeValues.pop());
        var x = this._valueToPositionMap[b];
        return delete this._valueToPositionMap[b], this._valueToPositionMap[m] = x, this._pushToHeaps(x, m), x;
      }
    }, {
      key: "_pushToHeaps",
      value: function(f, p) {
        var m = {
          position: f,
          value: p
        };
        this._smallValues.push(m), this._largeValues.push(m);
      }
    }, {
      key: "_cleanHeaps",
      value: function() {
        this._cleanHeap(this._smallValues), this._cleanHeap(this._largeValues);
        var f = Math.min(this._smallValues.size(), this._largeValues.size()), p = Math.max(this._smallValues.size(), this._largeValues.size());
        p > 10 * f && this._recreateHeaps();
      }
    }, {
      key: "_recreateHeaps",
      value: function() {
        for (var f = this._smallValues.size() < this._largeValues.size() ? this._smallValues : this._largeValues, p = new t.default(
          [],
          // Initial data in the heap
          this._smallerComparator
        ), m = new t.default(
          [],
          // Initial datat in the heap
          this._greaterComparator
        ); !f.empty(); ) {
          var v = f.pop();
          this._valueToPositionMap[v.value] !== void 0 && (p.push(v), m.push(v));
        }
        this._smallValues = p, this._largeValues = m;
      }
    }, {
      key: "_cleanHeap",
      value: function(f) {
        for (; !f.empty() && this._valueToPositionMap[f.peek().value] === void 0; )
          f.pop();
      }
    }, {
      key: "_smallerComparator",
      value: function(f, p) {
        return f.value < p.value;
      }
    }, {
      key: "_greaterComparator",
      value: function(f, p) {
        return f.value > p.value;
      }
    }]), l;
  }(), c = s;
  e.default = c;
})(x4);
var S4 = {};
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var t = r(Qc), n = r(iu);
  function r(p) {
    return p && p.__esModule ? p : { default: p };
  }
  function o(p, m) {
    if (!(p instanceof m))
      throw new TypeError("Cannot call a class as a function");
  }
  function i(p, m) {
    for (var v = 0; v < m.length; v++) {
      var g = m[v];
      g.enumerable = g.enumerable || !1, g.configurable = !0, "value" in g && (g.writable = !0), Object.defineProperty(p, g.key, g);
    }
  }
  function a(p, m, v) {
    return m && i(p.prototype, m), v && i(p, v), p;
  }
  var s = function(m) {
    return Math.floor(m / 2);
  }, c = n.default.Int32Array || function(p) {
    for (var m = [], v = p - 1; v >= 0; --v)
      m[v] = 0;
    return m;
  };
  function l(p) {
    for (var m = 1; m < p; )
      m *= 2;
    return m;
  }
  var d = /* @__PURE__ */ function() {
    function p(m) {
      o(this, p), this._size = m.length, this._half = l(this._size), this._heap = new c(2 * this._half);
      var v;
      for (v = 0; v < this._size; ++v)
        this._heap[this._half + v] = m[v];
      for (v = this._half - 1; v > 0; --v)
        this._heap[v] = this._heap[2 * v] + this._heap[2 * v + 1];
    }
    return a(p, [{
      key: "set",
      value: function(v, g) {
        (0, t.default)(0 <= v && v < this._size, "Index out of range %s", v);
        var b = this._half + v;
        for (this._heap[b] = g, b = s(b); b !== 0; b = s(b))
          this._heap[b] = this._heap[2 * b] + this._heap[2 * b + 1];
      }
    }, {
      key: "get",
      value: function(v) {
        (0, t.default)(0 <= v && v < this._size, "Index out of range %s", v);
        var g = this._half + v;
        return this._heap[g];
      }
    }, {
      key: "getSize",
      value: function() {
        return this._size;
      }
      /**
       * Returns the sum get(0) + get(1) + ... + get(end - 1).
       */
    }, {
      key: "sumUntil",
      value: function(v) {
        if ((0, t.default)(0 <= v && v < this._size + 1, "Index out of range %s", v), v === 0)
          return 0;
        for (var g = this._half + v - 1, b = this._heap[g]; g !== 1; g = s(g))
          g % 2 === 1 && (b += this._heap[g - 1]);
        return b;
      }
      /**
       * Returns the sum get(0) + get(1) + ... + get(inclusiveEnd).
       */
    }, {
      key: "sumTo",
      value: function(v) {
        return (0, t.default)(0 <= v && v < this._size, "Index out of range %s", v), this.sumUntil(v + 1);
      }
      /**
       * Returns the sum get(begin) + get(begin + 1) + ... + get(end - 1).
       */
    }, {
      key: "sum",
      value: function(v, g) {
        return (0, t.default)(v <= g, "Begin must precede end"), this.sumUntil(g) - this.sumUntil(v);
      }
      /**
       * Returns the smallest i such that 0 <= i <= size and sumUntil(i) <= t, or
       * -1 if no such i exists.
       */
    }, {
      key: "greatestLowerBound",
      value: function(v) {
        if (v < 0)
          return -1;
        var g = 1;
        if (this._heap[g] <= v)
          return this._size;
        for (; g < this._half; ) {
          var b = this._heap[2 * g];
          v < b ? g = 2 * g : (g = 2 * g + 1, v -= b);
        }
        return g - this._half;
      }
      /**
       * Returns the smallest i such that 0 <= i <= size and sumUntil(i) < t, or
       * -1 if no such i exists.
       */
    }, {
      key: "greatestStrictLowerBound",
      value: function(v) {
        if (v <= 0)
          return -1;
        var g = 1;
        if (this._heap[g] < v)
          return this._size;
        for (; g < this._half; ) {
          var b = this._heap[2 * g];
          v <= b ? g = 2 * g : (g = 2 * g + 1, v -= b);
        }
        return g - this._half;
      }
      /**
       * Returns the smallest i such that 0 <= i <= size and t <= sumUntil(i), or
       * size + 1 if no such i exists.
       */
    }, {
      key: "leastUpperBound",
      value: function(v) {
        return this.greatestStrictLowerBound(v) + 1;
      }
      /**
       * Returns the smallest i such that 0 <= i <= size and t < sumUntil(i), or
       * size + 1 if no such i exists.
       */
    }, {
      key: "leastStrictUpperBound",
      value: function(v) {
        return this.greatestLowerBound(v) + 1;
      }
    }], [{
      key: "uniform",
      value: function(v, g) {
        for (var b = [], x = v - 1; x >= 0; --x)
          b[x] = g;
        return new p(b);
      }
    }, {
      key: "empty",
      value: function(v) {
        return p.uniform(v, 0);
      }
    }]), p;
  }(), f = d;
  e.default = f;
})(S4);
var T4 = {};
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var t = a(et), n = a(Fx), r = a(Qc), o = a(o4), i = a(Ox);
  function a(f) {
    return f && f.__esModule ? f : { default: f };
  }
  function s(f) {
    return (0, i.default)(f.props, ["align", "allowCellsRecycling", "cellClassName", "columnKey", "flexGrow", "fixed", "fixedRight", "maxWidth", "minWidth", "isReorderable", "isResizable", "pureRendering", "width"]);
  }
  function c(f, p) {
    f.cell.push(p.props.cell), f.footer.push(p.props.footer), f.header.push(p.props.header);
  }
  function l(f) {
    var p = [];
    t.default.Children.forEach(f, function(x, T) {
      x != null && ((0, r.default)(x.type.__TableColumnGroup__ || x.type.__TableColumn__, "child type should be <FixedDataTableColumn /> or <FixedDataTableColumnGroup />"), p.push(x));
    });
    var m = {
      cell: [],
      footer: [],
      groupHeader: [],
      header: []
    }, v = [], g = p.length && p[0].type.__TableColumnGroup__;
    if (g) {
      var b = (0, o.default)(p, s);
      return (0, n.default)(p, function(x, T) {
        m.groupHeader.push(x.props.header), t.default.Children.forEach(x.props.children, function(S) {
          var _ = s(S);
          _.groupIdx = T, v.push(_), c(m, S);
        });
      }), {
        columnGroupProps: b,
        columnProps: v,
        elementTemplates: m,
        useGroupHeader: !0
      };
    }
    return (0, n.default)(p, function(x) {
      v.push(s(x)), c(m, x);
    }), {
      columnGroupProps: [],
      columnProps: v,
      elementTemplates: m,
      useGroupHeader: !1
    };
  }
  var d = l;
  e.default = d;
})(T4);
var av = {}, Gx = {};
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = t;
  function t(n, r) {
    var o = n.storedHeights, i = n.rowOffsetIntervalTree, a = n.rowSettings, s = a.rowHeightGetter, c = a.subRowHeightGetter, l = s(r) + c(r), d = o[r];
    return l !== d && (i.set(r, l), o[r] = l, n.scrollContentHeight += l - d), o[r];
  }
})(Gx);
Object.defineProperty(av, "__esModule", {
  value: !0
});
av.getScrollAnchor = LDe;
av.scrollTo = M4;
var E4 = Yx(rv), k4 = Yx(lu), IDe = Yx(Gx);
function Yx(e) {
  return e && e.__esModule ? e : { default: e };
}
function LDe(e, t, n) {
  return t.scrollToRow !== void 0 && t.scrollToRow !== null && (!n || t.scrollToRow !== n.scrollToRow) ? $De(e, t.scrollToRow) : t.scrollTop !== void 0 && t.scrollTop !== null && (!n || t.scrollTop !== n.scrollTop) ? M4(e, t.scrollTop) : {
    firstIndex: e.firstRowIndex,
    firstOffset: e.firstRowOffset,
    lastIndex: void 0,
    changed: !1
  };
}
function M4(e, t) {
  var n = (0, k4.default)(e), r = n.availableHeight, o = e.rowOffsetIntervalTree, i = e.rowSettings, a = e.scrollContentHeight, s = i.rowsCount;
  if (s === 0)
    return {
      firstIndex: 0,
      firstOffset: 0,
      lastIndex: void 0,
      changed: e.firstRowIndex !== 0 || e.firstRowOffset !== 0
    };
  var c = 0, l = 0, d = void 0;
  if (!(t <= 0))
    if (t >= a - r)
      c = void 0, d = s - 1;
    else {
      var f = o.greatestLowerBound(t);
      c = (0, E4.default)(f, 0, Math.max(s - 1, 0));
      var p = o.sumUntil(c);
      l = p - t;
    }
  return {
    firstIndex: c,
    firstOffset: l,
    lastIndex: d,
    // NOTE (jordan) This changed heuristic may give false positives,
    // but that's fine since it's used as a filter to computeRenderedRows
    changed: !0
  };
}
function $De(e, t) {
  var n = (0, k4.default)(e), r = n.availableHeight, o = e.rowOffsetIntervalTree, i = e.rowSettings, a = e.storedHeights, s = e.scrollY, c = i.rowsCount;
  if (c === 0)
    return {
      firstIndex: 0,
      firstOffset: 0,
      lastIndex: void 0,
      changed: e.firstRowIndex !== 0 || e.firstRowOffset !== 0
    };
  t = (0, E4.default)(t, 0, Math.max(c - 1, 0)), (0, IDe.default)(e, t);
  var l = o.sumUntil(t), d = l + a[t], f = t, p = void 0;
  if (!(l < s))
    if (s + r < d)
      f = void 0, p = t;
    else
      return {
        firstIndex: e.firstRowIndex,
        firstOffset: e.firstRowOffset,
        lastIndex: void 0,
        changed: !1
      };
  return {
    firstIndex: f,
    firstOffset: 0,
    lastIndex: p,
    changed: !0
  };
}
var R4 = {};
function FDe(e, t, n) {
  return e === e && (n !== void 0 && (e = e <= n ? e : n), t !== void 0 && (e = e >= t ? e : t)), e;
}
var zDe = FDe, BDe = zDe, _b = jx;
function HDe(e, t, n) {
  return n === void 0 && (n = t, t = void 0), n !== void 0 && (n = _b(n), n = n === n ? n : 0), t !== void 0 && (t = _b(t), t = t === t ? t : 0), BDe(_b(e), t, n);
}
var P4 = HDe;
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var t = i(c4), n = i(P4), r = i(_s), o = i(zx);
  function i(g) {
    return g && g.__esModule ? g : { default: g };
  }
  function a() {
    return a = Object.assign || function(g) {
      for (var b = 1; b < arguments.length; b++) {
        var x = arguments[b];
        for (var T in x)
          Object.prototype.hasOwnProperty.call(x, T) && (g[T] = x[T]);
      }
      return g;
    }, a.apply(this, arguments);
  }
  var s = 15, c = 100;
  function l(g, b, x) {
    var T = b.scrollLeft, S = g.columnResizingData, _ = g.isColumnResizing, w = g.scrollX;
    T !== void 0 && (!x || T !== x.scrollLeft) && (w = T), w = d(g, b, x.scrollToColumn, w);
    var k = (0, o.default)(g), E = k.maxScrollX;
    return w = (0, n.default)(w, 0, E), _ = b.isColumnResizing !== void 0 ? b.isColumnResizing : _, S = _ ? S : {}, a({}, g, {
      columnResizingData: S,
      isColumnResizing: _,
      maxScrollX: E,
      scrollX: w
    });
  }
  function d(g, b, x, T) {
    var S = b.scrollToColumn;
    if ((0, t.default)(S))
      return T;
    var _ = (0, o.default)(g), w = _.availableScrollWidth, k = _.fixedColumns, E = _.scrollableColumns, R = k.length, P = E.length, A = P === 0, D = S === x, N = S < R, F = S >= R + P;
    if (D || N || F || A)
      return T;
    for (var $ = Math.min(S - R, E.length - 1), I = 0, j = 0; j < $; ++j)
      I += E[j].width;
    var U = E[$].width, G = I + U - w;
    return T < G ? G : T > I ? I : T;
  }
  function f(g, b) {
    var x = b.cellMinWidth, T = b.cellMaxWidth, S = b.cellWidth, _ = b.columnKey, w = b.combinedWidth, k = b.clientX, E = b.clientY, R = b.leftOffset;
    return a({}, g, {
      isColumnResizing: !0,
      columnResizingData: {
        left: R + w - S,
        width: S,
        minWidth: x,
        maxWidth: T,
        initialEvent: {
          clientX: k,
          clientY: E,
          preventDefault: r.default
        },
        key: _
      }
    });
  }
  function p(g, b) {
    var x = b.columnKey, T = b.left, S = b.scrollStart, _ = b.width, w = (0, o.default)(g), k = w.fixedColumns, E = k.some(function(R) {
      return R.columnKey === x;
    });
    return a({}, g, {
      isColumnReordering: !0,
      columnReorderingData: {
        cancelReorder: !1,
        dragDistance: 0,
        isFixed: E,
        scrollStart: S,
        columnKey: x,
        columnWidth: _,
        originalLeft: T,
        columnBefore: void 0,
        columnAfter: void 0
      }
    });
  }
  function m(g, b) {
    var x = g.columnReorderingData, T = x.isFixed, S = x.originalLeft, _ = x.scrollStart, w = g.maxScrollX, k = g.scrollX;
    if (!T) {
      var E = S - _ + b, R = (0, o.default)(g), P = R.availableScrollWidth;
      b += k - _, E > P - c ? k = Math.min(k + s, w) : E <= c && (k = Math.max(k - s, 0));
    }
    var A = a({}, g.columnReorderingData, {
      dragDistance: b,
      columnBefore: void 0,
      columnAfter: void 0
    });
    return a({}, g, {
      scrollX: k,
      columnReorderingData: A
    });
  }
  var v = {
    initialize: l,
    reorderColumn: p,
    reorderColumnMove: m,
    resizeColumn: f
  };
  e.default = v;
})(R4);
var O4 = {};
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = c;
  var t = a(P4), n = a(nv), r = a(lu), o = a(Hx), i = a(Gx);
  function a(p) {
    return p && p.__esModule ? p : { default: p };
  }
  function s() {
    return s = Object.assign || function(p) {
      for (var m = 1; m < arguments.length; m++) {
        var v = arguments[m];
        for (var g in v)
          Object.prototype.hasOwnProperty.call(v, g) && (p[g] = v[g]);
      }
      return p;
    }, s.apply(this, arguments);
  }
  function c(p, m) {
    var v = s({}, p), g = l(v, m), b = v.rowSettings, x = v.scrollContentHeight, T = b.rowsCount, S = (0, o.default)(v), _ = S.bodyHeight, w = x - _, k;
    w === 0 ? (g.firstViewportIdx > 0 && (g = l(v, {
      firstOffset: 0,
      lastIndex: T - 1
    })), k = 0) : k = g.firstOffset;
    var E = g.firstViewportIdx, R = g.endViewportIdx;
    d(v, g, p.scrolling);
    var P = 0;
    return T > 0 && (P = v.rowOffsets[g.firstViewportIdx] - k), P = (0, t.default)(P, 0, w), s(v, {
      firstRowIndex: E,
      firstRowOffset: k,
      endRowIndex: R,
      maxScrollY: w,
      scrollY: P
    });
  }
  function l(p, m) {
    var v = (0, n.default)(p), g = v.bufferRowCount, b = v.maxAvailableHeight, x = p.rowSettings.rowsCount;
    if (x === 0)
      return {
        endBufferIdx: 0,
        endViewportIdx: 0,
        firstBufferIdx: 0,
        firstOffset: 0,
        firstViewportIdx: 0
      };
    var T = m.firstIndex, S = m.firstOffset, _ = m.lastIndex;
    (T >= x || _ >= x) && (_ = x - 1);
    var w = 1, k = T, E = S;
    _ !== void 0 && (w = -1, k = _, E = 0);
    for (var R = k, P = R; R < x && R >= 0 && E < b; )
      E += (0, i.default)(p, R), P = R, R += w;
    var A = !1;
    if (E < b && R === x && _ === void 0)
      for (A = !0, R = T - 1; R >= 0 && E < b; )
        E += (0, i.default)(p, R), k = R, --R;
    var D = Math.min(k, P), N = Math.max(D - g, 0);
    for (R = N; R < D; R++)
      (0, i.default)(p, R);
    var F = Math.max(k, P) + 1, $ = Math.min(F + g, x);
    for (R = F; R < $; R++)
      (0, i.default)(p, R);
    var I = (0, r.default)(p), j = I.availableHeight;
    if (_ !== void 0 || A) {
      S = S + Math.min(j - E, 0);
      var U = p.storedHeights;
      -1 * S >= U[D] && (D += 1, S += U[D]);
    }
    return {
      endBufferIdx: $,
      endViewportIdx: F,
      firstBufferIdx: N,
      firstOffset: S,
      firstViewportIdx: D
    };
  }
  function d(p, m, v) {
    var g = p.rowBufferSet, b = p.rowOffsetIntervalTree, x = p.storedHeights, T = m.endBufferIdx, S = m.endViewportIdx, _ = m.firstBufferIdx, w = m.firstViewportIdx, k = T - _;
    if (k === 0) {
      p.rowOffsets = {}, p.rows = [];
      return;
    }
    for (var E = v ? w : _, R = v ? S : T, P = [], A = {}, D = b.sumUntil(E), N = E; N < R; N++) {
      A[N] = D, D += x[N];
      var F = f(N, g, E, R, k);
      P[F] = N;
    }
    p.rows = P, p.rowOffsets = A;
  }
  function f(p, m, v, g, b) {
    var x = m.getValuePosition(p);
    return x === null && m.getSize() >= b && (x = m.replaceFurthestValuePosition(
      v,
      g - 1,
      // replaceFurthestValuePosition uses closed interval from startRange to endRange
      p
    )), x === null && (x = m.getNewPositionForValue(p)), x;
  }
})(O4);
var sv = {}, N4 = {};
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var t = {
    BACKSPACE: 8,
    TAB: 9,
    RETURN: 13,
    ALT: 18,
    ESC: 27,
    SPACE: 32,
    PAGE_UP: 33,
    PAGE_DOWN: 34,
    END: 35,
    HOME: 36,
    LEFT: 37,
    UP: 38,
    RIGHT: 39,
    DOWN: 40,
    DELETE: 46,
    COMMA: 188,
    PERIOD: 190,
    A: 65,
    Z: 90,
    ZERO: 48,
    NUMPAD_0: 96,
    NUMPAD_9: 105
  };
  e.default = t;
})(N4);
var r_ = {
  "--scrollbar-face-active-color": "#7d7d7d",
  "--scrollbar-face-color": "#c2c2c2",
  "--scrollbar-face-margin": "4px",
  "--scrollbar-face-radius": "6px",
  "--scrollbar-size": "15px",
  "--scrollbar-size-large": "17px",
  "--scrollbar-track-color": "#fff",
  "--border-color": "#d3d3d3",
  "--fbui-white": "#fff",
  "--fbui-desktop-background-light": "#f6f7f8"
};
function A4(e) {
  if (r_.hasOwnProperty(e))
    return r_[e];
  throw new Error('cssVar("' + e + '"): Unexpected class transformation.');
}
A4.CSS_VARS = r_;
var jDe = A4;
(function(e) {
  function t(j) {
    "@babel/helpers - typeof";
    return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? t = function(G) {
      return typeof G;
    } : t = function(G) {
      return G && typeof Symbol == "function" && G.constructor === Symbol && G !== Symbol.prototype ? "symbol" : typeof G;
    }, t(j);
  }
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var n = p(et), r = p(_r), o = p(Jr), i = p(Jo), a = p(_s), s = p(N4), c = p(Nx), l = p(ov), d = p(jDe), f = p(If);
  function p(j) {
    return j && j.__esModule ? j : { default: j };
  }
  function m(j, U) {
    if (!(j instanceof U))
      throw new TypeError("Cannot call a class as a function");
  }
  function v(j, U) {
    for (var G = 0; G < U.length; G++) {
      var V = U[G];
      V.enumerable = V.enumerable || !1, V.configurable = !0, "value" in V && (V.writable = !0), Object.defineProperty(j, V.key, V);
    }
  }
  function g(j, U, G) {
    return U && v(j.prototype, U), j;
  }
  function b(j, U) {
    if (typeof U != "function" && U !== null)
      throw new TypeError("Super expression must either be null or a function");
    j.prototype = Object.create(U && U.prototype, { constructor: { value: j, writable: !0, configurable: !0 } }), U && x(j, U);
  }
  function x(j, U) {
    return x = Object.setPrototypeOf || function(V, H) {
      return V.__proto__ = H, V;
    }, x(j, U);
  }
  function T(j) {
    var U = w();
    return function() {
      var V = k(j), H;
      if (U) {
        var q = k(this).constructor;
        H = Reflect.construct(V, arguments, q);
      } else
        H = V.apply(this, arguments);
      return S(this, H);
    };
  }
  function S(j, U) {
    return U && (t(U) === "object" || typeof U == "function") ? U : _(j);
  }
  function _(j) {
    if (j === void 0)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return j;
  }
  function w() {
    if (typeof Reflect == "undefined" || !Reflect.construct || Reflect.construct.sham)
      return !1;
    if (typeof Proxy == "function")
      return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      })), !0;
    } catch (j) {
      return !1;
    }
  }
  function k(j) {
    return k = Object.setPrototypeOf ? Object.getPrototypeOf : function(G) {
      return G.__proto__ || Object.getPrototypeOf(G);
    }, k(j);
  }
  function E(j, U, G) {
    return U in j ? Object.defineProperty(j, U, { value: G, enumerable: !0, configurable: !0, writable: !0 }) : j[U] = G, j;
  }
  var R = {
    position: 0,
    scrollable: !1
  }, P = parseInt((0, d.default)("--scrollbar-face-margin"), 10), A = P * 2, D = 30, N = 40, F = null, $ = /* @__PURE__ */ function(j) {
    b(G, j);
    var U = T(G);
    function G(V) {
      var H;
      return m(this, G), H = U.call(this, V), E(_(H), "_onRefFace", function(q) {
        return H._faceRef = q;
      }), E(_(H), "_onRefRoot", function(q) {
        return H._rootRef = q;
      }), E(_(H), "scrollBy", function(q) {
        H._onWheel(q);
      }), E(_(H), "_shouldHandleX", function(q) {
        return (
          /*boolean*/
          H.props.orientation === "horizontal" ? H._shouldHandleChange(q) : !1
        );
      }), E(_(H), "_shouldHandleY", function(q) {
        return (
          /*boolean*/
          H.props.orientation !== "horizontal" ? H._shouldHandleChange(q) : !1
        );
      }), E(_(H), "_shouldHandleChange", function(q) {
        var Q = H._calculateState(H.state.position + q, H.props.size, H.props.contentSize, H.props.orientation);
        return Q.position !== H.state.position;
      }), E(_(H), "_calculateState", function(q, Q, X, K) {
        var J = Math.max(1, Q);
        if (X <= J)
          return R;
        var ne = "".concat(q, "_").concat(J, "_").concat(X, "_").concat(K);
        if (H._stateKey === ne)
          return H._stateForKey;
        var ae = K === "horizontal", te = J / X, le = J * te;
        le < D && (te = (J - D) / (X - J), le = D);
        var ce = !0, fe = X - J;
        q < 0 ? q = 0 : q > fe && (q = fe);
        var ee = H._mouseMoveTracker ? H._mouseMoveTracker.isDragging() : !1, me = {
          faceSize: le,
          isDragging: ee,
          isHorizontal: ae,
          position: q,
          scale: te,
          scrollable: ce
        };
        return H._stateKey = ne, H._stateForKey = me, me;
      }), E(_(H), "_onWheelY", function(q, Q) {
        H._onWheel(Q);
      }), E(_(H), "_onWheelX", function(q, Q) {
        H._onWheel(q);
      }), E(_(H), "_onWheel", function(q) {
        var Q = H.props;
        H._setNextState(H._calculateState(H.state.position + q, Q.size, Q.contentSize, Q.orientation));
      }), E(_(H), "_onMouseDown", function(q) {
        var Q;
        if (q.target !== H._faceRef) {
          var X = q.nativeEvent, K = H.state.isHorizontal ? X.offsetX || X.layerX || H.getTouchX(X) : X.offsetY || X.layerY || H.getTouchY(X), J = H.props;
          K /= H.state.scale, Q = H._calculateState(K - H.state.faceSize * 0.5 / H.state.scale, J.size, J.contentSize, J.orientation);
        } else
          Q = {};
        Q.focused = !0, H._setNextState(Q), H._mouseMoveTracker.captureMouseMoves(q), H._rootRef.focus();
      }), E(_(H), "_onTouchCancel", function(q) {
        q.stopPropagation();
      }), E(_(H), "_onTouchEnd", function(q) {
        q.stopPropagation();
      }), E(_(H), "_onTouchMove", function(q) {
        q.stopPropagation();
      }), E(_(H), "_onTouchStart", function(q) {
        q.stopPropagation(), H._onMouseDown(q);
      }), E(_(H), "_onMouseMove", function(q, Q) {
        var X = H.props, K = H.state.isHorizontal ? q * (H.props.isRTL ? -1 : 1) : Q;
        K /= H.state.scale;
        var J = r.default.flushSync || function(ne) {
          return ne();
        };
        J(function() {
          return H._setNextState(H._calculateState(H.state.position + K, X.size, X.contentSize, X.orientation));
        });
      }), E(_(H), "_onMouseMoveEnd", function() {
        H._nextState = null, H._mouseMoveTracker.releaseMouseMoves(), H.setState({
          isDragging: !1
        });
      }), E(_(H), "_onKeyDown", function(q) {
        var Q = q.keyCode;
        if (Q !== s.default.TAB) {
          var X = N, K = 0;
          if (H.state.isHorizontal)
            switch (Q) {
              case s.default.HOME:
                K = -1, X = H.props.contentSize;
                break;
              case s.default.LEFT:
                K = -1;
                break;
              case s.default.RIGHT:
                K = 1;
                break;
              default:
                return;
            }
          if (!H.state.isHorizontal)
            switch (Q) {
              case s.default.SPACE:
                q.shiftKey ? K = -1 : K = 1;
                break;
              case s.default.HOME:
                K = -1, X = H.props.contentSize;
                break;
              case s.default.UP:
                K = -1;
                break;
              case s.default.DOWN:
                K = 1;
                break;
              case s.default.PAGE_UP:
                K = -1, X = H.props.size;
                break;
              case s.default.PAGE_DOWN:
                K = 1, X = H.props.size;
                break;
              default:
                return;
            }
          q.preventDefault();
          var J = H.props;
          H._setNextState(H._calculateState(H.state.position + X * K, J.size, J.contentSize, J.orientation));
        }
      }), E(_(H), "_onFocus", function() {
        H.setState({
          focused: !0
        });
      }), E(_(H), "_onBlur", function() {
        H.setState({
          focused: !1
        });
      }), E(_(H), "_blur", function() {
        var q = r.default.findDOMNode(_(H));
        if (q)
          try {
            H._onBlur(), q.blur();
          } catch (Q) {
          }
      }), E(_(H), "getTouchX", function(q) {
        return Math.round(q.targetTouches[0].clientX - q.target.getBoundingClientRect().x);
      }), E(_(H), "getTouchY", function(q) {
        return Math.round(q.targetTouches[0].clientY - q.target.getBoundingClientRect().y);
      }), E(_(H), "_setNextState", function(q, Q) {
        Q = Q || H.props;
        var X = Q.position, K = H.state.position !== q.position;
        if (X === void 0) {
          var J = K ? H._didScroll : void 0;
          H.setState(q, J);
        } else if (X === q.position)
          H.setState(q);
        else {
          q.position !== void 0 && q.position !== H.state.position && H.props.onScroll(q.position);
          return;
        }
        K && F !== _(H) && (F && F._blur(), F = _(H));
      }), E(_(H), "_didScroll", function() {
        H.props.onScroll(H.state.position);
      }), H.state = H._calculateState(V.position || V.defaultPosition || 0, V.size, V.contentSize, V.orientation), H._initialRender = !0, H;
    }
    return g(G, [{
      key: "componentDidUpdate",
      value: function() {
        var H = this.props.position;
        H === void 0 ? this._setNextState(this._calculateState(this.state.position, this.props.size, this.props.contentSize, this.props.orientation)) : this._setNextState(this._calculateState(H, this.props.size, this.props.contentSize, this.props.orientation), this.props);
      }
    }, {
      key: "render",
      value: function() {
        if (!this.state.scrollable)
          return null;
        var H = this.props.size, q, Q, X = this.state.isHorizontal, K = !X, J = this.state.focused || this.state.isDragging, ne = this.state.faceSize, ae = this.props.isOpaque, te = this.props.verticalTop || 0, le = (0, i.default)({
          "ScrollbarLayout/main": !0,
          "ScrollbarLayout/mainVertical": K,
          "ScrollbarLayout/mainHorizontal": X,
          "public/Scrollbar/main": !0,
          "public/Scrollbar/mainOpaque": ae,
          "public/Scrollbar/mainActive": J
        }), ce = (0, i.default)({
          "ScrollbarLayout/face": !0,
          "ScrollbarLayout/faceHorizontal": X,
          "ScrollbarLayout/faceVertical": K,
          "public/Scrollbar/faceActive": J,
          "public/Scrollbar/face": !0
        }), fe = this.state.position * this.state.scale + P;
        return X ? (q = {
          width: H
        }, Q = {
          width: ne - A,
          top: 0,
          bottom: 0
        }, (0, f.default)(Q, fe, 0, this._initialRender, this.props.isRTL)) : (q = {
          top: te,
          height: H
        }, this.props.isRTL && (q.left = q.right || 0, q.right = "auto"), Q = {
          height: ne - A
        }, (0, f.default)(Q, 0, fe, this._initialRender, this.props.isRTL), Q.left = 0, Q.right = 0), q.touchAction = "none", q.zIndex = this.props.zIndex, this.props.trackColor === "gray" && (q.backgroundColor = (0, d.default)("--fbui-desktop-background-light")), /* @__PURE__ */ n.default.createElement("div", {
          onFocus: this._onFocus,
          onBlur: this._onBlur,
          onKeyDown: this._onKeyDown,
          onMouseDown: this._onMouseDown,
          onTouchCancel: this._onTouchCancel,
          onTouchEnd: this._onTouchEnd,
          onTouchMove: this._onTouchMove,
          onTouchStart: this._onTouchStart,
          className: le,
          style: q,
          ref: this._onRefRoot
        }, /* @__PURE__ */ n.default.createElement("div", {
          ref: this._onRefFace,
          className: ce,
          style: Q
        }));
      }
    }, {
      key: "componentDidMount",
      value: function() {
        var H = this.props.orientation === "horizontal", q = H ? this._onWheelX : this._onWheelY;
        this._wheelHandler = new c.default(
          q,
          this._shouldHandleX,
          // Should handle horizontal scroll
          this._shouldHandleY,
          // Should handle vertical scroll
          this.props.isRTL
        ), this._rootRef && this._rootRef.addEventListener("wheel", this._wheelHandler.onWheel, {
          passive: !1
        }), this._mouseMoveTracker = new l.default(this._onMouseMove, this._onMouseMoveEnd, document.documentElement, this.props.touchEnabled), this.props.position !== void 0 && this.state.position !== this.props.position && this._didScroll(), this._initialRender = !1;
      }
    }, {
      key: "componentWillUnmount",
      value: function() {
        this._rootRef && this._rootRef.removeEventListener("wheel", this._wheelHandler.onWheel, {
          passive: !1
        }), this._nextState = null, this._mouseMoveTracker && (this._mouseMoveTracker.releaseMouseMoves(), this._mouseMoveTracker = null), F === this && (F = null);
      }
    }]), G;
  }(n.default.PureComponent);
  E($, "propTypes", {
    contentSize: o.default.number.isRequired,
    defaultPosition: o.default.number,
    isOpaque: o.default.bool,
    orientation: o.default.oneOf(["vertical", "horizontal"]),
    onScroll: o.default.func,
    position: o.default.number,
    size: o.default.number.isRequired,
    trackColor: o.default.oneOf(["gray"]),
    touchEnabled: o.default.bool,
    zIndex: o.default.number,
    verticalTop: o.default.number,
    isRTL: o.default.bool
  }), E(
    $,
    "defaultProps",
    /*object*/
    {
      defaultPosition: 0,
      isOpaque: !1,
      onScroll: a.default,
      orientation: "vertical",
      zIndex: 99
    }
  ), $.KEYBOARD_SCROLL_AMOUNT = N, $.SIZE = parseInt((0, d.default)("--scrollbar-size"), 10), $.OFFSET = 1;
  var I = $;
  e.default = I;
})(sv);
(function(e) {
  function t(w) {
    "@babel/helpers - typeof";
    return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? t = function(E) {
      return typeof E;
    } : t = function(E) {
      return E && typeof Symbol == "function" && E.constructor === Symbol && E !== Symbol.prototype ? "symbol" : typeof E;
    }, t(w);
  }
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var n = v(Ox), r = v(x4), o = v(S4), i = v(Df), a = v(T4), s = m(en), c = av, l = v(R4), d = v(O4), f = v(sv);
  function p(w) {
    if (typeof WeakMap != "function")
      return null;
    var k = /* @__PURE__ */ new WeakMap(), E = /* @__PURE__ */ new WeakMap();
    return (p = function(P) {
      return P ? E : k;
    })(w);
  }
  function m(w, k) {
    if (w && w.__esModule)
      return w;
    if (w === null || t(w) !== "object" && typeof w != "function")
      return { default: w };
    var E = p(k);
    if (E && E.has(w))
      return E.get(w);
    var R = {}, P = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var A in w)
      if (A !== "default" && Object.prototype.hasOwnProperty.call(w, A)) {
        var D = P ? Object.getOwnPropertyDescriptor(w, A) : null;
        D && (D.get || D.set) ? Object.defineProperty(R, A, D) : R[A] = w[A];
      }
    return R.default = w, E && E.set(w, R), R;
  }
  function v(w) {
    return w && w.__esModule ? w : { default: w };
  }
  function g() {
    return g = Object.assign || function(w) {
      for (var k = 1; k < arguments.length; k++) {
        var E = arguments[k];
        for (var R in E)
          Object.prototype.hasOwnProperty.call(E, R) && (w[R] = E[R]);
      }
      return w;
    }, g.apply(this, arguments);
  }
  function b() {
    return {
      /*
       * Input state set from props
       */
      columnProps: [],
      columnGroupProps: [],
      elementTemplates: {
        cell: [],
        footer: [],
        groupHeader: [],
        header: []
      },
      elementHeights: {
        footerHeight: 0,
        groupHeaderHeight: 0,
        headerHeight: 0
      },
      propsRevision: null,
      rowSettings: {
        bufferRowCount: void 0,
        rowAttributesGetter: void 0,
        rowHeight: 0,
        rowHeightGetter: function() {
          return 0;
        },
        rowsCount: 0,
        subRowHeight: 0,
        subRowHeightGetter: function() {
          return 0;
        }
      },
      scrollFlags: {
        overflowX: "auto",
        overflowY: "auto",
        showScrollbarX: !0,
        showScrollbarY: !0
      },
      tableSize: {
        height: void 0,
        maxHeight: 0,
        ownerHeight: void 0,
        useMaxHeight: !1,
        width: 0
      },
      /*
       * Output state passed as props to the the rendered FixedDataTable
       * NOTE (jordan) rows may contain undefineds if we don't need all the buffer positions
       */
      columnReorderingData: {},
      columnResizingData: {},
      firstRowIndex: 0,
      firstRowOffset: 0,
      isColumnReordering: !1,
      isColumnResizing: !1,
      maxScrollX: 0,
      maxScrollY: 0,
      rowOffsets: {},
      rows: [],
      // rowsToRender
      scrollContentHeight: 0,
      scrollX: 0,
      scrollbarXHeight: f.default.SIZE,
      scrollY: 0,
      scrollbarYWidth: f.default.SIZE,
      scrolling: !1,
      /*
       * Internal state only used by this file
       * NOTE (jordan) internal state is altered in place
       * so don't trust it for redux history or immutability checks
       * TODO (jordan) investigate if we want to move this to local or scoped state
       */
      rowBufferSet: new r.default(),
      storedHeights: [],
      rowOffsetIntervalTree: null
      // PrefixIntervalTree
    };
  }
  function x() {
    var w = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : b(), k = arguments.length > 1 ? arguments[1] : void 0;
    switch (k.type) {
      case s.INITIALIZE: {
        var E = k.props, R = S(w, E);
        R = T(R);
        var P = (0, c.getScrollAnchor)(R, E);
        return R = (0, d.default)(R, P), l.default.initialize(R, E, {});
      }
      case s.PROP_CHANGE: {
        var A = k.newProps, D = k.oldProps, N = S(w, A);
        (D.rowsCount !== A.rowsCount || D.rowHeight !== A.rowHeight || D.subRowHeight !== A.subRowHeight) && (N = T(N)), D.rowsCount !== A.rowsCount && (N.rowBufferSet = new r.default());
        var F = (0, c.getScrollAnchor)(N, A, D);
        return (!(0, i.default)(w, N) || F.changed) && (N = (0, d.default)(N, F)), N = l.default.initialize(N, A, D), (N.scrollX !== w.scrollX || N.scrollY !== w.scrollY) && (N.scrolling = N.scrolling || !0), N;
      }
      case s.SCROLL_END: {
        var $ = g({}, w, {
          scrolling: !1
        }), I = {
          firstIndex: w.firstRowIndex,
          firstOffset: w.firstRowOffset,
          lastIndex: w.lastIndex
        };
        return (0, d.default)($, I);
      }
      case s.SCROLL_TO_Y: {
        var j = k.scrollY, U = g({}, w, {
          scrolling: !0
        }), G = (0, c.scrollTo)(U, j);
        return (0, d.default)(U, G);
      }
      case s.COLUMN_RESIZE: {
        var V = k.resizeData;
        return l.default.resizeColumn(w, V);
      }
      case s.COLUMN_REORDER_START: {
        var H = k.reorderData;
        return l.default.reorderColumn(w, H);
      }
      case s.COLUMN_REORDER_END:
        return g({}, w, {
          isColumnReordering: !1,
          columnReorderingData: {}
        });
      case s.COLUMN_REORDER_MOVE: {
        var q = k.deltaX;
        return l.default.reorderColumnMove(w, q);
      }
      case s.SCROLL_TO_X: {
        var Q = k.scrollX;
        return g({}, w, {
          scrolling: !0,
          scrollX: Q
        });
      }
      default:
        return w;
    }
  }
  function T(w) {
    for (var k = w.rowSettings, E = k.rowHeight, R = k.rowsCount, P = k.subRowHeight, A = E + P, D = o.default.uniform(R, A), N = R * A, F = new Array(R), $ = 0; $ < R; $++)
      F[$] = A;
    return g({}, w, {
      rowOffsetIntervalTree: D,
      scrollContentHeight: N,
      storedHeights: F
    });
  }
  function S(w, k) {
    var E = (0, a.default)(k.children), R = E.columnGroupProps, P = E.columnProps, A = E.elementTemplates, D = E.useGroupHeader, N = g({}, w, {
      columnGroupProps: R,
      columnProps: P,
      elementTemplates: A,
      propsRevision: w.propsRevision + 1
    });
    N.elementHeights = g({}, N.elementHeights, (0, n.default)(k, ["cellGroupWrapperHeight", "footerHeight", "groupHeaderHeight", "headerHeight"])), D || (N.elementHeights.groupHeaderHeight = 0), N.rowSettings = g({}, N.rowSettings, (0, n.default)(k, ["bufferRowCount", "rowHeight", "rowsCount", "subRowHeight"]));
    var F = N.rowSettings, $ = F.rowHeight, I = F.subRowHeight;
    return N.rowSettings.rowHeightGetter = k.rowHeightGetter || function() {
      return $;
    }, N.rowSettings.subRowHeightGetter = k.subRowHeightGetter || function() {
      return I || 0;
    }, N.rowSettings.rowAttributesGetter = k.rowAttributesGetter, N.scrollFlags = g({}, N.scrollFlags, (0, n.default)(k, ["overflowX", "overflowY", "showScrollbarX", "showScrollbarY"])), N.tableSize = g({}, N.tableSize, (0, n.default)(k, ["height", "maxHeight", "ownerHeight", "width"])), N.tableSize.useMaxHeight = N.tableSize.height === void 0, N.scrollbarXHeight = k.scrollbarXHeight, N.scrollbarYWidth = k.scrollbarYWidth, N;
  }
  var _ = x;
  e.default = _;
})(w4);
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var t = xL, n = r(w4);
  function r(i) {
    return i && i.__esModule ? i : { default: i };
  }
  var o = {
    get: function() {
      return (0, t.createStore)(n.default);
    }
  };
  e.default = o;
})(_4);
var D4 = {}, WDe = YL, VDe = JL, UDe = Kg, qDe = bo, GDe = tv, YDe = Dx, ZDe = GL, XDe = Ix, KDe = "[object Map]", JDe = "[object Set]", QDe = Object.prototype, eIe = QDe.hasOwnProperty;
function tIe(e) {
  if (e == null)
    return !0;
  if (GDe(e) && (qDe(e) || typeof e == "string" || typeof e.splice == "function" || YDe(e) || XDe(e) || UDe(e)))
    return !e.length;
  var t = VDe(e);
  if (t == KDe || t == JDe)
    return !e.size;
  if (ZDe(e))
    return !WDe(e).length;
  for (var n in e)
    if (eIe.call(e, n))
      return !1;
  return !0;
}
var nIe = tIe;
(function(e) {
  function t(R) {
    "@babel/helpers - typeof";
    return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? t = function(A) {
      return typeof A;
    } : t = function(A) {
      return A && typeof Symbol == "function" && A.constructor === Symbol && A !== Symbol.prototype ? "symbol" : typeof A;
    }, t(R);
  }
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var n = c(et), r = c(Jr), o = c(nIe), i = c(Jo), a = c(ys), s = c(sv);
  function c(R) {
    return R && R.__esModule ? R : { default: R };
  }
  function l() {
    return l = Object.assign || function(R) {
      for (var P = 1; P < arguments.length; P++) {
        var A = arguments[P];
        for (var D in A)
          Object.prototype.hasOwnProperty.call(A, D) && (R[D] = A[D]);
      }
      return R;
    }, l.apply(this, arguments);
  }
  function d(R, P) {
    if (!(R instanceof P))
      throw new TypeError("Cannot call a class as a function");
  }
  function f(R, P) {
    for (var A = 0; A < P.length; A++) {
      var D = P[A];
      D.enumerable = D.enumerable || !1, D.configurable = !0, "value" in D && (D.writable = !0), Object.defineProperty(R, D.key, D);
    }
  }
  function p(R, P, A) {
    return P && f(R.prototype, P), R;
  }
  function m(R, P) {
    if (typeof P != "function" && P !== null)
      throw new TypeError("Super expression must either be null or a function");
    R.prototype = Object.create(P && P.prototype, { constructor: { value: R, writable: !0, configurable: !0 } }), P && v(R, P);
  }
  function v(R, P) {
    return v = Object.setPrototypeOf || function(D, N) {
      return D.__proto__ = N, D;
    }, v(R, P);
  }
  function g(R) {
    var P = T();
    return function() {
      var D = S(R), N;
      if (P) {
        var F = S(this).constructor;
        N = Reflect.construct(D, arguments, F);
      } else
        N = D.apply(this, arguments);
      return b(this, N);
    };
  }
  function b(R, P) {
    return P && (t(P) === "object" || typeof P == "function") ? P : x(R);
  }
  function x(R) {
    if (R === void 0)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return R;
  }
  function T() {
    if (typeof Reflect == "undefined" || !Reflect.construct || Reflect.construct.sham)
      return !1;
    if (typeof Proxy == "function")
      return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      })), !0;
    } catch (R) {
      return !1;
    }
  }
  function S(R) {
    return S = Object.setPrototypeOf ? Object.getPrototypeOf : function(A) {
      return A.__proto__ || Object.getPrototypeOf(A);
    }, S(R);
  }
  function _(R, P, A) {
    return P in R ? Object.defineProperty(R, P, { value: A, enumerable: !0, configurable: !0, writable: !0 }) : R[P] = A, R;
  }
  var w = /* @__PURE__ */ function(R) {
    m(A, R);
    var P = g(A);
    function A() {
      var D;
      d(this, A);
      for (var N = arguments.length, F = new Array(N), $ = 0; $ < N; $++)
        F[$] = arguments[$];
      return D = P.call.apply(P, [this].concat(F)), _(x(D), "state", {}), _(x(D), "_onScrollBarsUpdate", function(I) {
        D.setState(I);
      }), _(x(D), "_onVerticalScroll", function(I) {
        D.state.scrollToY !== void 0 && D.state.scrollToY(I);
      }), _(x(D), "_onHorizontalScroll", function(I) {
        D.state.scrollToX !== void 0 && D.state.scrollToX(I);
      }), D;
    }
    return p(A, [{
      key: "render",
      value: function() {
        var N = !(0, o.default)(this.state) && /* @__PURE__ */ n.default.createElement(s.default, {
          size: this.state.viewportHeight,
          contentSize: this.state.contentHeight,
          onScroll: this._onVerticalScroll,
          verticalTop: this.state.scrollbarYOffsetTop,
          position: this.state.scrollY,
          touchEnabled: this.props.touchScrollEnabled,
          isRTL: this.props.isRTL
        }), F = !(0, o.default)(this.state) && /* @__PURE__ */ n.default.createElement(k, {
          contentSize: this.state.contentWidth,
          offset: this.state.scrollbarXOffsetTop,
          onScroll: this._onHorizontalScroll,
          position: this.state.scrollX,
          size: this.state.viewportWidth,
          touchEnabled: this.props.touchScrollEnabled,
          isRTL: this.props.isRTL
        });
        return /* @__PURE__ */ n.default.cloneElement(this.props.children, {
          onScrollBarsUpdate: this._onScrollBarsUpdate,
          scrollbarX: F,
          scrollbarY: N
        });
      }
    }]), A;
  }(n.default.Component), k = /* @__PURE__ */ function(R) {
    m(A, R);
    var P = g(A);
    function A() {
      return d(this, A), P.apply(this, arguments);
    }
    return p(A, [{
      key: "render",
      value: function() {
        var N = this.props, F = N.offset, $ = N.size, I = {
          height: s.default.SIZE,
          width: $
        }, j = {
          height: s.default.SIZE,
          overflow: "hidden",
          width: $,
          top: F
        };
        return /* @__PURE__ */ n.default.createElement("div", {
          className: (0, a.default)((0, i.default)("public/fixedDataTable/horizontalScrollbar")),
          style: I
        }, /* @__PURE__ */ n.default.createElement("div", {
          style: j
        }, /* @__PURE__ */ n.default.createElement(s.default, l({}, this.props, {
          isOpaque: !0,
          orientation: "horizontal",
          offset: void 0
        }))));
      }
    }]), A;
  }(n.default.PureComponent);
  _(k, "propTypes", {
    contentSize: r.default.number.isRequired,
    offset: r.default.number.isRequired,
    onScroll: r.default.func.isRequired,
    position: r.default.number.isRequired,
    size: r.default.number.isRequired,
    isRTL: r.default.bool
  });
  var E = w;
  e.default = E;
})(D4);
(function(e) {
  function t(I) {
    "@babel/helpers - typeof";
    return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? t = function(U) {
      return typeof U;
    } : t = function(U) {
      return U && typeof Symbol == "function" && U.constructor === Symbol && U !== Symbol.prototype ? "symbol" : typeof U;
    }, t(I);
  }
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var n = b(et), r = xL, o = b(Qc), i = b(Ox), a = g(en), s = g(ki), c = g(Mi), l = b(IL), d = b(_4), f = b(sv), p = b(D4), m = g4;
  function v(I) {
    if (typeof WeakMap != "function")
      return null;
    var j = /* @__PURE__ */ new WeakMap(), U = /* @__PURE__ */ new WeakMap();
    return (v = function(V) {
      return V ? U : j;
    })(I);
  }
  function g(I, j) {
    if (I && I.__esModule)
      return I;
    if (I === null || t(I) !== "object" && typeof I != "function")
      return { default: I };
    var U = v(j);
    if (U && U.has(I))
      return U.get(I);
    var G = {}, V = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var H in I)
      if (H !== "default" && Object.prototype.hasOwnProperty.call(I, H)) {
        var q = V ? Object.getOwnPropertyDescriptor(I, H) : null;
        q && (q.get || q.set) ? Object.defineProperty(G, H, q) : G[H] = I[H];
      }
    return G.default = I, U && U.set(I, G), G;
  }
  function b(I) {
    return I && I.__esModule ? I : { default: I };
  }
  function x() {
    return x = Object.assign || function(I) {
      for (var j = 1; j < arguments.length; j++) {
        var U = arguments[j];
        for (var G in U)
          Object.prototype.hasOwnProperty.call(U, G) && (I[G] = U[G]);
      }
      return I;
    }, x.apply(this, arguments);
  }
  function T(I, j) {
    if (!(I instanceof j))
      throw new TypeError("Cannot call a class as a function");
  }
  function S(I, j) {
    for (var U = 0; U < j.length; U++) {
      var G = j[U];
      G.enumerable = G.enumerable || !1, G.configurable = !0, "value" in G && (G.writable = !0), Object.defineProperty(I, G.key, G);
    }
  }
  function _(I, j, U) {
    return j && S(I.prototype, j), U && S(I, U), I;
  }
  function w(I, j) {
    if (typeof j != "function" && j !== null)
      throw new TypeError("Super expression must either be null or a function");
    I.prototype = Object.create(j && j.prototype, { constructor: { value: I, writable: !0, configurable: !0 } }), j && k(I, j);
  }
  function k(I, j) {
    return k = Object.setPrototypeOf || function(G, V) {
      return G.__proto__ = V, G;
    }, k(I, j);
  }
  function E(I) {
    var j = A();
    return function() {
      var G = D(I), V;
      if (j) {
        var H = D(this).constructor;
        V = Reflect.construct(G, arguments, H);
      } else
        V = G.apply(this, arguments);
      return R(this, V);
    };
  }
  function R(I, j) {
    return j && (t(j) === "object" || typeof j == "function") ? j : P(I);
  }
  function P(I) {
    if (I === void 0)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return I;
  }
  function A() {
    if (typeof Reflect == "undefined" || !Reflect.construct || Reflect.construct.sham)
      return !1;
    if (typeof Proxy == "function")
      return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      })), !0;
    } catch (I) {
      return !1;
    }
  }
  function D(I) {
    return D = Object.setPrototypeOf ? Object.getPrototypeOf : function(U) {
      return U.__proto__ || Object.getPrototypeOf(U);
    }, D(I);
  }
  function N(I, j, U) {
    return j in I ? Object.defineProperty(I, j, { value: U, enumerable: !0, configurable: !0, writable: !0 }) : I[j] = U, I;
  }
  var F = /* @__PURE__ */ function(I) {
    w(U, I);
    var j = E(U);
    function U(G) {
      var V;
      return T(this, U), V = j.call(this, G), V.reduxStore = d.default.get(), V.scrollActions = (0, r.bindActionCreators)(c, V.reduxStore.dispatch), V.columnActions = (0, r.bindActionCreators)(s, V.reduxStore.dispatch), V.reduxStore.dispatch({
        type: a.INITIALIZE,
        props: G
      }), V.unsubscribe = V.reduxStore.subscribe(V.onStoreUpdate.bind(P(V))), V.state = {
        boundState: U.getBoundState(V.reduxStore),
        // the state from the redux store
        reduxStore: V.reduxStore,
        // put store instance in local state so that getDerivedStateFromProps can access it
        props: G
        // put props in local state so that getDerivedStateFromProps can access it
      }, V;
    }
    return _(U, [{
      key: "componentWillUnmount",
      value: function() {
        this.unsubscribe && (this.unsubscribe(), this.unsubscribe = null), this.reduxStore = null;
      }
    }, {
      key: "render",
      value: function() {
        var V = /* @__PURE__ */ n.default.createElement(l.default, x({}, this.props, this.state.boundState, {
          scrollActions: this.scrollActions,
          columnActions: this.columnActions
        }));
        return this.props.defaultScrollbars ? /* @__PURE__ */ n.default.createElement(p.default, this.props, V) : V;
      }
    }, {
      key: "onStoreUpdate",
      value: function() {
        var V = U.getBoundState(this.reduxStore);
        this.state.boundState.propsRevision === V.propsRevision && this.setState({
          boundState: V
        });
      }
    }], [{
      key: "getDerivedStateFromProps",
      value: function(V, H) {
        return (0, o.default)(V.height !== void 0 || V.maxHeight !== void 0, "You must set either a height or a maxHeight"), V === H.props ? null : (H.reduxStore.dispatch({
          type: a.PROP_CHANGE,
          newProps: V,
          oldProps: H.props
        }), {
          boundState: U.getBoundState(H.reduxStore),
          props: V
        });
      }
    }, {
      key: "getBoundState",
      value: function(V) {
        var H = V.getState(), q = (0, i.default)(H, ["columnGroupProps", "columnProps", "columnReorderingData", "columnResizingData", "elementHeights", "elementTemplates", "firstRowIndex", "endRowIndex", "isColumnReordering", "isColumnResizing", "maxScrollX", "maxScrollY", "propsRevision", "rows", "rowOffsets", "rowSettings", "scrollContentHeight", "scrollFlags", "scrollX", "scrollY", "scrolling", "scrollJumpedX", "scrollJumpedY", "tableSize"]);
        return q;
      }
    }]), U;
  }(n.default.Component);
  N(F, "defaultProps", {
    defaultScrollbars: !0,
    scrollbarXHeight: f.default.SIZE,
    scrollbarYWidth: f.default.SIZE
  });
  var $ = (0, m.polyfill)(F);
  e.default = $;
})(yL);
var I4 = {};
(function(e) {
  function t(P) {
    "@babel/helpers - typeof";
    return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? t = function(D) {
      return typeof D;
    } : t = function(D) {
      return D && typeof Symbol == "function" && D.constructor === Symbol && D !== Symbol.prototype ? "symbol" : typeof D;
    }, t(P);
  }
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var n = a(et), r = a(Jr), o = a(Jo), i = a(ys);
  function a(P) {
    return P && P.__esModule ? P : { default: P };
  }
  function s() {
    return s = Object.assign || function(P) {
      for (var A = 1; A < arguments.length; A++) {
        var D = arguments[A];
        for (var N in D)
          Object.prototype.hasOwnProperty.call(D, N) && (P[N] = D[N]);
      }
      return P;
    }, s.apply(this, arguments);
  }
  function c(P, A) {
    var D = Object.keys(P);
    if (Object.getOwnPropertySymbols) {
      var N = Object.getOwnPropertySymbols(P);
      A && (N = N.filter(function(F) {
        return Object.getOwnPropertyDescriptor(P, F).enumerable;
      })), D.push.apply(D, N);
    }
    return D;
  }
  function l(P) {
    for (var A = 1; A < arguments.length; A++) {
      var D = arguments[A] != null ? arguments[A] : {};
      A % 2 ? c(Object(D), !0).forEach(function(N) {
        k(P, N, D[N]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(P, Object.getOwnPropertyDescriptors(D)) : c(Object(D)).forEach(function(N) {
        Object.defineProperty(P, N, Object.getOwnPropertyDescriptor(D, N));
      });
    }
    return P;
  }
  function d(P, A) {
    if (P == null)
      return {};
    var D = f(P, A), N, F;
    if (Object.getOwnPropertySymbols) {
      var $ = Object.getOwnPropertySymbols(P);
      for (F = 0; F < $.length; F++)
        N = $[F], !(A.indexOf(N) >= 0) && Object.prototype.propertyIsEnumerable.call(P, N) && (D[N] = P[N]);
    }
    return D;
  }
  function f(P, A) {
    if (P == null)
      return {};
    var D = {}, N = Object.keys(P), F, $;
    for ($ = 0; $ < N.length; $++)
      F = N[$], !(A.indexOf(F) >= 0) && (D[F] = P[F]);
    return D;
  }
  function p(P, A) {
    if (!(P instanceof A))
      throw new TypeError("Cannot call a class as a function");
  }
  function m(P, A) {
    for (var D = 0; D < A.length; D++) {
      var N = A[D];
      N.enumerable = N.enumerable || !1, N.configurable = !0, "value" in N && (N.writable = !0), Object.defineProperty(P, N.key, N);
    }
  }
  function v(P, A, D) {
    return A && m(P.prototype, A), P;
  }
  function g(P, A) {
    if (typeof A != "function" && A !== null)
      throw new TypeError("Super expression must either be null or a function");
    P.prototype = Object.create(A && A.prototype, { constructor: { value: P, writable: !0, configurable: !0 } }), A && b(P, A);
  }
  function b(P, A) {
    return b = Object.setPrototypeOf || function(N, F) {
      return N.__proto__ = F, N;
    }, b(P, A);
  }
  function x(P) {
    var A = _();
    return function() {
      var N = w(P), F;
      if (A) {
        var $ = w(this).constructor;
        F = Reflect.construct(N, arguments, $);
      } else
        F = N.apply(this, arguments);
      return T(this, F);
    };
  }
  function T(P, A) {
    return A && (t(A) === "object" || typeof A == "function") ? A : S(P);
  }
  function S(P) {
    if (P === void 0)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return P;
  }
  function _() {
    if (typeof Reflect == "undefined" || !Reflect.construct || Reflect.construct.sham)
      return !1;
    if (typeof Proxy == "function")
      return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      })), !0;
    } catch (P) {
      return !1;
    }
  }
  function w(P) {
    return w = Object.setPrototypeOf ? Object.getPrototypeOf : function(D) {
      return D.__proto__ || Object.getPrototypeOf(D);
    }, w(P);
  }
  function k(P, A, D) {
    return A in P ? Object.defineProperty(P, A, { value: D, enumerable: !0, configurable: !0, writable: !0 }) : P[A] = D, P;
  }
  var E = /* @__PURE__ */ function(P) {
    g(D, P);
    var A = x(D);
    function D() {
      return p(this, D), A.apply(this, arguments);
    }
    return v(D, [{
      key: "render",
      value: function() {
        var F = this.props, $ = F.height, I = F.width, j = F.style, U = F.className, G = F.children, V = d(F, ["height", "width", "isVisible", "style", "className", "children", "columnKey", "rowIndex"]), H = l({
          height: $,
          width: I
        }, j);
        return /* @__PURE__ */ n.default.createElement("div", s({}, V, {
          className: (0, i.default)((0, o.default)("fixedDataTableCellLayout/wrap"), (0, o.default)("public/fixedDataTableCell/wrap"), (0, o.default)("public/fixedDataTableCell/cellContent"), U),
          style: H
        }), G);
      }
    }]), D;
  }(n.default.Component);
  k(E, "propTypes", {
    /**
     * Outer height of the cell.
     */
    height: r.default.number,
    /**
     * Outer width of the cell.
     */
    width: r.default.number,
    /**
     * Optional prop that if specified on the `Column` will be passed to the
     * cell. It can be used to uniquely identify which column is the cell is in.
     */
    columnKey: r.default.oneOfType([r.default.string, r.default.number]),
    /**
     * Optional prop that represents the rows index in the table.
     * For the 'cell' prop of a Column, this parameter will exist for any
     * cell in a row with a positive index.
     *
     * Below that entry point the user is welcome to consume or
     * pass the prop through at their discretion.
     */
    rowIndex: r.default.number,
    /**
     * Whether this cell is currently within the viewport.
     */
    isVisible: r.default.bool
  });
  var R = E;
  e.default = R;
})(I4);
var L4 = {};
(function(e) {
  function t(T) {
    "@babel/helpers - typeof";
    return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? t = function(_) {
      return typeof _;
    } : t = function(_) {
      return _ && typeof Symbol == "function" && _.constructor === Symbol && _ !== Symbol.prototype ? "symbol" : typeof _;
    }, t(T);
  }
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var n = o(et), r = o(Jr);
  function o(T) {
    return T && T.__esModule ? T : { default: T };
  }
  function i(T, S) {
    if (!(T instanceof S))
      throw new TypeError("Cannot call a class as a function");
  }
  function a(T, S) {
    for (var _ = 0; _ < S.length; _++) {
      var w = S[_];
      w.enumerable = w.enumerable || !1, w.configurable = !0, "value" in w && (w.writable = !0), Object.defineProperty(T, w.key, w);
    }
  }
  function s(T, S, _) {
    return S && a(T.prototype, S), T;
  }
  function c(T, S) {
    if (typeof S != "function" && S !== null)
      throw new TypeError("Super expression must either be null or a function");
    T.prototype = Object.create(S && S.prototype, { constructor: { value: T, writable: !0, configurable: !0 } }), S && l(T, S);
  }
  function l(T, S) {
    return l = Object.setPrototypeOf || function(w, k) {
      return w.__proto__ = k, w;
    }, l(T, S);
  }
  function d(T) {
    var S = m();
    return function() {
      var w = v(T), k;
      if (S) {
        var E = v(this).constructor;
        k = Reflect.construct(w, arguments, E);
      } else
        k = w.apply(this, arguments);
      return f(this, k);
    };
  }
  function f(T, S) {
    return S && (t(S) === "object" || typeof S == "function") ? S : p(T);
  }
  function p(T) {
    if (T === void 0)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return T;
  }
  function m() {
    if (typeof Reflect == "undefined" || !Reflect.construct || Reflect.construct.sham)
      return !1;
    if (typeof Proxy == "function")
      return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      })), !0;
    } catch (T) {
      return !1;
    }
  }
  function v(T) {
    return v = Object.setPrototypeOf ? Object.getPrototypeOf : function(_) {
      return _.__proto__ || Object.getPrototypeOf(_);
    }, v(T);
  }
  function g(T, S, _) {
    return S in T ? Object.defineProperty(T, S, { value: _, enumerable: !0, configurable: !0, writable: !0 }) : T[S] = _, T;
  }
  var b = /* @__PURE__ */ function(T) {
    c(_, T);
    var S = d(_);
    function _() {
      return i(this, _), S.apply(this, arguments);
    }
    return s(_, [{
      key: "render",
      value: function() {
        if (process.env.NODE_ENV !== "production")
          throw new Error("Component <FixedDataTableColumn /> should never render");
        return null;
      }
    }]), _;
  }(n.default.Component);
  g(b, "__TableColumn__", !0), g(b, "propTypes", {
    /**
     * The horizontal alignment of the table cell content.
     */
    align: r.default.oneOf(["left", "center", "right"]),
    /**
     * Controls if the column is fixed when scrolling in the X axis.
     */
    fixed: r.default.bool,
    /**
     * Controls if the column is fixed to the right side of the table when scrolling in the X axis.
     */
    fixedRight: r.default.bool,
    /**
     * The header cell for this column.
     * This can either be a string a React element, or a function that generates
     * a React Element. Passing in a string will render a default header cell
     * with that string. By default, the React element passed in can expect to
     * receive the following props:
     *
     * ```
     * props: {
     *   columnKey: string // (of the column, if given)
     *   height: number // (supplied from the Table or rowHeightGetter)
     *   width: number // (supplied from the Column)
     * }
     * ```
     *
     * Because you are passing in your own React element, you can feel free to
     * pass in whatever props you may want or need.
     *
     * If you pass in a function, you will receive the same props object as the
     * first argument.
     */
    header: r.default.oneOfType([r.default.node, r.default.func]),
    /**
     * This is the body cell that will be cloned for this column.
     * This can either be a string a React element, or a function that generates
     * a React Element. Passing in a string will render a default header cell
     * with that string. By default, the React element passed in can expect to
     * receive the following props:
     *
     * ```
     * props: {
     *   rowIndex; number // (the row index of the cell)
     *   columnKey: string // (of the column, if given)
     *   height: number // (supplied from the Table or rowHeightGetter)
     *   width: number // (supplied from the Column)
     * }
     * ```
     *
     * Because you are passing in your own React element, you can feel free to
     * pass in whatever props you may want or need.
     *
     * If you pass in a function, you will receive the same props object as the
     * first argument.
     */
    cell: r.default.oneOfType([r.default.node, r.default.func]),
    /**
     * This is the footer cell for this column.
     * This can either be a string a React element, or a function that generates
     * a React Element. Passing in a string will render a default header cell
     * with that string. By default, the React element passed in can expect to
     * receive the following props:
     *
     * ```
     * props: {
     *   columnKey: string // (of the column, if given)
     *   height: number // (supplied from the Table or rowHeightGetter)
     *   width: number // (supplied from the Column)
     * }
     * ```
     *
     * Because you are passing in your own React element, you can feel free to
     * pass in whatever props you may want or need.
     *
     * If you pass in a function, you will receive the same props object as the
     * first argument.
     */
    footer: r.default.oneOfType([r.default.node, r.default.func]),
    /**
     * This is used to uniquely identify the column, and is not required unless
     * you a resizing columns. This will be the key given in the
     * `onColumnResizeEndCallback` on the Table.
     */
    columnKey: r.default.oneOfType([r.default.string, r.default.number]),
    /**
     * The pixel width of the column.
     */
    width: r.default.number.isRequired,
    /**
     * If this is a resizable column this is its minimum pixel width.
     */
    minWidth: r.default.number,
    /**
     * If this is a resizable column this is its maximum pixel width.
     */
    maxWidth: r.default.number,
    /**
     * The grow factor relative to other columns. Same as the flex-grow API
     * from http://www.w3.org/TR/css3-flexbox/. Basically, take any available
     * extra width and distribute it proportionally according to all columns'
     * flexGrow values. Defaults to zero (no-flexing).
     */
    flexGrow: r.default.number,
    /**
     * Whether the column can be resized.
     * Please note that if a column has a flex grow, once you resize
     * the column, this will be set to 0.
     *
     * This property only provides the UI for the column resizing. If this
     * is set to true, you will need to set the onColumnResizeEndCallback table
     * property and render your columns appropriately.
     */
    isResizable: r.default.bool,
    /**
     * Whether the column can be dragged to reorder.
     */
    isReorderable: r.default.bool,
    /**
     * Whether cells in this column can be removed from document when outside
     * of viewport as a result of horizontal scrolling.
     * Setting this property to true allows the table to not render cells in
     * particular column that are outside of viewport for visible rows. This
     * allows to create table with many columns and not have vertical scrolling
     * performance drop.
     * Setting the property to false will keep previous behaviour and keep
     * cell rendered if the row it belongs to is visible.
     */
    allowCellsRecycling: r.default.bool,
    /**
     * Flag to enable performance check when rendering. Stops the component from
     * rendering if none of it's passed in props have changed
     */
    pureRendering: r.default.bool,
    /**
     * Additional classnames to be added to cells under this column.
     */
    cellClassName: r.default.string
  }), g(b, "defaultProps", {
    allowCellsRecycling: !1,
    fixed: !1,
    fixedRight: !1
  });
  var x = b;
  e.default = x;
})(L4);
var $4 = {};
(function(e) {
  function t(T) {
    "@babel/helpers - typeof";
    return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? t = function(_) {
      return typeof _;
    } : t = function(_) {
      return _ && typeof Symbol == "function" && _.constructor === Symbol && _ !== Symbol.prototype ? "symbol" : typeof _;
    }, t(T);
  }
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var n = o(et), r = o(Jr);
  function o(T) {
    return T && T.__esModule ? T : { default: T };
  }
  function i(T, S) {
    if (!(T instanceof S))
      throw new TypeError("Cannot call a class as a function");
  }
  function a(T, S) {
    for (var _ = 0; _ < S.length; _++) {
      var w = S[_];
      w.enumerable = w.enumerable || !1, w.configurable = !0, "value" in w && (w.writable = !0), Object.defineProperty(T, w.key, w);
    }
  }
  function s(T, S, _) {
    return S && a(T.prototype, S), T;
  }
  function c(T, S) {
    if (typeof S != "function" && S !== null)
      throw new TypeError("Super expression must either be null or a function");
    T.prototype = Object.create(S && S.prototype, { constructor: { value: T, writable: !0, configurable: !0 } }), S && l(T, S);
  }
  function l(T, S) {
    return l = Object.setPrototypeOf || function(w, k) {
      return w.__proto__ = k, w;
    }, l(T, S);
  }
  function d(T) {
    var S = m();
    return function() {
      var w = v(T), k;
      if (S) {
        var E = v(this).constructor;
        k = Reflect.construct(w, arguments, E);
      } else
        k = w.apply(this, arguments);
      return f(this, k);
    };
  }
  function f(T, S) {
    return S && (t(S) === "object" || typeof S == "function") ? S : p(T);
  }
  function p(T) {
    if (T === void 0)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return T;
  }
  function m() {
    if (typeof Reflect == "undefined" || !Reflect.construct || Reflect.construct.sham)
      return !1;
    if (typeof Proxy == "function")
      return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      })), !0;
    } catch (T) {
      return !1;
    }
  }
  function v(T) {
    return v = Object.setPrototypeOf ? Object.getPrototypeOf : function(_) {
      return _.__proto__ || Object.getPrototypeOf(_);
    }, v(T);
  }
  function g(T, S, _) {
    return S in T ? Object.defineProperty(T, S, { value: _, enumerable: !0, configurable: !0, writable: !0 }) : T[S] = _, T;
  }
  var b = /* @__PURE__ */ function(T) {
    c(_, T);
    var S = d(_);
    function _() {
      return i(this, _), S.apply(this, arguments);
    }
    return s(_, [{
      key: "render",
      value: function() {
        if (process.env.NODE_ENV !== "production")
          throw new Error("Component <FixedDataTableColumnGroup /> should never render");
        return null;
      }
    }]), _;
  }(n.default.Component);
  g(b, "__TableColumnGroup__", !0), g(b, "propTypes", {
    /**
     * The horizontal alignment of the table cell content.
     */
    align: r.default.oneOf(["left", "center", "right"]),
    /**
     * Controls if the column group is fixed when scrolling in the X axis.
     */
    fixed: r.default.bool,
    /**
     * This is the header cell for this column group.
     * This can either be a string or a React element. Passing in a string
     * will render a default footer cell with that string. By default, the React
     * element passed in can expect to receive the following props:
     *
     * ```
     * props: {
     *   height: number // (supplied from the groupHeaderHeight)
     *   width: number // (supplied from the Column)
     * }
     * ```
     *
     * Because you are passing in your own React element, you can feel free to
     * pass in whatever props you may want or need.
     *
     * You can also pass in a function that returns a react elemnt, with the
     * props object above passed in as the first parameter.
     */
    header: r.default.oneOfType([r.default.node, r.default.func])
  }), g(b, "defaultProps", {
    fixed: !1
  });
  var x = b;
  e.default = x;
})($4);
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), Object.defineProperty(e, "Table", {
    enumerable: !0,
    get: function() {
      return t.default;
    }
  }), Object.defineProperty(e, "Cell", {
    enumerable: !0,
    get: function() {
      return n.default;
    }
  }), Object.defineProperty(e, "DataCell", {
    enumerable: !0,
    get: function() {
      return r.default;
    }
  }), Object.defineProperty(e, "Column", {
    enumerable: !0,
    get: function() {
      return o.default;
    }
  }), Object.defineProperty(e, "ColumnGroup", {
    enumerable: !0,
    get: function() {
      return i.default;
    }
  }), e.version = void 0;
  var t = a(yL), n = a(Vx), r = a(I4), o = a(L4), i = a($4);
  function a(c) {
    return c && c.__esModule ? c : { default: c };
  }
  var s = "1.2.22";
  e.version = s;
})(bL);
var Lp = bL;
const rIe = "#f4f4f8", oIe = "#edeef1", iIe = "#e3e5ea", aIe = "#f9f9fb", sIe = "#ffcb05", lIe = "#1faff3", cIe = "#e5e5e5", uIe = "#5b6372", dIe = "#3a4356", fIe = "#3c3c42", pIe = "#a3a3a3", hIe = "#d0d3db", mIe = "_tableWrapper_1ode4_16", gIe = "_table_1ode4_16", vIe = "_tableHeader_1ode4_78", bIe = "_tableCell_1ode4_88", yIe = "_tableCellContent_1ode4_99", _Ie = "_headerColor_1ode4_105", wIe = "_rowColor_1ode4_109", od = {
  athensGray: rIe,
  athensGrayDark: oIe,
  athensGrayDark2: iIe,
  athensGrayLight: aIe,
  defaultBrandColor: sIe,
  dodgerBlue: lIe,
  mercury: cIe,
  shuttleGrayDark: uIe,
  oxfordBlue: dIe,
  darkModeDefaultBackground: fIe,
  indicatorGrey: pIe,
  secondaryButtonHover: hIe,
  tableWrapper: mIe,
  table: gIe,
  tableHeader: vIe,
  tableCell: bIe,
  tableCellContent: yIe,
  headerColor: _Ie,
  rowColor: wIe
}, xIe = "#f4f4f8", CIe = "#edeef1", SIe = "#e3e5ea", TIe = "#f9f9fb", EIe = "#ffcb05", kIe = "#1faff3", MIe = "#e5e5e5", RIe = "#5b6372", PIe = "#3a4356", OIe = "#3c3c42", NIe = "#a3a3a3", AIe = "#d0d3db", DIe = "_headerCell_2qf2w_16", IIe = "_noSort_2qf2w_29", LIe = "_standard_2qf2w_29", $Ie = "_caret_2qf2w_33", FIe = "_headerLabel_2qf2w_38", zIe = "_icon_2qf2w_43", BIe = "_numberIcon_2qf2w_50", HIe = "_dateIcon_2qf2w_54", jIe = "_textIcon_2qf2w_58", WIe = "_booleanIcon_2qf2w_62", VIe = "_sortIcon_2qf2w_66", UIe = "_sortAscending_2qf2w_74", qIe = "_sortDescending_2qf2w_78", $a = {
  athensGray: xIe,
  athensGrayDark: CIe,
  athensGrayDark2: SIe,
  athensGrayLight: TIe,
  defaultBrandColor: EIe,
  dodgerBlue: kIe,
  mercury: MIe,
  shuttleGrayDark: RIe,
  oxfordBlue: PIe,
  darkModeDefaultBackground: OIe,
  indicatorGrey: NIe,
  secondaryButtonHover: AIe,
  headerCell: DIe,
  noSort: IIe,
  standard: LIe,
  caret: $Ie,
  headerLabel: FIe,
  icon: zIe,
  numberIcon: BIe,
  dateIcon: HIe,
  textIcon: jIe,
  booleanIcon: WIe,
  sortIcon: VIe,
  sortAscending: UIe,
  sortDescending: qIe
};
var F4 = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function(e) {
  (function() {
    var t = {}.hasOwnProperty;
    function n() {
      for (var i = "", a = 0; a < arguments.length; a++) {
        var s = arguments[a];
        s && (i = o(i, r(s)));
      }
      return i;
    }
    function r(i) {
      if (typeof i == "string" || typeof i == "number")
        return i;
      if (typeof i != "object")
        return "";
      if (Array.isArray(i))
        return n.apply(null, i);
      if (i.toString !== Object.prototype.toString && !i.toString.toString().includes("[native code]"))
        return i.toString();
      var a = "";
      for (var s in i)
        t.call(i, s) && i[s] && (a = o(a, s));
      return a;
    }
    function o(i, a) {
      return a ? i ? i + " " + a : i + a : i;
    }
    e.exports ? (n.default = n, e.exports = n) : window.classNames = n;
  })();
})(F4);
var GIe = F4.exports;
const bm = /* @__PURE__ */ ya(GIe), YIe = "_icon_t30x8_1", ZIe = "_numberIcon_t30x8_11", XIe = "_dateIcon_t30x8_15", KIe = "_textIcon_t30x8_19", JIe = "_booleanIcon_t30x8_23", Gu = {
  icon: YIe,
  numberIcon: ZIe,
  dateIcon: XIe,
  textIcon: KIe,
  booleanIcon: JIe
}, QIe = ({ columnType: e }) => /* @__PURE__ */ z(
  "div",
  {
    className: bm(Gu.icon, {
      [Gu.numberIcon]: is(e),
      [Gu.dateIcon]: dh(e),
      [Gu.textIcon]: cF(e),
      [Gu.booleanIcon]: uF(e)
    })
  }
), e5e = ({ column: e, onClick: t, isSelected: n, children: r, showFieldTypeIcon: o, sortIcon: i = "standard" }) => /* @__PURE__ */ _e(
  "div",
  {
    className: $a.headerCell,
    onClick: () => {
      t(e);
    },
    children: [
      o && /* @__PURE__ */ z(QIe, { columnType: e.type }),
      /* @__PURE__ */ z("div", { className: $a.headerLabel, children: r }),
      /* @__PURE__ */ z(
        "div",
        {
          className: bm($a.sortIcon, {
            [$a.caret]: i === "caret",
            [$a.standard]: i === "standard",
            [$a.noSort]: !n || e.direction === 0,
            [$a.sortAscending]: n && e.direction === 1,
            [$a.sortDescending]: n && e.direction === -1
          })
        }
      )
    ]
  }
), t5e = 26, n5e = 26, RP = 20, z4 = 36, B4 = 29, H4 = 24, o_ = 350, r5e = 126, o5e = 38, i5e = 55, a5e = (e, t, n, r) => {
  const i = document.createElement("canvas").getContext("2d");
  if (!i)
    return [];
  i.font = `13px ${r || "Open Sans"}`;
  const a = e.columns.map((f) => i.measureText(f.name).width + z4 + (t ? B4 : 0)), s = i.measureText("0").width, c = e.columns.map((f) => ({ type: dF(f.type), index: f.index })), { rows: l } = e, d = c.map((f) => {
    const p = l.reduce((m, v) => {
      var T;
      const g = v[f.index].displayValue, b = (T = n[f.index]) != null && T.isHtml ? s5e(g) : g, x = f.type === "number" ? v[f.index].displayValue.length * s : i.measureText(b).width;
      return Math.max(m, x);
    }, 0);
    return H4 + p;
  });
  return a.map((f, p) => {
    var m;
    return (m = n[p]) != null && m.width ? n[p].width : Math.ceil(
      Math.max(r5e, Math.min(o_, Math.max(f, d[p])))
    );
  });
};
function s5e(e) {
  const t = document.createElement("div");
  return t.innerHTML = e, j4(t);
}
function j4(e) {
  let t, n, r, o;
  for (n = "", t = 0; t < e.childNodes.length; t++)
    o = e.childNodes[t], r = null, o.nodeType === 1 ? r = j4(o) : o.nodeType === 3 && (r = o.nodeValue), r && (n += r);
  return n;
}
const PP = (e) => e % 2 === 1, OP = ({
  colIndex: e = 0,
  rowIndex: t = 0,
  themeSettings: n,
  customStyles: r,
  isHeaderCell: o
}) => {
  var l, d, f, p, m, v, g, b, x, T, S, _, w, k, E, R, P, A;
  let i = n.chart.textColor;
  const a = n.typography.fontFamily;
  let s = n.chart.backgroundColor;
  const c = wO(s);
  return o ? (d = (l = r == null ? void 0 : r.header) == null ? void 0 : l.color) != null && d.enabled && (s = ((p = (f = r == null ? void 0 : r.header) == null ? void 0 : f.color) == null ? void 0 : p.backgroundColor) || c, i = ((v = (m = r == null ? void 0 : r.header) == null ? void 0 : m.color) == null ? void 0 : v.textColor) || i) : ((b = (g = r == null ? void 0 : r.columns) == null ? void 0 : g.alternatingColor) != null && b.enabled && PP(e) && (s = ((T = (x = r == null ? void 0 : r.columns) == null ? void 0 : x.alternatingColor) == null ? void 0 : T.backgroundColor) || c, i = ((_ = (S = r == null ? void 0 : r.columns) == null ? void 0 : S.alternatingColor) == null ? void 0 : _.textColor) || i), (k = (w = r == null ? void 0 : r.rows) == null ? void 0 : w.alternatingColor) != null && k.enabled && PP(t) && (s = ((R = (E = r == null ? void 0 : r.rows) == null ? void 0 : E.alternatingColor) == null ? void 0 : R.backgroundColor) || c, i = ((A = (P = r == null ? void 0 : r.rows) == null ? void 0 : P.alternatingColor) == null ? void 0 : A.textColor) || i)), {
    color: i,
    backgroundColor: s,
    fontFamily: a
  };
}, l5e = (e) => is(e) ? "right" : "left", NP = ({
  displayValue: e,
  width: t,
  padding: n,
  ellipsizedLength: r,
  isHtml: o
}) => {
  const i = e.length > r;
  return /* @__PURE__ */ z(
    "div",
    {
      className: od.tableCellContent,
      style: {
        maxWidth: `${t - n}px`
      },
      children: o ? /* @__PURE__ */ z("div", { dangerouslySetInnerHTML: { __html: e } }) : i ? /* @__PURE__ */ z(bx, { title: e, children: /* @__PURE__ */ z("div", { children: e }) }) : /* @__PURE__ */ z("div", { children: e })
    }
  );
}, c5e = ({
  dataTable: e,
  dataOptions: t,
  height: n,
  width: r,
  customStyles: o,
  themeSettings: i,
  onSortUpdate: a
}) => {
  var T, S, _;
  const s = o && o.showFieldTypeIcon !== void 0 ? o.showFieldTypeIcon : !0, c = z4 + (s ? B4 : 0), l = (o == null ? void 0 : o.paddingVertical) || RP, d = (o == null ? void 0 : o.paddingHorizontal) || RP, f = ((T = o == null ? void 0 : o.columns) == null ? void 0 : T.width) === "auto" ? (r - d * 2 - 1) / t.columns.length : void 0, p = We(
    () => t.columns.map((w) => ({
      isHtml: "isHtml" in w && !!w.isHtml,
      width: f
    })),
    [t.columns, f]
  ), [m, v] = Ge(((S = document.fonts) == null ? void 0 : S.status) === "loaded"), g = (_ = i.typography) == null ? void 0 : _.fontFamily, b = We(() => a5e(e, s, p, g), [e, s, p, g, m]);
  mt(() => {
    var w;
    (w = document.fonts) == null || w.ready.then(() => {
      v(!0);
    }).catch((k) => {
      console.warn("Failed to observe font loading", k);
    });
  }, []);
  const x = We(
    () => e.columns.map((w, k) => {
      const E = b[k], R = t.columns[k], P = OP({
        isHeaderCell: !0,
        themeSettings: i,
        customStyles: o
      });
      return E ? /* @__PURE__ */ z(
        Lp.Column,
        {
          maxWidth: o_,
          minWidth: o_,
          allowCellsRecycling: !0,
          width: E,
          header: /* @__PURE__ */ z(Lp.Cell, { className: bm(od.tableHeader), style: P, children: /* @__PURE__ */ z(
            e5e,
            {
              column: w,
              onClick: a,
              isSelected: !!Math.abs(w.direction),
              showFieldTypeIcon: s,
              sortIcon: (o == null ? void 0 : o.sortIcon) || "standard",
              children: NP({
                displayValue: sd(R),
                width: E,
                padding: c,
                ellipsizedLength: o5e
              })
            }
          ) }),
          cell: (N) => {
            var F = N, { rowIndex: A } = F, D = xl(F, ["rowIndex"]);
            return /* @__PURE__ */ z(
              Lp.Cell,
              ge(se({
                className: bm(od.tableCell),
                style: OP({
                  colIndex: k,
                  rowIndex: A,
                  themeSettings: i,
                  customStyles: o
                })
              }, D), {
                children: NP({
                  // eslint-disable-next-line security/detect-object-injection
                  displayValue: e.rows[A][k].displayValue,
                  width: E,
                  padding: H4,
                  ellipsizedLength: i5e,
                  isHtml: "isHtml" in R && R.isHtml
                })
              })
            );
          },
          align: l5e(w.type)
        },
        `col${k}`
      ) : null;
    }),
    [
      e,
      b,
      i,
      o,
      a,
      s,
      t,
      c
    ]
  );
  return We(
    () => /* @__PURE__ */ z(
      "div",
      {
        className: od.tableWrapper,
        style: {
          padding: `${l}px ${d}px`
        },
        children: /* @__PURE__ */ z(
          Lp.Table,
          {
            className: od.table,
            rowHeight: (o == null ? void 0 : o.rowHeight) || n5e,
            rowsCount: e.rows.length,
            width: r - d * 2,
            height: n - l * 2,
            headerHeight: (o == null ? void 0 : o.headerHeight) || t5e,
            children: x
          }
        )
      }
    ),
    [x, o, e, n, d, l, r]
  );
}, u5e = "_component_1rw9b_1", d5e = {
  component: u5e
}, f5e = (e, t) => {
  if (!e.columns.some((a) => is(a.type)))
    return e;
  const n = e.columns, o = e.rows.map((a) => a.map((s, c) => {
    const l = n[c].type, d = Fc(
      t.columns[c].numberFormatConfig
    );
    if (is(l)) {
      const f = yO(s.displayValue, l);
      return {
        displayValue: as(d, f.value),
        compareValue: f
      };
    } else
      return s;
  }));
  return { columns: n, rows: o };
}, p5e = ({
  dataTable: e,
  dataOptions: t,
  designOptions: n = {},
  onSortUpdate: r,
  themeSettings: o,
  width: i = 400,
  height: a = 500
}) => {
  const s = it(null), c = it(e), l = We(
    () => f5e(e, t),
    [e, t]
  );
  Lc(() => {
    c.current = e;
  }, [e]);
  const d = We(
    () => se({
      sortIcon: "caret",
      showFieldTypeIcon: !1
    }, n),
    [n]
  );
  return /* @__PURE__ */ z("div", { className: d5e.component, ref: s, children: /* @__PURE__ */ z(
    c5e,
    {
      dataTable: l,
      dataOptions: t,
      onSortUpdate: r,
      height: a,
      width: i,
      customStyles: d,
      themeSettings: o
    }
  ) });
}, h5e = (e) => ({
  "& .MuiPaginationItem-circular.Mui-selected": {
    color: e.chart.textColor
  },
  "& .MuiPaginationItem-circular": {
    color: e.chart.secondaryTextColor,
    fontFamily: e.typography.fontFamily
  }
});
var m5e = Object.prototype, g5e = m5e.hasOwnProperty;
function v5e(e, t) {
  return e != null && g5e.call(e, t);
}
function b5e(e, t) {
  return e != null && fF(e, t, v5e);
}
function y5e(e, t) {
  for (const n of t)
    b5e(e, n) && console.warn(
      `Prop '${n}' has been deprecated. Please refer to the documentation at https://sisense.dev/guides/sdk/ for the updated prop and use that instead.`
    );
}
const _5e = (e) => (y5e(e, [
  "headersColor",
  "alternatingRowsColor",
  "alternatingColumnsColor"
]), {
  paddingVertical: e.paddingVertical,
  paddingHorizontal: e.paddingHorizontal,
  header: se(se({}, e.headersColor ? { color: { enabled: e.headersColor } } : null), e.header),
  rows: se(se({}, e.alternatingRowsColor ? { alternatingColor: { enabled: e.alternatingRowsColor } } : null), e.rows),
  columns: se(se({}, e.alternatingColumnsColor ? { alternatingColor: { enabled: e.alternatingColumnsColor } } : null), e.columns)
}), w5e = 25, x5e = 10, W4 = ({
  dataSet: e,
  dataOptions: t,
  styleOptions: n = {},
  filters: r
}) => {
  const { rowsPerPage: o = w5e, width: i, height: a } = n, { themeSettings: s } = Yn(), [c, l] = Ge(0), { filters: d, relations: f } = b_(r), [p, m] = Ge(1), v = it(null), g = We(
    () => H2e(t),
    [t]
  ), b = We(
    () => pL(
      g.columns.filter(wr).map(
        __
      )
    ),
    [g]
  ), x = We(
    () => _5e(n),
    [n]
  ), [T, S] = Ge(g), [_, w] = Ge(e), [k, E] = Z2e({
    dataSet: _,
    dataOptions: T,
    filters: d,
    filterRelations: f,
    count: o * x5e,
    offset: c
  }), R = eSe({
    data: k,
    innerDataOptions: E,
    dataColumnNamesMapping: b,
    needToAggregate: !ss(_)
  });
  mt(() => {
    S(g), w(e), m(1), l(0);
  }, [e, g]);
  const P = bt(
    (F) => {
      if (!k)
        return;
      Math.floor(k.rows.length / o) === F && l(k.rows.length), m(F);
    },
    [k, o]
  ), A = bt(
    (F) => {
      m(1), l(0), T && S(J2e(T, F));
    },
    [T]
  ), D = We(() => {
    if (!R || ss(_))
      return R;
    const F = R.columns.find(($) => $.direction !== 0);
    return F ? uO(R, [F]) : R;
  }, [R, _]), N = We(
    () => D ? {
      columns: D.columns,
      rows: D.rows.slice(
        (p - 1) * o,
        p * o
      )
    } : void 0,
    [D, p, o]
  );
  return E ? /* @__PURE__ */ z(
    Vg,
    {
      defaultSize: _x("table"),
      size: {
        width: i,
        height: a
      },
      children: (F) => {
        if (!R || !N)
          return /* @__PURE__ */ z(qw, { themeSettings: s });
        if (pF(R))
          return /* @__PURE__ */ z(cL, { iconType: "table" });
        const $ = Math.ceil(R.rows.length / o), I = $ > 1 ? 32 : 0;
        return /* @__PURE__ */ _e(
          "div",
          {
            style: {
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              backgroundColor: s.chart.backgroundColor
            },
            "aria-label": "table-root",
            children: [
              /* @__PURE__ */ z(
                p5e,
                {
                  dataTable: N,
                  dataOptions: E,
                  designOptions: x,
                  themeSettings: s,
                  width: F.width,
                  height: F.height - I,
                  onSortUpdate: A
                }
              ),
              $ > 1 && /* @__PURE__ */ z(
                F5,
                {
                  ref: v,
                  page: p,
                  count: $,
                  onChange: (j, U) => P(U),
                  sx: h5e(s)
                }
              )
            ]
          }
        );
      }
    }
  ) : null;
}, C5e = (e) => {
  const { dataSet: t } = e;
  return !!t && typeof t != "string" && "rows" in t && "columns" in t;
}, S5e = ol(null), wb = {
  didCatch: !1,
  error: null
};
class T5e extends af {
  constructor(t) {
    super(t), this.resetErrorBoundary = this.resetErrorBoundary.bind(this), this.state = wb;
  }
  static getDerivedStateFromError(t) {
    return {
      didCatch: !0,
      error: t
    };
  }
  resetErrorBoundary() {
    const {
      error: t
    } = this.state;
    if (t !== null) {
      for (var n, r, o = arguments.length, i = new Array(o), a = 0; a < o; a++)
        i[a] = arguments[a];
      (n = (r = this.props).onReset) === null || n === void 0 || n.call(r, {
        args: i,
        reason: "imperative-api"
      }), this.setState(wb);
    }
  }
  componentDidCatch(t, n) {
    var r, o;
    (r = (o = this.props).onError) === null || r === void 0 || r.call(o, t, n);
  }
  componentDidUpdate(t, n) {
    const {
      didCatch: r
    } = this.state, {
      resetKeys: o
    } = this.props;
    if (r && n.error !== null && E5e(t.resetKeys, o)) {
      var i, a;
      (i = (a = this.props).onReset) === null || i === void 0 || i.call(a, {
        next: o,
        prev: t.resetKeys,
        reason: "keys"
      }), this.setState(wb);
    }
  }
  render() {
    const {
      children: t,
      fallbackRender: n,
      FallbackComponent: r,
      fallback: o
    } = this.props, {
      didCatch: i,
      error: a
    } = this.state;
    let s = t;
    if (i) {
      const c = {
        error: a,
        resetErrorBoundary: this.resetErrorBoundary
      };
      if (typeof n == "function")
        s = n(c);
      else if (r)
        s = uh(r, c);
      else if (o === null || sa(o))
        s = o;
      else
        throw a;
    }
    return uh(S5e.Provider, {
      value: {
        didCatch: i,
        error: a,
        resetErrorBoundary: this.resetErrorBoundary
      }
    }, s);
  }
}
function E5e() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
  return e.length !== t.length || e.some((n, r) => !Object.is(n, t[r]));
}
const k5e = (e) => {
  if (!ss(e.dataSet))
    throw "error, advanced charts only works against a data model";
  const t = Li(e.dataOptions), n = hF(t);
  t.value.push(...n);
  const r = mF(t);
  t.value.push(...r);
  const o = bt(
    ({ error: i }) => (console.debug("Unexpected error occurred when rendering advanced chart:", i), /* @__PURE__ */ z(Y1, se({}, e))),
    [e]
  );
  return /* @__PURE__ */ z(T5e, { fallbackRender: o, children: /* @__PURE__ */ z(Y1, ge(se({}, e), { dataOptions: t })) });
}, M5e = Jc({
  componentName: "Chart",
  shouldSkipSisenseContextWaiting: C5e,
  customContextErrorMessageKey: "errors.chartNoSisenseContext"
})((e) => {
  if (R5e(e))
    return /* @__PURE__ */ z(W4, se({}, e));
  if (P5e(e))
    return /* @__PURE__ */ z(k5e, se({}, e));
  if (V4(e))
    return /* @__PURE__ */ z(Y1, se({}, e));
  throw new vt("errors.chartInvalidProps");
});
function R5e(e) {
  return e.chartType === "table" && "columns" in e.dataOptions;
}
function V4(e) {
  return e.chartType !== "table";
}
function P5e(e) {
  return !V4(e) || !_a(e.chartType) ? !1 : e.dataOptions.value.some(
    (n) => (n == null ? void 0 : n.forecast) !== void 0 || (n == null ? void 0 : n.trend) !== void 0
  );
}
var U4 = /* @__PURE__ */ ((e) => (e.None = "", e.Large = "30px", e.Medium = "20px", e.Small = "10px", e))(U4 || {}), i_ = /* @__PURE__ */ ((e) => (e.None = "", e.Light = "0.15", e.Medium = "0.3", e.Dark = "0.7", e))(i_ || {}), a_ = /* @__PURE__ */ ((e) => (e.None = "", e.Large = "3px 12px", e.Medium = "2px 8px", e.Small = "1px 4px", e))(a_ || {}), q4 = /* @__PURE__ */ ((e) => (e.None = "", e.Large = "15px", e.Medium = "10px", e.Small = "5px", e))(q4 || {});
const O5e = (e, t) => {
  const n = Td(e, "shadow", t.widget.shadow), r = Td(e, "spaceAround", t.widget.spaceAround);
  if (n === "None" || r === "None")
    return "none";
  if (n in i_ && r in a_) {
    const o = i_[`${n}`];
    return `0px ${a_[`${r}`]} rgba(9, 9, 10, ${o})`;
  }
  return "none";
};
function N5e({
  title: e,
  description: t,
  styleOptions: n,
  onRefresh: r
}) {
  var d, f, p;
  const [o, i] = Ge(null), { themeSettings: a } = Yn(), { t: s } = Bi(), c = (m) => {
    i(m.currentTarget);
  }, l = () => {
    i(null);
  };
  return /* @__PURE__ */ _e(fo, { children: [
    /* @__PURE__ */ z(
      bx,
      {
        title: s("widgetHeader.info.tooltip"),
        style: {
          color: (d = a.chart) == null ? void 0 : d.textColor,
          fontFamily: (f = a.typography) == null ? void 0 : f.fontFamily
        },
        children: /* @__PURE__ */ z(ef, { onClick: c, sx: { p: 0 }, children: /* @__PURE__ */ z("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "24", height: "24", children: /* @__PURE__ */ z(
          "path",
          {
            fill: (n == null ? void 0 : n.titleTextColor) || a.widget.header.titleTextColor,
            d: "M11.5 20a7.5 7.5 0 1 1 0-15 7.5 7.5 0 0 1 0 15zm0-1a6.5 6.5 0 1 0 0-13 6.5 6.5 0 0 0 0 13zm-.5-8h1v5h-1v-5zm0-1v-.998h1V10h-1z"
          }
        ) }) })
      }
    ),
    /* @__PURE__ */ z(
      ax,
      {
        open: !!o,
        anchorEl: o,
        onClose: l,
        anchorOrigin: {
          vertical: "bottom",
          horizontal: "center"
        },
        transformOrigin: {
          vertical: "top",
          horizontal: "center"
        },
        slotProps: {
          root: {
            sx: {
              ".MuiPaper-root": {
                boxShadow: "0 0 8px 0 rgba(0, 0, 0, 0.25)",
                borderRadius: 0
              }
            }
          }
        },
        children: /* @__PURE__ */ _e(D5, { raised: !0, className: "csdk-max-w-xs csdk-w-[300px]", children: [
          /* @__PURE__ */ _e(
            "div",
            {
              className: "csdk-flex csdk-flex-row csdk-justify-between csdk-items-center csdk-py-[5px] csdk-px-[12px]",
              style: {
                backgroundColor: wO(a.general.backgroundColor)
              },
              children: [
                /* @__PURE__ */ z(
                  si,
                  {
                    variant: "subtitle2",
                    sx: { fontWeight: "bold" },
                    style: {
                      color: a.typography.primaryTextColor,
                      fontFamily: a.typography.fontFamily
                    },
                    children: s("widgetHeader.info.details")
                  }
                ),
                /* @__PURE__ */ z(ef, { onClick: r, sx: { p: 0 }, children: /* @__PURE__ */ z("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "24", height: "24", children: /* @__PURE__ */ z(
                  "path",
                  {
                    fill: (p = a.chart) == null ? void 0 : p.textColor,
                    d: "M20 12a8 8 0 0 1-15.259 3.368l1.004-.222a7 7 0 0 0 13.252-2.925L20 12zm0 0a8 8 0 0 1-15.259 3.368l1.004-.222a7 7 0 0 0 13.252-2.925L20 12zm-8-7a7 7 0 0 1 6.267 3.877l1.003-.22A8.001 8.001 0 0 0 4 12l1.003-.22A7 7 0 0 1 12 5zm6.998 3.12A8 8 0 0 0 4 12l1.003-.22a7 7 0 0 1 13.264-2.903l.73-.16v.28l-2.98.016-.017.971h3.985V6h-.987v2.12zm-14.01 9.864H4V14h3.985l-.016.971-2.981.017v2.996z"
                  }
                ) }) })
              ]
            }
          ),
          /* @__PURE__ */ z(
            Qd,
            {
              sx: { borderColor: a.typography.secondaryTextColor, opacity: 0.3 }
            }
          ),
          /* @__PURE__ */ _e(
            I5,
            {
              style: {
                backgroundColor: a.general.backgroundColor,
                padding: 12
              },
              children: [
                e && /* @__PURE__ */ z(
                  si,
                  {
                    variant: "body2",
                    style: {
                      color: a.typography.primaryTextColor,
                      fontFamily: a.typography.fontFamily,
                      fontSize: 13
                    },
                    children: e
                  }
                ),
                !!t && /* @__PURE__ */ _e(fo, { children: [
                  /* @__PURE__ */ z(
                    Qd,
                    {
                      sx: {
                        my: 1,
                        borderColor: a.typography.secondaryTextColor,
                        opacity: 0.3
                      }
                    }
                  ),
                  /* @__PURE__ */ z(
                    si,
                    {
                      variant: "body2",
                      style: {
                        color: a.typography.primaryTextColor,
                        fontFamily: a.typography.fontFamily,
                        fontSize: 13
                      },
                      children: t
                    }
                  )
                ] })
              ]
            }
          )
        ] })
      }
    )
  ] });
}
const A5e = ({
  title: e,
  description: t,
  dataSetName: n,
  styleOptions: r,
  onRefresh: o
}) => {
  var s;
  const { themeSettings: i } = Yn(), a = () => {
    var l;
    const c = /* @__PURE__ */ z(fo, { children: /* @__PURE__ */ z(
      N5e,
      {
        title: n,
        description: t,
        styleOptions: r,
        onRefresh: o
      }
    ) });
    return r != null && r.renderToolbar ? (l = r == null ? void 0 : r.renderToolbar) == null ? void 0 : l.call(r, o, c) : c;
  };
  return /* @__PURE__ */ _e(fo, { children: [
    /* @__PURE__ */ _e(
      "div",
      {
        className: "csdk-flex csdk-flex-row csdk-items-center csdk-px-2 csdk-min-h-[32px]",
        style: {
          backgroundColor: (r == null ? void 0 : r.backgroundColor) || i.widget.header.backgroundColor
        },
        children: [
          /* @__PURE__ */ z(
            "div",
            {
              className: "csdk-w-full csdk-whitespace-nowrap csdk-overflow-hidden",
              style: {
                textAlign: D5e(
                  (r == null ? void 0 : r.titleAlignment) || i.widget.header.titleAlignment
                ),
                color: (r == null ? void 0 : r.titleTextColor) || i.widget.header.titleTextColor,
                fontFamily: (s = i.typography) == null ? void 0 : s.fontFamily,
                fontSize: 15
              },
              children: e || ""
            }
          ),
          /* @__PURE__ */ z("div", { className: "csdk-ml-auto csdk-flex csdk-items-center", children: a() })
        ]
      }
    ),
    Td(r, "dividerLine", i.widget.header.dividerLine) && /* @__PURE__ */ z(
      Qd,
      {
        style: {
          backgroundColor: (r == null ? void 0 : r.dividerLineColor) || i.widget.header.dividerLineColor || "#d5d5d5"
        }
      }
    )
  ] });
};
function D5e(e) {
  return e.toLowerCase();
}
const G4 = ({
  dataSetName: e,
  styleOptions: t,
  title: n,
  description: r,
  topSlot: o,
  bottomSlot: i,
  children: a,
  onRefresh: s = () => {
  }
}) => {
  var l, d, f;
  const { themeSettings: c } = Yn();
  return /* @__PURE__ */ z("div", { className: "csdk-w-full csdk-h-full csdk-overflow-hidden", children: /* @__PURE__ */ z(
    "div",
    {
      className: "csdk-h-full",
      style: {
        padding: q4[Td(t, "spaceAround", c.widget.spaceAround)] || "0px"
      },
      children: /* @__PURE__ */ _e(
        "div",
        {
          className: "csdk-h-full csdk-overflow-hidden",
          style: {
            backgroundColor: (t == null ? void 0 : t.backgroundColor) || "unset",
            borderWidth: Td(t, "border", c.widget.border) ? "1px" : 0,
            borderColor: (t == null ? void 0 : t.borderColor) || c.widget.borderColor,
            borderRadius: U4[(t == null ? void 0 : t.cornerRadius) || c.widget.cornerRadius] || 0,
            boxShadow: O5e(t, c),
            display: "flex",
            flexDirection: "column"
          },
          children: [
            !((l = t == null ? void 0 : t.header) != null && l.hidden) && /* @__PURE__ */ z(
              A5e,
              {
                title: n,
                description: r,
                dataSetName: e,
                styleOptions: t == null ? void 0 : t.header,
                onRefresh: s
              }
            ),
            o,
            /* @__PURE__ */ z(
              wxe,
              {
                theme: {
                  chart: {
                    backgroundColor: (t == null ? void 0 : t.backgroundColor) || ((d = c.chart) == null ? void 0 : d.backgroundColor)
                  }
                },
                children: /* @__PURE__ */ z(
                  "div",
                  {
                    style: {
                      flexGrow: 1,
                      // prevents 'auto' behavior of using content size as minimal size for container
                      minWidth: 0,
                      minHeight: 0,
                      backgroundColor: (t == null ? void 0 : t.backgroundColor) || ((f = c.chart) == null ? void 0 : f.backgroundColor)
                    },
                    children: a
                  }
                )
              }
            ),
            i
          ]
        }
      )
    }
  ) });
};
var I5e = "[object String]";
function L5e(e) {
  return typeof e == "string" || !ph(e) && sf(e) && xm(e) == I5e;
}
function $5e(e, t, n) {
  const r = aL(e);
  return typeof e != "object" && e === r ? !1 : r == null || (t ? t.some(
    // eslint-disable-next-line security/detect-object-injection
    (i) => !Ic(r[i], e[i])
  ) : !Ic(r, e)) ? !0 : n ? n(e, r) : !1;
}
const Y4 = "sdkHookInit", v$e = (e, t, n, r) => {
  if (!n)
    return;
  bI(Y4, {
    packageName: t,
    packageVersion: "1.22.0",
    hookName: e
  }, n.httpClient).finally(r);
};
function F5e(e) {
  const { tracking: t } = Gn(), { trackEvent: n } = Uw(), r = it(!1);
  mt(() => {
    if (t && !r.current) {
      const o = {
        packageName: t.packageName || "sdk-ui",
        packageVersion: "1.22.0",
        hookName: e
      };
      n(Y4, o, !t.enabled).finally(
        () => r.current = !0
      );
    }
  }, [t, e, n]);
}
const z5e = (e) => (t) => (...n) => (F5e(e), t(...n));
function AP(e, t) {
  switch (t.type) {
    case "loading":
      return B5e(e);
    case "success":
      return H5e(t.data);
    case "error":
      return j5e(t.error);
  }
}
function B5e(e) {
  return e.status === "loading" ? e : ge(se({}, e), {
    isLoading: !0,
    isError: !1,
    isSuccess: !1,
    status: "loading",
    error: void 0
  });
}
function H5e(e) {
  return {
    isLoading: !1,
    isError: !1,
    isSuccess: !0,
    data: e,
    status: "success",
    error: void 0
  };
}
function j5e(e) {
  return {
    isLoading: !1,
    isError: !0,
    isSuccess: !1,
    data: void 0,
    status: "error",
    error: e
  };
}
function W5e({ enabled: e }, t) {
  const n = it(!1);
  return bt(
    (r, o = !1) => {
      const i = e === !1 || !r, a = n.current;
      return n.current = i, !i && (a || t || o);
    },
    [e, t]
  );
}
function Z4(e) {
  var t = e == null ? 0 : e.length;
  return t ? e[t - 1] : void 0;
}
function V5e(e, t) {
  return t.length < 2 ? e : gF(e, z5(t, 0, -1));
}
function U5e(e, t) {
  return t = xO(t, e), e = V5e(e, t), e == null || delete e[vF(Z4(t))];
}
var q5e = "[object Object]", G5e = Function.prototype, Y5e = Object.prototype, X4 = G5e.toString, Z5e = Y5e.hasOwnProperty, X5e = X4.call(Object);
function K5e(e) {
  if (!sf(e) || xm(e) != q5e)
    return !1;
  var t = bF(e);
  if (t === null)
    return !0;
  var n = Z5e.call(t, "constructor") && t.constructor;
  return typeof n == "function" && n instanceof n && X4.call(n) == X5e;
}
function J5e(e) {
  return K5e(e) ? void 0 : e;
}
var Q5e = 1, eLe = 2, tLe = 4, nLe = yF(function(e, t) {
  var n = {};
  if (e == null)
    return n;
  var r = !1;
  t = _F(t, function(i) {
    return i = xO(i, e), r || (r = i.length > 1), i;
  }), wF(e, xF(e), n), r && (n = CF(n, Q5e | eLe | tLe, J5e));
  for (var o = t.length; o--; )
    U5e(n, t[o]);
  return n;
});
function rLe({
  chartType: e,
  dataOptions: t,
  enabled: n
}) {
  const [r, o] = Ge([]), i = We(() => {
    var p;
    const f = _a(e) && ((p = t.category) == null ? void 0 : p.length) === 1 || ca(e);
    return n && f;
  }, [n, e, t]), a = We(() => {
    if (r.length === 0)
      return (f) => ge(se({}, f), {
        series: f.series.map((p) => ge(se({}, p), {
          data: p.data.map((m) => ge(se({}, m), { selected: !1 }))
        }))
      });
    if (ca(e))
      return (f) => ge(se({}, f), {
        series: f.series.map((p) => ge(se({}, p), {
          data: p.data.map((m) => ge(se({}, m), {
            selected: !r.some(
              (v) => {
                var g, b;
                return v.x === m.x && v.y === m.y && v.size === m.z && v.breakByPoint === ((g = m.custom) == null ? void 0 : g.maskedBreakByPoint) && v.breakByColor === ((b = m.custom) == null ? void 0 : b.maskedBreakByColor);
              }
            )
          }))
        }))
      });
    {
      const f = r.reduce(
        (p, { categoryValue: m }) => (m && (p[`${m}`] = !0), p),
        {}
      );
      return (p) => ge(se({}, p), {
        series: p.series.map((m) => ge(se({}, m), {
          data: m.data.map(
            (v) => {
              var g, b;
              return (
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                f[(b = (g = v.custom) == null ? void 0 : g.xValue) == null ? void 0 : b[0]] ? v : ge(se({}, v), { selected: !0 })
              );
            }
          )
        }))
      });
    }
  }, [r, e]), s = We(
    () => (f) => {
      var p;
      return ge(se({}, f), {
        chart: ge(se({}, f.chart), {
          events: ge(se({}, (p = f.chart) == null ? void 0 : p.events), {
            click: () => {
              o([]);
            }
          })
        })
      });
    },
    []
  ), c = bt(
    (f) => (i && (f = a(f), f = s(f)), f),
    [a, s, i]
  ), l = bt(
    (f) => {
      i && o(f);
    },
    [i]
  ), d = bt(
    (f) => {
      i && o([f]);
    },
    [i]
  );
  return {
    onBeforeRender: c,
    onDataPointsSelected: l,
    onDataPointClick: d
  };
}
const oLe = () => {
  const e = Sg();
  if (!e)
    throw new vt("errors.missingMenuRoot");
  const { openMenu: t, closeMenu: n } = e;
  return {
    openMenu: t,
    closeMenu: n
  };
};
function s_(e) {
  return e && e.length ? X5(e) : [];
}
function iLe(e, t, n, r) {
  for (var o = -1, i = e == null ? 0 : e.length; ++o < i; ) {
    var a = e[o];
    t(r, a, n(a), e);
  }
  return r;
}
function aLe(e, t) {
  return function(n, r) {
    if (n == null)
      return n;
    if (!g_(n))
      return e(n, r);
    for (var o = n.length, i = -1, a = Object(n); ++i < o && r(a[i], i, a) !== !1; )
      ;
    return n;
  };
}
var sLe = aLe(CO);
function lLe(e, t, n, r) {
  return sLe(e, function(o, i, a) {
    t(r, o, n(o), a);
  }), r;
}
function K4(e, t) {
  return function(n, r) {
    var o = ph(n) ? iLe : lLe, i = t ? t() : {};
    return o(n, e, SO(r), i);
  };
}
var Zx = K4(function(e, t, n) {
  e[n ? 0 : 1].push(t);
}, function() {
  return [[], []];
});
const cLe = ({
  clearDrilldownSelections: e,
  currentDimension: t,
  setIsHovered: n,
  themeProps: r
}) => {
  const { t: o } = Bi(), i = t.name, a = Fo(mm)`
    && {
      background-color: ${r.activeDrillBackgroundColor};
      color: ${r.primaryButtonTextColor};
      border-radius: 100%;
      border: 2px solid white;
      min-width: 39px;
      width: 39px;
      height: 39px;
      z-index: 10;
      padding: 7px;
      cursor: pointer;
      text-transform: none;
      margin-right: -5px;

      &:hover {
        background-color: ${r.activeDrillHoverBackgroundColor};
        color: ${r.primaryTextColor};
      }
    }
  `, s = Fo.svg`
    width: 22px;
    height: 22px;
    fill: #9ea2ab;
  `, c = () => /* @__PURE__ */ z(
    a,
    {
      theme: r,
      onMouseEnter: () => n(!0),
      onMouseLeave: () => n(!1),
      onClick: e,
      children: /* @__PURE__ */ z(s, { width: 22, height: 22, viewBox: "0 0 24 24", children: /* @__PURE__ */ z(
        "path",
        {
          fill: "#9EA2AB",
          d: "M12 12.293L6.854 7.146a.5.5 0 1 0-.708.708L11.293 13l-5.147 5.146a.5.5 0 0 0 .708.708L12 13.707l5.146 5.147a.5.5 0 0 0 .708-.708L12.707 13l5.147-5.146a.5.5 0 0 0-.708-.708L12 12.293z"
        }
      ) })
    }
  ), l = Fo(mm)`
    && {
      position: relative;
      font-family: ${(f) => f.theme.fontFamily};
      border-radius: 0;
      border: 1px solid ${Ri};
      background-color: ${(f) => f.theme.chartBackgroundColor};
      border-right: none;
      border-left: none;
      color: ${(f) => f.theme.secondaryTextColor};
      padding-right: 1.25rem;
      padding-left: 1.875rem;
      height: 1.64rem;
      font-size: 13px;
      transition: background-color 0.2s, border-color 0.2s, color 0.2s;
      text-transform: none;
      cursor: auto;
      pointer-events: none;
      white-space: nowrap;

      &:hover {
        background-color: ${(f) => f.theme.chartBackgroundColor};
        border: 1px solid ${Ri};
        border-right: none;
        border-left: none;
      }
    }
  `;
  return { CancelButton: c, CurrentDrillButton: () => /* @__PURE__ */ _e(l, { theme: r, children: [
    i,
    " (",
    o("drilldown.breadcrumbsAllSuffix"),
    ")",
    /* @__PURE__ */ z("span", { className: "flex items-center justify-between", children: /* @__PURE__ */ z(
      "span",
      {
        className: "csdk-absolute csdk-right-[0px] csdk-top-[3px] csdk-h-[18px] csdk-w-[18px] csdk-transform csdk-translate-x-1/2 csdk-rotate-45",
        style: {
          backgroundColor: "transparent",
          borderTop: `1px solid ${Ri}`,
          borderRight: `1px solid ${Ri}`
        }
      }
    ) })
  ] }) };
}, uLe = {
  modifiers: [
    {
      name: "offset",
      options: {
        offset: [0, 12]
      }
    }
  ]
}, dLe = ({ themeProps: e, filterDisplayValues: t, currentTable: n, currentColumn: r }) => {
  const { t: o } = Bi();
  return /* @__PURE__ */ _e(
    "div",
    {
      className: "csdk-w-50 csdk-px-[12px] csdk-shadow-md csdk-shadow-gray-500 csdk-rounded-md csdk-bg-white",
      style: {
        backgroundColor: e.chartBackgroundColor,
        color: e.primaryTextColor
      },
      children: [
        /* @__PURE__ */ _e("div", { className: "csdk-border-b csdk-border-[#e4e4e4] csdk-p-3 csdk-pl-1", children: [
          /* @__PURE__ */ z(si, { variant: "body2", fontFamily: e.fontFamily, fontSize: 11, children: o("drilldown.popover.members") }),
          /* @__PURE__ */ z(si, { variant: "body2", fontFamily: e.fontFamily, fontSize: 13, children: t.join(", ") })
        ] }),
        /* @__PURE__ */ _e("div", { className: "csdk-border-b csdk-border-[#e4e4e4] csdk-p-3 csdk-pl-1", children: [
          /* @__PURE__ */ z(si, { variant: "body2", fontFamily: e.fontFamily, fontSize: 11, children: o("drilldown.popover.table") }),
          /* @__PURE__ */ z(si, { variant: "body2", fontFamily: e.fontFamily, fontSize: 13, children: n })
        ] }),
        /* @__PURE__ */ _e("div", { className: "csdk-p-3 csdk-pl-1", children: [
          /* @__PURE__ */ z(si, { variant: "body2", fontFamily: e.fontFamily, fontSize: 11, children: o("drilldown.popover.column") }),
          /* @__PURE__ */ z(si, { variant: "body2", fontFamily: e.fontFamily, fontSize: 13, children: r })
        ] })
      ]
    }
  );
}, fLe = ({
  popperParams: e,
  currentDimension: t,
  themeProps: n
}) => {
  const r = t.expression.match(/\[(.*?)]/), [o, i] = r ? r[1].split(".") : ["", ""];
  return /* @__PURE__ */ z(
    Hg,
    {
      open: !!e,
      anchorEl: e == null ? void 0 : e.anchorEl,
      placement: "bottom",
      popperOptions: uLe,
      children: e && /* @__PURE__ */ z(
        dLe,
        {
          themeProps: n,
          filterDisplayValues: e.filterDisplayValues,
          currentTable: o,
          currentColumn: i
        }
      )
    }
  );
}, pLe = () => {
  const {
    themeSettings: {
      typography: { primaryTextColor: e, secondaryTextColor: t, fontFamily: n },
      general: { backgroundColor: r, brandColor: o, primaryButtonTextColor: i },
      chart: { backgroundColor: a }
    }
  } = Yn(), s = hc(a, -0.02), c = hc(s, -0.05);
  return {
    primaryTextColor: e,
    secondaryTextColor: t,
    fontFamily: n,
    backgroundColor: r,
    brandColor: o,
    primaryButtonTextColor: i,
    chartBackgroundColor: a,
    activeDrillBackgroundColor: s,
    activeDrillHoverBackgroundColor: c
  };
}, hLe = Fo(ef)`
  && {
    position: absolute;
    left: 0;
    right: auto;
    margin: auto;
    bottom: 0;
    top: 0;
    z-index: 10;
    background: linear-gradient(to right, white 30%, rgba(255, 255, 255, 0) 100%);
    display: inline-flex;

    span[aria-label='prev-item'] {
      width: 0;
      height: 0;
      border-top: 6px solid transparent;
      border-bottom: 6px solid transparent;
      border-right: 5px solid #000;
      color: transparent;
      opacity: 0.3;

      &:hover {
        opacity: 0.8;
      }
    }
  }
`, mLe = Fo(ef)`
  && {
    position: absolute;
    left: auto;
    right: 0;
    margin: auto;
    bottom: 0;
    top: 0;
    z-index: 10;
    background: linear-gradient(to right, rgba(255, 255, 255, 0) 0, white 70%);
    display: inline-flex;

    span[aria-label='next-item'] {
      width: 0;
      height: 0;
      border-top: 6px solid transparent;
      border-bottom: 6px solid transparent;
      border-left: 5px solid #000;
      color: transparent;
      opacity: 0.3;

      &:hover {
        opacity: 0.8;
      }
    }
  }
`, gLe = ({
  currentDimension: e,
  children: t
}) => {
  const { t: n } = Bi(), r = it(null), [o, i] = Ge(0), [a, s] = Ge(0), [c, l] = Ge(0), d = () => {
    var v;
    return (v = r.current) == null ? void 0 : v.querySelector("ol");
  };
  mt(() => {
    const v = d();
    if (v) {
      const g = v.clientWidth, b = v.scrollWidth, x = v.scrollLeft;
      i(g), s(b), l(x);
    }
  }, [e]), mt(() => {
    const v = d();
    function g() {
      if (v) {
        const T = v.clientWidth;
        i(T);
      }
    }
    function b() {
      if (v) {
        const T = v.scrollLeft;
        l(T);
      }
    }
    const x = new ResizeObserver(g);
    return v ? (x.observe(v), v.addEventListener("scroll", b), () => {
      x.disconnect(), v.removeEventListener("scroll", b);
    }) : () => {
    };
  }, []);
  const f = (v) => {
    const b = "smooth", x = d();
    x && x.scrollBy({
      left: v === "right" ? 200 : -200,
      behavior: b
    });
  }, p = c != 0, m = Math.floor(a - c) > o;
  return /* @__PURE__ */ _e("div", { style: { position: "relative" }, children: [
    p && /* @__PURE__ */ z(hLe, { onClick: () => f("left"), children: /* @__PURE__ */ z("span", { "aria-label": "prev-item", children: n("drilldown.breadcrumbsPrev") }) }),
    m && /* @__PURE__ */ z(mLe, { onClick: () => f("right"), children: /* @__PURE__ */ z("span", { "aria-label": "next-item", children: n("drilldown.breadcrumbsNext") }) }),
    /* @__PURE__ */ z("div", { ref: r, children: t })
  ] });
}, Ri = "#F2F2F2", vLe = Fo(mm)`
  && {
    font-family: ${({ theme: e }) => e.fontFamily};
    position: relative;
    border-radius: 0;
    border: 1px solid ${Ri};
    border-right: none;
    color: ${({ active: e, theme: t }) => e === "true" ? t.primaryTextColor : t.secondaryTextColor};
    background-color: ${({ active: e, theme: t }) => e === "true" ? t.activeDrillBackgroundColor : t.chartBackgroundColor};
    padding-right: 1.25rem;
    padding-left: 1.875rem;
    height: 1.64rem;
    font-size: 13px;
    text-transform: none;
    transition: background-color 0.2s, border-color 0.2s, color 0.2s;
    white-space: nowrap;
    cursor: ${({ active: e }) => e === "true" ? "pointer" : "auto"};
    margin-right: ${({ active: e }) => e === "true" ? "5px" : "0px"};

    &:hover {
      background-color: ${({ active: e, theme: t }) => e === "true" ? t.activeDrillHoverBackgroundColor : t.chartBackgroundColor};
      border: 1px solid ${Ri};
      border-right: none;
    }

    .MuiTouchRipple-root {
      display: none;
    }
  }
`, bLe = Fo(P5)`
  .MuiBreadcrumbs-ol {
    flex-wrap: nowrap;
    overflow: hidden;
  }
  .MuiBreadcrumbs-separator {
    display: none;
  }
`, yLe = ({
  isActive: e,
  filterDisplayValue: t,
  handleMouseEnter: n,
  handleMouseLeave: r,
  handleClick: o,
  themeProps: i,
  popperParams: a,
  index: s
}) => /* @__PURE__ */ z(
  vLe,
  {
    theme: i,
    active: e.toString(),
    index: s,
    onMouseEnter: n,
    onMouseLeave: r,
    onClick: o,
    children: /* @__PURE__ */ _e("span", { className: "flex items-center justify-between", children: [
      /* @__PURE__ */ _e("span", { className: "mr-2", children: [
        t.slice(0, 2).join(", "),
        t.length > 2 && ", ..."
      ] }),
      e ? /* @__PURE__ */ z(
        "span",
        {
          className: "csdk-absolute csdk-right-0 csdk-h-[18px] csdk-w-[18px] csdk-top-[3px] csdk-translate-x-1/2 csdk-rotate-45",
          style: {
            backgroundColor: t === (a == null ? void 0 : a.filterDisplayValues) ? i.activeDrillHoverBackgroundColor : i.activeDrillBackgroundColor,
            borderTop: `1px solid ${Ri}`,
            borderRight: `1px solid ${Ri}`,
            transition: "background-color 0.2s, border-color 0.2s, color 0.2s",
            zIndex: 8
          }
        }
      ) : void 0,
      /* @__PURE__ */ z(
        "span",
        {
          className: `csdk-absolute ${e ? "csdk-h-[18px] csdk-w-[18px] csdk-top-[3px] csdk-right-[-15px]" : "csdk-h-[10px] csdk-w-[10px] csdk-top-[7px] csdk-right-[-5px]"} csdk-transform translate-x-1/2 csdk-rotate-45`,
          style: {
            backgroundColor: i.chartBackgroundColor,
            borderTop: `1px solid ${Ri}`,
            borderRight: `1px solid ${Ri}`,
            zIndex: 7,
            transition: "background-color 0.2s, border-color 0.2s, color 0.2s"
          }
        }
      )
    ] })
  }
), _Le = Jc({
  componentName: "DrilldownBreadcrumbs",
  shouldSkipSisenseContextWaiting: !0
})(
  ({
    filtersDisplayValues: e,
    currentDimension: t,
    clearDrilldownSelections: n,
    sliceDrilldownSelections: r
  }) => {
    const [o, i] = Ge(null), [a, s] = Ge(!1), c = pLe(), { CancelButton: l, CurrentDrillButton: d } = cLe({
      clearDrilldownSelections: n,
      currentDimension: t,
      isHovered: a,
      setIsHovered: s,
      themeProps: c
    }), f = (g) => (b) => {
      s(!0), i({
        filterDisplayValues: g,
        anchorEl: b.currentTarget
      });
    }, p = () => {
      s(!1), i(null);
    }, m = (g) => g < e.length - 1, v = (g) => g === e.length - 2;
    return e.length ? /* @__PURE__ */ z(gLe, { currentDimension: t, children: /* @__PURE__ */ _e(
      bLe,
      {
        separator: null,
        sx: { backgroundColor: c.chartBackgroundColor, padding: "4px" },
        children: [
          /* @__PURE__ */ z(l, {}),
          e.map((g, b) => {
            const x = m(b), T = v(b);
            return /* @__PURE__ */ z("div", { children: /* @__PURE__ */ z(
              yLe,
              {
                isActive: x,
                isLastActive: T,
                filterDisplayValue: g,
                handleMouseEnter: f(g),
                handleMouseLeave: p,
                handleClick: () => r(b + 1),
                themeProps: c,
                popperParams: o,
                index: b
              }
            ) }, b);
          }),
          /* @__PURE__ */ z(d, {}),
          /* @__PURE__ */ z(
            fLe,
            {
              popperParams: o,
              currentDimension: t,
              themeProps: c
            }
          )
        ]
      }
    ) }) : null;
  }
), b$e = (e) => {
  const t = wLe(e);
  return t.disabled = !e.disabled, t;
}, wLe = (e) => {
  const t = Li(e);
  return Object.setPrototypeOf(t, e), t;
};
function xLe(e, t, n) {
  return Sm(e, [], !1, n, void 0, t);
}
function CLe(e) {
  if (!TO(e))
    throw new vt("errors.notAMembersFilter");
  const { attribute: t, guid: n, backgroundFilter: r } = e;
  return xLe(t, r, n);
}
function SLe(e) {
  return "members" in e && e.members.length === 0;
}
function J4(e, t) {
  return ia(e.attribute, t.attribute);
}
function ia(e, t) {
  return e.expression === (t == null ? void 0 : t.expression) && e.granularity === t.granularity;
}
function TLe(e, { onLocalStateChange: t, syncCompareFn: n = Ic } = {}) {
  const [r, o] = Ge(e);
  mt(() => {
    o(
      (a) => (
        // Returns the existing state if the current value hasn't changed. It doesn't provide state update or children re-render.
        n(a, e) ? a : e
      )
    );
  }, [e, n]);
  const i = bt(
    (a) => {
      o((s) => {
        const c = Sd(a) ? a(s) : a;
        return t == null || t(c), c;
      });
    },
    [t]
  );
  return [r, i];
}
const ELe = (e) => {
  const { initialDimension: t, onDrilldownSelectionsChange: n } = e, r = We(() => e.drilldownPaths || [], [e.drilldownPaths]), o = We(
    () => e.drilldownSelections || [],
    [e.drilldownSelections]
  ), { t: i } = Bi();
  if (!t)
    throw new vt("errors.drilldownNoInitialDimension");
  const [a, s] = TLe(
    o,
    { onLocalStateChange: n }
  ), c = We(
    () => [
      ua(t),
      ...a.map(({ nextDimension: b }) => b)
    ],
    [t, a]
  ), l = We(() => r.filter((b) => {
    if (ci.isAttribute(b)) {
      const S = b;
      return c.every(
        (_) => !ia(_, S)
      );
    }
    const T = b;
    return c.every(
      (S, _) => ia(S, T.levels[_])
    );
  }), [r, c]), d = bt(
    (b, x, T) => {
      s((S) => {
        var N;
        if (!T)
          return [...S, { points: b, nextDimension: x }];
        if (ia(T.levels[0], x))
          return [];
        const w = S.findIndex(
          (F) => ia(F.nextDimension, x)
        );
        if (w !== -1)
          return S.slice(0, w + 1);
        const E = (N = Z4(S)) == null ? void 0 : N.nextDimension, R = S.length ? T.levels.findIndex(
          (F) => E && ia(F, E)
        ) : 0, P = T.levels.indexOf(x), D = T.levels.slice(
          R + 1,
          P + 1
        ).map((F, $) => ({
          points: $ === 0 ? b : [],
          nextDimension: F
        }));
        return [...S, ...D];
      });
    },
    [s]
  ), f = bt(
    (b) => {
      s((x) => x.slice(0, b));
    },
    [s]
  ), p = bt(() => {
    s([]);
  }, [s]), { drilldownFilters: m, drilldownFiltersDisplayValues: v, drilldownDimension: g } = We(
    () => kLe(a, t, i),
    [a, t, i]
  );
  return {
    drilldownSelections: a,
    availableDrilldownPaths: l,
    drilldownFilters: m,
    drilldownFiltersDisplayValues: v,
    drilldownDimension: g,
    selectDrilldown: d,
    sliceDrilldownSelections: f,
    clearDrilldownSelections: p
  };
}, kLe = (e, t, n) => {
  let r = t && ua(t);
  const o = [], i = [];
  return e.forEach(({ points: a, nextDimension: s }) => {
    o.push(
      Sm(
        r,
        a.map(MLe)
      )
    );
    const c = a.length ? a.map(Q4) : [`${r.name} (${n("drilldown.breadcrumbsAllSuffix")})`];
    i.push(c), r = s;
  }), {
    drilldownFilters: o,
    drilldownFiltersDisplayValues: i,
    drilldownDimension: r
  };
};
function Q4(e) {
  return "categoryDisplayValue" in e ? `${e.categoryDisplayValue}` : "categoryValue" in e ? `${e.categoryValue}` : "";
}
function MLe(e) {
  return "categoryValue" in e ? `${e.categoryValue}` : "";
}
var RLe = Object.prototype, PLe = RLe.hasOwnProperty, OLe = K4(function(e, t, n) {
  PLe.call(e, n) ? e[n].push(t) : SF(e, n, [t]);
});
function y$e(e, t) {
  return t.all ? [] : e.filter((n) => {
    var r;
    return !((r = t.ids) != null && r.includes(n.guid));
  });
}
function e6(e, t) {
  return e.find((n) => ia(n.attribute, t));
}
function t6(e, t, n) {
  const r = e6(n, e);
  return Sm(
    e,
    t.map((o) => `${o}`),
    !1,
    r == null ? void 0 : r.guid,
    void 0,
    r == null ? void 0 : r.backgroundFilter
  );
}
function NLe(e, t) {
  return J4(e, t) && "members" in e && "members" in t && Ic(e.members, t.members);
}
var rf = /* @__PURE__ */ ((e) => (e.DRILLDOWN_CHART_POINTS_SELECTION = "drilldown-chart-points-selection", e.DRILLDOWN_DRILL_DIRECTIONS = "drilldown-drill-directions", e.CROSSFILTERING_CHART_POINTS_SELECTION = "crossfiltering-chart-points-selection", e))(rf || {});
const n6 = 2;
function cu(e, t) {
  const n = e.flatMap(
    ({ entries: o = {} }) => t.flatMap((i) => {
      const a = o[i];
      return a ? (Array.isArray(a) ? a : [a]).filter(({ attribute: c }) => !!c) : [];
    })
  ), r = OLe(n, ({ id: o }) => o);
  return Object.values(r).map((o) => ({
    attribute: o[0].attribute,
    values: s_(o.map(({ value: i }) => i)),
    displayValues: s_(o.map(({ displayValue: i }) => i))
  }));
}
function ALe(e) {
  return cu(e, ["category"]);
}
function DLe(e) {
  return cu(e, ["category"]);
}
function ILe(e, t) {
  const n = cu(e, ["category"]), r = n.length - 1;
  return t.category.map((o, i) => r === i ? n[i] : {
    attribute: ua(o),
    values: [],
    displayValues: []
  });
}
function LLe(e) {
  return cu(e, ["x", "y", "breakByPoint", "breakByColor"]);
}
function $Le(e) {
  return cu(e, ["geo"]);
}
function FLe(e) {
  return cu(e, ["geo"]);
}
function zLe(e, t, n) {
  return e === "plugin" ? [] : e === "text" ? [] : e === "pivot" ? [] : e === "treemap" || e === "sunburst" ? ILe(
    n,
    t
  ) : _a(e) || e === "pie" || e === "funnel" ? ALe(n) : il(e) ? DLe(n) : ca(e) ? LLe(n) : Bc(e) ? $Le(n) : Hc(e) ? FLe(n) : [];
}
function r6(e, t) {
  let n = [];
  return e === "plugin" ? n = [] : e === "text" ? n = [] : e === "pivot" ? n = [
    ...t.rows || [],
    ...t.columns || []
  ] : _a(e) || zc(e) || il(e) || jc(e) ? n = [...t.category] : ca(e) ? n = [
    t.x,
    t.y,
    t.breakByPoint,
    t.breakByColor
  ].filter((r) => !!(r && !wr(r))) : (Bc(e) || Hc(e)) && (n = [...t.geo]), n.map(ua);
}
function BLe(e, t, n) {
  const r = e6(t, e.attribute);
  if (!r || SLe(r))
    return null;
  if (NLe(e, r))
    return CLe(e);
  if (TO(r) && n) {
    const [o, i] = Zx(
      r.members,
      (s) => e.members.includes(s)
    );
    if (o.length === e.members.length && i.length)
      return t6(e.attribute, i, [r]);
  }
  return null;
}
function HLe(e, t, n) {
  const r = t.filter((a) => !a.disabled), o = e.map(
    (a) => BLe(
      a,
      r,
      n
    )
  ).filter((a) => !!a), i = e.length !== o.length;
  return {
    filters: i ? e : o,
    isSelection: i
  };
}
function _$e(e, t, n = !1) {
  const r = e.map(
    ({ attribute: i, values: a }) => t6(i, a, t)
  ), o = jLe(
    t,
    r
  );
  return HLe(
    o,
    t,
    n
  );
}
function jLe(e, t) {
  const n = e.filter((r) => r.locked);
  return n.length ? t.filter(
    (r) => !n.some((o) => J4(o, r))
  ) : t;
}
function WLe(e, t, n) {
  const r = zLe(e, t, n).filter(({ displayValues: s }) => s.length);
  if (r.length === 0)
    return "";
  const [o] = r, i = n.length === 1, a = o.displayValues.length > n6;
  return r.length > 1 ? i ? r.map((s) => s.displayValues[0]).join(", ") : a ? "" : o.displayValues.join(", ") : a ? o.attribute.name : o.displayValues.join(", ");
}
function w$e(e, t, n) {
  const r = WLe(e, t, n);
  return r ? {
    id: rf.CROSSFILTERING_CHART_POINTS_SELECTION,
    sectionTitle: r
  } : null;
}
function x$e(e, t) {
  return {
    items: [
      {
        caption: e,
        onClick: t
      }
    ]
  };
}
const VLe = ({
  initialDimension: e,
  drilldownPaths: t,
  drilldownSelections: n,
  openMenu: r,
  onDrilldownSelectionsChange: o
}) => {
  const { t: i } = Bi(), {
    availableDrilldownPaths: a,
    drilldownFilters: s,
    drilldownFiltersDisplayValues: c,
    drilldownDimension: l,
    selectDrilldown: d,
    sliceDrilldownSelections: f,
    clearDrilldownSelections: p
  } = ELe({
    initialDimension: e,
    drilldownPaths: t,
    drilldownSelections: n,
    onDrilldownSelectionsChange: o
  }), m = bt(
    (g, b) => {
      const x = [
        ULe(b, l),
        GLe(
          a,
          l,
          (T, S) => {
            d(b, T, S);
          },
          i
        )
      ];
      r({ position: g, itemSections: x });
    },
    [l, a, i, d, r]
  ), v = We(() => l && /* @__PURE__ */ z(
    _Le,
    {
      filtersDisplayValues: c,
      currentDimension: l,
      clearDrilldownSelections: p,
      sliceDrilldownSelections: f
    }
  ), [
    p,
    l,
    c,
    f
  ]);
  return {
    drilldownDimension: l,
    drilldownFilters: s,
    breadcrumbs: v,
    openDrilldownMenu: m
  };
};
function ULe(e, t) {
  const n = s_(
    e.map(Q4).filter((r) => !!r)
  );
  return n.length > n6 ? {
    id: rf.DRILLDOWN_CHART_POINTS_SELECTION,
    sectionTitle: t.name
  } : {
    id: rf.DRILLDOWN_CHART_POINTS_SELECTION,
    sectionTitle: n.join(", ")
  };
}
function qLe(e) {
  return 30 + 12 * e;
}
function GLe(e, t, n, r) {
  const [o, i] = Zx(e, ci.isAttribute.bind(ci)), a = o.map((c) => ({
    caption: c.name,
    onClick: () => n(c)
  })), s = i.map((c) => ({
    caption: c.title,
    subItems: [
      {
        items: c.levels.map((l, d) => ({
          caption: l.name,
          class: d === 0 ? "" : "csdk-drilldown-hierarchy-nested-menu-item",
          style: {
            paddingLeft: `${qLe(d)}px`
          },
          disabled: ia(l, t),
          onClick: () => n(l, c)
        }))
      }
    ]
  }));
  return {
    id: rf.DRILLDOWN_DRILL_DIRECTIONS,
    sectionTitle: r("drilldown.drillMenuItem"),
    items: [...s, ...a]
  };
}
function YLe(e, t, n) {
  var r;
  return n(e, function(o, i, a) {
    if (t(o, i, a))
      return r = i, !1;
  }), r;
}
function ZLe(e, t) {
  return YLe(e, SO(t), CO);
}
function XLe(e) {
  return function(t) {
    t = lf(t);
    var n = H5(t) ? U1(t) : void 0, r = n ? n[0] : t.charAt(0), o = n ? B5(n, 1).join("") : t.slice(1);
    return r[e]() + o;
  };
}
var KLe = XLe("toUpperCase");
function JLe(e) {
  return KLe(lf(e).toLowerCase());
}
function QLe(e, t, n, r) {
  for (var o = -1, i = e == null ? 0 : e.length; ++o < i; )
    n = t(n, e[o], o, e);
  return n;
}
function e4e(e) {
  return function(t) {
    return e == null ? void 0 : e[t];
  };
}
var t4e = {
  // Latin-1 Supplement block.
  À: "A",
  Á: "A",
  Â: "A",
  Ã: "A",
  Ä: "A",
  Å: "A",
  à: "a",
  á: "a",
  â: "a",
  ã: "a",
  ä: "a",
  å: "a",
  Ç: "C",
  ç: "c",
  Ð: "D",
  ð: "d",
  È: "E",
  É: "E",
  Ê: "E",
  Ë: "E",
  è: "e",
  é: "e",
  ê: "e",
  ë: "e",
  Ì: "I",
  Í: "I",
  Î: "I",
  Ï: "I",
  ì: "i",
  í: "i",
  î: "i",
  ï: "i",
  Ñ: "N",
  ñ: "n",
  Ò: "O",
  Ó: "O",
  Ô: "O",
  Õ: "O",
  Ö: "O",
  Ø: "O",
  ò: "o",
  ó: "o",
  ô: "o",
  õ: "o",
  ö: "o",
  ø: "o",
  Ù: "U",
  Ú: "U",
  Û: "U",
  Ü: "U",
  ù: "u",
  ú: "u",
  û: "u",
  ü: "u",
  Ý: "Y",
  ý: "y",
  ÿ: "y",
  Æ: "Ae",
  æ: "ae",
  Þ: "Th",
  þ: "th",
  ß: "ss",
  // Latin Extended-A block.
  Ā: "A",
  Ă: "A",
  Ą: "A",
  ā: "a",
  ă: "a",
  ą: "a",
  Ć: "C",
  Ĉ: "C",
  Ċ: "C",
  Č: "C",
  ć: "c",
  ĉ: "c",
  ċ: "c",
  č: "c",
  Ď: "D",
  Đ: "D",
  ď: "d",
  đ: "d",
  Ē: "E",
  Ĕ: "E",
  Ė: "E",
  Ę: "E",
  Ě: "E",
  ē: "e",
  ĕ: "e",
  ė: "e",
  ę: "e",
  ě: "e",
  Ĝ: "G",
  Ğ: "G",
  Ġ: "G",
  Ģ: "G",
  ĝ: "g",
  ğ: "g",
  ġ: "g",
  ģ: "g",
  Ĥ: "H",
  Ħ: "H",
  ĥ: "h",
  ħ: "h",
  Ĩ: "I",
  Ī: "I",
  Ĭ: "I",
  Į: "I",
  İ: "I",
  ĩ: "i",
  ī: "i",
  ĭ: "i",
  į: "i",
  ı: "i",
  Ĵ: "J",
  ĵ: "j",
  Ķ: "K",
  ķ: "k",
  ĸ: "k",
  Ĺ: "L",
  Ļ: "L",
  Ľ: "L",
  Ŀ: "L",
  Ł: "L",
  ĺ: "l",
  ļ: "l",
  ľ: "l",
  ŀ: "l",
  ł: "l",
  Ń: "N",
  Ņ: "N",
  Ň: "N",
  Ŋ: "N",
  ń: "n",
  ņ: "n",
  ň: "n",
  ŋ: "n",
  Ō: "O",
  Ŏ: "O",
  Ő: "O",
  ō: "o",
  ŏ: "o",
  ő: "o",
  Ŕ: "R",
  Ŗ: "R",
  Ř: "R",
  ŕ: "r",
  ŗ: "r",
  ř: "r",
  Ś: "S",
  Ŝ: "S",
  Ş: "S",
  Š: "S",
  ś: "s",
  ŝ: "s",
  ş: "s",
  š: "s",
  Ţ: "T",
  Ť: "T",
  Ŧ: "T",
  ţ: "t",
  ť: "t",
  ŧ: "t",
  Ũ: "U",
  Ū: "U",
  Ŭ: "U",
  Ů: "U",
  Ű: "U",
  Ų: "U",
  ũ: "u",
  ū: "u",
  ŭ: "u",
  ů: "u",
  ű: "u",
  ų: "u",
  Ŵ: "W",
  ŵ: "w",
  Ŷ: "Y",
  ŷ: "y",
  Ÿ: "Y",
  Ź: "Z",
  Ż: "Z",
  Ž: "Z",
  ź: "z",
  ż: "z",
  ž: "z",
  Ĳ: "IJ",
  ĳ: "ij",
  Œ: "Oe",
  œ: "oe",
  ŉ: "'n",
  ſ: "s"
}, n4e = e4e(t4e), r4e = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, o4e = "\\u0300-\\u036f", i4e = "\\ufe20-\\ufe2f", a4e = "\\u20d0-\\u20ff", s4e = o4e + i4e + a4e, l4e = "[" + s4e + "]", c4e = RegExp(l4e, "g");
function u4e(e) {
  return e = lf(e), e && e.replace(r4e, n4e).replace(c4e, "");
}
var d4e = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
function f4e(e) {
  return e.match(d4e) || [];
}
var p4e = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
function h4e(e) {
  return p4e.test(e);
}
var o6 = "\\ud800-\\udfff", m4e = "\\u0300-\\u036f", g4e = "\\ufe20-\\ufe2f", v4e = "\\u20d0-\\u20ff", b4e = m4e + g4e + v4e, i6 = "\\u2700-\\u27bf", a6 = "a-z\\xdf-\\xf6\\xf8-\\xff", y4e = "\\xac\\xb1\\xd7\\xf7", _4e = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", w4e = "\\u2000-\\u206f", x4e = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", s6 = "A-Z\\xc0-\\xd6\\xd8-\\xde", C4e = "\\ufe0e\\ufe0f", l6 = y4e + _4e + w4e + x4e, c6 = "['’]", DP = "[" + l6 + "]", S4e = "[" + b4e + "]", u6 = "\\d+", T4e = "[" + i6 + "]", d6 = "[" + a6 + "]", f6 = "[^" + o6 + l6 + u6 + i6 + a6 + s6 + "]", E4e = "\\ud83c[\\udffb-\\udfff]", k4e = "(?:" + S4e + "|" + E4e + ")", M4e = "[^" + o6 + "]", p6 = "(?:\\ud83c[\\udde6-\\uddff]){2}", h6 = "[\\ud800-\\udbff][\\udc00-\\udfff]", Kl = "[" + s6 + "]", R4e = "\\u200d", IP = "(?:" + d6 + "|" + f6 + ")", P4e = "(?:" + Kl + "|" + f6 + ")", LP = "(?:" + c6 + "(?:d|ll|m|re|s|t|ve))?", $P = "(?:" + c6 + "(?:D|LL|M|RE|S|T|VE))?", m6 = k4e + "?", g6 = "[" + C4e + "]?", O4e = "(?:" + R4e + "(?:" + [M4e, p6, h6].join("|") + ")" + g6 + m6 + ")*", N4e = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", A4e = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", D4e = g6 + m6 + O4e, I4e = "(?:" + [T4e, p6, h6].join("|") + ")" + D4e, L4e = RegExp([
  Kl + "?" + d6 + "+" + LP + "(?=" + [DP, Kl, "$"].join("|") + ")",
  P4e + "+" + $P + "(?=" + [DP, Kl + IP, "$"].join("|") + ")",
  Kl + "?" + IP + "+" + LP,
  Kl + "+" + $P,
  A4e,
  N4e,
  u6,
  I4e
].join("|"), "g");
function $4e(e) {
  return e.match(L4e) || [];
}
function F4e(e, t, n) {
  return e = lf(e), t = t, t === void 0 ? h4e(e) ? $4e(e) : f4e(e) : e.match(t) || [];
}
var z4e = "['’]", B4e = RegExp(z4e, "g");
function H4e(e) {
  return function(t) {
    return QLe(F4e(u4e(t).replace(B4e, "")), e, "");
  };
}
var v6 = H4e(function(e, t, n) {
  return t = t.toLowerCase(), e + (n ? JLe(t) : t);
});
function Xx(e, t) {
  var l, d, f, p;
  const n = "formula" in e, r = "datasource" in e ? e.datasource : void 0;
  let o;
  if (e.sort && (o = e.sort === "asc" ? ts.Ascending : ts.Descending), n) {
    const m = TF((l = e.context) != null ? l : {}, (v) => typeof v == "string" ? v : v && Xx(v));
    return new EF(
      e.title,
      e.formula,
      m,
      void 0,
      void 0,
      o
    );
  }
  const i = !!e.agg, a = e.datatype === VC.DATETIME, s = e.datatype === VC.NUMERIC ? ci.NumericAttribute : ci.TextAttribute, c = a ? new jC(
    e.title,
    e.dim,
    jC.translateJaqlToGranularity(e),
    (p = (d = t == null ? void 0 : t.mask) == null ? void 0 : d[e.level]) != null ? p : (f = t == null ? void 0 : t.mask) == null ? void 0 : f.dateAndTime,
    void 0,
    o
  ) : new kF(e.title, e.dim, s, void 0, o, r);
  return i ? new WC(
    e.title,
    c,
    WC.aggregationFromJAQL(e.agg || ""),
    void 0,
    void 0,
    o
  ) : "filter" in e ? MF(e) : c;
}
function j4e(e) {
  return e.percent || e.type === "percent" ? "Percent" : e.currency ? "Currency" : "Numbers";
}
function W4e(e) {
  return e.decimals !== void 0 && e.decimals !== "auto" ? typeof e.decimals == "string" ? Number.parseFloat(e.decimals) : e.decimals : "auto";
}
function V4e(e) {
  var r, o, i, a, s, c, l, d, f;
  const t = e.jaql.datatype === "numeric" || "context" in e.jaql, n = (r = e.format) == null ? void 0 : r.mask;
  return t && n ? {
    decimalScale: W4e(n),
    kilo: (o = n.abbreviations) == null ? void 0 : o.k,
    million: (i = n.abbreviations) == null ? void 0 : i.m,
    billion: (a = n.abbreviations) == null ? void 0 : a.b,
    trillion: (s = n.abbreviations) == null ? void 0 : s.t,
    thousandSeparator: (l = (c = n.number) == null ? void 0 : c.separated) != null ? l : n.separated,
    prefix: ((d = n.currency) == null ? void 0 : d.position) === OF.PRE,
    symbol: (f = n.currency) == null ? void 0 : f.symbol,
    name: j4e(n)
  } : null;
}
const U4e = !0;
function q4e(e, t) {
  if (!t || !U4e)
    return e;
  const { forecast: n, trend: r } = t;
  let o = se({}, e);
  return n && !n.isViewerDisabled && n.isEnabled && (o = ge(se({}, o), {
    forecast: {
      confidenceInterval: n.confidence / 100,
      forecastHorizon: n.forecastPeriod,
      modelType: "auto"
    }
  })), r && !r.isViewerDisabled && r.isEnabled && (o = ge(se({}, o), {
    trend: {
      modelType: r.trendType
    }
  })), o;
}
function ym(e, t) {
  var c, l, d, f, p, m, v;
  const n = Xx(e.jaql, e.format), r = kO((c = e.jaql.sort) != null ? c : e.categoriesSorting), o = V4e(e), i = (l = e.format) == null ? void 0 : l.subtotal, a = (d = e.format) == null ? void 0 : d.width;
  let s = j1((f = e.format) == null ? void 0 : f.color, t);
  if (!s && !((p = e.format) != null && p.color) && e.format && "colorIndex" in e.format && (s = j1(
    {
      type: "color",
      colorIndex: e.format.colorIndex
    },
    t
  )), ci.isMeasure(n)) {
    const g = e.y2, b = e.singleSeriesType, x = "subtotalAgg" in e.jaql && e.jaql.subtotalAgg, T = (m = e.format) == null ? void 0 : m.databars, S = se(se(se(se(se(se(se(se({
      column: n
    }, s && { color: s }), g && { showOnRightAxis: g }), r && { sortType: r }), b && { chartType: b }), o && { numberFormatConfig: o }), x && { totalsCalculation: x }), T && { dataBars: T }), a && { width: a });
    return q4e(S, e.statisticalModels);
  }
  return se(se(se(se(se({
    column: n,
    isColored: (v = e.isColored) != null ? v : !1
  }, r && { sortType: r }), o && { numberFormatConfig: o }), i && { includeSubTotals: i }), a && { width: a }), s && { color: s });
}
function C$e(e) {
  const t = e.column;
  let n;
  if (ci.isFilter(t))
    n = t.filterJaql();
  else if (ci.isAttribute(t))
    n = t.jaql(!0);
  else if (ci.isMeasure(t))
    n = t.jaql(!0);
  else
    throw new vt("errors.unsupportedDimensionalElement");
  return {
    jaql: n
    // TODO: add format
  };
}
const S$e = (e, t) => {
  const n = {};
  return e.forEach((r) => {
    r.name !== "filters" && (n[v6(r.name)] = nn(
      e,
      r.name,
      t
    ));
  }), n;
};
function l_(e, t, n) {
  return qa(e, t).map(EO).map(n);
}
function nn(e, t, n) {
  return l_(
    e,
    t,
    (r) => ym(r, n)
  );
}
function G4e(e, t, n) {
  var d, f;
  const o = ["chart/line", "chart/area"].includes(t) ? "x-axis" : "categories", i = nn(
    e,
    o,
    n
  ), a = nn(e, "values", n), s = nn(e, "break by", n), c = (f = (d = qa(e, "break by")[0]) == null ? void 0 : d.format) == null ? void 0 : f.members, l = c && jg(c);
  return se({
    category: i,
    value: a,
    breakBy: s
  }, l && { seriesToColorMap: l });
}
function Y4e(e, t, n) {
  var c, l, d, f;
  const r = nn(
    t,
    "categories",
    n
  ), o = nn(
    t,
    "values",
    n
  ), i = nn(
    t,
    "size",
    n
  );
  let a, s;
  return e === "sunburst" ? s = O_e(
    qa(t, "categories")
  ) : (a = (l = (c = qa(t, "categories")[0]) == null ? void 0 : c.format) == null ? void 0 : l.members, qa(t, "color").length && (a = (f = (d = qa(t, "color")[0]) == null ? void 0 : d.format) == null ? void 0 : f.members), s = a && jg(a)), se({
    category: r,
    value: [...o, ...i]
  }, s && { seriesToColorMap: s });
}
function Z4e(e, t) {
  var l, d;
  const [n] = nn(e, "x-axis", t), [r] = nn(e, "y-axis", t), [o] = nn(e, "point", t), [i] = nn(e, "Break By / Color", t), [a] = nn(e, "size", t), s = (d = (l = qa(e, "Break By / Color")[0]) == null ? void 0 : l.format) == null ? void 0 : d.members, c = s && jg(s);
  return se({
    x: n,
    y: r,
    breakByPoint: o,
    breakByColor: i,
    size: a
  }, c && { seriesToColorMap: c });
}
function X4e(e, t) {
  const n = nn(e, "value", t), r = nn(
    e,
    "secondary",
    t
  ), o = nn(e, "min", t), i = nn(e, "max", t);
  return {
    value: n,
    secondary: r,
    min: o,
    max: i
  };
}
function K4e(e, t) {
  return {
    columns: nn(e, "columns", t)
  };
}
function J4e(e, t, n) {
  let r;
  const o = {}, i = nn(e, "columns", n), a = l_(e, "values", (c, l) => {
    const { field: d, jaql: f } = c, { sortDetails: p } = f;
    return p && (r = p), d && (o[d.index] = l), ym(c, n);
  });
  return {
    rows: l_(e, "rows", (c, l, d) => {
      var g;
      const f = l === d.length - 1;
      let { sortDetails: p } = c == null ? void 0 : c.jaql;
      const m = ym(c, n);
      m.column = m.column.sort(ts.None), f && r && (p = r);
      const v = (p == null ? void 0 : p.field) !== ((g = c.field) == null ? void 0 : g.index);
      return p && (m.sortType = se({
        direction: kO(p.dir)
      }, v && {
        by: {
          valuesIndex: o[p.field],
          columnsMembersPath: Object.values(p.measurePath || {})
        }
      })), m;
    }),
    columns: i,
    values: a,
    grandTotals: {
      rows: t.rowsGrandTotal,
      columns: t.columnsGrandTotal
    }
  };
}
function Q4e(e) {
  const t = {
    "whisker/iqr": "iqr",
    "whisker/extremums": "extremums",
    "whisker/deviation": "standardDeviation"
  }, n = ZLe(
    e.whisker,
    (r) => r
  );
  return t[n];
}
function e6e(e, t, n) {
  const r = nn(e, "category", n), o = nn(e, "value", n), i = Q4e(t), a = t.outliers.enabled;
  return {
    category: r,
    value: o,
    boxType: i,
    outliersEnabled: a
  };
}
function t6e(e, t) {
  return qa(e, "geo").map(EO).map((n) => {
    const r = ym(n, t);
    return "geoLevel" in n ? ge(se({}, r), {
      level: n.geoLevel
    }) : r;
  });
}
function n6e(e, t) {
  const n = t6e(e, t), r = nn(e, "size", t)[0], o = nn(
    e,
    "color",
    t
  )[0], i = nn(e, "details", t)[0];
  return {
    geo: n,
    size: r,
    colorBy: o,
    details: i
  };
}
function r6e(e, t) {
  const n = [
    nn(e, "geo", t)[0]
  ], r = nn(e, "color", t)[0];
  return se({
    geo: n
  }, r && { color: [r] });
}
function c_(e, t) {
  const n = "dim" in e.jaql ? ge(se({}, e), {
    jaql: ge(se({}, e.jaql), {
      datasource: t
    })
  }) : e, r = e.parent ? c_(e.parent, t) : void 0, o = e.through ? c_(e.through, t) : void 0;
  return ge(se({}, n), {
    parent: r,
    through: o
  });
}
function T$e(e, t) {
  return e.map((n) => ge(se({}, n), {
    items: n.items.map((r) => c_(r, t))
  }));
}
function E$e(e, t, n, r) {
  if (o6e(e))
    return G4e(t, e, r);
  if (i6e(e))
    return Y4e(e, t, r);
  if (e === "chart/scatter")
    return Z4e(t, r);
  if (e === "indicator")
    return X4e(t, r);
  if (RF(e))
    return K4e(t, r);
  if (PF(e))
    return J4e(
      t,
      n,
      r
    );
  if (e === "chart/boxplot")
    return e6e(t, n, r);
  if (e === "map/scatter")
    return n6e(t, r);
  if (e === "map/area")
    return r6e(t, r);
  if (e === "richtexteditor")
    return {};
  throw new vt("errors.unsupportedWidgetType", { widgetType: e });
}
function o6e(e) {
  return ["chart/line", "chart/area", "chart/bar", "chart/column", "chart/polar"].includes(
    e
  );
}
function i6e(e) {
  return ["chart/pie", "chart/funnel", "treemap", "sunburst"].includes(e);
}
function a6e(e) {
  const { _id: t, title: n, levels: r } = e;
  return {
    id: t,
    title: n,
    levels: r.map((o) => Xx(o))
  };
}
function s6e(e, t, n) {
  return Mo(this, null, function* () {
    const o = yield new dL(e, n).getHierarchies(t);
    return o == null ? void 0 : o.map(
      (i) => a6e(i)
    );
  });
}
const k$e = z5e("useGetHierarchyModels")(
  b6
);
function b6(e) {
  const t = $5e(e, [
    "dataSource",
    "dimension",
    "ids",
    "alwaysIncluded"
  ]), n = W5e(e, t), [r, o] = E$(AP, {
    isLoading: !0,
    isError: !1,
    isSuccess: !1,
    status: "loading",
    error: void 0,
    data: void 0
  }), { isInitialized: i, app: a } = Gn();
  return mt(() => {
    i || o({
      type: "error",
      error: new vt("errors.sisenseContextNotFound")
    }), n(a) && (o({ type: "loading" }), s6e(a.httpClient, e, a.defaultDataSource).then((s) => {
      o({ type: "success", data: s });
    }).catch((s) => {
      o({ type: "error", error: s });
    }));
  }, [a, i, e, n]), r.data && t ? FP(AP(r, { type: "loading" })) : FP(r);
}
function FP(e) {
  const r = e, { data: t } = r, n = xl(r, ["data"]);
  return ge(se({}, n), {
    hierarchies: t
  });
}
function l6e({
  attribute: e,
  dataSource: t,
  drilldownPaths: n = [],
  enabled: r
}) {
  const [o, i] = We(() => Zx(n, L5e), [n]), { hierarchies: a = [] } = b6({
    enabled: r,
    dataSource: t,
    dimension: e,
    ids: o,
    alwaysIncluded: !0
  });
  return We(
    () => a.length ? [...a, ...i] : i,
    [a, i]
  );
}
function c6e(e, t) {
  return r6(e, t)[0];
}
function u6e(e) {
  return [
    ...hO,
    ...mO,
    ...gO,
    ...vO,
    ...bO
  ].includes(e);
}
function d6e(e, t) {
  return r6(e, t).length === 1;
}
function f6e(e, t) {
  return d6e(e, t) && u6e(e);
}
function p6e(e, t, n) {
  const r = (o) => !!o && !ia(n, ua(o));
  if (_a(e) || zc(e) || il(e) || jc(e)) {
    const o = t.category[0];
    if (r(o))
      return ge(se({}, t), {
        category: [n]
      });
  } else if (ca(e)) {
    const o = t, i = ["x", "y", "breakByPoint", "breakByColor"];
    for (const a of i) {
      const s = o[a];
      if (s && !wr(s) && r(s))
        return ge(se({}, o), {
          [a]: n
        });
    }
  }
  return t;
}
function zP(e, t, n) {
  return e.map((r) => {
    const o = ["x", "y", "breakByPoint", "breakByColor"], i = [...o, "size"].some(
      (s) => s in r
    ), a = o.find(
      (s) => n[s] && !wr(n[s])
    );
    if (i) {
      const s = t, c = s.type === "mouseup";
      c && console.warn("No drilldown support for multi-selection in scatter chart");
      const l = c ? r[a] : s.point.options.custom[v6(`{masked ${a}`)];
      return {
        categoryValue: l,
        categoryDisplayValue: l
      };
    }
    return r;
  });
}
const h6e = ({
  propsToExtend: e,
  onDrilldownSelectionsChange: t
}) => {
  const { chartType: n, dataOptions: r, dataSource: o, drilldownOptions: i } = e, { drilldownSelections: a } = i || {}, { openMenu: s } = oLe(), c = We(
    () => f6e(n, r),
    [n, r]
  ), l = We(
    () => [
      ...(i == null ? void 0 : i.drilldownPaths) || [],
      ...(i == null ? void 0 : i.drilldownDimensions) || []
    ],
    [i == null ? void 0 : i.drilldownPaths, i == null ? void 0 : i.drilldownDimensions]
  ), d = We(() => {
    const R = NF({ name: "dummy drilldown initial attribute" });
    return c6e(n, r) || R;
  }, [n, r]), f = l6e({
    attribute: d,
    dataSource: o,
    drilldownPaths: l,
    enabled: c
  }), p = We(() => {
    var P, A;
    return (((P = i == null ? void 0 : i.drilldownSelections) == null ? void 0 : P.length) || ((A = i == null ? void 0 : i.drilldownDimensions) == null ? void 0 : A.length) || (f == null ? void 0 : f.length)) && c;
  }, [i, c, f]), { drilldownDimension: m, drilldownFilters: v, breadcrumbs: g, openDrilldownMenu: b } = VLe({
    initialDimension: d,
    drilldownSelections: a,
    drilldownPaths: f,
    openMenu: s,
    onDrilldownSelectionsChange: t
  }), x = bt(
    (R, P) => {
      const A = zP(R, P, r);
      b(
        {
          left: P.clientX,
          top: P.clientY
        },
        A
      );
    },
    [r, b]
  ), T = bt(
    (R, P) => {
      const A = zP([R], P, r);
      b(
        {
          left: P.clientX,
          top: P.clientY
        },
        A
      );
    },
    [r, b]
  ), S = We(() => p6e(n, r, m), [n, r, m]), _ = We(() => v.length ? (
    // todo: cover filter relations case
    pO(e.filters, v)
  ) : e.filters, [e.filters, v]), w = We(
    () => cd([x, e.onDataPointsSelected]),
    [x, e.onDataPointsSelected]
  ), k = We(
    () => cd([T, e.onDataPointContextMenu]),
    [T, e.onDataPointContextMenu]
  );
  return {
    propsWithDrilldown: se(se({}, e), p && {
      dataOptions: S,
      filters: _,
      onDataPointsSelected: w,
      onDataPointContextMenu: k
    }),
    isDrilldownEnabled: p,
    breadcrumbs: g
  };
}, M$e = Jc({
  componentName: "ChartWidget"
})((e) => {
  var R, P;
  const { app: t } = Gn(), {
    chartType: n,
    dataSource: r = t == null ? void 0 : t.defaultDataSource,
    dataOptions: o,
    styleOptions: i,
    highlightSelectionDisabled: a = !1,
    highlights: s,
    description: c,
    onChange: l
  } = e, { width: d, height: f } = i || {}, p = uL(n, {
    hasHeader: !((R = i == null ? void 0 : i.header) != null && R.hidden)
  }), [m, v] = Ge(0), g = We(
    () => nLe(i, ["width", "height"]),
    [i]
  ), b = bt(
    (A) => {
      l == null || l({
        drilldownOptions: {
          drilldownSelections: A
        }
      });
    },
    [l]
  ), { propsWithDrilldown: x, isDrilldownEnabled: T, breadcrumbs: S } = h6e({
    propsToExtend: e,
    onDrilldownSelectionsChange: b
  }), _ = rLe({
    chartType: n,
    dataOptions: o,
    enabled: !a && !T && !(s != null && s.length)
  }), w = (P = t == null ? void 0 : t.settings.accessibilityConfig) == null ? void 0 : P.enabled, k = bt(
    (A) => {
      var D;
      return w ? ge(se({}, A), {
        accessibility: ge(se({}, A.accessibility), {
          description: c != null ? c : (D = A.accessibility) == null ? void 0 : D.description
        })
      }) : A;
    },
    [c, w]
  );
  if (!n || !o)
    return null;
  const E = ge(se({}, x), {
    dataSet: r,
    styleOptions: g,
    refreshCounter: m,
    onDataPointClick: We(
      () => cd([_.onDataPointClick, e.onDataPointClick]),
      [_.onDataPointClick, e.onDataPointClick]
    ),
    onDataPointContextMenu: x.onDataPointContextMenu,
    onDataPointsSelected: We(
      () => cd([
        _.onDataPointsSelected,
        x.onDataPointsSelected
      ]),
      [_.onDataPointsSelected, x.onDataPointsSelected]
    ),
    onBeforeRender: We(
      () => cd(
        [
          k,
          _.onBeforeRender,
          e.onBeforeRender
        ],
        !0
      ),
      [
        k,
        _.onBeforeRender,
        e.onBeforeRender
      ]
    )
  });
  return /* @__PURE__ */ z(
    Vg,
    {
      defaultSize: p,
      size: {
        width: d,
        height: f
      },
      children: /* @__PURE__ */ z(
        G4,
        ge(se({}, e), {
          topSlot: /* @__PURE__ */ _e(fo, { children: [
            e.topSlot,
            S
          ] }),
          dataSetName: r && y_(r),
          onRefresh: () => v(m + 1),
          children: /* @__PURE__ */ z(M5e, se({}, E))
        })
      )
    }
  );
});
var xb = function() {
  return AF.Date.now();
}, m6e = "Expected a function", g6e = Math.max, v6e = Math.min;
function R$e(e, t, n) {
  var r, o, i, a, s, c, l = 0, d = !1, f = !1, p = !0;
  if (typeof e != "function")
    throw new TypeError(m6e);
  t = Tb(t) || 0, eO(n) && (d = !!n.leading, f = "maxWait" in n, i = f ? g6e(Tb(n.maxWait) || 0, t) : i, p = "trailing" in n ? !!n.trailing : p);
  function m(k) {
    var E = r, R = o;
    return r = o = void 0, l = k, a = e.apply(R, E), a;
  }
  function v(k) {
    return l = k, s = setTimeout(x, t), d ? m(k) : a;
  }
  function g(k) {
    var E = k - c, R = k - l, P = t - E;
    return f ? v6e(P, i - R) : P;
  }
  function b(k) {
    var E = k - c, R = k - l;
    return c === void 0 || E >= t || E < 0 || f && R >= i;
  }
  function x() {
    var k = xb();
    if (b(k))
      return T(k);
    s = setTimeout(x, g(k));
  }
  function T(k) {
    return s = void 0, p && r ? m(k) : (r = o = void 0, a);
  }
  function S() {
    s !== void 0 && clearTimeout(s), l = 0, r = c = o = s = void 0;
  }
  function _() {
    return s === void 0 ? a : T(xb());
  }
  function w() {
    var k = xb(), E = b(k);
    if (r = arguments, o = this, c = k, E) {
      if (s === void 0)
        return v(c);
      if (f)
        return clearTimeout(s), s = setTimeout(x, t), m(c);
    }
    return s === void 0 && (s = setTimeout(x, t)), a;
  }
  return w.cancel = S, w.flush = _, w;
}
class Lf {
  constructor() {
    this.listeners = /* @__PURE__ */ new Set(), this.subscribe = this.subscribe.bind(this);
  }
  subscribe(t) {
    const n = {
      listener: t
    };
    return this.listeners.add(n), this.onSubscribe(), () => {
      this.listeners.delete(n), this.onUnsubscribe();
    };
  }
  hasListeners() {
    return this.listeners.size > 0;
  }
  onSubscribe() {
  }
  onUnsubscribe() {
  }
}
const of = typeof window == "undefined" || "Deno" in window;
function Ao() {
}
function b6e(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function u_(e) {
  return typeof e == "number" && e >= 0 && e !== 1 / 0;
}
function y6(e, t) {
  return Math.max(e + (t || 0) - Date.now(), 0);
}
function id(e, t, n) {
  return $f(e) ? typeof t == "function" ? ge(se({}, n), {
    queryKey: e,
    queryFn: t
  }) : ge(se({}, t), {
    queryKey: e
  }) : e;
}
function P$e(e, t, n) {
  return $f(e) ? ge(se({}, t), {
    mutationKey: e
  }) : typeof e == "function" ? ge(se({}, t), {
    mutationFn: e
  }) : se({}, e);
}
function ja(e, t, n) {
  return $f(e) ? [ge(se({}, t), {
    queryKey: e
  }), n] : [e || {}, t];
}
function BP(e, t) {
  const {
    type: n = "all",
    exact: r,
    fetchStatus: o,
    predicate: i,
    queryKey: a,
    stale: s
  } = e;
  if ($f(a)) {
    if (r) {
      if (t.queryHash !== Kx(a, t.options))
        return !1;
    } else if (!sc(t.queryKey, a))
      return !1;
  }
  if (n !== "all") {
    const c = t.isActive();
    if (n === "active" && !c || n === "inactive" && c)
      return !1;
  }
  return !(typeof s == "boolean" && t.isStale() !== s || typeof o != "undefined" && o !== t.state.fetchStatus || i && !i(t));
}
function HP(e, t) {
  const {
    exact: n,
    fetching: r,
    predicate: o,
    mutationKey: i
  } = e;
  if ($f(i)) {
    if (!t.options.mutationKey)
      return !1;
    if (n) {
      if (Ws(t.options.mutationKey) !== Ws(i))
        return !1;
    } else if (!sc(t.options.mutationKey, i))
      return !1;
  }
  return !(typeof r == "boolean" && t.state.status === "loading" !== r || o && !o(t));
}
function Kx(e, t) {
  return ((t == null ? void 0 : t.queryKeyHashFn) || Ws)(e);
}
function Ws(e) {
  return JSON.stringify(e, (t, n) => f_(n) ? Object.keys(n).sort().reduce((r, o) => (r[o] = n[o], r), {}) : n);
}
function sc(e, t) {
  return _6(e, t);
}
function _6(e, t) {
  return e === t ? !0 : typeof e != typeof t ? !1 : e && t && typeof e == "object" && typeof t == "object" ? !Object.keys(t).some((n) => !_6(e[n], t[n])) : !1;
}
function w6(e, t) {
  if (e === t)
    return e;
  const n = jP(e) && jP(t);
  if (n || f_(e) && f_(t)) {
    const r = n ? e.length : Object.keys(e).length, o = n ? t : Object.keys(t), i = o.length, a = n ? [] : {};
    let s = 0;
    for (let c = 0; c < i; c++) {
      const l = n ? c : o[c];
      a[l] = w6(e[l], t[l]), a[l] === e[l] && s++;
    }
    return r === i && s === r ? e : a;
  }
  return t;
}
function d_(e, t) {
  if (e && !t || t && !e)
    return !1;
  for (const n in e)
    if (e[n] !== t[n])
      return !1;
  return !0;
}
function jP(e) {
  return Array.isArray(e) && e.length === Object.keys(e).length;
}
function f_(e) {
  if (!WP(e))
    return !1;
  const t = e.constructor;
  if (typeof t == "undefined")
    return !0;
  const n = t.prototype;
  return !(!WP(n) || !n.hasOwnProperty("isPrototypeOf"));
}
function WP(e) {
  return Object.prototype.toString.call(e) === "[object Object]";
}
function $f(e) {
  return Array.isArray(e);
}
function x6(e) {
  return new Promise((t) => {
    setTimeout(t, e);
  });
}
function VP(e) {
  x6(0).then(e);
}
function y6e() {
  if (typeof AbortController == "function")
    return new AbortController();
}
function p_(e, t, n) {
  return n.isDataEqual != null && n.isDataEqual(e, t) ? e : typeof n.structuralSharing == "function" ? n.structuralSharing(e, t) : n.structuralSharing !== !1 ? w6(e, t) : t;
}
class _6e extends Lf {
  constructor() {
    super(), this.setup = (t) => {
      if (!of && window.addEventListener) {
        const n = () => t();
        return window.addEventListener("visibilitychange", n, !1), window.addEventListener("focus", n, !1), () => {
          window.removeEventListener("visibilitychange", n), window.removeEventListener("focus", n);
        };
      }
    };
  }
  onSubscribe() {
    this.cleanup || this.setEventListener(this.setup);
  }
  onUnsubscribe() {
    if (!this.hasListeners()) {
      var t;
      (t = this.cleanup) == null || t.call(this), this.cleanup = void 0;
    }
  }
  setEventListener(t) {
    var n;
    this.setup = t, (n = this.cleanup) == null || n.call(this), this.cleanup = t((r) => {
      typeof r == "boolean" ? this.setFocused(r) : this.onFocus();
    });
  }
  setFocused(t) {
    this.focused !== t && (this.focused = t, this.onFocus());
  }
  onFocus() {
    this.listeners.forEach(({
      listener: t
    }) => {
      t();
    });
  }
  isFocused() {
    return typeof this.focused == "boolean" ? this.focused : typeof document == "undefined" ? !0 : [void 0, "visible", "prerender"].includes(document.visibilityState);
  }
}
const _m = new _6e(), UP = ["online", "offline"];
class w6e extends Lf {
  constructor() {
    super(), this.setup = (t) => {
      if (!of && window.addEventListener) {
        const n = () => t();
        return UP.forEach((r) => {
          window.addEventListener(r, n, !1);
        }), () => {
          UP.forEach((r) => {
            window.removeEventListener(r, n);
          });
        };
      }
    };
  }
  onSubscribe() {
    this.cleanup || this.setEventListener(this.setup);
  }
  onUnsubscribe() {
    if (!this.hasListeners()) {
      var t;
      (t = this.cleanup) == null || t.call(this), this.cleanup = void 0;
    }
  }
  setEventListener(t) {
    var n;
    this.setup = t, (n = this.cleanup) == null || n.call(this), this.cleanup = t((r) => {
      typeof r == "boolean" ? this.setOnline(r) : this.onOnline();
    });
  }
  setOnline(t) {
    this.online !== t && (this.online = t, this.onOnline());
  }
  onOnline() {
    this.listeners.forEach(({
      listener: t
    }) => {
      t();
    });
  }
  isOnline() {
    return typeof this.online == "boolean" ? this.online : typeof navigator == "undefined" || typeof navigator.onLine == "undefined" ? !0 : navigator.onLine;
  }
}
const wm = new w6e();
function x6e(e) {
  return Math.min(1e3 * ro(2, e), 3e4);
}
function lv(e) {
  return (e != null ? e : "online") === "online" ? wm.isOnline() : !0;
}
class C6 {
  constructor(t) {
    this.revert = t == null ? void 0 : t.revert, this.silent = t == null ? void 0 : t.silent;
  }
}
function ch(e) {
  return e instanceof C6;
}
function S6(e) {
  let t = !1, n = 0, r = !1, o, i, a;
  const s = new Promise((b, x) => {
    i = b, a = x;
  }), c = (b) => {
    r || (m(new C6(b)), e.abort == null || e.abort());
  }, l = () => {
    t = !0;
  }, d = () => {
    t = !1;
  }, f = () => !_m.isFocused() || e.networkMode !== "always" && !wm.isOnline(), p = (b) => {
    r || (r = !0, e.onSuccess == null || e.onSuccess(b), o == null || o(), i(b));
  }, m = (b) => {
    r || (r = !0, e.onError == null || e.onError(b), o == null || o(), a(b));
  }, v = () => new Promise((b) => {
    o = (x) => {
      const T = r || !f();
      return T && b(x), T;
    }, e.onPause == null || e.onPause();
  }).then(() => {
    o = void 0, r || e.onContinue == null || e.onContinue();
  }), g = () => {
    if (r)
      return;
    let b;
    try {
      b = e.fn();
    } catch (x) {
      b = Promise.reject(x);
    }
    Promise.resolve(b).then(p).catch((x) => {
      var T, S;
      if (r)
        return;
      const _ = (T = e.retry) != null ? T : 3, w = (S = e.retryDelay) != null ? S : x6e, k = typeof w == "function" ? w(n, x) : w, E = _ === !0 || typeof _ == "number" && n < _ || typeof _ == "function" && _(n, x);
      if (t || !E) {
        m(x);
        return;
      }
      n++, e.onFail == null || e.onFail(n, x), x6(k).then(() => {
        if (f())
          return v();
      }).then(() => {
        t ? m(x) : g();
      });
    });
  };
  return lv(e.networkMode) ? g() : v().then(g), {
    promise: s,
    cancel: c,
    continue: () => (o == null ? void 0 : o()) ? s : Promise.resolve(),
    cancelRetry: l,
    continueRetry: d
  };
}
const Jx = console;
function C6e() {
  let e = [], t = 0, n = (d) => {
    d();
  }, r = (d) => {
    d();
  };
  const o = (d) => {
    let f;
    t++;
    try {
      f = d();
    } finally {
      t--, t || s();
    }
    return f;
  }, i = (d) => {
    t ? e.push(d) : VP(() => {
      n(d);
    });
  }, a = (d) => (...f) => {
    i(() => {
      d(...f);
    });
  }, s = () => {
    const d = e;
    e = [], d.length && VP(() => {
      r(() => {
        d.forEach((f) => {
          n(f);
        });
      });
    });
  };
  return {
    batch: o,
    batchCalls: a,
    schedule: i,
    setNotifyFunction: (d) => {
      n = d;
    },
    setBatchNotifyFunction: (d) => {
      r = d;
    }
  };
}
const jn = C6e();
class T6 {
  destroy() {
    this.clearGcTimeout();
  }
  scheduleGc() {
    this.clearGcTimeout(), u_(this.cacheTime) && (this.gcTimeout = setTimeout(() => {
      this.optionalRemove();
    }, this.cacheTime));
  }
  updateCacheTime(t) {
    this.cacheTime = Math.max(this.cacheTime || 0, t != null ? t : of ? 1 / 0 : 5 * 60 * 1e3);
  }
  clearGcTimeout() {
    this.gcTimeout && (clearTimeout(this.gcTimeout), this.gcTimeout = void 0);
  }
}
class S6e extends T6 {
  constructor(t) {
    super(), this.abortSignalConsumed = !1, this.defaultOptions = t.defaultOptions, this.setOptions(t.options), this.observers = [], this.cache = t.cache, this.logger = t.logger || Jx, this.queryKey = t.queryKey, this.queryHash = t.queryHash, this.initialState = t.state || T6e(this.options), this.state = this.initialState, this.scheduleGc();
  }
  get meta() {
    return this.options.meta;
  }
  setOptions(t) {
    this.options = se(se({}, this.defaultOptions), t), this.updateCacheTime(this.options.cacheTime);
  }
  optionalRemove() {
    !this.observers.length && this.state.fetchStatus === "idle" && this.cache.remove(this);
  }
  setData(t, n) {
    const r = p_(this.state.data, t, this.options);
    return this.dispatch({
      data: r,
      type: "success",
      dataUpdatedAt: n == null ? void 0 : n.updatedAt,
      manual: n == null ? void 0 : n.manual
    }), r;
  }
  setState(t, n) {
    this.dispatch({
      type: "setState",
      state: t,
      setStateOptions: n
    });
  }
  cancel(t) {
    var n;
    const r = this.promise;
    return (n = this.retryer) == null || n.cancel(t), r ? r.then(Ao).catch(Ao) : Promise.resolve();
  }
  destroy() {
    super.destroy(), this.cancel({
      silent: !0
    });
  }
  reset() {
    this.destroy(), this.setState(this.initialState);
  }
  isActive() {
    return this.observers.some((t) => t.options.enabled !== !1);
  }
  isDisabled() {
    return this.getObserversCount() > 0 && !this.isActive();
  }
  isStale() {
    return this.state.isInvalidated || !this.state.dataUpdatedAt || this.observers.some((t) => t.getCurrentResult().isStale);
  }
  isStaleByTime(t = 0) {
    return this.state.isInvalidated || !this.state.dataUpdatedAt || !y6(this.state.dataUpdatedAt, t);
  }
  onFocus() {
    var t;
    const n = this.observers.find((r) => r.shouldFetchOnWindowFocus());
    n && n.refetch({
      cancelRefetch: !1
    }), (t = this.retryer) == null || t.continue();
  }
  onOnline() {
    var t;
    const n = this.observers.find((r) => r.shouldFetchOnReconnect());
    n && n.refetch({
      cancelRefetch: !1
    }), (t = this.retryer) == null || t.continue();
  }
  addObserver(t) {
    this.observers.includes(t) || (this.observers.push(t), this.clearGcTimeout(), this.cache.notify({
      type: "observerAdded",
      query: this,
      observer: t
    }));
  }
  removeObserver(t) {
    this.observers.includes(t) && (this.observers = this.observers.filter((n) => n !== t), this.observers.length || (this.retryer && (this.abortSignalConsumed ? this.retryer.cancel({
      revert: !0
    }) : this.retryer.cancelRetry()), this.scheduleGc()), this.cache.notify({
      type: "observerRemoved",
      query: this,
      observer: t
    }));
  }
  getObserversCount() {
    return this.observers.length;
  }
  invalidate() {
    this.state.isInvalidated || this.dispatch({
      type: "invalidate"
    });
  }
  fetch(t, n) {
    var r, o;
    if (this.state.fetchStatus !== "idle") {
      if (this.state.dataUpdatedAt && n != null && n.cancelRefetch)
        this.cancel({
          silent: !0
        });
      else if (this.promise) {
        var i;
        return (i = this.retryer) == null || i.continueRetry(), this.promise;
      }
    }
    if (t && this.setOptions(t), !this.options.queryFn) {
      const m = this.observers.find((v) => v.options.queryFn);
      m && this.setOptions(m.options);
    }
    process.env.NODE_ENV !== "production" && (Array.isArray(this.options.queryKey) || this.logger.error("As of v4, queryKey needs to be an Array. If you are using a string like 'repoData', please change it to an Array, e.g. ['repoData']"));
    const a = y6e(), s = {
      queryKey: this.queryKey,
      pageParam: void 0,
      meta: this.meta
    }, c = (m) => {
      Object.defineProperty(m, "signal", {
        enumerable: !0,
        get: () => {
          if (a)
            return this.abortSignalConsumed = !0, a.signal;
        }
      });
    };
    c(s);
    const l = () => this.options.queryFn ? (this.abortSignalConsumed = !1, this.options.queryFn(s)) : Promise.reject("Missing queryFn for queryKey '" + this.options.queryHash + "'"), d = {
      fetchOptions: n,
      options: this.options,
      queryKey: this.queryKey,
      state: this.state,
      fetchFn: l
    };
    if (c(d), (r = this.options.behavior) == null || r.onFetch(d), this.revertState = this.state, this.state.fetchStatus === "idle" || this.state.fetchMeta !== ((o = d.fetchOptions) == null ? void 0 : o.meta)) {
      var f;
      this.dispatch({
        type: "fetch",
        meta: (f = d.fetchOptions) == null ? void 0 : f.meta
      });
    }
    const p = (m) => {
      if (ch(m) && m.silent || this.dispatch({
        type: "error",
        error: m
      }), !ch(m)) {
        var v, g, b, x;
        (v = (g = this.cache.config).onError) == null || v.call(g, m, this), (b = (x = this.cache.config).onSettled) == null || b.call(x, this.state.data, m, this), process.env.NODE_ENV !== "production" && this.logger.error(m);
      }
      this.isFetchingOptimistic || this.scheduleGc(), this.isFetchingOptimistic = !1;
    };
    return this.retryer = S6({
      fn: d.fetchFn,
      abort: a == null ? void 0 : a.abort.bind(a),
      onSuccess: (m) => {
        var v, g, b, x;
        if (typeof m == "undefined") {
          process.env.NODE_ENV !== "production" && this.logger.error("Query data cannot be undefined. Please make sure to return a value other than undefined from your query function. Affected query key: " + this.queryHash), p(new Error(this.queryHash + " data is undefined"));
          return;
        }
        this.setData(m), (v = (g = this.cache.config).onSuccess) == null || v.call(g, m, this), (b = (x = this.cache.config).onSettled) == null || b.call(x, m, this.state.error, this), this.isFetchingOptimistic || this.scheduleGc(), this.isFetchingOptimistic = !1;
      },
      onError: p,
      onFail: (m, v) => {
        this.dispatch({
          type: "failed",
          failureCount: m,
          error: v
        });
      },
      onPause: () => {
        this.dispatch({
          type: "pause"
        });
      },
      onContinue: () => {
        this.dispatch({
          type: "continue"
        });
      },
      retry: d.options.retry,
      retryDelay: d.options.retryDelay,
      networkMode: d.options.networkMode
    }), this.promise = this.retryer.promise, this.promise;
  }
  dispatch(t) {
    const n = (r) => {
      var o, i;
      switch (t.type) {
        case "failed":
          return ge(se({}, r), {
            fetchFailureCount: t.failureCount,
            fetchFailureReason: t.error
          });
        case "pause":
          return ge(se({}, r), {
            fetchStatus: "paused"
          });
        case "continue":
          return ge(se({}, r), {
            fetchStatus: "fetching"
          });
        case "fetch":
          return se(ge(se({}, r), {
            fetchFailureCount: 0,
            fetchFailureReason: null,
            fetchMeta: (o = t.meta) != null ? o : null,
            fetchStatus: lv(this.options.networkMode) ? "fetching" : "paused"
          }), !r.dataUpdatedAt && {
            error: null,
            status: "loading"
          });
        case "success":
          return se(ge(se({}, r), {
            data: t.data,
            dataUpdateCount: r.dataUpdateCount + 1,
            dataUpdatedAt: (i = t.dataUpdatedAt) != null ? i : Date.now(),
            error: null,
            isInvalidated: !1,
            status: "success"
          }), !t.manual && {
            fetchStatus: "idle",
            fetchFailureCount: 0,
            fetchFailureReason: null
          });
        case "error":
          const a = t.error;
          return ch(a) && a.revert && this.revertState ? ge(se({}, this.revertState), {
            fetchStatus: "idle"
          }) : ge(se({}, r), {
            error: a,
            errorUpdateCount: r.errorUpdateCount + 1,
            errorUpdatedAt: Date.now(),
            fetchFailureCount: r.fetchFailureCount + 1,
            fetchFailureReason: a,
            fetchStatus: "idle",
            status: "error"
          });
        case "invalidate":
          return ge(se({}, r), {
            isInvalidated: !0
          });
        case "setState":
          return se(se({}, r), t.state);
      }
    };
    this.state = n(this.state), jn.batch(() => {
      this.observers.forEach((r) => {
        r.onQueryUpdate(t);
      }), this.cache.notify({
        query: this,
        type: "updated",
        action: t
      });
    });
  }
}
function T6e(e) {
  const t = typeof e.initialData == "function" ? e.initialData() : e.initialData, n = typeof t != "undefined", r = n ? typeof e.initialDataUpdatedAt == "function" ? e.initialDataUpdatedAt() : e.initialDataUpdatedAt : 0;
  return {
    data: t,
    dataUpdateCount: 0,
    dataUpdatedAt: n ? r != null ? r : Date.now() : 0,
    error: null,
    errorUpdateCount: 0,
    errorUpdatedAt: 0,
    fetchFailureCount: 0,
    fetchFailureReason: null,
    fetchMeta: null,
    isInvalidated: !1,
    status: n ? "success" : "loading",
    fetchStatus: "idle"
  };
}
class E6e extends Lf {
  constructor(t) {
    super(), this.config = t || {}, this.queries = [], this.queriesMap = {};
  }
  build(t, n, r) {
    var o;
    const i = n.queryKey, a = (o = n.queryHash) != null ? o : Kx(i, n);
    let s = this.get(a);
    return s || (s = new S6e({
      cache: this,
      logger: t.getLogger(),
      queryKey: i,
      queryHash: a,
      options: t.defaultQueryOptions(n),
      state: r,
      defaultOptions: t.getQueryDefaults(i)
    }), this.add(s)), s;
  }
  add(t) {
    this.queriesMap[t.queryHash] || (this.queriesMap[t.queryHash] = t, this.queries.push(t), this.notify({
      type: "added",
      query: t
    }));
  }
  remove(t) {
    const n = this.queriesMap[t.queryHash];
    n && (t.destroy(), this.queries = this.queries.filter((r) => r !== t), n === t && delete this.queriesMap[t.queryHash], this.notify({
      type: "removed",
      query: t
    }));
  }
  clear() {
    jn.batch(() => {
      this.queries.forEach((t) => {
        this.remove(t);
      });
    });
  }
  get(t) {
    return this.queriesMap[t];
  }
  getAll() {
    return this.queries;
  }
  find(t, n) {
    const [r] = ja(t, n);
    return typeof r.exact == "undefined" && (r.exact = !0), this.queries.find((o) => BP(r, o));
  }
  findAll(t, n) {
    const [r] = ja(t, n);
    return Object.keys(r).length > 0 ? this.queries.filter((o) => BP(r, o)) : this.queries;
  }
  notify(t) {
    jn.batch(() => {
      this.listeners.forEach(({
        listener: n
      }) => {
        n(t);
      });
    });
  }
  onFocus() {
    jn.batch(() => {
      this.queries.forEach((t) => {
        t.onFocus();
      });
    });
  }
  onOnline() {
    jn.batch(() => {
      this.queries.forEach((t) => {
        t.onOnline();
      });
    });
  }
}
class k6e extends T6 {
  constructor(t) {
    super(), this.defaultOptions = t.defaultOptions, this.mutationId = t.mutationId, this.mutationCache = t.mutationCache, this.logger = t.logger || Jx, this.observers = [], this.state = t.state || M6e(), this.setOptions(t.options), this.scheduleGc();
  }
  setOptions(t) {
    this.options = se(se({}, this.defaultOptions), t), this.updateCacheTime(this.options.cacheTime);
  }
  get meta() {
    return this.options.meta;
  }
  setState(t) {
    this.dispatch({
      type: "setState",
      state: t
    });
  }
  addObserver(t) {
    this.observers.includes(t) || (this.observers.push(t), this.clearGcTimeout(), this.mutationCache.notify({
      type: "observerAdded",
      mutation: this,
      observer: t
    }));
  }
  removeObserver(t) {
    this.observers = this.observers.filter((n) => n !== t), this.scheduleGc(), this.mutationCache.notify({
      type: "observerRemoved",
      mutation: this,
      observer: t
    });
  }
  optionalRemove() {
    this.observers.length || (this.state.status === "loading" ? this.scheduleGc() : this.mutationCache.remove(this));
  }
  continue() {
    var t, n;
    return (t = (n = this.retryer) == null ? void 0 : n.continue()) != null ? t : this.execute();
  }
  execute() {
    return Mo(this, null, function* () {
      const t = () => {
        var E;
        return this.retryer = S6({
          fn: () => this.options.mutationFn ? this.options.mutationFn(this.state.variables) : Promise.reject("No mutationFn found"),
          onFail: (R, P) => {
            this.dispatch({
              type: "failed",
              failureCount: R,
              error: P
            });
          },
          onPause: () => {
            this.dispatch({
              type: "pause"
            });
          },
          onContinue: () => {
            this.dispatch({
              type: "continue"
            });
          },
          retry: (E = this.options.retry) != null ? E : 0,
          retryDelay: this.options.retryDelay,
          networkMode: this.options.networkMode
        }), this.retryer.promise;
      }, n = this.state.status === "loading";
      try {
        var r, o, i, a, s, c, l, d;
        if (!n) {
          var f, p, m, v;
          this.dispatch({
            type: "loading",
            variables: this.options.variables
          }), yield (f = (p = this.mutationCache.config).onMutate) == null ? void 0 : f.call(p, this.state.variables, this);
          const R = yield (m = (v = this.options).onMutate) == null ? void 0 : m.call(v, this.state.variables);
          R !== this.state.context && this.dispatch({
            type: "loading",
            context: R,
            variables: this.state.variables
          });
        }
        const E = yield t();
        return yield (r = (o = this.mutationCache.config).onSuccess) == null ? void 0 : r.call(o, E, this.state.variables, this.state.context, this), yield (i = (a = this.options).onSuccess) == null ? void 0 : i.call(a, E, this.state.variables, this.state.context), yield (s = (c = this.mutationCache.config).onSettled) == null ? void 0 : s.call(c, E, null, this.state.variables, this.state.context, this), yield (l = (d = this.options).onSettled) == null ? void 0 : l.call(d, E, null, this.state.variables, this.state.context), this.dispatch({
          type: "success",
          data: E
        }), E;
      } catch (E) {
        try {
          var g, b, x, T, S, _, w, k;
          throw yield (g = (b = this.mutationCache.config).onError) == null ? void 0 : g.call(b, E, this.state.variables, this.state.context, this), process.env.NODE_ENV !== "production" && this.logger.error(E), yield (x = (T = this.options).onError) == null ? void 0 : x.call(T, E, this.state.variables, this.state.context), yield (S = (_ = this.mutationCache.config).onSettled) == null ? void 0 : S.call(_, void 0, E, this.state.variables, this.state.context, this), yield (w = (k = this.options).onSettled) == null ? void 0 : w.call(k, void 0, E, this.state.variables, this.state.context), E;
        } finally {
          this.dispatch({
            type: "error",
            error: E
          });
        }
      }
    });
  }
  dispatch(t) {
    const n = (r) => {
      switch (t.type) {
        case "failed":
          return ge(se({}, r), {
            failureCount: t.failureCount,
            failureReason: t.error
          });
        case "pause":
          return ge(se({}, r), {
            isPaused: !0
          });
        case "continue":
          return ge(se({}, r), {
            isPaused: !1
          });
        case "loading":
          return ge(se({}, r), {
            context: t.context,
            data: void 0,
            failureCount: 0,
            failureReason: null,
            error: null,
            isPaused: !lv(this.options.networkMode),
            status: "loading",
            variables: t.variables
          });
        case "success":
          return ge(se({}, r), {
            data: t.data,
            failureCount: 0,
            failureReason: null,
            error: null,
            status: "success",
            isPaused: !1
          });
        case "error":
          return ge(se({}, r), {
            data: void 0,
            error: t.error,
            failureCount: r.failureCount + 1,
            failureReason: t.error,
            isPaused: !1,
            status: "error"
          });
        case "setState":
          return se(se({}, r), t.state);
      }
    };
    this.state = n(this.state), jn.batch(() => {
      this.observers.forEach((r) => {
        r.onMutationUpdate(t);
      }), this.mutationCache.notify({
        mutation: this,
        type: "updated",
        action: t
      });
    });
  }
}
function M6e() {
  return {
    context: void 0,
    data: void 0,
    error: null,
    failureCount: 0,
    failureReason: null,
    isPaused: !1,
    status: "idle",
    variables: void 0
  };
}
class R6e extends Lf {
  constructor(t) {
    super(), this.config = t || {}, this.mutations = [], this.mutationId = 0;
  }
  build(t, n, r) {
    const o = new k6e({
      mutationCache: this,
      logger: t.getLogger(),
      mutationId: ++this.mutationId,
      options: t.defaultMutationOptions(n),
      state: r,
      defaultOptions: n.mutationKey ? t.getMutationDefaults(n.mutationKey) : void 0
    });
    return this.add(o), o;
  }
  add(t) {
    this.mutations.push(t), this.notify({
      type: "added",
      mutation: t
    });
  }
  remove(t) {
    this.mutations = this.mutations.filter((n) => n !== t), this.notify({
      type: "removed",
      mutation: t
    });
  }
  clear() {
    jn.batch(() => {
      this.mutations.forEach((t) => {
        this.remove(t);
      });
    });
  }
  getAll() {
    return this.mutations;
  }
  find(t) {
    return typeof t.exact == "undefined" && (t.exact = !0), this.mutations.find((n) => HP(t, n));
  }
  findAll(t) {
    return this.mutations.filter((n) => HP(t, n));
  }
  notify(t) {
    jn.batch(() => {
      this.listeners.forEach(({
        listener: n
      }) => {
        n(t);
      });
    });
  }
  resumePausedMutations() {
    var t;
    return this.resuming = ((t = this.resuming) != null ? t : Promise.resolve()).then(() => {
      const n = this.mutations.filter((r) => r.state.isPaused);
      return jn.batch(() => n.reduce((r, o) => r.then(() => o.continue().catch(Ao)), Promise.resolve()));
    }).then(() => {
      this.resuming = void 0;
    }), this.resuming;
  }
}
function P6e() {
  return {
    onFetch: (e) => {
      e.fetchFn = () => {
        var t, n, r, o, i, a;
        const s = (t = e.fetchOptions) == null || (n = t.meta) == null ? void 0 : n.refetchPage, c = (r = e.fetchOptions) == null || (o = r.meta) == null ? void 0 : o.fetchMore, l = c == null ? void 0 : c.pageParam, d = (c == null ? void 0 : c.direction) === "forward", f = (c == null ? void 0 : c.direction) === "backward", p = ((i = e.state.data) == null ? void 0 : i.pages) || [], m = ((a = e.state.data) == null ? void 0 : a.pageParams) || [];
        let v = m, g = !1;
        const b = (k) => {
          Object.defineProperty(k, "signal", {
            enumerable: !0,
            get: () => {
              var E;
              if ((E = e.signal) != null && E.aborted)
                g = !0;
              else {
                var R;
                (R = e.signal) == null || R.addEventListener("abort", () => {
                  g = !0;
                });
              }
              return e.signal;
            }
          });
        }, x = e.options.queryFn || (() => Promise.reject("Missing queryFn for queryKey '" + e.options.queryHash + "'")), T = (k, E, R, P) => (v = P ? [E, ...v] : [...v, E], P ? [R, ...k] : [...k, R]), S = (k, E, R, P) => {
          if (g)
            return Promise.reject("Cancelled");
          if (typeof R == "undefined" && !E && k.length)
            return Promise.resolve(k);
          const A = {
            queryKey: e.queryKey,
            pageParam: R,
            meta: e.options.meta
          };
          b(A);
          const D = x(A);
          return Promise.resolve(D).then((F) => T(k, R, F, P));
        };
        let _;
        if (!p.length)
          _ = S([]);
        else if (d) {
          const k = typeof l != "undefined", E = k ? l : qP(e.options, p);
          _ = S(p, k, E);
        } else if (f) {
          const k = typeof l != "undefined", E = k ? l : O6e(e.options, p);
          _ = S(p, k, E, !0);
        } else {
          v = [];
          const k = typeof e.options.getNextPageParam == "undefined";
          _ = (s && p[0] ? s(p[0], 0, p) : !0) ? S([], k, m[0]) : Promise.resolve(T([], m[0], p[0]));
          for (let R = 1; R < p.length; R++)
            _ = _.then((P) => {
              if (s && p[R] ? s(p[R], R, p) : !0) {
                const D = k ? m[R] : qP(e.options, P);
                return S(P, k, D);
              }
              return Promise.resolve(T(P, m[R], p[R]));
            });
        }
        return _.then((k) => ({
          pages: k,
          pageParams: v
        }));
      };
    }
  };
}
function qP(e, t) {
  return e.getNextPageParam == null ? void 0 : e.getNextPageParam(t[t.length - 1], t);
}
function O6e(e, t) {
  return e.getPreviousPageParam == null ? void 0 : e.getPreviousPageParam(t[0], t);
}
class O$e {
  constructor(t = {}) {
    this.queryCache = t.queryCache || new E6e(), this.mutationCache = t.mutationCache || new R6e(), this.logger = t.logger || Jx, this.defaultOptions = t.defaultOptions || {}, this.queryDefaults = [], this.mutationDefaults = [], this.mountCount = 0, process.env.NODE_ENV !== "production" && t.logger && this.logger.error("Passing a custom logger has been deprecated and will be removed in the next major version.");
  }
  mount() {
    this.mountCount++, this.mountCount === 1 && (this.unsubscribeFocus = _m.subscribe(() => {
      _m.isFocused() && (this.resumePausedMutations(), this.queryCache.onFocus());
    }), this.unsubscribeOnline = wm.subscribe(() => {
      wm.isOnline() && (this.resumePausedMutations(), this.queryCache.onOnline());
    }));
  }
  unmount() {
    var t, n;
    this.mountCount--, this.mountCount === 0 && ((t = this.unsubscribeFocus) == null || t.call(this), this.unsubscribeFocus = void 0, (n = this.unsubscribeOnline) == null || n.call(this), this.unsubscribeOnline = void 0);
  }
  isFetching(t, n) {
    const [r] = ja(t, n);
    return r.fetchStatus = "fetching", this.queryCache.findAll(r).length;
  }
  isMutating(t) {
    return this.mutationCache.findAll(ge(se({}, t), {
      fetching: !0
    })).length;
  }
  getQueryData(t, n) {
    var r;
    return (r = this.queryCache.find(t, n)) == null ? void 0 : r.state.data;
  }
  ensureQueryData(t, n, r) {
    const o = id(t, n, r), i = this.getQueryData(o.queryKey);
    return i ? Promise.resolve(i) : this.fetchQuery(o);
  }
  getQueriesData(t) {
    return this.getQueryCache().findAll(t).map(({
      queryKey: n,
      state: r
    }) => {
      const o = r.data;
      return [n, o];
    });
  }
  setQueryData(t, n, r) {
    const o = this.queryCache.find(t), i = o == null ? void 0 : o.state.data, a = b6e(n, i);
    if (typeof a == "undefined")
      return;
    const s = id(t), c = this.defaultQueryOptions(s);
    return this.queryCache.build(this, c).setData(a, ge(se({}, r), {
      manual: !0
    }));
  }
  setQueriesData(t, n, r) {
    return jn.batch(() => this.getQueryCache().findAll(t).map(({
      queryKey: o
    }) => [o, this.setQueryData(o, n, r)]));
  }
  getQueryState(t, n) {
    var r;
    return (r = this.queryCache.find(t, n)) == null ? void 0 : r.state;
  }
  removeQueries(t, n) {
    const [r] = ja(t, n), o = this.queryCache;
    jn.batch(() => {
      o.findAll(r).forEach((i) => {
        o.remove(i);
      });
    });
  }
  resetQueries(t, n, r) {
    const [o, i] = ja(t, n, r), a = this.queryCache, s = se({
      type: "active"
    }, o);
    return jn.batch(() => (a.findAll(o).forEach((c) => {
      c.reset();
    }), this.refetchQueries(s, i)));
  }
  cancelQueries(t, n, r) {
    const [o, i = {}] = ja(t, n, r);
    typeof i.revert == "undefined" && (i.revert = !0);
    const a = jn.batch(() => this.queryCache.findAll(o).map((s) => s.cancel(i)));
    return Promise.all(a).then(Ao).catch(Ao);
  }
  invalidateQueries(t, n, r) {
    const [o, i] = ja(t, n, r);
    return jn.batch(() => {
      var a, s;
      if (this.queryCache.findAll(o).forEach((l) => {
        l.invalidate();
      }), o.refetchType === "none")
        return Promise.resolve();
      const c = ge(se({}, o), {
        type: (a = (s = o.refetchType) != null ? s : o.type) != null ? a : "active"
      });
      return this.refetchQueries(c, i);
    });
  }
  refetchQueries(t, n, r) {
    const [o, i] = ja(t, n, r), a = jn.batch(() => this.queryCache.findAll(o).filter((c) => !c.isDisabled()).map((c) => {
      var l;
      return c.fetch(void 0, ge(se({}, i), {
        cancelRefetch: (l = i == null ? void 0 : i.cancelRefetch) != null ? l : !0,
        meta: {
          refetchPage: o.refetchPage
        }
      }));
    }));
    let s = Promise.all(a).then(Ao);
    return i != null && i.throwOnError || (s = s.catch(Ao)), s;
  }
  fetchQuery(t, n, r) {
    const o = id(t, n, r), i = this.defaultQueryOptions(o);
    typeof i.retry == "undefined" && (i.retry = !1);
    const a = this.queryCache.build(this, i);
    return a.isStaleByTime(i.staleTime) ? a.fetch(i) : Promise.resolve(a.state.data);
  }
  prefetchQuery(t, n, r) {
    return this.fetchQuery(t, n, r).then(Ao).catch(Ao);
  }
  fetchInfiniteQuery(t, n, r) {
    const o = id(t, n, r);
    return o.behavior = P6e(), this.fetchQuery(o);
  }
  prefetchInfiniteQuery(t, n, r) {
    return this.fetchInfiniteQuery(t, n, r).then(Ao).catch(Ao);
  }
  resumePausedMutations() {
    return this.mutationCache.resumePausedMutations();
  }
  getQueryCache() {
    return this.queryCache;
  }
  getMutationCache() {
    return this.mutationCache;
  }
  getLogger() {
    return this.logger;
  }
  getDefaultOptions() {
    return this.defaultOptions;
  }
  setDefaultOptions(t) {
    this.defaultOptions = t;
  }
  setQueryDefaults(t, n) {
    const r = this.queryDefaults.find((o) => Ws(t) === Ws(o.queryKey));
    r ? r.defaultOptions = n : this.queryDefaults.push({
      queryKey: t,
      defaultOptions: n
    });
  }
  getQueryDefaults(t) {
    if (!t)
      return;
    const n = this.queryDefaults.find((r) => sc(t, r.queryKey));
    return process.env.NODE_ENV !== "production" && this.queryDefaults.filter((o) => sc(t, o.queryKey)).length > 1 && this.logger.error("[QueryClient] Several query defaults match with key '" + JSON.stringify(t) + "'. The first matching query defaults are used. Please check how query defaults are registered. Order does matter here. cf. https://react-query.tanstack.com/reference/QueryClient#queryclientsetquerydefaults."), n == null ? void 0 : n.defaultOptions;
  }
  setMutationDefaults(t, n) {
    const r = this.mutationDefaults.find((o) => Ws(t) === Ws(o.mutationKey));
    r ? r.defaultOptions = n : this.mutationDefaults.push({
      mutationKey: t,
      defaultOptions: n
    });
  }
  getMutationDefaults(t) {
    if (!t)
      return;
    const n = this.mutationDefaults.find((r) => sc(t, r.mutationKey));
    return process.env.NODE_ENV !== "production" && this.mutationDefaults.filter((o) => sc(t, o.mutationKey)).length > 1 && this.logger.error("[QueryClient] Several mutation defaults match with key '" + JSON.stringify(t) + "'. The first matching mutation defaults are used. Please check how mutation defaults are registered. Order does matter here. cf. https://react-query.tanstack.com/reference/QueryClient#queryclientsetmutationdefaults."), n == null ? void 0 : n.defaultOptions;
  }
  defaultQueryOptions(t) {
    if (t != null && t._defaulted)
      return t;
    const n = ge(se(se(se({}, this.defaultOptions.queries), this.getQueryDefaults(t == null ? void 0 : t.queryKey)), t), {
      _defaulted: !0
    });
    return !n.queryHash && n.queryKey && (n.queryHash = Kx(n.queryKey, n)), typeof n.refetchOnReconnect == "undefined" && (n.refetchOnReconnect = n.networkMode !== "always"), typeof n.useErrorBoundary == "undefined" && (n.useErrorBoundary = !!n.suspense), n;
  }
  defaultMutationOptions(t) {
    return t != null && t._defaulted ? t : ge(se(se(se({}, this.defaultOptions.mutations), this.getMutationDefaults(t == null ? void 0 : t.mutationKey)), t), {
      _defaulted: !0
    });
  }
  clear() {
    this.queryCache.clear(), this.mutationCache.clear();
  }
}
class N6e extends Lf {
  constructor(t, n) {
    super(), this.client = t, this.options = n, this.trackedProps = /* @__PURE__ */ new Set(), this.selectError = null, this.bindMethods(), this.setOptions(n);
  }
  bindMethods() {
    this.remove = this.remove.bind(this), this.refetch = this.refetch.bind(this);
  }
  onSubscribe() {
    this.listeners.size === 1 && (this.currentQuery.addObserver(this), GP(this.currentQuery, this.options) && this.executeFetch(), this.updateTimers());
  }
  onUnsubscribe() {
    this.hasListeners() || this.destroy();
  }
  shouldFetchOnReconnect() {
    return h_(this.currentQuery, this.options, this.options.refetchOnReconnect);
  }
  shouldFetchOnWindowFocus() {
    return h_(this.currentQuery, this.options, this.options.refetchOnWindowFocus);
  }
  destroy() {
    this.listeners = /* @__PURE__ */ new Set(), this.clearStaleTimeout(), this.clearRefetchInterval(), this.currentQuery.removeObserver(this);
  }
  setOptions(t, n) {
    const r = this.options, o = this.currentQuery;
    if (this.options = this.client.defaultQueryOptions(t), process.env.NODE_ENV !== "production" && typeof (t == null ? void 0 : t.isDataEqual) != "undefined" && this.client.getLogger().error("The isDataEqual option has been deprecated and will be removed in the next major version. You can achieve the same functionality by passing a function as the structuralSharing option"), d_(r, this.options) || this.client.getQueryCache().notify({
      type: "observerOptionsUpdated",
      query: this.currentQuery,
      observer: this
    }), typeof this.options.enabled != "undefined" && typeof this.options.enabled != "boolean")
      throw new Error("Expected enabled to be a boolean");
    this.options.queryKey || (this.options.queryKey = r.queryKey), this.updateQuery();
    const i = this.hasListeners();
    i && YP(this.currentQuery, o, this.options, r) && this.executeFetch(), this.updateResult(n), i && (this.currentQuery !== o || this.options.enabled !== r.enabled || this.options.staleTime !== r.staleTime) && this.updateStaleTimeout();
    const a = this.computeRefetchInterval();
    i && (this.currentQuery !== o || this.options.enabled !== r.enabled || a !== this.currentRefetchInterval) && this.updateRefetchInterval(a);
  }
  getOptimisticResult(t) {
    const n = this.client.getQueryCache().build(this.client, t), r = this.createResult(n, t);
    return D6e(this, r, t) && (this.currentResult = r, this.currentResultOptions = this.options, this.currentResultState = this.currentQuery.state), r;
  }
  getCurrentResult() {
    return this.currentResult;
  }
  trackResult(t) {
    const n = {};
    return Object.keys(t).forEach((r) => {
      Object.defineProperty(n, r, {
        configurable: !1,
        enumerable: !0,
        get: () => (this.trackedProps.add(r), t[r])
      });
    }), n;
  }
  getCurrentQuery() {
    return this.currentQuery;
  }
  remove() {
    this.client.getQueryCache().remove(this.currentQuery);
  }
  refetch(r = {}) {
    var o = r, {
      refetchPage: t
    } = o, n = xl(o, [
      "refetchPage"
    ]);
    return this.fetch(ge(se({}, n), {
      meta: {
        refetchPage: t
      }
    }));
  }
  fetchOptimistic(t) {
    const n = this.client.defaultQueryOptions(t), r = this.client.getQueryCache().build(this.client, n);
    return r.isFetchingOptimistic = !0, r.fetch().then(() => this.createResult(r, n));
  }
  fetch(t) {
    var n;
    return this.executeFetch(ge(se({}, t), {
      cancelRefetch: (n = t.cancelRefetch) != null ? n : !0
    })).then(() => (this.updateResult(), this.currentResult));
  }
  executeFetch(t) {
    this.updateQuery();
    let n = this.currentQuery.fetch(this.options, t);
    return t != null && t.throwOnError || (n = n.catch(Ao)), n;
  }
  updateStaleTimeout() {
    if (this.clearStaleTimeout(), of || this.currentResult.isStale || !u_(this.options.staleTime))
      return;
    const n = y6(this.currentResult.dataUpdatedAt, this.options.staleTime) + 1;
    this.staleTimeoutId = setTimeout(() => {
      this.currentResult.isStale || this.updateResult();
    }, n);
  }
  computeRefetchInterval() {
    var t;
    return typeof this.options.refetchInterval == "function" ? this.options.refetchInterval(this.currentResult.data, this.currentQuery) : (t = this.options.refetchInterval) != null ? t : !1;
  }
  updateRefetchInterval(t) {
    this.clearRefetchInterval(), this.currentRefetchInterval = t, !(of || this.options.enabled === !1 || !u_(this.currentRefetchInterval) || this.currentRefetchInterval === 0) && (this.refetchIntervalId = setInterval(() => {
      (this.options.refetchIntervalInBackground || _m.isFocused()) && this.executeFetch();
    }, this.currentRefetchInterval));
  }
  updateTimers() {
    this.updateStaleTimeout(), this.updateRefetchInterval(this.computeRefetchInterval());
  }
  clearStaleTimeout() {
    this.staleTimeoutId && (clearTimeout(this.staleTimeoutId), this.staleTimeoutId = void 0);
  }
  clearRefetchInterval() {
    this.refetchIntervalId && (clearInterval(this.refetchIntervalId), this.refetchIntervalId = void 0);
  }
  createResult(t, n) {
    const r = this.currentQuery, o = this.options, i = this.currentResult, a = this.currentResultState, s = this.currentResultOptions, c = t !== r, l = c ? t.state : this.currentQueryInitialState, d = c ? this.currentResult : this.previousQueryResult, {
      state: f
    } = t;
    let {
      dataUpdatedAt: p,
      error: m,
      errorUpdatedAt: v,
      fetchStatus: g,
      status: b
    } = f, x = !1, T = !1, S;
    if (n._optimisticResults) {
      const R = this.hasListeners(), P = !R && GP(t, n), A = R && YP(t, r, n, o);
      (P || A) && (g = lv(t.options.networkMode) ? "fetching" : "paused", p || (b = "loading")), n._optimisticResults === "isRestoring" && (g = "idle");
    }
    if (n.keepPreviousData && !f.dataUpdatedAt && d != null && d.isSuccess && b !== "error")
      S = d.data, p = d.dataUpdatedAt, b = d.status, x = !0;
    else if (n.select && typeof f.data != "undefined")
      if (i && f.data === (a == null ? void 0 : a.data) && n.select === this.selectFn)
        S = this.selectResult;
      else
        try {
          this.selectFn = n.select, S = n.select(f.data), S = p_(i == null ? void 0 : i.data, S, n), this.selectResult = S, this.selectError = null;
        } catch (R) {
          process.env.NODE_ENV !== "production" && this.client.getLogger().error(R), this.selectError = R;
        }
    else
      S = f.data;
    if (typeof n.placeholderData != "undefined" && typeof S == "undefined" && b === "loading") {
      let R;
      if (i != null && i.isPlaceholderData && n.placeholderData === (s == null ? void 0 : s.placeholderData))
        R = i.data;
      else if (R = typeof n.placeholderData == "function" ? n.placeholderData() : n.placeholderData, n.select && typeof R != "undefined")
        try {
          R = n.select(R), this.selectError = null;
        } catch (P) {
          process.env.NODE_ENV !== "production" && this.client.getLogger().error(P), this.selectError = P;
        }
      typeof R != "undefined" && (b = "success", S = p_(i == null ? void 0 : i.data, R, n), T = !0);
    }
    this.selectError && (m = this.selectError, S = this.selectResult, v = Date.now(), b = "error");
    const _ = g === "fetching", w = b === "loading", k = b === "error";
    return {
      status: b,
      fetchStatus: g,
      isLoading: w,
      isSuccess: b === "success",
      isError: k,
      isInitialLoading: w && _,
      data: S,
      dataUpdatedAt: p,
      error: m,
      errorUpdatedAt: v,
      failureCount: f.fetchFailureCount,
      failureReason: f.fetchFailureReason,
      errorUpdateCount: f.errorUpdateCount,
      isFetched: f.dataUpdateCount > 0 || f.errorUpdateCount > 0,
      isFetchedAfterMount: f.dataUpdateCount > l.dataUpdateCount || f.errorUpdateCount > l.errorUpdateCount,
      isFetching: _,
      isRefetching: _ && !w,
      isLoadingError: k && f.dataUpdatedAt === 0,
      isPaused: g === "paused",
      isPlaceholderData: T,
      isPreviousData: x,
      isRefetchError: k && f.dataUpdatedAt !== 0,
      isStale: Qx(t, n),
      refetch: this.refetch,
      remove: this.remove
    };
  }
  updateResult(t) {
    const n = this.currentResult, r = this.createResult(this.currentQuery, this.options);
    if (this.currentResultState = this.currentQuery.state, this.currentResultOptions = this.options, d_(r, n))
      return;
    this.currentResult = r;
    const o = {
      cache: !0
    }, i = () => {
      if (!n)
        return !0;
      const {
        notifyOnChangeProps: a
      } = this.options, s = typeof a == "function" ? a() : a;
      if (s === "all" || !s && !this.trackedProps.size)
        return !0;
      const c = new Set(s != null ? s : this.trackedProps);
      return this.options.useErrorBoundary && c.add("error"), Object.keys(this.currentResult).some((l) => {
        const d = l;
        return this.currentResult[d] !== n[d] && c.has(d);
      });
    };
    (t == null ? void 0 : t.listeners) !== !1 && i() && (o.listeners = !0), this.notify(se(se({}, o), t));
  }
  updateQuery() {
    const t = this.client.getQueryCache().build(this.client, this.options);
    if (t === this.currentQuery)
      return;
    const n = this.currentQuery;
    this.currentQuery = t, this.currentQueryInitialState = t.state, this.previousQueryResult = this.currentResult, this.hasListeners() && (n == null || n.removeObserver(this), t.addObserver(this));
  }
  onQueryUpdate(t) {
    const n = {};
    t.type === "success" ? n.onSuccess = !t.manual : t.type === "error" && !ch(t.error) && (n.onError = !0), this.updateResult(n), this.hasListeners() && this.updateTimers();
  }
  notify(t) {
    jn.batch(() => {
      if (t.onSuccess) {
        var n, r, o, i;
        (n = (r = this.options).onSuccess) == null || n.call(r, this.currentResult.data), (o = (i = this.options).onSettled) == null || o.call(i, this.currentResult.data, null);
      } else if (t.onError) {
        var a, s, c, l;
        (a = (s = this.options).onError) == null || a.call(s, this.currentResult.error), (c = (l = this.options).onSettled) == null || c.call(l, void 0, this.currentResult.error);
      }
      t.listeners && this.listeners.forEach(({
        listener: d
      }) => {
        d(this.currentResult);
      }), t.cache && this.client.getQueryCache().notify({
        query: this.currentQuery,
        type: "observerResultsUpdated"
      });
    });
  }
}
function A6e(e, t) {
  return t.enabled !== !1 && !e.state.dataUpdatedAt && !(e.state.status === "error" && t.retryOnMount === !1);
}
function GP(e, t) {
  return A6e(e, t) || e.state.dataUpdatedAt > 0 && h_(e, t, t.refetchOnMount);
}
function h_(e, t, n) {
  if (t.enabled !== !1) {
    const r = typeof n == "function" ? n(e) : n;
    return r === "always" || r !== !1 && Qx(e, t);
  }
  return !1;
}
function YP(e, t, n, r) {
  return n.enabled !== !1 && (e !== t || r.enabled === !1) && (!n.suspense || e.state.status !== "error") && Qx(e, n);
}
function Qx(e, t) {
  return e.isStaleByTime(t.staleTime);
}
function D6e(e, t, n) {
  return n.keepPreviousData ? !1 : n.placeholderData !== void 0 ? t.isPlaceholderData : !d_(e.getCurrentResult(), t);
}
var m_ = { exports: {} }, Cb = {};
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ZP;
function I6e() {
  if (ZP)
    return Cb;
  ZP = 1;
  var e = et;
  function t(f, p) {
    return f === p && (f !== 0 || 1 / f === 1 / p) || f !== f && p !== p;
  }
  var n = typeof Object.is == "function" ? Object.is : t, r = e.useState, o = e.useEffect, i = e.useLayoutEffect, a = e.useDebugValue;
  function s(f, p) {
    var m = p(), v = r({ inst: { value: m, getSnapshot: p } }), g = v[0].inst, b = v[1];
    return i(function() {
      g.value = m, g.getSnapshot = p, c(g) && b({ inst: g });
    }, [f, m, p]), o(function() {
      return c(g) && b({ inst: g }), f(function() {
        c(g) && b({ inst: g });
      });
    }, [f]), a(m), m;
  }
  function c(f) {
    var p = f.getSnapshot;
    f = f.value;
    try {
      var m = p();
      return !n(f, m);
    } catch (v) {
      return !0;
    }
  }
  function l(f, p) {
    return p();
  }
  var d = typeof window == "undefined" || typeof window.document == "undefined" || typeof window.document.createElement == "undefined" ? l : s;
  return Cb.useSyncExternalStore = e.useSyncExternalStore !== void 0 ? e.useSyncExternalStore : d, Cb;
}
var Sb = {};
/**
 * @license React
 * use-sync-external-store-shim.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var XP;
function L6e() {
  return XP || (XP = 1, process.env.NODE_ENV !== "production" && function() {
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ != "undefined" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var e = et, t = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function n(S) {
      {
        for (var _ = arguments.length, w = new Array(_ > 1 ? _ - 1 : 0), k = 1; k < _; k++)
          w[k - 1] = arguments[k];
        r("error", S, w);
      }
    }
    function r(S, _, w) {
      {
        var k = t.ReactDebugCurrentFrame, E = k.getStackAddendum();
        E !== "" && (_ += "%s", w = w.concat([E]));
        var R = w.map(function(P) {
          return String(P);
        });
        R.unshift("Warning: " + _), Function.prototype.apply.call(console[S], console, R);
      }
    }
    function o(S, _) {
      return S === _ && (S !== 0 || 1 / S === 1 / _) || S !== S && _ !== _;
    }
    var i = typeof Object.is == "function" ? Object.is : o, a = e.useState, s = e.useEffect, c = e.useLayoutEffect, l = e.useDebugValue, d = !1, f = !1;
    function p(S, _, w) {
      d || e.startTransition !== void 0 && (d = !0, n("You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."));
      var k = _();
      if (!f) {
        var E = _();
        i(k, E) || (n("The result of getSnapshot should be cached to avoid an infinite loop"), f = !0);
      }
      var R = a({
        inst: {
          value: k,
          getSnapshot: _
        }
      }), P = R[0].inst, A = R[1];
      return c(function() {
        P.value = k, P.getSnapshot = _, m(P) && A({
          inst: P
        });
      }, [S, k, _]), s(function() {
        m(P) && A({
          inst: P
        });
        var D = function() {
          m(P) && A({
            inst: P
          });
        };
        return S(D);
      }, [S]), l(k), k;
    }
    function m(S) {
      var _ = S.getSnapshot, w = S.value;
      try {
        var k = _();
        return !i(w, k);
      } catch (E) {
        return !0;
      }
    }
    function v(S, _, w) {
      return _();
    }
    var g = typeof window != "undefined" && typeof window.document != "undefined" && typeof window.document.createElement != "undefined", b = !g, x = b ? v : p, T = e.useSyncExternalStore !== void 0 ? e.useSyncExternalStore : x;
    Sb.useSyncExternalStore = T, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ != "undefined" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
  }()), Sb;
}
process.env.NODE_ENV === "production" ? m_.exports = I6e() : m_.exports = L6e();
var $6e = m_.exports;
const F6e = $6e.useSyncExternalStore, KP = /* @__PURE__ */ B.createContext(void 0), E6 = /* @__PURE__ */ B.createContext(!1);
function k6(e, t) {
  return e || (t && typeof window != "undefined" ? (window.ReactQueryClientContext || (window.ReactQueryClientContext = KP), window.ReactQueryClientContext) : KP);
}
const z6e = ({
  context: e
} = {}) => {
  const t = B.useContext(k6(e, B.useContext(E6)));
  if (!t)
    throw new Error("No QueryClient set, use QueryClientProvider to set one");
  return t;
}, N$e = ({
  client: e,
  children: t,
  context: n,
  contextSharing: r = !1
}) => {
  B.useEffect(() => (e.mount(), () => {
    e.unmount();
  }), [e]), process.env.NODE_ENV !== "production" && r && e.getLogger().error("The contextSharing option has been deprecated and will be removed in the next major version");
  const o = k6(n, r);
  return /* @__PURE__ */ B.createElement(E6.Provider, {
    value: !n && r
  }, /* @__PURE__ */ B.createElement(o.Provider, {
    value: e
  }, t));
}, B6e = /* @__PURE__ */ B.createContext(!1), H6e = () => B.useContext(B6e);
function j6e() {
  let e = !1;
  return {
    clearReset: () => {
      e = !1;
    },
    reset: () => {
      e = !0;
    },
    isReset: () => e
  };
}
const W6e = /* @__PURE__ */ B.createContext(j6e()), V6e = () => B.useContext(W6e);
function U6e(e, t) {
  return typeof e == "function" ? e(...t) : !!e;
}
const q6e = (e, t) => {
  (e.suspense || e.useErrorBoundary) && (t.isReset() || (e.retryOnMount = !1));
}, G6e = (e) => {
  B.useEffect(() => {
    e.clearReset();
  }, [e]);
}, Y6e = ({
  result: e,
  errorResetBoundary: t,
  useErrorBoundary: n,
  query: r
}) => e.isError && !t.isReset() && !e.isFetching && U6e(n, [e.error, r]), Z6e = (e) => {
  e.suspense && typeof e.staleTime != "number" && (e.staleTime = 1e3);
}, X6e = (e, t) => e.isLoading && e.isFetching && !t, K6e = (e, t, n) => (e == null ? void 0 : e.suspense) && X6e(t, n), J6e = (e, t, n) => t.fetchOptimistic(e).then(({
  data: r
}) => {
  e.onSuccess == null || e.onSuccess(r), e.onSettled == null || e.onSettled(r, null);
}).catch((r) => {
  n.clearReset(), e.onError == null || e.onError(r), e.onSettled == null || e.onSettled(void 0, r);
});
function Q6e(e, t) {
  const n = z6e({
    context: e.context
  }), r = H6e(), o = V6e(), i = n.defaultQueryOptions(e);
  i._optimisticResults = r ? "isRestoring" : "optimistic", i.onError && (i.onError = jn.batchCalls(i.onError)), i.onSuccess && (i.onSuccess = jn.batchCalls(i.onSuccess)), i.onSettled && (i.onSettled = jn.batchCalls(i.onSettled)), Z6e(i), q6e(i, o), G6e(o);
  const [a] = B.useState(() => new t(n, i)), s = a.getOptimisticResult(i);
  if (F6e(B.useCallback((c) => {
    const l = r ? () => {
    } : a.subscribe(jn.batchCalls(c));
    return a.updateResult(), l;
  }, [a, r]), () => a.getCurrentResult(), () => a.getCurrentResult()), B.useEffect(() => {
    a.setOptions(i, {
      listeners: !1
    });
  }, [i, a]), K6e(i, s, r))
    throw J6e(i, a, o);
  if (Y6e({
    result: s,
    errorResetBoundary: o,
    useErrorBoundary: i.useErrorBoundary,
    query: a.getCurrentQuery()
  }))
    throw s.error;
  return i.notifyOnChangeProps ? s : a.trackResult(s);
}
function A$e(e, t, n) {
  const r = id(e, t, n);
  return Q6e(r, N6e);
}
function e$e(e) {
  return t$e(e.dataSet);
}
function t$e(e) {
  return !!e && typeof e != "string" && "rows" in e && "columns" in e;
}
const n$e = Jc({
  componentName: "Table",
  shouldSkipSisenseContextWaiting: e$e
})((e) => /* @__PURE__ */ z(W4, se({}, e))), D$e = Jc({
  componentName: "TableWidget"
})((e) => {
  var f;
  const [t, n] = Ge(0), { app: r } = Gn(), { styleOptions: o, dataSource: i = r == null ? void 0 : r.defaultDataSource, dataOptions: a } = e, s = uL("table", {
    hasHeader: !((f = o == null ? void 0 : o.header) != null && f.hidden)
  }), p = e.styleOptions || {}, { width: c, height: l } = p, d = xl(p, ["width", "height"]);
  return a ? /* @__PURE__ */ z(
    Vg,
    {
      defaultSize: s,
      size: {
        width: c,
        height: l
      },
      children: /* @__PURE__ */ z(
        G4,
        ge(se({}, e), {
          dataSetName: i && y_(i),
          onRefresh: () => n(t + 1),
          children: /* @__PURE__ */ z(
            n$e,
            {
              dataSet: e.dataSource,
              dataOptions: e.dataOptions,
              styleOptions: d,
              filters: e.filters,
              refreshCounter: t
            }
          )
        })
      )
    }
  ) : null;
});
export {
  jE as $,
  eve as A,
  Kc as B,
  Qge as C,
  xn as D,
  Ic as E,
  L5e as F,
  $5e as G,
  BE as H,
  HE as I,
  g$e as J,
  pwe as K,
  fwe as L,
  Gn as M,
  Bw as N,
  h$e as O,
  M as P,
  wW as Q,
  mCe as R,
  AP as S,
  z5e as T,
  qt as U,
  W5e as V,
  d$e as W,
  Jc as X,
  W2 as Y,
  Yn as Z,
  ue as _,
  l$e as a,
  tme as a$,
  Vg as a0,
  UCe as a1,
  Dp as a2,
  cL as a3,
  uL as a4,
  G4 as a5,
  dL as a6,
  r2e as a7,
  Cp as a8,
  X5 as a9,
  R$e as aA,
  $we as aB,
  K5e as aC,
  Yfe as aD,
  b$e as aE,
  ax as aF,
  mL as aG,
  CLe as aH,
  J4 as aI,
  NLe as aJ,
  y$e as aK,
  r6 as aL,
  ia as aM,
  SLe as aN,
  w$e as aO,
  zLe as aP,
  _$e as aQ,
  x$e as aR,
  TLe as aS,
  p6e as aT,
  Z4 as aU,
  oLe as aV,
  rf as aW,
  wxe as aX,
  u$e as aY,
  O$e as aZ,
  N$e as a_,
  ym as aa,
  Zx as ab,
  Y2e as ac,
  H2e as ad,
  j2e as ae,
  T$e as af,
  S$e as ag,
  E$e as ah,
  C$e as ai,
  w5e as aj,
  x5e as ak,
  Fo as al,
  Yhe as am,
  C_e as an,
  M$e as ao,
  Dhe as ap,
  gI as aq,
  Cg as ar,
  bx as as,
  bm as at,
  lx as au,
  mm as av,
  Hg as aw,
  t5 as ax,
  ra as ay,
  aL as az,
  QD as b,
  Zhe as b0,
  vI as b1,
  ELe as b2,
  ULe as b3,
  GLe as b4,
  _Le as b5,
  M5e as b6,
  C5e as b7,
  xI as b8,
  Xx as b9,
  Ghe as bA,
  ef as bB,
  sx as bC,
  T5e as bD,
  A$e as ba,
  kLe as bb,
  D$e as bc,
  __e as bd,
  Ehe as be,
  k$e as bf,
  s6e as bg,
  m$e as bh,
  v$e as bi,
  qw as bj,
  n$e as bk,
  gxe as bl,
  f5 as bm,
  p5 as bn,
  ix as bo,
  Lg as bp,
  h0e as bq,
  d5 as br,
  Lf as bs,
  d_ as bt,
  jn as bu,
  M6e as bv,
  z6e as bw,
  F6e as bx,
  U6e as by,
  P$e as bz,
  Ww as c,
  mI as d,
  Mhe as e,
  She as f,
  tz as g,
  Che as h,
  f$e as i,
  hn as j,
  un as k,
  c$e as l,
  ot as m,
  lt as n,
  Ig as o,
  xt as p,
  Pn as q,
  Dg as r,
  ct as s,
  Kr as t,
  l5 as u,
  Ja as v,
  Xc as w,
  s5 as x,
  qr as y,
  Mn as z
};
